import {
  UpdateManager,
  fetcher,
  graph,
  isBlankNode,
  isLiteral,
  isNamedNode,
  lit,
  namedNode,
  st
} from "./chunk-7VQUARYZ.js";
import {
  __commonJS,
  __export,
  __toESM
} from "./chunk-U67V476Y.js";

// ../node_modules/events/events.js
var require_events = __commonJS({
  "../node_modules/events/events.js"(exports, module2) {
    "use strict";
    var R = typeof Reflect === "object" ? Reflect : null;
    var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply2(target5, receiver2, args) {
      return Function.prototype.apply.call(target5, receiver2, args);
    };
    var ReflectOwnKeys;
    if (R && typeof R.ownKeys === "function") {
      ReflectOwnKeys = R.ownKeys;
    } else if (Object.getOwnPropertySymbols) {
      ReflectOwnKeys = function ReflectOwnKeys2(target5) {
        return Object.getOwnPropertyNames(target5).concat(Object.getOwnPropertySymbols(target5));
      };
    } else {
      ReflectOwnKeys = function ReflectOwnKeys2(target5) {
        return Object.getOwnPropertyNames(target5);
      };
    }
    function ProcessEmitWarning(warning4) {
      if (console && console.warn) console.warn(warning4);
    }
    var NumberIsNaN = Number.isNaN || function NumberIsNaN2(value6) {
      return value6 !== value6;
    };
    function EventEmitter2() {
      EventEmitter2.init.call(this);
    }
    module2.exports = EventEmitter2;
    module2.exports.once = once;
    EventEmitter2.EventEmitter = EventEmitter2;
    EventEmitter2.prototype._events = void 0;
    EventEmitter2.prototype._eventsCount = 0;
    EventEmitter2.prototype._maxListeners = void 0;
    var defaultMaxListeners = 10;
    function checkListener(listener) {
      if (typeof listener !== "function") {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
    }
    Object.defineProperty(EventEmitter2, "defaultMaxListeners", {
      enumerable: true,
      get: function() {
        return defaultMaxListeners;
      },
      set: function(arg2) {
        if (typeof arg2 !== "number" || arg2 < 0 || NumberIsNaN(arg2)) {
          throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg2 + ".");
        }
        defaultMaxListeners = arg2;
      }
    });
    EventEmitter2.init = function() {
      if (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) {
        this._events = /* @__PURE__ */ Object.create(null);
        this._eventsCount = 0;
      }
      this._maxListeners = this._maxListeners || void 0;
    };
    EventEmitter2.prototype.setMaxListeners = function setMaxListeners(n2) {
      if (typeof n2 !== "number" || n2 < 0 || NumberIsNaN(n2)) {
        throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n2 + ".");
      }
      this._maxListeners = n2;
      return this;
    };
    function _getMaxListeners(that) {
      if (that._maxListeners === void 0)
        return EventEmitter2.defaultMaxListeners;
      return that._maxListeners;
    }
    EventEmitter2.prototype.getMaxListeners = function getMaxListeners() {
      return _getMaxListeners(this);
    };
    EventEmitter2.prototype.emit = function emit(type5) {
      var args = [];
      for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
      var doError = type5 === "error";
      var events3 = this._events;
      if (events3 !== void 0)
        doError = doError && events3.error === void 0;
      else if (!doError)
        return false;
      if (doError) {
        var er;
        if (args.length > 0)
          er = args[0];
        if (er instanceof Error) {
          throw er;
        }
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err;
      }
      var handler = events3[type5];
      if (handler === void 0)
        return false;
      if (typeof handler === "function") {
        ReflectApply(handler, this, args);
      } else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for (var i = 0; i < len; ++i)
          ReflectApply(listeners[i], this, args);
      }
      return true;
    };
    function _addListener(target5, type5, listener, prepend) {
      var m;
      var events3;
      var existing;
      checkListener(listener);
      events3 = target5._events;
      if (events3 === void 0) {
        events3 = target5._events = /* @__PURE__ */ Object.create(null);
        target5._eventsCount = 0;
      } else {
        if (events3.newListener !== void 0) {
          target5.emit(
            "newListener",
            type5,
            listener.listener ? listener.listener : listener
          );
          events3 = target5._events;
        }
        existing = events3[type5];
      }
      if (existing === void 0) {
        existing = events3[type5] = listener;
        ++target5._eventsCount;
      } else {
        if (typeof existing === "function") {
          existing = events3[type5] = prepend ? [listener, existing] : [existing, listener];
        } else if (prepend) {
          existing.unshift(listener);
        } else {
          existing.push(listener);
        }
        m = _getMaxListeners(target5);
        if (m > 0 && existing.length > m && !existing.warned) {
          existing.warned = true;
          var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type5) + " listeners added. Use emitter.setMaxListeners() to increase limit");
          w.name = "MaxListenersExceededWarning";
          w.emitter = target5;
          w.type = type5;
          w.count = existing.length;
          ProcessEmitWarning(w);
        }
      }
      return target5;
    }
    EventEmitter2.prototype.addListener = function addListener(type5, listener) {
      return _addListener(this, type5, listener, false);
    };
    EventEmitter2.prototype.on = EventEmitter2.prototype.addListener;
    EventEmitter2.prototype.prependListener = function prependListener(type5, listener) {
      return _addListener(this, type5, listener, true);
    };
    function onceWrapper() {
      if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0)
          return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
      }
    }
    function _onceWrap(target5, type5, listener) {
      var state2 = { fired: false, wrapFn: void 0, target: target5, type: type5, listener };
      var wrapped = onceWrapper.bind(state2);
      wrapped.listener = listener;
      state2.wrapFn = wrapped;
      return wrapped;
    }
    EventEmitter2.prototype.once = function once2(type5, listener) {
      checkListener(listener);
      this.on(type5, _onceWrap(this, type5, listener));
      return this;
    };
    EventEmitter2.prototype.prependOnceListener = function prependOnceListener(type5, listener) {
      checkListener(listener);
      this.prependListener(type5, _onceWrap(this, type5, listener));
      return this;
    };
    EventEmitter2.prototype.removeListener = function removeListener(type5, listener) {
      var list, events3, position4, i, originalListener;
      checkListener(listener);
      events3 = this._events;
      if (events3 === void 0)
        return this;
      list = events3[type5];
      if (list === void 0)
        return this;
      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = /* @__PURE__ */ Object.create(null);
        else {
          delete events3[type5];
          if (events3.removeListener)
            this.emit("removeListener", type5, list.listener || listener);
        }
      } else if (typeof list !== "function") {
        position4 = -1;
        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position4 = i;
            break;
          }
        }
        if (position4 < 0)
          return this;
        if (position4 === 0)
          list.shift();
        else {
          spliceOne(list, position4);
        }
        if (list.length === 1)
          events3[type5] = list[0];
        if (events3.removeListener !== void 0)
          this.emit("removeListener", type5, originalListener || listener);
      }
      return this;
    };
    EventEmitter2.prototype.off = EventEmitter2.prototype.removeListener;
    EventEmitter2.prototype.removeAllListeners = function removeAllListeners(type5) {
      var listeners, events3, i;
      events3 = this._events;
      if (events3 === void 0)
        return this;
      if (events3.removeListener === void 0) {
        if (arguments.length === 0) {
          this._events = /* @__PURE__ */ Object.create(null);
          this._eventsCount = 0;
        } else if (events3[type5] !== void 0) {
          if (--this._eventsCount === 0)
            this._events = /* @__PURE__ */ Object.create(null);
          else
            delete events3[type5];
        }
        return this;
      }
      if (arguments.length === 0) {
        var keys = Object.keys(events3);
        var key3;
        for (i = 0; i < keys.length; ++i) {
          key3 = keys[i];
          if (key3 === "removeListener") continue;
          this.removeAllListeners(key3);
        }
        this.removeAllListeners("removeListener");
        this._events = /* @__PURE__ */ Object.create(null);
        this._eventsCount = 0;
        return this;
      }
      listeners = events3[type5];
      if (typeof listeners === "function") {
        this.removeListener(type5, listeners);
      } else if (listeners !== void 0) {
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type5, listeners[i]);
        }
      }
      return this;
    };
    function _listeners(target5, type5, unwrap) {
      var events3 = target5._events;
      if (events3 === void 0)
        return [];
      var evlistener = events3[type5];
      if (evlistener === void 0)
        return [];
      if (typeof evlistener === "function")
        return unwrap ? [evlistener.listener || evlistener] : [evlistener];
      return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
    }
    EventEmitter2.prototype.listeners = function listeners(type5) {
      return _listeners(this, type5, true);
    };
    EventEmitter2.prototype.rawListeners = function rawListeners(type5) {
      return _listeners(this, type5, false);
    };
    EventEmitter2.listenerCount = function(emitter, type5) {
      if (typeof emitter.listenerCount === "function") {
        return emitter.listenerCount(type5);
      } else {
        return listenerCount.call(emitter, type5);
      }
    };
    EventEmitter2.prototype.listenerCount = listenerCount;
    function listenerCount(type5) {
      var events3 = this._events;
      if (events3 !== void 0) {
        var evlistener = events3[type5];
        if (typeof evlistener === "function") {
          return 1;
        } else if (evlistener !== void 0) {
          return evlistener.length;
        }
      }
      return 0;
    }
    EventEmitter2.prototype.eventNames = function eventNames() {
      return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
    };
    function arrayClone(arr, n2) {
      var copy = new Array(n2);
      for (var i = 0; i < n2; ++i)
        copy[i] = arr[i];
      return copy;
    }
    function spliceOne(list, index2) {
      for (; index2 + 1 < list.length; index2++)
        list[index2] = list[index2 + 1];
      list.pop();
    }
    function unwrapListeners(arr) {
      var ret = new Array(arr.length);
      for (var i = 0; i < ret.length; ++i) {
        ret[i] = arr[i].listener || arr[i];
      }
      return ret;
    }
    function once(emitter, name7) {
      return new Promise(function(resolve, reject2) {
        function errorListener(err) {
          emitter.removeListener(name7, resolver);
          reject2(err);
        }
        function resolver() {
          if (typeof emitter.removeListener === "function") {
            emitter.removeListener("error", errorListener);
          }
          resolve([].slice.call(arguments));
        }
        ;
        eventTargetAgnosticAddListener(emitter, name7, resolver, { once: true });
        if (name7 !== "error") {
          addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
        }
      });
    }
    function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
      if (typeof emitter.on === "function") {
        eventTargetAgnosticAddListener(emitter, "error", handler, flags);
      }
    }
    function eventTargetAgnosticAddListener(emitter, name7, listener, flags) {
      if (typeof emitter.on === "function") {
        if (flags.once) {
          emitter.once(name7, listener);
        } else {
          emitter.on(name7, listener);
        }
      } else if (typeof emitter.addEventListener === "function") {
        emitter.addEventListener(name7, function wrapListener(arg2) {
          if (flags.once) {
            emitter.removeEventListener(name7, wrapListener);
          }
          listener(arg2);
        });
      } else {
        throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
      }
    }
  }
});

// ../node_modules/@inrupt/oidc-client/lib/oidc-client.min.js
var require_oidc_client_min = __commonJS({
  "../node_modules/@inrupt/oidc-client/lib/oidc-client.min.js"(exports, module2) {
    !function t(e, r) {
      if ("object" == typeof exports && "object" == typeof module2) module2.exports = r();
      else if ("function" == typeof define && define.amd) define([], r);
      else {
        var n2 = r();
        for (var i in n2) ("object" == typeof exports ? exports : e)[i] = n2[i];
      }
    }(exports, function() {
      return function(t) {
        var e = {};
        function r(n2) {
          if (e[n2]) return e[n2].exports;
          var i = e[n2] = { i: n2, l: false, exports: {} };
          return t[n2].call(i.exports, i, i.exports, r), i.l = true, i.exports;
        }
        return r.m = t, r.c = e, r.d = function(t2, e2, n2) {
          r.o(t2, e2) || Object.defineProperty(t2, e2, { enumerable: true, get: n2 });
        }, r.r = function(t2) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t2, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t2, "__esModule", { value: true });
        }, r.t = function(t2, e2) {
          if (1 & e2 && (t2 = r(t2)), 8 & e2) return t2;
          if (4 & e2 && "object" == typeof t2 && t2 && t2.__esModule) return t2;
          var n2 = /* @__PURE__ */ Object.create(null);
          if (r.r(n2), Object.defineProperty(n2, "default", { enumerable: true, value: t2 }), 2 & e2 && "string" != typeof t2) for (var i in t2) r.d(n2, i, function(e3) {
            return t2[e3];
          }.bind(null, i));
          return n2;
        }, r.n = function(t2) {
          var e2 = t2 && t2.__esModule ? function e3() {
            return t2.default;
          } : function e3() {
            return t2;
          };
          return r.d(e2, "a", e2), e2;
        }, r.o = function(t2, e2) {
          return Object.prototype.hasOwnProperty.call(t2, e2);
        }, r.p = "", r(r.s = 22);
      }([function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true });
        var n2 = /* @__PURE__ */ function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n3 = e2[r2];
              n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(t3, n3.key, n3);
            }
          }
          return function(e2, r2, n3) {
            return r2 && t2(e2.prototype, r2), n3 && t2(e2, n3), e2;
          };
        }();
        var i = { debug: function t2() {
        }, info: function t2() {
        }, warn: function t2() {
        }, error: function t2() {
        } }, o = void 0, s = void 0;
        (e.Log = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2)) throw new TypeError("Cannot call a class as a function");
            }(this, t2);
          }
          return t2.reset = function t3() {
            s = 3, o = i;
          }, t2.debug = function t3() {
            if (s >= 4) {
              for (var e2 = arguments.length, r2 = Array(e2), n3 = 0; n3 < e2; n3++) r2[n3] = arguments[n3];
              o.debug.apply(o, Array.from(r2));
            }
          }, t2.info = function t3() {
            if (s >= 3) {
              for (var e2 = arguments.length, r2 = Array(e2), n3 = 0; n3 < e2; n3++) r2[n3] = arguments[n3];
              o.info.apply(o, Array.from(r2));
            }
          }, t2.warn = function t3() {
            if (s >= 2) {
              for (var e2 = arguments.length, r2 = Array(e2), n3 = 0; n3 < e2; n3++) r2[n3] = arguments[n3];
              o.warn.apply(o, Array.from(r2));
            }
          }, t2.error = function t3() {
            if (s >= 1) {
              for (var e2 = arguments.length, r2 = Array(e2), n3 = 0; n3 < e2; n3++) r2[n3] = arguments[n3];
              o.error.apply(o, Array.from(r2));
            }
          }, n2(t2, null, [{ key: "NONE", get: function t3() {
            return 0;
          } }, { key: "ERROR", get: function t3() {
            return 1;
          } }, { key: "WARN", get: function t3() {
            return 2;
          } }, { key: "INFO", get: function t3() {
            return 3;
          } }, { key: "DEBUG", get: function t3() {
            return 4;
          } }, { key: "level", get: function t3() {
            return s;
          }, set: function t3(e2) {
            if (!(0 <= e2 && e2 <= 4)) throw new Error("Invalid log level");
            s = e2;
          } }, { key: "logger", get: function t3() {
            return o;
          }, set: function t3(e2) {
            if (!e2.debug && e2.info && (e2.debug = e2.info), !(e2.debug && e2.info && e2.warn && e2.error)) throw new Error("Invalid logger");
            o = e2;
          } }]), t2;
        }()).reset();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true });
        var n2 = /* @__PURE__ */ function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n3 = e2[r2];
              n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(t3, n3.key, n3);
            }
          }
          return function(e2, r2, n3) {
            return r2 && t2(e2.prototype, r2), n3 && t2(e2, n3), e2;
          };
        }();
        var i = { setInterval: function(t2) {
          function e2(e3, r2) {
            return t2.apply(this, arguments);
          }
          return e2.toString = function() {
            return t2.toString();
          }, e2;
        }(function(t2, e2) {
          return setInterval(t2, e2);
        }), clearInterval: function(t2) {
          function e2(e3) {
            return t2.apply(this, arguments);
          }
          return e2.toString = function() {
            return t2.toString();
          }, e2;
        }(function(t2) {
          return clearInterval(t2);
        }) }, o = false, s = null;
        e.Global = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2)) throw new TypeError("Cannot call a class as a function");
            }(this, t2);
          }
          return t2._testing = function t3() {
            o = true;
          }, t2.setXMLHttpRequest = function t3(e2) {
            s = e2;
          }, n2(t2, null, [{ key: "location", get: function t3() {
            if (!o) return location;
          } }, { key: "localStorage", get: function t3() {
            if (!o && "undefined" != typeof window) return localStorage;
          } }, { key: "sessionStorage", get: function t3() {
            if (!o && "undefined" != typeof window) return sessionStorage;
          } }, { key: "XMLHttpRequest", get: function t3() {
            if (!o && "undefined" != typeof window) return s || XMLHttpRequest;
          } }, { key: "timer", get: function t3() {
            if (!o) return i;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.MetadataService = void 0;
        var n2 = /* @__PURE__ */ function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n3 = e2[r2];
              n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(t3, n3.key, n3);
            }
          }
          return function(e2, r2, n3) {
            return r2 && t2(e2.prototype, r2), n3 && t2(e2, n3), e2;
          };
        }(), i = r(0), o = r(7);
        function s(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        var a = ".well-known/openid-configuration";
        e.MetadataService = function() {
          function t2(e2) {
            var r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.JsonService;
            if (s(this, t2), !e2) throw i.Log.error("MetadataService: No settings passed to MetadataService"), new Error("settings");
            this._settings = e2, this._jsonService = new r2(["application/jwk-set+json"]);
          }
          return t2.prototype.resetSigningKeys = function t3() {
            this._settings = this._settings || {}, this._settings.signingKeys = void 0;
          }, t2.prototype.getMetadata = function t3() {
            var e2 = this;
            return this._settings.metadata ? (i.Log.debug("MetadataService.getMetadata: Returning metadata from settings"), Promise.resolve(this._settings.metadata)) : this.metadataUrl ? (i.Log.debug("MetadataService.getMetadata: getting metadata from", this.metadataUrl), this._jsonService.getJson(this.metadataUrl).then(function(t4) {
              i.Log.debug("MetadataService.getMetadata: json received");
              var r2 = e2._settings.metadataSeed || {};
              return e2._settings.metadata = Object.assign({}, r2, t4), e2._settings.metadata;
            })) : (i.Log.error("MetadataService.getMetadata: No authority or metadataUrl configured on settings"), Promise.reject(new Error("No authority or metadataUrl configured on settings")));
          }, t2.prototype.getIssuer = function t3() {
            return this._getMetadataProperty("issuer");
          }, t2.prototype.getAuthorizationEndpoint = function t3() {
            return this._getMetadataProperty("authorization_endpoint");
          }, t2.prototype.getUserInfoEndpoint = function t3() {
            return this._getMetadataProperty("userinfo_endpoint");
          }, t2.prototype.getTokenEndpoint = function t3() {
            var e2 = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
            return this._getMetadataProperty("token_endpoint", e2);
          }, t2.prototype.getCheckSessionIframe = function t3() {
            return this._getMetadataProperty("check_session_iframe", true);
          }, t2.prototype.getEndSessionEndpoint = function t3() {
            return this._getMetadataProperty("end_session_endpoint", true);
          }, t2.prototype.getRevocationEndpoint = function t3() {
            return this._getMetadataProperty("revocation_endpoint", true);
          }, t2.prototype.getKeysEndpoint = function t3() {
            return this._getMetadataProperty("jwks_uri", true);
          }, t2.prototype._getMetadataProperty = function t3(e2) {
            var r2 = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            return i.Log.debug("MetadataService.getMetadataProperty for: " + e2), this.getMetadata().then(function(t4) {
              if (i.Log.debug("MetadataService.getMetadataProperty: metadata recieved"), void 0 === t4[e2]) {
                if (true === r2) return void i.Log.warn("MetadataService.getMetadataProperty: Metadata does not contain optional property " + e2);
                throw i.Log.error("MetadataService.getMetadataProperty: Metadata does not contain property " + e2), new Error("Metadata does not contain property " + e2);
              }
              return t4[e2];
            });
          }, t2.prototype.getSigningKeys = function t3() {
            var e2 = this;
            return this._settings.signingKeys ? (i.Log.debug("MetadataService.getSigningKeys: Returning signingKeys from settings"), Promise.resolve(this._settings.signingKeys)) : this._getMetadataProperty("jwks_uri").then(function(t4) {
              return i.Log.debug("MetadataService.getSigningKeys: jwks_uri received", t4), e2._jsonService.getJson(t4).then(function(t5) {
                if (i.Log.debug("MetadataService.getSigningKeys: key set received", t5), !t5.keys) throw i.Log.error("MetadataService.getSigningKeys: Missing keys on keyset"), new Error("Missing keys on keyset");
                return e2._settings.signingKeys = t5.keys, e2._settings.signingKeys;
              });
            });
          }, n2(t2, [{ key: "metadataUrl", get: function t3() {
            return this._metadataUrl || (this._settings.metadataUrl ? this._metadataUrl = this._settings.metadataUrl : (this._metadataUrl = this._settings.authority, this._metadataUrl && this._metadataUrl.indexOf(a) < 0 && ("/" !== this._metadataUrl[this._metadataUrl.length - 1] && (this._metadataUrl += "/"), this._metadataUrl += a))), this._metadataUrl;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.UrlUtility = void 0;
        var n2 = r(0), i = r(1);
        e.UrlUtility = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2)) throw new TypeError("Cannot call a class as a function");
            }(this, t2);
          }
          return t2.addQueryParam = function t3(e2, r2, n3) {
            return e2.indexOf("?") < 0 && (e2 += "?"), "?" !== e2[e2.length - 1] && (e2 += "&"), e2 += encodeURIComponent(r2), e2 += "=", e2 += encodeURIComponent(n3);
          }, t2.parseUrlFragment = function t3(e2) {
            var r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "#", o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.Global;
            "string" != typeof e2 && (e2 = o.location.href);
            var s = e2.lastIndexOf(r2);
            s >= 0 && (e2 = e2.substr(s + 1)), "?" === r2 && (s = e2.indexOf("#")) >= 0 && (e2 = e2.substr(0, s));
            for (var a, u = {}, c = /([^&=]+)=([^&]*)/g, h = 0; a = c.exec(e2); ) if (u[decodeURIComponent(a[1])] = decodeURIComponent(a[2].replace(/\+/g, " ")), h++ > 50) return n2.Log.error("UrlUtility.parseUrlFragment: response exceeded expected number of parameters", e2), { error: "Response exceeded expected number of parameters" };
            for (var l in u) return u;
            return {};
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.JoseUtil = void 0;
        var n2 = r(26), i = function o(t2) {
          return t2 && t2.__esModule ? t2 : { default: t2 };
        }(r(33));
        e.JoseUtil = (0, i.default)({ jws: n2.jws, KeyUtil: n2.KeyUtil, X509: n2.X509, crypto: n2.crypto, hextob64u: n2.hextob64u, b64tohex: n2.b64tohex, AllowedSigningAlgs: n2.AllowedSigningAlgs });
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.OidcClientSettings = void 0;
        var n2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t2) {
          return typeof t2;
        } : function(t2) {
          return t2 && "function" == typeof Symbol && t2.constructor === Symbol && t2 !== Symbol.prototype ? "symbol" : typeof t2;
        }, i = /* @__PURE__ */ function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n3 = e2[r2];
              n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(t3, n3.key, n3);
            }
          }
          return function(e2, r2, n3) {
            return r2 && t2(e2.prototype, r2), n3 && t2(e2, n3), e2;
          };
        }(), o = r(0), s = r(23), a = r(6), u = r(24), c = r(2);
        function h(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        var l = ".well-known/openid-configuration", f = "id_token", g = "openid", d = "client_secret_post";
        e.OidcClientSettings = function() {
          function t2() {
            var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r2 = e2.authority, i2 = e2.metadataUrl, o2 = e2.metadata, l2 = e2.signingKeys, p = e2.metadataSeed, v2 = e2.client_id, y = e2.client_secret, m = e2.response_type, _ = void 0 === m ? f : m, S = e2.scope, b = void 0 === S ? g : S, w = e2.redirect_uri, F = e2.post_logout_redirect_uri, E = e2.client_authentication, x = void 0 === E ? d : E, A = e2.prompt, k = e2.display, P = e2.max_age, C = e2.ui_locales, T = e2.acr_values, R = e2.resource, I = e2.response_mode, D = e2.filterProtocolClaims, L = void 0 === D || D, N = e2.loadUserInfo, U = void 0 === N || N, B = e2.staleStateAge, O = void 0 === B ? 900 : B, j = e2.clockSkew, M = void 0 === j ? 300 : j, H = e2.clockService, V = void 0 === H ? new s.ClockService() : H, K = e2.userInfoJwtIssuer, q = void 0 === K ? "OP" : K, J = e2.mergeClaims, W = void 0 !== J && J, z = e2.stateStore, Y = void 0 === z ? new a.WebStorageStateStore() : z, G = e2.ResponseValidatorCtor, X = void 0 === G ? u.ResponseValidator : G, $ = e2.MetadataServiceCtor, Q = void 0 === $ ? c.MetadataService : $, Z = e2.extraQueryParams, tt = void 0 === Z ? {} : Z, et = e2.extraTokenParams, rt = void 0 === et ? {} : et;
            h(this, t2), this._authority = r2, this._metadataUrl = i2, this._metadata = o2, this._metadataSeed = p, this._signingKeys = l2, this._client_id = v2, this._client_secret = y, this._response_type = _, this._scope = b, this._redirect_uri = w, this._post_logout_redirect_uri = F, this._client_authentication = x, this._prompt = A, this._display = k, this._max_age = P, this._ui_locales = C, this._acr_values = T, this._resource = R, this._response_mode = I, this._filterProtocolClaims = !!L, this._loadUserInfo = !!U, this._staleStateAge = O, this._clockSkew = M, this._clockService = V, this._userInfoJwtIssuer = q, this._mergeClaims = !!W, this._stateStore = Y, this._validator = new X(this), this._metadataService = new Q(this), this._extraQueryParams = "object" === (void 0 === tt ? "undefined" : n2(tt)) ? tt : {}, this._extraTokenParams = "object" === (void 0 === rt ? "undefined" : n2(rt)) ? rt : {};
          }
          return t2.prototype.getEpochTime = function t3() {
            return this._clockService.getEpochTime();
          }, i(t2, [{ key: "client_id", get: function t3() {
            return this._client_id;
          }, set: function t3(e2) {
            if (this._client_id) throw o.Log.error("OidcClientSettings.set_client_id: client_id has already been assigned."), new Error("client_id has already been assigned.");
            this._client_id = e2;
          } }, { key: "client_secret", get: function t3() {
            return this._client_secret;
          } }, { key: "response_type", get: function t3() {
            return this._response_type;
          } }, { key: "scope", get: function t3() {
            return this._scope;
          } }, { key: "redirect_uri", get: function t3() {
            return this._redirect_uri;
          } }, { key: "post_logout_redirect_uri", get: function t3() {
            return this._post_logout_redirect_uri;
          } }, { key: "client_authentication", get: function t3() {
            return this._client_authentication;
          } }, { key: "prompt", get: function t3() {
            return this._prompt;
          } }, { key: "display", get: function t3() {
            return this._display;
          } }, { key: "max_age", get: function t3() {
            return this._max_age;
          } }, { key: "ui_locales", get: function t3() {
            return this._ui_locales;
          } }, { key: "acr_values", get: function t3() {
            return this._acr_values;
          } }, { key: "resource", get: function t3() {
            return this._resource;
          } }, { key: "response_mode", get: function t3() {
            return this._response_mode;
          } }, { key: "authority", get: function t3() {
            return this._authority;
          }, set: function t3(e2) {
            if (this._authority) throw o.Log.error("OidcClientSettings.set_authority: authority has already been assigned."), new Error("authority has already been assigned.");
            this._authority = e2;
          } }, { key: "metadataUrl", get: function t3() {
            return this._metadataUrl || (this._metadataUrl = this.authority, this._metadataUrl && this._metadataUrl.indexOf(l) < 0 && ("/" !== this._metadataUrl[this._metadataUrl.length - 1] && (this._metadataUrl += "/"), this._metadataUrl += l)), this._metadataUrl;
          } }, { key: "metadata", get: function t3() {
            return this._metadata;
          }, set: function t3(e2) {
            this._metadata = e2;
          } }, { key: "metadataSeed", get: function t3() {
            return this._metadataSeed;
          }, set: function t3(e2) {
            this._metadataSeed = e2;
          } }, { key: "signingKeys", get: function t3() {
            return this._signingKeys;
          }, set: function t3(e2) {
            this._signingKeys = e2;
          } }, { key: "filterProtocolClaims", get: function t3() {
            return this._filterProtocolClaims;
          } }, { key: "loadUserInfo", get: function t3() {
            return this._loadUserInfo;
          } }, { key: "staleStateAge", get: function t3() {
            return this._staleStateAge;
          } }, { key: "clockSkew", get: function t3() {
            return this._clockSkew;
          } }, { key: "userInfoJwtIssuer", get: function t3() {
            return this._userInfoJwtIssuer;
          } }, { key: "mergeClaims", get: function t3() {
            return this._mergeClaims;
          } }, { key: "stateStore", get: function t3() {
            return this._stateStore;
          } }, { key: "validator", get: function t3() {
            return this._validator;
          } }, { key: "metadataService", get: function t3() {
            return this._metadataService;
          } }, { key: "extraQueryParams", get: function t3() {
            return this._extraQueryParams;
          }, set: function t3(e2) {
            "object" === (void 0 === e2 ? "undefined" : n2(e2)) ? this._extraQueryParams = e2 : this._extraQueryParams = {};
          } }, { key: "extraTokenParams", get: function t3() {
            return this._extraTokenParams;
          }, set: function t3(e2) {
            "object" === (void 0 === e2 ? "undefined" : n2(e2)) ? this._extraTokenParams = e2 : this._extraTokenParams = {};
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.WebStorageStateStore = void 0;
        var n2 = r(0), i = r(1);
        function o(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        e.WebStorageStateStore = function() {
          function t2() {
            var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r2 = e2.prefix, n3 = void 0 === r2 ? "oidc." : r2, s = e2.store, a = void 0 === s ? i.Global.localStorage : s;
            o(this, t2), this._store = a, this._prefix = n3;
          }
          return t2.prototype.set = function t3(e2, r2) {
            return n2.Log.debug("WebStorageStateStore.set", e2), e2 = this._prefix + e2, this._store.setItem(e2, r2), Promise.resolve();
          }, t2.prototype.get = function t3(e2) {
            n2.Log.debug("WebStorageStateStore.get", e2), e2 = this._prefix + e2;
            var r2 = this._store.getItem(e2);
            return Promise.resolve(r2);
          }, t2.prototype.remove = function t3(e2) {
            n2.Log.debug("WebStorageStateStore.remove", e2), e2 = this._prefix + e2;
            var r2 = this._store.getItem(e2);
            return this._store.removeItem(e2), Promise.resolve(r2);
          }, t2.prototype.getAllKeys = function t3() {
            n2.Log.debug("WebStorageStateStore.getAllKeys");
            for (var e2 = [], r2 = 0; r2 < this._store.length; r2++) {
              var i2 = this._store.key(r2);
              0 === i2.indexOf(this._prefix) && e2.push(i2.substr(this._prefix.length));
            }
            return Promise.resolve(e2);
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.JsonService = void 0;
        var n2 = r(0), i = r(1);
        function o(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        e.JsonService = function() {
          function t2() {
            var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.Global.XMLHttpRequest, n3 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
            o(this, t2), e2 && Array.isArray(e2) ? this._contentTypes = e2.slice() : this._contentTypes = [], this._contentTypes.push("application/json"), n3 && this._contentTypes.push("application/jwt"), this._XMLHttpRequest = r2, this._jwtHandler = n3;
          }
          return t2.prototype.getJson = function t3(e2, r2) {
            var i2 = this;
            if (!e2) throw n2.Log.error("JsonService.getJson: No url passed"), new Error("url");
            return n2.Log.debug("JsonService.getJson, url: ", e2), new Promise(function(t4, o2) {
              var s = new i2._XMLHttpRequest();
              s.open("GET", e2);
              var a = i2._contentTypes, u = i2._jwtHandler;
              s.onload = function() {
                if (n2.Log.debug("JsonService.getJson: HTTP response received, status", s.status), 200 === s.status) {
                  var r3 = s.getResponseHeader("Content-Type");
                  if (r3) {
                    var i3 = a.find(function(t5) {
                      if (r3.startsWith(t5)) return true;
                    });
                    if ("application/jwt" == i3) return void u(s).then(t4, o2);
                    if (i3) try {
                      return void t4(JSON.parse(s.responseText));
                    } catch (t5) {
                      return n2.Log.error("JsonService.getJson: Error parsing JSON response", t5.message), void o2(t5);
                    }
                  }
                  o2(Error("Invalid response Content-Type: " + r3 + ", from URL: " + e2));
                } else o2(Error(s.statusText + " (" + s.status + ")"));
              }, s.onerror = function() {
                n2.Log.error("JsonService.getJson: network error"), o2(Error("Network Error"));
              }, r2 && (n2.Log.debug("JsonService.getJson: token passed, setting Authorization header"), s.setRequestHeader("Authorization", "Bearer " + r2)), s.send();
            });
          }, t2.prototype.postForm = function t3(e2, r2, i2) {
            var o2 = this;
            if (!e2) throw n2.Log.error("JsonService.postForm: No url passed"), new Error("url");
            return n2.Log.debug("JsonService.postForm, url: ", e2), new Promise(function(t4, s) {
              var a = new o2._XMLHttpRequest();
              a.open("POST", e2);
              var u = o2._contentTypes;
              a.onload = function() {
                if (n2.Log.debug("JsonService.postForm: HTTP response received, status", a.status), 200 !== a.status) {
                  if (400 === a.status) {
                    if (i3 = a.getResponseHeader("Content-Type")) {
                      if (u.find(function(t5) {
                        if (i3.startsWith(t5)) return true;
                      })) try {
                        var r3 = JSON.parse(a.responseText);
                        if (r3 && r3.error) return n2.Log.error("JsonService.postForm: Error from server: ", r3.error), void s(new Error(r3.error));
                      } catch (t5) {
                        return n2.Log.error("JsonService.postForm: Error parsing JSON response", t5.message), void s(t5);
                      }
                    }
                  }
                  s(Error(a.statusText + " (" + a.status + ")"));
                } else {
                  var i3;
                  if ((i3 = a.getResponseHeader("Content-Type")) && u.find(function(t5) {
                    if (i3.startsWith(t5)) return true;
                  })) try {
                    return void t4(JSON.parse(a.responseText));
                  } catch (t5) {
                    return n2.Log.error("JsonService.postForm: Error parsing JSON response", t5.message), void s(t5);
                  }
                  s(Error("Invalid response Content-Type: " + i3 + ", from URL: " + e2));
                }
              }, a.onerror = function() {
                n2.Log.error("JsonService.postForm: network error"), s(Error("Network Error"));
              };
              var c = "";
              for (var h in r2) {
                var l = r2[h];
                l && (c.length > 0 && (c += "&"), c += encodeURIComponent(h), c += "=", c += encodeURIComponent(l));
              }
              a.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), void 0 !== i2 && a.setRequestHeader("Authorization", "Basic " + btoa(i2)), a.send(c);
            });
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.SigninRequest = void 0;
        var n2 = r(0), i = r(3), o = r(13);
        e.SigninRequest = function() {
          function t2(e2) {
            var r2 = e2.url, s = e2.client_id, a = e2.redirect_uri, u = e2.response_type, c = e2.scope, h = e2.authority, l = e2.data, f = e2.prompt, g = e2.display, d = e2.max_age, p = e2.ui_locales, v2 = e2.id_token_hint, y = e2.login_hint, m = e2.acr_values, _ = e2.resource, S = e2.response_mode, b = e2.request, w = e2.request_uri, F = e2.extraQueryParams, E = e2.request_type, x = e2.client_secret, A = e2.extraTokenParams, k = e2.skipUserInfo;
            if (function P(t3, e3) {
              if (!(t3 instanceof e3)) throw new TypeError("Cannot call a class as a function");
            }(this, t2), !r2) throw n2.Log.error("SigninRequest.ctor: No url passed"), new Error("url");
            if (!s) throw n2.Log.error("SigninRequest.ctor: No client_id passed"), new Error("client_id");
            if (!a) throw n2.Log.error("SigninRequest.ctor: No redirect_uri passed"), new Error("redirect_uri");
            if (!u) throw n2.Log.error("SigninRequest.ctor: No response_type passed"), new Error("response_type");
            if (!c) throw n2.Log.error("SigninRequest.ctor: No scope passed"), new Error("scope");
            if (!h) throw n2.Log.error("SigninRequest.ctor: No authority passed"), new Error("authority");
            var C = t2.isOidc(u), T = t2.isCode(u);
            S || (S = t2.isCode(u) ? "query" : null), this.state = new o.SigninState({ nonce: C, data: l, client_id: s, authority: h, redirect_uri: a, code_verifier: T, request_type: E, response_mode: S, client_secret: x, scope: c, extraTokenParams: A, skipUserInfo: k }), r2 = i.UrlUtility.addQueryParam(r2, "client_id", s), r2 = i.UrlUtility.addQueryParam(r2, "redirect_uri", a), r2 = i.UrlUtility.addQueryParam(r2, "response_type", u), r2 = i.UrlUtility.addQueryParam(r2, "scope", c), r2 = i.UrlUtility.addQueryParam(r2, "state", this.state.id), C && (r2 = i.UrlUtility.addQueryParam(r2, "nonce", this.state.nonce)), T && (r2 = i.UrlUtility.addQueryParam(r2, "code_challenge", this.state.code_challenge), r2 = i.UrlUtility.addQueryParam(r2, "code_challenge_method", "S256"));
            var R = { prompt: f, display: g, max_age: d, ui_locales: p, id_token_hint: v2, login_hint: y, acr_values: m, resource: _, request: b, request_uri: w, response_mode: S };
            for (var I in R) R[I] && (r2 = i.UrlUtility.addQueryParam(r2, I, R[I]));
            for (var D in F) r2 = i.UrlUtility.addQueryParam(r2, D, F[D]);
            this.url = r2;
          }
          return t2.isOidc = function t3(e2) {
            return !!e2.split(/\s+/g).filter(function(t4) {
              return "id_token" === t4;
            })[0];
          }, t2.isOAuth = function t3(e2) {
            return !!e2.split(/\s+/g).filter(function(t4) {
              return "token" === t4;
            })[0];
          }, t2.isCode = function t3(e2) {
            return !!e2.split(/\s+/g).filter(function(t4) {
              return "code" === t4;
            })[0];
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.State = void 0;
        var n2 = /* @__PURE__ */ function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n3 = e2[r2];
              n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(t3, n3.key, n3);
            }
          }
          return function(e2, r2, n3) {
            return r2 && t2(e2.prototype, r2), n3 && t2(e2, n3), e2;
          };
        }(), i = r(0), o = function s(t2) {
          return t2 && t2.__esModule ? t2 : { default: t2 };
        }(r(14));
        function a(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        e.State = function() {
          function t2() {
            var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r2 = e2.id, n3 = e2.data, i2 = e2.created, s = e2.request_type;
            a(this, t2), this._id = r2 || (0, o.default)(), this._data = n3, this._created = "number" == typeof i2 && i2 > 0 ? i2 : parseInt(Date.now() / 1e3), this._request_type = s;
          }
          return t2.prototype.toStorageString = function t3() {
            return i.Log.debug("State.toStorageString"), JSON.stringify({ id: this.id, data: this.data, created: this.created, request_type: this.request_type });
          }, t2.fromStorageString = function e2(r2) {
            return i.Log.debug("State.fromStorageString"), new t2(JSON.parse(r2));
          }, t2.clearStaleState = function e2(r2, n3) {
            var o2 = Date.now() / 1e3 - n3;
            return r2.getAllKeys().then(function(e3) {
              i.Log.debug("State.clearStaleState: got keys", e3);
              for (var n4 = [], s = function s2(a3) {
                var c = e3[a3];
                u = r2.get(c).then(function(e4) {
                  var n5 = false;
                  if (e4) try {
                    var s3 = t2.fromStorageString(e4);
                    i.Log.debug("State.clearStaleState: got item from key: ", c, s3.created), s3.created <= o2 && (n5 = true);
                  } catch (t3) {
                    i.Log.error("State.clearStaleState: Error parsing state for key", c, t3.message), n5 = true;
                  }
                  else i.Log.debug("State.clearStaleState: no item in storage for key: ", c), n5 = true;
                  if (n5) return i.Log.debug("State.clearStaleState: removed item for key: ", c), r2.remove(c);
                }), n4.push(u);
              }, a2 = 0; a2 < e3.length; a2++) {
                var u;
                s(a2);
              }
              return i.Log.debug("State.clearStaleState: waiting on promise count:", n4.length), Promise.all(n4);
            });
          }, n2(t2, [{ key: "id", get: function t3() {
            return this._id;
          } }, { key: "data", get: function t3() {
            return this._data;
          } }, { key: "created", get: function t3() {
            return this._created;
          } }, { key: "request_type", get: function t3() {
            return this._request_type;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.OidcClient = void 0;
        var n2 = /* @__PURE__ */ function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n3 = e2[r2];
              n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(t3, n3.key, n3);
            }
          }
          return function(e2, r2, n3) {
            return r2 && t2(e2.prototype, r2), n3 && t2(e2, n3), e2;
          };
        }(), i = r(0), o = r(5), s = r(12), a = r(8), u = r(34), c = r(35), h = r(36), l = r(13), f = r(9);
        function g(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        e.OidcClient = function() {
          function t2() {
            var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            g(this, t2), e2 instanceof o.OidcClientSettings ? this._settings = e2 : this._settings = new o.OidcClientSettings(e2);
          }
          return t2.prototype.createSigninRequest = function t3() {
            var e2 = this, r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n3 = r2.response_type, o2 = r2.scope, s2 = r2.redirect_uri, u2 = r2.data, c2 = r2.state, h2 = r2.prompt, l2 = r2.display, f2 = r2.max_age, g2 = r2.ui_locales, d = r2.id_token_hint, p = r2.login_hint, v2 = r2.acr_values, y = r2.resource, m = r2.request, _ = r2.request_uri, S = r2.response_mode, b = r2.extraQueryParams, w = r2.extraTokenParams, F = r2.request_type, E = r2.skipUserInfo, x = arguments[1];
            i.Log.debug("OidcClient.createSigninRequest");
            var A = this._settings.client_id;
            n3 = n3 || this._settings.response_type, o2 = o2 || this._settings.scope, s2 = s2 || this._settings.redirect_uri, h2 = h2 || this._settings.prompt, l2 = l2 || this._settings.display, f2 = f2 || this._settings.max_age, g2 = g2 || this._settings.ui_locales, v2 = v2 || this._settings.acr_values, y = y || this._settings.resource, S = S || this._settings.response_mode, b = b || this._settings.extraQueryParams, w = w || this._settings.extraTokenParams;
            var k = this._settings.authority;
            return a.SigninRequest.isCode(n3) && "code" !== n3 ? Promise.reject(new Error("OpenID Connect hybrid flow is not supported")) : this._metadataService.getAuthorizationEndpoint().then(function(t4) {
              i.Log.debug("OidcClient.createSigninRequest: Received authorization endpoint", t4);
              var r3 = new a.SigninRequest({ url: t4, client_id: A, redirect_uri: s2, response_type: n3, scope: o2, data: u2 || c2, authority: k, prompt: h2, display: l2, max_age: f2, ui_locales: g2, id_token_hint: d, login_hint: p, acr_values: v2, resource: y, request: m, request_uri: _, extraQueryParams: b, extraTokenParams: w, request_type: F, response_mode: S, client_secret: e2._settings.client_secret, skipUserInfo: E }), P = r3.state;
              return (x = x || e2._stateStore).set(P.id, P.toStorageString()).then(function() {
                return r3;
              });
            });
          }, t2.prototype.readSigninResponseState = function t3(e2, r2) {
            var n3 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            i.Log.debug("OidcClient.readSigninResponseState");
            var o2 = "query" === this._settings.response_mode || !this._settings.response_mode && a.SigninRequest.isCode(this._settings.response_type), s2 = o2 ? "?" : "#", c2 = new u.SigninResponse(e2, s2);
            if (!c2.state) return i.Log.error("OidcClient.readSigninResponseState: No state in response"), Promise.reject(new Error("No state in response"));
            r2 = r2 || this._stateStore;
            var h2 = n3 ? r2.remove.bind(r2) : r2.get.bind(r2);
            return h2(c2.state).then(function(t4) {
              if (!t4) throw i.Log.error("OidcClient.readSigninResponseState: No matching state found in storage"), new Error("No matching state found in storage");
              return { state: l.SigninState.fromStorageString(t4), response: c2 };
            });
          }, t2.prototype.processSigninResponse = function t3(e2, r2) {
            var n3 = this;
            return i.Log.debug("OidcClient.processSigninResponse"), this.readSigninResponseState(e2, r2, true).then(function(t4) {
              var e3 = t4.state, r3 = t4.response;
              return i.Log.debug("OidcClient.processSigninResponse: Received state from storage; validating response"), n3._validator.validateSigninResponse(e3, r3);
            });
          }, t2.prototype.createSignoutRequest = function t3() {
            var e2 = this, r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n3 = r2.id_token_hint, o2 = r2.data, s2 = r2.state, a2 = r2.post_logout_redirect_uri, u2 = r2.extraQueryParams, h2 = r2.request_type, l2 = arguments[1];
            return i.Log.debug("OidcClient.createSignoutRequest"), a2 = a2 || this._settings.post_logout_redirect_uri, u2 = u2 || this._settings.extraQueryParams, this._metadataService.getEndSessionEndpoint().then(function(t4) {
              if (!t4) throw i.Log.error("OidcClient.createSignoutRequest: No end session endpoint url returned"), new Error("no end session endpoint");
              i.Log.debug("OidcClient.createSignoutRequest: Received end session endpoint", t4);
              var r3 = new c.SignoutRequest({ url: t4, id_token_hint: n3, post_logout_redirect_uri: a2, data: o2 || s2, extraQueryParams: u2, request_type: h2 }), f2 = r3.state;
              return f2 && (i.Log.debug("OidcClient.createSignoutRequest: Signout request has state to persist"), (l2 = l2 || e2._stateStore).set(f2.id, f2.toStorageString())), r3;
            });
          }, t2.prototype.readSignoutResponseState = function t3(e2, r2) {
            var n3 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            i.Log.debug("OidcClient.readSignoutResponseState");
            var o2 = new h.SignoutResponse(e2);
            if (!o2.state) return i.Log.debug("OidcClient.readSignoutResponseState: No state in response"), o2.error ? (i.Log.warn("OidcClient.readSignoutResponseState: Response was error: ", o2.error), Promise.reject(new s.ErrorResponse(o2))) : Promise.resolve({ state: void 0, response: o2 });
            var a2 = o2.state;
            r2 = r2 || this._stateStore;
            var u2 = n3 ? r2.remove.bind(r2) : r2.get.bind(r2);
            return u2(a2).then(function(t4) {
              if (!t4) throw i.Log.error("OidcClient.readSignoutResponseState: No matching state found in storage"), new Error("No matching state found in storage");
              return { state: f.State.fromStorageString(t4), response: o2 };
            });
          }, t2.prototype.processSignoutResponse = function t3(e2, r2) {
            var n3 = this;
            return i.Log.debug("OidcClient.processSignoutResponse"), this.readSignoutResponseState(e2, r2, true).then(function(t4) {
              var e3 = t4.state, r3 = t4.response;
              return e3 ? (i.Log.debug("OidcClient.processSignoutResponse: Received state from storage; validating response"), n3._validator.validateSignoutResponse(e3, r3)) : (i.Log.debug("OidcClient.processSignoutResponse: No state from storage; skipping validating response"), r3);
            });
          }, t2.prototype.clearStaleState = function t3(e2) {
            return i.Log.debug("OidcClient.clearStaleState"), e2 = e2 || this._stateStore, f.State.clearStaleState(e2, this.settings.staleStateAge);
          }, n2(t2, [{ key: "_stateStore", get: function t3() {
            return this.settings.stateStore;
          } }, { key: "_validator", get: function t3() {
            return this.settings.validator;
          } }, { key: "_metadataService", get: function t3() {
            return this.settings.metadataService;
          } }, { key: "settings", get: function t3() {
            return this._settings;
          } }, { key: "metadataService", get: function t3() {
            return this._metadataService;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.TokenClient = void 0;
        var n2 = r(7), i = r(2), o = r(0);
        function s(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        e.TokenClient = function() {
          function t2(e2) {
            var r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n2.JsonService, a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.MetadataService;
            if (s(this, t2), !e2) throw o.Log.error("TokenClient.ctor: No settings passed"), new Error("settings");
            this._settings = e2, this._jsonService = new r2(), this._metadataService = new a(this._settings);
          }
          return t2.prototype.exchangeCode = function t3() {
            var e2 = this, r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            (r2 = Object.assign({}, r2)).grant_type = r2.grant_type || "authorization_code", r2.client_id = r2.client_id || this._settings.client_id, r2.client_secret = r2.client_secret || this._settings.client_secret, r2.redirect_uri = r2.redirect_uri || this._settings.redirect_uri;
            var n3 = void 0, i2 = r2._client_authentication || this._settings._client_authentication;
            return delete r2._client_authentication, r2.code ? r2.redirect_uri ? r2.code_verifier ? r2.client_id ? r2.client_secret || "client_secret_basic" != i2 ? ("client_secret_basic" == i2 && (n3 = r2.client_id + ":" + r2.client_secret, delete r2.client_id, delete r2.client_secret), this._metadataService.getTokenEndpoint(false).then(function(t4) {
              return o.Log.debug("TokenClient.exchangeCode: Received token endpoint"), e2._jsonService.postForm(t4, r2, n3).then(function(t5) {
                return o.Log.debug("TokenClient.exchangeCode: response received"), t5;
              });
            })) : (o.Log.error("TokenClient.exchangeCode: No client_secret passed"), Promise.reject(new Error("A client_secret is required"))) : (o.Log.error("TokenClient.exchangeCode: No client_id passed"), Promise.reject(new Error("A client_id is required"))) : (o.Log.error("TokenClient.exchangeCode: No code_verifier passed"), Promise.reject(new Error("A code_verifier is required"))) : (o.Log.error("TokenClient.exchangeCode: No redirect_uri passed"), Promise.reject(new Error("A redirect_uri is required"))) : (o.Log.error("TokenClient.exchangeCode: No code passed"), Promise.reject(new Error("A code is required")));
          }, t2.prototype.exchangeRefreshToken = function t3() {
            var e2 = this, r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            (r2 = Object.assign({}, r2)).grant_type = r2.grant_type || "refresh_token", r2.client_id = r2.client_id || this._settings.client_id, r2.client_secret = r2.client_secret || this._settings.client_secret;
            var n3 = void 0, i2 = r2._client_authentication || this._settings._client_authentication;
            return delete r2._client_authentication, r2.refresh_token ? r2.client_id ? ("client_secret_basic" == i2 && (n3 = r2.client_id + ":" + r2.client_secret, delete r2.client_id, delete r2.client_secret), this._metadataService.getTokenEndpoint(false).then(function(t4) {
              return o.Log.debug("TokenClient.exchangeRefreshToken: Received token endpoint"), e2._jsonService.postForm(t4, r2, n3).then(function(t5) {
                return o.Log.debug("TokenClient.exchangeRefreshToken: response received"), t5;
              });
            })) : (o.Log.error("TokenClient.exchangeRefreshToken: No client_id passed"), Promise.reject(new Error("A client_id is required"))) : (o.Log.error("TokenClient.exchangeRefreshToken: No refresh_token passed"), Promise.reject(new Error("A refresh_token is required")));
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.ErrorResponse = void 0;
        var n2 = r(0);
        function i(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        function o(t2, e2) {
          if (!t2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !e2 || "object" != typeof e2 && "function" != typeof e2 ? t2 : e2;
        }
        e.ErrorResponse = function(t2) {
          function e2() {
            var r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, s = r2.error, a = r2.error_description, u = r2.error_uri, c = r2.state, h = r2.session_state;
            if (i(this, e2), !s) throw n2.Log.error("No error passed to ErrorResponse"), new Error("error");
            var l = o(this, t2.call(this, a || s));
            return l.name = "ErrorResponse", l.error = s, l.error_description = a, l.error_uri = u, l.state = c, l.session_state = h, l;
          }
          return function r2(t3, e3) {
            if ("function" != typeof e3 && null !== e3) throw new TypeError("Super expression must either be null or a function, not " + typeof e3);
            t3.prototype = Object.create(e3 && e3.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), e3 && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, e3) : t3.__proto__ = e3);
          }(e2, t2), e2;
        }(Error);
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.SigninState = void 0;
        var n2 = /* @__PURE__ */ function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n3 = e2[r2];
              n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(t3, n3.key, n3);
            }
          }
          return function(e2, r2, n3) {
            return r2 && t2(e2.prototype, r2), n3 && t2(e2, n3), e2;
          };
        }(), i = r(0), o = r(9), s = r(4), a = function u(t2) {
          return t2 && t2.__esModule ? t2 : { default: t2 };
        }(r(14));
        function c(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        function h(t2, e2) {
          if (!t2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !e2 || "object" != typeof e2 && "function" != typeof e2 ? t2 : e2;
        }
        e.SigninState = function(t2) {
          function e2() {
            var r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n3 = r2.nonce, i2 = r2.authority, o2 = r2.client_id, u = r2.redirect_uri, l = r2.code_verifier, f = r2.response_mode, g = r2.client_secret, d = r2.scope, p = r2.extraTokenParams, v2 = r2.skipUserInfo;
            c(this, e2);
            var y = h(this, t2.call(this, arguments[0]));
            if (true === n3 ? y._nonce = (0, a.default)() : n3 && (y._nonce = n3), true === l ? y._code_verifier = (0, a.default)() + (0, a.default)() + (0, a.default)() : l && (y._code_verifier = l), y.code_verifier) {
              var m = s.JoseUtil.hashString(y.code_verifier, "SHA256");
              y._code_challenge = s.JoseUtil.hexToBase64Url(m);
            }
            return y._redirect_uri = u, y._authority = i2, y._client_id = o2, y._response_mode = f, y._client_secret = g, y._scope = d, y._extraTokenParams = p, y._skipUserInfo = v2, y;
          }
          return function r2(t3, e3) {
            if ("function" != typeof e3 && null !== e3) throw new TypeError("Super expression must either be null or a function, not " + typeof e3);
            t3.prototype = Object.create(e3 && e3.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), e3 && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, e3) : t3.__proto__ = e3);
          }(e2, t2), e2.prototype.toStorageString = function t3() {
            return i.Log.debug("SigninState.toStorageString"), JSON.stringify({ id: this.id, data: this.data, created: this.created, request_type: this.request_type, nonce: this.nonce, code_verifier: this.code_verifier, redirect_uri: this.redirect_uri, authority: this.authority, client_id: this.client_id, response_mode: this.response_mode, client_secret: this.client_secret, scope: this.scope, extraTokenParams: this.extraTokenParams, skipUserInfo: this.skipUserInfo });
          }, e2.fromStorageString = function t3(r2) {
            return i.Log.debug("SigninState.fromStorageString"), new e2(JSON.parse(r2));
          }, n2(e2, [{ key: "nonce", get: function t3() {
            return this._nonce;
          } }, { key: "authority", get: function t3() {
            return this._authority;
          } }, { key: "client_id", get: function t3() {
            return this._client_id;
          } }, { key: "redirect_uri", get: function t3() {
            return this._redirect_uri;
          } }, { key: "code_verifier", get: function t3() {
            return this._code_verifier;
          } }, { key: "code_challenge", get: function t3() {
            return this._code_challenge;
          } }, { key: "response_mode", get: function t3() {
            return this._response_mode;
          } }, { key: "client_secret", get: function t3() {
            return this._client_secret;
          } }, { key: "scope", get: function t3() {
            return this._scope;
          } }, { key: "extraTokenParams", get: function t3() {
            return this._extraTokenParams;
          } }, { key: "skipUserInfo", get: function t3() {
            return this._skipUserInfo;
          } }]), e2;
        }(o.State);
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.default = function n2() {
          return ("undefined" != i && null !== i && void 0 !== i.getRandomValues ? o : s)().replace(/-/g, "");
        };
        var i = "undefined" != typeof window ? window.crypto || window.msCrypto : null;
        function o() {
          return ("10000000-1000-4000-8000" + -1e11).replace(/[018]/g, function(t2) {
            return (t2 ^ i.getRandomValues(new Uint8Array(1))[0] & 15 >> t2 / 4).toString(16);
          });
        }
        function s() {
          return ("10000000-1000-4000-8000" + -1e11).replace(/[018]/g, function(t2) {
            return (t2 ^ 16 * Math.random() >> t2 / 4).toString(16);
          });
        }
        t.exports = e.default;
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.User = void 0;
        var n2 = /* @__PURE__ */ function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n3 = e2[r2];
              n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(t3, n3.key, n3);
            }
          }
          return function(e2, r2, n3) {
            return r2 && t2(e2.prototype, r2), n3 && t2(e2, n3), e2;
          };
        }(), i = r(0);
        e.User = function() {
          function t2(e2) {
            var r2 = e2.id_token, n3 = e2.session_state, i2 = e2.access_token, o = e2.refresh_token, s = e2.token_type, a = e2.scope, u = e2.profile, c = e2.expires_at, h = e2.state;
            !function l(t3, e3) {
              if (!(t3 instanceof e3)) throw new TypeError("Cannot call a class as a function");
            }(this, t2), this.id_token = r2, this.session_state = n3, this.access_token = i2, this.refresh_token = o, this.token_type = s, this.scope = a, this.profile = u, this.expires_at = c, this.state = h;
          }
          return t2.prototype.toStorageString = function t3() {
            return i.Log.debug("User.toStorageString"), JSON.stringify({ id_token: this.id_token, session_state: this.session_state, access_token: this.access_token, refresh_token: this.refresh_token, token_type: this.token_type, scope: this.scope, profile: this.profile, expires_at: this.expires_at });
          }, t2.fromStorageString = function e2(r2) {
            return i.Log.debug("User.fromStorageString"), new t2(JSON.parse(r2));
          }, n2(t2, [{ key: "expires_in", get: function t3() {
            if (this.expires_at) {
              var e2 = parseInt(Date.now() / 1e3);
              return this.expires_at - e2;
            }
          }, set: function t3(e2) {
            var r2 = parseInt(e2);
            if ("number" == typeof r2 && r2 > 0) {
              var n3 = parseInt(Date.now() / 1e3);
              this.expires_at = n3 + r2;
            }
          } }, { key: "expired", get: function t3() {
            var e2 = this.expires_in;
            if (void 0 !== e2) return e2 <= 0;
          } }, { key: "scopes", get: function t3() {
            return (this.scope || "").split(" ");
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.AccessTokenEvents = void 0;
        var n2 = r(0), i = r(46);
        function o(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        e.AccessTokenEvents = function() {
          function t2() {
            var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r2 = e2.accessTokenExpiringNotificationTime, n3 = void 0 === r2 ? 60 : r2, s = e2.accessTokenExpiringTimer, a = void 0 === s ? new i.Timer("Access token expiring") : s, u = e2.accessTokenExpiredTimer, c = void 0 === u ? new i.Timer("Access token expired") : u;
            o(this, t2), this._accessTokenExpiringNotificationTime = n3, this._accessTokenExpiring = a, this._accessTokenExpired = c;
          }
          return t2.prototype.load = function t3(e2) {
            if (e2.access_token && void 0 !== e2.expires_in) {
              var r2 = e2.expires_in;
              if (n2.Log.debug("AccessTokenEvents.load: access token present, remaining duration:", r2), r2 > 0) {
                var i2 = r2 - this._accessTokenExpiringNotificationTime;
                i2 <= 0 && (i2 = 1), n2.Log.debug("AccessTokenEvents.load: registering expiring timer in:", i2), this._accessTokenExpiring.init(i2);
              } else n2.Log.debug("AccessTokenEvents.load: canceling existing expiring timer becase we're past expiration."), this._accessTokenExpiring.cancel();
              var o2 = r2 + 1;
              n2.Log.debug("AccessTokenEvents.load: registering expired timer in:", o2), this._accessTokenExpired.init(o2);
            } else this._accessTokenExpiring.cancel(), this._accessTokenExpired.cancel();
          }, t2.prototype.unload = function t3() {
            n2.Log.debug("AccessTokenEvents.unload: canceling existing access token timers"), this._accessTokenExpiring.cancel(), this._accessTokenExpired.cancel();
          }, t2.prototype.addAccessTokenExpiring = function t3(e2) {
            this._accessTokenExpiring.addHandler(e2);
          }, t2.prototype.removeAccessTokenExpiring = function t3(e2) {
            this._accessTokenExpiring.removeHandler(e2);
          }, t2.prototype.addAccessTokenExpired = function t3(e2) {
            this._accessTokenExpired.addHandler(e2);
          }, t2.prototype.removeAccessTokenExpired = function t3(e2) {
            this._accessTokenExpired.removeHandler(e2);
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.Event = void 0;
        var n2 = r(0);
        e.Event = function() {
          function t2(e2) {
            !function r2(t3, e3) {
              if (!(t3 instanceof e3)) throw new TypeError("Cannot call a class as a function");
            }(this, t2), this._name = e2, this._callbacks = [];
          }
          return t2.prototype.addHandler = function t3(e2) {
            this._callbacks.push(e2);
          }, t2.prototype.removeHandler = function t3(e2) {
            var r2 = this._callbacks.findIndex(function(t4) {
              return t4 === e2;
            });
            r2 >= 0 && this._callbacks.splice(r2, 1);
          }, t2.prototype.raise = function t3() {
            n2.Log.debug("Event: Raising event: " + this._name);
            for (var e2 = 0; e2 < this._callbacks.length; e2++) {
              var r2;
              (r2 = this._callbacks)[e2].apply(r2, arguments);
            }
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.SessionMonitor = void 0;
        var n2 = /* @__PURE__ */ function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n3 = e2[r2];
              n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(t3, n3.key, n3);
            }
          }
          return function(e2, r2, n3) {
            return r2 && t2(e2.prototype, r2), n3 && t2(e2, n3), e2;
          };
        }(), i = r(0), o = r(19), s = r(1);
        function a(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        e.SessionMonitor = function() {
          function t2(e2) {
            var r2 = this, n3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.CheckSessionIFrame, u = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : s.Global.timer;
            if (a(this, t2), !e2) throw i.Log.error("SessionMonitor.ctor: No user manager passed to SessionMonitor"), new Error("userManager");
            this._userManager = e2, this._CheckSessionIFrameCtor = n3, this._timer = u, this._userManager.events.addUserLoaded(this._start.bind(this)), this._userManager.events.addUserUnloaded(this._stop.bind(this)), Promise.resolve(this._userManager.getUser().then(function(t3) {
              t3 ? r2._start(t3) : r2._settings.monitorAnonymousSession && r2._userManager.querySessionStatus().then(function(t4) {
                var e3 = { session_state: t4.session_state };
                t4.sub && t4.sid && (e3.profile = { sub: t4.sub, sid: t4.sid }), r2._start(e3);
              }).catch(function(t4) {
                i.Log.error("SessionMonitor ctor: error from querySessionStatus:", t4.message);
              });
            }).catch(function(t3) {
              i.Log.error("SessionMonitor ctor: error from getUser:", t3.message);
            }));
          }
          return t2.prototype._start = function t3(e2) {
            var r2 = this, n3 = e2.session_state;
            n3 && (e2.profile ? (this._sub = e2.profile.sub, this._sid = e2.profile.sid, i.Log.debug("SessionMonitor._start: session_state:", n3, ", sub:", this._sub)) : (this._sub = void 0, this._sid = void 0, i.Log.debug("SessionMonitor._start: session_state:", n3, ", anonymous user")), this._checkSessionIFrame ? this._checkSessionIFrame.start(n3) : this._metadataService.getCheckSessionIframe().then(function(t4) {
              if (t4) {
                i.Log.debug("SessionMonitor._start: Initializing check session iframe");
                var e3 = r2._client_id, o2 = r2._checkSessionInterval, s2 = r2._stopCheckSessionOnError;
                r2._checkSessionIFrame = new r2._CheckSessionIFrameCtor(r2._callback.bind(r2), e3, t4, o2, s2), r2._checkSessionIFrame.load().then(function() {
                  r2._checkSessionIFrame.start(n3);
                });
              } else i.Log.warn("SessionMonitor._start: No check session iframe found in the metadata");
            }).catch(function(t4) {
              i.Log.error("SessionMonitor._start: Error from getCheckSessionIframe:", t4.message);
            }));
          }, t2.prototype._stop = function t3() {
            var e2 = this;
            if (this._sub = void 0, this._sid = void 0, this._checkSessionIFrame && (i.Log.debug("SessionMonitor._stop"), this._checkSessionIFrame.stop()), this._settings.monitorAnonymousSession) var r2 = this._timer.setInterval(function() {
              e2._timer.clearInterval(r2), e2._userManager.querySessionStatus().then(function(t4) {
                var r3 = { session_state: t4.session_state };
                t4.sub && t4.sid && (r3.profile = { sub: t4.sub, sid: t4.sid }), e2._start(r3);
              }).catch(function(t4) {
                i.Log.error("SessionMonitor: error from querySessionStatus:", t4.message);
              });
            }, 1e3);
          }, t2.prototype._callback = function t3() {
            var e2 = this;
            this._userManager.querySessionStatus().then(function(t4) {
              var r2 = true;
              t4 ? t4.sub === e2._sub ? (r2 = false, e2._checkSessionIFrame.start(t4.session_state), t4.sid === e2._sid ? i.Log.debug("SessionMonitor._callback: Same sub still logged in at OP, restarting check session iframe; session_state:", t4.session_state) : (i.Log.debug("SessionMonitor._callback: Same sub still logged in at OP, session state has changed, restarting check session iframe; session_state:", t4.session_state), e2._userManager.events._raiseUserSessionChanged())) : i.Log.debug("SessionMonitor._callback: Different subject signed into OP:", t4.sub) : i.Log.debug("SessionMonitor._callback: Subject no longer signed into OP"), r2 && (e2._sub ? (i.Log.debug("SessionMonitor._callback: SessionMonitor._callback; raising signed out event"), e2._userManager.events._raiseUserSignedOut()) : (i.Log.debug("SessionMonitor._callback: SessionMonitor._callback; raising signed in event"), e2._userManager.events._raiseUserSignedIn()));
            }).catch(function(t4) {
              e2._sub && (i.Log.debug("SessionMonitor._callback: Error calling queryCurrentSigninSession; raising signed out event", t4.message), e2._userManager.events._raiseUserSignedOut());
            });
          }, n2(t2, [{ key: "_settings", get: function t3() {
            return this._userManager.settings;
          } }, { key: "_metadataService", get: function t3() {
            return this._userManager.metadataService;
          } }, { key: "_client_id", get: function t3() {
            return this._settings.client_id;
          } }, { key: "_checkSessionInterval", get: function t3() {
            return this._settings.checkSessionInterval;
          } }, { key: "_stopCheckSessionOnError", get: function t3() {
            return this._settings.stopCheckSessionOnError;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.CheckSessionIFrame = void 0;
        var n2 = r(0);
        function i(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        e.CheckSessionIFrame = function() {
          function t2(e2, r2, n3, o) {
            var s = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4];
            i(this, t2), this._callback = e2, this._client_id = r2, this._url = n3, this._interval = o || 2e3, this._stopOnError = s;
            var a = n3.indexOf("/", n3.indexOf("//") + 2);
            this._frame_origin = n3.substr(0, a), this._frame = window.document.createElement("iframe"), this._frame.style.visibility = "hidden", this._frame.style.position = "absolute", this._frame.style.display = "none", this._frame.width = 0, this._frame.height = 0, this._frame.src = n3;
          }
          return t2.prototype.load = function t3() {
            var e2 = this;
            return new Promise(function(t4) {
              e2._frame.onload = function() {
                t4();
              }, window.document.body.appendChild(e2._frame), e2._boundMessageEvent = e2._message.bind(e2), window.addEventListener("message", e2._boundMessageEvent, false);
            });
          }, t2.prototype._message = function t3(e2) {
            e2.origin === this._frame_origin && e2.source === this._frame.contentWindow && ("error" === e2.data ? (n2.Log.error("CheckSessionIFrame: error message from check session op iframe"), this._stopOnError && this.stop()) : "changed" === e2.data ? (n2.Log.debug("CheckSessionIFrame: changed message from check session op iframe"), this.stop(), this._callback()) : n2.Log.debug("CheckSessionIFrame: " + e2.data + " message from check session op iframe"));
          }, t2.prototype.start = function t3(e2) {
            var r2 = this;
            if (this._session_state !== e2) {
              n2.Log.debug("CheckSessionIFrame.start"), this.stop(), this._session_state = e2;
              var i2 = function t4() {
                r2._frame.contentWindow.postMessage(r2._client_id + " " + r2._session_state, r2._frame_origin);
              };
              i2(), this._timer = window.setInterval(i2, this._interval);
            }
          }, t2.prototype.stop = function t3() {
            this._session_state = null, this._timer && (n2.Log.debug("CheckSessionIFrame.stop"), window.clearInterval(this._timer), this._timer = null);
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.TokenRevocationClient = void 0;
        var n2 = r(0), i = r(2), o = r(1);
        function s(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        var a = "access_token", u = "refresh_token";
        e.TokenRevocationClient = function() {
          function t2(e2) {
            var r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.Global.XMLHttpRequest, a2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.MetadataService;
            if (s(this, t2), !e2) throw n2.Log.error("TokenRevocationClient.ctor: No settings provided"), new Error("No settings provided.");
            this._settings = e2, this._XMLHttpRequestCtor = r2, this._metadataService = new a2(this._settings);
          }
          return t2.prototype.revoke = function t3(e2, r2) {
            var i2 = this, o2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "access_token";
            if (!e2) throw n2.Log.error("TokenRevocationClient.revoke: No token provided"), new Error("No token provided.");
            if (o2 !== a && o2 != u) throw n2.Log.error("TokenRevocationClient.revoke: Invalid token type"), new Error("Invalid token type.");
            return this._metadataService.getRevocationEndpoint().then(function(t4) {
              if (t4) {
                n2.Log.debug("TokenRevocationClient.revoke: Revoking " + o2);
                var s2 = i2._settings.client_id, a2 = i2._settings.client_secret;
                return i2._revoke(t4, s2, a2, e2, o2);
              }
              if (r2) throw n2.Log.error("TokenRevocationClient.revoke: Revocation not supported"), new Error("Revocation not supported");
            });
          }, t2.prototype._revoke = function t3(e2, r2, i2, o2, s2) {
            var a2 = this;
            return new Promise(function(t4, u2) {
              var c = new a2._XMLHttpRequestCtor();
              c.open("POST", e2), c.onload = function() {
                n2.Log.debug("TokenRevocationClient.revoke: HTTP response received, status", c.status), 200 === c.status ? t4() : u2(Error(c.statusText + " (" + c.status + ")"));
              }, c.onerror = function() {
                n2.Log.debug("TokenRevocationClient.revoke: Network Error."), u2("Network Error");
              };
              var h = "client_id=" + encodeURIComponent(r2);
              i2 && (h += "&client_secret=" + encodeURIComponent(i2)), h += "&token_type_hint=" + encodeURIComponent(s2), h += "&token=" + encodeURIComponent(o2), c.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), c.send(h);
            });
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.CordovaPopupWindow = void 0;
        var n2 = /* @__PURE__ */ function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n3 = e2[r2];
              n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(t3, n3.key, n3);
            }
          }
          return function(e2, r2, n3) {
            return r2 && t2(e2.prototype, r2), n3 && t2(e2, n3), e2;
          };
        }(), i = r(0);
        e.CordovaPopupWindow = function() {
          function t2(e2) {
            var r2 = this;
            !function n3(t3, e3) {
              if (!(t3 instanceof e3)) throw new TypeError("Cannot call a class as a function");
            }(this, t2), this._promise = new Promise(function(t3, e3) {
              r2._resolve = t3, r2._reject = e3;
            }), this.features = e2.popupWindowFeatures || "location=no,toolbar=no,zoom=no", this.target = e2.popupWindowTarget || "_blank", this.redirect_uri = e2.startUrl, i.Log.debug("CordovaPopupWindow.ctor: redirect_uri: " + this.redirect_uri);
          }
          return t2.prototype._isInAppBrowserInstalled = function t3(e2) {
            return ["cordova-plugin-inappbrowser", "cordova-plugin-inappbrowser.inappbrowser", "org.apache.cordova.inappbrowser"].some(function(t4) {
              return e2.hasOwnProperty(t4);
            });
          }, t2.prototype.navigate = function t3(e2) {
            if (e2 && e2.url) {
              if (!window.cordova) return this._error("cordova is undefined");
              var r2 = window.cordova.require("cordova/plugin_list").metadata;
              if (false === this._isInAppBrowserInstalled(r2)) return this._error("InAppBrowser plugin not found");
              this._popup = cordova.InAppBrowser.open(e2.url, this.target, this.features), this._popup ? (i.Log.debug("CordovaPopupWindow.navigate: popup successfully created"), this._exitCallbackEvent = this._exitCallback.bind(this), this._loadStartCallbackEvent = this._loadStartCallback.bind(this), this._popup.addEventListener("exit", this._exitCallbackEvent, false), this._popup.addEventListener("loadstart", this._loadStartCallbackEvent, false)) : this._error("Error opening popup window");
            } else this._error("No url provided");
            return this.promise;
          }, t2.prototype._loadStartCallback = function t3(e2) {
            0 === e2.url.indexOf(this.redirect_uri) && this._success({ url: e2.url });
          }, t2.prototype._exitCallback = function t3(e2) {
            this._error(e2);
          }, t2.prototype._success = function t3(e2) {
            this._cleanup(), i.Log.debug("CordovaPopupWindow: Successful response from cordova popup window"), this._resolve(e2);
          }, t2.prototype._error = function t3(e2) {
            this._cleanup(), i.Log.error(e2), this._reject(new Error(e2));
          }, t2.prototype.close = function t3() {
            this._cleanup();
          }, t2.prototype._cleanup = function t3() {
            this._popup && (i.Log.debug("CordovaPopupWindow: cleaning up popup"), this._popup.removeEventListener("exit", this._exitCallbackEvent, false), this._popup.removeEventListener("loadstart", this._loadStartCallbackEvent, false), this._popup.close()), this._popup = null;
          }, n2(t2, [{ key: "promise", get: function t3() {
            return this._promise;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true });
        var n2 = r(0), i = r(10), o = r(5), s = r(6), a = r(37), u = r(38), c = r(16), h = r(2), l = r(48), f = r(49), g = r(19), d = r(20), p = r(18), v2 = r(1), y = r(15), m = r(50);
        e.default = { Version: m.Version, Log: n2.Log, OidcClient: i.OidcClient, OidcClientSettings: o.OidcClientSettings, WebStorageStateStore: s.WebStorageStateStore, InMemoryWebStorage: a.InMemoryWebStorage, UserManager: u.UserManager, AccessTokenEvents: c.AccessTokenEvents, MetadataService: h.MetadataService, CordovaPopupNavigator: l.CordovaPopupNavigator, CordovaIFrameNavigator: f.CordovaIFrameNavigator, CheckSessionIFrame: g.CheckSessionIFrame, TokenRevocationClient: d.TokenRevocationClient, SessionMonitor: p.SessionMonitor, Global: v2.Global, User: y.User }, t.exports = e.default;
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true });
        e.ClockService = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2)) throw new TypeError("Cannot call a class as a function");
            }(this, t2);
          }
          return t2.prototype.getEpochTime = function t3() {
            return Promise.resolve(Date.now() / 1e3 | 0);
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.ResponseValidator = void 0;
        var n2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t2) {
          return typeof t2;
        } : function(t2) {
          return t2 && "function" == typeof Symbol && t2.constructor === Symbol && t2 !== Symbol.prototype ? "symbol" : typeof t2;
        }, i = r(0), o = r(2), s = r(25), a = r(11), u = r(12), c = r(4);
        function h(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        var l = ["nonce", "at_hash", "iat", "nbf", "exp", "aud", "iss", "c_hash"];
        e.ResponseValidator = function() {
          function t2(e2) {
            var r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.MetadataService, n3 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : s.UserInfoService, u2 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : c.JoseUtil, l2 = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : a.TokenClient;
            if (h(this, t2), !e2) throw i.Log.error("ResponseValidator.ctor: No settings passed to ResponseValidator"), new Error("settings");
            this._settings = e2, this._metadataService = new r2(this._settings), this._userInfoService = new n3(this._settings), this._joseUtil = u2, this._tokenClient = new l2(this._settings);
          }
          return t2.prototype.validateSigninResponse = function t3(e2, r2) {
            var n3 = this;
            return i.Log.debug("ResponseValidator.validateSigninResponse"), this._processSigninParams(e2, r2).then(function(t4) {
              return i.Log.debug("ResponseValidator.validateSigninResponse: state processed"), n3._validateTokens(e2, t4).then(function(t5) {
                return i.Log.debug("ResponseValidator.validateSigninResponse: tokens validated"), n3._processClaims(e2, t5).then(function(t6) {
                  return i.Log.debug("ResponseValidator.validateSigninResponse: claims processed"), t6;
                });
              });
            });
          }, t2.prototype.validateSignoutResponse = function t3(e2, r2) {
            return e2.id !== r2.state ? (i.Log.error("ResponseValidator.validateSignoutResponse: State does not match"), Promise.reject(new Error("State does not match"))) : (i.Log.debug("ResponseValidator.validateSignoutResponse: state validated"), r2.state = e2.data, r2.error ? (i.Log.warn("ResponseValidator.validateSignoutResponse: Response was error", r2.error), Promise.reject(new u.ErrorResponse(r2))) : Promise.resolve(r2));
          }, t2.prototype._processSigninParams = function t3(e2, r2) {
            if (e2.id !== r2.state) return i.Log.error("ResponseValidator._processSigninParams: State does not match"), Promise.reject(new Error("State does not match"));
            if (!e2.client_id) return i.Log.error("ResponseValidator._processSigninParams: No client_id on state"), Promise.reject(new Error("No client_id on state"));
            if (!e2.authority) return i.Log.error("ResponseValidator._processSigninParams: No authority on state"), Promise.reject(new Error("No authority on state"));
            if (this._settings.authority) {
              if (this._settings.authority && this._settings.authority !== e2.authority) return i.Log.error("ResponseValidator._processSigninParams: authority mismatch on settings vs. signin state"), Promise.reject(new Error("authority mismatch on settings vs. signin state"));
            } else this._settings.authority = e2.authority;
            if (this._settings.client_id) {
              if (this._settings.client_id && this._settings.client_id !== e2.client_id) return i.Log.error("ResponseValidator._processSigninParams: client_id mismatch on settings vs. signin state"), Promise.reject(new Error("client_id mismatch on settings vs. signin state"));
            } else this._settings.client_id = e2.client_id;
            return i.Log.debug("ResponseValidator._processSigninParams: state validated"), r2.state = e2.data, r2.error ? (i.Log.warn("ResponseValidator._processSigninParams: Response was error", r2.error), Promise.reject(new u.ErrorResponse(r2))) : e2.nonce && !r2.id_token ? (i.Log.error("ResponseValidator._processSigninParams: Expecting id_token in response"), Promise.reject(new Error("No id_token in response"))) : !e2.nonce && r2.id_token ? (i.Log.error("ResponseValidator._processSigninParams: Not expecting id_token in response"), Promise.reject(new Error("Unexpected id_token in response"))) : e2.code_verifier && !r2.code ? (i.Log.error("ResponseValidator._processSigninParams: Expecting code in response"), Promise.reject(new Error("No code in response"))) : !e2.code_verifier && r2.code ? (i.Log.error("ResponseValidator._processSigninParams: Not expecting code in response"), Promise.reject(new Error("Unexpected code in response"))) : (r2.scope || (r2.scope = e2.scope), Promise.resolve(r2));
          }, t2.prototype._processClaims = function t3(e2, r2) {
            var n3 = this;
            if (r2.isOpenIdConnect) {
              if (i.Log.debug("ResponseValidator._processClaims: response is OIDC, processing claims"), r2.profile = this._filterProtocolClaims(r2.profile), true !== e2.skipUserInfo && this._settings.loadUserInfo && r2.access_token) return i.Log.debug("ResponseValidator._processClaims: loading user info"), this._userInfoService.getClaims(r2.access_token).then(function(t4) {
                return i.Log.debug("ResponseValidator._processClaims: user info claims received from user info endpoint"), t4.sub !== r2.profile.sub ? (i.Log.error("ResponseValidator._processClaims: sub from user info endpoint does not match sub in id_token"), Promise.reject(new Error("sub from user info endpoint does not match sub in id_token"))) : (r2.profile = n3._mergeClaims(r2.profile, t4), i.Log.debug("ResponseValidator._processClaims: user info claims received, updated profile:", r2.profile), r2);
              });
              i.Log.debug("ResponseValidator._processClaims: not loading user info");
            } else i.Log.debug("ResponseValidator._processClaims: response is not OIDC, not processing claims");
            return Promise.resolve(r2);
          }, t2.prototype._mergeClaims = function t3(e2, r2) {
            var i2 = Object.assign({}, e2);
            for (var o2 in r2) {
              var s2 = r2[o2];
              Array.isArray(s2) || (s2 = [s2]);
              for (var a2 = 0; a2 < s2.length; a2++) {
                var u2 = s2[a2];
                i2[o2] ? Array.isArray(i2[o2]) ? i2[o2].indexOf(u2) < 0 && i2[o2].push(u2) : i2[o2] !== u2 && ("object" === (void 0 === u2 ? "undefined" : n2(u2)) && this._settings.mergeClaims ? i2[o2] = this._mergeClaims(i2[o2], u2) : i2[o2] = [i2[o2], u2]) : i2[o2] = u2;
              }
            }
            return i2;
          }, t2.prototype._filterProtocolClaims = function t3(e2) {
            i.Log.debug("ResponseValidator._filterProtocolClaims, incoming claims:", e2);
            var r2 = Object.assign({}, e2);
            return this._settings._filterProtocolClaims ? (l.forEach(function(t4) {
              delete r2[t4];
            }), i.Log.debug("ResponseValidator._filterProtocolClaims: protocol claims filtered", r2)) : i.Log.debug("ResponseValidator._filterProtocolClaims: protocol claims not filtered"), r2;
          }, t2.prototype._validateTokens = function t3(e2, r2) {
            return r2.code ? (i.Log.debug("ResponseValidator._validateTokens: Validating code"), this._processCode(e2, r2)) : r2.id_token ? r2.access_token ? (i.Log.debug("ResponseValidator._validateTokens: Validating id_token and access_token"), this._validateIdTokenAndAccessToken(e2, r2)) : (i.Log.debug("ResponseValidator._validateTokens: Validating id_token"), this._validateIdToken(e2, r2)) : (i.Log.debug("ResponseValidator._validateTokens: No code to process or id_token to validate"), Promise.resolve(r2));
          }, t2.prototype._processCode = function t3(e2, r2) {
            var o2 = this, s2 = { client_id: e2.client_id, client_secret: e2.client_secret, code: r2.code, redirect_uri: e2.redirect_uri, code_verifier: e2.code_verifier };
            return e2.extraTokenParams && "object" === n2(e2.extraTokenParams) && Object.assign(s2, e2.extraTokenParams), this._tokenClient.exchangeCode(s2).then(function(t4) {
              for (var n3 in t4) r2[n3] = t4[n3];
              return r2.id_token ? (i.Log.debug("ResponseValidator._processCode: token response successful, processing id_token"), o2._validateIdTokenAttributes(e2, r2)) : (i.Log.debug("ResponseValidator._processCode: token response successful, returning response"), r2);
            });
          }, t2.prototype._validateIdTokenAttributes = function t3(e2, r2) {
            var n3 = this;
            return this._metadataService.getIssuer().then(function(t4) {
              var o2 = e2.client_id, s2 = n3._settings.clockSkew;
              return i.Log.debug("ResponseValidator._validateIdTokenAttributes: Validaing JWT attributes; using clock skew (in seconds) of: ", s2), n3._settings.getEpochTime().then(function(a2) {
                return n3._joseUtil.validateJwtAttributes(r2.id_token, t4, o2, s2, a2).then(function(t5) {
                  return e2.nonce && e2.nonce !== t5.nonce ? (i.Log.error("ResponseValidator._validateIdTokenAttributes: Invalid nonce in id_token"), Promise.reject(new Error("Invalid nonce in id_token"))) : t5.sub ? (r2.profile = t5, r2) : (i.Log.error("ResponseValidator._validateIdTokenAttributes: No sub present in id_token"), Promise.reject(new Error("No sub present in id_token")));
                });
              });
            });
          }, t2.prototype._validateIdTokenAndAccessToken = function t3(e2, r2) {
            var n3 = this;
            return this._validateIdToken(e2, r2).then(function(t4) {
              return n3._validateAccessToken(t4);
            });
          }, t2.prototype._getSigningKeyForJwt = function t3(e2) {
            var r2 = this;
            return this._metadataService.getSigningKeys().then(function(t4) {
              var n3 = e2.header.kid;
              if (!t4) return i.Log.error("ResponseValidator._validateIdToken: No signing keys from metadata"), Promise.reject(new Error("No signing keys from metadata"));
              i.Log.debug("ResponseValidator._validateIdToken: Received signing keys");
              var o2 = void 0;
              if (n3) o2 = t4.filter(function(t5) {
                return t5.kid === n3;
              })[0];
              else {
                if ((t4 = r2._filterByAlg(t4, e2.header.alg)).length > 1) return i.Log.error("ResponseValidator._validateIdToken: No kid found in id_token and more than one key found in metadata"), Promise.reject(new Error("No kid found in id_token and more than one key found in metadata"));
                o2 = t4[0];
              }
              return Promise.resolve(o2);
            });
          }, t2.prototype._getSigningKeyForJwtWithSingleRetry = function t3(e2) {
            var r2 = this;
            return this._getSigningKeyForJwt(e2).then(function(t4) {
              return t4 ? Promise.resolve(t4) : (r2._metadataService.resetSigningKeys(), r2._getSigningKeyForJwt(e2));
            });
          }, t2.prototype._validateIdToken = function t3(e2, r2) {
            var n3 = this;
            if (!e2.nonce) return i.Log.error("ResponseValidator._validateIdToken: No nonce on state"), Promise.reject(new Error("No nonce on state"));
            var o2 = this._joseUtil.parseJwt(r2.id_token);
            return o2 && o2.header && o2.payload ? e2.nonce !== o2.payload.nonce ? (i.Log.error("ResponseValidator._validateIdToken: Invalid nonce in id_token"), Promise.reject(new Error("Invalid nonce in id_token"))) : this._metadataService.getIssuer().then(function(t4) {
              return i.Log.debug("ResponseValidator._validateIdToken: Received issuer"), n3._getSigningKeyForJwtWithSingleRetry(o2).then(function(s2) {
                if (!s2) return i.Log.error("ResponseValidator._validateIdToken: No key matching kid or alg found in signing keys"), Promise.reject(new Error("No key matching kid or alg found in signing keys"));
                var a2 = e2.client_id, u2 = n3._settings.clockSkew;
                return i.Log.debug("ResponseValidator._validateIdToken: Validaing JWT; using clock skew (in seconds) of: ", u2), n3._joseUtil.validateJwt(r2.id_token, s2, t4, a2, u2).then(function() {
                  return i.Log.debug("ResponseValidator._validateIdToken: JWT validation successful"), o2.payload.sub ? (r2.profile = o2.payload, r2) : (i.Log.error("ResponseValidator._validateIdToken: No sub present in id_token"), Promise.reject(new Error("No sub present in id_token")));
                });
              });
            }) : (i.Log.error("ResponseValidator._validateIdToken: Failed to parse id_token", o2), Promise.reject(new Error("Failed to parse id_token")));
          }, t2.prototype._filterByAlg = function t3(e2, r2) {
            var n3 = null;
            if (r2.startsWith("RS")) n3 = "RSA";
            else if (r2.startsWith("PS")) n3 = "PS";
            else {
              if (!r2.startsWith("ES")) return i.Log.debug("ResponseValidator._filterByAlg: alg not supported: ", r2), [];
              n3 = "EC";
            }
            return i.Log.debug("ResponseValidator._filterByAlg: Looking for keys that match kty: ", n3), e2 = e2.filter(function(t4) {
              return t4.kty === n3;
            }), i.Log.debug("ResponseValidator._filterByAlg: Number of keys that match kty: ", n3, e2.length), e2;
          }, t2.prototype._validateAccessToken = function t3(e2) {
            if (!e2.profile) return i.Log.error("ResponseValidator._validateAccessToken: No profile loaded from id_token"), Promise.reject(new Error("No profile loaded from id_token"));
            if (!e2.profile.at_hash) return i.Log.error("ResponseValidator._validateAccessToken: No at_hash in id_token"), Promise.reject(new Error("No at_hash in id_token"));
            if (!e2.id_token) return i.Log.error("ResponseValidator._validateAccessToken: No id_token"), Promise.reject(new Error("No id_token"));
            var r2 = this._joseUtil.parseJwt(e2.id_token);
            if (!r2 || !r2.header) return i.Log.error("ResponseValidator._validateAccessToken: Failed to parse id_token", r2), Promise.reject(new Error("Failed to parse id_token"));
            var n3 = r2.header.alg;
            if (!n3 || 5 !== n3.length) return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:", n3), Promise.reject(new Error("Unsupported alg: " + n3));
            var o2 = n3.substr(2, 3);
            if (!o2) return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:", n3, o2), Promise.reject(new Error("Unsupported alg: " + n3));
            if (256 !== (o2 = parseInt(o2)) && 384 !== o2 && 512 !== o2) return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:", n3, o2), Promise.reject(new Error("Unsupported alg: " + n3));
            var s2 = "sha" + o2, a2 = this._joseUtil.hashString(e2.access_token, s2);
            if (!a2) return i.Log.error("ResponseValidator._validateAccessToken: access_token hash failed:", s2), Promise.reject(new Error("Failed to validate at_hash"));
            var u2 = a2.substr(0, a2.length / 2), c2 = this._joseUtil.hexToBase64Url(u2);
            return c2 !== e2.profile.at_hash ? (i.Log.error("ResponseValidator._validateAccessToken: Failed to validate at_hash", c2, e2.profile.at_hash), Promise.reject(new Error("Failed to validate at_hash"))) : (i.Log.debug("ResponseValidator._validateAccessToken: success"), Promise.resolve(e2));
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.UserInfoService = void 0;
        var n2 = r(7), i = r(2), o = r(0), s = r(4);
        function a(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        e.UserInfoService = function() {
          function t2(e2) {
            var r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n2.JsonService, u = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.MetadataService, c = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : s.JoseUtil;
            if (a(this, t2), !e2) throw o.Log.error("UserInfoService.ctor: No settings passed"), new Error("settings");
            this._settings = e2, this._jsonService = new r2(void 0, void 0, this._getClaimsFromJwt.bind(this)), this._metadataService = new u(this._settings), this._joseUtil = c;
          }
          return t2.prototype.getClaims = function t3(e2) {
            var r2 = this;
            return e2 ? this._metadataService.getUserInfoEndpoint().then(function(t4) {
              return o.Log.debug("UserInfoService.getClaims: received userinfo url", t4), r2._jsonService.getJson(t4, e2).then(function(t5) {
                return o.Log.debug("UserInfoService.getClaims: claims received", t5), t5;
              });
            }) : (o.Log.error("UserInfoService.getClaims: No token passed"), Promise.reject(new Error("A token is required")));
          }, t2.prototype._getClaimsFromJwt = function t3(e2) {
            var r2 = this;
            try {
              var n3 = this._joseUtil.parseJwt(e2.responseText);
              if (!n3 || !n3.header || !n3.payload) return o.Log.error("UserInfoService._getClaimsFromJwt: Failed to parse JWT", n3), Promise.reject(new Error("Failed to parse id_token"));
              var i2 = n3.header.kid, s2 = void 0;
              switch (this._settings.userInfoJwtIssuer) {
                case "OP":
                  s2 = this._metadataService.getIssuer();
                  break;
                case "ANY":
                  s2 = Promise.resolve(n3.payload.iss);
                  break;
                default:
                  s2 = Promise.resolve(this._settings.userInfoJwtIssuer);
              }
              return s2.then(function(t4) {
                return o.Log.debug("UserInfoService._getClaimsFromJwt: Received issuer:" + t4), r2._metadataService.getSigningKeys().then(function(s3) {
                  if (!s3) return o.Log.error("UserInfoService._getClaimsFromJwt: No signing keys from metadata"), Promise.reject(new Error("No signing keys from metadata"));
                  o.Log.debug("UserInfoService._getClaimsFromJwt: Received signing keys");
                  var a2 = void 0;
                  if (i2) a2 = s3.filter(function(t5) {
                    return t5.kid === i2;
                  })[0];
                  else {
                    if ((s3 = r2._filterByAlg(s3, n3.header.alg)).length > 1) return o.Log.error("UserInfoService._getClaimsFromJwt: No kid found in id_token and more than one key found in metadata"), Promise.reject(new Error("No kid found in id_token and more than one key found in metadata"));
                    a2 = s3[0];
                  }
                  if (!a2) return o.Log.error("UserInfoService._getClaimsFromJwt: No key matching kid or alg found in signing keys"), Promise.reject(new Error("No key matching kid or alg found in signing keys"));
                  var u = r2._settings.client_id, c = r2._settings.clockSkew;
                  return o.Log.debug("UserInfoService._getClaimsFromJwt: Validaing JWT; using clock skew (in seconds) of: ", c), r2._joseUtil.validateJwt(e2.responseText, a2, t4, u, c, void 0, true).then(function() {
                    return o.Log.debug("UserInfoService._getClaimsFromJwt: JWT validation successful"), n3.payload;
                  });
                });
              });
            } catch (t4) {
              return o.Log.error("UserInfoService._getClaimsFromJwt: Error parsing JWT response", t4.message), void reject(t4);
            }
          }, t2.prototype._filterByAlg = function t3(e2, r2) {
            var n3 = null;
            if (r2.startsWith("RS")) n3 = "RSA";
            else if (r2.startsWith("PS")) n3 = "PS";
            else {
              if (!r2.startsWith("ES")) return o.Log.debug("UserInfoService._filterByAlg: alg not supported: ", r2), [];
              n3 = "EC";
            }
            return o.Log.debug("UserInfoService._filterByAlg: Looking for keys that match kty: ", n3), e2 = e2.filter(function(t4) {
              return t4.kty === n3;
            }), o.Log.debug("UserInfoService._filterByAlg: Number of keys that match kty: ", n3, e2.length), e2;
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.AllowedSigningAlgs = e.b64tohex = e.hextob64u = e.crypto = e.X509 = e.KeyUtil = e.jws = void 0;
        var n2 = r(27);
        e.jws = n2.jws, e.KeyUtil = n2.KEYUTIL, e.X509 = n2.X509, e.crypto = n2.crypto, e.hextob64u = n2.hextob64u, e.b64tohex = n2.b64tohex, e.AllowedSigningAlgs = ["RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512"];
      }, function(t, e, r) {
        "use strict";
        (function(t2) {
          Object.defineProperty(e, "__esModule", { value: true });
          var r2, n2, i, o, s, a, u, c, h, l, f, g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t3) {
            return typeof t3;
          } : function(t3) {
            return t3 && "function" == typeof Symbol && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3;
          }, d = { userAgent: false }, p = {}, v2 = v2 || (r2 = Math, i = (n2 = {}).lib = {}, o = i.Base = /* @__PURE__ */ function() {
            function t3() {
            }
            return { extend: function e2(r3) {
              t3.prototype = this;
              var n3 = new t3();
              return r3 && n3.mixIn(r3), n3.hasOwnProperty("init") || (n3.init = function() {
                n3.$super.init.apply(this, arguments);
              }), n3.init.prototype = n3, n3.$super = this, n3;
            }, create: function t4() {
              var e2 = this.extend();
              return e2.init.apply(e2, arguments), e2;
            }, init: function t4() {
            }, mixIn: function t4(e2) {
              for (var r3 in e2) e2.hasOwnProperty(r3) && (this[r3] = e2[r3]);
              e2.hasOwnProperty("toString") && (this.toString = e2.toString);
            }, clone: function t4() {
              return this.init.prototype.extend(this);
            } };
          }(), s = i.WordArray = o.extend({ init: function t3(e2, r3) {
            e2 = this.words = e2 || [], this.sigBytes = null != r3 ? r3 : 4 * e2.length;
          }, toString: function t3(e2) {
            return (e2 || u).stringify(this);
          }, concat: function t3(e2) {
            var r3 = this.words, n3 = e2.words, i2 = this.sigBytes, o2 = e2.sigBytes;
            if (this.clamp(), i2 % 4) for (var s2 = 0; s2 < o2; s2++) {
              var a2 = n3[s2 >>> 2] >>> 24 - s2 % 4 * 8 & 255;
              r3[i2 + s2 >>> 2] |= a2 << 24 - (i2 + s2) % 4 * 8;
            }
            else for (s2 = 0; s2 < o2; s2 += 4) r3[i2 + s2 >>> 2] = n3[s2 >>> 2];
            return this.sigBytes += o2, this;
          }, clamp: function t3() {
            var e2 = this.words, n3 = this.sigBytes;
            e2[n3 >>> 2] &= 4294967295 << 32 - n3 % 4 * 8, e2.length = r2.ceil(n3 / 4);
          }, clone: function t3() {
            var e2 = o.clone.call(this);
            return e2.words = this.words.slice(0), e2;
          }, random: function t3(e2) {
            for (var n3 = [], i2 = 0; i2 < e2; i2 += 4) n3.push(4294967296 * r2.random() | 0);
            return new s.init(n3, e2);
          } }), a = n2.enc = {}, u = a.Hex = { stringify: function t3(e2) {
            for (var r3 = e2.words, n3 = e2.sigBytes, i2 = [], o2 = 0; o2 < n3; o2++) {
              var s2 = r3[o2 >>> 2] >>> 24 - o2 % 4 * 8 & 255;
              i2.push((s2 >>> 4).toString(16)), i2.push((15 & s2).toString(16));
            }
            return i2.join("");
          }, parse: function t3(e2) {
            for (var r3 = e2.length, n3 = [], i2 = 0; i2 < r3; i2 += 2) n3[i2 >>> 3] |= parseInt(e2.substr(i2, 2), 16) << 24 - i2 % 8 * 4;
            return new s.init(n3, r3 / 2);
          } }, c = a.Latin1 = { stringify: function t3(e2) {
            for (var r3 = e2.words, n3 = e2.sigBytes, i2 = [], o2 = 0; o2 < n3; o2++) {
              var s2 = r3[o2 >>> 2] >>> 24 - o2 % 4 * 8 & 255;
              i2.push(String.fromCharCode(s2));
            }
            return i2.join("");
          }, parse: function t3(e2) {
            for (var r3 = e2.length, n3 = [], i2 = 0; i2 < r3; i2++) n3[i2 >>> 2] |= (255 & e2.charCodeAt(i2)) << 24 - i2 % 4 * 8;
            return new s.init(n3, r3);
          } }, h = a.Utf8 = { stringify: function t3(e2) {
            try {
              return decodeURIComponent(escape(c.stringify(e2)));
            } catch (t4) {
              throw new Error("Malformed UTF-8 data");
            }
          }, parse: function t3(e2) {
            return c.parse(unescape(encodeURIComponent(e2)));
          } }, l = i.BufferedBlockAlgorithm = o.extend({ reset: function t3() {
            this._data = new s.init(), this._nDataBytes = 0;
          }, _append: function t3(e2) {
            "string" == typeof e2 && (e2 = h.parse(e2)), this._data.concat(e2), this._nDataBytes += e2.sigBytes;
          }, _process: function t3(e2) {
            var n3 = this._data, i2 = n3.words, o2 = n3.sigBytes, a2 = this.blockSize, u2 = o2 / (4 * a2), c2 = (u2 = e2 ? r2.ceil(u2) : r2.max((0 | u2) - this._minBufferSize, 0)) * a2, h2 = r2.min(4 * c2, o2);
            if (c2) {
              for (var l2 = 0; l2 < c2; l2 += a2) this._doProcessBlock(i2, l2);
              var f2 = i2.splice(0, c2);
              n3.sigBytes -= h2;
            }
            return new s.init(f2, h2);
          }, clone: function t3() {
            var e2 = o.clone.call(this);
            return e2._data = this._data.clone(), e2;
          }, _minBufferSize: 0 }), i.Hasher = l.extend({ cfg: o.extend(), init: function t3(e2) {
            this.cfg = this.cfg.extend(e2), this.reset();
          }, reset: function t3() {
            l.reset.call(this), this._doReset();
          }, update: function t3(e2) {
            return this._append(e2), this._process(), this;
          }, finalize: function t3(e2) {
            return e2 && this._append(e2), this._doFinalize();
          }, blockSize: 16, _createHelper: function t3(e2) {
            return function(t4, r3) {
              return new e2.init(r3).finalize(t4);
            };
          }, _createHmacHelper: function t3(e2) {
            return function(t4, r3) {
              return new f.HMAC.init(e2, r3).finalize(t4);
            };
          } }), f = n2.algo = {}, n2);
          !function(t3) {
            var e2, r3 = (e2 = v2).lib, n3 = r3.Base, i2 = r3.WordArray;
            (e2 = e2.x64 = {}).Word = n3.extend({ init: function t4(e3, r4) {
              this.high = e3, this.low = r4;
            } }), e2.WordArray = n3.extend({ init: function t4(e3, r4) {
              e3 = this.words = e3 || [], this.sigBytes = null != r4 ? r4 : 8 * e3.length;
            }, toX32: function t4() {
              for (var e3 = this.words, r4 = e3.length, n4 = [], o2 = 0; o2 < r4; o2++) {
                var s2 = e3[o2];
                n4.push(s2.high), n4.push(s2.low);
              }
              return i2.create(n4, this.sigBytes);
            }, clone: function t4() {
              for (var e3 = n3.clone.call(this), r4 = e3.words = this.words.slice(0), i3 = r4.length, o2 = 0; o2 < i3; o2++) r4[o2] = r4[o2].clone();
              return e3;
            } });
          }(), function() {
            var t3 = v2, e2 = t3.lib.WordArray;
            t3.enc.Base64 = { stringify: function t4(e3) {
              var r3 = e3.words, n3 = e3.sigBytes, i2 = this._map;
              e3.clamp(), e3 = [];
              for (var o2 = 0; o2 < n3; o2 += 3) for (var s2 = (r3[o2 >>> 2] >>> 24 - o2 % 4 * 8 & 255) << 16 | (r3[o2 + 1 >>> 2] >>> 24 - (o2 + 1) % 4 * 8 & 255) << 8 | r3[o2 + 2 >>> 2] >>> 24 - (o2 + 2) % 4 * 8 & 255, a2 = 0; 4 > a2 && o2 + 0.75 * a2 < n3; a2++) e3.push(i2.charAt(s2 >>> 6 * (3 - a2) & 63));
              if (r3 = i2.charAt(64)) for (; e3.length % 4; ) e3.push(r3);
              return e3.join("");
            }, parse: function t4(r3) {
              var n3 = r3.length, i2 = this._map;
              (o2 = i2.charAt(64)) && (-1 != (o2 = r3.indexOf(o2)) && (n3 = o2));
              for (var o2 = [], s2 = 0, a2 = 0; a2 < n3; a2++) if (a2 % 4) {
                var u2 = i2.indexOf(r3.charAt(a2 - 1)) << a2 % 4 * 2, c2 = i2.indexOf(r3.charAt(a2)) >>> 6 - a2 % 4 * 2;
                o2[s2 >>> 2] |= (u2 | c2) << 24 - s2 % 4 * 8, s2++;
              }
              return e2.create(o2, s2);
            }, _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=" };
          }(), function(t3) {
            for (var e2 = v2, r3 = (i2 = e2.lib).WordArray, n3 = i2.Hasher, i2 = e2.algo, o2 = [], s2 = [], a2 = function t4(e3) {
              return 4294967296 * (e3 - (0 | e3)) | 0;
            }, u2 = 2, c2 = 0; 64 > c2; ) {
              var h2;
              t: {
                h2 = u2;
                for (var l2 = t3.sqrt(h2), f2 = 2; f2 <= l2; f2++) if (!(h2 % f2)) {
                  h2 = false;
                  break t;
                }
                h2 = true;
              }
              h2 && (8 > c2 && (o2[c2] = a2(t3.pow(u2, 0.5))), s2[c2] = a2(t3.pow(u2, 1 / 3)), c2++), u2++;
            }
            var g2 = [];
            i2 = i2.SHA256 = n3.extend({ _doReset: function t4() {
              this._hash = new r3.init(o2.slice(0));
            }, _doProcessBlock: function t4(e3, r4) {
              for (var n4 = this._hash.words, i3 = n4[0], o3 = n4[1], a3 = n4[2], u3 = n4[3], c3 = n4[4], h3 = n4[5], l3 = n4[6], f3 = n4[7], d2 = 0; 64 > d2; d2++) {
                if (16 > d2) g2[d2] = 0 | e3[r4 + d2];
                else {
                  var p2 = g2[d2 - 15], v3 = g2[d2 - 2];
                  g2[d2] = ((p2 << 25 | p2 >>> 7) ^ (p2 << 14 | p2 >>> 18) ^ p2 >>> 3) + g2[d2 - 7] + ((v3 << 15 | v3 >>> 17) ^ (v3 << 13 | v3 >>> 19) ^ v3 >>> 10) + g2[d2 - 16];
                }
                p2 = f3 + ((c3 << 26 | c3 >>> 6) ^ (c3 << 21 | c3 >>> 11) ^ (c3 << 7 | c3 >>> 25)) + (c3 & h3 ^ ~c3 & l3) + s2[d2] + g2[d2], v3 = ((i3 << 30 | i3 >>> 2) ^ (i3 << 19 | i3 >>> 13) ^ (i3 << 10 | i3 >>> 22)) + (i3 & o3 ^ i3 & a3 ^ o3 & a3), f3 = l3, l3 = h3, h3 = c3, c3 = u3 + p2 | 0, u3 = a3, a3 = o3, o3 = i3, i3 = p2 + v3 | 0;
              }
              n4[0] = n4[0] + i3 | 0, n4[1] = n4[1] + o3 | 0, n4[2] = n4[2] + a3 | 0, n4[3] = n4[3] + u3 | 0, n4[4] = n4[4] + c3 | 0, n4[5] = n4[5] + h3 | 0, n4[6] = n4[6] + l3 | 0, n4[7] = n4[7] + f3 | 0;
            }, _doFinalize: function e3() {
              var r4 = this._data, n4 = r4.words, i3 = 8 * this._nDataBytes, o3 = 8 * r4.sigBytes;
              return n4[o3 >>> 5] |= 128 << 24 - o3 % 32, n4[14 + (o3 + 64 >>> 9 << 4)] = t3.floor(i3 / 4294967296), n4[15 + (o3 + 64 >>> 9 << 4)] = i3, r4.sigBytes = 4 * n4.length, this._process(), this._hash;
            }, clone: function t4() {
              var e3 = n3.clone.call(this);
              return e3._hash = this._hash.clone(), e3;
            } });
            e2.SHA256 = n3._createHelper(i2), e2.HmacSHA256 = n3._createHmacHelper(i2);
          }(Math), function() {
            function t3() {
              return n3.create.apply(n3, arguments);
            }
            for (var e2 = v2, r3 = e2.lib.Hasher, n3 = (o2 = e2.x64).Word, i2 = o2.WordArray, o2 = e2.algo, s2 = [t3(1116352408, 3609767458), t3(1899447441, 602891725), t3(3049323471, 3964484399), t3(3921009573, 2173295548), t3(961987163, 4081628472), t3(1508970993, 3053834265), t3(2453635748, 2937671579), t3(2870763221, 3664609560), t3(3624381080, 2734883394), t3(310598401, 1164996542), t3(607225278, 1323610764), t3(1426881987, 3590304994), t3(1925078388, 4068182383), t3(2162078206, 991336113), t3(2614888103, 633803317), t3(3248222580, 3479774868), t3(3835390401, 2666613458), t3(4022224774, 944711139), t3(264347078, 2341262773), t3(604807628, 2007800933), t3(770255983, 1495990901), t3(1249150122, 1856431235), t3(1555081692, 3175218132), t3(1996064986, 2198950837), t3(2554220882, 3999719339), t3(2821834349, 766784016), t3(2952996808, 2566594879), t3(3210313671, 3203337956), t3(3336571891, 1034457026), t3(3584528711, 2466948901), t3(113926993, 3758326383), t3(338241895, 168717936), t3(666307205, 1188179964), t3(773529912, 1546045734), t3(1294757372, 1522805485), t3(1396182291, 2643833823), t3(1695183700, 2343527390), t3(1986661051, 1014477480), t3(2177026350, 1206759142), t3(2456956037, 344077627), t3(2730485921, 1290863460), t3(2820302411, 3158454273), t3(3259730800, 3505952657), t3(3345764771, 106217008), t3(3516065817, 3606008344), t3(3600352804, 1432725776), t3(4094571909, 1467031594), t3(275423344, 851169720), t3(430227734, 3100823752), t3(506948616, 1363258195), t3(659060556, 3750685593), t3(883997877, 3785050280), t3(958139571, 3318307427), t3(1322822218, 3812723403), t3(1537002063, 2003034995), t3(1747873779, 3602036899), t3(1955562222, 1575990012), t3(2024104815, 1125592928), t3(2227730452, 2716904306), t3(2361852424, 442776044), t3(2428436474, 593698344), t3(2756734187, 3733110249), t3(3204031479, 2999351573), t3(3329325298, 3815920427), t3(3391569614, 3928383900), t3(3515267271, 566280711), t3(3940187606, 3454069534), t3(4118630271, 4000239992), t3(116418474, 1914138554), t3(174292421, 2731055270), t3(289380356, 3203993006), t3(460393269, 320620315), t3(685471733, 587496836), t3(852142971, 1086792851), t3(1017036298, 365543100), t3(1126000580, 2618297676), t3(1288033470, 3409855158), t3(1501505948, 4234509866), t3(1607167915, 987167468), t3(1816402316, 1246189591)], a2 = [], u2 = 0; 80 > u2; u2++) a2[u2] = t3();
            o2 = o2.SHA512 = r3.extend({ _doReset: function t4() {
              this._hash = new i2.init([new n3.init(1779033703, 4089235720), new n3.init(3144134277, 2227873595), new n3.init(1013904242, 4271175723), new n3.init(2773480762, 1595750129), new n3.init(1359893119, 2917565137), new n3.init(2600822924, 725511199), new n3.init(528734635, 4215389547), new n3.init(1541459225, 327033209)]);
            }, _doProcessBlock: function t4(e3, r4) {
              for (var n4 = (f2 = this._hash.words)[0], i3 = f2[1], o3 = f2[2], u3 = f2[3], c2 = f2[4], h2 = f2[5], l2 = f2[6], f2 = f2[7], g2 = n4.high, d2 = n4.low, p2 = i3.high, v3 = i3.low, y2 = o3.high, m2 = o3.low, _2 = u3.high, S2 = u3.low, b2 = c2.high, w2 = c2.low, F2 = h2.high, E = h2.low, x = l2.high, A = l2.low, k2 = f2.high, P2 = f2.low, C2 = g2, T2 = d2, R2 = p2, I2 = v3, D2 = y2, L2 = m2, N2 = _2, U2 = S2, B2 = b2, O2 = w2, j2 = F2, M2 = E, H2 = x, V2 = A, K2 = k2, q2 = P2, J = 0; 80 > J; J++) {
                var W = a2[J];
                if (16 > J) var z = W.high = 0 | e3[r4 + 2 * J], Y = W.low = 0 | e3[r4 + 2 * J + 1];
                else {
                  z = ((Y = (z = a2[J - 15]).high) >>> 1 | (G = z.low) << 31) ^ (Y >>> 8 | G << 24) ^ Y >>> 7;
                  var G = (G >>> 1 | Y << 31) ^ (G >>> 8 | Y << 24) ^ (G >>> 7 | Y << 25), X = ((Y = (X = a2[J - 2]).high) >>> 19 | ($ = X.low) << 13) ^ (Y << 3 | $ >>> 29) ^ Y >>> 6, $ = ($ >>> 19 | Y << 13) ^ ($ << 3 | Y >>> 29) ^ ($ >>> 6 | Y << 26), Q = (Y = a2[J - 7]).high, Z = (tt = a2[J - 16]).high, tt = tt.low;
                  z = (z = (z = z + Q + ((Y = G + Y.low) >>> 0 < G >>> 0 ? 1 : 0)) + X + ((Y = Y + $) >>> 0 < $ >>> 0 ? 1 : 0)) + Z + ((Y = Y + tt) >>> 0 < tt >>> 0 ? 1 : 0);
                  W.high = z, W.low = Y;
                }
                Q = B2 & j2 ^ ~B2 & H2, tt = O2 & M2 ^ ~O2 & V2, W = C2 & R2 ^ C2 & D2 ^ R2 & D2;
                var et = T2 & I2 ^ T2 & L2 ^ I2 & L2, rt = (G = (C2 >>> 28 | T2 << 4) ^ (C2 << 30 | T2 >>> 2) ^ (C2 << 25 | T2 >>> 7), X = (T2 >>> 28 | C2 << 4) ^ (T2 << 30 | C2 >>> 2) ^ (T2 << 25 | C2 >>> 7), ($ = s2[J]).high), nt = $.low;
                Z = K2 + ((B2 >>> 14 | O2 << 18) ^ (B2 >>> 18 | O2 << 14) ^ (B2 << 23 | O2 >>> 9)) + (($ = q2 + ((O2 >>> 14 | B2 << 18) ^ (O2 >>> 18 | B2 << 14) ^ (O2 << 23 | B2 >>> 9))) >>> 0 < q2 >>> 0 ? 1 : 0), K2 = H2, q2 = V2, H2 = j2, V2 = M2, j2 = B2, M2 = O2, B2 = N2 + (Z = (Z = (Z = Z + Q + (($ = $ + tt) >>> 0 < tt >>> 0 ? 1 : 0)) + rt + (($ = $ + nt) >>> 0 < nt >>> 0 ? 1 : 0)) + z + (($ = $ + Y) >>> 0 < Y >>> 0 ? 1 : 0)) + ((O2 = U2 + $ | 0) >>> 0 < U2 >>> 0 ? 1 : 0) | 0, N2 = D2, U2 = L2, D2 = R2, L2 = I2, R2 = C2, I2 = T2, C2 = Z + (W = G + W + ((Y = X + et) >>> 0 < X >>> 0 ? 1 : 0)) + ((T2 = $ + Y | 0) >>> 0 < $ >>> 0 ? 1 : 0) | 0;
              }
              d2 = n4.low = d2 + T2, n4.high = g2 + C2 + (d2 >>> 0 < T2 >>> 0 ? 1 : 0), v3 = i3.low = v3 + I2, i3.high = p2 + R2 + (v3 >>> 0 < I2 >>> 0 ? 1 : 0), m2 = o3.low = m2 + L2, o3.high = y2 + D2 + (m2 >>> 0 < L2 >>> 0 ? 1 : 0), S2 = u3.low = S2 + U2, u3.high = _2 + N2 + (S2 >>> 0 < U2 >>> 0 ? 1 : 0), w2 = c2.low = w2 + O2, c2.high = b2 + B2 + (w2 >>> 0 < O2 >>> 0 ? 1 : 0), E = h2.low = E + M2, h2.high = F2 + j2 + (E >>> 0 < M2 >>> 0 ? 1 : 0), A = l2.low = A + V2, l2.high = x + H2 + (A >>> 0 < V2 >>> 0 ? 1 : 0), P2 = f2.low = P2 + q2, f2.high = k2 + K2 + (P2 >>> 0 < q2 >>> 0 ? 1 : 0);
            }, _doFinalize: function t4() {
              var e3 = this._data, r4 = e3.words, n4 = 8 * this._nDataBytes, i3 = 8 * e3.sigBytes;
              return r4[i3 >>> 5] |= 128 << 24 - i3 % 32, r4[30 + (i3 + 128 >>> 10 << 5)] = Math.floor(n4 / 4294967296), r4[31 + (i3 + 128 >>> 10 << 5)] = n4, e3.sigBytes = 4 * r4.length, this._process(), this._hash.toX32();
            }, clone: function t4() {
              var e3 = r3.clone.call(this);
              return e3._hash = this._hash.clone(), e3;
            }, blockSize: 32 }), e2.SHA512 = r3._createHelper(o2), e2.HmacSHA512 = r3._createHmacHelper(o2);
          }(), function() {
            var t3 = v2, e2 = (i2 = t3.x64).Word, r3 = i2.WordArray, n3 = (i2 = t3.algo).SHA512, i2 = i2.SHA384 = n3.extend({ _doReset: function t4() {
              this._hash = new r3.init([new e2.init(3418070365, 3238371032), new e2.init(1654270250, 914150663), new e2.init(2438529370, 812702999), new e2.init(355462360, 4144912697), new e2.init(1731405415, 4290775857), new e2.init(2394180231, 1750603025), new e2.init(3675008525, 1694076839), new e2.init(1203062813, 3204075428)]);
            }, _doFinalize: function t4() {
              var e3 = n3._doFinalize.call(this);
              return e3.sigBytes -= 16, e3;
            } });
            t3.SHA384 = n3._createHelper(i2), t3.HmacSHA384 = n3._createHmacHelper(i2);
          }();
          var y, m = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
          function _(t3) {
            var e2, r3, n3 = "";
            for (e2 = 0; e2 + 3 <= t3.length; e2 += 3) r3 = parseInt(t3.substring(e2, e2 + 3), 16), n3 += m.charAt(r3 >> 6) + m.charAt(63 & r3);
            for (e2 + 1 == t3.length ? (r3 = parseInt(t3.substring(e2, e2 + 1), 16), n3 += m.charAt(r3 << 2)) : e2 + 2 == t3.length && (r3 = parseInt(t3.substring(e2, e2 + 2), 16), n3 += m.charAt(r3 >> 2) + m.charAt((3 & r3) << 4)), "="; (3 & n3.length) > 0; ) n3 += "=";
            return n3;
          }
          function S(t3) {
            var e2, r3, n3, i2 = "", o2 = 0;
            for (e2 = 0; e2 < t3.length && "=" != t3.charAt(e2); ++e2) (n3 = m.indexOf(t3.charAt(e2))) < 0 || (0 == o2 ? (i2 += T(n3 >> 2), r3 = 3 & n3, o2 = 1) : 1 == o2 ? (i2 += T(r3 << 2 | n3 >> 4), r3 = 15 & n3, o2 = 2) : 2 == o2 ? (i2 += T(r3), i2 += T(n3 >> 2), r3 = 3 & n3, o2 = 3) : (i2 += T(r3 << 2 | n3 >> 4), i2 += T(15 & n3), o2 = 0));
            return 1 == o2 && (i2 += T(r3 << 2)), i2;
          }
          function b(t3) {
            var e2, r3 = S(t3), n3 = new Array();
            for (e2 = 0; 2 * e2 < r3.length; ++e2) n3[e2] = parseInt(r3.substring(2 * e2, 2 * e2 + 2), 16);
            return n3;
          }
          function w(t3, e2, r3) {
            null != t3 && ("number" == typeof t3 ? this.fromNumber(t3, e2, r3) : null == e2 && "string" != typeof t3 ? this.fromString(t3, 256) : this.fromString(t3, e2));
          }
          function F() {
            return new w(null);
          }
          "Microsoft Internet Explorer" == d.appName ? (w.prototype.am = function E(t3, e2, r3, n3, i2, o2) {
            for (var s2 = 32767 & e2, a2 = e2 >> 15; --o2 >= 0; ) {
              var u2 = 32767 & this[t3], c2 = this[t3++] >> 15, h2 = a2 * u2 + c2 * s2;
              i2 = ((u2 = s2 * u2 + ((32767 & h2) << 15) + r3[n3] + (1073741823 & i2)) >>> 30) + (h2 >>> 15) + a2 * c2 + (i2 >>> 30), r3[n3++] = 1073741823 & u2;
            }
            return i2;
          }, y = 30) : "Netscape" != d.appName ? (w.prototype.am = function x(t3, e2, r3, n3, i2, o2) {
            for (; --o2 >= 0; ) {
              var s2 = e2 * this[t3++] + r3[n3] + i2;
              i2 = Math.floor(s2 / 67108864), r3[n3++] = 67108863 & s2;
            }
            return i2;
          }, y = 26) : (w.prototype.am = function A(t3, e2, r3, n3, i2, o2) {
            for (var s2 = 16383 & e2, a2 = e2 >> 14; --o2 >= 0; ) {
              var u2 = 16383 & this[t3], c2 = this[t3++] >> 14, h2 = a2 * u2 + c2 * s2;
              i2 = ((u2 = s2 * u2 + ((16383 & h2) << 14) + r3[n3] + i2) >> 28) + (h2 >> 14) + a2 * c2, r3[n3++] = 268435455 & u2;
            }
            return i2;
          }, y = 28), w.prototype.DB = y, w.prototype.DM = (1 << y) - 1, w.prototype.DV = 1 << y;
          w.prototype.FV = Math.pow(2, 52), w.prototype.F1 = 52 - y, w.prototype.F2 = 2 * y - 52;
          var k, P, C = new Array();
          for (k = "0".charCodeAt(0), P = 0; P <= 9; ++P) C[k++] = P;
          for (k = "a".charCodeAt(0), P = 10; P < 36; ++P) C[k++] = P;
          for (k = "A".charCodeAt(0), P = 10; P < 36; ++P) C[k++] = P;
          function T(t3) {
            return "0123456789abcdefghijklmnopqrstuvwxyz".charAt(t3);
          }
          function R(t3, e2) {
            var r3 = C[t3.charCodeAt(e2)];
            return null == r3 ? -1 : r3;
          }
          function I(t3) {
            var e2 = F();
            return e2.fromInt(t3), e2;
          }
          function D(t3) {
            var e2, r3 = 1;
            return 0 != (e2 = t3 >>> 16) && (t3 = e2, r3 += 16), 0 != (e2 = t3 >> 8) && (t3 = e2, r3 += 8), 0 != (e2 = t3 >> 4) && (t3 = e2, r3 += 4), 0 != (e2 = t3 >> 2) && (t3 = e2, r3 += 2), 0 != (e2 = t3 >> 1) && (t3 = e2, r3 += 1), r3;
          }
          function L(t3) {
            this.m = t3;
          }
          function N(t3) {
            this.m = t3, this.mp = t3.invDigit(), this.mpl = 32767 & this.mp, this.mph = this.mp >> 15, this.um = (1 << t3.DB - 15) - 1, this.mt2 = 2 * t3.t;
          }
          function U(t3, e2) {
            return t3 & e2;
          }
          function B(t3, e2) {
            return t3 | e2;
          }
          function O(t3, e2) {
            return t3 ^ e2;
          }
          function j(t3, e2) {
            return t3 & ~e2;
          }
          function M(t3) {
            if (0 == t3) return -1;
            var e2 = 0;
            return 0 == (65535 & t3) && (t3 >>= 16, e2 += 16), 0 == (255 & t3) && (t3 >>= 8, e2 += 8), 0 == (15 & t3) && (t3 >>= 4, e2 += 4), 0 == (3 & t3) && (t3 >>= 2, e2 += 2), 0 == (1 & t3) && ++e2, e2;
          }
          function H(t3) {
            for (var e2 = 0; 0 != t3; ) t3 &= t3 - 1, ++e2;
            return e2;
          }
          function V() {
          }
          function K(t3) {
            return t3;
          }
          function q(t3) {
            this.r2 = F(), this.q3 = F(), w.ONE.dlShiftTo(2 * t3.t, this.r2), this.mu = this.r2.divide(t3), this.m = t3;
          }
          L.prototype.convert = function J(t3) {
            return t3.s < 0 || t3.compareTo(this.m) >= 0 ? t3.mod(this.m) : t3;
          }, L.prototype.revert = function W(t3) {
            return t3;
          }, L.prototype.reduce = function z(t3) {
            t3.divRemTo(this.m, null, t3);
          }, L.prototype.mulTo = function Y(t3, e2, r3) {
            t3.multiplyTo(e2, r3), this.reduce(r3);
          }, L.prototype.sqrTo = function G(t3, e2) {
            t3.squareTo(e2), this.reduce(e2);
          }, N.prototype.convert = function X(t3) {
            var e2 = F();
            return t3.abs().dlShiftTo(this.m.t, e2), e2.divRemTo(this.m, null, e2), t3.s < 0 && e2.compareTo(w.ZERO) > 0 && this.m.subTo(e2, e2), e2;
          }, N.prototype.revert = function $(t3) {
            var e2 = F();
            return t3.copyTo(e2), this.reduce(e2), e2;
          }, N.prototype.reduce = function Q(t3) {
            for (; t3.t <= this.mt2; ) t3[t3.t++] = 0;
            for (var e2 = 0; e2 < this.m.t; ++e2) {
              var r3 = 32767 & t3[e2], n3 = r3 * this.mpl + ((r3 * this.mph + (t3[e2] >> 15) * this.mpl & this.um) << 15) & t3.DM;
              for (t3[r3 = e2 + this.m.t] += this.m.am(0, n3, t3, e2, 0, this.m.t); t3[r3] >= t3.DV; ) t3[r3] -= t3.DV, t3[++r3]++;
            }
            t3.clamp(), t3.drShiftTo(this.m.t, t3), t3.compareTo(this.m) >= 0 && t3.subTo(this.m, t3);
          }, N.prototype.mulTo = function Z(t3, e2, r3) {
            t3.multiplyTo(e2, r3), this.reduce(r3);
          }, N.prototype.sqrTo = function tt(t3, e2) {
            t3.squareTo(e2), this.reduce(e2);
          }, w.prototype.copyTo = function et(t3) {
            for (var e2 = this.t - 1; e2 >= 0; --e2) t3[e2] = this[e2];
            t3.t = this.t, t3.s = this.s;
          }, w.prototype.fromInt = function rt(t3) {
            this.t = 1, this.s = t3 < 0 ? -1 : 0, t3 > 0 ? this[0] = t3 : t3 < -1 ? this[0] = t3 + this.DV : this.t = 0;
          }, w.prototype.fromString = function nt(t3, e2) {
            var r3;
            if (16 == e2) r3 = 4;
            else if (8 == e2) r3 = 3;
            else if (256 == e2) r3 = 8;
            else if (2 == e2) r3 = 1;
            else if (32 == e2) r3 = 5;
            else {
              if (4 != e2) return void this.fromRadix(t3, e2);
              r3 = 2;
            }
            this.t = 0, this.s = 0;
            for (var n3 = t3.length, i2 = false, o2 = 0; --n3 >= 0; ) {
              var s2 = 8 == r3 ? 255 & t3[n3] : R(t3, n3);
              s2 < 0 ? "-" == t3.charAt(n3) && (i2 = true) : (i2 = false, 0 == o2 ? this[this.t++] = s2 : o2 + r3 > this.DB ? (this[this.t - 1] |= (s2 & (1 << this.DB - o2) - 1) << o2, this[this.t++] = s2 >> this.DB - o2) : this[this.t - 1] |= s2 << o2, (o2 += r3) >= this.DB && (o2 -= this.DB));
            }
            8 == r3 && 0 != (128 & t3[0]) && (this.s = -1, o2 > 0 && (this[this.t - 1] |= (1 << this.DB - o2) - 1 << o2)), this.clamp(), i2 && w.ZERO.subTo(this, this);
          }, w.prototype.clamp = function it() {
            for (var t3 = this.s & this.DM; this.t > 0 && this[this.t - 1] == t3; ) --this.t;
          }, w.prototype.dlShiftTo = function ot(t3, e2) {
            var r3;
            for (r3 = this.t - 1; r3 >= 0; --r3) e2[r3 + t3] = this[r3];
            for (r3 = t3 - 1; r3 >= 0; --r3) e2[r3] = 0;
            e2.t = this.t + t3, e2.s = this.s;
          }, w.prototype.drShiftTo = function st2(t3, e2) {
            for (var r3 = t3; r3 < this.t; ++r3) e2[r3 - t3] = this[r3];
            e2.t = Math.max(this.t - t3, 0), e2.s = this.s;
          }, w.prototype.lShiftTo = function at(t3, e2) {
            var r3, n3 = t3 % this.DB, i2 = this.DB - n3, o2 = (1 << i2) - 1, s2 = Math.floor(t3 / this.DB), a2 = this.s << n3 & this.DM;
            for (r3 = this.t - 1; r3 >= 0; --r3) e2[r3 + s2 + 1] = this[r3] >> i2 | a2, a2 = (this[r3] & o2) << n3;
            for (r3 = s2 - 1; r3 >= 0; --r3) e2[r3] = 0;
            e2[s2] = a2, e2.t = this.t + s2 + 1, e2.s = this.s, e2.clamp();
          }, w.prototype.rShiftTo = function ut(t3, e2) {
            e2.s = this.s;
            var r3 = Math.floor(t3 / this.DB);
            if (r3 >= this.t) e2.t = 0;
            else {
              var n3 = t3 % this.DB, i2 = this.DB - n3, o2 = (1 << n3) - 1;
              e2[0] = this[r3] >> n3;
              for (var s2 = r3 + 1; s2 < this.t; ++s2) e2[s2 - r3 - 1] |= (this[s2] & o2) << i2, e2[s2 - r3] = this[s2] >> n3;
              n3 > 0 && (e2[this.t - r3 - 1] |= (this.s & o2) << i2), e2.t = this.t - r3, e2.clamp();
            }
          }, w.prototype.subTo = function ct(t3, e2) {
            for (var r3 = 0, n3 = 0, i2 = Math.min(t3.t, this.t); r3 < i2; ) n3 += this[r3] - t3[r3], e2[r3++] = n3 & this.DM, n3 >>= this.DB;
            if (t3.t < this.t) {
              for (n3 -= t3.s; r3 < this.t; ) n3 += this[r3], e2[r3++] = n3 & this.DM, n3 >>= this.DB;
              n3 += this.s;
            } else {
              for (n3 += this.s; r3 < t3.t; ) n3 -= t3[r3], e2[r3++] = n3 & this.DM, n3 >>= this.DB;
              n3 -= t3.s;
            }
            e2.s = n3 < 0 ? -1 : 0, n3 < -1 ? e2[r3++] = this.DV + n3 : n3 > 0 && (e2[r3++] = n3), e2.t = r3, e2.clamp();
          }, w.prototype.multiplyTo = function ht(t3, e2) {
            var r3 = this.abs(), n3 = t3.abs(), i2 = r3.t;
            for (e2.t = i2 + n3.t; --i2 >= 0; ) e2[i2] = 0;
            for (i2 = 0; i2 < n3.t; ++i2) e2[i2 + r3.t] = r3.am(0, n3[i2], e2, i2, 0, r3.t);
            e2.s = 0, e2.clamp(), this.s != t3.s && w.ZERO.subTo(e2, e2);
          }, w.prototype.squareTo = function lt(t3) {
            for (var e2 = this.abs(), r3 = t3.t = 2 * e2.t; --r3 >= 0; ) t3[r3] = 0;
            for (r3 = 0; r3 < e2.t - 1; ++r3) {
              var n3 = e2.am(r3, e2[r3], t3, 2 * r3, 0, 1);
              (t3[r3 + e2.t] += e2.am(r3 + 1, 2 * e2[r3], t3, 2 * r3 + 1, n3, e2.t - r3 - 1)) >= e2.DV && (t3[r3 + e2.t] -= e2.DV, t3[r3 + e2.t + 1] = 1);
            }
            t3.t > 0 && (t3[t3.t - 1] += e2.am(r3, e2[r3], t3, 2 * r3, 0, 1)), t3.s = 0, t3.clamp();
          }, w.prototype.divRemTo = function ft(t3, e2, r3) {
            var n3 = t3.abs();
            if (!(n3.t <= 0)) {
              var i2 = this.abs();
              if (i2.t < n3.t) return null != e2 && e2.fromInt(0), void (null != r3 && this.copyTo(r3));
              null == r3 && (r3 = F());
              var o2 = F(), s2 = this.s, a2 = t3.s, u2 = this.DB - D(n3[n3.t - 1]);
              u2 > 0 ? (n3.lShiftTo(u2, o2), i2.lShiftTo(u2, r3)) : (n3.copyTo(o2), i2.copyTo(r3));
              var c2 = o2.t, h2 = o2[c2 - 1];
              if (0 != h2) {
                var l2 = h2 * (1 << this.F1) + (c2 > 1 ? o2[c2 - 2] >> this.F2 : 0), f2 = this.FV / l2, g2 = (1 << this.F1) / l2, d2 = 1 << this.F2, p2 = r3.t, v3 = p2 - c2, y2 = null == e2 ? F() : e2;
                for (o2.dlShiftTo(v3, y2), r3.compareTo(y2) >= 0 && (r3[r3.t++] = 1, r3.subTo(y2, r3)), w.ONE.dlShiftTo(c2, y2), y2.subTo(o2, o2); o2.t < c2; ) o2[o2.t++] = 0;
                for (; --v3 >= 0; ) {
                  var m2 = r3[--p2] == h2 ? this.DM : Math.floor(r3[p2] * f2 + (r3[p2 - 1] + d2) * g2);
                  if ((r3[p2] += o2.am(0, m2, r3, v3, 0, c2)) < m2) for (o2.dlShiftTo(v3, y2), r3.subTo(y2, r3); r3[p2] < --m2; ) r3.subTo(y2, r3);
                }
                null != e2 && (r3.drShiftTo(c2, e2), s2 != a2 && w.ZERO.subTo(e2, e2)), r3.t = c2, r3.clamp(), u2 > 0 && r3.rShiftTo(u2, r3), s2 < 0 && w.ZERO.subTo(r3, r3);
              }
            }
          }, w.prototype.invDigit = function gt() {
            if (this.t < 1) return 0;
            var t3 = this[0];
            if (0 == (1 & t3)) return 0;
            var e2 = 3 & t3;
            return (e2 = (e2 = (e2 = (e2 = e2 * (2 - (15 & t3) * e2) & 15) * (2 - (255 & t3) * e2) & 255) * (2 - ((65535 & t3) * e2 & 65535)) & 65535) * (2 - t3 * e2 % this.DV) % this.DV) > 0 ? this.DV - e2 : -e2;
          }, w.prototype.isEven = function dt() {
            return 0 == (this.t > 0 ? 1 & this[0] : this.s);
          }, w.prototype.exp = function pt(t3, e2) {
            if (t3 > 4294967295 || t3 < 1) return w.ONE;
            var r3 = F(), n3 = F(), i2 = e2.convert(this), o2 = D(t3) - 1;
            for (i2.copyTo(r3); --o2 >= 0; ) if (e2.sqrTo(r3, n3), (t3 & 1 << o2) > 0) e2.mulTo(n3, i2, r3);
            else {
              var s2 = r3;
              r3 = n3, n3 = s2;
            }
            return e2.revert(r3);
          }, w.prototype.toString = function vt(t3) {
            if (this.s < 0) return "-" + this.negate().toString(t3);
            var e2;
            if (16 == t3) e2 = 4;
            else if (8 == t3) e2 = 3;
            else if (2 == t3) e2 = 1;
            else if (32 == t3) e2 = 5;
            else {
              if (4 != t3) return this.toRadix(t3);
              e2 = 2;
            }
            var r3, n3 = (1 << e2) - 1, i2 = false, o2 = "", s2 = this.t, a2 = this.DB - s2 * this.DB % e2;
            if (s2-- > 0) for (a2 < this.DB && (r3 = this[s2] >> a2) > 0 && (i2 = true, o2 = T(r3)); s2 >= 0; ) a2 < e2 ? (r3 = (this[s2] & (1 << a2) - 1) << e2 - a2, r3 |= this[--s2] >> (a2 += this.DB - e2)) : (r3 = this[s2] >> (a2 -= e2) & n3, a2 <= 0 && (a2 += this.DB, --s2)), r3 > 0 && (i2 = true), i2 && (o2 += T(r3));
            return i2 ? o2 : "0";
          }, w.prototype.negate = function yt() {
            var t3 = F();
            return w.ZERO.subTo(this, t3), t3;
          }, w.prototype.abs = function mt() {
            return this.s < 0 ? this.negate() : this;
          }, w.prototype.compareTo = function _t(t3) {
            var e2 = this.s - t3.s;
            if (0 != e2) return e2;
            var r3 = this.t;
            if (0 != (e2 = r3 - t3.t)) return this.s < 0 ? -e2 : e2;
            for (; --r3 >= 0; ) if (0 != (e2 = this[r3] - t3[r3])) return e2;
            return 0;
          }, w.prototype.bitLength = function St() {
            return this.t <= 0 ? 0 : this.DB * (this.t - 1) + D(this[this.t - 1] ^ this.s & this.DM);
          }, w.prototype.mod = function bt(t3) {
            var e2 = F();
            return this.abs().divRemTo(t3, null, e2), this.s < 0 && e2.compareTo(w.ZERO) > 0 && t3.subTo(e2, e2), e2;
          }, w.prototype.modPowInt = function wt(t3, e2) {
            var r3;
            return r3 = t3 < 256 || e2.isEven() ? new L(e2) : new N(e2), this.exp(t3, r3);
          }, w.ZERO = I(0), w.ONE = I(1), V.prototype.convert = K, V.prototype.revert = K, V.prototype.mulTo = function Ft(t3, e2, r3) {
            t3.multiplyTo(e2, r3);
          }, V.prototype.sqrTo = function Et(t3, e2) {
            t3.squareTo(e2);
          }, q.prototype.convert = function xt(t3) {
            if (t3.s < 0 || t3.t > 2 * this.m.t) return t3.mod(this.m);
            if (t3.compareTo(this.m) < 0) return t3;
            var e2 = F();
            return t3.copyTo(e2), this.reduce(e2), e2;
          }, q.prototype.revert = function At(t3) {
            return t3;
          }, q.prototype.reduce = function kt(t3) {
            for (t3.drShiftTo(this.m.t - 1, this.r2), t3.t > this.m.t + 1 && (t3.t = this.m.t + 1, t3.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); t3.compareTo(this.r2) < 0; ) t3.dAddOffset(1, this.m.t + 1);
            for (t3.subTo(this.r2, t3); t3.compareTo(this.m) >= 0; ) t3.subTo(this.m, t3);
          }, q.prototype.mulTo = function Pt(t3, e2, r3) {
            t3.multiplyTo(e2, r3), this.reduce(r3);
          }, q.prototype.sqrTo = function Ct(t3, e2) {
            t3.squareTo(e2), this.reduce(e2);
          };
          var Tt = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997], Rt = (1 << 26) / Tt[Tt.length - 1];
          function It() {
            this.i = 0, this.j = 0, this.S = new Array();
          }
          w.prototype.chunkSize = function Dt(t3) {
            return Math.floor(Math.LN2 * this.DB / Math.log(t3));
          }, w.prototype.toRadix = function Lt(t3) {
            if (null == t3 && (t3 = 10), 0 == this.signum() || t3 < 2 || t3 > 36) return "0";
            var e2 = this.chunkSize(t3), r3 = Math.pow(t3, e2), n3 = I(r3), i2 = F(), o2 = F(), s2 = "";
            for (this.divRemTo(n3, i2, o2); i2.signum() > 0; ) s2 = (r3 + o2.intValue()).toString(t3).substr(1) + s2, i2.divRemTo(n3, i2, o2);
            return o2.intValue().toString(t3) + s2;
          }, w.prototype.fromRadix = function Nt(t3, e2) {
            this.fromInt(0), null == e2 && (e2 = 10);
            for (var r3 = this.chunkSize(e2), n3 = Math.pow(e2, r3), i2 = false, o2 = 0, s2 = 0, a2 = 0; a2 < t3.length; ++a2) {
              var u2 = R(t3, a2);
              u2 < 0 ? "-" == t3.charAt(a2) && 0 == this.signum() && (i2 = true) : (s2 = e2 * s2 + u2, ++o2 >= r3 && (this.dMultiply(n3), this.dAddOffset(s2, 0), o2 = 0, s2 = 0));
            }
            o2 > 0 && (this.dMultiply(Math.pow(e2, o2)), this.dAddOffset(s2, 0)), i2 && w.ZERO.subTo(this, this);
          }, w.prototype.fromNumber = function Ut(t3, e2, r3) {
            if ("number" == typeof e2) if (t3 < 2) this.fromInt(1);
            else for (this.fromNumber(t3, r3), this.testBit(t3 - 1) || this.bitwiseTo(w.ONE.shiftLeft(t3 - 1), B, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(e2); ) this.dAddOffset(2, 0), this.bitLength() > t3 && this.subTo(w.ONE.shiftLeft(t3 - 1), this);
            else {
              var n3 = new Array(), i2 = 7 & t3;
              n3.length = 1 + (t3 >> 3), e2.nextBytes(n3), i2 > 0 ? n3[0] &= (1 << i2) - 1 : n3[0] = 0, this.fromString(n3, 256);
            }
          }, w.prototype.bitwiseTo = function Bt(t3, e2, r3) {
            var n3, i2, o2 = Math.min(t3.t, this.t);
            for (n3 = 0; n3 < o2; ++n3) r3[n3] = e2(this[n3], t3[n3]);
            if (t3.t < this.t) {
              for (i2 = t3.s & this.DM, n3 = o2; n3 < this.t; ++n3) r3[n3] = e2(this[n3], i2);
              r3.t = this.t;
            } else {
              for (i2 = this.s & this.DM, n3 = o2; n3 < t3.t; ++n3) r3[n3] = e2(i2, t3[n3]);
              r3.t = t3.t;
            }
            r3.s = e2(this.s, t3.s), r3.clamp();
          }, w.prototype.changeBit = function Ot(t3, e2) {
            var r3 = w.ONE.shiftLeft(t3);
            return this.bitwiseTo(r3, e2, r3), r3;
          }, w.prototype.addTo = function jt(t3, e2) {
            for (var r3 = 0, n3 = 0, i2 = Math.min(t3.t, this.t); r3 < i2; ) n3 += this[r3] + t3[r3], e2[r3++] = n3 & this.DM, n3 >>= this.DB;
            if (t3.t < this.t) {
              for (n3 += t3.s; r3 < this.t; ) n3 += this[r3], e2[r3++] = n3 & this.DM, n3 >>= this.DB;
              n3 += this.s;
            } else {
              for (n3 += this.s; r3 < t3.t; ) n3 += t3[r3], e2[r3++] = n3 & this.DM, n3 >>= this.DB;
              n3 += t3.s;
            }
            e2.s = n3 < 0 ? -1 : 0, n3 > 0 ? e2[r3++] = n3 : n3 < -1 && (e2[r3++] = this.DV + n3), e2.t = r3, e2.clamp();
          }, w.prototype.dMultiply = function Mt(t3) {
            this[this.t] = this.am(0, t3 - 1, this, 0, 0, this.t), ++this.t, this.clamp();
          }, w.prototype.dAddOffset = function Ht(t3, e2) {
            if (0 != t3) {
              for (; this.t <= e2; ) this[this.t++] = 0;
              for (this[e2] += t3; this[e2] >= this.DV; ) this[e2] -= this.DV, ++e2 >= this.t && (this[this.t++] = 0), ++this[e2];
            }
          }, w.prototype.multiplyLowerTo = function Vt(t3, e2, r3) {
            var n3, i2 = Math.min(this.t + t3.t, e2);
            for (r3.s = 0, r3.t = i2; i2 > 0; ) r3[--i2] = 0;
            for (n3 = r3.t - this.t; i2 < n3; ++i2) r3[i2 + this.t] = this.am(0, t3[i2], r3, i2, 0, this.t);
            for (n3 = Math.min(t3.t, e2); i2 < n3; ++i2) this.am(0, t3[i2], r3, i2, 0, e2 - i2);
            r3.clamp();
          }, w.prototype.multiplyUpperTo = function Kt(t3, e2, r3) {
            --e2;
            var n3 = r3.t = this.t + t3.t - e2;
            for (r3.s = 0; --n3 >= 0; ) r3[n3] = 0;
            for (n3 = Math.max(e2 - this.t, 0); n3 < t3.t; ++n3) r3[this.t + n3 - e2] = this.am(e2 - n3, t3[n3], r3, 0, 0, this.t + n3 - e2);
            r3.clamp(), r3.drShiftTo(1, r3);
          }, w.prototype.modInt = function qt(t3) {
            if (t3 <= 0) return 0;
            var e2 = this.DV % t3, r3 = this.s < 0 ? t3 - 1 : 0;
            if (this.t > 0) if (0 == e2) r3 = this[0] % t3;
            else for (var n3 = this.t - 1; n3 >= 0; --n3) r3 = (e2 * r3 + this[n3]) % t3;
            return r3;
          }, w.prototype.millerRabin = function Jt(t3) {
            var e2 = this.subtract(w.ONE), r3 = e2.getLowestSetBit();
            if (r3 <= 0) return false;
            var n3 = e2.shiftRight(r3);
            (t3 = t3 + 1 >> 1) > Tt.length && (t3 = Tt.length);
            for (var i2 = F(), o2 = 0; o2 < t3; ++o2) {
              i2.fromInt(Tt[Math.floor(Math.random() * Tt.length)]);
              var s2 = i2.modPow(n3, this);
              if (0 != s2.compareTo(w.ONE) && 0 != s2.compareTo(e2)) {
                for (var a2 = 1; a2++ < r3 && 0 != s2.compareTo(e2); ) if (0 == (s2 = s2.modPowInt(2, this)).compareTo(w.ONE)) return false;
                if (0 != s2.compareTo(e2)) return false;
              }
            }
            return true;
          }, w.prototype.clone = /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
           */
          function Wt() {
            var t3 = F();
            return this.copyTo(t3), t3;
          }, w.prototype.intValue = function zt() {
            if (this.s < 0) {
              if (1 == this.t) return this[0] - this.DV;
              if (0 == this.t) return -1;
            } else {
              if (1 == this.t) return this[0];
              if (0 == this.t) return 0;
            }
            return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
          }, w.prototype.byteValue = function Yt() {
            return 0 == this.t ? this.s : this[0] << 24 >> 24;
          }, w.prototype.shortValue = function Gt() {
            return 0 == this.t ? this.s : this[0] << 16 >> 16;
          }, w.prototype.signum = function Xt() {
            return this.s < 0 ? -1 : this.t <= 0 || 1 == this.t && this[0] <= 0 ? 0 : 1;
          }, w.prototype.toByteArray = function $t() {
            var t3 = this.t, e2 = new Array();
            e2[0] = this.s;
            var r3, n3 = this.DB - t3 * this.DB % 8, i2 = 0;
            if (t3-- > 0) for (n3 < this.DB && (r3 = this[t3] >> n3) != (this.s & this.DM) >> n3 && (e2[i2++] = r3 | this.s << this.DB - n3); t3 >= 0; ) n3 < 8 ? (r3 = (this[t3] & (1 << n3) - 1) << 8 - n3, r3 |= this[--t3] >> (n3 += this.DB - 8)) : (r3 = this[t3] >> (n3 -= 8) & 255, n3 <= 0 && (n3 += this.DB, --t3)), 0 != (128 & r3) && (r3 |= -256), 0 == i2 && (128 & this.s) != (128 & r3) && ++i2, (i2 > 0 || r3 != this.s) && (e2[i2++] = r3);
            return e2;
          }, w.prototype.equals = function Qt(t3) {
            return 0 == this.compareTo(t3);
          }, w.prototype.min = function Zt(t3) {
            return this.compareTo(t3) < 0 ? this : t3;
          }, w.prototype.max = function te(t3) {
            return this.compareTo(t3) > 0 ? this : t3;
          }, w.prototype.and = function ee(t3) {
            var e2 = F();
            return this.bitwiseTo(t3, U, e2), e2;
          }, w.prototype.or = function re(t3) {
            var e2 = F();
            return this.bitwiseTo(t3, B, e2), e2;
          }, w.prototype.xor = function ne(t3) {
            var e2 = F();
            return this.bitwiseTo(t3, O, e2), e2;
          }, w.prototype.andNot = function ie(t3) {
            var e2 = F();
            return this.bitwiseTo(t3, j, e2), e2;
          }, w.prototype.not = function oe() {
            for (var t3 = F(), e2 = 0; e2 < this.t; ++e2) t3[e2] = this.DM & ~this[e2];
            return t3.t = this.t, t3.s = ~this.s, t3;
          }, w.prototype.shiftLeft = function se(t3) {
            var e2 = F();
            return t3 < 0 ? this.rShiftTo(-t3, e2) : this.lShiftTo(t3, e2), e2;
          }, w.prototype.shiftRight = function ae(t3) {
            var e2 = F();
            return t3 < 0 ? this.lShiftTo(-t3, e2) : this.rShiftTo(t3, e2), e2;
          }, w.prototype.getLowestSetBit = function ue() {
            for (var t3 = 0; t3 < this.t; ++t3) if (0 != this[t3]) return t3 * this.DB + M(this[t3]);
            return this.s < 0 ? this.t * this.DB : -1;
          }, w.prototype.bitCount = function ce() {
            for (var t3 = 0, e2 = this.s & this.DM, r3 = 0; r3 < this.t; ++r3) t3 += H(this[r3] ^ e2);
            return t3;
          }, w.prototype.testBit = function he(t3) {
            var e2 = Math.floor(t3 / this.DB);
            return e2 >= this.t ? 0 != this.s : 0 != (this[e2] & 1 << t3 % this.DB);
          }, w.prototype.setBit = function le(t3) {
            return this.changeBit(t3, B);
          }, w.prototype.clearBit = function fe(t3) {
            return this.changeBit(t3, j);
          }, w.prototype.flipBit = function ge(t3) {
            return this.changeBit(t3, O);
          }, w.prototype.add = function de(t3) {
            var e2 = F();
            return this.addTo(t3, e2), e2;
          }, w.prototype.subtract = function pe(t3) {
            var e2 = F();
            return this.subTo(t3, e2), e2;
          }, w.prototype.multiply = function ve(t3) {
            var e2 = F();
            return this.multiplyTo(t3, e2), e2;
          }, w.prototype.divide = function ye(t3) {
            var e2 = F();
            return this.divRemTo(t3, e2, null), e2;
          }, w.prototype.remainder = function me(t3) {
            var e2 = F();
            return this.divRemTo(t3, null, e2), e2;
          }, w.prototype.divideAndRemainder = function _e(t3) {
            var e2 = F(), r3 = F();
            return this.divRemTo(t3, e2, r3), new Array(e2, r3);
          }, w.prototype.modPow = function Se(t3, e2) {
            var r3, n3, i2 = t3.bitLength(), o2 = I(1);
            if (i2 <= 0) return o2;
            r3 = i2 < 18 ? 1 : i2 < 48 ? 3 : i2 < 144 ? 4 : i2 < 768 ? 5 : 6, n3 = i2 < 8 ? new L(e2) : e2.isEven() ? new q(e2) : new N(e2);
            var s2 = new Array(), a2 = 3, u2 = r3 - 1, c2 = (1 << r3) - 1;
            if (s2[1] = n3.convert(this), r3 > 1) {
              var h2 = F();
              for (n3.sqrTo(s2[1], h2); a2 <= c2; ) s2[a2] = F(), n3.mulTo(h2, s2[a2 - 2], s2[a2]), a2 += 2;
            }
            var l2, f2, g2 = t3.t - 1, d2 = true, p2 = F();
            for (i2 = D(t3[g2]) - 1; g2 >= 0; ) {
              for (i2 >= u2 ? l2 = t3[g2] >> i2 - u2 & c2 : (l2 = (t3[g2] & (1 << i2 + 1) - 1) << u2 - i2, g2 > 0 && (l2 |= t3[g2 - 1] >> this.DB + i2 - u2)), a2 = r3; 0 == (1 & l2); ) l2 >>= 1, --a2;
              if ((i2 -= a2) < 0 && (i2 += this.DB, --g2), d2) s2[l2].copyTo(o2), d2 = false;
              else {
                for (; a2 > 1; ) n3.sqrTo(o2, p2), n3.sqrTo(p2, o2), a2 -= 2;
                a2 > 0 ? n3.sqrTo(o2, p2) : (f2 = o2, o2 = p2, p2 = f2), n3.mulTo(p2, s2[l2], o2);
              }
              for (; g2 >= 0 && 0 == (t3[g2] & 1 << i2); ) n3.sqrTo(o2, p2), f2 = o2, o2 = p2, p2 = f2, --i2 < 0 && (i2 = this.DB - 1, --g2);
            }
            return n3.revert(o2);
          }, w.prototype.modInverse = function be(t3) {
            var e2 = t3.isEven();
            if (this.isEven() && e2 || 0 == t3.signum()) return w.ZERO;
            for (var r3 = t3.clone(), n3 = this.clone(), i2 = I(1), o2 = I(0), s2 = I(0), a2 = I(1); 0 != r3.signum(); ) {
              for (; r3.isEven(); ) r3.rShiftTo(1, r3), e2 ? (i2.isEven() && o2.isEven() || (i2.addTo(this, i2), o2.subTo(t3, o2)), i2.rShiftTo(1, i2)) : o2.isEven() || o2.subTo(t3, o2), o2.rShiftTo(1, o2);
              for (; n3.isEven(); ) n3.rShiftTo(1, n3), e2 ? (s2.isEven() && a2.isEven() || (s2.addTo(this, s2), a2.subTo(t3, a2)), s2.rShiftTo(1, s2)) : a2.isEven() || a2.subTo(t3, a2), a2.rShiftTo(1, a2);
              r3.compareTo(n3) >= 0 ? (r3.subTo(n3, r3), e2 && i2.subTo(s2, i2), o2.subTo(a2, o2)) : (n3.subTo(r3, n3), e2 && s2.subTo(i2, s2), a2.subTo(o2, a2));
            }
            return 0 != n3.compareTo(w.ONE) ? w.ZERO : a2.compareTo(t3) >= 0 ? a2.subtract(t3) : a2.signum() < 0 ? (a2.addTo(t3, a2), a2.signum() < 0 ? a2.add(t3) : a2) : a2;
          }, w.prototype.pow = function we(t3) {
            return this.exp(t3, new V());
          }, w.prototype.gcd = function Fe(t3) {
            var e2 = this.s < 0 ? this.negate() : this.clone(), r3 = t3.s < 0 ? t3.negate() : t3.clone();
            if (e2.compareTo(r3) < 0) {
              var n3 = e2;
              e2 = r3, r3 = n3;
            }
            var i2 = e2.getLowestSetBit(), o2 = r3.getLowestSetBit();
            if (o2 < 0) return e2;
            for (i2 < o2 && (o2 = i2), o2 > 0 && (e2.rShiftTo(o2, e2), r3.rShiftTo(o2, r3)); e2.signum() > 0; ) (i2 = e2.getLowestSetBit()) > 0 && e2.rShiftTo(i2, e2), (i2 = r3.getLowestSetBit()) > 0 && r3.rShiftTo(i2, r3), e2.compareTo(r3) >= 0 ? (e2.subTo(r3, e2), e2.rShiftTo(1, e2)) : (r3.subTo(e2, r3), r3.rShiftTo(1, r3));
            return o2 > 0 && r3.lShiftTo(o2, r3), r3;
          }, w.prototype.isProbablePrime = function Ee(t3) {
            var e2, r3 = this.abs();
            if (1 == r3.t && r3[0] <= Tt[Tt.length - 1]) {
              for (e2 = 0; e2 < Tt.length; ++e2) if (r3[0] == Tt[e2]) return true;
              return false;
            }
            if (r3.isEven()) return false;
            for (e2 = 1; e2 < Tt.length; ) {
              for (var n3 = Tt[e2], i2 = e2 + 1; i2 < Tt.length && n3 < Rt; ) n3 *= Tt[i2++];
              for (n3 = r3.modInt(n3); e2 < i2; ) if (n3 % Tt[e2++] == 0) return false;
            }
            return r3.millerRabin(t3);
          }, w.prototype.square = function xe() {
            var t3 = F();
            return this.squareTo(t3), t3;
          }, It.prototype.init = function Ae(t3) {
            var e2, r3, n3;
            for (e2 = 0; e2 < 256; ++e2) this.S[e2] = e2;
            for (r3 = 0, e2 = 0; e2 < 256; ++e2) r3 = r3 + this.S[e2] + t3[e2 % t3.length] & 255, n3 = this.S[e2], this.S[e2] = this.S[r3], this.S[r3] = n3;
            this.i = 0, this.j = 0;
          }, It.prototype.next = function ke() {
            var t3;
            return this.i = this.i + 1 & 255, this.j = this.j + this.S[this.i] & 255, t3 = this.S[this.i], this.S[this.i] = this.S[this.j], this.S[this.j] = t3, this.S[t3 + this.S[this.i] & 255];
          };
          var Pe, Ce, Te;
          function Re() {
            !function t3(e2) {
              Ce[Te++] ^= 255 & e2, Ce[Te++] ^= e2 >> 8 & 255, Ce[Te++] ^= e2 >> 16 & 255, Ce[Te++] ^= e2 >> 24 & 255, Te >= 256 && (Te -= 256);
            }((/* @__PURE__ */ new Date()).getTime());
          }
          if (null == Ce) {
            var Ie;
            if (Ce = new Array(), Te = 0, void 0 !== p && (void 0 !== p.crypto || void 0 !== p.msCrypto)) {
              var De = p.crypto || p.msCrypto;
              if (De.getRandomValues) {
                var Le = new Uint8Array(32);
                for (De.getRandomValues(Le), Ie = 0; Ie < 32; ++Ie) Ce[Te++] = Le[Ie];
              } else if ("Netscape" == d.appName && d.appVersion < "5") {
                var Ne = p.crypto.random(32);
                for (Ie = 0; Ie < Ne.length; ++Ie) Ce[Te++] = 255 & Ne.charCodeAt(Ie);
              }
            }
            for (; Te < 256; ) Ie = Math.floor(65536 * Math.random()), Ce[Te++] = Ie >>> 8, Ce[Te++] = 255 & Ie;
            Te = 0, Re();
          }
          function Ue() {
            if (null == Pe) {
              for (Re(), (Pe = function t3() {
                return new It();
              }()).init(Ce), Te = 0; Te < Ce.length; ++Te) Ce[Te] = 0;
              Te = 0;
            }
            return Pe.next();
          }
          function Be() {
          }
          function Oe(t3, e2) {
            return new w(t3, e2);
          }
          function je(t3, e2, r3) {
            for (var n3 = "", i2 = 0; n3.length < e2; ) n3 += r3(String.fromCharCode.apply(String, t3.concat([(4278190080 & i2) >> 24, (16711680 & i2) >> 16, (65280 & i2) >> 8, 255 & i2]))), i2 += 1;
            return n3;
          }
          function Me2() {
            this.n = null, this.e = 0, this.d = null, this.p = null, this.q = null, this.dmp1 = null, this.dmq1 = null, this.coeff = null;
          }
          function He(t3, e2) {
            this.x = e2, this.q = t3;
          }
          function Ve(t3, e2, r3, n3) {
            this.curve = t3, this.x = e2, this.y = r3, this.z = null == n3 ? w.ONE : n3, this.zinv = null;
          }
          function Ke(t3, e2, r3) {
            this.q = t3, this.a = this.fromBigInteger(e2), this.b = this.fromBigInteger(r3), this.infinity = new Ve(this, null, null);
          }
          Be.prototype.nextBytes = function qe(t3) {
            var e2;
            for (e2 = 0; e2 < t3.length; ++e2) t3[e2] = Ue();
          }, Me2.prototype.doPublic = function Je(t3) {
            return t3.modPowInt(this.e, this.n);
          }, Me2.prototype.setPublic = function We(t3, e2) {
            if (this.isPublic = true, this.isPrivate = false, "string" != typeof t3) this.n = t3, this.e = e2;
            else {
              if (!(null != t3 && null != e2 && t3.length > 0 && e2.length > 0)) throw "Invalid RSA public key";
              this.n = Oe(t3, 16), this.e = parseInt(e2, 16);
            }
          }, Me2.prototype.encrypt = function ze(t3) {
            var e2 = function r3(t4, e3) {
              if (e3 < t4.length + 11) throw "Message too long for RSA";
              for (var r4 = new Array(), n4 = t4.length - 1; n4 >= 0 && e3 > 0; ) {
                var i3 = t4.charCodeAt(n4--);
                i3 < 128 ? r4[--e3] = i3 : i3 > 127 && i3 < 2048 ? (r4[--e3] = 63 & i3 | 128, r4[--e3] = i3 >> 6 | 192) : (r4[--e3] = 63 & i3 | 128, r4[--e3] = i3 >> 6 & 63 | 128, r4[--e3] = i3 >> 12 | 224);
              }
              r4[--e3] = 0;
              for (var o2 = new Be(), s2 = new Array(); e3 > 2; ) {
                for (s2[0] = 0; 0 == s2[0]; ) o2.nextBytes(s2);
                r4[--e3] = s2[0];
              }
              return r4[--e3] = 2, r4[--e3] = 0, new w(r4);
            }(t3, this.n.bitLength() + 7 >> 3);
            if (null == e2) return null;
            var n3 = this.doPublic(e2);
            if (null == n3) return null;
            var i2 = n3.toString(16);
            return 0 == (1 & i2.length) ? i2 : "0" + i2;
          }, Me2.prototype.encryptOAEP = function Ye(t3, e2, r3) {
            var n3 = function i2(t4, e3, r4, n4) {
              var i3 = Sr.crypto.MessageDigest, o3 = Sr.crypto.Util, s3 = null;
              if (r4 || (r4 = "sha1"), "string" == typeof r4 && (s3 = i3.getCanonicalAlgName(r4), n4 = i3.getHashLength(s3), r4 = function t5(e4) {
                return Lr(o3.hashHex(Nr(e4), s3));
              }), t4.length + 2 * n4 + 2 > e3) throw "Message too long for RSA";
              var a2, u2 = "";
              for (a2 = 0; a2 < e3 - t4.length - 2 * n4 - 2; a2 += 1) u2 += "\0";
              var c2 = r4("") + u2 + "" + t4, h2 = new Array(n4);
              new Be().nextBytes(h2);
              var l2 = je(h2, c2.length, r4), f2 = [];
              for (a2 = 0; a2 < c2.length; a2 += 1) f2[a2] = c2.charCodeAt(a2) ^ l2.charCodeAt(a2);
              var g2 = je(f2, h2.length, r4), d2 = [0];
              for (a2 = 0; a2 < h2.length; a2 += 1) d2[a2 + 1] = h2[a2] ^ g2.charCodeAt(a2);
              return new w(d2.concat(f2));
            }(t3, this.n.bitLength() + 7 >> 3, e2, r3);
            if (null == n3) return null;
            var o2 = this.doPublic(n3);
            if (null == o2) return null;
            var s2 = o2.toString(16);
            return 0 == (1 & s2.length) ? s2 : "0" + s2;
          }, Me2.prototype.type = "RSA", He.prototype.equals = function Ge(t3) {
            return t3 == this || this.q.equals(t3.q) && this.x.equals(t3.x);
          }, He.prototype.toBigInteger = function Xe() {
            return this.x;
          }, He.prototype.negate = function $e() {
            return new He(this.q, this.x.negate().mod(this.q));
          }, He.prototype.add = function Qe(t3) {
            return new He(this.q, this.x.add(t3.toBigInteger()).mod(this.q));
          }, He.prototype.subtract = function Ze(t3) {
            return new He(this.q, this.x.subtract(t3.toBigInteger()).mod(this.q));
          }, He.prototype.multiply = function tr(t3) {
            return new He(this.q, this.x.multiply(t3.toBigInteger()).mod(this.q));
          }, He.prototype.square = function er() {
            return new He(this.q, this.x.square().mod(this.q));
          }, He.prototype.divide = function rr(t3) {
            return new He(this.q, this.x.multiply(t3.toBigInteger().modInverse(this.q)).mod(this.q));
          }, Ve.prototype.getX = function nr() {
            return null == this.zinv && (this.zinv = this.z.modInverse(this.curve.q)), this.curve.fromBigInteger(this.x.toBigInteger().multiply(this.zinv).mod(this.curve.q));
          }, Ve.prototype.getY = function ir() {
            return null == this.zinv && (this.zinv = this.z.modInverse(this.curve.q)), this.curve.fromBigInteger(this.y.toBigInteger().multiply(this.zinv).mod(this.curve.q));
          }, Ve.prototype.equals = function or(t3) {
            return t3 == this || (this.isInfinity() ? t3.isInfinity() : t3.isInfinity() ? this.isInfinity() : !!t3.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t3.z)).mod(this.curve.q).equals(w.ZERO) && t3.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t3.z)).mod(this.curve.q).equals(w.ZERO));
          }, Ve.prototype.isInfinity = function sr() {
            return null == this.x && null == this.y || this.z.equals(w.ZERO) && !this.y.toBigInteger().equals(w.ZERO);
          }, Ve.prototype.negate = function ar() {
            return new Ve(this.curve, this.x, this.y.negate(), this.z);
          }, Ve.prototype.add = function ur(t3) {
            if (this.isInfinity()) return t3;
            if (t3.isInfinity()) return this;
            var e2 = t3.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t3.z)).mod(this.curve.q), r3 = t3.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t3.z)).mod(this.curve.q);
            if (w.ZERO.equals(r3)) return w.ZERO.equals(e2) ? this.twice() : this.curve.getInfinity();
            var n3 = new w("3"), i2 = this.x.toBigInteger(), o2 = this.y.toBigInteger(), s2 = (t3.x.toBigInteger(), t3.y.toBigInteger(), r3.square()), a2 = s2.multiply(r3), u2 = i2.multiply(s2), c2 = e2.square().multiply(this.z), h2 = c2.subtract(u2.shiftLeft(1)).multiply(t3.z).subtract(a2).multiply(r3).mod(this.curve.q), l2 = u2.multiply(n3).multiply(e2).subtract(o2.multiply(a2)).subtract(c2.multiply(e2)).multiply(t3.z).add(e2.multiply(a2)).mod(this.curve.q), f2 = a2.multiply(this.z).multiply(t3.z).mod(this.curve.q);
            return new Ve(this.curve, this.curve.fromBigInteger(h2), this.curve.fromBigInteger(l2), f2);
          }, Ve.prototype.twice = function cr() {
            if (this.isInfinity()) return this;
            if (0 == this.y.toBigInteger().signum()) return this.curve.getInfinity();
            var t3 = new w("3"), e2 = this.x.toBigInteger(), r3 = this.y.toBigInteger(), n3 = r3.multiply(this.z), i2 = n3.multiply(r3).mod(this.curve.q), o2 = this.curve.a.toBigInteger(), s2 = e2.square().multiply(t3);
            w.ZERO.equals(o2) || (s2 = s2.add(this.z.square().multiply(o2)));
            var a2 = (s2 = s2.mod(this.curve.q)).square().subtract(e2.shiftLeft(3).multiply(i2)).shiftLeft(1).multiply(n3).mod(this.curve.q), u2 = s2.multiply(t3).multiply(e2).subtract(i2.shiftLeft(1)).shiftLeft(2).multiply(i2).subtract(s2.square().multiply(s2)).mod(this.curve.q), c2 = n3.square().multiply(n3).shiftLeft(3).mod(this.curve.q);
            return new Ve(this.curve, this.curve.fromBigInteger(a2), this.curve.fromBigInteger(u2), c2);
          }, Ve.prototype.multiply = function hr(t3) {
            if (this.isInfinity()) return this;
            if (0 == t3.signum()) return this.curve.getInfinity();
            var e2, r3 = t3, n3 = r3.multiply(new w("3")), i2 = this.negate(), o2 = this, s2 = this.curve.q.subtract(t3), a2 = s2.multiply(new w("3")), u2 = new Ve(this.curve, this.x, this.y), c2 = u2.negate();
            for (e2 = n3.bitLength() - 2; e2 > 0; --e2) {
              o2 = o2.twice();
              var h2 = n3.testBit(e2);
              h2 != r3.testBit(e2) && (o2 = o2.add(h2 ? this : i2));
            }
            for (e2 = a2.bitLength() - 2; e2 > 0; --e2) {
              u2 = u2.twice();
              var l2 = a2.testBit(e2);
              l2 != s2.testBit(e2) && (u2 = u2.add(l2 ? u2 : c2));
            }
            return o2;
          }, Ve.prototype.multiplyTwo = function lr(t3, e2, r3) {
            var n3;
            n3 = t3.bitLength() > r3.bitLength() ? t3.bitLength() - 1 : r3.bitLength() - 1;
            for (var i2 = this.curve.getInfinity(), o2 = this.add(e2); n3 >= 0; ) i2 = i2.twice(), t3.testBit(n3) ? i2 = r3.testBit(n3) ? i2.add(o2) : i2.add(this) : r3.testBit(n3) && (i2 = i2.add(e2)), --n3;
            return i2;
          }, Ke.prototype.getQ = function fr() {
            return this.q;
          }, Ke.prototype.getA = function gr() {
            return this.a;
          }, Ke.prototype.getB = function dr() {
            return this.b;
          }, Ke.prototype.equals = function pr(t3) {
            return t3 == this || this.q.equals(t3.q) && this.a.equals(t3.a) && this.b.equals(t3.b);
          }, Ke.prototype.getInfinity = function vr() {
            return this.infinity;
          }, Ke.prototype.fromBigInteger = function yr(t3) {
            return new He(this.q, t3);
          }, Ke.prototype.decodePointHex = function mr(t3) {
            switch (parseInt(t3.substr(0, 2), 16)) {
              case 0:
                return this.infinity;
              case 2:
              case 3:
                return null;
              case 4:
              case 6:
              case 7:
                var e2 = (t3.length - 2) / 2, r3 = t3.substr(2, e2), n3 = t3.substr(e2 + 2, e2);
                return new Ve(this, this.fromBigInteger(new w(r3, 16)), this.fromBigInteger(new w(n3, 16)));
              default:
                return null;
            }
          }, /*! (c) Stefan Thomas | https://github.com/bitcoinjs/bitcoinjs-lib
           */
          He.prototype.getByteLength = function() {
            return Math.floor((this.toBigInteger().bitLength() + 7) / 8);
          }, Ve.prototype.getEncoded = function(t3) {
            var e2 = function t4(e3, r4) {
              var n4 = e3.toByteArrayUnsigned();
              if (r4 < n4.length) n4 = n4.slice(n4.length - r4);
              else for (; r4 > n4.length; ) n4.unshift(0);
              return n4;
            }, r3 = this.getX().toBigInteger(), n3 = this.getY().toBigInteger(), i2 = e2(r3, 32);
            return t3 ? n3.isEven() ? i2.unshift(2) : i2.unshift(3) : (i2.unshift(4), i2 = i2.concat(e2(n3, 32))), i2;
          }, Ve.decodeFrom = function(t3, e2) {
            e2[0];
            var r3 = e2.length - 1, n3 = e2.slice(1, 1 + r3 / 2), i2 = e2.slice(1 + r3 / 2, 1 + r3);
            n3.unshift(0), i2.unshift(0);
            var o2 = new w(n3), s2 = new w(i2);
            return new Ve(t3, t3.fromBigInteger(o2), t3.fromBigInteger(s2));
          }, Ve.decodeFromHex = function(t3, e2) {
            e2.substr(0, 2);
            var r3 = e2.length - 2, n3 = e2.substr(2, r3 / 2), i2 = e2.substr(2 + r3 / 2, r3 / 2), o2 = new w(n3, 16), s2 = new w(i2, 16);
            return new Ve(t3, t3.fromBigInteger(o2), t3.fromBigInteger(s2));
          }, Ve.prototype.add2D = function(t3) {
            if (this.isInfinity()) return t3;
            if (t3.isInfinity()) return this;
            if (this.x.equals(t3.x)) return this.y.equals(t3.y) ? this.twice() : this.curve.getInfinity();
            var e2 = t3.x.subtract(this.x), r3 = t3.y.subtract(this.y).divide(e2), n3 = r3.square().subtract(this.x).subtract(t3.x), i2 = r3.multiply(this.x.subtract(n3)).subtract(this.y);
            return new Ve(this.curve, n3, i2);
          }, Ve.prototype.twice2D = function() {
            if (this.isInfinity()) return this;
            if (0 == this.y.toBigInteger().signum()) return this.curve.getInfinity();
            var t3 = this.curve.fromBigInteger(w.valueOf(2)), e2 = this.curve.fromBigInteger(w.valueOf(3)), r3 = this.x.square().multiply(e2).add(this.curve.a).divide(this.y.multiply(t3)), n3 = r3.square().subtract(this.x.multiply(t3)), i2 = r3.multiply(this.x.subtract(n3)).subtract(this.y);
            return new Ve(this.curve, n3, i2);
          }, Ve.prototype.multiply2D = function(t3) {
            if (this.isInfinity()) return this;
            if (0 == t3.signum()) return this.curve.getInfinity();
            var e2, r3 = t3, n3 = r3.multiply(new w("3")), i2 = this.negate(), o2 = this;
            for (e2 = n3.bitLength() - 2; e2 > 0; --e2) {
              o2 = o2.twice();
              var s2 = n3.testBit(e2);
              s2 != r3.testBit(e2) && (o2 = o2.add2D(s2 ? this : i2));
            }
            return o2;
          }, Ve.prototype.isOnCurve = function() {
            var t3 = this.getX().toBigInteger(), e2 = this.getY().toBigInteger(), r3 = this.curve.getA().toBigInteger(), n3 = this.curve.getB().toBigInteger(), i2 = this.curve.getQ(), o2 = e2.multiply(e2).mod(i2), s2 = t3.multiply(t3).multiply(t3).add(r3.multiply(t3)).add(n3).mod(i2);
            return o2.equals(s2);
          }, Ve.prototype.toString = function() {
            return "(" + this.getX().toBigInteger().toString() + "," + this.getY().toBigInteger().toString() + ")";
          }, Ve.prototype.validate = function() {
            var t3 = this.curve.getQ();
            if (this.isInfinity()) throw new Error("Point is at infinity.");
            var e2 = this.getX().toBigInteger(), r3 = this.getY().toBigInteger();
            if (e2.compareTo(w.ONE) < 0 || e2.compareTo(t3.subtract(w.ONE)) > 0) throw new Error("x coordinate out of bounds");
            if (r3.compareTo(w.ONE) < 0 || r3.compareTo(t3.subtract(w.ONE)) > 0) throw new Error("y coordinate out of bounds");
            if (!this.isOnCurve()) throw new Error("Point is not on the curve.");
            if (this.multiply(t3).isInfinity()) throw new Error("Point is not a scalar multiple of G.");
            return true;
          };
          var _r = function() {
            var t3 = new RegExp('(?:false|true|null|[\\{\\}\\[\\]]|(?:-?\\b(?:0|[1-9][0-9]*)(?:\\.[0-9]+)?(?:[eE][+-]?[0-9]+)?\\b)|(?:"(?:[^\\0-\\x08\\x0a-\\x1f"\\\\]|\\\\(?:["/\\\\bfnrt]|u[0-9A-Fa-f]{4}))*"))', "g"), e2 = new RegExp("\\\\(?:([^u])|u(.{4}))", "g"), r3 = { '"': '"', "/": "/", "\\": "\\", b: "\b", f: "\f", n: "\n", r: "\r", t: "	" };
            function n3(t4, e3, n4) {
              return e3 ? r3[e3] : String.fromCharCode(parseInt(n4, 16));
            }
            var i2 = new String(""), o2 = Object.hasOwnProperty;
            return function(r4, s2) {
              var a2, u2, c2 = r4.match(t3), h2 = c2[0], l2 = false;
              "{" === h2 ? a2 = {} : "[" === h2 ? a2 = [] : (a2 = [], l2 = true);
              for (var f2 = [a2], d2 = 1 - l2, p2 = c2.length; d2 < p2; ++d2) {
                var v3;
                switch ((h2 = c2[d2]).charCodeAt(0)) {
                  default:
                    (v3 = f2[0])[u2 || v3.length] = +h2, u2 = void 0;
                    break;
                  case 34:
                    if (-1 !== (h2 = h2.substring(1, h2.length - 1)).indexOf("\\") && (h2 = h2.replace(e2, n3)), v3 = f2[0], !u2) {
                      if (!(v3 instanceof Array)) {
                        u2 = h2 || i2;
                        break;
                      }
                      u2 = v3.length;
                    }
                    v3[u2] = h2, u2 = void 0;
                    break;
                  case 91:
                    v3 = f2[0], f2.unshift(v3[u2 || v3.length] = []), u2 = void 0;
                    break;
                  case 93:
                    f2.shift();
                    break;
                  case 102:
                    (v3 = f2[0])[u2 || v3.length] = false, u2 = void 0;
                    break;
                  case 110:
                    (v3 = f2[0])[u2 || v3.length] = null, u2 = void 0;
                    break;
                  case 116:
                    (v3 = f2[0])[u2 || v3.length] = true, u2 = void 0;
                    break;
                  case 123:
                    v3 = f2[0], f2.unshift(v3[u2 || v3.length] = {}), u2 = void 0;
                    break;
                  case 125:
                    f2.shift();
                }
              }
              if (l2) {
                if (1 !== f2.length) throw new Error();
                a2 = a2[0];
              } else if (f2.length) throw new Error();
              if (s2) {
                a2 = function t4(e3, r5) {
                  var n4 = e3[r5];
                  if (n4 && "object" === (void 0 === n4 ? "undefined" : g(n4))) {
                    var i3 = null;
                    for (var a3 in n4) if (o2.call(n4, a3) && n4 !== e3) {
                      var u3 = t4(n4, a3);
                      void 0 !== u3 ? n4[a3] = u3 : (i3 || (i3 = []), i3.push(a3));
                    }
                    if (i3) for (var c3 = i3.length; --c3 >= 0; ) delete n4[i3[c3]];
                  }
                  return s2.call(e3, r5, n4);
                }({ "": a2 }, "");
              }
              return a2;
            };
          }();
          void 0 !== Sr && Sr || (e.KJUR = Sr = {}), void 0 !== Sr.asn1 && Sr.asn1 || (Sr.asn1 = {}), Sr.asn1.ASN1Util = new function() {
            this.integerToByteHex = function(t3) {
              var e2 = t3.toString(16);
              return e2.length % 2 == 1 && (e2 = "0" + e2), e2;
            }, this.bigIntToMinTwosComplementsHex = function(t3) {
              var e2 = t3.toString(16);
              if ("-" != e2.substr(0, 1)) e2.length % 2 == 1 ? e2 = "0" + e2 : e2.match(/^[0-7]/) || (e2 = "00" + e2);
              else {
                var r3 = e2.substr(1).length;
                r3 % 2 == 1 ? r3 += 1 : e2.match(/^[0-7]/) || (r3 += 2);
                for (var n3 = "", i2 = 0; i2 < r3; i2++) n3 += "f";
                e2 = new w(n3, 16).xor(t3).add(w.ONE).toString(16).replace(/^-/, "");
              }
              return e2;
            }, this.getPEMStringFromHex = function(t3, e2) {
              return jr(t3, e2);
            }, this.newObject = function(t3) {
              var e2 = Sr.asn1, r3 = e2.ASN1Object, n3 = e2.DERBoolean, i2 = e2.DERInteger, o2 = e2.DERBitString, s2 = e2.DEROctetString, a2 = e2.DERNull, u2 = e2.DERObjectIdentifier, c2 = e2.DEREnumerated, h2 = e2.DERUTF8String, l2 = e2.DERNumericString, f2 = e2.DERPrintableString, g2 = e2.DERTeletexString, d2 = e2.DERIA5String, p2 = e2.DERUTCTime, v3 = e2.DERGeneralizedTime, y2 = e2.DERVisibleString, m2 = e2.DERBMPString, _2 = e2.DERSequence, S2 = e2.DERSet, b2 = e2.DERTaggedObject, w2 = e2.ASN1Util.newObject;
              if (t3 instanceof e2.ASN1Object) return t3;
              var F2 = Object.keys(t3);
              if (1 != F2.length) throw new Error("key of param shall be only one.");
              var E = F2[0];
              if (-1 == ":asn1:bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:visstr:bmpstr:seq:set:tag:".indexOf(":" + E + ":")) throw new Error("undefined key: " + E);
              if ("bool" == E) return new n3(t3[E]);
              if ("int" == E) return new i2(t3[E]);
              if ("bitstr" == E) return new o2(t3[E]);
              if ("octstr" == E) return new s2(t3[E]);
              if ("null" == E) return new a2(t3[E]);
              if ("oid" == E) return new u2(t3[E]);
              if ("enum" == E) return new c2(t3[E]);
              if ("utf8str" == E) return new h2(t3[E]);
              if ("numstr" == E) return new l2(t3[E]);
              if ("prnstr" == E) return new f2(t3[E]);
              if ("telstr" == E) return new g2(t3[E]);
              if ("ia5str" == E) return new d2(t3[E]);
              if ("utctime" == E) return new p2(t3[E]);
              if ("gentime" == E) return new v3(t3[E]);
              if ("visstr" == E) return new y2(t3[E]);
              if ("bmpstr" == E) return new m2(t3[E]);
              if ("asn1" == E) return new r3(t3[E]);
              if ("seq" == E) {
                for (var x = t3[E], A = [], k2 = 0; k2 < x.length; k2++) {
                  var P2 = w2(x[k2]);
                  A.push(P2);
                }
                return new _2({ array: A });
              }
              if ("set" == E) {
                for (x = t3[E], A = [], k2 = 0; k2 < x.length; k2++) {
                  P2 = w2(x[k2]);
                  A.push(P2);
                }
                return new S2({ array: A });
              }
              if ("tag" == E) {
                var C2 = t3[E];
                if ("[object Array]" === Object.prototype.toString.call(C2) && 3 == C2.length) {
                  var T2 = w2(C2[2]);
                  return new b2({ tag: C2[0], explicit: C2[1], obj: T2 });
                }
                return new b2(C2);
              }
            }, this.jsonToASN1HEX = function(t3) {
              return this.newObject(t3).getEncodedHex();
            };
          }(), Sr.asn1.ASN1Util.oidHexToInt = function(t3) {
            for (var e2 = "", r3 = parseInt(t3.substr(0, 2), 16), n3 = (e2 = Math.floor(r3 / 40) + "." + r3 % 40, ""), i2 = 2; i2 < t3.length; i2 += 2) {
              var o2 = ("00000000" + parseInt(t3.substr(i2, 2), 16).toString(2)).slice(-8);
              if (n3 += o2.substr(1, 7), "0" == o2.substr(0, 1)) e2 = e2 + "." + new w(n3, 2).toString(10), n3 = "";
            }
            return e2;
          }, Sr.asn1.ASN1Util.oidIntToHex = function(t3) {
            var e2 = function t4(e3) {
              var r4 = e3.toString(16);
              return 1 == r4.length && (r4 = "0" + r4), r4;
            }, r3 = function t4(r4) {
              var n4 = "", i3 = new w(r4, 10).toString(2), o3 = 7 - i3.length % 7;
              7 == o3 && (o3 = 0);
              for (var s3 = "", a2 = 0; a2 < o3; a2++) s3 += "0";
              i3 = s3 + i3;
              for (a2 = 0; a2 < i3.length - 1; a2 += 7) {
                var u2 = i3.substr(a2, 7);
                a2 != i3.length - 7 && (u2 = "1" + u2), n4 += e2(parseInt(u2, 2));
              }
              return n4;
            };
            if (!t3.match(/^[0-9.]+$/)) throw "malformed oid string: " + t3;
            var n3 = "", i2 = t3.split("."), o2 = 40 * parseInt(i2[0]) + parseInt(i2[1]);
            n3 += e2(o2), i2.splice(0, 2);
            for (var s2 = 0; s2 < i2.length; s2++) n3 += r3(i2[s2]);
            return n3;
          }, Sr.asn1.ASN1Object = function(t3) {
            this.params = null, this.getLengthHexFromValue = function() {
              if (void 0 === this.hV || null == this.hV) throw new Error("this.hV is null or undefined");
              if (this.hV.length % 2 == 1) throw new Error("value hex must be even length: n=" + "".length + ",v=" + this.hV);
              var t4 = this.hV.length / 2, e2 = t4.toString(16);
              if (e2.length % 2 == 1 && (e2 = "0" + e2), t4 < 128) return e2;
              var r3 = e2.length / 2;
              if (r3 > 15) throw "ASN.1 length too long to represent by 8x: n = " + t4.toString(16);
              return (128 + r3).toString(16) + e2;
            }, this.getEncodedHex = function() {
              return (null == this.hTLV || this.isModified) && (this.hV = this.getFreshValueHex(), this.hL = this.getLengthHexFromValue(), this.hTLV = this.hT + this.hL + this.hV, this.isModified = false), this.hTLV;
            }, this.getValueHex = function() {
              return this.getEncodedHex(), this.hV;
            }, this.getFreshValueHex = function() {
              return "";
            }, this.setByParam = function(t4) {
              this.params = t4;
            }, null != t3 && null != t3.tlv && (this.hTLV = t3.tlv, this.isModified = false);
          }, Sr.asn1.DERAbstractString = function(t3) {
            Sr.asn1.DERAbstractString.superclass.constructor.call(this);
            this.getString = function() {
              return this.s;
            }, this.setString = function(t4) {
              this.hTLV = null, this.isModified = true, this.s = t4, this.hV = Ir(this.s).toLowerCase();
            }, this.setStringHex = function(t4) {
              this.hTLV = null, this.isModified = true, this.s = null, this.hV = t4;
            }, this.getFreshValueHex = function() {
              return this.hV;
            }, void 0 !== t3 && ("string" == typeof t3 ? this.setString(t3) : void 0 !== t3.str ? this.setString(t3.str) : void 0 !== t3.hex && this.setStringHex(t3.hex));
          }, Zr(Sr.asn1.DERAbstractString, Sr.asn1.ASN1Object), Sr.asn1.DERAbstractTime = function(t3) {
            Sr.asn1.DERAbstractTime.superclass.constructor.call(this);
            this.localDateToUTC = function(t4) {
              var e2 = t4.getTime() + 6e4 * t4.getTimezoneOffset();
              return new Date(e2);
            }, this.formatDate = function(t4, e2, r3) {
              var n3 = this.zeroPadding, i2 = this.localDateToUTC(t4), o2 = String(i2.getFullYear());
              "utc" == e2 && (o2 = o2.substr(2, 2));
              var s2 = o2 + n3(String(i2.getMonth() + 1), 2) + n3(String(i2.getDate()), 2) + n3(String(i2.getHours()), 2) + n3(String(i2.getMinutes()), 2) + n3(String(i2.getSeconds()), 2);
              if (true === r3) {
                var a2 = i2.getMilliseconds();
                if (0 != a2) {
                  var u2 = n3(String(a2), 3);
                  s2 = s2 + "." + (u2 = u2.replace(/[0]+$/, ""));
                }
              }
              return s2 + "Z";
            }, this.zeroPadding = function(t4, e2) {
              return t4.length >= e2 ? t4 : new Array(e2 - t4.length + 1).join("0") + t4;
            }, this.getString = function() {
              return this.s;
            }, this.setString = function(t4) {
              this.hTLV = null, this.isModified = true, this.s = t4, this.hV = kr(t4);
            }, this.setByDateValue = function(t4, e2, r3, n3, i2, o2) {
              var s2 = new Date(Date.UTC(t4, e2 - 1, r3, n3, i2, o2, 0));
              this.setByDate(s2);
            }, this.getFreshValueHex = function() {
              return this.hV;
            };
          }, Zr(Sr.asn1.DERAbstractTime, Sr.asn1.ASN1Object), Sr.asn1.DERAbstractStructured = function(t3) {
            Sr.asn1.DERAbstractString.superclass.constructor.call(this);
            this.setByASN1ObjectArray = function(t4) {
              this.hTLV = null, this.isModified = true, this.asn1Array = t4;
            }, this.appendASN1Object = function(t4) {
              this.hTLV = null, this.isModified = true, this.asn1Array.push(t4);
            }, this.asn1Array = new Array(), void 0 !== t3 && void 0 !== t3.array && (this.asn1Array = t3.array);
          }, Zr(Sr.asn1.DERAbstractStructured, Sr.asn1.ASN1Object), Sr.asn1.DERBoolean = function(t3) {
            Sr.asn1.DERBoolean.superclass.constructor.call(this), this.hT = "01", this.hTLV = 0 == t3 ? "010100" : "0101ff";
          }, Zr(Sr.asn1.DERBoolean, Sr.asn1.ASN1Object), Sr.asn1.DERInteger = function(t3) {
            Sr.asn1.DERInteger.superclass.constructor.call(this), this.hT = "02", this.setByBigInteger = function(t4) {
              this.hTLV = null, this.isModified = true, this.hV = Sr.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t4);
            }, this.setByInteger = function(t4) {
              var e2 = new w(String(t4), 10);
              this.setByBigInteger(e2);
            }, this.setValueHex = function(t4) {
              this.hV = t4;
            }, this.getFreshValueHex = function() {
              return this.hV;
            }, void 0 !== t3 && (void 0 !== t3.bigint ? this.setByBigInteger(t3.bigint) : void 0 !== t3.int ? this.setByInteger(t3.int) : "number" == typeof t3 ? this.setByInteger(t3) : void 0 !== t3.hex && this.setValueHex(t3.hex));
          }, Zr(Sr.asn1.DERInteger, Sr.asn1.ASN1Object), Sr.asn1.DERBitString = function(t3) {
            if (void 0 !== t3 && void 0 !== t3.obj) {
              var e2 = Sr.asn1.ASN1Util.newObject(t3.obj);
              t3.hex = "00" + e2.getEncodedHex();
            }
            Sr.asn1.DERBitString.superclass.constructor.call(this), this.hT = "03", this.setHexValueIncludingUnusedBits = function(t4) {
              this.hTLV = null, this.isModified = true, this.hV = t4;
            }, this.setUnusedBitsAndHexValue = function(t4, e3) {
              if (t4 < 0 || 7 < t4) throw "unused bits shall be from 0 to 7: u = " + t4;
              var r3 = "0" + t4;
              this.hTLV = null, this.isModified = true, this.hV = r3 + e3;
            }, this.setByBinaryString = function(t4) {
              var e3 = 8 - (t4 = t4.replace(/0+$/, "")).length % 8;
              8 == e3 && (e3 = 0);
              for (var r3 = 0; r3 <= e3; r3++) t4 += "0";
              var n3 = "";
              for (r3 = 0; r3 < t4.length - 1; r3 += 8) {
                var i2 = t4.substr(r3, 8), o2 = parseInt(i2, 2).toString(16);
                1 == o2.length && (o2 = "0" + o2), n3 += o2;
              }
              this.hTLV = null, this.isModified = true, this.hV = "0" + e3 + n3;
            }, this.setByBooleanArray = function(t4) {
              for (var e3 = "", r3 = 0; r3 < t4.length; r3++) 1 == t4[r3] ? e3 += "1" : e3 += "0";
              this.setByBinaryString(e3);
            }, this.newFalseArray = function(t4) {
              for (var e3 = new Array(t4), r3 = 0; r3 < t4; r3++) e3[r3] = false;
              return e3;
            }, this.getFreshValueHex = function() {
              return this.hV;
            }, void 0 !== t3 && ("string" == typeof t3 && t3.toLowerCase().match(/^[0-9a-f]+$/) ? this.setHexValueIncludingUnusedBits(t3) : void 0 !== t3.hex ? this.setHexValueIncludingUnusedBits(t3.hex) : void 0 !== t3.bin ? this.setByBinaryString(t3.bin) : void 0 !== t3.array && this.setByBooleanArray(t3.array));
          }, Zr(Sr.asn1.DERBitString, Sr.asn1.ASN1Object), Sr.asn1.DEROctetString = function(t3) {
            if (void 0 !== t3 && void 0 !== t3.obj) {
              var e2 = Sr.asn1.ASN1Util.newObject(t3.obj);
              t3.hex = e2.getEncodedHex();
            }
            Sr.asn1.DEROctetString.superclass.constructor.call(this, t3), this.hT = "04";
          }, Zr(Sr.asn1.DEROctetString, Sr.asn1.DERAbstractString), Sr.asn1.DERNull = function() {
            Sr.asn1.DERNull.superclass.constructor.call(this), this.hT = "05", this.hTLV = "0500";
          }, Zr(Sr.asn1.DERNull, Sr.asn1.ASN1Object), Sr.asn1.DERObjectIdentifier = function(t3) {
            Sr.asn1.DERObjectIdentifier.superclass.constructor.call(this), this.hT = "06", this.setValueHex = function(t4) {
              this.hTLV = null, this.isModified = true, this.s = null, this.hV = t4;
            }, this.setValueOidString = function(t4) {
              var e2 = function r3(t5) {
                var e3 = function t6(e4) {
                  var r5 = e4.toString(16);
                  return 1 == r5.length && (r5 = "0" + r5), r5;
                }, r4 = function t6(r5) {
                  var n4 = "", i3 = parseInt(r5, 10).toString(2), o3 = 7 - i3.length % 7;
                  7 == o3 && (o3 = 0);
                  for (var s3 = "", a2 = 0; a2 < o3; a2++) s3 += "0";
                  i3 = s3 + i3;
                  for (a2 = 0; a2 < i3.length - 1; a2 += 7) {
                    var u2 = i3.substr(a2, 7);
                    a2 != i3.length - 7 && (u2 = "1" + u2), n4 += e3(parseInt(u2, 2));
                  }
                  return n4;
                };
                try {
                  if (!t5.match(/^[0-9.]+$/)) return null;
                  var n3 = "", i2 = t5.split("."), o2 = 40 * parseInt(i2[0], 10) + parseInt(i2[1], 10);
                  n3 += e3(o2), i2.splice(0, 2);
                  for (var s2 = 0; s2 < i2.length; s2++) n3 += r4(i2[s2]);
                  return n3;
                } catch (t6) {
                  return null;
                }
              }(t4);
              if (null == e2) throw new Error("malformed oid string: " + t4);
              this.hTLV = null, this.isModified = true, this.s = null, this.hV = e2;
            }, this.setValueName = function(t4) {
              var e2 = Sr.asn1.x509.OID.name2oid(t4);
              if ("" === e2) throw new Error("DERObjectIdentifier oidName undefined: " + t4);
              this.setValueOidString(e2);
            }, this.setValueNameOrOid = function(t4) {
              t4.match(/^[0-2].[0-9.]+$/) ? this.setValueOidString(t4) : this.setValueName(t4);
            }, this.getFreshValueHex = function() {
              return this.hV;
            }, this.setByParam = function(t4) {
              "string" == typeof t4 ? this.setValueNameOrOid(t4) : void 0 !== t4.oid ? this.setValueNameOrOid(t4.oid) : void 0 !== t4.name ? this.setValueNameOrOid(t4.name) : void 0 !== t4.hex && this.setValueHex(t4.hex);
            }, void 0 !== t3 && this.setByParam(t3);
          }, Zr(Sr.asn1.DERObjectIdentifier, Sr.asn1.ASN1Object), Sr.asn1.DEREnumerated = function(t3) {
            Sr.asn1.DEREnumerated.superclass.constructor.call(this), this.hT = "0a", this.setByBigInteger = function(t4) {
              this.hTLV = null, this.isModified = true, this.hV = Sr.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t4);
            }, this.setByInteger = function(t4) {
              var e2 = new w(String(t4), 10);
              this.setByBigInteger(e2);
            }, this.setValueHex = function(t4) {
              this.hV = t4;
            }, this.getFreshValueHex = function() {
              return this.hV;
            }, void 0 !== t3 && (void 0 !== t3.int ? this.setByInteger(t3.int) : "number" == typeof t3 ? this.setByInteger(t3) : void 0 !== t3.hex && this.setValueHex(t3.hex));
          }, Zr(Sr.asn1.DEREnumerated, Sr.asn1.ASN1Object), Sr.asn1.DERUTF8String = function(t3) {
            Sr.asn1.DERUTF8String.superclass.constructor.call(this, t3), this.hT = "0c";
          }, Zr(Sr.asn1.DERUTF8String, Sr.asn1.DERAbstractString), Sr.asn1.DERNumericString = function(t3) {
            Sr.asn1.DERNumericString.superclass.constructor.call(this, t3), this.hT = "12";
          }, Zr(Sr.asn1.DERNumericString, Sr.asn1.DERAbstractString), Sr.asn1.DERPrintableString = function(t3) {
            Sr.asn1.DERPrintableString.superclass.constructor.call(this, t3), this.hT = "13";
          }, Zr(Sr.asn1.DERPrintableString, Sr.asn1.DERAbstractString), Sr.asn1.DERTeletexString = function(t3) {
            Sr.asn1.DERTeletexString.superclass.constructor.call(this, t3), this.hT = "14";
          }, Zr(Sr.asn1.DERTeletexString, Sr.asn1.DERAbstractString), Sr.asn1.DERIA5String = function(t3) {
            Sr.asn1.DERIA5String.superclass.constructor.call(this, t3), this.hT = "16";
          }, Zr(Sr.asn1.DERIA5String, Sr.asn1.DERAbstractString), Sr.asn1.DERVisibleString = function(t3) {
            Sr.asn1.DERIA5String.superclass.constructor.call(this, t3), this.hT = "1a";
          }, Zr(Sr.asn1.DERVisibleString, Sr.asn1.DERAbstractString), Sr.asn1.DERBMPString = function(t3) {
            Sr.asn1.DERBMPString.superclass.constructor.call(this, t3), this.hT = "1e";
          }, Zr(Sr.asn1.DERBMPString, Sr.asn1.DERAbstractString), Sr.asn1.DERUTCTime = function(t3) {
            Sr.asn1.DERUTCTime.superclass.constructor.call(this, t3), this.hT = "17", this.setByDate = function(t4) {
              this.hTLV = null, this.isModified = true, this.date = t4, this.s = this.formatDate(this.date, "utc"), this.hV = kr(this.s);
            }, this.getFreshValueHex = function() {
              return void 0 === this.date && void 0 === this.s && (this.date = /* @__PURE__ */ new Date(), this.s = this.formatDate(this.date, "utc"), this.hV = kr(this.s)), this.hV;
            }, void 0 !== t3 && (void 0 !== t3.str ? this.setString(t3.str) : "string" == typeof t3 && t3.match(/^[0-9]{12}Z$/) ? this.setString(t3) : void 0 !== t3.hex ? this.setStringHex(t3.hex) : void 0 !== t3.date && this.setByDate(t3.date));
          }, Zr(Sr.asn1.DERUTCTime, Sr.asn1.DERAbstractTime), Sr.asn1.DERGeneralizedTime = function(t3) {
            Sr.asn1.DERGeneralizedTime.superclass.constructor.call(this, t3), this.hT = "18", this.withMillis = false, this.setByDate = function(t4) {
              this.hTLV = null, this.isModified = true, this.date = t4, this.s = this.formatDate(this.date, "gen", this.withMillis), this.hV = kr(this.s);
            }, this.getFreshValueHex = function() {
              return void 0 === this.date && void 0 === this.s && (this.date = /* @__PURE__ */ new Date(), this.s = this.formatDate(this.date, "gen", this.withMillis), this.hV = kr(this.s)), this.hV;
            }, void 0 !== t3 && (void 0 !== t3.str ? this.setString(t3.str) : "string" == typeof t3 && t3.match(/^[0-9]{14}Z$/) ? this.setString(t3) : void 0 !== t3.hex ? this.setStringHex(t3.hex) : void 0 !== t3.date && this.setByDate(t3.date), true === t3.millis && (this.withMillis = true));
          }, Zr(Sr.asn1.DERGeneralizedTime, Sr.asn1.DERAbstractTime), Sr.asn1.DERSequence = function(t3) {
            Sr.asn1.DERSequence.superclass.constructor.call(this, t3), this.hT = "30", this.getFreshValueHex = function() {
              for (var t4 = "", e2 = 0; e2 < this.asn1Array.length; e2++) {
                t4 += this.asn1Array[e2].getEncodedHex();
              }
              return this.hV = t4, this.hV;
            };
          }, Zr(Sr.asn1.DERSequence, Sr.asn1.DERAbstractStructured), Sr.asn1.DERSet = function(t3) {
            Sr.asn1.DERSet.superclass.constructor.call(this, t3), this.hT = "31", this.sortFlag = true, this.getFreshValueHex = function() {
              for (var t4 = new Array(), e2 = 0; e2 < this.asn1Array.length; e2++) {
                var r3 = this.asn1Array[e2];
                t4.push(r3.getEncodedHex());
              }
              return 1 == this.sortFlag && t4.sort(), this.hV = t4.join(""), this.hV;
            }, void 0 !== t3 && void 0 !== t3.sortflag && 0 == t3.sortflag && (this.sortFlag = false);
          }, Zr(Sr.asn1.DERSet, Sr.asn1.DERAbstractStructured), Sr.asn1.DERTaggedObject = function(t3) {
            Sr.asn1.DERTaggedObject.superclass.constructor.call(this);
            var e2 = Sr.asn1;
            this.hT = "a0", this.hV = "", this.isExplicit = true, this.asn1Object = null, this.setASN1Object = function(t4, e3, r3) {
              this.hT = e3, this.isExplicit = t4, this.asn1Object = r3, this.isExplicit ? (this.hV = this.asn1Object.getEncodedHex(), this.hTLV = null, this.isModified = true) : (this.hV = null, this.hTLV = r3.getEncodedHex(), this.hTLV = this.hTLV.replace(/^../, e3), this.isModified = false);
            }, this.getFreshValueHex = function() {
              return this.hV;
            }, this.setByParam = function(t4) {
              null != t4.tag && (this.hT = t4.tag), null != t4.explicit && (this.isExplicit = t4.explicit), null != t4.tage && (this.hT = t4.tage, this.isExplicit = true), null != t4.tagi && (this.hT = t4.tagi, this.isExplicit = false), null != t4.obj && (t4.obj instanceof e2.ASN1Object ? (this.asn1Object = t4.obj, this.setASN1Object(this.isExplicit, this.hT, this.asn1Object)) : "object" == g(t4.obj) && (this.asn1Object = e2.ASN1Util.newObject(t4.obj), this.setASN1Object(this.isExplicit, this.hT, this.asn1Object)));
            }, null != t3 && this.setByParam(t3);
          }, Zr(Sr.asn1.DERTaggedObject, Sr.asn1.ASN1Object);
          var Sr, br, wr, Fr = new function() {
          }();
          function Er(t3) {
            for (var e2 = new Array(), r3 = 0; r3 < t3.length; r3++) e2[r3] = t3.charCodeAt(r3);
            return e2;
          }
          function xr(t3) {
            for (var e2 = "", r3 = 0; r3 < t3.length; r3++) e2 += String.fromCharCode(t3[r3]);
            return e2;
          }
          function Ar(t3) {
            for (var e2 = "", r3 = 0; r3 < t3.length; r3++) {
              var n3 = t3[r3].toString(16);
              1 == n3.length && (n3 = "0" + n3), e2 += n3;
            }
            return e2;
          }
          function kr(t3) {
            return Ar(Er(t3));
          }
          function Pr(t3) {
            return t3 = (t3 = (t3 = t3.replace(/\=/g, "")).replace(/\+/g, "-")).replace(/\//g, "_");
          }
          function Cr(t3) {
            return t3.length % 4 == 2 ? t3 += "==" : t3.length % 4 == 3 && (t3 += "="), t3 = (t3 = t3.replace(/-/g, "+")).replace(/_/g, "/");
          }
          function Tr(t3) {
            return t3.length % 2 == 1 && (t3 = "0" + t3), Pr(_(t3));
          }
          function Rr(t3) {
            return S(Cr(t3));
          }
          function Ir(t3) {
            return Kr(Gr(t3));
          }
          function Dr(t3) {
            return decodeURIComponent(qr(t3));
          }
          function Lr(t3) {
            for (var e2 = "", r3 = 0; r3 < t3.length - 1; r3 += 2) e2 += String.fromCharCode(parseInt(t3.substr(r3, 2), 16));
            return e2;
          }
          function Nr(t3) {
            for (var e2 = "", r3 = 0; r3 < t3.length; r3++) e2 += ("0" + t3.charCodeAt(r3).toString(16)).slice(-2);
            return e2;
          }
          function Ur(t3) {
            return _(t3);
          }
          function Br(t3) {
            var e2 = Ur(t3).replace(/(.{64})/g, "$1\r\n");
            return e2 = e2.replace(/\r\n$/, "");
          }
          function Or(t3) {
            return S(t3.replace(/[^0-9A-Za-z\/+=]*/g, ""));
          }
          function jr(t3, e2) {
            return "-----BEGIN " + e2 + "-----\r\n" + Br(t3) + "\r\n-----END " + e2 + "-----\r\n";
          }
          function Mr(t3, e2) {
            if (-1 == t3.indexOf("-----BEGIN ")) throw "can't find PEM header: " + e2;
            return Or(t3 = void 0 !== e2 ? (t3 = t3.replace(new RegExp("^[^]*-----BEGIN " + e2 + "-----"), "")).replace(new RegExp("-----END " + e2 + "-----[^]*$"), "") : (t3 = t3.replace(/^[^]*-----BEGIN [^-]+-----/, "")).replace(/-----END [^-]+-----[^]*$/, ""));
          }
          function Hr(t3) {
            var e2, r3, n3, i2, o2, s2, a2, u2, c2, h2, l2;
            if (l2 = t3.match(/^(\d{2}|\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)(|\.\d+)Z$/)) return u2 = l2[1], e2 = parseInt(u2), 2 === u2.length && (50 <= e2 && e2 < 100 ? e2 = 1900 + e2 : 0 <= e2 && e2 < 50 && (e2 = 2e3 + e2)), r3 = parseInt(l2[2]) - 1, n3 = parseInt(l2[3]), i2 = parseInt(l2[4]), o2 = parseInt(l2[5]), s2 = parseInt(l2[6]), a2 = 0, "" !== (c2 = l2[7]) && (h2 = (c2.substr(1) + "00").substr(0, 3), a2 = parseInt(h2)), Date.UTC(e2, r3, n3, i2, o2, s2, a2);
            throw "unsupported zulu format: " + t3;
          }
          function Vr(t3) {
            return ~~(Hr(t3) / 1e3);
          }
          function Kr(t3) {
            return t3.replace(/%/g, "");
          }
          function qr(t3) {
            return t3.replace(/(..)/g, "%$1");
          }
          function Jr(t3) {
            var e2 = "malformed IPv6 address";
            if (!t3.match(/^[0-9A-Fa-f:]+$/)) throw e2;
            var r3 = (t3 = t3.toLowerCase()).split(":").length - 1;
            if (r3 < 2) throw e2;
            var n3 = ":".repeat(7 - r3 + 2), i2 = (t3 = t3.replace("::", n3)).split(":");
            if (8 != i2.length) throw e2;
            for (var o2 = 0; o2 < 8; o2++) i2[o2] = ("0000" + i2[o2]).slice(-4);
            return i2.join("");
          }
          function Wr(t3) {
            if (!t3.match(/^[0-9A-Fa-f]{32}$/)) throw "malformed IPv6 address octet";
            for (var e2 = (t3 = t3.toLowerCase()).match(/.{1,4}/g), r3 = 0; r3 < 8; r3++) e2[r3] = e2[r3].replace(/^0+/, ""), "" == e2[r3] && (e2[r3] = "0");
            var n3 = (t3 = ":" + e2.join(":") + ":").match(/:(0:){2,}/g);
            if (null === n3) return t3.slice(1, -1);
            var i2 = "";
            for (r3 = 0; r3 < n3.length; r3++) n3[r3].length > i2.length && (i2 = n3[r3]);
            return (t3 = t3.replace(i2, "::")).slice(1, -1);
          }
          function zr(t3) {
            var e2 = "malformed hex value";
            if (!t3.match(/^([0-9A-Fa-f][0-9A-Fa-f]){1,}$/)) throw e2;
            if (8 != t3.length) return 32 == t3.length ? Wr(t3) : t3;
            try {
              return parseInt(t3.substr(0, 2), 16) + "." + parseInt(t3.substr(2, 2), 16) + "." + parseInt(t3.substr(4, 2), 16) + "." + parseInt(t3.substr(6, 2), 16);
            } catch (t4) {
              throw e2;
            }
          }
          function Yr(t3) {
            return t3.match(/.{4}/g).map(function e2(t4) {
              var e3 = parseInt(t4.substr(0, 2), 16), r3 = parseInt(t4.substr(2), 16);
              if (0 == e3 & r3 < 128) return String.fromCharCode(r3);
              if (e3 < 8) {
                var n3 = 128 | 63 & r3;
                return Dr((192 | (7 & e3) << 3 | (192 & r3) >> 6).toString(16) + n3.toString(16));
              }
              n3 = 128 | (15 & e3) << 2 | (192 & r3) >> 6;
              var i2 = 128 | 63 & r3;
              return Dr((224 | (240 & e3) >> 4).toString(16) + n3.toString(16) + i2.toString(16));
            }).join("");
          }
          function Gr(t3) {
            for (var e2 = encodeURIComponent(t3), r3 = "", n3 = 0; n3 < e2.length; n3++) "%" == e2[n3] ? (r3 += e2.substr(n3, 3), n3 += 2) : r3 = r3 + "%" + kr(e2[n3]);
            return r3;
          }
          function Xr(t3) {
            return !(t3.length % 2 != 0 || !t3.match(/^[0-9a-f]+$/) && !t3.match(/^[0-9A-F]+$/));
          }
          function $r(t3) {
            return t3.length % 2 == 1 ? "0" + t3 : t3.substr(0, 1) > "7" ? "00" + t3 : t3;
          }
          Fr.getLblen = function(t3, e2) {
            if ("8" != t3.substr(e2 + 2, 1)) return 1;
            var r3 = parseInt(t3.substr(e2 + 3, 1));
            return 0 == r3 ? -1 : 0 < r3 && r3 < 10 ? r3 + 1 : -2;
          }, Fr.getL = function(t3, e2) {
            var r3 = Fr.getLblen(t3, e2);
            return r3 < 1 ? "" : t3.substr(e2 + 2, 2 * r3);
          }, Fr.getVblen = function(t3, e2) {
            var r3;
            return "" == (r3 = Fr.getL(t3, e2)) ? -1 : ("8" === r3.substr(0, 1) ? new w(r3.substr(2), 16) : new w(r3, 16)).intValue();
          }, Fr.getVidx = function(t3, e2) {
            var r3 = Fr.getLblen(t3, e2);
            return r3 < 0 ? r3 : e2 + 2 * (r3 + 1);
          }, Fr.getV = function(t3, e2) {
            var r3 = Fr.getVidx(t3, e2), n3 = Fr.getVblen(t3, e2);
            return t3.substr(r3, 2 * n3);
          }, Fr.getTLV = function(t3, e2) {
            return t3.substr(e2, 2) + Fr.getL(t3, e2) + Fr.getV(t3, e2);
          }, Fr.getTLVblen = function(t3, e2) {
            return 2 + 2 * Fr.getLblen(t3, e2) + 2 * Fr.getVblen(t3, e2);
          }, Fr.getNextSiblingIdx = function(t3, e2) {
            return Fr.getVidx(t3, e2) + 2 * Fr.getVblen(t3, e2);
          }, Fr.getChildIdx = function(t3, e2) {
            var r3, n3, i2, o2 = Fr, s2 = [];
            r3 = o2.getVidx(t3, e2), n3 = 2 * o2.getVblen(t3, e2), "03" == t3.substr(e2, 2) && (r3 += 2, n3 -= 2), i2 = 0;
            for (var a2 = r3; i2 <= n3; ) {
              var u2 = o2.getTLVblen(t3, a2);
              if ((i2 += u2) <= n3 && s2.push(a2), a2 += u2, i2 >= n3) break;
            }
            return s2;
          }, Fr.getNthChildIdx = function(t3, e2, r3) {
            return Fr.getChildIdx(t3, e2)[r3];
          }, Fr.getIdxbyList = function(t3, e2, r3, n3) {
            var i2, o2, s2 = Fr;
            return 0 == r3.length ? void 0 !== n3 && t3.substr(e2, 2) !== n3 ? -1 : e2 : (i2 = r3.shift()) >= (o2 = s2.getChildIdx(t3, e2)).length ? -1 : s2.getIdxbyList(t3, o2[i2], r3, n3);
          }, Fr.getIdxbyListEx = function(t3, e2, r3, n3) {
            var i2, o2, s2 = Fr;
            if (0 == r3.length) return void 0 !== n3 && t3.substr(e2, 2) !== n3 ? -1 : e2;
            i2 = r3.shift(), o2 = s2.getChildIdx(t3, e2);
            for (var a2 = 0, u2 = 0; u2 < o2.length; u2++) {
              var c2 = t3.substr(o2[u2], 2);
              if ("number" == typeof i2 && !s2.isContextTag(c2) && a2 == i2 || "string" == typeof i2 && s2.isContextTag(c2, i2)) return s2.getIdxbyListEx(t3, o2[u2], r3, n3);
              s2.isContextTag(c2) || a2++;
            }
            return -1;
          }, Fr.getTLVbyList = function(t3, e2, r3, n3) {
            var i2 = Fr, o2 = i2.getIdxbyList(t3, e2, r3, n3);
            return -1 == o2 || o2 >= t3.length ? null : i2.getTLV(t3, o2);
          }, Fr.getTLVbyListEx = function(t3, e2, r3, n3) {
            var i2 = Fr, o2 = i2.getIdxbyListEx(t3, e2, r3, n3);
            return -1 == o2 ? null : i2.getTLV(t3, o2);
          }, Fr.getVbyList = function(t3, e2, r3, n3, i2) {
            var o2, s2, a2 = Fr;
            return -1 == (o2 = a2.getIdxbyList(t3, e2, r3, n3)) || o2 >= t3.length ? null : (s2 = a2.getV(t3, o2), true === i2 && (s2 = s2.substr(2)), s2);
          }, Fr.getVbyListEx = function(t3, e2, r3, n3, i2) {
            var o2, s2, a2 = Fr;
            return -1 == (o2 = a2.getIdxbyListEx(t3, e2, r3, n3)) ? null : (s2 = a2.getV(t3, o2), "03" == t3.substr(o2, 2) && false !== i2 && (s2 = s2.substr(2)), s2);
          }, Fr.getInt = function(t3, e2, r3) {
            null == r3 && (r3 = -1);
            try {
              var n3 = t3.substr(e2, 2);
              if ("02" != n3 && "03" != n3) return r3;
              var i2 = Fr.getV(t3, e2);
              return "02" == n3 ? parseInt(i2, 16) : function o2(t4) {
                try {
                  var e3 = t4.substr(0, 2);
                  if ("00" == e3) return parseInt(t4.substr(2), 16);
                  var r4 = parseInt(e3, 16), n4 = t4.substr(2), i3 = parseInt(n4, 16).toString(2);
                  return "0" == i3 && (i3 = "00000000"), i3 = i3.slice(0, 0 - r4), parseInt(i3, 2);
                } catch (t5) {
                  return -1;
                }
              }(i2);
            } catch (t4) {
              return r3;
            }
          }, Fr.getOID = function(t3, e2, r3) {
            null == r3 && (r3 = null);
            try {
              return "06" != t3.substr(e2, 2) ? r3 : function n3(t4) {
                if (!Xr(t4)) return null;
                try {
                  var e3 = [], r4 = t4.substr(0, 2), n4 = parseInt(r4, 16);
                  e3[0] = new String(Math.floor(n4 / 40)), e3[1] = new String(n4 % 40);
                  for (var i2 = t4.substr(2), o2 = [], s2 = 0; s2 < i2.length / 2; s2++) o2.push(parseInt(i2.substr(2 * s2, 2), 16));
                  var a2 = [], u2 = "";
                  for (s2 = 0; s2 < o2.length; s2++) 128 & o2[s2] ? u2 += Qr((127 & o2[s2]).toString(2), 7) : (u2 += Qr((127 & o2[s2]).toString(2), 7), a2.push(new String(parseInt(u2, 2))), u2 = "");
                  var c2 = e3.join(".");
                  return a2.length > 0 && (c2 = c2 + "." + a2.join(".")), c2;
                } catch (t5) {
                  return null;
                }
              }(Fr.getV(t3, e2));
            } catch (t4) {
              return r3;
            }
          }, Fr.getOIDName = function(t3, e2, r3) {
            null == r3 && (r3 = null);
            try {
              var n3 = Fr.getOID(t3, e2, r3);
              if (n3 == r3) return r3;
              var i2 = Sr.asn1.x509.OID.oid2name(n3);
              return "" == i2 ? n3 : i2;
            } catch (t4) {
              return r3;
            }
          }, Fr.getString = function(t3, e2, r3) {
            null == r3 && (r3 = null);
            try {
              return Lr(Fr.getV(t3, e2));
            } catch (t4) {
              return r3;
            }
          }, Fr.hextooidstr = function(t3) {
            var e2 = function t4(e3, r4) {
              return e3.length >= r4 ? e3 : new Array(r4 - e3.length + 1).join("0") + e3;
            }, r3 = [], n3 = t3.substr(0, 2), i2 = parseInt(n3, 16);
            r3[0] = new String(Math.floor(i2 / 40)), r3[1] = new String(i2 % 40);
            for (var o2 = t3.substr(2), s2 = [], a2 = 0; a2 < o2.length / 2; a2++) s2.push(parseInt(o2.substr(2 * a2, 2), 16));
            var u2 = [], c2 = "";
            for (a2 = 0; a2 < s2.length; a2++) 128 & s2[a2] ? c2 += e2((127 & s2[a2]).toString(2), 7) : (c2 += e2((127 & s2[a2]).toString(2), 7), u2.push(new String(parseInt(c2, 2))), c2 = "");
            var h2 = r3.join(".");
            return u2.length > 0 && (h2 = h2 + "." + u2.join(".")), h2;
          }, Fr.dump = function(t3, e2, r3, n3) {
            var i2 = Fr, o2 = i2.getV, s2 = i2.dump, a2 = i2.getChildIdx, u2 = t3;
            t3 instanceof Sr.asn1.ASN1Object && (u2 = t3.getEncodedHex());
            var c2 = function t4(e3, r4) {
              return e3.length <= 2 * r4 ? e3 : e3.substr(0, r4) + "..(total " + e3.length / 2 + "bytes).." + e3.substr(e3.length - r4, r4);
            };
            void 0 === e2 && (e2 = { ommit_long_octet: 32 }), void 0 === r3 && (r3 = 0), void 0 === n3 && (n3 = "");
            var h2, l2 = e2.ommit_long_octet;
            if ("01" == (h2 = u2.substr(r3, 2))) return "00" == (f2 = o2(u2, r3)) ? n3 + "BOOLEAN FALSE\n" : n3 + "BOOLEAN TRUE\n";
            if ("02" == h2) return n3 + "INTEGER " + c2(f2 = o2(u2, r3), l2) + "\n";
            if ("03" == h2) {
              var f2 = o2(u2, r3);
              if (i2.isASN1HEX(f2.substr(2))) {
                var g2 = n3 + "BITSTRING, encapsulates\n";
                return g2 += s2(f2.substr(2), e2, 0, n3 + "  ");
              }
              return n3 + "BITSTRING " + c2(f2, l2) + "\n";
            }
            if ("04" == h2) {
              f2 = o2(u2, r3);
              if (i2.isASN1HEX(f2)) {
                g2 = n3 + "OCTETSTRING, encapsulates\n";
                return g2 += s2(f2, e2, 0, n3 + "  ");
              }
              return n3 + "OCTETSTRING " + c2(f2, l2) + "\n";
            }
            if ("05" == h2) return n3 + "NULL\n";
            if ("06" == h2) {
              var d2 = o2(u2, r3), p2 = Sr.asn1.ASN1Util.oidHexToInt(d2), v3 = Sr.asn1.x509.OID.oid2name(p2), y2 = p2.replace(/\./g, " ");
              return "" != v3 ? n3 + "ObjectIdentifier " + v3 + " (" + y2 + ")\n" : n3 + "ObjectIdentifier (" + y2 + ")\n";
            }
            if ("0a" == h2) return n3 + "ENUMERATED " + parseInt(o2(u2, r3)) + "\n";
            if ("0c" == h2) return n3 + "UTF8String '" + Dr(o2(u2, r3)) + "'\n";
            if ("13" == h2) return n3 + "PrintableString '" + Dr(o2(u2, r3)) + "'\n";
            if ("14" == h2) return n3 + "TeletexString '" + Dr(o2(u2, r3)) + "'\n";
            if ("16" == h2) return n3 + "IA5String '" + Dr(o2(u2, r3)) + "'\n";
            if ("17" == h2) return n3 + "UTCTime " + Dr(o2(u2, r3)) + "\n";
            if ("18" == h2) return n3 + "GeneralizedTime " + Dr(o2(u2, r3)) + "\n";
            if ("1a" == h2) return n3 + "VisualString '" + Dr(o2(u2, r3)) + "'\n";
            if ("1e" == h2) return n3 + "BMPString '" + Yr(o2(u2, r3)) + "'\n";
            if ("30" == h2) {
              if ("3000" == u2.substr(r3, 4)) return n3 + "SEQUENCE {}\n";
              g2 = n3 + "SEQUENCE\n";
              var m2 = e2;
              if ((2 == (b2 = a2(u2, r3)).length || 3 == b2.length) && "06" == u2.substr(b2[0], 2) && "04" == u2.substr(b2[b2.length - 1], 2)) {
                v3 = i2.oidname(o2(u2, b2[0]));
                var _2 = JSON.parse(JSON.stringify(e2));
                _2.x509ExtName = v3, m2 = _2;
              }
              for (var S2 = 0; S2 < b2.length; S2++) g2 += s2(u2, m2, b2[S2], n3 + "  ");
              return g2;
            }
            if ("31" == h2) {
              g2 = n3 + "SET\n";
              var b2 = a2(u2, r3);
              for (S2 = 0; S2 < b2.length; S2++) g2 += s2(u2, e2, b2[S2], n3 + "  ");
              return g2;
            }
            if (0 != (128 & (h2 = parseInt(h2, 16)))) {
              var w2 = 31 & h2;
              if (0 != (32 & h2)) {
                for (g2 = n3 + "[" + w2 + "]\n", b2 = a2(u2, r3), S2 = 0; S2 < b2.length; S2++) g2 += s2(u2, e2, b2[S2], n3 + "  ");
                return g2;
              }
              f2 = o2(u2, r3);
              if (Fr.isASN1HEX(f2)) {
                var g2 = n3 + "[" + w2 + "]\n";
                return g2 += s2(f2, e2, 0, n3 + "  ");
              }
              return ("68747470" == f2.substr(0, 8) || "subjectAltName" === e2.x509ExtName && 2 == w2) && (f2 = Dr(f2)), g2 = n3 + "[" + w2 + "] " + f2 + "\n";
            }
            return n3 + "UNKNOWN(" + h2 + ") " + o2(u2, r3) + "\n";
          }, Fr.isContextTag = function(t3, e2) {
            var r3, n3;
            t3 = t3.toLowerCase();
            try {
              r3 = parseInt(t3, 16);
            } catch (t4) {
              return -1;
            }
            if (void 0 === e2) return 128 == (192 & r3);
            try {
              return null != e2.match(/^\[[0-9]+\]$/) && (!((n3 = parseInt(e2.substr(1, e2.length - 1), 10)) > 31) && (128 == (192 & r3) && (31 & r3) == n3));
            } catch (t4) {
              return false;
            }
          }, Fr.isASN1HEX = function(t3) {
            var e2 = Fr;
            if (t3.length % 2 == 1) return false;
            var r3 = e2.getVblen(t3, 0), n3 = t3.substr(0, 2), i2 = e2.getL(t3, 0);
            return t3.length - n3.length - i2.length == 2 * r3;
          }, Fr.checkStrictDER = function(t3, e2, r3, n3, i2) {
            var o2 = Fr;
            if (void 0 === r3) {
              if ("string" != typeof t3) throw new Error("not hex string");
              if (t3 = t3.toLowerCase(), !Sr.lang.String.isHex(t3)) throw new Error("not hex string");
              r3 = t3.length, i2 = (n3 = t3.length / 2) < 128 ? 1 : Math.ceil(n3.toString(16)) + 1;
            }
            if (o2.getL(t3, e2).length > 2 * i2) throw new Error("L of TLV too long: idx=" + e2);
            var s2 = o2.getVblen(t3, e2);
            if (s2 > n3) throw new Error("value of L too long than hex: idx=" + e2);
            var a2 = o2.getTLV(t3, e2), u2 = a2.length - 2 - o2.getL(t3, e2).length;
            if (u2 !== 2 * s2) throw new Error("V string length and L's value not the same:" + u2 + "/" + 2 * s2);
            if (0 === e2 && t3.length != a2.length) throw new Error("total length and TLV length unmatch:" + t3.length + "!=" + a2.length);
            var c2 = t3.substr(e2, 2);
            if ("02" === c2) {
              var h2 = o2.getVidx(t3, e2);
              if ("00" == t3.substr(h2, 2) && t3.charCodeAt(h2 + 2) < 56) throw new Error("not least zeros for DER INTEGER");
            }
            if (32 & parseInt(c2, 16)) {
              for (var l2 = o2.getVblen(t3, e2), f2 = 0, g2 = o2.getChildIdx(t3, e2), d2 = 0; d2 < g2.length; d2++) {
                f2 += o2.getTLV(t3, g2[d2]).length, o2.checkStrictDER(t3, g2[d2], r3, n3, i2);
              }
              if (2 * l2 != f2) throw new Error("sum of children's TLV length and L unmatch: " + 2 * l2 + "!=" + f2);
            }
          }, Fr.oidname = function(t3) {
            var e2 = Sr.asn1;
            Sr.lang.String.isHex(t3) && (t3 = e2.ASN1Util.oidHexToInt(t3));
            var r3 = e2.x509.OID.oid2name(t3);
            return "" === r3 && (r3 = t3), r3;
          }, void 0 !== Sr && Sr || (e.KJUR = Sr = {}), void 0 !== Sr.lang && Sr.lang || (Sr.lang = {}), Sr.lang.String = function() {
          }, "function" == typeof t2 ? (e.utf8tob64u = br = function e2(r3) {
            return Pr(t2.from(r3, "utf8").toString("base64"));
          }, e.b64utoutf8 = wr = function e2(r3) {
            return t2.from(Cr(r3), "base64").toString("utf8");
          }) : (e.utf8tob64u = br = function t3(e2) {
            return Tr(Kr(Gr(e2)));
          }, e.b64utoutf8 = wr = function t3(e2) {
            return decodeURIComponent(qr(Rr(e2)));
          }), Sr.lang.String.isInteger = function(t3) {
            return !!t3.match(/^[0-9]+$/) || !!t3.match(/^-[0-9]+$/);
          }, Sr.lang.String.isHex = function(t3) {
            return Xr(t3);
          }, Sr.lang.String.isBase64 = function(t3) {
            return !(!(t3 = t3.replace(/\s+/g, "")).match(/^[0-9A-Za-z+\/]+={0,3}$/) || t3.length % 4 != 0);
          }, Sr.lang.String.isBase64URL = function(t3) {
            return !t3.match(/[+/=]/) && (t3 = Cr(t3), Sr.lang.String.isBase64(t3));
          }, Sr.lang.String.isIntegerArray = function(t3) {
            return !!(t3 = t3.replace(/\s+/g, "")).match(/^\[[0-9,]+\]$/);
          }, Sr.lang.String.isPrintable = function(t3) {
            return null !== t3.match(/^[0-9A-Za-z '()+,-./:=?]*$/);
          }, Sr.lang.String.isIA5 = function(t3) {
            return null !== t3.match(/^[\x20-\x21\x23-\x7f]*$/);
          }, Sr.lang.String.isMail = function(t3) {
            return null !== t3.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/);
          };
          var Qr = function t3(e2, r3, n3) {
            return null == n3 && (n3 = "0"), e2.length >= r3 ? e2 : new Array(r3 - e2.length + 1).join(n3) + e2;
          };
          function Zr(t3, e2) {
            var r3 = function t4() {
            };
            r3.prototype = e2.prototype, t3.prototype = new r3(), t3.prototype.constructor = t3, t3.superclass = e2.prototype, e2.prototype.constructor == Object.prototype.constructor && (e2.prototype.constructor = e2);
          }
          void 0 !== Sr && Sr || (e.KJUR = Sr = {}), void 0 !== Sr.crypto && Sr.crypto || (Sr.crypto = {}), Sr.crypto.Util = new function() {
            this.DIGESTINFOHEAD = { sha1: "3021300906052b0e03021a05000414", sha224: "302d300d06096086480165030402040500041c", sha256: "3031300d060960864801650304020105000420", sha384: "3041300d060960864801650304020205000430", sha512: "3051300d060960864801650304020305000440", md2: "3020300c06082a864886f70d020205000410", md5: "3020300c06082a864886f70d020505000410", ripemd160: "3021300906052b2403020105000414" }, this.DEFAULTPROVIDER = { md5: "cryptojs", sha1: "cryptojs", sha224: "cryptojs", sha256: "cryptojs", sha384: "cryptojs", sha512: "cryptojs", ripemd160: "cryptojs", hmacmd5: "cryptojs", hmacsha1: "cryptojs", hmacsha224: "cryptojs", hmacsha256: "cryptojs", hmacsha384: "cryptojs", hmacsha512: "cryptojs", hmacripemd160: "cryptojs", MD5withRSA: "cryptojs/jsrsa", SHA1withRSA: "cryptojs/jsrsa", SHA224withRSA: "cryptojs/jsrsa", SHA256withRSA: "cryptojs/jsrsa", SHA384withRSA: "cryptojs/jsrsa", SHA512withRSA: "cryptojs/jsrsa", RIPEMD160withRSA: "cryptojs/jsrsa", MD5withECDSA: "cryptojs/jsrsa", SHA1withECDSA: "cryptojs/jsrsa", SHA224withECDSA: "cryptojs/jsrsa", SHA256withECDSA: "cryptojs/jsrsa", SHA384withECDSA: "cryptojs/jsrsa", SHA512withECDSA: "cryptojs/jsrsa", RIPEMD160withECDSA: "cryptojs/jsrsa", SHA1withDSA: "cryptojs/jsrsa", SHA224withDSA: "cryptojs/jsrsa", SHA256withDSA: "cryptojs/jsrsa", MD5withRSAandMGF1: "cryptojs/jsrsa", SHAwithRSAandMGF1: "cryptojs/jsrsa", SHA1withRSAandMGF1: "cryptojs/jsrsa", SHA224withRSAandMGF1: "cryptojs/jsrsa", SHA256withRSAandMGF1: "cryptojs/jsrsa", SHA384withRSAandMGF1: "cryptojs/jsrsa", SHA512withRSAandMGF1: "cryptojs/jsrsa", RIPEMD160withRSAandMGF1: "cryptojs/jsrsa" }, this.CRYPTOJSMESSAGEDIGESTNAME = { md5: v2.algo.MD5, sha1: v2.algo.SHA1, sha224: v2.algo.SHA224, sha256: v2.algo.SHA256, sha384: v2.algo.SHA384, sha512: v2.algo.SHA512, ripemd160: v2.algo.RIPEMD160 }, this.getDigestInfoHex = function(t3, e2) {
              if (void 0 === this.DIGESTINFOHEAD[e2]) throw "alg not supported in Util.DIGESTINFOHEAD: " + e2;
              return this.DIGESTINFOHEAD[e2] + t3;
            }, this.getPaddedDigestInfoHex = function(t3, e2, r3) {
              var n3 = this.getDigestInfoHex(t3, e2), i2 = r3 / 4;
              if (n3.length + 22 > i2) throw "key is too short for SigAlg: keylen=" + r3 + "," + e2;
              for (var o2 = "0001", s2 = "00" + n3, a2 = "", u2 = i2 - o2.length - s2.length, c2 = 0; c2 < u2; c2 += 2) a2 += "ff";
              return o2 + a2 + s2;
            }, this.hashString = function(t3, e2) {
              return new Sr.crypto.MessageDigest({ alg: e2 }).digestString(t3);
            }, this.hashHex = function(t3, e2) {
              return new Sr.crypto.MessageDigest({ alg: e2 }).digestHex(t3);
            }, this.sha1 = function(t3) {
              return this.hashString(t3, "sha1");
            }, this.sha256 = function(t3) {
              return this.hashString(t3, "sha256");
            }, this.sha256Hex = function(t3) {
              return this.hashHex(t3, "sha256");
            }, this.sha512 = function(t3) {
              return this.hashString(t3, "sha512");
            }, this.sha512Hex = function(t3) {
              return this.hashHex(t3, "sha512");
            }, this.isKey = function(t3) {
              return t3 instanceof Me2 || t3 instanceof Sr.crypto.DSA || t3 instanceof Sr.crypto.ECDSA;
            };
          }(), Sr.crypto.Util.md5 = function(t3) {
            return new Sr.crypto.MessageDigest({ alg: "md5", prov: "cryptojs" }).digestString(t3);
          }, Sr.crypto.Util.ripemd160 = function(t3) {
            return new Sr.crypto.MessageDigest({ alg: "ripemd160", prov: "cryptojs" }).digestString(t3);
          }, Sr.crypto.Util.SECURERANDOMGEN = new Be(), Sr.crypto.Util.getRandomHexOfNbytes = function(t3) {
            var e2 = new Array(t3);
            return Sr.crypto.Util.SECURERANDOMGEN.nextBytes(e2), Ar(e2);
          }, Sr.crypto.Util.getRandomBigIntegerOfNbytes = function(t3) {
            return new w(Sr.crypto.Util.getRandomHexOfNbytes(t3), 16);
          }, Sr.crypto.Util.getRandomHexOfNbits = function(t3) {
            var e2 = t3 % 8, r3 = new Array((t3 - e2) / 8 + 1);
            return Sr.crypto.Util.SECURERANDOMGEN.nextBytes(r3), r3[0] = (255 << e2 & 255 ^ 255) & r3[0], Ar(r3);
          }, Sr.crypto.Util.getRandomBigIntegerOfNbits = function(t3) {
            return new w(Sr.crypto.Util.getRandomHexOfNbits(t3), 16);
          }, Sr.crypto.Util.getRandomBigIntegerZeroToMax = function(t3) {
            for (var e2 = t3.bitLength(); ; ) {
              var r3 = Sr.crypto.Util.getRandomBigIntegerOfNbits(e2);
              if (-1 != t3.compareTo(r3)) return r3;
            }
          }, Sr.crypto.Util.getRandomBigIntegerMinToMax = function(t3, e2) {
            var r3 = t3.compareTo(e2);
            if (1 == r3) throw "biMin is greater than biMax";
            if (0 == r3) return t3;
            var n3 = e2.subtract(t3);
            return Sr.crypto.Util.getRandomBigIntegerZeroToMax(n3).add(t3);
          }, Sr.crypto.MessageDigest = function(t3) {
            this.setAlgAndProvider = function(t4, e2) {
              if (null !== (t4 = Sr.crypto.MessageDigest.getCanonicalAlgName(t4)) && void 0 === e2 && (e2 = Sr.crypto.Util.DEFAULTPROVIDER[t4]), -1 != ":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(t4) && "cryptojs" == e2) {
                try {
                  this.md = Sr.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[t4].create();
                } catch (e3) {
                  throw "setAlgAndProvider hash alg set fail alg=" + t4 + "/" + e3;
                }
                this.updateString = function(t5) {
                  this.md.update(t5);
                }, this.updateHex = function(t5) {
                  var e3 = v2.enc.Hex.parse(t5);
                  this.md.update(e3);
                }, this.digest = function() {
                  return this.md.finalize().toString(v2.enc.Hex);
                }, this.digestString = function(t5) {
                  return this.updateString(t5), this.digest();
                }, this.digestHex = function(t5) {
                  return this.updateHex(t5), this.digest();
                };
              }
              if (-1 != ":sha256:".indexOf(t4) && "sjcl" == e2) {
                try {
                  this.md = new sjcl.hash.sha256();
                } catch (e3) {
                  throw "setAlgAndProvider hash alg set fail alg=" + t4 + "/" + e3;
                }
                this.updateString = function(t5) {
                  this.md.update(t5);
                }, this.updateHex = function(t5) {
                  var e3 = sjcl.codec.hex.toBits(t5);
                  this.md.update(e3);
                }, this.digest = function() {
                  var t5 = this.md.finalize();
                  return sjcl.codec.hex.fromBits(t5);
                }, this.digestString = function(t5) {
                  return this.updateString(t5), this.digest();
                }, this.digestHex = function(t5) {
                  return this.updateHex(t5), this.digest();
                };
              }
            }, this.updateString = function(t4) {
              throw "updateString(str) not supported for this alg/prov: " + this.algName + "/" + this.provName;
            }, this.updateHex = function(t4) {
              throw "updateHex(hex) not supported for this alg/prov: " + this.algName + "/" + this.provName;
            }, this.digest = function() {
              throw "digest() not supported for this alg/prov: " + this.algName + "/" + this.provName;
            }, this.digestString = function(t4) {
              throw "digestString(str) not supported for this alg/prov: " + this.algName + "/" + this.provName;
            }, this.digestHex = function(t4) {
              throw "digestHex(hex) not supported for this alg/prov: " + this.algName + "/" + this.provName;
            }, void 0 !== t3 && void 0 !== t3.alg && (this.algName = t3.alg, void 0 === t3.prov && (this.provName = Sr.crypto.Util.DEFAULTPROVIDER[this.algName]), this.setAlgAndProvider(this.algName, this.provName));
          }, Sr.crypto.MessageDigest.getCanonicalAlgName = function(t3) {
            return "string" == typeof t3 && (t3 = (t3 = t3.toLowerCase()).replace(/-/, "")), t3;
          }, Sr.crypto.MessageDigest.getHashLength = function(t3) {
            var e2 = Sr.crypto.MessageDigest, r3 = e2.getCanonicalAlgName(t3);
            if (void 0 === e2.HASHLENGTH[r3]) throw "not supported algorithm: " + t3;
            return e2.HASHLENGTH[r3];
          }, Sr.crypto.MessageDigest.HASHLENGTH = { md5: 16, sha1: 20, sha224: 28, sha256: 32, sha384: 48, sha512: 64, ripemd160: 20 }, Sr.crypto.Mac = function(t3) {
            this.setAlgAndProvider = function(t4, e2) {
              if (null == (t4 = t4.toLowerCase()) && (t4 = "hmacsha1"), "hmac" != (t4 = t4.toLowerCase()).substr(0, 4)) throw "setAlgAndProvider unsupported HMAC alg: " + t4;
              void 0 === e2 && (e2 = Sr.crypto.Util.DEFAULTPROVIDER[t4]), this.algProv = t4 + "/" + e2;
              var r3 = t4.substr(4);
              if (-1 != ":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(r3) && "cryptojs" == e2) {
                try {
                  var n3 = Sr.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[r3];
                  this.mac = v2.algo.HMAC.create(n3, this.pass);
                } catch (t5) {
                  throw "setAlgAndProvider hash alg set fail hashAlg=" + r3 + "/" + t5;
                }
                this.updateString = function(t5) {
                  this.mac.update(t5);
                }, this.updateHex = function(t5) {
                  var e3 = v2.enc.Hex.parse(t5);
                  this.mac.update(e3);
                }, this.doFinal = function() {
                  return this.mac.finalize().toString(v2.enc.Hex);
                }, this.doFinalString = function(t5) {
                  return this.updateString(t5), this.doFinal();
                }, this.doFinalHex = function(t5) {
                  return this.updateHex(t5), this.doFinal();
                };
              }
            }, this.updateString = function(t4) {
              throw "updateString(str) not supported for this alg/prov: " + this.algProv;
            }, this.updateHex = function(t4) {
              throw "updateHex(hex) not supported for this alg/prov: " + this.algProv;
            }, this.doFinal = function() {
              throw "digest() not supported for this alg/prov: " + this.algProv;
            }, this.doFinalString = function(t4) {
              throw "digestString(str) not supported for this alg/prov: " + this.algProv;
            }, this.doFinalHex = function(t4) {
              throw "digestHex(hex) not supported for this alg/prov: " + this.algProv;
            }, this.setPassword = function(t4) {
              if ("string" == typeof t4) {
                var e2 = t4;
                return t4.length % 2 != 1 && t4.match(/^[0-9A-Fa-f]+$/) || (e2 = Nr(t4)), void (this.pass = v2.enc.Hex.parse(e2));
              }
              if ("object" != (void 0 === t4 ? "undefined" : g(t4))) throw "KJUR.crypto.Mac unsupported password type: " + t4;
              e2 = null;
              if (void 0 !== t4.hex) {
                if (t4.hex.length % 2 != 0 || !t4.hex.match(/^[0-9A-Fa-f]+$/)) throw "Mac: wrong hex password: " + t4.hex;
                e2 = t4.hex;
              }
              if (void 0 !== t4.utf8 && (e2 = Ir(t4.utf8)), void 0 !== t4.rstr && (e2 = Nr(t4.rstr)), void 0 !== t4.b64 && (e2 = S(t4.b64)), void 0 !== t4.b64u && (e2 = Rr(t4.b64u)), null == e2) throw "KJUR.crypto.Mac unsupported password type: " + t4;
              this.pass = v2.enc.Hex.parse(e2);
            }, void 0 !== t3 && (void 0 !== t3.pass && this.setPassword(t3.pass), void 0 !== t3.alg && (this.algName = t3.alg, void 0 === t3.prov && (this.provName = Sr.crypto.Util.DEFAULTPROVIDER[this.algName]), this.setAlgAndProvider(this.algName, this.provName)));
          }, Sr.crypto.Signature = function(t3) {
            var e2 = null;
            if (this._setAlgNames = function() {
              var t4 = this.algName.match(/^(.+)with(.+)$/);
              t4 && (this.mdAlgName = t4[1].toLowerCase(), this.pubkeyAlgName = t4[2].toLowerCase(), "rsaandmgf1" == this.pubkeyAlgName && "sha" == this.mdAlgName && (this.mdAlgName = "sha1"));
            }, this._zeroPaddingOfSignature = function(t4, e3) {
              for (var r3 = "", n3 = e3 / 4 - t4.length, i2 = 0; i2 < n3; i2++) r3 += "0";
              return r3 + t4;
            }, this.setAlgAndProvider = function(t4, e3) {
              if (this._setAlgNames(), "cryptojs/jsrsa" != e3) throw new Error("provider not supported: " + e3);
              if (-1 != ":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(this.mdAlgName)) {
                try {
                  this.md = new Sr.crypto.MessageDigest({ alg: this.mdAlgName });
                } catch (t5) {
                  throw new Error("setAlgAndProvider hash alg set fail alg=" + this.mdAlgName + "/" + t5);
                }
                this.init = function(t5, e4) {
                  var r3 = null;
                  try {
                    r3 = void 0 === e4 ? tn.getKey(t5) : tn.getKey(t5, e4);
                  } catch (t6) {
                    throw "init failed:" + t6;
                  }
                  if (true === r3.isPrivate) this.prvKey = r3, this.state = "SIGN";
                  else {
                    if (true !== r3.isPublic) throw "init failed.:" + r3;
                    this.pubKey = r3, this.state = "VERIFY";
                  }
                }, this.updateString = function(t5) {
                  this.md.updateString(t5);
                }, this.updateHex = function(t5) {
                  this.md.updateHex(t5);
                }, this.sign = function() {
                  if (this.sHashHex = this.md.digest(), void 0 === this.prvKey && void 0 !== this.ecprvhex && void 0 !== this.eccurvename && void 0 !== Sr.crypto.ECDSA && (this.prvKey = new Sr.crypto.ECDSA({ curve: this.eccurvename, prv: this.ecprvhex })), this.prvKey instanceof Me2 && "rsaandmgf1" === this.pubkeyAlgName) this.hSign = this.prvKey.signWithMessageHashPSS(this.sHashHex, this.mdAlgName, this.pssSaltLen);
                  else if (this.prvKey instanceof Me2 && "rsa" === this.pubkeyAlgName) this.hSign = this.prvKey.signWithMessageHash(this.sHashHex, this.mdAlgName);
                  else if (this.prvKey instanceof Sr.crypto.ECDSA) this.hSign = this.prvKey.signWithMessageHash(this.sHashHex);
                  else {
                    if (!(this.prvKey instanceof Sr.crypto.DSA)) throw "Signature: unsupported private key alg: " + this.pubkeyAlgName;
                    this.hSign = this.prvKey.signWithMessageHash(this.sHashHex);
                  }
                  return this.hSign;
                }, this.signString = function(t5) {
                  return this.updateString(t5), this.sign();
                }, this.signHex = function(t5) {
                  return this.updateHex(t5), this.sign();
                }, this.verify = function(t5) {
                  if (this.sHashHex = this.md.digest(), void 0 === this.pubKey && void 0 !== this.ecpubhex && void 0 !== this.eccurvename && void 0 !== Sr.crypto.ECDSA && (this.pubKey = new Sr.crypto.ECDSA({ curve: this.eccurvename, pub: this.ecpubhex })), this.pubKey instanceof Me2 && "rsaandmgf1" === this.pubkeyAlgName) return this.pubKey.verifyWithMessageHashPSS(this.sHashHex, t5, this.mdAlgName, this.pssSaltLen);
                  if (this.pubKey instanceof Me2 && "rsa" === this.pubkeyAlgName) return this.pubKey.verifyWithMessageHash(this.sHashHex, t5);
                  if (void 0 !== Sr.crypto.ECDSA && this.pubKey instanceof Sr.crypto.ECDSA) return this.pubKey.verifyWithMessageHash(this.sHashHex, t5);
                  if (void 0 !== Sr.crypto.DSA && this.pubKey instanceof Sr.crypto.DSA) return this.pubKey.verifyWithMessageHash(this.sHashHex, t5);
                  throw "Signature: unsupported public key alg: " + this.pubkeyAlgName;
                };
              }
            }, this.init = function(t4, e3) {
              throw "init(key, pass) not supported for this alg:prov=" + this.algProvName;
            }, this.updateString = function(t4) {
              throw "updateString(str) not supported for this alg:prov=" + this.algProvName;
            }, this.updateHex = function(t4) {
              throw "updateHex(hex) not supported for this alg:prov=" + this.algProvName;
            }, this.sign = function() {
              throw "sign() not supported for this alg:prov=" + this.algProvName;
            }, this.signString = function(t4) {
              throw "digestString(str) not supported for this alg:prov=" + this.algProvName;
            }, this.signHex = function(t4) {
              throw "digestHex(hex) not supported for this alg:prov=" + this.algProvName;
            }, this.verify = function(t4) {
              throw "verify(hSigVal) not supported for this alg:prov=" + this.algProvName;
            }, this.initParams = t3, void 0 !== t3 && (void 0 !== t3.alg && (this.algName = t3.alg, void 0 === t3.prov ? this.provName = Sr.crypto.Util.DEFAULTPROVIDER[this.algName] : this.provName = t3.prov, this.algProvName = this.algName + ":" + this.provName, this.setAlgAndProvider(this.algName, this.provName), this._setAlgNames()), void 0 !== t3.psssaltlen && (this.pssSaltLen = t3.psssaltlen), void 0 !== t3.prvkeypem)) {
              if (void 0 !== t3.prvkeypas) throw "both prvkeypem and prvkeypas parameters not supported";
              try {
                e2 = tn.getKey(t3.prvkeypem);
                this.init(e2);
              } catch (t4) {
                throw "fatal error to load pem private key: " + t4;
              }
            }
          }, Sr.crypto.Cipher = function(t3) {
          }, Sr.crypto.Cipher.encrypt = function(t3, e2, r3) {
            if (e2 instanceof Me2 && e2.isPublic) {
              var n3 = Sr.crypto.Cipher.getAlgByKeyAndName(e2, r3);
              if ("RSA" === n3) return e2.encrypt(t3);
              if ("RSAOAEP" === n3) return e2.encryptOAEP(t3, "sha1");
              var i2 = n3.match(/^RSAOAEP(\d+)$/);
              if (null !== i2) return e2.encryptOAEP(t3, "sha" + i2[1]);
              throw "Cipher.encrypt: unsupported algorithm for RSAKey: " + r3;
            }
            throw "Cipher.encrypt: unsupported key or algorithm";
          }, Sr.crypto.Cipher.decrypt = function(t3, e2, r3) {
            if (e2 instanceof Me2 && e2.isPrivate) {
              var n3 = Sr.crypto.Cipher.getAlgByKeyAndName(e2, r3);
              if ("RSA" === n3) return e2.decrypt(t3);
              if ("RSAOAEP" === n3) return e2.decryptOAEP(t3, "sha1");
              var i2 = n3.match(/^RSAOAEP(\d+)$/);
              if (null !== i2) return e2.decryptOAEP(t3, "sha" + i2[1]);
              throw "Cipher.decrypt: unsupported algorithm for RSAKey: " + r3;
            }
            throw "Cipher.decrypt: unsupported key or algorithm";
          }, Sr.crypto.Cipher.getAlgByKeyAndName = function(t3, e2) {
            if (t3 instanceof Me2) {
              if (-1 != ":RSA:RSAOAEP:RSAOAEP224:RSAOAEP256:RSAOAEP384:RSAOAEP512:".indexOf(e2)) return e2;
              if (null == e2) return "RSA";
              throw "getAlgByKeyAndName: not supported algorithm name for RSAKey: " + e2;
            }
            throw "getAlgByKeyAndName: not supported algorithm name: " + e2;
          }, Sr.crypto.OID = new function() {
            this.oidhex2name = { "2a864886f70d010101": "rsaEncryption", "2a8648ce3d0201": "ecPublicKey", "2a8648ce380401": "dsa", "2a8648ce3d030107": "secp256r1", "2b8104001f": "secp192k1", "2b81040021": "secp224r1", "2b8104000a": "secp256k1", "2b81040023": "secp521r1", "2b81040022": "secp384r1", "2a8648ce380403": "SHA1withDSA", "608648016503040301": "SHA224withDSA", "608648016503040302": "SHA256withDSA" };
          }(), void 0 !== Sr && Sr || (e.KJUR = Sr = {}), void 0 !== Sr.crypto && Sr.crypto || (Sr.crypto = {}), Sr.crypto.ECDSA = function(t3) {
            var e2 = Error, r3 = w, n3 = Ve, i2 = Sr.crypto.ECDSA, o2 = Sr.crypto.ECParameterDB, s2 = i2.getName, a2 = Fr, u2 = a2.getVbyListEx, c2 = a2.isASN1HEX, h2 = new Be();
            this.type = "EC", this.isPrivate = false, this.isPublic = false, this.getBigRandom = function(t4) {
              return new r3(t4.bitLength(), h2).mod(t4.subtract(r3.ONE)).add(r3.ONE);
            }, this.setNamedCurve = function(t4) {
              this.ecparams = o2.getByName(t4), this.prvKeyHex = null, this.pubKeyHex = null, this.curveName = t4;
            }, this.setPrivateKeyHex = function(t4) {
              this.isPrivate = true, this.prvKeyHex = t4;
            }, this.setPublicKeyHex = function(t4) {
              this.isPublic = true, this.pubKeyHex = t4;
            }, this.getPublicKeyXYHex = function() {
              var t4 = this.pubKeyHex;
              if ("04" !== t4.substr(0, 2)) throw "this method supports uncompressed format(04) only";
              var e3 = this.ecparams.keylen / 4;
              if (t4.length !== 2 + 2 * e3) throw "malformed public key hex length";
              var r4 = {};
              return r4.x = t4.substr(2, e3), r4.y = t4.substr(2 + e3), r4;
            }, this.getShortNISTPCurveName = function() {
              var t4 = this.curveName;
              return "secp256r1" === t4 || "NIST P-256" === t4 || "P-256" === t4 || "prime256v1" === t4 ? "P-256" : "secp384r1" === t4 || "NIST P-384" === t4 || "P-384" === t4 ? "P-384" : null;
            }, this.generateKeyPairHex = function() {
              var t4 = this.ecparams.n, e3 = this.getBigRandom(t4), r4 = this.ecparams.G.multiply(e3), n4 = r4.getX().toBigInteger(), i3 = r4.getY().toBigInteger(), o3 = this.ecparams.keylen / 4, s3 = ("0000000000" + e3.toString(16)).slice(-o3), a3 = "04" + ("0000000000" + n4.toString(16)).slice(-o3) + ("0000000000" + i3.toString(16)).slice(-o3);
              return this.setPrivateKeyHex(s3), this.setPublicKeyHex(a3), { ecprvhex: s3, ecpubhex: a3 };
            }, this.signWithMessageHash = function(t4) {
              return this.signHex(t4, this.prvKeyHex);
            }, this.signHex = function(t4, e3) {
              var n4 = new r3(e3, 16), o3 = this.ecparams.n, s3 = new r3(t4.substring(0, this.ecparams.keylen / 4), 16);
              do {
                var a3 = this.getBigRandom(o3), u3 = this.ecparams.G.multiply(a3).getX().toBigInteger().mod(o3);
              } while (u3.compareTo(r3.ZERO) <= 0);
              var c3 = a3.modInverse(o3).multiply(s3.add(n4.multiply(u3))).mod(o3);
              return i2.biRSSigToASN1Sig(u3, c3);
            }, this.sign = function(t4, e3) {
              var n4 = e3, i3 = this.ecparams.n, o3 = r3.fromByteArrayUnsigned(t4);
              do {
                var s3 = this.getBigRandom(i3), a3 = this.ecparams.G.multiply(s3).getX().toBigInteger().mod(i3);
              } while (a3.compareTo(w.ZERO) <= 0);
              var u3 = s3.modInverse(i3).multiply(o3.add(n4.multiply(a3))).mod(i3);
              return this.serializeSig(a3, u3);
            }, this.verifyWithMessageHash = function(t4, e3) {
              return this.verifyHex(t4, e3, this.pubKeyHex);
            }, this.verifyHex = function(t4, e3, o3) {
              try {
                var s3, a3, u3 = i2.parseSigHex(e3);
                s3 = u3.r, a3 = u3.s;
                var c3 = n3.decodeFromHex(this.ecparams.curve, o3), h3 = new r3(t4.substring(0, this.ecparams.keylen / 4), 16);
                return this.verifyRaw(h3, s3, a3, c3);
              } catch (t5) {
                return false;
              }
            }, this.verify = function(t4, e3, i3) {
              var o3, s3, a3;
              if (Bitcoin.Util.isArray(e3)) {
                var u3 = this.parseSig(e3);
                o3 = u3.r, s3 = u3.s;
              } else {
                if ("object" !== (void 0 === e3 ? "undefined" : g(e3)) || !e3.r || !e3.s) throw "Invalid value for signature";
                o3 = e3.r, s3 = e3.s;
              }
              if (i3 instanceof Ve) a3 = i3;
              else {
                if (!Bitcoin.Util.isArray(i3)) throw "Invalid format for pubkey value, must be byte array or ECPointFp";
                a3 = n3.decodeFrom(this.ecparams.curve, i3);
              }
              var c3 = r3.fromByteArrayUnsigned(t4);
              return this.verifyRaw(c3, o3, s3, a3);
            }, this.verifyRaw = function(t4, e3, n4, i3) {
              var o3 = this.ecparams.n, s3 = this.ecparams.G;
              if (e3.compareTo(r3.ONE) < 0 || e3.compareTo(o3) >= 0) return false;
              if (n4.compareTo(r3.ONE) < 0 || n4.compareTo(o3) >= 0) return false;
              var a3 = n4.modInverse(o3), u3 = t4.multiply(a3).mod(o3), c3 = e3.multiply(a3).mod(o3);
              return s3.multiply(u3).add(i3.multiply(c3)).getX().toBigInteger().mod(o3).equals(e3);
            }, this.serializeSig = function(t4, e3) {
              var r4 = t4.toByteArraySigned(), n4 = e3.toByteArraySigned(), i3 = [];
              return i3.push(2), i3.push(r4.length), (i3 = i3.concat(r4)).push(2), i3.push(n4.length), (i3 = i3.concat(n4)).unshift(i3.length), i3.unshift(48), i3;
            }, this.parseSig = function(t4) {
              var e3;
              if (48 != t4[0]) throw new Error("Signature not a valid DERSequence");
              if (2 != t4[e3 = 2]) throw new Error("First element in signature must be a DERInteger");
              var n4 = t4.slice(e3 + 2, e3 + 2 + t4[e3 + 1]);
              if (2 != t4[e3 += 2 + t4[e3 + 1]]) throw new Error("Second element in signature must be a DERInteger");
              var i3 = t4.slice(e3 + 2, e3 + 2 + t4[e3 + 1]);
              return e3 += 2 + t4[e3 + 1], { r: r3.fromByteArrayUnsigned(n4), s: r3.fromByteArrayUnsigned(i3) };
            }, this.parseSigCompact = function(t4) {
              if (65 !== t4.length) throw "Signature has the wrong length";
              var e3 = t4[0] - 27;
              if (e3 < 0 || e3 > 7) throw "Invalid signature type";
              var n4 = this.ecparams.n;
              return { r: r3.fromByteArrayUnsigned(t4.slice(1, 33)).mod(n4), s: r3.fromByteArrayUnsigned(t4.slice(33, 65)).mod(n4), i: e3 };
            }, this.readPKCS5PrvKeyHex = function(t4) {
              if (false === c2(t4)) throw new Error("not ASN.1 hex string");
              var e3, r4, n4;
              try {
                e3 = u2(t4, 0, ["[0]", 0], "06"), r4 = u2(t4, 0, [1], "04");
                try {
                  n4 = u2(t4, 0, ["[1]", 0], "03");
                } catch (t5) {
                }
              } catch (t5) {
                throw new Error("malformed PKCS#1/5 plain ECC private key");
              }
              if (this.curveName = s2(e3), void 0 === this.curveName) throw "unsupported curve name";
              this.setNamedCurve(this.curveName), this.setPublicKeyHex(n4), this.setPrivateKeyHex(r4), this.isPublic = false;
            }, this.readPKCS8PrvKeyHex = function(t4) {
              if (false === c2(t4)) throw new e2("not ASN.1 hex string");
              var r4, n4, i3;
              try {
                u2(t4, 0, [1, 0], "06"), r4 = u2(t4, 0, [1, 1], "06"), n4 = u2(t4, 0, [2, 0, 1], "04");
                try {
                  i3 = u2(t4, 0, [2, 0, "[1]", 0], "03");
                } catch (t5) {
                }
              } catch (t5) {
                throw new e2("malformed PKCS#8 plain ECC private key");
              }
              if (this.curveName = s2(r4), void 0 === this.curveName) throw new e2("unsupported curve name");
              this.setNamedCurve(this.curveName), this.setPublicKeyHex(i3), this.setPrivateKeyHex(n4), this.isPublic = false;
            }, this.readPKCS8PubKeyHex = function(t4) {
              if (false === c2(t4)) throw new e2("not ASN.1 hex string");
              var r4, n4;
              try {
                u2(t4, 0, [0, 0], "06"), r4 = u2(t4, 0, [0, 1], "06"), n4 = u2(t4, 0, [1], "03");
              } catch (t5) {
                throw new e2("malformed PKCS#8 ECC public key");
              }
              if (this.curveName = s2(r4), null === this.curveName) throw new e2("unsupported curve name");
              this.setNamedCurve(this.curveName), this.setPublicKeyHex(n4);
            }, this.readCertPubKeyHex = function(t4, r4) {
              if (false === c2(t4)) throw new e2("not ASN.1 hex string");
              var n4, i3;
              try {
                n4 = u2(t4, 0, [0, 5, 0, 1], "06"), i3 = u2(t4, 0, [0, 5, 1], "03");
              } catch (t5) {
                throw new e2("malformed X.509 certificate ECC public key");
              }
              if (this.curveName = s2(n4), null === this.curveName) throw new e2("unsupported curve name");
              this.setNamedCurve(this.curveName), this.setPublicKeyHex(i3);
            }, void 0 !== t3 && void 0 !== t3.curve && (this.curveName = t3.curve), void 0 === this.curveName && (this.curveName = "secp256r1"), this.setNamedCurve(this.curveName), void 0 !== t3 && (void 0 !== t3.prv && this.setPrivateKeyHex(t3.prv), void 0 !== t3.pub && this.setPublicKeyHex(t3.pub));
          }, Sr.crypto.ECDSA.parseSigHex = function(t3) {
            var e2 = Sr.crypto.ECDSA.parseSigHexInHexRS(t3);
            return { r: new w(e2.r, 16), s: new w(e2.s, 16) };
          }, Sr.crypto.ECDSA.parseSigHexInHexRS = function(t3) {
            var e2 = Fr, r3 = e2.getChildIdx, n3 = e2.getV;
            if (e2.checkStrictDER(t3, 0), "30" != t3.substr(0, 2)) throw new Error("signature is not a ASN.1 sequence");
            var i2 = r3(t3, 0);
            if (2 != i2.length) throw new Error("signature shall have two elements");
            var o2 = i2[0], s2 = i2[1];
            if ("02" != t3.substr(o2, 2)) throw new Error("1st item not ASN.1 integer");
            if ("02" != t3.substr(s2, 2)) throw new Error("2nd item not ASN.1 integer");
            return { r: n3(t3, o2), s: n3(t3, s2) };
          }, Sr.crypto.ECDSA.asn1SigToConcatSig = function(t3) {
            var e2 = Sr.crypto.ECDSA.parseSigHexInHexRS(t3), r3 = e2.r, n3 = e2.s;
            if ("00" == r3.substr(0, 2) && r3.length % 32 == 2 && (r3 = r3.substr(2)), "00" == n3.substr(0, 2) && n3.length % 32 == 2 && (n3 = n3.substr(2)), r3.length % 32 == 30 && (r3 = "00" + r3), n3.length % 32 == 30 && (n3 = "00" + n3), r3.length % 32 != 0) throw "unknown ECDSA sig r length error";
            if (n3.length % 32 != 0) throw "unknown ECDSA sig s length error";
            return r3 + n3;
          }, Sr.crypto.ECDSA.concatSigToASN1Sig = function(t3) {
            if (t3.length / 2 * 8 % 128 != 0) throw "unknown ECDSA concatinated r-s sig  length error";
            var e2 = t3.substr(0, t3.length / 2), r3 = t3.substr(t3.length / 2);
            return Sr.crypto.ECDSA.hexRSSigToASN1Sig(e2, r3);
          }, Sr.crypto.ECDSA.hexRSSigToASN1Sig = function(t3, e2) {
            var r3 = new w(t3, 16), n3 = new w(e2, 16);
            return Sr.crypto.ECDSA.biRSSigToASN1Sig(r3, n3);
          }, Sr.crypto.ECDSA.biRSSigToASN1Sig = function(t3, e2) {
            var r3 = Sr.asn1, n3 = new r3.DERInteger({ bigint: t3 }), i2 = new r3.DERInteger({ bigint: e2 });
            return new r3.DERSequence({ array: [n3, i2] }).getEncodedHex();
          }, Sr.crypto.ECDSA.getName = function(t3) {
            return "2b8104001f" === t3 ? "secp192k1" : "2a8648ce3d030107" === t3 ? "secp256r1" : "2b8104000a" === t3 ? "secp256k1" : "2b81040021" === t3 ? "secp224r1" : "2b81040022" === t3 ? "secp384r1" : -1 !== "|secp256r1|NIST P-256|P-256|prime256v1|".indexOf(t3) ? "secp256r1" : -1 !== "|secp256k1|".indexOf(t3) ? "secp256k1" : -1 !== "|secp224r1|NIST P-224|P-224|".indexOf(t3) ? "secp224r1" : -1 !== "|secp384r1|NIST P-384|P-384|".indexOf(t3) ? "secp384r1" : null;
          }, void 0 !== Sr && Sr || (e.KJUR = Sr = {}), void 0 !== Sr.crypto && Sr.crypto || (Sr.crypto = {}), Sr.crypto.ECParameterDB = new function() {
            var t3 = {}, e2 = {};
            function r3(t4) {
              return new w(t4, 16);
            }
            this.getByName = function(r4) {
              var n3 = r4;
              if (void 0 !== e2[n3] && (n3 = e2[r4]), void 0 !== t3[n3]) return t3[n3];
              throw "unregistered EC curve name: " + n3;
            }, this.regist = function(n3, i2, o2, s2, a2, u2, c2, h2, l2, f2, g2, d2) {
              t3[n3] = {};
              var p2 = r3(o2), v3 = r3(s2), y2 = r3(a2), m2 = r3(u2), _2 = r3(c2), S2 = new Ke(p2, v3, y2), b2 = S2.decodePointHex("04" + h2 + l2);
              t3[n3].name = n3, t3[n3].keylen = i2, t3[n3].curve = S2, t3[n3].G = b2, t3[n3].n = m2, t3[n3].h = _2, t3[n3].oid = g2, t3[n3].info = d2;
              for (var w2 = 0; w2 < f2.length; w2++) e2[f2[w2]] = n3;
            };
          }(), Sr.crypto.ECParameterDB.regist("secp128r1", 128, "FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFF", "FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFC", "E87579C11079F43DD824993C2CEE5ED3", "FFFFFFFE0000000075A30D1B9038A115", "1", "161FF7528B899B2D0C28607CA52C5B86", "CF5AC8395BAFEB13C02DA292DDED7A83", [], "", "secp128r1 : SECG curve over a 128 bit prime field"), Sr.crypto.ECParameterDB.regist("secp160k1", 160, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFAC73", "0", "7", "0100000000000000000001B8FA16DFAB9ACA16B6B3", "1", "3B4C382CE37AA192A4019E763036F4F5DD4D7EBB", "938CF935318FDCED6BC28286531733C3F03C4FEE", [], "", "secp160k1 : SECG curve over a 160 bit prime field"), Sr.crypto.ECParameterDB.regist("secp160r1", 160, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFC", "1C97BEFC54BD7A8B65ACF89F81D4D4ADC565FA45", "0100000000000000000001F4C8F927AED3CA752257", "1", "4A96B5688EF573284664698968C38BB913CBFC82", "23A628553168947D59DCC912042351377AC5FB32", [], "", "secp160r1 : SECG curve over a 160 bit prime field"), Sr.crypto.ECParameterDB.regist("secp192k1", 192, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFEE37", "0", "3", "FFFFFFFFFFFFFFFFFFFFFFFE26F2FC170F69466A74DEFD8D", "1", "DB4FF10EC057E9AE26B07D0280B7F4341DA5D1B1EAE06C7D", "9B2F2F6D9C5628A7844163D015BE86344082AA88D95E2F9D", []), Sr.crypto.ECParameterDB.regist("secp192r1", 192, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFC", "64210519E59C80E70FA7E9AB72243049FEB8DEECC146B9B1", "FFFFFFFFFFFFFFFFFFFFFFFF99DEF836146BC9B1B4D22831", "1", "188DA80EB03090F67CBF20EB43A18800F4FF0AFD82FF1012", "07192B95FFC8DA78631011ED6B24CDD573F977A11E794811", []), Sr.crypto.ECParameterDB.regist("secp224r1", 224, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000000000000000001", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFE", "B4050A850C04B3ABF54132565044B0B7D7BFD8BA270B39432355FFB4", "FFFFFFFFFFFFFFFFFFFFFFFFFFFF16A2E0B8F03E13DD29455C5C2A3D", "1", "B70E0CBD6BB4BF7F321390B94A03C1D356C21122343280D6115C1D21", "BD376388B5F723FB4C22DFE6CD4375A05A07476444D5819985007E34", []), Sr.crypto.ECParameterDB.regist("secp256k1", 256, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFC2F", "0", "7", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "1", "79BE667EF9DCBBAC55A06295CE870B07029BFCDB2DCE28D959F2815B16F81798", "483ADA7726A3C4655DA4FBFC0E1108A8FD17B448A68554199C47D08FFB10D4B8", []), Sr.crypto.ECParameterDB.regist("secp256r1", 256, "FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF", "FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC", "5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B", "FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551", "1", "6B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C296", "4FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5", ["NIST P-256", "P-256", "prime256v1"]), Sr.crypto.ECParameterDB.regist("secp384r1", 384, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFC", "B3312FA7E23EE7E4988E056BE3F82D19181D9C6EFE8141120314088F5013875AC656398D8A2ED19D2A85C8EDD3EC2AEF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC7634D81F4372DDF581A0DB248B0A77AECEC196ACCC52973", "1", "AA87CA22BE8B05378EB1C71EF320AD746E1D3B628BA79B9859F741E082542A385502F25DBF55296C3A545E3872760AB7", "3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f", ["NIST P-384", "P-384"]), Sr.crypto.ECParameterDB.regist("secp521r1", 521, "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC", "051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00", "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409", "1", "C6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66", "011839296a789a3bc0045c8a5fb42c7d1bd998f54449579b446817afbd17273e662c97ee72995ef42640c550b9013fad0761353c7086a272c24088be94769fd16650", ["NIST P-521", "P-521"]);
          var tn = /* @__PURE__ */ function() {
            var t3 = function t4(r4, n4, i3) {
              return e2(v2.AES, r4, n4, i3);
            }, e2 = function t4(e3, r4, n4, i3) {
              var o3 = v2.enc.Hex.parse(r4), s3 = v2.enc.Hex.parse(n4), a3 = v2.enc.Hex.parse(i3), u2 = {};
              u2.key = s3, u2.iv = a3, u2.ciphertext = o3;
              var c2 = e3.decrypt(u2, s3, { iv: a3 });
              return v2.enc.Hex.stringify(c2);
            }, r3 = function t4(e3, r4, i3) {
              return n3(v2.AES, e3, r4, i3);
            }, n3 = function t4(e3, r4, n4, i3) {
              var o3 = v2.enc.Hex.parse(r4), s3 = v2.enc.Hex.parse(n4), a3 = v2.enc.Hex.parse(i3), u2 = e3.encrypt(o3, s3, { iv: a3 }), c2 = v2.enc.Hex.parse(u2.toString());
              return v2.enc.Base64.stringify(c2);
            }, i2 = { "AES-256-CBC": { proc: t3, eproc: r3, keylen: 32, ivlen: 16 }, "AES-192-CBC": { proc: t3, eproc: r3, keylen: 24, ivlen: 16 }, "AES-128-CBC": { proc: t3, eproc: r3, keylen: 16, ivlen: 16 }, "DES-EDE3-CBC": { proc: function t4(r4, n4, i3) {
              return e2(v2.TripleDES, r4, n4, i3);
            }, eproc: function t4(e3, r4, i3) {
              return n3(v2.TripleDES, e3, r4, i3);
            }, keylen: 24, ivlen: 8 }, "DES-CBC": { proc: function t4(r4, n4, i3) {
              return e2(v2.DES, r4, n4, i3);
            }, eproc: function t4(e3, r4, i3) {
              return n3(v2.DES, e3, r4, i3);
            }, keylen: 8, ivlen: 8 } }, o2 = function t4(e3) {
              var r4 = {}, n4 = e3.match(new RegExp("DEK-Info: ([^,]+),([0-9A-Fa-f]+)", "m"));
              n4 && (r4.cipher = n4[1], r4.ivsalt = n4[2]);
              var i3 = e3.match(new RegExp("-----BEGIN ([A-Z]+) PRIVATE KEY-----"));
              i3 && (r4.type = i3[1]);
              var o3 = -1, s3 = 0;
              -1 != e3.indexOf("\r\n\r\n") && (o3 = e3.indexOf("\r\n\r\n"), s3 = 2), -1 != e3.indexOf("\n\n") && (o3 = e3.indexOf("\n\n"), s3 = 1);
              var a3 = e3.indexOf("-----END");
              if (-1 != o3 && -1 != a3) {
                var u2 = e3.substring(o3 + 2 * s3, a3 - s3);
                u2 = u2.replace(/\s+/g, ""), r4.data = u2;
              }
              return r4;
            }, s2 = function t4(e3, r4, n4) {
              for (var o3 = n4.substring(0, 16), s3 = v2.enc.Hex.parse(o3), a3 = v2.enc.Utf8.parse(r4), u2 = i2[e3].keylen + i2[e3].ivlen, c2 = "", h2 = null; ; ) {
                var l2 = v2.algo.MD5.create();
                if (null != h2 && l2.update(h2), l2.update(a3), l2.update(s3), h2 = l2.finalize(), (c2 += v2.enc.Hex.stringify(h2)).length >= 2 * u2) break;
              }
              var f2 = {};
              return f2.keyhex = c2.substr(0, 2 * i2[e3].keylen), f2.ivhex = c2.substr(2 * i2[e3].keylen, 2 * i2[e3].ivlen), f2;
            }, a2 = function t4(e3, r4, n4, o3) {
              var s3 = v2.enc.Base64.parse(e3), a3 = v2.enc.Hex.stringify(s3);
              return (0, i2[r4].proc)(a3, n4, o3);
            };
            return { version: "1.0.0", parsePKCS5PEM: function t4(e3) {
              return o2(e3);
            }, getKeyAndUnusedIvByPasscodeAndIvsalt: function t4(e3, r4, n4) {
              return s2(e3, r4, n4);
            }, decryptKeyB64: function t4(e3, r4, n4, i3) {
              return a2(e3, r4, n4, i3);
            }, getDecryptedKeyHex: function t4(e3, r4) {
              var n4 = o2(e3), i3 = (n4.type, n4.cipher), u2 = n4.ivsalt, c2 = n4.data, h2 = s2(i3, r4, u2).keyhex;
              return a2(c2, i3, h2, u2);
            }, getEncryptedPKCS5PEMFromPrvKeyHex: function t4(e3, r4, n4, o3, a3) {
              var u2 = "";
              if (void 0 !== o3 && null != o3 || (o3 = "AES-256-CBC"), void 0 === i2[o3]) throw new Error("KEYUTIL unsupported algorithm: " + o3);
              void 0 !== a3 && null != a3 || (a3 = function t5(e4) {
                var r5 = v2.lib.WordArray.random(e4);
                return v2.enc.Hex.stringify(r5);
              }(i2[o3].ivlen).toUpperCase());
              var c2 = function t5(e4, r5, n5, o4) {
                return (0, i2[r5].eproc)(e4, n5, o4);
              }(r4, o3, s2(o3, n4, a3).keyhex, a3);
              u2 = "-----BEGIN " + e3 + " PRIVATE KEY-----\r\n";
              return u2 += "Proc-Type: 4,ENCRYPTED\r\n", u2 += "DEK-Info: " + o3 + "," + a3 + "\r\n", u2 += "\r\n", u2 += c2.replace(/(.{64})/g, "$1\r\n"), u2 += "\r\n-----END " + e3 + " PRIVATE KEY-----\r\n";
            }, parseHexOfEncryptedPKCS8: function t4(e3) {
              var r4 = Fr, n4 = r4.getChildIdx, i3 = r4.getV, o3 = {}, s3 = n4(e3, 0);
              if (2 != s3.length) throw new Error("malformed format: SEQUENCE(0).items != 2: " + s3.length);
              o3.ciphertext = i3(e3, s3[1]);
              var a3 = n4(e3, s3[0]);
              if (2 != a3.length) throw new Error("malformed format: SEQUENCE(0.0).items != 2: " + a3.length);
              if ("2a864886f70d01050d" != i3(e3, a3[0])) throw new Error("this only supports pkcs5PBES2");
              var u2 = n4(e3, a3[1]);
              if (2 != a3.length) throw new Error("malformed format: SEQUENCE(0.0.1).items != 2: " + u2.length);
              var c2 = n4(e3, u2[1]);
              if (2 != c2.length) throw new Error("malformed format: SEQUENCE(0.0.1.1).items != 2: " + c2.length);
              if ("2a864886f70d0307" != i3(e3, c2[0])) throw "this only supports TripleDES";
              o3.encryptionSchemeAlg = "TripleDES", o3.encryptionSchemeIV = i3(e3, c2[1]);
              var h2 = n4(e3, u2[0]);
              if (2 != h2.length) throw new Error("malformed format: SEQUENCE(0.0.1.0).items != 2: " + h2.length);
              if ("2a864886f70d01050c" != i3(e3, h2[0])) throw new Error("this only supports pkcs5PBKDF2");
              var l2 = n4(e3, h2[1]);
              if (l2.length < 2) throw new Error("malformed format: SEQUENCE(0.0.1.0.1).items < 2: " + l2.length);
              o3.pbkdf2Salt = i3(e3, l2[0]);
              var f2 = i3(e3, l2[1]);
              try {
                o3.pbkdf2Iter = parseInt(f2, 16);
              } catch (t5) {
                throw new Error("malformed format pbkdf2Iter: " + f2);
              }
              return o3;
            }, getPBKDF2KeyHexFromParam: function t4(e3, r4) {
              var n4 = v2.enc.Hex.parse(e3.pbkdf2Salt), i3 = e3.pbkdf2Iter, o3 = v2.PBKDF2(r4, n4, { keySize: 6, iterations: i3 });
              return v2.enc.Hex.stringify(o3);
            }, _getPlainPKCS8HexFromEncryptedPKCS8PEM: function t4(e3, r4) {
              var n4 = Mr(e3, "ENCRYPTED PRIVATE KEY"), i3 = this.parseHexOfEncryptedPKCS8(n4), o3 = tn.getPBKDF2KeyHexFromParam(i3, r4), s3 = {};
              s3.ciphertext = v2.enc.Hex.parse(i3.ciphertext);
              var a3 = v2.enc.Hex.parse(o3), u2 = v2.enc.Hex.parse(i3.encryptionSchemeIV), c2 = v2.TripleDES.decrypt(s3, a3, { iv: u2 });
              return v2.enc.Hex.stringify(c2);
            }, getKeyFromEncryptedPKCS8PEM: function t4(e3, r4) {
              var n4 = this._getPlainPKCS8HexFromEncryptedPKCS8PEM(e3, r4);
              return this.getKeyFromPlainPrivatePKCS8Hex(n4);
            }, parsePlainPrivatePKCS8Hex: function t4(e3) {
              var r4 = Fr, n4 = r4.getChildIdx, i3 = r4.getV, o3 = { algparam: null };
              if ("30" != e3.substr(0, 2)) throw new Error("malformed plain PKCS8 private key(code:001)");
              var s3 = n4(e3, 0);
              if (s3.length < 3) throw new Error("malformed plain PKCS8 private key(code:002)");
              if ("30" != e3.substr(s3[1], 2)) throw new Error("malformed PKCS8 private key(code:003)");
              var a3 = n4(e3, s3[1]);
              if (2 != a3.length) throw new Error("malformed PKCS8 private key(code:004)");
              if ("06" != e3.substr(a3[0], 2)) throw new Error("malformed PKCS8 private key(code:005)");
              if (o3.algoid = i3(e3, a3[0]), "06" == e3.substr(a3[1], 2) && (o3.algparam = i3(e3, a3[1])), "04" != e3.substr(s3[2], 2)) throw new Error("malformed PKCS8 private key(code:006)");
              return o3.keyidx = r4.getVidx(e3, s3[2]), o3;
            }, getKeyFromPlainPrivatePKCS8PEM: function t4(e3) {
              var r4 = Mr(e3, "PRIVATE KEY");
              return this.getKeyFromPlainPrivatePKCS8Hex(r4);
            }, getKeyFromPlainPrivatePKCS8Hex: function t4(e3) {
              var r4, n4 = this.parsePlainPrivatePKCS8Hex(e3);
              if ("2a864886f70d010101" == n4.algoid) r4 = new Me2();
              else if ("2a8648ce380401" == n4.algoid) r4 = new Sr.crypto.DSA();
              else {
                if ("2a8648ce3d0201" != n4.algoid) throw new Error("unsupported private key algorithm");
                r4 = new Sr.crypto.ECDSA();
              }
              return r4.readPKCS8PrvKeyHex(e3), r4;
            }, _getKeyFromPublicPKCS8Hex: function t4(e3) {
              var r4, n4 = Fr.getVbyList(e3, 0, [0, 0], "06");
              if ("2a864886f70d010101" === n4) r4 = new Me2();
              else if ("2a8648ce380401" === n4) r4 = new Sr.crypto.DSA();
              else {
                if ("2a8648ce3d0201" !== n4) throw new Error("unsupported PKCS#8 public key hex");
                r4 = new Sr.crypto.ECDSA();
              }
              return r4.readPKCS8PubKeyHex(e3), r4;
            }, parsePublicRawRSAKeyHex: function t4(e3) {
              var r4 = Fr, n4 = r4.getChildIdx, i3 = r4.getV, o3 = {};
              if ("30" != e3.substr(0, 2)) throw new Error("malformed RSA key(code:001)");
              var s3 = n4(e3, 0);
              if (2 != s3.length) throw new Error("malformed RSA key(code:002)");
              if ("02" != e3.substr(s3[0], 2)) throw new Error("malformed RSA key(code:003)");
              if (o3.n = i3(e3, s3[0]), "02" != e3.substr(s3[1], 2)) throw new Error("malformed RSA key(code:004)");
              return o3.e = i3(e3, s3[1]), o3;
            }, parsePublicPKCS8Hex: function t4(e3) {
              var r4 = Fr, n4 = r4.getChildIdx, i3 = r4.getV, o3 = { algparam: null }, s3 = n4(e3, 0);
              if (2 != s3.length) throw new Error("outer DERSequence shall have 2 elements: " + s3.length);
              var a3 = s3[0];
              if ("30" != e3.substr(a3, 2)) throw new Error("malformed PKCS8 public key(code:001)");
              var u2 = n4(e3, a3);
              if (2 != u2.length) throw new Error("malformed PKCS8 public key(code:002)");
              if ("06" != e3.substr(u2[0], 2)) throw new Error("malformed PKCS8 public key(code:003)");
              if (o3.algoid = i3(e3, u2[0]), "06" == e3.substr(u2[1], 2) ? o3.algparam = i3(e3, u2[1]) : "30" == e3.substr(u2[1], 2) && (o3.algparam = {}, o3.algparam.p = r4.getVbyList(e3, u2[1], [0], "02"), o3.algparam.q = r4.getVbyList(e3, u2[1], [1], "02"), o3.algparam.g = r4.getVbyList(e3, u2[1], [2], "02")), "03" != e3.substr(s3[1], 2)) throw new Error("malformed PKCS8 public key(code:004)");
              return o3.key = i3(e3, s3[1]).substr(2), o3;
            } };
          }();
          tn.getKey = function(t3, e2, r3) {
            var n3 = (v3 = Fr).getChildIdx, i2 = (v3.getV, v3.getVbyList), o2 = Sr.crypto, s2 = o2.ECDSA, a2 = o2.DSA, u2 = Me2, c2 = Mr, h2 = tn;
            if (void 0 !== u2 && t3 instanceof u2) return t3;
            if (void 0 !== s2 && t3 instanceof s2) return t3;
            if (void 0 !== a2 && t3 instanceof a2) return t3;
            if (void 0 !== t3.curve && void 0 !== t3.xy && void 0 === t3.d) return new s2({ pub: t3.xy, curve: t3.curve });
            if (void 0 !== t3.curve && void 0 !== t3.d) return new s2({ prv: t3.d, curve: t3.curve });
            if (void 0 === t3.kty && void 0 !== t3.n && void 0 !== t3.e && void 0 === t3.d) return (P2 = new u2()).setPublic(t3.n, t3.e), P2;
            if (void 0 === t3.kty && void 0 !== t3.n && void 0 !== t3.e && void 0 !== t3.d && void 0 !== t3.p && void 0 !== t3.q && void 0 !== t3.dp && void 0 !== t3.dq && void 0 !== t3.co && void 0 === t3.qi) return (P2 = new u2()).setPrivateEx(t3.n, t3.e, t3.d, t3.p, t3.q, t3.dp, t3.dq, t3.co), P2;
            if (void 0 === t3.kty && void 0 !== t3.n && void 0 !== t3.e && void 0 !== t3.d && void 0 === t3.p) return (P2 = new u2()).setPrivate(t3.n, t3.e, t3.d), P2;
            if (void 0 !== t3.p && void 0 !== t3.q && void 0 !== t3.g && void 0 !== t3.y && void 0 === t3.x) return (P2 = new a2()).setPublic(t3.p, t3.q, t3.g, t3.y), P2;
            if (void 0 !== t3.p && void 0 !== t3.q && void 0 !== t3.g && void 0 !== t3.y && void 0 !== t3.x) return (P2 = new a2()).setPrivate(t3.p, t3.q, t3.g, t3.y, t3.x), P2;
            if ("RSA" === t3.kty && void 0 !== t3.n && void 0 !== t3.e && void 0 === t3.d) return (P2 = new u2()).setPublic(Rr(t3.n), Rr(t3.e)), P2;
            if ("RSA" === t3.kty && void 0 !== t3.n && void 0 !== t3.e && void 0 !== t3.d && void 0 !== t3.p && void 0 !== t3.q && void 0 !== t3.dp && void 0 !== t3.dq && void 0 !== t3.qi) return (P2 = new u2()).setPrivateEx(Rr(t3.n), Rr(t3.e), Rr(t3.d), Rr(t3.p), Rr(t3.q), Rr(t3.dp), Rr(t3.dq), Rr(t3.qi)), P2;
            if ("RSA" === t3.kty && void 0 !== t3.n && void 0 !== t3.e && void 0 !== t3.d) return (P2 = new u2()).setPrivate(Rr(t3.n), Rr(t3.e), Rr(t3.d)), P2;
            if ("EC" === t3.kty && void 0 !== t3.crv && void 0 !== t3.x && void 0 !== t3.y && void 0 === t3.d) {
              var l2 = (k2 = new s2({ curve: t3.crv })).ecparams.keylen / 4, f2 = "04" + ("0000000000" + Rr(t3.x)).slice(-l2) + ("0000000000" + Rr(t3.y)).slice(-l2);
              return k2.setPublicKeyHex(f2), k2;
            }
            if ("EC" === t3.kty && void 0 !== t3.crv && void 0 !== t3.x && void 0 !== t3.y && void 0 !== t3.d) {
              l2 = (k2 = new s2({ curve: t3.crv })).ecparams.keylen / 4, f2 = "04" + ("0000000000" + Rr(t3.x)).slice(-l2) + ("0000000000" + Rr(t3.y)).slice(-l2);
              var g2 = ("0000000000" + Rr(t3.d)).slice(-l2);
              return k2.setPublicKeyHex(f2), k2.setPrivateKeyHex(g2), k2;
            }
            if ("pkcs5prv" === r3) {
              var d2, p2 = t3, v3 = Fr;
              if (9 === (d2 = n3(p2, 0)).length) (P2 = new u2()).readPKCS5PrvKeyHex(p2);
              else if (6 === d2.length) (P2 = new a2()).readPKCS5PrvKeyHex(p2);
              else {
                if (!(d2.length > 2 && "04" === p2.substr(d2[1], 2))) throw new Error("unsupported PKCS#1/5 hexadecimal key");
                (P2 = new s2()).readPKCS5PrvKeyHex(p2);
              }
              return P2;
            }
            if ("pkcs8prv" === r3) return P2 = h2.getKeyFromPlainPrivatePKCS8Hex(t3);
            if ("pkcs8pub" === r3) return h2._getKeyFromPublicPKCS8Hex(t3);
            if ("x509pub" === r3) return on.getPublicKeyFromCertHex(t3);
            if (-1 != t3.indexOf("-END CERTIFICATE-", 0) || -1 != t3.indexOf("-END X509 CERTIFICATE-", 0) || -1 != t3.indexOf("-END TRUSTED CERTIFICATE-", 0)) return on.getPublicKeyFromCertPEM(t3);
            if (-1 != t3.indexOf("-END PUBLIC KEY-")) {
              var y2 = Mr(t3, "PUBLIC KEY");
              return h2._getKeyFromPublicPKCS8Hex(y2);
            }
            if (-1 != t3.indexOf("-END RSA PRIVATE KEY-") && -1 == t3.indexOf("4,ENCRYPTED")) {
              var m2 = c2(t3, "RSA PRIVATE KEY");
              return h2.getKey(m2, null, "pkcs5prv");
            }
            if (-1 != t3.indexOf("-END DSA PRIVATE KEY-") && -1 == t3.indexOf("4,ENCRYPTED")) {
              var _2 = i2(R2 = c2(t3, "DSA PRIVATE KEY"), 0, [1], "02"), S2 = i2(R2, 0, [2], "02"), b2 = i2(R2, 0, [3], "02"), F2 = i2(R2, 0, [4], "02"), E = i2(R2, 0, [5], "02");
              return (P2 = new a2()).setPrivate(new w(_2, 16), new w(S2, 16), new w(b2, 16), new w(F2, 16), new w(E, 16)), P2;
            }
            if (-1 != t3.indexOf("-END EC PRIVATE KEY-") && -1 == t3.indexOf("4,ENCRYPTED")) {
              m2 = c2(t3, "EC PRIVATE KEY");
              return h2.getKey(m2, null, "pkcs5prv");
            }
            if (-1 != t3.indexOf("-END PRIVATE KEY-")) return h2.getKeyFromPlainPrivatePKCS8PEM(t3);
            if (-1 != t3.indexOf("-END RSA PRIVATE KEY-") && -1 != t3.indexOf("4,ENCRYPTED")) {
              var x = h2.getDecryptedKeyHex(t3, e2), A = new Me2();
              return A.readPKCS5PrvKeyHex(x), A;
            }
            if (-1 != t3.indexOf("-END EC PRIVATE KEY-") && -1 != t3.indexOf("4,ENCRYPTED")) {
              var k2, P2 = i2(R2 = h2.getDecryptedKeyHex(t3, e2), 0, [1], "04"), C2 = i2(R2, 0, [2, 0], "06"), T2 = i2(R2, 0, [3, 0], "03").substr(2);
              if (void 0 === Sr.crypto.OID.oidhex2name[C2]) throw new Error("undefined OID(hex) in KJUR.crypto.OID: " + C2);
              return (k2 = new s2({ curve: Sr.crypto.OID.oidhex2name[C2] })).setPublicKeyHex(T2), k2.setPrivateKeyHex(P2), k2.isPublic = false, k2;
            }
            if (-1 != t3.indexOf("-END DSA PRIVATE KEY-") && -1 != t3.indexOf("4,ENCRYPTED")) {
              var R2;
              _2 = i2(R2 = h2.getDecryptedKeyHex(t3, e2), 0, [1], "02"), S2 = i2(R2, 0, [2], "02"), b2 = i2(R2, 0, [3], "02"), F2 = i2(R2, 0, [4], "02"), E = i2(R2, 0, [5], "02");
              return (P2 = new a2()).setPrivate(new w(_2, 16), new w(S2, 16), new w(b2, 16), new w(F2, 16), new w(E, 16)), P2;
            }
            if (-1 != t3.indexOf("-END ENCRYPTED PRIVATE KEY-")) return h2.getKeyFromEncryptedPKCS8PEM(t3, e2);
            throw new Error("not supported argument");
          }, tn.generateKeypair = function(t3, e2) {
            if ("RSA" == t3) {
              var r3 = e2;
              (s2 = new Me2()).generate(r3, "10001"), s2.isPrivate = true, s2.isPublic = true;
              var n3 = new Me2(), i2 = s2.n.toString(16), o2 = s2.e.toString(16);
              return n3.setPublic(i2, o2), n3.isPrivate = false, n3.isPublic = true, (a2 = {}).prvKeyObj = s2, a2.pubKeyObj = n3, a2;
            }
            if ("EC" == t3) {
              var s2, a2, u2 = e2, c2 = new Sr.crypto.ECDSA({ curve: u2 }).generateKeyPairHex();
              return (s2 = new Sr.crypto.ECDSA({ curve: u2 })).setPublicKeyHex(c2.ecpubhex), s2.setPrivateKeyHex(c2.ecprvhex), s2.isPrivate = true, s2.isPublic = false, (n3 = new Sr.crypto.ECDSA({ curve: u2 })).setPublicKeyHex(c2.ecpubhex), n3.isPrivate = false, n3.isPublic = true, (a2 = {}).prvKeyObj = s2, a2.pubKeyObj = n3, a2;
            }
            throw new Error("unknown algorithm: " + t3);
          }, tn.getPEM = function(t3, e2, r3, n3, i2, o2) {
            var s2 = Sr, a2 = s2.asn1, u2 = a2.DERObjectIdentifier, c2 = a2.DERInteger, h2 = a2.ASN1Util.newObject, l2 = a2.x509.SubjectPublicKeyInfo, f2 = s2.crypto, g2 = f2.DSA, d2 = f2.ECDSA, p2 = Me2;
            function y2(t4) {
              return h2({ seq: [{ int: 0 }, { int: { bigint: t4.n } }, { int: t4.e }, { int: { bigint: t4.d } }, { int: { bigint: t4.p } }, { int: { bigint: t4.q } }, { int: { bigint: t4.dmp1 } }, { int: { bigint: t4.dmq1 } }, { int: { bigint: t4.coeff } }] });
            }
            function m2(t4) {
              return h2({ seq: [{ int: 1 }, { octstr: { hex: t4.prvKeyHex } }, { tag: ["a0", true, { oid: { name: t4.curveName } }] }, { tag: ["a1", true, { bitstr: { hex: "00" + t4.pubKeyHex } }] }] });
            }
            function _2(t4) {
              return h2({ seq: [{ int: 0 }, { int: { bigint: t4.p } }, { int: { bigint: t4.q } }, { int: { bigint: t4.g } }, { int: { bigint: t4.y } }, { int: { bigint: t4.x } }] });
            }
            if ((void 0 !== p2 && t3 instanceof p2 || void 0 !== g2 && t3 instanceof g2 || void 0 !== d2 && t3 instanceof d2) && 1 == t3.isPublic && (void 0 === e2 || "PKCS8PUB" == e2)) return jr(F2 = new l2(t3).getEncodedHex(), "PUBLIC KEY");
            if ("PKCS1PRV" == e2 && void 0 !== p2 && t3 instanceof p2 && (void 0 === r3 || null == r3) && 1 == t3.isPrivate) return jr(F2 = y2(t3).getEncodedHex(), "RSA PRIVATE KEY");
            if ("PKCS1PRV" == e2 && void 0 !== d2 && t3 instanceof d2 && (void 0 === r3 || null == r3) && 1 == t3.isPrivate) {
              var S2 = new u2({ name: t3.curveName }).getEncodedHex(), b2 = m2(t3).getEncodedHex(), w2 = "";
              return w2 += jr(S2, "EC PARAMETERS"), w2 += jr(b2, "EC PRIVATE KEY");
            }
            if ("PKCS1PRV" == e2 && void 0 !== g2 && t3 instanceof g2 && (void 0 === r3 || null == r3) && 1 == t3.isPrivate) return jr(F2 = _2(t3).getEncodedHex(), "DSA PRIVATE KEY");
            if ("PKCS5PRV" == e2 && void 0 !== p2 && t3 instanceof p2 && void 0 !== r3 && null != r3 && 1 == t3.isPrivate) {
              var F2 = y2(t3).getEncodedHex();
              return void 0 === n3 && (n3 = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("RSA", F2, r3, n3, o2);
            }
            if ("PKCS5PRV" == e2 && void 0 !== d2 && t3 instanceof d2 && void 0 !== r3 && null != r3 && 1 == t3.isPrivate) {
              F2 = m2(t3).getEncodedHex();
              return void 0 === n3 && (n3 = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("EC", F2, r3, n3, o2);
            }
            if ("PKCS5PRV" == e2 && void 0 !== g2 && t3 instanceof g2 && void 0 !== r3 && null != r3 && 1 == t3.isPrivate) {
              F2 = _2(t3).getEncodedHex();
              return void 0 === n3 && (n3 = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("DSA", F2, r3, n3, o2);
            }
            var E = function t4(e3, r4) {
              var n4 = x(e3, r4);
              return new h2({ seq: [{ seq: [{ oid: { name: "pkcs5PBES2" } }, { seq: [{ seq: [{ oid: { name: "pkcs5PBKDF2" } }, { seq: [{ octstr: { hex: n4.pbkdf2Salt } }, { int: n4.pbkdf2Iter }] }] }, { seq: [{ oid: { name: "des-EDE3-CBC" } }, { octstr: { hex: n4.encryptionSchemeIV } }] }] }] }, { octstr: { hex: n4.ciphertext } }] }).getEncodedHex();
            }, x = function t4(e3, r4) {
              var n4 = v2.lib.WordArray.random(8), i3 = v2.lib.WordArray.random(8), o3 = v2.PBKDF2(r4, n4, { keySize: 6, iterations: 100 }), s3 = v2.enc.Hex.parse(e3), a3 = v2.TripleDES.encrypt(s3, o3, { iv: i3 }) + "", u3 = {};
              return u3.ciphertext = a3, u3.pbkdf2Salt = v2.enc.Hex.stringify(n4), u3.pbkdf2Iter = 100, u3.encryptionSchemeAlg = "DES-EDE3-CBC", u3.encryptionSchemeIV = v2.enc.Hex.stringify(i3), u3;
            };
            if ("PKCS8PRV" == e2 && null != p2 && t3 instanceof p2 && 1 == t3.isPrivate) {
              var A = y2(t3).getEncodedHex();
              F2 = h2({ seq: [{ int: 0 }, { seq: [{ oid: { name: "rsaEncryption" } }, { null: true }] }, { octstr: { hex: A } }] }).getEncodedHex();
              return void 0 === r3 || null == r3 ? jr(F2, "PRIVATE KEY") : jr(b2 = E(F2, r3), "ENCRYPTED PRIVATE KEY");
            }
            if ("PKCS8PRV" == e2 && void 0 !== d2 && t3 instanceof d2 && 1 == t3.isPrivate) {
              A = new h2({ seq: [{ int: 1 }, { octstr: { hex: t3.prvKeyHex } }, { tag: ["a1", true, { bitstr: { hex: "00" + t3.pubKeyHex } }] }] }).getEncodedHex(), F2 = h2({ seq: [{ int: 0 }, { seq: [{ oid: { name: "ecPublicKey" } }, { oid: { name: t3.curveName } }] }, { octstr: { hex: A } }] }).getEncodedHex();
              return void 0 === r3 || null == r3 ? jr(F2, "PRIVATE KEY") : jr(b2 = E(F2, r3), "ENCRYPTED PRIVATE KEY");
            }
            if ("PKCS8PRV" == e2 && void 0 !== g2 && t3 instanceof g2 && 1 == t3.isPrivate) {
              A = new c2({ bigint: t3.x }).getEncodedHex(), F2 = h2({ seq: [{ int: 0 }, { seq: [{ oid: { name: "dsa" } }, { seq: [{ int: { bigint: t3.p } }, { int: { bigint: t3.q } }, { int: { bigint: t3.g } }] }] }, { octstr: { hex: A } }] }).getEncodedHex();
              return void 0 === r3 || null == r3 ? jr(F2, "PRIVATE KEY") : jr(b2 = E(F2, r3), "ENCRYPTED PRIVATE KEY");
            }
            throw new Error("unsupported object nor format");
          }, tn.getKeyFromCSRPEM = function(t3) {
            var e2 = Mr(t3, "CERTIFICATE REQUEST");
            return tn.getKeyFromCSRHex(e2);
          }, tn.getKeyFromCSRHex = function(t3) {
            var e2 = tn.parseCSRHex(t3);
            return tn.getKey(e2.p8pubkeyhex, null, "pkcs8pub");
          }, tn.parseCSRHex = function(t3) {
            var e2 = Fr, r3 = e2.getChildIdx, n3 = e2.getTLV, i2 = {}, o2 = t3;
            if ("30" != o2.substr(0, 2)) throw new Error("malformed CSR(code:001)");
            var s2 = r3(o2, 0);
            if (s2.length < 1) throw new Error("malformed CSR(code:002)");
            if ("30" != o2.substr(s2[0], 2)) throw new Error("malformed CSR(code:003)");
            var a2 = r3(o2, s2[0]);
            if (a2.length < 3) throw new Error("malformed CSR(code:004)");
            return i2.p8pubkeyhex = n3(o2, a2[2]), i2;
          }, tn.getKeyID = function(t3) {
            var e2 = tn, r3 = Fr;
            "string" == typeof t3 && -1 != t3.indexOf("BEGIN ") && (t3 = e2.getKey(t3));
            var n3 = Mr(e2.getPEM(t3)), i2 = r3.getIdxbyList(n3, 0, [1]), o2 = r3.getV(n3, i2).substring(2);
            return Sr.crypto.Util.hashHex(o2, "sha1");
          }, tn.getJWKFromKey = function(t3) {
            var e2 = {};
            if (t3 instanceof Me2 && t3.isPrivate) return e2.kty = "RSA", e2.n = Tr(t3.n.toString(16)), e2.e = Tr(t3.e.toString(16)), e2.d = Tr(t3.d.toString(16)), e2.p = Tr(t3.p.toString(16)), e2.q = Tr(t3.q.toString(16)), e2.dp = Tr(t3.dmp1.toString(16)), e2.dq = Tr(t3.dmq1.toString(16)), e2.qi = Tr(t3.coeff.toString(16)), e2;
            if (t3 instanceof Me2 && t3.isPublic) return e2.kty = "RSA", e2.n = Tr(t3.n.toString(16)), e2.e = Tr(t3.e.toString(16)), e2;
            if (t3 instanceof Sr.crypto.ECDSA && t3.isPrivate) {
              if ("P-256" !== (n3 = t3.getShortNISTPCurveName()) && "P-384" !== n3) throw new Error("unsupported curve name for JWT: " + n3);
              var r3 = t3.getPublicKeyXYHex();
              return e2.kty = "EC", e2.crv = n3, e2.x = Tr(r3.x), e2.y = Tr(r3.y), e2.d = Tr(t3.prvKeyHex), e2;
            }
            if (t3 instanceof Sr.crypto.ECDSA && t3.isPublic) {
              var n3;
              if ("P-256" !== (n3 = t3.getShortNISTPCurveName()) && "P-384" !== n3) throw new Error("unsupported curve name for JWT: " + n3);
              r3 = t3.getPublicKeyXYHex();
              return e2.kty = "EC", e2.crv = n3, e2.x = Tr(r3.x), e2.y = Tr(r3.y), e2;
            }
            throw new Error("not supported key object");
          }, Me2.getPosArrayOfChildrenFromHex = function(t3) {
            return Fr.getChildIdx(t3, 0);
          }, Me2.getHexValueArrayOfChildrenFromHex = function(t3) {
            var e2, r3 = Fr.getV, n3 = r3(t3, (e2 = Me2.getPosArrayOfChildrenFromHex(t3))[0]), i2 = r3(t3, e2[1]), o2 = r3(t3, e2[2]), s2 = r3(t3, e2[3]), a2 = r3(t3, e2[4]), u2 = r3(t3, e2[5]), c2 = r3(t3, e2[6]), h2 = r3(t3, e2[7]), l2 = r3(t3, e2[8]);
            return (e2 = new Array()).push(n3, i2, o2, s2, a2, u2, c2, h2, l2), e2;
          }, Me2.prototype.readPrivateKeyFromPEMString = function(t3) {
            var e2 = Mr(t3), r3 = Me2.getHexValueArrayOfChildrenFromHex(e2);
            this.setPrivateEx(r3[1], r3[2], r3[3], r3[4], r3[5], r3[6], r3[7], r3[8]);
          }, Me2.prototype.readPKCS5PrvKeyHex = function(t3) {
            var e2 = Me2.getHexValueArrayOfChildrenFromHex(t3);
            this.setPrivateEx(e2[1], e2[2], e2[3], e2[4], e2[5], e2[6], e2[7], e2[8]);
          }, Me2.prototype.readPKCS8PrvKeyHex = function(t3) {
            var e2, r3, n3, i2, o2, s2, a2, u2, c2 = Fr, h2 = c2.getVbyListEx;
            if (false === c2.isASN1HEX(t3)) throw new Error("not ASN.1 hex string");
            try {
              e2 = h2(t3, 0, [2, 0, 1], "02"), r3 = h2(t3, 0, [2, 0, 2], "02"), n3 = h2(t3, 0, [2, 0, 3], "02"), i2 = h2(t3, 0, [2, 0, 4], "02"), o2 = h2(t3, 0, [2, 0, 5], "02"), s2 = h2(t3, 0, [2, 0, 6], "02"), a2 = h2(t3, 0, [2, 0, 7], "02"), u2 = h2(t3, 0, [2, 0, 8], "02");
            } catch (t4) {
              throw new Error("malformed PKCS#8 plain RSA private key");
            }
            this.setPrivateEx(e2, r3, n3, i2, o2, s2, a2, u2);
          }, Me2.prototype.readPKCS5PubKeyHex = function(t3) {
            var e2 = Fr, r3 = e2.getV;
            if (false === e2.isASN1HEX(t3)) throw new Error("keyHex is not ASN.1 hex string");
            var n3 = e2.getChildIdx(t3, 0);
            if (2 !== n3.length || "02" !== t3.substr(n3[0], 2) || "02" !== t3.substr(n3[1], 2)) throw new Error("wrong hex for PKCS#5 public key");
            var i2 = r3(t3, n3[0]), o2 = r3(t3, n3[1]);
            this.setPublic(i2, o2);
          }, Me2.prototype.readPKCS8PubKeyHex = function(t3) {
            var e2 = Fr;
            if (false === e2.isASN1HEX(t3)) throw new Error("not ASN.1 hex string");
            if ("06092a864886f70d010101" !== e2.getTLVbyListEx(t3, 0, [0, 0])) throw new Error("not PKCS8 RSA public key");
            var r3 = e2.getTLVbyListEx(t3, 0, [1, 0]);
            this.readPKCS5PubKeyHex(r3);
          }, Me2.prototype.readCertPubKeyHex = function(t3, e2) {
            var r3, n3;
            (r3 = new on()).readCertHex(t3), n3 = r3.getPublicKeyHex(), this.readPKCS8PubKeyHex(n3);
          };
          new RegExp("[^0-9a-f]", "gi");
          function en(t3, e2) {
            for (var r3 = "", n3 = e2 / 4 - t3.length, i2 = 0; i2 < n3; i2++) r3 += "0";
            return r3 + t3;
          }
          function rn(t3, e2, r3) {
            for (var n3 = "", i2 = 0; n3.length < e2; ) n3 += Lr(r3(Nr(t3 + String.fromCharCode.apply(String, [(4278190080 & i2) >> 24, (16711680 & i2) >> 16, (65280 & i2) >> 8, 255 & i2])))), i2 += 1;
            return n3;
          }
          function nn(t3) {
            for (var e2 in Sr.crypto.Util.DIGESTINFOHEAD) {
              var r3 = Sr.crypto.Util.DIGESTINFOHEAD[e2], n3 = r3.length;
              if (t3.substring(0, n3) == r3) return [e2, t3.substring(n3)];
            }
            return [];
          }
          function on(t3) {
            var e2, r3 = Fr, n3 = r3.getChildIdx, i2 = r3.getV, o2 = r3.getTLV, s2 = r3.getVbyList, a2 = r3.getVbyListEx, u2 = r3.getTLVbyList, c2 = r3.getTLVbyListEx, h2 = r3.getIdxbyList, l2 = r3.getIdxbyListEx, f2 = r3.getVidx, g2 = r3.getInt, d2 = r3.oidname, p2 = r3.hextooidstr, v3 = Mr;
            try {
              e2 = Sr.asn1.x509.AlgorithmIdentifier.PSSNAME2ASN1TLV;
            } catch (t4) {
            }
            this.HEX2STAG = { "0c": "utf8", 13: "prn", 16: "ia5", "1a": "vis", "1e": "bmp" }, this.hex = null, this.version = 0, this.foffset = 0, this.aExtInfo = null, this.getVersion = function() {
              if (null === this.hex || 0 !== this.version) return this.version;
              var t4 = u2(this.hex, 0, [0, 0]);
              if ("a0" == t4.substr(0, 2)) {
                var e3 = u2(t4, 0, [0]), r4 = g2(e3, 0);
                if (r4 < 0 || 2 < r4) throw new Error("malformed version field");
                return this.version = r4 + 1, this.version;
              }
              return this.version = 1, this.foffset = -1, 1;
            }, this.getSerialNumberHex = function() {
              return a2(this.hex, 0, [0, 0], "02");
            }, this.getSignatureAlgorithmField = function() {
              var t4 = c2(this.hex, 0, [0, 1]);
              return this.getAlgorithmIdentifierName(t4);
            }, this.getAlgorithmIdentifierName = function(t4) {
              for (var r4 in e2) if (t4 === e2[r4]) return r4;
              return d2(a2(t4, 0, [0], "06"));
            }, this.getIssuer = function() {
              return this.getX500Name(this.getIssuerHex());
            }, this.getIssuerHex = function() {
              return u2(this.hex, 0, [0, 3 + this.foffset], "30");
            }, this.getIssuerString = function() {
              return this.getIssuer().str;
            }, this.getSubject = function() {
              return this.getX500Name(this.getSubjectHex());
            }, this.getSubjectHex = function() {
              return u2(this.hex, 0, [0, 5 + this.foffset], "30");
            }, this.getSubjectString = function() {
              return this.getSubject().str;
            }, this.getNotBefore = function() {
              var t4 = s2(this.hex, 0, [0, 4 + this.foffset, 0]);
              return t4 = t4.replace(/(..)/g, "%$1"), t4 = decodeURIComponent(t4);
            }, this.getNotAfter = function() {
              var t4 = s2(this.hex, 0, [0, 4 + this.foffset, 1]);
              return t4 = t4.replace(/(..)/g, "%$1"), t4 = decodeURIComponent(t4);
            }, this.getPublicKeyHex = function() {
              return r3.getTLVbyList(this.hex, 0, [0, 6 + this.foffset], "30");
            }, this.getPublicKeyIdx = function() {
              return h2(this.hex, 0, [0, 6 + this.foffset], "30");
            }, this.getPublicKeyContentIdx = function() {
              var t4 = this.getPublicKeyIdx();
              return h2(this.hex, t4, [1, 0], "30");
            }, this.getPublicKey = function() {
              return tn.getKey(this.getPublicKeyHex(), null, "pkcs8pub");
            }, this.getSignatureAlgorithmName = function() {
              var t4 = u2(this.hex, 0, [1], "30");
              return this.getAlgorithmIdentifierName(t4);
            }, this.getSignatureValueHex = function() {
              return s2(this.hex, 0, [2], "03", true);
            }, this.verifySignature = function(t4) {
              var e3 = this.getSignatureAlgorithmField(), r4 = this.getSignatureValueHex(), n4 = u2(this.hex, 0, [0], "30"), i3 = new Sr.crypto.Signature({ alg: e3 });
              return i3.init(t4), i3.updateHex(n4), i3.verify(r4);
            }, this.parseExt = function(t4) {
              var e3, o3, a3;
              if (void 0 === t4) {
                if (a3 = this.hex, 3 !== this.version) return -1;
                e3 = h2(a3, 0, [0, 7, 0], "30"), o3 = n3(a3, e3);
              } else {
                a3 = Mr(t4);
                var u3 = h2(a3, 0, [0, 3, 0, 0], "06");
                if ("2a864886f70d01090e" != i2(a3, u3)) return void (this.aExtInfo = new Array());
                e3 = h2(a3, 0, [0, 3, 0, 1, 0], "30"), o3 = n3(a3, e3), this.hex = a3;
              }
              this.aExtInfo = new Array();
              for (var c3 = 0; c3 < o3.length; c3++) {
                var l3 = { critical: false }, g3 = 0;
                3 === n3(a3, o3[c3]).length && (l3.critical = true, g3 = 1), l3.oid = r3.hextooidstr(s2(a3, o3[c3], [0], "06"));
                var d3 = h2(a3, o3[c3], [1 + g3]);
                l3.vidx = f2(a3, d3), this.aExtInfo.push(l3);
              }
            }, this.getExtInfo = function(t4) {
              var e3 = this.aExtInfo, r4 = t4;
              if (t4.match(/^[0-9.]+$/) || (r4 = Sr.asn1.x509.OID.name2oid(t4)), "" !== r4) {
                for (var n4 = 0; n4 < e3.length; n4++) if (e3[n4].oid === r4) return e3[n4];
              }
            }, this.getExtBasicConstraints = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("basicConstraints");
                if (void 0 === r4) return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var n4 = { extname: "basicConstraints" };
              if (e3 && (n4.critical = true), "3000" === t4) return n4;
              if ("30030101ff" === t4) return n4.cA = true, n4;
              if ("30060101ff02" === t4.substr(0, 12)) {
                var s3 = i2(t4, 10), a3 = parseInt(s3, 16);
                return n4.cA = true, n4.pathLen = a3, n4;
              }
              throw new Error("hExtV parse error: " + t4);
            }, this.getExtKeyUsage = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("keyUsage");
                if (void 0 === r4) return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var n4 = { extname: "keyUsage" };
              return e3 && (n4.critical = true), n4.names = this.getExtKeyUsageString(t4).split(","), n4;
            }, this.getExtKeyUsageBin = function(t4) {
              if (void 0 === t4) {
                var e3 = this.getExtInfo("keyUsage");
                if (void 0 === e3) return "";
                t4 = o2(this.hex, e3.vidx);
              }
              if (8 != t4.length && 10 != t4.length) throw new Error("malformed key usage value: " + t4);
              var r4 = "000000000000000" + parseInt(t4.substr(6), 16).toString(2);
              return 8 == t4.length && (r4 = r4.slice(-8)), 10 == t4.length && (r4 = r4.slice(-16)), "" == (r4 = r4.replace(/0+$/, "")) && (r4 = "0"), r4;
            }, this.getExtKeyUsageString = function(t4) {
              for (var e3 = this.getExtKeyUsageBin(t4), r4 = new Array(), n4 = 0; n4 < e3.length; n4++) "1" == e3.substr(n4, 1) && r4.push(on.KEYUSAGE_NAME[n4]);
              return r4.join(",");
            }, this.getExtSubjectKeyIdentifier = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("subjectKeyIdentifier");
                if (void 0 === r4) return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var n4 = { extname: "subjectKeyIdentifier" };
              e3 && (n4.critical = true);
              var s3 = i2(t4, 0);
              return n4.kid = { hex: s3 }, n4;
            }, this.getExtAuthorityKeyIdentifier = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("authorityKeyIdentifier");
                if (void 0 === r4) return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var s3 = { extname: "authorityKeyIdentifier" };
              e3 && (s3.critical = true);
              for (var a3 = n3(t4, 0), u3 = 0; u3 < a3.length; u3++) {
                var c3 = t4.substr(a3[u3], 2);
                if ("80" === c3 && (s3.kid = { hex: i2(t4, a3[u3]) }), "a1" === c3) {
                  var h3 = o2(t4, a3[u3]), l3 = this.getGeneralNames(h3);
                  s3.issuer = l3[0].dn;
                }
                "82" === c3 && (s3.sn = { hex: i2(t4, a3[u3]) });
              }
              return s3;
            }, this.getExtExtKeyUsage = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("extKeyUsage");
                if (void 0 === r4) return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var s3 = { extname: "extKeyUsage", array: [] };
              e3 && (s3.critical = true);
              for (var a3 = n3(t4, 0), u3 = 0; u3 < a3.length; u3++) s3.array.push(d2(i2(t4, a3[u3])));
              return s3;
            }, this.getExtExtKeyUsageName = function() {
              var t4 = this.getExtInfo("extKeyUsage");
              if (void 0 === t4) return t4;
              var e3 = new Array(), r4 = o2(this.hex, t4.vidx);
              if ("" === r4) return e3;
              for (var s3 = n3(r4, 0), a3 = 0; a3 < s3.length; a3++) e3.push(d2(i2(r4, s3[a3])));
              return e3;
            }, this.getExtSubjectAltName = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("subjectAltName");
                if (void 0 === r4) return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var n4 = { extname: "subjectAltName", array: [] };
              return e3 && (n4.critical = true), n4.array = this.getGeneralNames(t4), n4;
            }, this.getExtIssuerAltName = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("issuerAltName");
                if (void 0 === r4) return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var n4 = { extname: "issuerAltName", array: [] };
              return e3 && (n4.critical = true), n4.array = this.getGeneralNames(t4), n4;
            }, this.getGeneralNames = function(t4) {
              for (var e3 = n3(t4, 0), r4 = [], i3 = 0; i3 < e3.length; i3++) {
                var s3 = this.getGeneralName(o2(t4, e3[i3]));
                void 0 !== s3 && r4.push(s3);
              }
              return r4;
            }, this.getGeneralName = function(t4) {
              var e3 = t4.substr(0, 2), r4 = i2(t4, 0), n4 = Lr(r4);
              return "81" == e3 ? { rfc822: n4 } : "82" == e3 ? { dns: n4 } : "86" == e3 ? { uri: n4 } : "87" == e3 ? { ip: zr(r4) } : "a4" == e3 ? { dn: this.getX500Name(r4) } : void 0;
            }, this.getExtSubjectAltName2 = function() {
              var t4, e3, r4, s3 = this.getExtInfo("subjectAltName");
              if (void 0 === s3) return s3;
              for (var a3 = new Array(), u3 = o2(this.hex, s3.vidx), c3 = n3(u3, 0), h3 = 0; h3 < c3.length; h3++) r4 = u3.substr(c3[h3], 2), t4 = i2(u3, c3[h3]), "81" === r4 && (e3 = Dr(t4), a3.push(["MAIL", e3])), "82" === r4 && (e3 = Dr(t4), a3.push(["DNS", e3])), "84" === r4 && (e3 = on.hex2dn(t4, 0), a3.push(["DN", e3])), "86" === r4 && (e3 = Dr(t4), a3.push(["URI", e3])), "87" === r4 && (e3 = zr(t4), a3.push(["IP", e3]));
              return a3;
            }, this.getExtCRLDistributionPoints = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("cRLDistributionPoints");
                if (void 0 === r4) return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var i3 = { extname: "cRLDistributionPoints", array: [] };
              e3 && (i3.critical = true);
              for (var s3 = n3(t4, 0), a3 = 0; a3 < s3.length; a3++) {
                var u3 = o2(t4, s3[a3]);
                i3.array.push(this.getDistributionPoint(u3));
              }
              return i3;
            }, this.getDistributionPoint = function(t4) {
              for (var e3 = {}, r4 = n3(t4, 0), i3 = 0; i3 < r4.length; i3++) {
                var s3 = t4.substr(r4[i3], 2), a3 = o2(t4, r4[i3]);
                "a0" == s3 && (e3.dpname = this.getDistributionPointName(a3));
              }
              return e3;
            }, this.getDistributionPointName = function(t4) {
              for (var e3 = {}, r4 = n3(t4, 0), i3 = 0; i3 < r4.length; i3++) {
                var s3 = t4.substr(r4[i3], 2), a3 = o2(t4, r4[i3]);
                "a0" == s3 && (e3.full = this.getGeneralNames(a3));
              }
              return e3;
            }, this.getExtCRLDistributionPointsURI = function() {
              var t4 = this.getExtInfo("cRLDistributionPoints");
              if (void 0 === t4) return t4;
              for (var e3 = new Array(), r4 = n3(this.hex, t4.vidx), i3 = 0; i3 < r4.length; i3++) try {
                var o3 = Dr(s2(this.hex, r4[i3], [0, 0, 0], "86"));
                e3.push(o3);
              } catch (t5) {
              }
              return e3;
            }, this.getExtAIAInfo = function() {
              var t4 = this.getExtInfo("authorityInfoAccess");
              if (void 0 === t4) return t4;
              for (var e3 = { ocsp: [], caissuer: [] }, r4 = n3(this.hex, t4.vidx), i3 = 0; i3 < r4.length; i3++) {
                var o3 = s2(this.hex, r4[i3], [0], "06"), a3 = s2(this.hex, r4[i3], [1], "86");
                "2b06010505073001" === o3 && e3.ocsp.push(Dr(a3)), "2b06010505073002" === o3 && e3.caissuer.push(Dr(a3));
              }
              return e3;
            }, this.getExtAuthorityInfoAccess = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("authorityInfoAccess");
                if (void 0 === r4) return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var i3 = { extname: "authorityInfoAccess", array: [] };
              e3 && (i3.critical = true);
              for (var u3 = n3(t4, 0), c3 = 0; c3 < u3.length; c3++) {
                var h3 = a2(t4, u3[c3], [0], "06"), l3 = Dr(s2(t4, u3[c3], [1], "86"));
                if ("2b06010505073001" == h3) i3.array.push({ ocsp: l3 });
                else {
                  if ("2b06010505073002" != h3) throw new Error("unknown method: " + h3);
                  i3.array.push({ caissuer: l3 });
                }
              }
              return i3;
            }, this.getExtCertificatePolicies = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("certificatePolicies");
                if (void 0 === r4) return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var i3 = { extname: "certificatePolicies", array: [] };
              e3 && (i3.critical = true);
              for (var s3 = n3(t4, 0), a3 = 0; a3 < s3.length; a3++) {
                var u3 = o2(t4, s3[a3]), c3 = this.getPolicyInformation(u3);
                i3.array.push(c3);
              }
              return i3;
            }, this.getPolicyInformation = function(t4) {
              var e3 = {}, r4 = s2(t4, 0, [0], "06");
              e3.policyoid = d2(r4);
              var i3 = l2(t4, 0, [1], "30");
              if (-1 != i3) {
                e3.array = [];
                for (var a3 = n3(t4, i3), u3 = 0; u3 < a3.length; u3++) {
                  var c3 = o2(t4, a3[u3]), h3 = this.getPolicyQualifierInfo(c3);
                  e3.array.push(h3);
                }
              }
              return e3;
            }, this.getPolicyQualifierInfo = function(t4) {
              var e3 = {}, r4 = s2(t4, 0, [0], "06");
              if ("2b06010505070201" === r4) {
                var n4 = a2(t4, 0, [1], "16");
                e3.cps = Lr(n4);
              } else if ("2b06010505070202" === r4) {
                var i3 = u2(t4, 0, [1], "30");
                e3.unotice = this.getUserNotice(i3);
              }
              return e3;
            }, this.getUserNotice = function(t4) {
              for (var e3 = {}, r4 = n3(t4, 0), i3 = 0; i3 < r4.length; i3++) {
                var s3 = o2(t4, r4[i3]);
                "30" != s3.substr(0, 2) && (e3.exptext = this.getDisplayText(s3));
              }
              return e3;
            }, this.getDisplayText = function(t4) {
              var e3 = {};
              return e3.type = { "0c": "utf8", 16: "ia5", "1a": "vis", "1e": "bmp" }[t4.substr(0, 2)], e3.str = Lr(i2(t4, 0)), e3;
            }, this.getExtCRLNumber = function(t4, e3) {
              var r4 = { extname: "cRLNumber" };
              if (e3 && (r4.critical = true), "02" == t4.substr(0, 2)) return r4.num = { hex: i2(t4, 0) }, r4;
              throw new Error("hExtV parse error: " + t4);
            }, this.getExtCRLReason = function(t4, e3) {
              var r4 = { extname: "cRLReason" };
              if (e3 && (r4.critical = true), "0a" == t4.substr(0, 2)) return r4.code = parseInt(i2(t4, 0), 16), r4;
              throw new Error("hExtV parse error: " + t4);
            }, this.getExtOcspNonce = function(t4, e3) {
              var r4 = { extname: "ocspNonce" };
              e3 && (r4.critical = true);
              var n4 = i2(t4, 0);
              return r4.hex = n4, r4;
            }, this.getExtOcspNoCheck = function(t4, e3) {
              var r4 = { extname: "ocspNoCheck" };
              return e3 && (r4.critical = true), r4;
            }, this.getExtAdobeTimeStamp = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("adobeTimeStamp");
                if (void 0 === r4) return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var i3 = { extname: "adobeTimeStamp" };
              e3 && (i3.critical = true);
              var s3 = n3(t4, 0);
              if (s3.length > 1) {
                var a3 = o2(t4, s3[1]), u3 = this.getGeneralName(a3);
                null != u3.uri && (i3.uri = u3.uri);
              }
              if (s3.length > 2) {
                var c3 = o2(t4, s3[2]);
                "0101ff" == c3 && (i3.reqauth = true), "010100" == c3 && (i3.reqauth = false);
              }
              return i3;
            }, this.getX500NameRule = function(t4) {
              for (var e3 = null, r4 = [], n4 = 0; n4 < t4.length; n4++) for (var i3 = t4[n4], o3 = 0; o3 < i3.length; o3++) r4.push(i3[o3]);
              for (n4 = 0; n4 < r4.length; n4++) {
                var s3 = r4[n4], a3 = s3.ds, u3 = s3.value, c3 = s3.type;
                if (":" + a3, "prn" != a3 && "utf8" != a3 && "ia5" != a3) return "mixed";
                if ("ia5" == a3) {
                  if ("CN" != c3) return "mixed";
                  if (Sr.lang.String.isMail(u3)) continue;
                  return "mixed";
                }
                if ("C" == c3) {
                  if ("prn" == a3) continue;
                  return "mixed";
                }
                if (":" + a3, null == e3) e3 = a3;
                else if (e3 !== a3) return "mixed";
              }
              return null == e3 ? "prn" : e3;
            }, this.getX500Name = function(t4) {
              var e3 = this.getX500NameArray(t4);
              return { array: e3, str: this.dnarraytostr(e3) };
            }, this.getX500NameArray = function(t4) {
              for (var e3 = [], r4 = n3(t4, 0), i3 = 0; i3 < r4.length; i3++) e3.push(this.getRDN(o2(t4, r4[i3])));
              return e3;
            }, this.getRDN = function(t4) {
              for (var e3 = [], r4 = n3(t4, 0), i3 = 0; i3 < r4.length; i3++) e3.push(this.getAttrTypeAndValue(o2(t4, r4[i3])));
              return e3;
            }, this.getAttrTypeAndValue = function(t4) {
              var e3 = { type: null, value: null, ds: null }, r4 = n3(t4, 0), i3 = s2(t4, r4[0], [], "06"), o3 = s2(t4, r4[1], []), a3 = Sr.asn1.ASN1Util.oidHexToInt(i3);
              return e3.type = Sr.asn1.x509.OID.oid2atype(a3), e3.ds = this.HEX2STAG[t4.substr(r4[1], 2)], "bmp" != e3.ds ? e3.value = Dr(o3) : e3.value = Yr(o3), e3;
            }, this.readCertPEM = function(t4) {
              this.readCertHex(v3(t4));
            }, this.readCertHex = function(t4) {
              this.hex = t4, this.getVersion();
              try {
                h2(this.hex, 0, [0, 7], "a3"), this.parseExt();
              } catch (t5) {
              }
            }, this.getParam = function() {
              var t4 = {};
              return t4.version = this.getVersion(), t4.serial = { hex: this.getSerialNumberHex() }, t4.sigalg = this.getSignatureAlgorithmField(), t4.issuer = this.getIssuer(), t4.notbefore = this.getNotBefore(), t4.notafter = this.getNotAfter(), t4.subject = this.getSubject(), t4.sbjpubkey = jr(this.getPublicKeyHex(), "PUBLIC KEY"), this.aExtInfo.length > 0 && (t4.ext = this.getExtParamArray()), t4.sighex = this.getSignatureValueHex(), t4;
            }, this.getExtParamArray = function(t4) {
              null == t4 && (-1 != l2(this.hex, 0, [0, "[3]"]) && (t4 = c2(this.hex, 0, [0, "[3]", 0], "30")));
              for (var e3 = [], r4 = n3(t4, 0), i3 = 0; i3 < r4.length; i3++) {
                var s3 = o2(t4, r4[i3]), a3 = this.getExtParam(s3);
                null != a3 && e3.push(a3);
              }
              return e3;
            }, this.getExtParam = function(t4) {
              var e3 = n3(t4, 0).length;
              if (2 != e3 && 3 != e3) throw new Error("wrong number elements in Extension: " + e3 + " " + t4);
              var r4 = p2(s2(t4, 0, [0], "06")), i3 = false;
              3 == e3 && "0101ff" == u2(t4, 0, [1]) && (i3 = true);
              var o3 = u2(t4, 0, [e3 - 1, 0]), a3 = void 0;
              if ("2.5.29.14" == r4 ? a3 = this.getExtSubjectKeyIdentifier(o3, i3) : "2.5.29.15" == r4 ? a3 = this.getExtKeyUsage(o3, i3) : "2.5.29.17" == r4 ? a3 = this.getExtSubjectAltName(o3, i3) : "2.5.29.18" == r4 ? a3 = this.getExtIssuerAltName(o3, i3) : "2.5.29.19" == r4 ? a3 = this.getExtBasicConstraints(o3, i3) : "2.5.29.31" == r4 ? a3 = this.getExtCRLDistributionPoints(o3, i3) : "2.5.29.32" == r4 ? a3 = this.getExtCertificatePolicies(o3, i3) : "2.5.29.35" == r4 ? a3 = this.getExtAuthorityKeyIdentifier(o3, i3) : "2.5.29.37" == r4 ? a3 = this.getExtExtKeyUsage(o3, i3) : "1.3.6.1.5.5.7.1.1" == r4 ? a3 = this.getExtAuthorityInfoAccess(o3, i3) : "2.5.29.20" == r4 ? a3 = this.getExtCRLNumber(o3, i3) : "2.5.29.21" == r4 ? a3 = this.getExtCRLReason(o3, i3) : "1.3.6.1.5.5.7.48.1.2" == r4 ? a3 = this.getExtOcspNonce(o3, i3) : "1.3.6.1.5.5.7.48.1.5" == r4 ? a3 = this.getExtOcspNoCheck(o3, i3) : "1.2.840.113583.1.1.9.1" == r4 && (a3 = this.getExtAdobeTimeStamp(o3, i3)), null != a3) return a3;
              var c3 = { extname: r4, extn: o3 };
              return i3 && (c3.critical = true), c3;
            }, this.findExt = function(t4, e3) {
              for (var r4 = 0; r4 < t4.length; r4++) if (t4[r4].extname == e3) return t4[r4];
              return null;
            }, this.updateExtCDPFullURI = function(t4, e3) {
              var r4 = this.findExt(t4, "cRLDistributionPoints");
              if (null != r4 && null != r4.array) {
                for (var n4 = r4.array, i3 = 0; i3 < n4.length; i3++) if (null != n4[i3].dpname && null != n4[i3].dpname.full) for (var o3 = n4[i3].dpname.full, s3 = 0; s3 < o3.length; s3++) {
                  var a3 = o3[i3];
                  null != a3.uri && (a3.uri = e3);
                }
              }
            }, this.updateExtAIAOCSP = function(t4, e3) {
              var r4 = this.findExt(t4, "authorityInfoAccess");
              if (null != r4 && null != r4.array) for (var n4 = r4.array, i3 = 0; i3 < n4.length; i3++) null != n4[i3].ocsp && (n4[i3].ocsp = e3);
            }, this.updateExtAIACAIssuer = function(t4, e3) {
              var r4 = this.findExt(t4, "authorityInfoAccess");
              if (null != r4 && null != r4.array) for (var n4 = r4.array, i3 = 0; i3 < n4.length; i3++) null != n4[i3].caissuer && (n4[i3].caissuer = e3);
            }, this.dnarraytostr = function(t4) {
              return "/" + t4.map(function(t5) {
                return function e3(t6) {
                  return t6.map(function(t7) {
                    return function e4(t8) {
                      return t8.type + "=" + t8.value;
                    }(t7).replace(/\+/, "\\+");
                  }).join("+");
                }(t5).replace(/\//, "\\/");
              }).join("/");
            }, this.getInfo = function() {
              var t4, e3, r4, n4 = function t5(e4) {
                return JSON.stringify(e4.array).replace(/[\[\]\{\}\"]/g, "");
              }, i3 = function t5(e4) {
                for (var r5 = "", n5 = e4.array, i4 = 0; i4 < n5.length; i4++) {
                  var o4 = n5[i4];
                  if (r5 += "    policy oid: " + o4.policyoid + "\n", void 0 !== o4.array) for (var s4 = 0; s4 < o4.array.length; s4++) {
                    var a4 = o4.array[s4];
                    void 0 !== a4.cps && (r5 += "    cps: " + a4.cps + "\n");
                  }
                }
                return r5;
              }, o3 = function t5(e4) {
                for (var r5 = "", n5 = e4.array, i4 = 0; i4 < n5.length; i4++) {
                  var o4 = n5[i4];
                  try {
                    void 0 !== o4.dpname.full[0].uri && (r5 += "    " + o4.dpname.full[0].uri + "\n");
                  } catch (t6) {
                  }
                  try {
                    void 0 !== o4.dname.full[0].dn.hex && (r5 += "    " + on.hex2dn(o4.dpname.full[0].dn.hex) + "\n");
                  } catch (t6) {
                  }
                }
                return r5;
              }, s3 = function t5(e4) {
                for (var r5 = "", n5 = e4.array, i4 = 0; i4 < n5.length; i4++) {
                  var o4 = n5[i4];
                  void 0 !== o4.caissuer && (r5 += "    caissuer: " + o4.caissuer + "\n"), void 0 !== o4.ocsp && (r5 += "    ocsp: " + o4.ocsp + "\n");
                }
                return r5;
              };
              if (t4 = "Basic Fields\n", t4 += "  serial number: " + this.getSerialNumberHex() + "\n", t4 += "  signature algorithm: " + this.getSignatureAlgorithmField() + "\n", t4 += "  issuer: " + this.getIssuerString() + "\n", t4 += "  notBefore: " + this.getNotBefore() + "\n", t4 += "  notAfter: " + this.getNotAfter() + "\n", t4 += "  subject: " + this.getSubjectString() + "\n", t4 += "  subject public key info: \n", t4 += "    key algorithm: " + (e3 = this.getPublicKey()).type + "\n", "RSA" === e3.type && (t4 += "    n=" + $r(e3.n.toString(16)).substr(0, 16) + "...\n", t4 += "    e=" + $r(e3.e.toString(16)) + "\n"), null != (r4 = this.aExtInfo)) {
                t4 += "X509v3 Extensions:\n";
                for (var a3 = 0; a3 < r4.length; a3++) {
                  var u3 = r4[a3], c3 = Sr.asn1.x509.OID.oid2name(u3.oid);
                  "" === c3 && (c3 = u3.oid);
                  var h3 = "";
                  if (true === u3.critical && (h3 = "CRITICAL"), t4 += "  " + c3 + " " + h3 + ":\n", "basicConstraints" === c3) {
                    var l3 = this.getExtBasicConstraints();
                    void 0 === l3.cA ? t4 += "    {}\n" : (t4 += "    cA=true", void 0 !== l3.pathLen && (t4 += ", pathLen=" + l3.pathLen), t4 += "\n");
                  } else if ("keyUsage" === c3) t4 += "    " + this.getExtKeyUsageString() + "\n";
                  else if ("subjectKeyIdentifier" === c3) t4 += "    " + this.getExtSubjectKeyIdentifier().kid.hex + "\n";
                  else if ("authorityKeyIdentifier" === c3) {
                    var f3 = this.getExtAuthorityKeyIdentifier();
                    void 0 !== f3.kid && (t4 += "    kid=" + f3.kid.hex + "\n");
                  } else {
                    if ("extKeyUsage" === c3) t4 += "    " + this.getExtExtKeyUsage().array.join(", ") + "\n";
                    else if ("subjectAltName" === c3) t4 += "    " + n4(this.getExtSubjectAltName()) + "\n";
                    else if ("cRLDistributionPoints" === c3) t4 += o3(this.getExtCRLDistributionPoints());
                    else if ("authorityInfoAccess" === c3) t4 += s3(this.getExtAuthorityInfoAccess());
                    else "certificatePolicies" === c3 && (t4 += i3(this.getExtCertificatePolicies()));
                  }
                }
              }
              return t4 += "signature algorithm: " + this.getSignatureAlgorithmName() + "\n", t4 += "signature: " + this.getSignatureValueHex().substr(0, 16) + "...\n";
            }, "string" == typeof t3 && (-1 != t3.indexOf("-----BEGIN") ? this.readCertPEM(t3) : Sr.lang.String.isHex(t3) && this.readCertHex(t3));
          }
          Me2.prototype.sign = function(t3, e2) {
            var r3 = function t4(r4) {
              return Sr.crypto.Util.hashString(r4, e2);
            }(t3);
            return this.signWithMessageHash(r3, e2);
          }, Me2.prototype.signWithMessageHash = function(t3, e2) {
            var r3 = Oe(Sr.crypto.Util.getPaddedDigestInfoHex(t3, e2, this.n.bitLength()), 16);
            return en(this.doPrivate(r3).toString(16), this.n.bitLength());
          }, Me2.prototype.signPSS = function(t3, e2, r3) {
            var n3 = function t4(r4) {
              return Sr.crypto.Util.hashHex(r4, e2);
            }(Nr(t3));
            return void 0 === r3 && (r3 = -1), this.signWithMessageHashPSS(n3, e2, r3);
          }, Me2.prototype.signWithMessageHashPSS = function(t3, e2, r3) {
            var n3, i2 = Lr(t3), o2 = i2.length, s2 = this.n.bitLength() - 1, a2 = Math.ceil(s2 / 8), u2 = function t4(r4) {
              return Sr.crypto.Util.hashHex(r4, e2);
            };
            if (-1 === r3 || void 0 === r3) r3 = o2;
            else if (-2 === r3) r3 = a2 - o2 - 2;
            else if (r3 < -2) throw new Error("invalid salt length");
            if (a2 < o2 + r3 + 2) throw new Error("data too long");
            var c2 = "";
            r3 > 0 && (c2 = new Array(r3), new Be().nextBytes(c2), c2 = String.fromCharCode.apply(String, c2));
            var h2 = Lr(u2(Nr("\0\0\0\0\0\0\0\0" + i2 + c2))), l2 = [];
            for (n3 = 0; n3 < a2 - r3 - o2 - 2; n3 += 1) l2[n3] = 0;
            var f2 = String.fromCharCode.apply(String, l2) + "" + c2, g2 = rn(h2, f2.length, u2), d2 = [];
            for (n3 = 0; n3 < f2.length; n3 += 1) d2[n3] = f2.charCodeAt(n3) ^ g2.charCodeAt(n3);
            var p2 = 65280 >> 8 * a2 - s2 & 255;
            for (d2[0] &= ~p2, n3 = 0; n3 < o2; n3++) d2.push(h2.charCodeAt(n3));
            return d2.push(188), en(this.doPrivate(new w(d2)).toString(16), this.n.bitLength());
          }, Me2.prototype.verify = function(t3, e2) {
            if (null == (e2 = e2.toLowerCase()).match(/^[0-9a-f]+$/)) return false;
            var r3 = Oe(e2, 16), n3 = this.n.bitLength();
            if (r3.bitLength() > n3) return false;
            var i2 = this.doPublic(r3).toString(16);
            if (i2.length + 3 != n3 / 4) return false;
            var o2 = nn(i2.replace(/^1f+00/, ""));
            if (0 == o2.length) return false;
            var s2 = o2[0];
            return o2[1] == function t4(e3) {
              return Sr.crypto.Util.hashString(e3, s2);
            }(t3);
          }, Me2.prototype.verifyWithMessageHash = function(t3, e2) {
            if (e2.length != Math.ceil(this.n.bitLength() / 4)) return false;
            var r3 = Oe(e2, 16);
            if (r3.bitLength() > this.n.bitLength()) return 0;
            var n3 = nn(this.doPublic(r3).toString(16).replace(/^1f+00/, ""));
            if (0 == n3.length) return false;
            n3[0];
            return n3[1] == t3;
          }, Me2.prototype.verifyPSS = function(t3, e2, r3, n3) {
            var i2 = function t4(e3) {
              return Sr.crypto.Util.hashHex(e3, r3);
            }(Nr(t3));
            return void 0 === n3 && (n3 = -1), this.verifyWithMessageHashPSS(i2, e2, r3, n3);
          }, Me2.prototype.verifyWithMessageHashPSS = function(t3, e2, r3, n3) {
            if (e2.length != Math.ceil(this.n.bitLength() / 4)) return false;
            var i2, o2 = new w(e2, 16), s2 = function t4(e3) {
              return Sr.crypto.Util.hashHex(e3, r3);
            }, a2 = Lr(t3), u2 = a2.length, c2 = this.n.bitLength() - 1, h2 = Math.ceil(c2 / 8);
            if (-1 === n3 || void 0 === n3) n3 = u2;
            else if (-2 === n3) n3 = h2 - u2 - 2;
            else if (n3 < -2) throw new Error("invalid salt length");
            if (h2 < u2 + n3 + 2) throw new Error("data too long");
            var l2 = this.doPublic(o2).toByteArray();
            for (i2 = 0; i2 < l2.length; i2 += 1) l2[i2] &= 255;
            for (; l2.length < h2; ) l2.unshift(0);
            if (188 !== l2[h2 - 1]) throw new Error("encoded message does not end in 0xbc");
            var f2 = (l2 = String.fromCharCode.apply(String, l2)).substr(0, h2 - u2 - 1), g2 = l2.substr(f2.length, u2), d2 = 65280 >> 8 * h2 - c2 & 255;
            if (0 != (f2.charCodeAt(0) & d2)) throw new Error("bits beyond keysize not zero");
            var p2 = rn(g2, f2.length, s2), v3 = [];
            for (i2 = 0; i2 < f2.length; i2 += 1) v3[i2] = f2.charCodeAt(i2) ^ p2.charCodeAt(i2);
            v3[0] &= ~d2;
            var y2 = h2 - u2 - n3 - 2;
            for (i2 = 0; i2 < y2; i2 += 1) if (0 !== v3[i2]) throw new Error("leftmost octets not zero");
            if (1 !== v3[y2]) throw new Error("0x01 marker not found");
            return g2 === Lr(s2(Nr("\0\0\0\0\0\0\0\0" + a2 + String.fromCharCode.apply(String, v3.slice(-n3)))));
          }, Me2.SALT_LEN_HLEN = -1, Me2.SALT_LEN_MAX = -2, Me2.SALT_LEN_RECOVER = -2, on.hex2dn = function(t3, e2) {
            void 0 === e2 && (e2 = 0);
            var r3 = new on();
            Fr.getTLV(t3, e2);
            return r3.getX500Name(t3).str;
          }, on.hex2rdn = function(t3, e2) {
            if (void 0 === e2 && (e2 = 0), "31" !== t3.substr(e2, 2)) throw new Error("malformed RDN");
            for (var r3 = new Array(), n3 = Fr.getChildIdx(t3, e2), i2 = 0; i2 < n3.length; i2++) r3.push(on.hex2attrTypeValue(t3, n3[i2]));
            return (r3 = r3.map(function(t4) {
              return t4.replace("+", "\\+");
            })).join("+");
          }, on.hex2attrTypeValue = function(t3, e2) {
            var r3 = Fr, n3 = r3.getV;
            if (void 0 === e2 && (e2 = 0), "30" !== t3.substr(e2, 2)) throw new Error("malformed attribute type and value");
            var i2 = r3.getChildIdx(t3, e2);
            2 !== i2.length || t3.substr(i2[0], 2);
            var o2 = n3(t3, i2[0]), s2 = Sr.asn1.ASN1Util.oidHexToInt(o2);
            return Sr.asn1.x509.OID.oid2atype(s2) + "=" + Lr(n3(t3, i2[1]));
          }, on.getPublicKeyFromCertHex = function(t3) {
            var e2 = new on();
            return e2.readCertHex(t3), e2.getPublicKey();
          }, on.getPublicKeyFromCertPEM = function(t3) {
            var e2 = new on();
            return e2.readCertPEM(t3), e2.getPublicKey();
          }, on.getPublicKeyInfoPropOfCertPEM = function(t3) {
            var e2, r3, n3 = Fr.getVbyList, i2 = {};
            return i2.algparam = null, (e2 = new on()).readCertPEM(t3), r3 = e2.getPublicKeyHex(), i2.keyhex = n3(r3, 0, [1], "03").substr(2), i2.algoid = n3(r3, 0, [0, 0], "06"), "2a8648ce3d0201" === i2.algoid && (i2.algparam = n3(r3, 0, [0, 1], "06")), i2;
          }, on.KEYUSAGE_NAME = ["digitalSignature", "nonRepudiation", "keyEncipherment", "dataEncipherment", "keyAgreement", "keyCertSign", "cRLSign", "encipherOnly", "decipherOnly"], void 0 !== Sr && Sr || (e.KJUR = Sr = {}), void 0 !== Sr.jws && Sr.jws || (Sr.jws = {}), Sr.jws.JWS = function() {
            var t3 = Sr.jws.JWS.isSafeJSONString;
            this.parseJWS = function(e2, r3) {
              if (void 0 === this.parsedJWS || !r3 && void 0 === this.parsedJWS.sigvalH) {
                var n3 = e2.match(/^([^.]+)\.([^.]+)\.([^.]+)$/);
                if (null == n3) throw "JWS signature is not a form of 'Head.Payload.SigValue'.";
                var i2 = n3[1], o2 = n3[2], s2 = n3[3], a2 = i2 + "." + o2;
                if (this.parsedJWS = {}, this.parsedJWS.headB64U = i2, this.parsedJWS.payloadB64U = o2, this.parsedJWS.sigvalB64U = s2, this.parsedJWS.si = a2, !r3) {
                  var u2 = Rr(s2), c2 = Oe(u2, 16);
                  this.parsedJWS.sigvalH = u2, this.parsedJWS.sigvalBI = c2;
                }
                var h2 = wr(i2), l2 = wr(o2);
                if (this.parsedJWS.headS = h2, this.parsedJWS.payloadS = l2, !t3(h2, this.parsedJWS, "headP")) throw "malformed JSON string for JWS Head: " + h2;
              }
            };
          }, Sr.jws.JWS.sign = function(t3, e2, r3, n3, i2) {
            var o2, s2, a2, u2 = Sr, c2 = u2.jws.JWS, h2 = c2.readSafeJSONString, l2 = c2.isSafeJSONString, f2 = u2.crypto, d2 = (f2.ECDSA, f2.Mac), p2 = f2.Signature, v3 = JSON;
            if ("string" != typeof e2 && "object" != (void 0 === e2 ? "undefined" : g(e2))) throw "spHeader must be JSON string or object: " + e2;
            if ("object" == (void 0 === e2 ? "undefined" : g(e2)) && (s2 = e2, o2 = v3.stringify(s2)), "string" == typeof e2) {
              if (!l2(o2 = e2)) throw "JWS Head is not safe JSON string: " + o2;
              s2 = h2(o2);
            }
            if (a2 = r3, "object" == (void 0 === r3 ? "undefined" : g(r3)) && (a2 = v3.stringify(r3)), "" != t3 && null != t3 || void 0 === s2.alg || (t3 = s2.alg), "" != t3 && null != t3 && void 0 === s2.alg && (s2.alg = t3, o2 = v3.stringify(s2)), t3 !== s2.alg) throw "alg and sHeader.alg doesn't match: " + t3 + "!=" + s2.alg;
            var y2 = null;
            if (void 0 === c2.jwsalg2sigalg[t3]) throw "unsupported alg name: " + t3;
            y2 = c2.jwsalg2sigalg[t3];
            var m2 = br(o2) + "." + br(a2), _2 = "";
            if ("Hmac" == y2.substr(0, 4)) {
              if (void 0 === n3) throw "mac key shall be specified for HS* alg";
              var S2 = new d2({ alg: y2, prov: "cryptojs", pass: n3 });
              S2.updateString(m2), _2 = S2.doFinal();
            } else if (-1 != y2.indexOf("withECDSA")) {
              (w2 = new p2({ alg: y2 })).init(n3, i2), w2.updateString(m2);
              var b2 = w2.sign();
              _2 = Sr.crypto.ECDSA.asn1SigToConcatSig(b2);
            } else {
              var w2;
              if ("none" != y2) (w2 = new p2({ alg: y2 })).init(n3, i2), w2.updateString(m2), _2 = w2.sign();
            }
            return m2 + "." + Tr(_2);
          }, Sr.jws.JWS.verify = function(t3, e2, r3) {
            var n3, i2 = Sr, o2 = i2.jws.JWS, s2 = o2.readSafeJSONString, a2 = i2.crypto, u2 = a2.ECDSA, c2 = a2.Mac, h2 = a2.Signature;
            void 0 !== g(Me2) && (n3 = Me2);
            var l2 = t3.split(".");
            if (3 !== l2.length) return false;
            var f2 = l2[0] + "." + l2[1], d2 = Rr(l2[2]), p2 = s2(wr(l2[0])), v3 = null, y2 = null;
            if (void 0 === p2.alg) throw "algorithm not specified in header";
            if ((y2 = (v3 = p2.alg).substr(0, 2), null != r3 && "[object Array]" === Object.prototype.toString.call(r3) && r3.length > 0) && -1 == (":" + r3.join(":") + ":").indexOf(":" + v3 + ":")) throw "algorithm '" + v3 + "' not accepted in the list";
            if ("none" != v3 && null === e2) throw "key shall be specified to verify.";
            if ("string" == typeof e2 && -1 != e2.indexOf("-----BEGIN ") && (e2 = tn.getKey(e2)), !("RS" != y2 && "PS" != y2 || e2 instanceof n3)) throw "key shall be a RSAKey obj for RS* and PS* algs";
            if ("ES" == y2 && !(e2 instanceof u2)) throw "key shall be a ECDSA obj for ES* algs";
            var m2 = null;
            if (void 0 === o2.jwsalg2sigalg[p2.alg]) throw "unsupported alg name: " + v3;
            if ("none" == (m2 = o2.jwsalg2sigalg[v3])) throw "not supported";
            if ("Hmac" == m2.substr(0, 4)) {
              if (void 0 === e2) throw "hexadecimal key shall be specified for HMAC";
              var _2 = new c2({ alg: m2, pass: e2 });
              return _2.updateString(f2), d2 == _2.doFinal();
            }
            if (-1 != m2.indexOf("withECDSA")) {
              var S2, b2 = null;
              try {
                b2 = u2.concatSigToASN1Sig(d2);
              } catch (t4) {
                return false;
              }
              return (S2 = new h2({ alg: m2 })).init(e2), S2.updateString(f2), S2.verify(b2);
            }
            return (S2 = new h2({ alg: m2 })).init(e2), S2.updateString(f2), S2.verify(d2);
          }, Sr.jws.JWS.parse = function(t3) {
            var e2, r3, n3, i2 = t3.split("."), o2 = {};
            if (2 != i2.length && 3 != i2.length) throw "malformed sJWS: wrong number of '.' splitted elements";
            return e2 = i2[0], r3 = i2[1], 3 == i2.length && (n3 = i2[2]), o2.headerObj = Sr.jws.JWS.readSafeJSONString(wr(e2)), o2.payloadObj = Sr.jws.JWS.readSafeJSONString(wr(r3)), o2.headerPP = JSON.stringify(o2.headerObj, null, "  "), null == o2.payloadObj ? o2.payloadPP = wr(r3) : o2.payloadPP = JSON.stringify(o2.payloadObj, null, "  "), void 0 !== n3 && (o2.sigHex = Rr(n3)), o2;
          }, Sr.jws.JWS.verifyJWT = function(t3, e2, r3) {
            var n3 = Sr.jws, i2 = n3.JWS, o2 = i2.readSafeJSONString, s2 = i2.inArray, a2 = i2.includedArray, u2 = t3.split("."), c2 = u2[0], h2 = u2[1], l2 = (Rr(u2[2]), o2(wr(c2))), f2 = o2(wr(h2));
            if (void 0 === l2.alg) return false;
            if (void 0 === r3.alg) throw "acceptField.alg shall be specified";
            if (!s2(l2.alg, r3.alg)) return false;
            if (void 0 !== f2.iss && "object" === g(r3.iss) && !s2(f2.iss, r3.iss)) return false;
            if (void 0 !== f2.sub && "object" === g(r3.sub) && !s2(f2.sub, r3.sub)) return false;
            if (void 0 !== f2.aud && "object" === g(r3.aud)) {
              if ("string" == typeof f2.aud) {
                if (!s2(f2.aud, r3.aud)) return false;
              } else if ("object" == g(f2.aud) && !a2(f2.aud, r3.aud)) return false;
            }
            var d2 = n3.IntDate.getNow();
            return void 0 !== r3.verifyAt && "number" == typeof r3.verifyAt && (d2 = r3.verifyAt), void 0 !== r3.gracePeriod && "number" == typeof r3.gracePeriod || (r3.gracePeriod = 0), !(void 0 !== f2.exp && "number" == typeof f2.exp && f2.exp + r3.gracePeriod < d2) && (!(void 0 !== f2.nbf && "number" == typeof f2.nbf && d2 < f2.nbf - r3.gracePeriod) && (!(void 0 !== f2.iat && "number" == typeof f2.iat && d2 < f2.iat - r3.gracePeriod) && ((void 0 === f2.jti || void 0 === r3.jti || f2.jti === r3.jti) && !!i2.verify(t3, e2, r3.alg))));
          }, Sr.jws.JWS.includedArray = function(t3, e2) {
            var r3 = Sr.jws.JWS.inArray;
            if (null === t3) return false;
            if ("object" !== (void 0 === t3 ? "undefined" : g(t3))) return false;
            if ("number" != typeof t3.length) return false;
            for (var n3 = 0; n3 < t3.length; n3++) if (!r3(t3[n3], e2)) return false;
            return true;
          }, Sr.jws.JWS.inArray = function(t3, e2) {
            if (null === e2) return false;
            if ("object" !== (void 0 === e2 ? "undefined" : g(e2))) return false;
            if ("number" != typeof e2.length) return false;
            for (var r3 = 0; r3 < e2.length; r3++) if (e2[r3] == t3) return true;
            return false;
          }, Sr.jws.JWS.jwsalg2sigalg = { HS256: "HmacSHA256", HS384: "HmacSHA384", HS512: "HmacSHA512", RS256: "SHA256withRSA", RS384: "SHA384withRSA", RS512: "SHA512withRSA", ES256: "SHA256withECDSA", ES384: "SHA384withECDSA", PS256: "SHA256withRSAandMGF1", PS384: "SHA384withRSAandMGF1", PS512: "SHA512withRSAandMGF1", none: "none" }, Sr.jws.JWS.isSafeJSONString = function(t3, e2, r3) {
            var n3 = null;
            try {
              return "object" != (void 0 === (n3 = _r(t3)) ? "undefined" : g(n3)) || n3.constructor === Array ? 0 : (e2 && (e2[r3] = n3), 1);
            } catch (t4) {
              return 0;
            }
          }, Sr.jws.JWS.readSafeJSONString = function(t3) {
            var e2 = null;
            try {
              return "object" != (void 0 === (e2 = _r(t3)) ? "undefined" : g(e2)) || e2.constructor === Array ? null : e2;
            } catch (t4) {
              return null;
            }
          }, Sr.jws.JWS.getEncodedSignatureValueFromJWS = function(t3) {
            var e2 = t3.match(/^[^.]+\.[^.]+\.([^.]+)$/);
            if (null == e2) throw "JWS signature is not a form of 'Head.Payload.SigValue'.";
            return e2[1];
          }, Sr.jws.JWS.getJWKthumbprint = function(t3) {
            if ("RSA" !== t3.kty && "EC" !== t3.kty && "oct" !== t3.kty) throw "unsupported algorithm for JWK Thumprint";
            var e2 = "{";
            if ("RSA" === t3.kty) {
              if ("string" != typeof t3.n || "string" != typeof t3.e) throw "wrong n and e value for RSA key";
              e2 += '"e":"' + t3.e + '",', e2 += '"kty":"' + t3.kty + '",', e2 += '"n":"' + t3.n + '"}';
            } else if ("EC" === t3.kty) {
              if ("string" != typeof t3.crv || "string" != typeof t3.x || "string" != typeof t3.y) throw "wrong crv, x and y value for EC key";
              e2 += '"crv":"' + t3.crv + '",', e2 += '"kty":"' + t3.kty + '",', e2 += '"x":"' + t3.x + '",', e2 += '"y":"' + t3.y + '"}';
            } else if ("oct" === t3.kty) {
              if ("string" != typeof t3.k) throw "wrong k value for oct(symmetric) key";
              e2 += '"kty":"' + t3.kty + '",', e2 += '"k":"' + t3.k + '"}';
            }
            var r3 = Nr(e2);
            return Tr(Sr.crypto.Util.hashHex(r3, "sha256"));
          }, Sr.jws.IntDate = {}, Sr.jws.IntDate.get = function(t3) {
            var e2 = Sr.jws.IntDate, r3 = e2.getNow, n3 = e2.getZulu;
            if ("now" == t3) return r3();
            if ("now + 1hour" == t3) return r3() + 3600;
            if ("now + 1day" == t3) return r3() + 86400;
            if ("now + 1month" == t3) return r3() + 2592e3;
            if ("now + 1year" == t3) return r3() + 31536e3;
            if (t3.match(/Z$/)) return n3(t3);
            if (t3.match(/^[0-9]+$/)) return parseInt(t3);
            throw "unsupported format: " + t3;
          }, Sr.jws.IntDate.getZulu = function(t3) {
            return Vr(t3);
          }, Sr.jws.IntDate.getNow = function() {
            return ~~(/* @__PURE__ */ new Date() / 1e3);
          }, Sr.jws.IntDate.intDate2UTCString = function(t3) {
            return new Date(1e3 * t3).toUTCString();
          }, Sr.jws.IntDate.intDate2Zulu = function(t3) {
            var e2 = new Date(1e3 * t3);
            return ("0000" + e2.getUTCFullYear()).slice(-4) + ("00" + (e2.getUTCMonth() + 1)).slice(-2) + ("00" + e2.getUTCDate()).slice(-2) + ("00" + e2.getUTCHours()).slice(-2) + ("00" + e2.getUTCMinutes()).slice(-2) + ("00" + e2.getUTCSeconds()).slice(-2) + "Z";
          }, e.SecureRandom = Be, e.rng_seed_time = Re, e.BigInteger = w, e.RSAKey = Me2;
          var sn = Sr.crypto.EDSA;
          e.EDSA = sn;
          var an = Sr.crypto.DSA;
          e.DSA = an;
          var un = Sr.crypto.Signature;
          e.Signature = un;
          var cn = Sr.crypto.MessageDigest;
          e.MessageDigest = cn;
          var hn = Sr.crypto.Mac;
          e.Mac = hn;
          var ln = Sr.crypto.Cipher;
          e.Cipher = ln, e.KEYUTIL = tn, e.ASN1HEX = Fr, e.X509 = on, e.CryptoJS = v2, e.b64tohex = S, e.b64toBA = b, e.stoBA = Er, e.BAtos = xr, e.BAtohex = Ar, e.stohex = kr, e.stob64 = function fn2(t3) {
            return _(kr(t3));
          }, e.stob64u = function gn(t3) {
            return Pr(_(kr(t3)));
          }, e.b64utos = function dn(t3) {
            return xr(b(Cr(t3)));
          }, e.b64tob64u = Pr, e.b64utob64 = Cr, e.hex2b64 = _, e.hextob64u = Tr, e.b64utohex = Rr, e.utf8tob64u = br, e.b64utoutf8 = wr, e.utf8tob64 = function pn(t3) {
            return _(Kr(Gr(t3)));
          }, e.b64toutf8 = function vn(t3) {
            return decodeURIComponent(qr(S(t3)));
          }, e.utf8tohex = Ir, e.hextoutf8 = Dr, e.hextorstr = Lr, e.rstrtohex = Nr, e.hextob64 = Ur, e.hextob64nl = Br, e.b64nltohex = Or, e.hextopem = jr, e.pemtohex = Mr, e.hextoArrayBuffer = function yn(t3) {
            if (t3.length % 2 != 0) throw "input is not even length";
            if (null == t3.match(/^[0-9A-Fa-f]+$/)) throw "input is not hexadecimal";
            for (var e2 = new ArrayBuffer(t3.length / 2), r3 = new DataView(e2), n3 = 0; n3 < t3.length / 2; n3++) r3.setUint8(n3, parseInt(t3.substr(2 * n3, 2), 16));
            return e2;
          }, e.ArrayBuffertohex = function mn(t3) {
            for (var e2 = "", r3 = new DataView(t3), n3 = 0; n3 < t3.byteLength; n3++) e2 += ("00" + r3.getUint8(n3).toString(16)).slice(-2);
            return e2;
          }, e.zulutomsec = Hr, e.zulutosec = Vr, e.zulutodate = function _n(t3) {
            return new Date(Hr(t3));
          }, e.datetozulu = function Sn(t3, e2, r3) {
            var n3, i2 = t3.getUTCFullYear();
            if (e2) {
              if (i2 < 1950 || 2049 < i2) throw "not proper year for UTCTime: " + i2;
              n3 = ("" + i2).slice(-2);
            } else n3 = ("000" + i2).slice(-4);
            if (n3 += ("0" + (t3.getUTCMonth() + 1)).slice(-2), n3 += ("0" + t3.getUTCDate()).slice(-2), n3 += ("0" + t3.getUTCHours()).slice(-2), n3 += ("0" + t3.getUTCMinutes()).slice(-2), n3 += ("0" + t3.getUTCSeconds()).slice(-2), r3) {
              var o2 = t3.getUTCMilliseconds();
              0 !== o2 && (n3 += "." + (o2 = (o2 = ("00" + o2).slice(-3)).replace(/0+$/g, "")));
            }
            return n3 += "Z";
          }, e.uricmptohex = Kr, e.hextouricmp = qr, e.ipv6tohex = Jr, e.hextoipv6 = Wr, e.hextoip = zr, e.iptohex = function bn(t3) {
            var e2 = "malformed IP address";
            if (!(t3 = t3.toLowerCase(t3)).match(/^[0-9.]+$/)) {
              if (t3.match(/^[0-9a-f:]+$/) && -1 !== t3.indexOf(":")) return Jr(t3);
              throw e2;
            }
            var r3 = t3.split(".");
            if (4 !== r3.length) throw e2;
            var n3 = "";
            try {
              for (var i2 = 0; i2 < 4; i2++) {
                n3 += ("0" + parseInt(r3[i2]).toString(16)).slice(-2);
              }
              return n3;
            } catch (t4) {
              throw e2;
            }
          }, e.encodeURIComponentAll = Gr, e.newline_toUnix = function wn(t3) {
            return t3 = t3.replace(/\r\n/gm, "\n");
          }, e.newline_toDos = function Fn(t3) {
            return t3 = (t3 = t3.replace(/\r\n/gm, "\n")).replace(/\n/gm, "\r\n");
          }, e.hextoposhex = $r, e.intarystrtohex = function En(t3) {
            t3 = (t3 = (t3 = t3.replace(/^\s*\[\s*/, "")).replace(/\s*\]\s*$/, "")).replace(/\s*/g, "");
            try {
              return t3.split(/,/).map(function(t4, e2, r3) {
                var n3 = parseInt(t4);
                if (n3 < 0 || 255 < n3) throw "integer not in range 0-255";
                return ("00" + n3.toString(16)).slice(-2);
              }).join("");
            } catch (t4) {
              throw "malformed integer array string: " + t4;
            }
          }, e.strdiffidx = function t3(e2, r3) {
            var n3 = e2.length;
            e2.length > r3.length && (n3 = r3.length);
            for (var i2 = 0; i2 < n3; i2++) if (e2.charCodeAt(i2) != r3.charCodeAt(i2)) return i2;
            return e2.length != r3.length ? n3 : -1;
          }, e.KJUR = Sr;
          var xn = Sr.crypto;
          e.crypto = xn;
          var An = Sr.asn1;
          e.asn1 = An;
          var kn = Sr.jws;
          e.jws = kn;
          var Pn = Sr.lang;
          e.lang = Pn;
        }).call(this, r(28).Buffer);
      }, function(t, e, r) {
        "use strict";
        (function(t2) {
          var n2 = r(30), i = r(31), o = r(32);
          function s() {
            return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
          }
          function a(t3, e2) {
            if (s() < e2) throw new RangeError("Invalid typed array length");
            return u.TYPED_ARRAY_SUPPORT ? (t3 = new Uint8Array(e2)).__proto__ = u.prototype : (null === t3 && (t3 = new u(e2)), t3.length = e2), t3;
          }
          function u(t3, e2, r2) {
            if (!(u.TYPED_ARRAY_SUPPORT || this instanceof u)) return new u(t3, e2, r2);
            if ("number" == typeof t3) {
              if ("string" == typeof e2) throw new Error("If encoding is specified then the first argument must be a string");
              return l(this, t3);
            }
            return c(this, t3, e2, r2);
          }
          function c(t3, e2, r2, n3) {
            if ("number" == typeof e2) throw new TypeError('"value" argument must not be a number');
            return "undefined" != typeof ArrayBuffer && e2 instanceof ArrayBuffer ? function i2(t4, e3, r3, n4) {
              if (e3.byteLength, r3 < 0 || e3.byteLength < r3) throw new RangeError("'offset' is out of bounds");
              if (e3.byteLength < r3 + (n4 || 0)) throw new RangeError("'length' is out of bounds");
              e3 = void 0 === r3 && void 0 === n4 ? new Uint8Array(e3) : void 0 === n4 ? new Uint8Array(e3, r3) : new Uint8Array(e3, r3, n4);
              u.TYPED_ARRAY_SUPPORT ? (t4 = e3).__proto__ = u.prototype : t4 = f(t4, e3);
              return t4;
            }(t3, e2, r2, n3) : "string" == typeof e2 ? function s2(t4, e3, r3) {
              "string" == typeof r3 && "" !== r3 || (r3 = "utf8");
              if (!u.isEncoding(r3)) throw new TypeError('"encoding" must be a valid string encoding');
              var n4 = 0 | d(e3, r3), i2 = (t4 = a(t4, n4)).write(e3, r3);
              i2 !== n4 && (t4 = t4.slice(0, i2));
              return t4;
            }(t3, e2, r2) : function c2(t4, e3) {
              if (u.isBuffer(e3)) {
                var r3 = 0 | g(e3.length);
                return 0 === (t4 = a(t4, r3)).length || e3.copy(t4, 0, 0, r3), t4;
              }
              if (e3) {
                if ("undefined" != typeof ArrayBuffer && e3.buffer instanceof ArrayBuffer || "length" in e3) return "number" != typeof e3.length || function n4(t5) {
                  return t5 != t5;
                }(e3.length) ? a(t4, 0) : f(t4, e3);
                if ("Buffer" === e3.type && o(e3.data)) return f(t4, e3.data);
              }
              throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
            }(t3, e2);
          }
          function h(t3) {
            if ("number" != typeof t3) throw new TypeError('"size" argument must be a number');
            if (t3 < 0) throw new RangeError('"size" argument must not be negative');
          }
          function l(t3, e2) {
            if (h(e2), t3 = a(t3, e2 < 0 ? 0 : 0 | g(e2)), !u.TYPED_ARRAY_SUPPORT) for (var r2 = 0; r2 < e2; ++r2) t3[r2] = 0;
            return t3;
          }
          function f(t3, e2) {
            var r2 = e2.length < 0 ? 0 : 0 | g(e2.length);
            t3 = a(t3, r2);
            for (var n3 = 0; n3 < r2; n3 += 1) t3[n3] = 255 & e2[n3];
            return t3;
          }
          function g(t3) {
            if (t3 >= s()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s().toString(16) + " bytes");
            return 0 | t3;
          }
          function d(t3, e2) {
            if (u.isBuffer(t3)) return t3.length;
            if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t3) || t3 instanceof ArrayBuffer)) return t3.byteLength;
            "string" != typeof t3 && (t3 = "" + t3);
            var r2 = t3.length;
            if (0 === r2) return 0;
            for (var n3 = false; ; ) switch (e2) {
              case "ascii":
              case "latin1":
              case "binary":
                return r2;
              case "utf8":
              case "utf-8":
              case void 0:
                return K(t3).length;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return 2 * r2;
              case "hex":
                return r2 >>> 1;
              case "base64":
                return q(t3).length;
              default:
                if (n3) return K(t3).length;
                e2 = ("" + e2).toLowerCase(), n3 = true;
            }
          }
          function p(t3, e2, r2) {
            var n3 = false;
            if ((void 0 === e2 || e2 < 0) && (e2 = 0), e2 > this.length) return "";
            if ((void 0 === r2 || r2 > this.length) && (r2 = this.length), r2 <= 0) return "";
            if ((r2 >>>= 0) <= (e2 >>>= 0)) return "";
            for (t3 || (t3 = "utf8"); ; ) switch (t3) {
              case "hex":
                return I(this, e2, r2);
              case "utf8":
              case "utf-8":
                return A(this, e2, r2);
              case "ascii":
                return T(this, e2, r2);
              case "latin1":
              case "binary":
                return R(this, e2, r2);
              case "base64":
                return x(this, e2, r2);
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return D(this, e2, r2);
              default:
                if (n3) throw new TypeError("Unknown encoding: " + t3);
                t3 = (t3 + "").toLowerCase(), n3 = true;
            }
          }
          function v2(t3, e2, r2) {
            var n3 = t3[e2];
            t3[e2] = t3[r2], t3[r2] = n3;
          }
          function y(t3, e2, r2, n3, i2) {
            if (0 === t3.length) return -1;
            if ("string" == typeof r2 ? (n3 = r2, r2 = 0) : r2 > 2147483647 ? r2 = 2147483647 : r2 < -2147483648 && (r2 = -2147483648), r2 = +r2, isNaN(r2) && (r2 = i2 ? 0 : t3.length - 1), r2 < 0 && (r2 = t3.length + r2), r2 >= t3.length) {
              if (i2) return -1;
              r2 = t3.length - 1;
            } else if (r2 < 0) {
              if (!i2) return -1;
              r2 = 0;
            }
            if ("string" == typeof e2 && (e2 = u.from(e2, n3)), u.isBuffer(e2)) return 0 === e2.length ? -1 : m(t3, e2, r2, n3, i2);
            if ("number" == typeof e2) return e2 &= 255, u.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i2 ? Uint8Array.prototype.indexOf.call(t3, e2, r2) : Uint8Array.prototype.lastIndexOf.call(t3, e2, r2) : m(t3, [e2], r2, n3, i2);
            throw new TypeError("val must be string, number or Buffer");
          }
          function m(t3, e2, r2, n3, i2) {
            var o2, s2 = 1, a2 = t3.length, u2 = e2.length;
            if (void 0 !== n3 && ("ucs2" === (n3 = String(n3).toLowerCase()) || "ucs-2" === n3 || "utf16le" === n3 || "utf-16le" === n3)) {
              if (t3.length < 2 || e2.length < 2) return -1;
              s2 = 2, a2 /= 2, u2 /= 2, r2 /= 2;
            }
            function c2(t4, e3) {
              return 1 === s2 ? t4[e3] : t4.readUInt16BE(e3 * s2);
            }
            if (i2) {
              var h2 = -1;
              for (o2 = r2; o2 < a2; o2++) if (c2(t3, o2) === c2(e2, -1 === h2 ? 0 : o2 - h2)) {
                if (-1 === h2 && (h2 = o2), o2 - h2 + 1 === u2) return h2 * s2;
              } else -1 !== h2 && (o2 -= o2 - h2), h2 = -1;
            } else for (r2 + u2 > a2 && (r2 = a2 - u2), o2 = r2; o2 >= 0; o2--) {
              for (var l2 = true, f2 = 0; f2 < u2; f2++) if (c2(t3, o2 + f2) !== c2(e2, f2)) {
                l2 = false;
                break;
              }
              if (l2) return o2;
            }
            return -1;
          }
          function _(t3, e2, r2, n3) {
            r2 = Number(r2) || 0;
            var i2 = t3.length - r2;
            n3 ? (n3 = Number(n3)) > i2 && (n3 = i2) : n3 = i2;
            var o2 = e2.length;
            if (o2 % 2 != 0) throw new TypeError("Invalid hex string");
            n3 > o2 / 2 && (n3 = o2 / 2);
            for (var s2 = 0; s2 < n3; ++s2) {
              var a2 = parseInt(e2.substr(2 * s2, 2), 16);
              if (isNaN(a2)) return s2;
              t3[r2 + s2] = a2;
            }
            return s2;
          }
          function S(t3, e2, r2, n3) {
            return J(K(e2, t3.length - r2), t3, r2, n3);
          }
          function b(t3, e2, r2, n3) {
            return J(function i2(t4) {
              for (var e3 = [], r3 = 0; r3 < t4.length; ++r3) e3.push(255 & t4.charCodeAt(r3));
              return e3;
            }(e2), t3, r2, n3);
          }
          function w(t3, e2, r2, n3) {
            return b(t3, e2, r2, n3);
          }
          function F(t3, e2, r2, n3) {
            return J(q(e2), t3, r2, n3);
          }
          function E(t3, e2, r2, n3) {
            return J(function i2(t4, e3) {
              for (var r3, n4, i3, o2 = [], s2 = 0; s2 < t4.length && !((e3 -= 2) < 0); ++s2) n4 = (r3 = t4.charCodeAt(s2)) >> 8, i3 = r3 % 256, o2.push(i3), o2.push(n4);
              return o2;
            }(e2, t3.length - r2), t3, r2, n3);
          }
          function x(t3, e2, r2) {
            return 0 === e2 && r2 === t3.length ? n2.fromByteArray(t3) : n2.fromByteArray(t3.slice(e2, r2));
          }
          function A(t3, e2, r2) {
            r2 = Math.min(t3.length, r2);
            for (var n3 = [], i2 = e2; i2 < r2; ) {
              var o2, s2, a2, u2, c2 = t3[i2], h2 = null, l2 = c2 > 239 ? 4 : c2 > 223 ? 3 : c2 > 191 ? 2 : 1;
              if (i2 + l2 <= r2) switch (l2) {
                case 1:
                  c2 < 128 && (h2 = c2);
                  break;
                case 2:
                  128 == (192 & (o2 = t3[i2 + 1])) && (u2 = (31 & c2) << 6 | 63 & o2) > 127 && (h2 = u2);
                  break;
                case 3:
                  o2 = t3[i2 + 1], s2 = t3[i2 + 2], 128 == (192 & o2) && 128 == (192 & s2) && (u2 = (15 & c2) << 12 | (63 & o2) << 6 | 63 & s2) > 2047 && (u2 < 55296 || u2 > 57343) && (h2 = u2);
                  break;
                case 4:
                  o2 = t3[i2 + 1], s2 = t3[i2 + 2], a2 = t3[i2 + 3], 128 == (192 & o2) && 128 == (192 & s2) && 128 == (192 & a2) && (u2 = (15 & c2) << 18 | (63 & o2) << 12 | (63 & s2) << 6 | 63 & a2) > 65535 && u2 < 1114112 && (h2 = u2);
              }
              null === h2 ? (h2 = 65533, l2 = 1) : h2 > 65535 && (h2 -= 65536, n3.push(h2 >>> 10 & 1023 | 55296), h2 = 56320 | 1023 & h2), n3.push(h2), i2 += l2;
            }
            return function f2(t4) {
              var e3 = t4.length;
              if (e3 <= C) return String.fromCharCode.apply(String, t4);
              var r3 = "", n4 = 0;
              for (; n4 < e3; ) r3 += String.fromCharCode.apply(String, t4.slice(n4, n4 += C));
              return r3;
            }(n3);
          }
          e.Buffer = u, e.SlowBuffer = function k(t3) {
            +t3 != t3 && (t3 = 0);
            return u.alloc(+t3);
          }, e.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = void 0 !== t2.TYPED_ARRAY_SUPPORT ? t2.TYPED_ARRAY_SUPPORT : function P() {
            try {
              var t3 = new Uint8Array(1);
              return t3.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
                return 42;
              } }, 42 === t3.foo() && "function" == typeof t3.subarray && 0 === t3.subarray(1, 1).byteLength;
            } catch (t4) {
              return false;
            }
          }(), e.kMaxLength = s(), u.poolSize = 8192, u._augment = function(t3) {
            return t3.__proto__ = u.prototype, t3;
          }, u.from = function(t3, e2, r2) {
            return c(null, t3, e2, r2);
          }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, { value: null, configurable: true })), u.alloc = function(t3, e2, r2) {
            return function n3(t4, e3, r3, i2) {
              return h(e3), e3 <= 0 ? a(t4, e3) : void 0 !== r3 ? "string" == typeof i2 ? a(t4, e3).fill(r3, i2) : a(t4, e3).fill(r3) : a(t4, e3);
            }(null, t3, e2, r2);
          }, u.allocUnsafe = function(t3) {
            return l(null, t3);
          }, u.allocUnsafeSlow = function(t3) {
            return l(null, t3);
          }, u.isBuffer = function t3(e2) {
            return !(null == e2 || !e2._isBuffer);
          }, u.compare = function t3(e2, r2) {
            if (!u.isBuffer(e2) || !u.isBuffer(r2)) throw new TypeError("Arguments must be Buffers");
            if (e2 === r2) return 0;
            for (var n3 = e2.length, i2 = r2.length, o2 = 0, s2 = Math.min(n3, i2); o2 < s2; ++o2) if (e2[o2] !== r2[o2]) {
              n3 = e2[o2], i2 = r2[o2];
              break;
            }
            return n3 < i2 ? -1 : i2 < n3 ? 1 : 0;
          }, u.isEncoding = function t3(e2) {
            switch (String(e2).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "latin1":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return true;
              default:
                return false;
            }
          }, u.concat = function t3(e2, r2) {
            if (!o(e2)) throw new TypeError('"list" argument must be an Array of Buffers');
            if (0 === e2.length) return u.alloc(0);
            var n3;
            if (void 0 === r2) for (r2 = 0, n3 = 0; n3 < e2.length; ++n3) r2 += e2[n3].length;
            var i2 = u.allocUnsafe(r2), s2 = 0;
            for (n3 = 0; n3 < e2.length; ++n3) {
              var a2 = e2[n3];
              if (!u.isBuffer(a2)) throw new TypeError('"list" argument must be an Array of Buffers');
              a2.copy(i2, s2), s2 += a2.length;
            }
            return i2;
          }, u.byteLength = d, u.prototype._isBuffer = true, u.prototype.swap16 = function t3() {
            var e2 = this.length;
            if (e2 % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
            for (var r2 = 0; r2 < e2; r2 += 2) v2(this, r2, r2 + 1);
            return this;
          }, u.prototype.swap32 = function t3() {
            var e2 = this.length;
            if (e2 % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
            for (var r2 = 0; r2 < e2; r2 += 4) v2(this, r2, r2 + 3), v2(this, r2 + 1, r2 + 2);
            return this;
          }, u.prototype.swap64 = function t3() {
            var e2 = this.length;
            if (e2 % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
            for (var r2 = 0; r2 < e2; r2 += 8) v2(this, r2, r2 + 7), v2(this, r2 + 1, r2 + 6), v2(this, r2 + 2, r2 + 5), v2(this, r2 + 3, r2 + 4);
            return this;
          }, u.prototype.toString = function t3() {
            var e2 = 0 | this.length;
            return 0 === e2 ? "" : 0 === arguments.length ? A(this, 0, e2) : p.apply(this, arguments);
          }, u.prototype.equals = function t3(e2) {
            if (!u.isBuffer(e2)) throw new TypeError("Argument must be a Buffer");
            return this === e2 || 0 === u.compare(this, e2);
          }, u.prototype.inspect = function t3() {
            var r2 = "", n3 = e.INSPECT_MAX_BYTES;
            return this.length > 0 && (r2 = this.toString("hex", 0, n3).match(/.{2}/g).join(" "), this.length > n3 && (r2 += " ... ")), "<Buffer " + r2 + ">";
          }, u.prototype.compare = function t3(e2, r2, n3, i2, o2) {
            if (!u.isBuffer(e2)) throw new TypeError("Argument must be a Buffer");
            if (void 0 === r2 && (r2 = 0), void 0 === n3 && (n3 = e2 ? e2.length : 0), void 0 === i2 && (i2 = 0), void 0 === o2 && (o2 = this.length), r2 < 0 || n3 > e2.length || i2 < 0 || o2 > this.length) throw new RangeError("out of range index");
            if (i2 >= o2 && r2 >= n3) return 0;
            if (i2 >= o2) return -1;
            if (r2 >= n3) return 1;
            if (this === e2) return 0;
            for (var s2 = (o2 >>>= 0) - (i2 >>>= 0), a2 = (n3 >>>= 0) - (r2 >>>= 0), c2 = Math.min(s2, a2), h2 = this.slice(i2, o2), l2 = e2.slice(r2, n3), f2 = 0; f2 < c2; ++f2) if (h2[f2] !== l2[f2]) {
              s2 = h2[f2], a2 = l2[f2];
              break;
            }
            return s2 < a2 ? -1 : a2 < s2 ? 1 : 0;
          }, u.prototype.includes = function t3(e2, r2, n3) {
            return -1 !== this.indexOf(e2, r2, n3);
          }, u.prototype.indexOf = function t3(e2, r2, n3) {
            return y(this, e2, r2, n3, true);
          }, u.prototype.lastIndexOf = function t3(e2, r2, n3) {
            return y(this, e2, r2, n3, false);
          }, u.prototype.write = function t3(e2, r2, n3, i2) {
            if (void 0 === r2) i2 = "utf8", n3 = this.length, r2 = 0;
            else if (void 0 === n3 && "string" == typeof r2) i2 = r2, n3 = this.length, r2 = 0;
            else {
              if (!isFinite(r2)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
              r2 |= 0, isFinite(n3) ? (n3 |= 0, void 0 === i2 && (i2 = "utf8")) : (i2 = n3, n3 = void 0);
            }
            var o2 = this.length - r2;
            if ((void 0 === n3 || n3 > o2) && (n3 = o2), e2.length > 0 && (n3 < 0 || r2 < 0) || r2 > this.length) throw new RangeError("Attempt to write outside buffer bounds");
            i2 || (i2 = "utf8");
            for (var s2 = false; ; ) switch (i2) {
              case "hex":
                return _(this, e2, r2, n3);
              case "utf8":
              case "utf-8":
                return S(this, e2, r2, n3);
              case "ascii":
                return b(this, e2, r2, n3);
              case "latin1":
              case "binary":
                return w(this, e2, r2, n3);
              case "base64":
                return F(this, e2, r2, n3);
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return E(this, e2, r2, n3);
              default:
                if (s2) throw new TypeError("Unknown encoding: " + i2);
                i2 = ("" + i2).toLowerCase(), s2 = true;
            }
          }, u.prototype.toJSON = function t3() {
            return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
          };
          var C = 4096;
          function T(t3, e2, r2) {
            var n3 = "";
            r2 = Math.min(t3.length, r2);
            for (var i2 = e2; i2 < r2; ++i2) n3 += String.fromCharCode(127 & t3[i2]);
            return n3;
          }
          function R(t3, e2, r2) {
            var n3 = "";
            r2 = Math.min(t3.length, r2);
            for (var i2 = e2; i2 < r2; ++i2) n3 += String.fromCharCode(t3[i2]);
            return n3;
          }
          function I(t3, e2, r2) {
            var n3 = t3.length;
            (!e2 || e2 < 0) && (e2 = 0), (!r2 || r2 < 0 || r2 > n3) && (r2 = n3);
            for (var i2 = "", o2 = e2; o2 < r2; ++o2) i2 += V(t3[o2]);
            return i2;
          }
          function D(t3, e2, r2) {
            for (var n3 = t3.slice(e2, r2), i2 = "", o2 = 0; o2 < n3.length; o2 += 2) i2 += String.fromCharCode(n3[o2] + 256 * n3[o2 + 1]);
            return i2;
          }
          function L(t3, e2, r2) {
            if (t3 % 1 != 0 || t3 < 0) throw new RangeError("offset is not uint");
            if (t3 + e2 > r2) throw new RangeError("Trying to access beyond buffer length");
          }
          function N(t3, e2, r2, n3, i2, o2) {
            if (!u.isBuffer(t3)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (e2 > i2 || e2 < o2) throw new RangeError('"value" argument is out of bounds');
            if (r2 + n3 > t3.length) throw new RangeError("Index out of range");
          }
          function U(t3, e2, r2, n3) {
            e2 < 0 && (e2 = 65535 + e2 + 1);
            for (var i2 = 0, o2 = Math.min(t3.length - r2, 2); i2 < o2; ++i2) t3[r2 + i2] = (e2 & 255 << 8 * (n3 ? i2 : 1 - i2)) >>> 8 * (n3 ? i2 : 1 - i2);
          }
          function B(t3, e2, r2, n3) {
            e2 < 0 && (e2 = 4294967295 + e2 + 1);
            for (var i2 = 0, o2 = Math.min(t3.length - r2, 4); i2 < o2; ++i2) t3[r2 + i2] = e2 >>> 8 * (n3 ? i2 : 3 - i2) & 255;
          }
          function O(t3, e2, r2, n3, i2, o2) {
            if (r2 + n3 > t3.length) throw new RangeError("Index out of range");
            if (r2 < 0) throw new RangeError("Index out of range");
          }
          function j(t3, e2, r2, n3, o2) {
            return o2 || O(t3, 0, r2, 4), i.write(t3, e2, r2, n3, 23, 4), r2 + 4;
          }
          function M(t3, e2, r2, n3, o2) {
            return o2 || O(t3, 0, r2, 8), i.write(t3, e2, r2, n3, 52, 8), r2 + 8;
          }
          u.prototype.slice = function t3(e2, r2) {
            var n3, i2 = this.length;
            if ((e2 = ~~e2) < 0 ? (e2 += i2) < 0 && (e2 = 0) : e2 > i2 && (e2 = i2), (r2 = void 0 === r2 ? i2 : ~~r2) < 0 ? (r2 += i2) < 0 && (r2 = 0) : r2 > i2 && (r2 = i2), r2 < e2 && (r2 = e2), u.TYPED_ARRAY_SUPPORT) (n3 = this.subarray(e2, r2)).__proto__ = u.prototype;
            else {
              var o2 = r2 - e2;
              n3 = new u(o2, void 0);
              for (var s2 = 0; s2 < o2; ++s2) n3[s2] = this[s2 + e2];
            }
            return n3;
          }, u.prototype.readUIntLE = function t3(e2, r2, n3) {
            e2 |= 0, r2 |= 0, n3 || L(e2, r2, this.length);
            for (var i2 = this[e2], o2 = 1, s2 = 0; ++s2 < r2 && (o2 *= 256); ) i2 += this[e2 + s2] * o2;
            return i2;
          }, u.prototype.readUIntBE = function t3(e2, r2, n3) {
            e2 |= 0, r2 |= 0, n3 || L(e2, r2, this.length);
            for (var i2 = this[e2 + --r2], o2 = 1; r2 > 0 && (o2 *= 256); ) i2 += this[e2 + --r2] * o2;
            return i2;
          }, u.prototype.readUInt8 = function t3(e2, r2) {
            return r2 || L(e2, 1, this.length), this[e2];
          }, u.prototype.readUInt16LE = function t3(e2, r2) {
            return r2 || L(e2, 2, this.length), this[e2] | this[e2 + 1] << 8;
          }, u.prototype.readUInt16BE = function t3(e2, r2) {
            return r2 || L(e2, 2, this.length), this[e2] << 8 | this[e2 + 1];
          }, u.prototype.readUInt32LE = function t3(e2, r2) {
            return r2 || L(e2, 4, this.length), (this[e2] | this[e2 + 1] << 8 | this[e2 + 2] << 16) + 16777216 * this[e2 + 3];
          }, u.prototype.readUInt32BE = function t3(e2, r2) {
            return r2 || L(e2, 4, this.length), 16777216 * this[e2] + (this[e2 + 1] << 16 | this[e2 + 2] << 8 | this[e2 + 3]);
          }, u.prototype.readIntLE = function t3(e2, r2, n3) {
            e2 |= 0, r2 |= 0, n3 || L(e2, r2, this.length);
            for (var i2 = this[e2], o2 = 1, s2 = 0; ++s2 < r2 && (o2 *= 256); ) i2 += this[e2 + s2] * o2;
            return i2 >= (o2 *= 128) && (i2 -= Math.pow(2, 8 * r2)), i2;
          }, u.prototype.readIntBE = function t3(e2, r2, n3) {
            e2 |= 0, r2 |= 0, n3 || L(e2, r2, this.length);
            for (var i2 = r2, o2 = 1, s2 = this[e2 + --i2]; i2 > 0 && (o2 *= 256); ) s2 += this[e2 + --i2] * o2;
            return s2 >= (o2 *= 128) && (s2 -= Math.pow(2, 8 * r2)), s2;
          }, u.prototype.readInt8 = function t3(e2, r2) {
            return r2 || L(e2, 1, this.length), 128 & this[e2] ? -1 * (255 - this[e2] + 1) : this[e2];
          }, u.prototype.readInt16LE = function t3(e2, r2) {
            r2 || L(e2, 2, this.length);
            var n3 = this[e2] | this[e2 + 1] << 8;
            return 32768 & n3 ? 4294901760 | n3 : n3;
          }, u.prototype.readInt16BE = function t3(e2, r2) {
            r2 || L(e2, 2, this.length);
            var n3 = this[e2 + 1] | this[e2] << 8;
            return 32768 & n3 ? 4294901760 | n3 : n3;
          }, u.prototype.readInt32LE = function t3(e2, r2) {
            return r2 || L(e2, 4, this.length), this[e2] | this[e2 + 1] << 8 | this[e2 + 2] << 16 | this[e2 + 3] << 24;
          }, u.prototype.readInt32BE = function t3(e2, r2) {
            return r2 || L(e2, 4, this.length), this[e2] << 24 | this[e2 + 1] << 16 | this[e2 + 2] << 8 | this[e2 + 3];
          }, u.prototype.readFloatLE = function t3(e2, r2) {
            return r2 || L(e2, 4, this.length), i.read(this, e2, true, 23, 4);
          }, u.prototype.readFloatBE = function t3(e2, r2) {
            return r2 || L(e2, 4, this.length), i.read(this, e2, false, 23, 4);
          }, u.prototype.readDoubleLE = function t3(e2, r2) {
            return r2 || L(e2, 8, this.length), i.read(this, e2, true, 52, 8);
          }, u.prototype.readDoubleBE = function t3(e2, r2) {
            return r2 || L(e2, 8, this.length), i.read(this, e2, false, 52, 8);
          }, u.prototype.writeUIntLE = function t3(e2, r2, n3, i2) {
            (e2 = +e2, r2 |= 0, n3 |= 0, i2) || N(this, e2, r2, n3, Math.pow(2, 8 * n3) - 1, 0);
            var o2 = 1, s2 = 0;
            for (this[r2] = 255 & e2; ++s2 < n3 && (o2 *= 256); ) this[r2 + s2] = e2 / o2 & 255;
            return r2 + n3;
          }, u.prototype.writeUIntBE = function t3(e2, r2, n3, i2) {
            (e2 = +e2, r2 |= 0, n3 |= 0, i2) || N(this, e2, r2, n3, Math.pow(2, 8 * n3) - 1, 0);
            var o2 = n3 - 1, s2 = 1;
            for (this[r2 + o2] = 255 & e2; --o2 >= 0 && (s2 *= 256); ) this[r2 + o2] = e2 / s2 & 255;
            return r2 + n3;
          }, u.prototype.writeUInt8 = function t3(e2, r2, n3) {
            return e2 = +e2, r2 |= 0, n3 || N(this, e2, r2, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (e2 = Math.floor(e2)), this[r2] = 255 & e2, r2 + 1;
          }, u.prototype.writeUInt16LE = function t3(e2, r2, n3) {
            return e2 = +e2, r2 |= 0, n3 || N(this, e2, r2, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[r2] = 255 & e2, this[r2 + 1] = e2 >>> 8) : U(this, e2, r2, true), r2 + 2;
          }, u.prototype.writeUInt16BE = function t3(e2, r2, n3) {
            return e2 = +e2, r2 |= 0, n3 || N(this, e2, r2, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[r2] = e2 >>> 8, this[r2 + 1] = 255 & e2) : U(this, e2, r2, false), r2 + 2;
          }, u.prototype.writeUInt32LE = function t3(e2, r2, n3) {
            return e2 = +e2, r2 |= 0, n3 || N(this, e2, r2, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[r2 + 3] = e2 >>> 24, this[r2 + 2] = e2 >>> 16, this[r2 + 1] = e2 >>> 8, this[r2] = 255 & e2) : B(this, e2, r2, true), r2 + 4;
          }, u.prototype.writeUInt32BE = function t3(e2, r2, n3) {
            return e2 = +e2, r2 |= 0, n3 || N(this, e2, r2, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[r2] = e2 >>> 24, this[r2 + 1] = e2 >>> 16, this[r2 + 2] = e2 >>> 8, this[r2 + 3] = 255 & e2) : B(this, e2, r2, false), r2 + 4;
          }, u.prototype.writeIntLE = function t3(e2, r2, n3, i2) {
            if (e2 = +e2, r2 |= 0, !i2) {
              var o2 = Math.pow(2, 8 * n3 - 1);
              N(this, e2, r2, n3, o2 - 1, -o2);
            }
            var s2 = 0, a2 = 1, u2 = 0;
            for (this[r2] = 255 & e2; ++s2 < n3 && (a2 *= 256); ) e2 < 0 && 0 === u2 && 0 !== this[r2 + s2 - 1] && (u2 = 1), this[r2 + s2] = (e2 / a2 >> 0) - u2 & 255;
            return r2 + n3;
          }, u.prototype.writeIntBE = function t3(e2, r2, n3, i2) {
            if (e2 = +e2, r2 |= 0, !i2) {
              var o2 = Math.pow(2, 8 * n3 - 1);
              N(this, e2, r2, n3, o2 - 1, -o2);
            }
            var s2 = n3 - 1, a2 = 1, u2 = 0;
            for (this[r2 + s2] = 255 & e2; --s2 >= 0 && (a2 *= 256); ) e2 < 0 && 0 === u2 && 0 !== this[r2 + s2 + 1] && (u2 = 1), this[r2 + s2] = (e2 / a2 >> 0) - u2 & 255;
            return r2 + n3;
          }, u.prototype.writeInt8 = function t3(e2, r2, n3) {
            return e2 = +e2, r2 |= 0, n3 || N(this, e2, r2, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (e2 = Math.floor(e2)), e2 < 0 && (e2 = 255 + e2 + 1), this[r2] = 255 & e2, r2 + 1;
          }, u.prototype.writeInt16LE = function t3(e2, r2, n3) {
            return e2 = +e2, r2 |= 0, n3 || N(this, e2, r2, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[r2] = 255 & e2, this[r2 + 1] = e2 >>> 8) : U(this, e2, r2, true), r2 + 2;
          }, u.prototype.writeInt16BE = function t3(e2, r2, n3) {
            return e2 = +e2, r2 |= 0, n3 || N(this, e2, r2, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[r2] = e2 >>> 8, this[r2 + 1] = 255 & e2) : U(this, e2, r2, false), r2 + 2;
          }, u.prototype.writeInt32LE = function t3(e2, r2, n3) {
            return e2 = +e2, r2 |= 0, n3 || N(this, e2, r2, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[r2] = 255 & e2, this[r2 + 1] = e2 >>> 8, this[r2 + 2] = e2 >>> 16, this[r2 + 3] = e2 >>> 24) : B(this, e2, r2, true), r2 + 4;
          }, u.prototype.writeInt32BE = function t3(e2, r2, n3) {
            return e2 = +e2, r2 |= 0, n3 || N(this, e2, r2, 4, 2147483647, -2147483648), e2 < 0 && (e2 = 4294967295 + e2 + 1), u.TYPED_ARRAY_SUPPORT ? (this[r2] = e2 >>> 24, this[r2 + 1] = e2 >>> 16, this[r2 + 2] = e2 >>> 8, this[r2 + 3] = 255 & e2) : B(this, e2, r2, false), r2 + 4;
          }, u.prototype.writeFloatLE = function t3(e2, r2, n3) {
            return j(this, e2, r2, true, n3);
          }, u.prototype.writeFloatBE = function t3(e2, r2, n3) {
            return j(this, e2, r2, false, n3);
          }, u.prototype.writeDoubleLE = function t3(e2, r2, n3) {
            return M(this, e2, r2, true, n3);
          }, u.prototype.writeDoubleBE = function t3(e2, r2, n3) {
            return M(this, e2, r2, false, n3);
          }, u.prototype.copy = function t3(e2, r2, n3, i2) {
            if (n3 || (n3 = 0), i2 || 0 === i2 || (i2 = this.length), r2 >= e2.length && (r2 = e2.length), r2 || (r2 = 0), i2 > 0 && i2 < n3 && (i2 = n3), i2 === n3) return 0;
            if (0 === e2.length || 0 === this.length) return 0;
            if (r2 < 0) throw new RangeError("targetStart out of bounds");
            if (n3 < 0 || n3 >= this.length) throw new RangeError("sourceStart out of bounds");
            if (i2 < 0) throw new RangeError("sourceEnd out of bounds");
            i2 > this.length && (i2 = this.length), e2.length - r2 < i2 - n3 && (i2 = e2.length - r2 + n3);
            var o2, s2 = i2 - n3;
            if (this === e2 && n3 < r2 && r2 < i2) for (o2 = s2 - 1; o2 >= 0; --o2) e2[o2 + r2] = this[o2 + n3];
            else if (s2 < 1e3 || !u.TYPED_ARRAY_SUPPORT) for (o2 = 0; o2 < s2; ++o2) e2[o2 + r2] = this[o2 + n3];
            else Uint8Array.prototype.set.call(e2, this.subarray(n3, n3 + s2), r2);
            return s2;
          }, u.prototype.fill = function t3(e2, r2, n3, i2) {
            if ("string" == typeof e2) {
              if ("string" == typeof r2 ? (i2 = r2, r2 = 0, n3 = this.length) : "string" == typeof n3 && (i2 = n3, n3 = this.length), 1 === e2.length) {
                var o2 = e2.charCodeAt(0);
                o2 < 256 && (e2 = o2);
              }
              if (void 0 !== i2 && "string" != typeof i2) throw new TypeError("encoding must be a string");
              if ("string" == typeof i2 && !u.isEncoding(i2)) throw new TypeError("Unknown encoding: " + i2);
            } else "number" == typeof e2 && (e2 &= 255);
            if (r2 < 0 || this.length < r2 || this.length < n3) throw new RangeError("Out of range index");
            if (n3 <= r2) return this;
            var s2;
            if (r2 >>>= 0, n3 = void 0 === n3 ? this.length : n3 >>> 0, e2 || (e2 = 0), "number" == typeof e2) for (s2 = r2; s2 < n3; ++s2) this[s2] = e2;
            else {
              var a2 = u.isBuffer(e2) ? e2 : K(new u(e2, i2).toString()), c2 = a2.length;
              for (s2 = 0; s2 < n3 - r2; ++s2) this[s2 + r2] = a2[s2 % c2];
            }
            return this;
          };
          var H = /[^+\/0-9A-Za-z-_]/g;
          function V(t3) {
            return t3 < 16 ? "0" + t3.toString(16) : t3.toString(16);
          }
          function K(t3, e2) {
            var r2;
            e2 = e2 || 1 / 0;
            for (var n3 = t3.length, i2 = null, o2 = [], s2 = 0; s2 < n3; ++s2) {
              if ((r2 = t3.charCodeAt(s2)) > 55295 && r2 < 57344) {
                if (!i2) {
                  if (r2 > 56319) {
                    (e2 -= 3) > -1 && o2.push(239, 191, 189);
                    continue;
                  }
                  if (s2 + 1 === n3) {
                    (e2 -= 3) > -1 && o2.push(239, 191, 189);
                    continue;
                  }
                  i2 = r2;
                  continue;
                }
                if (r2 < 56320) {
                  (e2 -= 3) > -1 && o2.push(239, 191, 189), i2 = r2;
                  continue;
                }
                r2 = 65536 + (i2 - 55296 << 10 | r2 - 56320);
              } else i2 && (e2 -= 3) > -1 && o2.push(239, 191, 189);
              if (i2 = null, r2 < 128) {
                if ((e2 -= 1) < 0) break;
                o2.push(r2);
              } else if (r2 < 2048) {
                if ((e2 -= 2) < 0) break;
                o2.push(r2 >> 6 | 192, 63 & r2 | 128);
              } else if (r2 < 65536) {
                if ((e2 -= 3) < 0) break;
                o2.push(r2 >> 12 | 224, r2 >> 6 & 63 | 128, 63 & r2 | 128);
              } else {
                if (!(r2 < 1114112)) throw new Error("Invalid code point");
                if ((e2 -= 4) < 0) break;
                o2.push(r2 >> 18 | 240, r2 >> 12 & 63 | 128, r2 >> 6 & 63 | 128, 63 & r2 | 128);
              }
            }
            return o2;
          }
          function q(t3) {
            return n2.toByteArray(function e2(t4) {
              if ((t4 = function e3(t5) {
                return t5.trim ? t5.trim() : t5.replace(/^\s+|\s+$/g, "");
              }(t4).replace(H, "")).length < 2) return "";
              for (; t4.length % 4 != 0; ) t4 += "=";
              return t4;
            }(t3));
          }
          function J(t3, e2, r2, n3) {
            for (var i2 = 0; i2 < n3 && !(i2 + r2 >= e2.length || i2 >= t3.length); ++i2) e2[i2 + r2] = t3[i2];
            return i2;
          }
        }).call(this, r(29));
      }, function(t, e) {
        var r;
        r = /* @__PURE__ */ function() {
          return this;
        }();
        try {
          r = r || new Function("return this")();
        } catch (t2) {
          "object" == typeof window && (r = window);
        }
        t.exports = r;
      }, function(t, e, r) {
        "use strict";
        e.byteLength = function n2(t2) {
          var e2 = f(t2), r2 = e2[0], n3 = e2[1];
          return 3 * (r2 + n3) / 4 - n3;
        }, e.toByteArray = function i(t2) {
          var e2, r2, n2 = f(t2), i2 = n2[0], o = n2[1], s2 = new u(function c2(t3, e3, r3) {
            return 3 * (e3 + r3) / 4 - r3;
          }(0, i2, o)), h2 = 0, l2 = o > 0 ? i2 - 4 : i2;
          for (r2 = 0; r2 < l2; r2 += 4) e2 = a[t2.charCodeAt(r2)] << 18 | a[t2.charCodeAt(r2 + 1)] << 12 | a[t2.charCodeAt(r2 + 2)] << 6 | a[t2.charCodeAt(r2 + 3)], s2[h2++] = e2 >> 16 & 255, s2[h2++] = e2 >> 8 & 255, s2[h2++] = 255 & e2;
          2 === o && (e2 = a[t2.charCodeAt(r2)] << 2 | a[t2.charCodeAt(r2 + 1)] >> 4, s2[h2++] = 255 & e2);
          1 === o && (e2 = a[t2.charCodeAt(r2)] << 10 | a[t2.charCodeAt(r2 + 1)] << 4 | a[t2.charCodeAt(r2 + 2)] >> 2, s2[h2++] = e2 >> 8 & 255, s2[h2++] = 255 & e2);
          return s2;
        }, e.fromByteArray = function o(t2) {
          for (var e2, r2 = t2.length, n2 = r2 % 3, i = [], o2 = 16383, a2 = 0, u2 = r2 - n2; a2 < u2; a2 += o2) i.push(g(t2, a2, a2 + o2 > u2 ? u2 : a2 + o2));
          1 === n2 ? (e2 = t2[r2 - 1], i.push(s[e2 >> 2] + s[e2 << 4 & 63] + "==")) : 2 === n2 && (e2 = (t2[r2 - 2] << 8) + t2[r2 - 1], i.push(s[e2 >> 10] + s[e2 >> 4 & 63] + s[e2 << 2 & 63] + "="));
          return i.join("");
        };
        for (var s = [], a = [], u = "undefined" != typeof Uint8Array ? Uint8Array : Array, c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", h = 0, l = c.length; h < l; ++h) s[h] = c[h], a[c.charCodeAt(h)] = h;
        function f(t2) {
          var e2 = t2.length;
          if (e2 % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
          var r2 = t2.indexOf("=");
          return -1 === r2 && (r2 = e2), [r2, r2 === e2 ? 0 : 4 - r2 % 4];
        }
        function g(t2, e2, r2) {
          for (var n2, i, o = [], a2 = e2; a2 < r2; a2 += 3) n2 = (t2[a2] << 16 & 16711680) + (t2[a2 + 1] << 8 & 65280) + (255 & t2[a2 + 2]), o.push(s[(i = n2) >> 18 & 63] + s[i >> 12 & 63] + s[i >> 6 & 63] + s[63 & i]);
          return o.join("");
        }
        a["-".charCodeAt(0)] = 62, a["_".charCodeAt(0)] = 63;
      }, function(t, e) {
        e.read = function(t2, e2, r, n2, i) {
          var o, s, a = 8 * i - n2 - 1, u = (1 << a) - 1, c = u >> 1, h = -7, l = r ? i - 1 : 0, f = r ? -1 : 1, g = t2[e2 + l];
          for (l += f, o = g & (1 << -h) - 1, g >>= -h, h += a; h > 0; o = 256 * o + t2[e2 + l], l += f, h -= 8) ;
          for (s = o & (1 << -h) - 1, o >>= -h, h += n2; h > 0; s = 256 * s + t2[e2 + l], l += f, h -= 8) ;
          if (0 === o) o = 1 - c;
          else {
            if (o === u) return s ? NaN : 1 / 0 * (g ? -1 : 1);
            s += Math.pow(2, n2), o -= c;
          }
          return (g ? -1 : 1) * s * Math.pow(2, o - n2);
        }, e.write = function(t2, e2, r, n2, i, o) {
          var s, a, u, c = 8 * o - i - 1, h = (1 << c) - 1, l = h >> 1, f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, g = n2 ? 0 : o - 1, d = n2 ? 1 : -1, p = e2 < 0 || 0 === e2 && 1 / e2 < 0 ? 1 : 0;
          for (e2 = Math.abs(e2), isNaN(e2) || e2 === 1 / 0 ? (a = isNaN(e2) ? 1 : 0, s = h) : (s = Math.floor(Math.log(e2) / Math.LN2), e2 * (u = Math.pow(2, -s)) < 1 && (s--, u *= 2), (e2 += s + l >= 1 ? f / u : f * Math.pow(2, 1 - l)) * u >= 2 && (s++, u /= 2), s + l >= h ? (a = 0, s = h) : s + l >= 1 ? (a = (e2 * u - 1) * Math.pow(2, i), s += l) : (a = e2 * Math.pow(2, l - 1) * Math.pow(2, i), s = 0)); i >= 8; t2[r + g] = 255 & a, g += d, a /= 256, i -= 8) ;
          for (s = s << i | a, c += i; c > 0; t2[r + g] = 255 & s, g += d, s /= 256, c -= 8) ;
          t2[r + g - d] |= 128 * p;
        };
      }, function(t, e) {
        var r = {}.toString;
        t.exports = Array.isArray || function(t2) {
          return "[object Array]" == r.call(t2);
        };
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.default = function n2(t2) {
          var e2 = t2.jws, r2 = t2.KeyUtil, n3 = t2.X509, o = t2.crypto, s = t2.hextob64u, a = t2.b64tohex, u = t2.AllowedSigningAlgs;
          return function() {
            function t3() {
              !function e3(t4, r3) {
                if (!(t4 instanceof r3)) throw new TypeError("Cannot call a class as a function");
              }(this, t3);
            }
            return t3.parseJwt = function t4(r3) {
              i.Log.debug("JoseUtil.parseJwt");
              try {
                var n4 = e2.JWS.parse(r3);
                return { header: n4.headerObj, payload: n4.payloadObj };
              } catch (t5) {
                i.Log.error(t5);
              }
            }, t3.validateJwt = function e3(o2, s2, u2, c, h, l, f) {
              i.Log.debug("JoseUtil.validateJwt");
              try {
                if ("RSA" === s2.kty) if (s2.e && s2.n) s2 = r2.getKey(s2);
                else {
                  if (!s2.x5c || !s2.x5c.length) return i.Log.error("JoseUtil.validateJwt: RSA key missing key material", s2), Promise.reject(new Error("RSA key missing key material"));
                  var g = a(s2.x5c[0]);
                  s2 = n3.getPublicKeyFromCertHex(g);
                }
                else {
                  if ("EC" !== s2.kty) return i.Log.error("JoseUtil.validateJwt: Unsupported key type", s2 && s2.kty), Promise.reject(new Error(s2.kty));
                  if (!(s2.crv && s2.x && s2.y)) return i.Log.error("JoseUtil.validateJwt: EC key missing key material", s2), Promise.reject(new Error("EC key missing key material"));
                  s2 = r2.getKey(s2);
                }
                return t3._validateJwt(o2, s2, u2, c, h, l, f);
              } catch (t4) {
                return i.Log.error(t4 && t4.message || t4), Promise.reject("JWT validation failed");
              }
            }, t3.validateJwtAttributes = function e3(r3, n4, o2, s2, a2, u2) {
              s2 || (s2 = 0), a2 || (a2 = parseInt(Date.now() / 1e3));
              var c = t3.parseJwt(r3).payload;
              if (!c.iss) return i.Log.error("JoseUtil._validateJwt: issuer was not provided"), Promise.reject(new Error("issuer was not provided"));
              if (c.iss !== n4) return i.Log.error("JoseUtil._validateJwt: Invalid issuer in token", c.iss), Promise.reject(new Error("Invalid issuer in token: " + c.iss));
              if (!c.aud) return i.Log.error("JoseUtil._validateJwt: aud was not provided"), Promise.reject(new Error("aud was not provided"));
              if (!(c.aud === o2 || Array.isArray(c.aud) && c.aud.indexOf(o2) >= 0)) return i.Log.error("JoseUtil._validateJwt: Invalid audience in token", c.aud), Promise.reject(new Error("Invalid audience in token: " + c.aud));
              if (c.azp && c.azp !== o2) return i.Log.error("JoseUtil._validateJwt: Invalid azp in token", c.azp), Promise.reject(new Error("Invalid azp in token: " + c.azp));
              if (!u2) {
                var h = a2 + s2, l = a2 - s2;
                if (!c.iat) return i.Log.error("JoseUtil._validateJwt: iat was not provided"), Promise.reject(new Error("iat was not provided"));
                if (h < c.iat) return i.Log.error("JoseUtil._validateJwt: iat is in the future", c.iat), Promise.reject(new Error("iat is in the future: " + c.iat));
                if (c.nbf && h < c.nbf) return i.Log.error("JoseUtil._validateJwt: nbf is in the future", c.nbf), Promise.reject(new Error("nbf is in the future: " + c.nbf));
                if (!c.exp) return i.Log.error("JoseUtil._validateJwt: exp was not provided"), Promise.reject(new Error("exp was not provided"));
                if (c.exp < l) return i.Log.error("JoseUtil._validateJwt: exp is in the past", c.exp), Promise.reject(new Error("exp is in the past:" + c.exp));
              }
              return Promise.resolve(c);
            }, t3._validateJwt = function r3(n4, o2, s2, a2, c, h, l) {
              return t3.validateJwtAttributes(n4, s2, a2, c, h, l).then(function(t4) {
                try {
                  return e2.JWS.verify(n4, o2, u) ? t4 : (i.Log.error("JoseUtil._validateJwt: signature validation failed"), Promise.reject(new Error("signature validation failed")));
                } catch (t5) {
                  return i.Log.error(t5 && t5.message || t5), Promise.reject(new Error("signature validation failed"));
                }
              });
            }, t3.hashString = function t4(e3, r3) {
              try {
                return o.Util.hashString(e3, r3);
              } catch (t5) {
                i.Log.error(t5);
              }
            }, t3.hexToBase64Url = function t4(e3) {
              try {
                return s(e3);
              } catch (t5) {
                i.Log.error(t5);
              }
            }, t3;
          }();
        };
        var i = r(0);
        t.exports = e.default;
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.SigninResponse = void 0;
        var n2 = /* @__PURE__ */ function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n3 = e2[r2];
              n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(t3, n3.key, n3);
            }
          }
          return function(e2, r2, n3) {
            return r2 && t2(e2.prototype, r2), n3 && t2(e2, n3), e2;
          };
        }(), i = r(3);
        function o(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        e.SigninResponse = function() {
          function t2(e2) {
            var r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "#";
            o(this, t2);
            var n3 = i.UrlUtility.parseUrlFragment(e2, r2);
            this.error = n3.error, this.error_description = n3.error_description, this.error_uri = n3.error_uri, this.code = n3.code, this.state = n3.state, this.id_token = n3.id_token, this.session_state = n3.session_state, this.access_token = n3.access_token, this.token_type = n3.token_type, this.scope = n3.scope, this.profile = void 0, this.expires_in = n3.expires_in;
          }
          return n2(t2, [{ key: "expires_in", get: function t3() {
            if (this.expires_at) {
              var e2 = parseInt(Date.now() / 1e3);
              return this.expires_at - e2;
            }
          }, set: function t3(e2) {
            var r2 = parseInt(e2);
            if ("number" == typeof r2 && r2 > 0) {
              var n3 = parseInt(Date.now() / 1e3);
              this.expires_at = n3 + r2;
            }
          } }, { key: "expired", get: function t3() {
            var e2 = this.expires_in;
            if (void 0 !== e2) return e2 <= 0;
          } }, { key: "scopes", get: function t3() {
            return (this.scope || "").split(" ");
          } }, { key: "isOpenIdConnect", get: function t3() {
            return this.scopes.indexOf("openid") >= 0 || !!this.id_token;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.SignoutRequest = void 0;
        var n2 = r(0), i = r(3), o = r(9);
        e.SignoutRequest = function t2(e2) {
          var r2 = e2.url, s = e2.id_token_hint, a = e2.post_logout_redirect_uri, u = e2.data, c = e2.extraQueryParams, h = e2.request_type;
          if (function l(t3, e3) {
            if (!(t3 instanceof e3)) throw new TypeError("Cannot call a class as a function");
          }(this, t2), !r2) throw n2.Log.error("SignoutRequest.ctor: No url passed"), new Error("url");
          for (var f in s && (r2 = i.UrlUtility.addQueryParam(r2, "id_token_hint", s)), a && (r2 = i.UrlUtility.addQueryParam(r2, "post_logout_redirect_uri", a), u && (this.state = new o.State({ data: u, request_type: h }), r2 = i.UrlUtility.addQueryParam(r2, "state", this.state.id))), c) r2 = i.UrlUtility.addQueryParam(r2, f, c[f]);
          this.url = r2;
        };
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.SignoutResponse = void 0;
        var n2 = r(3);
        e.SignoutResponse = function t2(e2) {
          !function r2(t3, e3) {
            if (!(t3 instanceof e3)) throw new TypeError("Cannot call a class as a function");
          }(this, t2);
          var i = n2.UrlUtility.parseUrlFragment(e2, "?");
          this.error = i.error, this.error_description = i.error_description, this.error_uri = i.error_uri, this.state = i.state;
        };
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.InMemoryWebStorage = void 0;
        var n2 = /* @__PURE__ */ function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n3 = e2[r2];
              n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(t3, n3.key, n3);
            }
          }
          return function(e2, r2, n3) {
            return r2 && t2(e2.prototype, r2), n3 && t2(e2, n3), e2;
          };
        }(), i = r(0);
        e.InMemoryWebStorage = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2)) throw new TypeError("Cannot call a class as a function");
            }(this, t2), this._data = {};
          }
          return t2.prototype.getItem = function t3(e2) {
            return i.Log.debug("InMemoryWebStorage.getItem", e2), this._data[e2];
          }, t2.prototype.setItem = function t3(e2, r2) {
            i.Log.debug("InMemoryWebStorage.setItem", e2), this._data[e2] = r2;
          }, t2.prototype.removeItem = function t3(e2) {
            i.Log.debug("InMemoryWebStorage.removeItem", e2), delete this._data[e2];
          }, t2.prototype.key = function t3(e2) {
            return Object.getOwnPropertyNames(this._data)[e2];
          }, n2(t2, [{ key: "length", get: function t3() {
            return Object.getOwnPropertyNames(this._data).length;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.UserManager = void 0;
        var n2 = /* @__PURE__ */ function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n3 = e2[r2];
              n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(t3, n3.key, n3);
            }
          }
          return function(e2, r2, n3) {
            return r2 && t2(e2.prototype, r2), n3 && t2(e2, n3), e2;
          };
        }(), i = r(0), o = r(10), s = r(39), a = r(15), u = r(45), c = r(47), h = r(18), l = r(8), f = r(20), g = r(11), d = r(4);
        function p(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        function v2(t2, e2) {
          if (!t2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !e2 || "object" != typeof e2 && "function" != typeof e2 ? t2 : e2;
        }
        e.UserManager = function(t2) {
          function e2() {
            var r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : c.SilentRenewService, o2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : h.SessionMonitor, a2 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : f.TokenRevocationClient, l2 = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : g.TokenClient, y = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : d.JoseUtil;
            p(this, e2), r2 instanceof s.UserManagerSettings || (r2 = new s.UserManagerSettings(r2));
            var m = v2(this, t2.call(this, r2));
            return m._events = new u.UserManagerEvents(r2), m._silentRenewService = new n3(m), m.settings.automaticSilentRenew && (i.Log.debug("UserManager.ctor: automaticSilentRenew is configured, setting up silent renew"), m.startSilentRenew()), m.settings.monitorSession && (i.Log.debug("UserManager.ctor: monitorSession is configured, setting up session monitor"), m._sessionMonitor = new o2(m)), m._tokenRevocationClient = new a2(m._settings), m._tokenClient = new l2(m._settings), m._joseUtil = y, m;
          }
          return function r2(t3, e3) {
            if ("function" != typeof e3 && null !== e3) throw new TypeError("Super expression must either be null or a function, not " + typeof e3);
            t3.prototype = Object.create(e3 && e3.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), e3 && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, e3) : t3.__proto__ = e3);
          }(e2, t2), e2.prototype.getUser = function t3() {
            var e3 = this;
            return this._loadUser().then(function(t4) {
              return t4 ? (i.Log.info("UserManager.getUser: user loaded"), e3._events.load(t4, false), t4) : (i.Log.info("UserManager.getUser: user not found in storage"), null);
            });
          }, e2.prototype.removeUser = function t3() {
            var e3 = this;
            return this.storeUser(null).then(function() {
              i.Log.info("UserManager.removeUser: user removed from storage"), e3._events.unload();
            });
          }, e2.prototype.signinRedirect = function t3() {
            var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            (e3 = Object.assign({}, e3)).request_type = "si:r";
            var r2 = { useReplaceToNavigate: e3.useReplaceToNavigate };
            return this._signinStart(e3, this._redirectNavigator, r2).then(function() {
              i.Log.info("UserManager.signinRedirect: successful");
            });
          }, e2.prototype.signinRedirectCallback = function t3(e3) {
            return this._signinEnd(e3 || this._redirectNavigator.url).then(function(t4) {
              return t4.profile && t4.profile.sub ? i.Log.info("UserManager.signinRedirectCallback: successful, signed in sub: ", t4.profile.sub) : i.Log.info("UserManager.signinRedirectCallback: no sub"), t4;
            });
          }, e2.prototype.signinPopup = function t3() {
            var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            (e3 = Object.assign({}, e3)).request_type = "si:p";
            var r2 = e3.redirect_uri || this.settings.popup_redirect_uri || this.settings.redirect_uri;
            return r2 ? (e3.redirect_uri = r2, e3.display = "popup", this._signin(e3, this._popupNavigator, { startUrl: r2, popupWindowFeatures: e3.popupWindowFeatures || this.settings.popupWindowFeatures, popupWindowTarget: e3.popupWindowTarget || this.settings.popupWindowTarget }).then(function(t4) {
              return t4 && (t4.profile && t4.profile.sub ? i.Log.info("UserManager.signinPopup: signinPopup successful, signed in sub: ", t4.profile.sub) : i.Log.info("UserManager.signinPopup: no sub")), t4;
            })) : (i.Log.error("UserManager.signinPopup: No popup_redirect_uri or redirect_uri configured"), Promise.reject(new Error("No popup_redirect_uri or redirect_uri configured")));
          }, e2.prototype.signinPopupCallback = function t3(e3) {
            return this._signinCallback(e3, this._popupNavigator).then(function(t4) {
              return t4 && (t4.profile && t4.profile.sub ? i.Log.info("UserManager.signinPopupCallback: successful, signed in sub: ", t4.profile.sub) : i.Log.info("UserManager.signinPopupCallback: no sub")), t4;
            }).catch(function(t4) {
              i.Log.error(t4.message);
            });
          }, e2.prototype.signinSilent = function t3() {
            var e3 = this, r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return r2 = Object.assign({}, r2), this._loadUser().then(function(t4) {
              return t4 && t4.refresh_token ? (r2.refresh_token = t4.refresh_token, e3._useRefreshToken(r2)) : (r2.request_type = "si:s", r2.id_token_hint = r2.id_token_hint || e3.settings.includeIdTokenInSilentRenew && t4 && t4.id_token, t4 && e3._settings.validateSubOnSilentRenew && (i.Log.debug("UserManager.signinSilent, subject prior to silent renew: ", t4.profile.sub), r2.current_sub = t4.profile.sub), e3._signinSilentIframe(r2));
            });
          }, e2.prototype._useRefreshToken = function t3() {
            var e3 = this, r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return this._tokenClient.exchangeRefreshToken(r2).then(function(t4) {
              return t4 ? t4.access_token ? e3._loadUser().then(function(r3) {
                if (r3) {
                  var n3 = Promise.resolve();
                  return t4.id_token && (n3 = e3._validateIdTokenFromTokenRefreshToken(r3.profile, t4.id_token)), n3.then(function() {
                    return i.Log.debug("UserManager._useRefreshToken: refresh token response success"), r3.id_token = t4.id_token || r3.id_token, r3.access_token = t4.access_token, r3.refresh_token = t4.refresh_token || r3.refresh_token, r3.expires_in = t4.expires_in, e3.storeUser(r3).then(function() {
                      return e3._events.load(r3), r3;
                    });
                  });
                }
                return null;
              }) : (i.Log.error("UserManager._useRefreshToken: No access token returned from token endpoint"), Promise.reject("No access token returned from token endpoint")) : (i.Log.error("UserManager._useRefreshToken: No response returned from token endpoint"), Promise.reject("No response returned from token endpoint"));
            });
          }, e2.prototype._validateIdTokenFromTokenRefreshToken = function t3(e3, r2) {
            var n3 = this;
            return this._metadataService.getIssuer().then(function(t4) {
              return n3.settings.getEpochTime().then(function(o2) {
                return n3._joseUtil.validateJwtAttributes(r2, t4, n3._settings.client_id, n3._settings.clockSkew, o2).then(function(t5) {
                  return t5 ? t5.sub !== e3.sub ? (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: sub in id_token does not match current sub"), Promise.reject(new Error("sub in id_token does not match current sub"))) : t5.auth_time && t5.auth_time !== e3.auth_time ? (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: auth_time in id_token does not match original auth_time"), Promise.reject(new Error("auth_time in id_token does not match original auth_time"))) : t5.azp && t5.azp !== e3.azp ? (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: azp in id_token does not match original azp"), Promise.reject(new Error("azp in id_token does not match original azp"))) : !t5.azp && e3.azp ? (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: azp not in id_token, but present in original id_token"), Promise.reject(new Error("azp not in id_token, but present in original id_token"))) : void 0 : (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: Failed to validate id_token"), Promise.reject(new Error("Failed to validate id_token")));
                });
              });
            });
          }, e2.prototype._signinSilentIframe = function t3() {
            var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r2 = e3.redirect_uri || this.settings.silent_redirect_uri || this.settings.redirect_uri;
            return r2 ? (e3.redirect_uri = r2, e3.prompt = e3.prompt || "none", this._signin(e3, this._iframeNavigator, { startUrl: r2, silentRequestTimeout: e3.silentRequestTimeout || this.settings.silentRequestTimeout }).then(function(t4) {
              return t4 && (t4.profile && t4.profile.sub ? i.Log.info("UserManager.signinSilent: successful, signed in sub: ", t4.profile.sub) : i.Log.info("UserManager.signinSilent: no sub")), t4;
            })) : (i.Log.error("UserManager.signinSilent: No silent_redirect_uri configured"), Promise.reject(new Error("No silent_redirect_uri configured")));
          }, e2.prototype.signinSilentCallback = function t3(e3) {
            return this._signinCallback(e3, this._iframeNavigator).then(function(t4) {
              return t4 && (t4.profile && t4.profile.sub ? i.Log.info("UserManager.signinSilentCallback: successful, signed in sub: ", t4.profile.sub) : i.Log.info("UserManager.signinSilentCallback: no sub")), t4;
            });
          }, e2.prototype.signinCallback = function t3(e3) {
            var r2 = this;
            return this.readSigninResponseState(e3).then(function(t4) {
              var n3 = t4.state;
              t4.response;
              return "si:r" === n3.request_type ? r2.signinRedirectCallback(e3) : "si:p" === n3.request_type ? r2.signinPopupCallback(e3) : "si:s" === n3.request_type ? r2.signinSilentCallback(e3) : Promise.reject(new Error("invalid response_type in state"));
            });
          }, e2.prototype.signoutCallback = function t3(e3, r2) {
            var n3 = this;
            return this.readSignoutResponseState(e3).then(function(t4) {
              var i2 = t4.state, o2 = t4.response;
              return i2 ? "so:r" === i2.request_type ? n3.signoutRedirectCallback(e3) : "so:p" === i2.request_type ? n3.signoutPopupCallback(e3, r2) : Promise.reject(new Error("invalid response_type in state")) : o2;
            });
          }, e2.prototype.querySessionStatus = function t3() {
            var e3 = this, r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            (r2 = Object.assign({}, r2)).request_type = "si:s";
            var n3 = r2.redirect_uri || this.settings.silent_redirect_uri || this.settings.redirect_uri;
            return n3 ? (r2.redirect_uri = n3, r2.prompt = "none", r2.response_type = r2.response_type || this.settings.query_status_response_type, r2.scope = r2.scope || "openid", r2.skipUserInfo = true, this._signinStart(r2, this._iframeNavigator, { startUrl: n3, silentRequestTimeout: r2.silentRequestTimeout || this.settings.silentRequestTimeout }).then(function(t4) {
              return e3.processSigninResponse(t4.url).then(function(t5) {
                if (i.Log.debug("UserManager.querySessionStatus: got signin response"), t5.session_state && t5.profile.sub) return i.Log.info("UserManager.querySessionStatus: querySessionStatus success for sub: ", t5.profile.sub), { session_state: t5.session_state, sub: t5.profile.sub, sid: t5.profile.sid };
                i.Log.info("querySessionStatus successful, user not authenticated");
              }).catch(function(t5) {
                if (t5.session_state && e3.settings.monitorAnonymousSession && ("login_required" == t5.message || "consent_required" == t5.message || "interaction_required" == t5.message || "account_selection_required" == t5.message)) return i.Log.info("UserManager.querySessionStatus: querySessionStatus success for anonymous user"), { session_state: t5.session_state };
                throw t5;
              });
            })) : (i.Log.error("UserManager.querySessionStatus: No silent_redirect_uri configured"), Promise.reject(new Error("No silent_redirect_uri configured")));
          }, e2.prototype._signin = function t3(e3, r2) {
            var n3 = this, i2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            return this._signinStart(e3, r2, i2).then(function(t4) {
              return n3._signinEnd(t4.url, e3);
            });
          }, e2.prototype._signinStart = function t3(e3, r2) {
            var n3 = this, o2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            return r2.prepare(o2).then(function(t4) {
              return i.Log.debug("UserManager._signinStart: got navigator window handle"), n3.createSigninRequest(e3).then(function(e4) {
                return i.Log.debug("UserManager._signinStart: got signin request"), o2.url = e4.url, o2.id = e4.state.id, t4.navigate(o2);
              }).catch(function(e4) {
                throw t4.close && (i.Log.debug("UserManager._signinStart: Error after preparing navigator, closing navigator window"), t4.close()), e4;
              });
            });
          }, e2.prototype._signinEnd = function t3(e3) {
            var r2 = this, n3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return this.processSigninResponse(e3).then(function(t4) {
              i.Log.debug("UserManager._signinEnd: got signin response");
              var e4 = new a.User(t4);
              if (n3.current_sub) {
                if (n3.current_sub !== e4.profile.sub) return i.Log.debug("UserManager._signinEnd: current user does not match user returned from signin. sub from signin: ", e4.profile.sub), Promise.reject(new Error("login_required"));
                i.Log.debug("UserManager._signinEnd: current user matches user returned from signin");
              }
              return r2.storeUser(e4).then(function() {
                return i.Log.debug("UserManager._signinEnd: user stored"), r2._events.load(e4), e4;
              });
            });
          }, e2.prototype._signinCallback = function t3(e3, r2) {
            i.Log.debug("UserManager._signinCallback");
            var n3 = "query" === this._settings.response_mode || !this._settings.response_mode && l.SigninRequest.isCode(this._settings.response_type) ? "?" : "#";
            return r2.callback(e3, void 0, n3);
          }, e2.prototype.signoutRedirect = function t3() {
            var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            (e3 = Object.assign({}, e3)).request_type = "so:r";
            var r2 = e3.post_logout_redirect_uri || this.settings.post_logout_redirect_uri;
            r2 && (e3.post_logout_redirect_uri = r2);
            var n3 = { useReplaceToNavigate: e3.useReplaceToNavigate };
            return this._signoutStart(e3, this._redirectNavigator, n3).then(function() {
              i.Log.info("UserManager.signoutRedirect: successful");
            });
          }, e2.prototype.signoutRedirectCallback = function t3(e3) {
            return this._signoutEnd(e3 || this._redirectNavigator.url).then(function(t4) {
              return i.Log.info("UserManager.signoutRedirectCallback: successful"), t4;
            });
          }, e2.prototype.signoutPopup = function t3() {
            var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            (e3 = Object.assign({}, e3)).request_type = "so:p";
            var r2 = e3.post_logout_redirect_uri || this.settings.popup_post_logout_redirect_uri || this.settings.post_logout_redirect_uri;
            return e3.post_logout_redirect_uri = r2, e3.display = "popup", e3.post_logout_redirect_uri && (e3.state = e3.state || {}), this._signout(e3, this._popupNavigator, { startUrl: r2, popupWindowFeatures: e3.popupWindowFeatures || this.settings.popupWindowFeatures, popupWindowTarget: e3.popupWindowTarget || this.settings.popupWindowTarget }).then(function() {
              i.Log.info("UserManager.signoutPopup: successful");
            });
          }, e2.prototype.signoutPopupCallback = function t3(e3, r2) {
            void 0 === r2 && "boolean" == typeof e3 && (r2 = e3, e3 = null);
            return this._popupNavigator.callback(e3, r2, "?").then(function() {
              i.Log.info("UserManager.signoutPopupCallback: successful");
            });
          }, e2.prototype._signout = function t3(e3, r2) {
            var n3 = this, i2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            return this._signoutStart(e3, r2, i2).then(function(t4) {
              return n3._signoutEnd(t4.url);
            });
          }, e2.prototype._signoutStart = function t3() {
            var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r2 = this, n3 = arguments[1], o2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            return n3.prepare(o2).then(function(t4) {
              return i.Log.debug("UserManager._signoutStart: got navigator window handle"), r2._loadUser().then(function(n4) {
                return i.Log.debug("UserManager._signoutStart: loaded current user from storage"), (r2._settings.revokeAccessTokenOnSignout ? r2._revokeInternal(n4) : Promise.resolve()).then(function() {
                  var s2 = e3.id_token_hint || n4 && n4.id_token;
                  return s2 && (i.Log.debug("UserManager._signoutStart: Setting id_token into signout request"), e3.id_token_hint = s2), r2.removeUser().then(function() {
                    return i.Log.debug("UserManager._signoutStart: user removed, creating signout request"), r2.createSignoutRequest(e3).then(function(e4) {
                      return i.Log.debug("UserManager._signoutStart: got signout request"), o2.url = e4.url, e4.state && (o2.id = e4.state.id), t4.navigate(o2);
                    });
                  });
                });
              }).catch(function(e4) {
                throw t4.close && (i.Log.debug("UserManager._signoutStart: Error after preparing navigator, closing navigator window"), t4.close()), e4;
              });
            });
          }, e2.prototype._signoutEnd = function t3(e3) {
            return this.processSignoutResponse(e3).then(function(t4) {
              return i.Log.debug("UserManager._signoutEnd: got signout response"), t4;
            });
          }, e2.prototype.revokeAccessToken = function t3() {
            var e3 = this;
            return this._loadUser().then(function(t4) {
              return e3._revokeInternal(t4, true).then(function(r2) {
                if (r2) return i.Log.debug("UserManager.revokeAccessToken: removing token properties from user and re-storing"), t4.access_token = null, t4.refresh_token = null, t4.expires_at = null, t4.token_type = null, e3.storeUser(t4).then(function() {
                  i.Log.debug("UserManager.revokeAccessToken: user stored"), e3._events.load(t4);
                });
              });
            }).then(function() {
              i.Log.info("UserManager.revokeAccessToken: access token revoked successfully");
            });
          }, e2.prototype._revokeInternal = function t3(e3, r2) {
            var n3 = this;
            if (e3) {
              var o2 = e3.access_token, s2 = e3.refresh_token;
              return this._revokeAccessTokenInternal(o2, r2).then(function(t4) {
                return n3._revokeRefreshTokenInternal(s2, r2).then(function(e4) {
                  return t4 || e4 || i.Log.debug("UserManager.revokeAccessToken: no need to revoke due to no token(s), or JWT format"), t4 || e4;
                });
              });
            }
            return Promise.resolve(false);
          }, e2.prototype._revokeAccessTokenInternal = function t3(e3, r2) {
            return !e3 || e3.indexOf(".") >= 0 ? Promise.resolve(false) : this._tokenRevocationClient.revoke(e3, r2).then(function() {
              return true;
            });
          }, e2.prototype._revokeRefreshTokenInternal = function t3(e3, r2) {
            return e3 ? this._tokenRevocationClient.revoke(e3, r2, "refresh_token").then(function() {
              return true;
            }) : Promise.resolve(false);
          }, e2.prototype.startSilentRenew = function t3() {
            this._silentRenewService.start();
          }, e2.prototype.stopSilentRenew = function t3() {
            this._silentRenewService.stop();
          }, e2.prototype._loadUser = function t3() {
            return this._userStore.get(this._userStoreKey).then(function(t4) {
              return t4 ? (i.Log.debug("UserManager._loadUser: user storageString loaded"), a.User.fromStorageString(t4)) : (i.Log.debug("UserManager._loadUser: no user storageString"), null);
            });
          }, e2.prototype.storeUser = function t3(e3) {
            if (e3) {
              i.Log.debug("UserManager.storeUser: storing user");
              var r2 = e3.toStorageString();
              return this._userStore.set(this._userStoreKey, r2);
            }
            return i.Log.debug("storeUser.storeUser: removing user"), this._userStore.remove(this._userStoreKey);
          }, n2(e2, [{ key: "_redirectNavigator", get: function t3() {
            return this.settings.redirectNavigator;
          } }, { key: "_popupNavigator", get: function t3() {
            return this.settings.popupNavigator;
          } }, { key: "_iframeNavigator", get: function t3() {
            return this.settings.iframeNavigator;
          } }, { key: "_userStore", get: function t3() {
            return this.settings.userStore;
          } }, { key: "events", get: function t3() {
            return this._events;
          } }, { key: "_userStoreKey", get: function t3() {
            return "user:" + this.settings.authority + ":" + this.settings.client_id;
          } }]), e2;
        }(o.OidcClient);
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.UserManagerSettings = void 0;
        var n2 = /* @__PURE__ */ function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n3 = e2[r2];
              n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(t3, n3.key, n3);
            }
          }
          return function(e2, r2, n3) {
            return r2 && t2(e2.prototype, r2), n3 && t2(e2, n3), e2;
          };
        }(), i = (r(0), r(5)), o = r(40), s = r(41), a = r(43), u = r(6), c = r(1), h = r(8);
        function l(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        function f(t2, e2) {
          if (!t2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !e2 || "object" != typeof e2 && "function" != typeof e2 ? t2 : e2;
        }
        e.UserManagerSettings = function(t2) {
          function e2() {
            var r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n3 = r2.popup_redirect_uri, i2 = r2.popup_post_logout_redirect_uri, g = r2.popupWindowFeatures, d = r2.popupWindowTarget, p = r2.silent_redirect_uri, v2 = r2.silentRequestTimeout, y = r2.automaticSilentRenew, m = void 0 !== y && y, _ = r2.validateSubOnSilentRenew, S = void 0 !== _ && _, b = r2.includeIdTokenInSilentRenew, w = void 0 === b || b, F = r2.monitorSession, E = void 0 === F || F, x = r2.monitorAnonymousSession, A = void 0 !== x && x, k = r2.checkSessionInterval, P = void 0 === k ? 2e3 : k, C = r2.stopCheckSessionOnError, T = void 0 === C || C, R = r2.query_status_response_type, I = r2.revokeAccessTokenOnSignout, D = void 0 !== I && I, L = r2.accessTokenExpiringNotificationTime, N = void 0 === L ? 60 : L, U = r2.redirectNavigator, B = void 0 === U ? new o.RedirectNavigator() : U, O = r2.popupNavigator, j = void 0 === O ? new s.PopupNavigator() : O, M = r2.iframeNavigator, H = void 0 === M ? new a.IFrameNavigator() : M, V = r2.userStore, K = void 0 === V ? new u.WebStorageStateStore({ store: c.Global.sessionStorage }) : V;
            l(this, e2);
            var q = f(this, t2.call(this, arguments[0]));
            return q._popup_redirect_uri = n3, q._popup_post_logout_redirect_uri = i2, q._popupWindowFeatures = g, q._popupWindowTarget = d, q._silent_redirect_uri = p, q._silentRequestTimeout = v2, q._automaticSilentRenew = m, q._validateSubOnSilentRenew = S, q._includeIdTokenInSilentRenew = w, q._accessTokenExpiringNotificationTime = N, q._monitorSession = E, q._monitorAnonymousSession = A, q._checkSessionInterval = P, q._stopCheckSessionOnError = T, R ? q._query_status_response_type = R : arguments[0] && arguments[0].response_type ? q._query_status_response_type = h.SigninRequest.isOidc(arguments[0].response_type) ? "id_token" : "code" : q._query_status_response_type = "id_token", q._revokeAccessTokenOnSignout = D, q._redirectNavigator = B, q._popupNavigator = j, q._iframeNavigator = H, q._userStore = K, q;
          }
          return function r2(t3, e3) {
            if ("function" != typeof e3 && null !== e3) throw new TypeError("Super expression must either be null or a function, not " + typeof e3);
            t3.prototype = Object.create(e3 && e3.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), e3 && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, e3) : t3.__proto__ = e3);
          }(e2, t2), n2(e2, [{ key: "popup_redirect_uri", get: function t3() {
            return this._popup_redirect_uri;
          } }, { key: "popup_post_logout_redirect_uri", get: function t3() {
            return this._popup_post_logout_redirect_uri;
          } }, { key: "popupWindowFeatures", get: function t3() {
            return this._popupWindowFeatures;
          } }, { key: "popupWindowTarget", get: function t3() {
            return this._popupWindowTarget;
          } }, { key: "silent_redirect_uri", get: function t3() {
            return this._silent_redirect_uri;
          } }, { key: "silentRequestTimeout", get: function t3() {
            return this._silentRequestTimeout;
          } }, { key: "automaticSilentRenew", get: function t3() {
            return this._automaticSilentRenew;
          } }, { key: "validateSubOnSilentRenew", get: function t3() {
            return this._validateSubOnSilentRenew;
          } }, { key: "includeIdTokenInSilentRenew", get: function t3() {
            return this._includeIdTokenInSilentRenew;
          } }, { key: "accessTokenExpiringNotificationTime", get: function t3() {
            return this._accessTokenExpiringNotificationTime;
          } }, { key: "monitorSession", get: function t3() {
            return this._monitorSession;
          } }, { key: "monitorAnonymousSession", get: function t3() {
            return this._monitorAnonymousSession;
          } }, { key: "checkSessionInterval", get: function t3() {
            return this._checkSessionInterval;
          } }, { key: "stopCheckSessionOnError", get: function t3() {
            return this._stopCheckSessionOnError;
          } }, { key: "query_status_response_type", get: function t3() {
            return this._query_status_response_type;
          } }, { key: "revokeAccessTokenOnSignout", get: function t3() {
            return this._revokeAccessTokenOnSignout;
          } }, { key: "redirectNavigator", get: function t3() {
            return this._redirectNavigator;
          } }, { key: "popupNavigator", get: function t3() {
            return this._popupNavigator;
          } }, { key: "iframeNavigator", get: function t3() {
            return this._iframeNavigator;
          } }, { key: "userStore", get: function t3() {
            return this._userStore;
          } }]), e2;
        }(i.OidcClientSettings);
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.RedirectNavigator = void 0;
        var n2 = /* @__PURE__ */ function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n3 = e2[r2];
              n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(t3, n3.key, n3);
            }
          }
          return function(e2, r2, n3) {
            return r2 && t2(e2.prototype, r2), n3 && t2(e2, n3), e2;
          };
        }(), i = r(0);
        e.RedirectNavigator = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2)) throw new TypeError("Cannot call a class as a function");
            }(this, t2);
          }
          return t2.prototype.prepare = function t3() {
            return Promise.resolve(this);
          }, t2.prototype.navigate = function t3(e2) {
            return e2 && e2.url ? (e2.useReplaceToNavigate ? window.location.replace(e2.url) : window.location = e2.url, Promise.resolve()) : (i.Log.error("RedirectNavigator.navigate: No url provided"), Promise.reject(new Error("No url provided")));
          }, n2(t2, [{ key: "url", get: function t3() {
            return window.location.href;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.PopupNavigator = void 0;
        var n2 = r(0), i = r(42);
        e.PopupNavigator = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2)) throw new TypeError("Cannot call a class as a function");
            }(this, t2);
          }
          return t2.prototype.prepare = function t3(e2) {
            var r2 = new i.PopupWindow(e2);
            return Promise.resolve(r2);
          }, t2.prototype.callback = function t3(e2, r2, o) {
            n2.Log.debug("PopupNavigator.callback");
            try {
              return i.PopupWindow.notifyOpener(e2, r2, o), Promise.resolve();
            } catch (t4) {
              return Promise.reject(t4);
            }
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.PopupWindow = void 0;
        var n2 = /* @__PURE__ */ function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n3 = e2[r2];
              n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(t3, n3.key, n3);
            }
          }
          return function(e2, r2, n3) {
            return r2 && t2(e2.prototype, r2), n3 && t2(e2, n3), e2;
          };
        }(), i = r(0), o = r(3);
        e.PopupWindow = function() {
          function t2(e2) {
            var r2 = this;
            !function n3(t3, e3) {
              if (!(t3 instanceof e3)) throw new TypeError("Cannot call a class as a function");
            }(this, t2), this._promise = new Promise(function(t3, e3) {
              r2._resolve = t3, r2._reject = e3;
            });
            var o2 = e2.popupWindowTarget || "_blank", s = e2.popupWindowFeatures || "location=no,toolbar=no,width=500,height=500,left=100,top=100;";
            this._popup = window.open("", o2, s), this._popup && (i.Log.debug("PopupWindow.ctor: popup successfully created"), this._checkForPopupClosedTimer = window.setInterval(this._checkForPopupClosed.bind(this), 500));
          }
          return t2.prototype.navigate = function t3(e2) {
            return this._popup ? e2 && e2.url ? (i.Log.debug("PopupWindow.navigate: Setting URL in popup"), this._id = e2.id, this._id && (window["popupCallback_" + e2.id] = this._callback.bind(this)), this._popup.focus(), this._popup.window.location = e2.url) : (this._error("PopupWindow.navigate: no url provided"), this._error("No url provided")) : this._error("PopupWindow.navigate: Error opening popup window"), this.promise;
          }, t2.prototype._success = function t3(e2) {
            i.Log.debug("PopupWindow.callback: Successful response from popup window"), this._cleanup(), this._resolve(e2);
          }, t2.prototype._error = function t3(e2) {
            i.Log.error("PopupWindow.error: ", e2), this._cleanup(), this._reject(new Error(e2));
          }, t2.prototype.close = function t3() {
            this._cleanup(false);
          }, t2.prototype._cleanup = function t3(e2) {
            i.Log.debug("PopupWindow.cleanup"), window.clearInterval(this._checkForPopupClosedTimer), this._checkForPopupClosedTimer = null, delete window["popupCallback_" + this._id], this._popup && !e2 && this._popup.close(), this._popup = null;
          }, t2.prototype._checkForPopupClosed = function t3() {
            this._popup && !this._popup.closed || this._error("Popup window closed");
          }, t2.prototype._callback = function t3(e2, r2) {
            this._cleanup(r2), e2 ? (i.Log.debug("PopupWindow.callback success"), this._success({ url: e2 })) : (i.Log.debug("PopupWindow.callback: Invalid response from popup"), this._error("Invalid response from popup"));
          }, t2.notifyOpener = function t3(e2, r2, n3) {
            if (window.opener) {
              if (e2 = e2 || window.location.href) {
                var s = o.UrlUtility.parseUrlFragment(e2, n3);
                if (s.state) {
                  var a = "popupCallback_" + s.state, u = window.opener[a];
                  u ? (i.Log.debug("PopupWindow.notifyOpener: passing url message to opener"), u(e2, r2)) : i.Log.warn("PopupWindow.notifyOpener: no matching callback found on opener");
                } else i.Log.warn("PopupWindow.notifyOpener: no state found in response url");
              }
            } else i.Log.warn("PopupWindow.notifyOpener: no window.opener. Can't complete notification.");
          }, n2(t2, [{ key: "promise", get: function t3() {
            return this._promise;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.IFrameNavigator = void 0;
        var n2 = r(0), i = r(44);
        e.IFrameNavigator = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2)) throw new TypeError("Cannot call a class as a function");
            }(this, t2);
          }
          return t2.prototype.prepare = function t3(e2) {
            var r2 = new i.IFrameWindow(e2);
            return Promise.resolve(r2);
          }, t2.prototype.callback = function t3(e2) {
            n2.Log.debug("IFrameNavigator.callback");
            try {
              return i.IFrameWindow.notifyParent(e2), Promise.resolve();
            } catch (t4) {
              return Promise.reject(t4);
            }
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.IFrameWindow = void 0;
        var n2 = /* @__PURE__ */ function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n3 = e2[r2];
              n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(t3, n3.key, n3);
            }
          }
          return function(e2, r2, n3) {
            return r2 && t2(e2.prototype, r2), n3 && t2(e2, n3), e2;
          };
        }(), i = r(0);
        e.IFrameWindow = function() {
          function t2(e2) {
            var r2 = this;
            !function n3(t3, e3) {
              if (!(t3 instanceof e3)) throw new TypeError("Cannot call a class as a function");
            }(this, t2), this._promise = new Promise(function(t3, e3) {
              r2._resolve = t3, r2._reject = e3;
            }), this._boundMessageEvent = this._message.bind(this), window.addEventListener("message", this._boundMessageEvent, false), this._frame = window.document.createElement("iframe"), this._frame.style.visibility = "hidden", this._frame.style.position = "absolute", this._frame.width = 0, this._frame.height = 0, window.document.body.appendChild(this._frame);
          }
          return t2.prototype.navigate = function t3(e2) {
            if (e2 && e2.url) {
              var r2 = e2.silentRequestTimeout || 1e4;
              i.Log.debug("IFrameWindow.navigate: Using timeout of:", r2), this._timer = window.setTimeout(this._timeout.bind(this), r2), this._frame.src = e2.url;
            } else this._error("No url provided");
            return this.promise;
          }, t2.prototype._success = function t3(e2) {
            this._cleanup(), i.Log.debug("IFrameWindow: Successful response from frame window"), this._resolve(e2);
          }, t2.prototype._error = function t3(e2) {
            this._cleanup(), i.Log.error(e2), this._reject(new Error(e2));
          }, t2.prototype.close = function t3() {
            this._cleanup();
          }, t2.prototype._cleanup = function t3() {
            this._frame && (i.Log.debug("IFrameWindow: cleanup"), window.removeEventListener("message", this._boundMessageEvent, false), window.clearTimeout(this._timer), window.document.body.removeChild(this._frame), this._timer = null, this._frame = null, this._boundMessageEvent = null);
          }, t2.prototype._timeout = function t3() {
            i.Log.debug("IFrameWindow.timeout"), this._error("Frame window timed out");
          }, t2.prototype._message = function t3(e2) {
            if (i.Log.debug("IFrameWindow.message"), this._timer && e2.origin === this._origin && e2.source === this._frame.contentWindow && "string" == typeof e2.data && (e2.data.startsWith("http://") || e2.data.startsWith("https://"))) {
              var r2 = e2.data;
              r2 ? this._success({ url: r2 }) : this._error("Invalid response from frame");
            }
          }, t2.notifyParent = function t3(e2) {
            i.Log.debug("IFrameWindow.notifyParent"), (e2 = e2 || window.location.href) && (i.Log.debug("IFrameWindow.notifyParent: posting url message to parent"), window.parent.postMessage(e2, location.protocol + "//" + location.host));
          }, n2(t2, [{ key: "promise", get: function t3() {
            return this._promise;
          } }, { key: "_origin", get: function t3() {
            return location.protocol + "//" + location.host;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.UserManagerEvents = void 0;
        var n2 = r(0), i = r(16), o = r(17);
        e.UserManagerEvents = function(t2) {
          function e2(r2) {
            !function n3(t3, e3) {
              if (!(t3 instanceof e3)) throw new TypeError("Cannot call a class as a function");
            }(this, e2);
            var i2 = function s(t3, e3) {
              if (!t3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return !e3 || "object" != typeof e3 && "function" != typeof e3 ? t3 : e3;
            }(this, t2.call(this, r2));
            return i2._userLoaded = new o.Event("User loaded"), i2._userUnloaded = new o.Event("User unloaded"), i2._silentRenewError = new o.Event("Silent renew error"), i2._userSignedIn = new o.Event("User signed in"), i2._userSignedOut = new o.Event("User signed out"), i2._userSessionChanged = new o.Event("User session changed"), i2;
          }
          return function r2(t3, e3) {
            if ("function" != typeof e3 && null !== e3) throw new TypeError("Super expression must either be null or a function, not " + typeof e3);
            t3.prototype = Object.create(e3 && e3.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), e3 && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, e3) : t3.__proto__ = e3);
          }(e2, t2), e2.prototype.load = function e3(r2) {
            var i2 = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
            n2.Log.debug("UserManagerEvents.load"), t2.prototype.load.call(this, r2), i2 && this._userLoaded.raise(r2);
          }, e2.prototype.unload = function e3() {
            n2.Log.debug("UserManagerEvents.unload"), t2.prototype.unload.call(this), this._userUnloaded.raise();
          }, e2.prototype.addUserLoaded = function t3(e3) {
            this._userLoaded.addHandler(e3);
          }, e2.prototype.removeUserLoaded = function t3(e3) {
            this._userLoaded.removeHandler(e3);
          }, e2.prototype.addUserUnloaded = function t3(e3) {
            this._userUnloaded.addHandler(e3);
          }, e2.prototype.removeUserUnloaded = function t3(e3) {
            this._userUnloaded.removeHandler(e3);
          }, e2.prototype.addSilentRenewError = function t3(e3) {
            this._silentRenewError.addHandler(e3);
          }, e2.prototype.removeSilentRenewError = function t3(e3) {
            this._silentRenewError.removeHandler(e3);
          }, e2.prototype._raiseSilentRenewError = function t3(e3) {
            n2.Log.debug("UserManagerEvents._raiseSilentRenewError", e3.message), this._silentRenewError.raise(e3);
          }, e2.prototype.addUserSignedIn = function t3(e3) {
            this._userSignedIn.addHandler(e3);
          }, e2.prototype.removeUserSignedIn = function t3(e3) {
            this._userSignedIn.removeHandler(e3);
          }, e2.prototype._raiseUserSignedIn = function t3() {
            n2.Log.debug("UserManagerEvents._raiseUserSignedIn"), this._userSignedIn.raise();
          }, e2.prototype.addUserSignedOut = function t3(e3) {
            this._userSignedOut.addHandler(e3);
          }, e2.prototype.removeUserSignedOut = function t3(e3) {
            this._userSignedOut.removeHandler(e3);
          }, e2.prototype._raiseUserSignedOut = function t3() {
            n2.Log.debug("UserManagerEvents._raiseUserSignedOut"), this._userSignedOut.raise();
          }, e2.prototype.addUserSessionChanged = function t3(e3) {
            this._userSessionChanged.addHandler(e3);
          }, e2.prototype.removeUserSessionChanged = function t3(e3) {
            this._userSessionChanged.removeHandler(e3);
          }, e2.prototype._raiseUserSessionChanged = function t3() {
            n2.Log.debug("UserManagerEvents._raiseUserSessionChanged"), this._userSessionChanged.raise();
          }, e2;
        }(i.AccessTokenEvents);
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.Timer = void 0;
        var n2 = /* @__PURE__ */ function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n3 = e2[r2];
              n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(t3, n3.key, n3);
            }
          }
          return function(e2, r2, n3) {
            return r2 && t2(e2.prototype, r2), n3 && t2(e2, n3), e2;
          };
        }(), i = r(0), o = r(1), s = r(17);
        function a(t2, e2) {
          if (!(t2 instanceof e2)) throw new TypeError("Cannot call a class as a function");
        }
        function u(t2, e2) {
          if (!t2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !e2 || "object" != typeof e2 && "function" != typeof e2 ? t2 : e2;
        }
        e.Timer = function(t2) {
          function e2(r2) {
            var n3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.Global.timer, i2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
            a(this, e2);
            var s2 = u(this, t2.call(this, r2));
            return s2._timer = n3, s2._nowFunc = i2 || function() {
              return Date.now() / 1e3;
            }, s2;
          }
          return function r2(t3, e3) {
            if ("function" != typeof e3 && null !== e3) throw new TypeError("Super expression must either be null or a function, not " + typeof e3);
            t3.prototype = Object.create(e3 && e3.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), e3 && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, e3) : t3.__proto__ = e3);
          }(e2, t2), e2.prototype.init = function t3(e3) {
            e3 <= 0 && (e3 = 1), e3 = parseInt(e3);
            var r2 = this.now + e3;
            if (this.expiration === r2 && this._timerHandle) i.Log.debug("Timer.init timer " + this._name + " skipping initialization since already initialized for expiration:", this.expiration);
            else {
              this.cancel(), i.Log.debug("Timer.init timer " + this._name + " for duration:", e3), this._expiration = r2;
              var n3 = 5;
              e3 < n3 && (n3 = e3), this._timerHandle = this._timer.setInterval(this._callback.bind(this), 1e3 * n3);
            }
          }, e2.prototype.cancel = function t3() {
            this._timerHandle && (i.Log.debug("Timer.cancel: ", this._name), this._timer.clearInterval(this._timerHandle), this._timerHandle = null);
          }, e2.prototype._callback = function e3() {
            var r2 = this._expiration - this.now;
            i.Log.debug("Timer.callback; " + this._name + " timer expires in:", r2), this._expiration <= this.now && (this.cancel(), t2.prototype.raise.call(this));
          }, n2(e2, [{ key: "now", get: function t3() {
            return parseInt(this._nowFunc());
          } }, { key: "expiration", get: function t3() {
            return this._expiration;
          } }]), e2;
        }(s.Event);
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.SilentRenewService = void 0;
        var n2 = r(0);
        e.SilentRenewService = function() {
          function t2(e2) {
            !function r2(t3, e3) {
              if (!(t3 instanceof e3)) throw new TypeError("Cannot call a class as a function");
            }(this, t2), this._userManager = e2;
          }
          return t2.prototype.start = function t3() {
            this._callback || (this._callback = this._tokenExpiring.bind(this), this._userManager.events.addAccessTokenExpiring(this._callback), this._userManager.getUser().then(function(t4) {
            }).catch(function(t4) {
              n2.Log.error("SilentRenewService.start: Error from getUser:", t4.message);
            }));
          }, t2.prototype.stop = function t3() {
            this._callback && (this._userManager.events.removeAccessTokenExpiring(this._callback), delete this._callback);
          }, t2.prototype._tokenExpiring = function t3() {
            var e2 = this;
            this._userManager.signinSilent().then(function(t4) {
              n2.Log.debug("SilentRenewService._tokenExpiring: Silent token renewal successful");
            }, function(t4) {
              n2.Log.error("SilentRenewService._tokenExpiring: Error from signinSilent:", t4.message), e2._userManager.events._raiseSilentRenewError(t4);
            });
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.CordovaPopupNavigator = void 0;
        var n2 = r(21);
        e.CordovaPopupNavigator = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2)) throw new TypeError("Cannot call a class as a function");
            }(this, t2);
          }
          return t2.prototype.prepare = function t3(e2) {
            var r2 = new n2.CordovaPopupWindow(e2);
            return Promise.resolve(r2);
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.CordovaIFrameNavigator = void 0;
        var n2 = r(21);
        e.CordovaIFrameNavigator = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2)) throw new TypeError("Cannot call a class as a function");
            }(this, t2);
          }
          return t2.prototype.prepare = function t3(e2) {
            e2.popupWindowFeatures = "hidden=yes";
            var r2 = new n2.CordovaPopupWindow(e2);
            return Promise.resolve(r2);
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true });
        e.Version = "1.11.6";
      }]);
    });
  }
});

// ../node_modules/lunr/lunr.js
var require_lunr = __commonJS({
  "../node_modules/lunr/lunr.js"(exports, module2) {
    (function() {
      var lunr2 = function(config2) {
        var builder = new lunr2.Builder();
        builder.pipeline.add(
          lunr2.trimmer,
          lunr2.stopWordFilter,
          lunr2.stemmer
        );
        builder.searchPipeline.add(
          lunr2.stemmer
        );
        config2.call(builder, builder);
        return builder.build();
      };
      lunr2.version = "2.3.9";
      lunr2.utils = {};
      lunr2.utils.warn = /* @__PURE__ */ function(global2) {
        return function(message4) {
          if (global2.console && console.warn) {
            console.warn(message4);
          }
        };
      }(this);
      lunr2.utils.asString = function(obj) {
        if (obj === void 0 || obj === null) {
          return "";
        } else {
          return obj.toString();
        }
      };
      lunr2.utils.clone = function(obj) {
        if (obj === null || obj === void 0) {
          return obj;
        }
        var clone2 = /* @__PURE__ */ Object.create(null), keys = Object.keys(obj);
        for (var i = 0; i < keys.length; i++) {
          var key3 = keys[i], val = obj[key3];
          if (Array.isArray(val)) {
            clone2[key3] = val.slice();
            continue;
          }
          if (typeof val === "string" || typeof val === "number" || typeof val === "boolean") {
            clone2[key3] = val;
            continue;
          }
          throw new TypeError("clone is not deep and does not support nested objects");
        }
        return clone2;
      };
      lunr2.FieldRef = function(docRef, fieldName, stringValue) {
        this.docRef = docRef;
        this.fieldName = fieldName;
        this._stringValue = stringValue;
      };
      lunr2.FieldRef.joiner = "/";
      lunr2.FieldRef.fromString = function(s) {
        var n2 = s.indexOf(lunr2.FieldRef.joiner);
        if (n2 === -1) {
          throw "malformed field ref string";
        }
        var fieldRef = s.slice(0, n2), docRef = s.slice(n2 + 1);
        return new lunr2.FieldRef(docRef, fieldRef, s);
      };
      lunr2.FieldRef.prototype.toString = function() {
        if (this._stringValue == void 0) {
          this._stringValue = this.fieldName + lunr2.FieldRef.joiner + this.docRef;
        }
        return this._stringValue;
      };
      lunr2.Set = function(elements) {
        this.elements = /* @__PURE__ */ Object.create(null);
        if (elements) {
          this.length = elements.length;
          for (var i = 0; i < this.length; i++) {
            this.elements[elements[i]] = true;
          }
        } else {
          this.length = 0;
        }
      };
      lunr2.Set.complete = {
        intersect: function(other2) {
          return other2;
        },
        union: function() {
          return this;
        },
        contains: function() {
          return true;
        }
      };
      lunr2.Set.empty = {
        intersect: function() {
          return this;
        },
        union: function(other2) {
          return other2;
        },
        contains: function() {
          return false;
        }
      };
      lunr2.Set.prototype.contains = function(object6) {
        return !!this.elements[object6];
      };
      lunr2.Set.prototype.intersect = function(other2) {
        var a, b, elements, intersection = [];
        if (other2 === lunr2.Set.complete) {
          return this;
        }
        if (other2 === lunr2.Set.empty) {
          return other2;
        }
        if (this.length < other2.length) {
          a = this;
          b = other2;
        } else {
          a = other2;
          b = this;
        }
        elements = Object.keys(a.elements);
        for (var i = 0; i < elements.length; i++) {
          var element2 = elements[i];
          if (element2 in b.elements) {
            intersection.push(element2);
          }
        }
        return new lunr2.Set(intersection);
      };
      lunr2.Set.prototype.union = function(other2) {
        if (other2 === lunr2.Set.complete) {
          return lunr2.Set.complete;
        }
        if (other2 === lunr2.Set.empty) {
          return this;
        }
        return new lunr2.Set(Object.keys(this.elements).concat(Object.keys(other2.elements)));
      };
      lunr2.idf = function(posting, documentCount) {
        var documentsWithTerm = 0;
        for (var fieldName in posting) {
          if (fieldName == "_index") continue;
          documentsWithTerm += Object.keys(posting[fieldName]).length;
        }
        var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5);
        return Math.log(1 + Math.abs(x));
      };
      lunr2.Token = function(str, metadata2) {
        this.str = str || "";
        this.metadata = metadata2 || {};
      };
      lunr2.Token.prototype.toString = function() {
        return this.str;
      };
      lunr2.Token.prototype.update = function(fn2) {
        this.str = fn2(this.str, this.metadata);
        return this;
      };
      lunr2.Token.prototype.clone = function(fn2) {
        fn2 = fn2 || function(s) {
          return s;
        };
        return new lunr2.Token(fn2(this.str, this.metadata), this.metadata);
      };
      lunr2.tokenizer = function(obj, metadata2) {
        if (obj == null || obj == void 0) {
          return [];
        }
        if (Array.isArray(obj)) {
          return obj.map(function(t) {
            return new lunr2.Token(
              lunr2.utils.asString(t).toLowerCase(),
              lunr2.utils.clone(metadata2)
            );
          });
        }
        var str = obj.toString().toLowerCase(), len = str.length, tokens = [];
        for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
          var char = str.charAt(sliceEnd), sliceLength = sliceEnd - sliceStart;
          if (char.match(lunr2.tokenizer.separator) || sliceEnd == len) {
            if (sliceLength > 0) {
              var tokenMetadata = lunr2.utils.clone(metadata2) || {};
              tokenMetadata["position"] = [sliceStart, sliceLength];
              tokenMetadata["index"] = tokens.length;
              tokens.push(
                new lunr2.Token(
                  str.slice(sliceStart, sliceEnd),
                  tokenMetadata
                )
              );
            }
            sliceStart = sliceEnd + 1;
          }
        }
        return tokens;
      };
      lunr2.tokenizer.separator = /[\s\-]+/;
      lunr2.Pipeline = function() {
        this._stack = [];
      };
      lunr2.Pipeline.registeredFunctions = /* @__PURE__ */ Object.create(null);
      lunr2.Pipeline.registerFunction = function(fn2, label4) {
        if (label4 in this.registeredFunctions) {
          lunr2.utils.warn("Overwriting existing registered function: " + label4);
        }
        fn2.label = label4;
        lunr2.Pipeline.registeredFunctions[fn2.label] = fn2;
      };
      lunr2.Pipeline.warnIfFunctionNotRegistered = function(fn2) {
        var isRegistered = fn2.label && fn2.label in this.registeredFunctions;
        if (!isRegistered) {
          lunr2.utils.warn("Function is not registered with pipeline. This may cause problems when serialising the index.\n", fn2);
        }
      };
      lunr2.Pipeline.load = function(serialised) {
        var pipeline = new lunr2.Pipeline();
        serialised.forEach(function(fnName) {
          var fn2 = lunr2.Pipeline.registeredFunctions[fnName];
          if (fn2) {
            pipeline.add(fn2);
          } else {
            throw new Error("Cannot load unregistered function: " + fnName);
          }
        });
        return pipeline;
      };
      lunr2.Pipeline.prototype.add = function() {
        var fns = Array.prototype.slice.call(arguments);
        fns.forEach(function(fn2) {
          lunr2.Pipeline.warnIfFunctionNotRegistered(fn2);
          this._stack.push(fn2);
        }, this);
      };
      lunr2.Pipeline.prototype.after = function(existingFn, newFn) {
        lunr2.Pipeline.warnIfFunctionNotRegistered(newFn);
        var pos = this._stack.indexOf(existingFn);
        if (pos == -1) {
          throw new Error("Cannot find existingFn");
        }
        pos = pos + 1;
        this._stack.splice(pos, 0, newFn);
      };
      lunr2.Pipeline.prototype.before = function(existingFn, newFn) {
        lunr2.Pipeline.warnIfFunctionNotRegistered(newFn);
        var pos = this._stack.indexOf(existingFn);
        if (pos == -1) {
          throw new Error("Cannot find existingFn");
        }
        this._stack.splice(pos, 0, newFn);
      };
      lunr2.Pipeline.prototype.remove = function(fn2) {
        var pos = this._stack.indexOf(fn2);
        if (pos == -1) {
          return;
        }
        this._stack.splice(pos, 1);
      };
      lunr2.Pipeline.prototype.run = function(tokens) {
        var stackLength = this._stack.length;
        for (var i = 0; i < stackLength; i++) {
          var fn2 = this._stack[i];
          var memo = [];
          for (var j = 0; j < tokens.length; j++) {
            var result5 = fn2(tokens[j], j, tokens);
            if (result5 === null || result5 === void 0 || result5 === "") continue;
            if (Array.isArray(result5)) {
              for (var k = 0; k < result5.length; k++) {
                memo.push(result5[k]);
              }
            } else {
              memo.push(result5);
            }
          }
          tokens = memo;
        }
        return tokens;
      };
      lunr2.Pipeline.prototype.runString = function(str, metadata2) {
        var token = new lunr2.Token(str, metadata2);
        return this.run([token]).map(function(t) {
          return t.toString();
        });
      };
      lunr2.Pipeline.prototype.reset = function() {
        this._stack = [];
      };
      lunr2.Pipeline.prototype.toJSON = function() {
        return this._stack.map(function(fn2) {
          lunr2.Pipeline.warnIfFunctionNotRegistered(fn2);
          return fn2.label;
        });
      };
      lunr2.Vector = function(elements) {
        this._magnitude = 0;
        this.elements = elements || [];
      };
      lunr2.Vector.prototype.positionForIndex = function(index2) {
        if (this.elements.length == 0) {
          return 0;
        }
        var start2 = 0, end2 = this.elements.length / 2, sliceLength = end2 - start2, pivotPoint = Math.floor(sliceLength / 2), pivotIndex = this.elements[pivotPoint * 2];
        while (sliceLength > 1) {
          if (pivotIndex < index2) {
            start2 = pivotPoint;
          }
          if (pivotIndex > index2) {
            end2 = pivotPoint;
          }
          if (pivotIndex == index2) {
            break;
          }
          sliceLength = end2 - start2;
          pivotPoint = start2 + Math.floor(sliceLength / 2);
          pivotIndex = this.elements[pivotPoint * 2];
        }
        if (pivotIndex == index2) {
          return pivotPoint * 2;
        }
        if (pivotIndex > index2) {
          return pivotPoint * 2;
        }
        if (pivotIndex < index2) {
          return (pivotPoint + 1) * 2;
        }
      };
      lunr2.Vector.prototype.insert = function(insertIdx, val) {
        this.upsert(insertIdx, val, function() {
          throw "duplicate index";
        });
      };
      lunr2.Vector.prototype.upsert = function(insertIdx, val, fn2) {
        this._magnitude = 0;
        var position4 = this.positionForIndex(insertIdx);
        if (this.elements[position4] == insertIdx) {
          this.elements[position4 + 1] = fn2(this.elements[position4 + 1], val);
        } else {
          this.elements.splice(position4, 0, insertIdx, val);
        }
      };
      lunr2.Vector.prototype.magnitude = function() {
        if (this._magnitude) return this._magnitude;
        var sumOfSquares = 0, elementsLength = this.elements.length;
        for (var i = 1; i < elementsLength; i += 2) {
          var val = this.elements[i];
          sumOfSquares += val * val;
        }
        return this._magnitude = Math.sqrt(sumOfSquares);
      };
      lunr2.Vector.prototype.dot = function(otherVector) {
        var dotProduct = 0, a = this.elements, b = otherVector.elements, aLen = a.length, bLen = b.length, aVal = 0, bVal = 0, i = 0, j = 0;
        while (i < aLen && j < bLen) {
          aVal = a[i], bVal = b[j];
          if (aVal < bVal) {
            i += 2;
          } else if (aVal > bVal) {
            j += 2;
          } else if (aVal == bVal) {
            dotProduct += a[i + 1] * b[j + 1];
            i += 2;
            j += 2;
          }
        }
        return dotProduct;
      };
      lunr2.Vector.prototype.similarity = function(otherVector) {
        return this.dot(otherVector) / this.magnitude() || 0;
      };
      lunr2.Vector.prototype.toArray = function() {
        var output2 = new Array(this.elements.length / 2);
        for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
          output2[j] = this.elements[i];
        }
        return output2;
      };
      lunr2.Vector.prototype.toJSON = function() {
        return this.elements;
      };
      lunr2.stemmer = function() {
        var step2list = {
          "ational": "ate",
          "tional": "tion",
          "enci": "ence",
          "anci": "ance",
          "izer": "ize",
          "bli": "ble",
          "alli": "al",
          "entli": "ent",
          "eli": "e",
          "ousli": "ous",
          "ization": "ize",
          "ation": "ate",
          "ator": "ate",
          "alism": "al",
          "iveness": "ive",
          "fulness": "ful",
          "ousness": "ous",
          "aliti": "al",
          "iviti": "ive",
          "biliti": "ble",
          "logi": "log"
        }, step3list = {
          "icate": "ic",
          "ative": "",
          "alize": "al",
          "iciti": "ic",
          "ical": "ic",
          "ful": "",
          "ness": ""
        }, c = "[^aeiou]", v2 = "[aeiouy]", C = c + "[^aeiouy]*", V = v2 + "[aeiou]*", mgr0 = "^(" + C + ")?" + V + C, meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$", mgr1 = "^(" + C + ")?" + V + C + V + C, s_v = "^(" + C + ")?" + v2;
        var re_mgr0 = new RegExp(mgr0);
        var re_mgr1 = new RegExp(mgr1);
        var re_meq1 = new RegExp(meq1);
        var re_s_v = new RegExp(s_v);
        var re_1a = /^(.+?)(ss|i)es$/;
        var re2_1a = /^(.+?)([^s])s$/;
        var re_1b = /^(.+?)eed$/;
        var re2_1b = /^(.+?)(ed|ing)$/;
        var re_1b_2 = /.$/;
        var re2_1b_2 = /(at|bl|iz)$/;
        var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
        var re4_1b_2 = new RegExp("^" + C + v2 + "[^aeiouwxy]$");
        var re_1c = /^(.+?[^aeiou])y$/;
        var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;
        var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;
        var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
        var re2_4 = /^(.+?)(s|t)(ion)$/;
        var re_5 = /^(.+?)e$/;
        var re_5_1 = /ll$/;
        var re3_5 = new RegExp("^" + C + v2 + "[^aeiouwxy]$");
        var porterStemmer = function porterStemmer2(w) {
          var stem, suffix2, firstch, re, re2, re3, re4;
          if (w.length < 3) {
            return w;
          }
          firstch = w.substr(0, 1);
          if (firstch == "y") {
            w = firstch.toUpperCase() + w.substr(1);
          }
          re = re_1a;
          re2 = re2_1a;
          if (re.test(w)) {
            w = w.replace(re, "$1$2");
          } else if (re2.test(w)) {
            w = w.replace(re2, "$1$2");
          }
          re = re_1b;
          re2 = re2_1b;
          if (re.test(w)) {
            var fp = re.exec(w);
            re = re_mgr0;
            if (re.test(fp[1])) {
              re = re_1b_2;
              w = w.replace(re, "");
            }
          } else if (re2.test(w)) {
            var fp = re2.exec(w);
            stem = fp[1];
            re2 = re_s_v;
            if (re2.test(stem)) {
              w = stem;
              re2 = re2_1b_2;
              re3 = re3_1b_2;
              re4 = re4_1b_2;
              if (re2.test(w)) {
                w = w + "e";
              } else if (re3.test(w)) {
                re = re_1b_2;
                w = w.replace(re, "");
              } else if (re4.test(w)) {
                w = w + "e";
              }
            }
          }
          re = re_1c;
          if (re.test(w)) {
            var fp = re.exec(w);
            stem = fp[1];
            w = stem + "i";
          }
          re = re_2;
          if (re.test(w)) {
            var fp = re.exec(w);
            stem = fp[1];
            suffix2 = fp[2];
            re = re_mgr0;
            if (re.test(stem)) {
              w = stem + step2list[suffix2];
            }
          }
          re = re_3;
          if (re.test(w)) {
            var fp = re.exec(w);
            stem = fp[1];
            suffix2 = fp[2];
            re = re_mgr0;
            if (re.test(stem)) {
              w = stem + step3list[suffix2];
            }
          }
          re = re_4;
          re2 = re2_4;
          if (re.test(w)) {
            var fp = re.exec(w);
            stem = fp[1];
            re = re_mgr1;
            if (re.test(stem)) {
              w = stem;
            }
          } else if (re2.test(w)) {
            var fp = re2.exec(w);
            stem = fp[1] + fp[2];
            re2 = re_mgr1;
            if (re2.test(stem)) {
              w = stem;
            }
          }
          re = re_5;
          if (re.test(w)) {
            var fp = re.exec(w);
            stem = fp[1];
            re = re_mgr1;
            re2 = re_meq1;
            re3 = re3_5;
            if (re.test(stem) || re2.test(stem) && !re3.test(stem)) {
              w = stem;
            }
          }
          re = re_5_1;
          re2 = re_mgr1;
          if (re.test(w) && re2.test(w)) {
            re = re_1b_2;
            w = w.replace(re, "");
          }
          if (firstch == "y") {
            w = firstch.toLowerCase() + w.substr(1);
          }
          return w;
        };
        return function(token) {
          return token.update(porterStemmer);
        };
      }();
      lunr2.Pipeline.registerFunction(lunr2.stemmer, "stemmer");
      lunr2.generateStopWordFilter = function(stopWords) {
        var words = stopWords.reduce(function(memo, stopWord) {
          memo[stopWord] = stopWord;
          return memo;
        }, {});
        return function(token) {
          if (token && words[token.toString()] !== token.toString()) return token;
        };
      };
      lunr2.stopWordFilter = lunr2.generateStopWordFilter([
        "a",
        "able",
        "about",
        "across",
        "after",
        "all",
        "almost",
        "also",
        "am",
        "among",
        "an",
        "and",
        "any",
        "are",
        "as",
        "at",
        "be",
        "because",
        "been",
        "but",
        "by",
        "can",
        "cannot",
        "could",
        "dear",
        "did",
        "do",
        "does",
        "either",
        "else",
        "ever",
        "every",
        "for",
        "from",
        "get",
        "got",
        "had",
        "has",
        "have",
        "he",
        "her",
        "hers",
        "him",
        "his",
        "how",
        "however",
        "i",
        "if",
        "in",
        "into",
        "is",
        "it",
        "its",
        "just",
        "least",
        "let",
        "like",
        "likely",
        "may",
        "me",
        "might",
        "most",
        "must",
        "my",
        "neither",
        "no",
        "nor",
        "not",
        "of",
        "off",
        "often",
        "on",
        "only",
        "or",
        "other",
        "our",
        "own",
        "rather",
        "said",
        "say",
        "says",
        "she",
        "should",
        "since",
        "so",
        "some",
        "than",
        "that",
        "the",
        "their",
        "them",
        "then",
        "there",
        "these",
        "they",
        "this",
        "tis",
        "to",
        "too",
        "twas",
        "us",
        "wants",
        "was",
        "we",
        "were",
        "what",
        "when",
        "where",
        "which",
        "while",
        "who",
        "whom",
        "why",
        "will",
        "with",
        "would",
        "yet",
        "you",
        "your"
      ]);
      lunr2.Pipeline.registerFunction(lunr2.stopWordFilter, "stopWordFilter");
      lunr2.trimmer = function(token) {
        return token.update(function(s) {
          return s.replace(/^\W+/, "").replace(/\W+$/, "");
        });
      };
      lunr2.Pipeline.registerFunction(lunr2.trimmer, "trimmer");
      lunr2.TokenSet = function() {
        this.final = false;
        this.edges = {};
        this.id = lunr2.TokenSet._nextId;
        lunr2.TokenSet._nextId += 1;
      };
      lunr2.TokenSet._nextId = 1;
      lunr2.TokenSet.fromArray = function(arr) {
        var builder = new lunr2.TokenSet.Builder();
        for (var i = 0, len = arr.length; i < len; i++) {
          builder.insert(arr[i]);
        }
        builder.finish();
        return builder.root;
      };
      lunr2.TokenSet.fromClause = function(clause) {
        if ("editDistance" in clause) {
          return lunr2.TokenSet.fromFuzzyString(clause.term, clause.editDistance);
        } else {
          return lunr2.TokenSet.fromString(clause.term);
        }
      };
      lunr2.TokenSet.fromFuzzyString = function(str, editDistance) {
        var root = new lunr2.TokenSet();
        var stack = [{
          node: root,
          editsRemaining: editDistance,
          str
        }];
        while (stack.length) {
          var frame = stack.pop();
          if (frame.str.length > 0) {
            var char = frame.str.charAt(0), noEditNode;
            if (char in frame.node.edges) {
              noEditNode = frame.node.edges[char];
            } else {
              noEditNode = new lunr2.TokenSet();
              frame.node.edges[char] = noEditNode;
            }
            if (frame.str.length == 1) {
              noEditNode.final = true;
            }
            stack.push({
              node: noEditNode,
              editsRemaining: frame.editsRemaining,
              str: frame.str.slice(1)
            });
          }
          if (frame.editsRemaining == 0) {
            continue;
          }
          if ("*" in frame.node.edges) {
            var insertionNode = frame.node.edges["*"];
          } else {
            var insertionNode = new lunr2.TokenSet();
            frame.node.edges["*"] = insertionNode;
          }
          if (frame.str.length == 0) {
            insertionNode.final = true;
          }
          stack.push({
            node: insertionNode,
            editsRemaining: frame.editsRemaining - 1,
            str: frame.str
          });
          if (frame.str.length > 1) {
            stack.push({
              node: frame.node,
              editsRemaining: frame.editsRemaining - 1,
              str: frame.str.slice(1)
            });
          }
          if (frame.str.length == 1) {
            frame.node.final = true;
          }
          if (frame.str.length >= 1) {
            if ("*" in frame.node.edges) {
              var substitutionNode = frame.node.edges["*"];
            } else {
              var substitutionNode = new lunr2.TokenSet();
              frame.node.edges["*"] = substitutionNode;
            }
            if (frame.str.length == 1) {
              substitutionNode.final = true;
            }
            stack.push({
              node: substitutionNode,
              editsRemaining: frame.editsRemaining - 1,
              str: frame.str.slice(1)
            });
          }
          if (frame.str.length > 1) {
            var charA = frame.str.charAt(0), charB = frame.str.charAt(1), transposeNode;
            if (charB in frame.node.edges) {
              transposeNode = frame.node.edges[charB];
            } else {
              transposeNode = new lunr2.TokenSet();
              frame.node.edges[charB] = transposeNode;
            }
            if (frame.str.length == 1) {
              transposeNode.final = true;
            }
            stack.push({
              node: transposeNode,
              editsRemaining: frame.editsRemaining - 1,
              str: charA + frame.str.slice(2)
            });
          }
        }
        return root;
      };
      lunr2.TokenSet.fromString = function(str) {
        var node2 = new lunr2.TokenSet(), root = node2;
        for (var i = 0, len = str.length; i < len; i++) {
          var char = str[i], final2 = i == len - 1;
          if (char == "*") {
            node2.edges[char] = node2;
            node2.final = final2;
          } else {
            var next3 = new lunr2.TokenSet();
            next3.final = final2;
            node2.edges[char] = next3;
            node2 = next3;
          }
        }
        return root;
      };
      lunr2.TokenSet.prototype.toArray = function() {
        var words = [];
        var stack = [{
          prefix: "",
          node: this
        }];
        while (stack.length) {
          var frame = stack.pop(), edges = Object.keys(frame.node.edges), len = edges.length;
          if (frame.node.final) {
            frame.prefix.charAt(0);
            words.push(frame.prefix);
          }
          for (var i = 0; i < len; i++) {
            var edge = edges[i];
            stack.push({
              prefix: frame.prefix.concat(edge),
              node: frame.node.edges[edge]
            });
          }
        }
        return words;
      };
      lunr2.TokenSet.prototype.toString = function() {
        if (this._str) {
          return this._str;
        }
        var str = this.final ? "1" : "0", labels = Object.keys(this.edges).sort(), len = labels.length;
        for (var i = 0; i < len; i++) {
          var label4 = labels[i], node2 = this.edges[label4];
          str = str + label4 + node2.id;
        }
        return str;
      };
      lunr2.TokenSet.prototype.intersect = function(b) {
        var output2 = new lunr2.TokenSet(), frame = void 0;
        var stack = [{
          qNode: b,
          output: output2,
          node: this
        }];
        while (stack.length) {
          frame = stack.pop();
          var qEdges = Object.keys(frame.qNode.edges), qLen = qEdges.length, nEdges = Object.keys(frame.node.edges), nLen = nEdges.length;
          for (var q = 0; q < qLen; q++) {
            var qEdge = qEdges[q];
            for (var n2 = 0; n2 < nLen; n2++) {
              var nEdge = nEdges[n2];
              if (nEdge == qEdge || qEdge == "*") {
                var node2 = frame.node.edges[nEdge], qNode = frame.qNode.edges[qEdge], final2 = node2.final && qNode.final, next3 = void 0;
                if (nEdge in frame.output.edges) {
                  next3 = frame.output.edges[nEdge];
                  next3.final = next3.final || final2;
                } else {
                  next3 = new lunr2.TokenSet();
                  next3.final = final2;
                  frame.output.edges[nEdge] = next3;
                }
                stack.push({
                  qNode,
                  output: next3,
                  node: node2
                });
              }
            }
          }
        }
        return output2;
      };
      lunr2.TokenSet.Builder = function() {
        this.previousWord = "";
        this.root = new lunr2.TokenSet();
        this.uncheckedNodes = [];
        this.minimizedNodes = {};
      };
      lunr2.TokenSet.Builder.prototype.insert = function(word) {
        var node2, commonPrefix = 0;
        if (word < this.previousWord) {
          throw new Error("Out of order word insertion");
        }
        for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
          if (word[i] != this.previousWord[i]) break;
          commonPrefix++;
        }
        this.minimize(commonPrefix);
        if (this.uncheckedNodes.length == 0) {
          node2 = this.root;
        } else {
          node2 = this.uncheckedNodes[this.uncheckedNodes.length - 1].child;
        }
        for (var i = commonPrefix; i < word.length; i++) {
          var nextNode = new lunr2.TokenSet(), char = word[i];
          node2.edges[char] = nextNode;
          this.uncheckedNodes.push({
            parent: node2,
            char,
            child: nextNode
          });
          node2 = nextNode;
        }
        node2.final = true;
        this.previousWord = word;
      };
      lunr2.TokenSet.Builder.prototype.finish = function() {
        this.minimize(0);
      };
      lunr2.TokenSet.Builder.prototype.minimize = function(downTo) {
        for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
          var node2 = this.uncheckedNodes[i], childKey = node2.child.toString();
          if (childKey in this.minimizedNodes) {
            node2.parent.edges[node2.char] = this.minimizedNodes[childKey];
          } else {
            node2.child._str = childKey;
            this.minimizedNodes[childKey] = node2.child;
          }
          this.uncheckedNodes.pop();
        }
      };
      lunr2.Index = function(attrs) {
        this.invertedIndex = attrs.invertedIndex;
        this.fieldVectors = attrs.fieldVectors;
        this.tokenSet = attrs.tokenSet;
        this.fields = attrs.fields;
        this.pipeline = attrs.pipeline;
      };
      lunr2.Index.prototype.search = function(queryString) {
        return this.query(function(query4) {
          var parser = new lunr2.QueryParser(queryString, query4);
          parser.parse();
        });
      };
      lunr2.Index.prototype.query = function(fn2) {
        var query4 = new lunr2.Query(this.fields), matchingFields = /* @__PURE__ */ Object.create(null), queryVectors = /* @__PURE__ */ Object.create(null), termFieldCache = /* @__PURE__ */ Object.create(null), requiredMatches = /* @__PURE__ */ Object.create(null), prohibitedMatches = /* @__PURE__ */ Object.create(null);
        for (var i = 0; i < this.fields.length; i++) {
          queryVectors[this.fields[i]] = new lunr2.Vector();
        }
        fn2.call(query4, query4);
        for (var i = 0; i < query4.clauses.length; i++) {
          var clause = query4.clauses[i], terms = null, clauseMatches = lunr2.Set.empty;
          if (clause.usePipeline) {
            terms = this.pipeline.runString(clause.term, {
              fields: clause.fields
            });
          } else {
            terms = [clause.term];
          }
          for (var m = 0; m < terms.length; m++) {
            var term2 = terms[m];
            clause.term = term2;
            var termTokenSet = lunr2.TokenSet.fromClause(clause), expandedTerms = this.tokenSet.intersect(termTokenSet).toArray();
            if (expandedTerms.length === 0 && clause.presence === lunr2.Query.presence.REQUIRED) {
              for (var k = 0; k < clause.fields.length; k++) {
                var field2 = clause.fields[k];
                requiredMatches[field2] = lunr2.Set.empty;
              }
              break;
            }
            for (var j = 0; j < expandedTerms.length; j++) {
              var expandedTerm = expandedTerms[j], posting = this.invertedIndex[expandedTerm], termIndex = posting._index;
              for (var k = 0; k < clause.fields.length; k++) {
                var field2 = clause.fields[k], fieldPosting = posting[field2], matchingDocumentRefs = Object.keys(fieldPosting), termField = expandedTerm + "/" + field2, matchingDocumentsSet = new lunr2.Set(matchingDocumentRefs);
                if (clause.presence == lunr2.Query.presence.REQUIRED) {
                  clauseMatches = clauseMatches.union(matchingDocumentsSet);
                  if (requiredMatches[field2] === void 0) {
                    requiredMatches[field2] = lunr2.Set.complete;
                  }
                }
                if (clause.presence == lunr2.Query.presence.PROHIBITED) {
                  if (prohibitedMatches[field2] === void 0) {
                    prohibitedMatches[field2] = lunr2.Set.empty;
                  }
                  prohibitedMatches[field2] = prohibitedMatches[field2].union(matchingDocumentsSet);
                  continue;
                }
                queryVectors[field2].upsert(termIndex, clause.boost, function(a, b) {
                  return a + b;
                });
                if (termFieldCache[termField]) {
                  continue;
                }
                for (var l = 0; l < matchingDocumentRefs.length; l++) {
                  var matchingDocumentRef = matchingDocumentRefs[l], matchingFieldRef = new lunr2.FieldRef(matchingDocumentRef, field2), metadata2 = fieldPosting[matchingDocumentRef], fieldMatch;
                  if ((fieldMatch = matchingFields[matchingFieldRef]) === void 0) {
                    matchingFields[matchingFieldRef] = new lunr2.MatchData(expandedTerm, field2, metadata2);
                  } else {
                    fieldMatch.add(expandedTerm, field2, metadata2);
                  }
                }
                termFieldCache[termField] = true;
              }
            }
          }
          if (clause.presence === lunr2.Query.presence.REQUIRED) {
            for (var k = 0; k < clause.fields.length; k++) {
              var field2 = clause.fields[k];
              requiredMatches[field2] = requiredMatches[field2].intersect(clauseMatches);
            }
          }
        }
        var allRequiredMatches = lunr2.Set.complete, allProhibitedMatches = lunr2.Set.empty;
        for (var i = 0; i < this.fields.length; i++) {
          var field2 = this.fields[i];
          if (requiredMatches[field2]) {
            allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field2]);
          }
          if (prohibitedMatches[field2]) {
            allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field2]);
          }
        }
        var matchingFieldRefs = Object.keys(matchingFields), results = [], matches = /* @__PURE__ */ Object.create(null);
        if (query4.isNegated()) {
          matchingFieldRefs = Object.keys(this.fieldVectors);
          for (var i = 0; i < matchingFieldRefs.length; i++) {
            var matchingFieldRef = matchingFieldRefs[i];
            var fieldRef = lunr2.FieldRef.fromString(matchingFieldRef);
            matchingFields[matchingFieldRef] = new lunr2.MatchData();
          }
        }
        for (var i = 0; i < matchingFieldRefs.length; i++) {
          var fieldRef = lunr2.FieldRef.fromString(matchingFieldRefs[i]), docRef = fieldRef.docRef;
          if (!allRequiredMatches.contains(docRef)) {
            continue;
          }
          if (allProhibitedMatches.contains(docRef)) {
            continue;
          }
          var fieldVector = this.fieldVectors[fieldRef], score2 = queryVectors[fieldRef.fieldName].similarity(fieldVector), docMatch;
          if ((docMatch = matches[docRef]) !== void 0) {
            docMatch.score += score2;
            docMatch.matchData.combine(matchingFields[fieldRef]);
          } else {
            var match = {
              ref: docRef,
              score: score2,
              matchData: matchingFields[fieldRef]
            };
            matches[docRef] = match;
            results.push(match);
          }
        }
        return results.sort(function(a, b) {
          return b.score - a.score;
        });
      };
      lunr2.Index.prototype.toJSON = function() {
        var invertedIndex = Object.keys(this.invertedIndex).sort().map(function(term2) {
          return [term2, this.invertedIndex[term2]];
        }, this);
        var fieldVectors = Object.keys(this.fieldVectors).map(function(ref) {
          return [ref, this.fieldVectors[ref].toJSON()];
        }, this);
        return {
          version: lunr2.version,
          fields: this.fields,
          fieldVectors,
          invertedIndex,
          pipeline: this.pipeline.toJSON()
        };
      };
      lunr2.Index.load = function(serializedIndex) {
        var attrs = {}, fieldVectors = {}, serializedVectors = serializedIndex.fieldVectors, invertedIndex = /* @__PURE__ */ Object.create(null), serializedInvertedIndex = serializedIndex.invertedIndex, tokenSetBuilder = new lunr2.TokenSet.Builder(), pipeline = lunr2.Pipeline.load(serializedIndex.pipeline);
        if (serializedIndex.version != lunr2.version) {
          lunr2.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr2.version + "' does not match serialized index '" + serializedIndex.version + "'");
        }
        for (var i = 0; i < serializedVectors.length; i++) {
          var tuple = serializedVectors[i], ref = tuple[0], elements = tuple[1];
          fieldVectors[ref] = new lunr2.Vector(elements);
        }
        for (var i = 0; i < serializedInvertedIndex.length; i++) {
          var tuple = serializedInvertedIndex[i], term2 = tuple[0], posting = tuple[1];
          tokenSetBuilder.insert(term2);
          invertedIndex[term2] = posting;
        }
        tokenSetBuilder.finish();
        attrs.fields = serializedIndex.fields;
        attrs.fieldVectors = fieldVectors;
        attrs.invertedIndex = invertedIndex;
        attrs.tokenSet = tokenSetBuilder.root;
        attrs.pipeline = pipeline;
        return new lunr2.Index(attrs);
      };
      lunr2.Builder = function() {
        this._ref = "id";
        this._fields = /* @__PURE__ */ Object.create(null);
        this._documents = /* @__PURE__ */ Object.create(null);
        this.invertedIndex = /* @__PURE__ */ Object.create(null);
        this.fieldTermFrequencies = {};
        this.fieldLengths = {};
        this.tokenizer = lunr2.tokenizer;
        this.pipeline = new lunr2.Pipeline();
        this.searchPipeline = new lunr2.Pipeline();
        this.documentCount = 0;
        this._b = 0.75;
        this._k1 = 1.2;
        this.termIndex = 0;
        this.metadataWhitelist = [];
      };
      lunr2.Builder.prototype.ref = function(ref) {
        this._ref = ref;
      };
      lunr2.Builder.prototype.field = function(fieldName, attributes) {
        if (/\//.test(fieldName)) {
          throw new RangeError("Field '" + fieldName + "' contains illegal character '/'");
        }
        this._fields[fieldName] = attributes || {};
      };
      lunr2.Builder.prototype.b = function(number2) {
        if (number2 < 0) {
          this._b = 0;
        } else if (number2 > 1) {
          this._b = 1;
        } else {
          this._b = number2;
        }
      };
      lunr2.Builder.prototype.k1 = function(number2) {
        this._k1 = number2;
      };
      lunr2.Builder.prototype.add = function(doc, attributes) {
        var docRef = doc[this._ref], fields = Object.keys(this._fields);
        this._documents[docRef] = attributes || {};
        this.documentCount += 1;
        for (var i = 0; i < fields.length; i++) {
          var fieldName = fields[i], extractor = this._fields[fieldName].extractor, field2 = extractor ? extractor(doc) : doc[fieldName], tokens = this.tokenizer(field2, {
            fields: [fieldName]
          }), terms = this.pipeline.run(tokens), fieldRef = new lunr2.FieldRef(docRef, fieldName), fieldTerms = /* @__PURE__ */ Object.create(null);
          this.fieldTermFrequencies[fieldRef] = fieldTerms;
          this.fieldLengths[fieldRef] = 0;
          this.fieldLengths[fieldRef] += terms.length;
          for (var j = 0; j < terms.length; j++) {
            var term2 = terms[j];
            if (fieldTerms[term2] == void 0) {
              fieldTerms[term2] = 0;
            }
            fieldTerms[term2] += 1;
            if (this.invertedIndex[term2] == void 0) {
              var posting = /* @__PURE__ */ Object.create(null);
              posting["_index"] = this.termIndex;
              this.termIndex += 1;
              for (var k = 0; k < fields.length; k++) {
                posting[fields[k]] = /* @__PURE__ */ Object.create(null);
              }
              this.invertedIndex[term2] = posting;
            }
            if (this.invertedIndex[term2][fieldName][docRef] == void 0) {
              this.invertedIndex[term2][fieldName][docRef] = /* @__PURE__ */ Object.create(null);
            }
            for (var l = 0; l < this.metadataWhitelist.length; l++) {
              var metadataKey = this.metadataWhitelist[l], metadata2 = term2.metadata[metadataKey];
              if (this.invertedIndex[term2][fieldName][docRef][metadataKey] == void 0) {
                this.invertedIndex[term2][fieldName][docRef][metadataKey] = [];
              }
              this.invertedIndex[term2][fieldName][docRef][metadataKey].push(metadata2);
            }
          }
        }
      };
      lunr2.Builder.prototype.calculateAverageFieldLengths = function() {
        var fieldRefs = Object.keys(this.fieldLengths), numberOfFields = fieldRefs.length, accumulator = {}, documentsWithField = {};
        for (var i = 0; i < numberOfFields; i++) {
          var fieldRef = lunr2.FieldRef.fromString(fieldRefs[i]), field2 = fieldRef.fieldName;
          documentsWithField[field2] || (documentsWithField[field2] = 0);
          documentsWithField[field2] += 1;
          accumulator[field2] || (accumulator[field2] = 0);
          accumulator[field2] += this.fieldLengths[fieldRef];
        }
        var fields = Object.keys(this._fields);
        for (var i = 0; i < fields.length; i++) {
          var fieldName = fields[i];
          accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName];
        }
        this.averageFieldLength = accumulator;
      };
      lunr2.Builder.prototype.createFieldVectors = function() {
        var fieldVectors = {}, fieldRefs = Object.keys(this.fieldTermFrequencies), fieldRefsLength = fieldRefs.length, termIdfCache = /* @__PURE__ */ Object.create(null);
        for (var i = 0; i < fieldRefsLength; i++) {
          var fieldRef = lunr2.FieldRef.fromString(fieldRefs[i]), fieldName = fieldRef.fieldName, fieldLength = this.fieldLengths[fieldRef], fieldVector = new lunr2.Vector(), termFrequencies = this.fieldTermFrequencies[fieldRef], terms = Object.keys(termFrequencies), termsLength = terms.length;
          var fieldBoost = this._fields[fieldName].boost || 1, docBoost = this._documents[fieldRef.docRef].boost || 1;
          for (var j = 0; j < termsLength; j++) {
            var term2 = terms[j], tf = termFrequencies[term2], termIndex = this.invertedIndex[term2]._index, idf, score2, scoreWithPrecision;
            if (termIdfCache[term2] === void 0) {
              idf = lunr2.idf(this.invertedIndex[term2], this.documentCount);
              termIdfCache[term2] = idf;
            } else {
              idf = termIdfCache[term2];
            }
            score2 = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf);
            score2 *= fieldBoost;
            score2 *= docBoost;
            scoreWithPrecision = Math.round(score2 * 1e3) / 1e3;
            fieldVector.insert(termIndex, scoreWithPrecision);
          }
          fieldVectors[fieldRef] = fieldVector;
        }
        this.fieldVectors = fieldVectors;
      };
      lunr2.Builder.prototype.createTokenSet = function() {
        this.tokenSet = lunr2.TokenSet.fromArray(
          Object.keys(this.invertedIndex).sort()
        );
      };
      lunr2.Builder.prototype.build = function() {
        this.calculateAverageFieldLengths();
        this.createFieldVectors();
        this.createTokenSet();
        return new lunr2.Index({
          invertedIndex: this.invertedIndex,
          fieldVectors: this.fieldVectors,
          tokenSet: this.tokenSet,
          fields: Object.keys(this._fields),
          pipeline: this.searchPipeline
        });
      };
      lunr2.Builder.prototype.use = function(fn2) {
        var args = Array.prototype.slice.call(arguments, 1);
        args.unshift(this);
        fn2.apply(this, args);
      };
      lunr2.MatchData = function(term2, field2, metadata2) {
        var clonedMetadata = /* @__PURE__ */ Object.create(null), metadataKeys = Object.keys(metadata2 || {});
        for (var i = 0; i < metadataKeys.length; i++) {
          var key3 = metadataKeys[i];
          clonedMetadata[key3] = metadata2[key3].slice();
        }
        this.metadata = /* @__PURE__ */ Object.create(null);
        if (term2 !== void 0) {
          this.metadata[term2] = /* @__PURE__ */ Object.create(null);
          this.metadata[term2][field2] = clonedMetadata;
        }
      };
      lunr2.MatchData.prototype.combine = function(otherMatchData) {
        var terms = Object.keys(otherMatchData.metadata);
        for (var i = 0; i < terms.length; i++) {
          var term2 = terms[i], fields = Object.keys(otherMatchData.metadata[term2]);
          if (this.metadata[term2] == void 0) {
            this.metadata[term2] = /* @__PURE__ */ Object.create(null);
          }
          for (var j = 0; j < fields.length; j++) {
            var field2 = fields[j], keys = Object.keys(otherMatchData.metadata[term2][field2]);
            if (this.metadata[term2][field2] == void 0) {
              this.metadata[term2][field2] = /* @__PURE__ */ Object.create(null);
            }
            for (var k = 0; k < keys.length; k++) {
              var key3 = keys[k];
              if (this.metadata[term2][field2][key3] == void 0) {
                this.metadata[term2][field2][key3] = otherMatchData.metadata[term2][field2][key3];
              } else {
                this.metadata[term2][field2][key3] = this.metadata[term2][field2][key3].concat(otherMatchData.metadata[term2][field2][key3]);
              }
            }
          }
        }
      };
      lunr2.MatchData.prototype.add = function(term2, field2, metadata2) {
        if (!(term2 in this.metadata)) {
          this.metadata[term2] = /* @__PURE__ */ Object.create(null);
          this.metadata[term2][field2] = metadata2;
          return;
        }
        if (!(field2 in this.metadata[term2])) {
          this.metadata[term2][field2] = metadata2;
          return;
        }
        var metadataKeys = Object.keys(metadata2);
        for (var i = 0; i < metadataKeys.length; i++) {
          var key3 = metadataKeys[i];
          if (key3 in this.metadata[term2][field2]) {
            this.metadata[term2][field2][key3] = this.metadata[term2][field2][key3].concat(metadata2[key3]);
          } else {
            this.metadata[term2][field2][key3] = metadata2[key3];
          }
        }
      };
      lunr2.Query = function(allFields) {
        this.clauses = [];
        this.allFields = allFields;
      };
      lunr2.Query.wildcard = new String("*");
      lunr2.Query.wildcard.NONE = 0;
      lunr2.Query.wildcard.LEADING = 1;
      lunr2.Query.wildcard.TRAILING = 2;
      lunr2.Query.presence = {
        /**
         * Term's presence in a document is optional, this is the default value.
         */
        OPTIONAL: 1,
        /**
         * Term's presence in a document is required, documents that do not contain
         * this term will not be returned.
         */
        REQUIRED: 2,
        /**
         * Term's presence in a document is prohibited, documents that do contain
         * this term will not be returned.
         */
        PROHIBITED: 3
      };
      lunr2.Query.prototype.clause = function(clause) {
        if (!("fields" in clause)) {
          clause.fields = this.allFields;
        }
        if (!("boost" in clause)) {
          clause.boost = 1;
        }
        if (!("usePipeline" in clause)) {
          clause.usePipeline = true;
        }
        if (!("wildcard" in clause)) {
          clause.wildcard = lunr2.Query.wildcard.NONE;
        }
        if (clause.wildcard & lunr2.Query.wildcard.LEADING && clause.term.charAt(0) != lunr2.Query.wildcard) {
          clause.term = "*" + clause.term;
        }
        if (clause.wildcard & lunr2.Query.wildcard.TRAILING && clause.term.slice(-1) != lunr2.Query.wildcard) {
          clause.term = "" + clause.term + "*";
        }
        if (!("presence" in clause)) {
          clause.presence = lunr2.Query.presence.OPTIONAL;
        }
        this.clauses.push(clause);
        return this;
      };
      lunr2.Query.prototype.isNegated = function() {
        for (var i = 0; i < this.clauses.length; i++) {
          if (this.clauses[i].presence != lunr2.Query.presence.PROHIBITED) {
            return false;
          }
        }
        return true;
      };
      lunr2.Query.prototype.term = function(term2, options) {
        if (Array.isArray(term2)) {
          term2.forEach(function(t) {
            this.term(t, lunr2.utils.clone(options));
          }, this);
          return this;
        }
        var clause = options || {};
        clause.term = term2.toString();
        this.clause(clause);
        return this;
      };
      lunr2.QueryParseError = function(message4, start2, end2) {
        this.name = "QueryParseError";
        this.message = message4;
        this.start = start2;
        this.end = end2;
      };
      lunr2.QueryParseError.prototype = new Error();
      lunr2.QueryLexer = function(str) {
        this.lexemes = [];
        this.str = str;
        this.length = str.length;
        this.pos = 0;
        this.start = 0;
        this.escapeCharPositions = [];
      };
      lunr2.QueryLexer.prototype.run = function() {
        var state2 = lunr2.QueryLexer.lexText;
        while (state2) {
          state2 = state2(this);
        }
      };
      lunr2.QueryLexer.prototype.sliceString = function() {
        var subSlices = [], sliceStart = this.start, sliceEnd = this.pos;
        for (var i = 0; i < this.escapeCharPositions.length; i++) {
          sliceEnd = this.escapeCharPositions[i];
          subSlices.push(this.str.slice(sliceStart, sliceEnd));
          sliceStart = sliceEnd + 1;
        }
        subSlices.push(this.str.slice(sliceStart, this.pos));
        this.escapeCharPositions.length = 0;
        return subSlices.join("");
      };
      lunr2.QueryLexer.prototype.emit = function(type5) {
        this.lexemes.push({
          type: type5,
          str: this.sliceString(),
          start: this.start,
          end: this.pos
        });
        this.start = this.pos;
      };
      lunr2.QueryLexer.prototype.escapeCharacter = function() {
        this.escapeCharPositions.push(this.pos - 1);
        this.pos += 1;
      };
      lunr2.QueryLexer.prototype.next = function() {
        if (this.pos >= this.length) {
          return lunr2.QueryLexer.EOS;
        }
        var char = this.str.charAt(this.pos);
        this.pos += 1;
        return char;
      };
      lunr2.QueryLexer.prototype.width = function() {
        return this.pos - this.start;
      };
      lunr2.QueryLexer.prototype.ignore = function() {
        if (this.start == this.pos) {
          this.pos += 1;
        }
        this.start = this.pos;
      };
      lunr2.QueryLexer.prototype.backup = function() {
        this.pos -= 1;
      };
      lunr2.QueryLexer.prototype.acceptDigitRun = function() {
        var char, charCode;
        do {
          char = this.next();
          charCode = char.charCodeAt(0);
        } while (charCode > 47 && charCode < 58);
        if (char != lunr2.QueryLexer.EOS) {
          this.backup();
        }
      };
      lunr2.QueryLexer.prototype.more = function() {
        return this.pos < this.length;
      };
      lunr2.QueryLexer.EOS = "EOS";
      lunr2.QueryLexer.FIELD = "FIELD";
      lunr2.QueryLexer.TERM = "TERM";
      lunr2.QueryLexer.EDIT_DISTANCE = "EDIT_DISTANCE";
      lunr2.QueryLexer.BOOST = "BOOST";
      lunr2.QueryLexer.PRESENCE = "PRESENCE";
      lunr2.QueryLexer.lexField = function(lexer) {
        lexer.backup();
        lexer.emit(lunr2.QueryLexer.FIELD);
        lexer.ignore();
        return lunr2.QueryLexer.lexText;
      };
      lunr2.QueryLexer.lexTerm = function(lexer) {
        if (lexer.width() > 1) {
          lexer.backup();
          lexer.emit(lunr2.QueryLexer.TERM);
        }
        lexer.ignore();
        if (lexer.more()) {
          return lunr2.QueryLexer.lexText;
        }
      };
      lunr2.QueryLexer.lexEditDistance = function(lexer) {
        lexer.ignore();
        lexer.acceptDigitRun();
        lexer.emit(lunr2.QueryLexer.EDIT_DISTANCE);
        return lunr2.QueryLexer.lexText;
      };
      lunr2.QueryLexer.lexBoost = function(lexer) {
        lexer.ignore();
        lexer.acceptDigitRun();
        lexer.emit(lunr2.QueryLexer.BOOST);
        return lunr2.QueryLexer.lexText;
      };
      lunr2.QueryLexer.lexEOS = function(lexer) {
        if (lexer.width() > 0) {
          lexer.emit(lunr2.QueryLexer.TERM);
        }
      };
      lunr2.QueryLexer.termSeparator = lunr2.tokenizer.separator;
      lunr2.QueryLexer.lexText = function(lexer) {
        while (true) {
          var char = lexer.next();
          if (char == lunr2.QueryLexer.EOS) {
            return lunr2.QueryLexer.lexEOS;
          }
          if (char.charCodeAt(0) == 92) {
            lexer.escapeCharacter();
            continue;
          }
          if (char == ":") {
            return lunr2.QueryLexer.lexField;
          }
          if (char == "~") {
            lexer.backup();
            if (lexer.width() > 0) {
              lexer.emit(lunr2.QueryLexer.TERM);
            }
            return lunr2.QueryLexer.lexEditDistance;
          }
          if (char == "^") {
            lexer.backup();
            if (lexer.width() > 0) {
              lexer.emit(lunr2.QueryLexer.TERM);
            }
            return lunr2.QueryLexer.lexBoost;
          }
          if (char == "+" && lexer.width() === 1) {
            lexer.emit(lunr2.QueryLexer.PRESENCE);
            return lunr2.QueryLexer.lexText;
          }
          if (char == "-" && lexer.width() === 1) {
            lexer.emit(lunr2.QueryLexer.PRESENCE);
            return lunr2.QueryLexer.lexText;
          }
          if (char.match(lunr2.QueryLexer.termSeparator)) {
            return lunr2.QueryLexer.lexTerm;
          }
        }
      };
      lunr2.QueryParser = function(str, query4) {
        this.lexer = new lunr2.QueryLexer(str);
        this.query = query4;
        this.currentClause = {};
        this.lexemeIdx = 0;
      };
      lunr2.QueryParser.prototype.parse = function() {
        this.lexer.run();
        this.lexemes = this.lexer.lexemes;
        var state2 = lunr2.QueryParser.parseClause;
        while (state2) {
          state2 = state2(this);
        }
        return this.query;
      };
      lunr2.QueryParser.prototype.peekLexeme = function() {
        return this.lexemes[this.lexemeIdx];
      };
      lunr2.QueryParser.prototype.consumeLexeme = function() {
        var lexeme = this.peekLexeme();
        this.lexemeIdx += 1;
        return lexeme;
      };
      lunr2.QueryParser.prototype.nextClause = function() {
        var completedClause = this.currentClause;
        this.query.clause(completedClause);
        this.currentClause = {};
      };
      lunr2.QueryParser.parseClause = function(parser) {
        var lexeme = parser.peekLexeme();
        if (lexeme == void 0) {
          return;
        }
        switch (lexeme.type) {
          case lunr2.QueryLexer.PRESENCE:
            return lunr2.QueryParser.parsePresence;
          case lunr2.QueryLexer.FIELD:
            return lunr2.QueryParser.parseField;
          case lunr2.QueryLexer.TERM:
            return lunr2.QueryParser.parseTerm;
          default:
            var errorMessage = "expected either a field or a term, found " + lexeme.type;
            if (lexeme.str.length >= 1) {
              errorMessage += " with value '" + lexeme.str + "'";
            }
            throw new lunr2.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
      };
      lunr2.QueryParser.parsePresence = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == void 0) {
          return;
        }
        switch (lexeme.str) {
          case "-":
            parser.currentClause.presence = lunr2.Query.presence.PROHIBITED;
            break;
          case "+":
            parser.currentClause.presence = lunr2.Query.presence.REQUIRED;
            break;
          default:
            var errorMessage = "unrecognised presence operator'" + lexeme.str + "'";
            throw new lunr2.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == void 0) {
          var errorMessage = "expecting term or field, found nothing";
          throw new lunr2.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        switch (nextLexeme.type) {
          case lunr2.QueryLexer.FIELD:
            return lunr2.QueryParser.parseField;
          case lunr2.QueryLexer.TERM:
            return lunr2.QueryParser.parseTerm;
          default:
            var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'";
            throw new lunr2.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
      };
      lunr2.QueryParser.parseField = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == void 0) {
          return;
        }
        if (parser.query.allFields.indexOf(lexeme.str) == -1) {
          var possibleFields = parser.query.allFields.map(function(f) {
            return "'" + f + "'";
          }).join(", "), errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields;
          throw new lunr2.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        parser.currentClause.fields = [lexeme.str];
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == void 0) {
          var errorMessage = "expecting term, found nothing";
          throw new lunr2.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        switch (nextLexeme.type) {
          case lunr2.QueryLexer.TERM:
            return lunr2.QueryParser.parseTerm;
          default:
            var errorMessage = "expecting term, found '" + nextLexeme.type + "'";
            throw new lunr2.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
      };
      lunr2.QueryParser.parseTerm = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == void 0) {
          return;
        }
        parser.currentClause.term = lexeme.str.toLowerCase();
        if (lexeme.str.indexOf("*") != -1) {
          parser.currentClause.usePipeline = false;
        }
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == void 0) {
          parser.nextClause();
          return;
        }
        switch (nextLexeme.type) {
          case lunr2.QueryLexer.TERM:
            parser.nextClause();
            return lunr2.QueryParser.parseTerm;
          case lunr2.QueryLexer.FIELD:
            parser.nextClause();
            return lunr2.QueryParser.parseField;
          case lunr2.QueryLexer.EDIT_DISTANCE:
            return lunr2.QueryParser.parseEditDistance;
          case lunr2.QueryLexer.BOOST:
            return lunr2.QueryParser.parseBoost;
          case lunr2.QueryLexer.PRESENCE:
            parser.nextClause();
            return lunr2.QueryParser.parsePresence;
          default:
            var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
            throw new lunr2.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
      };
      lunr2.QueryParser.parseEditDistance = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == void 0) {
          return;
        }
        var editDistance = parseInt(lexeme.str, 10);
        if (isNaN(editDistance)) {
          var errorMessage = "edit distance must be numeric";
          throw new lunr2.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        parser.currentClause.editDistance = editDistance;
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == void 0) {
          parser.nextClause();
          return;
        }
        switch (nextLexeme.type) {
          case lunr2.QueryLexer.TERM:
            parser.nextClause();
            return lunr2.QueryParser.parseTerm;
          case lunr2.QueryLexer.FIELD:
            parser.nextClause();
            return lunr2.QueryParser.parseField;
          case lunr2.QueryLexer.EDIT_DISTANCE:
            return lunr2.QueryParser.parseEditDistance;
          case lunr2.QueryLexer.BOOST:
            return lunr2.QueryParser.parseBoost;
          case lunr2.QueryLexer.PRESENCE:
            parser.nextClause();
            return lunr2.QueryParser.parsePresence;
          default:
            var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
            throw new lunr2.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
      };
      lunr2.QueryParser.parseBoost = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == void 0) {
          return;
        }
        var boost = parseInt(lexeme.str, 10);
        if (isNaN(boost)) {
          var errorMessage = "boost must be numeric";
          throw new lunr2.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        parser.currentClause.boost = boost;
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == void 0) {
          parser.nextClause();
          return;
        }
        switch (nextLexeme.type) {
          case lunr2.QueryLexer.TERM:
            parser.nextClause();
            return lunr2.QueryParser.parseTerm;
          case lunr2.QueryLexer.FIELD:
            parser.nextClause();
            return lunr2.QueryParser.parseField;
          case lunr2.QueryLexer.EDIT_DISTANCE:
            return lunr2.QueryParser.parseEditDistance;
          case lunr2.QueryLexer.BOOST:
            return lunr2.QueryParser.parseBoost;
          case lunr2.QueryLexer.PRESENCE:
            parser.nextClause();
            return lunr2.QueryParser.parsePresence;
          default:
            var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
            throw new lunr2.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
      };
      (function(root, factory) {
        if (typeof define === "function" && define.amd) {
          define(factory);
        } else if (typeof exports === "object") {
          module2.exports = factory();
        } else {
          root.lunr = factory();
        }
      })(this, function() {
        return lunr2;
      });
    })();
  }
});

// ../node_modules/slugify/slugify.js
var require_slugify = __commonJS({
  "../node_modules/slugify/slugify.js"(exports, module2) {
    (function(name7, root, factory) {
      if (typeof exports === "object") {
        module2.exports = factory();
        module2.exports["default"] = factory();
      } else if (typeof define === "function" && define.amd) {
        define(factory);
      } else {
        root[name7] = factory();
      }
    })("slugify", exports, function() {
      var charMap = JSON.parse(`{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","\xA2":"cent","\xA3":"pound","\xA4":"currency","\xA5":"yen","\xA9":"(c)","\xAA":"a","\xAE":"(r)","\xBA":"o","\xC0":"A","\xC1":"A","\xC2":"A","\xC3":"A","\xC4":"A","\xC5":"A","\xC6":"AE","\xC7":"C","\xC8":"E","\xC9":"E","\xCA":"E","\xCB":"E","\xCC":"I","\xCD":"I","\xCE":"I","\xCF":"I","\xD0":"D","\xD1":"N","\xD2":"O","\xD3":"O","\xD4":"O","\xD5":"O","\xD6":"O","\xD8":"O","\xD9":"U","\xDA":"U","\xDB":"U","\xDC":"U","\xDD":"Y","\xDE":"TH","\xDF":"ss","\xE0":"a","\xE1":"a","\xE2":"a","\xE3":"a","\xE4":"a","\xE5":"a","\xE6":"ae","\xE7":"c","\xE8":"e","\xE9":"e","\xEA":"e","\xEB":"e","\xEC":"i","\xED":"i","\xEE":"i","\xEF":"i","\xF0":"d","\xF1":"n","\xF2":"o","\xF3":"o","\xF4":"o","\xF5":"o","\xF6":"o","\xF8":"o","\xF9":"u","\xFA":"u","\xFB":"u","\xFC":"u","\xFD":"y","\xFE":"th","\xFF":"y","\u0100":"A","\u0101":"a","\u0102":"A","\u0103":"a","\u0104":"A","\u0105":"a","\u0106":"C","\u0107":"c","\u010C":"C","\u010D":"c","\u010E":"D","\u010F":"d","\u0110":"DJ","\u0111":"dj","\u0112":"E","\u0113":"e","\u0116":"E","\u0117":"e","\u0118":"e","\u0119":"e","\u011A":"E","\u011B":"e","\u011E":"G","\u011F":"g","\u0122":"G","\u0123":"g","\u0128":"I","\u0129":"i","\u012A":"i","\u012B":"i","\u012E":"I","\u012F":"i","\u0130":"I","\u0131":"i","\u0136":"k","\u0137":"k","\u013B":"L","\u013C":"l","\u013D":"L","\u013E":"l","\u0141":"L","\u0142":"l","\u0143":"N","\u0144":"n","\u0145":"N","\u0146":"n","\u0147":"N","\u0148":"n","\u014C":"O","\u014D":"o","\u0150":"O","\u0151":"o","\u0152":"OE","\u0153":"oe","\u0154":"R","\u0155":"r","\u0158":"R","\u0159":"r","\u015A":"S","\u015B":"s","\u015E":"S","\u015F":"s","\u0160":"S","\u0161":"s","\u0162":"T","\u0163":"t","\u0164":"T","\u0165":"t","\u0168":"U","\u0169":"u","\u016A":"u","\u016B":"u","\u016E":"U","\u016F":"u","\u0170":"U","\u0171":"u","\u0172":"U","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017A":"z","\u017B":"Z","\u017C":"z","\u017D":"Z","\u017E":"z","\u018F":"E","\u0192":"f","\u01A0":"O","\u01A1":"o","\u01AF":"U","\u01B0":"u","\u01C8":"LJ","\u01C9":"lj","\u01CB":"NJ","\u01CC":"nj","\u0218":"S","\u0219":"s","\u021A":"T","\u021B":"t","\u0259":"e","\u02DA":"o","\u0386":"A","\u0388":"E","\u0389":"H","\u038A":"I","\u038C":"O","\u038E":"Y","\u038F":"W","\u0390":"i","\u0391":"A","\u0392":"B","\u0393":"G","\u0394":"D","\u0395":"E","\u0396":"Z","\u0397":"H","\u0398":"8","\u0399":"I","\u039A":"K","\u039B":"L","\u039C":"M","\u039D":"N","\u039E":"3","\u039F":"O","\u03A0":"P","\u03A1":"R","\u03A3":"S","\u03A4":"T","\u03A5":"Y","\u03A6":"F","\u03A7":"X","\u03A8":"PS","\u03A9":"W","\u03AA":"I","\u03AB":"Y","\u03AC":"a","\u03AD":"e","\u03AE":"h","\u03AF":"i","\u03B0":"y","\u03B1":"a","\u03B2":"b","\u03B3":"g","\u03B4":"d","\u03B5":"e","\u03B6":"z","\u03B7":"h","\u03B8":"8","\u03B9":"i","\u03BA":"k","\u03BB":"l","\u03BC":"m","\u03BD":"n","\u03BE":"3","\u03BF":"o","\u03C0":"p","\u03C1":"r","\u03C2":"s","\u03C3":"s","\u03C4":"t","\u03C5":"y","\u03C6":"f","\u03C7":"x","\u03C8":"ps","\u03C9":"w","\u03CA":"i","\u03CB":"y","\u03CC":"o","\u03CD":"y","\u03CE":"w","\u0401":"Yo","\u0402":"DJ","\u0404":"Ye","\u0406":"I","\u0407":"Yi","\u0408":"J","\u0409":"LJ","\u040A":"NJ","\u040B":"C","\u040F":"DZ","\u0410":"A","\u0411":"B","\u0412":"V","\u0413":"G","\u0414":"D","\u0415":"E","\u0416":"Zh","\u0417":"Z","\u0418":"I","\u0419":"J","\u041A":"K","\u041B":"L","\u041C":"M","\u041D":"N","\u041E":"O","\u041F":"P","\u0420":"R","\u0421":"S","\u0422":"T","\u0423":"U","\u0424":"F","\u0425":"H","\u0426":"C","\u0427":"Ch","\u0428":"Sh","\u0429":"Sh","\u042A":"U","\u042B":"Y","\u042C":"","\u042D":"E","\u042E":"Yu","\u042F":"Ya","\u0430":"a","\u0431":"b","\u0432":"v","\u0433":"g","\u0434":"d","\u0435":"e","\u0436":"zh","\u0437":"z","\u0438":"i","\u0439":"j","\u043A":"k","\u043B":"l","\u043C":"m","\u043D":"n","\u043E":"o","\u043F":"p","\u0440":"r","\u0441":"s","\u0442":"t","\u0443":"u","\u0444":"f","\u0445":"h","\u0446":"c","\u0447":"ch","\u0448":"sh","\u0449":"sh","\u044A":"u","\u044B":"y","\u044C":"","\u044D":"e","\u044E":"yu","\u044F":"ya","\u0451":"yo","\u0452":"dj","\u0454":"ye","\u0456":"i","\u0457":"yi","\u0458":"j","\u0459":"lj","\u045A":"nj","\u045B":"c","\u045D":"u","\u045F":"dz","\u0490":"G","\u0491":"g","\u0492":"GH","\u0493":"gh","\u049A":"KH","\u049B":"kh","\u04A2":"NG","\u04A3":"ng","\u04AE":"UE","\u04AF":"ue","\u04B0":"U","\u04B1":"u","\u04BA":"H","\u04BB":"h","\u04D8":"AE","\u04D9":"ae","\u04E8":"OE","\u04E9":"oe","\u0531":"A","\u0532":"B","\u0533":"G","\u0534":"D","\u0535":"E","\u0536":"Z","\u0537":"E'","\u0538":"Y'","\u0539":"T'","\u053A":"JH","\u053B":"I","\u053C":"L","\u053D":"X","\u053E":"C'","\u053F":"K","\u0540":"H","\u0541":"D'","\u0542":"GH","\u0543":"TW","\u0544":"M","\u0545":"Y","\u0546":"N","\u0547":"SH","\u0549":"CH","\u054A":"P","\u054B":"J","\u054C":"R'","\u054D":"S","\u054E":"V","\u054F":"T","\u0550":"R","\u0551":"C","\u0553":"P'","\u0554":"Q'","\u0555":"O''","\u0556":"F","\u0587":"EV","\u0621":"a","\u0622":"aa","\u0623":"a","\u0624":"u","\u0625":"i","\u0626":"e","\u0627":"a","\u0628":"b","\u0629":"h","\u062A":"t","\u062B":"th","\u062C":"j","\u062D":"h","\u062E":"kh","\u062F":"d","\u0630":"th","\u0631":"r","\u0632":"z","\u0633":"s","\u0634":"sh","\u0635":"s","\u0636":"dh","\u0637":"t","\u0638":"z","\u0639":"a","\u063A":"gh","\u0641":"f","\u0642":"q","\u0643":"k","\u0644":"l","\u0645":"m","\u0646":"n","\u0647":"h","\u0648":"w","\u0649":"a","\u064A":"y","\u064B":"an","\u064C":"on","\u064D":"en","\u064E":"a","\u064F":"u","\u0650":"e","\u0652":"","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u067E":"p","\u0686":"ch","\u0698":"zh","\u06A9":"k","\u06AF":"g","\u06CC":"y","\u06F0":"0","\u06F1":"1","\u06F2":"2","\u06F3":"3","\u06F4":"4","\u06F5":"5","\u06F6":"6","\u06F7":"7","\u06F8":"8","\u06F9":"9","\u0E3F":"baht","\u10D0":"a","\u10D1":"b","\u10D2":"g","\u10D3":"d","\u10D4":"e","\u10D5":"v","\u10D6":"z","\u10D7":"t","\u10D8":"i","\u10D9":"k","\u10DA":"l","\u10DB":"m","\u10DC":"n","\u10DD":"o","\u10DE":"p","\u10DF":"zh","\u10E0":"r","\u10E1":"s","\u10E2":"t","\u10E3":"u","\u10E4":"f","\u10E5":"k","\u10E6":"gh","\u10E7":"q","\u10E8":"sh","\u10E9":"ch","\u10EA":"ts","\u10EB":"dz","\u10EC":"ts","\u10ED":"ch","\u10EE":"kh","\u10EF":"j","\u10F0":"h","\u1E62":"S","\u1E63":"s","\u1E80":"W","\u1E81":"w","\u1E82":"W","\u1E83":"w","\u1E84":"W","\u1E85":"w","\u1E9E":"SS","\u1EA0":"A","\u1EA1":"a","\u1EA2":"A","\u1EA3":"a","\u1EA4":"A","\u1EA5":"a","\u1EA6":"A","\u1EA7":"a","\u1EA8":"A","\u1EA9":"a","\u1EAA":"A","\u1EAB":"a","\u1EAC":"A","\u1EAD":"a","\u1EAE":"A","\u1EAF":"a","\u1EB0":"A","\u1EB1":"a","\u1EB2":"A","\u1EB3":"a","\u1EB4":"A","\u1EB5":"a","\u1EB6":"A","\u1EB7":"a","\u1EB8":"E","\u1EB9":"e","\u1EBA":"E","\u1EBB":"e","\u1EBC":"E","\u1EBD":"e","\u1EBE":"E","\u1EBF":"e","\u1EC0":"E","\u1EC1":"e","\u1EC2":"E","\u1EC3":"e","\u1EC4":"E","\u1EC5":"e","\u1EC6":"E","\u1EC7":"e","\u1EC8":"I","\u1EC9":"i","\u1ECA":"I","\u1ECB":"i","\u1ECC":"O","\u1ECD":"o","\u1ECE":"O","\u1ECF":"o","\u1ED0":"O","\u1ED1":"o","\u1ED2":"O","\u1ED3":"o","\u1ED4":"O","\u1ED5":"o","\u1ED6":"O","\u1ED7":"o","\u1ED8":"O","\u1ED9":"o","\u1EDA":"O","\u1EDB":"o","\u1EDC":"O","\u1EDD":"o","\u1EDE":"O","\u1EDF":"o","\u1EE0":"O","\u1EE1":"o","\u1EE2":"O","\u1EE3":"o","\u1EE4":"U","\u1EE5":"u","\u1EE6":"U","\u1EE7":"u","\u1EE8":"U","\u1EE9":"u","\u1EEA":"U","\u1EEB":"u","\u1EEC":"U","\u1EED":"u","\u1EEE":"U","\u1EEF":"u","\u1EF0":"U","\u1EF1":"u","\u1EF2":"Y","\u1EF3":"y","\u1EF4":"Y","\u1EF5":"y","\u1EF6":"Y","\u1EF7":"y","\u1EF8":"Y","\u1EF9":"y","\u2013":"-","\u2018":"'","\u2019":"'","\u201C":"\\"","\u201D":"\\"","\u201E":"\\"","\u2020":"+","\u2022":"*","\u2026":"...","\u20A0":"ecu","\u20A2":"cruzeiro","\u20A3":"french franc","\u20A4":"lira","\u20A5":"mill","\u20A6":"naira","\u20A7":"peseta","\u20A8":"rupee","\u20A9":"won","\u20AA":"new shequel","\u20AB":"dong","\u20AC":"euro","\u20AD":"kip","\u20AE":"tugrik","\u20AF":"drachma","\u20B0":"penny","\u20B1":"peso","\u20B2":"guarani","\u20B3":"austral","\u20B4":"hryvnia","\u20B5":"cedi","\u20B8":"kazakhstani tenge","\u20B9":"indian rupee","\u20BA":"turkish lira","\u20BD":"russian ruble","\u20BF":"bitcoin","\u2120":"sm","\u2122":"tm","\u2202":"d","\u2206":"delta","\u2211":"sum","\u221E":"infinity","\u2665":"love","\u5143":"yuan","\u5186":"yen","\uFDFC":"rial","\uFEF5":"laa","\uFEF7":"laa","\uFEF9":"lai","\uFEFB":"la"}`);
      var locales = JSON.parse('{"bg":{"\u0419":"Y","\u0426":"Ts","\u0429":"Sht","\u042A":"A","\u042C":"Y","\u0439":"y","\u0446":"ts","\u0449":"sht","\u044A":"a","\u044C":"y"},"de":{"\xC4":"AE","\xE4":"ae","\xD6":"OE","\xF6":"oe","\xDC":"UE","\xFC":"ue","\xDF":"ss","%":"prozent","&":"und","|":"oder","\u2211":"summe","\u221E":"unendlich","\u2665":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","\xA2":"centavos","\xA3":"libras","\xA4":"moneda","\u20A3":"francos","\u2211":"suma","\u221E":"infinito","\u2665":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","\xA2":"centime","\xA3":"livre","\xA4":"devise","\u20A3":"franc","\u2211":"somme","\u221E":"infini","\u2665":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","\xA2":"centavo","\u2211":"soma","\xA3":"libra","\u221E":"infinito","\u2665":"amor"},"uk":{"\u0418":"Y","\u0438":"y","\u0419":"Y","\u0439":"y","\u0426":"Ts","\u0446":"ts","\u0425":"Kh","\u0445":"kh","\u0429":"Shch","\u0449":"shch","\u0413":"H","\u0433":"h"},"vi":{"\u0110":"D","\u0111":"d"},"da":{"\xD8":"OE","\xF8":"oe","\xC5":"AA","\xE5":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"st\xF8rre end"},"nb":{"&":"og","\xC5":"AA","\xC6":"AE","\xD8":"OE","\xE5":"aa","\xE6":"ae","\xF8":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","\xC5":"AA","\xC4":"AE","\xD6":"OE","\xE5":"aa","\xE4":"ae","\xF6":"oe"}}');
      function replace(string2, options) {
        if (typeof string2 !== "string") {
          throw new Error("slugify: string argument expected");
        }
        options = typeof options === "string" ? { replacement: options } : options || {};
        var locale = locales[options.locale] || {};
        var replacement = options.replacement === void 0 ? "-" : options.replacement;
        var trim = options.trim === void 0 ? true : options.trim;
        var slug = string2.normalize().split("").reduce(function(result5, ch) {
          var appendChar = locale[ch];
          if (appendChar === void 0) appendChar = charMap[ch];
          if (appendChar === void 0) appendChar = ch;
          if (appendChar === replacement) appendChar = " ";
          return result5 + appendChar.replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, "");
        }, "");
        if (options.strict) {
          slug = slug.replace(/[^A-Za-z0-9\s]/g, "");
        }
        if (trim) {
          slug = slug.trim();
        }
        slug = slug.replace(/\s+/g, replacement);
        if (options.lower) {
          slug = slug.toLowerCase();
        }
        return slug;
      }
      replace.extend = function(customMap) {
        Object.assign(charMap, customMap);
      };
      return replace;
    });
  }
});

// ../node_modules/tslib/tslib.es6.mjs
var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
    throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function __awaiter(thisArg, _arguments, P, generator3) {
  function adopt(value6) {
    return value6 instanceof P ? value6 : new P(function(resolve) {
      resolve(value6);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject2) {
    function fulfilled(value6) {
      try {
        step4(generator3.next(value6));
      } catch (e) {
        reject2(e);
      }
    }
    function rejected(value6) {
      try {
        step4(generator3["throw"](value6));
      } catch (e) {
        reject2(e);
      }
    }
    function step4(result5) {
      result5.done ? resolve(result5.value) : adopt(result5.value).then(fulfilled, rejected);
    }
    step4((generator3 = generator3.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1) throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb2(0), "throw": verb2(1), "return": verb2(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb2(n2) {
    return function(v2) {
      return step4([n2, v2]);
    };
  }
  function step4(op2) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op2[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op2[0] & 2 ? y["return"] : op2[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op2[1])).done) return t;
      if (y = 0, t) op2 = [op2[0] & 2, t.value];
      switch (op2[0]) {
        case 0:
        case 1:
          t = op2;
          break;
        case 4:
          _.label++;
          return { value: op2[1], done: false };
        case 5:
          _.label++;
          y = op2[1];
          op2 = [0];
          continue;
        case 7:
          op2 = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op2[0] === 6 || op2[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op2[0] === 3 && (!t || op2[1] > t[0] && op2[1] < t[3])) {
            _.label = op2[1];
            break;
          }
          if (op2[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op2;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op2);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op2 = body.call(thisArg, _);
    } catch (e) {
      op2 = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op2[0] & 5) throw op2[1];
    return { value: op2[0] ? op2[1] : void 0, done: true };
  }
}
function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function() {
      if (o && i >= o.length) o = void 0;
      return { value: o && o[i++], done: !o };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n2) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error4) {
    e = { error: error4 };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spreadArray(to2, from2, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from2.length, ar; i < l; i++) {
    if (ar || !(i in from2)) {
      if (!ar) ar = Array.prototype.slice.call(from2, 0, i);
      ar[i] = from2[i];
    }
  }
  return to2.concat(ar || Array.prototype.slice.call(from2));
}
function __await(v2) {
  return this instanceof __await ? (this.v = v2, this) : new __await(v2);
}
function __asyncGenerator(thisArg, _arguments, generator3) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator3.apply(thisArg, _arguments || []), i, q = [];
  return i = {}, verb2("next"), verb2("throw"), verb2("return"), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function verb2(n2) {
    if (g[n2]) i[n2] = function(v2) {
      return new Promise(function(a, b) {
        q.push([n2, v2, a, b]) > 1 || resume(n2, v2);
      });
    };
  }
  function resume(n2, v2) {
    try {
      step4(g[n2](v2));
    } catch (e) {
      settle(q[0][3], e);
    }
  }
  function step4(r) {
    r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject2) : settle(q[0][2], r);
  }
  function fulfill(value6) {
    resume("next", value6);
  }
  function reject2(value6) {
    resume("throw", value6);
  }
  function settle(f, v2) {
    if (f(v2), q.shift(), q.length) resume(q[0][0], q[0][1]);
  }
}
function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb2("next"), verb2("throw"), verb2("return"), i[Symbol.asyncIterator] = function() {
    return this;
  }, i);
  function verb2(n2) {
    i[n2] = o[n2] && function(v2) {
      return new Promise(function(resolve, reject2) {
        v2 = o[n2](v2), settle(resolve, reject2, v2.done, v2.value);
      });
    };
  }
  function settle(resolve, reject2, d, v2) {
    Promise.resolve(v2).then(function(v3) {
      resolve({ value: v3, done: d });
    }, reject2);
  }
}

// ../node_modules/rxjs/dist/esm5/internal/util/isFunction.js
function isFunction(value6) {
  return typeof value6 === "function";
}

// ../node_modules/rxjs/dist/esm5/internal/util/createErrorClass.js
function createErrorClass(createImpl) {
  var _super = function(instance3) {
    Error.call(instance3);
    instance3.stack = new Error().stack;
  };
  var ctorFunc = createImpl(_super);
  ctorFunc.prototype = Object.create(Error.prototype);
  ctorFunc.prototype.constructor = ctorFunc;
  return ctorFunc;
}

// ../node_modules/rxjs/dist/esm5/internal/util/UnsubscriptionError.js
var UnsubscriptionError = createErrorClass(function(_super) {
  return function UnsubscriptionErrorImpl(errors) {
    _super(this);
    this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
      return i + 1 + ") " + err.toString();
    }).join("\n  ") : "";
    this.name = "UnsubscriptionError";
    this.errors = errors;
  };
});

// ../node_modules/rxjs/dist/esm5/internal/util/arrRemove.js
function arrRemove(arr, item4) {
  if (arr) {
    var index2 = arr.indexOf(item4);
    0 <= index2 && arr.splice(index2, 1);
  }
}

// ../node_modules/rxjs/dist/esm5/internal/Subscription.js
var Subscription = function() {
  function Subscription3(initialTeardown) {
    this.initialTeardown = initialTeardown;
    this.closed = false;
    this._parentage = null;
    this._finalizers = null;
  }
  Subscription3.prototype.unsubscribe = function() {
    var e_1, _a, e_2, _b;
    var errors;
    if (!this.closed) {
      this.closed = true;
      var _parentage = this._parentage;
      if (_parentage) {
        this._parentage = null;
        if (Array.isArray(_parentage)) {
          try {
            for (var _parentage_1 = __values(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()) {
              var parent_1 = _parentage_1_1.value;
              parent_1.remove(this);
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
        } else {
          _parentage.remove(this);
        }
      }
      var initialFinalizer = this.initialTeardown;
      if (isFunction(initialFinalizer)) {
        try {
          initialFinalizer();
        } catch (e) {
          errors = e instanceof UnsubscriptionError ? e.errors : [e];
        }
      }
      var _finalizers = this._finalizers;
      if (_finalizers) {
        this._finalizers = null;
        try {
          for (var _finalizers_1 = __values(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()) {
            var finalizer = _finalizers_1_1.value;
            try {
              execFinalizer(finalizer);
            } catch (err) {
              errors = errors !== null && errors !== void 0 ? errors : [];
              if (err instanceof UnsubscriptionError) {
                errors = __spreadArray(__spreadArray([], __read(errors)), __read(err.errors));
              } else {
                errors.push(err);
              }
            }
          }
        } catch (e_2_1) {
          e_2 = { error: e_2_1 };
        } finally {
          try {
            if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
          } finally {
            if (e_2) throw e_2.error;
          }
        }
      }
      if (errors) {
        throw new UnsubscriptionError(errors);
      }
    }
  };
  Subscription3.prototype.add = function(teardown2) {
    var _a;
    if (teardown2 && teardown2 !== this) {
      if (this.closed) {
        execFinalizer(teardown2);
      } else {
        if (teardown2 instanceof Subscription3) {
          if (teardown2.closed || teardown2._hasParent(this)) {
            return;
          }
          teardown2._addParent(this);
        }
        (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown2);
      }
    }
  };
  Subscription3.prototype._hasParent = function(parent4) {
    var _parentage = this._parentage;
    return _parentage === parent4 || Array.isArray(_parentage) && _parentage.includes(parent4);
  };
  Subscription3.prototype._addParent = function(parent4) {
    var _parentage = this._parentage;
    this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent4), _parentage) : _parentage ? [_parentage, parent4] : parent4;
  };
  Subscription3.prototype._removeParent = function(parent4) {
    var _parentage = this._parentage;
    if (_parentage === parent4) {
      this._parentage = null;
    } else if (Array.isArray(_parentage)) {
      arrRemove(_parentage, parent4);
    }
  };
  Subscription3.prototype.remove = function(teardown2) {
    var _finalizers = this._finalizers;
    _finalizers && arrRemove(_finalizers, teardown2);
    if (teardown2 instanceof Subscription3) {
      teardown2._removeParent(this);
    }
  };
  Subscription3.EMPTY = function() {
    var empty = new Subscription3();
    empty.closed = true;
    return empty;
  }();
  return Subscription3;
}();
var EMPTY_SUBSCRIPTION = Subscription.EMPTY;
function isSubscription(value6) {
  return value6 instanceof Subscription || value6 && "closed" in value6 && isFunction(value6.remove) && isFunction(value6.add) && isFunction(value6.unsubscribe);
}
function execFinalizer(finalizer) {
  if (isFunction(finalizer)) {
    finalizer();
  } else {
    finalizer.unsubscribe();
  }
}

// ../node_modules/rxjs/dist/esm5/internal/config.js
var config = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: false,
  useDeprecatedNextContext: false
};

// ../node_modules/rxjs/dist/esm5/internal/scheduler/timeoutProvider.js
var timeoutProvider = {
  setTimeout: function(handler, timeout2) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      args[_i - 2] = arguments[_i];
    }
    var delegate = timeoutProvider.delegate;
    if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) {
      return delegate.setTimeout.apply(delegate, __spreadArray([handler, timeout2], __read(args)));
    }
    return setTimeout.apply(void 0, __spreadArray([handler, timeout2], __read(args)));
  },
  clearTimeout: function(handle) {
    var delegate = timeoutProvider.delegate;
    return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
  },
  delegate: void 0
};

// ../node_modules/rxjs/dist/esm5/internal/util/reportUnhandledError.js
function reportUnhandledError(err) {
  timeoutProvider.setTimeout(function() {
    var onUnhandledError = config.onUnhandledError;
    if (onUnhandledError) {
      onUnhandledError(err);
    } else {
      throw err;
    }
  });
}

// ../node_modules/rxjs/dist/esm5/internal/util/noop.js
function noop() {
}

// ../node_modules/rxjs/dist/esm5/internal/NotificationFactories.js
var COMPLETE_NOTIFICATION = function() {
  return createNotification("C", void 0, void 0);
}();
function errorNotification(error4) {
  return createNotification("E", void 0, error4);
}
function nextNotification(value6) {
  return createNotification("N", value6, void 0);
}
function createNotification(kind2, value6, error4) {
  return {
    kind: kind2,
    value: value6,
    error: error4
  };
}

// ../node_modules/rxjs/dist/esm5/internal/util/errorContext.js
var context = null;
function errorContext(cb) {
  if (config.useDeprecatedSynchronousErrorHandling) {
    var isRoot = !context;
    if (isRoot) {
      context = { errorThrown: false, error: null };
    }
    cb();
    if (isRoot) {
      var _a = context, errorThrown = _a.errorThrown, error4 = _a.error;
      context = null;
      if (errorThrown) {
        throw error4;
      }
    }
  } else {
    cb();
  }
}
function captureError(err) {
  if (config.useDeprecatedSynchronousErrorHandling && context) {
    context.errorThrown = true;
    context.error = err;
  }
}

// ../node_modules/rxjs/dist/esm5/internal/Subscriber.js
var Subscriber = function(_super) {
  __extends(Subscriber2, _super);
  function Subscriber2(destination2) {
    var _this = _super.call(this) || this;
    _this.isStopped = false;
    if (destination2) {
      _this.destination = destination2;
      if (isSubscription(destination2)) {
        destination2.add(_this);
      }
    } else {
      _this.destination = EMPTY_OBSERVER;
    }
    return _this;
  }
  Subscriber2.create = function(next3, error4, complete2) {
    return new SafeSubscriber(next3, error4, complete2);
  };
  Subscriber2.prototype.next = function(value6) {
    if (this.isStopped) {
      handleStoppedNotification(nextNotification(value6), this);
    } else {
      this._next(value6);
    }
  };
  Subscriber2.prototype.error = function(err) {
    if (this.isStopped) {
      handleStoppedNotification(errorNotification(err), this);
    } else {
      this.isStopped = true;
      this._error(err);
    }
  };
  Subscriber2.prototype.complete = function() {
    if (this.isStopped) {
      handleStoppedNotification(COMPLETE_NOTIFICATION, this);
    } else {
      this.isStopped = true;
      this._complete();
    }
  };
  Subscriber2.prototype.unsubscribe = function() {
    if (!this.closed) {
      this.isStopped = true;
      _super.prototype.unsubscribe.call(this);
      this.destination = null;
    }
  };
  Subscriber2.prototype._next = function(value6) {
    this.destination.next(value6);
  };
  Subscriber2.prototype._error = function(err) {
    try {
      this.destination.error(err);
    } finally {
      this.unsubscribe();
    }
  };
  Subscriber2.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  };
  return Subscriber2;
}(Subscription);
var _bind = Function.prototype.bind;
function bind(fn2, thisArg) {
  return _bind.call(fn2, thisArg);
}
var ConsumerObserver = function() {
  function ConsumerObserver2(partialObserver) {
    this.partialObserver = partialObserver;
  }
  ConsumerObserver2.prototype.next = function(value6) {
    var partialObserver = this.partialObserver;
    if (partialObserver.next) {
      try {
        partialObserver.next(value6);
      } catch (error4) {
        handleUnhandledError(error4);
      }
    }
  };
  ConsumerObserver2.prototype.error = function(err) {
    var partialObserver = this.partialObserver;
    if (partialObserver.error) {
      try {
        partialObserver.error(err);
      } catch (error4) {
        handleUnhandledError(error4);
      }
    } else {
      handleUnhandledError(err);
    }
  };
  ConsumerObserver2.prototype.complete = function() {
    var partialObserver = this.partialObserver;
    if (partialObserver.complete) {
      try {
        partialObserver.complete();
      } catch (error4) {
        handleUnhandledError(error4);
      }
    }
  };
  return ConsumerObserver2;
}();
var SafeSubscriber = function(_super) {
  __extends(SafeSubscriber2, _super);
  function SafeSubscriber2(observerOrNext, error4, complete2) {
    var _this = _super.call(this) || this;
    var partialObserver;
    if (isFunction(observerOrNext) || !observerOrNext) {
      partialObserver = {
        next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : void 0,
        error: error4 !== null && error4 !== void 0 ? error4 : void 0,
        complete: complete2 !== null && complete2 !== void 0 ? complete2 : void 0
      };
    } else {
      var context_1;
      if (_this && config.useDeprecatedNextContext) {
        context_1 = Object.create(observerOrNext);
        context_1.unsubscribe = function() {
          return _this.unsubscribe();
        };
        partialObserver = {
          next: observerOrNext.next && bind(observerOrNext.next, context_1),
          error: observerOrNext.error && bind(observerOrNext.error, context_1),
          complete: observerOrNext.complete && bind(observerOrNext.complete, context_1)
        };
      } else {
        partialObserver = observerOrNext;
      }
    }
    _this.destination = new ConsumerObserver(partialObserver);
    return _this;
  }
  return SafeSubscriber2;
}(Subscriber);
function handleUnhandledError(error4) {
  if (config.useDeprecatedSynchronousErrorHandling) {
    captureError(error4);
  } else {
    reportUnhandledError(error4);
  }
}
function defaultErrorHandler(err) {
  throw err;
}
function handleStoppedNotification(notification2, subscriber3) {
  var onStoppedNotification = config.onStoppedNotification;
  onStoppedNotification && timeoutProvider.setTimeout(function() {
    return onStoppedNotification(notification2, subscriber3);
  });
}
var EMPTY_OBSERVER = {
  closed: true,
  next: noop,
  error: defaultErrorHandler,
  complete: noop
};

// ../node_modules/rxjs/dist/esm5/internal/symbol/observable.js
var observable = function() {
  return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();

// ../node_modules/rxjs/dist/esm5/internal/util/identity.js
function identity(x) {
  return x;
}

// ../node_modules/rxjs/dist/esm5/internal/util/pipe.js
function pipeFromArray(fns) {
  if (fns.length === 0) {
    return identity;
  }
  if (fns.length === 1) {
    return fns[0];
  }
  return function piped(input2) {
    return fns.reduce(function(prev, fn2) {
      return fn2(prev);
    }, input2);
  };
}

// ../node_modules/rxjs/dist/esm5/internal/Observable.js
var Observable = function() {
  function Observable2(subscribe) {
    if (subscribe) {
      this._subscribe = subscribe;
    }
  }
  Observable2.prototype.lift = function(operator2) {
    var observable2 = new Observable2();
    observable2.source = this;
    observable2.operator = operator2;
    return observable2;
  };
  Observable2.prototype.subscribe = function(observerOrNext, error4, complete2) {
    var _this = this;
    var subscriber3 = isSubscriber(observerOrNext) ? observerOrNext : new SafeSubscriber(observerOrNext, error4, complete2);
    errorContext(function() {
      var _a = _this, operator2 = _a.operator, source8 = _a.source;
      subscriber3.add(operator2 ? operator2.call(subscriber3, source8) : source8 ? _this._subscribe(subscriber3) : _this._trySubscribe(subscriber3));
    });
    return subscriber3;
  };
  Observable2.prototype._trySubscribe = function(sink) {
    try {
      return this._subscribe(sink);
    } catch (err) {
      sink.error(err);
    }
  };
  Observable2.prototype.forEach = function(next3, promiseCtor) {
    var _this = this;
    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function(resolve, reject2) {
      var subscriber3 = new SafeSubscriber({
        next: function(value6) {
          try {
            next3(value6);
          } catch (err) {
            reject2(err);
            subscriber3.unsubscribe();
          }
        },
        error: reject2,
        complete: resolve
      });
      _this.subscribe(subscriber3);
    });
  };
  Observable2.prototype._subscribe = function(subscriber3) {
    var _a;
    return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber3);
  };
  Observable2.prototype[observable] = function() {
    return this;
  };
  Observable2.prototype.pipe = function() {
    var operations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      operations[_i] = arguments[_i];
    }
    return pipeFromArray(operations)(this);
  };
  Observable2.prototype.toPromise = function(promiseCtor) {
    var _this = this;
    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function(resolve, reject2) {
      var value6;
      _this.subscribe(function(x) {
        return value6 = x;
      }, function(err) {
        return reject2(err);
      }, function() {
        return resolve(value6);
      });
    });
  };
  Observable2.create = function(subscribe) {
    return new Observable2(subscribe);
  };
  return Observable2;
}();
function getPromiseCtor(promiseCtor) {
  var _a;
  return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : config.Promise) !== null && _a !== void 0 ? _a : Promise;
}
function isObserver(value6) {
  return value6 && isFunction(value6.next) && isFunction(value6.error) && isFunction(value6.complete);
}
function isSubscriber(value6) {
  return value6 && value6 instanceof Subscriber || isObserver(value6) && isSubscription(value6);
}

// ../node_modules/rxjs/dist/esm5/internal/util/lift.js
function hasLift(source8) {
  return isFunction(source8 === null || source8 === void 0 ? void 0 : source8.lift);
}
function operate(init) {
  return function(source8) {
    if (hasLift(source8)) {
      return source8.lift(function(liftedSource) {
        try {
          return init(liftedSource, this);
        } catch (err) {
          this.error(err);
        }
      });
    }
    throw new TypeError("Unable to lift unknown Observable type");
  };
}

// ../node_modules/rxjs/dist/esm5/internal/operators/OperatorSubscriber.js
function createOperatorSubscriber(destination2, onNext, onComplete, onError, onFinalize) {
  return new OperatorSubscriber(destination2, onNext, onComplete, onError, onFinalize);
}
var OperatorSubscriber = function(_super) {
  __extends(OperatorSubscriber2, _super);
  function OperatorSubscriber2(destination2, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
    var _this = _super.call(this, destination2) || this;
    _this.onFinalize = onFinalize;
    _this.shouldUnsubscribe = shouldUnsubscribe;
    _this._next = onNext ? function(value6) {
      try {
        onNext(value6);
      } catch (err) {
        destination2.error(err);
      }
    } : _super.prototype._next;
    _this._error = onError ? function(err) {
      try {
        onError(err);
      } catch (err2) {
        destination2.error(err2);
      } finally {
        this.unsubscribe();
      }
    } : _super.prototype._error;
    _this._complete = onComplete ? function() {
      try {
        onComplete();
      } catch (err) {
        destination2.error(err);
      } finally {
        this.unsubscribe();
      }
    } : _super.prototype._complete;
    return _this;
  }
  OperatorSubscriber2.prototype.unsubscribe = function() {
    var _a;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var closed_1 = this.closed;
      _super.prototype.unsubscribe.call(this);
      !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 ? void 0 : _a.call(this));
    }
  };
  return OperatorSubscriber2;
}(Subscriber);

// ../node_modules/rxjs/dist/esm5/internal/util/ObjectUnsubscribedError.js
var ObjectUnsubscribedError = createErrorClass(function(_super) {
  return function ObjectUnsubscribedErrorImpl() {
    _super(this);
    this.name = "ObjectUnsubscribedError";
    this.message = "object unsubscribed";
  };
});

// ../node_modules/rxjs/dist/esm5/internal/Subject.js
var Subject = function(_super) {
  __extends(Subject2, _super);
  function Subject2() {
    var _this = _super.call(this) || this;
    _this.closed = false;
    _this.currentObservers = null;
    _this.observers = [];
    _this.isStopped = false;
    _this.hasError = false;
    _this.thrownError = null;
    return _this;
  }
  Subject2.prototype.lift = function(operator2) {
    var subject5 = new AnonymousSubject(this, this);
    subject5.operator = operator2;
    return subject5;
  };
  Subject2.prototype._throwIfClosed = function() {
    if (this.closed) {
      throw new ObjectUnsubscribedError();
    }
  };
  Subject2.prototype.next = function(value6) {
    var _this = this;
    errorContext(function() {
      var e_1, _a;
      _this._throwIfClosed();
      if (!_this.isStopped) {
        if (!_this.currentObservers) {
          _this.currentObservers = Array.from(_this.observers);
        }
        try {
          for (var _b = __values(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()) {
            var observer2 = _c.value;
            observer2.next(value6);
          }
        } catch (e_1_1) {
          e_1 = { error: e_1_1 };
        } finally {
          try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
      }
    });
  };
  Subject2.prototype.error = function(err) {
    var _this = this;
    errorContext(function() {
      _this._throwIfClosed();
      if (!_this.isStopped) {
        _this.hasError = _this.isStopped = true;
        _this.thrownError = err;
        var observers = _this.observers;
        while (observers.length) {
          observers.shift().error(err);
        }
      }
    });
  };
  Subject2.prototype.complete = function() {
    var _this = this;
    errorContext(function() {
      _this._throwIfClosed();
      if (!_this.isStopped) {
        _this.isStopped = true;
        var observers = _this.observers;
        while (observers.length) {
          observers.shift().complete();
        }
      }
    });
  };
  Subject2.prototype.unsubscribe = function() {
    this.isStopped = this.closed = true;
    this.observers = this.currentObservers = null;
  };
  Object.defineProperty(Subject2.prototype, "observed", {
    get: function() {
      var _a;
      return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
    },
    enumerable: false,
    configurable: true
  });
  Subject2.prototype._trySubscribe = function(subscriber3) {
    this._throwIfClosed();
    return _super.prototype._trySubscribe.call(this, subscriber3);
  };
  Subject2.prototype._subscribe = function(subscriber3) {
    this._throwIfClosed();
    this._checkFinalizedStatuses(subscriber3);
    return this._innerSubscribe(subscriber3);
  };
  Subject2.prototype._innerSubscribe = function(subscriber3) {
    var _this = this;
    var _a = this, hasError2 = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
    if (hasError2 || isStopped) {
      return EMPTY_SUBSCRIPTION;
    }
    this.currentObservers = null;
    observers.push(subscriber3);
    return new Subscription(function() {
      _this.currentObservers = null;
      arrRemove(observers, subscriber3);
    });
  };
  Subject2.prototype._checkFinalizedStatuses = function(subscriber3) {
    var _a = this, hasError2 = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
    if (hasError2) {
      subscriber3.error(thrownError);
    } else if (isStopped) {
      subscriber3.complete();
    }
  };
  Subject2.prototype.asObservable = function() {
    var observable2 = new Observable();
    observable2.source = this;
    return observable2;
  };
  Subject2.create = function(destination2, source8) {
    return new AnonymousSubject(destination2, source8);
  };
  return Subject2;
}(Observable);
var AnonymousSubject = function(_super) {
  __extends(AnonymousSubject2, _super);
  function AnonymousSubject2(destination2, source8) {
    var _this = _super.call(this) || this;
    _this.destination = destination2;
    _this.source = source8;
    return _this;
  }
  AnonymousSubject2.prototype.next = function(value6) {
    var _a, _b;
    (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.call(_a, value6);
  };
  AnonymousSubject2.prototype.error = function(err) {
    var _a, _b;
    (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, err);
  };
  AnonymousSubject2.prototype.complete = function() {
    var _a, _b;
    (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.call(_a);
  };
  AnonymousSubject2.prototype._subscribe = function(subscriber3) {
    var _a, _b;
    return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber3)) !== null && _b !== void 0 ? _b : EMPTY_SUBSCRIPTION;
  };
  return AnonymousSubject2;
}(Subject);

// ../node_modules/rxjs/dist/esm5/internal/BehaviorSubject.js
var BehaviorSubject = function(_super) {
  __extends(BehaviorSubject3, _super);
  function BehaviorSubject3(_value2) {
    var _this = _super.call(this) || this;
    _this._value = _value2;
    return _this;
  }
  Object.defineProperty(BehaviorSubject3.prototype, "value", {
    get: function() {
      return this.getValue();
    },
    enumerable: false,
    configurable: true
  });
  BehaviorSubject3.prototype._subscribe = function(subscriber3) {
    var subscription2 = _super.prototype._subscribe.call(this, subscriber3);
    !subscription2.closed && subscriber3.next(this._value);
    return subscription2;
  };
  BehaviorSubject3.prototype.getValue = function() {
    var _a = this, hasError2 = _a.hasError, thrownError = _a.thrownError, _value2 = _a._value;
    if (hasError2) {
      throw thrownError;
    }
    this._throwIfClosed();
    return _value2;
  };
  BehaviorSubject3.prototype.next = function(value6) {
    _super.prototype.next.call(this, this._value = value6);
  };
  return BehaviorSubject3;
}(Subject);

// ../node_modules/rxjs/dist/esm5/internal/observable/empty.js
var EMPTY = new Observable(function(subscriber3) {
  return subscriber3.complete();
});

// ../node_modules/rxjs/dist/esm5/internal/util/isScheduler.js
function isScheduler(value6) {
  return value6 && isFunction(value6.schedule);
}

// ../node_modules/rxjs/dist/esm5/internal/util/args.js
function last(arr) {
  return arr[arr.length - 1];
}
function popScheduler(args) {
  return isScheduler(last(args)) ? args.pop() : void 0;
}
function popNumber(args, defaultValue4) {
  return typeof last(args) === "number" ? args.pop() : defaultValue4;
}

// ../node_modules/rxjs/dist/esm5/internal/util/isArrayLike.js
var isArrayLike = function(x) {
  return x && typeof x.length === "number" && typeof x !== "function";
};

// ../node_modules/rxjs/dist/esm5/internal/util/isPromise.js
function isPromise(value6) {
  return isFunction(value6 === null || value6 === void 0 ? void 0 : value6.then);
}

// ../node_modules/rxjs/dist/esm5/internal/util/isInteropObservable.js
function isInteropObservable(input2) {
  return isFunction(input2[observable]);
}

// ../node_modules/rxjs/dist/esm5/internal/util/isAsyncIterable.js
function isAsyncIterable(obj) {
  return Symbol.asyncIterator && isFunction(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

// ../node_modules/rxjs/dist/esm5/internal/util/throwUnobservableError.js
function createInvalidObservableTypeError(input2) {
  return new TypeError("You provided " + (input2 !== null && typeof input2 === "object" ? "an invalid object" : "'" + input2 + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

// ../node_modules/rxjs/dist/esm5/internal/symbol/iterator.js
function getSymbolIterator() {
  if (typeof Symbol !== "function" || !Symbol.iterator) {
    return "@@iterator";
  }
  return Symbol.iterator;
}
var iterator = getSymbolIterator();

// ../node_modules/rxjs/dist/esm5/internal/util/isIterable.js
function isIterable(input2) {
  return isFunction(input2 === null || input2 === void 0 ? void 0 : input2[iterator]);
}

// ../node_modules/rxjs/dist/esm5/internal/util/isReadableStreamLike.js
function readableStreamLikeToAsyncGenerator(readableStream) {
  return __asyncGenerator(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
    var reader, _a, value6, done;
    return __generator(this, function(_b) {
      switch (_b.label) {
        case 0:
          reader = readableStream.getReader();
          _b.label = 1;
        case 1:
          _b.trys.push([1, , 9, 10]);
          _b.label = 2;
        case 2:
          if (false) return [3, 8];
          return [4, __await(reader.read())];
        case 3:
          _a = _b.sent(), value6 = _a.value, done = _a.done;
          if (!done) return [3, 5];
          return [4, __await(void 0)];
        case 4:
          return [2, _b.sent()];
        case 5:
          return [4, __await(value6)];
        case 6:
          return [4, _b.sent()];
        case 7:
          _b.sent();
          return [3, 2];
        case 8:
          return [3, 10];
        case 9:
          reader.releaseLock();
          return [7];
        case 10:
          return [2];
      }
    });
  });
}
function isReadableStreamLike(obj) {
  return isFunction(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

// ../node_modules/rxjs/dist/esm5/internal/observable/innerFrom.js
function innerFrom(input2) {
  if (input2 instanceof Observable) {
    return input2;
  }
  if (input2 != null) {
    if (isInteropObservable(input2)) {
      return fromInteropObservable(input2);
    }
    if (isArrayLike(input2)) {
      return fromArrayLike(input2);
    }
    if (isPromise(input2)) {
      return fromPromise(input2);
    }
    if (isAsyncIterable(input2)) {
      return fromAsyncIterable(input2);
    }
    if (isIterable(input2)) {
      return fromIterable(input2);
    }
    if (isReadableStreamLike(input2)) {
      return fromReadableStreamLike(input2);
    }
  }
  throw createInvalidObservableTypeError(input2);
}
function fromInteropObservable(obj) {
  return new Observable(function(subscriber3) {
    var obs = obj[observable]();
    if (isFunction(obs.subscribe)) {
      return obs.subscribe(subscriber3);
    }
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function fromArrayLike(array) {
  return new Observable(function(subscriber3) {
    for (var i = 0; i < array.length && !subscriber3.closed; i++) {
      subscriber3.next(array[i]);
    }
    subscriber3.complete();
  });
}
function fromPromise(promise) {
  return new Observable(function(subscriber3) {
    promise.then(function(value6) {
      if (!subscriber3.closed) {
        subscriber3.next(value6);
        subscriber3.complete();
      }
    }, function(err) {
      return subscriber3.error(err);
    }).then(null, reportUnhandledError);
  });
}
function fromIterable(iterable) {
  return new Observable(function(subscriber3) {
    var e_1, _a;
    try {
      for (var iterable_1 = __values(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()) {
        var value6 = iterable_1_1.value;
        subscriber3.next(value6);
        if (subscriber3.closed) {
          return;
        }
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    subscriber3.complete();
  });
}
function fromAsyncIterable(asyncIterable) {
  return new Observable(function(subscriber3) {
    process(asyncIterable, subscriber3).catch(function(err) {
      return subscriber3.error(err);
    });
  });
}
function fromReadableStreamLike(readableStream) {
  return fromAsyncIterable(readableStreamLikeToAsyncGenerator(readableStream));
}
function process(asyncIterable, subscriber3) {
  var asyncIterable_1, asyncIterable_1_1;
  var e_2, _a;
  return __awaiter(this, void 0, void 0, function() {
    var value6, e_2_1;
    return __generator(this, function(_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 5, 6, 11]);
          asyncIterable_1 = __asyncValues(asyncIterable);
          _b.label = 1;
        case 1:
          return [4, asyncIterable_1.next()];
        case 2:
          if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [3, 4];
          value6 = asyncIterable_1_1.value;
          subscriber3.next(value6);
          if (subscriber3.closed) {
            return [2];
          }
          _b.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          e_2_1 = _b.sent();
          e_2 = { error: e_2_1 };
          return [3, 11];
        case 6:
          _b.trys.push([6, , 9, 10]);
          if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [3, 8];
          return [4, _a.call(asyncIterable_1)];
        case 7:
          _b.sent();
          _b.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (e_2) throw e_2.error;
          return [7];
        case 10:
          return [7];
        case 11:
          subscriber3.complete();
          return [2];
      }
    });
  });
}

// ../node_modules/rxjs/dist/esm5/internal/util/executeSchedule.js
function executeSchedule(parentSubscription, scheduler, work, delay, repeat3) {
  if (delay === void 0) {
    delay = 0;
  }
  if (repeat3 === void 0) {
    repeat3 = false;
  }
  var scheduleSubscription = scheduler.schedule(function() {
    work();
    if (repeat3) {
      parentSubscription.add(this.schedule(null, delay));
    } else {
      this.unsubscribe();
    }
  }, delay);
  parentSubscription.add(scheduleSubscription);
  if (!repeat3) {
    return scheduleSubscription;
  }
}

// ../node_modules/rxjs/dist/esm5/internal/operators/observeOn.js
function observeOn(scheduler, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  return operate(function(source8, subscriber3) {
    source8.subscribe(createOperatorSubscriber(subscriber3, function(value6) {
      return executeSchedule(subscriber3, scheduler, function() {
        return subscriber3.next(value6);
      }, delay);
    }, function() {
      return executeSchedule(subscriber3, scheduler, function() {
        return subscriber3.complete();
      }, delay);
    }, function(err) {
      return executeSchedule(subscriber3, scheduler, function() {
        return subscriber3.error(err);
      }, delay);
    }));
  });
}

// ../node_modules/rxjs/dist/esm5/internal/operators/subscribeOn.js
function subscribeOn(scheduler, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  return operate(function(source8, subscriber3) {
    subscriber3.add(scheduler.schedule(function() {
      return source8.subscribe(subscriber3);
    }, delay));
  });
}

// ../node_modules/rxjs/dist/esm5/internal/scheduled/scheduleObservable.js
function scheduleObservable(input2, scheduler) {
  return innerFrom(input2).pipe(subscribeOn(scheduler), observeOn(scheduler));
}

// ../node_modules/rxjs/dist/esm5/internal/scheduled/schedulePromise.js
function schedulePromise(input2, scheduler) {
  return innerFrom(input2).pipe(subscribeOn(scheduler), observeOn(scheduler));
}

// ../node_modules/rxjs/dist/esm5/internal/scheduled/scheduleArray.js
function scheduleArray(input2, scheduler) {
  return new Observable(function(subscriber3) {
    var i = 0;
    return scheduler.schedule(function() {
      if (i === input2.length) {
        subscriber3.complete();
      } else {
        subscriber3.next(input2[i++]);
        if (!subscriber3.closed) {
          this.schedule();
        }
      }
    });
  });
}

// ../node_modules/rxjs/dist/esm5/internal/scheduled/scheduleIterable.js
function scheduleIterable(input2, scheduler) {
  return new Observable(function(subscriber3) {
    var iterator2;
    executeSchedule(subscriber3, scheduler, function() {
      iterator2 = input2[iterator]();
      executeSchedule(subscriber3, scheduler, function() {
        var _a;
        var value6;
        var done;
        try {
          _a = iterator2.next(), value6 = _a.value, done = _a.done;
        } catch (err) {
          subscriber3.error(err);
          return;
        }
        if (done) {
          subscriber3.complete();
        } else {
          subscriber3.next(value6);
        }
      }, 0, true);
    });
    return function() {
      return isFunction(iterator2 === null || iterator2 === void 0 ? void 0 : iterator2.return) && iterator2.return();
    };
  });
}

// ../node_modules/rxjs/dist/esm5/internal/scheduled/scheduleAsyncIterable.js
function scheduleAsyncIterable(input2, scheduler) {
  if (!input2) {
    throw new Error("Iterable cannot be null");
  }
  return new Observable(function(subscriber3) {
    executeSchedule(subscriber3, scheduler, function() {
      var iterator2 = input2[Symbol.asyncIterator]();
      executeSchedule(subscriber3, scheduler, function() {
        iterator2.next().then(function(result5) {
          if (result5.done) {
            subscriber3.complete();
          } else {
            subscriber3.next(result5.value);
          }
        });
      }, 0, true);
    });
  });
}

// ../node_modules/rxjs/dist/esm5/internal/scheduled/scheduleReadableStreamLike.js
function scheduleReadableStreamLike(input2, scheduler) {
  return scheduleAsyncIterable(readableStreamLikeToAsyncGenerator(input2), scheduler);
}

// ../node_modules/rxjs/dist/esm5/internal/scheduled/scheduled.js
function scheduled(input2, scheduler) {
  if (input2 != null) {
    if (isInteropObservable(input2)) {
      return scheduleObservable(input2, scheduler);
    }
    if (isArrayLike(input2)) {
      return scheduleArray(input2, scheduler);
    }
    if (isPromise(input2)) {
      return schedulePromise(input2, scheduler);
    }
    if (isAsyncIterable(input2)) {
      return scheduleAsyncIterable(input2, scheduler);
    }
    if (isIterable(input2)) {
      return scheduleIterable(input2, scheduler);
    }
    if (isReadableStreamLike(input2)) {
      return scheduleReadableStreamLike(input2, scheduler);
    }
  }
  throw createInvalidObservableTypeError(input2);
}

// ../node_modules/rxjs/dist/esm5/internal/observable/from.js
function from(input2, scheduler) {
  return scheduler ? scheduled(input2, scheduler) : innerFrom(input2);
}

// ../node_modules/rxjs/dist/esm5/internal/operators/map.js
function map(project, thisArg) {
  return operate(function(source8, subscriber3) {
    var index2 = 0;
    source8.subscribe(createOperatorSubscriber(subscriber3, function(value6) {
      subscriber3.next(project.call(thisArg, value6, index2++));
    }));
  });
}

// ../node_modules/rxjs/dist/esm5/internal/util/mapOneOrManyArgs.js
var isArray = Array.isArray;
function callOrApply(fn2, args) {
  return isArray(args) ? fn2.apply(void 0, __spreadArray([], __read(args))) : fn2(args);
}
function mapOneOrManyArgs(fn2) {
  return map(function(args) {
    return callOrApply(fn2, args);
  });
}

// ../node_modules/rxjs/dist/esm5/internal/operators/mergeInternals.js
function mergeInternals(source8, subscriber3, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
  var buffer = [];
  var active2 = 0;
  var index2 = 0;
  var isComplete = false;
  var checkComplete = function() {
    if (isComplete && !buffer.length && !active2) {
      subscriber3.complete();
    }
  };
  var outerNext = function(value6) {
    return active2 < concurrent ? doInnerSub(value6) : buffer.push(value6);
  };
  var doInnerSub = function(value6) {
    expand && subscriber3.next(value6);
    active2++;
    var innerComplete = false;
    innerFrom(project(value6, index2++)).subscribe(createOperatorSubscriber(subscriber3, function(innerValue) {
      onBeforeNext === null || onBeforeNext === void 0 ? void 0 : onBeforeNext(innerValue);
      if (expand) {
        outerNext(innerValue);
      } else {
        subscriber3.next(innerValue);
      }
    }, function() {
      innerComplete = true;
    }, void 0, function() {
      if (innerComplete) {
        try {
          active2--;
          var _loop_1 = function() {
            var bufferedValue = buffer.shift();
            if (innerSubScheduler) {
              executeSchedule(subscriber3, innerSubScheduler, function() {
                return doInnerSub(bufferedValue);
              });
            } else {
              doInnerSub(bufferedValue);
            }
          };
          while (buffer.length && active2 < concurrent) {
            _loop_1();
          }
          checkComplete();
        } catch (err) {
          subscriber3.error(err);
        }
      }
    }));
  };
  source8.subscribe(createOperatorSubscriber(subscriber3, outerNext, function() {
    isComplete = true;
    checkComplete();
  }));
  return function() {
    additionalFinalizer === null || additionalFinalizer === void 0 ? void 0 : additionalFinalizer();
  };
}

// ../node_modules/rxjs/dist/esm5/internal/operators/mergeMap.js
function mergeMap(project, resultSelector, concurrent) {
  if (concurrent === void 0) {
    concurrent = Infinity;
  }
  if (isFunction(resultSelector)) {
    return mergeMap(function(a, i) {
      return map(function(b, ii) {
        return resultSelector(a, b, i, ii);
      })(innerFrom(project(a, i)));
    }, concurrent);
  } else if (typeof resultSelector === "number") {
    concurrent = resultSelector;
  }
  return operate(function(source8, subscriber3) {
    return mergeInternals(source8, subscriber3, project, concurrent);
  });
}

// ../node_modules/rxjs/dist/esm5/internal/operators/mergeAll.js
function mergeAll(concurrent) {
  if (concurrent === void 0) {
    concurrent = Infinity;
  }
  return mergeMap(identity, concurrent);
}

// ../node_modules/rxjs/dist/esm5/internal/observable/fromEvent.js
var nodeEventEmitterMethods = ["addListener", "removeListener"];
var eventTargetMethods = ["addEventListener", "removeEventListener"];
var jqueryMethods = ["on", "off"];
function fromEvent(target5, eventName, options, resultSelector) {
  if (isFunction(options)) {
    resultSelector = options;
    options = void 0;
  }
  if (resultSelector) {
    return fromEvent(target5, eventName, options).pipe(mapOneOrManyArgs(resultSelector));
  }
  var _a = __read(isEventTarget(target5) ? eventTargetMethods.map(function(methodName) {
    return function(handler) {
      return target5[methodName](eventName, handler, options);
    };
  }) : isNodeStyleEventEmitter(target5) ? nodeEventEmitterMethods.map(toCommonHandlerRegistry(target5, eventName)) : isJQueryStyleEventEmitter(target5) ? jqueryMethods.map(toCommonHandlerRegistry(target5, eventName)) : [], 2), add2 = _a[0], remove = _a[1];
  if (!add2) {
    if (isArrayLike(target5)) {
      return mergeMap(function(subTarget) {
        return fromEvent(subTarget, eventName, options);
      })(innerFrom(target5));
    }
  }
  if (!add2) {
    throw new TypeError("Invalid event target");
  }
  return new Observable(function(subscriber3) {
    var handler = function() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return subscriber3.next(1 < args.length ? args : args[0]);
    };
    add2(handler);
    return function() {
      return remove(handler);
    };
  });
}
function toCommonHandlerRegistry(target5, eventName) {
  return function(methodName) {
    return function(handler) {
      return target5[methodName](eventName, handler);
    };
  };
}
function isNodeStyleEventEmitter(target5) {
  return isFunction(target5.addListener) && isFunction(target5.removeListener);
}
function isJQueryStyleEventEmitter(target5) {
  return isFunction(target5.on) && isFunction(target5.off);
}
function isEventTarget(target5) {
  return isFunction(target5.addEventListener) && isFunction(target5.removeEventListener);
}

// ../node_modules/rxjs/dist/esm5/internal/observable/merge.js
function merge() {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  var scheduler = popScheduler(args);
  var concurrent = popNumber(args, Infinity);
  var sources = args;
  return !sources.length ? EMPTY : sources.length === 1 ? innerFrom(sources[0]) : mergeAll(concurrent)(from(sources, scheduler));
}

// ../node_modules/rxjs/dist/esm5/internal/operators/tap.js
function tap(observerOrNext, error4, complete2) {
  var tapObserver = isFunction(observerOrNext) || error4 || complete2 ? { next: observerOrNext, error: error4, complete: complete2 } : observerOrNext;
  return tapObserver ? operate(function(source8, subscriber3) {
    var _a;
    (_a = tapObserver.subscribe) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
    var isUnsub = true;
    source8.subscribe(createOperatorSubscriber(subscriber3, function(value6) {
      var _a2;
      (_a2 = tapObserver.next) === null || _a2 === void 0 ? void 0 : _a2.call(tapObserver, value6);
      subscriber3.next(value6);
    }, function() {
      var _a2;
      isUnsub = false;
      (_a2 = tapObserver.complete) === null || _a2 === void 0 ? void 0 : _a2.call(tapObserver);
      subscriber3.complete();
    }, function(err) {
      var _a2;
      isUnsub = false;
      (_a2 = tapObserver.error) === null || _a2 === void 0 ? void 0 : _a2.call(tapObserver, err);
      subscriber3.error(err);
    }, function() {
      var _a2, _b;
      if (isUnsub) {
        (_a2 = tapObserver.unsubscribe) === null || _a2 === void 0 ? void 0 : _a2.call(tapObserver);
      }
      (_b = tapObserver.finalize) === null || _b === void 0 ? void 0 : _b.call(tapObserver);
    }));
  }) : identity;
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/runtime/webcrypto.js
var webcrypto_default = crypto;
var isCryptoKey = (key3) => key3 instanceof CryptoKey;

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/lib/buffer_utils.js
var encoder = new TextEncoder();
var decoder = new TextDecoder();
var MAX_INT32 = 2 ** 32;
function concat(...buffers) {
  const size4 = buffers.reduce((acc, { length: length2 }) => acc + length2, 0);
  const buf = new Uint8Array(size4);
  let i = 0;
  for (const buffer of buffers) {
    buf.set(buffer, i);
    i += buffer.length;
  }
  return buf;
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/runtime/base64url.js
var encodeBase64 = (input2) => {
  let unencoded = input2;
  if (typeof unencoded === "string") {
    unencoded = encoder.encode(unencoded);
  }
  const CHUNK_SIZE = 32768;
  const arr = [];
  for (let i = 0; i < unencoded.length; i += CHUNK_SIZE) {
    arr.push(String.fromCharCode.apply(null, unencoded.subarray(i, i + CHUNK_SIZE)));
  }
  return btoa(arr.join(""));
};
var encode = (input2) => {
  return encodeBase64(input2).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
var decodeBase64 = (encoded) => {
  const binary = atob(encoded);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};
var decode = (input2) => {
  let encoded = input2;
  if (encoded instanceof Uint8Array) {
    encoded = decoder.decode(encoded);
  }
  encoded = encoded.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
  try {
    return decodeBase64(encoded);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
};

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/util/errors.js
var JOSEError = class extends Error {
  constructor(message4, options) {
    super(message4, options);
    this.code = "ERR_JOSE_GENERIC";
    this.name = this.constructor.name;
    Error.captureStackTrace?.(this, this.constructor);
  }
};
JOSEError.code = "ERR_JOSE_GENERIC";
var JWTClaimValidationFailed = class extends JOSEError {
  constructor(message4, payload4, claim2 = "unspecified", reason2 = "unspecified") {
    super(message4, { cause: { claim: claim2, reason: reason2, payload: payload4 } });
    this.code = "ERR_JWT_CLAIM_VALIDATION_FAILED";
    this.claim = claim2;
    this.reason = reason2;
    this.payload = payload4;
  }
};
JWTClaimValidationFailed.code = "ERR_JWT_CLAIM_VALIDATION_FAILED";
var JWTExpired = class extends JOSEError {
  constructor(message4, payload4, claim2 = "unspecified", reason2 = "unspecified") {
    super(message4, { cause: { claim: claim2, reason: reason2, payload: payload4 } });
    this.code = "ERR_JWT_EXPIRED";
    this.claim = claim2;
    this.reason = reason2;
    this.payload = payload4;
  }
};
JWTExpired.code = "ERR_JWT_EXPIRED";
var JOSEAlgNotAllowed = class extends JOSEError {
  constructor() {
    super(...arguments);
    this.code = "ERR_JOSE_ALG_NOT_ALLOWED";
  }
};
JOSEAlgNotAllowed.code = "ERR_JOSE_ALG_NOT_ALLOWED";
var JOSENotSupported = class extends JOSEError {
  constructor() {
    super(...arguments);
    this.code = "ERR_JOSE_NOT_SUPPORTED";
  }
};
JOSENotSupported.code = "ERR_JOSE_NOT_SUPPORTED";
var JWEDecryptionFailed = class extends JOSEError {
  constructor(message4 = "decryption operation failed", options) {
    super(message4, options);
    this.code = "ERR_JWE_DECRYPTION_FAILED";
  }
};
JWEDecryptionFailed.code = "ERR_JWE_DECRYPTION_FAILED";
var JWEInvalid = class extends JOSEError {
  constructor() {
    super(...arguments);
    this.code = "ERR_JWE_INVALID";
  }
};
JWEInvalid.code = "ERR_JWE_INVALID";
var JWSInvalid = class extends JOSEError {
  constructor() {
    super(...arguments);
    this.code = "ERR_JWS_INVALID";
  }
};
JWSInvalid.code = "ERR_JWS_INVALID";
var JWTInvalid = class extends JOSEError {
  constructor() {
    super(...arguments);
    this.code = "ERR_JWT_INVALID";
  }
};
JWTInvalid.code = "ERR_JWT_INVALID";
var JWKInvalid = class extends JOSEError {
  constructor() {
    super(...arguments);
    this.code = "ERR_JWK_INVALID";
  }
};
JWKInvalid.code = "ERR_JWK_INVALID";
var JWKSInvalid = class extends JOSEError {
  constructor() {
    super(...arguments);
    this.code = "ERR_JWKS_INVALID";
  }
};
JWKSInvalid.code = "ERR_JWKS_INVALID";
var JWKSNoMatchingKey = class extends JOSEError {
  constructor(message4 = "no applicable key found in the JSON Web Key Set", options) {
    super(message4, options);
    this.code = "ERR_JWKS_NO_MATCHING_KEY";
  }
};
JWKSNoMatchingKey.code = "ERR_JWKS_NO_MATCHING_KEY";
var JWKSMultipleMatchingKeys = class extends JOSEError {
  constructor(message4 = "multiple matching keys found in the JSON Web Key Set", options) {
    super(message4, options);
    this.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
  }
};
JWKSMultipleMatchingKeys.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
var JWKSTimeout = class extends JOSEError {
  constructor(message4 = "request timed out", options) {
    super(message4, options);
    this.code = "ERR_JWKS_TIMEOUT";
  }
};
JWKSTimeout.code = "ERR_JWKS_TIMEOUT";
var JWSSignatureVerificationFailed = class extends JOSEError {
  constructor(message4 = "signature verification failed", options) {
    super(message4, options);
    this.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
  }
};
JWSSignatureVerificationFailed.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/lib/crypto_key.js
function unusable(name7, prop = "algorithm.name") {
  return new TypeError(`CryptoKey does not support this operation, its ${prop} must be ${name7}`);
}
function isAlgorithm(algorithm3, name7) {
  return algorithm3.name === name7;
}
function getHashLength(hash2) {
  return parseInt(hash2.name.slice(4), 10);
}
function getNamedCurve(alg) {
  switch (alg) {
    case "ES256":
      return "P-256";
    case "ES384":
      return "P-384";
    case "ES512":
      return "P-521";
    default:
      throw new Error("unreachable");
  }
}
function checkUsage(key3, usages) {
  if (usages.length && !usages.some((expected) => key3.usages.includes(expected))) {
    let msg = "CryptoKey does not support this operation, its usages must include ";
    if (usages.length > 2) {
      const last3 = usages.pop();
      msg += `one of ${usages.join(", ")}, or ${last3}.`;
    } else if (usages.length === 2) {
      msg += `one of ${usages[0]} or ${usages[1]}.`;
    } else {
      msg += `${usages[0]}.`;
    }
    throw new TypeError(msg);
  }
}
function checkSigCryptoKey(key3, alg, ...usages) {
  switch (alg) {
    case "HS256":
    case "HS384":
    case "HS512": {
      if (!isAlgorithm(key3.algorithm, "HMAC"))
        throw unusable("HMAC");
      const expected = parseInt(alg.slice(2), 10);
      const actual2 = getHashLength(key3.algorithm.hash);
      if (actual2 !== expected)
        throw unusable(`SHA-${expected}`, "algorithm.hash");
      break;
    }
    case "RS256":
    case "RS384":
    case "RS512": {
      if (!isAlgorithm(key3.algorithm, "RSASSA-PKCS1-v1_5"))
        throw unusable("RSASSA-PKCS1-v1_5");
      const expected = parseInt(alg.slice(2), 10);
      const actual2 = getHashLength(key3.algorithm.hash);
      if (actual2 !== expected)
        throw unusable(`SHA-${expected}`, "algorithm.hash");
      break;
    }
    case "PS256":
    case "PS384":
    case "PS512": {
      if (!isAlgorithm(key3.algorithm, "RSA-PSS"))
        throw unusable("RSA-PSS");
      const expected = parseInt(alg.slice(2), 10);
      const actual2 = getHashLength(key3.algorithm.hash);
      if (actual2 !== expected)
        throw unusable(`SHA-${expected}`, "algorithm.hash");
      break;
    }
    case "EdDSA": {
      if (key3.algorithm.name !== "Ed25519" && key3.algorithm.name !== "Ed448") {
        throw unusable("Ed25519 or Ed448");
      }
      break;
    }
    case "ES256":
    case "ES384":
    case "ES512": {
      if (!isAlgorithm(key3.algorithm, "ECDSA"))
        throw unusable("ECDSA");
      const expected = getNamedCurve(alg);
      const actual2 = key3.algorithm.namedCurve;
      if (actual2 !== expected)
        throw unusable(expected, "algorithm.namedCurve");
      break;
    }
    default:
      throw new TypeError("CryptoKey does not support this operation");
  }
  checkUsage(key3, usages);
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/lib/invalid_key_input.js
function message(msg, actual2, ...types2) {
  types2 = types2.filter(Boolean);
  if (types2.length > 2) {
    const last3 = types2.pop();
    msg += `one of type ${types2.join(", ")}, or ${last3}.`;
  } else if (types2.length === 2) {
    msg += `one of type ${types2[0]} or ${types2[1]}.`;
  } else {
    msg += `of type ${types2[0]}.`;
  }
  if (actual2 == null) {
    msg += ` Received ${actual2}`;
  } else if (typeof actual2 === "function" && actual2.name) {
    msg += ` Received function ${actual2.name}`;
  } else if (typeof actual2 === "object" && actual2 != null) {
    if (actual2.constructor?.name) {
      msg += ` Received an instance of ${actual2.constructor.name}`;
    }
  }
  return msg;
}
var invalid_key_input_default = (actual2, ...types2) => {
  return message("Key must be ", actual2, ...types2);
};
function withAlg(alg, actual2, ...types2) {
  return message(`Key for the ${alg} algorithm must be `, actual2, ...types2);
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/runtime/is_key_like.js
var is_key_like_default = (key3) => {
  if (isCryptoKey(key3)) {
    return true;
  }
  return key3?.[Symbol.toStringTag] === "KeyObject";
};
var types = ["CryptoKey"];

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/lib/is_disjoint.js
var isDisjoint = (...headers) => {
  const sources = headers.filter(Boolean);
  if (sources.length === 0 || sources.length === 1) {
    return true;
  }
  let acc;
  for (const header2 of sources) {
    const parameters = Object.keys(header2);
    if (!acc || acc.size === 0) {
      acc = new Set(parameters);
      continue;
    }
    for (const parameter2 of parameters) {
      if (acc.has(parameter2)) {
        return false;
      }
      acc.add(parameter2);
    }
  }
  return true;
};
var is_disjoint_default = isDisjoint;

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/lib/is_object.js
function isObjectLike(value6) {
  return typeof value6 === "object" && value6 !== null;
}
function isObject(input2) {
  if (!isObjectLike(input2) || Object.prototype.toString.call(input2) !== "[object Object]") {
    return false;
  }
  if (Object.getPrototypeOf(input2) === null) {
    return true;
  }
  let proto = input2;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(input2) === proto;
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/runtime/check_key_length.js
var check_key_length_default = (alg, key3) => {
  if (alg.startsWith("RS") || alg.startsWith("PS")) {
    const { modulusLength } = key3.algorithm;
    if (typeof modulusLength !== "number" || modulusLength < 2048) {
      throw new TypeError(`${alg} requires key modulusLength to be 2048 bits or larger`);
    }
  }
};

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/lib/is_jwk.js
function isJWK(key3) {
  return isObject(key3) && typeof key3.kty === "string";
}
function isPrivateJWK(key3) {
  return key3.kty !== "oct" && typeof key3.d === "string";
}
function isPublicJWK(key3) {
  return key3.kty !== "oct" && typeof key3.d === "undefined";
}
function isSecretJWK(key3) {
  return isJWK(key3) && key3.kty === "oct" && typeof key3.k === "string";
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/runtime/jwk_to_key.js
function subtleMapping(jwk) {
  let algorithm3;
  let keyUsages;
  switch (jwk.kty) {
    case "RSA": {
      switch (jwk.alg) {
        case "PS256":
        case "PS384":
        case "PS512":
          algorithm3 = { name: "RSA-PSS", hash: `SHA-${jwk.alg.slice(-3)}` };
          keyUsages = jwk.d ? ["sign"] : ["verify"];
          break;
        case "RS256":
        case "RS384":
        case "RS512":
          algorithm3 = { name: "RSASSA-PKCS1-v1_5", hash: `SHA-${jwk.alg.slice(-3)}` };
          keyUsages = jwk.d ? ["sign"] : ["verify"];
          break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
          algorithm3 = {
            name: "RSA-OAEP",
            hash: `SHA-${parseInt(jwk.alg.slice(-3), 10) || 1}`
          };
          keyUsages = jwk.d ? ["decrypt", "unwrapKey"] : ["encrypt", "wrapKey"];
          break;
        default:
          throw new JOSENotSupported('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "EC": {
      switch (jwk.alg) {
        case "ES256":
          algorithm3 = { name: "ECDSA", namedCurve: "P-256" };
          keyUsages = jwk.d ? ["sign"] : ["verify"];
          break;
        case "ES384":
          algorithm3 = { name: "ECDSA", namedCurve: "P-384" };
          keyUsages = jwk.d ? ["sign"] : ["verify"];
          break;
        case "ES512":
          algorithm3 = { name: "ECDSA", namedCurve: "P-521" };
          keyUsages = jwk.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          algorithm3 = { name: "ECDH", namedCurve: jwk.crv };
          keyUsages = jwk.d ? ["deriveBits"] : [];
          break;
        default:
          throw new JOSENotSupported('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "OKP": {
      switch (jwk.alg) {
        case "EdDSA":
          algorithm3 = { name: jwk.crv };
          keyUsages = jwk.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          algorithm3 = { name: jwk.crv };
          keyUsages = jwk.d ? ["deriveBits"] : [];
          break;
        default:
          throw new JOSENotSupported('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    default:
      throw new JOSENotSupported('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
  }
  return { algorithm: algorithm3, keyUsages };
}
var parse = async (jwk) => {
  if (!jwk.alg) {
    throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
  }
  const { algorithm: algorithm3, keyUsages } = subtleMapping(jwk);
  const rest3 = [
    algorithm3,
    jwk.ext ?? false,
    jwk.key_ops ?? keyUsages
  ];
  const keyData = { ...jwk };
  delete keyData.alg;
  delete keyData.use;
  return webcrypto_default.subtle.importKey("jwk", keyData, ...rest3);
};
var jwk_to_key_default = parse;

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/runtime/normalize_key.js
var exportKeyValue = (k) => decode(k);
var privCache;
var pubCache;
var isKeyObject = (key3) => {
  return key3?.[Symbol.toStringTag] === "KeyObject";
};
var importAndCache = async (cache, key3, jwk, alg, freeze = false) => {
  let cached = cache.get(key3);
  if (cached?.[alg]) {
    return cached[alg];
  }
  const cryptoKey = await jwk_to_key_default({ ...jwk, alg });
  if (freeze)
    Object.freeze(key3);
  if (!cached) {
    cache.set(key3, { [alg]: cryptoKey });
  } else {
    cached[alg] = cryptoKey;
  }
  return cryptoKey;
};
var normalizePublicKey = (key3, alg) => {
  if (isKeyObject(key3)) {
    let jwk = key3.export({ format: "jwk" });
    delete jwk.d;
    delete jwk.dp;
    delete jwk.dq;
    delete jwk.p;
    delete jwk.q;
    delete jwk.qi;
    if (jwk.k) {
      return exportKeyValue(jwk.k);
    }
    pubCache || (pubCache = /* @__PURE__ */ new WeakMap());
    return importAndCache(pubCache, key3, jwk, alg);
  }
  if (isJWK(key3)) {
    if (key3.k)
      return decode(key3.k);
    pubCache || (pubCache = /* @__PURE__ */ new WeakMap());
    const cryptoKey = importAndCache(pubCache, key3, key3, alg, true);
    return cryptoKey;
  }
  return key3;
};
var normalizePrivateKey = (key3, alg) => {
  if (isKeyObject(key3)) {
    let jwk = key3.export({ format: "jwk" });
    if (jwk.k) {
      return exportKeyValue(jwk.k);
    }
    privCache || (privCache = /* @__PURE__ */ new WeakMap());
    return importAndCache(privCache, key3, jwk, alg);
  }
  if (isJWK(key3)) {
    if (key3.k)
      return decode(key3.k);
    privCache || (privCache = /* @__PURE__ */ new WeakMap());
    const cryptoKey = importAndCache(privCache, key3, key3, alg, true);
    return cryptoKey;
  }
  return key3;
};
var normalize_key_default = { normalizePublicKey, normalizePrivateKey };

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/key/import.js
async function importJWK(jwk, alg) {
  if (!isObject(jwk)) {
    throw new TypeError("JWK must be an object");
  }
  alg || (alg = jwk.alg);
  switch (jwk.kty) {
    case "oct":
      if (typeof jwk.k !== "string" || !jwk.k) {
        throw new TypeError('missing "k" (Key Value) Parameter value');
      }
      return decode(jwk.k);
    case "RSA":
      if (jwk.oth !== void 0) {
        throw new JOSENotSupported('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
      }
    case "EC":
    case "OKP":
      return jwk_to_key_default({ ...jwk, alg });
    default:
      throw new JOSENotSupported('Unsupported "kty" (Key Type) Parameter value');
  }
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/lib/check_key_type.js
var tag = (key3) => key3?.[Symbol.toStringTag];
var jwkMatchesOp = (alg, key3, usage2) => {
  if (key3.use !== void 0 && key3.use !== "sig") {
    throw new TypeError("Invalid key for this operation, when present its use must be sig");
  }
  if (key3.key_ops !== void 0 && key3.key_ops.includes?.(usage2) !== true) {
    throw new TypeError(`Invalid key for this operation, when present its key_ops must include ${usage2}`);
  }
  if (key3.alg !== void 0 && key3.alg !== alg) {
    throw new TypeError(`Invalid key for this operation, when present its alg must be ${alg}`);
  }
  return true;
};
var symmetricTypeCheck = (alg, key3, usage2, allowJwk) => {
  if (key3 instanceof Uint8Array)
    return;
  if (allowJwk && isJWK(key3)) {
    if (isSecretJWK(key3) && jwkMatchesOp(alg, key3, usage2))
      return;
    throw new TypeError(`JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present`);
  }
  if (!is_key_like_default(key3)) {
    throw new TypeError(withAlg(alg, key3, ...types, "Uint8Array", allowJwk ? "JSON Web Key" : null));
  }
  if (key3.type !== "secret") {
    throw new TypeError(`${tag(key3)} instances for symmetric algorithms must be of type "secret"`);
  }
};
var asymmetricTypeCheck = (alg, key3, usage2, allowJwk) => {
  if (allowJwk && isJWK(key3)) {
    switch (usage2) {
      case "sign":
        if (isPrivateJWK(key3) && jwkMatchesOp(alg, key3, usage2))
          return;
        throw new TypeError(`JSON Web Key for this operation be a private JWK`);
      case "verify":
        if (isPublicJWK(key3) && jwkMatchesOp(alg, key3, usage2))
          return;
        throw new TypeError(`JSON Web Key for this operation be a public JWK`);
    }
  }
  if (!is_key_like_default(key3)) {
    throw new TypeError(withAlg(alg, key3, ...types, allowJwk ? "JSON Web Key" : null));
  }
  if (key3.type === "secret") {
    throw new TypeError(`${tag(key3)} instances for asymmetric algorithms must not be of type "secret"`);
  }
  if (usage2 === "sign" && key3.type === "public") {
    throw new TypeError(`${tag(key3)} instances for asymmetric algorithm signing must be of type "private"`);
  }
  if (usage2 === "decrypt" && key3.type === "public") {
    throw new TypeError(`${tag(key3)} instances for asymmetric algorithm decryption must be of type "private"`);
  }
  if (key3.algorithm && usage2 === "verify" && key3.type === "private") {
    throw new TypeError(`${tag(key3)} instances for asymmetric algorithm verifying must be of type "public"`);
  }
  if (key3.algorithm && usage2 === "encrypt" && key3.type === "private") {
    throw new TypeError(`${tag(key3)} instances for asymmetric algorithm encryption must be of type "public"`);
  }
};
function checkKeyType(allowJwk, alg, key3, usage2) {
  const symmetric = alg.startsWith("HS") || alg === "dir" || alg.startsWith("PBES2") || /^A\d{3}(?:GCM)?KW$/.test(alg);
  if (symmetric) {
    symmetricTypeCheck(alg, key3, usage2, allowJwk);
  } else {
    asymmetricTypeCheck(alg, key3, usage2, allowJwk);
  }
}
var check_key_type_default = checkKeyType.bind(void 0, false);
var checkKeyTypeWithJwk = checkKeyType.bind(void 0, true);

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/lib/validate_crit.js
function validateCrit(Err, recognizedDefault, recognizedOption, protectedHeader, joseHeader) {
  if (joseHeader.crit !== void 0 && protectedHeader?.crit === void 0) {
    throw new Err('"crit" (Critical) Header Parameter MUST be integrity protected');
  }
  if (!protectedHeader || protectedHeader.crit === void 0) {
    return /* @__PURE__ */ new Set();
  }
  if (!Array.isArray(protectedHeader.crit) || protectedHeader.crit.length === 0 || protectedHeader.crit.some((input2) => typeof input2 !== "string" || input2.length === 0)) {
    throw new Err('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
  }
  let recognized;
  if (recognizedOption !== void 0) {
    recognized = new Map([...Object.entries(recognizedOption), ...recognizedDefault.entries()]);
  } else {
    recognized = recognizedDefault;
  }
  for (const parameter2 of protectedHeader.crit) {
    if (!recognized.has(parameter2)) {
      throw new JOSENotSupported(`Extension Header Parameter "${parameter2}" is not recognized`);
    }
    if (joseHeader[parameter2] === void 0) {
      throw new Err(`Extension Header Parameter "${parameter2}" is missing`);
    }
    if (recognized.get(parameter2) && protectedHeader[parameter2] === void 0) {
      throw new Err(`Extension Header Parameter "${parameter2}" MUST be integrity protected`);
    }
  }
  return new Set(protectedHeader.crit);
}
var validate_crit_default = validateCrit;

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/lib/validate_algorithms.js
var validateAlgorithms = (option5, algorithms) => {
  if (algorithms !== void 0 && (!Array.isArray(algorithms) || algorithms.some((s) => typeof s !== "string"))) {
    throw new TypeError(`"${option5}" option must be an array of strings`);
  }
  if (!algorithms) {
    return void 0;
  }
  return new Set(algorithms);
};
var validate_algorithms_default = validateAlgorithms;

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/runtime/key_to_jwk.js
var keyToJWK = async (key3) => {
  if (key3 instanceof Uint8Array) {
    return {
      kty: "oct",
      k: encode(key3)
    };
  }
  if (!isCryptoKey(key3)) {
    throw new TypeError(invalid_key_input_default(key3, ...types, "Uint8Array"));
  }
  if (!key3.extractable) {
    throw new TypeError("non-extractable CryptoKey cannot be exported as a JWK");
  }
  const { ext, key_ops, alg, use: use2, ...jwk } = await webcrypto_default.subtle.exportKey("jwk", key3);
  return jwk;
};
var key_to_jwk_default = keyToJWK;

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/key/export.js
async function exportJWK(key3) {
  return key_to_jwk_default(key3);
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/runtime/subtle_dsa.js
function subtleDsa(alg, algorithm3) {
  const hash2 = `SHA-${alg.slice(-3)}`;
  switch (alg) {
    case "HS256":
    case "HS384":
    case "HS512":
      return { hash: hash2, name: "HMAC" };
    case "PS256":
    case "PS384":
    case "PS512":
      return { hash: hash2, name: "RSA-PSS", saltLength: alg.slice(-3) >> 3 };
    case "RS256":
    case "RS384":
    case "RS512":
      return { hash: hash2, name: "RSASSA-PKCS1-v1_5" };
    case "ES256":
    case "ES384":
    case "ES512":
      return { hash: hash2, name: "ECDSA", namedCurve: algorithm3.namedCurve };
    case "EdDSA":
      return { name: algorithm3.name };
    default:
      throw new JOSENotSupported(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
  }
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/runtime/get_sign_verify_key.js
async function getCryptoKey(alg, key3, usage2) {
  if (usage2 === "sign") {
    key3 = await normalize_key_default.normalizePrivateKey(key3, alg);
  }
  if (usage2 === "verify") {
    key3 = await normalize_key_default.normalizePublicKey(key3, alg);
  }
  if (isCryptoKey(key3)) {
    checkSigCryptoKey(key3, alg, usage2);
    return key3;
  }
  if (key3 instanceof Uint8Array) {
    if (!alg.startsWith("HS")) {
      throw new TypeError(invalid_key_input_default(key3, ...types));
    }
    return webcrypto_default.subtle.importKey("raw", key3, { hash: `SHA-${alg.slice(-3)}`, name: "HMAC" }, false, [usage2]);
  }
  throw new TypeError(invalid_key_input_default(key3, ...types, "Uint8Array", "JSON Web Key"));
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/runtime/verify.js
var verify = async (alg, key3, signature2, data2) => {
  const cryptoKey = await getCryptoKey(alg, key3, "verify");
  check_key_length_default(alg, cryptoKey);
  const algorithm3 = subtleDsa(alg, cryptoKey.algorithm);
  try {
    return await webcrypto_default.subtle.verify(algorithm3, cryptoKey, signature2, data2);
  } catch {
    return false;
  }
};
var verify_default = verify;

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/jws/flattened/verify.js
async function flattenedVerify(jws2, key3, options) {
  if (!isObject(jws2)) {
    throw new JWSInvalid("Flattened JWS must be an object");
  }
  if (jws2.protected === void 0 && jws2.header === void 0) {
    throw new JWSInvalid('Flattened JWS must have either of the "protected" or "header" members');
  }
  if (jws2.protected !== void 0 && typeof jws2.protected !== "string") {
    throw new JWSInvalid("JWS Protected Header incorrect type");
  }
  if (jws2.payload === void 0) {
    throw new JWSInvalid("JWS Payload missing");
  }
  if (typeof jws2.signature !== "string") {
    throw new JWSInvalid("JWS Signature missing or incorrect type");
  }
  if (jws2.header !== void 0 && !isObject(jws2.header)) {
    throw new JWSInvalid("JWS Unprotected Header incorrect type");
  }
  let parsedProt = {};
  if (jws2.protected) {
    try {
      const protectedHeader = decode(jws2.protected);
      parsedProt = JSON.parse(decoder.decode(protectedHeader));
    } catch {
      throw new JWSInvalid("JWS Protected Header is invalid");
    }
  }
  if (!is_disjoint_default(parsedProt, jws2.header)) {
    throw new JWSInvalid("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
  }
  const joseHeader = {
    ...parsedProt,
    ...jws2.header
  };
  const extensions = validate_crit_default(JWSInvalid, /* @__PURE__ */ new Map([["b64", true]]), options?.crit, parsedProt, joseHeader);
  let b64 = true;
  if (extensions.has("b64")) {
    b64 = parsedProt.b64;
    if (typeof b64 !== "boolean") {
      throw new JWSInvalid('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    }
  }
  const { alg } = joseHeader;
  if (typeof alg !== "string" || !alg) {
    throw new JWSInvalid('JWS "alg" (Algorithm) Header Parameter missing or invalid');
  }
  const algorithms = options && validate_algorithms_default("algorithms", options.algorithms);
  if (algorithms && !algorithms.has(alg)) {
    throw new JOSEAlgNotAllowed('"alg" (Algorithm) Header Parameter value not allowed');
  }
  if (b64) {
    if (typeof jws2.payload !== "string") {
      throw new JWSInvalid("JWS Payload must be a string");
    }
  } else if (typeof jws2.payload !== "string" && !(jws2.payload instanceof Uint8Array)) {
    throw new JWSInvalid("JWS Payload must be a string or an Uint8Array instance");
  }
  let resolvedKey = false;
  if (typeof key3 === "function") {
    key3 = await key3(parsedProt, jws2);
    resolvedKey = true;
    checkKeyTypeWithJwk(alg, key3, "verify");
    if (isJWK(key3)) {
      key3 = await importJWK(key3, alg);
    }
  } else {
    checkKeyTypeWithJwk(alg, key3, "verify");
  }
  const data2 = concat(encoder.encode(jws2.protected ?? ""), encoder.encode("."), typeof jws2.payload === "string" ? encoder.encode(jws2.payload) : jws2.payload);
  let signature2;
  try {
    signature2 = decode(jws2.signature);
  } catch {
    throw new JWSInvalid("Failed to base64url decode the signature");
  }
  const verified2 = await verify_default(alg, key3, signature2, data2);
  if (!verified2) {
    throw new JWSSignatureVerificationFailed();
  }
  let payload4;
  if (b64) {
    try {
      payload4 = decode(jws2.payload);
    } catch {
      throw new JWSInvalid("Failed to base64url decode the payload");
    }
  } else if (typeof jws2.payload === "string") {
    payload4 = encoder.encode(jws2.payload);
  } else {
    payload4 = jws2.payload;
  }
  const result5 = { payload: payload4 };
  if (jws2.protected !== void 0) {
    result5.protectedHeader = parsedProt;
  }
  if (jws2.header !== void 0) {
    result5.unprotectedHeader = jws2.header;
  }
  if (resolvedKey) {
    return { ...result5, key: key3 };
  }
  return result5;
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/jws/compact/verify.js
async function compactVerify(jws2, key3, options) {
  if (jws2 instanceof Uint8Array) {
    jws2 = decoder.decode(jws2);
  }
  if (typeof jws2 !== "string") {
    throw new JWSInvalid("Compact JWS must be a string or Uint8Array");
  }
  const { 0: protectedHeader, 1: payload4, 2: signature2, length: length2 } = jws2.split(".");
  if (length2 !== 3) {
    throw new JWSInvalid("Invalid Compact JWS");
  }
  const verified2 = await flattenedVerify({ payload: payload4, protected: protectedHeader, signature: signature2 }, key3, options);
  const result5 = { payload: verified2.payload, protectedHeader: verified2.protectedHeader };
  if (typeof key3 === "function") {
    return { ...result5, key: verified2.key };
  }
  return result5;
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/lib/epoch.js
var epoch_default = (date5) => Math.floor(date5.getTime() / 1e3);

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/lib/secs.js
var minute = 60;
var hour = minute * 60;
var day = hour * 24;
var week = day * 7;
var year = day * 365.25;
var REGEX = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i;
var secs_default = (str) => {
  const matched = REGEX.exec(str);
  if (!matched || matched[4] && matched[1]) {
    throw new TypeError("Invalid time period format");
  }
  const value6 = parseFloat(matched[2]);
  const unit2 = matched[3].toLowerCase();
  let numericDate;
  switch (unit2) {
    case "sec":
    case "secs":
    case "second":
    case "seconds":
    case "s":
      numericDate = Math.round(value6);
      break;
    case "minute":
    case "minutes":
    case "min":
    case "mins":
    case "m":
      numericDate = Math.round(value6 * minute);
      break;
    case "hour":
    case "hours":
    case "hr":
    case "hrs":
    case "h":
      numericDate = Math.round(value6 * hour);
      break;
    case "day":
    case "days":
    case "d":
      numericDate = Math.round(value6 * day);
      break;
    case "week":
    case "weeks":
    case "w":
      numericDate = Math.round(value6 * week);
      break;
    default:
      numericDate = Math.round(value6 * year);
      break;
  }
  if (matched[1] === "-" || matched[4] === "ago") {
    return -numericDate;
  }
  return numericDate;
};

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/lib/jwt_claims_set.js
var normalizeTyp = (value6) => value6.toLowerCase().replace(/^application\//, "");
var checkAudiencePresence = (audPayload, audOption) => {
  if (typeof audPayload === "string") {
    return audOption.includes(audPayload);
  }
  if (Array.isArray(audPayload)) {
    return audOption.some(Set.prototype.has.bind(new Set(audPayload)));
  }
  return false;
};
var jwt_claims_set_default = (protectedHeader, encodedPayload, options = {}) => {
  let payload4;
  try {
    payload4 = JSON.parse(decoder.decode(encodedPayload));
  } catch {
  }
  if (!isObject(payload4)) {
    throw new JWTInvalid("JWT Claims Set must be a top-level JSON object");
  }
  const { typ } = options;
  if (typ && (typeof protectedHeader.typ !== "string" || normalizeTyp(protectedHeader.typ) !== normalizeTyp(typ))) {
    throw new JWTClaimValidationFailed('unexpected "typ" JWT header value', payload4, "typ", "check_failed");
  }
  const { requiredClaims = [], issuer: issuer2, subject: subject5, audience: audience5, maxTokenAge } = options;
  const presenceCheck = [...requiredClaims];
  if (maxTokenAge !== void 0)
    presenceCheck.push("iat");
  if (audience5 !== void 0)
    presenceCheck.push("aud");
  if (subject5 !== void 0)
    presenceCheck.push("sub");
  if (issuer2 !== void 0)
    presenceCheck.push("iss");
  for (const claim2 of new Set(presenceCheck.reverse())) {
    if (!(claim2 in payload4)) {
      throw new JWTClaimValidationFailed(`missing required "${claim2}" claim`, payload4, claim2, "missing");
    }
  }
  if (issuer2 && !(Array.isArray(issuer2) ? issuer2 : [issuer2]).includes(payload4.iss)) {
    throw new JWTClaimValidationFailed('unexpected "iss" claim value', payload4, "iss", "check_failed");
  }
  if (subject5 && payload4.sub !== subject5) {
    throw new JWTClaimValidationFailed('unexpected "sub" claim value', payload4, "sub", "check_failed");
  }
  if (audience5 && !checkAudiencePresence(payload4.aud, typeof audience5 === "string" ? [audience5] : audience5)) {
    throw new JWTClaimValidationFailed('unexpected "aud" claim value', payload4, "aud", "check_failed");
  }
  let tolerance;
  switch (typeof options.clockTolerance) {
    case "string":
      tolerance = secs_default(options.clockTolerance);
      break;
    case "number":
      tolerance = options.clockTolerance;
      break;
    case "undefined":
      tolerance = 0;
      break;
    default:
      throw new TypeError("Invalid clockTolerance option type");
  }
  const { currentDate } = options;
  const now = epoch_default(currentDate || /* @__PURE__ */ new Date());
  if ((payload4.iat !== void 0 || maxTokenAge) && typeof payload4.iat !== "number") {
    throw new JWTClaimValidationFailed('"iat" claim must be a number', payload4, "iat", "invalid");
  }
  if (payload4.nbf !== void 0) {
    if (typeof payload4.nbf !== "number") {
      throw new JWTClaimValidationFailed('"nbf" claim must be a number', payload4, "nbf", "invalid");
    }
    if (payload4.nbf > now + tolerance) {
      throw new JWTClaimValidationFailed('"nbf" claim timestamp check failed', payload4, "nbf", "check_failed");
    }
  }
  if (payload4.exp !== void 0) {
    if (typeof payload4.exp !== "number") {
      throw new JWTClaimValidationFailed('"exp" claim must be a number', payload4, "exp", "invalid");
    }
    if (payload4.exp <= now - tolerance) {
      throw new JWTExpired('"exp" claim timestamp check failed', payload4, "exp", "check_failed");
    }
  }
  if (maxTokenAge) {
    const age2 = now - payload4.iat;
    const max2 = typeof maxTokenAge === "number" ? maxTokenAge : secs_default(maxTokenAge);
    if (age2 - tolerance > max2) {
      throw new JWTExpired('"iat" claim timestamp check failed (too far in the past)', payload4, "iat", "check_failed");
    }
    if (age2 < 0 - tolerance) {
      throw new JWTClaimValidationFailed('"iat" claim timestamp check failed (it should be in the past)', payload4, "iat", "check_failed");
    }
  }
  return payload4;
};

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/jwt/verify.js
async function jwtVerify(jwt, key3, options) {
  const verified2 = await compactVerify(jwt, key3, options);
  if (verified2.protectedHeader.crit?.includes("b64") && verified2.protectedHeader.b64 === false) {
    throw new JWTInvalid("JWTs MUST NOT use unencoded payload");
  }
  const payload4 = jwt_claims_set_default(verified2.protectedHeader, verified2.payload, options);
  const result5 = { payload: payload4, protectedHeader: verified2.protectedHeader };
  if (typeof key3 === "function") {
    return { ...result5, key: verified2.key };
  }
  return result5;
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/runtime/sign.js
var sign = async (alg, key3, data2) => {
  const cryptoKey = await getCryptoKey(alg, key3, "sign");
  check_key_length_default(alg, cryptoKey);
  const signature2 = await webcrypto_default.subtle.sign(subtleDsa(alg, cryptoKey.algorithm), cryptoKey, data2);
  return new Uint8Array(signature2);
};
var sign_default = sign;

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/jws/flattened/sign.js
var FlattenedSign = class {
  constructor(payload4) {
    if (!(payload4 instanceof Uint8Array)) {
      throw new TypeError("payload must be an instance of Uint8Array");
    }
    this._payload = payload4;
  }
  setProtectedHeader(protectedHeader) {
    if (this._protectedHeader) {
      throw new TypeError("setProtectedHeader can only be called once");
    }
    this._protectedHeader = protectedHeader;
    return this;
  }
  setUnprotectedHeader(unprotectedHeader) {
    if (this._unprotectedHeader) {
      throw new TypeError("setUnprotectedHeader can only be called once");
    }
    this._unprotectedHeader = unprotectedHeader;
    return this;
  }
  async sign(key3, options) {
    if (!this._protectedHeader && !this._unprotectedHeader) {
      throw new JWSInvalid("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
    }
    if (!is_disjoint_default(this._protectedHeader, this._unprotectedHeader)) {
      throw new JWSInvalid("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    }
    const joseHeader = {
      ...this._protectedHeader,
      ...this._unprotectedHeader
    };
    const extensions = validate_crit_default(JWSInvalid, /* @__PURE__ */ new Map([["b64", true]]), options?.crit, this._protectedHeader, joseHeader);
    let b64 = true;
    if (extensions.has("b64")) {
      b64 = this._protectedHeader.b64;
      if (typeof b64 !== "boolean") {
        throw new JWSInvalid('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
      }
    }
    const { alg } = joseHeader;
    if (typeof alg !== "string" || !alg) {
      throw new JWSInvalid('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    }
    checkKeyTypeWithJwk(alg, key3, "sign");
    let payload4 = this._payload;
    if (b64) {
      payload4 = encoder.encode(encode(payload4));
    }
    let protectedHeader;
    if (this._protectedHeader) {
      protectedHeader = encoder.encode(encode(JSON.stringify(this._protectedHeader)));
    } else {
      protectedHeader = encoder.encode("");
    }
    const data2 = concat(protectedHeader, encoder.encode("."), payload4);
    const signature2 = await sign_default(alg, key3, data2);
    const jws2 = {
      signature: encode(signature2),
      payload: ""
    };
    if (b64) {
      jws2.payload = decoder.decode(payload4);
    }
    if (this._unprotectedHeader) {
      jws2.header = this._unprotectedHeader;
    }
    if (this._protectedHeader) {
      jws2.protected = decoder.decode(protectedHeader);
    }
    return jws2;
  }
};

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/jws/compact/sign.js
var CompactSign = class {
  constructor(payload4) {
    this._flattened = new FlattenedSign(payload4);
  }
  setProtectedHeader(protectedHeader) {
    this._flattened.setProtectedHeader(protectedHeader);
    return this;
  }
  async sign(key3, options) {
    const jws2 = await this._flattened.sign(key3, options);
    if (jws2.payload === void 0) {
      throw new TypeError("use the flattened module for creating JWS with b64: false");
    }
    return `${jws2.protected}.${jws2.payload}.${jws2.signature}`;
  }
};

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/jwt/produce.js
function validateInput(label4, input2) {
  if (!Number.isFinite(input2)) {
    throw new TypeError(`Invalid ${label4} input`);
  }
  return input2;
}
var ProduceJWT = class {
  constructor(payload4 = {}) {
    if (!isObject(payload4)) {
      throw new TypeError("JWT Claims Set MUST be an object");
    }
    this._payload = payload4;
  }
  setIssuer(issuer2) {
    this._payload = { ...this._payload, iss: issuer2 };
    return this;
  }
  setSubject(subject5) {
    this._payload = { ...this._payload, sub: subject5 };
    return this;
  }
  setAudience(audience5) {
    this._payload = { ...this._payload, aud: audience5 };
    return this;
  }
  setJti(jwtId) {
    this._payload = { ...this._payload, jti: jwtId };
    return this;
  }
  setNotBefore(input2) {
    if (typeof input2 === "number") {
      this._payload = { ...this._payload, nbf: validateInput("setNotBefore", input2) };
    } else if (input2 instanceof Date) {
      this._payload = { ...this._payload, nbf: validateInput("setNotBefore", epoch_default(input2)) };
    } else {
      this._payload = { ...this._payload, nbf: epoch_default(/* @__PURE__ */ new Date()) + secs_default(input2) };
    }
    return this;
  }
  setExpirationTime(input2) {
    if (typeof input2 === "number") {
      this._payload = { ...this._payload, exp: validateInput("setExpirationTime", input2) };
    } else if (input2 instanceof Date) {
      this._payload = { ...this._payload, exp: validateInput("setExpirationTime", epoch_default(input2)) };
    } else {
      this._payload = { ...this._payload, exp: epoch_default(/* @__PURE__ */ new Date()) + secs_default(input2) };
    }
    return this;
  }
  setIssuedAt(input2) {
    if (typeof input2 === "undefined") {
      this._payload = { ...this._payload, iat: epoch_default(/* @__PURE__ */ new Date()) };
    } else if (input2 instanceof Date) {
      this._payload = { ...this._payload, iat: validateInput("setIssuedAt", epoch_default(input2)) };
    } else if (typeof input2 === "string") {
      this._payload = {
        ...this._payload,
        iat: validateInput("setIssuedAt", epoch_default(/* @__PURE__ */ new Date()) + secs_default(input2))
      };
    } else {
      this._payload = { ...this._payload, iat: validateInput("setIssuedAt", input2) };
    }
    return this;
  }
};

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/jwt/sign.js
var SignJWT = class extends ProduceJWT {
  setProtectedHeader(protectedHeader) {
    this._protectedHeader = protectedHeader;
    return this;
  }
  async sign(key3, options) {
    const sig = new CompactSign(encoder.encode(JSON.stringify(this._payload)));
    sig.setProtectedHeader(this._protectedHeader);
    if (Array.isArray(this._protectedHeader?.crit) && this._protectedHeader.crit.includes("b64") && this._protectedHeader.b64 === false) {
      throw new JWTInvalid("JWTs MUST NOT use unencoded payload");
    }
    return sig.sign(key3, options);
  }
};

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/jwks/local.js
function getKtyFromAlg(alg) {
  switch (typeof alg === "string" && alg.slice(0, 2)) {
    case "RS":
    case "PS":
      return "RSA";
    case "ES":
      return "EC";
    case "Ed":
      return "OKP";
    default:
      throw new JOSENotSupported('Unsupported "alg" value for a JSON Web Key Set');
  }
}
function isJWKSLike(jwks) {
  return jwks && typeof jwks === "object" && Array.isArray(jwks.keys) && jwks.keys.every(isJWKLike);
}
function isJWKLike(key3) {
  return isObject(key3);
}
function clone(obj) {
  if (typeof structuredClone === "function") {
    return structuredClone(obj);
  }
  return JSON.parse(JSON.stringify(obj));
}
var LocalJWKSet = class {
  constructor(jwks) {
    this._cached = /* @__PURE__ */ new WeakMap();
    if (!isJWKSLike(jwks)) {
      throw new JWKSInvalid("JSON Web Key Set malformed");
    }
    this._jwks = clone(jwks);
  }
  async getKey(protectedHeader, token) {
    const { alg, kid } = { ...protectedHeader, ...token?.header };
    const kty = getKtyFromAlg(alg);
    const candidates = this._jwks.keys.filter((jwk2) => {
      let candidate4 = kty === jwk2.kty;
      if (candidate4 && typeof kid === "string") {
        candidate4 = kid === jwk2.kid;
      }
      if (candidate4 && typeof jwk2.alg === "string") {
        candidate4 = alg === jwk2.alg;
      }
      if (candidate4 && typeof jwk2.use === "string") {
        candidate4 = jwk2.use === "sig";
      }
      if (candidate4 && Array.isArray(jwk2.key_ops)) {
        candidate4 = jwk2.key_ops.includes("verify");
      }
      if (candidate4 && alg === "EdDSA") {
        candidate4 = jwk2.crv === "Ed25519" || jwk2.crv === "Ed448";
      }
      if (candidate4) {
        switch (alg) {
          case "ES256":
            candidate4 = jwk2.crv === "P-256";
            break;
          case "ES256K":
            candidate4 = jwk2.crv === "secp256k1";
            break;
          case "ES384":
            candidate4 = jwk2.crv === "P-384";
            break;
          case "ES512":
            candidate4 = jwk2.crv === "P-521";
            break;
        }
      }
      return candidate4;
    });
    const { 0: jwk, length: length2 } = candidates;
    if (length2 === 0) {
      throw new JWKSNoMatchingKey();
    }
    if (length2 !== 1) {
      const error4 = new JWKSMultipleMatchingKeys();
      const { _cached } = this;
      error4[Symbol.asyncIterator] = async function* () {
        for (const jwk2 of candidates) {
          try {
            yield await importWithAlgCache(_cached, jwk2, alg);
          } catch {
          }
        }
      };
      throw error4;
    }
    return importWithAlgCache(this._cached, jwk, alg);
  }
};
async function importWithAlgCache(cache, jwk, alg) {
  const cached = cache.get(jwk) || cache.set(jwk, {}).get(jwk);
  if (cached[alg] === void 0) {
    const key3 = await importJWK({ ...jwk, ext: true }, alg);
    if (key3 instanceof Uint8Array || key3.type !== "public") {
      throw new JWKSInvalid("JSON Web Key Set members must be public keys");
    }
    cached[alg] = key3;
  }
  return cached[alg];
}
function createLocalJWKSet(jwks) {
  const set = new LocalJWKSet(jwks);
  const localJWKSet = async (protectedHeader, token) => set.getKey(protectedHeader, token);
  Object.defineProperties(localJWKSet, {
    jwks: {
      value: () => clone(set._jwks),
      enumerable: true,
      configurable: false,
      writable: false
    }
  });
  return localJWKSet;
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/runtime/fetch_jwks.js
var fetchJwks = async (url7, timeout2, options) => {
  let controller2;
  let id4;
  let timedOut = false;
  if (typeof AbortController === "function") {
    controller2 = new AbortController();
    id4 = setTimeout(() => {
      timedOut = true;
      controller2.abort();
    }, timeout2);
  }
  const response6 = await fetch(url7.href, {
    signal: controller2 ? controller2.signal : void 0,
    redirect: "manual",
    headers: options.headers
  }).catch((err) => {
    if (timedOut)
      throw new JWKSTimeout();
    throw err;
  });
  if (id4 !== void 0)
    clearTimeout(id4);
  if (response6.status !== 200) {
    throw new JOSEError("Expected 200 OK from the JSON Web Key Set HTTP response");
  }
  try {
    return await response6.json();
  } catch {
    throw new JOSEError("Failed to parse the JSON Web Key Set HTTP response as JSON");
  }
};
var fetch_jwks_default = fetchJwks;

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/jwks/remote.js
function isCloudflareWorkers() {
  return typeof WebSocketPair !== "undefined" || typeof navigator !== "undefined" && navigator.userAgent === "Cloudflare-Workers" || typeof EdgeRuntime !== "undefined" && EdgeRuntime === "vercel";
}
var USER_AGENT;
if (typeof navigator === "undefined" || !navigator.userAgent?.startsWith?.("Mozilla/5.0 ")) {
  const NAME = "jose";
  const VERSION = "v5.9.6";
  USER_AGENT = `${NAME}/${VERSION}`;
}
var jwksCache = Symbol();
function isFreshJwksCache(input2, cacheMaxAge) {
  if (typeof input2 !== "object" || input2 === null) {
    return false;
  }
  if (!("uat" in input2) || typeof input2.uat !== "number" || Date.now() - input2.uat >= cacheMaxAge) {
    return false;
  }
  if (!("jwks" in input2) || !isObject(input2.jwks) || !Array.isArray(input2.jwks.keys) || !Array.prototype.every.call(input2.jwks.keys, isObject)) {
    return false;
  }
  return true;
}
var RemoteJWKSet = class {
  constructor(url7, options) {
    if (!(url7 instanceof URL)) {
      throw new TypeError("url must be an instance of URL");
    }
    this._url = new URL(url7.href);
    this._options = { agent: options?.agent, headers: options?.headers };
    this._timeoutDuration = typeof options?.timeoutDuration === "number" ? options?.timeoutDuration : 5e3;
    this._cooldownDuration = typeof options?.cooldownDuration === "number" ? options?.cooldownDuration : 3e4;
    this._cacheMaxAge = typeof options?.cacheMaxAge === "number" ? options?.cacheMaxAge : 6e5;
    if (options?.[jwksCache] !== void 0) {
      this._cache = options?.[jwksCache];
      if (isFreshJwksCache(options?.[jwksCache], this._cacheMaxAge)) {
        this._jwksTimestamp = this._cache.uat;
        this._local = createLocalJWKSet(this._cache.jwks);
      }
    }
  }
  coolingDown() {
    return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cooldownDuration : false;
  }
  fresh() {
    return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cacheMaxAge : false;
  }
  async getKey(protectedHeader, token) {
    if (!this._local || !this.fresh()) {
      await this.reload();
    }
    try {
      return await this._local(protectedHeader, token);
    } catch (err) {
      if (err instanceof JWKSNoMatchingKey) {
        if (this.coolingDown() === false) {
          await this.reload();
          return this._local(protectedHeader, token);
        }
      }
      throw err;
    }
  }
  async reload() {
    if (this._pendingFetch && isCloudflareWorkers()) {
      this._pendingFetch = void 0;
    }
    const headers = new Headers(this._options.headers);
    if (USER_AGENT && !headers.has("User-Agent")) {
      headers.set("User-Agent", USER_AGENT);
      this._options.headers = Object.fromEntries(headers.entries());
    }
    this._pendingFetch || (this._pendingFetch = fetch_jwks_default(this._url, this._timeoutDuration, this._options).then((json) => {
      this._local = createLocalJWKSet(json);
      if (this._cache) {
        this._cache.uat = Date.now();
        this._cache.jwks = json;
      }
      this._jwksTimestamp = Date.now();
      this._pendingFetch = void 0;
    }).catch((err) => {
      this._pendingFetch = void 0;
      throw err;
    }));
    await this._pendingFetch;
  }
};
function createRemoteJWKSet(url7, options) {
  const set = new RemoteJWKSet(url7, options);
  const remoteJWKSet = async (protectedHeader, token) => set.getKey(protectedHeader, token);
  Object.defineProperties(remoteJWKSet, {
    coolingDown: {
      get: () => set.coolingDown(),
      enumerable: true,
      configurable: false
    },
    fresh: {
      get: () => set.fresh(),
      enumerable: true,
      configurable: false
    },
    reload: {
      value: () => set.reload(),
      enumerable: true,
      configurable: false,
      writable: false
    },
    reloading: {
      get: () => !!set._pendingFetch,
      enumerable: true,
      configurable: false
    },
    jwks: {
      value: () => set._local?.jwks(),
      enumerable: true,
      configurable: false,
      writable: false
    }
  });
  return remoteJWKSet;
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/runtime/generate.js
function getModulusLengthOption(options) {
  const modulusLength = options?.modulusLength ?? 2048;
  if (typeof modulusLength !== "number" || modulusLength < 2048) {
    throw new JOSENotSupported("Invalid or unsupported modulusLength option provided, 2048 bits or larger keys must be used");
  }
  return modulusLength;
}
async function generateKeyPair(alg, options) {
  let algorithm3;
  let keyUsages;
  switch (alg) {
    case "PS256":
    case "PS384":
    case "PS512":
      algorithm3 = {
        name: "RSA-PSS",
        hash: `SHA-${alg.slice(-3)}`,
        publicExponent: new Uint8Array([1, 0, 1]),
        modulusLength: getModulusLengthOption(options)
      };
      keyUsages = ["sign", "verify"];
      break;
    case "RS256":
    case "RS384":
    case "RS512":
      algorithm3 = {
        name: "RSASSA-PKCS1-v1_5",
        hash: `SHA-${alg.slice(-3)}`,
        publicExponent: new Uint8Array([1, 0, 1]),
        modulusLength: getModulusLengthOption(options)
      };
      keyUsages = ["sign", "verify"];
      break;
    case "RSA-OAEP":
    case "RSA-OAEP-256":
    case "RSA-OAEP-384":
    case "RSA-OAEP-512":
      algorithm3 = {
        name: "RSA-OAEP",
        hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`,
        publicExponent: new Uint8Array([1, 0, 1]),
        modulusLength: getModulusLengthOption(options)
      };
      keyUsages = ["decrypt", "unwrapKey", "encrypt", "wrapKey"];
      break;
    case "ES256":
      algorithm3 = { name: "ECDSA", namedCurve: "P-256" };
      keyUsages = ["sign", "verify"];
      break;
    case "ES384":
      algorithm3 = { name: "ECDSA", namedCurve: "P-384" };
      keyUsages = ["sign", "verify"];
      break;
    case "ES512":
      algorithm3 = { name: "ECDSA", namedCurve: "P-521" };
      keyUsages = ["sign", "verify"];
      break;
    case "EdDSA": {
      keyUsages = ["sign", "verify"];
      const crv = options?.crv ?? "Ed25519";
      switch (crv) {
        case "Ed25519":
        case "Ed448":
          algorithm3 = { name: crv };
          break;
        default:
          throw new JOSENotSupported("Invalid or unsupported crv option provided");
      }
      break;
    }
    case "ECDH-ES":
    case "ECDH-ES+A128KW":
    case "ECDH-ES+A192KW":
    case "ECDH-ES+A256KW": {
      keyUsages = ["deriveKey", "deriveBits"];
      const crv = options?.crv ?? "P-256";
      switch (crv) {
        case "P-256":
        case "P-384":
        case "P-521": {
          algorithm3 = { name: "ECDH", namedCurve: crv };
          break;
        }
        case "X25519":
        case "X448":
          algorithm3 = { name: crv };
          break;
        default:
          throw new JOSENotSupported("Invalid or unsupported crv option provided, supported values are P-256, P-384, P-521, X25519, and X448");
      }
      break;
    }
    default:
      throw new JOSENotSupported('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
  }
  return webcrypto_default.subtle.generateKey(algorithm3, options?.extractable ?? false, keyUsages);
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/jose/dist/browser/key/generate_key_pair.js
async function generateKeyPair2(alg, options) {
  return generateKeyPair(alg, options);
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/uuid/dist/esm-browser/stringify.js
var byteToHex = [];
for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).slice(1));
}
function unsafeStringify(arr, offset3 = 0) {
  return (byteToHex[arr[offset3 + 0]] + byteToHex[arr[offset3 + 1]] + byteToHex[arr[offset3 + 2]] + byteToHex[arr[offset3 + 3]] + "-" + byteToHex[arr[offset3 + 4]] + byteToHex[arr[offset3 + 5]] + "-" + byteToHex[arr[offset3 + 6]] + byteToHex[arr[offset3 + 7]] + "-" + byteToHex[arr[offset3 + 8]] + byteToHex[arr[offset3 + 9]] + "-" + byteToHex[arr[offset3 + 10]] + byteToHex[arr[offset3 + 11]] + byteToHex[arr[offset3 + 12]] + byteToHex[arr[offset3 + 13]] + byteToHex[arr[offset3 + 14]] + byteToHex[arr[offset3 + 15]]).toLowerCase();
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/uuid/dist/esm-browser/rng.js
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    if (typeof crypto === "undefined" || !crypto.getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    getRandomValues = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues(rnds8);
}

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/uuid/dist/esm-browser/native.js
var randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native_default = { randomUUID };

// ../node_modules/@inrupt/solid-client-authn-core/node_modules/uuid/dist/esm-browser/v4.js
function v4(options, buf, offset3) {
  if (native_default.randomUUID && !buf && !options) {
    return native_default.randomUUID();
  }
  options = options || {};
  const rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset3 = offset3 || 0;
    for (let i = 0; i < 16; ++i) {
      buf[offset3 + i] = rnds[i];
    }
    return buf;
  }
  return unsafeStringify(rnds);
}
var v4_default = v4;

// ../node_modules/@inrupt/solid-client-authn-core/dist/index.mjs
var SOLID_CLIENT_AUTHN_KEY_PREFIX = "solidClientAuthn:";
var PREFERRED_SIGNING_ALG = ["ES256", "RS256"];
var EVENTS = {
  // Note that an `error` events MUST be listened to: https://nodejs.org/dist/latest-v16.x/docs/api/events.html#error-events.
  ERROR: "error",
  LOGIN: "login",
  LOGOUT: "logout",
  NEW_REFRESH_TOKEN: "newRefreshToken",
  SESSION_EXPIRED: "sessionExpired",
  SESSION_EXTENDED: "sessionExtended",
  SESSION_RESTORED: "sessionRestore",
  TIMEOUT_SET: "timeoutSet"
};
var REFRESH_BEFORE_EXPIRATION_SECONDS = 5;
var SCOPE_OPENID = "openid";
var SCOPE_OFFLINE = "offline_access";
var SCOPE_WEBID = "webid";
var DEFAULT_SCOPES = [SCOPE_OPENID, SCOPE_OFFLINE, SCOPE_WEBID].join(" ");
var AggregateHandler = class {
  constructor(handleables) {
    this.handleables = handleables;
    this.handleables = handleables;
  }
  /**
   * Helper function that will asynchronously determine the proper handler to use. If multiple
   * handlers can handle, it will choose the first one in the list
   * @param params Paramerters to feed to the handler
   */
  async getProperHandler(params2) {
    const canHandleList = await Promise.all(this.handleables.map((handleable) => handleable.canHandle(...params2)));
    for (let i = 0; i < canHandleList.length; i += 1) {
      if (canHandleList[i]) {
        return this.handleables[i];
      }
    }
    return null;
  }
  async canHandle(...params2) {
    return await this.getProperHandler(params2) !== null;
  }
  async handle(...params2) {
    const handler = await this.getProperHandler(params2);
    if (handler) {
      return handler.handle(...params2);
    }
    throw new Error(`[${this.constructor.name}] cannot find a suitable handler for: ${params2.map((param2) => {
      try {
        return JSON.stringify(param2);
      } catch (err) {
        return param2.toString();
      }
    }).join(", ")}`);
  }
};
async function getWebidFromTokenPayload(idToken, jwksIri, issuerIri, clientId) {
  let payload4;
  let clientIdInPayload;
  try {
    const { payload: verifiedPayload } = await jwtVerify(idToken, createRemoteJWKSet(new URL(jwksIri)), {
      issuer: issuerIri,
      audience: clientId
    });
    payload4 = verifiedPayload;
  } catch (e) {
    throw new Error(`Token verification failed: ${e.stack}`);
  }
  if (typeof payload4.azp === "string") {
    clientIdInPayload = payload4.azp;
  }
  if (typeof payload4.webid === "string") {
    return {
      webId: payload4.webid,
      clientId: clientIdInPayload
    };
  }
  if (typeof payload4.sub !== "string") {
    throw new Error(`The token ${JSON.stringify(payload4)} is invalid: it has no 'webid' claim and no 'sub' claim.`);
  }
  try {
    new URL(payload4.sub);
    return {
      webId: payload4.sub,
      clientId: clientIdInPayload
    };
  } catch (e) {
    throw new Error(`The token has no 'webid' claim, and its 'sub' claim of [${payload4.sub}] is invalid as a URL - error [${e}].`);
  }
}
function isValidRedirectUrl(redirectUrl) {
  try {
    const urlObject = new URL(redirectUrl);
    const noReservedQuery = !urlObject.searchParams.has("code") && !urlObject.searchParams.has("state");
    const noHash = urlObject.hash === "";
    return noReservedQuery && noHash;
  } catch (e) {
    return false;
  }
}
function removeOpenIdParams(redirectUrl) {
  const cleanedUpUrl = new URL(redirectUrl);
  cleanedUpUrl.searchParams.delete("state");
  cleanedUpUrl.searchParams.delete("code");
  cleanedUpUrl.searchParams.delete("error");
  cleanedUpUrl.searchParams.delete("error_description");
  cleanedUpUrl.searchParams.delete("iss");
  return cleanedUpUrl;
}
function booleanWithFallback(value6, fallback) {
  if (typeof value6 === "boolean") {
    return Boolean(value6);
  }
  return Boolean(fallback);
}
var AuthorizationCodeWithPkceOidcHandlerBase = class {
  constructor(storageUtility, redirector) {
    this.storageUtility = storageUtility;
    this.redirector = redirector;
    this.parametersGuard = (oidcLoginOptions) => {
      return oidcLoginOptions.issuerConfiguration.grantTypesSupported !== void 0 && oidcLoginOptions.issuerConfiguration.grantTypesSupported.indexOf("authorization_code") > -1 && oidcLoginOptions.redirectUrl !== void 0;
    };
    this.storageUtility = storageUtility;
    this.redirector = redirector;
  }
  async canHandle(oidcLoginOptions) {
    return this.parametersGuard(oidcLoginOptions);
  }
  async handleRedirect({ oidcLoginOptions, state: state2, codeVerifier, targetUrl: targetUrl3 }) {
    if (!this.parametersGuard(oidcLoginOptions)) {
      throw new Error("The authorization code grant requires a redirectUrl.");
    }
    await Promise.all([
      // We use the OAuth 'state' value (which should be crypto-random) as
      // the key in our storage to store our actual SessionID. We do this
      // 'cos we'll need to lookup our session information again when the
      // browser is redirected back to us (i.e. the OAuth client
      // application) from the Authorization Server.
      // We don't want to use our session ID as the OAuth 'state' value, as
      // that session ID can be any developer-specified value, and therefore
      // may not be appropriate (since the OAuth 'state' value should really
      // be an unguessable crypto-random value).
      this.storageUtility.setForUser(state2, {
        sessionId: oidcLoginOptions.sessionId
      }),
      // Store our login-process state using the session ID as the key.
      // Strictly speaking, this indirection from our OAuth state value to
      // our session ID is unnecessary, but it provides a slightly cleaner
      // separation of concerns.
      this.storageUtility.setForUser(oidcLoginOptions.sessionId, {
        codeVerifier,
        issuer: oidcLoginOptions.issuer.toString(),
        // The redirect URL is read after redirect, so it must be stored now.
        redirectUrl: oidcLoginOptions.redirectUrl,
        dpop: Boolean(oidcLoginOptions.dpop).toString(),
        keepAlive: booleanWithFallback(oidcLoginOptions.keepAlive, true).toString()
      })
    ]);
    this.redirector.redirect(targetUrl3, {
      handleRedirect: oidcLoginOptions.handleRedirect
    });
    return void 0;
  }
};
var GeneralLogoutHandler = class {
  constructor(sessionInfoManager) {
    this.sessionInfoManager = sessionInfoManager;
    this.sessionInfoManager = sessionInfoManager;
  }
  async canHandle() {
    return true;
  }
  async handle(userId) {
    await this.sessionInfoManager.clear(userId);
  }
};
var IRpLogoutHandler = class {
  constructor(redirector) {
    this.redirector = redirector;
    this.redirector = redirector;
  }
  async canHandle(userId, options) {
    return (options === null || options === void 0 ? void 0 : options.logoutType) === "idp";
  }
  async handle(userId, options) {
    if ((options === null || options === void 0 ? void 0 : options.logoutType) !== "idp") {
      throw new Error("Attempting to call idp logout handler to perform app logout");
    }
    if (options.toLogoutUrl === void 0) {
      throw new Error("Cannot perform IDP logout. Did you log in using the OIDC authentication flow?");
    }
    this.redirector.redirect(options.toLogoutUrl(options), {
      handleRedirect: options.handleRedirect
    });
  }
};
var IWaterfallLogoutHandler = class {
  constructor(sessionInfoManager, redirector) {
    this.handlers = [
      new GeneralLogoutHandler(sessionInfoManager),
      new IRpLogoutHandler(redirector)
    ];
  }
  async canHandle() {
    return true;
  }
  async handle(userId, options) {
    for (const handler of this.handlers) {
      if (await handler.canHandle(userId, options))
        await handler.handle(userId, options);
    }
  }
};
function getUnauthenticatedSession() {
  return {
    isLoggedIn: false,
    sessionId: v4_default(),
    fetch: (...args) => fetch(...args)
  };
}
async function clear(sessionId, storage2) {
  await Promise.all([
    storage2.deleteAllUserData(sessionId, { secure: false }),
    storage2.deleteAllUserData(sessionId, { secure: true })
  ]);
}
var SessionInfoManagerBase = class {
  constructor(storageUtility) {
    this.storageUtility = storageUtility;
    this.storageUtility = storageUtility;
  }
  update(_sessionId, _options) {
    throw new Error("Not Implemented");
  }
  get(_) {
    throw new Error("Not implemented");
  }
  // eslint-disable-next-line class-methods-use-this
  async getAll() {
    throw new Error("Not implemented");
  }
  /**
   * This function removes all session-related information from storage.
   * @param sessionId the session identifier
   * @param storage the storage where session info is stored
   * @hidden
   */
  async clear(sessionId) {
    return clear(sessionId, this.storageUtility);
  }
  /**
   * Registers a new session, so that its ID can be retrieved.
   * @param sessionId
   */
  async register(_sessionId) {
    throw new Error("Not implemented");
  }
  /**
   * Returns all the registered session IDs. Differs from getAll, which also
   * returns additional session information.
   */
  async getRegisteredSessionIdAll() {
    throw new Error("Not implemented");
  }
  /**
   * Deletes all information about all sessions, including their registrations.
   */
  async clearAll() {
    throw new Error("Not implemented");
  }
};
function getEndSessionUrl({ endSessionEndpoint, idTokenHint, postLogoutRedirectUri, state: state2 }) {
  const url7 = new URL(endSessionEndpoint);
  if (idTokenHint !== void 0)
    url7.searchParams.append("id_token_hint", idTokenHint);
  if (postLogoutRedirectUri !== void 0) {
    url7.searchParams.append("post_logout_redirect_uri", postLogoutRedirectUri);
    if (state2 !== void 0)
      url7.searchParams.append("state", state2);
  }
  return url7.toString();
}
function maybeBuildRpInitiatedLogout({ endSessionEndpoint, idTokenHint }) {
  if (endSessionEndpoint === void 0)
    return void 0;
  return function logout({ state: state2, postLogoutUrl }) {
    return getEndSessionUrl({
      endSessionEndpoint,
      idTokenHint,
      state: state2,
      postLogoutRedirectUri: postLogoutUrl
    });
  };
}
function isSupportedTokenType(token) {
  return typeof token === "string" && ["DPoP", "Bearer"].includes(token);
}
function isValidUrl(url7) {
  try {
    new URL(url7);
    return true;
  } catch (_a) {
    return false;
  }
}
function determineSigningAlg(supported, preferred2) {
  var _a;
  return (_a = preferred2.find((signingAlg) => {
    return supported.includes(signingAlg);
  })) !== null && _a !== void 0 ? _a : null;
}
function isStaticClient(options) {
  return options.clientId !== void 0 && !isValidUrl(options.clientId);
}
function isSolidOidcClient(options, issuerConfig) {
  return issuerConfig.scopesSupported.includes("webid") && options.clientId !== void 0 && isValidUrl(options.clientId);
}
function isKnownClientType(clientType) {
  return typeof clientType === "string" && ["dynamic", "static", "solid-oidc"].includes(clientType);
}
async function handleRegistration(options, issuerConfig, storageUtility, clientRegistrar) {
  let clientInfo;
  if (isSolidOidcClient(options, issuerConfig)) {
    clientInfo = {
      clientId: options.clientId,
      clientName: options.clientName,
      clientType: "solid-oidc"
    };
  } else if (isStaticClient(options)) {
    clientInfo = {
      clientId: options.clientId,
      clientSecret: options.clientSecret,
      clientName: options.clientName,
      clientType: "static"
    };
  } else {
    return clientRegistrar.getClient({
      sessionId: options.sessionId,
      clientName: options.clientName,
      redirectUrl: options.redirectUrl
    }, issuerConfig);
  }
  const infoToSave = {
    clientId: clientInfo.clientId,
    clientType: clientInfo.clientType
  };
  if (clientInfo.clientType === "static") {
    infoToSave.clientSecret = clientInfo.clientSecret;
  }
  if (clientInfo.clientName) {
    infoToSave.clientName = clientInfo.clientName;
  }
  await storageUtility.setForUser(options.sessionId, infoToSave);
  return clientInfo;
}
var boundFetch = (request2, init) => fetch(request2, init);
var ClientAuthentication = class {
  constructor(loginHandler, redirectHandler, logoutHandler, sessionInfoManager, issuerConfigFetcher) {
    this.loginHandler = loginHandler;
    this.redirectHandler = redirectHandler;
    this.logoutHandler = logoutHandler;
    this.sessionInfoManager = sessionInfoManager;
    this.issuerConfigFetcher = issuerConfigFetcher;
    this.fetch = boundFetch;
    this.logout = async (sessionId, options) => {
      await this.logoutHandler.handle(sessionId, (options === null || options === void 0 ? void 0 : options.logoutType) === "idp" ? {
        ...options,
        toLogoutUrl: this.boundLogout
      } : options);
      this.fetch = boundFetch;
      delete this.boundLogout;
    };
    this.getSessionInfo = async (sessionId) => {
      return this.sessionInfoManager.get(sessionId);
    };
    this.getAllSessionInfo = async () => {
      return this.sessionInfoManager.getAll();
    };
    this.loginHandler = loginHandler;
    this.redirectHandler = redirectHandler;
    this.logoutHandler = logoutHandler;
    this.sessionInfoManager = sessionInfoManager;
    this.issuerConfigFetcher = issuerConfigFetcher;
  }
};
async function loadOidcContextFromStorage(sessionId, storageUtility, configFetcher) {
  try {
    const [issuerIri, codeVerifier, storedRedirectIri, dpop, keepAlive] = await Promise.all([
      storageUtility.getForUser(sessionId, "issuer", {
        errorIfNull: true
      }),
      storageUtility.getForUser(sessionId, "codeVerifier"),
      storageUtility.getForUser(sessionId, "redirectUrl"),
      storageUtility.getForUser(sessionId, "dpop", { errorIfNull: true }),
      storageUtility.getForUser(sessionId, "keepAlive")
    ]);
    await storageUtility.deleteForUser(sessionId, "codeVerifier");
    const issuerConfig = await configFetcher.fetchConfig(issuerIri);
    return {
      codeVerifier,
      redirectUrl: storedRedirectIri,
      issuerConfig,
      dpop: dpop === "true",
      // Default keepAlive to true if not found in storage.
      keepAlive: typeof keepAlive === "string" ? keepAlive === "true" : true
    };
  } catch (e) {
    throw new Error(`Failed to retrieve OIDC context from storage associated with session [${sessionId}]: ${e}`);
  }
}
async function saveSessionInfoToStorage(storageUtility, sessionId, webId, clientId, isLoggedIn2, refreshToken, secure, dpopKey) {
  if (refreshToken !== void 0) {
    await storageUtility.setForUser(sessionId, { refreshToken }, { secure });
  }
  if (webId !== void 0) {
    await storageUtility.setForUser(sessionId, { webId }, { secure });
  }
  if (clientId !== void 0) {
    await storageUtility.setForUser(sessionId, { clientId }, { secure });
  }
  if (isLoggedIn2 !== void 0) {
    await storageUtility.setForUser(sessionId, { isLoggedIn: isLoggedIn2 }, { secure });
  }
  if (dpopKey !== void 0) {
    await storageUtility.setForUser(sessionId, {
      publicKey: JSON.stringify(dpopKey.publicKey),
      privateKey: JSON.stringify(await exportJWK(dpopKey.privateKey))
    }, { secure });
  }
}
var StorageUtility = class {
  constructor(secureStorage, insecureStorage) {
    this.secureStorage = secureStorage;
    this.insecureStorage = insecureStorage;
    this.secureStorage = secureStorage;
    this.insecureStorage = insecureStorage;
  }
  getKey(userId) {
    return `solidClientAuthenticationUser:${userId}`;
  }
  async getUserData(userId, secure) {
    const stored = await (secure ? this.secureStorage : this.insecureStorage).get(this.getKey(userId));
    if (stored === void 0) {
      return {};
    }
    try {
      return JSON.parse(stored);
    } catch (err) {
      throw new Error(`Data for user [${userId}] in [${secure ? "secure" : "unsecure"}] storage is corrupted - expected valid JSON, but got: ${stored}`);
    }
  }
  async setUserData(userId, data2, secure) {
    await (secure ? this.secureStorage : this.insecureStorage).set(this.getKey(userId), JSON.stringify(data2));
  }
  async get(key3, options) {
    const value6 = await ((options === null || options === void 0 ? void 0 : options.secure) ? this.secureStorage : this.insecureStorage).get(key3);
    if (value6 === void 0 && (options === null || options === void 0 ? void 0 : options.errorIfNull)) {
      throw new Error(`[${key3}] is not stored`);
    }
    return value6;
  }
  async set(key3, value6, options) {
    return ((options === null || options === void 0 ? void 0 : options.secure) ? this.secureStorage : this.insecureStorage).set(key3, value6);
  }
  async delete(key3, options) {
    return ((options === null || options === void 0 ? void 0 : options.secure) ? this.secureStorage : this.insecureStorage).delete(key3);
  }
  async getForUser(userId, key3, options) {
    const userData = await this.getUserData(userId, options === null || options === void 0 ? void 0 : options.secure);
    let value6;
    if (!userData || !userData[key3]) {
      value6 = void 0;
    }
    value6 = userData[key3];
    if (value6 === void 0 && (options === null || options === void 0 ? void 0 : options.errorIfNull)) {
      throw new Error(`Field [${key3}] for user [${userId}] is not stored`);
    }
    return value6 || void 0;
  }
  async setForUser(userId, values, options) {
    let userData;
    try {
      userData = await this.getUserData(userId, options === null || options === void 0 ? void 0 : options.secure);
    } catch (_a) {
      userData = {};
    }
    await this.setUserData(userId, { ...userData, ...values }, options === null || options === void 0 ? void 0 : options.secure);
  }
  async deleteForUser(userId, key3, options) {
    const userData = await this.getUserData(userId, options === null || options === void 0 ? void 0 : options.secure);
    delete userData[key3];
    await this.setUserData(userId, userData, options === null || options === void 0 ? void 0 : options.secure);
  }
  async deleteAllUserData(userId, options) {
    await ((options === null || options === void 0 ? void 0 : options.secure) ? this.secureStorage : this.insecureStorage).delete(this.getKey(userId));
  }
};
var InMemoryStorage = class {
  constructor() {
    this.map = {};
  }
  async get(key3) {
    return this.map[key3] || void 0;
  }
  async set(key3, value6) {
    this.map[key3] = value6;
  }
  async delete(key3) {
    delete this.map[key3];
  }
};
var ConfigurationError = class extends Error {
  /* istanbul ignore next */
  constructor(message4) {
    super(message4);
  }
};
var InvalidResponseError = class extends Error {
  /* istanbul ignore next */
  constructor(missingFields) {
    super(`Invalid response from OIDC provider: missing fields ${missingFields}`);
    this.missingFields = missingFields;
  }
};
var OidcProviderError = class extends Error {
  /* istanbul ignore next */
  constructor(message4, error4, errorDescription) {
    super(message4);
    this.error = error4;
    this.errorDescription = errorDescription;
  }
};
function normalizeHTU(audience5) {
  const audienceUrl = new URL(audience5);
  return new URL(audienceUrl.pathname, audienceUrl.origin).toString();
}
async function createDpopHeader(audience5, method5, dpopKey) {
  return new SignJWT({
    htu: normalizeHTU(audience5),
    htm: method5.toUpperCase(),
    jti: v4_default()
  }).setProtectedHeader({
    alg: PREFERRED_SIGNING_ALG[0],
    jwk: dpopKey.publicKey,
    typ: "dpop+jwt"
  }).setIssuedAt().sign(dpopKey.privateKey, {});
}
async function generateDpopKeyPair() {
  const { privateKey, publicKey } = await generateKeyPair2(PREFERRED_SIGNING_ALG[0]);
  const dpopKeyPair = {
    privateKey,
    publicKey: await exportJWK(publicKey)
  };
  [dpopKeyPair.publicKey.alg] = PREFERRED_SIGNING_ALG;
  return dpopKeyPair;
}
var DEFAULT_EXPIRATION_TIME_SECONDS = 600;
function isExpectedAuthError(statusCode2) {
  return [401, 403].includes(statusCode2);
}
async function buildDpopFetchOptions(targetUrl3, authToken, dpopKey, defaultOptions) {
  var _a;
  const headers = new Headers(defaultOptions === null || defaultOptions === void 0 ? void 0 : defaultOptions.headers);
  headers.set("Authorization", `DPoP ${authToken}`);
  headers.set("DPoP", await createDpopHeader(targetUrl3, (_a = defaultOptions === null || defaultOptions === void 0 ? void 0 : defaultOptions.method) !== null && _a !== void 0 ? _a : "get", dpopKey));
  return {
    ...defaultOptions,
    headers
  };
}
async function buildAuthenticatedHeaders(targetUrl3, authToken, dpopKey, defaultOptions) {
  if (dpopKey !== void 0) {
    return buildDpopFetchOptions(targetUrl3, authToken, dpopKey, defaultOptions);
  }
  const headers = new Headers(defaultOptions === null || defaultOptions === void 0 ? void 0 : defaultOptions.headers);
  headers.set("Authorization", `Bearer ${authToken}`);
  return {
    ...defaultOptions,
    headers
  };
}
async function makeAuthenticatedRequest(accessToken, url7, defaultRequestInit, dpopKey) {
  return fetch(url7, await buildAuthenticatedHeaders(url7.toString(), accessToken, dpopKey, defaultRequestInit));
}
async function refreshAccessToken(refreshOptions, dpopKey, eventEmitter) {
  var _a;
  const tokenSet = await refreshOptions.tokenRefresher.refresh(refreshOptions.sessionId, refreshOptions.refreshToken, dpopKey);
  eventEmitter === null || eventEmitter === void 0 ? void 0 : eventEmitter.emit(EVENTS.SESSION_EXTENDED, (_a = tokenSet.expiresIn) !== null && _a !== void 0 ? _a : DEFAULT_EXPIRATION_TIME_SECONDS);
  if (typeof tokenSet.refreshToken === "string") {
    eventEmitter === null || eventEmitter === void 0 ? void 0 : eventEmitter.emit(EVENTS.NEW_REFRESH_TOKEN, tokenSet.refreshToken);
  }
  return {
    accessToken: tokenSet.accessToken,
    refreshToken: tokenSet.refreshToken,
    expiresIn: tokenSet.expiresIn
  };
}
var computeRefreshDelay = (expiresIn) => {
  if (expiresIn !== void 0) {
    return expiresIn - REFRESH_BEFORE_EXPIRATION_SECONDS > 0 ? (
      // We want to refresh the token 5 seconds before they actually expire.
      expiresIn - REFRESH_BEFORE_EXPIRATION_SECONDS
    ) : expiresIn;
  }
  return DEFAULT_EXPIRATION_TIME_SECONDS;
};
async function buildAuthenticatedFetch(accessToken, options) {
  var _a;
  let currentAccessToken = accessToken;
  let latestTimeout;
  const currentRefreshOptions = options === null || options === void 0 ? void 0 : options.refreshOptions;
  if (currentRefreshOptions !== void 0) {
    const proactivelyRefreshToken = async () => {
      var _a2, _b, _c, _d;
      try {
        const { accessToken: refreshedAccessToken, refreshToken, expiresIn } = await refreshAccessToken(
          currentRefreshOptions,
          // If currentRefreshOptions is defined, options is necessarily defined too.
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          options.dpopKey,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          options.eventEmitter
        );
        currentAccessToken = refreshedAccessToken;
        if (refreshToken !== void 0) {
          currentRefreshOptions.refreshToken = refreshToken;
        }
        clearTimeout(latestTimeout);
        latestTimeout = setTimeout(proactivelyRefreshToken, computeRefreshDelay(expiresIn) * 1e3);
        (_a2 = options.eventEmitter) === null || _a2 === void 0 ? void 0 : _a2.emit(EVENTS.TIMEOUT_SET, latestTimeout);
      } catch (e) {
        if (e instanceof OidcProviderError) {
          (_b = options === null || options === void 0 ? void 0 : options.eventEmitter) === null || _b === void 0 ? void 0 : _b.emit(EVENTS.ERROR, e.error, e.errorDescription);
          (_c = options === null || options === void 0 ? void 0 : options.eventEmitter) === null || _c === void 0 ? void 0 : _c.emit(EVENTS.SESSION_EXPIRED);
        }
        if (e instanceof InvalidResponseError && e.missingFields.includes("access_token")) {
          (_d = options === null || options === void 0 ? void 0 : options.eventEmitter) === null || _d === void 0 ? void 0 : _d.emit(EVENTS.SESSION_EXPIRED);
        }
      }
    };
    latestTimeout = setTimeout(
      proactivelyRefreshToken,
      // If currentRefreshOptions is defined, options is necessarily defined too.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      computeRefreshDelay(options.expiresIn) * 1e3
    );
    (_a = options.eventEmitter) === null || _a === void 0 ? void 0 : _a.emit(EVENTS.TIMEOUT_SET, latestTimeout);
  } else if (options !== void 0 && options.eventEmitter !== void 0) {
    const expirationTimeout = setTimeout(() => {
      options.eventEmitter.emit(EVENTS.SESSION_EXPIRED);
    }, computeRefreshDelay(options.expiresIn) * 1e3);
    options.eventEmitter.emit(EVENTS.TIMEOUT_SET, expirationTimeout);
  }
  return async (url7, requestInit) => {
    let response6 = await makeAuthenticatedRequest(currentAccessToken, url7, requestInit, options === null || options === void 0 ? void 0 : options.dpopKey);
    const failedButNotExpectedAuthError = !response6.ok && !isExpectedAuthError(response6.status);
    if (response6.ok || failedButNotExpectedAuthError) {
      return response6;
    }
    const hasBeenRedirected = response6.url !== url7;
    if (hasBeenRedirected && (options === null || options === void 0 ? void 0 : options.dpopKey) !== void 0) {
      response6 = await makeAuthenticatedRequest(
        currentAccessToken,
        // Replace the original target IRI (`url`) by the redirection target
        response6.url,
        requestInit,
        options.dpopKey
      );
    }
    return response6;
  };
}

// ../node_modules/@inrupt/solid-client-authn-browser/node_modules/uuid/dist/esm-browser/stringify.js
var byteToHex2 = [];
for (let i = 0; i < 256; ++i) {
  byteToHex2.push((i + 256).toString(16).slice(1));
}
function unsafeStringify2(arr, offset3 = 0) {
  return (byteToHex2[arr[offset3 + 0]] + byteToHex2[arr[offset3 + 1]] + byteToHex2[arr[offset3 + 2]] + byteToHex2[arr[offset3 + 3]] + "-" + byteToHex2[arr[offset3 + 4]] + byteToHex2[arr[offset3 + 5]] + "-" + byteToHex2[arr[offset3 + 6]] + byteToHex2[arr[offset3 + 7]] + "-" + byteToHex2[arr[offset3 + 8]] + byteToHex2[arr[offset3 + 9]] + "-" + byteToHex2[arr[offset3 + 10]] + byteToHex2[arr[offset3 + 11]] + byteToHex2[arr[offset3 + 12]] + byteToHex2[arr[offset3 + 13]] + byteToHex2[arr[offset3 + 14]] + byteToHex2[arr[offset3 + 15]]).toLowerCase();
}

// ../node_modules/@inrupt/solid-client-authn-browser/node_modules/uuid/dist/esm-browser/rng.js
var getRandomValues2;
var rnds82 = new Uint8Array(16);
function rng2() {
  if (!getRandomValues2) {
    if (typeof crypto === "undefined" || !crypto.getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    getRandomValues2 = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues2(rnds82);
}

// ../node_modules/@inrupt/solid-client-authn-browser/node_modules/uuid/dist/esm-browser/native.js
var randomUUID2 = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native_default2 = { randomUUID: randomUUID2 };

// ../node_modules/@inrupt/solid-client-authn-browser/node_modules/uuid/dist/esm-browser/v4.js
function v42(options, buf, offset3) {
  if (native_default2.randomUUID && !buf && !options) {
    return native_default2.randomUUID();
  }
  options = options || {};
  const rnds = options.random || (options.rng || rng2)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset3 = offset3 || 0;
    for (let i = 0; i < 16; ++i) {
      buf[offset3 + i] = rnds[i];
    }
    return buf;
  }
  return unsafeStringify2(rnds);
}
var v4_default2 = v42;

// ../node_modules/@inrupt/solid-client-authn-browser/dist/index.mjs
var import_events = __toESM(require_events(), 1);

// ../node_modules/@inrupt/oidc-client-ext/dist/index.es.js
var import_oidc_client = __toESM(require_oidc_client_min());
var import_oidc_client2 = __toESM(require_oidc_client_min());
function processErrorResponse(responseBody, options) {
  var _a, _b, _c, _d;
  if (responseBody.error === "invalid_redirect_uri") {
    throw new Error(`Dynamic client registration failed: the provided redirect uri [${(_a = options.redirectUrl) === null || _a === void 0 ? void 0 : _a.toString()}] is invalid - ${(_b = responseBody.error_description) !== null && _b !== void 0 ? _b : ""}`);
  }
  if (responseBody.error === "invalid_client_metadata") {
    throw new Error(`Dynamic client registration failed: the provided client metadata ${JSON.stringify(options)} is invalid - ${(_c = responseBody.error_description) !== null && _c !== void 0 ? _c : ""}`);
  }
  throw new Error(`Dynamic client registration failed: ${responseBody.error} - ${(_d = responseBody.error_description) !== null && _d !== void 0 ? _d : ""}`);
}
function validateRegistrationResponse(responseBody, options) {
  if (responseBody.client_id === void 0) {
    throw new Error(`Dynamic client registration failed: no client_id has been found on ${JSON.stringify(responseBody)}`);
  }
  if (options.redirectUrl && (responseBody.redirect_uris === void 0 || responseBody.redirect_uris[0] !== options.redirectUrl.toString())) {
    throw new Error(`Dynamic client registration failed: the returned redirect URIs ${JSON.stringify(responseBody.redirect_uris)} don't match the provided ${JSON.stringify([
      options.redirectUrl.toString()
    ])}`);
  }
}
async function registerClient(options, issuerConfig) {
  var _a;
  if (!issuerConfig.registrationEndpoint) {
    throw new Error("Dynamic Registration could not be completed because the issuer has no registration endpoint.");
  }
  if (!Array.isArray(issuerConfig.idTokenSigningAlgValuesSupported)) {
    throw new Error("The OIDC issuer discovery profile is missing the 'id_token_signing_alg_values_supported' value, which is mandatory.");
  }
  const signingAlg = determineSigningAlg(issuerConfig.idTokenSigningAlgValuesSupported, PREFERRED_SIGNING_ALG);
  const config2 = {
    /* eslint-disable camelcase */
    client_name: options.clientName,
    application_type: "web",
    redirect_uris: [(_a = options.redirectUrl) === null || _a === void 0 ? void 0 : _a.toString()],
    subject_type: "public",
    token_endpoint_auth_method: "client_secret_basic",
    id_token_signed_response_alg: signingAlg,
    grant_types: ["authorization_code", "refresh_token"]
    /* eslint-enable camelcase */
  };
  const headers = {
    "Content-Type": "application/json"
  };
  const registerResponse = await fetch(issuerConfig.registrationEndpoint.toString(), {
    method: "POST",
    headers,
    body: JSON.stringify(config2)
  });
  if (registerResponse.ok) {
    const responseBody = await registerResponse.json();
    validateRegistrationResponse(responseBody, options);
    return {
      clientId: responseBody.client_id,
      clientSecret: responseBody.client_secret,
      idTokenSignedResponseAlg: responseBody.id_token_signed_response_alg,
      clientType: "dynamic"
    };
  }
  if (registerResponse.status === 400) {
    processErrorResponse(await registerResponse.json(), options);
  }
  throw new Error(`Dynamic client registration failed: the server returned ${registerResponse.status} ${registerResponse.statusText} - ${await registerResponse.text()}`);
}
function hasError(value6) {
  return value6.error !== void 0 && typeof value6.error === "string";
}
function hasErrorDescription(value6) {
  return value6.error_description !== void 0 && typeof value6.error_description === "string";
}
function hasErrorUri(value6) {
  return value6.error_uri !== void 0 && typeof value6.error_uri === "string";
}
function hasAccessToken(value6) {
  return value6.access_token !== void 0 && typeof value6.access_token === "string";
}
function hasIdToken(value6) {
  return value6.id_token !== void 0 && typeof value6.id_token === "string";
}
function hasRefreshToken(value6) {
  return value6.refresh_token !== void 0 && typeof value6.refresh_token === "string";
}
function hasTokenType(value6) {
  return value6.token_type !== void 0 && typeof value6.token_type === "string";
}
function hasExpiresIn(value6) {
  return value6.expires_in === void 0 || typeof value6.expires_in === "number";
}
function validatePreconditions(issuer2, data2) {
  if (data2.grantType && (!issuer2.grantTypesSupported || !issuer2.grantTypesSupported.includes(data2.grantType))) {
    throw new Error(`The issuer [${issuer2.issuer}] does not support the [${data2.grantType}] grant`);
  }
  if (!issuer2.tokenEndpoint) {
    throw new Error(`This issuer [${issuer2.issuer}] does not have a token endpoint`);
  }
}
function validateTokenEndpointResponse(tokenResponse, dpop) {
  if (hasError(tokenResponse)) {
    throw new OidcProviderError(`Token endpoint returned error [${tokenResponse.error}]${hasErrorDescription(tokenResponse) ? `: ${tokenResponse.error_description}` : ""}${hasErrorUri(tokenResponse) ? ` (see ${tokenResponse.error_uri})` : ""}`, tokenResponse.error, hasErrorDescription(tokenResponse) ? tokenResponse.error_description : void 0);
  }
  if (!hasAccessToken(tokenResponse)) {
    throw new InvalidResponseError(["access_token"]);
  }
  if (!hasIdToken(tokenResponse)) {
    throw new InvalidResponseError(["id_token"]);
  }
  if (!hasTokenType(tokenResponse)) {
    throw new InvalidResponseError(["token_type"]);
  }
  if (!hasExpiresIn(tokenResponse)) {
    throw new InvalidResponseError(["expires_in"]);
  }
  if (!dpop && tokenResponse.token_type.toLowerCase() !== "bearer") {
    throw new Error(`Invalid token endpoint response: requested a [Bearer] token, but got a 'token_type' value of [${tokenResponse.token_type}].`);
  }
  return tokenResponse;
}
async function getTokens(issuer2, client, data2, dpop) {
  validatePreconditions(issuer2, data2);
  const headers = {
    "content-type": "application/x-www-form-urlencoded"
  };
  let dpopKey;
  if (dpop) {
    dpopKey = await generateDpopKeyPair();
    headers.DPoP = await createDpopHeader(issuer2.tokenEndpoint, "POST", dpopKey);
  }
  if (client.clientSecret) {
    headers.Authorization = `Basic ${btoa(`${client.clientId}:${client.clientSecret}`)}`;
  }
  const requestBody = {
    /* eslint-disable camelcase */
    grant_type: data2.grantType,
    redirect_uri: data2.redirectUrl,
    code: data2.code,
    code_verifier: data2.codeVerifier,
    client_id: client.clientId
    /* eslint-enable camelcase */
  };
  const tokenRequestInit = {
    method: "POST",
    headers,
    body: new URLSearchParams(requestBody).toString()
  };
  const rawTokenResponse = await fetch(issuer2.tokenEndpoint, tokenRequestInit);
  const jsonTokenResponse = await rawTokenResponse.json();
  const tokenResponse = validateTokenEndpointResponse(jsonTokenResponse, dpop);
  const { webId, clientId } = await getWebidFromTokenPayload(tokenResponse.id_token, issuer2.jwksUri, issuer2.issuer, client.clientId);
  return {
    accessToken: tokenResponse.access_token,
    idToken: tokenResponse.id_token,
    refreshToken: hasRefreshToken(tokenResponse) ? tokenResponse.refresh_token : void 0,
    webId,
    clientId,
    dpopKey,
    expiresIn: tokenResponse.expires_in
  };
}
var isValidUrl2 = (url7) => {
  try {
    new URL(url7);
    return true;
  } catch (_a) {
    return false;
  }
};
async function refresh(refreshToken, issuer2, client, dpopKey) {
  if (client.clientId === void 0) {
    throw new Error("No client ID available when trying to refresh the access token.");
  }
  const requestBody = {
    grant_type: "refresh_token",
    refresh_token: refreshToken,
    scope: DEFAULT_SCOPES
  };
  let dpopHeader = {};
  if (dpopKey !== void 0) {
    dpopHeader = {
      DPoP: await createDpopHeader(issuer2.tokenEndpoint, "POST", dpopKey)
    };
  }
  let authHeader = {};
  if (client.clientSecret !== void 0) {
    authHeader = {
      // We assume that client_secret_basic is the client authentication method.
      // TODO: Get the authentication method from the IClient configuration object.
      Authorization: `Basic ${btoa(`${client.clientId}:${client.clientSecret}`)}`
    };
  } else if (isValidUrl2(client.clientId)) {
    requestBody.client_id = client.clientId;
  }
  const rawResponse = await fetch(issuer2.tokenEndpoint, {
    method: "POST",
    body: new URLSearchParams(requestBody).toString(),
    headers: {
      ...dpopHeader,
      ...authHeader,
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
  let response6;
  try {
    response6 = await rawResponse.json();
  } catch (e) {
    throw new Error(`The token endpoint of issuer ${issuer2.issuer} returned a malformed response.`);
  }
  const validatedResponse = validateTokenEndpointResponse(response6, dpopKey !== void 0);
  const { webId } = await getWebidFromTokenPayload(validatedResponse.id_token, issuer2.jwksUri, issuer2.issuer, client.clientId);
  return {
    accessToken: validatedResponse.access_token,
    idToken: validatedResponse.id_token,
    refreshToken: typeof validatedResponse.refresh_token === "string" ? validatedResponse.refresh_token : void 0,
    webId,
    dpopKey,
    expiresIn: validatedResponse.expires_in
  };
}
function normalizeCallbackUrl(redirectUrl) {
  const cleanedUrl = removeOpenIdParams(redirectUrl);
  cleanedUrl.hash = "";
  if (
    // The trailing slash is present in the original redirect URL
    redirectUrl.includes(`${cleanedUrl.origin}/`)
  ) {
    return cleanedUrl.href;
  }
  return `${cleanedUrl.origin}${cleanedUrl.href.substring(
    // Adds 1 to the origin length to remove the trailing slash
    cleanedUrl.origin.length + 1
  )}`;
}
async function clearOidcPersistentStorage() {
  const client = new import_oidc_client.OidcClient({
    // TODO: We should look at the various interfaces being used for storage,
    //  i.e. between oidc-client-js (WebStorageStoreState), localStorage
    //  (which has an interface Storage), and our own proprietary interface
    //  IStorage - i.e. we should really just be using the browser Web Storage
    //  API, e.g. "stateStore: window.localStorage,".
    // We are instantiating a new instance here, so the only value we need to
    // explicitly provide is the response mode (default otherwise will look
    // for a hash '#' fragment!).
    // eslint-disable-next-line camelcase
    response_mode: "query"
  });
  await client.clearStaleState(new import_oidc_client.WebStorageStateStore({}));
  const myStorage = window.localStorage;
  const itemsToRemove = [];
  for (let i = 0; i <= myStorage.length; i += 1) {
    const key3 = myStorage.key(i);
    if (key3 && (key3.match(/^oidc\..+$/) || key3.match(/^solidClientAuthenticationUser:.+$/))) {
      itemsToRemove.push(key3);
    }
  }
  itemsToRemove.forEach((key3) => myStorage.removeItem(key3));
}

// ../node_modules/@inrupt/solid-client-authn-browser/dist/index.mjs
var StorageUtilityBrowser = class extends StorageUtility {
  constructor(secureStorage, insecureStorage) {
    super(secureStorage, insecureStorage);
  }
};
var ClientAuthentication2 = class extends ClientAuthentication {
  constructor() {
    super(...arguments);
    this.login = async (options, eventEmitter) => {
      var _a, _b;
      await this.sessionInfoManager.clear(options.sessionId);
      const redirectUrl = (_a = options.redirectUrl) !== null && _a !== void 0 ? _a : normalizeCallbackUrl(window.location.href);
      if (!isValidRedirectUrl(redirectUrl)) {
        throw new Error(`${redirectUrl} is not a valid redirect URL, it is either a malformed IRI, includes a hash fragment, or reserved query parameters ('code' or 'state').`);
      }
      await this.loginHandler.handle({
        ...options,
        redirectUrl,
        // If no clientName is provided, the clientId may be used instead.
        clientName: (_b = options.clientName) !== null && _b !== void 0 ? _b : options.clientId,
        eventEmitter
      });
    };
    this.validateCurrentSession = async (currentSessionId) => {
      const sessionInfo = await this.sessionInfoManager.get(currentSessionId);
      if (sessionInfo === void 0 || sessionInfo.clientAppId === void 0 || sessionInfo.issuer === void 0) {
        return null;
      }
      return sessionInfo;
    };
    this.handleIncomingRedirect = async (url7, eventEmitter) => {
      try {
        const redirectInfo = await this.redirectHandler.handle(url7, eventEmitter, void 0);
        this.fetch = redirectInfo.fetch.bind(window);
        this.boundLogout = redirectInfo.getLogoutUrl;
        await this.cleanUrlAfterRedirect(url7);
        return {
          isLoggedIn: redirectInfo.isLoggedIn,
          webId: redirectInfo.webId,
          sessionId: redirectInfo.sessionId,
          expirationDate: redirectInfo.expirationDate,
          clientAppId: redirectInfo.clientAppId
        };
      } catch (err) {
        await this.cleanUrlAfterRedirect(url7);
        eventEmitter.emit(EVENTS.ERROR, "redirect", err);
        return void 0;
      }
    };
  }
  async cleanUrlAfterRedirect(url7) {
    const cleanedUpUrl = removeOpenIdParams(url7).href;
    window.history.replaceState(null, "", cleanedUpUrl);
    while (window.location.href !== cleanedUpUrl) {
      await new Promise((resolve) => {
        setTimeout(() => resolve(), 1);
      });
    }
  }
};
function hasIssuer(options) {
  return typeof options.oidcIssuer === "string";
}
function hasRedirectUrl(options) {
  return typeof options.redirectUrl === "string";
}
var OidcLoginHandler = class {
  constructor(storageUtility, oidcHandler, issuerConfigFetcher, clientRegistrar) {
    this.storageUtility = storageUtility;
    this.oidcHandler = oidcHandler;
    this.issuerConfigFetcher = issuerConfigFetcher;
    this.clientRegistrar = clientRegistrar;
    this.storageUtility = storageUtility;
    this.oidcHandler = oidcHandler;
    this.issuerConfigFetcher = issuerConfigFetcher;
    this.clientRegistrar = clientRegistrar;
  }
  async canHandle(options) {
    return hasIssuer(options) && hasRedirectUrl(options);
  }
  async handle(options) {
    if (!hasIssuer(options)) {
      throw new ConfigurationError(`OidcLoginHandler requires an OIDC issuer: missing property 'oidcIssuer' in ${JSON.stringify(options)}`);
    }
    if (!hasRedirectUrl(options)) {
      throw new ConfigurationError(`OidcLoginHandler requires a redirect URL: missing property 'redirectUrl' in ${JSON.stringify(options)}`);
    }
    const issuerConfig = await this.issuerConfigFetcher.fetchConfig(options.oidcIssuer);
    const clientRegistration = await handleRegistration(options, issuerConfig, this.storageUtility, this.clientRegistrar);
    const OidcOptions = {
      // Note that here, the issuer is not the one from the received options, but
      // from the issuer's config. This enforces the canonical URL is used and stored,
      // which is also the one present in the ID token, so storing a technically
      // valid, but different issuer URL (e.g. using a trailing slash or not) now
      // could prevent from validating the ID token later.
      issuer: issuerConfig.issuer,
      // TODO: differentiate if DPoP should be true
      dpop: options.tokenType.toLowerCase() === "dpop",
      ...options,
      issuerConfiguration: issuerConfig,
      client: clientRegistration
    };
    return this.oidcHandler.handle(OidcOptions);
  }
};
var AuthorizationCodeWithPkceOidcHandler = class extends AuthorizationCodeWithPkceOidcHandlerBase {
  async handle(oidcLoginOptions) {
    var _a;
    const oidcOptions = {
      authority: oidcLoginOptions.issuer.toString(),
      client_id: oidcLoginOptions.client.clientId,
      client_secret: oidcLoginOptions.client.clientSecret,
      redirect_uri: oidcLoginOptions.redirectUrl,
      response_type: "code",
      scope: DEFAULT_SCOPES,
      filterProtocolClaims: true,
      // The userinfo endpoint on NSS fails, so disable this for now
      // Note that in Solid, information should be retrieved from the
      // profile referenced by the WebId.
      loadUserInfo: false,
      code_verifier: true,
      prompt: (_a = oidcLoginOptions.prompt) !== null && _a !== void 0 ? _a : "consent"
    };
    const oidcClientLibrary = new import_oidc_client2.OidcClient(oidcOptions);
    try {
      const signingRequest = await oidcClientLibrary.createSigninRequest();
      return await this.handleRedirect({
        oidcLoginOptions,
        // eslint-disable-next-line no-underscore-dangle
        state: signingRequest.state._id,
        // eslint-disable-next-line no-underscore-dangle
        codeVerifier: signingRequest.state._code_verifier,
        targetUrl: signingRequest.url.toString()
      });
    } catch (err) {
      console.error(err);
    }
    return void 0;
  }
};
var WELL_KNOWN_OPENID_CONFIG = ".well-known/openid-configuration";
var issuerConfigKeyMap = {
  issuer: {
    toKey: "issuer",
    convertToUrl: true
  },
  authorization_endpoint: {
    toKey: "authorizationEndpoint",
    convertToUrl: true
  },
  token_endpoint: {
    toKey: "tokenEndpoint",
    convertToUrl: true
  },
  userinfo_endpoint: {
    toKey: "userinfoEndpoint",
    convertToUrl: true
  },
  jwks_uri: {
    toKey: "jwksUri",
    convertToUrl: true
  },
  registration_endpoint: {
    toKey: "registrationEndpoint",
    convertToUrl: true
  },
  end_session_endpoint: {
    toKey: "endSessionEndpoint",
    convertToUrl: true
  },
  scopes_supported: { toKey: "scopesSupported" },
  response_types_supported: { toKey: "responseTypesSupported" },
  response_modes_supported: { toKey: "responseModesSupported" },
  grant_types_supported: { toKey: "grantTypesSupported" },
  acr_values_supported: { toKey: "acrValuesSupported" },
  subject_types_supported: { toKey: "subjectTypesSupported" },
  id_token_signing_alg_values_supported: {
    toKey: "idTokenSigningAlgValuesSupported"
  },
  id_token_encryption_alg_values_supported: {
    toKey: "idTokenEncryptionAlgValuesSupported"
  },
  id_token_encryption_enc_values_supported: {
    toKey: "idTokenEncryptionEncValuesSupported"
  },
  userinfo_signing_alg_values_supported: {
    toKey: "userinfoSigningAlgValuesSupported"
  },
  userinfo_encryption_alg_values_supported: {
    toKey: "userinfoEncryptionAlgValuesSupported"
  },
  userinfo_encryption_enc_values_supported: {
    toKey: "userinfoEncryptionEncValuesSupported"
  },
  request_object_signing_alg_values_supported: {
    toKey: "requestObjectSigningAlgValuesSupported"
  },
  request_object_encryption_alg_values_supported: {
    toKey: "requestObjectEncryptionAlgValuesSupported"
  },
  request_object_encryption_enc_values_supported: {
    toKey: "requestObjectEncryptionEncValuesSupported"
  },
  token_endpoint_auth_methods_supported: {
    toKey: "tokenEndpointAuthMethodsSupported"
  },
  token_endpoint_auth_signing_alg_values_supported: {
    toKey: "tokenEndpointAuthSigningAlgValuesSupported"
  },
  display_values_supported: { toKey: "displayValuesSupported" },
  claim_types_supported: { toKey: "claimTypesSupported" },
  claims_supported: { toKey: "claimsSupported" },
  service_documentation: { toKey: "serviceDocumentation" },
  claims_locales_supported: { toKey: "claimsLocalesSupported" },
  ui_locales_supported: { toKey: "uiLocalesSupported" },
  claims_parameter_supported: { toKey: "claimsParameterSupported" },
  request_parameter_supported: { toKey: "requestParameterSupported" },
  request_uri_parameter_supported: { toKey: "requestUriParameterSupported" },
  require_request_uri_registration: { toKey: "requireRequestUriRegistration" },
  op_policy_uri: {
    toKey: "opPolicyUri",
    convertToUrl: true
  },
  op_tos_uri: {
    toKey: "opTosUri",
    convertToUrl: true
  }
};
function processConfig(config2) {
  const parsedConfig = {};
  Object.keys(config2).forEach((key3) => {
    if (issuerConfigKeyMap[key3]) {
      parsedConfig[issuerConfigKeyMap[key3].toKey] = config2[key3];
    }
  });
  if (!Array.isArray(parsedConfig.scopesSupported)) {
    parsedConfig.scopesSupported = ["openid"];
  }
  return parsedConfig;
}
var IssuerConfigFetcher = class _IssuerConfigFetcher {
  constructor(storageUtility) {
    this.storageUtility = storageUtility;
    this.storageUtility = storageUtility;
  }
  // This method needs no state (so can be static), and can be exposed to allow
  // callers to know where this implementation puts state it needs.
  static getLocalStorageKey(issuer2) {
    return `issuerConfig:${issuer2}`;
  }
  async fetchConfig(issuer2) {
    let issuerConfig;
    const openIdConfigUrl = new URL(
      WELL_KNOWN_OPENID_CONFIG,
      // Make sure to append a slash at issuer URL, so that the .well-known URL
      // includes the full issuer path. See https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderConfig.
      issuer2.endsWith("/") ? issuer2 : `${issuer2}/`
    ).href;
    const issuerConfigRequestBody = await fetch(openIdConfigUrl);
    try {
      issuerConfig = processConfig(await issuerConfigRequestBody.json());
    } catch (err) {
      throw new ConfigurationError(`[${issuer2.toString()}] has an invalid configuration: ${err.message}`);
    }
    await this.storageUtility.set(_IssuerConfigFetcher.getLocalStorageKey(issuer2), JSON.stringify(issuerConfig));
    return issuerConfig;
  }
};
async function clear2(sessionId, storage2) {
  await clear(sessionId, storage2);
  await clearOidcPersistentStorage();
}
var SessionInfoManager = class extends SessionInfoManagerBase {
  async get(sessionId) {
    const [isLoggedIn2, webId, clientId, clientSecret, redirectUrl, refreshToken, issuer2, tokenType] = await Promise.all([
      this.storageUtility.getForUser(sessionId, "isLoggedIn", {
        secure: true
      }),
      this.storageUtility.getForUser(sessionId, "webId", {
        secure: true
      }),
      this.storageUtility.getForUser(sessionId, "clientId", {
        secure: false
      }),
      this.storageUtility.getForUser(sessionId, "clientSecret", {
        secure: false
      }),
      this.storageUtility.getForUser(sessionId, "redirectUrl", {
        secure: false
      }),
      this.storageUtility.getForUser(sessionId, "refreshToken", {
        secure: true
      }),
      this.storageUtility.getForUser(sessionId, "issuer", {
        secure: false
      }),
      this.storageUtility.getForUser(sessionId, "tokenType", {
        secure: false
      })
    ]);
    if (typeof redirectUrl === "string" && !isValidRedirectUrl(redirectUrl)) {
      await Promise.all([
        this.storageUtility.deleteAllUserData(sessionId, { secure: false }),
        this.storageUtility.deleteAllUserData(sessionId, { secure: true })
      ]);
      return void 0;
    }
    if (tokenType !== void 0 && !isSupportedTokenType(tokenType)) {
      throw new Error(`Tokens of type [${tokenType}] are not supported.`);
    }
    if (clientId === void 0 && isLoggedIn2 === void 0 && webId === void 0 && refreshToken === void 0) {
      return void 0;
    }
    return {
      sessionId,
      webId,
      isLoggedIn: isLoggedIn2 === "true",
      redirectUrl,
      refreshToken,
      issuer: issuer2,
      clientAppId: clientId,
      clientAppSecret: clientSecret,
      // Default the token type to DPoP if unspecified.
      tokenType: tokenType !== null && tokenType !== void 0 ? tokenType : "DPoP"
    };
  }
  /**
   * This function removes all session-related information from storage.
   * @param sessionId the session identifier
   * @param storage the storage where session info is stored
   * @hidden
   */
  async clear(sessionId) {
    return clear2(sessionId, this.storageUtility);
  }
};
var FallbackRedirectHandler = class {
  async canHandle(redirectUrl) {
    try {
      new URL(redirectUrl);
      return true;
    } catch (e) {
      throw new Error(`[${redirectUrl}] is not a valid URL, and cannot be used as a redirect URL: ${e}`);
    }
  }
  async handle(_redirectUrl) {
    return getUnauthenticatedSession();
  }
};
var AuthCodeRedirectHandler = class {
  constructor(storageUtility, sessionInfoManager, issuerConfigFetcher, clientRegistrar, tokerRefresher) {
    this.storageUtility = storageUtility;
    this.sessionInfoManager = sessionInfoManager;
    this.issuerConfigFetcher = issuerConfigFetcher;
    this.clientRegistrar = clientRegistrar;
    this.tokerRefresher = tokerRefresher;
    this.storageUtility = storageUtility;
    this.sessionInfoManager = sessionInfoManager;
    this.issuerConfigFetcher = issuerConfigFetcher;
    this.clientRegistrar = clientRegistrar;
    this.tokerRefresher = tokerRefresher;
  }
  async canHandle(redirectUrl) {
    try {
      const myUrl = new URL(redirectUrl);
      return myUrl.searchParams.get("code") !== null && myUrl.searchParams.get("state") !== null;
    } catch (e) {
      throw new Error(`[${redirectUrl}] is not a valid URL, and cannot be used as a redirect URL: ${e}`);
    }
  }
  async handle(redirectUrl, eventEmitter) {
    if (!await this.canHandle(redirectUrl)) {
      throw new Error(`AuthCodeRedirectHandler cannot handle [${redirectUrl}]: it is missing one of [code, state].`);
    }
    const url7 = new URL(redirectUrl);
    const oauthState = url7.searchParams.get("state");
    const storedSessionId = await this.storageUtility.getForUser(oauthState, "sessionId", {
      errorIfNull: true
    });
    const { issuerConfig, codeVerifier, redirectUrl: storedRedirectIri, dpop: isDpop } = await loadOidcContextFromStorage(storedSessionId, this.storageUtility, this.issuerConfigFetcher);
    const iss = url7.searchParams.get("iss");
    if (typeof iss === "string" && iss !== issuerConfig.issuer) {
      throw new Error(`The value of the iss parameter (${iss}) does not match the issuer identifier of the authorization server (${issuerConfig.issuer}). See [rfc9207](https://www.rfc-editor.org/rfc/rfc9207.html#section-2.3-3.1.1)`);
    }
    if (codeVerifier === void 0) {
      throw new Error(`The code verifier for session ${storedSessionId} is missing from storage.`);
    }
    if (storedRedirectIri === void 0) {
      throw new Error(`The redirect URL for session ${storedSessionId} is missing from storage.`);
    }
    const client = await this.clientRegistrar.getClient({ sessionId: storedSessionId }, issuerConfig);
    const tokenCreatedAt = Date.now();
    const tokens = await getTokens(issuerConfig, client, {
      grantType: "authorization_code",
      // We rely on our 'canHandle' function checking that the OAuth 'code'
      // parameter is present in our query string.
      code: url7.searchParams.get("code"),
      codeVerifier,
      redirectUrl: storedRedirectIri
    }, isDpop);
    window.localStorage.removeItem(`oidc.${oauthState}`);
    let refreshOptions;
    if (tokens.refreshToken !== void 0) {
      refreshOptions = {
        sessionId: storedSessionId,
        refreshToken: tokens.refreshToken,
        tokenRefresher: this.tokerRefresher
      };
    }
    const authFetch = await buildAuthenticatedFetch(tokens.accessToken, {
      dpopKey: tokens.dpopKey,
      refreshOptions,
      eventEmitter,
      expiresIn: tokens.expiresIn
    });
    await saveSessionInfoToStorage(this.storageUtility, storedSessionId, tokens.webId, tokens.clientId, "true", void 0, true);
    const sessionInfo = await this.sessionInfoManager.get(storedSessionId);
    if (!sessionInfo) {
      throw new Error(`Could not retrieve session: [${storedSessionId}].`);
    }
    return Object.assign(sessionInfo, {
      fetch: authFetch,
      getLogoutUrl: maybeBuildRpInitiatedLogout({
        idTokenHint: tokens.idToken,
        endSessionEndpoint: issuerConfig.endSessionEndpoint
      }),
      expirationDate: typeof tokens.expiresIn === "number" ? tokenCreatedAt + tokens.expiresIn * 1e3 : void 0
    });
  }
};
var AggregateRedirectHandler = class extends AggregateHandler {
  constructor(redirectHandlers) {
    super(redirectHandlers);
  }
};
var BrowserStorage = class {
  get storage() {
    return window.localStorage;
  }
  async get(key3) {
    return this.storage.getItem(key3) || void 0;
  }
  async set(key3, value6) {
    this.storage.setItem(key3, value6);
  }
  async delete(key3) {
    this.storage.removeItem(key3);
  }
};
var Redirector = class {
  redirect(redirectUrl, options) {
    if (options && options.handleRedirect) {
      options.handleRedirect(redirectUrl);
    } else if (options && options.redirectByReplacingState) {
      window.history.replaceState({}, "", redirectUrl);
    } else {
      window.location.href = redirectUrl;
    }
  }
};
var ClientRegistrar = class {
  constructor(storageUtility) {
    this.storageUtility = storageUtility;
    this.storageUtility = storageUtility;
  }
  async getClient(options, issuerConfig) {
    const [storedClientId, storedClientSecret, storedClientName, storedClientType] = await Promise.all([
      this.storageUtility.getForUser(options.sessionId, "clientId", {
        secure: false
      }),
      this.storageUtility.getForUser(options.sessionId, "clientSecret", {
        secure: false
      }),
      this.storageUtility.getForUser(options.sessionId, "clientName", {
        secure: false
      }),
      this.storageUtility.getForUser(options.sessionId, "clientType", {
        secure: false
      })
    ]);
    if (storedClientId && isKnownClientType(storedClientType)) {
      return {
        clientId: storedClientId,
        clientSecret: storedClientSecret,
        clientName: storedClientName,
        // Note: static clients are not applicable in a browser context.
        clientType: storedClientType
      };
    }
    try {
      const registeredClient = await registerClient(options, issuerConfig);
      const infoToSave = {
        clientId: registeredClient.clientId,
        clientType: "dynamic"
      };
      if (registeredClient.clientSecret) {
        infoToSave.clientSecret = registeredClient.clientSecret;
      }
      if (registeredClient.idTokenSignedResponseAlg) {
        infoToSave.idTokenSignedResponseAlg = registeredClient.idTokenSignedResponseAlg;
      }
      await this.storageUtility.setForUser(options.sessionId, infoToSave, {
        // FIXME: figure out how to persist secure storage at reload
        // Otherwise, the client info cannot be retrieved from storage, and
        // the lib tries to re-register the client on each fetch
        secure: false
      });
      return registeredClient;
    } catch (error4) {
      throw new Error(`Client registration failed: [${error4}]`);
    }
  }
};
var ErrorOidcHandler = class {
  async canHandle(redirectUrl) {
    try {
      return new URL(redirectUrl).searchParams.has("error");
    } catch (e) {
      throw new Error(`[${redirectUrl}] is not a valid URL, and cannot be used as a redirect URL: ${e}`);
    }
  }
  async handle(redirectUrl, eventEmitter) {
    if (eventEmitter !== void 0) {
      const url7 = new URL(redirectUrl);
      const errorUrl = url7.searchParams.get("error");
      const errorDescriptionUrl = url7.searchParams.get("error_description");
      eventEmitter.emit(EVENTS.ERROR, errorUrl, errorDescriptionUrl);
    }
    return getUnauthenticatedSession();
  }
};
var TokenRefresher = class {
  constructor(storageUtility, issuerConfigFetcher, clientRegistrar) {
    this.storageUtility = storageUtility;
    this.issuerConfigFetcher = issuerConfigFetcher;
    this.clientRegistrar = clientRegistrar;
    this.storageUtility = storageUtility;
    this.issuerConfigFetcher = issuerConfigFetcher;
    this.clientRegistrar = clientRegistrar;
  }
  async refresh(sessionId, refreshToken, dpopKey, eventEmitter) {
    const oidcContext = await loadOidcContextFromStorage(sessionId, this.storageUtility, this.issuerConfigFetcher);
    const clientInfo = await this.clientRegistrar.getClient({ sessionId }, oidcContext.issuerConfig);
    if (refreshToken === void 0) {
      throw new Error(`Session [${sessionId}] has no refresh token to allow it to refresh its access token.`);
    }
    if (oidcContext.dpop && dpopKey === void 0) {
      throw new Error(`For session [${sessionId}], the key bound to the DPoP access token must be provided to refresh said access token.`);
    }
    const tokenSet = await refresh(refreshToken, oidcContext.issuerConfig, clientInfo, dpopKey);
    if (tokenSet.refreshToken !== void 0) {
      eventEmitter === null || eventEmitter === void 0 ? void 0 : eventEmitter.emit(EVENTS.NEW_REFRESH_TOKEN, tokenSet.refreshToken);
    }
    return tokenSet;
  }
};
function getClientAuthenticationWithDependencies(dependencies3) {
  const inMemoryStorage = new InMemoryStorage();
  const secureStorage = dependencies3.secureStorage || inMemoryStorage;
  const insecureStorage = dependencies3.insecureStorage || new BrowserStorage();
  const storageUtility = new StorageUtilityBrowser(secureStorage, insecureStorage);
  const issuerConfigFetcher = new IssuerConfigFetcher(storageUtility);
  const clientRegistrar = new ClientRegistrar(storageUtility);
  const sessionInfoManager = new SessionInfoManager(storageUtility);
  const tokenRefresher = new TokenRefresher(storageUtility, issuerConfigFetcher, clientRegistrar);
  const redirector = new Redirector();
  const loginHandler = new OidcLoginHandler(storageUtility, new AuthorizationCodeWithPkceOidcHandler(storageUtility, redirector), issuerConfigFetcher, clientRegistrar);
  const redirectHandler = new AggregateRedirectHandler([
    new ErrorOidcHandler(),
    new AuthCodeRedirectHandler(storageUtility, sessionInfoManager, issuerConfigFetcher, clientRegistrar, tokenRefresher),
    // This catch-all class will always be able to handle the
    // redirect IRI, so it must be registered last.
    new FallbackRedirectHandler()
  ]);
  return new ClientAuthentication2(loginHandler, redirectHandler, new IWaterfallLogoutHandler(sessionInfoManager, redirector), sessionInfoManager, issuerConfigFetcher);
}
var KEY_CURRENT_SESSION = `${SOLID_CLIENT_AUTHN_KEY_PREFIX}currentSession`;
var KEY_CURRENT_URL = `${SOLID_CLIENT_AUTHN_KEY_PREFIX}currentUrl`;
async function silentlyAuthenticate(sessionId, clientAuthn, session4) {
  var _a;
  const storedSessionInfo = await clientAuthn.validateCurrentSession(sessionId);
  if (storedSessionInfo !== null) {
    window.localStorage.setItem(KEY_CURRENT_URL, window.location.href);
    await clientAuthn.login({
      sessionId,
      prompt: "none",
      oidcIssuer: storedSessionInfo.issuer,
      redirectUrl: storedSessionInfo.redirectUrl,
      clientId: storedSessionInfo.clientAppId,
      clientSecret: storedSessionInfo.clientAppSecret,
      tokenType: (_a = storedSessionInfo.tokenType) !== null && _a !== void 0 ? _a : "DPoP"
    }, session4.events);
    return true;
  }
  return false;
}
function isLoggedIn(sessionInfo) {
  return !!(sessionInfo === null || sessionInfo === void 0 ? void 0 : sessionInfo.isLoggedIn);
}
var Session = class {
  /**
   * Session object constructor. Typically called as follows:
   *
   * ```typescript
   * const session = new Session();
   * ```
   *
   * See also [getDefaultSession](https://docs.inrupt.com/developer-tools/api/javascript/solid-client-authn-browser/functions.html#getdefaultsession).
   *
   * @param sessionOptions The options enabling the correct instantiation of
   * the session. Either both storages or clientAuthentication are required. For
   * more information, see {@link ISessionOptions}.
   * @param sessionId A string uniquely identifying the session.
   *
   */
  constructor(sessionOptions = {}, sessionId = void 0) {
    this.tokenRequestInProgress = false;
    this.login = async (options) => {
      var _a;
      await this.clientAuthentication.login({
        sessionId: this.info.sessionId,
        ...options,
        // Defaults the token type to DPoP
        tokenType: (_a = options.tokenType) !== null && _a !== void 0 ? _a : "DPoP"
      }, this.events);
      return new Promise(() => {
      });
    };
    this.fetch = (url7, init) => this.clientAuthentication.fetch(url7, init);
    this.internalLogout = async (emitSignal, options) => {
      window.localStorage.removeItem(KEY_CURRENT_SESSION);
      await this.clientAuthentication.logout(this.info.sessionId, options);
      this.info.isLoggedIn = false;
      if (emitSignal) {
        this.events.emit(EVENTS.LOGOUT);
      }
    };
    this.logout = async (options) => this.internalLogout(true, options);
    this.handleIncomingRedirect = async (inputOptions = {}) => {
      var _a;
      if (this.info.isLoggedIn) {
        return this.info;
      }
      if (this.tokenRequestInProgress) {
        return void 0;
      }
      const options = typeof inputOptions === "string" ? { url: inputOptions } : inputOptions;
      const url7 = (_a = options.url) !== null && _a !== void 0 ? _a : window.location.href;
      this.tokenRequestInProgress = true;
      const sessionInfo = await this.clientAuthentication.handleIncomingRedirect(url7, this.events);
      if (isLoggedIn(sessionInfo)) {
        this.setSessionInfo(sessionInfo);
        const currentUrl = window.localStorage.getItem(KEY_CURRENT_URL);
        if (currentUrl === null) {
          this.events.emit(EVENTS.LOGIN);
        } else {
          window.localStorage.removeItem(KEY_CURRENT_URL);
          this.events.emit(EVENTS.SESSION_RESTORED, currentUrl);
        }
      } else if (options.restorePreviousSession === true) {
        const storedSessionId = window.localStorage.getItem(KEY_CURRENT_SESSION);
        if (storedSessionId !== null) {
          const attemptedSilentAuthentication = await silentlyAuthenticate(storedSessionId, this.clientAuthentication, this);
          if (attemptedSilentAuthentication) {
            return new Promise(() => {
            });
          }
        }
      }
      this.tokenRequestInProgress = false;
      return sessionInfo;
    };
    this.events = new import_events.default();
    if (sessionOptions.clientAuthentication) {
      this.clientAuthentication = sessionOptions.clientAuthentication;
    } else if (sessionOptions.secureStorage && sessionOptions.insecureStorage) {
      this.clientAuthentication = getClientAuthenticationWithDependencies({
        secureStorage: sessionOptions.secureStorage,
        insecureStorage: sessionOptions.insecureStorage
      });
    } else {
      this.clientAuthentication = getClientAuthenticationWithDependencies({});
    }
    if (sessionOptions.sessionInfo) {
      this.info = {
        sessionId: sessionOptions.sessionInfo.sessionId,
        isLoggedIn: false,
        webId: sessionOptions.sessionInfo.webId,
        clientAppId: sessionOptions.sessionInfo.clientAppId
      };
    } else {
      this.info = {
        sessionId: sessionId !== null && sessionId !== void 0 ? sessionId : v4_default2(),
        isLoggedIn: false
      };
    }
    this.events.on(EVENTS.LOGIN, () => window.localStorage.setItem(KEY_CURRENT_SESSION, this.info.sessionId));
    this.events.on(EVENTS.SESSION_EXPIRED, () => this.internalLogout(false));
    this.events.on(EVENTS.ERROR, () => this.internalLogout(false));
  }
  setSessionInfo(sessionInfo) {
    this.info.isLoggedIn = sessionInfo.isLoggedIn;
    this.info.webId = sessionInfo.webId;
    this.info.sessionId = sessionInfo.sessionId;
    this.info.clientAppId = sessionInfo.clientAppId;
    this.info.expirationDate = sessionInfo.expirationDate;
    this.events.on(EVENTS.SESSION_EXTENDED, (expiresIn) => {
      this.info.expirationDate = Date.now() + expiresIn * 1e3;
    });
  }
};

// src/authentication/observeSession.ts
function observeSession(session4) {
  const sessionInfoSubject = new BehaviorSubject(session4.info);
  const login = fromEvent(session4.events, EVENTS.LOGIN);
  const logout = fromEvent(session4.events, EVENTS.LOGOUT);
  const sessionRestored = fromEvent(session4.events, EVENTS.SESSION_RESTORED);
  merge(login, logout, sessionRestored).pipe(map(() => sessionInfoSubject.next(session4.info))).subscribe();
  return sessionInfoSubject;
}

// src/authentication/index.ts
var BrowserSession = class {
  get authenticatedFetch() {
    return this._authenticatedFetch;
  }
  constructor() {
    this.session = new Session();
    this.sessionInfo$ = observeSession(this.session);
    this._authenticatedFetch = this.session.fetch;
  }
  async handleIncomingRedirect(restorePreviousSession = false) {
    return this.session.handleIncomingRedirect({
      restorePreviousSession
    });
  }
  async login(oidcIssuer2) {
    return this.session.login({
      oidcIssuer: oidcIssuer2,
      redirectUrl: window.location.href,
      clientName: `Pod OS at ${window.location.host}`
    });
  }
  async logout() {
    return this.session.logout();
  }
  /**
   * @deprecated use observeSession instead
   */
  trackSession(callback) {
    this.session.events.on(EVENTS.LOGIN, () => callback(this.session.info));
    this.session.events.on(EVENTS.LOGOUT, () => callback(this.session.info));
    this.session.events.on(
      EVENTS.SESSION_RESTORED,
      () => callback(this.session.info)
    );
    callback(this.session.info);
  }
  observeSession() {
    return this.sessionInfo$;
  }
  onSessionRestore(callback) {
    this.session.events.on(EVENTS.SESSION_RESTORED, callback);
  }
};

// src/files/BinaryFile.ts
var BinaryFile = class {
  constructor(url7, data2) {
    this.url = url7;
    this.data = data2;
  }
  blob() {
    return this.data;
  }
};

// src/files/BrokenFile.ts
var BrokenFile = class {
  constructor(url7, status9) {
    this.url = url7;
    this.status = status9;
  }
  toString() {
    return `${this.status.toString()} - ${this.url}`;
  }
  blob() {
    return null;
  }
};

// src/files/HttpStatus.ts
var HttpStatus = class {
  constructor(code4, text4) {
    this.code = code4;
    this.text = text4;
  }
  toString() {
    return this.text ? `${this.code} - ${this.text}` : this.code.toString();
  }
};

// src/files/FileFetcher.ts
var FileFetcher = class {
  constructor(session4) {
    this.session = session4;
  }
  async fetchFile(url7) {
    const response6 = await this.session.authenticatedFetch(url7);
    if (response6.ok) {
      const blob = await response6.blob();
      return new BinaryFile(url7, blob);
    } else {
      return new BrokenFile(
        url7,
        new HttpStatus(response6.status, response6.statusText)
      );
    }
  }
};

// src/modules/contacts.ts
async function loadContactsModule(store) {
  const module2 = await import("./dist-F3EUFQHU.js");
  return new module2.default({
    store: store.graph,
    fetcher: store.fetcher,
    updater: store.updater
  });
}

// src/thing/accumulateSubjects.ts
var accumulateSubjects = (accumulator, current2) => {
  const existing = accumulator[current2.predicate.uri];
  return {
    ...accumulator,
    [current2.predicate.uri]: existing ? [...existing, current2.subject.value] : [current2.subject.value]
  };
};

// src/thing/accumulateValues.ts
var accumulateValues = (accumulator, current2) => {
  const existing = accumulator[current2.predicate.uri];
  return {
    ...accumulator,
    [current2.predicate.uri]: existing ? [...existing, current2.object.value] : [current2.object.value]
  };
};

// src/thing/isRdfType.ts
function isRdfType(predicate2) {
  return predicate2.sameTerm(
    namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type")
  );
}

// src/thing/labelForType.ts
function labelForType(typeUri) {
  if (typeUri.includes("#")) {
    return typeUri.substring(typeUri.lastIndexOf("#") + 1);
  } else {
    return typeUri.substring(typeUri.lastIndexOf("/") + 1);
  }
}

// src/thing/labelFromUri.ts
function labelFromUri(uri6) {
  const url7 = new URL(uri6);
  if (isTooGeneric(url7.hash)) {
    return (getFilename(url7) || url7.host + url7.pathname) + url7.hash;
  }
  return labelFromFragment(url7.hash) || getFilename(url7) || url7.host;
}
function labelFromFragment(fragment) {
  return fragment ? fragment.split("#")[1] : null;
}
function isTooGeneric(fragment) {
  const genericFragments = ["#it", "#this", "#me", "#i"];
  return genericFragments.includes(fragment);
}
function getFilename(url7) {
  if (url7.pathname.endsWith("/")) {
    const containerName = url7.pathname.split("/").at(-2);
    return containerName ? containerName + "/" : null;
  } else {
    return url7.pathname.split("/").pop();
  }
}

// src/thing/Thing.ts
var Thing = class {
  constructor(uri6, store, editable = false) {
    this.uri = uri6;
    this.store = store;
    this.editable = editable;
  }
  label() {
    const value6 = this.anyValue(
      "http://www.w3.org/2006/vcard/ns#fn",
      "http://xmlns.com/foaf/0.1/name",
      "http://xmlns.com/foaf/0.1/nick",
      "https://schema.org/name",
      "http://schema.org/name",
      "http://purl.org/dc/terms/title",
      "http://purl.org/dc/elements/1.1/title",
      "http://www.w3.org/2000/01/rdf-schema#label",
      "https://www.w3.org/ns/activitystreams#name",
      "http://schema.org/caption",
      "https://schema.org/caption"
    );
    if (value6) {
      return value6;
    }
    return labelFromUri(this.uri);
  }
  literals() {
    const statements = this.store.statementsMatching(namedNode(this.uri));
    const values = statements.filter((it) => isLiteral(it.object)).reduce(accumulateValues, {});
    return Object.keys(values).map((predicate2) => ({
      predicate: predicate2,
      label: labelFromUri(predicate2),
      values: values[predicate2]
    }));
  }
  relations() {
    const statements = this.store.statementsMatching(namedNode(this.uri));
    const values = statements.filter((it) => isNamedNode(it.object) && !isRdfType(it.predicate)).reduce(accumulateValues, {});
    return Object.keys(values).map((predicate2) => ({
      predicate: predicate2,
      label: labelFromUri(predicate2),
      uris: values[predicate2]
    }));
  }
  reverseRelations() {
    const statements = this.store.statementsMatching(
      void 0,
      void 0,
      namedNode(this.uri)
    );
    const values = statements.reduce(accumulateSubjects, {});
    return Object.keys(values).map((predicate2) => ({
      predicate: predicate2,
      label: labelFromUri(predicate2),
      uris: values[predicate2]
    }));
  }
  anyValue(...predicateUris) {
    let value6;
    predicateUris.some((it) => {
      value6 = this.store.anyValue(namedNode(this.uri), namedNode(it));
      return Boolean(value6);
    });
    return value6;
  }
  description() {
    return this.anyValue(
      "http://purl.org/dc/terms/description",
      "http://purl.org/dc/elements/1.1/description",
      "http://schema.org/description",
      "https://schema.org/description",
      "https://schema.org/text",
      "http://www.w3.org/2000/01/rdf-schema#comment",
      "https://www.w3.org/ns/activitystreams#summary",
      "https://www.w3.org/ns/activitystreams#content",
      "http://www.w3.org/2006/vcard/ns#note"
    );
  }
  picture() {
    const directUrl = this.anyValue(
      "http://schema.org/image",
      "https://schema.org/image",
      "http://schema.org/logo",
      "https://schema.org/logo",
      "http://www.w3.org/2006/vcard/ns#hasPhoto",
      "http://www.w3.org/2006/vcard/ns#photo",
      "http://www.w3.org/2006/vcard/ns#hasLogo",
      "http://www.w3.org/2006/vcard/ns#logo",
      "http://xmlns.com/foaf/0.1/img",
      "http://xmlns.com/foaf/0.1/depiction",
      "http://xmlns.com/foaf/0.1/thumbnail"
    );
    if (directUrl) {
      return {
        url: directUrl
      };
    } else {
      return this.findActivityStreamsPicture();
    }
  }
  findActivityStreamsPicture() {
    const activityStreamsImage = this.store.any(
      namedNode(this.uri),
      namedNode("https://www.w3.org/ns/activitystreams#image")
    ) || this.store.any(
      namedNode(this.uri),
      namedNode("https://www.w3.org/ns/activitystreams#icon")
    );
    if (!activityStreamsImage || !(isBlankNode(activityStreamsImage) || isNamedNode(activityStreamsImage))) {
      return null;
    }
    const url7 = this.store.anyValue(
      activityStreamsImage,
      namedNode("https://www.w3.org/ns/activitystreams#url")
    );
    return url7 ? {
      url: url7
    } : null;
  }
  types() {
    const uriMap = this.store.findTypeURIs(namedNode(this.uri));
    return Object.keys(uriMap).map((uri6) => ({
      uri: uri6,
      label: labelForType(uri6)
    }));
  }
  assume(SpecificThing) {
    return new SpecificThing(this.uri, this.store, this.editable);
  }
};

// src/profile/WebIdProfile.ts
var WebIdProfile = class extends Thing {
  constructor(webId, store, editable = false) {
    super(webId, store, editable);
    this.webId = webId;
    this.store = store;
    this.editable = editable;
  }
  /**
   * Returns te URI of the preferences document
   */
  getPreferencesFile() {
    return this.store.anyValue(
      namedNode(this.webId),
      namedNode("http://www.w3.org/ns/pim/space#preferencesFile"),
      void 0,
      namedNode(this.webId).doc()
    );
  }
  /**
   * Returns the URIs of the private label indexes
   */
  getPrivateLabelIndexes() {
    const profileNodes = this.store.each(
      namedNode(this.webId),
      namedNode("http://www.w3.org/ns/solid/terms#privateLabelIndex"),
      void 0,
      namedNode(this.webId).doc()
    );
    const preferences = this.getPreferencesFile();
    if (preferences) {
      const preferencesNodes = this.store.each(
        namedNode(this.webId),
        namedNode("http://www.w3.org/ns/solid/terms#privateLabelIndex"),
        void 0,
        namedNode(preferences)
      );
      return [...profileNodes, ...preferencesNodes].map((it) => it.value);
    } else {
      return profileNodes.map((it) => it.value);
    }
  }
};

// src/search/SearchIndex.ts
var import_lunr = __toESM(require_lunr());
var SearchIndex = class {
  constructor(indexes) {
    this.index = (0, import_lunr.default)(function() {
      this.ref("uri");
      this.field("uri");
      this.field("label");
      this.metadataWhitelist = ["position"];
      const items2 = indexes.flatMap((it) => it.getIndexedItems());
      items2.forEach((item4) => {
        this.add({
          uri: item4.uri,
          label: item4.label
        });
      });
    });
  }
  /**
   * Search the index for a given term. It finds partial matches, but will rank exact matches higher.
   *
   * The rank order is:
   *
   *  1. exact matches
   *  2. prefix matches
   *  3. suffix matches
   *  4. any matches inside a literal
   *
   * @param term The (partial) term to search for
   * @param maxResults The maximum number of results to return (defaults to 10)
   */
  search(term2, maxResults = 10) {
    const escapedTerm = term2.replace(/[~^+:]/g, (x) => `\\${x}`);
    return this.index.search(
      `${escapedTerm}^100 ${escapedTerm}*^20 *${escapedTerm}^10 *${escapedTerm}*^5`
    ).slice(0, maxResults);
  }
  /**
   * Remove all data from the search index.
   */
  clear() {
    this.index = (0, import_lunr.default)(() => {
    });
  }
};

// src/rdf-document/RdfDocument.ts
var RdfDocument = class extends Thing {
  constructor(uri6, store, editable = false) {
    super(uri6, store, editable);
    this.uri = uri6;
    this.store = store;
    this.editable = editable;
  }
  subjects() {
    const matches = this.store.statementsMatching(
      null,
      null,
      null,
      namedNode(this.uri)
    );
    const uris = matches.filter((match) => isNamedNode(match.subject)).map((match) => match.subject.value);
    const uniqueUris = new Set(uris);
    uniqueUris.delete(this.uri);
    return [...uniqueUris].map((uri6) => ({
      uri: uri6
    }));
  }
};

// src/search/LabelIndex.ts
var LabelIndex = class extends RdfDocument {
  constructor(uri6, store, editable = false) {
    super(uri6, store, editable);
    this.uri = uri6;
    this.store = store;
    this.editable = editable;
  }
  /**
   * Returns the URIs and labels for all the things listed in the document.
   */
  getIndexedItems() {
    const matches = this.store.statementsMatching(
      null,
      namedNode("http://www.w3.org/2000/01/rdf-schema#label"),
      null,
      namedNode(this.uri)
    );
    return matches.map((it) => {
      return {
        uri: it.subject.value,
        label: it.object.value
      };
    });
  }
};

// src/Store.ts
var Store = class {
  constructor(session4) {
    this.graph = graph();
    this.fetcher = fetcher(this.graph, { fetch: session4.authenticatedFetch });
    this.updater = new UpdateManager(this.graph);
  }
  /**
   * Fetch data for the given URI to the store
   * @param uri
   */
  fetch(uri6) {
    return this.fetcher.load(namedNode(uri6), {
      // force fetching due to
      // https://github.com/linkeddata/rdflib.js/issues/247
      // and
      // https://github.com/linkeddata/rdflib.js/issues/441
      force: true,
      // explicitly omit credentials due to
      // https://github.com/pod-os/PodOS/issues/17
      credentials: "omit"
    });
  }
  /**
   * Fetch all the given URIs in parallel and put the data to the store
   * @param uris
   */
  fetchAll(uris) {
    const responses = uris.map((uri6) => this.fetch(uri6));
    return Promise.allSettled(responses);
  }
  /**
   * Retrieve the thing identified by the given URI from the store
   * @param uri
   */
  get(uri6) {
    const editable = !!this.updater.editable(uri6);
    return new Thing(uri6, this.graph, editable);
  }
  /**
   * Adds a new value to the property of the given thing
   * @param thing
   * @param property
   * @param value
   */
  addPropertyValue(thing, property3, value6) {
    return this.updater.update(
      [],
      [st(namedNode(thing.uri), namedNode(property3), lit(value6), namedNode(thing.uri).doc())],
      void 0,
      false,
      {
        // explicitly omit credentials due to
        // https://github.com/pod-os/PodOS/issues/17
        credentials: "omit"
      }
    );
  }
  async addNewThing(uri6, name7, type5) {
    await this.updater.update(
      [],
      [
        st(
          namedNode(uri6),
          namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"),
          namedNode(type5),
          namedNode(uri6).doc()
        ),
        st(
          namedNode(uri6),
          namedNode("http://www.w3.org/2000/01/rdf-schema#label"),
          lit(name7),
          namedNode(uri6).doc()
        )
      ],
      void 0,
      false,
      {
        // explicitly omit credentials due to
        // https://github.com/pod-os/PodOS/issues/17
        credentials: "omit"
      }
    );
  }
};

// ../node_modules/rdf-namespaces/dist/index.es.js
var index_es_exports = {};
__export(index_es_exports, {
  acl: () => acl,
  arg: () => arg,
  as: () => as,
  cal: () => cal,
  contact: () => contact3,
  dc: () => dc,
  dct: () => dct,
  fhir: () => fhir,
  foaf: () => foaf,
  http: () => http,
  hydra: () => hydra,
  ldp: () => ldp,
  link: () => link3,
  log: () => log,
  meeting: () => meeting,
  owl: () => owl,
  qu: () => qu,
  rdf: () => rdf,
  rdfs: () => rdfs,
  sched: () => sched,
  schema: () => schema,
  schema_https: () => schema_https,
  sec: () => sec,
  sioc: () => sioc,
  skos: () => skos,
  solid: () => solid,
  space: () => space,
  tab: () => tab,
  tabont: () => tabont,
  trip: () => trip3,
  vcard: () => vcard,
  wf: () => wf
});

// ../node_modules/rdf-namespaces/dist/acl-cd02deb2.js
var Access = "http://www.w3.org/ns/auth/acl#Access";
var Append = "http://www.w3.org/ns/auth/acl#Append";
var AuthenticatedAgent = "http://www.w3.org/ns/auth/acl#AuthenticatedAgent";
var Authorization = "http://www.w3.org/ns/auth/acl#Authorization";
var Control = "http://www.w3.org/ns/auth/acl#Control";
var Origin = "http://www.w3.org/ns/auth/acl#Origin";
var Read = "http://www.w3.org/ns/auth/acl#Read";
var Write = "http://www.w3.org/ns/auth/acl#Write";
var accessControl = "http://www.w3.org/ns/auth/acl#accessControl";
var accessTo = "http://www.w3.org/ns/auth/acl#accessTo";
var accessToClass = "http://www.w3.org/ns/auth/acl#accessToClass";
var agent = "http://www.w3.org/ns/auth/acl#agent";
var agentClass = "http://www.w3.org/ns/auth/acl#agentClass";
var agentGroup = "http://www.w3.org/ns/auth/acl#agentGroup";
var default__workaround = "http://www.w3.org/ns/auth/acl#default";
var defaultForNew = "http://www.w3.org/ns/auth/acl#defaultForNew";
var delegates = "http://www.w3.org/ns/auth/acl#delegates";
var mode = "http://www.w3.org/ns/auth/acl#mode";
var origin = "http://www.w3.org/ns/auth/acl#origin";
var owner = "http://www.w3.org/ns/auth/acl#owner";
var aclImport = /* @__PURE__ */ Object.freeze({
  Access,
  Append,
  AuthenticatedAgent,
  Authorization,
  Control,
  Origin,
  Read,
  Write,
  accessControl,
  accessTo,
  accessToClass,
  agent,
  agentClass,
  agentGroup,
  default__workaround,
  defaultForNew,
  delegates,
  mode,
  origin,
  owner
});

// ../node_modules/rdf-namespaces/dist/arg-33a88d95.js
var Conjunction = "http://www.w3.org/ns/pim/arg#Conjunction";
var Position = "http://www.w3.org/ns/pim/arg#Position";
var Resolution = "http://www.w3.org/ns/pim/arg#Resolution";
var opposition = "http://www.w3.org/ns/pim/arg#opposition";
var requires = "http://www.w3.org/ns/pim/arg#requires";
var support = "http://www.w3.org/ns/pim/arg#support";
var argImport = /* @__PURE__ */ Object.freeze({
  Conjunction,
  Position,
  Resolution,
  opposition,
  requires,
  support
});

// ../node_modules/rdf-namespaces/dist/as-318e037b.js
var actor = "http://www.w3.org/ns/activitystreams#actor";
var attributedTo = "http://www.w3.org/ns/activitystreams#attributedTo";
var attachment = "http://www.w3.org/ns/activitystreams#attachment";
var attachments = "http://www.w3.org/ns/activitystreams#attachments";
var author = "http://www.w3.org/ns/activitystreams#author";
var bcc = "http://www.w3.org/ns/activitystreams#bcc";
var bto = "http://www.w3.org/ns/activitystreams#bto";
var cc = "http://www.w3.org/ns/activitystreams#cc";
var context2 = "http://www.w3.org/ns/activitystreams#context";
var generator = "http://www.w3.org/ns/activitystreams#generator";
var icon = "http://www.w3.org/ns/activitystreams#icon";
var image = "http://www.w3.org/ns/activitystreams#image";
var inReplyTo = "http://www.w3.org/ns/activitystreams#inReplyTo";
var items = "http://www.w3.org/ns/activitystreams#items";
var location2 = "http://www.w3.org/ns/activitystreams#location";
var object = "http://www.w3.org/ns/activitystreams#object";
var oneOf = "http://www.w3.org/ns/activitystreams#oneOf";
var anyOf = "http://www.w3.org/ns/activitystreams#anyOf";
var preview = "http://www.w3.org/ns/activitystreams#preview";
var provider = "http://www.w3.org/ns/activitystreams#provider";
var replies = "http://www.w3.org/ns/activitystreams#replies";
var result = "http://www.w3.org/ns/activitystreams#result";
var audience = "http://www.w3.org/ns/activitystreams#audience";
var tag2 = "http://www.w3.org/ns/activitystreams#tag";
var tags = "http://www.w3.org/ns/activitystreams#tags";
var target = "http://www.w3.org/ns/activitystreams#target";
var origin2 = "http://www.w3.org/ns/activitystreams#origin";
var instrument = "http://www.w3.org/ns/activitystreams#instrument";
var to = "http://www.w3.org/ns/activitystreams#to";
var url = "http://www.w3.org/ns/activitystreams#url";
var relationship = "http://www.w3.org/ns/activitystreams#relationship";
var describes = "http://www.w3.org/ns/activitystreams#describes";
var formerType = "http://www.w3.org/ns/activitystreams#formerType";
var accuracy = "http://www.w3.org/ns/activitystreams#accuracy";
var altitude = "http://www.w3.org/ns/activitystreams#altitude";
var content = "http://www.w3.org/ns/activitystreams#content";
var name = "http://www.w3.org/ns/activitystreams#name";
var downstreamDuplicates = "http://www.w3.org/ns/activitystreams#downstreamDuplicates";
var duration = "http://www.w3.org/ns/activitystreams#duration";
var endTime = "http://www.w3.org/ns/activitystreams#endTime";
var height = "http://www.w3.org/ns/activitystreams#height";
var href = "http://www.w3.org/ns/activitystreams#href";
var hreflang = "http://www.w3.org/ns/activitystreams#hreflang";
var id = "http://www.w3.org/ns/activitystreams#id";
var latitude = "http://www.w3.org/ns/activitystreams#latitude";
var longitude = "http://www.w3.org/ns/activitystreams#longitude";
var mediaType = "http://www.w3.org/ns/activitystreams#mediaType";
var objectType = "http://www.w3.org/ns/activitystreams#objectType";
var published = "http://www.w3.org/ns/activitystreams#published";
var radius = "http://www.w3.org/ns/activitystreams#radius";
var rating = "http://www.w3.org/ns/activitystreams#rating";
var rel = "http://www.w3.org/ns/activitystreams#rel";
var startIndex = "http://www.w3.org/ns/activitystreams#startIndex";
var startTime = "http://www.w3.org/ns/activitystreams#startTime";
var summary = "http://www.w3.org/ns/activitystreams#summary";
var totalItems = "http://www.w3.org/ns/activitystreams#totalItems";
var units = "http://www.w3.org/ns/activitystreams#units";
var updated = "http://www.w3.org/ns/activitystreams#updated";
var upstreamDuplicates = "http://www.w3.org/ns/activitystreams#upstreamDuplicates";
var verb = "http://www.w3.org/ns/activitystreams#verb";
var width = "http://www.w3.org/ns/activitystreams#width";
var deleted = "http://www.w3.org/ns/activitystreams#deleted";
var Accept = "http://www.w3.org/ns/activitystreams#Accept";
var Activity = "http://www.w3.org/ns/activitystreams#Activity";
var Block = "http://www.w3.org/ns/activitystreams#Block";
var IntransitiveActivity = "http://www.w3.org/ns/activitystreams#IntransitiveActivity";
var Add = "http://www.w3.org/ns/activitystreams#Add";
var Announce = "http://www.w3.org/ns/activitystreams#Announce";
var Application = "http://www.w3.org/ns/activitystreams#Application";
var Arrive = "http://www.w3.org/ns/activitystreams#Arrive";
var Article = "http://www.w3.org/ns/activitystreams#Article";
var Audio = "http://www.w3.org/ns/activitystreams#Audio";
var Collection = "http://www.w3.org/ns/activitystreams#Collection";
var CollectionPage = "http://www.w3.org/ns/activitystreams#CollectionPage";
var OrderedCollectionPage = "http://www.w3.org/ns/activitystreams#OrderedCollectionPage";
var Relationship = "http://www.w3.org/ns/activitystreams#Relationship";
var Create = "http://www.w3.org/ns/activitystreams#Create";
var Delete = "http://www.w3.org/ns/activitystreams#Delete";
var Dislike = "http://www.w3.org/ns/activitystreams#Dislike";
var Document = "http://www.w3.org/ns/activitystreams#Document";
var Event = "http://www.w3.org/ns/activitystreams#Event";
var Flag = "http://www.w3.org/ns/activitystreams#Flag";
var Follow = "http://www.w3.org/ns/activitystreams#Follow";
var Group = "http://www.w3.org/ns/activitystreams#Group";
var Ignore = "http://www.w3.org/ns/activitystreams#Ignore";
var Image = "http://www.w3.org/ns/activitystreams#Image";
var Invite = "http://www.w3.org/ns/activitystreams#Invite";
var Join = "http://www.w3.org/ns/activitystreams#Join";
var Leave = "http://www.w3.org/ns/activitystreams#Leave";
var Like = "http://www.w3.org/ns/activitystreams#Like";
var View = "http://www.w3.org/ns/activitystreams#View";
var Listen = "http://www.w3.org/ns/activitystreams#Listen";
var Read2 = "http://www.w3.org/ns/activitystreams#Read";
var Move = "http://www.w3.org/ns/activitystreams#Move";
var Travel = "http://www.w3.org/ns/activitystreams#Travel";
var Link = "http://www.w3.org/ns/activitystreams#Link";
var Mention = "http://www.w3.org/ns/activitystreams#Mention";
var Note = "http://www.w3.org/ns/activitystreams#Note";
var Object__workaround = "http://www.w3.org/ns/activitystreams#Object";
var Offer = "http://www.w3.org/ns/activitystreams#Offer";
var OrderedCollection = "http://www.w3.org/ns/activitystreams#OrderedCollection";
var OrderedItems = "http://www.w3.org/ns/activitystreams#OrderedItems";
var Page = "http://www.w3.org/ns/activitystreams#Page";
var Person = "http://www.w3.org/ns/activitystreams#Person";
var Organization = "http://www.w3.org/ns/activitystreams#Organization";
var Profile = "http://www.w3.org/ns/activitystreams#Profile";
var Place = "http://www.w3.org/ns/activitystreams#Place";
var Question = "http://www.w3.org/ns/activitystreams#Question";
var Reject = "http://www.w3.org/ns/activitystreams#Reject";
var Remove = "http://www.w3.org/ns/activitystreams#Remove";
var Service = "http://www.w3.org/ns/activitystreams#Service";
var TentativeAccept = "http://www.w3.org/ns/activitystreams#TentativeAccept";
var TentativeReject = "http://www.w3.org/ns/activitystreams#TentativeReject";
var Tombstone = "http://www.w3.org/ns/activitystreams#Tombstone";
var Undo = "http://www.w3.org/ns/activitystreams#Undo";
var Update = "http://www.w3.org/ns/activitystreams#Update";
var Video = "http://www.w3.org/ns/activitystreams#Video";
var asImport = /* @__PURE__ */ Object.freeze({
  actor,
  attributedTo,
  attachment,
  attachments,
  author,
  bcc,
  bto,
  cc,
  context: context2,
  generator,
  icon,
  image,
  inReplyTo,
  items,
  location: location2,
  object,
  oneOf,
  anyOf,
  preview,
  provider,
  replies,
  result,
  audience,
  tag: tag2,
  tags,
  target,
  origin: origin2,
  instrument,
  to,
  url,
  relationship,
  describes,
  formerType,
  accuracy,
  altitude,
  content,
  name,
  downstreamDuplicates,
  duration,
  endTime,
  height,
  href,
  hreflang,
  id,
  latitude,
  longitude,
  mediaType,
  objectType,
  published,
  radius,
  rating,
  rel,
  startIndex,
  startTime,
  summary,
  totalItems,
  units,
  updated,
  upstreamDuplicates,
  verb,
  width,
  deleted,
  Accept,
  Activity,
  Block,
  IntransitiveActivity,
  Add,
  Announce,
  Application,
  Arrive,
  Article,
  Audio,
  Collection,
  CollectionPage,
  OrderedCollectionPage,
  Relationship,
  Create,
  Delete,
  Dislike,
  Document,
  Event,
  Flag,
  Follow,
  Group,
  Ignore,
  Image,
  Invite,
  Join,
  Leave,
  Like,
  View,
  Listen,
  Read: Read2,
  Move,
  Travel,
  Link,
  Mention,
  Note,
  Object__workaround,
  Offer,
  OrderedCollection,
  OrderedItems,
  Page,
  Person,
  Organization,
  Profile,
  Place,
  Question,
  Reject,
  Remove,
  Service,
  TentativeAccept,
  TentativeReject,
  Tombstone,
  Undo,
  Update,
  Video
});

// ../node_modules/rdf-namespaces/dist/cal-7a3ea416.js
var Vevent = "http://www.w3.org/2002/12/cal/ical#Vevent";
var Vtodo = "http://www.w3.org/2002/12/cal/ical#Vtodo";
var Vjournal = "http://www.w3.org/2002/12/cal/ical#Vjournal";
var Vfreebusy = "http://www.w3.org/2002/12/cal/ical#Vfreebusy";
var Vtimezone = "http://www.w3.org/2002/12/cal/ical#Vtimezone";
var Valarm = "http://www.w3.org/2002/12/cal/ical#Valarm";
var calscale = "http://www.w3.org/2002/12/cal/ical#calscale";
var method = "http://www.w3.org/2002/12/cal/ical#method";
var prodid = "http://www.w3.org/2002/12/cal/ical#prodid";
var version = "http://www.w3.org/2002/12/cal/ical#version";
var attach = "http://www.w3.org/2002/12/cal/ical#attach";
var categories = "http://www.w3.org/2002/12/cal/ical#categories";
var class__workaround = "http://www.w3.org/2002/12/cal/ical#class";
var comment = "http://www.w3.org/2002/12/cal/ical#comment";
var description = "http://www.w3.org/2002/12/cal/ical#description";
var geo = "http://www.w3.org/2002/12/cal/ical#geo";
var List_of_Float = "http://www.w3.org/2002/12/cal/ical#List_of_Float";
var location3 = "http://www.w3.org/2002/12/cal/ical#location";
var percentComplete = "http://www.w3.org/2002/12/cal/ical#percentComplete";
var priority = "http://www.w3.org/2002/12/cal/ical#priority";
var resources = "http://www.w3.org/2002/12/cal/ical#resources";
var status = "http://www.w3.org/2002/12/cal/ical#status";
var summary2 = "http://www.w3.org/2002/12/cal/ical#summary";
var completed = "http://www.w3.org/2002/12/cal/ical#completed";
var dtend = "http://www.w3.org/2002/12/cal/ical#dtend";
var Value_DATE = "http://www.w3.org/2002/12/cal/ical#Value_DATE";
var due = "http://www.w3.org/2002/12/cal/ical#due";
var dtstart = "http://www.w3.org/2002/12/cal/ical#dtstart";
var duration2 = "http://www.w3.org/2002/12/cal/ical#duration";
var Value_DURATION = "http://www.w3.org/2002/12/cal/ical#Value_DURATION";
var freebusy = "http://www.w3.org/2002/12/cal/ical#freebusy";
var Value_PERIOD = "http://www.w3.org/2002/12/cal/ical#Value_PERIOD";
var transp = "http://www.w3.org/2002/12/cal/ical#transp";
var tzid = "http://www.w3.org/2002/12/cal/ical#tzid";
var tzname = "http://www.w3.org/2002/12/cal/ical#tzname";
var tzoffsetfrom = "http://www.w3.org/2002/12/cal/ical#tzoffsetfrom";
var tzoffsetto = "http://www.w3.org/2002/12/cal/ical#tzoffsetto";
var tzurl = "http://www.w3.org/2002/12/cal/ical#tzurl";
var attendee = "http://www.w3.org/2002/12/cal/ical#attendee";
var contact = "http://www.w3.org/2002/12/cal/ical#contact";
var organizer = "http://www.w3.org/2002/12/cal/ical#organizer";
var recurrenceId = "http://www.w3.org/2002/12/cal/ical#recurrenceId";
var DomainOf_rrule = "http://www.w3.org/2002/12/cal/ical#DomainOf_rrule";
var relatedTo = "http://www.w3.org/2002/12/cal/ical#relatedTo";
var url2 = "http://www.w3.org/2002/12/cal/ical#url";
var uid = "http://www.w3.org/2002/12/cal/ical#uid";
var exdate = "http://www.w3.org/2002/12/cal/ical#exdate";
var exrule = "http://www.w3.org/2002/12/cal/ical#exrule";
var Value_RECUR = "http://www.w3.org/2002/12/cal/ical#Value_RECUR";
var rdate = "http://www.w3.org/2002/12/cal/ical#rdate";
var rrule = "http://www.w3.org/2002/12/cal/ical#rrule";
var action = "http://www.w3.org/2002/12/cal/ical#action";
var repeat = "http://www.w3.org/2002/12/cal/ical#repeat";
var trigger = "http://www.w3.org/2002/12/cal/ical#trigger";
var created = "http://www.w3.org/2002/12/cal/ical#created";
var dtstamp = "http://www.w3.org/2002/12/cal/ical#dtstamp";
var lastModified = "http://www.w3.org/2002/12/cal/ical#lastModified";
var sequence = "http://www.w3.org/2002/12/cal/ical#sequence";
var requestStatus = "http://www.w3.org/2002/12/cal/ical#requestStatus";
var calImport = /* @__PURE__ */ Object.freeze({
  Vevent,
  Vtodo,
  Vjournal,
  Vfreebusy,
  Vtimezone,
  Valarm,
  calscale,
  method,
  prodid,
  version,
  attach,
  categories,
  class__workaround,
  comment,
  description,
  geo,
  List_of_Float,
  location: location3,
  percentComplete,
  priority,
  resources,
  status,
  summary: summary2,
  completed,
  dtend,
  Value_DATE,
  due,
  dtstart,
  duration: duration2,
  Value_DURATION,
  freebusy,
  Value_PERIOD,
  transp,
  tzid,
  tzname,
  tzoffsetfrom,
  tzoffsetto,
  tzurl,
  attendee,
  contact,
  organizer,
  recurrenceId,
  DomainOf_rrule,
  relatedTo,
  url: url2,
  uid,
  exdate,
  exrule,
  Value_RECUR,
  rdate,
  rrule,
  action,
  repeat,
  trigger,
  created,
  dtstamp,
  lastModified,
  sequence,
  requestStatus
});

// ../node_modules/rdf-namespaces/dist/contact-a1025d9f.js
var Address = "http://www.w3.org/2000/10/swap/pim/contact#Address";
var ContactLocation = "http://www.w3.org/2000/10/swap/pim/contact#ContactLocation";
var Female = "http://www.w3.org/2000/10/swap/pim/contact#Female";
var LanguageCode = "http://www.w3.org/2000/10/swap/pim/contact#LanguageCode";
var Male = "http://www.w3.org/2000/10/swap/pim/contact#Male";
var Phone = "http://www.w3.org/2000/10/swap/pim/contact#Phone";
var SocialEntity = "http://www.w3.org/2000/10/swap/pim/contact#SocialEntity";
var _addressProperty = "http://www.w3.org/2000/10/swap/pim/contact#_addressProperty";
var address = "http://www.w3.org/2000/10/swap/pim/contact#address";
var assistant = "http://www.w3.org/2000/10/swap/pim/contact#assistant";
var birthday = "http://www.w3.org/2000/10/swap/pim/contact#birthday";
var child = "http://www.w3.org/2000/10/swap/pim/contact#child";
var description2 = "http://www.w3.org/2000/10/swap/pim/contact#description";
var emergency = "http://www.w3.org/2000/10/swap/pim/contact#emergency";
var fax = "http://www.w3.org/2000/10/swap/pim/contact#fax";
var fullName = "http://www.w3.org/2000/10/swap/pim/contact#fullName";
var home = "http://www.w3.org/2000/10/swap/pim/contact#home";
var knownAs = "http://www.w3.org/2000/10/swap/pim/contact#knownAs";
var mobile = "http://www.w3.org/2000/10/swap/pim/contact#mobile";
var motherTongue = "http://www.w3.org/2000/10/swap/pim/contact#motherTongue";
var nearestAirport = "http://www.w3.org/2000/10/swap/pim/contact#nearestAirport";
var office = "http://www.w3.org/2000/10/swap/pim/contact#office";
var participant = "http://www.w3.org/2000/10/swap/pim/contact#participant";
var partner = "http://www.w3.org/2000/10/swap/pim/contact#partner";
var phone = "http://www.w3.org/2000/10/swap/pim/contact#phone";
var preferredURI = "http://www.w3.org/2000/10/swap/pim/contact#preferredURI";
var region = "http://www.w3.org/2000/10/swap/pim/contact#region";
var sortName = "http://www.w3.org/2000/10/swap/pim/contact#sortName";
var vacationHome = "http://www.w3.org/2000/10/swap/pim/contact#vacationHome";
var webPage = "http://www.w3.org/2000/10/swap/pim/contact#webPage";
var contactImport = /* @__PURE__ */ Object.freeze({
  Address,
  ContactLocation,
  Female,
  LanguageCode,
  Male,
  Phone,
  SocialEntity,
  _addressProperty,
  address,
  assistant,
  birthday,
  child,
  description: description2,
  emergency,
  fax,
  fullName,
  home,
  knownAs,
  mobile,
  motherTongue,
  nearestAirport,
  office,
  participant,
  partner,
  phone,
  preferredURI,
  region,
  sortName,
  vacationHome,
  webPage
});

// ../node_modules/rdf-namespaces/dist/dc-5f5380c9.js
var contributor = "http://purl.org/dc/elements/1.1/contributor";
var coverage = "http://purl.org/dc/elements/1.1/coverage";
var creator = "http://purl.org/dc/elements/1.1/creator";
var date = "http://purl.org/dc/elements/1.1/date";
var description3 = "http://purl.org/dc/elements/1.1/description";
var format = "http://purl.org/dc/elements/1.1/format";
var identifier = "http://purl.org/dc/elements/1.1/identifier";
var language = "http://purl.org/dc/elements/1.1/language";
var publisher = "http://purl.org/dc/elements/1.1/publisher";
var relation = "http://purl.org/dc/elements/1.1/relation";
var rights = "http://purl.org/dc/elements/1.1/rights";
var source = "http://purl.org/dc/elements/1.1/source";
var subject = "http://purl.org/dc/elements/1.1/subject";
var title = "http://purl.org/dc/elements/1.1/title";
var type = "http://purl.org/dc/elements/1.1/type";
var dcImport = /* @__PURE__ */ Object.freeze({
  contributor,
  coverage,
  creator,
  date,
  description: description3,
  format,
  identifier,
  language,
  publisher,
  relation,
  rights,
  source,
  subject,
  title,
  type
});

// ../node_modules/rdf-namespaces/dist/dct-ab257c3b.js
var AgentClass = "http://purl.org/dc/terms/AgentClass";
var BibliographicResource = "http://purl.org/dc/terms/BibliographicResource";
var Box = "http://purl.org/dc/terms/Box";
var FileFormat = "http://purl.org/dc/terms/FileFormat";
var Frequency = "http://purl.org/dc/terms/Frequency";
var ISO3166 = "http://purl.org/dc/terms/ISO3166";
var Jurisdiction = "http://purl.org/dc/terms/Jurisdiction";
var LicenseDocument = "http://purl.org/dc/terms/LicenseDocument";
var LinguisticSystem = "http://purl.org/dc/terms/LinguisticSystem";
var Location = "http://purl.org/dc/terms/Location";
var LocationPeriodOrJurisdiction = "http://purl.org/dc/terms/LocationPeriodOrJurisdiction";
var MediaType = "http://purl.org/dc/terms/MediaType";
var MediaTypeOrExtent = "http://purl.org/dc/terms/MediaTypeOrExtent";
var MethodOfAccrual = "http://purl.org/dc/terms/MethodOfAccrual";
var MethodOfInstruction = "http://purl.org/dc/terms/MethodOfInstruction";
var Period = "http://purl.org/dc/terms/Period";
var PeriodOfTime = "http://purl.org/dc/terms/PeriodOfTime";
var PhysicalMedium = "http://purl.org/dc/terms/PhysicalMedium";
var PhysicalResource = "http://purl.org/dc/terms/PhysicalResource";
var Point = "http://purl.org/dc/terms/Point";
var Policy = "http://purl.org/dc/terms/Policy";
var ProvenanceStatement = "http://purl.org/dc/terms/ProvenanceStatement";
var RFC1766 = "http://purl.org/dc/terms/RFC1766";
var RFC3066 = "http://purl.org/dc/terms/RFC3066";
var RFC4646 = "http://purl.org/dc/terms/RFC4646";
var RFC5646 = "http://purl.org/dc/terms/RFC5646";
var RightsStatement = "http://purl.org/dc/terms/RightsStatement";
var SizeOrDuration = "http://purl.org/dc/terms/SizeOrDuration";
var Standard = "http://purl.org/dc/terms/Standard";
var URI = "http://purl.org/dc/terms/URI";
var W3CDTF = "http://purl.org/dc/terms/W3CDTF";
var abstract = "http://purl.org/dc/terms/abstract";
var accessRights = "http://purl.org/dc/terms/accessRights";
var accrualMethod = "http://purl.org/dc/terms/accrualMethod";
var accrualPeriodicity = "http://purl.org/dc/terms/accrualPeriodicity";
var accrualPolicy = "http://purl.org/dc/terms/accrualPolicy";
var alternative = "http://purl.org/dc/terms/alternative";
var audience2 = "http://purl.org/dc/terms/audience";
var available = "http://purl.org/dc/terms/available";
var bibliographicCitation = "http://purl.org/dc/terms/bibliographicCitation";
var conformsTo = "http://purl.org/dc/terms/conformsTo";
var contributor2 = "http://purl.org/dc/terms/contributor";
var coverage2 = "http://purl.org/dc/terms/coverage";
var created2 = "http://purl.org/dc/terms/created";
var creator2 = "http://purl.org/dc/terms/creator";
var date2 = "http://purl.org/dc/terms/date";
var dateAccepted = "http://purl.org/dc/terms/dateAccepted";
var dateCopyrighted = "http://purl.org/dc/terms/dateCopyrighted";
var dateSubmitted = "http://purl.org/dc/terms/dateSubmitted";
var description4 = "http://purl.org/dc/terms/description";
var educationLevel = "http://purl.org/dc/terms/educationLevel";
var extent = "http://purl.org/dc/terms/extent";
var format2 = "http://purl.org/dc/terms/format";
var hasFormat = "http://purl.org/dc/terms/hasFormat";
var hasPart = "http://purl.org/dc/terms/hasPart";
var hasVersion = "http://purl.org/dc/terms/hasVersion";
var identifier2 = "http://purl.org/dc/terms/identifier";
var instructionalMethod = "http://purl.org/dc/terms/instructionalMethod";
var isFormatOf = "http://purl.org/dc/terms/isFormatOf";
var isPartOf = "http://purl.org/dc/terms/isPartOf";
var isReferencedBy = "http://purl.org/dc/terms/isReferencedBy";
var isReplacedBy = "http://purl.org/dc/terms/isReplacedBy";
var isRequiredBy = "http://purl.org/dc/terms/isRequiredBy";
var isVersionOf = "http://purl.org/dc/terms/isVersionOf";
var issued = "http://purl.org/dc/terms/issued";
var language2 = "http://purl.org/dc/terms/language";
var license = "http://purl.org/dc/terms/license";
var mediator = "http://purl.org/dc/terms/mediator";
var medium = "http://purl.org/dc/terms/medium";
var modified = "http://purl.org/dc/terms/modified";
var provenance = "http://purl.org/dc/terms/provenance";
var publisher2 = "http://purl.org/dc/terms/publisher";
var references = "http://purl.org/dc/terms/references";
var relation2 = "http://purl.org/dc/terms/relation";
var replaces = "http://purl.org/dc/terms/replaces";
var requires2 = "http://purl.org/dc/terms/requires";
var rights2 = "http://purl.org/dc/terms/rights";
var rightsHolder = "http://purl.org/dc/terms/rightsHolder";
var source2 = "http://purl.org/dc/terms/source";
var spatial = "http://purl.org/dc/terms/spatial";
var subject2 = "http://purl.org/dc/terms/subject";
var tableOfContents = "http://purl.org/dc/terms/tableOfContents";
var temporal = "http://purl.org/dc/terms/temporal";
var title2 = "http://purl.org/dc/terms/title";
var type2 = "http://purl.org/dc/terms/type";
var valid = "http://purl.org/dc/terms/valid";
var dctImport = /* @__PURE__ */ Object.freeze({
  AgentClass,
  BibliographicResource,
  Box,
  FileFormat,
  Frequency,
  ISO3166,
  Jurisdiction,
  LicenseDocument,
  LinguisticSystem,
  Location,
  LocationPeriodOrJurisdiction,
  MediaType,
  MediaTypeOrExtent,
  MethodOfAccrual,
  MethodOfInstruction,
  Period,
  PeriodOfTime,
  PhysicalMedium,
  PhysicalResource,
  Point,
  Policy,
  ProvenanceStatement,
  RFC1766,
  RFC3066,
  RFC4646,
  RFC5646,
  RightsStatement,
  SizeOrDuration,
  Standard,
  URI,
  W3CDTF,
  abstract,
  accessRights,
  accrualMethod,
  accrualPeriodicity,
  accrualPolicy,
  alternative,
  audience: audience2,
  available,
  bibliographicCitation,
  conformsTo,
  contributor: contributor2,
  coverage: coverage2,
  created: created2,
  creator: creator2,
  date: date2,
  dateAccepted,
  dateCopyrighted,
  dateSubmitted,
  description: description4,
  educationLevel,
  extent,
  format: format2,
  hasFormat,
  hasPart,
  hasVersion,
  identifier: identifier2,
  instructionalMethod,
  isFormatOf,
  isPartOf,
  isReferencedBy,
  isReplacedBy,
  isRequiredBy,
  isVersionOf,
  issued,
  language: language2,
  license,
  mediator,
  medium,
  modified,
  provenance,
  publisher: publisher2,
  references,
  relation: relation2,
  replaces,
  requires: requires2,
  rights: rights2,
  rightsHolder,
  source: source2,
  spatial,
  subject: subject2,
  tableOfContents,
  temporal,
  title: title2,
  type: type2,
  valid
});

// ../node_modules/rdf-namespaces/dist/fhir-14170346.js
var constituent = "http://hl7.org/fhir/constituent";
var _careTeam = "http://hl7.org/fhir/_careTeam";
var ClinicalUseDefinitionWarningComponent = "http://hl7.org/fhir/ClinicalUseDefinitionWarningComponent";
var PlanDefinitionActionParticipantComponent = "http://hl7.org/fhir/PlanDefinitionActionParticipantComponent";
var VisionPrescriptionLensSpecificationComponent = "http://hl7.org/fhir/VisionPrescriptionLensSpecificationComponent";
var _answerOption = "http://hl7.org/fhir/_answerOption";
var decimal = "http://hl7.org/fhir/decimal";
var _applies = "http://hl7.org/fhir/_applies";
var serviceProvider = "http://hl7.org/fhir/serviceProvider";
var NutritionProductIngredientComponent = "http://hl7.org/fhir/NutritionProductIngredientComponent";
var Error__workaround = "http://hl7.org/fhir/Error";
var productStatus = "http://hl7.org/fhir/productStatus";
var ImagingStudySeriesPerformerComponent = "http://hl7.org/fhir/ImagingStudySeriesPerformerComponent";
var _lowerLimit = "http://hl7.org/fhir/_lowerLimit";
var Medication = "http://hl7.org/fhir/Medication";
var header = "http://hl7.org/fhir/header";
var StructureMapGroupRuleComponent = "http://hl7.org/fhir/StructureMapGroupRuleComponent";
var _productType = "http://hl7.org/fhir/_productType";
var _relatedItem = "http://hl7.org/fhir/_relatedItem";
var author2 = "http://hl7.org/fhir/author";
var _direction = "http://hl7.org/fhir/_direction";
var _frequencyOfOccurrence = "http://hl7.org/fhir/_frequencyOfOccurrence";
var RequestOrchestration = "http://hl7.org/fhir/RequestOrchestration";
var Detail = "http://hl7.org/fhir/Detail";
var numberOfRepeatsAllowed = "http://hl7.org/fhir/numberOfRepeatsAllowed";
var _communicationRequest = "http://hl7.org/fhir/_communicationRequest";
var DocumentReferenceContentProfileComponent = "http://hl7.org/fhir/DocumentReferenceContentProfileComponent";
var _masterFile = "http://hl7.org/fhir/_masterFile";
var comment2 = "http://hl7.org/fhir/comment";
var availableTime = "http://hl7.org/fhir/availableTime";
var _assert = "http://hl7.org/fhir/_assert";
var listRuleId = "http://hl7.org/fhir/listRuleId";
var preAdmissionIdentifier = "http://hl7.org/fhir/preAdmissionIdentifier";
var participantType = "http://hl7.org/fhir/participantType";
var _related = "http://hl7.org/fhir/_related";
var SupplementSchedule = "http://hl7.org/fhir/SupplementSchedule";
var reAdmission = "http://hl7.org/fhir/reAdmission";
var _requestURL = "http://hl7.org/fhir/_requestURL";
var _caseSensitive = "http://hl7.org/fhir/_caseSensitive";
var _chargeItem = "http://hl7.org/fhir/_chargeItem";
var _withdrawalPeriod = "http://hl7.org/fhir/_withdrawalPeriod";
var CapabilityStatementImplementationComponent = "http://hl7.org/fhir/CapabilityStatementImplementationComponent";
var analysis = "http://hl7.org/fhir/analysis";
var monitoringProgram = "http://hl7.org/fhir/monitoringProgram";
var _date = "http://hl7.org/fhir/_date";
var satisfiedBy = "http://hl7.org/fhir/satisfiedBy";
var artifact = "http://hl7.org/fhir/artifact";
var timing = "http://hl7.org/fhir/timing";
var appliesToAll = "http://hl7.org/fhir/appliesToAll";
var _appointmentRequired = "http://hl7.org/fhir/_appointmentRequired";
var _canFilterBy = "http://hl7.org/fhir/_canFilterBy";
var filter = "http://hl7.org/fhir/filter";
var _targetNumber = "http://hl7.org/fhir/_targetNumber";
var _additive = "http://hl7.org/fhir/_additive";
var _management = "http://hl7.org/fhir/_management";
var _phylum = "http://hl7.org/fhir/_phylum";
var _distributor = "http://hl7.org/fhir/_distributor";
var _clinicalRecommendationStatement = "http://hl7.org/fhir/_clinicalRecommendationStatement";
var _manifest = "http://hl7.org/fhir/_manifest";
var cancellationDate = "http://hl7.org/fhir/cancellationDate";
var _doseQuantity = "http://hl7.org/fhir/_doseQuantity";
var DeviceDefinitionPackagingComponentUdiDeviceIdentifier = "http://hl7.org/fhir/DeviceDefinitionPackagingComponentUdiDeviceIdentifier";
var VerificationResult = "http://hl7.org/fhir/VerificationResult";
var preference = "http://hl7.org/fhir/preference";
var _asserter = "http://hl7.org/fhir/_asserter";
var _regulatoryIdentifier = "http://hl7.org/fhir/_regulatoryIdentifier";
var molecularFormula = "http://hl7.org/fhir/molecularFormula";
var isActive = "http://hl7.org/fhir/isActive";
var dispenserInstruction = "http://hl7.org/fhir/dispenserInstruction";
var MedicationKnowledgeRelatedMedicationKnowledgeComponent = "http://hl7.org/fhir/MedicationKnowledgeRelatedMedicationKnowledgeComponent";
var CapabilityStatementRestSecurityComponent = "http://hl7.org/fhir/CapabilityStatementRestSecurityComponent";
var initialSelected = "http://hl7.org/fhir/initialSelected";
var _preventiveAction = "http://hl7.org/fhir/_preventiveAction";
var DeviceDefinitionConformsToComponent = "http://hl7.org/fhir/DeviceDefinitionConformsToComponent";
var _MedicationStatement = "http://hl7.org/fhir/_MedicationStatement";
var _availableStartTime = "http://hl7.org/fhir/_availableStartTime";
var validationType = "http://hl7.org/fhir/validationType";
var _axis = "http://hl7.org/fhir/_axis";
var _serialNumber = "http://hl7.org/fhir/_serialNumber";
var Narrative = "http://hl7.org/fhir/Narrative";
var _dependency = "http://hl7.org/fhir/_dependency";
var endDate = "http://hl7.org/fhir/endDate";
var _prognosisReference = "http://hl7.org/fhir/_prognosisReference";
var _recruitment = "http://hl7.org/fhir/_recruitment";
var searchParam = "http://hl7.org/fhir/searchParam";
var _usageInstruction = "http://hl7.org/fhir/_usageInstruction";
var _generation = "http://hl7.org/fhir/_generation";
var artifactAssessment = "http://hl7.org/fhir/artifactAssessment";
var complete = "http://hl7.org/fhir/complete";
var _dependent = "http://hl7.org/fhir/_dependent";
var _due = "http://hl7.org/fhir/_due";
var _replaces = "http://hl7.org/fhir/_replaces";
var EvidenceStatisticModelCharacteristicComponent = "http://hl7.org/fhir/EvidenceStatisticModelCharacteristicComponent";
var _friday = "http://hl7.org/fhir/_friday";
var orderedBy = "http://hl7.org/fhir/orderedBy";
var _modality = "http://hl7.org/fhir/_modality";
var expirationType = "http://hl7.org/fhir/expirationType";
var party = "http://hl7.org/fhir/party";
var _objective = "http://hl7.org/fhir/_objective";
var _totalNet = "http://hl7.org/fhir/_totalNet";
var _adherence = "http://hl7.org/fhir/_adherence";
var _cardinalityBehavior = "http://hl7.org/fhir/_cardinalityBehavior";
var startDate = "http://hl7.org/fhir/startDate";
var basis = "http://hl7.org/fhir/basis";
var _minutesDuration = "http://hl7.org/fhir/_minutesDuration";
var instruction = "http://hl7.org/fhir/instruction";
var _targetDisease = "http://hl7.org/fhir/_targetDisease";
var eventTrigger = "http://hl7.org/fhir/eventTrigger";
var closure = "http://hl7.org/fhir/closure";
var numberOfParticipants = "http://hl7.org/fhir/numberOfParticipants";
var businessArrangement = "http://hl7.org/fhir/businessArrangement";
var requesterLinkId = "http://hl7.org/fhir/requesterLinkId";
var _programEligibility = "http://hl7.org/fhir/_programEligibility";
var _average = "http://hl7.org/fhir/_average";
var proxySignature = "http://hl7.org/fhir/proxySignature";
var _assessmentMethod = "http://hl7.org/fhir/_assessmentMethod";
var _series = "http://hl7.org/fhir/_series";
var _performingOrganization = "http://hl7.org/fhir/_performingOrganization";
var frames = "http://hl7.org/fhir/frames";
var _paternalOrganismName = "http://hl7.org/fhir/_paternalOrganismName";
var inputProfile = "http://hl7.org/fhir/inputProfile";
var _guarantor = "http://hl7.org/fhir/_guarantor";
var _human = "http://hl7.org/fhir/_human";
var NutritionProductCharacteristicComponent = "http://hl7.org/fhir/NutritionProductCharacteristicComponent";
var _orderDetail = "http://hl7.org/fhir/_orderDetail";
var maxParticipants = "http://hl7.org/fhir/maxParticipants";
var ClinicalUseDefinitionUndesirableEffectComponent = "http://hl7.org/fhir/ClinicalUseDefinitionUndesirableEffectComponent";
var _observed = "http://hl7.org/fhir/_observed";
var validityPeriod = "http://hl7.org/fhir/validityPeriod";
var ComputableLanguage = "http://hl7.org/fhir/ComputableLanguage";
var surfaceOrientation = "http://hl7.org/fhir/surfaceOrientation";
var _Provenance = "http://hl7.org/fhir/_Provenance";
var testRun = "http://hl7.org/fhir/testRun";
var SubstanceProtein = "http://hl7.org/fhir/SubstanceProtein";
var _focalDevice = "http://hl7.org/fhir/_focalDevice";
var _operationType = "http://hl7.org/fhir/_operationType";
var context3 = "http://hl7.org/fhir/context";
var occurrenceDateTime = "http://hl7.org/fhir/occurrenceDateTime";
var DetectedIssueEvidenceComponent = "http://hl7.org/fhir/DetectedIssueEvidenceComponent";
var _ExplanationOfBenefit = "http://hl7.org/fhir/_ExplanationOfBenefit";
var validated = "http://hl7.org/fhir/validated";
var _subunit = "http://hl7.org/fhir/_subunit";
var EvidenceStatisticAttributeEstimateComponent = "http://hl7.org/fhir/EvidenceStatisticAttributeEstimateComponent";
var replacedSequence = "http://hl7.org/fhir/replacedSequence";
var specimen = "http://hl7.org/fhir/specimen";
var rater = "http://hl7.org/fhir/rater";
var relatedMedicationKnowledge = "http://hl7.org/fhir/relatedMedicationKnowledge";
var lastModified2 = "http://hl7.org/fhir/lastModified";
var RequestOrchestrationActionParticipantComponent = "http://hl7.org/fhir/RequestOrchestrationActionParticipantComponent";
var _informationType = "http://hl7.org/fhir/_informationType";
var citation = "http://hl7.org/fhir/citation";
var paymentStatus = "http://hl7.org/fhir/paymentStatus";
var treatment = "http://hl7.org/fhir/treatment";
var _initial = "http://hl7.org/fhir/_initial";
var priceComponent = "http://hl7.org/fhir/priceComponent";
var _Linkage = "http://hl7.org/fhir/_Linkage";
var _indicationGuideline = "http://hl7.org/fhir/_indicationGuideline";
var SubstanceSourceMaterial = "http://hl7.org/fhir/SubstanceSourceMaterial";
var _conditionalRead = "http://hl7.org/fhir/_conditionalRead";
var managingEntity = "http://hl7.org/fhir/managingEntity";
var EvidenceVariableCharacteristicDefinitionByTypeAndValueComponent = "http://hl7.org/fhir/EvidenceVariableCharacteristicDefinitionByTypeAndValueComponent";
var operationalStatus = "http://hl7.org/fhir/operationalStatus";
var _module = "http://hl7.org/fhir/_module";
var MedicationAdministration = "http://hl7.org/fhir/MedicationAdministration";
var UdiDeviceIdentifierMarketDistribution = "http://hl7.org/fhir/UdiDeviceIdentifierMarketDistribution";
var _probability = "http://hl7.org/fhir/_probability";
var clinicalRecommendationStatement = "http://hl7.org/fhir/clinicalRecommendationStatement";
var _image = "http://hl7.org/fhir/_image";
var SubscriptionTopicNotificationShapeComponent = "http://hl7.org/fhir/SubscriptionTopicNotificationShapeComponent";
var _componentPart = "http://hl7.org/fhir/_componentPart";
var op = "http://hl7.org/fhir/op";
var _processingFacility = "http://hl7.org/fhir/_processingFacility";
var unit = "http://hl7.org/fhir/unit";
var _problem = "http://hl7.org/fhir/_problem";
var SubstanceDefinitionPropertyComponent = "http://hl7.org/fhir/SubstanceDefinitionPropertyComponent";
var _fluidConsistencyType = "http://hl7.org/fhir/_fluidConsistencyType";
var _SubstancePolymer = "http://hl7.org/fhir/_SubstancePolymer";
var ValueSetComposeIncludeConceptDesignationComponent = "http://hl7.org/fhir/ValueSetComposeIncludeConceptDesignationComponent";
var versionReference = "http://hl7.org/fhir/versionReference";
var _maxSingleDose = "http://hl7.org/fhir/_maxSingleDose";
var meaning = "http://hl7.org/fhir/meaning";
var measurementPoint = "http://hl7.org/fhir/measurementPoint";
var diagnosisRelatedGroup = "http://hl7.org/fhir/diagnosisRelatedGroup";
var _relative = "http://hl7.org/fhir/_relative";
var _publicationForm = "http://hl7.org/fhir/_publicationForm";
var _Patient = "http://hl7.org/fhir/_Patient";
var GuidanceResponse = "http://hl7.org/fhir/GuidanceResponse";
var entity = "http://hl7.org/fhir/entity";
var sourceReference = "http://hl7.org/fhir/sourceReference";
var valueFilter = "http://hl7.org/fhir/valueFilter";
var _useBy = "http://hl7.org/fhir/_useBy";
var bodyLandmarkOrientation = "http://hl7.org/fhir/bodyLandmarkOrientation";
var SubstanceDefinitionNameComponentName = "http://hl7.org/fhir/SubstanceDefinitionNameComponentName";
var _policyText = "http://hl7.org/fhir/_policyText";
var _changePattern = "http://hl7.org/fhir/_changePattern";
var subDetail = "http://hl7.org/fhir/subDetail";
var allDay = "http://hl7.org/fhir/allDay";
var _modification = "http://hl7.org/fhir/_modification";
var _nodeId = "http://hl7.org/fhir/_nodeId";
var AdverseEventContributingFactorComponent = "http://hl7.org/fhir/AdverseEventContributingFactorComponent";
var TestPlanTestCaseComponent = "http://hl7.org/fhir/TestPlanTestCaseComponent";
var sunday = "http://hl7.org/fhir/sunday";
var cancellationReason = "http://hl7.org/fhir/cancellationReason";
var _title = "http://hl7.org/fhir/_title";
var _sourceId = "http://hl7.org/fhir/_sourceId";
var _entityRelatedness = "http://hl7.org/fhir/_entityRelatedness";
var line = "http://hl7.org/fhir/line";
var _effectivePeriod = "http://hl7.org/fhir/_effectivePeriod";
var preAuthRef = "http://hl7.org/fhir/preAuthRef";
var requestId = "http://hl7.org/fhir/requestId";
var _autodelete = "http://hl7.org/fhir/_autodelete";
var _fundsReserve = "http://hl7.org/fhir/_fundsReserve";
var BundleEntryComponentLink = "http://hl7.org/fhir/BundleEntryComponentLink";
var DocumentReferenceContentComponent = "http://hl7.org/fhir/DocumentReferenceContentComponent";
var _holder = "http://hl7.org/fhir/_holder";
var _qualifiers = "http://hl7.org/fhir/_qualifiers";
var _Specimen = "http://hl7.org/fhir/_Specimen";
var CodeSystemFilterComponent = "http://hl7.org/fhir/CodeSystemFilterComponent";
var _replacementSequence = "http://hl7.org/fhir/_replacementSequence";
var serviceCategory = "http://hl7.org/fhir/serviceCategory";
var _next = "http://hl7.org/fhir/_next";
var paymentTerms = "http://hl7.org/fhir/paymentTerms";
var _started = "http://hl7.org/fhir/_started";
var offer = "http://hl7.org/fhir/offer";
var coordinateSystem = "http://hl7.org/fhir/coordinateSystem";
var DeviceDefinition = "http://hl7.org/fhir/DeviceDefinition";
var _intent = "http://hl7.org/fhir/_intent";
var _text = "http://hl7.org/fhir/_text";
var _level = "http://hl7.org/fhir/_level";
var facility = "http://hl7.org/fhir/facility";
var qualifiedValue = "http://hl7.org/fhir/qualifiedValue";
var ManifestResource = "http://hl7.org/fhir/ManifestResource";
var prism = "http://hl7.org/fhir/prism";
var MedicationBatchComponent = "http://hl7.org/fhir/MedicationBatchComponent";
var resultForDelete = "http://hl7.org/fhir/resultForDelete";
var _accept = "http://hl7.org/fhir/_accept";
var overbooked = "http://hl7.org/fhir/overbooked";
var _plan = "http://hl7.org/fhir/_plan";
var ReviewOutcome = "http://hl7.org/fhir/ReviewOutcome";
var CitationCitedArtifactContributorshipEntryComponent = "http://hl7.org/fhir/CitationCitedArtifactContributorshipEntryComponent";
var discriminator = "http://hl7.org/fhir/discriminator";
var ordered = "http://hl7.org/fhir/ordered";
var LegalLanguage = "http://hl7.org/fhir/LegalLanguage";
var frequencyOfOccurrence = "http://hl7.org/fhir/frequencyOfOccurrence";
var _validationType = "http://hl7.org/fhir/_validationType";
var PermissionRuleDataComponent = "http://hl7.org/fhir/PermissionRuleDataComponent";
var _versionNeeded = "http://hl7.org/fhir/_versionNeeded";
var PackagedProductDefinitionPackagingContainedItemComponent = "http://hl7.org/fhir/PackagedProductDefinitionPackagingContainedItemComponent";
var predecessor = "http://hl7.org/fhir/predecessor";
var ArtifactAssessment = "http://hl7.org/fhir/ArtifactAssessment";
var _dependsOn = "http://hl7.org/fhir/_dependsOn";
var evidence = "http://hl7.org/fhir/evidence";
var MeasureGroupPopulationComponent = "http://hl7.org/fhir/MeasureGroupPopulationComponent";
var opticalActivity = "http://hl7.org/fhir/opticalActivity";
var nutritionProduct = "http://hl7.org/fhir/nutritionProduct";
var specialMeasures = "http://hl7.org/fhir/specialMeasures";
var packageId = "http://hl7.org/fhir/packageId";
var TerminologyCapabilitiesCodeSystemVersionFilterComponent = "http://hl7.org/fhir/TerminologyCapabilitiesCodeSystemVersionFilterComponent";
var SubDetail = "http://hl7.org/fhir/SubDetail";
var _received = "http://hl7.org/fhir/_received";
var CapabilityStatementDocumentComponent = "http://hl7.org/fhir/CapabilityStatementDocumentComponent";
var observationResultRequirement = "http://hl7.org/fhir/observationResultRequirement";
var FriendlyLanguage = "http://hl7.org/fhir/FriendlyLanguage";
var _observedGroup = "http://hl7.org/fhir/_observedGroup";
var cancelledReason = "http://hl7.org/fhir/cancelledReason";
var _expirationType = "http://hl7.org/fhir/_expirationType";
var _actualNumber = "http://hl7.org/fhir/_actualNumber";
var derivation = "http://hl7.org/fhir/derivation";
var AdverseEventSuspectEntityComponent = "http://hl7.org/fhir/AdverseEventSuspectEntityComponent";
var ImmunizationRecommendation = "http://hl7.org/fhir/ImmunizationRecommendation";
var _BiologicallyDerivedProductDispense = "http://hl7.org/fhir/_BiologicallyDerivedProductDispense";
var _definitionId = "http://hl7.org/fhir/_definitionId";
var _authoredOn = "http://hl7.org/fhir/_authoredOn";
var keyword = "http://hl7.org/fhir/keyword";
var characteristic = "http://hl7.org/fhir/characteristic";
var _note = "http://hl7.org/fhir/_note";
var ImagingStudySeriesInstanceComponent = "http://hl7.org/fhir/ImagingStudySeriesInstanceComponent";
var _signature = "http://hl7.org/fhir/_signature";
var slicing = "http://hl7.org/fhir/slicing";
var _population = "http://hl7.org/fhir/_population";
var cap = "http://hl7.org/fhir/cap";
var given = "http://hl7.org/fhir/given";
var account = "http://hl7.org/fhir/account";
var _organism = "http://hl7.org/fhir/_organism";
var _need = "http://hl7.org/fhir/_need";
var environmentalSetting = "http://hl7.org/fhir/environmentalSetting";
var volume = "http://hl7.org/fhir/volume";
var weeklyTemplate = "http://hl7.org/fhir/weeklyTemplate";
var lowerLimit = "http://hl7.org/fhir/lowerLimit";
var _justification = "http://hl7.org/fhir/_justification";
var _fixture = "http://hl7.org/fhir/_fixture";
var unitPriceComponent = "http://hl7.org/fhir/unitPriceComponent";
var availabilityStatus = "http://hl7.org/fhir/availabilityStatus";
var _proxySignature = "http://hl7.org/fhir/_proxySignature";
var statusChanged = "http://hl7.org/fhir/statusChanged";
var _about = "http://hl7.org/fhir/_about";
var occurence = "http://hl7.org/fhir/occurence";
var actualPeriod = "http://hl7.org/fhir/actualPeriod";
var _originalPrescription = "http://hl7.org/fhir/_originalPrescription";
var _dosage = "http://hl7.org/fhir/_dosage";
var returnedAmount = "http://hl7.org/fhir/returnedAmount";
var _cTerminalModification = "http://hl7.org/fhir/_cTerminalModification";
var name2 = "http://hl7.org/fhir/name";
var masterFile = "http://hl7.org/fhir/masterFile";
var baseFormulaType = "http://hl7.org/fhir/baseFormulaType";
var threshold = "http://hl7.org/fhir/threshold";
var active = "http://hl7.org/fhir/active";
var IngredientSubstanceComponent = "http://hl7.org/fhir/IngredientSubstanceComponent";
var size = "http://hl7.org/fhir/size";
var _validityPeriod = "http://hl7.org/fhir/_validityPeriod";
var who = "http://hl7.org/fhir/who";
var ExampleScenarioProcessStepAlternativeComponent = "http://hl7.org/fhir/ExampleScenarioProcessStepAlternativeComponent";
var InsurancePlanPlanSpecificCostComponent = "http://hl7.org/fhir/InsurancePlanPlanSpecificCostComponent";
var interaction = "http://hl7.org/fhir/interaction";
var _beneficiary = "http://hl7.org/fhir/_beneficiary";
var requestURL = "http://hl7.org/fhir/requestURL";
var transform = "http://hl7.org/fhir/transform";
var sugar = "http://hl7.org/fhir/sugar";
var _subscriptionTopic = "http://hl7.org/fhir/_subscriptionTopic";
var _usageStatus = "http://hl7.org/fhir/_usageStatus";
var _recurring = "http://hl7.org/fhir/_recurring";
var chargeItem = "http://hl7.org/fhir/chargeItem";
var DiagnosticReportMediaComponent = "http://hl7.org/fhir/DiagnosticReportMediaComponent";
var validationProcess = "http://hl7.org/fhir/validationProcess";
var _DiagnosticReport = "http://hl7.org/fhir/_DiagnosticReport";
var moiety = "http://hl7.org/fhir/moiety";
var _marketingStatus = "http://hl7.org/fhir/_marketingStatus";
var _citedArtifact = "http://hl7.org/fhir/_citedArtifact";
var CitationCitedArtifactPartComponent = "http://hl7.org/fhir/CitationCitedArtifactPartComponent";
var TerminologyCapabilitiesImplementationComponent = "http://hl7.org/fhir/TerminologyCapabilitiesImplementationComponent";
var _immutable = "http://hl7.org/fhir/_immutable";
var _requester = "http://hl7.org/fhir/_requester";
var regionsStudied = "http://hl7.org/fhir/regionsStudied";
var _code = "http://hl7.org/fhir/_code";
var sourceMaterial = "http://hl7.org/fhir/sourceMaterial";
var subrogation = "http://hl7.org/fhir/subrogation";
var _structureVersion = "http://hl7.org/fhir/_structureVersion";
var _priceComponent = "http://hl7.org/fhir/_priceComponent";
var management = "http://hl7.org/fhir/management";
var _additionalInstruction = "http://hl7.org/fhir/_additionalInstruction";
var _managingEntity = "http://hl7.org/fhir/_managingEntity";
var patchFormat = "http://hl7.org/fhir/patchFormat";
var proxyIdentityCertificate = "http://hl7.org/fhir/proxyIdentityCertificate";
var DeviceVersionComponent = "http://hl7.org/fhir/DeviceVersionComponent";
var TaskRestrictionComponent = "http://hl7.org/fhir/TaskRestrictionComponent";
var _frameOfReferenceUid = "http://hl7.org/fhir/_frameOfReferenceUid";
var MedicinalProductDefinition = "http://hl7.org/fhir/MedicinalProductDefinition";
var paternalOrganismId = "http://hl7.org/fhir/paternalOrganismId";
var averageMolecularFormula = "http://hl7.org/fhir/averageMolecularFormula";
var EvidenceStatisticSampleSizeComponent = "http://hl7.org/fhir/EvidenceStatisticSampleSizeComponent";
var _occurred = "http://hl7.org/fhir/_occurred";
var definitionByCombination = "http://hl7.org/fhir/definitionByCombination";
var _compositional = "http://hl7.org/fhir/_compositional";
var financial = "http://hl7.org/fhir/financial";
var _bodysite = "http://hl7.org/fhir/_bodysite";
var sourceScope = "http://hl7.org/fhir/sourceScope";
var parameter = "http://hl7.org/fhir/parameter";
var lineItem = "http://hl7.org/fhir/lineItem";
var _businessArrangement = "http://hl7.org/fhir/_businessArrangement";
var _ordinalPosition = "http://hl7.org/fhir/_ordinalPosition";
var dependency = "http://hl7.org/fhir/dependency";
var DeviceUsage = "http://hl7.org/fhir/DeviceUsage";
var sent = "http://hl7.org/fhir/sent";
var _associatedMedication = "http://hl7.org/fhir/_associatedMedication";
var ParametersParameterComponentParameter = "http://hl7.org/fhir/ParametersParameterComponentParameter";
var executionPeriod = "http://hl7.org/fhir/executionPeriod";
var _custodian = "http://hl7.org/fhir/_custodian";
var specification = "http://hl7.org/fhir/specification";
var HumanName = "http://hl7.org/fhir/HumanName";
var ObservationDefinitionComponentComponentQualifiedValue = "http://hl7.org/fhir/ObservationDefinitionComponentComponentQualifiedValue";
var _searchInclude = "http://hl7.org/fhir/_searchInclude";
var _technique = "http://hl7.org/fhir/_technique";
var legalStatusOfSupply = "http://hl7.org/fhir/legalStatusOfSupply";
var short = "http://hl7.org/fhir/short";
var generation = "http://hl7.org/fhir/generation";
var doseAndRate = "http://hl7.org/fhir/doseAndRate";
var _condition = "http://hl7.org/fhir/_condition";
var _followUp = "http://hl7.org/fhir/_followUp";
var manufacturer = "http://hl7.org/fhir/manufacturer";
var BiologicallyDerivedProductDispense = "http://hl7.org/fhir/BiologicallyDerivedProductDispense";
var _seriesUid = "http://hl7.org/fhir/_seriesUid";
var relatesTo = "http://hl7.org/fhir/relatesTo";
var temperatureQualifier = "http://hl7.org/fhir/temperatureQualifier";
var _PackagedProductDefinition = "http://hl7.org/fhir/_PackagedProductDefinition";
var _correspondingContact = "http://hl7.org/fhir/_correspondingContact";
var citeAs = "http://hl7.org/fhir/citeAs";
var _DeviceAssociation = "http://hl7.org/fhir/_DeviceAssociation";
var requireBoth = "http://hl7.org/fhir/requireBoth";
var provisionData = "http://hl7.org/fhir/provisionData";
var _characterization = "http://hl7.org/fhir/_characterization";
var criticality = "http://hl7.org/fhir/criticality";
var ConditionDefinitionPlanComponent = "http://hl7.org/fhir/ConditionDefinitionPlanComponent";
var canPushUpdates = "http://hl7.org/fhir/canPushUpdates";
var _nTerminalModificationId = "http://hl7.org/fhir/_nTerminalModificationId";
var _regionsCalled = "http://hl7.org/fhir/_regionsCalled";
var TestPlanTestCaseTestRunComponent = "http://hl7.org/fhir/TestPlanTestCaseTestRunComponent";
var _productOrService = "http://hl7.org/fhir/_productOrService";
var reviewOutcome = "http://hl7.org/fhir/reviewOutcome";
var maxDispense = "http://hl7.org/fhir/maxDispense";
var filterDefinition = "http://hl7.org/fhir/filterDefinition";
var sourceAttachment = "http://hl7.org/fhir/sourceAttachment";
var provisionActor = "http://hl7.org/fhir/provisionActor";
var NamingSystem = "http://hl7.org/fhir/NamingSystem";
var dateOfService = "http://hl7.org/fhir/dateOfService";
var VisionPrescription = "http://hl7.org/fhir/VisionPrescription";
var _unitPrice = "http://hl7.org/fhir/_unitPrice";
var resource = "http://hl7.org/fhir/resource";
var _response = "http://hl7.org/fhir/_response";
var _agent = "http://hl7.org/fhir/_agent";
var contraindicatedVaccineCode = "http://hl7.org/fhir/contraindicatedVaccineCode";
var collector = "http://hl7.org/fhir/collector";
var enterer = "http://hl7.org/fhir/enterer";
var _supportedInteraction = "http://hl7.org/fhir/_supportedInteraction";
var _differential = "http://hl7.org/fhir/_differential";
var _qualifiedValue = "http://hl7.org/fhir/_qualifiedValue";
var ManufacturedItemDefinitionComponentConstituentComponent = "http://hl7.org/fhir/ManufacturedItemDefinitionComponentConstituentComponent";
var _additionalMonitoringIndicator = "http://hl7.org/fhir/_additionalMonitoringIndicator";
var _position = "http://hl7.org/fhir/_position";
var limit = "http://hl7.org/fhir/limit";
var _reason = "http://hl7.org/fhir/_reason";
var _planningHorizon = "http://hl7.org/fhir/_planningHorizon";
var _safety = "http://hl7.org/fhir/_safety";
var Identifier = "http://hl7.org/fhir/Identifier";
var _mitigation = "http://hl7.org/fhir/_mitigation";
var _specialCourtesy = "http://hl7.org/fhir/_specialCourtesy";
var ExampleScenarioInstanceContainedInstanceComponent = "http://hl7.org/fhir/ExampleScenarioInstanceContainedInstanceComponent";
var edit = "http://hl7.org/fhir/edit";
var qualitativeRisk = "http://hl7.org/fhir/qualitativeRisk";
var immunizationEvent = "http://hl7.org/fhir/immunizationEvent";
var reference = "http://hl7.org/fhir/reference";
var reporter = "http://hl7.org/fhir/reporter";
var BackboneElement = "http://hl7.org/fhir/BackboneElement";
var _hasMember = "http://hl7.org/fhir/_hasMember";
var Provenance = "http://hl7.org/fhir/Provenance";
var reasonLinkId = "http://hl7.org/fhir/reasonLinkId";
var owner2 = "http://hl7.org/fhir/owner";
var _assignedComparisonGroup = "http://hl7.org/fhir/_assignedComparisonGroup";
var _Condition = "http://hl7.org/fhir/_Condition";
var ConsentPolicyBasisComponent = "http://hl7.org/fhir/ConsentPolicyBasisComponent";
var communicationMethod = "http://hl7.org/fhir/communicationMethod";
var _param = "http://hl7.org/fhir/_param";
var _power = "http://hl7.org/fhir/_power";
var _issue = "http://hl7.org/fhir/_issue";
var concept = "http://hl7.org/fhir/concept";
var decisionMode = "http://hl7.org/fhir/decisionMode";
var instantiatesUri = "http://hl7.org/fhir/instantiatesUri";
var _ifMatch = "http://hl7.org/fhir/_ifMatch";
var sequenceType = "http://hl7.org/fhir/sequenceType";
var _fastingStatus = "http://hl7.org/fhir/_fastingStatus";
var preferredReportName = "http://hl7.org/fhir/preferredReportName";
var _numberOfSeries = "http://hl7.org/fhir/_numberOfSeries";
var rankingOrder = "http://hl7.org/fhir/rankingOrder";
var _currency = "http://hl7.org/fhir/_currency";
var testTools = "http://hl7.org/fhir/testTools";
var _warning = "http://hl7.org/fhir/_warning";
var CoverageEligibilityResponseEventComponent = "http://hl7.org/fhir/CoverageEligibilityResponseEventComponent";
var _characteristic = "http://hl7.org/fhir/_characteristic";
var dataRequirement = "http://hl7.org/fhir/dataRequirement";
var _domain = "http://hl7.org/fhir/_domain";
var InventoryReport = "http://hl7.org/fhir/InventoryReport";
var _parameterName = "http://hl7.org/fhir/_parameterName";
var progressStatus = "http://hl7.org/fhir/progressStatus";
var _narrative = "http://hl7.org/fhir/_narrative";
var Endpoint = "http://hl7.org/fhir/Endpoint";
var subjectState = "http://hl7.org/fhir/subjectState";
var entry = "http://hl7.org/fhir/entry";
var _weeklyTemplate = "http://hl7.org/fhir/_weeklyTemplate";
var what = "http://hl7.org/fhir/what";
var whenPrepared = "http://hl7.org/fhir/whenPrepared";
var Action = "http://hl7.org/fhir/Action";
var _observationRequirement = "http://hl7.org/fhir/_observationRequirement";
var focal = "http://hl7.org/fhir/focal";
var verification = "http://hl7.org/fhir/verification";
var _availability = "http://hl7.org/fhir/_availability";
var resultingEffect = "http://hl7.org/fhir/resultingEffect";
var timeout = "http://hl7.org/fhir/timeout";
var CapabilityStatementMessagingSupportedMessageComponent = "http://hl7.org/fhir/CapabilityStatementMessagingSupportedMessageComponent";
var _revenue = "http://hl7.org/fhir/_revenue";
var _returnedAmount = "http://hl7.org/fhir/_returnedAmount";
var MedicationKnowledgeDefinitionalIngredientComponent = "http://hl7.org/fhir/MedicationKnowledgeDefinitionalIngredientComponent";
var candidate = "http://hl7.org/fhir/candidate";
var Subscription2 = "http://hl7.org/fhir/Subscription";
var relatedAction = "http://hl7.org/fhir/relatedAction";
var textPresentation = "http://hl7.org/fhir/textPresentation";
var _supplements = "http://hl7.org/fhir/_supplements";
var result2 = "http://hl7.org/fhir/result";
var policyText = "http://hl7.org/fhir/policyText";
var _regionType = "http://hl7.org/fhir/_regionType";
var StratifierGroup = "http://hl7.org/fhir/StratifierGroup";
var _contract = "http://hl7.org/fhir/_contract";
var _timeFromEvent = "http://hl7.org/fhir/_timeFromEvent";
var notificationEvent = "http://hl7.org/fhir/notificationEvent";
var _inclusionCriteria = "http://hl7.org/fhir/_inclusionCriteria";
var _orderMeaning = "http://hl7.org/fhir/_orderMeaning";
var autodelete = "http://hl7.org/fhir/autodelete";
var qualifiers = "http://hl7.org/fhir/qualifiers";
var _regionsStudied = "http://hl7.org/fhir/_regionsStudied";
var _application = "http://hl7.org/fhir/_application";
var frequency = "http://hl7.org/fhir/frequency";
var _sourceMaterial = "http://hl7.org/fhir/_sourceMaterial";
var regulatoryBasis = "http://hl7.org/fhir/regulatoryBasis";
var associationType = "http://hl7.org/fhir/associationType";
var _software = "http://hl7.org/fhir/_software";
var _copolymerConnectivity = "http://hl7.org/fhir/_copolymerConnectivity";
var _approvalDate = "http://hl7.org/fhir/_approvalDate";
var totalVolume = "http://hl7.org/fhir/totalVolume";
var AppointmentRecurrenceTemplateWeeklyTemplateComponent = "http://hl7.org/fhir/AppointmentRecurrenceTemplateWeeklyTemplateComponent";
var _requestedPerformer = "http://hl7.org/fhir/_requestedPerformer";
var packagedProduct = "http://hl7.org/fhir/packagedProduct";
var tissue = "http://hl7.org/fhir/tissue";
var isSubpotent = "http://hl7.org/fhir/isSubpotent";
var _supportingInfoSequence = "http://hl7.org/fhir/_supportingInfoSequence";
var _rating = "http://hl7.org/fhir/_rating";
var maternalOrganismName = "http://hl7.org/fhir/maternalOrganismName";
var CommunicationRequest = "http://hl7.org/fhir/CommunicationRequest";
var polymer = "http://hl7.org/fhir/polymer";
var initiatorActive = "http://hl7.org/fhir/initiatorActive";
var _productStatus = "http://hl7.org/fhir/_productStatus";
var strand = "http://hl7.org/fhir/strand";
var _outputParameters = "http://hl7.org/fhir/_outputParameters";
var participantStatus = "http://hl7.org/fhir/participantStatus";
var label = "http://hl7.org/fhir/label";
var manipulated = "http://hl7.org/fhir/manipulated";
var _geometry = "http://hl7.org/fhir/_geometry";
var Coding = "http://hl7.org/fhir/Coding";
var requisition = "http://hl7.org/fhir/requisition";
var InventoryReportInventoryListingComponent = "http://hl7.org/fhir/InventoryReportInventoryListingComponent";
var _parent = "http://hl7.org/fhir/_parent";
var _net = "http://hl7.org/fhir/_net";
var presentation = "http://hl7.org/fhir/presentation";
var flag = "http://hl7.org/fhir/flag";
var hoursOfOperation = "http://hl7.org/fhir/hoursOfOperation";
var encounter = "http://hl7.org/fhir/encounter";
var applicability = "http://hl7.org/fhir/applicability";
var releaseDate = "http://hl7.org/fhir/releaseDate";
var _relationshipType = "http://hl7.org/fhir/_relationshipType";
var _managingOrganization = "http://hl7.org/fhir/_managingOrganization";
var derivedFromCanonical = "http://hl7.org/fhir/derivedFromCanonical";
var _hasSeverity = "http://hl7.org/fhir/_hasSeverity";
var cTerminalModification = "http://hl7.org/fhir/cTerminalModification";
var ContentDefinition = "http://hl7.org/fhir/ContentDefinition";
var _bodyLandmarkOrientation = "http://hl7.org/fhir/_bodyLandmarkOrientation";
var relationship2 = "http://hl7.org/fhir/relationship";
var goal = "http://hl7.org/fhir/goal";
var _connectivity = "http://hl7.org/fhir/_connectivity";
var _listMode = "http://hl7.org/fhir/_listMode";
var _availableTime = "http://hl7.org/fhir/_availableTime";
var property = "http://hl7.org/fhir/property";
var _calibration = "http://hl7.org/fhir/_calibration";
var TerminologyCapabilitiesExpansionParameterComponent = "http://hl7.org/fhir/TerminologyCapabilitiesExpansionParameterComponent";
var adjustmentReason = "http://hl7.org/fhir/adjustmentReason";
var AdministrableProductDefinitionRouteOfAdministrationTargetSpeciesComponent = "http://hl7.org/fhir/AdministrableProductDefinitionRouteOfAdministrationTargetSpeciesComponent";
var Basic = "http://hl7.org/fhir/Basic";
var _isDerived = "http://hl7.org/fhir/_isDerived";
var hierarchical = "http://hl7.org/fhir/hierarchical";
var _resultForCreate = "http://hl7.org/fhir/_resultForCreate";
var _deviceName = "http://hl7.org/fhir/_deviceName";
var _startDate = "http://hl7.org/fhir/_startDate";
var Attachment = "http://hl7.org/fhir/Attachment";
var _patientPreparation = "http://hl7.org/fhir/_patientPreparation";
var CitationCitedArtifactPublicationFormComponent = "http://hl7.org/fhir/CitationCitedArtifactPublicationFormComponent";
var windowStart = "http://hl7.org/fhir/windowStart";
var _propertyGroup = "http://hl7.org/fhir/_propertyGroup";
var languageCode = "http://hl7.org/fhir/languageCode";
var _canPushUpdates = "http://hl7.org/fhir/_canPushUpdates";
var groupingBehavior = "http://hl7.org/fhir/groupingBehavior";
var for__workaround = "http://hl7.org/fhir/for";
var _studyUid = "http://hl7.org/fhir/_studyUid";
var _event = "http://hl7.org/fhir/_event";
var informationProvider = "http://hl7.org/fhir/informationProvider";
var network = "http://hl7.org/fhir/network";
var _manufacturedDoseForm = "http://hl7.org/fhir/_manufacturedDoseForm";
var assert = "http://hl7.org/fhir/assert";
var _warningOnly = "http://hl7.org/fhir/_warningOnly";
var isSummary = "http://hl7.org/fhir/isSummary";
var attachedDocument = "http://hl7.org/fhir/attachedDocument";
var _unit = "http://hl7.org/fhir/_unit";
var _endDate = "http://hl7.org/fhir/_endDate";
var authoredOn = "http://hl7.org/fhir/authoredOn";
var _geographicalLocation = "http://hl7.org/fhir/_geographicalLocation";
var CitationCitedArtifactClassificationComponent = "http://hl7.org/fhir/CitationCitedArtifactClassificationComponent";
var userSelected = "http://hl7.org/fhir/userSelected";
var _prognosisCodeableConcept = "http://hl7.org/fhir/_prognosisCodeableConcept";
var dateCriterion = "http://hl7.org/fhir/dateCriterion";
var additionalInstruction = "http://hl7.org/fhir/additionalInstruction";
var specialPrecautionsForStorage = "http://hl7.org/fhir/specialPrecautionsForStorage";
var population = "http://hl7.org/fhir/population";
var _member = "http://hl7.org/fhir/_member";
var securityLabel = "http://hl7.org/fhir/securityLabel";
var _renderedDosageInstruction = "http://hl7.org/fhir/_renderedDosageInstruction";
var Notes = "http://hl7.org/fhir/Notes";
var _dynamicValue = "http://hl7.org/fhir/_dynamicValue";
var _confidentialityIndicator = "http://hl7.org/fhir/_confidentialityIndicator";
var _intendedUse = "http://hl7.org/fhir/_intendedUse";
var lastUpdated = "http://hl7.org/fhir/lastUpdated";
var deceased = "http://hl7.org/fhir/deceased";
var NutritionOrderEnteralFormulaAdditiveComponent = "http://hl7.org/fhir/NutritionOrderEnteralFormulaAdditiveComponent";
var designation = "http://hl7.org/fhir/designation";
var reportedDateTime = "http://hl7.org/fhir/reportedDateTime";
var productOrServiceEnd = "http://hl7.org/fhir/productOrServiceEnd";
var teardown = "http://hl7.org/fhir/teardown";
var securityLabelNumber = "http://hl7.org/fhir/securityLabelNumber";
var _manufactureDate = "http://hl7.org/fhir/_manufactureDate";
var _textFilter = "http://hl7.org/fhir/_textFilter";
var _route = "http://hl7.org/fhir/_route";
var parentSubstanceName = "http://hl7.org/fhir/parentSubstanceName";
var _docStatus = "http://hl7.org/fhir/_docStatus";
var ArtifactAssessmentContentComponentContentContent = "http://hl7.org/fhir/ArtifactAssessmentContentComponentContentContent";
var _subscriber = "http://hl7.org/fhir/_subscriber";
var workflowStatus = "http://hl7.org/fhir/workflowStatus";
var phylum = "http://hl7.org/fhir/phylum";
var _mustSupport = "http://hl7.org/fhir/_mustSupport";
var forecastStatus = "http://hl7.org/fhir/forecastStatus";
var _closure = "http://hl7.org/fhir/_closure";
var _abstract = "http://hl7.org/fhir/_abstract";
var relatedClinicalInformation = "http://hl7.org/fhir/relatedClinicalInformation";
var PersonCommunicationComponent = "http://hl7.org/fhir/PersonCommunicationComponent";
var _relativePath = "http://hl7.org/fhir/_relativePath";
var CitationCitedArtifactVersionComponent = "http://hl7.org/fhir/CitationCitedArtifactVersionComponent";
var _paging = "http://hl7.org/fhir/_paging";
var _uniqueId = "http://hl7.org/fhir/_uniqueId";
var _readOnly = "http://hl7.org/fhir/_readOnly";
var _jurisdiction = "http://hl7.org/fhir/_jurisdiction";
var _treatment = "http://hl7.org/fhir/_treatment";
var _responsibleParty = "http://hl7.org/fhir/_responsibleParty";
var RequestOrchestrationActionComponentActionAction = "http://hl7.org/fhir/RequestOrchestrationActionComponentActionAction";
var _role = "http://hl7.org/fhir/_role";
var TestPlanDependencyComponent = "http://hl7.org/fhir/TestPlanDependencyComponent";
var Binary = "http://hl7.org/fhir/Binary";
var contentDerivative = "http://hl7.org/fhir/contentDerivative";
var inforce = "http://hl7.org/fhir/inforce";
var RiskAssessmentPredictionComponent = "http://hl7.org/fhir/RiskAssessmentPredictionComponent";
var _enteredDate = "http://hl7.org/fhir/_enteredDate";
var _legalStatusOfSupply = "http://hl7.org/fhir/_legalStatusOfSupply";
var valueAlternatives = "http://hl7.org/fhir/valueAlternatives";
var subject3 = "http://hl7.org/fhir/subject";
var _publicationDate = "http://hl7.org/fhir/_publicationDate";
var occurrenceChanged = "http://hl7.org/fhir/occurrenceChanged";
var _referralRequest = "http://hl7.org/fhir/_referralRequest";
var friday = "http://hl7.org/fhir/friday";
var productType = "http://hl7.org/fhir/productType";
var _payeeType = "http://hl7.org/fhir/_payeeType";
var _fixed = "http://hl7.org/fhir/_fixed";
var _nTerminalModification = "http://hl7.org/fhir/_nTerminalModification";
var _progressStatus = "http://hl7.org/fhir/_progressStatus";
var _age = "http://hl7.org/fhir/_age";
var _verificationDate = "http://hl7.org/fhir/_verificationDate";
var CompartmentDefinitionResourceComponent = "http://hl7.org/fhir/CompartmentDefinitionResourceComponent";
var _questionnaire = "http://hl7.org/fhir/_questionnaire";
var TestScript = "http://hl7.org/fhir/TestScript";
var billingStatus = "http://hl7.org/fhir/billingStatus";
var _resourceTrigger = "http://hl7.org/fhir/_resourceTrigger";
var compose = "http://hl7.org/fhir/compose";
var _submitter = "http://hl7.org/fhir/_submitter";
var _productReference = "http://hl7.org/fhir/_productReference";
var payment = "http://hl7.org/fhir/payment";
var rateAggregation = "http://hl7.org/fhir/rateAggregation";
var OrganizationQualificationComponent = "http://hl7.org/fhir/OrganizationQualificationComponent";
var identityCertificate = "http://hl7.org/fhir/identityCertificate";
var _subDetail = "http://hl7.org/fhir/_subDetail";
var contextInvariant = "http://hl7.org/fhir/contextInvariant";
var _suffix = "http://hl7.org/fhir/_suffix";
var _recurrenceId = "http://hl7.org/fhir/_recurrenceId";
var dispenseInterval = "http://hl7.org/fhir/dispenseInterval";
var _map = "http://hl7.org/fhir/_map";
var _lensSpecification = "http://hl7.org/fhir/_lensSpecification";
var allergyIntolerance = "http://hl7.org/fhir/allergyIntolerance";
var asset = "http://hl7.org/fhir/asset";
var CoverageEligibilityResponse = "http://hl7.org/fhir/CoverageEligibilityResponse";
var OperationDefinitionParameterComponentParameter = "http://hl7.org/fhir/OperationDefinitionParameterComponentParameter";
var packagedMedicinalProduct = "http://hl7.org/fhir/packagedMedicinalProduct";
var _count = "http://hl7.org/fhir/_count";
var SubstancePolymerRepeatRepeatUnitDegreeOfPolymerisationComponent = "http://hl7.org/fhir/SubstancePolymerRepeatRepeatUnitDegreeOfPolymerisationComponent";
var adjudication = "http://hl7.org/fhir/adjudication";
var RequestOrchestrationActionConditionComponent = "http://hl7.org/fhir/RequestOrchestrationActionConditionComponent";
var validator = "http://hl7.org/fhir/validator";
var _gene = "http://hl7.org/fhir/_gene";
var _length = "http://hl7.org/fhir/_length";
var series = "http://hl7.org/fhir/series";
var maxDosePerAdministration = "http://hl7.org/fhir/maxDosePerAdministration";
var _performerRole = "http://hl7.org/fhir/_performerRole";
var _balance = "http://hl7.org/fhir/_balance";
var _correctiveAction = "http://hl7.org/fhir/_correctiveAction";
var dispenser = "http://hl7.org/fhir/dispenser";
var NutritionOrderOralDietComponent = "http://hl7.org/fhir/NutritionOrderOralDietComponent";
var _meaning = "http://hl7.org/fhir/_meaning";
var endParam = "http://hl7.org/fhir/endParam";
var _provider = "http://hl7.org/fhir/_provider";
var inResponseTo = "http://hl7.org/fhir/inResponseTo";
var authorDescription = "http://hl7.org/fhir/authorDescription";
var _intendedExposure = "http://hl7.org/fhir/_intendedExposure";
var _cycle = "http://hl7.org/fhir/_cycle";
var ProvenanceEntityComponentAgent = "http://hl7.org/fhir/ProvenanceEntityComponentAgent";
var high = "http://hl7.org/fhir/high";
var _paymentStatus = "http://hl7.org/fhir/_paymentStatus";
var TestScriptVariableComponent = "http://hl7.org/fhir/TestScriptVariableComponent";
var _comparator = "http://hl7.org/fhir/_comparator";
var _instantiatesCanonical = "http://hl7.org/fhir/_instantiatesCanonical";
var class__workaround2 = "http://hl7.org/fhir/class";
var _countryOfOrigin = "http://hl7.org/fhir/_countryOfOrigin";
var structuralRepresentation = "http://hl7.org/fhir/structuralRepresentation";
var _communicationMethod = "http://hl7.org/fhir/_communicationMethod";
var _size = "http://hl7.org/fhir/_size";
var _averageMolecularFormula = "http://hl7.org/fhir/_averageMolecularFormula";
var _ingredientLabel = "http://hl7.org/fhir/_ingredientLabel";
var _landmarkDescription = "http://hl7.org/fhir/_landmarkDescription";
var _criticalCodedValueSet = "http://hl7.org/fhir/_criticalCodedValueSet";
var unmapped = "http://hl7.org/fhir/unmapped";
var _productCategory = "http://hl7.org/fhir/_productCategory";
var SubstanceReferenceInformationTargetComponent = "http://hl7.org/fhir/SubstanceReferenceInformationTargetComponent";
var _preferredReportName = "http://hl7.org/fhir/_preferredReportName";
var _maternalOrganismId = "http://hl7.org/fhir/_maternalOrganismId";
var _order = "http://hl7.org/fhir/_order";
var qualifier = "http://hl7.org/fhir/qualifier";
var recruitment = "http://hl7.org/fhir/recruitment";
var mitigation = "http://hl7.org/fhir/mitigation";
var Procedure = "http://hl7.org/fhir/Procedure";
var material = "http://hl7.org/fhir/material";
var _packageId = "http://hl7.org/fhir/_packageId";
var address2 = "http://hl7.org/fhir/address";
var module = "http://hl7.org/fhir/module";
var SubstanceNucleicAcidSubunitComponent = "http://hl7.org/fhir/SubstanceNucleicAcidSubunitComponent";
var _healthcareService = "http://hl7.org/fhir/_healthcareService";
var check = "http://hl7.org/fhir/check";
var _serviceProvisionCode = "http://hl7.org/fhir/_serviceProvisionCode";
var DeviceDefinitionHasPartComponent = "http://hl7.org/fhir/DeviceDefinitionHasPartComponent";
var hybrid = "http://hl7.org/fhir/hybrid";
var DeviceDefinitionPackagingComponentPackaging = "http://hl7.org/fhir/DeviceDefinitionPackagingComponentPackaging";
var extends__workaround = "http://hl7.org/fhir/extends";
var AdverseEventSupportingInfoComponent = "http://hl7.org/fhir/AdverseEventSupportingInfoComponent";
var _MedicationRequest = "http://hl7.org/fhir/_MedicationRequest";
var startingSequence = "http://hl7.org/fhir/startingSequence";
var MedicationKnowledgeMonographComponent = "http://hl7.org/fhir/MedicationKnowledgeMonographComponent";
var DetectedIssue = "http://hl7.org/fhir/DetectedIssue";
var targetLocation = "http://hl7.org/fhir/targetLocation";
var MedicinalProductDefinitionCrossReferenceComponent = "http://hl7.org/fhir/MedicinalProductDefinitionCrossReferenceComponent";
var _alternateMaterial = "http://hl7.org/fhir/_alternateMaterial";
var _ordered = "http://hl7.org/fhir/_ordered";
var _List = "http://hl7.org/fhir/_List";
var _gateway = "http://hl7.org/fhir/_gateway";
var _effect = "http://hl7.org/fhir/_effect";
var _coordinate = "http://hl7.org/fhir/_coordinate";
var case__workaround = "http://hl7.org/fhir/case";
var QuestionnaireItemComponentItem = "http://hl7.org/fhir/QuestionnaireItemComponentItem";
var DeviceConformsToComponent = "http://hl7.org/fhir/DeviceConformsToComponent";
var PatientLinkComponent = "http://hl7.org/fhir/PatientLinkComponent";
var testData = "http://hl7.org/fhir/testData";
var ProcedureFocalDeviceComponent = "http://hl7.org/fhir/ProcedureFocalDeviceComponent";
var _typeCanonical = "http://hl7.org/fhir/_typeCanonical";
var nodeId = "http://hl7.org/fhir/nodeId";
var CapabilityStatementSoftwareComponent = "http://hl7.org/fhir/CapabilityStatementSoftwareComponent";
var _preparation = "http://hl7.org/fhir/_preparation";
var _subType = "http://hl7.org/fhir/_subType";
var _definitionCodeableConcept = "http://hl7.org/fhir/_definitionCodeableConcept";
var benefitBalance = "http://hl7.org/fhir/benefitBalance";
var exclusionCriteria = "http://hl7.org/fhir/exclusionCriteria";
var numberOfStudies = "http://hl7.org/fhir/numberOfStudies";
var start = "http://hl7.org/fhir/start";
var AccountRelatedAccountComponent = "http://hl7.org/fhir/AccountRelatedAccountComponent";
var _OperationOutcome = "http://hl7.org/fhir/_OperationOutcome";
var orientation = "http://hl7.org/fhir/orientation";
var holder = "http://hl7.org/fhir/holder";
var _mitigatingAction = "http://hl7.org/fhir/_mitigatingAction";
var include = "http://hl7.org/fhir/include";
var _conditionalPatch = "http://hl7.org/fhir/_conditionalPatch";
var NamingSystemUniqueIdComponent = "http://hl7.org/fhir/NamingSystemUniqueIdComponent";
var _threshold = "http://hl7.org/fhir/_threshold";
var Count = "http://hl7.org/fhir/Count";
var _instantiates = "http://hl7.org/fhir/_instantiates";
var media = "http://hl7.org/fhir/media";
var appliesTo = "http://hl7.org/fhir/appliesTo";
var _implementationGuide = "http://hl7.org/fhir/_implementationGuide";
var RequestOrchestrationActionInputComponent = "http://hl7.org/fhir/RequestOrchestrationActionInputComponent";
var _discriminator = "http://hl7.org/fhir/_discriminator";
var ClaimResponse = "http://hl7.org/fhir/ClaimResponse";
var section = "http://hl7.org/fhir/section";
var _workflowStatus = "http://hl7.org/fhir/_workflowStatus";
var _DeviceMetric = "http://hl7.org/fhir/_DeviceMetric";
var diseaseSymptomProcedure = "http://hl7.org/fhir/diseaseSymptomProcedure";
var _keyword = "http://hl7.org/fhir/_keyword";
var _forecastStatus = "http://hl7.org/fhir/_forecastStatus";
var Bundle = "http://hl7.org/fhir/Bundle";
var _excluded = "http://hl7.org/fhir/_excluded";
var _transform = "http://hl7.org/fhir/_transform";
var intent = "http://hl7.org/fhir/intent";
var _slicing = "http://hl7.org/fhir/_slicing";
var generalPractitioner = "http://hl7.org/fhir/generalPractitioner";
var gestationalAge = "http://hl7.org/fhir/gestationalAge";
var _account = "http://hl7.org/fhir/_account";
var _administeredProduct = "http://hl7.org/fhir/_administeredProduct";
var answerOption = "http://hl7.org/fhir/answerOption";
var regionType = "http://hl7.org/fhir/regionType";
var _association = "http://hl7.org/fhir/_association";
var _messaging = "http://hl7.org/fhir/_messaging";
var organismType = "http://hl7.org/fhir/organismType";
var accept = "http://hl7.org/fhir/accept";
var _methodType = "http://hl7.org/fhir/_methodType";
var _authorizationRequired = "http://hl7.org/fhir/_authorizationRequired";
var includedStructure = "http://hl7.org/fhir/includedStructure";
var sourceIdentityCertificate = "http://hl7.org/fhir/sourceIdentityCertificate";
var foodType = "http://hl7.org/fhir/foodType";
var temperatureRange = "http://hl7.org/fhir/temperatureRange";
var ManifestPage = "http://hl7.org/fhir/ManifestPage";
var DeviceRequest = "http://hl7.org/fhir/DeviceRequest";
var _contextLinkId = "http://hl7.org/fhir/_contextLinkId";
var ExampleScenarioProcessStepOperationComponent = "http://hl7.org/fhir/ExampleScenarioProcessStepOperationComponent";
var SubstanceDefinitionStructureComponent = "http://hl7.org/fhir/SubstanceDefinitionStructureComponent";
var calculatedAt = "http://hl7.org/fhir/calculatedAt";
var MarketingStatus = "http://hl7.org/fhir/MarketingStatus";
var _emptyReason = "http://hl7.org/fhir/_emptyReason";
var _offsets = "http://hl7.org/fhir/_offsets";
var _financial = "http://hl7.org/fhir/_financial";
var _exposureRoute = "http://hl7.org/fhir/_exposureRoute";
var _policyHolder = "http://hl7.org/fhir/_policyHolder";
var SupplyDeliverySuppliedItemComponent = "http://hl7.org/fhir/SupplyDeliverySuppliedItemComponent";
var intendedRoute = "http://hl7.org/fhir/intendedRoute";
var _paymentDate = "http://hl7.org/fhir/_paymentDate";
var GenomicStudyAnalysisDeviceComponent = "http://hl7.org/fhir/GenomicStudyAnalysisDeviceComponent";
var _informationProvider = "http://hl7.org/fhir/_informationProvider";
var _outsideFoodAllowed = "http://hl7.org/fhir/_outsideFoodAllowed";
var feature = "http://hl7.org/fhir/feature";
var needsMap = "http://hl7.org/fhir/needsMap";
var _dataAbsentReason = "http://hl7.org/fhir/_dataAbsentReason";
var _definition = "http://hl7.org/fhir/_definition";
var creation = "http://hl7.org/fhir/creation";
var _minValue = "http://hl7.org/fhir/_minValue";
var width2 = "http://hl7.org/fhir/width";
var _Permission = "http://hl7.org/fhir/_Permission";
var AllergyIntolerance = "http://hl7.org/fhir/AllergyIntolerance";
var _Encounter = "http://hl7.org/fhir/_Encounter";
var targetNumber = "http://hl7.org/fhir/targetNumber";
var severity = "http://hl7.org/fhir/severity";
var ObservationDefinitionQualifiedValueComponent = "http://hl7.org/fhir/ObservationDefinitionQualifiedValueComponent";
var filterBy = "http://hl7.org/fhir/filterBy";
var packaging = "http://hl7.org/fhir/packaging";
var endorser = "http://hl7.org/fhir/endorser";
var _relatesTo = "http://hl7.org/fhir/_relatesTo";
var _sourceSignature = "http://hl7.org/fhir/_sourceSignature";
var abnormalCodedValueSet = "http://hl7.org/fhir/abnormalCodedValueSet";
var lastOccurrenceDate = "http://hl7.org/fhir/lastOccurrenceDate";
var _securityLabelNumber = "http://hl7.org/fhir/_securityLabelNumber";
var _queryCriteria = "http://hl7.org/fhir/_queryCriteria";
var _multipleResultsAllowed = "http://hl7.org/fhir/_multipleResultsAllowed";
var _allowed = "http://hl7.org/fhir/_allowed";
var _TestReport = "http://hl7.org/fhir/_TestReport";
var _Location = "http://hl7.org/fhir/_Location";
var deviceName = "http://hl7.org/fhir/deviceName";
var ImmunizationReactionComponent = "http://hl7.org/fhir/ImmunizationReactionComponent";
var ConceptMap = "http://hl7.org/fhir/ConceptMap";
var _daysOfWeek = "http://hl7.org/fhir/_daysOfWeek";
var ParameterDefinition = "http://hl7.org/fhir/ParameterDefinition";
var _packageCode = "http://hl7.org/fhir/_packageCode";
var Insurance = "http://hl7.org/fhir/Insurance";
var lastPerformed = "http://hl7.org/fhir/lastPerformed";
var IngredientManufacturerComponent = "http://hl7.org/fhir/IngredientManufacturerComponent";
var nthWeekOfMonth = "http://hl7.org/fhir/nthWeekOfMonth";
var targetSpecies = "http://hl7.org/fhir/targetSpecies";
var authorization = "http://hl7.org/fhir/authorization";
var _RequestOrchestration = "http://hl7.org/fhir/_RequestOrchestration";
var _endpoint = "http://hl7.org/fhir/_endpoint";
var triggeredBy = "http://hl7.org/fhir/triggeredBy";
var _Dosage = "http://hl7.org/fhir/_Dosage";
var _doNotPerform = "http://hl7.org/fhir/_doNotPerform";
var careTeam = "http://hl7.org/fhir/careTeam";
var _meta = "http://hl7.org/fhir/_meta";
var TerminologyCapabilitiesCodeSystemVersionComponent = "http://hl7.org/fhir/TerminologyCapabilitiesCodeSystemVersionComponent";
var entryQuantity = "http://hl7.org/fhir/entryQuantity";
var CapabilityStatementMessagingEndpointComponent = "http://hl7.org/fhir/CapabilityStatementMessagingEndpointComponent";
var nTerminalModification = "http://hl7.org/fhir/nTerminalModification";
var _asNeededFor = "http://hl7.org/fhir/_asNeededFor";
var _link = "http://hl7.org/fhir/_link";
var attribute = "http://hl7.org/fhir/attribute";
var Note2 = "http://hl7.org/fhir/Note";
var textFilter = "http://hl7.org/fhir/textFilter";
var disposition = "http://hl7.org/fhir/disposition";
var PackagedProductDefinition = "http://hl7.org/fhir/PackagedProductDefinition";
var Accident = "http://hl7.org/fhir/Accident";
var _reference = "http://hl7.org/fhir/_reference";
var StructureMapGroupRuleTargetParameterComponent = "http://hl7.org/fhir/StructureMapGroupRuleTargetParameterComponent";
var subscriber = "http://hl7.org/fhir/subscriber";
var structureType = "http://hl7.org/fhir/structureType";
var _detail = "http://hl7.org/fhir/_detail";
var meaningWhenMissing = "http://hl7.org/fhir/meaningWhenMissing";
var modelCharacteristic = "http://hl7.org/fhir/modelCharacteristic";
var mapping = "http://hl7.org/fhir/mapping";
var _Person = "http://hl7.org/fhir/_Person";
var _eligibility = "http://hl7.org/fhir/_eligibility";
var SubstanceSourceMaterialFractionDescriptionComponent = "http://hl7.org/fhir/SubstanceSourceMaterialFractionDescriptionComponent";
var typeCollected = "http://hl7.org/fhir/typeCollected";
var timestamp = "http://hl7.org/fhir/timestamp";
var _subpotentReason = "http://hl7.org/fhir/_subpotentReason";
var _relatedMedicationKnowledge = "http://hl7.org/fhir/_relatedMedicationKnowledge";
var _inventoryStatus = "http://hl7.org/fhir/_inventoryStatus";
var synonym = "http://hl7.org/fhir/synonym";
var _category = "http://hl7.org/fhir/_category";
var _regulatory = "http://hl7.org/fhir/_regulatory";
var birthDate = "http://hl7.org/fhir/birthDate";
var _priorPrescription = "http://hl7.org/fhir/_priorPrescription";
var Base = "http://hl7.org/fhir/Base";
var _testTools = "http://hl7.org/fhir/_testTools";
var _targetLocation = "http://hl7.org/fhir/_targetLocation";
var substanceDefinition = "http://hl7.org/fhir/substanceDefinition";
var _medication = "http://hl7.org/fhir/_medication";
var _vaccineCode = "http://hl7.org/fhir/_vaccineCode";
var _dateAsserted = "http://hl7.org/fhir/_dateAsserted";
var DeviceDefinitionMaterialComponent = "http://hl7.org/fhir/DeviceDefinitionMaterialComponent";
var _codeSearch = "http://hl7.org/fhir/_codeSearch";
var range = "http://hl7.org/fhir/range";
var NutritionOrder = "http://hl7.org/fhir/NutritionOrder";
var _dispenserInstruction = "http://hl7.org/fhir/_dispenserInstruction";
var _summary = "http://hl7.org/fhir/_summary";
var _synthesisType = "http://hl7.org/fhir/_synthesisType";
var productName = "http://hl7.org/fhir/productName";
var _reviewOutcome = "http://hl7.org/fhir/_reviewOutcome";
var claimResponse = "http://hl7.org/fhir/claimResponse";
var path = "http://hl7.org/fhir/path";
var additive = "http://hl7.org/fhir/additive";
var ElementDefinition = "http://hl7.org/fhir/ElementDefinition";
var fundingSource = "http://hl7.org/fhir/fundingSource";
var instantiatesCanonical = "http://hl7.org/fhir/instantiatesCanonical";
var family = "http://hl7.org/fhir/family";
var NutritionIntake = "http://hl7.org/fhir/NutritionIntake";
var EvidenceReport = "http://hl7.org/fhir/EvidenceReport";
var billablePeriod = "http://hl7.org/fhir/billablePeriod";
var _otherTherapy = "http://hl7.org/fhir/_otherTherapy";
var _dateOfService = "http://hl7.org/fhir/_dateOfService";
var _benefitBalance = "http://hl7.org/fhir/_benefitBalance";
var _information = "http://hl7.org/fhir/_information";
var _CareTeam = "http://hl7.org/fhir/_CareTeam";
var _aggregateMethod = "http://hl7.org/fhir/_aggregateMethod";
var generatedBy = "http://hl7.org/fhir/generatedBy";
var _tag = "http://hl7.org/fhir/_tag";
var asserter = "http://hl7.org/fhir/asserter";
var _revInclude = "http://hl7.org/fhir/_revInclude";
var onset = "http://hl7.org/fhir/onset";
var criticalCodedValueSet = "http://hl7.org/fhir/criticalCodedValueSet";
var _mode = "http://hl7.org/fhir/_mode";
var anchor = "http://hl7.org/fhir/anchor";
var _substitution = "http://hl7.org/fhir/_substitution";
var _consent = "http://hl7.org/fhir/_consent";
var _candidate = "http://hl7.org/fhir/_candidate";
var _concept = "http://hl7.org/fhir/_concept";
var MeasureReportGroupStratifierStratumComponentComponent = "http://hl7.org/fhir/MeasureReportGroupStratifierStratumComponentComponent";
var ifNoneExist = "http://hl7.org/fhir/ifNoneExist";
var GraphDefinitionNodeComponent = "http://hl7.org/fhir/GraphDefinitionNodeComponent";
var _answer = "http://hl7.org/fhir/_answer";
var _schedule = "http://hl7.org/fhir/_schedule";
var administrationTreatment = "http://hl7.org/fhir/administrationTreatment";
var _baseFormulaProductName = "http://hl7.org/fhir/_baseFormulaProductName";
var PermissionRuleDataResourceComponent = "http://hl7.org/fhir/PermissionRuleDataResourceComponent";
var _gestationalAge = "http://hl7.org/fhir/_gestationalAge";
var carrierAIDC = "http://hl7.org/fhir/carrierAIDC";
var _capability = "http://hl7.org/fhir/_capability";
var usageStatus = "http://hl7.org/fhir/usageStatus";
var _knownAllergen = "http://hl7.org/fhir/_knownAllergen";
var storageTempRequirements = "http://hl7.org/fhir/storageTempRequirements";
var definitionReference = "http://hl7.org/fhir/definitionReference";
var experimental = "http://hl7.org/fhir/experimental";
var _numberOfParticipants = "http://hl7.org/fhir/_numberOfParticipants";
var _repeat = "http://hl7.org/fhir/_repeat";
var displayName = "http://hl7.org/fhir/displayName";
var replaces2 = "http://hl7.org/fhir/replaces";
var _distanceFromLandmark = "http://hl7.org/fhir/_distanceFromLandmark";
var _frequency = "http://hl7.org/fhir/_frequency";
var shortDoco = "http://hl7.org/fhir/shortDoco";
var ImagingSelection = "http://hl7.org/fhir/ImagingSelection";
var modality = "http://hl7.org/fhir/modality";
var _targetId = "http://hl7.org/fhir/_targetId";
var _amount = "http://hl7.org/fhir/_amount";
var species = "http://hl7.org/fhir/species";
var totalNet = "http://hl7.org/fhir/totalNet";
var observationRequirement = "http://hl7.org/fhir/observationRequirement";
var InsurancePlanPlanGeneralCostComponent = "http://hl7.org/fhir/InsurancePlanPlanGeneralCostComponent";
var InvoiceLineItemComponent = "http://hl7.org/fhir/InvoiceLineItemComponent";
var requestor = "http://hl7.org/fhir/requestor";
var dietPreference = "http://hl7.org/fhir/dietPreference";
var comparator = "http://hl7.org/fhir/comparator";
var _combinedPharmaceuticalDoseForm = "http://hl7.org/fhir/_combinedPharmaceuticalDoseForm";
var servicePeriod = "http://hl7.org/fhir/servicePeriod";
var _rater = "http://hl7.org/fhir/_rater";
var receiverActive = "http://hl7.org/fhir/receiverActive";
var modification = "http://hl7.org/fhir/modification";
var practitioner = "http://hl7.org/fhir/practitioner";
var _normalCodedValueSet = "http://hl7.org/fhir/_normalCodedValueSet";
var TestCaseDependency = "http://hl7.org/fhir/TestCaseDependency";
var _costToBeneficiary = "http://hl7.org/fhir/_costToBeneficiary";
var MessageHeader = "http://hl7.org/fhir/MessageHeader";
var ResearchStudyRecruitmentComponent = "http://hl7.org/fhir/ResearchStudyRecruitmentComponent";
var _forenameInitials = "http://hl7.org/fhir/_forenameInitials";
var plannedStartDate = "http://hl7.org/fhir/plannedStartDate";
var study = "http://hl7.org/fhir/study";
var groupIdentifier = "http://hl7.org/fhir/groupIdentifier";
var _participatingOrganization = "http://hl7.org/fhir/_participatingOrganization";
var MeasureGroupStratifierComponent = "http://hl7.org/fhir/MeasureGroupStratifierComponent";
var wednesday = "http://hl7.org/fhir/wednesday";
var _diameter = "http://hl7.org/fhir/_diameter";
var enteralFormula = "http://hl7.org/fhir/enteralFormula";
var _stabilityDuration = "http://hl7.org/fhir/_stabilityDuration";
var integer = "http://hl7.org/fhir/integer";
var domain = "http://hl7.org/fhir/domain";
var _periodType = "http://hl7.org/fhir/_periodType";
var _ImagingStudy = "http://hl7.org/fhir/_ImagingStudy";
var searchRevInclude = "http://hl7.org/fhir/searchRevInclude";
var _relatedAction = "http://hl7.org/fhir/_relatedAction";
var observed = "http://hl7.org/fhir/observed";
var born = "http://hl7.org/fhir/born";
var _ImmunizationRecommendation = "http://hl7.org/fhir/_ImmunizationRecommendation";
var service = "http://hl7.org/fhir/service";
var _requestIdentifier = "http://hl7.org/fhir/_requestIdentifier";
var maxDosePerLifetime = "http://hl7.org/fhir/maxDosePerLifetime";
var format3 = "http://hl7.org/fhir/format";
var _isSummary = "http://hl7.org/fhir/_isSummary";
var supportingInfoSequence = "http://hl7.org/fhir/supportingInfoSequence";
var EvidenceStatisticModelCharacteristicVariableComponent = "http://hl7.org/fhir/EvidenceStatisticModelCharacteristicVariableComponent";
var ManufacturedItemDefinitionPropertyComponent = "http://hl7.org/fhir/ManufacturedItemDefinitionPropertyComponent";
var _concentration = "http://hl7.org/fhir/_concentration";
var coordinate = "http://hl7.org/fhir/coordinate";
var AddedItemDetailSubDetail = "http://hl7.org/fhir/AddedItemDetailSubDetail";
var TerminologyCapabilitiesTranslationComponent = "http://hl7.org/fhir/TerminologyCapabilitiesTranslationComponent";
var _generalPractitioner = "http://hl7.org/fhir/_generalPractitioner";
var _protocol = "http://hl7.org/fhir/_protocol";
var _exception = "http://hl7.org/fhir/_exception";
var _complication = "http://hl7.org/fhir/_complication";
var value = "http://hl7.org/fhir/value";
var _nthWeekOfMonth = "http://hl7.org/fhir/_nthWeekOfMonth";
var _url = "http://hl7.org/fhir/_url";
var SubstanceSourceMaterialOrganismHybridComponent = "http://hl7.org/fhir/SubstanceSourceMaterialOrganismHybridComponent";
var SubscriptionTopicEventTriggerComponent = "http://hl7.org/fhir/SubscriptionTopicEventTriggerComponent";
var MedicinalProductDefinitionNameComponent = "http://hl7.org/fhir/MedicinalProductDefinitionNameComponent";
var SubstanceSourceMaterialOrganismComponent = "http://hl7.org/fhir/SubstanceSourceMaterialOrganismComponent";
var overrideReason = "http://hl7.org/fhir/overrideReason";
var pages = "http://hl7.org/fhir/pages";
var _conclusion = "http://hl7.org/fhir/_conclusion";
var _combined = "http://hl7.org/fhir/_combined";
var _contains = "http://hl7.org/fhir/_contains";
var _documentType = "http://hl7.org/fhir/_documentType";
var MeasureGroupStratifierComponentComponent = "http://hl7.org/fhir/MeasureGroupStratifierComponentComponent";
var _numberOfInstances = "http://hl7.org/fhir/_numberOfInstances";
var PlanDefinitionActionComponent = "http://hl7.org/fhir/PlanDefinitionActionComponent";
var _processor = "http://hl7.org/fhir/_processor";
var actualNumber = "http://hl7.org/fhir/actualNumber";
var _network = "http://hl7.org/fhir/_network";
var effective = "http://hl7.org/fhir/effective";
var textEquivalent = "http://hl7.org/fhir/textEquivalent";
var preferred = "http://hl7.org/fhir/preferred";
var ImplementationGuide = "http://hl7.org/fhir/ImplementationGuide";
var EvidenceReportRelatesToTargetComponent = "http://hl7.org/fhir/EvidenceReportRelatesToTargetComponent";
var _applicability = "http://hl7.org/fhir/_applicability";
var min = "http://hl7.org/fhir/min";
var DeviceNameComponent = "http://hl7.org/fhir/DeviceNameComponent";
var Payment = "http://hl7.org/fhir/Payment";
var organismName = "http://hl7.org/fhir/organismName";
var relative = "http://hl7.org/fhir/relative";
var Ratio = "http://hl7.org/fhir/Ratio";
var item = "http://hl7.org/fhir/item";
var rating2 = "http://hl7.org/fhir/rating";
var _numerator = "http://hl7.org/fhir/_numerator";
var TestScriptScopeComponent = "http://hl7.org/fhir/TestScriptScopeComponent";
var _aggregation = "http://hl7.org/fhir/_aggregation";
var minutesDuration = "http://hl7.org/fhir/minutesDuration";
var AuditEventEntityComponent = "http://hl7.org/fhir/AuditEventEntityComponent";
var rate = "http://hl7.org/fhir/rate";
var CompartmentDefinition = "http://hl7.org/fhir/CompartmentDefinition";
var renderedDosageInstruction = "http://hl7.org/fhir/renderedDosageInstruction";
var methodType = "http://hl7.org/fhir/methodType";
var parent = "http://hl7.org/fhir/parent";
var sourceId = "http://hl7.org/fhir/sourceId";
var _requestedPeriod = "http://hl7.org/fhir/_requestedPeriod";
var _chromosome = "http://hl7.org/fhir/_chromosome";
var isSubPotent = "http://hl7.org/fhir/isSubPotent";
var presentedForm = "http://hl7.org/fhir/presentedForm";
var repetitions = "http://hl7.org/fhir/repetitions";
var aggregate = "http://hl7.org/fhir/aggregate";
var EvidenceStatisticComponent = "http://hl7.org/fhir/EvidenceStatisticComponent";
var ImplementationGuideDefinitionParameterComponent = "http://hl7.org/fhir/ImplementationGuideDefinitionParameterComponent";
var CompositionEventComponent = "http://hl7.org/fhir/CompositionEventComponent";
var _NutritionOrder = "http://hl7.org/fhir/_NutritionOrder";
var TaskInputComponent = "http://hl7.org/fhir/TaskInputComponent";
var rule = "http://hl7.org/fhir/rule";
var Specimen = "http://hl7.org/fhir/Specimen";
var _MedicinalProductDefinition = "http://hl7.org/fhir/_MedicinalProductDefinition";
var OperationDefinition = "http://hl7.org/fhir/OperationDefinition";
var process2 = "http://hl7.org/fhir/process";
var CitationCitedArtifactContributorshipEntryContributionInstanceComponent = "http://hl7.org/fhir/CitationCitedArtifactContributorshipEntryContributionInstanceComponent";
var EncounterAdmissionComponent = "http://hl7.org/fhir/EncounterAdmissionComponent";
var _MedicationDispense = "http://hl7.org/fhir/_MedicationDispense";
var translation = "http://hl7.org/fhir/translation";
var ObservationTriggeredByComponent = "http://hl7.org/fhir/ObservationTriggeredByComponent";
var _etag = "http://hl7.org/fhir/_etag";
var _dateCriterion = "http://hl7.org/fhir/_dateCriterion";
var _administrationInstruction = "http://hl7.org/fhir/_administrationInstruction";
var part = "http://hl7.org/fhir/part";
var _billablePeriod = "http://hl7.org/fhir/_billablePeriod";
var requestHeader = "http://hl7.org/fhir/requestHeader";
var _shortTitle = "http://hl7.org/fhir/_shortTitle";
var _securityLabel = "http://hl7.org/fhir/_securityLabel";
var _procedure = "http://hl7.org/fhir/_procedure";
var periodMax = "http://hl7.org/fhir/periodMax";
var monograph = "http://hl7.org/fhir/monograph";
var _eventsSinceSubscriptionStart = "http://hl7.org/fhir/_eventsSinceSubscriptionStart";
var QuestionnaireResponseItemAnswerComponent = "http://hl7.org/fhir/QuestionnaireResponseItemAnswerComponent";
var formatted = "http://hl7.org/fhir/formatted";
var restoreDate = "http://hl7.org/fhir/restoreDate";
var _grouping = "http://hl7.org/fhir/_grouping";
var definition = "http://hl7.org/fhir/definition";
var BodyStructureIncludedStructureBodyLandmarkOrientationDistanceFromLandmarkComponent = "http://hl7.org/fhir/BodyStructureIncludedStructureBodyLandmarkOrientationDistanceFromLandmarkComponent";
var dayOfWeek = "http://hl7.org/fhir/dayOfWeek";
var _variableDefinition = "http://hl7.org/fhir/_variableDefinition";
var nodeRole = "http://hl7.org/fhir/nodeRole";
var Permission = "http://hl7.org/fhir/Permission";
var dateWritten = "http://hl7.org/fhir/dateWritten";
var ratioHighLimitAmount = "http://hl7.org/fhir/ratioHighLimitAmount";
var _relatedData = "http://hl7.org/fhir/_relatedData";
var _inforce = "http://hl7.org/fhir/_inforce";
var _reportingVendor = "http://hl7.org/fhir/_reportingVendor";
var _sequenceRange = "http://hl7.org/fhir/_sequenceRange";
var member = "http://hl7.org/fhir/member";
var _versionAlgorithm = "http://hl7.org/fhir/_versionAlgorithm";
var _subject = "http://hl7.org/fhir/_subject";
var _case = "http://hl7.org/fhir/_case";
var _ClinicalUseDefinition = "http://hl7.org/fhir/_ClinicalUseDefinition";
var _cylinder = "http://hl7.org/fhir/_cylinder";
var _saturday = "http://hl7.org/fhir/_saturday";
var ConceptMapGroupUnmappedComponent = "http://hl7.org/fhir/ConceptMapGroupUnmappedComponent";
var Address2 = "http://hl7.org/fhir/Address";
var _validateCode = "http://hl7.org/fhir/_validateCode";
var _dispenser = "http://hl7.org/fhir/_dispenser";
var _issued = "http://hl7.org/fhir/_issued";
var TestReport = "http://hl7.org/fhir/TestReport";
var conditionalRead = "http://hl7.org/fhir/conditionalRead";
var fullUrl = "http://hl7.org/fhir/fullUrl";
var parameterFocus = "http://hl7.org/fhir/parameterFocus";
var _currentState = "http://hl7.org/fhir/_currentState";
var ActivityDefinition = "http://hl7.org/fhir/ActivityDefinition";
var daysOfWeek = "http://hl7.org/fhir/daysOfWeek";
var containedInstance = "http://hl7.org/fhir/containedInstance";
var StructureMapGroupRuleSourceComponent = "http://hl7.org/fhir/StructureMapGroupRuleSourceComponent";
var application = "http://hl7.org/fhir/application";
var received = "http://hl7.org/fhir/received";
var AuditEventEntityComponentAgent = "http://hl7.org/fhir/AuditEventEntityComponentAgent";
var element = "http://hl7.org/fhir/element";
var _compose = "http://hl7.org/fhir/_compose";
var _environmentalSetting = "http://hl7.org/fhir/_environmentalSetting";
var _payment = "http://hl7.org/fhir/_payment";
var _preparedDate = "http://hl7.org/fhir/_preparedDate";
var ImagingSelectionInstanceComponent = "http://hl7.org/fhir/ImagingSelectionInstanceComponent";
var _responseRequired = "http://hl7.org/fhir/_responseRequired";
var _contraindication = "http://hl7.org/fhir/_contraindication";
var _operator = "http://hl7.org/fhir/_operator";
var ActivityDefinitionParticipantComponent = "http://hl7.org/fhir/ActivityDefinitionParticipantComponent";
var _contraindicatedVaccineCode = "http://hl7.org/fhir/_contraindicatedVaccineCode";
var _membership = "http://hl7.org/fhir/_membership";
var _recordedDate = "http://hl7.org/fhir/_recordedDate";
var _provision = "http://hl7.org/fhir/_provision";
var _dietPreference = "http://hl7.org/fhir/_dietPreference";
var _laterality = "http://hl7.org/fhir/_laterality";
var _parentSubstanceId = "http://hl7.org/fhir/_parentSubstanceId";
var _report = "http://hl7.org/fhir/_report";
var MedicationDispensePerformerComponent = "http://hl7.org/fhir/MedicationDispensePerformerComponent";
var FamilyMemberHistoryConditionComponent = "http://hl7.org/fhir/FamilyMemberHistoryConditionComponent";
var _editor = "http://hl7.org/fhir/_editor";
var instant = "http://hl7.org/fhir/instant";
var paging = "http://hl7.org/fhir/paging";
var _receiverActive = "http://hl7.org/fhir/_receiverActive";
var publicationForm = "http://hl7.org/fhir/publicationForm";
var operation = "http://hl7.org/fhir/operation";
var organism = "http://hl7.org/fhir/organism";
var focus = "http://hl7.org/fhir/focus";
var _reviewer = "http://hl7.org/fhir/_reviewer";
var validCodedValueSet = "http://hl7.org/fhir/validCodedValueSet";
var Signatory = "http://hl7.org/fhir/Signatory";
var clockFacePosition = "http://hl7.org/fhir/clockFacePosition";
var _instanceReference = "http://hl7.org/fhir/_instanceReference";
var withdrawalPeriod = "http://hl7.org/fhir/withdrawalPeriod";
var conformance = "http://hl7.org/fhir/conformance";
var effectivePeriod = "http://hl7.org/fhir/effectivePeriod";
var _matchStatus = "http://hl7.org/fhir/_matchStatus";
var virtualService = "http://hl7.org/fhir/virtualService";
var Communication = "http://hl7.org/fhir/Communication";
var _enteralFormula = "http://hl7.org/fhir/_enteralFormula";
var whenHandedOver = "http://hl7.org/fhir/whenHandedOver";
var EvidenceReportSubjectComponent = "http://hl7.org/fhir/EvidenceReportSubjectComponent";
var substance = "http://hl7.org/fhir/substance";
var Section = "http://hl7.org/fhir/Section";
var _valueRange = "http://hl7.org/fhir/_valueRange";
var regulatoryIdentifier = "http://hl7.org/fhir/regulatoryIdentifier";
var kind = "http://hl7.org/fhir/kind";
var hasIngredient = "http://hl7.org/fhir/hasIngredient";
var detailSequence = "http://hl7.org/fhir/detailSequence";
var NutritionProductNutrientComponent = "http://hl7.org/fhir/NutritionProductNutrientComponent";
var _fractionDescription = "http://hl7.org/fhir/_fractionDescription";
var _degreeOfPolymerisation = "http://hl7.org/fhir/_degreeOfPolymerisation";
var _Account = "http://hl7.org/fhir/_Account";
var rangeCategory = "http://hl7.org/fhir/rangeCategory";
var _index = "http://hl7.org/fhir/_index";
var ValueSetComposeComponentInclude = "http://hl7.org/fhir/ValueSetComposeComponentInclude";
var regulatory = "http://hl7.org/fhir/regulatory";
var _modifier = "http://hl7.org/fhir/_modifier";
var _short = "http://hl7.org/fhir/_short";
var medication = "http://hl7.org/fhir/medication";
var codeSearch = "http://hl7.org/fhir/codeSearch";
var suffix = "http://hl7.org/fhir/suffix";
var MedicationDispenseSubstitutionComponent = "http://hl7.org/fhir/MedicationDispenseSubstitutionComponent";
var foodPreferenceModifier = "http://hl7.org/fhir/foodPreferenceModifier";
var Immunization = "http://hl7.org/fhir/Immunization";
var AppointmentRecurrenceTemplateMonthlyTemplateComponent = "http://hl7.org/fhir/AppointmentRecurrenceTemplateMonthlyTemplateComponent";
var preventiveAction = "http://hl7.org/fhir/preventiveAction";
var _AdministrableProductDefinition = "http://hl7.org/fhir/_AdministrableProductDefinition";
var _deliverFrom = "http://hl7.org/fhir/_deliverFrom";
var _address = "http://hl7.org/fhir/_address";
var intendedUse = "http://hl7.org/fhir/intendedUse";
var ElementDefinitionSlicingDiscriminatorComponent = "http://hl7.org/fhir/ElementDefinitionSlicingDiscriminatorComponent";
var SubscriptionTopic = "http://hl7.org/fhir/SubscriptionTopic";
var GenomicStudy = "http://hl7.org/fhir/GenomicStudy";
var _partLocation = "http://hl7.org/fhir/_partLocation";
var _subsumption = "http://hl7.org/fhir/_subsumption";
var BenefitBalance = "http://hl7.org/fhir/BenefitBalance";
var script = "http://hl7.org/fhir/script";
var _resourceReference = "http://hl7.org/fhir/_resourceReference";
var lastReviewDate = "http://hl7.org/fhir/lastReviewDate";
var SubstanceDefinitionNameComponentNameName = "http://hl7.org/fhir/SubstanceDefinitionNameComponentNameName";
var length = "http://hl7.org/fhir/length";
var _overrideReason = "http://hl7.org/fhir/_overrideReason";
var _period = "http://hl7.org/fhir/_period";
var TerminologyCapabilities = "http://hl7.org/fhir/TerminologyCapabilities";
var _supportingPatientInformation = "http://hl7.org/fhir/_supportingPatientInformation";
var OperationDefinitionParameterBindingComponent = "http://hl7.org/fhir/OperationDefinitionParameterBindingComponent";
var Task = "http://hl7.org/fhir/Task";
var MeasureReportGroupPopulationComponent = "http://hl7.org/fhir/MeasureReportGroupPopulationComponent";
var revInclude = "http://hl7.org/fhir/revInclude";
var _appliesTo = "http://hl7.org/fhir/_appliesTo";
var MedicationKnowledgeDefinitionalComponent = "http://hl7.org/fhir/MedicationKnowledgeDefinitionalComponent";
var usageInstruction = "http://hl7.org/fhir/usageInstruction";
var trigger2 = "http://hl7.org/fhir/trigger";
var mustSupport = "http://hl7.org/fhir/mustSupport";
var TimingRepeatComponent = "http://hl7.org/fhir/TimingRepeatComponent";
var effectiveDosePeriod = "http://hl7.org/fhir/effectiveDosePeriod";
var _textEquivalent = "http://hl7.org/fhir/_textEquivalent";
var bodysite = "http://hl7.org/fhir/bodysite";
var _appliesToAll = "http://hl7.org/fhir/_appliesToAll";
var comorbidity = "http://hl7.org/fhir/comorbidity";
var TestScriptFixtureComponent = "http://hl7.org/fhir/TestScriptFixtureComponent";
var oligoNucleotideType = "http://hl7.org/fhir/oligoNucleotideType";
var intendedEffect = "http://hl7.org/fhir/intendedEffect";
var _conformsTo = "http://hl7.org/fhir/_conformsTo";
var copyright = "http://hl7.org/fhir/copyright";
var _insurance = "http://hl7.org/fhir/_insurance";
var _partDescription = "http://hl7.org/fhir/_partDescription";
var _genomeBuild = "http://hl7.org/fhir/_genomeBuild";
var Slot = "http://hl7.org/fhir/Slot";
var _medium = "http://hl7.org/fhir/_medium";
var followUp = "http://hl7.org/fhir/followUp";
var maxDuration = "http://hl7.org/fhir/maxDuration";
var lotNumber = "http://hl7.org/fhir/lotNumber";
var EncounterHistoryLocationComponent = "http://hl7.org/fhir/EncounterHistoryLocationComponent";
var _owner = "http://hl7.org/fhir/_owner";
var InventoryItem = "http://hl7.org/fhir/InventoryItem";
var content2 = "http://hl7.org/fhir/content";
var DeviceDefinitionPropertyComponent = "http://hl7.org/fhir/DeviceDefinitionPropertyComponent";
var enteredDate = "http://hl7.org/fhir/enteredDate";
var _district = "http://hl7.org/fhir/_district";
var QuestionnaireItemComponentItemItem = "http://hl7.org/fhir/QuestionnaireItemComponentItemItem";
var eye = "http://hl7.org/fhir/eye";
var facilityType = "http://hl7.org/fhir/facilityType";
var markdown = "http://hl7.org/fhir/markdown";
var _friendly = "http://hl7.org/fhir/_friendly";
var ManufacturedItemDefinitionComponentComponentComponent = "http://hl7.org/fhir/ManufacturedItemDefinitionComponentComponentComponent";
var basedOn = "http://hl7.org/fhir/basedOn";
var assessmentMethod = "http://hl7.org/fhir/assessmentMethod";
var _sourceMaterialClass = "http://hl7.org/fhir/_sourceMaterialClass";
var CarePlanActivityComponent = "http://hl7.org/fhir/CarePlanActivityComponent";
var response = "http://hl7.org/fhir/response";
var _singleUse = "http://hl7.org/fhir/_singleUse";
var ProvenanceAgentComponent = "http://hl7.org/fhir/ProvenanceAgentComponent";
var _kingdom = "http://hl7.org/fhir/_kingdom";
var error = "http://hl7.org/fhir/error";
var effect = "http://hl7.org/fhir/effect";
var verifiedWith = "http://hl7.org/fhir/verifiedWith";
var _packaging = "http://hl7.org/fhir/_packaging";
var position = "http://hl7.org/fhir/position";
var EvidenceCertaintyComponentCertainty = "http://hl7.org/fhir/EvidenceCertaintyComponentCertainty";
var low = "http://hl7.org/fhir/low";
var _Device = "http://hl7.org/fhir/_Device";
var AddedItemSubDetail = "http://hl7.org/fhir/AddedItemSubDetail";
var _responsible = "http://hl7.org/fhir/_responsible";
var excludingDate = "http://hl7.org/fhir/excludingDate";
var _verified = "http://hl7.org/fhir/_verified";
var TestScriptMetadataCapabilityComponent = "http://hl7.org/fhir/TestScriptMetadataCapabilityComponent";
var marketingStatus = "http://hl7.org/fhir/marketingStatus";
var _ClaimResponse = "http://hl7.org/fhir/_ClaimResponse";
var request = "http://hl7.org/fhir/request";
var MolecularSequenceRelativeEditComponent = "http://hl7.org/fhir/MolecularSequenceRelativeEditComponent";
var periodType = "http://hl7.org/fhir/periodType";
var approvalDate = "http://hl7.org/fhir/approvalDate";
var _monomerSet = "http://hl7.org/fhir/_monomerSet";
var _eventTrigger = "http://hl7.org/fhir/_eventTrigger";
var _ingredient = "http://hl7.org/fhir/_ingredient";
var _biologicalSourceEvent = "http://hl7.org/fhir/_biologicalSourceEvent";
var durationMax = "http://hl7.org/fhir/durationMax";
var _MolecularSequence = "http://hl7.org/fhir/_MolecularSequence";
var _permittedDataType = "http://hl7.org/fhir/_permittedDataType";
var subtitle = "http://hl7.org/fhir/subtitle";
var _SubscriptionStatus = "http://hl7.org/fhir/_SubscriptionStatus";
var maxTreatmentPeriod = "http://hl7.org/fhir/maxTreatmentPeriod";
var _relatedIdentifier = "http://hl7.org/fhir/_relatedIdentifier";
var _feature = "http://hl7.org/fhir/_feature";
var ValueSetExpansionComponent = "http://hl7.org/fhir/ValueSetExpansionComponent";
var _parameterFocus = "http://hl7.org/fhir/_parameterFocus";
var _maxDosePerDay = "http://hl7.org/fhir/_maxDosePerDay";
var CapabilityStatementMessagingComponent = "http://hl7.org/fhir/CapabilityStatementMessagingComponent";
var ResearchStudyObjectiveComponent = "http://hl7.org/fhir/ResearchStudyObjectiveComponent";
var MedicationIngredientComponent = "http://hl7.org/fhir/MedicationIngredientComponent";
var SourceElement = "http://hl7.org/fhir/SourceElement";
var _sequence = "http://hl7.org/fhir/_sequence";
var _validateProfileId = "http://hl7.org/fhir/_validateProfileId";
var responsibility = "http://hl7.org/fhir/responsibility";
var containedItem = "http://hl7.org/fhir/containedItem";
var completionTime = "http://hl7.org/fhir/completionTime";
var _identifier = "http://hl7.org/fhir/_identifier";
var _scope = "http://hl7.org/fhir/_scope";
var currency = "http://hl7.org/fhir/currency";
var _inputProfile = "http://hl7.org/fhir/_inputProfile";
var TestAction = "http://hl7.org/fhir/TestAction";
var _performer = "http://hl7.org/fhir/_performer";
var QuestionnaireResponseItemComponentItemItem = "http://hl7.org/fhir/QuestionnaireResponseItemComponentItemItem";
var _pushTypeAvailable = "http://hl7.org/fhir/_pushTypeAvailable";
var communication = "http://hl7.org/fhir/communication";
var interpretation = "http://hl7.org/fhir/interpretation";
var _capacity = "http://hl7.org/fhir/_capacity";
var topic = "http://hl7.org/fhir/topic";
var _undesirableEffect = "http://hl7.org/fhir/_undesirableEffect";
var _noteNumber = "http://hl7.org/fhir/_noteNumber";
var _DeviceRequest = "http://hl7.org/fhir/_DeviceRequest";
var courseOfTherapyType = "http://hl7.org/fhir/courseOfTherapyType";
var ordinalPosition = "http://hl7.org/fhir/ordinalPosition";
var ObservationComponentComponentReferenceRange = "http://hl7.org/fhir/ObservationComponentComponentReferenceRange";
var _actorId = "http://hl7.org/fhir/_actorId";
var conclusion = "http://hl7.org/fhir/conclusion";
var Resource = "http://hl7.org/fhir/Resource";
var accountNumber = "http://hl7.org/fhir/accountNumber";
var deliverTo = "http://hl7.org/fhir/deliverTo";
var multipleResultsAllowed = "http://hl7.org/fhir/multipleResultsAllowed";
var _asNeeded = "http://hl7.org/fhir/_asNeeded";
var _onHold = "http://hl7.org/fhir/_onHold";
var genomeAssembly = "http://hl7.org/fhir/genomeAssembly";
var _preAuthRefPeriod = "http://hl7.org/fhir/_preAuthRefPeriod";
var itemSequence = "http://hl7.org/fhir/itemSequence";
var _relatedClinicalInformation = "http://hl7.org/fhir/_relatedClinicalInformation";
var ResearchStudy = "http://hl7.org/fhir/ResearchStudy";
var _action = "http://hl7.org/fhir/_action";
var _DocumentReference = "http://hl7.org/fhir/_DocumentReference";
var _coverageArea = "http://hl7.org/fhir/_coverageArea";
var DataType = "http://hl7.org/fhir/DataType";
var Duration = "http://hl7.org/fhir/Duration";
var _Consent = "http://hl7.org/fhir/_Consent";
var _referencePolicy = "http://hl7.org/fhir/_referencePolicy";
var _virtualService = "http://hl7.org/fhir/_virtualService";
var _lastModified = "http://hl7.org/fhir/_lastModified";
var destination = "http://hl7.org/fhir/destination";
var _whenHandedOver = "http://hl7.org/fhir/_whenHandedOver";
var _typeTested = "http://hl7.org/fhir/_typeTested";
var product = "http://hl7.org/fhir/product";
var _referrer = "http://hl7.org/fhir/_referrer";
var plannedEndDate = "http://hl7.org/fhir/plannedEndDate";
var _birthDate = "http://hl7.org/fhir/_birthDate";
var _mustHaveValue = "http://hl7.org/fhir/_mustHaveValue";
var ClinicalUseDefinition = "http://hl7.org/fhir/ClinicalUseDefinition";
var dynamicValue = "http://hl7.org/fhir/dynamicValue";
var _detailSequence = "http://hl7.org/fhir/_detailSequence";
var SupportingInformation = "http://hl7.org/fhir/SupportingInformation";
var CitationStatusDateComponent = "http://hl7.org/fhir/CitationStatusDateComponent";
var subscriberId = "http://hl7.org/fhir/subscriberId";
var node = "http://hl7.org/fhir/node";
var details = "http://hl7.org/fhir/details";
var GenomicStudyAnalysisInputComponent = "http://hl7.org/fhir/GenomicStudyAnalysisInputComponent";
var contract = "http://hl7.org/fhir/contract";
var _paymentIssuer = "http://hl7.org/fhir/_paymentIssuer";
var _clinicalTrial = "http://hl7.org/fhir/_clinicalTrial";
var Adjudication = "http://hl7.org/fhir/Adjudication";
var AdverseEventMitigatingActionComponent = "http://hl7.org/fhir/AdverseEventMitigatingActionComponent";
var ratioType = "http://hl7.org/fhir/ratioType";
var authoritative = "http://hl7.org/fhir/authoritative";
var chromosome = "http://hl7.org/fhir/chromosome";
var referralMethod = "http://hl7.org/fhir/referralMethod";
var MedicationKnowledgeDefinitionalDrugCharacteristicComponent = "http://hl7.org/fhir/MedicationKnowledgeDefinitionalDrugCharacteristicComponent";
var _filterParameter = "http://hl7.org/fhir/_filterParameter";
var _costCenter = "http://hl7.org/fhir/_costCenter";
var _maternalOrganismName = "http://hl7.org/fhir/_maternalOrganismName";
var _CommunicationRequest = "http://hl7.org/fhir/_CommunicationRequest";
var _mapping = "http://hl7.org/fhir/_mapping";
var _spatialReference = "http://hl7.org/fhir/_spatialReference";
var _AppointmentResponse = "http://hl7.org/fhir/_AppointmentResponse";
var preparation = "http://hl7.org/fhir/preparation";
var _outcome = "http://hl7.org/fhir/_outcome";
var _policy = "http://hl7.org/fhir/_policy";
var planningHorizon = "http://hl7.org/fhir/planningHorizon";
var _targetSpecies = "http://hl7.org/fhir/_targetSpecies";
var EvidenceVariableCharacteristicComponent = "http://hl7.org/fhir/EvidenceVariableCharacteristicComponent";
var _authorization = "http://hl7.org/fhir/_authorization";
var software = "http://hl7.org/fhir/software";
var _lastReviewDate = "http://hl7.org/fhir/_lastReviewDate";
var _derivedFromCanonical = "http://hl7.org/fhir/_derivedFromCanonical";
var specialCourtesy = "http://hl7.org/fhir/specialCourtesy";
var intraspecificType = "http://hl7.org/fhir/intraspecificType";
var shortTitle = "http://hl7.org/fhir/shortTitle";
var channelType = "http://hl7.org/fhir/channelType";
var _subSite = "http://hl7.org/fhir/_subSite";
var use = "http://hl7.org/fhir/use";
var webLocation = "http://hl7.org/fhir/webLocation";
var PlanDefinitionGoalTargetComponent = "http://hl7.org/fhir/PlanDefinitionGoalTargetComponent";
var _entryQuantity = "http://hl7.org/fhir/_entryQuantity";
var _seriousness = "http://hl7.org/fhir/_seriousness";
var _born = "http://hl7.org/fhir/_born";
var initiator = "http://hl7.org/fhir/initiator";
var geometry = "http://hl7.org/fhir/geometry";
var _organismGeneral = "http://hl7.org/fhir/_organismGeneral";
var TestReportSetupComponent = "http://hl7.org/fhir/TestReportSetupComponent";
var message2 = "http://hl7.org/fhir/message";
var PlanDefinitionActionInputComponent = "http://hl7.org/fhir/PlanDefinitionActionInputComponent";
var Dosage = "http://hl7.org/fhir/Dosage";
var _structureType = "http://hl7.org/fhir/_structureType";
var onAdmission = "http://hl7.org/fhir/onAdmission";
var EncounterLocationComponent = "http://hl7.org/fhir/EncounterLocationComponent";
var statusHistory = "http://hl7.org/fhir/statusHistory";
var CitationCitedArtifactComponent = "http://hl7.org/fhir/CitationCitedArtifactComponent";
var _paymentTerms = "http://hl7.org/fhir/_paymentTerms";
var _intendedEffect = "http://hl7.org/fhir/_intendedEffect";
var SubstanceSourceMaterialOrganismAuthorComponent = "http://hl7.org/fhir/SubstanceSourceMaterialOrganismAuthorComponent";
var listMode = "http://hl7.org/fhir/listMode";
var _typeCollected = "http://hl7.org/fhir/_typeCollected";
var definitional = "http://hl7.org/fhir/definitional";
var improvementNotation = "http://hl7.org/fhir/improvementNotation";
var ValuedItem = "http://hl7.org/fhir/ValuedItem";
var ElementDefinitionBaseComponent = "http://hl7.org/fhir/ElementDefinitionBaseComponent";
var Errors = "http://hl7.org/fhir/Errors";
var pattern = "http://hl7.org/fhir/pattern";
var TestScriptDestinationComponent = "http://hl7.org/fhir/TestScriptDestinationComponent";
var CoveragePaymentByComponent = "http://hl7.org/fhir/CoveragePaymentByComponent";
var _AuditEvent = "http://hl7.org/fhir/_AuditEvent";
var requirements = "http://hl7.org/fhir/requirements";
var authority = "http://hl7.org/fhir/authority";
var _compareToSourceId = "http://hl7.org/fhir/_compareToSourceId";
var _Contract = "http://hl7.org/fhir/_Contract";
var _occurrenceChanged = "http://hl7.org/fhir/_occurrenceChanged";
var typeReference = "http://hl7.org/fhir/typeReference";
var detail = "http://hl7.org/fhir/detail";
var _alternative = "http://hl7.org/fhir/_alternative";
var ClaimResponseAdjudication = "http://hl7.org/fhir/ClaimResponseAdjudication";
var Person2 = "http://hl7.org/fhir/Person";
var readHistory = "http://hl7.org/fhir/readHistory";
var _subjects = "http://hl7.org/fhir/_subjects";
var membership = "http://hl7.org/fhir/membership";
var studyUid = "http://hl7.org/fhir/studyUid";
var GraphDefinitionLinkCompartmentComponent = "http://hl7.org/fhir/GraphDefinitionLinkCompartmentComponent";
var _occurrence = "http://hl7.org/fhir/_occurrence";
var _dayOfMonth = "http://hl7.org/fhir/_dayOfMonth";
var Extension = "http://hl7.org/fhir/Extension";
var _proxyIdentityCertificate = "http://hl7.org/fhir/_proxyIdentityCertificate";
var emptyReason = "http://hl7.org/fhir/emptyReason";
var ConceptMapGroupComponent = "http://hl7.org/fhir/ConceptMapGroupComponent";
var laterality = "http://hl7.org/fhir/laterality";
var _previous = "http://hl7.org/fhir/_previous";
var _claimResponse = "http://hl7.org/fhir/_claimResponse";
var dataUpdateType = "http://hl7.org/fhir/dataUpdateType";
var paymentDate = "http://hl7.org/fhir/paymentDate";
var baseFormulaProductName = "http://hl7.org/fhir/baseFormulaProductName";
var performed = "http://hl7.org/fhir/performed";
var ServiceRequestOrderDetailComponent = "http://hl7.org/fhir/ServiceRequestOrderDetailComponent";
var _informationSequence = "http://hl7.org/fhir/_informationSequence";
var _wednesday = "http://hl7.org/fhir/_wednesday";
var _id = "http://hl7.org/fhir/_id";
var nucleicAcid = "http://hl7.org/fhir/nucleicAcid";
var implementation = "http://hl7.org/fhir/implementation";
var _species = "http://hl7.org/fhir/_species";
var _goalId = "http://hl7.org/fhir/_goalId";
var manager = "http://hl7.org/fhir/manager";
var Meta = "http://hl7.org/fhir/Meta";
var interpreter = "http://hl7.org/fhir/interpreter";
var situation = "http://hl7.org/fhir/situation";
var _recorded = "http://hl7.org/fhir/_recorded";
var DiagnosticReport = "http://hl7.org/fhir/DiagnosticReport";
var drugCharacteristic = "http://hl7.org/fhir/drugCharacteristic";
var SubstanceDefinitionStructureRepresentationComponent = "http://hl7.org/fhir/SubstanceDefinitionStructureRepresentationComponent";
var RequestOrchestrationActionRelatedActionComponent = "http://hl7.org/fhir/RequestOrchestrationActionRelatedActionComponent";
var variableRole = "http://hl7.org/fhir/variableRole";
var failureAction = "http://hl7.org/fhir/failureAction";
var suppliedItem = "http://hl7.org/fhir/suppliedItem";
var abstract2 = "http://hl7.org/fhir/abstract";
var valueRange = "http://hl7.org/fhir/valueRange";
var _query = "http://hl7.org/fhir/_query";
var sigFormat = "http://hl7.org/fhir/sigFormat";
var VirtualServiceDetail = "http://hl7.org/fhir/VirtualServiceDetail";
var _rest = "http://hl7.org/fhir/_rest";
var packageCode = "http://hl7.org/fhir/packageCode";
var _reaction = "http://hl7.org/fhir/_reaction";
var _contributor = "http://hl7.org/fhir/_contributor";
var _normalValue = "http://hl7.org/fhir/_normalValue";
var _resultsInterpreter = "http://hl7.org/fhir/_resultsInterpreter";
var _tester = "http://hl7.org/fhir/_tester";
var denominator = "http://hl7.org/fhir/denominator";
var uniqueId = "http://hl7.org/fhir/uniqueId";
var readOnly = "http://hl7.org/fhir/readOnly";
var _effectiveDosePeriod = "http://hl7.org/fhir/_effectiveDosePeriod";
var _patientInstruction = "http://hl7.org/fhir/_patientInstruction";
var focusReference = "http://hl7.org/fhir/focusReference";
var _sopClass = "http://hl7.org/fhir/_sopClass";
var _brand = "http://hl7.org/fhir/_brand";
var SubscriptionStatusNotificationEventComponent = "http://hl7.org/fhir/SubscriptionStatusNotificationEventComponent";
var specialArrangement = "http://hl7.org/fhir/specialArrangement";
var _autocreate = "http://hl7.org/fhir/_autocreate";
var _responsibility = "http://hl7.org/fhir/_responsibility";
var any = "http://hl7.org/fhir/any";
var protocolApplied = "http://hl7.org/fhir/protocolApplied";
var PaymentNotice = "http://hl7.org/fhir/PaymentNotice";
var _completionTime = "http://hl7.org/fhir/_completionTime";
var _preAdmissionIdentifier = "http://hl7.org/fhir/_preAdmissionIdentifier";
var _interpretation = "http://hl7.org/fhir/_interpretation";
var testingDestination = "http://hl7.org/fhir/testingDestination";
var ExtendedContactDetail = "http://hl7.org/fhir/ExtendedContactDetail";
var administrableDoseForm = "http://hl7.org/fhir/administrableDoseForm";
var repeat2 = "http://hl7.org/fhir/repeat";
var CapabilityStatementRestResourceSearchParamComponent = "http://hl7.org/fhir/CapabilityStatementRestResourceSearchParamComponent";
var interactant = "http://hl7.org/fhir/interactant";
var _groupDefinition = "http://hl7.org/fhir/_groupDefinition";
var _effective = "http://hl7.org/fhir/_effective";
var _service = "http://hl7.org/fhir/_service";
var admitSource = "http://hl7.org/fhir/admitSource";
var _cap = "http://hl7.org/fhir/_cap";
var _structure = "http://hl7.org/fhir/_structure";
var _preferred = "http://hl7.org/fhir/_preferred";
var human = "http://hl7.org/fhir/human";
var _genomeAssembly = "http://hl7.org/fhir/_genomeAssembly";
var _dimensions = "http://hl7.org/fhir/_dimensions";
var Reason = "http://hl7.org/fhir/Reason";
var eligibility = "http://hl7.org/fhir/eligibility";
var resultForCreate = "http://hl7.org/fhir/resultForCreate";
var PersonLinkComponent = "http://hl7.org/fhir/PersonLinkComponent";
var EvidenceCertaintyComponent = "http://hl7.org/fhir/EvidenceCertaintyComponent";
var texture = "http://hl7.org/fhir/texture";
var characterization = "http://hl7.org/fhir/characterization";
var TerminologyCapabilitiesExpansionComponent = "http://hl7.org/fhir/TerminologyCapabilitiesExpansionComponent";
var DataRequirementCodeFilterComponent = "http://hl7.org/fhir/DataRequirementCodeFilterComponent";
var _derivedFrom = "http://hl7.org/fhir/_derivedFrom";
var _doseAdministrationAid = "http://hl7.org/fhir/_doseAdministrationAid";
var productOrService = "http://hl7.org/fhir/productOrService";
var _plannedEndDate = "http://hl7.org/fhir/_plannedEndDate";
var conformsTo2 = "http://hl7.org/fhir/conformsTo";
var _detected = "http://hl7.org/fhir/_detected";
var _threePrime = "http://hl7.org/fhir/_threePrime";
var referencedFrom = "http://hl7.org/fhir/referencedFrom";
var targetFormat = "http://hl7.org/fhir/targetFormat";
var _characteristicType = "http://hl7.org/fhir/_characteristicType";
var StructureDefinitionMappingComponent = "http://hl7.org/fhir/StructureDefinitionMappingComponent";
var _initiatorActive = "http://hl7.org/fhir/_initiatorActive";
var supportedInteraction = "http://hl7.org/fhir/supportedInteraction";
var vaccineCode = "http://hl7.org/fhir/vaccineCode";
var seriesNumber = "http://hl7.org/fhir/seriesNumber";
var pageCount = "http://hl7.org/fhir/pageCount";
var _who = "http://hl7.org/fhir/_who";
var PermissionRuleActivityComponent = "http://hl7.org/fhir/PermissionRuleActivityComponent";
var careManager = "http://hl7.org/fhir/careManager";
var CodeSystem = "http://hl7.org/fhir/CodeSystem";
var MedicinalProductDefinitionNamePartComponent = "http://hl7.org/fhir/MedicinalProductDefinitionNamePartComponent";
var _requestingOrganization = "http://hl7.org/fhir/_requestingOrganization";
var _referralMethod = "http://hl7.org/fhir/_referralMethod";
var _suspectEntity = "http://hl7.org/fhir/_suspectEntity";
var _exclusionCriteria = "http://hl7.org/fhir/_exclusionCriteria";
var ObservationComponentComponent = "http://hl7.org/fhir/ObservationComponentComponent";
var _testScript = "http://hl7.org/fhir/_testScript";
var manufactureDate = "http://hl7.org/fhir/manufactureDate";
var _textPresentation = "http://hl7.org/fhir/_textPresentation";
var TestReportSetupActionOperationComponent = "http://hl7.org/fhir/TestReportSetupActionOperationComponent";
var legal = "http://hl7.org/fhir/legal";
var provider2 = "http://hl7.org/fhir/provider";
var exitCriteria = "http://hl7.org/fhir/exitCriteria";
var image2 = "http://hl7.org/fhir/image";
var SupplyRequest = "http://hl7.org/fhir/SupplyRequest";
var _periodMax = "http://hl7.org/fhir/_periodMax";
var _monograph = "http://hl7.org/fhir/_monograph";
var _decision = "http://hl7.org/fhir/_decision";
var _diagnostics = "http://hl7.org/fhir/_diagnostics";
var _origin = "http://hl7.org/fhir/_origin";
var _durationUnit = "http://hl7.org/fhir/_durationUnit";
var contact2 = "http://hl7.org/fhir/contact";
var _disabledDisplay = "http://hl7.org/fhir/_disabledDisplay";
var _attestation = "http://hl7.org/fhir/_attestation";
var PackagedProductDefinitionPackagingComponentPackaging = "http://hl7.org/fhir/PackagedProductDefinitionPackagingComponentPackaging";
var OperationOutcomeIssueComponent = "http://hl7.org/fhir/OperationOutcomeIssueComponent";
var _hash = "http://hl7.org/fhir/_hash";
var _pageString = "http://hl7.org/fhir/_pageString";
var _constituent = "http://hl7.org/fhir/_constituent";
var DeviceAssociation = "http://hl7.org/fhir/DeviceAssociation";
var _dayOfWeek = "http://hl7.org/fhir/_dayOfWeek";
var _inventoryListing = "http://hl7.org/fhir/_inventoryListing";
var _hierarchyMeaning = "http://hl7.org/fhir/_hierarchyMeaning";
var _dispenseRequest = "http://hl7.org/fhir/_dispenseRequest";
var legallyBinding = "http://hl7.org/fhir/legallyBinding";
var _manufacturer = "http://hl7.org/fhir/_manufacturer";
var _answerConstraint = "http://hl7.org/fhir/_answerConstraint";
var _when = "http://hl7.org/fhir/_when";
var _form = "http://hl7.org/fhir/_form";
var businessStatus = "http://hl7.org/fhir/businessStatus";
var comparisonGroup = "http://hl7.org/fhir/comparisonGroup";
var _instance = "http://hl7.org/fhir/_instance";
var _itemStatus = "http://hl7.org/fhir/_itemStatus";
var _conditionalDelete = "http://hl7.org/fhir/_conditionalDelete";
var _grade = "http://hl7.org/fhir/_grade";
var _process = "http://hl7.org/fhir/_process";
var _articleDate = "http://hl7.org/fhir/_articleDate";
var additionalMonitoringIndicator = "http://hl7.org/fhir/additionalMonitoringIndicator";
var title3 = "http://hl7.org/fhir/title";
var _courseOfTherapyType = "http://hl7.org/fhir/_courseOfTherapyType";
var _identity = "http://hl7.org/fhir/_identity";
var CapabilityStatementRestComponent = "http://hl7.org/fhir/CapabilityStatementRestComponent";
var additionalAttribute = "http://hl7.org/fhir/additionalAttribute";
var monomerSet = "http://hl7.org/fhir/monomerSet";
var ingredient = "http://hl7.org/fhir/ingredient";
var _subPotentReason = "http://hl7.org/fhir/_subPotentReason";
var _supportedMessage = "http://hl7.org/fhir/_supportedMessage";
var DataRequirementDateFilterComponent = "http://hl7.org/fhir/DataRequirementDateFilterComponent";
var _performedActivity = "http://hl7.org/fhir/_performedActivity";
var _specialty = "http://hl7.org/fhir/_specialty";
var _weekInterval = "http://hl7.org/fhir/_weekInterval";
var publicationDate = "http://hl7.org/fhir/publicationDate";
var administrationInstruction = "http://hl7.org/fhir/administrationInstruction";
var fivePrime = "http://hl7.org/fhir/fivePrime";
var _points = "http://hl7.org/fhir/_points";
var TestScriptSetupActionAssertComponent = "http://hl7.org/fhir/TestScriptSetupActionAssertComponent";
var referralRequest = "http://hl7.org/fhir/referralRequest";
var _timeAspect = "http://hl7.org/fhir/_timeAspect";
var _presentedForm = "http://hl7.org/fhir/_presentedForm";
var _seriesDoses = "http://hl7.org/fhir/_seriesDoses";
var milestone = "http://hl7.org/fhir/milestone";
var MedicationAdministrationPerformerComponent = "http://hl7.org/fhir/MedicationAdministrationPerformerComponent";
var Invoice = "http://hl7.org/fhir/Invoice";
var additionalContext = "http://hl7.org/fhir/additionalContext";
var _satisfiedBy = "http://hl7.org/fhir/_satisfiedBy";
var identifier3 = "http://hl7.org/fhir/identifier";
var SubstanceNucleicAcid = "http://hl7.org/fhir/SubstanceNucleicAcid";
var resourceTrigger = "http://hl7.org/fhir/resourceTrigger";
var _overload = "http://hl7.org/fhir/_overload";
var organization = "http://hl7.org/fhir/organization";
var PlanDefinitionActionConditionComponent = "http://hl7.org/fhir/PlanDefinitionActionConditionComponent";
var RegulatedAuthorizationCaseComponentCaseCase = "http://hl7.org/fhir/RegulatedAuthorizationCaseComponentCaseCase";
var sliceIsConstraining = "http://hl7.org/fhir/sliceIsConstraining";
var _dataUpdateType = "http://hl7.org/fhir/_dataUpdateType";
var noteNumber = "http://hl7.org/fhir/noteNumber";
var installDate = "http://hl7.org/fhir/installDate";
var cardBrand = "http://hl7.org/fhir/cardBrand";
var _fullUrl = "http://hl7.org/fhir/_fullUrl";
var codeMap = "http://hl7.org/fhir/codeMap";
var ConditionDefinitionObservationComponent = "http://hl7.org/fhir/ConditionDefinitionObservationComponent";
var FamilyMemberHistory = "http://hl7.org/fhir/FamilyMemberHistory";
var operationTypeReason = "http://hl7.org/fhir/operationTypeReason";
var SpecimenDefinitionTypeTestedContainerAdditiveComponent = "http://hl7.org/fhir/SpecimenDefinitionTypeTestedContainerAdditiveComponent";
var _element = "http://hl7.org/fhir/_element";
var _attachedDocument = "http://hl7.org/fhir/_attachedDocument";
var _implementation = "http://hl7.org/fhir/_implementation";
var sourceMaterialType = "http://hl7.org/fhir/sourceMaterialType";
var _substance = "http://hl7.org/fhir/_substance";
var _qualification = "http://hl7.org/fhir/_qualification";
var _countType = "http://hl7.org/fhir/_countType";
var sourceMaterialState = "http://hl7.org/fhir/sourceMaterialState";
var _observationResultRequirement = "http://hl7.org/fhir/_observationResultRequirement";
var attestationSignature = "http://hl7.org/fhir/attestationSignature";
var PackagedProductDefinitionPackagingComponentPackagingPackaging = "http://hl7.org/fhir/PackagedProductDefinitionPackagingComponentPackagingPackaging";
var _marketingAuthorizationHolder = "http://hl7.org/fhir/_marketingAuthorizationHolder";
var _decisionMode = "http://hl7.org/fhir/_decisionMode";
var repeats = "http://hl7.org/fhir/repeats";
var typeTested = "http://hl7.org/fhir/typeTested";
var _rankingOrder = "http://hl7.org/fhir/_rankingOrder";
var end = "http://hl7.org/fhir/end";
var GenomicStudyAnalysisComponent = "http://hl7.org/fhir/GenomicStudyAnalysisComponent";
var excluded = "http://hl7.org/fhir/excluded";
var BundleEntryRequestComponent = "http://hl7.org/fhir/BundleEntryRequestComponent";
var DeviceDefinitionDeviceNameComponent = "http://hl7.org/fhir/DeviceDefinitionDeviceNameComponent";
var _eventNumber = "http://hl7.org/fhir/_eventNumber";
var FormularyItem = "http://hl7.org/fhir/FormularyItem";
var _marketDistribution = "http://hl7.org/fhir/_marketDistribution";
var _searchParam = "http://hl7.org/fhir/_searchParam";
var countryOfOrigin = "http://hl7.org/fhir/countryOfOrigin";
var AuditEventAgentComponent = "http://hl7.org/fhir/AuditEventAgentComponent";
var _regulatoryAuthority = "http://hl7.org/fhir/_regulatoryAuthority";
var _subjectState = "http://hl7.org/fhir/_subjectState";
var actualComparisonGroup = "http://hl7.org/fhir/actualComparisonGroup";
var _focusReference = "http://hl7.org/fhir/_focusReference";
var _statusReason = "http://hl7.org/fhir/_statusReason";
var ingredientLabel = "http://hl7.org/fhir/ingredientLabel";
var _whenPrepared = "http://hl7.org/fhir/_whenPrepared";
var costCenter = "http://hl7.org/fhir/costCenter";
var outputParameters = "http://hl7.org/fhir/outputParameters";
var DevicePropertyComponent = "http://hl7.org/fhir/DevicePropertyComponent";
var productCategory = "http://hl7.org/fhir/productCategory";
var serviceType = "http://hl7.org/fhir/serviceType";
var _verification = "http://hl7.org/fhir/_verification";
var reliableCache = "http://hl7.org/fhir/reliableCache";
var _Flag = "http://hl7.org/fhir/_Flag";
var numberAffected = "http://hl7.org/fhir/numberAffected";
var StructureMapGroupRuleDependentComponent = "http://hl7.org/fhir/StructureMapGroupRuleDependentComponent";
var relationshipType = "http://hl7.org/fhir/relationshipType";
var _statement = "http://hl7.org/fhir/_statement";
var _Goal = "http://hl7.org/fhir/_Goal";
var issued2 = "http://hl7.org/fhir/issued";
var _instruction = "http://hl7.org/fhir/_instruction";
var inclusionCriteria = "http://hl7.org/fhir/inclusionCriteria";
var about = "http://hl7.org/fhir/about";
var Practitioner = "http://hl7.org/fhir/Practitioner";
var prognosisCodeableConcept = "http://hl7.org/fhir/prognosisCodeableConcept";
var AdverseEventParticipantComponent = "http://hl7.org/fhir/AdverseEventParticipantComponent";
var _maxValue = "http://hl7.org/fhir/_maxValue";
var ItemDetail = "http://hl7.org/fhir/ItemDetail";
var _hasBodySite = "http://hl7.org/fhir/_hasBodySite";
var _metadata = "http://hl7.org/fhir/_metadata";
var rejectionCriterion = "http://hl7.org/fhir/rejectionCriterion";
var cors = "http://hl7.org/fhir/cors";
var _option = "http://hl7.org/fhir/_option";
var TypeRefComponent = "http://hl7.org/fhir/TypeRefComponent";
var minValue = "http://hl7.org/fhir/minValue";
var _tuesday = "http://hl7.org/fhir/_tuesday";
var _offset = "http://hl7.org/fhir/_offset";
var report = "http://hl7.org/fhir/report";
var _fhirPathCriteria = "http://hl7.org/fhir/_fhirPathCriteria";
var editor = "http://hl7.org/fhir/editor";
var _firstDose = "http://hl7.org/fhir/_firstDose";
var procedureSequence = "http://hl7.org/fhir/procedureSequence";
var MedicinalProductDefinitionContactComponent = "http://hl7.org/fhir/MedicinalProductDefinitionContactComponent";
var _Communication = "http://hl7.org/fhir/_Communication";
var _controller = "http://hl7.org/fhir/_controller";
var TestScriptSetupActionAssertRequirementComponent = "http://hl7.org/fhir/TestScriptSetupActionAssertRequirementComponent";
var _allocation = "http://hl7.org/fhir/_allocation";
var otherTherapy = "http://hl7.org/fhir/otherTherapy";
var _requestedLocation = "http://hl7.org/fhir/_requestedLocation";
var _referencedFrom = "http://hl7.org/fhir/_referencedFrom";
var eventsSinceSubscriptionStart = "http://hl7.org/fhir/eventsSinceSubscriptionStart";
var _question = "http://hl7.org/fhir/_question";
var _drugCharacteristic = "http://hl7.org/fhir/_drugCharacteristic";
var _total = "http://hl7.org/fhir/_total";
var AuditEvent = "http://hl7.org/fhir/AuditEvent";
var _environmentType = "http://hl7.org/fhir/_environmentType";
var AssetContext = "http://hl7.org/fhir/AssetContext";
var _rangeCategory = "http://hl7.org/fhir/_rangeCategory";
var Location2 = "http://hl7.org/fhir/Location";
var rank = "http://hl7.org/fhir/rank";
var PlanDefinitionActionComponentActionAction = "http://hl7.org/fhir/PlanDefinitionActionComponentActionAction";
var _occurrenceCount = "http://hl7.org/fhir/_occurrenceCount";
var entryType = "http://hl7.org/fhir/entryType";
var _trigger = "http://hl7.org/fhir/_trigger";
var _contextInvariant = "http://hl7.org/fhir/_contextInvariant";
var id2 = "http://hl7.org/fhir/id";
var _productionIdentifierInUDI = "http://hl7.org/fhir/_productionIdentifierInUDI";
var _variable = "http://hl7.org/fhir/_variable";
var occurrence = "http://hl7.org/fhir/occurrence";
var dayOfMonth = "http://hl7.org/fhir/dayOfMonth";
var _maxDosePerPeriod = "http://hl7.org/fhir/_maxDosePerPeriod";
var _MeasureReport = "http://hl7.org/fhir/_MeasureReport";
var MedicationKnowledgeCostComponent = "http://hl7.org/fhir/MedicationKnowledgeCostComponent";
var uuid = "http://hl7.org/fhir/uuid";
var _range = "http://hl7.org/fhir/_range";
var related = "http://hl7.org/fhir/related";
var endpoint = "http://hl7.org/fhir/endpoint";
var ValueSetExpansionParameterComponent = "http://hl7.org/fhir/ValueSetExpansionParameterComponent";
var _logMessage = "http://hl7.org/fhir/_logMessage";
var SubscriptionTopicResourceTriggerQueryCriteriaComponent = "http://hl7.org/fhir/SubscriptionTopicResourceTriggerQueryCriteriaComponent";
var _supportingImmunization = "http://hl7.org/fhir/_supportingImmunization";
var StructureMapConstComponent = "http://hl7.org/fhir/StructureMapConstComponent";
var NutritionIntakeConsumedItemComponent = "http://hl7.org/fhir/NutritionIntakeConsumedItemComponent";
var PlanDefinitionGoalComponent = "http://hl7.org/fhir/PlanDefinitionGoalComponent";
var precondition = "http://hl7.org/fhir/precondition";
var _CoverageEligibilityResponse = "http://hl7.org/fhir/_CoverageEligibilityResponse";
var _duration = "http://hl7.org/fhir/_duration";
var _routeOfAdministration = "http://hl7.org/fhir/_routeOfAdministration";
var _legallyBinding = "http://hl7.org/fhir/_legallyBinding";
var rendering = "http://hl7.org/fhir/rendering";
var _hierarchical = "http://hl7.org/fhir/_hierarchical";
var _nameType = "http://hl7.org/fhir/_nameType";
var _businessStatus = "http://hl7.org/fhir/_businessStatus";
var _maxLength = "http://hl7.org/fhir/_maxLength";
var SubstancePolymerRepeatComponent = "http://hl7.org/fhir/SubstancePolymerRepeatComponent";
var responsibleParty = "http://hl7.org/fhir/responsibleParty";
var BundleEntryComponent = "http://hl7.org/fhir/BundleEntryComponent";
var _input = "http://hl7.org/fhir/_input";
var _languageCode = "http://hl7.org/fhir/_languageCode";
var _patient = "http://hl7.org/fhir/_patient";
var direction = "http://hl7.org/fhir/direction";
var _publicationDateSeason = "http://hl7.org/fhir/_publicationDateSeason";
var maritalStatus = "http://hl7.org/fhir/maritalStatus";
var AllergyIntoleranceReactionComponent = "http://hl7.org/fhir/AllergyIntoleranceReactionComponent";
var _observer = "http://hl7.org/fhir/_observer";
var SubscriptionParameterComponent = "http://hl7.org/fhir/SubscriptionParameterComponent";
var doseAdministrationAid = "http://hl7.org/fhir/doseAdministrationAid";
var DeviceDefinitionClassificationComponent = "http://hl7.org/fhir/DeviceDefinitionClassificationComponent";
var _measure = "http://hl7.org/fhir/_measure";
var _maxDosePerAdministration = "http://hl7.org/fhir/_maxDosePerAdministration";
var CompositionAttesterComponent = "http://hl7.org/fhir/CompositionAttesterComponent";
var _valueFilter = "http://hl7.org/fhir/_valueFilter";
var studyDesign = "http://hl7.org/fhir/studyDesign";
var _relation = "http://hl7.org/fhir/_relation";
var _priority = "http://hl7.org/fhir/_priority";
var MessageDefinition = "http://hl7.org/fhir/MessageDefinition";
var _description = "http://hl7.org/fhir/_description";
var TestPlanTestCaseTestDataComponent = "http://hl7.org/fhir/TestPlanTestCaseTestDataComponent";
var HealthcareServiceEligibilityComponent = "http://hl7.org/fhir/HealthcareServiceEligibilityComponent";
var category = "http://hl7.org/fhir/category";
var Details = "http://hl7.org/fhir/Details";
var verificationDate = "http://hl7.org/fhir/verificationDate";
var ExampleScenarioActorComponent = "http://hl7.org/fhir/ExampleScenarioActorComponent";
var _specimenQuantity = "http://hl7.org/fhir/_specimenQuantity";
var DeviceDefinitionPackagingComponent = "http://hl7.org/fhir/DeviceDefinitionPackagingComponent";
var autocreate = "http://hl7.org/fhir/autocreate";
var _structuralRepresentation = "http://hl7.org/fhir/_structuralRepresentation";
var agent2 = "http://hl7.org/fhir/agent";
var _request = "http://hl7.org/fhir/_request";
var _deliverTo = "http://hl7.org/fhir/_deliverTo";
var _textConcentration = "http://hl7.org/fhir/_textConcentration";
var benefitPeriod = "http://hl7.org/fhir/benefitPeriod";
var SpecimenDefinitionTypeTestedContainerComponent = "http://hl7.org/fhir/SpecimenDefinitionTypeTestedContainerComponent";
var ServiceRequestPatientInstructionComponent = "http://hl7.org/fhir/ServiceRequestPatientInstructionComponent";
var _adjustment = "http://hl7.org/fhir/_adjustment";
var _guidance = "http://hl7.org/fhir/_guidance";
var productReference = "http://hl7.org/fhir/productReference";
var _for = "http://hl7.org/fhir/_for";
var _intended = "http://hl7.org/fhir/_intended";
var _additionalUse = "http://hl7.org/fhir/_additionalUse";
var MetadataResource = "http://hl7.org/fhir/MetadataResource";
var _startingSequence = "http://hl7.org/fhir/_startingSequence";
var MedicationStatement = "http://hl7.org/fhir/MedicationStatement";
var medium2 = "http://hl7.org/fhir/medium";
var _baseUnit = "http://hl7.org/fhir/_baseUnit";
var _doseStatusReason = "http://hl7.org/fhir/_doseStatusReason";
var unitOfPresentation = "http://hl7.org/fhir/unitOfPresentation";
var CareTeam = "http://hl7.org/fhir/CareTeam";
var sourceSignature = "http://hl7.org/fhir/sourceSignature";
var availableStartTime = "http://hl7.org/fhir/availableStartTime";
var _effectiveDate = "http://hl7.org/fhir/_effectiveDate";
var _relevantHistory = "http://hl7.org/fhir/_relevantHistory";
var ParametersParameterComponent = "http://hl7.org/fhir/ParametersParameterComponent";
var MessageDefinitionFocusComponent = "http://hl7.org/fhir/MessageDefinitionFocusComponent";
var EnrollmentResponse = "http://hl7.org/fhir/EnrollmentResponse";
var ListEntryComponent = "http://hl7.org/fhir/ListEntryComponent";
var _subset = "http://hl7.org/fhir/_subset";
var dimensions = "http://hl7.org/fhir/dimensions";
var _function = "http://hl7.org/fhir/_function";
var recommendation = "http://hl7.org/fhir/recommendation";
var _prescription = "http://hl7.org/fhir/_prescription";
var prognosisReference = "http://hl7.org/fhir/prognosisReference";
var _hint = "http://hl7.org/fhir/_hint";
var _ownedBy = "http://hl7.org/fhir/_ownedBy";
var measurementFrequency = "http://hl7.org/fhir/measurementFrequency";
var _traceNumber = "http://hl7.org/fhir/_traceNumber";
var _excludingDate = "http://hl7.org/fhir/_excludingDate";
var _required = "http://hl7.org/fhir/_required";
var correctiveAction = "http://hl7.org/fhir/correctiveAction";
var schedule = "http://hl7.org/fhir/schedule";
var _referral = "http://hl7.org/fhir/_referral";
var alternate = "http://hl7.org/fhir/alternate";
var intendedExposure = "http://hl7.org/fhir/intendedExposure";
var threePrime = "http://hl7.org/fhir/threePrime";
var param = "http://hl7.org/fhir/param";
var _proposedNewTime = "http://hl7.org/fhir/_proposedNewTime";
var power = "http://hl7.org/fhir/power";
var cardinalityBehavior = "http://hl7.org/fhir/cardinalityBehavior";
var supportingPatientInformation = "http://hl7.org/fhir/supportingPatientInformation";
var _predecessor = "http://hl7.org/fhir/_predecessor";
var allergenicIndicator = "http://hl7.org/fhir/allergenicIndicator";
var _regulator = "http://hl7.org/fhir/_regulator";
var issue = "http://hl7.org/fhir/issue";
var _admission = "http://hl7.org/fhir/_admission";
var _extension = "http://hl7.org/fhir/_extension";
var _notificationShape = "http://hl7.org/fhir/_notificationShape";
var Device = "http://hl7.org/fhir/Device";
var Range = "http://hl7.org/fhir/Range";
var ItemBodySite = "http://hl7.org/fhir/ItemBodySite";
var average = "http://hl7.org/fhir/average";
var SubstanceNucleicAcidSubunitSugarComponent = "http://hl7.org/fhir/SubstanceNucleicAcidSubunitSugarComponent";
var Composition = "http://hl7.org/fhir/Composition";
var _otherMap = "http://hl7.org/fhir/_otherMap";
var Rule = "http://hl7.org/fhir/Rule";
var testScript = "http://hl7.org/fhir/testScript";
var targetId = "http://hl7.org/fhir/targetId";
var _additionalAttribute = "http://hl7.org/fhir/_additionalAttribute";
var _validity = "http://hl7.org/fhir/_validity";
var _product = "http://hl7.org/fhir/_product";
var objective = "http://hl7.org/fhir/objective";
var _containedItem = "http://hl7.org/fhir/_containedItem";
var MedicationKnowledgePackagingComponentCost = "http://hl7.org/fhir/MedicationKnowledgePackagingComponentCost";
var relatedDevice = "http://hl7.org/fhir/relatedDevice";
var QuestionnaireItemEnableWhenComponent = "http://hl7.org/fhir/QuestionnaireItemEnableWhenComponent";
var _numberAffected = "http://hl7.org/fhir/_numberAffected";
var _batch = "http://hl7.org/fhir/_batch";
var preparationInstruction = "http://hl7.org/fhir/preparationInstruction";
var EpisodeOfCare = "http://hl7.org/fhir/EpisodeOfCare";
var _entity = "http://hl7.org/fhir/_entity";
var _initiator = "http://hl7.org/fhir/_initiator";
var _communication = "http://hl7.org/fhir/_communication";
var programEligibility = "http://hl7.org/fhir/programEligibility";
var addItem = "http://hl7.org/fhir/addItem";
var _details = "http://hl7.org/fhir/_details";
var pageString = "http://hl7.org/fhir/pageString";
var expansion = "http://hl7.org/fhir/expansion";
var MedicationKnowledgeRegulatoryComponent = "http://hl7.org/fhir/MedicationKnowledgeRegulatoryComponent";
var _affiliation = "http://hl7.org/fhir/_affiliation";
var _contentDefinition = "http://hl7.org/fhir/_contentDefinition";
var marketPeriod = "http://hl7.org/fhir/marketPeriod";
var _reportingPeriod = "http://hl7.org/fhir/_reportingPeriod";
var _accountNumber = "http://hl7.org/fhir/_accountNumber";
var _geneSequenceOrigin = "http://hl7.org/fhir/_geneSequenceOrigin";
var subpotentReason = "http://hl7.org/fhir/subpotentReason";
var inventoryStatus = "http://hl7.org/fhir/inventoryStatus";
var subunit = "http://hl7.org/fhir/subunit";
var orderer = "http://hl7.org/fhir/orderer";
var ExampleScenarioInstanceVersionComponent = "http://hl7.org/fhir/ExampleScenarioInstanceVersionComponent";
var itemStatus = "http://hl7.org/fhir/itemStatus";
var _ResearchStudy = "http://hl7.org/fhir/_ResearchStudy";
var resourceType = "http://hl7.org/fhir/resourceType";
var Quantity = "http://hl7.org/fhir/Quantity";
var contained = "http://hl7.org/fhir/contained";
var _appointmentType = "http://hl7.org/fhir/_appointmentType";
var SpecimenDefinitionTypeTestedComponent = "http://hl7.org/fhir/SpecimenDefinitionTypeTestedComponent";
var _actual = "http://hl7.org/fhir/_actual";
var CostToBeneficiary = "http://hl7.org/fhir/CostToBeneficiary";
var _Schedule = "http://hl7.org/fhir/_Schedule";
var programCode = "http://hl7.org/fhir/programCode";
var _PractitionerRole = "http://hl7.org/fhir/_PractitionerRole";
var guarantor = "http://hl7.org/fhir/guarantor";
var _FamilyMemberHistory = "http://hl7.org/fhir/_FamilyMemberHistory";
var _operationTypeReason = "http://hl7.org/fhir/_operationTypeReason";
var _programStatus = "http://hl7.org/fhir/_programStatus";
var _performerLinkId = "http://hl7.org/fhir/_performerLinkId";
var onHold = "http://hl7.org/fhir/onHold";
var _copackagedIndicator = "http://hl7.org/fhir/_copackagedIndicator";
var storageGuideline = "http://hl7.org/fhir/storageGuideline";
var _receiver = "http://hl7.org/fhir/_receiver";
var _whyStopped = "http://hl7.org/fhir/_whyStopped";
var _packageFor = "http://hl7.org/fhir/_packageFor";
var action2 = "http://hl7.org/fhir/action";
var _sourceMaterialState = "http://hl7.org/fhir/_sourceMaterialState";
var indicationGuideline = "http://hl7.org/fhir/indicationGuideline";
var _interaction = "http://hl7.org/fhir/_interaction";
var aggregateMethod = "http://hl7.org/fhir/aggregateMethod";
var _authorizingPrescription = "http://hl7.org/fhir/_authorizingPrescription";
var _authoritative = "http://hl7.org/fhir/_authoritative";
var timeAspect = "http://hl7.org/fhir/timeAspect";
var _valueSet = "http://hl7.org/fhir/_valueSet";
var OperationOutcome = "http://hl7.org/fhir/OperationOutcome";
var Contributor = "http://hl7.org/fhir/Contributor";
var _message = "http://hl7.org/fhir/_message";
var import__workaround = "http://hl7.org/fhir/import";
var definitionByTypeAndValue = "http://hl7.org/fhir/definitionByTypeAndValue";
var TestScriptSetupActionOperationComponent = "http://hl7.org/fhir/TestScriptSetupActionOperationComponent";
var mitigatingAction = "http://hl7.org/fhir/mitigatingAction";
var validationDate = "http://hl7.org/fhir/validationDate";
var healthcareService = "http://hl7.org/fhir/healthcareService";
var conditionalPatch = "http://hl7.org/fhir/conditionalPatch";
var minimumVolume = "http://hl7.org/fhir/minimumVolume";
var _practiceSetting = "http://hl7.org/fhir/_practiceSetting";
var protocol = "http://hl7.org/fhir/protocol";
var _structureProfile = "http://hl7.org/fhir/_structureProfile";
var _Coverage = "http://hl7.org/fhir/_Coverage";
var _issuerType = "http://hl7.org/fhir/_issuerType";
var MedicationRequest = "http://hl7.org/fhir/MedicationRequest";
var _pattern = "http://hl7.org/fhir/_pattern";
var processingFacility = "http://hl7.org/fhir/processingFacility";
var _situation = "http://hl7.org/fhir/_situation";
var _patchFormat = "http://hl7.org/fhir/_patchFormat";
var alternateMaterial = "http://hl7.org/fhir/alternateMaterial";
var responsible = "http://hl7.org/fhir/responsible";
var PlanDefinitionActionRelatedActionComponent = "http://hl7.org/fhir/PlanDefinitionActionRelatedActionComponent";
var _security = "http://hl7.org/fhir/_security";
var combined = "http://hl7.org/fhir/combined";
var contains = "http://hl7.org/fhir/contains";
var _addresses = "http://hl7.org/fhir/_addresses";
var expirationDate = "http://hl7.org/fhir/expirationDate";
var compartment = "http://hl7.org/fhir/compartment";
var _scoring = "http://hl7.org/fhir/_scoring";
var policy = "http://hl7.org/fhir/policy";
var recordedDate = "http://hl7.org/fhir/recordedDate";
var _sourceScope = "http://hl7.org/fhir/_sourceScope";
var _chain = "http://hl7.org/fhir/_chain";
var ImplementationGuideManifestComponent = "http://hl7.org/fhir/ImplementationGuideManifestComponent";
var _contributedToDeath = "http://hl7.org/fhir/_contributedToDeath";
var _diagnosisRelatedGroup = "http://hl7.org/fhir/_diagnosisRelatedGroup";
var _referenceNumber = "http://hl7.org/fhir/_referenceNumber";
var _template = "http://hl7.org/fhir/_template";
var _preConditions = "http://hl7.org/fhir/_preConditions";
var _score = "http://hl7.org/fhir/_score";
var SubstancePolymerMonomerSetComponent = "http://hl7.org/fhir/SubstancePolymerMonomerSetComponent";
var _requiredBehavior = "http://hl7.org/fhir/_requiredBehavior";
var _statusHistory = "http://hl7.org/fhir/_statusHistory";
var replacementSequence = "http://hl7.org/fhir/replacementSequence";
var _file = "http://hl7.org/fhir/_file";
var _height = "http://hl7.org/fhir/_height";
var _groupSize = "http://hl7.org/fhir/_groupSize";
var observedGroup = "http://hl7.org/fhir/observedGroup";
var receivedTime = "http://hl7.org/fhir/receivedTime";
var _doseAndRate = "http://hl7.org/fhir/_doseAndRate";
var definitionCanonical = "http://hl7.org/fhir/definitionCanonical";
var QuestionnaireResponseItemComponent = "http://hl7.org/fhir/QuestionnaireResponseItemComponent";
var _typeReference = "http://hl7.org/fhir/_typeReference";
var PractitionerQualificationComponent = "http://hl7.org/fhir/PractitionerQualificationComponent";
var cTerminalModificationId = "http://hl7.org/fhir/cTerminalModificationId";
var _requireBoth = "http://hl7.org/fhir/_requireBoth";
var dataAbsentReason = "http://hl7.org/fhir/dataAbsentReason";
var _criticality = "http://hl7.org/fhir/_criticality";
var _subjectStatus = "http://hl7.org/fhir/_subjectStatus";
var _expiry = "http://hl7.org/fhir/_expiry";
var usage = "http://hl7.org/fhir/usage";
var city = "http://hl7.org/fhir/city";
var _instances = "http://hl7.org/fhir/_instances";
var stratum = "http://hl7.org/fhir/stratum";
var MeasureReportGroupStratifierComponent = "http://hl7.org/fhir/MeasureReportGroupStratifierComponent";
var _ratioHighLimitAmount = "http://hl7.org/fhir/_ratioHighLimitAmount";
var route = "http://hl7.org/fhir/route";
var TestScriptMetadataLinkComponent = "http://hl7.org/fhir/TestScriptMetadataLinkComponent";
var DeviceDispensePerformerComponent = "http://hl7.org/fhir/DeviceDispensePerformerComponent";
var frequencyMax = "http://hl7.org/fhir/frequencyMax";
var _number = "http://hl7.org/fhir/_number";
var QuestionnaireResponse = "http://hl7.org/fhir/QuestionnaireResponse";
var MappingProperty = "http://hl7.org/fhir/MappingProperty";
var _securityContext = "http://hl7.org/fhir/_securityContext";
var display = "http://hl7.org/fhir/display";
var yearlyTemplate = "http://hl7.org/fhir/yearlyTemplate";
var ChargeItemPerformerComponent = "http://hl7.org/fhir/ChargeItemPerformerComponent";
var Contact = "http://hl7.org/fhir/Contact";
var EndpointPayloadComponent = "http://hl7.org/fhir/EndpointPayloadComponent";
var _relatedArtifact = "http://hl7.org/fhir/_relatedArtifact";
var updateCreate = "http://hl7.org/fhir/updateCreate";
var _subtype = "http://hl7.org/fhir/_subtype";
var _stereochemistry = "http://hl7.org/fhir/_stereochemistry";
var _upperLimit = "http://hl7.org/fhir/_upperLimit";
var routeOfAdministration = "http://hl7.org/fhir/routeOfAdministration";
var _amountType = "http://hl7.org/fhir/_amountType";
var _organismType = "http://hl7.org/fhir/_organismType";
var bodySite = "http://hl7.org/fhir/bodySite";
var _moiety = "http://hl7.org/fhir/_moiety";
var _recommendation = "http://hl7.org/fhir/_recommendation";
var grouping = "http://hl7.org/fhir/grouping";
var _pause = "http://hl7.org/fhir/_pause";
var _primaryPurposeType = "http://hl7.org/fhir/_primaryPurposeType";
var ConceptSubProperty = "http://hl7.org/fhir/ConceptSubProperty";
var subscription = "http://hl7.org/fhir/subscription";
var _lastPage = "http://hl7.org/fhir/_lastPage";
var partLocation = "http://hl7.org/fhir/partLocation";
var controller = "http://hl7.org/fhir/controller";
var publicationDateSeason = "http://hl7.org/fhir/publicationDateSeason";
var imports = "http://hl7.org/fhir/imports";
var allocation = "http://hl7.org/fhir/allocation";
var _pageCount = "http://hl7.org/fhir/_pageCount";
var _failureAction = "http://hl7.org/fhir/_failureAction";
var profile = "http://hl7.org/fhir/profile";
var cylinder = "http://hl7.org/fhir/cylinder";
var deleted2 = "http://hl7.org/fhir/deleted";
var episodeOfCare = "http://hl7.org/fhir/episodeOfCare";
var saturday = "http://hl7.org/fhir/saturday";
var _expectedInResearchStudy = "http://hl7.org/fhir/_expectedInResearchStudy";
var CommunicationRequestPayloadComponent = "http://hl7.org/fhir/CommunicationRequestPayloadComponent";
var _calculatedAt = "http://hl7.org/fhir/_calculatedAt";
var _impurity = "http://hl7.org/fhir/_impurity";
var type3 = "http://hl7.org/fhir/type";
var goalId = "http://hl7.org/fhir/goalId";
var ObservationDefinitionComponentComponent = "http://hl7.org/fhir/ObservationDefinitionComponentComponent";
var TestScriptSetupComponent = "http://hl7.org/fhir/TestScriptSetupComponent";
var Appointment = "http://hl7.org/fhir/Appointment";
var _groupIdentifier = "http://hl7.org/fhir/_groupIdentifier";
var _countMax = "http://hl7.org/fhir/_countMax";
var patientCharacteristic = "http://hl7.org/fhir/patientCharacteristic";
var lowNumerator = "http://hl7.org/fhir/lowNumerator";
var _texture = "http://hl7.org/fhir/_texture";
var _causality = "http://hl7.org/fhir/_causality";
var operator = "http://hl7.org/fhir/operator";
var fixed = "http://hl7.org/fhir/fixed";
var nTerminalModificationId = "http://hl7.org/fhir/nTerminalModificationId";
var InventoryItemNameComponent = "http://hl7.org/fhir/InventoryItemNameComponent";
var _minimumId = "http://hl7.org/fhir/_minimumId";
var verificationStatus = "http://hl7.org/fhir/verificationStatus";
var _PaymentNotice = "http://hl7.org/fhir/_PaymentNotice";
var _dateAccessed = "http://hl7.org/fhir/_dateAccessed";
var logMessage = "http://hl7.org/fhir/logMessage";
var ResearchStudyProgressStatusComponent = "http://hl7.org/fhir/ResearchStudyProgressStatusComponent";
var _residueSite = "http://hl7.org/fhir/_residueSite";
var MonetaryComponent = "http://hl7.org/fhir/MonetaryComponent";
var TeardownAction = "http://hl7.org/fhir/TeardownAction";
var clinicalUseIssue = "http://hl7.org/fhir/clinicalUseIssue";
var classification = "http://hl7.org/fhir/classification";
var _lifecycleStatus = "http://hl7.org/fhir/_lifecycleStatus";
var signature = "http://hl7.org/fhir/signature";
var reviewer = "http://hl7.org/fhir/reviewer";
var _usePeriod = "http://hl7.org/fhir/_usePeriod";
var BodyStructureIncludedStructureComponent = "http://hl7.org/fhir/BodyStructureIncludedStructureComponent";
var next = "http://hl7.org/fhir/next";
var _changeType = "http://hl7.org/fhir/_changeType";
var _ImmunizationEvaluation = "http://hl7.org/fhir/_ImmunizationEvaluation";
var requestingOrganization = "http://hl7.org/fhir/requestingOrganization";
var _unitOfPresentation = "http://hl7.org/fhir/_unitOfPresentation";
var requestedPeriod = "http://hl7.org/fhir/requestedPeriod";
var Answer = "http://hl7.org/fhir/Answer";
var count = "http://hl7.org/fhir/count";
var ContractOffer = "http://hl7.org/fhir/ContractOffer";
var composition = "http://hl7.org/fhir/composition";
var _EnrollmentResponse = "http://hl7.org/fhir/_EnrollmentResponse";
var ConditionStageComponent = "http://hl7.org/fhir/ConditionStageComponent";
var ResearchSubjectProgressComponent = "http://hl7.org/fhir/ResearchSubjectProgressComponent";
var key = "http://hl7.org/fhir/key";
var assertion = "http://hl7.org/fhir/assertion";
var MedicationKnowledgeIndicationGuidelineDosingGuidelinePatientCharacteristicComponent = "http://hl7.org/fhir/MedicationKnowledgeIndicationGuidelineDosingGuidelinePatientCharacteristicComponent";
var alternative2 = "http://hl7.org/fhir/alternative";
var plan = "http://hl7.org/fhir/plan";
var _criteria = "http://hl7.org/fhir/_criteria";
var cycle = "http://hl7.org/fhir/cycle";
var _latitude = "http://hl7.org/fhir/_latitude";
var modifier = "http://hl7.org/fhir/modifier";
var _scoringUnit = "http://hl7.org/fhir/_scoringUnit";
var subJurisdiction = "http://hl7.org/fhir/subJurisdiction";
var _search = "http://hl7.org/fhir/_search";
var assignedComparisonGroup = "http://hl7.org/fhir/assignedComparisonGroup";
var _alias = "http://hl7.org/fhir/_alias";
var _status = "http://hl7.org/fhir/_status";
var recurring = "http://hl7.org/fhir/recurring";
var InventoryItemInstanceComponent = "http://hl7.org/fhir/InventoryItemInstanceComponent";
var frameOfReferenceUid = "http://hl7.org/fhir/frameOfReferenceUid";
var _validationDate = "http://hl7.org/fhir/_validationDate";
var NutritionOrderEnteralFormulaComponent = "http://hl7.org/fhir/NutritionOrderEnteralFormulaComponent";
var deliveryDevice = "http://hl7.org/fhir/deliveryDevice";
var _cardBrand = "http://hl7.org/fhir/_cardBrand";
var adjustment = "http://hl7.org/fhir/adjustment";
var _cors = "http://hl7.org/fhir/_cors";
var _allergenicIndicator = "http://hl7.org/fhir/_allergenicIndicator";
var _timezone = "http://hl7.org/fhir/_timezone";
var _actor = "http://hl7.org/fhir/_actor";
var valueQuantity = "http://hl7.org/fhir/valueQuantity";
var _versionId = "http://hl7.org/fhir/_versionId";
var requester = "http://hl7.org/fhir/requester";
var _SupplyRequest = "http://hl7.org/fhir/_SupplyRequest";
var MeasureTermComponent = "http://hl7.org/fhir/MeasureTermComponent";
var _containedItemQuantity = "http://hl7.org/fhir/_containedItemQuantity";
var _daysSupply = "http://hl7.org/fhir/_daysSupply";
var reportingVendor = "http://hl7.org/fhir/reportingVendor";
var current = "http://hl7.org/fhir/current";
var uid2 = "http://hl7.org/fhir/uid";
var order = "http://hl7.org/fhir/order";
var priorPrescription = "http://hl7.org/fhir/priorPrescription";
var distanceFromLandmark = "http://hl7.org/fhir/distanceFromLandmark";
var VerificationResultValidatorComponent = "http://hl7.org/fhir/VerificationResultValidatorComponent";
var _recurrenceTemplate = "http://hl7.org/fhir/_recurrenceTemplate";
var tenderedAmount = "http://hl7.org/fhir/tenderedAmount";
var _diseaseStatus = "http://hl7.org/fhir/_diseaseStatus";
var _expirationDate = "http://hl7.org/fhir/_expirationDate";
var _dataPeriod = "http://hl7.org/fhir/_dataPeriod";
var note = "http://hl7.org/fhir/note";
var _manipulated = "http://hl7.org/fhir/_manipulated";
var _Invoice = "http://hl7.org/fhir/_Invoice";
var RatioRange = "http://hl7.org/fhir/RatioRange";
var _requisition = "http://hl7.org/fhir/_requisition";
var ClinicalImpression = "http://hl7.org/fhir/ClinicalImpression";
var _claim = "http://hl7.org/fhir/_claim";
var need = "http://hl7.org/fhir/need";
var contributor3 = "http://hl7.org/fhir/contributor";
var ConceptProperty = "http://hl7.org/fhir/ConceptProperty";
var ConsentVerificationComponent = "http://hl7.org/fhir/ConsentVerificationComponent";
var TestReportTeardownComponent = "http://hl7.org/fhir/TestReportTeardownComponent";
var _genus = "http://hl7.org/fhir/_genus";
var extraDetails = "http://hl7.org/fhir/extraDetails";
var _location = "http://hl7.org/fhir/_location";
var _reported = "http://hl7.org/fhir/_reported";
var _codeMap = "http://hl7.org/fhir/_codeMap";
var firstPage = "http://hl7.org/fhir/firstPage";
var _setup = "http://hl7.org/fhir/_setup";
var _paymentBy = "http://hl7.org/fhir/_paymentBy";
var custodian = "http://hl7.org/fhir/custodian";
var estimatedAge = "http://hl7.org/fhir/estimatedAge";
var _observation = "http://hl7.org/fhir/_observation";
var technique = "http://hl7.org/fhir/technique";
var Requirements = "http://hl7.org/fhir/Requirements";
var supplementalData = "http://hl7.org/fhir/supplementalData";
var SimpleQuantity = "http://hl7.org/fhir/SimpleQuantity";
var ProvenanceEntityComponent = "http://hl7.org/fhir/ProvenanceEntityComponent";
var condition = "http://hl7.org/fhir/condition";
var excludeFoodModifier = "http://hl7.org/fhir/excludeFoodModifier";
var coverageArea = "http://hl7.org/fhir/coverageArea";
var contributionInstance = "http://hl7.org/fhir/contributionInstance";
var _productCode = "http://hl7.org/fhir/_productCode";
var _language = "http://hl7.org/fhir/_language";
var base = "http://hl7.org/fhir/base";
var _windowStart = "http://hl7.org/fhir/_windowStart";
var district = "http://hl7.org/fhir/district";
var forenameInitials = "http://hl7.org/fhir/forenameInitials";
var _state = "http://hl7.org/fhir/_state";
var friendly = "http://hl7.org/fhir/friendly";
var AdditionalAttribute = "http://hl7.org/fhir/AdditionalAttribute";
var _Transport = "http://hl7.org/fhir/_Transport";
var xhtml = "http://hl7.org/fhir/xhtml";
var _official = "http://hl7.org/fhir/_official";
var CodeSystemConceptDesignationComponent = "http://hl7.org/fhir/CodeSystemConceptDesignationComponent";
var _precedence = "http://hl7.org/fhir/_precedence";
var _result = "http://hl7.org/fhir/_result";
var _sliceName = "http://hl7.org/fhir/_sliceName";
var points = "http://hl7.org/fhir/points";
var finding = "http://hl7.org/fhir/finding";
var _yearlyTemplate = "http://hl7.org/fhir/_yearlyTemplate";
var _isModifierReason = "http://hl7.org/fhir/_isModifierReason";
var _experimental = "http://hl7.org/fhir/_experimental";
var _overbooked = "http://hl7.org/fhir/_overbooked";
var ExampleScenario = "http://hl7.org/fhir/ExampleScenario";
var AvailabilityNotAvailableTimeComponent = "http://hl7.org/fhir/AvailabilityNotAvailableTimeComponent";
var derivedFrom = "http://hl7.org/fhir/derivedFrom";
var _postalCode = "http://hl7.org/fhir/_postalCode";
var _endorser = "http://hl7.org/fhir/_endorser";
var modifierExtension = "http://hl7.org/fhir/modifierExtension";
var verified = "http://hl7.org/fhir/verified";
var warning = "http://hl7.org/fhir/warning";
var _color = "http://hl7.org/fhir/_color";
var _global = "http://hl7.org/fhir/_global";
var _policyBasis = "http://hl7.org/fhir/_policyBasis";
var timeFromEvent = "http://hl7.org/fhir/timeFromEvent";
var costToBeneficiary = "http://hl7.org/fhir/costToBeneficiary";
var Questionnaire = "http://hl7.org/fhir/Questionnaire";
var _FormularyItem = "http://hl7.org/fhir/_FormularyItem";
var _permittedUnit = "http://hl7.org/fhir/_permittedUnit";
var data = "http://hl7.org/fhir/data";
var _targetItem = "http://hl7.org/fhir/_targetItem";
var whyStopped = "http://hl7.org/fhir/whyStopped";
var _practitioner = "http://hl7.org/fhir/_practitioner";
var packageFor = "http://hl7.org/fhir/packageFor";
var _informationSource = "http://hl7.org/fhir/_informationSource";
var hasMember = "http://hl7.org/fhir/hasMember";
var _paymentIdentifier = "http://hl7.org/fhir/_paymentIdentifier";
var allowedType = "http://hl7.org/fhir/allowedType";
var _intraspecificType = "http://hl7.org/fhir/_intraspecificType";
var _isDefault = "http://hl7.org/fhir/_isDefault";
var _supportedProfile = "http://hl7.org/fhir/_supportedProfile";
var _authored = "http://hl7.org/fhir/_authored";
var stabilityDuration = "http://hl7.org/fhir/stabilityDuration";
var InsurancePlanCoverageBenefitLimitComponent = "http://hl7.org/fhir/InsurancePlanCoverageBenefitLimitComponent";
var compareToSourcePath = "http://hl7.org/fhir/compareToSourcePath";
var _dosageInstruction = "http://hl7.org/fhir/_dosageInstruction";
var sequence2 = "http://hl7.org/fhir/sequence";
var revenue = "http://hl7.org/fhir/revenue";
var SystemInteraction = "http://hl7.org/fhir/SystemInteraction";
var SubscriptionFilterByComponent = "http://hl7.org/fhir/SubscriptionFilterByComponent";
var _requirement = "http://hl7.org/fhir/_requirement";
var _reliableCache = "http://hl7.org/fhir/_reliableCache";
var nextScheduled = "http://hl7.org/fhir/nextScheduled";
var MeasureGroupComponent = "http://hl7.org/fhir/MeasureGroupComponent";
var processNote = "http://hl7.org/fhir/processNote";
var StratifierGroupPopulation = "http://hl7.org/fhir/StratifierGroupPopulation";
var issuerType = "http://hl7.org/fhir/issuerType";
var capacity = "http://hl7.org/fhir/capacity";
var _rendering = "http://hl7.org/fhir/_rendering";
var TestScriptTeardownComponent = "http://hl7.org/fhir/TestScriptTeardownComponent";
var requestIdentifier = "http://hl7.org/fhir/requestIdentifier";
var _definitionCanonical = "http://hl7.org/fhir/_definitionCanonical";
var v = "http://hl7.org/fhir/v";
var _classification = "http://hl7.org/fhir/_classification";
var Claim = "http://hl7.org/fhir/Claim";
var asNeeded = "http://hl7.org/fhir/asNeeded";
var defaultManualCompletion = "http://hl7.org/fhir/defaultManualCompletion";
var partDescription = "http://hl7.org/fhir/partDescription";
var articleDate = "http://hl7.org/fhir/articleDate";
var narrative = "http://hl7.org/fhir/narrative";
var participant2 = "http://hl7.org/fhir/participant";
var incidence = "http://hl7.org/fhir/incidence";
var div = "http://hl7.org/fhir/div";
var _versioning = "http://hl7.org/fhir/_versioning";
var RelatedClaim = "http://hl7.org/fhir/RelatedClaim";
var _page = "http://hl7.org/fhir/_page";
var appointment = "http://hl7.org/fhir/appointment";
var AuditEventEntityDetailComponent = "http://hl7.org/fhir/AuditEventEntityDetailComponent";
var productionIdentifierInUDI = "http://hl7.org/fhir/productionIdentifierInUDI";
var _photo = "http://hl7.org/fhir/_photo";
var formOf = "http://hl7.org/fhir/formOf";
var referrer = "http://hl7.org/fhir/referrer";
var _subdetailSequence = "http://hl7.org/fhir/_subdetailSequence";
var CareTeamParticipantComponent = "http://hl7.org/fhir/CareTeamParticipantComponent";
var SpecimenDefinition = "http://hl7.org/fhir/SpecimenDefinition";
var _affectsState = "http://hl7.org/fhir/_affectsState";
var _inputPopulationId = "http://hl7.org/fhir/_inputPopulationId";
var outputProfile = "http://hl7.org/fhir/outputProfile";
var MessageDefinitionAllowedResponseComponent = "http://hl7.org/fhir/MessageDefinitionAllowedResponseComponent";
var numberOfInstances = "http://hl7.org/fhir/numberOfInstances";
var Term = "http://hl7.org/fhir/Term";
var supportingImmunization = "http://hl7.org/fhir/supportingImmunization";
var previousAppointment = "http://hl7.org/fhir/previousAppointment";
var seriesDoses = "http://hl7.org/fhir/seriesDoses";
var propertyGroup = "http://hl7.org/fhir/propertyGroup";
var option = "http://hl7.org/fhir/option";
var component = "http://hl7.org/fhir/component";
var offset = "http://hl7.org/fhir/offset";
var materialType = "http://hl7.org/fhir/materialType";
var marketingAuthorizationHolder = "http://hl7.org/fhir/marketingAuthorizationHolder";
var requestedPerformer = "http://hl7.org/fhir/requestedPerformer";
var developmentStage = "http://hl7.org/fhir/developmentStage";
var _deliveryDevice = "http://hl7.org/fhir/_deliveryDevice";
var _Timing = "http://hl7.org/fhir/_Timing";
var AdverseEventSuspectEntityCausalityComponent = "http://hl7.org/fhir/AdverseEventSuspectEntityCausalityComponent";
var add = "http://hl7.org/fhir/add";
var ImmunizationPerformerComponent = "http://hl7.org/fhir/ImmunizationPerformerComponent";
var _BodyStructure = "http://hl7.org/fhir/_BodyStructure";
var _organismName = "http://hl7.org/fhir/_organismName";
var _monthlyTemplate = "http://hl7.org/fhir/_monthlyTemplate";
var versionAlgorithm = "http://hl7.org/fhir/versionAlgorithm";
var _deliverFor = "http://hl7.org/fhir/_deliverFor";
var ElementDefinitionSlicingComponent = "http://hl7.org/fhir/ElementDefinitionSlicingComponent";
var _responseId = "http://hl7.org/fhir/_responseId";
var _tenderedAmount = "http://hl7.org/fhir/_tenderedAmount";
var upperLimit = "http://hl7.org/fhir/upperLimit";
var _verificationStatus = "http://hl7.org/fhir/_verificationStatus";
var amountType = "http://hl7.org/fhir/amountType";
var _patientPaid = "http://hl7.org/fhir/_patientPaid";
var RequestOrchestrationActionOutputComponent = "http://hl7.org/fhir/RequestOrchestrationActionOutputComponent";
var _quantity = "http://hl7.org/fhir/_quantity";
var InsurancePlanPlanSpecificCostBenefitCostComponent = "http://hl7.org/fhir/InsurancePlanPlanSpecificCostBenefitCostComponent";
var _alternate = "http://hl7.org/fhir/_alternate";
var _contributingFactor = "http://hl7.org/fhir/_contributingFactor";
var _sourceIdentityCertificate = "http://hl7.org/fhir/_sourceIdentityCertificate";
var eventNumber = "http://hl7.org/fhir/eventNumber";
var AdministrableProductDefinitionPropertyComponent = "http://hl7.org/fhir/AdministrableProductDefinitionPropertyComponent";
var responseRequired = "http://hl7.org/fhir/responseRequired";
var _verifiedBy = "http://hl7.org/fhir/_verifiedBy";
var _maritalStatus = "http://hl7.org/fhir/_maritalStatus";
var _timeOfDay = "http://hl7.org/fhir/_timeOfDay";
var contraindication = "http://hl7.org/fhir/contraindication";
var patientPreparation = "http://hl7.org/fhir/patientPreparation";
var _expression = "http://hl7.org/fhir/_expression";
var _min = "http://hl7.org/fhir/_min";
var _attester = "http://hl7.org/fhir/_attester";
var _progress = "http://hl7.org/fhir/_progress";
var _collection = "http://hl7.org/fhir/_collection";
var base64Binary = "http://hl7.org/fhir/base64Binary";
var ExampleScenarioProcessStepComponent = "http://hl7.org/fhir/ExampleScenarioProcessStepComponent";
var _comprisedOf = "http://hl7.org/fhir/_comprisedOf";
var _factor = "http://hl7.org/fhir/_factor";
var _endRelationship = "http://hl7.org/fhir/_endRelationship";
var _startingMaterial = "http://hl7.org/fhir/_startingMaterial";
var expectedSupplyDuration = "http://hl7.org/fhir/expectedSupplyDuration";
var totalPriceComponent = "http://hl7.org/fhir/totalPriceComponent";
var _signer = "http://hl7.org/fhir/_signer";
var enableBehavior = "http://hl7.org/fhir/enableBehavior";
var Contract = "http://hl7.org/fhir/Contract";
var _cTerminalModificationId = "http://hl7.org/fhir/_cTerminalModificationId";
var ObservationReferenceRangeComponent = "http://hl7.org/fhir/ObservationReferenceRangeComponent";
var maxVolumeToDeliver = "http://hl7.org/fhir/maxVolumeToDeliver";
var CapabilityStatementRestResourceOperationComponent = "http://hl7.org/fhir/CapabilityStatementRestResourceOperationComponent";
var isDerived = "http://hl7.org/fhir/isDerived";
var conditionalUpdate = "http://hl7.org/fhir/conditionalUpdate";
var repeatUnitAmountType = "http://hl7.org/fhir/repeatUnitAmountType";
var subjects = "http://hl7.org/fhir/subjects";
var EvidenceVariableCharacteristicTimeFromEventComponent = "http://hl7.org/fhir/EvidenceVariableCharacteristicTimeFromEventComponent";
var _expansion = "http://hl7.org/fhir/_expansion";
var _Ingredient = "http://hl7.org/fhir/_Ingredient";
var _phase = "http://hl7.org/fhir/_phase";
var _benefitPeriod = "http://hl7.org/fhir/_benefitPeriod";
var Organization2 = "http://hl7.org/fhir/Organization";
var _referenceStrength = "http://hl7.org/fhir/_referenceStrength";
var StructureMapGroupComponent = "http://hl7.org/fhir/StructureMapGroupComponent";
var referencePolicy = "http://hl7.org/fhir/referencePolicy";
var previous = "http://hl7.org/fhir/previous";
var _stage = "http://hl7.org/fhir/_stage";
var PlanDefinitionActionOutputComponent = "http://hl7.org/fhir/PlanDefinitionActionOutputComponent";
var _publisherLocation = "http://hl7.org/fhir/_publisherLocation";
var MedicationKnowledgeIndicationGuidelineDosingGuidelineDosageComponent = "http://hl7.org/fhir/MedicationKnowledgeIndicationGuidelineDosingGuidelineDosageComponent";
var containedItemQuantity = "http://hl7.org/fhir/containedItemQuantity";
var copyrightLabel = "http://hl7.org/fhir/copyrightLabel";
var BodyStructureIncludedStructureBodyLandmarkOrientationComponent = "http://hl7.org/fhir/BodyStructureIncludedStructureBodyLandmarkOrientationComponent";
var hasBodySite = "http://hl7.org/fhir/hasBodySite";
var _valuedItem = "http://hl7.org/fhir/_valuedItem";
var Period2 = "http://hl7.org/fhir/Period";
var questionnaire = "http://hl7.org/fhir/questionnaire";
var specificCost = "http://hl7.org/fhir/specificCost";
var _collected = "http://hl7.org/fhir/_collected";
var _notAvailableTime = "http://hl7.org/fhir/_notAvailableTime";
var AllergyIntoleranceParticipantComponent = "http://hl7.org/fhir/AllergyIntoleranceParticipantComponent";
var headerField = "http://hl7.org/fhir/headerField";
var _contained = "http://hl7.org/fhir/_contained";
var _assigner = "http://hl7.org/fhir/_assigner";
var _ifNoneMatch = "http://hl7.org/fhir/_ifNoneMatch";
var DeviceAssociationOperationComponent = "http://hl7.org/fhir/DeviceAssociationOperationComponent";
var _graph = "http://hl7.org/fhir/_graph";
var changeType = "http://hl7.org/fhir/changeType";
var _orientation = "http://hl7.org/fhir/_orientation";
var parentSubstanceId = "http://hl7.org/fhir/parentSubstanceId";
var recorded = "http://hl7.org/fhir/recorded";
var _contributionType = "http://hl7.org/fhir/_contributionType";
var filterParameter = "http://hl7.org/fhir/filterParameter";
var positiveInt = "http://hl7.org/fhir/positiveInt";
var docStatus = "http://hl7.org/fhir/docStatus";
var CoverageBenefit = "http://hl7.org/fhir/CoverageBenefit";
var durationUnit = "http://hl7.org/fhir/durationUnit";
var contentType = "http://hl7.org/fhir/contentType";
var _addItem = "http://hl7.org/fhir/_addItem";
var MedicationKnowledgeIndicationGuidelineDosingGuidelineComponent = "http://hl7.org/fhir/MedicationKnowledgeIndicationGuidelineDosingGuidelineComponent";
var dateRange = "http://hl7.org/fhir/dateRange";
var used = "http://hl7.org/fhir/used";
var _city = "http://hl7.org/fhir/_city";
var reaction = "http://hl7.org/fhir/reaction";
var subset = "http://hl7.org/fhir/subset";
var performerRole = "http://hl7.org/fhir/performerRole";
var retentionTime = "http://hl7.org/fhir/retentionTime";
var _ClinicalImpression = "http://hl7.org/fhir/_ClinicalImpression";
var _generalCost = "http://hl7.org/fhir/_generalCost";
var instanceReference = "http://hl7.org/fhir/instanceReference";
var _history = "http://hl7.org/fhir/_history";
var molecularFormulaByMoiety = "http://hl7.org/fhir/molecularFormulaByMoiety";
var _orderer = "http://hl7.org/fhir/_orderer";
var _payee = "http://hl7.org/fhir/_payee";
var _windowEnd = "http://hl7.org/fhir/_windowEnd";
var _maxDosePerTreatmentPeriod = "http://hl7.org/fhir/_maxDosePerTreatmentPeriod";
var sopClass = "http://hl7.org/fhir/sopClass";
var PlanDefinitionActorOptionComponent = "http://hl7.org/fhir/PlanDefinitionActorOptionComponent";
var ExampleScenarioInstanceComponent = "http://hl7.org/fhir/ExampleScenarioInstanceComponent";
var organismGeneral = "http://hl7.org/fhir/organismGeneral";
var abatement = "http://hl7.org/fhir/abatement";
var _relatedDevice = "http://hl7.org/fhir/_relatedDevice";
var daysSupply = "http://hl7.org/fhir/daysSupply";
var _legal = "http://hl7.org/fhir/_legal";
var _EpisodeOfCare = "http://hl7.org/fhir/_EpisodeOfCare";
var _excludeFoodModifier = "http://hl7.org/fhir/_excludeFoodModifier";
var weekInterval = "http://hl7.org/fhir/weekInterval";
var _measureScore = "http://hl7.org/fhir/_measureScore";
var _const = "http://hl7.org/fhir/_const";
var _hybrid = "http://hl7.org/fhir/_hybrid";
var PackagedProductDefinitionPackagingComponent = "http://hl7.org/fhir/PackagedProductDefinitionPackagingComponent";
var _prefix = "http://hl7.org/fhir/_prefix";
var _publicationDateText = "http://hl7.org/fhir/_publicationDateText";
var ConceptSet = "http://hl7.org/fhir/ConceptSet";
var payeeType = "http://hl7.org/fhir/payeeType";
var _shelfLifeStorage = "http://hl7.org/fhir/_shelfLifeStorage";
var balance = "http://hl7.org/fhir/balance";
var _type = "http://hl7.org/fhir/_type";
var dataPeriod = "http://hl7.org/fhir/dataPeriod";
var _Immunization = "http://hl7.org/fhir/_Immunization";
var resourceReference = "http://hl7.org/fhir/resourceReference";
var _providedBy = "http://hl7.org/fhir/_providedBy";
var _fhirVersion = "http://hl7.org/fhir/_fhirVersion";
var _HealthcareService = "http://hl7.org/fhir/_HealthcareService";
var submitter = "http://hl7.org/fhir/submitter";
var description5 = "http://hl7.org/fhir/description";
var combinedPharmaceuticalDoseForm = "http://hl7.org/fhir/combinedPharmaceuticalDoseForm";
var _targetScope = "http://hl7.org/fhir/_targetScope";
var Parameter = "http://hl7.org/fhir/Parameter";
var BiologicallyDerivedProduct = "http://hl7.org/fhir/BiologicallyDerivedProduct";
var _GenomicStudy = "http://hl7.org/fhir/_GenomicStudy";
var _NutritionProduct = "http://hl7.org/fhir/_NutritionProduct";
var _additionalContext = "http://hl7.org/fhir/_additionalContext";
var version2 = "http://hl7.org/fhir/version";
var detected = "http://hl7.org/fhir/detected";
var _statistic = "http://hl7.org/fhir/_statistic";
var _bodyStructure = "http://hl7.org/fhir/_bodyStructure";
var _definitionExpression = "http://hl7.org/fhir/_definitionExpression";
var translations = "http://hl7.org/fhir/translations";
var _targetProfile = "http://hl7.org/fhir/_targetProfile";
var _notPerformedReason = "http://hl7.org/fhir/_notPerformedReason";
var ArtifactAssessmentContentComponent = "http://hl7.org/fhir/ArtifactAssessmentContentComponent";
var cost = "http://hl7.org/fhir/cost";
var CanonicalResource = "http://hl7.org/fhir/CanonicalResource";
var _authorizationSupporting = "http://hl7.org/fhir/_authorizationSupporting";
var team = "http://hl7.org/fhir/team";
var actual = "http://hl7.org/fhir/actual";
var landmarkDescription = "http://hl7.org/fhir/landmarkDescription";
var typeCanonical = "http://hl7.org/fhir/typeCanonical";
var ArtifactAssessmentContentComponentContent = "http://hl7.org/fhir/ArtifactAssessmentContentComponentContent";
var _organizationReference = "http://hl7.org/fhir/_organizationReference";
var _minimumVolume = "http://hl7.org/fhir/_minimumVolume";
var precedence = "http://hl7.org/fhir/precedence";
var CitationSummaryComponent = "http://hl7.org/fhir/CitationSummaryComponent";
var decision = "http://hl7.org/fhir/decision";
var role = "http://hl7.org/fhir/role";
var maternalOrganismId = "http://hl7.org/fhir/maternalOrganismId";
var _triggeredBy = "http://hl7.org/fhir/_triggeredBy";
var MedicationKnowledgeStorageGuidelineComponent = "http://hl7.org/fhir/MedicationKnowledgeStorageGuidelineComponent";
var dischargeDisposition = "http://hl7.org/fhir/dischargeDisposition";
var _output = "http://hl7.org/fhir/_output";
var QuestionnaireItemComponent = "http://hl7.org/fhir/QuestionnaireItemComponent";
var _compareToSourcePath = "http://hl7.org/fhir/_compareToSourcePath";
var traceNumber = "http://hl7.org/fhir/traceNumber";
var InsurancePlanPlanComponent = "http://hl7.org/fhir/InsurancePlanPlanComponent";
var object2 = "http://hl7.org/fhir/object";
var statusReason = "http://hl7.org/fhir/statusReason";
var recall = "http://hl7.org/fhir/recall";
var _codeSystem = "http://hl7.org/fhir/_codeSystem";
var _processing = "http://hl7.org/fhir/_processing";
var gateway = "http://hl7.org/fhir/gateway";
var _performerType = "http://hl7.org/fhir/_performerType";
var _subcomponent = "http://hl7.org/fhir/_subcomponent";
var postalCode = "http://hl7.org/fhir/postalCode";
var AddedItemDetail = "http://hl7.org/fhir/AddedItemDetail";
var instance = "http://hl7.org/fhir/instance";
var _disposition = "http://hl7.org/fhir/_disposition";
var _statusDate = "http://hl7.org/fhir/_statusDate";
var _facilityType = "http://hl7.org/fhir/_facilityType";
var _stratum = "http://hl7.org/fhir/_stratum";
var Payee = "http://hl7.org/fhir/Payee";
var _measurementType = "http://hl7.org/fhir/_measurementType";
var RelatedArtifact = "http://hl7.org/fhir/RelatedArtifact";
var RequestOrchestrationActionDynamicValueComponent = "http://hl7.org/fhir/RequestOrchestrationActionDynamicValueComponent";
var identity2 = "http://hl7.org/fhir/identity";
var subType = "http://hl7.org/fhir/subType";
var ValueSetExpansionContainsComponent = "http://hl7.org/fhir/ValueSetExpansionContainsComponent";
var MedicationKnowledgePackagingComponent = "http://hl7.org/fhir/MedicationKnowledgePackagingComponent";
var _display = "http://hl7.org/fhir/_display";
var ImplementationGuideGlobalComponent = "http://hl7.org/fhir/ImplementationGuideGlobalComponent";
var _SubstanceNucleicAcid = "http://hl7.org/fhir/_SubstanceNucleicAcid";
var TestScriptSetupActionOperationRequestHeaderComponent = "http://hl7.org/fhir/TestScriptSetupActionOperationRequestHeaderComponent";
var targetItem = "http://hl7.org/fhir/targetItem";
var _dosingGuideline = "http://hl7.org/fhir/_dosingGuideline";
var _totalGross = "http://hl7.org/fhir/_totalGross";
var Reference = "http://hl7.org/fhir/Reference";
var _precheckBehavior = "http://hl7.org/fhir/_precheckBehavior";
var _enableBehavior = "http://hl7.org/fhir/_enableBehavior";
var slot = "http://hl7.org/fhir/slot";
var groupDefinition = "http://hl7.org/fhir/groupDefinition";
var _verifiedWith = "http://hl7.org/fhir/_verifiedWith";
var ResourceInteraction = "http://hl7.org/fhir/ResourceInteraction";
var _numberOfSubunits = "http://hl7.org/fhir/_numberOfSubunits";
var numberOfSeries = "http://hl7.org/fhir/numberOfSeries";
var preAuthRefPeriod = "http://hl7.org/fhir/preAuthRefPeriod";
var _excludingRecurrenceId = "http://hl7.org/fhir/_excludingRecurrenceId";
var _baseCitation = "http://hl7.org/fhir/_baseCitation";
var ContractAsset = "http://hl7.org/fhir/ContractAsset";
var ClinicalImpressionFindingComponent = "http://hl7.org/fhir/ClinicalImpressionFindingComponent";
var stopTestOnFail = "http://hl7.org/fhir/stopTestOnFail";
var _selectionBehavior = "http://hl7.org/fhir/_selectionBehavior";
var _imports = "http://hl7.org/fhir/_imports";
var contextLinkId = "http://hl7.org/fhir/contextLinkId";
var _eye = "http://hl7.org/fhir/_eye";
var affiliation = "http://hl7.org/fhir/affiliation";
var defaultValue = "http://hl7.org/fhir/defaultValue";
var MolecularSequence = "http://hl7.org/fhir/MolecularSequence";
var overload = "http://hl7.org/fhir/overload";
var _productName = "http://hl7.org/fhir/_productName";
var _comment = "http://hl7.org/fhir/_comment";
var _profile = "http://hl7.org/fhir/_profile";
var _deleted = "http://hl7.org/fhir/_deleted";
var _workflow = "http://hl7.org/fhir/_workflow";
var _attestationSignature = "http://hl7.org/fhir/_attestationSignature";
var permittedDataType = "http://hl7.org/fhir/permittedDataType";
var gene = "http://hl7.org/fhir/gene";
var _prediction = "http://hl7.org/fhir/_prediction";
var exposureRoute = "http://hl7.org/fhir/exposureRoute";
var height2 = "http://hl7.org/fhir/height";
var _entryClassifier = "http://hl7.org/fhir/_entryClassifier";
var test = "http://hl7.org/fhir/test";
var _previousAppointment = "http://hl7.org/fhir/_previousAppointment";
var implementationGuide = "http://hl7.org/fhir/implementationGuide";
var UsageContext = "http://hl7.org/fhir/UsageContext";
var EventDefinition = "http://hl7.org/fhir/EventDefinition";
var relatedIdentifier = "http://hl7.org/fhir/relatedIdentifier";
var ImplementationGuideDependsOnComponent = "http://hl7.org/fhir/ImplementationGuideDependsOnComponent";
var _procedureSequence = "http://hl7.org/fhir/_procedureSequence";
var _copyrightLabel = "http://hl7.org/fhir/_copyrightLabel";
var _navigationLinks = "http://hl7.org/fhir/_navigationLinks";
var _generatedBy = "http://hl7.org/fhir/_generatedBy";
var administeredProduct = "http://hl7.org/fhir/administeredProduct";
var validateProfileId = "http://hl7.org/fhir/validateProfileId";
var MedicationKnowledgeIndicationGuidelineComponent = "http://hl7.org/fhir/MedicationKnowledgeIndicationGuidelineComponent";
var intraspecificDescription = "http://hl7.org/fhir/intraspecificDescription";
var _protocolApplied = "http://hl7.org/fhir/_protocolApplied";
var _VerificationResult = "http://hl7.org/fhir/_VerificationResult";
var monthInterval = "http://hl7.org/fhir/monthInterval";
var expiry = "http://hl7.org/fhir/expiry";
var versioning = "http://hl7.org/fhir/versioning";
var pushTypeAvailable = "http://hl7.org/fhir/pushTypeAvailable";
var CitationCitedArtifactStatusDateComponent = "http://hl7.org/fhir/CitationCitedArtifactStatusDateComponent";
var _assertion = "http://hl7.org/fhir/_assertion";
var diagnosis = "http://hl7.org/fhir/diagnosis";
var _ifNoneExist = "http://hl7.org/fhir/_ifNoneExist";
var _low = "http://hl7.org/fhir/_low";
var undesirableEffect = "http://hl7.org/fhir/undesirableEffect";
var _base = "http://hl7.org/fhir/_base";
var queryCriteria = "http://hl7.org/fhir/queryCriteria";
var _availableEndTime = "http://hl7.org/fhir/_availableEndTime";
var number = "http://hl7.org/fhir/number";
var spatialReference = "http://hl7.org/fhir/spatialReference";
var conditionality = "http://hl7.org/fhir/conditionality";
var _codeFilter = "http://hl7.org/fhir/_codeFilter";
var SubstanceDefinitionCharacterizationComponent = "http://hl7.org/fhir/SubstanceDefinitionCharacterizationComponent";
var offsets = "http://hl7.org/fhir/offsets";
var _orderedBy = "http://hl7.org/fhir/_orderedBy";
var _authorizationUrl = "http://hl7.org/fhir/_authorizationUrl";
var _carrierAIDC = "http://hl7.org/fhir/_carrierAIDC";
var _episodeOfCare = "http://hl7.org/fhir/_episodeOfCare";
var disabledDisplay = "http://hl7.org/fhir/disabledDisplay";
var DocumentReference = "http://hl7.org/fhir/DocumentReference";
var compositeScoring = "http://hl7.org/fhir/compositeScoring";
var _yearInterval = "http://hl7.org/fhir/_yearInterval";
var RelatedPersonCommunicationComponent = "http://hl7.org/fhir/RelatedPersonCommunicationComponent";
var _displayName = "http://hl7.org/fhir/_displayName";
var _monday = "http://hl7.org/fhir/_monday";
var messaging = "http://hl7.org/fhir/messaging";
var geneElement = "http://hl7.org/fhir/geneElement";
var exclude = "http://hl7.org/fhir/exclude";
var _itemSequence = "http://hl7.org/fhir/_itemSequence";
var _artifactAssessment = "http://hl7.org/fhir/_artifactAssessment";
var dispenseRequest = "http://hl7.org/fhir/dispenseRequest";
var intendedJurisdiction = "http://hl7.org/fhir/intendedJurisdiction";
var _restriction = "http://hl7.org/fhir/_restriction";
var ImmunizationEvaluation = "http://hl7.org/fhir/ImmunizationEvaluation";
var Observation = "http://hl7.org/fhir/Observation";
var _supplier = "http://hl7.org/fhir/_supplier";
var NutritionIntakePerformerComponent = "http://hl7.org/fhir/NutritionIntakePerformerComponent";
var CapabilityStatementRestComponentSearchParam = "http://hl7.org/fhir/CapabilityStatementRestComponentSearchParam";
var _SubstanceReferenceInformation = "http://hl7.org/fhir/_SubstanceReferenceInformation";
var _CarePlan = "http://hl7.org/fhir/_CarePlan";
var AdverseEventPreventiveActionComponent = "http://hl7.org/fhir/AdverseEventPreventiveActionComponent";
var outsideFoodAllowed = "http://hl7.org/fhir/outsideFoodAllowed";
var _maxVolumeToDeliver = "http://hl7.org/fhir/_maxVolumeToDeliver";
var InventoryItemAssociationComponent = "http://hl7.org/fhir/InventoryItemAssociationComponent";
var deliverFor = "http://hl7.org/fhir/deliverFor";
var ElementDefinitionExampleComponent = "http://hl7.org/fhir/ElementDefinitionExampleComponent";
var _totalPriceComponent = "http://hl7.org/fhir/_totalPriceComponent";
var _carrierHRF = "http://hl7.org/fhir/_carrierHRF";
var _subProperty = "http://hl7.org/fhir/_subProperty";
var allowed = "http://hl7.org/fhir/allowed";
var _searchType = "http://hl7.org/fhir/_searchType";
var List = "http://hl7.org/fhir/List";
var responseId = "http://hl7.org/fhir/responseId";
var _defaultManualCompletion = "http://hl7.org/fhir/_defaultManualCompletion";
var _subscriberId = "http://hl7.org/fhir/_subscriberId";
var _groupingId = "http://hl7.org/fhir/_groupingId";
var _protocolPerformed = "http://hl7.org/fhir/_protocolPerformed";
var subPotentReason = "http://hl7.org/fhir/subPotentReason";
var maxValue = "http://hl7.org/fhir/maxValue";
var _data = "http://hl7.org/fhir/_data";
var _disulfideLinkage = "http://hl7.org/fhir/_disulfideLinkage";
var metadata = "http://hl7.org/fhir/metadata";
var ConditionParticipantComponent = "http://hl7.org/fhir/ConditionParticipantComponent";
var rationale = "http://hl7.org/fhir/rationale";
var tax = "http://hl7.org/fhir/tax";
var _line = "http://hl7.org/fhir/_line";
var index = "http://hl7.org/fhir/index";
var _firstPage = "http://hl7.org/fhir/_firstPage";
var verifiedBy = "http://hl7.org/fhir/verifiedBy";
var _requestProvider = "http://hl7.org/fhir/_requestProvider";
var Diagnosis = "http://hl7.org/fhir/Diagnosis";
var _hybridType = "http://hl7.org/fhir/_hybridType";
var _abnormalCodedValueSet = "http://hl7.org/fhir/_abnormalCodedValueSet";
var Encounter = "http://hl7.org/fhir/Encounter";
var expression = "http://hl7.org/fhir/expression";
var _current = "http://hl7.org/fhir/_current";
var BackboneType = "http://hl7.org/fhir/BackboneType";
var collection = "http://hl7.org/fhir/collection";
var _family = "http://hl7.org/fhir/_family";
var _validated = "http://hl7.org/fhir/_validated";
var question = "http://hl7.org/fhir/question";
var _noMap = "http://hl7.org/fhir/_noMap";
var _comparisonGroup = "http://hl7.org/fhir/_comparisonGroup";
var EnrollmentRequest = "http://hl7.org/fhir/EnrollmentRequest";
var _surfaceOrientation = "http://hl7.org/fhir/_surfaceOrientation";
var prescription = "http://hl7.org/fhir/prescription";
var _contributorship = "http://hl7.org/fhir/_contributorship";
var synthesisType = "http://hl7.org/fhir/synthesisType";
var _anchor = "http://hl7.org/fhir/_anchor";
var _suppress = "http://hl7.org/fhir/_suppress";
var _other = "http://hl7.org/fhir/_other";
var variable = "http://hl7.org/fhir/variable";
var MolecularSequenceRelativeComponent = "http://hl7.org/fhir/MolecularSequenceRelativeComponent";
var Ingredient = "http://hl7.org/fhir/Ingredient";
var _occurrenceDateTime = "http://hl7.org/fhir/_occurrenceDateTime";
var Annotation = "http://hl7.org/fhir/Annotation";
var SubstanceReferenceInformationGeneComponent = "http://hl7.org/fhir/SubstanceReferenceInformationGeneComponent";
var _valueQuantity = "http://hl7.org/fhir/_valueQuantity";
var DeviceDefinitionCorrectiveActionComponent = "http://hl7.org/fhir/DeviceDefinitionCorrectiveActionComponent";
var OperationDefinitionParameterComponent = "http://hl7.org/fhir/OperationDefinitionParameterComponent";
var EvidenceVariableCharacteristicDefinitionByCombinationComponent = "http://hl7.org/fhir/EvidenceVariableCharacteristicDefinitionByCombinationComponent";
var SpecimenDefinitionTypeTestedHandlingComponent = "http://hl7.org/fhir/SpecimenDefinitionTypeTestedHandlingComponent";
var _testRun = "http://hl7.org/fhir/_testRun";
var compareToSourceId = "http://hl7.org/fhir/compareToSourceId";
var _definitional = "http://hl7.org/fhir/_definitional";
var _testCase = "http://hl7.org/fhir/_testCase";
var _PaymentReconciliation = "http://hl7.org/fhir/_PaymentReconciliation";
var valuedItem = "http://hl7.org/fhir/valuedItem";
var relatedItem = "http://hl7.org/fhir/relatedItem";
var consumedItem = "http://hl7.org/fhir/consumedItem";
var search = "http://hl7.org/fhir/search";
var duration3 = "http://hl7.org/fhir/duration";
var status2 = "http://hl7.org/fhir/status";
var _context = "http://hl7.org/fhir/_context";
var _requirements = "http://hl7.org/fhir/_requirements";
var _subjectType = "http://hl7.org/fhir/_subjectType";
var _use = "http://hl7.org/fhir/_use";
var udi = "http://hl7.org/fhir/udi";
var nameType = "http://hl7.org/fhir/nameType";
var _producedFrom = "http://hl7.org/fhir/_producedFrom";
var _interval = "http://hl7.org/fhir/_interval";
var summary3 = "http://hl7.org/fhir/summary";
var MedicinalProductDefinitionCharacteristicComponent = "http://hl7.org/fhir/MedicinalProductDefinitionCharacteristicComponent";
var sex = "http://hl7.org/fhir/sex";
var AdministrableProductDefinition = "http://hl7.org/fhir/AdministrableProductDefinition";
var SecurityLabel = "http://hl7.org/fhir/SecurityLabel";
var SubstanceDefinitionRelationshipComponent = "http://hl7.org/fhir/SubstanceDefinitionRelationshipComponent";
var knownAllergen = "http://hl7.org/fhir/knownAllergen";
var knownDataCount = "http://hl7.org/fhir/knownDataCount";
var observer = "http://hl7.org/fhir/observer";
var _subtitle = "http://hl7.org/fhir/_subtitle";
var accessionNumber = "http://hl7.org/fhir/accessionNumber";
var _finding = "http://hl7.org/fhir/_finding";
var _style = "http://hl7.org/fhir/_style";
var relation3 = "http://hl7.org/fhir/relation";
var priority2 = "http://hl7.org/fhir/priority";
var _requestId = "http://hl7.org/fhir/_requestId";
var ElementDefinitionBindingComponent = "http://hl7.org/fhir/ElementDefinitionBindingComponent";
var sequenceAttachment = "http://hl7.org/fhir/sequenceAttachment";
var AddedItemBodySite = "http://hl7.org/fhir/AddedItemBodySite";
var _group = "http://hl7.org/fhir/_group";
var publisher3 = "http://hl7.org/fhir/publisher";
var consent = "http://hl7.org/fhir/consent";
var site = "http://hl7.org/fhir/site";
var canFilterBy = "http://hl7.org/fhir/canFilterBy";
var TerminologyCapabilitiesValidateCodeComponent = "http://hl7.org/fhir/TerminologyCapabilitiesValidateCodeComponent";
var _isSubPotent = "http://hl7.org/fhir/_isSubPotent";
var EncounterParticipantComponent = "http://hl7.org/fhir/EncounterParticipantComponent";
var _cancellationReason = "http://hl7.org/fhir/_cancellationReason";
var _repetitions = "http://hl7.org/fhir/_repetitions";
var TestPlanTestCaseTestRunScriptComponent = "http://hl7.org/fhir/TestPlanTestCaseTestRunScriptComponent";
var distributor = "http://hl7.org/fhir/distributor";
var _stopTestOnFail = "http://hl7.org/fhir/_stopTestOnFail";
var organizationReference = "http://hl7.org/fhir/organizationReference";
var residueSite = "http://hl7.org/fhir/residueSite";
var guidance = "http://hl7.org/fhir/guidance";
var _originatingAppointment = "http://hl7.org/fhir/_originatingAppointment";
var intended = "http://hl7.org/fhir/intended";
var _measurementFrequency = "http://hl7.org/fhir/_measurementFrequency";
var _variableRole = "http://hl7.org/fhir/_variableRole";
var assurance = "http://hl7.org/fhir/assurance";
var literal = "http://hl7.org/fhir/literal";
var _suppliedItem = "http://hl7.org/fhir/_suppliedItem";
var ProcedurePerformerComponent = "http://hl7.org/fhir/ProcedurePerformerComponent";
var baseUnit = "http://hl7.org/fhir/baseUnit";
var _translation = "http://hl7.org/fhir/_translation";
var StructureDefinitionSnapshotComponent = "http://hl7.org/fhir/StructureDefinitionSnapshotComponent";
var _name = "http://hl7.org/fhir/_name";
var MedicationRequestDispenseRequestInitialFillComponent = "http://hl7.org/fhir/MedicationRequestDispenseRequestInitialFillComponent";
var _incidence = "http://hl7.org/fhir/_incidence";
var _during = "http://hl7.org/fhir/_during";
var _snapshot = "http://hl7.org/fhir/_snapshot";
var SubstancePolymerRepeatRepeatUnitComponent = "http://hl7.org/fhir/SubstancePolymerRepeatRepeatUnitComponent";
var _format = "http://hl7.org/fhir/_format";
var PlanBenefit = "http://hl7.org/fhir/PlanBenefit";
var _foodPreferenceModifier = "http://hl7.org/fhir/_foodPreferenceModifier";
var function__workaround = "http://hl7.org/fhir/function";
var environmentType = "http://hl7.org/fhir/environmentType";
var SubscriptionTopicCanFilterByComponent = "http://hl7.org/fhir/SubscriptionTopicCanFilterByComponent";
var occurrenceCount = "http://hl7.org/fhir/occurrenceCount";
var careTeamSequence = "http://hl7.org/fhir/careTeamSequence";
var _notConsumedReason = "http://hl7.org/fhir/_notConsumedReason";
var _restoreDate = "http://hl7.org/fhir/_restoreDate";
var providedBy = "http://hl7.org/fhir/providedBy";
var meta = "http://hl7.org/fhir/meta";
var _subDetailSequence = "http://hl7.org/fhir/_subDetailSequence";
var required = "http://hl7.org/fhir/required";
var _dateWritten = "http://hl7.org/fhir/_dateWritten";
var _deviceIdentifier = "http://hl7.org/fhir/_deviceIdentifier";
var referral = "http://hl7.org/fhir/referral";
var _conditionality = "http://hl7.org/fhir/_conditionality";
var AuditEventSourceComponent = "http://hl7.org/fhir/AuditEventSourceComponent";
var _component = "http://hl7.org/fhir/_component";
var link = "http://hl7.org/fhir/link";
var _hasStage = "http://hl7.org/fhir/_hasStage";
var _contentReference = "http://hl7.org/fhir/_contentReference";
var program = "http://hl7.org/fhir/program";
var OtherElement = "http://hl7.org/fhir/OtherElement";
var scoringUnit = "http://hl7.org/fhir/scoringUnit";
var _maxCount = "http://hl7.org/fhir/_maxCount";
var ExplanationOfBenefitEventComponent = "http://hl7.org/fhir/ExplanationOfBenefitEventComponent";
var _ArtifactAssessment = "http://hl7.org/fhir/_ArtifactAssessment";
var scope = "http://hl7.org/fhir/scope";
var inventoryListing = "http://hl7.org/fhir/inventoryListing";
var concentration = "http://hl7.org/fhir/concentration";
var _device = "http://hl7.org/fhir/_device";
var hierarchyMeaning = "http://hl7.org/fhir/hierarchyMeaning";
var CapabilityStatementRestComponentOperation = "http://hl7.org/fhir/CapabilityStatementRestComponentOperation";
var otherMap = "http://hl7.org/fhir/otherMap";
var answerConstraint = "http://hl7.org/fhir/answerConstraint";
var normalCodedValueSet = "http://hl7.org/fhir/normalCodedValueSet";
var global = "http://hl7.org/fhir/global";
var excludingRecurrenceId = "http://hl7.org/fhir/excludingRecurrenceId";
var _SubstanceSourceMaterial = "http://hl7.org/fhir/_SubstanceSourceMaterial";
var validity = "http://hl7.org/fhir/validity";
var subjectReport = "http://hl7.org/fhir/subjectReport";
var _any = "http://hl7.org/fhir/_any";
var _nextScheduled = "http://hl7.org/fhir/_nextScheduled";
var administration = "http://hl7.org/fhir/administration";
var sort = "http://hl7.org/fhir/sort";
var ManufacturedItemDefinitionComponentComponentProperty = "http://hl7.org/fhir/ManufacturedItemDefinitionComponentComponentProperty";
var _sent = "http://hl7.org/fhir/_sent";
var _directnessMatch = "http://hl7.org/fhir/_directnessMatch";
var _targetFormat = "http://hl7.org/fhir/_targetFormat";
var _used = "http://hl7.org/fhir/_used";
var _occurence = "http://hl7.org/fhir/_occurence";
var _partOf = "http://hl7.org/fhir/_partOf";
var relativeRisk = "http://hl7.org/fhir/relativeRisk";
var supportedMessage = "http://hl7.org/fhir/supportedMessage";
var _dateOfDiagnosis = "http://hl7.org/fhir/_dateOfDiagnosis";
var _seriesNumber = "http://hl7.org/fhir/_seriesNumber";
var DataRequirementSortComponent = "http://hl7.org/fhir/DataRequirementSortComponent";
var ChargeItemDefinitionPropertyGroupComponentApplicability = "http://hl7.org/fhir/ChargeItemDefinitionPropertyGroupComponentApplicability";
var codeSystem = "http://hl7.org/fhir/codeSystem";
var processing = "http://hl7.org/fhir/processing";
var _ResearchSubject = "http://hl7.org/fhir/_ResearchSubject";
var _heartbeatPeriod = "http://hl7.org/fhir/_heartbeatPeriod";
var ValueSetExpansionPropertyComponent = "http://hl7.org/fhir/ValueSetExpansionPropertyComponent";
var orderDetail = "http://hl7.org/fhir/orderDetail";
var Group2 = "http://hl7.org/fhir/Group";
var statusDate = "http://hl7.org/fhir/statusDate";
var uri = "http://hl7.org/fhir/uri";
var max = "http://hl7.org/fhir/max";
var _conformance = "http://hl7.org/fhir/_conformance";
var _unitPriceComponent = "http://hl7.org/fhir/_unitPriceComponent";
var _availabilityStatus = "http://hl7.org/fhir/_availabilityStatus";
var _exitCriteria = "http://hl7.org/fhir/_exitCriteria";
var Schedule = "http://hl7.org/fhir/Schedule";
var BiologicallyDerivedProductCollectionComponent = "http://hl7.org/fhir/BiologicallyDerivedProductCollectionComponent";
var DomainResource = "http://hl7.org/fhir/DomainResource";
var _AdverseEvent = "http://hl7.org/fhir/_AdverseEvent";
var focalDevice = "http://hl7.org/fhir/focalDevice";
var _authorType = "http://hl7.org/fhir/_authorType";
var mode2 = "http://hl7.org/fhir/mode";
var observation = "http://hl7.org/fhir/observation";
var _issuer = "http://hl7.org/fhir/_issuer";
var ClaimEventComponent = "http://hl7.org/fhir/ClaimEventComponent";
var FamilyMemberHistoryParticipantComponent = "http://hl7.org/fhir/FamilyMemberHistoryParticipantComponent";
var _validationStatus = "http://hl7.org/fhir/_validationStatus";
var string = "http://hl7.org/fhir/string";
var productCode = "http://hl7.org/fhir/productCode";
var receiver = "http://hl7.org/fhir/receiver";
var CitationCitedArtifactTitleComponent = "http://hl7.org/fhir/CitationCitedArtifactTitleComponent";
var totalGross = "http://hl7.org/fhir/totalGross";
var _outputProfile = "http://hl7.org/fhir/_outputProfile";
var conditionalDelete = "http://hl7.org/fhir/conditionalDelete";
var baseDefinition = "http://hl7.org/fhir/baseDefinition";
var NutritionProductInstanceComponent = "http://hl7.org/fhir/NutritionProductInstanceComponent";
var ClinicalUseDefinitionIndicationComponent = "http://hl7.org/fhir/ClinicalUseDefinitionIndicationComponent";
var relevantHistory = "http://hl7.org/fhir/relevantHistory";
var referenceInformation = "http://hl7.org/fhir/referenceInformation";
var valueSet = "http://hl7.org/fhir/valueSet";
var library = "http://hl7.org/fhir/library";
var InventoryReportInventoryListingItemComponent = "http://hl7.org/fhir/InventoryReportInventoryListingItemComponent";
var performedActivity = "http://hl7.org/fhir/performedActivity";
var Coverage = "http://hl7.org/fhir/Coverage";
var probability = "http://hl7.org/fhir/probability";
var TerminologyCapabilitiesSoftwareComponent = "http://hl7.org/fhir/TerminologyCapabilitiesSoftwareComponent";
var _activity = "http://hl7.org/fhir/_activity";
var prediction = "http://hl7.org/fhir/prediction";
var _mimeType = "http://hl7.org/fhir/_mimeType";
var exception = "http://hl7.org/fhir/exception";
var ImplementationGuideDefinitionTemplateComponent = "http://hl7.org/fhir/ImplementationGuideDefinitionTemplateComponent";
var _edit = "http://hl7.org/fhir/_edit";
var _usage = "http://hl7.org/fhir/_usage";
var proposedNewTime = "http://hl7.org/fhir/proposedNewTime";
var security = "http://hl7.org/fhir/security";
var _parameter = "http://hl7.org/fhir/_parameter";
var InventoryItemDescriptionComponent = "http://hl7.org/fhir/InventoryItemDescriptionComponent";
var ConditionDefinitionPreconditionComponent = "http://hl7.org/fhir/ConditionDefinitionPreconditionComponent";
var LocationPositionComponent = "http://hl7.org/fhir/LocationPositionComponent";
var sequenceRange = "http://hl7.org/fhir/sequenceRange";
var policyBasis = "http://hl7.org/fhir/policyBasis";
var _inputParameters = "http://hl7.org/fhir/_inputParameters";
var _dateRange = "http://hl7.org/fhir/_dateRange";
var _cost = "http://hl7.org/fhir/_cost";
var Timing = "http://hl7.org/fhir/Timing";
var _team = "http://hl7.org/fhir/_team";
var _paternalOrganismId = "http://hl7.org/fhir/_paternalOrganismId";
var _statusChanged = "http://hl7.org/fhir/_statusChanged";
var ActivityDefinitionDynamicValueComponent = "http://hl7.org/fhir/ActivityDefinitionDynamicValueComponent";
var processor = "http://hl7.org/fhir/processor";
var _constraint = "http://hl7.org/fhir/_constraint";
var _sampleSize = "http://hl7.org/fhir/_sampleSize";
var ClinicalUseDefinitionContraindicationComponent = "http://hl7.org/fhir/ClinicalUseDefinitionContraindicationComponent";
var _comorbidity = "http://hl7.org/fhir/_comorbidity";
var _knownDataCount = "http://hl7.org/fhir/_knownDataCount";
var template = "http://hl7.org/fhir/template";
var codeFilter = "http://hl7.org/fhir/codeFilter";
var dateAccessed = "http://hl7.org/fhir/dateAccessed";
var _organization = "http://hl7.org/fhir/_organization";
var _ifModifiedSince = "http://hl7.org/fhir/_ifModifiedSince";
var _lastRevisionDate = "http://hl7.org/fhir/_lastRevisionDate";
var _strength = "http://hl7.org/fhir/_strength";
var numerator = "http://hl7.org/fhir/numerator";
var _altitude = "http://hl7.org/fhir/_altitude";
var _countingDateTime = "http://hl7.org/fhir/_countingDateTime";
var MedicationDispense = "http://hl7.org/fhir/MedicationDispense";
var _maxDuration = "http://hl7.org/fhir/_maxDuration";
var requirement = "http://hl7.org/fhir/requirement";
var SubstanceProteinSubunitComponent = "http://hl7.org/fhir/SubstanceProteinSubunitComponent";
var _abatement = "http://hl7.org/fhir/_abatement";
var reportingPeriod = "http://hl7.org/fhir/reportingPeriod";
var dosage = "http://hl7.org/fhir/dosage";
var _supplement = "http://hl7.org/fhir/_supplement";
var _treatmentIntent = "http://hl7.org/fhir/_treatmentIntent";
var performingOrganization = "http://hl7.org/fhir/performingOrganization";
var _what = "http://hl7.org/fhir/_what";
var intervalUnit = "http://hl7.org/fhir/intervalUnit";
var preAuthPeriod = "http://hl7.org/fhir/preAuthPeriod";
var fhirPathCriteria = "http://hl7.org/fhir/fhirPathCriteria";
var administeredBy = "http://hl7.org/fhir/administeredBy";
var factor = "http://hl7.org/fhir/factor";
var ContactPoint = "http://hl7.org/fhir/ContactPoint";
var appointmentType = "http://hl7.org/fhir/appointmentType";
var _collector = "http://hl7.org/fhir/_collector";
var answerValueSet = "http://hl7.org/fhir/answerValueSet";
var _achievementStatus = "http://hl7.org/fhir/_achievementStatus";
var carrierHRF = "http://hl7.org/fhir/carrierHRF";
var _evaluatedResource = "http://hl7.org/fhir/_evaluatedResource";
var signer = "http://hl7.org/fhir/signer";
var _usageReason = "http://hl7.org/fhir/_usageReason";
var variableDefinition = "http://hl7.org/fhir/variableDefinition";
var manifestation = "http://hl7.org/fhir/manifestation";
var searchType = "http://hl7.org/fhir/searchType";
var PaymentReconciliation = "http://hl7.org/fhir/PaymentReconciliation";
var _modelNumber = "http://hl7.org/fhir/_modelNumber";
var groupingId = "http://hl7.org/fhir/groupingId";
var _VisionPrescription = "http://hl7.org/fhir/_VisionPrescription";
var performerLinkId = "http://hl7.org/fhir/performerLinkId";
var procedure = "http://hl7.org/fhir/procedure";
var implicitRules = "http://hl7.org/fhir/implicitRules";
var query = "http://hl7.org/fhir/query";
var Items = "http://hl7.org/fhir/Items";
var _slot = "http://hl7.org/fhir/_slot";
var _conditionalCreate = "http://hl7.org/fhir/_conditionalCreate";
var PatientCommunicationComponent = "http://hl7.org/fhir/PatientCommunicationComponent";
var ConditionDefinitionMedicationComponent = "http://hl7.org/fhir/ConditionDefinitionMedicationComponent";
var documentation = "http://hl7.org/fhir/documentation";
var maxDosePerTreatmentPeriod = "http://hl7.org/fhir/maxDosePerTreatmentPeriod";
var example = "http://hl7.org/fhir/example";
var _sessionKey = "http://hl7.org/fhir/_sessionKey";
var lastPage = "http://hl7.org/fhir/lastPage";
var hybridType = "http://hl7.org/fhir/hybridType";
var field = "http://hl7.org/fhir/field";
var maxDosePerPeriod = "http://hl7.org/fhir/maxDosePerPeriod";
var _excludedStructure = "http://hl7.org/fhir/_excludedStructure";
var _script = "http://hl7.org/fhir/_script";
var acceptLanguage = "http://hl7.org/fhir/acceptLanguage";
var practiceSetting = "http://hl7.org/fhir/practiceSetting";
var brand = "http://hl7.org/fhir/brand";
var _attributeEstimate = "http://hl7.org/fhir/_attributeEstimate";
var _end = "http://hl7.org/fhir/_end";
var diagnosisSequence = "http://hl7.org/fhir/diagnosisSequence";
var _specification = "http://hl7.org/fhir/_specification";
var _test = "http://hl7.org/fhir/_test";
var _durationMax = "http://hl7.org/fhir/_durationMax";
var impurity = "http://hl7.org/fhir/impurity";
var _Practitioner = "http://hl7.org/fhir/_Practitioner";
var SubstanceIngredientComponent = "http://hl7.org/fhir/SubstanceIngredientComponent";
var control = "http://hl7.org/fhir/control";
var _enterer = "http://hl7.org/fhir/_enterer";
var TransportOutputComponent = "http://hl7.org/fhir/TransportOutputComponent";
var _retentionTime = "http://hl7.org/fhir/_retentionTime";
var _encodeRequestUrl = "http://hl7.org/fhir/_encodeRequestUrl";
var countMax = "http://hl7.org/fhir/countMax";
var _netContent = "http://hl7.org/fhir/_netContent";
var AccountBalanceComponent = "http://hl7.org/fhir/AccountBalanceComponent";
var _sequenceAttachment = "http://hl7.org/fhir/_sequenceAttachment";
var requestedLocation = "http://hl7.org/fhir/requestedLocation";
var DeviceDefinitionRegulatoryIdentifierComponent = "http://hl7.org/fhir/DeviceDefinitionRegulatoryIdentifierComponent";
var _target = "http://hl7.org/fhir/_target";
var _implicated = "http://hl7.org/fhir/_implicated";
var _administration = "http://hl7.org/fhir/_administration";
var _flag = "http://hl7.org/fhir/_flag";
var _party = "http://hl7.org/fhir/_party";
var _version = "http://hl7.org/fhir/_version";
var provision = "http://hl7.org/fhir/provision";
var patientPaid = "http://hl7.org/fhir/patientPaid";
var referenceNumber = "http://hl7.org/fhir/referenceNumber";
var manifest = "http://hl7.org/fhir/manifest";
var Account = "http://hl7.org/fhir/Account";
var _goal = "http://hl7.org/fhir/_goal";
var _basis = "http://hl7.org/fhir/_basis";
var MessageSource = "http://hl7.org/fhir/MessageSource";
var _formCode = "http://hl7.org/fhir/_formCode";
var _disclaimer = "http://hl7.org/fhir/_disclaimer";
var _definitionByCombination = "http://hl7.org/fhir/_definitionByCombination";
var step = "http://hl7.org/fhir/step";
var fractionDescription = "http://hl7.org/fhir/fractionDescription";
var valueCategory = "http://hl7.org/fhir/valueCategory";
var requestMethod = "http://hl7.org/fhir/requestMethod";
var BodySite = "http://hl7.org/fhir/BodySite";
var etag = "http://hl7.org/fhir/etag";
var specimenQuantity = "http://hl7.org/fhir/specimenQuantity";
var comprisedOf = "http://hl7.org/fhir/comprisedOf";
var _pediatricUseIndicator = "http://hl7.org/fhir/_pediatricUseIndicator";
var _destination = "http://hl7.org/fhir/_destination";
var _evaluationMessage = "http://hl7.org/fhir/_evaluationMessage";
var ResearchStudyComparisonGroupComponent = "http://hl7.org/fhir/ResearchStudyComparisonGroupComponent";
var _DomainResource = "http://hl7.org/fhir/_DomainResource";
var CitationCitedArtifactWebLocationComponent = "http://hl7.org/fhir/CitationCitedArtifactWebLocationComponent";
var beneficiary = "http://hl7.org/fhir/beneficiary";
var prefix = "http://hl7.org/fhir/prefix";
var effectiveTime = "http://hl7.org/fhir/effectiveTime";
var RegulatedAuthorizationCaseComponent = "http://hl7.org/fhir/RegulatedAuthorizationCaseComponent";
var AccountProcedureComponent = "http://hl7.org/fhir/AccountProcedureComponent";
var doseStatusReason = "http://hl7.org/fhir/doseStatusReason";
var ResearchStudyAssociatedPartyComponent = "http://hl7.org/fhir/ResearchStudyAssociatedPartyComponent";
var reason = "http://hl7.org/fhir/reason";
var _precondition = "http://hl7.org/fhir/_precondition";
var criteria = "http://hl7.org/fhir/criteria";
var MedicationAdministrationDosageComponent = "http://hl7.org/fhir/MedicationAdministrationDosageComponent";
var latitude2 = "http://hl7.org/fhir/latitude";
var IngredientSubstanceStrengthReferenceStrengthComponent = "http://hl7.org/fhir/IngredientSubstanceStrengthReferenceStrengthComponent";
var _thursday = "http://hl7.org/fhir/_thursday";
var securityContext = "http://hl7.org/fhir/securityContext";
var _baseDefinition = "http://hl7.org/fhir/_baseDefinition";
var _publicationStatus = "http://hl7.org/fhir/_publicationStatus";
var relatedArtifact = "http://hl7.org/fhir/relatedArtifact";
var safety = "http://hl7.org/fhir/safety";
var stereochemistry = "http://hl7.org/fhir/stereochemistry";
var _timeout = "http://hl7.org/fhir/_timeout";
var primarySource = "http://hl7.org/fhir/primarySource";
var NutritionOrderOralDietNutrientComponent = "http://hl7.org/fhir/NutritionOrderOralDietNutrientComponent";
var responseCode = "http://hl7.org/fhir/responseCode";
var eventHistory = "http://hl7.org/fhir/eventHistory";
var _doseForm = "http://hl7.org/fhir/_doseForm";
var _allowedResponse = "http://hl7.org/fhir/_allowedResponse";
var _storageGuideline = "http://hl7.org/fhir/_storageGuideline";
var timezone = "http://hl7.org/fhir/timezone";
var copolymerConnectivity = "http://hl7.org/fhir/copolymerConnectivity";
var GenomicStudyAnalysisOutputComponent = "http://hl7.org/fhir/GenomicStudyAnalysisOutputComponent";
var _molecularWeight = "http://hl7.org/fhir/_molecularWeight";
var ObservationDefinition = "http://hl7.org/fhir/ObservationDefinition";
var ifNoneMatch = "http://hl7.org/fhir/ifNoneMatch";
var _notConsumed = "http://hl7.org/fhir/_notConsumed";
var grade = "http://hl7.org/fhir/grade";
var OralDietSchedule = "http://hl7.org/fhir/OralDietSchedule";
var _diagnosis = "http://hl7.org/fhir/_diagnosis";
var _channelType = "http://hl7.org/fhir/_channelType";
var _encounter = "http://hl7.org/fhir/_encounter";
var SubstancePolymerMonomerSetStartingMaterialComponent = "http://hl7.org/fhir/SubstancePolymerMonomerSetStartingMaterialComponent";
var statisticType = "http://hl7.org/fhir/statisticType";
var _webLocation = "http://hl7.org/fhir/_webLocation";
var SubstanceSourceMaterialOrganismOrganismGeneralComponent = "http://hl7.org/fhir/SubstanceSourceMaterialOrganismOrganismGeneralComponent";
var textConcentration = "http://hl7.org/fhir/textConcentration";
var _multipleAnd = "http://hl7.org/fhir/_multipleAnd";
var _freeToShare = "http://hl7.org/fhir/_freeToShare";
var _contributionInstance = "http://hl7.org/fhir/_contributionInstance";
var MedicationStatementAdherenceComponent = "http://hl7.org/fhir/MedicationStatementAdherenceComponent";
var _onAdmission = "http://hl7.org/fhir/_onAdmission";
var output = "http://hl7.org/fhir/output";
var _indication = "http://hl7.org/fhir/_indication";
var DeviceDefinitionChargeItemComponent = "http://hl7.org/fhir/DeviceDefinitionChargeItemComponent";
var location4 = "http://hl7.org/fhir/location";
var generalCost = "http://hl7.org/fhir/generalCost";
var _plannedActivityReference = "http://hl7.org/fhir/_plannedActivityReference";
var rules = "http://hl7.org/fhir/rules";
var reported = "http://hl7.org/fhir/reported";
var maxDosePerDay = "http://hl7.org/fhir/maxDosePerDay";
var NutritionOrderOralDietTextureComponent = "http://hl7.org/fhir/NutritionOrderOralDietTextureComponent";
var _definitionByTypeAndValue = "http://hl7.org/fhir/_definitionByTypeAndValue";
var GroupMemberComponent = "http://hl7.org/fhir/GroupMemberComponent";
var _verificationType = "http://hl7.org/fhir/_verificationType";
var _supportingInformation = "http://hl7.org/fhir/_supportingInformation";
var kingdom = "http://hl7.org/fhir/kingdom";
var sourceMaterialClass = "http://hl7.org/fhir/sourceMaterialClass";
var _polymer = "http://hl7.org/fhir/_polymer";
var insurance = "http://hl7.org/fhir/insurance";
var _handling = "http://hl7.org/fhir/_handling";
var supportingInfo = "http://hl7.org/fhir/supportingInfo";
var lifecycleStatus = "http://hl7.org/fhir/lifecycleStatus";
var _symptomConditionEffect = "http://hl7.org/fhir/_symptomConditionEffect";
var _fraction = "http://hl7.org/fhir/_fraction";
var language3 = "http://hl7.org/fhir/language";
var combining = "http://hl7.org/fhir/combining";
var country = "http://hl7.org/fhir/country";
var isExample = "http://hl7.org/fhir/isExample";
var _readHistory = "http://hl7.org/fhir/_readHistory";
var BundleLinkComponent = "http://hl7.org/fhir/BundleLinkComponent";
var currentLocation = "http://hl7.org/fhir/currentLocation";
var official = "http://hl7.org/fhir/official";
var _EncounterHistory = "http://hl7.org/fhir/_EncounterHistory";
var EvidenceVariableCategoryComponent = "http://hl7.org/fhir/EvidenceVariableCategoryComponent";
var _administeredBy = "http://hl7.org/fhir/_administeredBy";
var _ProductShelfLife = "http://hl7.org/fhir/_ProductShelfLife";
var SubstanceDefinitionMolecularWeightComponent = "http://hl7.org/fhir/SubstanceDefinitionMolecularWeightComponent";
var affectsState = "http://hl7.org/fhir/affectsState";
var notificationShape = "http://hl7.org/fhir/notificationShape";
var descriptionSummary = "http://hl7.org/fhir/descriptionSummary";
var _answerValueSet = "http://hl7.org/fhir/_answerValueSet";
var PractitionerRole = "http://hl7.org/fhir/PractitionerRole";
var _rationale = "http://hl7.org/fhir/_rationale";
var _ChargeItem = "http://hl7.org/fhir/_ChargeItem";
var _offer = "http://hl7.org/fhir/_offer";
var OperationDefinitionParameterReferencedFromComponent = "http://hl7.org/fhir/OperationDefinitionParameterReferencedFromComponent";
var singleUse = "http://hl7.org/fhir/singleUse";
var _exclude = "http://hl7.org/fhir/_exclude";
var fhirVersion = "http://hl7.org/fhir/fhirVersion";
var _nucleicAcid = "http://hl7.org/fhir/_nucleicAcid";
var CodeableConcept = "http://hl7.org/fhir/CodeableConcept";
var _Claim = "http://hl7.org/fhir/_Claim";
var _site = "http://hl7.org/fhir/_site";
var targetScope = "http://hl7.org/fhir/targetScope";
var _monthInterval = "http://hl7.org/fhir/_monthInterval";
var _monitoringProgram = "http://hl7.org/fhir/_monitoringProgram";
var mustHaveValue = "http://hl7.org/fhir/mustHaveValue";
var _interpreter = "http://hl7.org/fhir/_interpreter";
var SubscriptionStatus = "http://hl7.org/fhir/SubscriptionStatus";
var _productOrServiceEnd = "http://hl7.org/fhir/_productOrServiceEnd";
var doseQuantity = "http://hl7.org/fhir/doseQuantity";
var _prism = "http://hl7.org/fhir/_prism";
var highNumerator = "http://hl7.org/fhir/highNumerator";
var contentDefinition = "http://hl7.org/fhir/contentDefinition";
var due2 = "http://hl7.org/fhir/due";
var structureProfile = "http://hl7.org/fhir/structureProfile";
var _acceptLanguage = "http://hl7.org/fhir/_acceptLanguage";
var _RegulatedAuthorization = "http://hl7.org/fhir/_RegulatedAuthorization";
var authorType = "http://hl7.org/fhir/authorType";
var paymentIssuer = "http://hl7.org/fhir/paymentIssuer";
var clinicalTrial = "http://hl7.org/fhir/clinicalTrial";
var _parentSubstanceName = "http://hl7.org/fhir/_parentSubstanceName";
var _high = "http://hl7.org/fhir/_high";
var actorId = "http://hl7.org/fhir/actorId";
var _document = "http://hl7.org/fhir/_document";
var _marketPeriod = "http://hl7.org/fhir/_marketPeriod";
var _denominator = "http://hl7.org/fhir/_denominator";
var accessionIdentifier = "http://hl7.org/fhir/accessionIdentifier";
var VerificationResultPrimarySourceComponent = "http://hl7.org/fhir/VerificationResultPrimarySourceComponent";
var authored = "http://hl7.org/fhir/authored";
var serialNumber = "http://hl7.org/fhir/serialNumber";
var Consent = "http://hl7.org/fhir/Consent";
var _resourceType = "http://hl7.org/fhir/_resourceType";
var outcomeMeasure = "http://hl7.org/fhir/outcomeMeasure";
var purpose = "http://hl7.org/fhir/purpose";
var DiagnosticReportSupportingInfoComponent = "http://hl7.org/fhir/DiagnosticReportSupportingInfoComponent";
var Citation = "http://hl7.org/fhir/Citation";
var _serviced = "http://hl7.org/fhir/_serviced";
var performer = "http://hl7.org/fhir/performer";
var _stratifier = "http://hl7.org/fhir/_stratifier";
var InvoiceParticipantComponent = "http://hl7.org/fhir/InvoiceParticipantComponent";
var requiredBehavior = "http://hl7.org/fhir/requiredBehavior";
var _oralDiet = "http://hl7.org/fhir/_oralDiet";
var monday = "http://hl7.org/fhir/monday";
var MedicationRequestDispenseRequestComponent = "http://hl7.org/fhir/MedicationRequestDispenseRequestComponent";
var _subJurisdiction = "http://hl7.org/fhir/_subJurisdiction";
var _interactant = "http://hl7.org/fhir/_interactant";
var _admitSource = "http://hl7.org/fhir/_admitSource";
var TargetElement = "http://hl7.org/fhir/TargetElement";
var _given = "http://hl7.org/fhir/_given";
var _recorder = "http://hl7.org/fhir/_recorder";
var hasPart2 = "http://hl7.org/fhir/hasPart";
var _cancellationDate = "http://hl7.org/fhir/_cancellationDate";
var supplements = "http://hl7.org/fhir/supplements";
var constraint = "http://hl7.org/fhir/constraint";
var total = "http://hl7.org/fhir/total";
var outcome = "http://hl7.org/fhir/outcome";
var sampleSize = "http://hl7.org/fhir/sampleSize";
var ContributorshipSummary = "http://hl7.org/fhir/ContributorshipSummary";
var PrimitiveType = "http://hl7.org/fhir/PrimitiveType";
var caloricDensity = "http://hl7.org/fhir/caloricDensity";
var MedicationKnowledgeStorageGuidelineEnvironmentalSettingComponent = "http://hl7.org/fhir/MedicationKnowledgeStorageGuidelineEnvironmentalSettingComponent";
var _clinicalUseIssue = "http://hl7.org/fhir/_clinicalUseIssue";
var LinkageItemComponent = "http://hl7.org/fhir/LinkageItemComponent";
var AdministrableProductDefinitionRouteOfAdministrationComponent = "http://hl7.org/fhir/AdministrableProductDefinitionRouteOfAdministrationComponent";
var _conditionalUpdate = "http://hl7.org/fhir/_conditionalUpdate";
var _publisher = "http://hl7.org/fhir/_publisher";
var MolecularSequenceRelativeStartingSequenceComponent = "http://hl7.org/fhir/MolecularSequenceRelativeStartingSequenceComponent";
var _validator = "http://hl7.org/fhir/_validator";
var _inactive = "http://hl7.org/fhir/_inactive";
var AppointmentResponse = "http://hl7.org/fhir/AppointmentResponse";
var _molecularFormula = "http://hl7.org/fhir/_molecularFormula";
var payload = "http://hl7.org/fhir/payload";
var subSite = "http://hl7.org/fhir/subSite";
var _sort = "http://hl7.org/fhir/_sort";
var TestScriptOriginComponent = "http://hl7.org/fhir/TestScriptOriginComponent";
var _allergyIntolerance = "http://hl7.org/fhir/_allergyIntolerance";
var _identityCertificate = "http://hl7.org/fhir/_identityCertificate";
var _additional = "http://hl7.org/fhir/_additional";
var _assurance = "http://hl7.org/fhir/_assurance";
var _careManager = "http://hl7.org/fhir/_careManager";
var ImageRegion2D = "http://hl7.org/fhir/ImageRegion2D";
var forecastReason = "http://hl7.org/fhir/forecastReason";
var supplement = "http://hl7.org/fhir/supplement";
var _nutrient = "http://hl7.org/fhir/_nutrient";
var _sugar = "http://hl7.org/fhir/_sugar";
var entryReference = "http://hl7.org/fhir/entryReference";
var _citedMedium = "http://hl7.org/fhir/_citedMedium";
var MeasureSupplementalDataComponent = "http://hl7.org/fhir/MeasureSupplementalDataComponent";
var input = "http://hl7.org/fhir/input";
var ManufacturedItemDefinition = "http://hl7.org/fhir/ManufacturedItemDefinition";
var Prism = "http://hl7.org/fhir/Prism";
var GroupCharacteristicComponent = "http://hl7.org/fhir/GroupCharacteristicComponent";
var _qualifier = "http://hl7.org/fhir/_qualifier";
var GraphDefinition = "http://hl7.org/fhir/GraphDefinition";
var _BiologicallyDerivedProduct = "http://hl7.org/fhir/_BiologicallyDerivedProduct";
var _Procedure = "http://hl7.org/fhir/_Procedure";
var _receivedTime = "http://hl7.org/fhir/_receivedTime";
var quantity = "http://hl7.org/fhir/quantity";
var _linkId = "http://hl7.org/fhir/_linkId";
var ManufacturedItemDefinitionComponentComponentComponentComponent = "http://hl7.org/fhir/ManufacturedItemDefinitionComponentComponentComponentComponent";
var _prescriber = "http://hl7.org/fhir/_prescriber";
var EvidenceReportSubjectCharacteristicComponent = "http://hl7.org/fhir/EvidenceReportSubjectCharacteristicComponent";
var hasSeverity = "http://hl7.org/fhir/hasSeverity";
var _estimate = "http://hl7.org/fhir/_estimate";
var certainty = "http://hl7.org/fhir/certainty";
var _billingStatus = "http://hl7.org/fhir/_billingStatus";
var ContactDetail = "http://hl7.org/fhir/ContactDetail";
var sessionKey = "http://hl7.org/fhir/sessionKey";
var calibration = "http://hl7.org/fhir/calibration";
var _literal = "http://hl7.org/fhir/_literal";
var ConditionDefinitionQuestionnaireComponent = "http://hl7.org/fhir/ConditionDefinitionQuestionnaireComponent";
var _dateTime = "http://hl7.org/fhir/_dateTime";
var CoverageEligibilityRequest = "http://hl7.org/fhir/CoverageEligibilityRequest";
var _repeatUnitAmountType = "http://hl7.org/fhir/_repeatUnitAmountType";
var pediatricUseIndicator = "http://hl7.org/fhir/pediatricUseIndicator";
var SampledData = "http://hl7.org/fhir/SampledData";
var attester = "http://hl7.org/fhir/attester";
var originatingAppointment = "http://hl7.org/fhir/originatingAppointment";
var progress = "http://hl7.org/fhir/progress";
var _frequencyMax = "http://hl7.org/fhir/_frequencyMax";
var measureScore = "http://hl7.org/fhir/measureScore";
var InsurancePlanCoverageComponent = "http://hl7.org/fhir/InsurancePlanCoverageComponent";
var Evidence = "http://hl7.org/fhir/Evidence";
var _operationalStatus = "http://hl7.org/fhir/_operationalStatus";
var ImagingSelectionPerformerComponent = "http://hl7.org/fhir/ImagingSelectionPerformerComponent";
var restriction = "http://hl7.org/fhir/restriction";
var _issues = "http://hl7.org/fhir/_issues";
var dose = "http://hl7.org/fhir/dose";
var _updateCreate = "http://hl7.org/fhir/_updateCreate";
var _supportingInfo = "http://hl7.org/fhir/_supportingInfo";
var warningOnly = "http://hl7.org/fhir/warningOnly";
var _coverage = "http://hl7.org/fhir/_coverage";
var informationSequence = "http://hl7.org/fhir/informationSequence";
var netContent = "http://hl7.org/fhir/netContent";
var representation = "http://hl7.org/fhir/representation";
var _typeMode = "http://hl7.org/fhir/_typeMode";
var subProperty = "http://hl7.org/fhir/subProperty";
var _subscription = "http://hl7.org/fhir/_subscription";
var Library = "http://hl7.org/fhir/Library";
var DeviceMetricCalibrationComponent = "http://hl7.org/fhir/DeviceMetricCalibrationComponent";
var implicated = "http://hl7.org/fhir/implicated";
var _actualGroup = "http://hl7.org/fhir/_actualGroup";
var _SubstanceProtein = "http://hl7.org/fhir/_SubstanceProtein";
var _capabilities = "http://hl7.org/fhir/_capabilities";
var _associatedParty = "http://hl7.org/fhir/_associatedParty";
var _supplementalData = "http://hl7.org/fhir/_supplementalData";
var _program = "http://hl7.org/fhir/_program";
var offeredIn = "http://hl7.org/fhir/offeredIn";
var TerminologyCapabilitiesCodeSystemComponent = "http://hl7.org/fhir/TerminologyCapabilitiesCodeSystemComponent";
var multipleBirth = "http://hl7.org/fhir/multipleBirth";
var _replacedSequence = "http://hl7.org/fhir/_replacedSequence";
var disclaimer = "http://hl7.org/fhir/disclaimer";
var InsurancePlan = "http://hl7.org/fhir/InsurancePlan";
var _installDate = "http://hl7.org/fhir/_installDate";
var _extends = "http://hl7.org/fhir/_extends";
var fundsReserve = "http://hl7.org/fhir/fundsReserve";
var assigner = "http://hl7.org/fhir/assigner";
var SpecimenProcessingComponent = "http://hl7.org/fhir/SpecimenProcessingComponent";
var occurred = "http://hl7.org/fhir/occurred";
var _lockedDate = "http://hl7.org/fhir/_lockedDate";
var GenomicStudyAnalysisPerformerComponent = "http://hl7.org/fhir/GenomicStudyAnalysisPerformerComponent";
var _lowNumerator = "http://hl7.org/fhir/_lowNumerator";
var _classifier = "http://hl7.org/fhir/_classifier";
var resultsInterpreter = "http://hl7.org/fhir/resultsInterpreter";
var _limit = "http://hl7.org/fhir/_limit";
var _serviceProvider = "http://hl7.org/fhir/_serviceProvider";
var patientInstruction = "http://hl7.org/fhir/patientInstruction";
var binding = "http://hl7.org/fhir/binding";
var recurrenceType = "http://hl7.org/fhir/recurrenceType";
var during = "http://hl7.org/fhir/during";
var capability = "http://hl7.org/fhir/capability";
var Substance = "http://hl7.org/fhir/Substance";
var suspectEntity = "http://hl7.org/fhir/suspectEntity";
var QuestionnaireItemInitialComponent = "http://hl7.org/fhir/QuestionnaireItemInitialComponent";
var occurrenceDate = "http://hl7.org/fhir/occurrenceDate";
var monthlyTemplate = "http://hl7.org/fhir/monthlyTemplate";
var supportingInformation = "http://hl7.org/fhir/supportingInformation";
var authorizationRequired = "http://hl7.org/fhir/authorizationRequired";
var _versionReference = "http://hl7.org/fhir/_versionReference";
var ImmunizationRecommendationRecommendationComponent = "http://hl7.org/fhir/ImmunizationRecommendationRecommendationComponent";
var _measurementPoint = "http://hl7.org/fhir/_measurementPoint";
var batch = "http://hl7.org/fhir/batch";
var _include = "http://hl7.org/fhir/_include";
var ValueSetComposeIncludeFilterComponent = "http://hl7.org/fhir/ValueSetComposeIncludeFilterComponent";
var subcomponent = "http://hl7.org/fhir/subcomponent";
var _DetectedIssue = "http://hl7.org/fhir/_DetectedIssue";
var _GuidanceResponse = "http://hl7.org/fhir/_GuidanceResponse";
var _participantType = "http://hl7.org/fhir/_participantType";
var _division = "http://hl7.org/fhir/_division";
var _section = "http://hl7.org/fhir/_section";
var _MedicationAdministration = "http://hl7.org/fhir/_MedicationAdministration";
var _outcomeMeasure = "http://hl7.org/fhir/_outcomeMeasure";
var PackagingDistributor = "http://hl7.org/fhir/PackagingDistributor";
var _serviceType = "http://hl7.org/fhir/_serviceType";
var _subjectReport = "http://hl7.org/fhir/_subjectReport";
var _initialFill = "http://hl7.org/fhir/_initialFill";
var _administrableDoseForm = "http://hl7.org/fhir/_administrableDoseForm";
var areaOfHybridisation = "http://hl7.org/fhir/areaOfHybridisation";
var subjectType = "http://hl7.org/fhir/subjectType";
var device = "http://hl7.org/fhir/device";
var AddedItem = "http://hl7.org/fhir/AddedItem";
var _region = "http://hl7.org/fhir/_region";
var MedicationKnowledgeRegulatorySubstitutionComponent = "http://hl7.org/fhir/MedicationKnowledgeRegulatorySubstitutionComponent";
var MeasureReportGroupComponent = "http://hl7.org/fhir/MeasureReportGroupComponent";
var _accident = "http://hl7.org/fhir/_accident";
var endRelationship = "http://hl7.org/fhir/endRelationship";
var structure = "http://hl7.org/fhir/structure";
var _library = "http://hl7.org/fhir/_library";
var _descriptionSummary = "http://hl7.org/fhir/_descriptionSummary";
var baseCitation = "http://hl7.org/fhir/baseCitation";
var definitionId = "http://hl7.org/fhir/definitionId";
var _coordinateSystem = "http://hl7.org/fhir/_coordinateSystem";
var characteristicType = "http://hl7.org/fhir/characteristicType";
var _entry = "http://hl7.org/fhir/_entry";
var imageRegion2D = "http://hl7.org/fhir/imageRegion2D";
var _DeviceDefinition = "http://hl7.org/fhir/_DeviceDefinition";
var conclusionCode = "http://hl7.org/fhir/conclusionCode";
var BiologicallyDerivedProductDispensePerformerComponent = "http://hl7.org/fhir/BiologicallyDerivedProductDispensePerformerComponent";
var _caloricDensity = "http://hl7.org/fhir/_caloricDensity";
var ManufacturedItemDefinitionComponentComponent = "http://hl7.org/fhir/ManufacturedItemDefinitionComponentComponent";
var _focal = "http://hl7.org/fhir/_focal";
var indication = "http://hl7.org/fhir/indication";
var _AllergyIntolerance = "http://hl7.org/fhir/_AllergyIntolerance";
var _publishedIn = "http://hl7.org/fhir/_publishedIn";
var partOf = "http://hl7.org/fhir/partOf";
var _initialSelected = "http://hl7.org/fhir/_initialSelected";
var _key = "http://hl7.org/fhir/_key";
var backCurve = "http://hl7.org/fhir/backCurve";
var _path = "http://hl7.org/fhir/_path";
var definitionUri = "http://hl7.org/fhir/definitionUri";
var ExplanationOfBenefitItemReviewOutcomeComponent = "http://hl7.org/fhir/ExplanationOfBenefitItemReviewOutcomeComponent";
var DetectedIssueMitigationComponent = "http://hl7.org/fhir/DetectedIssueMitigationComponent";
var _lastOccurrenceDate = "http://hl7.org/fhir/_lastOccurrenceDate";
var _enableWhen = "http://hl7.org/fhir/_enableWhen";
var time = "http://hl7.org/fhir/time";
var MedicinalProductDefinitionNameUsageComponent = "http://hl7.org/fhir/MedicinalProductDefinitionNameUsageComponent";
var ChargeItemDefinitionApplicabilityComponent = "http://hl7.org/fhir/ChargeItemDefinitionApplicabilityComponent";
var InventoryItemCharacteristicComponent = "http://hl7.org/fhir/InventoryItemCharacteristicComponent";
var _dischargeDisposition = "http://hl7.org/fhir/_dischargeDisposition";
var isModifierReason = "http://hl7.org/fhir/isModifierReason";
var StructureDefinitionContextComponent = "http://hl7.org/fhir/StructureDefinitionContextComponent";
var _forecastReason = "http://hl7.org/fhir/_forecastReason";
var SubstanceDefinitionMoietyComponent = "http://hl7.org/fhir/SubstanceDefinitionMoietyComponent";
var _step = "http://hl7.org/fhir/_step";
var rest = "http://hl7.org/fhir/rest";
var issuer = "http://hl7.org/fhir/issuer";
var _nutritionProduct = "http://hl7.org/fhir/_nutritionProduct";
var SubstancePolymer = "http://hl7.org/fhir/SubstancePolymer";
var ValueSetComposeComponent = "http://hl7.org/fhir/ValueSetComposeComponent";
var _doseNumber = "http://hl7.org/fhir/_doseNumber";
var SubstanceDefinitionNameComponent = "http://hl7.org/fhir/SubstanceDefinitionNameComponent";
var derivedFromUri = "http://hl7.org/fhir/derivedFromUri";
var _startParam = "http://hl7.org/fhir/_startParam";
var _attribute = "http://hl7.org/fhir/_attribute";
var _extraDetails = "http://hl7.org/fhir/_extraDetails";
var _accessionIdentifier = "http://hl7.org/fhir/_accessionIdentifier";
var _entryReference = "http://hl7.org/fhir/_entryReference";
var Parameters = "http://hl7.org/fhir/Parameters";
var ChargeItem = "http://hl7.org/fhir/ChargeItem";
var _uid = "http://hl7.org/fhir/_uid";
var chain = "http://hl7.org/fhir/chain";
var _bodySite = "http://hl7.org/fhir/_bodySite";
var qualification = "http://hl7.org/fhir/qualification";
var yearInterval = "http://hl7.org/fhir/yearInterval";
var _developmentStage = "http://hl7.org/fhir/_developmentStage";
var riskAdjustment = "http://hl7.org/fhir/riskAdjustment";
var _estimatedAge = "http://hl7.org/fhir/_estimatedAge";
var RequirementsStatementComponent = "http://hl7.org/fhir/RequirementsStatementComponent";
var _intendedRoute = "http://hl7.org/fhir/_intendedRoute";
var score = "http://hl7.org/fhir/score";
var DeviceRequestParameterComponent = "http://hl7.org/fhir/DeviceRequestParameterComponent";
var _diseaseSymptomProcedure = "http://hl7.org/fhir/_diseaseSymptomProcedure";
var _validationProcess = "http://hl7.org/fhir/_validationProcess";
var ExampleScenarioProcessComponent = "http://hl7.org/fhir/ExampleScenarioProcessComponent";
var _timestamp = "http://hl7.org/fhir/_timestamp";
var supportedProfile = "http://hl7.org/fhir/supportedProfile";
var TestReportSetupActionAssertComponent = "http://hl7.org/fhir/TestReportSetupActionAssertComponent";
var _label = "http://hl7.org/fhir/_label";
var _preparationInstruction = "http://hl7.org/fhir/_preparationInstruction";
var InventoryItemResponsibleOrganizationComponent = "http://hl7.org/fhir/InventoryItemResponsibleOrganizationComponent";
var informationType = "http://hl7.org/fhir/informationType";
var BodyStructureIncludedStructure = "http://hl7.org/fhir/BodyStructureIncludedStructure";
var _requesterLinkId = "http://hl7.org/fhir/_requesterLinkId";
var PlanDefinition = "http://hl7.org/fhir/PlanDefinition";
var postConditions = "http://hl7.org/fhir/postConditions";
var EvidenceVariableDefinitionComponent = "http://hl7.org/fhir/EvidenceVariableDefinitionComponent";
var _meaningWhenMissing = "http://hl7.org/fhir/_meaningWhenMissing";
var DeviceDispense = "http://hl7.org/fhir/DeviceDispense";
var _modelCharacteristic = "http://hl7.org/fhir/_modelCharacteristic";
var SetupAction = "http://hl7.org/fhir/SetupAction";
var _studyDesign = "http://hl7.org/fhir/_studyDesign";
var _analysis = "http://hl7.org/fhir/_analysis";
var insurancePlan = "http://hl7.org/fhir/insurancePlan";
var communicationRequest = "http://hl7.org/fhir/communicationRequest";
var specialty = "http://hl7.org/fhir/specialty";
var _artifact = "http://hl7.org/fhir/_artifact";
var chargeItemCode = "http://hl7.org/fhir/chargeItemCode";
var actuality = "http://hl7.org/fhir/actuality";
var _maxParticipants = "http://hl7.org/fhir/_maxParticipants";
var _Basic = "http://hl7.org/fhir/_Basic";
var _example = "http://hl7.org/fhir/_example";
var _representation = "http://hl7.org/fhir/_representation";
var telecom = "http://hl7.org/fhir/telecom";
var EvidenceCertaintyComponentCertaintyCertainty = "http://hl7.org/fhir/EvidenceCertaintyComponentCertaintyCertainty";
var _lastPerformed = "http://hl7.org/fhir/_lastPerformed";
var _legalState = "http://hl7.org/fhir/_legalState";
var _preAuthPeriod = "http://hl7.org/fhir/_preAuthPeriod";
var GraphDefinitionLinkComponent = "http://hl7.org/fhir/GraphDefinitionLinkComponent";
var workflow = "http://hl7.org/fhir/workflow";
var _incomplete = "http://hl7.org/fhir/_incomplete";
var _sphere = "http://hl7.org/fhir/_sphere";
var _substanceDefinition = "http://hl7.org/fhir/_substanceDefinition";
var informationSource = "http://hl7.org/fhir/informationSource";
var _periodUnit = "http://hl7.org/fhir/_periodUnit";
var paymentIdentifier = "http://hl7.org/fhir/paymentIdentifier";
var stratifier = "http://hl7.org/fhir/stratifier";
var pause = "http://hl7.org/fhir/pause";
var _isActive = "http://hl7.org/fhir/_isActive";
var _synonym = "http://hl7.org/fhir/_synonym";
var _manifestation = "http://hl7.org/fhir/_manifestation";
var _control = "http://hl7.org/fhir/_control";
var RegulatedAuthorizationCaseComponentCase = "http://hl7.org/fhir/RegulatedAuthorizationCaseComponentCase";
var dosageInstruction = "http://hl7.org/fhir/dosageInstruction";
var _implicitRules = "http://hl7.org/fhir/_implicitRules";
var AvailabilityAvailableTimeComponent = "http://hl7.org/fhir/AvailabilityAvailableTimeComponent";
var SpecimenCollectionComponent = "http://hl7.org/fhir/SpecimenCollectionComponent";
var regulatoryAuthority = "http://hl7.org/fhir/regulatoryAuthority";
var _EnrollmentRequest = "http://hl7.org/fhir/_EnrollmentRequest";
var hash = "http://hl7.org/fhir/hash";
var marketDistribution = "http://hl7.org/fhir/marketDistribution";
var countType = "http://hl7.org/fhir/countType";
var _documentation = "http://hl7.org/fhir/_documentation";
var association = "http://hl7.org/fhir/association";
var _intendedJurisdiction = "http://hl7.org/fhir/_intendedJurisdiction";
var _recurrenceType = "http://hl7.org/fhir/_recurrenceType";
var when = "http://hl7.org/fhir/when";
var form = "http://hl7.org/fhir/form";
var _complete = "http://hl7.org/fhir/_complete";
var _shortDoco = "http://hl7.org/fhir/_shortDoco";
var differential = "http://hl7.org/fhir/differential";
var _occurrenceDate = "http://hl7.org/fhir/_occurrenceDate";
var additional = "http://hl7.org/fhir/additional";
var canonical = "http://hl7.org/fhir/canonical";
var _actualComparisonGroup = "http://hl7.org/fhir/_actualComparisonGroup";
var _requestor = "http://hl7.org/fhir/_requestor";
var CommunicationPayloadComponent = "http://hl7.org/fhir/CommunicationPayloadComponent";
var AccountDiagnosisComponent = "http://hl7.org/fhir/AccountDiagnosisComponent";
var _doseStatus = "http://hl7.org/fhir/_doseStatus";
var TestScriptTestComponent = "http://hl7.org/fhir/TestScriptTestComponent";
var TaskOutputComponent = "http://hl7.org/fhir/TaskOutputComponent";
var MeasureReport = "http://hl7.org/fhir/MeasureReport";
var producedFrom = "http://hl7.org/fhir/producedFrom";
var tuesday = "http://hl7.org/fhir/tuesday";
var _sourceReference = "http://hl7.org/fhir/_sourceReference";
var crossReference = "http://hl7.org/fhir/crossReference";
var _Composition = "http://hl7.org/fhir/_Composition";
var subdetailSequence = "http://hl7.org/fhir/subdetailSequence";
var _definitionReference = "http://hl7.org/fhir/_definitionReference";
var supplier = "http://hl7.org/fhir/supplier";
var inputPopulationId = "http://hl7.org/fhir/inputPopulationId";
var CarePlan = "http://hl7.org/fhir/CarePlan";
var clinicalStatus = "http://hl7.org/fhir/clinicalStatus";
var measurementType = "http://hl7.org/fhir/measurementType";
var ImplementationGuideDefinitionGroupingComponent = "http://hl7.org/fhir/ImplementationGuideDefinitionGroupingComponent";
var _fundingSource = "http://hl7.org/fhir/_fundingSource";
var _immunizationEvent = "http://hl7.org/fhir/_immunizationEvent";
var ClaimResponseEventComponent = "http://hl7.org/fhir/ClaimResponseEventComponent";
var statement = "http://hl7.org/fhir/statement";
var ImageRegion3D = "http://hl7.org/fhir/ImageRegion3D";
var _item = "http://hl7.org/fhir/_item";
var _repeatUnit = "http://hl7.org/fhir/_repeatUnit";
var startingMaterial = "http://hl7.org/fhir/startingMaterial";
var _temperatureQualifier = "http://hl7.org/fhir/_temperatureQualifier";
var dosingGuideline = "http://hl7.org/fhir/dosingGuideline";
var _serviceCategory = "http://hl7.org/fhir/_serviceCategory";
var _rate = "http://hl7.org/fhir/_rate";
var _filterDefinition = "http://hl7.org/fhir/_filterDefinition";
var prescriber = "http://hl7.org/fhir/prescriber";
var oid = "http://hl7.org/fhir/oid";
var _attachment = "http://hl7.org/fhir/_attachment";
var _sourceAttachment = "http://hl7.org/fhir/_sourceAttachment";
var _materialType = "http://hl7.org/fhir/_materialType";
var target2 = "http://hl7.org/fhir/target";
var _valueCategory = "http://hl7.org/fhir/_valueCategory";
var _requestMethod = "http://hl7.org/fhir/_requestMethod";
var linkage = "http://hl7.org/fhir/linkage";
var DeviceUdiCarrierComponent = "http://hl7.org/fhir/DeviceUdiCarrierComponent";
var TerminologyCapabilitiesClosureComponent = "http://hl7.org/fhir/TerminologyCapabilitiesClosureComponent";
var _conclusionCode = "http://hl7.org/fhir/_conclusionCode";
var _div = "http://hl7.org/fhir/_div";
var processingMode = "http://hl7.org/fhir/processingMode";
var _rule = "http://hl7.org/fhir/_rule";
var StructureMap = "http://hl7.org/fhir/StructureMap";
var _molecularFormulaByMoiety = "http://hl7.org/fhir/_molecularFormulaByMoiety";
var firstDose = "http://hl7.org/fhir/firstDose";
var BundleEntryResponseComponent = "http://hl7.org/fhir/BundleEntryResponseComponent";
var structureVersion = "http://hl7.org/fhir/structureVersion";
var alias = "http://hl7.org/fhir/alias";
var _programCode = "http://hl7.org/fhir/_programCode";
var _resultForDelete = "http://hl7.org/fhir/_resultForDelete";
var grantee = "http://hl7.org/fhir/grantee";
var _effectiveTime = "http://hl7.org/fhir/_effectiveTime";
var definitionCodeableConcept = "http://hl7.org/fhir/definitionCodeableConcept";
var Property = "http://hl7.org/fhir/Property";
var entryClassifier = "http://hl7.org/fhir/entryClassifier";
var _combining = "http://hl7.org/fhir/_combining";
var paternalOrganismName = "http://hl7.org/fhir/paternalOrganismName";
var _asset = "http://hl7.org/fhir/_asset";
var PaymentReconciliationAllocationComponent = "http://hl7.org/fhir/PaymentReconciliationAllocationComponent";
var _part = "http://hl7.org/fhir/_part";
var actor2 = "http://hl7.org/fhir/actor";
var _isExample = "http://hl7.org/fhir/_isExample";
var navigationLinks = "http://hl7.org/fhir/navigationLinks";
var availability = "http://hl7.org/fhir/availability";
var _specimen = "http://hl7.org/fhir/_specimen";
var term = "http://hl7.org/fhir/term";
var notAvailableTime = "http://hl7.org/fhir/notAvailableTime";
var specimenRequirement = "http://hl7.org/fhir/specimenRequirement";
var answer = "http://hl7.org/fhir/answer";
var _citation = "http://hl7.org/fhir/_citation";
var patient = "http://hl7.org/fhir/patient";
var suppress = "http://hl7.org/fhir/suppress";
var additionalUse = "http://hl7.org/fhir/additionalUse";
var _maxDosePerLifetime = "http://hl7.org/fhir/_maxDosePerLifetime";
var Distance = "http://hl7.org/fhir/Distance";
var _primarySource = "http://hl7.org/fhir/_primarySource";
var _opticalActivity = "http://hl7.org/fhir/_opticalActivity";
var _multipleOr = "http://hl7.org/fhir/_multipleOr";
var _specialMeasures = "http://hl7.org/fhir/_specialMeasures";
var usageReason = "http://hl7.org/fhir/usageReason";
var GoalTargetComponent = "http://hl7.org/fhir/GoalTargetComponent";
var measure = "http://hl7.org/fhir/measure";
var contributionType = "http://hl7.org/fhir/contributionType";
var modelNumber = "http://hl7.org/fhir/modelNumber";
var _derivedFromUri = "http://hl7.org/fhir/_derivedFromUri";
var _method = "http://hl7.org/fhir/_method";
var effectiveDate = "http://hl7.org/fhir/effectiveDate";
var _servicePeriod = "http://hl7.org/fhir/_servicePeriod";
var asNeededFor = "http://hl7.org/fhir/asNeededFor";
var ExplanationOfBenefit = "http://hl7.org/fhir/ExplanationOfBenefit";
var _add = "http://hl7.org/fhir/_add";
var _cancelledReason = "http://hl7.org/fhir/_cancelledReason";
var orderMeaning = "http://hl7.org/fhir/orderMeaning";
var testCase = "http://hl7.org/fhir/testCase";
var net = "http://hl7.org/fhir/net";
var VerificationResultAttestationComponent = "http://hl7.org/fhir/VerificationResultAttestationComponent";
var _class = "http://hl7.org/fhir/_class";
var claim = "http://hl7.org/fhir/claim";
var Flag2 = "http://hl7.org/fhir/Flag";
var _riskAdjustment = "http://hl7.org/fhir/_riskAdjustment";
var _compareToSourceExpression = "http://hl7.org/fhir/_compareToSourceExpression";
var _notificationEvent = "http://hl7.org/fhir/_notificationEvent";
var guideline = "http://hl7.org/fhir/guideline";
var amount = "http://hl7.org/fhir/amount";
var _dateFilter = "http://hl7.org/fhir/_dateFilter";
var _statisticType = "http://hl7.org/fhir/_statisticType";
var genus = "http://hl7.org/fhir/genus";
var _MessageHeader = "http://hl7.org/fhir/_MessageHeader";
var _administrationTreatment = "http://hl7.org/fhir/_administrationTreatment";
var _country = "http://hl7.org/fhir/_country";
var insurer = "http://hl7.org/fhir/insurer";
var DeviceDefinitionLinkComponent = "http://hl7.org/fhir/DeviceDefinitionLinkComponent";
var container = "http://hl7.org/fhir/container";
var _params = "http://hl7.org/fhir/_params";
var Goal = "http://hl7.org/fhir/Goal";
var lockedDate = "http://hl7.org/fhir/lockedDate";
var symptomConditionEffect = "http://hl7.org/fhir/symptomConditionEffect";
var referenceStrength = "http://hl7.org/fhir/referenceStrength";
var interval = "http://hl7.org/fhir/interval";
var _compartment = "http://hl7.org/fhir/_compartment";
var classifier = "http://hl7.org/fhir/classifier";
var PackagedProductDefinitionPackagingPropertyComponent = "http://hl7.org/fhir/PackagedProductDefinitionPackagingPropertyComponent";
var setup = "http://hl7.org/fhir/setup";
var _areaOfHybridisation = "http://hl7.org/fhir/_areaOfHybridisation";
var maxLength = "http://hl7.org/fhir/maxLength";
var publisherLocation = "http://hl7.org/fhir/publisherLocation";
var RelatedPerson = "http://hl7.org/fhir/RelatedPerson";
var _storageTempRequirements = "http://hl7.org/fhir/_storageTempRequirements";
var _Organization = "http://hl7.org/fhir/_Organization";
var _postConditions = "http://hl7.org/fhir/_postConditions";
var _DeviceDispense = "http://hl7.org/fhir/_DeviceDispense";
var state = "http://hl7.org/fhir/state";
var SubstanceDefinitionSourceMaterialComponent = "http://hl7.org/fhir/SubstanceDefinitionSourceMaterialComponent";
var _aggregate = "http://hl7.org/fhir/_aggregate";
var fluidConsistencyType = "http://hl7.org/fhir/fluidConsistencyType";
var MoneyQuantity = "http://hl7.org/fhir/MoneyQuantity";
var _specificCost = "http://hl7.org/fhir/_specificCost";
var _organismId = "http://hl7.org/fhir/_organismId";
var StructureMapGroupInputComponent = "http://hl7.org/fhir/StructureMapGroupInputComponent";
var _check = "http://hl7.org/fhir/_check";
var _chargeItemCode = "http://hl7.org/fhir/_chargeItemCode";
var ownedBy = "http://hl7.org/fhir/ownedBy";
var _participantStatus = "http://hl7.org/fhir/_participantStatus";
var _baseFormulaType = "http://hl7.org/fhir/_baseFormulaType";
var shelfLifeStorage = "http://hl7.org/fhir/shelfLifeStorage";
var authorizingPrescription = "http://hl7.org/fhir/authorizingPrescription";
var protein = "http://hl7.org/fhir/protein";
var connectivity = "http://hl7.org/fhir/connectivity";
var information = "http://hl7.org/fhir/information";
var DeviceDefinitionVersionComponent = "http://hl7.org/fhir/DeviceDefinitionVersionComponent";
var AdverseEvent = "http://hl7.org/fhir/AdverseEvent";
var _originRelationshipType = "http://hl7.org/fhir/_originRelationshipType";
var definitionExpression = "http://hl7.org/fhir/definitionExpression";
var ServiceRequestOrderDetailParameterComponent = "http://hl7.org/fhir/ServiceRequestOrderDetailParameterComponent";
var TestPlan = "http://hl7.org/fhir/TestPlan";
var requestProvider = "http://hl7.org/fhir/requestProvider";
var _formatted = "http://hl7.org/fhir/_formatted";
var NutritionProduct = "http://hl7.org/fhir/NutritionProduct";
var ActorDefinition = "http://hl7.org/fhir/ActorDefinition";
var RegulatedAuthorization = "http://hl7.org/fhir/RegulatedAuthorization";
var _facility = "http://hl7.org/fhir/_facility";
var sourceDocument = "http://hl7.org/fhir/sourceDocument";
var _morphology = "http://hl7.org/fhir/_morphology";
var _kind = "http://hl7.org/fhir/_kind";
var color = "http://hl7.org/fhir/color";
var _bounds = "http://hl7.org/fhir/_bounds";
var snapshot = "http://hl7.org/fhir/snapshot";
var SpecimenContainerComponent = "http://hl7.org/fhir/SpecimenContainerComponent";
var unsignedInt = "http://hl7.org/fhir/unsignedInt";
var MedicationKnowledgeMedicineClassificationComponent = "http://hl7.org/fhir/MedicationKnowledgeMedicineClassificationComponent";
var ImmunizationProgramEligibilityComponent = "http://hl7.org/fhir/ImmunizationProgramEligibilityComponent";
var _dose = "http://hl7.org/fhir/_dose";
var useBy = "http://hl7.org/fhir/useBy";
var _start = "http://hl7.org/fhir/_start";
var _import = "http://hl7.org/fhir/_import";
var TaskPerformerComponent = "http://hl7.org/fhir/TaskPerformerComponent";
var grantor = "http://hl7.org/fhir/grantor";
var _purpose = "http://hl7.org/fhir/_purpose";
var benefit = "http://hl7.org/fhir/benefit";
var contributorship = "http://hl7.org/fhir/contributorship";
var PlanDefinitionActionDynamicValueComponent = "http://hl7.org/fhir/PlanDefinitionActionDynamicValueComponent";
var ImagingStudySeriesComponent = "http://hl7.org/fhir/ImagingStudySeriesComponent";
var programStatus = "http://hl7.org/fhir/programStatus";
var _evidence = "http://hl7.org/fhir/_evidence";
var ClinicalUseDefinitionInteractionInteractantComponent = "http://hl7.org/fhir/ClinicalUseDefinitionInteractionInteractantComponent";
var _highNumerator = "http://hl7.org/fhir/_highNumerator";
var ChargeItemDefinitionPropertyGroupComponent = "http://hl7.org/fhir/ChargeItemDefinitionPropertyGroupComponent";
var boolean = "http://hl7.org/fhir/boolean";
var PackagedProductDefinitionProperty = "http://hl7.org/fhir/PackagedProductDefinitionProperty";
var _Group = "http://hl7.org/fhir/_Group";
var _media = "http://hl7.org/fhir/_media";
var hasStage = "http://hl7.org/fhir/hasStage";
var TestReportSetupActionAssertRequirementComponent = "http://hl7.org/fhir/TestReportSetupActionAssertRequirementComponent";
var _onBehalfOf = "http://hl7.org/fhir/_onBehalfOf";
var SubstanceReferenceInformationGeneElementComponent = "http://hl7.org/fhir/SubstanceReferenceInformationGeneElementComponent";
var maxCount = "http://hl7.org/fhir/maxCount";
var enableWhen = "http://hl7.org/fhir/enableWhen";
var regulator = "http://hl7.org/fhir/regulator";
var _medicineClassification = "http://hl7.org/fhir/_medicineClassification";
var imageRegion3D = "http://hl7.org/fhir/imageRegion3D";
var _source = "http://hl7.org/fhir/_source";
var _hoursOfOperation = "http://hl7.org/fhir/_hoursOfOperation";
var admission = "http://hl7.org/fhir/admission";
var extension = "http://hl7.org/fhir/extension";
var _reAdmission = "http://hl7.org/fhir/_reAdmission";
var integer64 = "http://hl7.org/fhir/integer64";
var _Task = "http://hl7.org/fhir/_Task";
var HealthcareService = "http://hl7.org/fhir/HealthcareService";
var _Appointment = "http://hl7.org/fhir/_Appointment";
var _crossReference = "http://hl7.org/fhir/_crossReference";
var _hasPart = "http://hl7.org/fhir/_hasPart";
var _executionPeriod = "http://hl7.org/fhir/_executionPeriod";
var Expression = "http://hl7.org/fhir/Expression";
var Class = "http://hl7.org/fhir/Class";
var _operation = "http://hl7.org/fhir/_operation";
var _adjustmentReason = "http://hl7.org/fhir/_adjustmentReason";
var notConsumed = "http://hl7.org/fhir/notConsumed";
var relativePath = "http://hl7.org/fhir/relativePath";
var ImplementationGuideDefinitionComponent = "http://hl7.org/fhir/ImplementationGuideDefinitionComponent";
var geneSequenceOrigin = "http://hl7.org/fhir/geneSequenceOrigin";
var level = "http://hl7.org/fhir/level";
var TestReportTestComponent = "http://hl7.org/fhir/TestReportTestComponent";
var doseNumber = "http://hl7.org/fhir/doseNumber";
var ParametersParameterComponentParameterParameter = "http://hl7.org/fhir/ParametersParameterComponentParameterParameter";
var age = "http://hl7.org/fhir/age";
var _payload = "http://hl7.org/fhir/_payload";
var entityRelatedness = "http://hl7.org/fhir/entityRelatedness";
var startParam = "http://hl7.org/fhir/startParam";
var _intraspecificDescription = "http://hl7.org/fhir/_intraspecificDescription";
var _clinicalStatus = "http://hl7.org/fhir/_clinicalStatus";
var _compositeScoring = "http://hl7.org/fhir/_compositeScoring";
var jurisdiction = "http://hl7.org/fhir/jurisdiction";
var Exemption = "http://hl7.org/fhir/Exemption";
var _requestHeader = "http://hl7.org/fhir/_requestHeader";
var _certainty = "http://hl7.org/fhir/_certainty";
var connectionType = "http://hl7.org/fhir/connectionType";
var _groupingBehavior = "http://hl7.org/fhir/_groupingBehavior";
var _translations = "http://hl7.org/fhir/_translations";
var photo = "http://hl7.org/fhir/photo";
var multipleAnd = "http://hl7.org/fhir/multipleAnd";
var _gender = "http://hl7.org/fhir/_gender";
var _coding = "http://hl7.org/fhir/_coding";
var _system = "http://hl7.org/fhir/_system";
var _Slot = "http://hl7.org/fhir/_Slot";
var freeToShare = "http://hl7.org/fhir/freeToShare";
var ElementDefinitionMappingComponent = "http://hl7.org/fhir/ElementDefinitionMappingComponent";
var copackagedIndicator = "http://hl7.org/fhir/copackagedIndicator";
var precheckBehavior = "http://hl7.org/fhir/precheckBehavior";
var map2 = "http://hl7.org/fhir/map";
var additionalInfo = "http://hl7.org/fhir/additionalInfo";
var preConditions = "http://hl7.org/fhir/preConditions";
var numberOfSubunits = "http://hl7.org/fhir/numberOfSubunits";
var numberOfEvents = "http://hl7.org/fhir/numberOfEvents";
var _sender = "http://hl7.org/fhir/_sender";
var _validCodedValueSet = "http://hl7.org/fhir/_validCodedValueSet";
var _referenceInformation = "http://hl7.org/fhir/_referenceInformation";
var longitude2 = "http://hl7.org/fhir/longitude";
var _contentDerivative = "http://hl7.org/fhir/_contentDerivative";
var _reportedDateTime = "http://hl7.org/fhir/_reportedDateTime";
var Primitive = "http://hl7.org/fhir/Primitive";
var _processingMode = "http://hl7.org/fhir/_processingMode";
var _composition = "http://hl7.org/fhir/_composition";
var _width = "http://hl7.org/fhir/_width";
var _valueAlternatives = "http://hl7.org/fhir/_valueAlternatives";
var hint = "http://hl7.org/fhir/hint";
var license2 = "http://hl7.org/fhir/license";
var created3 = "http://hl7.org/fhir/created";
var expectedInResearchStudy = "http://hl7.org/fhir/expectedInResearchStudy";
var originalPrescription = "http://hl7.org/fhir/originalPrescription";
var scoring = "http://hl7.org/fhir/scoring";
var ClinicalUseDefinitionInteractionComponent = "http://hl7.org/fhir/ClinicalUseDefinitionInteractionComponent";
var PlanDefinitionActorComponent = "http://hl7.org/fhir/PlanDefinitionActorComponent";
var subjectStatus = "http://hl7.org/fhir/subjectStatus";
var _qualitativeRisk = "http://hl7.org/fhir/_qualitativeRisk";
var _header = "http://hl7.org/fhir/_header";
var recurrenceId2 = "http://hl7.org/fhir/recurrenceId";
var _author = "http://hl7.org/fhir/_author";
var responsibleOrganization = "http://hl7.org/fhir/responsibleOrganization";
var TriggerDefinition = "http://hl7.org/fhir/TriggerDefinition";
var _BackboneElement = "http://hl7.org/fhir/_BackboneElement";
var _offeredIn = "http://hl7.org/fhir/_offeredIn";
var _accessionNumber = "http://hl7.org/fhir/_accessionNumber";
var legalState = "http://hl7.org/fhir/legalState";
var incomplete = "http://hl7.org/fhir/incomplete";
var CodeableReference = "http://hl7.org/fhir/CodeableReference";
var activity = "http://hl7.org/fhir/activity";
var availableEndTime = "http://hl7.org/fhir/availableEndTime";
var mimeType = "http://hl7.org/fhir/mimeType";
var NutritionOrderEnteralFormulaAdministrationComponent = "http://hl7.org/fhir/NutritionOrderEnteralFormulaAdministrationComponent";
var periodUnit = "http://hl7.org/fhir/periodUnit";
var EvidenceReportRelatesToComponent = "http://hl7.org/fhir/EvidenceReportRelatesToComponent";
var SubstanceDefinition = "http://hl7.org/fhir/SubstanceDefinition";
var _useContext = "http://hl7.org/fhir/_useContext";
var _instantiatesUri = "http://hl7.org/fhir/_instantiatesUri";
var authorizationUrl = "http://hl7.org/fhir/authorizationUrl";
var contributedToDeath = "http://hl7.org/fhir/contributedToDeath";
var confidentialityIndicator = "http://hl7.org/fhir/confidentialityIndicator";
var _diagnosisSequence = "http://hl7.org/fhir/_diagnosisSequence";
var selectionBehavior = "http://hl7.org/fhir/selectionBehavior";
var _time = "http://hl7.org/fhir/_time";
var addresses = "http://hl7.org/fhir/addresses";
var _dataRequirement = "http://hl7.org/fhir/_dataRequirement";
var CapabilityStatementRestResourceComponent = "http://hl7.org/fhir/CapabilityStatementRestResourceComponent";
var _lineItem = "http://hl7.org/fhir/_lineItem";
var _InventoryReport = "http://hl7.org/fhir/_InventoryReport";
var _copyright = "http://hl7.org/fhir/_copyright";
var _Substance = "http://hl7.org/fhir/_Substance";
var _timing = "http://hl7.org/fhir/_timing";
var wasSubstituted = "http://hl7.org/fhir/wasSubstituted";
var aggregation = "http://hl7.org/fhir/aggregation";
var _authorDescription = "http://hl7.org/fhir/_authorDescription";
var _filter = "http://hl7.org/fhir/_filter";
var MedicinalProductDefinitionOperationComponent = "http://hl7.org/fhir/MedicinalProductDefinitionOperationComponent";
var _defaultValue = "http://hl7.org/fhir/_defaultValue";
var StructureMapStructureComponent = "http://hl7.org/fhir/StructureMapStructureComponent";
var recipient = "http://hl7.org/fhir/recipient";
var _lotNumber = "http://hl7.org/fhir/_lotNumber";
var QuestionnaireItemAnswerOptionComponent = "http://hl7.org/fhir/QuestionnaireItemAnswerOptionComponent";
var applies = "http://hl7.org/fhir/applies";
var caseSensitive = "http://hl7.org/fhir/caseSensitive";
var subtype = "http://hl7.org/fhir/subtype";
var _field = "http://hl7.org/fhir/_field";
var _hasIngredient = "http://hl7.org/fhir/_hasIngredient";
var strength = "http://hl7.org/fhir/strength";
var linkId = "http://hl7.org/fhir/linkId";
var StructureMapGroupRuleTargetComponent = "http://hl7.org/fhir/StructureMapGroupRuleTargetComponent";
var _resultingEffect = "http://hl7.org/fhir/_resultingEffect";
var altitude2 = "http://hl7.org/fhir/altitude";
var phase = "http://hl7.org/fhir/phase";
var _numberOfRepeatsAllowed = "http://hl7.org/fhir/_numberOfRepeatsAllowed";
var groupSize = "http://hl7.org/fhir/groupSize";
var _oligoNucleotideType = "http://hl7.org/fhir/_oligoNucleotideType";
var doseStatus = "http://hl7.org/fhir/doseStatus";
var directnessMatch = "http://hl7.org/fhir/directnessMatch";
var AppointmentParticipantComponent = "http://hl7.org/fhir/AppointmentParticipantComponent";
var _continuous = "http://hl7.org/fhir/_continuous";
var _dispenseInterval = "http://hl7.org/fhir/_dispenseInterval";
var stage = "http://hl7.org/fhir/stage";
var associatedMedication = "http://hl7.org/fhir/associatedMedication";
var dateOfDiagnosis = "http://hl7.org/fhir/dateOfDiagnosis";
var _actualPeriod = "http://hl7.org/fhir/_actualPeriod";
var ValueSet = "http://hl7.org/fhir/ValueSet";
var lastOccurrence = "http://hl7.org/fhir/lastOccurrence";
var disulfideLinkage = "http://hl7.org/fhir/disulfideLinkage";
var participatingOrganization = "http://hl7.org/fhir/participatingOrganization";
var ResearchSubject = "http://hl7.org/fhir/ResearchSubject";
var heartbeatPeriod = "http://hl7.org/fhir/heartbeatPeriod";
var OrganizationAffiliation = "http://hl7.org/fhir/OrganizationAffiliation";
var _binding = "http://hl7.org/fhir/_binding";
var SubstanceNucleicAcidSubunitLinkageComponent = "http://hl7.org/fhir/SubstanceNucleicAcidSubunitLinkageComponent";
var ImplementationGuideDefinitionPageComponent = "http://hl7.org/fhir/ImplementationGuideDefinitionPageComponent";
var FamilyMemberHistoryProcedureComponent = "http://hl7.org/fhir/FamilyMemberHistoryProcedureComponent";
var subscriptionTopic = "http://hl7.org/fhir/subscriptionTopic";
var _resource = "http://hl7.org/fhir/_resource";
var correspondingContact = "http://hl7.org/fhir/correspondingContact";
var graph2 = "http://hl7.org/fhir/graph";
var _QuestionnaireResponse = "http://hl7.org/fhir/_QuestionnaireResponse";
var RequestOrchestrationActionComponentAction = "http://hl7.org/fhir/RequestOrchestrationActionComponentAction";
var issues = "http://hl7.org/fhir/issues";
var instances = "http://hl7.org/fhir/instances";
var _isDefining = "http://hl7.org/fhir/_isDefining";
var primaryPurposeType = "http://hl7.org/fhir/primaryPurposeType";
var _specimenRequirement = "http://hl7.org/fhir/_specimenRequirement";
var _sourceDocument = "http://hl7.org/fhir/_sourceDocument";
var SubstanceReferenceInformation = "http://hl7.org/fhir/SubstanceReferenceInformation";
var _multipleBirth = "http://hl7.org/fhir/_multipleBirth";
var _InsurancePlan = "http://hl7.org/fhir/_InsurancePlan";
var repeatUnit = "http://hl7.org/fhir/repeatUnit";
var StructureDefinition = "http://hl7.org/fhir/StructureDefinition";
var _node = "http://hl7.org/fhir/_node";
var TestPlanTestCaseAssertionComponent = "http://hl7.org/fhir/TestPlanTestCaseAssertionComponent";
var relatedData = "http://hl7.org/fhir/relatedData";
var _content = "http://hl7.org/fhir/_content";
var _associationType = "http://hl7.org/fhir/_associationType";
var _regulatoryBasis = "http://hl7.org/fhir/_regulatoryBasis";
var attachment2 = "http://hl7.org/fhir/attachment";
var ActionSubject = "http://hl7.org/fhir/ActionSubject";
var _packagedMedicinalProduct = "http://hl7.org/fhir/_packagedMedicinalProduct";
var _packagedProduct = "http://hl7.org/fhir/_packagedProduct";
var _onset = "http://hl7.org/fhir/_onset";
var _basedOn = "http://hl7.org/fhir/_basedOn";
var CitationCitedArtifactRelatesToComponent = "http://hl7.org/fhir/CitationCitedArtifactRelatesToComponent";
var _backCurve = "http://hl7.org/fhir/_backCurve";
var AuditEventOutcomeComponent = "http://hl7.org/fhir/AuditEventOutcomeComponent";
var payee = "http://hl7.org/fhir/payee";
var _reporter = "http://hl7.org/fhir/_reporter";
var SubstanceDefinitionStructureComponentMolecularWeight = "http://hl7.org/fhir/SubstanceDefinitionStructureComponentMolecularWeight";
var biologicalSourceEvent = "http://hl7.org/fhir/biologicalSourceEvent";
var RequestOrchestrationActionComponent = "http://hl7.org/fhir/RequestOrchestrationActionComponent";
var period = "http://hl7.org/fhir/period";
var SearchParameterComponentComponent = "http://hl7.org/fhir/SearchParameterComponentComponent";
var protocolPerformed = "http://hl7.org/fhir/protocolPerformed";
var ResearchStudyLabelComponent = "http://hl7.org/fhir/ResearchStudyLabelComponent";
var _careTeamSequence = "http://hl7.org/fhir/_careTeamSequence";
var instantiates = "http://hl7.org/fhir/instantiates";
var _patientCharacteristic = "http://hl7.org/fhir/_patientCharacteristic";
var _allowedType = "http://hl7.org/fhir/_allowedType";
var Element = "http://hl7.org/fhir/Element";
var DeviceMetric = "http://hl7.org/fhir/DeviceMetric";
var _maxTreatmentPeriod = "http://hl7.org/fhir/_maxTreatmentPeriod";
var _InventoryItem = "http://hl7.org/fhir/_InventoryItem";
var AppointmentRecurrenceTemplateComponent = "http://hl7.org/fhir/AppointmentRecurrenceTemplateComponent";
var targetDisease = "http://hl7.org/fhir/targetDisease";
var PlanDefinitionActionComponentAction = "http://hl7.org/fhir/PlanDefinitionActionComponentAction";
var file = "http://hl7.org/fhir/file";
var const__workaround = "http://hl7.org/fhir/const";
var citedMedium = "http://hl7.org/fhir/citedMedium";
var _frames = "http://hl7.org/fhir/_frames";
var multipleOr = "http://hl7.org/fhir/multipleOr";
var inputParameters = "http://hl7.org/fhir/inputParameters";
var causality = "http://hl7.org/fhir/causality";
var SupplyDelivery = "http://hl7.org/fhir/SupplyDelivery";
var minimumId = "http://hl7.org/fhir/minimumId";
var _processNote = "http://hl7.org/fhir/_processNote";
var Money = "http://hl7.org/fhir/Money";
var _BackboneType = "http://hl7.org/fhir/_BackboneType";
var _Endpoint = "http://hl7.org/fhir/_Endpoint";
var udiDeviceIdentifier = "http://hl7.org/fhir/udiDeviceIdentifier";
var EnteralFormulaSchedule = "http://hl7.org/fhir/EnteralFormulaSchedule";
var diseaseStatus = "http://hl7.org/fhir/diseaseStatus";
var _expectedSupplyDuration = "http://hl7.org/fhir/_expectedSupplyDuration";
var ifModifiedSince = "http://hl7.org/fhir/ifModifiedSince";
var formCode = "http://hl7.org/fhir/formCode";
var _connectionType = "http://hl7.org/fhir/_connectionType";
var ImplementationGuideDefinitionResourceComponent = "http://hl7.org/fhir/ImplementationGuideDefinitionResourceComponent";
var _fundsReserveRequested = "http://hl7.org/fhir/_fundsReserveRequested";
var dateFilter = "http://hl7.org/fhir/dateFilter";
var matchStatus = "http://hl7.org/fhir/matchStatus";
var usePeriod = "http://hl7.org/fhir/usePeriod";
var _participant = "http://hl7.org/fhir/_participant";
var MessageDestination = "http://hl7.org/fhir/MessageDestination";
var _additionalInfo = "http://hl7.org/fhir/_additionalInfo";
var _numberOfEvents = "http://hl7.org/fhir/_numberOfEvents";
var _includedStructure = "http://hl7.org/fhir/_includedStructure";
var _imageRegion2D = "http://hl7.org/fhir/_imageRegion2D";
var _tax = "http://hl7.org/fhir/_tax";
var _appointment = "http://hl7.org/fhir/_appointment";
var treatmentIntent = "http://hl7.org/fhir/treatmentIntent";
var SubstanceDefinitionCodeComponent = "http://hl7.org/fhir/SubstanceDefinitionCodeComponent";
var _study = "http://hl7.org/fhir/_study";
var _ratioType = "http://hl7.org/fhir/_ratioType";
var policyHolder = "http://hl7.org/fhir/policyHolder";
var region2 = "http://hl7.org/fhir/region";
var operationType = "http://hl7.org/fhir/operationType";
var _actuality = "http://hl7.org/fhir/_actuality";
var _definitionUri = "http://hl7.org/fhir/_definitionUri";
var organismId = "http://hl7.org/fhir/organismId";
var ManufacturedItemDefinitionComponentComponentComponentProperty = "http://hl7.org/fhir/ManufacturedItemDefinitionComponentComponentComponentProperty";
var _consumedItem = "http://hl7.org/fhir/_consumedItem";
var thursday = "http://hl7.org/fhir/thursday";
var _rules = "http://hl7.org/fhir/_rules";
var dependent = "http://hl7.org/fhir/dependent";
var deliverFrom = "http://hl7.org/fhir/deliverFrom";
var ImmunizationProtocolAppliedComponent = "http://hl7.org/fhir/ImmunizationProtocolAppliedComponent";
var actualGroup = "http://hl7.org/fhir/actualGroup";
var Age = "http://hl7.org/fhir/Age";
var subsumption = "http://hl7.org/fhir/subsumption";
var ElementDefinitionConstraintComponent = "http://hl7.org/fhir/ElementDefinitionConstraintComponent";
var subjectResults = "http://hl7.org/fhir/subjectResults";
var OperationDefinitionOverloadComponent = "http://hl7.org/fhir/OperationDefinitionOverloadComponent";
var recurrenceTemplate = "http://hl7.org/fhir/recurrenceTemplate";
var doseForm = "http://hl7.org/fhir/doseForm";
var adherence = "http://hl7.org/fhir/adherence";
var ServiceRequest = "http://hl7.org/fhir/ServiceRequest";
var deviceIdentifier = "http://hl7.org/fhir/deviceIdentifier";
var _reasonLinkId = "http://hl7.org/fhir/_reasonLinkId";
var versionId = "http://hl7.org/fhir/versionId";
var componentPart = "http://hl7.org/fhir/componentPart";
var _value = "http://hl7.org/fhir/_value";
var TestReportParticipantComponent = "http://hl7.org/fhir/TestReportParticipantComponent";
var morphology = "http://hl7.org/fhir/morphology";
var date3 = "http://hl7.org/fhir/date";
var _isModifier = "http://hl7.org/fhir/_isModifier";
var _allDay = "http://hl7.org/fhir/_allDay";
var contentReference = "http://hl7.org/fhir/contentReference";
var _sunday = "http://hl7.org/fhir/_sunday";
var DeviceUsageAdherenceComponent = "http://hl7.org/fhir/DeviceUsageAdherenceComponent";
var maxSingleDose = "http://hl7.org/fhir/maxSingleDose";
var referenceRange = "http://hl7.org/fhir/referenceRange";
var _pages = "http://hl7.org/fhir/_pages";
var DeviceDefinitionGuidelineComponent = "http://hl7.org/fhir/DeviceDefinitionGuidelineComponent";
var _temperatureRange = "http://hl7.org/fhir/_temperatureRange";
var _sequenceType = "http://hl7.org/fhir/_sequenceType";
var _partNumber = "http://hl7.org/fhir/_partNumber";
var _term = "http://hl7.org/fhir/_term";
var StructureDefinitionDifferentialComponent = "http://hl7.org/fhir/StructureDefinitionDifferentialComponent";
var _udi = "http://hl7.org/fhir/_udi";
var _telecom = "http://hl7.org/fhir/_telecom";
var CitationCitedArtifactPublicationFormPublishedInComponent = "http://hl7.org/fhir/CitationCitedArtifactPublicationFormPublishedInComponent";
var _wasSubstituted = "http://hl7.org/fhir/_wasSubstituted";
var initial = "http://hl7.org/fhir/initial";
var doNotPerform = "http://hl7.org/fhir/doNotPerform";
var diameter = "http://hl7.org/fhir/diameter";
var _property = "http://hl7.org/fhir/_property";
var MessageHeaderResponseComponent = "http://hl7.org/fhir/MessageHeaderResponseComponent";
var Linkage = "http://hl7.org/fhir/Linkage";
var permittedUnit = "http://hl7.org/fhir/permittedUnit";
var _sex = "http://hl7.org/fhir/_sex";
var genomeBuild = "http://hl7.org/fhir/genomeBuild";
var changePattern = "http://hl7.org/fhir/changePattern";
var MedicationRequestSubstitutionComponent = "http://hl7.org/fhir/MedicationRequestSubstitutionComponent";
var _authority = "http://hl7.org/fhir/_authority";
var onBehalfOf = "http://hl7.org/fhir/onBehalfOf";
var _rateAggregation = "http://hl7.org/fhir/_rateAggregation";
var managingOrganization = "http://hl7.org/fhir/managingOrganization";
var handling = "http://hl7.org/fhir/handling";
var notConsumedReason = "http://hl7.org/fhir/notConsumedReason";
var axis = "http://hl7.org/fhir/axis";
var _udiCarrier = "http://hl7.org/fhir/_udiCarrier";
var paymentBy = "http://hl7.org/fhir/paymentBy";
var _insurancePlan = "http://hl7.org/fhir/_insurancePlan";
var subDetailSequence = "http://hl7.org/fhir/subDetailSequence";
var DataRequirementValueFilterComponent = "http://hl7.org/fhir/DataRequirementValueFilterComponent";
var problem = "http://hl7.org/fhir/problem";
var initialFill = "http://hl7.org/fhir/initialFill";
var _ManufacturedItemDefinition = "http://hl7.org/fhir/_ManufacturedItemDefinition";
var _improvementNotation = "http://hl7.org/fhir/_improvementNotation";
var ClinicalUseDefinitionIndicationComponentOtherTherapy = "http://hl7.org/fhir/ClinicalUseDefinitionIndicationComponentOtherTherapy";
var fraction = "http://hl7.org/fhir/fraction";
var _lastOccurrence = "http://hl7.org/fhir/_lastOccurrence";
var _assessment = "http://hl7.org/fhir/_assessment";
var Patient = "http://hl7.org/fhir/Patient";
var _identified = "http://hl7.org/fhir/_identified";
var ExplanationOfBenefitAdjudication = "http://hl7.org/fhir/ExplanationOfBenefitAdjudication";
var _Subscription = "http://hl7.org/fhir/_Subscription";
var tag3 = "http://hl7.org/fhir/tag";
var _performed = "http://hl7.org/fhir/_performed";
var _formOf = "http://hl7.org/fhir/_formOf";
var DeviceDefinitionPackagingComponentPackagingPackaging = "http://hl7.org/fhir/DeviceDefinitionPackagingComponentPackagingPackaging";
var _subrogation = "http://hl7.org/fhir/_subrogation";
var _deceased = "http://hl7.org/fhir/_deceased";
var relatedAccount = "http://hl7.org/fhir/relatedAccount";
var Transport = "http://hl7.org/fhir/Transport";
var Measure = "http://hl7.org/fhir/Measure";
var RiskAssessment = "http://hl7.org/fhir/RiskAssessment";
var _teardown = "http://hl7.org/fhir/_teardown";
var degreeOfPolymerisation = "http://hl7.org/fhir/degreeOfPolymerisation";
var _CoverageEligibilityRequest = "http://hl7.org/fhir/_CoverageEligibilityRequest";
var _Medication = "http://hl7.org/fhir/_Medication";
var manufacturedDoseForm = "http://hl7.org/fhir/manufacturedDoseForm";
var sliceName = "http://hl7.org/fhir/sliceName";
var dateAsserted = "http://hl7.org/fhir/dateAsserted";
var ContractParty = "http://hl7.org/fhir/ContractParty";
var validationStatus = "http://hl7.org/fhir/validationStatus";
var TestScriptMetadataComponent = "http://hl7.org/fhir/TestScriptMetadataComponent";
var _headerField = "http://hl7.org/fhir/_headerField";
var geographicalLocation = "http://hl7.org/fhir/geographicalLocation";
var versionNeeded = "http://hl7.org/fhir/versionNeeded";
var ConceptDefinition = "http://hl7.org/fhir/ConceptDefinition";
var _sigFormat = "http://hl7.org/fhir/_sigFormat";
var publishedIn = "http://hl7.org/fhir/publishedIn";
var sphere = "http://hl7.org/fhir/sphere";
var _SubstanceDefinition = "http://hl7.org/fhir/_SubstanceDefinition";
var SubstanceDefinitionNameOfficialComponent = "http://hl7.org/fhir/SubstanceDefinitionNameOfficialComponent";
var _listRuleId = "http://hl7.org/fhir/_listRuleId";
var started = "http://hl7.org/fhir/started";
var EvidenceVariable = "http://hl7.org/fhir/EvidenceVariable";
var ResearchStudyOutcomeMeasureComponent = "http://hl7.org/fhir/ResearchStudyOutcomeMeasureComponent";
var allowedResponse = "http://hl7.org/fhir/allowedResponse";
var _ElementDefinition = "http://hl7.org/fhir/_ElementDefinition";
var CitationCitedArtifactContributorshipComponent = "http://hl7.org/fhir/CitationCitedArtifactContributorshipComponent";
var _contentType = "http://hl7.org/fhir/_contentType";
var _DeviceUsage = "http://hl7.org/fhir/_DeviceUsage";
var DeviceDefinitionUdiDeviceIdentifierComponent = "http://hl7.org/fhir/DeviceDefinitionUdiDeviceIdentifierComponent";
var document = "http://hl7.org/fhir/document";
var event = "http://hl7.org/fhir/event";
var Guarantor = "http://hl7.org/fhir/Guarantor";
var molecularWeight = "http://hl7.org/fhir/molecularWeight";
var substitution = "http://hl7.org/fhir/substitution";
var NutritionOrderSupplementComponent = "http://hl7.org/fhir/NutritionOrderSupplementComponent";
var _relativeRisk = "http://hl7.org/fhir/_relativeRisk";
var _volume = "http://hl7.org/fhir/_volume";
var _manager = "http://hl7.org/fhir/_manager";
var _presentation = "http://hl7.org/fhir/_presentation";
var _linkage = "http://hl7.org/fhir/_linkage";
var isDefault = "http://hl7.org/fhir/isDefault";
var BodyStructure = "http://hl7.org/fhir/BodyStructure";
var _relationship = "http://hl7.org/fhir/_relationship";
var _maxDispense = "http://hl7.org/fhir/_maxDispense";
var ChargeItemDefinition = "http://hl7.org/fhir/ChargeItemDefinition";
var _SupplyDelivery = "http://hl7.org/fhir/_SupplyDelivery";
var _specialArrangement = "http://hl7.org/fhir/_specialArrangement";
var DosageDoseAndRateComponent = "http://hl7.org/fhir/DosageDoseAndRateComponent";
var _guideline = "http://hl7.org/fhir/_guideline";
var _grantee = "http://hl7.org/fhir/_grantee";
var serviced = "http://hl7.org/fhir/serviced";
var _active = "http://hl7.org/fhir/_active";
var _preference = "http://hl7.org/fhir/_preference";
var useContext = "http://hl7.org/fhir/useContext";
var _container = "http://hl7.org/fhir/_container";
var justification = "http://hl7.org/fhir/justification";
var oralDiet = "http://hl7.org/fhir/oralDiet";
var _testingDestination = "http://hl7.org/fhir/_testingDestination";
var lastRevisionDate = "http://hl7.org/fhir/lastRevisionDate";
var NutritionIntakeIngredientLabelComponent = "http://hl7.org/fhir/NutritionIntakeIngredientLabelComponent";
var QuestionnaireResponseItemComponentItem = "http://hl7.org/fhir/QuestionnaireResponseItemComponentItem";
var PermissionJustificationComponent = "http://hl7.org/fhir/PermissionJustificationComponent";
var recorder = "http://hl7.org/fhir/recorder";
var ImmunizationRecommendationRecommendationDateCriterionComponent = "http://hl7.org/fhir/ImmunizationRecommendationRecommendationDateCriterionComponent";
var _focus = "http://hl7.org/fhir/_focus";
var countingDateTime = "http://hl7.org/fhir/countingDateTime";
var MedicationKnowledge = "http://hl7.org/fhir/MedicationKnowledge";
var ConditionDefinition = "http://hl7.org/fhir/ConditionDefinition";
var noMap = "http://hl7.org/fhir/noMap";
var _userSelected = "http://hl7.org/fhir/_userSelected";
var appointmentRequired = "http://hl7.org/fhir/appointmentRequired";
var _numberOfStudies = "http://hl7.org/fhir/_numberOfStudies";
var capabilities = "http://hl7.org/fhir/capabilities";
var Benefit = "http://hl7.org/fhir/Benefit";
var _uri = "http://hl7.org/fhir/_uri";
var _max = "http://hl7.org/fhir/_max";
var inactive = "http://hl7.org/fhir/inactive";
var other = "http://hl7.org/fhir/other";
var dependsOn = "http://hl7.org/fhir/dependsOn";
var citedArtifact = "http://hl7.org/fhir/citedArtifact";
var fixture = "http://hl7.org/fhir/fixture";
var _insurer = "http://hl7.org/fhir/_insurer";
var _endParam = "http://hl7.org/fhir/_endParam";
var continuous = "http://hl7.org/fhir/continuous";
var SubstancePolymerRepeatRepeatUnitStructuralRepresentationComponent = "http://hl7.org/fhir/SubstancePolymerRepeatRepeatUnitStructuralRepresentationComponent";
var _responsibleOrganization = "http://hl7.org/fhir/_responsibleOrganization";
var url3 = "http://hl7.org/fhir/url";
var compareToSourceExpression = "http://hl7.org/fhir/compareToSourceExpression";
var nutrient = "http://hl7.org/fhir/nutrient";
var _subjectResults = "http://hl7.org/fhir/_subjectResults";
var DocumentReferenceRelatesToComponent = "http://hl7.org/fhir/DocumentReferenceRelatesToComponent";
var ImagingStudy = "http://hl7.org/fhir/ImagingStudy";
var AppointmentRecurrenceTemplateYearlyTemplateComponent = "http://hl7.org/fhir/AppointmentRecurrenceTemplateYearlyTemplateComponent";
var SpecimenFeatureComponent = "http://hl7.org/fhir/SpecimenFeatureComponent";
var _ServiceRequest = "http://hl7.org/fhir/_ServiceRequest";
var tester = "http://hl7.org/fhir/tester";
var seriousness = "http://hl7.org/fhir/seriousness";
var isDefining = "http://hl7.org/fhir/isDefining";
var contributingFactor = "http://hl7.org/fhir/contributingFactor";
var CapabilityStatement = "http://hl7.org/fhir/CapabilityStatement";
var _ImagingSelection = "http://hl7.org/fhir/_ImagingSelection";
var _unmapped = "http://hl7.org/fhir/_unmapped";
var compositional = "http://hl7.org/fhir/compositional";
var fundsReserveRequested = "http://hl7.org/fhir/fundsReserveRequested";
var Total = "http://hl7.org/fhir/Total";
var _citeAs = "http://hl7.org/fhir/_citeAs";
var _protein = "http://hl7.org/fhir/_protein";
var _referenceRange = "http://hl7.org/fhir/_referenceRange";
var complication = "http://hl7.org/fhir/complication";
var SubscriptionTopicResourceTriggerComponent = "http://hl7.org/fhir/SubscriptionTopicResourceTriggerComponent";
var estimate = "http://hl7.org/fhir/estimate";
var _material = "http://hl7.org/fhir/_material";
var Item = "http://hl7.org/fhir/Item";
var encodeRequestUrl = "http://hl7.org/fhir/encodeRequestUrl";
var _currentLocation = "http://hl7.org/fhir/_currentLocation";
var style = "http://hl7.org/fhir/style";
var method2 = "http://hl7.org/fhir/method";
var _MarketingStatus = "http://hl7.org/fhir/_MarketingStatus";
var group = "http://hl7.org/fhir/group";
var achievementStatus = "http://hl7.org/fhir/achievementStatus";
var evaluatedResource = "http://hl7.org/fhir/evaluatedResource";
var _udiDeviceIdentifier = "http://hl7.org/fhir/_udiDeviceIdentifier";
var _RelatedPerson = "http://hl7.org/fhir/_RelatedPerson";
var dateTime = "http://hl7.org/fhir/dateTime";
var _intervalUnit = "http://hl7.org/fhir/_intervalUnit";
var text = "http://hl7.org/fhir/text";
var _contact = "http://hl7.org/fhir/_contact";
var searchInclude = "http://hl7.org/fhir/searchInclude";
var _fivePrime = "http://hl7.org/fhir/_fivePrime";
var timeOfDay = "http://hl7.org/fhir/timeOfDay";
var originRelationshipType = "http://hl7.org/fhir/originRelationshipType";
var CitationClassificationComponent = "http://hl7.org/fhir/CitationClassificationComponent";
var _plannedStartDate = "http://hl7.org/fhir/_plannedStartDate";
var documentType = "http://hl7.org/fhir/documentType";
var CoverageEligibilityRequestEventComponent = "http://hl7.org/fhir/CoverageEligibilityRequestEventComponent";
var _milestone = "http://hl7.org/fhir/_milestone";
var page = "http://hl7.org/fhir/page";
var params = "http://hl7.org/fhir/params";
var regionsCalled = "http://hl7.org/fhir/regionsCalled";
var conditionalCreate = "http://hl7.org/fhir/conditionalCreate";
var lensSpecification = "http://hl7.org/fhir/lensSpecification";
var _grantor = "http://hl7.org/fhir/_grantor";
var coverage3 = "http://hl7.org/fhir/coverage";
var authorizationSupporting = "http://hl7.org/fhir/authorizationSupporting";
var ElementDefinitionBindingAdditionalComponent = "http://hl7.org/fhir/ElementDefinitionBindingAdditionalComponent";
var _benefit = "http://hl7.org/fhir/_benefit";
var _testData = "http://hl7.org/fhir/_testData";
var _OrganizationAffiliation = "http://hl7.org/fhir/_OrganizationAffiliation";
var excludedStructure = "http://hl7.org/fhir/excludedStructure";
var _searchRevInclude = "http://hl7.org/fhir/_searchRevInclude";
var serviceProvisionCode = "http://hl7.org/fhir/serviceProvisionCode";
var typeMode = "http://hl7.org/fhir/typeMode";
var ValueSetScopeComponent = "http://hl7.org/fhir/ValueSetScopeComponent";
var SupplyRequestParameterComponent = "http://hl7.org/fhir/SupplyRequestParameterComponent";
var attributeEstimate = "http://hl7.org/fhir/attributeEstimate";
var immutable = "http://hl7.org/fhir/immutable";
var _relatedAccount = "http://hl7.org/fhir/_relatedAccount";
var _RiskAssessment = "http://hl7.org/fhir/_RiskAssessment";
var BiologicallyDerivedProductPropertyComponent = "http://hl7.org/fhir/BiologicallyDerivedProductPropertyComponent";
var _totalVolume = "http://hl7.org/fhir/_totalVolume";
var _adjudication = "http://hl7.org/fhir/_adjudication";
var history = "http://hl7.org/fhir/history";
var _isSubpotent = "http://hl7.org/fhir/_isSubpotent";
var _longitude = "http://hl7.org/fhir/_longitude";
var _sliceIsConstraining = "http://hl7.org/fhir/_sliceIsConstraining";
var collected = "http://hl7.org/fhir/collected";
var medicineClassification = "http://hl7.org/fhir/medicineClassification";
var Signature = "http://hl7.org/fhir/Signature";
var ConceptReference = "http://hl7.org/fhir/ConceptReference";
var TransportRestrictionComponent = "http://hl7.org/fhir/TransportRestrictionComponent";
var _rank = "http://hl7.org/fhir/_rank";
var _inResponseTo = "http://hl7.org/fhir/_inResponseTo";
var CitationCitedArtifactAbstractComponent = "http://hl7.org/fhir/CitationCitedArtifactAbstractComponent";
var _error = "http://hl7.org/fhir/_error";
var origin3 = "http://hl7.org/fhir/origin";
var treeRoot = "http://hl7.org/fhir/treeRoot";
var _sourceMaterialType = "http://hl7.org/fhir/_sourceMaterialType";
var bodyStructure = "http://hl7.org/fhir/bodyStructure";
var _releaseDate = "http://hl7.org/fhir/_releaseDate";
var normalValue = "http://hl7.org/fhir/normalValue";
var PractitionerCommunicationComponent = "http://hl7.org/fhir/PractitionerCommunicationComponent";
var targetProfile = "http://hl7.org/fhir/targetProfile";
var bounds = "http://hl7.org/fhir/bounds";
var _op = "http://hl7.org/fhir/_op";
var OperationDefinitionParameterComponentParameterParameter = "http://hl7.org/fhir/OperationDefinitionParameterComponentParameterParameter";
var plannedActivityReference = "http://hl7.org/fhir/plannedActivityReference";
var _preAuthRef = "http://hl7.org/fhir/_preAuthRef";
var _imageRegion3D = "http://hl7.org/fhir/_imageRegion3D";
var _object = "http://hl7.org/fhir/_object";
var DocumentReferenceAttesterComponent = "http://hl7.org/fhir/DocumentReferenceAttesterComponent";
var _recall = "http://hl7.org/fhir/_recall";
var fastingStatus = "http://hl7.org/fhir/fastingStatus";
var seriesUid = "http://hl7.org/fhir/seriesUid";
var SubstanceSourceMaterialPartDescriptionComponent = "http://hl7.org/fhir/SubstanceSourceMaterialPartDescriptionComponent";
var _geneElement = "http://hl7.org/fhir/_geneElement";
var publicationDateText = "http://hl7.org/fhir/publicationDateText";
var EpisodeOfCareStatusHistoryComponent = "http://hl7.org/fhir/EpisodeOfCareStatusHistoryComponent";
var evaluationMessage = "http://hl7.org/fhir/evaluationMessage";
var division = "http://hl7.org/fhir/division";
var windowEnd = "http://hl7.org/fhir/windowEnd";
var _foodType = "http://hl7.org/fhir/_foodType";
var _repeats = "http://hl7.org/fhir/_repeats";
var _Observation = "http://hl7.org/fhir/_Observation";
var validateCode = "http://hl7.org/fhir/validateCode";
var parameterName = "http://hl7.org/fhir/parameterName";
var source3 = "http://hl7.org/fhir/source";
var currentState = "http://hl7.org/fhir/currentState";
var publicationStatus = "http://hl7.org/fhir/publicationStatus";
var _license = "http://hl7.org/fhir/_license";
var _created = "http://hl7.org/fhir/_created";
var ClinicalUseDefinitionContraindicationOtherTherapyComponent = "http://hl7.org/fhir/ClinicalUseDefinitionContraindicationOtherTherapyComponent";
var isModifier = "http://hl7.org/fhir/isModifier";
var _needsMap = "http://hl7.org/fhir/_needsMap";
var performerType = "http://hl7.org/fhir/performerType";
var unitPrice = "http://hl7.org/fhir/unitPrice";
var _topic = "http://hl7.org/fhir/_topic";
var _lastUpdated = "http://hl7.org/fhir/_lastUpdated";
var preparedDate = "http://hl7.org/fhir/preparedDate";
var accident = "http://hl7.org/fhir/accident";
var code = "http://hl7.org/fhir/code";
var _designation = "http://hl7.org/fhir/_designation";
var _creation = "http://hl7.org/fhir/_creation";
var verificationType = "http://hl7.org/fhir/verificationType";
var DeviceDefinitionPackagingComponentPackagingUdiDeviceIdentifier = "http://hl7.org/fhir/DeviceDefinitionPackagingComponentPackagingUdiDeviceIdentifier";
var _containedInstance = "http://hl7.org/fhir/_containedInstance";
var PackagedProductDefinitionLegalStatusOfSupplyComponent = "http://hl7.org/fhir/PackagedProductDefinitionLegalStatusOfSupplyComponent";
var _recipient = "http://hl7.org/fhir/_recipient";
var ifMatch = "http://hl7.org/fhir/ifMatch";
var partNumber = "http://hl7.org/fhir/partNumber";
var _severity = "http://hl7.org/fhir/_severity";
var _filterBy = "http://hl7.org/fhir/_filterBy";
var _NutritionIntake = "http://hl7.org/fhir/_NutritionIntake";
var BundleEntrySearchComponent = "http://hl7.org/fhir/BundleEntrySearchComponent";
var _responseCode = "http://hl7.org/fhir/_responseCode";
var _eventHistory = "http://hl7.org/fhir/_eventHistory";
var _rejectionCriterion = "http://hl7.org/fhir/_rejectionCriterion";
var notPerformedReason = "http://hl7.org/fhir/notPerformedReason";
var _entryType = "http://hl7.org/fhir/_entryType";
var EncounterHistory = "http://hl7.org/fhir/EncounterHistory";
var _specialPrecautionsForStorage = "http://hl7.org/fhir/_specialPrecautionsForStorage";
var SearchParameter = "http://hl7.org/fhir/SearchParameter";
var gender = "http://hl7.org/fhir/gender";
var coding = "http://hl7.org/fhir/coding";
var ProductShelfLife = "http://hl7.org/fhir/ProductShelfLife";
var system = "http://hl7.org/fhir/system";
var _tissue = "http://hl7.org/fhir/_tissue";
var associatedParty = "http://hl7.org/fhir/associatedParty";
var statistic = "http://hl7.org/fhir/statistic";
var DataRequirement = "http://hl7.org/fhir/DataRequirement";
var MedicationKnowledgeRegulatoryMaxDispenseComponent = "http://hl7.org/fhir/MedicationKnowledgeRegulatoryMaxDispenseComponent";
var udiCarrier = "http://hl7.org/fhir/udiCarrier";
var Availability = "http://hl7.org/fhir/Availability";
var sender = "http://hl7.org/fhir/sender";
var _strand = "http://hl7.org/fhir/_strand";
var IngredientSubstanceStrengthComponent = "http://hl7.org/fhir/IngredientSubstanceStrengthComponent";
var MedicationKnowledgeMonitoringProgramComponent = "http://hl7.org/fhir/MedicationKnowledgeMonitoringProgramComponent";
var _derivation = "http://hl7.org/fhir/_derivation";
var Condition = "http://hl7.org/fhir/Condition";
var AdministrableProductDefinitionRouteOfAdministrationTargetSpeciesWithdrawalPeriodComponent = "http://hl7.org/fhir/AdministrableProductDefinitionRouteOfAdministrationTargetSpeciesWithdrawalPeriodComponent";
var diagnostics = "http://hl7.org/fhir/diagnostics";
var assessment = "http://hl7.org/fhir/assessment";
var _clockFacePosition = "http://hl7.org/fhir/_clockFacePosition";
var attestation = "http://hl7.org/fhir/attestation";
var identified = "http://hl7.org/fhir/identified";
var fhirImport = /* @__PURE__ */ Object.freeze({
  constituent,
  _careTeam,
  ClinicalUseDefinitionWarningComponent,
  PlanDefinitionActionParticipantComponent,
  VisionPrescriptionLensSpecificationComponent,
  _answerOption,
  decimal,
  _applies,
  serviceProvider,
  NutritionProductIngredientComponent,
  Error__workaround,
  productStatus,
  ImagingStudySeriesPerformerComponent,
  _lowerLimit,
  Medication,
  header,
  StructureMapGroupRuleComponent,
  _productType,
  _relatedItem,
  author: author2,
  _direction,
  _frequencyOfOccurrence,
  RequestOrchestration,
  Detail,
  numberOfRepeatsAllowed,
  _communicationRequest,
  DocumentReferenceContentProfileComponent,
  _masterFile,
  comment: comment2,
  availableTime,
  _assert,
  listRuleId,
  preAdmissionIdentifier,
  participantType,
  _related,
  SupplementSchedule,
  reAdmission,
  _requestURL,
  _caseSensitive,
  _chargeItem,
  _withdrawalPeriod,
  CapabilityStatementImplementationComponent,
  analysis,
  monitoringProgram,
  _date,
  satisfiedBy,
  artifact,
  timing,
  appliesToAll,
  _appointmentRequired,
  _canFilterBy,
  filter,
  _targetNumber,
  _additive,
  _management,
  _phylum,
  _distributor,
  _clinicalRecommendationStatement,
  _manifest,
  cancellationDate,
  _doseQuantity,
  DeviceDefinitionPackagingComponentUdiDeviceIdentifier,
  VerificationResult,
  preference,
  _asserter,
  _regulatoryIdentifier,
  molecularFormula,
  isActive,
  dispenserInstruction,
  MedicationKnowledgeRelatedMedicationKnowledgeComponent,
  CapabilityStatementRestSecurityComponent,
  initialSelected,
  _preventiveAction,
  DeviceDefinitionConformsToComponent,
  _MedicationStatement,
  _availableStartTime,
  validationType,
  _axis,
  _serialNumber,
  Narrative,
  _dependency,
  endDate,
  _prognosisReference,
  _recruitment,
  searchParam,
  _usageInstruction,
  _generation,
  artifactAssessment,
  complete,
  _dependent,
  _due,
  _replaces,
  EvidenceStatisticModelCharacteristicComponent,
  _friday,
  orderedBy,
  _modality,
  expirationType,
  party,
  _objective,
  _totalNet,
  _adherence,
  _cardinalityBehavior,
  startDate,
  basis,
  _minutesDuration,
  instruction,
  _targetDisease,
  eventTrigger,
  closure,
  numberOfParticipants,
  businessArrangement,
  requesterLinkId,
  _programEligibility,
  _average,
  proxySignature,
  _assessmentMethod,
  _series,
  _performingOrganization,
  frames,
  _paternalOrganismName,
  inputProfile,
  _guarantor,
  _human,
  NutritionProductCharacteristicComponent,
  _orderDetail,
  maxParticipants,
  ClinicalUseDefinitionUndesirableEffectComponent,
  _observed,
  validityPeriod,
  ComputableLanguage,
  surfaceOrientation,
  _Provenance,
  testRun,
  SubstanceProtein,
  _focalDevice,
  _operationType,
  context: context3,
  occurrenceDateTime,
  DetectedIssueEvidenceComponent,
  _ExplanationOfBenefit,
  validated,
  _subunit,
  EvidenceStatisticAttributeEstimateComponent,
  replacedSequence,
  specimen,
  rater,
  relatedMedicationKnowledge,
  lastModified: lastModified2,
  RequestOrchestrationActionParticipantComponent,
  _informationType,
  citation,
  paymentStatus,
  treatment,
  _initial,
  priceComponent,
  _Linkage,
  _indicationGuideline,
  SubstanceSourceMaterial,
  _conditionalRead,
  managingEntity,
  EvidenceVariableCharacteristicDefinitionByTypeAndValueComponent,
  operationalStatus,
  _module,
  MedicationAdministration,
  UdiDeviceIdentifierMarketDistribution,
  _probability,
  clinicalRecommendationStatement,
  _image,
  SubscriptionTopicNotificationShapeComponent,
  _componentPart,
  op,
  _processingFacility,
  unit,
  _problem,
  SubstanceDefinitionPropertyComponent,
  _fluidConsistencyType,
  _SubstancePolymer,
  ValueSetComposeIncludeConceptDesignationComponent,
  versionReference,
  _maxSingleDose,
  meaning,
  measurementPoint,
  diagnosisRelatedGroup,
  _relative,
  _publicationForm,
  _Patient,
  GuidanceResponse,
  entity,
  sourceReference,
  valueFilter,
  _useBy,
  bodyLandmarkOrientation,
  SubstanceDefinitionNameComponentName,
  _policyText,
  _changePattern,
  subDetail,
  allDay,
  _modification,
  _nodeId,
  AdverseEventContributingFactorComponent,
  TestPlanTestCaseComponent,
  sunday,
  cancellationReason,
  _title,
  _sourceId,
  _entityRelatedness,
  line,
  _effectivePeriod,
  preAuthRef,
  requestId,
  _autodelete,
  _fundsReserve,
  BundleEntryComponentLink,
  DocumentReferenceContentComponent,
  _holder,
  _qualifiers,
  _Specimen,
  CodeSystemFilterComponent,
  _replacementSequence,
  serviceCategory,
  _next,
  paymentTerms,
  _started,
  offer,
  coordinateSystem,
  DeviceDefinition,
  _intent,
  _text,
  _level,
  facility,
  qualifiedValue,
  ManifestResource,
  prism,
  MedicationBatchComponent,
  resultForDelete,
  _accept,
  overbooked,
  _plan,
  ReviewOutcome,
  CitationCitedArtifactContributorshipEntryComponent,
  discriminator,
  ordered,
  LegalLanguage,
  frequencyOfOccurrence,
  _validationType,
  PermissionRuleDataComponent,
  _versionNeeded,
  PackagedProductDefinitionPackagingContainedItemComponent,
  predecessor,
  ArtifactAssessment,
  _dependsOn,
  evidence,
  MeasureGroupPopulationComponent,
  opticalActivity,
  nutritionProduct,
  specialMeasures,
  packageId,
  TerminologyCapabilitiesCodeSystemVersionFilterComponent,
  SubDetail,
  _received,
  CapabilityStatementDocumentComponent,
  observationResultRequirement,
  FriendlyLanguage,
  _observedGroup,
  cancelledReason,
  _expirationType,
  _actualNumber,
  derivation,
  AdverseEventSuspectEntityComponent,
  ImmunizationRecommendation,
  _BiologicallyDerivedProductDispense,
  _definitionId,
  _authoredOn,
  keyword,
  characteristic,
  _note,
  ImagingStudySeriesInstanceComponent,
  _signature,
  slicing,
  _population,
  cap,
  given,
  account,
  _organism,
  _need,
  environmentalSetting,
  volume,
  weeklyTemplate,
  lowerLimit,
  _justification,
  _fixture,
  unitPriceComponent,
  availabilityStatus,
  _proxySignature,
  statusChanged,
  _about,
  occurence,
  actualPeriod,
  _originalPrescription,
  _dosage,
  returnedAmount,
  _cTerminalModification,
  name: name2,
  masterFile,
  baseFormulaType,
  threshold,
  active,
  IngredientSubstanceComponent,
  size,
  _validityPeriod,
  who,
  ExampleScenarioProcessStepAlternativeComponent,
  InsurancePlanPlanSpecificCostComponent,
  interaction,
  _beneficiary,
  requestURL,
  transform,
  sugar,
  _subscriptionTopic,
  _usageStatus,
  _recurring,
  chargeItem,
  DiagnosticReportMediaComponent,
  validationProcess,
  _DiagnosticReport,
  moiety,
  _marketingStatus,
  _citedArtifact,
  CitationCitedArtifactPartComponent,
  TerminologyCapabilitiesImplementationComponent,
  _immutable,
  _requester,
  regionsStudied,
  _code,
  sourceMaterial,
  subrogation,
  _structureVersion,
  _priceComponent,
  management,
  _additionalInstruction,
  _managingEntity,
  patchFormat,
  proxyIdentityCertificate,
  DeviceVersionComponent,
  TaskRestrictionComponent,
  _frameOfReferenceUid,
  MedicinalProductDefinition,
  paternalOrganismId,
  averageMolecularFormula,
  EvidenceStatisticSampleSizeComponent,
  _occurred,
  definitionByCombination,
  _compositional,
  financial,
  _bodysite,
  sourceScope,
  parameter,
  lineItem,
  _businessArrangement,
  _ordinalPosition,
  dependency,
  DeviceUsage,
  sent,
  _associatedMedication,
  ParametersParameterComponentParameter,
  executionPeriod,
  _custodian,
  specification,
  HumanName,
  ObservationDefinitionComponentComponentQualifiedValue,
  _searchInclude,
  _technique,
  legalStatusOfSupply,
  short,
  generation,
  doseAndRate,
  _condition,
  _followUp,
  manufacturer,
  BiologicallyDerivedProductDispense,
  _seriesUid,
  relatesTo,
  temperatureQualifier,
  _PackagedProductDefinition,
  _correspondingContact,
  citeAs,
  _DeviceAssociation,
  requireBoth,
  provisionData,
  _characterization,
  criticality,
  ConditionDefinitionPlanComponent,
  canPushUpdates,
  _nTerminalModificationId,
  _regionsCalled,
  TestPlanTestCaseTestRunComponent,
  _productOrService,
  reviewOutcome,
  maxDispense,
  filterDefinition,
  sourceAttachment,
  provisionActor,
  NamingSystem,
  dateOfService,
  VisionPrescription,
  _unitPrice,
  resource,
  _response,
  _agent,
  contraindicatedVaccineCode,
  collector,
  enterer,
  _supportedInteraction,
  _differential,
  _qualifiedValue,
  ManufacturedItemDefinitionComponentConstituentComponent,
  _additionalMonitoringIndicator,
  _position,
  limit,
  _reason,
  _planningHorizon,
  _safety,
  Identifier,
  _mitigation,
  _specialCourtesy,
  ExampleScenarioInstanceContainedInstanceComponent,
  edit,
  qualitativeRisk,
  immunizationEvent,
  reference,
  reporter,
  BackboneElement,
  _hasMember,
  Provenance,
  reasonLinkId,
  owner: owner2,
  _assignedComparisonGroup,
  _Condition,
  ConsentPolicyBasisComponent,
  communicationMethod,
  _param,
  _power,
  _issue,
  concept,
  decisionMode,
  instantiatesUri,
  _ifMatch,
  sequenceType,
  _fastingStatus,
  preferredReportName,
  _numberOfSeries,
  rankingOrder,
  _currency,
  testTools,
  _warning,
  CoverageEligibilityResponseEventComponent,
  _characteristic,
  dataRequirement,
  _domain,
  InventoryReport,
  _parameterName,
  progressStatus,
  _narrative,
  Endpoint,
  subjectState,
  entry,
  _weeklyTemplate,
  what,
  whenPrepared,
  Action,
  _observationRequirement,
  focal,
  verification,
  _availability,
  resultingEffect,
  timeout,
  CapabilityStatementMessagingSupportedMessageComponent,
  _revenue,
  _returnedAmount,
  MedicationKnowledgeDefinitionalIngredientComponent,
  candidate,
  Subscription: Subscription2,
  relatedAction,
  textPresentation,
  _supplements,
  result: result2,
  policyText,
  _regionType,
  StratifierGroup,
  _contract,
  _timeFromEvent,
  notificationEvent,
  _inclusionCriteria,
  _orderMeaning,
  autodelete,
  qualifiers,
  _regionsStudied,
  _application,
  frequency,
  _sourceMaterial,
  regulatoryBasis,
  associationType,
  _software,
  _copolymerConnectivity,
  _approvalDate,
  totalVolume,
  AppointmentRecurrenceTemplateWeeklyTemplateComponent,
  _requestedPerformer,
  packagedProduct,
  tissue,
  isSubpotent,
  _supportingInfoSequence,
  _rating,
  maternalOrganismName,
  CommunicationRequest,
  polymer,
  initiatorActive,
  _productStatus,
  strand,
  _outputParameters,
  participantStatus,
  label,
  manipulated,
  _geometry,
  Coding,
  requisition,
  InventoryReportInventoryListingComponent,
  _parent,
  _net,
  presentation,
  flag,
  hoursOfOperation,
  encounter,
  applicability,
  releaseDate,
  _relationshipType,
  _managingOrganization,
  derivedFromCanonical,
  _hasSeverity,
  cTerminalModification,
  ContentDefinition,
  _bodyLandmarkOrientation,
  relationship: relationship2,
  goal,
  _connectivity,
  _listMode,
  _availableTime,
  property,
  _calibration,
  TerminologyCapabilitiesExpansionParameterComponent,
  adjustmentReason,
  AdministrableProductDefinitionRouteOfAdministrationTargetSpeciesComponent,
  Basic,
  _isDerived,
  hierarchical,
  _resultForCreate,
  _deviceName,
  _startDate,
  Attachment,
  _patientPreparation,
  CitationCitedArtifactPublicationFormComponent,
  windowStart,
  _propertyGroup,
  languageCode,
  _canPushUpdates,
  groupingBehavior,
  for__workaround,
  _studyUid,
  _event,
  informationProvider,
  network,
  _manufacturedDoseForm,
  assert,
  _warningOnly,
  isSummary,
  attachedDocument,
  _unit,
  _endDate,
  authoredOn,
  _geographicalLocation,
  CitationCitedArtifactClassificationComponent,
  userSelected,
  _prognosisCodeableConcept,
  dateCriterion,
  additionalInstruction,
  specialPrecautionsForStorage,
  population,
  _member,
  securityLabel,
  _renderedDosageInstruction,
  Notes,
  _dynamicValue,
  _confidentialityIndicator,
  _intendedUse,
  lastUpdated,
  deceased,
  NutritionOrderEnteralFormulaAdditiveComponent,
  designation,
  reportedDateTime,
  productOrServiceEnd,
  teardown,
  securityLabelNumber,
  _manufactureDate,
  _textFilter,
  _route,
  parentSubstanceName,
  _docStatus,
  ArtifactAssessmentContentComponentContentContent,
  _subscriber,
  workflowStatus,
  phylum,
  _mustSupport,
  forecastStatus,
  _closure,
  _abstract,
  relatedClinicalInformation,
  PersonCommunicationComponent,
  _relativePath,
  CitationCitedArtifactVersionComponent,
  _paging,
  _uniqueId,
  _readOnly,
  _jurisdiction,
  _treatment,
  _responsibleParty,
  RequestOrchestrationActionComponentActionAction,
  _role,
  TestPlanDependencyComponent,
  Binary,
  contentDerivative,
  inforce,
  RiskAssessmentPredictionComponent,
  _enteredDate,
  _legalStatusOfSupply,
  valueAlternatives,
  subject: subject3,
  _publicationDate,
  occurrenceChanged,
  _referralRequest,
  friday,
  productType,
  _payeeType,
  _fixed,
  _nTerminalModification,
  _progressStatus,
  _age,
  _verificationDate,
  CompartmentDefinitionResourceComponent,
  _questionnaire,
  TestScript,
  billingStatus,
  _resourceTrigger,
  compose,
  _submitter,
  _productReference,
  payment,
  rateAggregation,
  OrganizationQualificationComponent,
  identityCertificate,
  _subDetail,
  contextInvariant,
  _suffix,
  _recurrenceId,
  dispenseInterval,
  _map,
  _lensSpecification,
  allergyIntolerance,
  asset,
  CoverageEligibilityResponse,
  OperationDefinitionParameterComponentParameter,
  packagedMedicinalProduct,
  _count,
  SubstancePolymerRepeatRepeatUnitDegreeOfPolymerisationComponent,
  adjudication,
  RequestOrchestrationActionConditionComponent,
  validator,
  _gene,
  _length,
  series,
  maxDosePerAdministration,
  _performerRole,
  _balance,
  _correctiveAction,
  dispenser,
  NutritionOrderOralDietComponent,
  _meaning,
  endParam,
  _provider,
  inResponseTo,
  authorDescription,
  _intendedExposure,
  _cycle,
  ProvenanceEntityComponentAgent,
  high,
  _paymentStatus,
  TestScriptVariableComponent,
  _comparator,
  _instantiatesCanonical,
  class__workaround: class__workaround2,
  _countryOfOrigin,
  structuralRepresentation,
  _communicationMethod,
  _size,
  _averageMolecularFormula,
  _ingredientLabel,
  _landmarkDescription,
  _criticalCodedValueSet,
  unmapped,
  _productCategory,
  SubstanceReferenceInformationTargetComponent,
  _preferredReportName,
  _maternalOrganismId,
  _order,
  qualifier,
  recruitment,
  mitigation,
  Procedure,
  material,
  _packageId,
  address: address2,
  module,
  SubstanceNucleicAcidSubunitComponent,
  _healthcareService,
  check,
  _serviceProvisionCode,
  DeviceDefinitionHasPartComponent,
  hybrid,
  DeviceDefinitionPackagingComponentPackaging,
  extends__workaround,
  AdverseEventSupportingInfoComponent,
  _MedicationRequest,
  startingSequence,
  MedicationKnowledgeMonographComponent,
  DetectedIssue,
  targetLocation,
  MedicinalProductDefinitionCrossReferenceComponent,
  _alternateMaterial,
  _ordered,
  _List,
  _gateway,
  _effect,
  _coordinate,
  case__workaround,
  QuestionnaireItemComponentItem,
  DeviceConformsToComponent,
  PatientLinkComponent,
  testData,
  ProcedureFocalDeviceComponent,
  _typeCanonical,
  nodeId,
  CapabilityStatementSoftwareComponent,
  _preparation,
  _subType,
  _definitionCodeableConcept,
  benefitBalance,
  exclusionCriteria,
  numberOfStudies,
  start,
  AccountRelatedAccountComponent,
  _OperationOutcome,
  orientation,
  holder,
  _mitigatingAction,
  include,
  _conditionalPatch,
  NamingSystemUniqueIdComponent,
  _threshold,
  Count,
  _instantiates,
  media,
  appliesTo,
  _implementationGuide,
  RequestOrchestrationActionInputComponent,
  _discriminator,
  ClaimResponse,
  section,
  _workflowStatus,
  _DeviceMetric,
  diseaseSymptomProcedure,
  _keyword,
  _forecastStatus,
  Bundle,
  _excluded,
  _transform,
  intent,
  _slicing,
  generalPractitioner,
  gestationalAge,
  _account,
  _administeredProduct,
  answerOption,
  regionType,
  _association,
  _messaging,
  organismType,
  accept,
  _methodType,
  _authorizationRequired,
  includedStructure,
  sourceIdentityCertificate,
  foodType,
  temperatureRange,
  ManifestPage,
  DeviceRequest,
  _contextLinkId,
  ExampleScenarioProcessStepOperationComponent,
  SubstanceDefinitionStructureComponent,
  calculatedAt,
  MarketingStatus,
  _emptyReason,
  _offsets,
  _financial,
  _exposureRoute,
  _policyHolder,
  SupplyDeliverySuppliedItemComponent,
  intendedRoute,
  _paymentDate,
  GenomicStudyAnalysisDeviceComponent,
  _informationProvider,
  _outsideFoodAllowed,
  feature,
  needsMap,
  _dataAbsentReason,
  _definition,
  creation,
  _minValue,
  width: width2,
  _Permission,
  AllergyIntolerance,
  _Encounter,
  targetNumber,
  severity,
  ObservationDefinitionQualifiedValueComponent,
  filterBy,
  packaging,
  endorser,
  _relatesTo,
  _sourceSignature,
  abnormalCodedValueSet,
  lastOccurrenceDate,
  _securityLabelNumber,
  _queryCriteria,
  _multipleResultsAllowed,
  _allowed,
  _TestReport,
  _Location,
  deviceName,
  ImmunizationReactionComponent,
  ConceptMap,
  _daysOfWeek,
  ParameterDefinition,
  _packageCode,
  Insurance,
  lastPerformed,
  IngredientManufacturerComponent,
  nthWeekOfMonth,
  targetSpecies,
  authorization,
  _RequestOrchestration,
  _endpoint,
  triggeredBy,
  _Dosage,
  _doNotPerform,
  careTeam,
  _meta,
  TerminologyCapabilitiesCodeSystemVersionComponent,
  entryQuantity,
  CapabilityStatementMessagingEndpointComponent,
  nTerminalModification,
  _asNeededFor,
  _link,
  attribute,
  Note: Note2,
  textFilter,
  disposition,
  PackagedProductDefinition,
  Accident,
  _reference,
  StructureMapGroupRuleTargetParameterComponent,
  subscriber,
  structureType,
  _detail,
  meaningWhenMissing,
  modelCharacteristic,
  mapping,
  _Person,
  _eligibility,
  SubstanceSourceMaterialFractionDescriptionComponent,
  typeCollected,
  timestamp,
  _subpotentReason,
  _relatedMedicationKnowledge,
  _inventoryStatus,
  synonym,
  _category,
  _regulatory,
  birthDate,
  _priorPrescription,
  Base,
  _testTools,
  _targetLocation,
  substanceDefinition,
  _medication,
  _vaccineCode,
  _dateAsserted,
  DeviceDefinitionMaterialComponent,
  _codeSearch,
  range,
  NutritionOrder,
  _dispenserInstruction,
  _summary,
  _synthesisType,
  productName,
  _reviewOutcome,
  claimResponse,
  path,
  additive,
  ElementDefinition,
  fundingSource,
  instantiatesCanonical,
  family,
  NutritionIntake,
  EvidenceReport,
  billablePeriod,
  _otherTherapy,
  _dateOfService,
  _benefitBalance,
  _information,
  _CareTeam,
  _aggregateMethod,
  generatedBy,
  _tag,
  asserter,
  _revInclude,
  onset,
  criticalCodedValueSet,
  _mode,
  anchor,
  _substitution,
  _consent,
  _candidate,
  _concept,
  MeasureReportGroupStratifierStratumComponentComponent,
  ifNoneExist,
  GraphDefinitionNodeComponent,
  _answer,
  _schedule,
  administrationTreatment,
  _baseFormulaProductName,
  PermissionRuleDataResourceComponent,
  _gestationalAge,
  carrierAIDC,
  _capability,
  usageStatus,
  _knownAllergen,
  storageTempRequirements,
  definitionReference,
  experimental,
  _numberOfParticipants,
  _repeat,
  displayName,
  replaces: replaces2,
  _distanceFromLandmark,
  _frequency,
  shortDoco,
  ImagingSelection,
  modality,
  _targetId,
  _amount,
  species,
  totalNet,
  observationRequirement,
  InsurancePlanPlanGeneralCostComponent,
  InvoiceLineItemComponent,
  requestor,
  dietPreference,
  comparator,
  _combinedPharmaceuticalDoseForm,
  servicePeriod,
  _rater,
  receiverActive,
  modification,
  practitioner,
  _normalCodedValueSet,
  TestCaseDependency,
  _costToBeneficiary,
  MessageHeader,
  ResearchStudyRecruitmentComponent,
  _forenameInitials,
  plannedStartDate,
  study,
  groupIdentifier,
  _participatingOrganization,
  MeasureGroupStratifierComponent,
  wednesday,
  _diameter,
  enteralFormula,
  _stabilityDuration,
  integer,
  domain,
  _periodType,
  _ImagingStudy,
  searchRevInclude,
  _relatedAction,
  observed,
  born,
  _ImmunizationRecommendation,
  service,
  _requestIdentifier,
  maxDosePerLifetime,
  format: format3,
  _isSummary,
  supportingInfoSequence,
  EvidenceStatisticModelCharacteristicVariableComponent,
  ManufacturedItemDefinitionPropertyComponent,
  _concentration,
  coordinate,
  AddedItemDetailSubDetail,
  TerminologyCapabilitiesTranslationComponent,
  _generalPractitioner,
  _protocol,
  _exception,
  _complication,
  value,
  _nthWeekOfMonth,
  _url,
  SubstanceSourceMaterialOrganismHybridComponent,
  SubscriptionTopicEventTriggerComponent,
  MedicinalProductDefinitionNameComponent,
  SubstanceSourceMaterialOrganismComponent,
  overrideReason,
  pages,
  _conclusion,
  _combined,
  _contains,
  _documentType,
  MeasureGroupStratifierComponentComponent,
  _numberOfInstances,
  PlanDefinitionActionComponent,
  _processor,
  actualNumber,
  _network,
  effective,
  textEquivalent,
  preferred,
  ImplementationGuide,
  EvidenceReportRelatesToTargetComponent,
  _applicability,
  min,
  DeviceNameComponent,
  Payment,
  organismName,
  relative,
  Ratio,
  item,
  rating: rating2,
  _numerator,
  TestScriptScopeComponent,
  _aggregation,
  minutesDuration,
  AuditEventEntityComponent,
  rate,
  CompartmentDefinition,
  renderedDosageInstruction,
  methodType,
  parent,
  sourceId,
  _requestedPeriod,
  _chromosome,
  isSubPotent,
  presentedForm,
  repetitions,
  aggregate,
  EvidenceStatisticComponent,
  ImplementationGuideDefinitionParameterComponent,
  CompositionEventComponent,
  _NutritionOrder,
  TaskInputComponent,
  rule,
  Specimen,
  _MedicinalProductDefinition,
  OperationDefinition,
  process: process2,
  CitationCitedArtifactContributorshipEntryContributionInstanceComponent,
  EncounterAdmissionComponent,
  _MedicationDispense,
  translation,
  ObservationTriggeredByComponent,
  _etag,
  _dateCriterion,
  _administrationInstruction,
  part,
  _billablePeriod,
  requestHeader,
  _shortTitle,
  _securityLabel,
  _procedure,
  periodMax,
  monograph,
  _eventsSinceSubscriptionStart,
  QuestionnaireResponseItemAnswerComponent,
  formatted,
  restoreDate,
  _grouping,
  definition,
  BodyStructureIncludedStructureBodyLandmarkOrientationDistanceFromLandmarkComponent,
  dayOfWeek,
  _variableDefinition,
  nodeRole,
  Permission,
  dateWritten,
  ratioHighLimitAmount,
  _relatedData,
  _inforce,
  _reportingVendor,
  _sequenceRange,
  member,
  _versionAlgorithm,
  _subject,
  _case,
  _ClinicalUseDefinition,
  _cylinder,
  _saturday,
  ConceptMapGroupUnmappedComponent,
  Address: Address2,
  _validateCode,
  _dispenser,
  _issued,
  TestReport,
  conditionalRead,
  fullUrl,
  parameterFocus,
  _currentState,
  ActivityDefinition,
  daysOfWeek,
  containedInstance,
  StructureMapGroupRuleSourceComponent,
  application,
  received,
  AuditEventEntityComponentAgent,
  element,
  _compose,
  _environmentalSetting,
  _payment,
  _preparedDate,
  ImagingSelectionInstanceComponent,
  _responseRequired,
  _contraindication,
  _operator,
  ActivityDefinitionParticipantComponent,
  _contraindicatedVaccineCode,
  _membership,
  _recordedDate,
  _provision,
  _dietPreference,
  _laterality,
  _parentSubstanceId,
  _report,
  MedicationDispensePerformerComponent,
  FamilyMemberHistoryConditionComponent,
  _editor,
  instant,
  paging,
  _receiverActive,
  publicationForm,
  operation,
  organism,
  focus,
  _reviewer,
  validCodedValueSet,
  Signatory,
  clockFacePosition,
  _instanceReference,
  withdrawalPeriod,
  conformance,
  effectivePeriod,
  _matchStatus,
  virtualService,
  Communication,
  _enteralFormula,
  whenHandedOver,
  EvidenceReportSubjectComponent,
  substance,
  Section,
  _valueRange,
  regulatoryIdentifier,
  kind,
  hasIngredient,
  detailSequence,
  NutritionProductNutrientComponent,
  _fractionDescription,
  _degreeOfPolymerisation,
  _Account,
  rangeCategory,
  _index,
  ValueSetComposeComponentInclude,
  regulatory,
  _modifier,
  _short,
  medication,
  codeSearch,
  suffix,
  MedicationDispenseSubstitutionComponent,
  foodPreferenceModifier,
  Immunization,
  AppointmentRecurrenceTemplateMonthlyTemplateComponent,
  preventiveAction,
  _AdministrableProductDefinition,
  _deliverFrom,
  _address,
  intendedUse,
  ElementDefinitionSlicingDiscriminatorComponent,
  SubscriptionTopic,
  GenomicStudy,
  _partLocation,
  _subsumption,
  BenefitBalance,
  script,
  _resourceReference,
  lastReviewDate,
  SubstanceDefinitionNameComponentNameName,
  length,
  _overrideReason,
  _period,
  TerminologyCapabilities,
  _supportingPatientInformation,
  OperationDefinitionParameterBindingComponent,
  Task,
  MeasureReportGroupPopulationComponent,
  revInclude,
  _appliesTo,
  MedicationKnowledgeDefinitionalComponent,
  usageInstruction,
  trigger: trigger2,
  mustSupport,
  TimingRepeatComponent,
  effectiveDosePeriod,
  _textEquivalent,
  bodysite,
  _appliesToAll,
  comorbidity,
  TestScriptFixtureComponent,
  oligoNucleotideType,
  intendedEffect,
  _conformsTo,
  copyright,
  _insurance,
  _partDescription,
  _genomeBuild,
  Slot,
  _medium,
  followUp,
  maxDuration,
  lotNumber,
  EncounterHistoryLocationComponent,
  _owner,
  InventoryItem,
  content: content2,
  DeviceDefinitionPropertyComponent,
  enteredDate,
  _district,
  QuestionnaireItemComponentItemItem,
  eye,
  facilityType,
  markdown,
  _friendly,
  ManufacturedItemDefinitionComponentComponentComponent,
  basedOn,
  assessmentMethod,
  _sourceMaterialClass,
  CarePlanActivityComponent,
  response,
  _singleUse,
  ProvenanceAgentComponent,
  _kingdom,
  error,
  effect,
  verifiedWith,
  _packaging,
  position,
  EvidenceCertaintyComponentCertainty,
  low,
  _Device,
  AddedItemSubDetail,
  _responsible,
  excludingDate,
  _verified,
  TestScriptMetadataCapabilityComponent,
  marketingStatus,
  _ClaimResponse,
  request,
  MolecularSequenceRelativeEditComponent,
  periodType,
  approvalDate,
  _monomerSet,
  _eventTrigger,
  _ingredient,
  _biologicalSourceEvent,
  durationMax,
  _MolecularSequence,
  _permittedDataType,
  subtitle,
  _SubscriptionStatus,
  maxTreatmentPeriod,
  _relatedIdentifier,
  _feature,
  ValueSetExpansionComponent,
  _parameterFocus,
  _maxDosePerDay,
  CapabilityStatementMessagingComponent,
  ResearchStudyObjectiveComponent,
  MedicationIngredientComponent,
  SourceElement,
  _sequence,
  _validateProfileId,
  responsibility,
  containedItem,
  completionTime,
  _identifier,
  _scope,
  currency,
  _inputProfile,
  TestAction,
  _performer,
  QuestionnaireResponseItemComponentItemItem,
  _pushTypeAvailable,
  communication,
  interpretation,
  _capacity,
  topic,
  _undesirableEffect,
  _noteNumber,
  _DeviceRequest,
  courseOfTherapyType,
  ordinalPosition,
  ObservationComponentComponentReferenceRange,
  _actorId,
  conclusion,
  Resource,
  accountNumber,
  deliverTo,
  multipleResultsAllowed,
  _asNeeded,
  _onHold,
  genomeAssembly,
  _preAuthRefPeriod,
  itemSequence,
  _relatedClinicalInformation,
  ResearchStudy,
  _action,
  _DocumentReference,
  _coverageArea,
  DataType,
  Duration,
  _Consent,
  _referencePolicy,
  _virtualService,
  _lastModified,
  destination,
  _whenHandedOver,
  _typeTested,
  product,
  _referrer,
  plannedEndDate,
  _birthDate,
  _mustHaveValue,
  ClinicalUseDefinition,
  dynamicValue,
  _detailSequence,
  SupportingInformation,
  CitationStatusDateComponent,
  subscriberId,
  node,
  details,
  GenomicStudyAnalysisInputComponent,
  contract,
  _paymentIssuer,
  _clinicalTrial,
  Adjudication,
  AdverseEventMitigatingActionComponent,
  ratioType,
  authoritative,
  chromosome,
  referralMethod,
  MedicationKnowledgeDefinitionalDrugCharacteristicComponent,
  _filterParameter,
  _costCenter,
  _maternalOrganismName,
  _CommunicationRequest,
  _mapping,
  _spatialReference,
  _AppointmentResponse,
  preparation,
  _outcome,
  _policy,
  planningHorizon,
  _targetSpecies,
  EvidenceVariableCharacteristicComponent,
  _authorization,
  software,
  _lastReviewDate,
  _derivedFromCanonical,
  specialCourtesy,
  intraspecificType,
  shortTitle,
  channelType,
  _subSite,
  use,
  webLocation,
  PlanDefinitionGoalTargetComponent,
  _entryQuantity,
  _seriousness,
  _born,
  initiator,
  geometry,
  _organismGeneral,
  TestReportSetupComponent,
  message: message2,
  PlanDefinitionActionInputComponent,
  Dosage,
  _structureType,
  onAdmission,
  EncounterLocationComponent,
  statusHistory,
  CitationCitedArtifactComponent,
  _paymentTerms,
  _intendedEffect,
  SubstanceSourceMaterialOrganismAuthorComponent,
  listMode,
  _typeCollected,
  definitional,
  improvementNotation,
  ValuedItem,
  ElementDefinitionBaseComponent,
  Errors,
  pattern,
  TestScriptDestinationComponent,
  CoveragePaymentByComponent,
  _AuditEvent,
  requirements,
  authority,
  _compareToSourceId,
  _Contract,
  _occurrenceChanged,
  typeReference,
  detail,
  _alternative,
  ClaimResponseAdjudication,
  Person: Person2,
  readHistory,
  _subjects,
  membership,
  studyUid,
  GraphDefinitionLinkCompartmentComponent,
  _occurrence,
  _dayOfMonth,
  Extension,
  _proxyIdentityCertificate,
  emptyReason,
  ConceptMapGroupComponent,
  laterality,
  _previous,
  _claimResponse,
  dataUpdateType,
  paymentDate,
  baseFormulaProductName,
  performed,
  ServiceRequestOrderDetailComponent,
  _informationSequence,
  _wednesday,
  _id,
  nucleicAcid,
  implementation,
  _species,
  _goalId,
  manager,
  Meta,
  interpreter,
  situation,
  _recorded,
  DiagnosticReport,
  drugCharacteristic,
  SubstanceDefinitionStructureRepresentationComponent,
  RequestOrchestrationActionRelatedActionComponent,
  variableRole,
  failureAction,
  suppliedItem,
  abstract: abstract2,
  valueRange,
  _query,
  sigFormat,
  VirtualServiceDetail,
  _rest,
  packageCode,
  _reaction,
  _contributor,
  _normalValue,
  _resultsInterpreter,
  _tester,
  denominator,
  uniqueId,
  readOnly,
  _effectiveDosePeriod,
  _patientInstruction,
  focusReference,
  _sopClass,
  _brand,
  SubscriptionStatusNotificationEventComponent,
  specialArrangement,
  _autocreate,
  _responsibility,
  any,
  protocolApplied,
  PaymentNotice,
  _completionTime,
  _preAdmissionIdentifier,
  _interpretation,
  testingDestination,
  ExtendedContactDetail,
  administrableDoseForm,
  repeat: repeat2,
  CapabilityStatementRestResourceSearchParamComponent,
  interactant,
  _groupDefinition,
  _effective,
  _service,
  admitSource,
  _cap,
  _structure,
  _preferred,
  human,
  _genomeAssembly,
  _dimensions,
  Reason,
  eligibility,
  resultForCreate,
  PersonLinkComponent,
  EvidenceCertaintyComponent,
  texture,
  characterization,
  TerminologyCapabilitiesExpansionComponent,
  DataRequirementCodeFilterComponent,
  _derivedFrom,
  _doseAdministrationAid,
  productOrService,
  _plannedEndDate,
  conformsTo: conformsTo2,
  _detected,
  _threePrime,
  referencedFrom,
  targetFormat,
  _characteristicType,
  StructureDefinitionMappingComponent,
  _initiatorActive,
  supportedInteraction,
  vaccineCode,
  seriesNumber,
  pageCount,
  _who,
  PermissionRuleActivityComponent,
  careManager,
  CodeSystem,
  MedicinalProductDefinitionNamePartComponent,
  _requestingOrganization,
  _referralMethod,
  _suspectEntity,
  _exclusionCriteria,
  ObservationComponentComponent,
  _testScript,
  manufactureDate,
  _textPresentation,
  TestReportSetupActionOperationComponent,
  legal,
  provider: provider2,
  exitCriteria,
  image: image2,
  SupplyRequest,
  _periodMax,
  _monograph,
  _decision,
  _diagnostics,
  _origin,
  _durationUnit,
  contact: contact2,
  _disabledDisplay,
  _attestation,
  PackagedProductDefinitionPackagingComponentPackaging,
  OperationOutcomeIssueComponent,
  _hash,
  _pageString,
  _constituent,
  DeviceAssociation,
  _dayOfWeek,
  _inventoryListing,
  _hierarchyMeaning,
  _dispenseRequest,
  legallyBinding,
  _manufacturer,
  _answerConstraint,
  _when,
  _form,
  businessStatus,
  comparisonGroup,
  _instance,
  _itemStatus,
  _conditionalDelete,
  _grade,
  _process,
  _articleDate,
  additionalMonitoringIndicator,
  title: title3,
  _courseOfTherapyType,
  _identity,
  CapabilityStatementRestComponent,
  additionalAttribute,
  monomerSet,
  ingredient,
  _subPotentReason,
  _supportedMessage,
  DataRequirementDateFilterComponent,
  _performedActivity,
  _specialty,
  _weekInterval,
  publicationDate,
  administrationInstruction,
  fivePrime,
  _points,
  TestScriptSetupActionAssertComponent,
  referralRequest,
  _timeAspect,
  _presentedForm,
  _seriesDoses,
  milestone,
  MedicationAdministrationPerformerComponent,
  Invoice,
  additionalContext,
  _satisfiedBy,
  identifier: identifier3,
  SubstanceNucleicAcid,
  resourceTrigger,
  _overload,
  organization,
  PlanDefinitionActionConditionComponent,
  RegulatedAuthorizationCaseComponentCaseCase,
  sliceIsConstraining,
  _dataUpdateType,
  noteNumber,
  installDate,
  cardBrand,
  _fullUrl,
  codeMap,
  ConditionDefinitionObservationComponent,
  FamilyMemberHistory,
  operationTypeReason,
  SpecimenDefinitionTypeTestedContainerAdditiveComponent,
  _element,
  _attachedDocument,
  _implementation,
  sourceMaterialType,
  _substance,
  _qualification,
  _countType,
  sourceMaterialState,
  _observationResultRequirement,
  attestationSignature,
  PackagedProductDefinitionPackagingComponentPackagingPackaging,
  _marketingAuthorizationHolder,
  _decisionMode,
  repeats,
  typeTested,
  _rankingOrder,
  end,
  GenomicStudyAnalysisComponent,
  excluded,
  BundleEntryRequestComponent,
  DeviceDefinitionDeviceNameComponent,
  _eventNumber,
  FormularyItem,
  _marketDistribution,
  _searchParam,
  countryOfOrigin,
  AuditEventAgentComponent,
  _regulatoryAuthority,
  _subjectState,
  actualComparisonGroup,
  _focusReference,
  _statusReason,
  ingredientLabel,
  _whenPrepared,
  costCenter,
  outputParameters,
  DevicePropertyComponent,
  productCategory,
  serviceType,
  _verification,
  reliableCache,
  _Flag,
  numberAffected,
  StructureMapGroupRuleDependentComponent,
  relationshipType,
  _statement,
  _Goal,
  issued: issued2,
  _instruction,
  inclusionCriteria,
  about,
  Practitioner,
  prognosisCodeableConcept,
  AdverseEventParticipantComponent,
  _maxValue,
  ItemDetail,
  _hasBodySite,
  _metadata,
  rejectionCriterion,
  cors,
  _option,
  TypeRefComponent,
  minValue,
  _tuesday,
  _offset,
  report,
  _fhirPathCriteria,
  editor,
  _firstDose,
  procedureSequence,
  MedicinalProductDefinitionContactComponent,
  _Communication,
  _controller,
  TestScriptSetupActionAssertRequirementComponent,
  _allocation,
  otherTherapy,
  _requestedLocation,
  _referencedFrom,
  eventsSinceSubscriptionStart,
  _question,
  _drugCharacteristic,
  _total,
  AuditEvent,
  _environmentType,
  AssetContext,
  _rangeCategory,
  Location: Location2,
  rank,
  PlanDefinitionActionComponentActionAction,
  _occurrenceCount,
  entryType,
  _trigger,
  _contextInvariant,
  id: id2,
  _productionIdentifierInUDI,
  _variable,
  occurrence,
  dayOfMonth,
  _maxDosePerPeriod,
  _MeasureReport,
  MedicationKnowledgeCostComponent,
  uuid,
  _range,
  related,
  endpoint,
  ValueSetExpansionParameterComponent,
  _logMessage,
  SubscriptionTopicResourceTriggerQueryCriteriaComponent,
  _supportingImmunization,
  StructureMapConstComponent,
  NutritionIntakeConsumedItemComponent,
  PlanDefinitionGoalComponent,
  precondition,
  _CoverageEligibilityResponse,
  _duration,
  _routeOfAdministration,
  _legallyBinding,
  rendering,
  _hierarchical,
  _nameType,
  _businessStatus,
  _maxLength,
  SubstancePolymerRepeatComponent,
  responsibleParty,
  BundleEntryComponent,
  _input,
  _languageCode,
  _patient,
  direction,
  _publicationDateSeason,
  maritalStatus,
  AllergyIntoleranceReactionComponent,
  _observer,
  SubscriptionParameterComponent,
  doseAdministrationAid,
  DeviceDefinitionClassificationComponent,
  _measure,
  _maxDosePerAdministration,
  CompositionAttesterComponent,
  _valueFilter,
  studyDesign,
  _relation,
  _priority,
  MessageDefinition,
  _description,
  TestPlanTestCaseTestDataComponent,
  HealthcareServiceEligibilityComponent,
  category,
  Details,
  verificationDate,
  ExampleScenarioActorComponent,
  _specimenQuantity,
  DeviceDefinitionPackagingComponent,
  autocreate,
  _structuralRepresentation,
  agent: agent2,
  _request,
  _deliverTo,
  _textConcentration,
  benefitPeriod,
  SpecimenDefinitionTypeTestedContainerComponent,
  ServiceRequestPatientInstructionComponent,
  _adjustment,
  _guidance,
  productReference,
  _for,
  _intended,
  _additionalUse,
  MetadataResource,
  _startingSequence,
  MedicationStatement,
  medium: medium2,
  _baseUnit,
  _doseStatusReason,
  unitOfPresentation,
  CareTeam,
  sourceSignature,
  availableStartTime,
  _effectiveDate,
  _relevantHistory,
  ParametersParameterComponent,
  MessageDefinitionFocusComponent,
  EnrollmentResponse,
  ListEntryComponent,
  _subset,
  dimensions,
  _function,
  recommendation,
  _prescription,
  prognosisReference,
  _hint,
  _ownedBy,
  measurementFrequency,
  _traceNumber,
  _excludingDate,
  _required,
  correctiveAction,
  schedule,
  _referral,
  alternate,
  intendedExposure,
  threePrime,
  param,
  _proposedNewTime,
  power,
  cardinalityBehavior,
  supportingPatientInformation,
  _predecessor,
  allergenicIndicator,
  _regulator,
  issue,
  _admission,
  _extension,
  _notificationShape,
  Device,
  Range,
  ItemBodySite,
  average,
  SubstanceNucleicAcidSubunitSugarComponent,
  Composition,
  _otherMap,
  Rule,
  testScript,
  targetId,
  _additionalAttribute,
  _validity,
  _product,
  objective,
  _containedItem,
  MedicationKnowledgePackagingComponentCost,
  relatedDevice,
  QuestionnaireItemEnableWhenComponent,
  _numberAffected,
  _batch,
  preparationInstruction,
  EpisodeOfCare,
  _entity,
  _initiator,
  _communication,
  programEligibility,
  addItem,
  _details,
  pageString,
  expansion,
  MedicationKnowledgeRegulatoryComponent,
  _affiliation,
  _contentDefinition,
  marketPeriod,
  _reportingPeriod,
  _accountNumber,
  _geneSequenceOrigin,
  subpotentReason,
  inventoryStatus,
  subunit,
  orderer,
  ExampleScenarioInstanceVersionComponent,
  itemStatus,
  _ResearchStudy,
  resourceType,
  Quantity,
  contained,
  _appointmentType,
  SpecimenDefinitionTypeTestedComponent,
  _actual,
  CostToBeneficiary,
  _Schedule,
  programCode,
  _PractitionerRole,
  guarantor,
  _FamilyMemberHistory,
  _operationTypeReason,
  _programStatus,
  _performerLinkId,
  onHold,
  _copackagedIndicator,
  storageGuideline,
  _receiver,
  _whyStopped,
  _packageFor,
  action: action2,
  _sourceMaterialState,
  indicationGuideline,
  _interaction,
  aggregateMethod,
  _authorizingPrescription,
  _authoritative,
  timeAspect,
  _valueSet,
  OperationOutcome,
  Contributor,
  _message,
  import__workaround,
  definitionByTypeAndValue,
  TestScriptSetupActionOperationComponent,
  mitigatingAction,
  validationDate,
  healthcareService,
  conditionalPatch,
  minimumVolume,
  _practiceSetting,
  protocol,
  _structureProfile,
  _Coverage,
  _issuerType,
  MedicationRequest,
  _pattern,
  processingFacility,
  _situation,
  _patchFormat,
  alternateMaterial,
  responsible,
  PlanDefinitionActionRelatedActionComponent,
  _security,
  combined,
  contains,
  _addresses,
  expirationDate,
  compartment,
  _scoring,
  policy,
  recordedDate,
  _sourceScope,
  _chain,
  ImplementationGuideManifestComponent,
  _contributedToDeath,
  _diagnosisRelatedGroup,
  _referenceNumber,
  _template,
  _preConditions,
  _score,
  SubstancePolymerMonomerSetComponent,
  _requiredBehavior,
  _statusHistory,
  replacementSequence,
  _file,
  _height,
  _groupSize,
  observedGroup,
  receivedTime,
  _doseAndRate,
  definitionCanonical,
  QuestionnaireResponseItemComponent,
  _typeReference,
  PractitionerQualificationComponent,
  cTerminalModificationId,
  _requireBoth,
  dataAbsentReason,
  _criticality,
  _subjectStatus,
  _expiry,
  usage,
  city,
  _instances,
  stratum,
  MeasureReportGroupStratifierComponent,
  _ratioHighLimitAmount,
  route,
  TestScriptMetadataLinkComponent,
  DeviceDispensePerformerComponent,
  frequencyMax,
  _number,
  QuestionnaireResponse,
  MappingProperty,
  _securityContext,
  display,
  yearlyTemplate,
  ChargeItemPerformerComponent,
  Contact,
  EndpointPayloadComponent,
  _relatedArtifact,
  updateCreate,
  _subtype,
  _stereochemistry,
  _upperLimit,
  routeOfAdministration,
  _amountType,
  _organismType,
  bodySite,
  _moiety,
  _recommendation,
  grouping,
  _pause,
  _primaryPurposeType,
  ConceptSubProperty,
  subscription,
  _lastPage,
  partLocation,
  controller,
  publicationDateSeason,
  imports,
  allocation,
  _pageCount,
  _failureAction,
  profile,
  cylinder,
  deleted: deleted2,
  episodeOfCare,
  saturday,
  _expectedInResearchStudy,
  CommunicationRequestPayloadComponent,
  _calculatedAt,
  _impurity,
  type: type3,
  goalId,
  ObservationDefinitionComponentComponent,
  TestScriptSetupComponent,
  Appointment,
  _groupIdentifier,
  _countMax,
  patientCharacteristic,
  lowNumerator,
  _texture,
  _causality,
  operator,
  fixed,
  nTerminalModificationId,
  InventoryItemNameComponent,
  _minimumId,
  verificationStatus,
  _PaymentNotice,
  _dateAccessed,
  logMessage,
  ResearchStudyProgressStatusComponent,
  _residueSite,
  MonetaryComponent,
  TeardownAction,
  clinicalUseIssue,
  classification,
  _lifecycleStatus,
  signature,
  reviewer,
  _usePeriod,
  BodyStructureIncludedStructureComponent,
  next,
  _changeType,
  _ImmunizationEvaluation,
  requestingOrganization,
  _unitOfPresentation,
  requestedPeriod,
  Answer,
  count,
  ContractOffer,
  composition,
  _EnrollmentResponse,
  ConditionStageComponent,
  ResearchSubjectProgressComponent,
  key,
  assertion,
  MedicationKnowledgeIndicationGuidelineDosingGuidelinePatientCharacteristicComponent,
  alternative: alternative2,
  plan,
  _criteria,
  cycle,
  _latitude,
  modifier,
  _scoringUnit,
  subJurisdiction,
  _search,
  assignedComparisonGroup,
  _alias,
  _status,
  recurring,
  InventoryItemInstanceComponent,
  frameOfReferenceUid,
  _validationDate,
  NutritionOrderEnteralFormulaComponent,
  deliveryDevice,
  _cardBrand,
  adjustment,
  _cors,
  _allergenicIndicator,
  _timezone,
  _actor,
  valueQuantity,
  _versionId,
  requester,
  _SupplyRequest,
  MeasureTermComponent,
  _containedItemQuantity,
  _daysSupply,
  reportingVendor,
  current,
  uid: uid2,
  order,
  priorPrescription,
  distanceFromLandmark,
  VerificationResultValidatorComponent,
  _recurrenceTemplate,
  tenderedAmount,
  _diseaseStatus,
  _expirationDate,
  _dataPeriod,
  note,
  _manipulated,
  _Invoice,
  RatioRange,
  _requisition,
  ClinicalImpression,
  _claim,
  need,
  contributor: contributor3,
  ConceptProperty,
  ConsentVerificationComponent,
  TestReportTeardownComponent,
  _genus,
  extraDetails,
  _location,
  _reported,
  _codeMap,
  firstPage,
  _setup,
  _paymentBy,
  custodian,
  estimatedAge,
  _observation,
  technique,
  Requirements,
  supplementalData,
  SimpleQuantity,
  ProvenanceEntityComponent,
  condition,
  excludeFoodModifier,
  coverageArea,
  contributionInstance,
  _productCode,
  _language,
  base,
  _windowStart,
  district,
  forenameInitials,
  _state,
  friendly,
  AdditionalAttribute,
  _Transport,
  xhtml,
  _official,
  CodeSystemConceptDesignationComponent,
  _precedence,
  _result,
  _sliceName,
  points,
  finding,
  _yearlyTemplate,
  _isModifierReason,
  _experimental,
  _overbooked,
  ExampleScenario,
  AvailabilityNotAvailableTimeComponent,
  derivedFrom,
  _postalCode,
  _endorser,
  modifierExtension,
  verified,
  warning,
  _color,
  _global,
  _policyBasis,
  timeFromEvent,
  costToBeneficiary,
  Questionnaire,
  _FormularyItem,
  _permittedUnit,
  data,
  _targetItem,
  whyStopped,
  _practitioner,
  packageFor,
  _informationSource,
  hasMember,
  _paymentIdentifier,
  allowedType,
  _intraspecificType,
  _isDefault,
  _supportedProfile,
  _authored,
  stabilityDuration,
  InsurancePlanCoverageBenefitLimitComponent,
  compareToSourcePath,
  _dosageInstruction,
  sequence: sequence2,
  revenue,
  SystemInteraction,
  SubscriptionFilterByComponent,
  _requirement,
  _reliableCache,
  nextScheduled,
  MeasureGroupComponent,
  processNote,
  StratifierGroupPopulation,
  issuerType,
  capacity,
  _rendering,
  TestScriptTeardownComponent,
  requestIdentifier,
  _definitionCanonical,
  v,
  _classification,
  Claim,
  asNeeded,
  defaultManualCompletion,
  partDescription,
  articleDate,
  narrative,
  participant: participant2,
  incidence,
  div,
  _versioning,
  RelatedClaim,
  _page,
  appointment,
  AuditEventEntityDetailComponent,
  productionIdentifierInUDI,
  _photo,
  formOf,
  referrer,
  _subdetailSequence,
  CareTeamParticipantComponent,
  SpecimenDefinition,
  _affectsState,
  _inputPopulationId,
  outputProfile,
  MessageDefinitionAllowedResponseComponent,
  numberOfInstances,
  Term,
  supportingImmunization,
  previousAppointment,
  seriesDoses,
  propertyGroup,
  option,
  component,
  offset,
  materialType,
  marketingAuthorizationHolder,
  requestedPerformer,
  developmentStage,
  _deliveryDevice,
  _Timing,
  AdverseEventSuspectEntityCausalityComponent,
  add,
  ImmunizationPerformerComponent,
  _BodyStructure,
  _organismName,
  _monthlyTemplate,
  versionAlgorithm,
  _deliverFor,
  ElementDefinitionSlicingComponent,
  _responseId,
  _tenderedAmount,
  upperLimit,
  _verificationStatus,
  amountType,
  _patientPaid,
  RequestOrchestrationActionOutputComponent,
  _quantity,
  InsurancePlanPlanSpecificCostBenefitCostComponent,
  _alternate,
  _contributingFactor,
  _sourceIdentityCertificate,
  eventNumber,
  AdministrableProductDefinitionPropertyComponent,
  responseRequired,
  _verifiedBy,
  _maritalStatus,
  _timeOfDay,
  contraindication,
  patientPreparation,
  _expression,
  _min,
  _attester,
  _progress,
  _collection,
  base64Binary,
  ExampleScenarioProcessStepComponent,
  _comprisedOf,
  _factor,
  _endRelationship,
  _startingMaterial,
  expectedSupplyDuration,
  totalPriceComponent,
  _signer,
  enableBehavior,
  Contract,
  _cTerminalModificationId,
  ObservationReferenceRangeComponent,
  maxVolumeToDeliver,
  CapabilityStatementRestResourceOperationComponent,
  isDerived,
  conditionalUpdate,
  repeatUnitAmountType,
  subjects,
  EvidenceVariableCharacteristicTimeFromEventComponent,
  _expansion,
  _Ingredient,
  _phase,
  _benefitPeriod,
  Organization: Organization2,
  _referenceStrength,
  StructureMapGroupComponent,
  referencePolicy,
  previous,
  _stage,
  PlanDefinitionActionOutputComponent,
  _publisherLocation,
  MedicationKnowledgeIndicationGuidelineDosingGuidelineDosageComponent,
  containedItemQuantity,
  copyrightLabel,
  BodyStructureIncludedStructureBodyLandmarkOrientationComponent,
  hasBodySite,
  _valuedItem,
  Period: Period2,
  questionnaire,
  specificCost,
  _collected,
  _notAvailableTime,
  AllergyIntoleranceParticipantComponent,
  headerField,
  _contained,
  _assigner,
  _ifNoneMatch,
  DeviceAssociationOperationComponent,
  _graph,
  changeType,
  _orientation,
  parentSubstanceId,
  recorded,
  _contributionType,
  filterParameter,
  positiveInt,
  docStatus,
  CoverageBenefit,
  durationUnit,
  contentType,
  _addItem,
  MedicationKnowledgeIndicationGuidelineDosingGuidelineComponent,
  dateRange,
  used,
  _city,
  reaction,
  subset,
  performerRole,
  retentionTime,
  _ClinicalImpression,
  _generalCost,
  instanceReference,
  _history,
  molecularFormulaByMoiety,
  _orderer,
  _payee,
  _windowEnd,
  _maxDosePerTreatmentPeriod,
  sopClass,
  PlanDefinitionActorOptionComponent,
  ExampleScenarioInstanceComponent,
  organismGeneral,
  abatement,
  _relatedDevice,
  daysSupply,
  _legal,
  _EpisodeOfCare,
  _excludeFoodModifier,
  weekInterval,
  _measureScore,
  _const,
  _hybrid,
  PackagedProductDefinitionPackagingComponent,
  _prefix,
  _publicationDateText,
  ConceptSet,
  payeeType,
  _shelfLifeStorage,
  balance,
  _type,
  dataPeriod,
  _Immunization,
  resourceReference,
  _providedBy,
  _fhirVersion,
  _HealthcareService,
  submitter,
  description: description5,
  combinedPharmaceuticalDoseForm,
  _targetScope,
  Parameter,
  BiologicallyDerivedProduct,
  _GenomicStudy,
  _NutritionProduct,
  _additionalContext,
  version: version2,
  detected,
  _statistic,
  _bodyStructure,
  _definitionExpression,
  translations,
  _targetProfile,
  _notPerformedReason,
  ArtifactAssessmentContentComponent,
  cost,
  CanonicalResource,
  _authorizationSupporting,
  team,
  actual,
  landmarkDescription,
  typeCanonical,
  ArtifactAssessmentContentComponentContent,
  _organizationReference,
  _minimumVolume,
  precedence,
  CitationSummaryComponent,
  decision,
  role,
  maternalOrganismId,
  _triggeredBy,
  MedicationKnowledgeStorageGuidelineComponent,
  dischargeDisposition,
  _output,
  QuestionnaireItemComponent,
  _compareToSourcePath,
  traceNumber,
  InsurancePlanPlanComponent,
  object: object2,
  statusReason,
  recall,
  _codeSystem,
  _processing,
  gateway,
  _performerType,
  _subcomponent,
  postalCode,
  AddedItemDetail,
  instance,
  _disposition,
  _statusDate,
  _facilityType,
  _stratum,
  Payee,
  _measurementType,
  RelatedArtifact,
  RequestOrchestrationActionDynamicValueComponent,
  identity: identity2,
  subType,
  ValueSetExpansionContainsComponent,
  MedicationKnowledgePackagingComponent,
  _display,
  ImplementationGuideGlobalComponent,
  _SubstanceNucleicAcid,
  TestScriptSetupActionOperationRequestHeaderComponent,
  targetItem,
  _dosingGuideline,
  _totalGross,
  Reference,
  _precheckBehavior,
  _enableBehavior,
  slot,
  groupDefinition,
  _verifiedWith,
  ResourceInteraction,
  _numberOfSubunits,
  numberOfSeries,
  preAuthRefPeriod,
  _excludingRecurrenceId,
  _baseCitation,
  ContractAsset,
  ClinicalImpressionFindingComponent,
  stopTestOnFail,
  _selectionBehavior,
  _imports,
  contextLinkId,
  _eye,
  affiliation,
  defaultValue,
  MolecularSequence,
  overload,
  _productName,
  _comment,
  _profile,
  _deleted,
  _workflow,
  _attestationSignature,
  permittedDataType,
  gene,
  _prediction,
  exposureRoute,
  height: height2,
  _entryClassifier,
  test,
  _previousAppointment,
  implementationGuide,
  UsageContext,
  EventDefinition,
  relatedIdentifier,
  ImplementationGuideDependsOnComponent,
  _procedureSequence,
  _copyrightLabel,
  _navigationLinks,
  _generatedBy,
  administeredProduct,
  validateProfileId,
  MedicationKnowledgeIndicationGuidelineComponent,
  intraspecificDescription,
  _protocolApplied,
  _VerificationResult,
  monthInterval,
  expiry,
  versioning,
  pushTypeAvailable,
  CitationCitedArtifactStatusDateComponent,
  _assertion,
  diagnosis,
  _ifNoneExist,
  _low,
  undesirableEffect,
  _base,
  queryCriteria,
  _availableEndTime,
  number,
  spatialReference,
  conditionality,
  _codeFilter,
  SubstanceDefinitionCharacterizationComponent,
  offsets,
  _orderedBy,
  _authorizationUrl,
  _carrierAIDC,
  _episodeOfCare,
  disabledDisplay,
  DocumentReference,
  compositeScoring,
  _yearInterval,
  RelatedPersonCommunicationComponent,
  _displayName,
  _monday,
  messaging,
  geneElement,
  exclude,
  _itemSequence,
  _artifactAssessment,
  dispenseRequest,
  intendedJurisdiction,
  _restriction,
  ImmunizationEvaluation,
  Observation,
  _supplier,
  NutritionIntakePerformerComponent,
  CapabilityStatementRestComponentSearchParam,
  _SubstanceReferenceInformation,
  _CarePlan,
  AdverseEventPreventiveActionComponent,
  outsideFoodAllowed,
  _maxVolumeToDeliver,
  InventoryItemAssociationComponent,
  deliverFor,
  ElementDefinitionExampleComponent,
  _totalPriceComponent,
  _carrierHRF,
  _subProperty,
  allowed,
  _searchType,
  List,
  responseId,
  _defaultManualCompletion,
  _subscriberId,
  _groupingId,
  _protocolPerformed,
  subPotentReason,
  maxValue,
  _data,
  _disulfideLinkage,
  metadata,
  ConditionParticipantComponent,
  rationale,
  tax,
  _line,
  index,
  _firstPage,
  verifiedBy,
  _requestProvider,
  Diagnosis,
  _hybridType,
  _abnormalCodedValueSet,
  Encounter,
  expression,
  _current,
  BackboneType,
  collection,
  _family,
  _validated,
  question,
  _noMap,
  _comparisonGroup,
  EnrollmentRequest,
  _surfaceOrientation,
  prescription,
  _contributorship,
  synthesisType,
  _anchor,
  _suppress,
  _other,
  variable,
  MolecularSequenceRelativeComponent,
  Ingredient,
  _occurrenceDateTime,
  Annotation,
  SubstanceReferenceInformationGeneComponent,
  _valueQuantity,
  DeviceDefinitionCorrectiveActionComponent,
  OperationDefinitionParameterComponent,
  EvidenceVariableCharacteristicDefinitionByCombinationComponent,
  SpecimenDefinitionTypeTestedHandlingComponent,
  _testRun,
  compareToSourceId,
  _definitional,
  _testCase,
  _PaymentReconciliation,
  valuedItem,
  relatedItem,
  consumedItem,
  search,
  duration: duration3,
  status: status2,
  _context,
  _requirements,
  _subjectType,
  _use,
  udi,
  nameType,
  _producedFrom,
  _interval,
  summary: summary3,
  MedicinalProductDefinitionCharacteristicComponent,
  sex,
  AdministrableProductDefinition,
  SecurityLabel,
  SubstanceDefinitionRelationshipComponent,
  knownAllergen,
  knownDataCount,
  observer,
  _subtitle,
  accessionNumber,
  _finding,
  _style,
  relation: relation3,
  priority: priority2,
  _requestId,
  ElementDefinitionBindingComponent,
  sequenceAttachment,
  AddedItemBodySite,
  _group,
  publisher: publisher3,
  consent,
  site,
  canFilterBy,
  TerminologyCapabilitiesValidateCodeComponent,
  _isSubPotent,
  EncounterParticipantComponent,
  _cancellationReason,
  _repetitions,
  TestPlanTestCaseTestRunScriptComponent,
  distributor,
  _stopTestOnFail,
  organizationReference,
  residueSite,
  guidance,
  _originatingAppointment,
  intended,
  _measurementFrequency,
  _variableRole,
  assurance,
  literal,
  _suppliedItem,
  ProcedurePerformerComponent,
  baseUnit,
  _translation,
  StructureDefinitionSnapshotComponent,
  _name,
  MedicationRequestDispenseRequestInitialFillComponent,
  _incidence,
  _during,
  _snapshot,
  SubstancePolymerRepeatRepeatUnitComponent,
  _format,
  PlanBenefit,
  _foodPreferenceModifier,
  function__workaround,
  environmentType,
  SubscriptionTopicCanFilterByComponent,
  occurrenceCount,
  careTeamSequence,
  _notConsumedReason,
  _restoreDate,
  providedBy,
  meta,
  _subDetailSequence,
  required,
  _dateWritten,
  _deviceIdentifier,
  referral,
  _conditionality,
  AuditEventSourceComponent,
  _component,
  link,
  _hasStage,
  _contentReference,
  program,
  OtherElement,
  scoringUnit,
  _maxCount,
  ExplanationOfBenefitEventComponent,
  _ArtifactAssessment,
  scope,
  inventoryListing,
  concentration,
  _device,
  hierarchyMeaning,
  CapabilityStatementRestComponentOperation,
  otherMap,
  answerConstraint,
  normalCodedValueSet,
  global,
  excludingRecurrenceId,
  _SubstanceSourceMaterial,
  validity,
  subjectReport,
  _any,
  _nextScheduled,
  administration,
  sort,
  ManufacturedItemDefinitionComponentComponentProperty,
  _sent,
  _directnessMatch,
  _targetFormat,
  _used,
  _occurence,
  _partOf,
  relativeRisk,
  supportedMessage,
  _dateOfDiagnosis,
  _seriesNumber,
  DataRequirementSortComponent,
  ChargeItemDefinitionPropertyGroupComponentApplicability,
  codeSystem,
  processing,
  _ResearchSubject,
  _heartbeatPeriod,
  ValueSetExpansionPropertyComponent,
  orderDetail,
  Group: Group2,
  statusDate,
  uri,
  max,
  _conformance,
  _unitPriceComponent,
  _availabilityStatus,
  _exitCriteria,
  Schedule,
  BiologicallyDerivedProductCollectionComponent,
  DomainResource,
  _AdverseEvent,
  focalDevice,
  _authorType,
  mode: mode2,
  observation,
  _issuer,
  ClaimEventComponent,
  FamilyMemberHistoryParticipantComponent,
  _validationStatus,
  string,
  productCode,
  receiver,
  CitationCitedArtifactTitleComponent,
  totalGross,
  _outputProfile,
  conditionalDelete,
  baseDefinition,
  NutritionProductInstanceComponent,
  ClinicalUseDefinitionIndicationComponent,
  relevantHistory,
  referenceInformation,
  valueSet,
  library,
  InventoryReportInventoryListingItemComponent,
  performedActivity,
  Coverage,
  probability,
  TerminologyCapabilitiesSoftwareComponent,
  _activity,
  prediction,
  _mimeType,
  exception,
  ImplementationGuideDefinitionTemplateComponent,
  _edit,
  _usage,
  proposedNewTime,
  security,
  _parameter,
  InventoryItemDescriptionComponent,
  ConditionDefinitionPreconditionComponent,
  LocationPositionComponent,
  sequenceRange,
  policyBasis,
  _inputParameters,
  _dateRange,
  _cost,
  Timing,
  _team,
  _paternalOrganismId,
  _statusChanged,
  ActivityDefinitionDynamicValueComponent,
  processor,
  _constraint,
  _sampleSize,
  ClinicalUseDefinitionContraindicationComponent,
  _comorbidity,
  _knownDataCount,
  template,
  codeFilter,
  dateAccessed,
  _organization,
  _ifModifiedSince,
  _lastRevisionDate,
  _strength,
  numerator,
  _altitude,
  _countingDateTime,
  MedicationDispense,
  _maxDuration,
  requirement,
  SubstanceProteinSubunitComponent,
  _abatement,
  reportingPeriod,
  dosage,
  _supplement,
  _treatmentIntent,
  performingOrganization,
  _what,
  intervalUnit,
  preAuthPeriod,
  fhirPathCriteria,
  administeredBy,
  factor,
  ContactPoint,
  appointmentType,
  _collector,
  answerValueSet,
  _achievementStatus,
  carrierHRF,
  _evaluatedResource,
  signer,
  _usageReason,
  variableDefinition,
  manifestation,
  searchType,
  PaymentReconciliation,
  _modelNumber,
  groupingId,
  _VisionPrescription,
  performerLinkId,
  procedure,
  implicitRules,
  query,
  Items,
  _slot,
  _conditionalCreate,
  PatientCommunicationComponent,
  ConditionDefinitionMedicationComponent,
  documentation,
  maxDosePerTreatmentPeriod,
  example,
  _sessionKey,
  lastPage,
  hybridType,
  field,
  maxDosePerPeriod,
  _excludedStructure,
  _script,
  acceptLanguage,
  practiceSetting,
  brand,
  _attributeEstimate,
  _end,
  diagnosisSequence,
  _specification,
  _test,
  _durationMax,
  impurity,
  _Practitioner,
  SubstanceIngredientComponent,
  control,
  _enterer,
  TransportOutputComponent,
  _retentionTime,
  _encodeRequestUrl,
  countMax,
  _netContent,
  AccountBalanceComponent,
  _sequenceAttachment,
  requestedLocation,
  DeviceDefinitionRegulatoryIdentifierComponent,
  _target,
  _implicated,
  _administration,
  _flag,
  _party,
  _version,
  provision,
  patientPaid,
  referenceNumber,
  manifest,
  Account,
  _goal,
  _basis,
  MessageSource,
  _formCode,
  _disclaimer,
  _definitionByCombination,
  step,
  fractionDescription,
  valueCategory,
  requestMethod,
  BodySite,
  etag,
  specimenQuantity,
  comprisedOf,
  _pediatricUseIndicator,
  _destination,
  _evaluationMessage,
  ResearchStudyComparisonGroupComponent,
  _DomainResource,
  CitationCitedArtifactWebLocationComponent,
  beneficiary,
  prefix,
  effectiveTime,
  RegulatedAuthorizationCaseComponent,
  AccountProcedureComponent,
  doseStatusReason,
  ResearchStudyAssociatedPartyComponent,
  reason,
  _precondition,
  criteria,
  MedicationAdministrationDosageComponent,
  latitude: latitude2,
  IngredientSubstanceStrengthReferenceStrengthComponent,
  _thursday,
  securityContext,
  _baseDefinition,
  _publicationStatus,
  relatedArtifact,
  safety,
  stereochemistry,
  _timeout,
  primarySource,
  NutritionOrderOralDietNutrientComponent,
  responseCode,
  eventHistory,
  _doseForm,
  _allowedResponse,
  _storageGuideline,
  timezone,
  copolymerConnectivity,
  GenomicStudyAnalysisOutputComponent,
  _molecularWeight,
  ObservationDefinition,
  ifNoneMatch,
  _notConsumed,
  grade,
  OralDietSchedule,
  _diagnosis,
  _channelType,
  _encounter,
  SubstancePolymerMonomerSetStartingMaterialComponent,
  statisticType,
  _webLocation,
  SubstanceSourceMaterialOrganismOrganismGeneralComponent,
  textConcentration,
  _multipleAnd,
  _freeToShare,
  _contributionInstance,
  MedicationStatementAdherenceComponent,
  _onAdmission,
  output,
  _indication,
  DeviceDefinitionChargeItemComponent,
  location: location4,
  generalCost,
  _plannedActivityReference,
  rules,
  reported,
  maxDosePerDay,
  NutritionOrderOralDietTextureComponent,
  _definitionByTypeAndValue,
  GroupMemberComponent,
  _verificationType,
  _supportingInformation,
  kingdom,
  sourceMaterialClass,
  _polymer,
  insurance,
  _handling,
  supportingInfo,
  lifecycleStatus,
  _symptomConditionEffect,
  _fraction,
  language: language3,
  combining,
  country,
  isExample,
  _readHistory,
  BundleLinkComponent,
  currentLocation,
  official,
  _EncounterHistory,
  EvidenceVariableCategoryComponent,
  _administeredBy,
  _ProductShelfLife,
  SubstanceDefinitionMolecularWeightComponent,
  affectsState,
  notificationShape,
  descriptionSummary,
  _answerValueSet,
  PractitionerRole,
  _rationale,
  _ChargeItem,
  _offer,
  OperationDefinitionParameterReferencedFromComponent,
  singleUse,
  _exclude,
  fhirVersion,
  _nucleicAcid,
  CodeableConcept,
  _Claim,
  _site,
  targetScope,
  _monthInterval,
  _monitoringProgram,
  mustHaveValue,
  _interpreter,
  SubscriptionStatus,
  _productOrServiceEnd,
  doseQuantity,
  _prism,
  highNumerator,
  contentDefinition,
  due: due2,
  structureProfile,
  _acceptLanguage,
  _RegulatedAuthorization,
  authorType,
  paymentIssuer,
  clinicalTrial,
  _parentSubstanceName,
  _high,
  actorId,
  _document,
  _marketPeriod,
  _denominator,
  accessionIdentifier,
  VerificationResultPrimarySourceComponent,
  authored,
  serialNumber,
  Consent,
  _resourceType,
  outcomeMeasure,
  purpose,
  DiagnosticReportSupportingInfoComponent,
  Citation,
  _serviced,
  performer,
  _stratifier,
  InvoiceParticipantComponent,
  requiredBehavior,
  _oralDiet,
  monday,
  MedicationRequestDispenseRequestComponent,
  _subJurisdiction,
  _interactant,
  _admitSource,
  TargetElement,
  _given,
  _recorder,
  hasPart: hasPart2,
  _cancellationDate,
  supplements,
  constraint,
  total,
  outcome,
  sampleSize,
  ContributorshipSummary,
  PrimitiveType,
  caloricDensity,
  MedicationKnowledgeStorageGuidelineEnvironmentalSettingComponent,
  _clinicalUseIssue,
  LinkageItemComponent,
  AdministrableProductDefinitionRouteOfAdministrationComponent,
  _conditionalUpdate,
  _publisher,
  MolecularSequenceRelativeStartingSequenceComponent,
  _validator,
  _inactive,
  AppointmentResponse,
  _molecularFormula,
  payload,
  subSite,
  _sort,
  TestScriptOriginComponent,
  _allergyIntolerance,
  _identityCertificate,
  _additional,
  _assurance,
  _careManager,
  ImageRegion2D,
  forecastReason,
  supplement,
  _nutrient,
  _sugar,
  entryReference,
  _citedMedium,
  MeasureSupplementalDataComponent,
  input,
  ManufacturedItemDefinition,
  Prism,
  GroupCharacteristicComponent,
  _qualifier,
  GraphDefinition,
  _BiologicallyDerivedProduct,
  _Procedure,
  _receivedTime,
  quantity,
  _linkId,
  ManufacturedItemDefinitionComponentComponentComponentComponent,
  _prescriber,
  EvidenceReportSubjectCharacteristicComponent,
  hasSeverity,
  _estimate,
  certainty,
  _billingStatus,
  ContactDetail,
  sessionKey,
  calibration,
  _literal,
  ConditionDefinitionQuestionnaireComponent,
  _dateTime,
  CoverageEligibilityRequest,
  _repeatUnitAmountType,
  pediatricUseIndicator,
  SampledData,
  attester,
  originatingAppointment,
  progress,
  _frequencyMax,
  measureScore,
  InsurancePlanCoverageComponent,
  Evidence,
  _operationalStatus,
  ImagingSelectionPerformerComponent,
  restriction,
  _issues,
  dose,
  _updateCreate,
  _supportingInfo,
  warningOnly,
  _coverage,
  informationSequence,
  netContent,
  representation,
  _typeMode,
  subProperty,
  _subscription,
  Library,
  DeviceMetricCalibrationComponent,
  implicated,
  _actualGroup,
  _SubstanceProtein,
  _capabilities,
  _associatedParty,
  _supplementalData,
  _program,
  offeredIn,
  TerminologyCapabilitiesCodeSystemComponent,
  multipleBirth,
  _replacedSequence,
  disclaimer,
  InsurancePlan,
  _installDate,
  _extends,
  fundsReserve,
  assigner,
  SpecimenProcessingComponent,
  occurred,
  _lockedDate,
  GenomicStudyAnalysisPerformerComponent,
  _lowNumerator,
  _classifier,
  resultsInterpreter,
  _limit,
  _serviceProvider,
  patientInstruction,
  binding,
  recurrenceType,
  during,
  capability,
  Substance,
  suspectEntity,
  QuestionnaireItemInitialComponent,
  occurrenceDate,
  monthlyTemplate,
  supportingInformation,
  authorizationRequired,
  _versionReference,
  ImmunizationRecommendationRecommendationComponent,
  _measurementPoint,
  batch,
  _include,
  ValueSetComposeIncludeFilterComponent,
  subcomponent,
  _DetectedIssue,
  _GuidanceResponse,
  _participantType,
  _division,
  _section,
  _MedicationAdministration,
  _outcomeMeasure,
  PackagingDistributor,
  _serviceType,
  _subjectReport,
  _initialFill,
  _administrableDoseForm,
  areaOfHybridisation,
  subjectType,
  device,
  AddedItem,
  _region,
  MedicationKnowledgeRegulatorySubstitutionComponent,
  MeasureReportGroupComponent,
  _accident,
  endRelationship,
  structure,
  _library,
  _descriptionSummary,
  baseCitation,
  definitionId,
  _coordinateSystem,
  characteristicType,
  _entry,
  imageRegion2D,
  _DeviceDefinition,
  conclusionCode,
  BiologicallyDerivedProductDispensePerformerComponent,
  _caloricDensity,
  ManufacturedItemDefinitionComponentComponent,
  _focal,
  indication,
  _AllergyIntolerance,
  _publishedIn,
  partOf,
  _initialSelected,
  _key,
  backCurve,
  _path,
  definitionUri,
  ExplanationOfBenefitItemReviewOutcomeComponent,
  DetectedIssueMitigationComponent,
  _lastOccurrenceDate,
  _enableWhen,
  time,
  MedicinalProductDefinitionNameUsageComponent,
  ChargeItemDefinitionApplicabilityComponent,
  InventoryItemCharacteristicComponent,
  _dischargeDisposition,
  isModifierReason,
  StructureDefinitionContextComponent,
  _forecastReason,
  SubstanceDefinitionMoietyComponent,
  _step,
  rest,
  issuer,
  _nutritionProduct,
  SubstancePolymer,
  ValueSetComposeComponent,
  _doseNumber,
  SubstanceDefinitionNameComponent,
  derivedFromUri,
  _startParam,
  _attribute,
  _extraDetails,
  _accessionIdentifier,
  _entryReference,
  Parameters,
  ChargeItem,
  _uid,
  chain,
  _bodySite,
  qualification,
  yearInterval,
  _developmentStage,
  riskAdjustment,
  _estimatedAge,
  RequirementsStatementComponent,
  _intendedRoute,
  score,
  DeviceRequestParameterComponent,
  _diseaseSymptomProcedure,
  _validationProcess,
  ExampleScenarioProcessComponent,
  _timestamp,
  supportedProfile,
  TestReportSetupActionAssertComponent,
  _label,
  _preparationInstruction,
  InventoryItemResponsibleOrganizationComponent,
  informationType,
  BodyStructureIncludedStructure,
  _requesterLinkId,
  PlanDefinition,
  postConditions,
  EvidenceVariableDefinitionComponent,
  _meaningWhenMissing,
  DeviceDispense,
  _modelCharacteristic,
  SetupAction,
  _studyDesign,
  _analysis,
  insurancePlan,
  communicationRequest,
  specialty,
  _artifact,
  chargeItemCode,
  actuality,
  _maxParticipants,
  _Basic,
  _example,
  _representation,
  telecom,
  EvidenceCertaintyComponentCertaintyCertainty,
  _lastPerformed,
  _legalState,
  _preAuthPeriod,
  GraphDefinitionLinkComponent,
  workflow,
  _incomplete,
  _sphere,
  _substanceDefinition,
  informationSource,
  _periodUnit,
  paymentIdentifier,
  stratifier,
  pause,
  _isActive,
  _synonym,
  _manifestation,
  _control,
  RegulatedAuthorizationCaseComponentCase,
  dosageInstruction,
  _implicitRules,
  AvailabilityAvailableTimeComponent,
  SpecimenCollectionComponent,
  regulatoryAuthority,
  _EnrollmentRequest,
  hash,
  marketDistribution,
  countType,
  _documentation,
  association,
  _intendedJurisdiction,
  _recurrenceType,
  when,
  form,
  _complete,
  _shortDoco,
  differential,
  _occurrenceDate,
  additional,
  canonical,
  _actualComparisonGroup,
  _requestor,
  CommunicationPayloadComponent,
  AccountDiagnosisComponent,
  _doseStatus,
  TestScriptTestComponent,
  TaskOutputComponent,
  MeasureReport,
  producedFrom,
  tuesday,
  _sourceReference,
  crossReference,
  _Composition,
  subdetailSequence,
  _definitionReference,
  supplier,
  inputPopulationId,
  CarePlan,
  clinicalStatus,
  measurementType,
  ImplementationGuideDefinitionGroupingComponent,
  _fundingSource,
  _immunizationEvent,
  ClaimResponseEventComponent,
  statement,
  ImageRegion3D,
  _item,
  _repeatUnit,
  startingMaterial,
  _temperatureQualifier,
  dosingGuideline,
  _serviceCategory,
  _rate,
  _filterDefinition,
  prescriber,
  oid,
  _attachment,
  _sourceAttachment,
  _materialType,
  target: target2,
  _valueCategory,
  _requestMethod,
  linkage,
  DeviceUdiCarrierComponent,
  TerminologyCapabilitiesClosureComponent,
  _conclusionCode,
  _div,
  processingMode,
  _rule,
  StructureMap,
  _molecularFormulaByMoiety,
  firstDose,
  BundleEntryResponseComponent,
  structureVersion,
  alias,
  _programCode,
  _resultForDelete,
  grantee,
  _effectiveTime,
  definitionCodeableConcept,
  Property,
  entryClassifier,
  _combining,
  paternalOrganismName,
  _asset,
  PaymentReconciliationAllocationComponent,
  _part,
  actor: actor2,
  _isExample,
  navigationLinks,
  availability,
  _specimen,
  term,
  notAvailableTime,
  specimenRequirement,
  answer,
  _citation,
  patient,
  suppress,
  additionalUse,
  _maxDosePerLifetime,
  Distance,
  _primarySource,
  _opticalActivity,
  _multipleOr,
  _specialMeasures,
  usageReason,
  GoalTargetComponent,
  measure,
  contributionType,
  modelNumber,
  _derivedFromUri,
  _method,
  effectiveDate,
  _servicePeriod,
  asNeededFor,
  ExplanationOfBenefit,
  _add,
  _cancelledReason,
  orderMeaning,
  testCase,
  net,
  VerificationResultAttestationComponent,
  _class,
  claim,
  Flag: Flag2,
  _riskAdjustment,
  _compareToSourceExpression,
  _notificationEvent,
  guideline,
  amount,
  _dateFilter,
  _statisticType,
  genus,
  _MessageHeader,
  _administrationTreatment,
  _country,
  insurer,
  DeviceDefinitionLinkComponent,
  container,
  _params,
  Goal,
  lockedDate,
  symptomConditionEffect,
  referenceStrength,
  interval,
  _compartment,
  classifier,
  PackagedProductDefinitionPackagingPropertyComponent,
  setup,
  _areaOfHybridisation,
  maxLength,
  publisherLocation,
  RelatedPerson,
  _storageTempRequirements,
  _Organization,
  _postConditions,
  _DeviceDispense,
  state,
  SubstanceDefinitionSourceMaterialComponent,
  _aggregate,
  fluidConsistencyType,
  MoneyQuantity,
  _specificCost,
  _organismId,
  StructureMapGroupInputComponent,
  _check,
  _chargeItemCode,
  ownedBy,
  _participantStatus,
  _baseFormulaType,
  shelfLifeStorage,
  authorizingPrescription,
  protein,
  connectivity,
  information,
  DeviceDefinitionVersionComponent,
  AdverseEvent,
  _originRelationshipType,
  definitionExpression,
  ServiceRequestOrderDetailParameterComponent,
  TestPlan,
  requestProvider,
  _formatted,
  NutritionProduct,
  ActorDefinition,
  RegulatedAuthorization,
  _facility,
  sourceDocument,
  _morphology,
  _kind,
  color,
  _bounds,
  snapshot,
  SpecimenContainerComponent,
  unsignedInt,
  MedicationKnowledgeMedicineClassificationComponent,
  ImmunizationProgramEligibilityComponent,
  _dose,
  useBy,
  _start,
  _import,
  TaskPerformerComponent,
  grantor,
  _purpose,
  benefit,
  contributorship,
  PlanDefinitionActionDynamicValueComponent,
  ImagingStudySeriesComponent,
  programStatus,
  _evidence,
  ClinicalUseDefinitionInteractionInteractantComponent,
  _highNumerator,
  ChargeItemDefinitionPropertyGroupComponent,
  boolean,
  PackagedProductDefinitionProperty,
  _Group,
  _media,
  hasStage,
  TestReportSetupActionAssertRequirementComponent,
  _onBehalfOf,
  SubstanceReferenceInformationGeneElementComponent,
  maxCount,
  enableWhen,
  regulator,
  _medicineClassification,
  imageRegion3D,
  _source,
  _hoursOfOperation,
  admission,
  extension,
  _reAdmission,
  integer64,
  _Task,
  HealthcareService,
  _Appointment,
  _crossReference,
  _hasPart,
  _executionPeriod,
  Expression,
  Class,
  _operation,
  _adjustmentReason,
  notConsumed,
  relativePath,
  ImplementationGuideDefinitionComponent,
  geneSequenceOrigin,
  level,
  TestReportTestComponent,
  doseNumber,
  ParametersParameterComponentParameterParameter,
  age,
  _payload,
  entityRelatedness,
  startParam,
  _intraspecificDescription,
  _clinicalStatus,
  _compositeScoring,
  jurisdiction,
  Exemption,
  _requestHeader,
  _certainty,
  connectionType,
  _groupingBehavior,
  _translations,
  photo,
  multipleAnd,
  _gender,
  _coding,
  _system,
  _Slot,
  freeToShare,
  ElementDefinitionMappingComponent,
  copackagedIndicator,
  precheckBehavior,
  map: map2,
  additionalInfo,
  preConditions,
  numberOfSubunits,
  numberOfEvents,
  _sender,
  _validCodedValueSet,
  _referenceInformation,
  longitude: longitude2,
  _contentDerivative,
  _reportedDateTime,
  Primitive,
  _processingMode,
  _composition,
  _width,
  _valueAlternatives,
  hint,
  license: license2,
  created: created3,
  expectedInResearchStudy,
  originalPrescription,
  scoring,
  ClinicalUseDefinitionInteractionComponent,
  PlanDefinitionActorComponent,
  subjectStatus,
  _qualitativeRisk,
  _header,
  recurrenceId: recurrenceId2,
  _author,
  responsibleOrganization,
  TriggerDefinition,
  _BackboneElement,
  _offeredIn,
  _accessionNumber,
  legalState,
  incomplete,
  CodeableReference,
  activity,
  availableEndTime,
  mimeType,
  NutritionOrderEnteralFormulaAdministrationComponent,
  periodUnit,
  EvidenceReportRelatesToComponent,
  SubstanceDefinition,
  _useContext,
  _instantiatesUri,
  authorizationUrl,
  contributedToDeath,
  confidentialityIndicator,
  _diagnosisSequence,
  selectionBehavior,
  _time,
  addresses,
  _dataRequirement,
  CapabilityStatementRestResourceComponent,
  _lineItem,
  _InventoryReport,
  _copyright,
  _Substance,
  _timing,
  wasSubstituted,
  aggregation,
  _authorDescription,
  _filter,
  MedicinalProductDefinitionOperationComponent,
  _defaultValue,
  StructureMapStructureComponent,
  recipient,
  _lotNumber,
  QuestionnaireItemAnswerOptionComponent,
  applies,
  caseSensitive,
  subtype,
  _field,
  _hasIngredient,
  strength,
  linkId,
  StructureMapGroupRuleTargetComponent,
  _resultingEffect,
  altitude: altitude2,
  phase,
  _numberOfRepeatsAllowed,
  groupSize,
  _oligoNucleotideType,
  doseStatus,
  directnessMatch,
  AppointmentParticipantComponent,
  _continuous,
  _dispenseInterval,
  stage,
  associatedMedication,
  dateOfDiagnosis,
  _actualPeriod,
  ValueSet,
  lastOccurrence,
  disulfideLinkage,
  participatingOrganization,
  ResearchSubject,
  heartbeatPeriod,
  OrganizationAffiliation,
  _binding,
  SubstanceNucleicAcidSubunitLinkageComponent,
  ImplementationGuideDefinitionPageComponent,
  FamilyMemberHistoryProcedureComponent,
  subscriptionTopic,
  _resource,
  correspondingContact,
  graph: graph2,
  _QuestionnaireResponse,
  RequestOrchestrationActionComponentAction,
  issues,
  instances,
  _isDefining,
  primaryPurposeType,
  _specimenRequirement,
  _sourceDocument,
  SubstanceReferenceInformation,
  _multipleBirth,
  _InsurancePlan,
  repeatUnit,
  StructureDefinition,
  _node,
  TestPlanTestCaseAssertionComponent,
  relatedData,
  _content,
  _associationType,
  _regulatoryBasis,
  attachment: attachment2,
  ActionSubject,
  _packagedMedicinalProduct,
  _packagedProduct,
  _onset,
  _basedOn,
  CitationCitedArtifactRelatesToComponent,
  _backCurve,
  AuditEventOutcomeComponent,
  payee,
  _reporter,
  SubstanceDefinitionStructureComponentMolecularWeight,
  biologicalSourceEvent,
  RequestOrchestrationActionComponent,
  period,
  SearchParameterComponentComponent,
  protocolPerformed,
  ResearchStudyLabelComponent,
  _careTeamSequence,
  instantiates,
  _patientCharacteristic,
  _allowedType,
  Element,
  DeviceMetric,
  _maxTreatmentPeriod,
  _InventoryItem,
  AppointmentRecurrenceTemplateComponent,
  targetDisease,
  PlanDefinitionActionComponentAction,
  file,
  const__workaround,
  citedMedium,
  _frames,
  multipleOr,
  inputParameters,
  causality,
  SupplyDelivery,
  minimumId,
  _processNote,
  Money,
  _BackboneType,
  _Endpoint,
  udiDeviceIdentifier,
  EnteralFormulaSchedule,
  diseaseStatus,
  _expectedSupplyDuration,
  ifModifiedSince,
  formCode,
  _connectionType,
  ImplementationGuideDefinitionResourceComponent,
  _fundsReserveRequested,
  dateFilter,
  matchStatus,
  usePeriod,
  _participant,
  MessageDestination,
  _additionalInfo,
  _numberOfEvents,
  _includedStructure,
  _imageRegion2D,
  _tax,
  _appointment,
  treatmentIntent,
  SubstanceDefinitionCodeComponent,
  _study,
  _ratioType,
  policyHolder,
  region: region2,
  operationType,
  _actuality,
  _definitionUri,
  organismId,
  ManufacturedItemDefinitionComponentComponentComponentProperty,
  _consumedItem,
  thursday,
  _rules,
  dependent,
  deliverFrom,
  ImmunizationProtocolAppliedComponent,
  actualGroup,
  Age,
  subsumption,
  ElementDefinitionConstraintComponent,
  subjectResults,
  OperationDefinitionOverloadComponent,
  recurrenceTemplate,
  doseForm,
  adherence,
  ServiceRequest,
  deviceIdentifier,
  _reasonLinkId,
  versionId,
  componentPart,
  _value,
  TestReportParticipantComponent,
  morphology,
  date: date3,
  _isModifier,
  _allDay,
  contentReference,
  _sunday,
  DeviceUsageAdherenceComponent,
  maxSingleDose,
  referenceRange,
  _pages,
  DeviceDefinitionGuidelineComponent,
  _temperatureRange,
  _sequenceType,
  _partNumber,
  _term,
  StructureDefinitionDifferentialComponent,
  _udi,
  _telecom,
  CitationCitedArtifactPublicationFormPublishedInComponent,
  _wasSubstituted,
  initial,
  doNotPerform,
  diameter,
  _property,
  MessageHeaderResponseComponent,
  Linkage,
  permittedUnit,
  _sex,
  genomeBuild,
  changePattern,
  MedicationRequestSubstitutionComponent,
  _authority,
  onBehalfOf,
  _rateAggregation,
  managingOrganization,
  handling,
  notConsumedReason,
  axis,
  _udiCarrier,
  paymentBy,
  _insurancePlan,
  subDetailSequence,
  DataRequirementValueFilterComponent,
  problem,
  initialFill,
  _ManufacturedItemDefinition,
  _improvementNotation,
  ClinicalUseDefinitionIndicationComponentOtherTherapy,
  fraction,
  _lastOccurrence,
  _assessment,
  Patient,
  _identified,
  ExplanationOfBenefitAdjudication,
  _Subscription,
  tag: tag3,
  _performed,
  _formOf,
  DeviceDefinitionPackagingComponentPackagingPackaging,
  _subrogation,
  _deceased,
  relatedAccount,
  Transport,
  Measure,
  RiskAssessment,
  _teardown,
  degreeOfPolymerisation,
  _CoverageEligibilityRequest,
  _Medication,
  manufacturedDoseForm,
  sliceName,
  dateAsserted,
  ContractParty,
  validationStatus,
  TestScriptMetadataComponent,
  _headerField,
  geographicalLocation,
  versionNeeded,
  ConceptDefinition,
  _sigFormat,
  publishedIn,
  sphere,
  _SubstanceDefinition,
  SubstanceDefinitionNameOfficialComponent,
  _listRuleId,
  started,
  EvidenceVariable,
  ResearchStudyOutcomeMeasureComponent,
  allowedResponse,
  _ElementDefinition,
  CitationCitedArtifactContributorshipComponent,
  _contentType,
  _DeviceUsage,
  DeviceDefinitionUdiDeviceIdentifierComponent,
  document,
  event,
  Guarantor,
  molecularWeight,
  substitution,
  NutritionOrderSupplementComponent,
  _relativeRisk,
  _volume,
  _manager,
  _presentation,
  _linkage,
  isDefault,
  BodyStructure,
  _relationship,
  _maxDispense,
  ChargeItemDefinition,
  _SupplyDelivery,
  _specialArrangement,
  DosageDoseAndRateComponent,
  _guideline,
  _grantee,
  serviced,
  _active,
  _preference,
  useContext,
  _container,
  justification,
  oralDiet,
  _testingDestination,
  lastRevisionDate,
  NutritionIntakeIngredientLabelComponent,
  QuestionnaireResponseItemComponentItem,
  PermissionJustificationComponent,
  recorder,
  ImmunizationRecommendationRecommendationDateCriterionComponent,
  _focus,
  countingDateTime,
  MedicationKnowledge,
  ConditionDefinition,
  noMap,
  _userSelected,
  appointmentRequired,
  _numberOfStudies,
  capabilities,
  Benefit,
  _uri,
  _max,
  inactive,
  other,
  dependsOn,
  citedArtifact,
  fixture,
  _insurer,
  _endParam,
  continuous,
  SubstancePolymerRepeatRepeatUnitStructuralRepresentationComponent,
  _responsibleOrganization,
  url: url3,
  compareToSourceExpression,
  nutrient,
  _subjectResults,
  DocumentReferenceRelatesToComponent,
  ImagingStudy,
  AppointmentRecurrenceTemplateYearlyTemplateComponent,
  SpecimenFeatureComponent,
  _ServiceRequest,
  tester,
  seriousness,
  isDefining,
  contributingFactor,
  CapabilityStatement,
  _ImagingSelection,
  _unmapped,
  compositional,
  fundsReserveRequested,
  Total,
  _citeAs,
  _protein,
  _referenceRange,
  complication,
  SubscriptionTopicResourceTriggerComponent,
  estimate,
  _material,
  Item,
  encodeRequestUrl,
  _currentLocation,
  style,
  method: method2,
  _MarketingStatus,
  group,
  achievementStatus,
  evaluatedResource,
  _udiDeviceIdentifier,
  _RelatedPerson,
  dateTime,
  _intervalUnit,
  text,
  _contact,
  searchInclude,
  _fivePrime,
  timeOfDay,
  originRelationshipType,
  CitationClassificationComponent,
  _plannedStartDate,
  documentType,
  CoverageEligibilityRequestEventComponent,
  _milestone,
  page,
  params,
  regionsCalled,
  conditionalCreate,
  lensSpecification,
  _grantor,
  coverage: coverage3,
  authorizationSupporting,
  ElementDefinitionBindingAdditionalComponent,
  _benefit,
  _testData,
  _OrganizationAffiliation,
  excludedStructure,
  _searchRevInclude,
  serviceProvisionCode,
  typeMode,
  ValueSetScopeComponent,
  SupplyRequestParameterComponent,
  attributeEstimate,
  immutable,
  _relatedAccount,
  _RiskAssessment,
  BiologicallyDerivedProductPropertyComponent,
  _totalVolume,
  _adjudication,
  history,
  _isSubpotent,
  _longitude,
  _sliceIsConstraining,
  collected,
  medicineClassification,
  Signature,
  ConceptReference,
  TransportRestrictionComponent,
  _rank,
  _inResponseTo,
  CitationCitedArtifactAbstractComponent,
  _error,
  origin: origin3,
  treeRoot,
  _sourceMaterialType,
  bodyStructure,
  _releaseDate,
  normalValue,
  PractitionerCommunicationComponent,
  targetProfile,
  bounds,
  _op,
  OperationDefinitionParameterComponentParameterParameter,
  plannedActivityReference,
  _preAuthRef,
  _imageRegion3D,
  _object,
  DocumentReferenceAttesterComponent,
  _recall,
  fastingStatus,
  seriesUid,
  SubstanceSourceMaterialPartDescriptionComponent,
  _geneElement,
  publicationDateText,
  EpisodeOfCareStatusHistoryComponent,
  evaluationMessage,
  division,
  windowEnd,
  _foodType,
  _repeats,
  _Observation,
  validateCode,
  parameterName,
  source: source3,
  currentState,
  publicationStatus,
  _license,
  _created,
  ClinicalUseDefinitionContraindicationOtherTherapyComponent,
  isModifier,
  _needsMap,
  performerType,
  unitPrice,
  _topic,
  _lastUpdated,
  preparedDate,
  accident,
  code,
  _designation,
  _creation,
  verificationType,
  DeviceDefinitionPackagingComponentPackagingUdiDeviceIdentifier,
  _containedInstance,
  PackagedProductDefinitionLegalStatusOfSupplyComponent,
  _recipient,
  ifMatch,
  partNumber,
  _severity,
  _filterBy,
  _NutritionIntake,
  BundleEntrySearchComponent,
  _responseCode,
  _eventHistory,
  _rejectionCriterion,
  notPerformedReason,
  _entryType,
  EncounterHistory,
  _specialPrecautionsForStorage,
  SearchParameter,
  gender,
  coding,
  ProductShelfLife,
  system,
  _tissue,
  associatedParty,
  statistic,
  DataRequirement,
  MedicationKnowledgeRegulatoryMaxDispenseComponent,
  udiCarrier,
  Availability,
  sender,
  _strand,
  IngredientSubstanceStrengthComponent,
  MedicationKnowledgeMonitoringProgramComponent,
  _derivation,
  Condition,
  AdministrableProductDefinitionRouteOfAdministrationTargetSpeciesWithdrawalPeriodComponent,
  diagnostics,
  assessment,
  _clockFacePosition,
  attestation,
  identified
});

// ../node_modules/rdf-namespaces/dist/foaf-05174112.js
var Person3 = "http://xmlns.com/foaf/0.1/Person";
var Document2 = "http://xmlns.com/foaf/0.1/Document";
var Organization3 = "http://xmlns.com/foaf/0.1/Organization";
var Group3 = "http://xmlns.com/foaf/0.1/Group";
var Agent = "http://xmlns.com/foaf/0.1/Agent";
var Project = "http://xmlns.com/foaf/0.1/Project";
var Image2 = "http://xmlns.com/foaf/0.1/Image";
var PersonalProfileDocument = "http://xmlns.com/foaf/0.1/PersonalProfileDocument";
var OnlineAccount = "http://xmlns.com/foaf/0.1/OnlineAccount";
var OnlineGamingAccount = "http://xmlns.com/foaf/0.1/OnlineGamingAccount";
var OnlineEcommerceAccount = "http://xmlns.com/foaf/0.1/OnlineEcommerceAccount";
var OnlineChatAccount = "http://xmlns.com/foaf/0.1/OnlineChatAccount";
var mbox = "http://xmlns.com/foaf/0.1/mbox";
var mbox_sha1sum = "http://xmlns.com/foaf/0.1/mbox_sha1sum";
var gender2 = "http://xmlns.com/foaf/0.1/gender";
var geekcode = "http://xmlns.com/foaf/0.1/geekcode";
var dnaChecksum = "http://xmlns.com/foaf/0.1/dnaChecksum";
var sha1 = "http://xmlns.com/foaf/0.1/sha1";
var based_near = "http://xmlns.com/foaf/0.1/based_near";
var title4 = "http://xmlns.com/foaf/0.1/title";
var nick = "http://xmlns.com/foaf/0.1/nick";
var jabberID = "http://xmlns.com/foaf/0.1/jabberID";
var aimChatID = "http://xmlns.com/foaf/0.1/aimChatID";
var icqChatID = "http://xmlns.com/foaf/0.1/icqChatID";
var yahooChatID = "http://xmlns.com/foaf/0.1/yahooChatID";
var msnChatID = "http://xmlns.com/foaf/0.1/msnChatID";
var name3 = "http://xmlns.com/foaf/0.1/name";
var firstName = "http://xmlns.com/foaf/0.1/firstName";
var givenname = "http://xmlns.com/foaf/0.1/givenname";
var surname = "http://xmlns.com/foaf/0.1/surname";
var family_name = "http://xmlns.com/foaf/0.1/family_name";
var phone2 = "http://xmlns.com/foaf/0.1/phone";
var homepage = "http://xmlns.com/foaf/0.1/homepage";
var weblog = "http://xmlns.com/foaf/0.1/weblog";
var tipjar = "http://xmlns.com/foaf/0.1/tipjar";
var plan2 = "http://xmlns.com/foaf/0.1/plan";
var made = "http://xmlns.com/foaf/0.1/made";
var maker = "http://xmlns.com/foaf/0.1/maker";
var img = "http://xmlns.com/foaf/0.1/img";
var depiction = "http://xmlns.com/foaf/0.1/depiction";
var depicts = "http://xmlns.com/foaf/0.1/depicts";
var thumbnail = "http://xmlns.com/foaf/0.1/thumbnail";
var myersBriggs = "http://xmlns.com/foaf/0.1/myersBriggs";
var workplaceHomepage = "http://xmlns.com/foaf/0.1/workplaceHomepage";
var workInfoHomepage = "http://xmlns.com/foaf/0.1/workInfoHomepage";
var schoolHomepage = "http://xmlns.com/foaf/0.1/schoolHomepage";
var knows = "http://xmlns.com/foaf/0.1/knows";
var interest = "http://xmlns.com/foaf/0.1/interest";
var topic_interest = "http://xmlns.com/foaf/0.1/topic_interest";
var publications = "http://xmlns.com/foaf/0.1/publications";
var currentProject = "http://xmlns.com/foaf/0.1/currentProject";
var pastProject = "http://xmlns.com/foaf/0.1/pastProject";
var fundedBy = "http://xmlns.com/foaf/0.1/fundedBy";
var logo = "http://xmlns.com/foaf/0.1/logo";
var topic2 = "http://xmlns.com/foaf/0.1/topic";
var primaryTopic = "http://xmlns.com/foaf/0.1/primaryTopic";
var page2 = "http://xmlns.com/foaf/0.1/page";
var theme = "http://xmlns.com/foaf/0.1/theme";
var holdsAccount = "http://xmlns.com/foaf/0.1/holdsAccount";
var accountServiceHomepage = "http://xmlns.com/foaf/0.1/accountServiceHomepage";
var accountName = "http://xmlns.com/foaf/0.1/accountName";
var member2 = "http://xmlns.com/foaf/0.1/member";
var membershipClass = "http://xmlns.com/foaf/0.1/membershipClass";
var foafImport = /* @__PURE__ */ Object.freeze({
  Person: Person3,
  Document: Document2,
  Organization: Organization3,
  Group: Group3,
  Agent,
  Project,
  Image: Image2,
  PersonalProfileDocument,
  OnlineAccount,
  OnlineGamingAccount,
  OnlineEcommerceAccount,
  OnlineChatAccount,
  mbox,
  mbox_sha1sum,
  gender: gender2,
  geekcode,
  dnaChecksum,
  sha1,
  based_near,
  title: title4,
  nick,
  jabberID,
  aimChatID,
  icqChatID,
  yahooChatID,
  msnChatID,
  name: name3,
  firstName,
  givenname,
  surname,
  family_name,
  phone: phone2,
  homepage,
  weblog,
  tipjar,
  plan: plan2,
  made,
  maker,
  img,
  depiction,
  depicts,
  thumbnail,
  myersBriggs,
  workplaceHomepage,
  workInfoHomepage,
  schoolHomepage,
  knows,
  interest,
  topic_interest,
  publications,
  currentProject,
  pastProject,
  fundedBy,
  logo,
  topic: topic2,
  primaryTopic,
  page: page2,
  theme,
  holdsAccount,
  accountServiceHomepage,
  accountName,
  member: member2,
  membershipClass
});

// ../node_modules/rdf-namespaces/dist/http-8179cb74.js
var Message = "http://www.w3.org/2007/ont/http#Message";
var RequestMessage = "http://www.w3.org/2007/ont/http#RequestMessage";
var ResponseMessage = "http://www.w3.org/2007/ont/http#ResponseMessage";
var method3 = "http://www.w3.org/2007/ont/http#method";
var requestURI = "http://www.w3.org/2007/ont/http#requestURI";
var version3 = "http://www.w3.org/2007/ont/http#version";
var status3 = "http://www.w3.org/2007/ont/http#status";
var httpImport = /* @__PURE__ */ Object.freeze({
  Message,
  RequestMessage,
  ResponseMessage,
  method: method3,
  requestURI,
  version: version3,
  status: status3
});

// ../node_modules/rdf-namespaces/dist/hydra-a772aef4.js
var ApiDocumentation = "http://www.w3.org/ns/hydra/core#ApiDocumentation";
var BaseUriSource = "http://www.w3.org/ns/hydra/core#BaseUriSource";
var BasicRepresentation = "http://www.w3.org/ns/hydra/core#BasicRepresentation";
var Class2 = "http://www.w3.org/ns/hydra/core#Class";
var Collection2 = "http://www.w3.org/ns/hydra/core#Collection";
var Error__workaround2 = "http://www.w3.org/ns/hydra/core#Error";
var ExplicitRepresentation = "http://www.w3.org/ns/hydra/core#ExplicitRepresentation";
var HeaderSpecification = "http://www.w3.org/ns/hydra/core#HeaderSpecification";
var IriTemplate = "http://www.w3.org/ns/hydra/core#IriTemplate";
var IriTemplateMapping = "http://www.w3.org/ns/hydra/core#IriTemplateMapping";
var Link2 = "http://www.w3.org/ns/hydra/core#Link";
var Operation = "http://www.w3.org/ns/hydra/core#Operation";
var PartialCollectionView = "http://www.w3.org/ns/hydra/core#PartialCollectionView";
var Resource2 = "http://www.w3.org/ns/hydra/core#Resource";
var Rfc6570Template = "http://www.w3.org/ns/hydra/core#Rfc6570Template";
var Status = "http://www.w3.org/ns/hydra/core#Status";
var SupportedProperty = "http://www.w3.org/ns/hydra/core#SupportedProperty";
var TemplatedLink = "http://www.w3.org/ns/hydra/core#TemplatedLink";
var VariableRepresentation = "http://www.w3.org/ns/hydra/core#VariableRepresentation";
var apiDocumentation = "http://www.w3.org/ns/hydra/core#apiDocumentation";
var closedSet = "http://www.w3.org/ns/hydra/core#closedSet";
var collection2 = "http://www.w3.org/ns/hydra/core#collection";
var description6 = "http://www.w3.org/ns/hydra/core#description";
var entrypoint = "http://www.w3.org/ns/hydra/core#entrypoint";
var expects = "http://www.w3.org/ns/hydra/core#expects";
var expectsHeader = "http://www.w3.org/ns/hydra/core#expectsHeader";
var extension2 = "http://www.w3.org/ns/hydra/core#extension";
var first = "http://www.w3.org/ns/hydra/core#first";
var freetextQuery = "http://www.w3.org/ns/hydra/core#freetextQuery";
var headerName = "http://www.w3.org/ns/hydra/core#headerName";
var last2 = "http://www.w3.org/ns/hydra/core#last";
var limit2 = "http://www.w3.org/ns/hydra/core#limit";
var mapping2 = "http://www.w3.org/ns/hydra/core#mapping";
var member3 = "http://www.w3.org/ns/hydra/core#member";
var method4 = "http://www.w3.org/ns/hydra/core#method";
var next2 = "http://www.w3.org/ns/hydra/core#next";
var offset2 = "http://www.w3.org/ns/hydra/core#offset";
var operation2 = "http://www.w3.org/ns/hydra/core#operation";
var pageIndex = "http://www.w3.org/ns/hydra/core#pageIndex";
var pageReference = "http://www.w3.org/ns/hydra/core#pageReference";
var possibleStatus = "http://www.w3.org/ns/hydra/core#possibleStatus";
var possibleValue = "http://www.w3.org/ns/hydra/core#possibleValue";
var previous2 = "http://www.w3.org/ns/hydra/core#previous";
var property2 = "http://www.w3.org/ns/hydra/core#property";
var readable = "http://www.w3.org/ns/hydra/core#readable";
var required2 = "http://www.w3.org/ns/hydra/core#required";
var resolveRelativeUsing = "http://www.w3.org/ns/hydra/core#resolveRelativeUsing";
var returns = "http://www.w3.org/ns/hydra/core#returns";
var returnsHeader = "http://www.w3.org/ns/hydra/core#returnsHeader";
var search2 = "http://www.w3.org/ns/hydra/core#search";
var statusCode = "http://www.w3.org/ns/hydra/core#statusCode";
var supportedClass = "http://www.w3.org/ns/hydra/core#supportedClass";
var supportedOperation = "http://www.w3.org/ns/hydra/core#supportedOperation";
var supportedProperty = "http://www.w3.org/ns/hydra/core#supportedProperty";
var template2 = "http://www.w3.org/ns/hydra/core#template";
var title5 = "http://www.w3.org/ns/hydra/core#title";
var totalItems2 = "http://www.w3.org/ns/hydra/core#totalItems";
var variable2 = "http://www.w3.org/ns/hydra/core#variable";
var variableRepresentation = "http://www.w3.org/ns/hydra/core#variableRepresentation";
var view = "http://www.w3.org/ns/hydra/core#view";
var writable = "http://www.w3.org/ns/hydra/core#writable";
var hydraImport = /* @__PURE__ */ Object.freeze({
  ApiDocumentation,
  BaseUriSource,
  BasicRepresentation,
  Class: Class2,
  Collection: Collection2,
  Error__workaround: Error__workaround2,
  ExplicitRepresentation,
  HeaderSpecification,
  IriTemplate,
  IriTemplateMapping,
  Link: Link2,
  Operation,
  PartialCollectionView,
  Resource: Resource2,
  Rfc6570Template,
  Status,
  SupportedProperty,
  TemplatedLink,
  VariableRepresentation,
  apiDocumentation,
  closedSet,
  collection: collection2,
  description: description6,
  entrypoint,
  expects,
  expectsHeader,
  extension: extension2,
  first,
  freetextQuery,
  headerName,
  last: last2,
  limit: limit2,
  mapping: mapping2,
  member: member3,
  method: method4,
  next: next2,
  offset: offset2,
  operation: operation2,
  pageIndex,
  pageReference,
  possibleStatus,
  possibleValue,
  previous: previous2,
  property: property2,
  readable,
  required: required2,
  resolveRelativeUsing,
  returns,
  returnsHeader,
  search: search2,
  statusCode,
  supportedClass,
  supportedOperation,
  supportedProperty,
  template: template2,
  title: title5,
  totalItems: totalItems2,
  variable: variable2,
  variableRepresentation,
  view,
  writable
});

// ../node_modules/rdf-namespaces/dist/ldp-efa6e4d0.js
var Resource3 = "http://www.w3.org/ns/ldp#Resource";
var RDFSource = "http://www.w3.org/ns/ldp#RDFSource";
var NonRDFSource = "http://www.w3.org/ns/ldp#NonRDFSource";
var Container = "http://www.w3.org/ns/ldp#Container";
var BasicContainer = "http://www.w3.org/ns/ldp#BasicContainer";
var DirectContainer = "http://www.w3.org/ns/ldp#DirectContainer";
var IndirectContainer = "http://www.w3.org/ns/ldp#IndirectContainer";
var hasMemberRelation = "http://www.w3.org/ns/ldp#hasMemberRelation";
var isMemberOfRelation = "http://www.w3.org/ns/ldp#isMemberOfRelation";
var membershipResource = "http://www.w3.org/ns/ldp#membershipResource";
var insertedContentRelation = "http://www.w3.org/ns/ldp#insertedContentRelation";
var member4 = "http://www.w3.org/ns/ldp#member";
var contains2 = "http://www.w3.org/ns/ldp#contains";
var constrainedBy = "http://www.w3.org/ns/ldp#constrainedBy";
var pageSortCriteria = "http://www.w3.org/ns/ldp#pageSortCriteria";
var PageSortCriterion = "http://www.w3.org/ns/ldp#PageSortCriterion";
var pageSortPredicate = "http://www.w3.org/ns/ldp#pageSortPredicate";
var pageSortOrder = "http://www.w3.org/ns/ldp#pageSortOrder";
var pageSortCollation = "http://www.w3.org/ns/ldp#pageSortCollation";
var Page2 = "http://www.w3.org/ns/ldp#Page";
var pageSequence = "http://www.w3.org/ns/ldp#pageSequence";
var inbox = "http://www.w3.org/ns/ldp#inbox";
var ldpImport = /* @__PURE__ */ Object.freeze({
  Resource: Resource3,
  RDFSource,
  NonRDFSource,
  Container,
  BasicContainer,
  DirectContainer,
  IndirectContainer,
  hasMemberRelation,
  isMemberOfRelation,
  membershipResource,
  insertedContentRelation,
  member: member4,
  contains: contains2,
  constrainedBy,
  pageSortCriteria,
  PageSortCriterion,
  pageSortPredicate,
  pageSortOrder,
  pageSortCollation,
  Page: Page2,
  pageSequence,
  inbox
});

// ../node_modules/rdf-namespaces/dist/link-247081ec.js
var Access2 = "http://www.w3.org/2007/ont/link#Access";
var Document3 = "http://www.w3.org/2007/ont/link#Document";
var Mailbox = "http://www.w3.org/2007/ont/link#Mailbox";
var ProtocolEvent = "http://www.w3.org/2007/ont/link#ProtocolEvent";
var RDFDocument = "http://www.w3.org/2007/ont/link#RDFDocument";
var Response = "http://www.w3.org/2007/ont/link#Response";
var Session3 = "http://www.w3.org/2007/ont/link#Session";
var isMentionedIn = "http://www.w3.org/2007/ont/link#isMentionedIn";
var mentionsClass = "http://www.w3.org/2007/ont/link#mentionsClass";
var protocol2 = "http://www.w3.org/2007/ont/link#protocol";
var redirectedRequest = "http://www.w3.org/2007/ont/link#redirectedRequest";
var requestedBy = "http://www.w3.org/2007/ont/link#requestedBy";
var requestedURI = "http://www.w3.org/2007/ont/link#requestedURI";
var response2 = "http://www.w3.org/2007/ont/link#response";
var session = "http://www.w3.org/2007/ont/link#session";
var source4 = "http://www.w3.org/2007/ont/link#source";
var status4 = "http://www.w3.org/2007/ont/link#status";
var testDataset = "http://www.w3.org/2007/ont/link#testDataset";
var uri2 = "http://www.w3.org/2007/ont/link#uri";
var linkImport = /* @__PURE__ */ Object.freeze({
  Access: Access2,
  Document: Document3,
  Mailbox,
  ProtocolEvent,
  RDFDocument,
  Response,
  Session: Session3,
  isMentionedIn,
  mentionsClass,
  protocol: protocol2,
  redirectedRequest,
  requestedBy,
  requestedURI,
  response: response2,
  session,
  source: source4,
  status: status4,
  testDataset,
  uri: uri2
});

// ../node_modules/rdf-namespaces/dist/log-2f5c4638.js
var Chaff = "http://www.w3.org/2000/10/swap/log#Chaff";
var Formula = "http://www.w3.org/2000/10/swap/log#Formula";
var List2 = "http://www.w3.org/2000/10/swap/log#List";
var N3Document = "http://www.w3.org/2000/10/swap/log#N3Document";
var Other = "http://www.w3.org/2000/10/swap/log#Other";
var String__workaround = "http://www.w3.org/2000/10/swap/log#String";
var Truth = "http://www.w3.org/2000/10/swap/log#Truth";
var conclusion2 = "http://www.w3.org/2000/10/swap/log#conclusion";
var conjunction = "http://www.w3.org/2000/10/swap/log#conjunction";
var content3 = "http://www.w3.org/2000/10/swap/log#content";
var definitiveDocument = "http://www.w3.org/2000/10/swap/log#definitiveDocument";
var definitiveService = "http://www.w3.org/2000/10/swap/log#definitiveService";
var dtlit = "http://www.w3.org/2000/10/swap/log#dtlit";
var equalTo = "http://www.w3.org/2000/10/swap/log#equalTo";
var implies = "http://www.w3.org/2000/10/swap/log#implies";
var includes = "http://www.w3.org/2000/10/swap/log#includes";
var n3String = "http://www.w3.org/2000/10/swap/log#n3String";
var notEqualTo = "http://www.w3.org/2000/10/swap/log#notEqualTo";
var notIncludes = "http://www.w3.org/2000/10/swap/log#notIncludes";
var outputString = "http://www.w3.org/2000/10/swap/log#outputString";
var parsedAsN3 = "http://www.w3.org/2000/10/swap/log#parsedAsN3";
var racine = "http://www.w3.org/2000/10/swap/log#racine";
var rawType = "http://www.w3.org/2000/10/swap/log#rawType";
var rawUri = "http://www.w3.org/2000/10/swap/log#rawUri";
var semantics = "http://www.w3.org/2000/10/swap/log#semantics";
var semanticsOrError = "http://www.w3.org/2000/10/swap/log#semanticsOrError";
var uri3 = "http://www.w3.org/2000/10/swap/log#uri";
var logImport = /* @__PURE__ */ Object.freeze({
  Chaff,
  Formula,
  List: List2,
  N3Document,
  Other,
  String__workaround,
  Truth,
  conclusion: conclusion2,
  conjunction,
  content: content3,
  definitiveDocument,
  definitiveService,
  dtlit,
  equalTo,
  implies,
  includes,
  n3String,
  notEqualTo,
  notIncludes,
  outputString,
  parsedAsN3,
  racine,
  rawType,
  rawUri,
  semantics,
  semanticsOrError,
  uri: uri3
});

// ../node_modules/rdf-namespaces/dist/meeting-e6ab1dbe.js
var Meeting = "http://www.w3.org/ns/pim/meeting#Meeting";
var VideoCallPage = "http://www.w3.org/ns/pim/meeting#VideoCallPage";
var actionItems = "http://www.w3.org/ns/pim/meeting#actionItems";
var agenda = "http://www.w3.org/ns/pim/meeting#agenda";
var attendeeGroup = "http://www.w3.org/ns/pim/meeting#attendeeGroup";
var chat = "http://www.w3.org/ns/pim/meeting#chat";
var nextMeeting = "http://www.w3.org/ns/pim/meeting#nextMeeting";
var previousMeeting = "http://www.w3.org/ns/pim/meeting#previousMeeting";
var sharedNotes = "http://www.w3.org/ns/pim/meeting#sharedNotes";
var toolList = "http://www.w3.org/ns/pim/meeting#toolList";
var trip = "http://www.w3.org/ns/pim/meeting#trip";
var videoCallPage = "http://www.w3.org/ns/pim/meeting#videoCallPage";
var meetingImport = /* @__PURE__ */ Object.freeze({
  Meeting,
  VideoCallPage,
  actionItems,
  agenda,
  attendeeGroup,
  chat,
  nextMeeting,
  previousMeeting,
  sharedNotes,
  toolList,
  trip,
  videoCallPage
});

// ../node_modules/rdf-namespaces/dist/owl-4d58e757.js
var AllDifferent = "http://www.w3.org/2002/07/owl#AllDifferent";
var AllDisjointClasses = "http://www.w3.org/2002/07/owl#AllDisjointClasses";
var AllDisjointProperties = "http://www.w3.org/2002/07/owl#AllDisjointProperties";
var Annotation2 = "http://www.w3.org/2002/07/owl#Annotation";
var AnnotationProperty = "http://www.w3.org/2002/07/owl#AnnotationProperty";
var AsymmetricProperty = "http://www.w3.org/2002/07/owl#AsymmetricProperty";
var Axiom = "http://www.w3.org/2002/07/owl#Axiom";
var Class3 = "http://www.w3.org/2002/07/owl#Class";
var DataRange = "http://www.w3.org/2002/07/owl#DataRange";
var DatatypeProperty = "http://www.w3.org/2002/07/owl#DatatypeProperty";
var DeprecatedClass = "http://www.w3.org/2002/07/owl#DeprecatedClass";
var DeprecatedProperty = "http://www.w3.org/2002/07/owl#DeprecatedProperty";
var FunctionalProperty = "http://www.w3.org/2002/07/owl#FunctionalProperty";
var InverseFunctionalProperty = "http://www.w3.org/2002/07/owl#InverseFunctionalProperty";
var IrreflexiveProperty = "http://www.w3.org/2002/07/owl#IrreflexiveProperty";
var NamedIndividual = "http://www.w3.org/2002/07/owl#NamedIndividual";
var NegativePropertyAssertion = "http://www.w3.org/2002/07/owl#NegativePropertyAssertion";
var Nothing = "http://www.w3.org/2002/07/owl#Nothing";
var ObjectProperty = "http://www.w3.org/2002/07/owl#ObjectProperty";
var Ontology = "http://www.w3.org/2002/07/owl#Ontology";
var OntologyProperty = "http://www.w3.org/2002/07/owl#OntologyProperty";
var ReflexiveProperty = "http://www.w3.org/2002/07/owl#ReflexiveProperty";
var Restriction = "http://www.w3.org/2002/07/owl#Restriction";
var SymmetricProperty = "http://www.w3.org/2002/07/owl#SymmetricProperty";
var TransitiveProperty = "http://www.w3.org/2002/07/owl#TransitiveProperty";
var Thing2 = "http://www.w3.org/2002/07/owl#Thing";
var allValuesFrom = "http://www.w3.org/2002/07/owl#allValuesFrom";
var annotatedProperty = "http://www.w3.org/2002/07/owl#annotatedProperty";
var annotatedSource = "http://www.w3.org/2002/07/owl#annotatedSource";
var annotatedTarget = "http://www.w3.org/2002/07/owl#annotatedTarget";
var assertionProperty = "http://www.w3.org/2002/07/owl#assertionProperty";
var bottomDataProperty = "http://www.w3.org/2002/07/owl#bottomDataProperty";
var bottomObjectProperty = "http://www.w3.org/2002/07/owl#bottomObjectProperty";
var cardinality = "http://www.w3.org/2002/07/owl#cardinality";
var complementOf = "http://www.w3.org/2002/07/owl#complementOf";
var datatypeComplementOf = "http://www.w3.org/2002/07/owl#datatypeComplementOf";
var differentFrom = "http://www.w3.org/2002/07/owl#differentFrom";
var disjointUnionOf = "http://www.w3.org/2002/07/owl#disjointUnionOf";
var disjointWith = "http://www.w3.org/2002/07/owl#disjointWith";
var distinctMembers = "http://www.w3.org/2002/07/owl#distinctMembers";
var equivalentClass = "http://www.w3.org/2002/07/owl#equivalentClass";
var equivalentProperty = "http://www.w3.org/2002/07/owl#equivalentProperty";
var hasKey = "http://www.w3.org/2002/07/owl#hasKey";
var hasSelf = "http://www.w3.org/2002/07/owl#hasSelf";
var hasValue = "http://www.w3.org/2002/07/owl#hasValue";
var intersectionOf = "http://www.w3.org/2002/07/owl#intersectionOf";
var inverseOf = "http://www.w3.org/2002/07/owl#inverseOf";
var maxCardinality = "http://www.w3.org/2002/07/owl#maxCardinality";
var maxQualifiedCardinality = "http://www.w3.org/2002/07/owl#maxQualifiedCardinality";
var members = "http://www.w3.org/2002/07/owl#members";
var minCardinality = "http://www.w3.org/2002/07/owl#minCardinality";
var minQualifiedCardinality = "http://www.w3.org/2002/07/owl#minQualifiedCardinality";
var onClass = "http://www.w3.org/2002/07/owl#onClass";
var onDataRange = "http://www.w3.org/2002/07/owl#onDataRange";
var onDatatype = "http://www.w3.org/2002/07/owl#onDatatype";
var oneOf2 = "http://www.w3.org/2002/07/owl#oneOf";
var onProperties = "http://www.w3.org/2002/07/owl#onProperties";
var onProperty = "http://www.w3.org/2002/07/owl#onProperty";
var propertyChainAxiom = "http://www.w3.org/2002/07/owl#propertyChainAxiom";
var propertyDisjointWith = "http://www.w3.org/2002/07/owl#propertyDisjointWith";
var qualifiedCardinality = "http://www.w3.org/2002/07/owl#qualifiedCardinality";
var sameAs = "http://www.w3.org/2002/07/owl#sameAs";
var someValuesFrom = "http://www.w3.org/2002/07/owl#someValuesFrom";
var sourceIndividual = "http://www.w3.org/2002/07/owl#sourceIndividual";
var targetIndividual = "http://www.w3.org/2002/07/owl#targetIndividual";
var targetValue = "http://www.w3.org/2002/07/owl#targetValue";
var topDataProperty = "http://www.w3.org/2002/07/owl#topDataProperty";
var topObjectProperty = "http://www.w3.org/2002/07/owl#topObjectProperty";
var unionOf = "http://www.w3.org/2002/07/owl#unionOf";
var withRestrictions = "http://www.w3.org/2002/07/owl#withRestrictions";
var owlImport = /* @__PURE__ */ Object.freeze({
  AllDifferent,
  AllDisjointClasses,
  AllDisjointProperties,
  Annotation: Annotation2,
  AnnotationProperty,
  AsymmetricProperty,
  Axiom,
  Class: Class3,
  DataRange,
  DatatypeProperty,
  DeprecatedClass,
  DeprecatedProperty,
  FunctionalProperty,
  InverseFunctionalProperty,
  IrreflexiveProperty,
  NamedIndividual,
  NegativePropertyAssertion,
  Nothing,
  ObjectProperty,
  Ontology,
  OntologyProperty,
  ReflexiveProperty,
  Restriction,
  SymmetricProperty,
  TransitiveProperty,
  Thing: Thing2,
  allValuesFrom,
  annotatedProperty,
  annotatedSource,
  annotatedTarget,
  assertionProperty,
  bottomDataProperty,
  bottomObjectProperty,
  cardinality,
  complementOf,
  datatypeComplementOf,
  differentFrom,
  disjointUnionOf,
  disjointWith,
  distinctMembers,
  equivalentClass,
  equivalentProperty,
  hasKey,
  hasSelf,
  hasValue,
  intersectionOf,
  inverseOf,
  maxCardinality,
  maxQualifiedCardinality,
  members,
  minCardinality,
  minQualifiedCardinality,
  onClass,
  onDataRange,
  onDatatype,
  oneOf: oneOf2,
  onProperties,
  onProperty,
  propertyChainAxiom,
  propertyDisjointWith,
  qualifiedCardinality,
  sameAs,
  someValuesFrom,
  sourceIndividual,
  targetIndividual,
  targetValue,
  topDataProperty,
  topObjectProperty,
  unionOf,
  withRestrictions
});

// ../node_modules/rdf-namespaces/dist/qu-52da41a2.js
var Account2 = "http://www.w3.org/2000/10/swap/pim/qif#Account";
var Bank = "http://www.w3.org/2000/10/swap/pim/qif#Bank";
var Cat = "http://www.w3.org/2000/10/swap/pim/qif#Cat";
var Classified = "http://www.w3.org/2000/10/swap/pim/qif#Classified";
var Receipt = "http://www.w3.org/2000/10/swap/pim/qif#Receipt";
var SplitTransaction = "http://www.w3.org/2000/10/swap/pim/qif#SplitTransaction";
var SupportingDocument = "http://www.w3.org/2000/10/swap/pim/qif#SupportingDocument";
var Transaction = "http://www.w3.org/2000/10/swap/pim/qif#Transaction";
var Unclassified = "http://www.w3.org/2000/10/swap/pim/qif#Unclassified";
var UnclassifiedIncome = "http://www.w3.org/2000/10/swap/pim/qif#UnclassifiedIncome";
var UnclassifiedOutgoing = "http://www.w3.org/2000/10/swap/pim/qif#UnclassifiedOutgoing";
var accordingTo = "http://www.w3.org/2000/10/swap/pim/qif#accordingTo";
var amount2 = "http://www.w3.org/2000/10/swap/pim/qif#amount";
var category2 = "http://www.w3.org/2000/10/swap/pim/qif#category";
var date4 = "http://www.w3.org/2000/10/swap/pim/qif#date";
var payee2 = "http://www.w3.org/2000/10/swap/pim/qif#payee";
var splitPart = "http://www.w3.org/2000/10/swap/pim/qif#splitPart";
var splitReverse = "http://www.w3.org/2000/10/swap/pim/qif#splitReverse";
var toAccount = "http://www.w3.org/2000/10/swap/pim/qif#toAccount";
var quImport = /* @__PURE__ */ Object.freeze({
  Account: Account2,
  Bank,
  Cat,
  Classified,
  Receipt,
  SplitTransaction,
  SupportingDocument,
  Transaction,
  Unclassified,
  UnclassifiedIncome,
  UnclassifiedOutgoing,
  accordingTo,
  amount: amount2,
  category: category2,
  date: date4,
  payee: payee2,
  splitPart,
  splitReverse,
  toAccount
});

// ../node_modules/rdf-namespaces/dist/trip-a4eac398.js
var TaxiTransaction = "http://www.w3.org/ns/pim/trip#TaxiTransaction";
var Trip = "http://www.w3.org/ns/pim/trip#Trip";
var funder = "http://www.w3.org/ns/pim/trip#funder";
var location5 = "http://www.w3.org/ns/pim/trip#location";
var part2 = "http://www.w3.org/ns/pim/trip#part";
var travelDate = "http://www.w3.org/ns/pim/trip#travelDate";
var trip2 = "http://www.w3.org/ns/pim/trip#trip";
var tripImport = /* @__PURE__ */ Object.freeze({
  TaxiTransaction,
  Trip,
  funder,
  location: location5,
  part: part2,
  travelDate,
  trip: trip2
});

// ../node_modules/rdf-namespaces/dist/rdf-2b18691f.js
var HTML = "http://www.w3.org/1999/02/22-rdf-syntax-ns#HTML";
var langString = "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString";
var PlainLiteral = "http://www.w3.org/1999/02/22-rdf-syntax-ns#PlainLiteral";
var type4 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#type";
var Property2 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#Property";
var Statement = "http://www.w3.org/1999/02/22-rdf-syntax-ns#Statement";
var subject4 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#subject";
var predicate = "http://www.w3.org/1999/02/22-rdf-syntax-ns#predicate";
var object3 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#object";
var Bag = "http://www.w3.org/1999/02/22-rdf-syntax-ns#Bag";
var Seq = "http://www.w3.org/1999/02/22-rdf-syntax-ns#Seq";
var Alt = "http://www.w3.org/1999/02/22-rdf-syntax-ns#Alt";
var value2 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#value";
var List3 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#List";
var first2 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#first";
var rest2 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#rest";
var XMLLiteral = "http://www.w3.org/1999/02/22-rdf-syntax-ns#XMLLiteral";
var JSON__workaround = "http://www.w3.org/1999/02/22-rdf-syntax-ns#JSON";
var CompoundLiteral = "http://www.w3.org/1999/02/22-rdf-syntax-ns#CompoundLiteral";
var language4 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#language";
var direction2 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#direction";
var rdfImport = /* @__PURE__ */ Object.freeze({
  HTML,
  langString,
  PlainLiteral,
  type: type4,
  Property: Property2,
  Statement,
  subject: subject4,
  predicate,
  object: object3,
  Bag,
  Seq,
  Alt,
  value: value2,
  List: List3,
  first: first2,
  rest: rest2,
  XMLLiteral,
  JSON__workaround,
  CompoundLiteral,
  language: language4,
  direction: direction2
});

// ../node_modules/rdf-namespaces/dist/rdfs-47a3d3a9.js
var Resource4 = "http://www.w3.org/2000/01/rdf-schema#Resource";
var Class4 = "http://www.w3.org/2000/01/rdf-schema#Class";
var subClassOf = "http://www.w3.org/2000/01/rdf-schema#subClassOf";
var subPropertyOf = "http://www.w3.org/2000/01/rdf-schema#subPropertyOf";
var comment3 = "http://www.w3.org/2000/01/rdf-schema#comment";
var label2 = "http://www.w3.org/2000/01/rdf-schema#label";
var domain2 = "http://www.w3.org/2000/01/rdf-schema#domain";
var range2 = "http://www.w3.org/2000/01/rdf-schema#range";
var seeAlso = "http://www.w3.org/2000/01/rdf-schema#seeAlso";
var isDefinedBy = "http://www.w3.org/2000/01/rdf-schema#isDefinedBy";
var Literal = "http://www.w3.org/2000/01/rdf-schema#Literal";
var Container2 = "http://www.w3.org/2000/01/rdf-schema#Container";
var ContainerMembershipProperty = "http://www.w3.org/2000/01/rdf-schema#ContainerMembershipProperty";
var member5 = "http://www.w3.org/2000/01/rdf-schema#member";
var Datatype = "http://www.w3.org/2000/01/rdf-schema#Datatype";
var rdfsImport = /* @__PURE__ */ Object.freeze({
  Resource: Resource4,
  Class: Class4,
  subClassOf,
  subPropertyOf,
  comment: comment3,
  label: label2,
  domain: domain2,
  range: range2,
  seeAlso,
  isDefinedBy,
  Literal,
  Container: Container2,
  ContainerMembershipProperty,
  member: member5,
  Datatype
});

// ../node_modules/rdf-namespaces/dist/sched-1d1e63ee.js
var DegreesOfDifficulty = "http://www.w3.org/ns/pim/schedule#DegreesOfDifficulty";
var Difficult = "http://www.w3.org/ns/pim/schedule#Difficult";
var Ideal = "http://www.w3.org/ns/pim/schedule#Ideal";
var Impossible = "http://www.w3.org/ns/pim/schedule#Impossible";
var Painful = "http://www.w3.org/ns/pim/schedule#Painful";
var Tolerable = "http://www.w3.org/ns/pim/schedule#Tolerable";
var YesNo = "http://www.w3.org/ns/pim/schedule#YesNo";
var YesNoMaybe = "http://www.w3.org/ns/pim/schedule#YesNoMaybe";
var availabilityOptions = "http://www.w3.org/ns/pim/schedule#availabilityOptions";
var availibility = "http://www.w3.org/ns/pim/schedule#availibility";
var option2 = "http://www.w3.org/ns/pim/schedule#option";
var response3 = "http://www.w3.org/ns/pim/schedule#response";
var schedImport = /* @__PURE__ */ Object.freeze({
  DegreesOfDifficulty,
  Difficult,
  Ideal,
  Impossible,
  Painful,
  Tolerable,
  YesNo,
  YesNoMaybe,
  availabilityOptions,
  availibility,
  option: option2,
  response: response3
});

// ../node_modules/rdf-namespaces/dist/schema-67aaaa22.js
var AMRadioChannel = "http://schema.org/AMRadioChannel";
var APIReference = "http://schema.org/APIReference";
var AboutPage = "http://schema.org/AboutPage";
var AcceptAction = "http://schema.org/AcceptAction";
var Accommodation = "http://schema.org/Accommodation";
var AccountingService = "http://schema.org/AccountingService";
var AchieveAction = "http://schema.org/AchieveAction";
var Action2 = "http://schema.org/Action";
var ActionAccessSpecification = "http://schema.org/ActionAccessSpecification";
var ActionStatusType = "http://schema.org/ActionStatusType";
var ActivateAction = "http://schema.org/ActivateAction";
var AddAction = "http://schema.org/AddAction";
var AdministrativeArea = "http://schema.org/AdministrativeArea";
var AdultEntertainment = "http://schema.org/AdultEntertainment";
var AdultOrientedEnumeration = "http://schema.org/AdultOrientedEnumeration";
var AdvertiserContentArticle = "http://schema.org/AdvertiserContentArticle";
var AggregateOffer = "http://schema.org/AggregateOffer";
var AggregateRating = "http://schema.org/AggregateRating";
var AgreeAction = "http://schema.org/AgreeAction";
var Airline = "http://schema.org/Airline";
var Airport = "http://schema.org/Airport";
var AlignmentObject = "http://schema.org/AlignmentObject";
var AllocateAction = "http://schema.org/AllocateAction";
var AmpStory = "http://schema.org/AmpStory";
var AmusementPark = "http://schema.org/AmusementPark";
var AnalysisNewsArticle = "http://schema.org/AnalysisNewsArticle";
var AnatomicalStructure = "http://schema.org/AnatomicalStructure";
var AnatomicalSystem = "http://schema.org/AnatomicalSystem";
var AnimalShelter = "http://schema.org/AnimalShelter";
var Answer2 = "http://schema.org/Answer";
var Apartment = "http://schema.org/Apartment";
var ApartmentComplex = "http://schema.org/ApartmentComplex";
var AppendAction = "http://schema.org/AppendAction";
var ApplyAction = "http://schema.org/ApplyAction";
var ApprovedIndication = "http://schema.org/ApprovedIndication";
var Aquarium = "http://schema.org/Aquarium";
var ArchiveComponent = "http://schema.org/ArchiveComponent";
var ArchiveOrganization = "http://schema.org/ArchiveOrganization";
var ArriveAction = "http://schema.org/ArriveAction";
var ArtGallery = "http://schema.org/ArtGallery";
var Artery = "http://schema.org/Artery";
var Article2 = "http://schema.org/Article";
var AskAction = "http://schema.org/AskAction";
var AskPublicNewsArticle = "http://schema.org/AskPublicNewsArticle";
var AssessAction = "http://schema.org/AssessAction";
var AssignAction = "http://schema.org/AssignAction";
var Atlas = "http://schema.org/Atlas";
var Attorney = "http://schema.org/Attorney";
var Audience = "http://schema.org/Audience";
var AudioObject = "http://schema.org/AudioObject";
var AudioObjectSnapshot = "http://schema.org/AudioObjectSnapshot";
var Audiobook = "http://schema.org/Audiobook";
var AuthorizeAction = "http://schema.org/AuthorizeAction";
var AutoBodyShop = "http://schema.org/AutoBodyShop";
var AutoDealer = "http://schema.org/AutoDealer";
var AutoPartsStore = "http://schema.org/AutoPartsStore";
var AutoRental = "http://schema.org/AutoRental";
var AutoRepair = "http://schema.org/AutoRepair";
var AutoWash = "http://schema.org/AutoWash";
var AutomatedTeller = "http://schema.org/AutomatedTeller";
var AutomotiveBusiness = "http://schema.org/AutomotiveBusiness";
var BackgroundNewsArticle = "http://schema.org/BackgroundNewsArticle";
var Bakery = "http://schema.org/Bakery";
var BankAccount = "http://schema.org/BankAccount";
var BankOrCreditUnion = "http://schema.org/BankOrCreditUnion";
var BarOrPub = "http://schema.org/BarOrPub";
var Barcode = "http://schema.org/Barcode";
var Beach = "http://schema.org/Beach";
var BeautySalon = "http://schema.org/BeautySalon";
var BedAndBreakfast = "http://schema.org/BedAndBreakfast";
var BedDetails = "http://schema.org/BedDetails";
var BedType = "http://schema.org/BedType";
var BefriendAction = "http://schema.org/BefriendAction";
var BikeStore = "http://schema.org/BikeStore";
var BioChemEntity = "http://schema.org/BioChemEntity";
var Blog = "http://schema.org/Blog";
var BlogPosting = "http://schema.org/BlogPosting";
var BloodTest = "http://schema.org/BloodTest";
var BoardingPolicyType = "http://schema.org/BoardingPolicyType";
var BoatReservation = "http://schema.org/BoatReservation";
var BoatTerminal = "http://schema.org/BoatTerminal";
var BoatTrip = "http://schema.org/BoatTrip";
var BodyMeasurementTypeEnumeration = "http://schema.org/BodyMeasurementTypeEnumeration";
var BodyOfWater = "http://schema.org/BodyOfWater";
var Bone = "http://schema.org/Bone";
var Book = "http://schema.org/Book";
var BookFormatType = "http://schema.org/BookFormatType";
var BookSeries = "http://schema.org/BookSeries";
var BookStore = "http://schema.org/BookStore";
var BookmarkAction = "http://schema.org/BookmarkAction";
var Boolean__workaround = "http://schema.org/Boolean";
var BorrowAction = "http://schema.org/BorrowAction";
var BowlingAlley = "http://schema.org/BowlingAlley";
var BrainStructure = "http://schema.org/BrainStructure";
var Brand = "http://schema.org/Brand";
var BreadcrumbList = "http://schema.org/BreadcrumbList";
var Brewery = "http://schema.org/Brewery";
var Bridge = "http://schema.org/Bridge";
var BroadcastChannel = "http://schema.org/BroadcastChannel";
var BroadcastEvent = "http://schema.org/BroadcastEvent";
var BroadcastFrequencySpecification = "http://schema.org/BroadcastFrequencySpecification";
var BroadcastService = "http://schema.org/BroadcastService";
var BrokerageAccount = "http://schema.org/BrokerageAccount";
var BuddhistTemple = "http://schema.org/BuddhistTemple";
var BusOrCoach = "http://schema.org/BusOrCoach";
var BusReservation = "http://schema.org/BusReservation";
var BusStation = "http://schema.org/BusStation";
var BusStop = "http://schema.org/BusStop";
var BusTrip = "http://schema.org/BusTrip";
var BusinessAudience = "http://schema.org/BusinessAudience";
var BusinessEntityType = "http://schema.org/BusinessEntityType";
var BusinessEvent = "http://schema.org/BusinessEvent";
var BusinessFunction = "http://schema.org/BusinessFunction";
var BuyAction = "http://schema.org/BuyAction";
var CDCPMDRecord = "http://schema.org/CDCPMDRecord";
var CableOrSatelliteService = "http://schema.org/CableOrSatelliteService";
var CafeOrCoffeeShop = "http://schema.org/CafeOrCoffeeShop";
var Campground = "http://schema.org/Campground";
var CampingPitch = "http://schema.org/CampingPitch";
var Canal = "http://schema.org/Canal";
var CancelAction = "http://schema.org/CancelAction";
var Car = "http://schema.org/Car";
var CarUsageType = "http://schema.org/CarUsageType";
var Casino = "http://schema.org/Casino";
var CategoryCode = "http://schema.org/CategoryCode";
var CategoryCodeSet = "http://schema.org/CategoryCodeSet";
var CatholicChurch = "http://schema.org/CatholicChurch";
var Cemetery = "http://schema.org/Cemetery";
var Chapter = "http://schema.org/Chapter";
var CheckAction = "http://schema.org/CheckAction";
var CheckInAction = "http://schema.org/CheckInAction";
var CheckOutAction = "http://schema.org/CheckOutAction";
var CheckoutPage = "http://schema.org/CheckoutPage";
var ChemicalSubstance = "http://schema.org/ChemicalSubstance";
var ChildCare = "http://schema.org/ChildCare";
var ChildrensEvent = "http://schema.org/ChildrensEvent";
var ChooseAction = "http://schema.org/ChooseAction";
var Church = "http://schema.org/Church";
var City = "http://schema.org/City";
var CityHall = "http://schema.org/CityHall";
var CivicStructure = "http://schema.org/CivicStructure";
var Claim2 = "http://schema.org/Claim";
var ClaimReview = "http://schema.org/ClaimReview";
var Class5 = "http://schema.org/Class";
var Clip = "http://schema.org/Clip";
var ClothingStore = "http://schema.org/ClothingStore";
var Code = "http://schema.org/Code";
var Collection3 = "http://schema.org/Collection";
var CollectionPage2 = "http://schema.org/CollectionPage";
var CollegeOrUniversity = "http://schema.org/CollegeOrUniversity";
var ComedyClub = "http://schema.org/ComedyClub";
var ComedyEvent = "http://schema.org/ComedyEvent";
var ComicCoverArt = "http://schema.org/ComicCoverArt";
var ComicIssue = "http://schema.org/ComicIssue";
var ComicSeries = "http://schema.org/ComicSeries";
var ComicStory = "http://schema.org/ComicStory";
var Comment = "http://schema.org/Comment";
var CommentAction = "http://schema.org/CommentAction";
var CommunicateAction = "http://schema.org/CommunicateAction";
var CompleteDataFeed = "http://schema.org/CompleteDataFeed";
var CompoundPriceSpecification = "http://schema.org/CompoundPriceSpecification";
var ComputerLanguage = "http://schema.org/ComputerLanguage";
var ComputerStore = "http://schema.org/ComputerStore";
var ConfirmAction = "http://schema.org/ConfirmAction";
var Consortium = "http://schema.org/Consortium";
var ConstraintNode = "http://schema.org/ConstraintNode";
var ConsumeAction = "http://schema.org/ConsumeAction";
var ContactPage = "http://schema.org/ContactPage";
var ContactPoint2 = "http://schema.org/ContactPoint";
var ContactPointOption = "http://schema.org/ContactPointOption";
var Continent = "http://schema.org/Continent";
var ControlAction = "http://schema.org/ControlAction";
var ConvenienceStore = "http://schema.org/ConvenienceStore";
var Conversation = "http://schema.org/Conversation";
var CookAction = "http://schema.org/CookAction";
var Corporation = "http://schema.org/Corporation";
var CorrectionComment = "http://schema.org/CorrectionComment";
var Country = "http://schema.org/Country";
var Course = "http://schema.org/Course";
var CourseInstance = "http://schema.org/CourseInstance";
var Courthouse = "http://schema.org/Courthouse";
var CoverArt = "http://schema.org/CoverArt";
var CovidTestingFacility = "http://schema.org/CovidTestingFacility";
var CreateAction = "http://schema.org/CreateAction";
var CreativeWork = "http://schema.org/CreativeWork";
var CreativeWorkSeason = "http://schema.org/CreativeWorkSeason";
var CreativeWorkSeries = "http://schema.org/CreativeWorkSeries";
var CreditCard = "http://schema.org/CreditCard";
var Crematorium = "http://schema.org/Crematorium";
var CriticReview = "http://schema.org/CriticReview";
var CssSelectorType = "http://schema.org/CssSelectorType";
var CurrencyConversionService = "http://schema.org/CurrencyConversionService";
var DDxElement = "http://schema.org/DDxElement";
var DanceEvent = "http://schema.org/DanceEvent";
var DanceGroup = "http://schema.org/DanceGroup";
var DataCatalog = "http://schema.org/DataCatalog";
var DataDownload = "http://schema.org/DataDownload";
var DataFeed = "http://schema.org/DataFeed";
var DataFeedItem = "http://schema.org/DataFeedItem";
var DataType2 = "http://schema.org/DataType";
var Dataset = "http://schema.org/Dataset";
var Date__workaround = "http://schema.org/Date";
var DateTime = "http://schema.org/DateTime";
var DatedMoneySpecification = "http://schema.org/DatedMoneySpecification";
var DayOfWeek = "http://schema.org/DayOfWeek";
var DaySpa = "http://schema.org/DaySpa";
var DeactivateAction = "http://schema.org/DeactivateAction";
var DefenceEstablishment = "http://schema.org/DefenceEstablishment";
var DefinedRegion = "http://schema.org/DefinedRegion";
var DefinedTerm = "http://schema.org/DefinedTerm";
var DefinedTermSet = "http://schema.org/DefinedTermSet";
var DeleteAction = "http://schema.org/DeleteAction";
var DeliveryChargeSpecification = "http://schema.org/DeliveryChargeSpecification";
var DeliveryEvent = "http://schema.org/DeliveryEvent";
var DeliveryMethod = "http://schema.org/DeliveryMethod";
var DeliveryTimeSettings = "http://schema.org/DeliveryTimeSettings";
var Demand = "http://schema.org/Demand";
var Dentist = "http://schema.org/Dentist";
var DepartAction = "http://schema.org/DepartAction";
var DepartmentStore = "http://schema.org/DepartmentStore";
var DepositAccount = "http://schema.org/DepositAccount";
var DiagnosticLab = "http://schema.org/DiagnosticLab";
var DiagnosticProcedure = "http://schema.org/DiagnosticProcedure";
var Diet = "http://schema.org/Diet";
var DietarySupplement = "http://schema.org/DietarySupplement";
var DigitalDocument = "http://schema.org/DigitalDocument";
var DigitalDocumentPermission = "http://schema.org/DigitalDocumentPermission";
var DigitalDocumentPermissionType = "http://schema.org/DigitalDocumentPermissionType";
var DigitalPlatformEnumeration = "http://schema.org/DigitalPlatformEnumeration";
var DisagreeAction = "http://schema.org/DisagreeAction";
var DiscoverAction = "http://schema.org/DiscoverAction";
var DiscussionForumPosting = "http://schema.org/DiscussionForumPosting";
var DislikeAction = "http://schema.org/DislikeAction";
var Distance2 = "http://schema.org/Distance";
var Distillery = "http://schema.org/Distillery";
var DonateAction = "http://schema.org/DonateAction";
var DoseSchedule = "http://schema.org/DoseSchedule";
var DownloadAction = "http://schema.org/DownloadAction";
var DrawAction = "http://schema.org/DrawAction";
var Drawing = "http://schema.org/Drawing";
var DrinkAction = "http://schema.org/DrinkAction";
var DriveWheelConfigurationValue = "http://schema.org/DriveWheelConfigurationValue";
var Drug = "http://schema.org/Drug";
var DrugClass = "http://schema.org/DrugClass";
var DrugCost = "http://schema.org/DrugCost";
var DrugCostCategory = "http://schema.org/DrugCostCategory";
var DrugLegalStatus = "http://schema.org/DrugLegalStatus";
var DrugPregnancyCategory = "http://schema.org/DrugPregnancyCategory";
var DrugPrescriptionStatus = "http://schema.org/DrugPrescriptionStatus";
var DrugStrength = "http://schema.org/DrugStrength";
var DryCleaningOrLaundry = "http://schema.org/DryCleaningOrLaundry";
var Duration2 = "http://schema.org/Duration";
var EUEnergyEfficiencyEnumeration = "http://schema.org/EUEnergyEfficiencyEnumeration";
var EatAction = "http://schema.org/EatAction";
var EducationEvent = "http://schema.org/EducationEvent";
var EducationalAudience = "http://schema.org/EducationalAudience";
var EducationalOccupationalCredential = "http://schema.org/EducationalOccupationalCredential";
var EducationalOccupationalProgram = "http://schema.org/EducationalOccupationalProgram";
var EducationalOrganization = "http://schema.org/EducationalOrganization";
var Electrician = "http://schema.org/Electrician";
var ElectronicsStore = "http://schema.org/ElectronicsStore";
var ElementarySchool = "http://schema.org/ElementarySchool";
var EmailMessage = "http://schema.org/EmailMessage";
var Embassy = "http://schema.org/Embassy";
var EmergencyService = "http://schema.org/EmergencyService";
var EmployeeRole = "http://schema.org/EmployeeRole";
var EmployerAggregateRating = "http://schema.org/EmployerAggregateRating";
var EmployerReview = "http://schema.org/EmployerReview";
var EmploymentAgency = "http://schema.org/EmploymentAgency";
var EndorseAction = "http://schema.org/EndorseAction";
var EndorsementRating = "http://schema.org/EndorsementRating";
var Energy = "http://schema.org/Energy";
var EnergyConsumptionDetails = "http://schema.org/EnergyConsumptionDetails";
var EnergyEfficiencyEnumeration = "http://schema.org/EnergyEfficiencyEnumeration";
var EnergyStarEnergyEfficiencyEnumeration = "http://schema.org/EnergyStarEnergyEfficiencyEnumeration";
var EngineSpecification = "http://schema.org/EngineSpecification";
var EntertainmentBusiness = "http://schema.org/EntertainmentBusiness";
var EntryPoint = "http://schema.org/EntryPoint";
var Enumeration = "http://schema.org/Enumeration";
var Episode = "http://schema.org/Episode";
var Event2 = "http://schema.org/Event";
var EventAttendanceModeEnumeration = "http://schema.org/EventAttendanceModeEnumeration";
var EventReservation = "http://schema.org/EventReservation";
var EventSeries = "http://schema.org/EventSeries";
var EventStatusType = "http://schema.org/EventStatusType";
var EventVenue = "http://schema.org/EventVenue";
var ExchangeRateSpecification = "http://schema.org/ExchangeRateSpecification";
var ExerciseAction = "http://schema.org/ExerciseAction";
var ExerciseGym = "http://schema.org/ExerciseGym";
var ExercisePlan = "http://schema.org/ExercisePlan";
var ExhibitionEvent = "http://schema.org/ExhibitionEvent";
var FAQPage = "http://schema.org/FAQPage";
var FMRadioChannel = "http://schema.org/FMRadioChannel";
var FastFoodRestaurant = "http://schema.org/FastFoodRestaurant";
var Festival = "http://schema.org/Festival";
var FilmAction = "http://schema.org/FilmAction";
var FinancialProduct = "http://schema.org/FinancialProduct";
var FinancialService = "http://schema.org/FinancialService";
var FindAction = "http://schema.org/FindAction";
var FireStation = "http://schema.org/FireStation";
var Flight = "http://schema.org/Flight";
var FlightReservation = "http://schema.org/FlightReservation";
var Float = "http://schema.org/Float";
var FloorPlan = "http://schema.org/FloorPlan";
var Florist = "http://schema.org/Florist";
var FollowAction = "http://schema.org/FollowAction";
var FoodEstablishment = "http://schema.org/FoodEstablishment";
var FoodEstablishmentReservation = "http://schema.org/FoodEstablishmentReservation";
var FoodEvent = "http://schema.org/FoodEvent";
var FoodService = "http://schema.org/FoodService";
var FundingAgency = "http://schema.org/FundingAgency";
var FundingScheme = "http://schema.org/FundingScheme";
var FurnitureStore = "http://schema.org/FurnitureStore";
var Game = "http://schema.org/Game";
var GameAvailabilityEnumeration = "http://schema.org/GameAvailabilityEnumeration";
var GamePlayMode = "http://schema.org/GamePlayMode";
var GameServer = "http://schema.org/GameServer";
var GameServerStatus = "http://schema.org/GameServerStatus";
var GardenStore = "http://schema.org/GardenStore";
var GasStation = "http://schema.org/GasStation";
var GatedResidenceCommunity = "http://schema.org/GatedResidenceCommunity";
var GenderType = "http://schema.org/GenderType";
var Gene = "http://schema.org/Gene";
var GeneralContractor = "http://schema.org/GeneralContractor";
var GeoCircle = "http://schema.org/GeoCircle";
var GeoCoordinates = "http://schema.org/GeoCoordinates";
var GeoShape = "http://schema.org/GeoShape";
var GeospatialGeometry = "http://schema.org/GeospatialGeometry";
var GiveAction = "http://schema.org/GiveAction";
var GolfCourse = "http://schema.org/GolfCourse";
var GovernmentBenefitsType = "http://schema.org/GovernmentBenefitsType";
var GovernmentBuilding = "http://schema.org/GovernmentBuilding";
var GovernmentOffice = "http://schema.org/GovernmentOffice";
var GovernmentOrganization = "http://schema.org/GovernmentOrganization";
var GovernmentPermit = "http://schema.org/GovernmentPermit";
var GovernmentService = "http://schema.org/GovernmentService";
var Grant = "http://schema.org/Grant";
var GroceryStore = "http://schema.org/GroceryStore";
var Guide = "http://schema.org/Guide";
var HVACBusiness = "http://schema.org/HVACBusiness";
var Hackathon = "http://schema.org/Hackathon";
var HairSalon = "http://schema.org/HairSalon";
var HardwareStore = "http://schema.org/HardwareStore";
var HealthAndBeautyBusiness = "http://schema.org/HealthAndBeautyBusiness";
var HealthAspectEnumeration = "http://schema.org/HealthAspectEnumeration";
var HealthClub = "http://schema.org/HealthClub";
var HealthInsurancePlan = "http://schema.org/HealthInsurancePlan";
var HealthPlanCostSharingSpecification = "http://schema.org/HealthPlanCostSharingSpecification";
var HealthPlanFormulary = "http://schema.org/HealthPlanFormulary";
var HealthPlanNetwork = "http://schema.org/HealthPlanNetwork";
var HealthTopicContent = "http://schema.org/HealthTopicContent";
var HighSchool = "http://schema.org/HighSchool";
var HinduTemple = "http://schema.org/HinduTemple";
var HobbyShop = "http://schema.org/HobbyShop";
var HomeAndConstructionBusiness = "http://schema.org/HomeAndConstructionBusiness";
var HomeGoodsStore = "http://schema.org/HomeGoodsStore";
var Hospital = "http://schema.org/Hospital";
var Hostel = "http://schema.org/Hostel";
var Hotel = "http://schema.org/Hotel";
var HotelRoom = "http://schema.org/HotelRoom";
var House = "http://schema.org/House";
var HousePainter = "http://schema.org/HousePainter";
var HowTo = "http://schema.org/HowTo";
var HowToDirection = "http://schema.org/HowToDirection";
var HowToItem = "http://schema.org/HowToItem";
var HowToSection = "http://schema.org/HowToSection";
var HowToStep = "http://schema.org/HowToStep";
var HowToSupply = "http://schema.org/HowToSupply";
var HowToTip = "http://schema.org/HowToTip";
var HowToTool = "http://schema.org/HowToTool";
var HyperToc = "http://schema.org/HyperToc";
var HyperTocEntry = "http://schema.org/HyperTocEntry";
var IceCreamShop = "http://schema.org/IceCreamShop";
var IgnoreAction = "http://schema.org/IgnoreAction";
var ImageGallery = "http://schema.org/ImageGallery";
var ImageObject = "http://schema.org/ImageObject";
var ImageObjectSnapshot = "http://schema.org/ImageObjectSnapshot";
var ImagingTest = "http://schema.org/ImagingTest";
var IndividualProduct = "http://schema.org/IndividualProduct";
var InfectiousAgentClass = "http://schema.org/InfectiousAgentClass";
var InfectiousDisease = "http://schema.org/InfectiousDisease";
var InformAction = "http://schema.org/InformAction";
var InsertAction = "http://schema.org/InsertAction";
var InstallAction = "http://schema.org/InstallAction";
var InsuranceAgency = "http://schema.org/InsuranceAgency";
var Intangible = "http://schema.org/Intangible";
var Integer = "http://schema.org/Integer";
var InteractAction = "http://schema.org/InteractAction";
var InteractionCounter = "http://schema.org/InteractionCounter";
var InternetCafe = "http://schema.org/InternetCafe";
var InvestmentFund = "http://schema.org/InvestmentFund";
var InvestmentOrDeposit = "http://schema.org/InvestmentOrDeposit";
var InviteAction = "http://schema.org/InviteAction";
var Invoice2 = "http://schema.org/Invoice";
var ItemAvailability = "http://schema.org/ItemAvailability";
var ItemList = "http://schema.org/ItemList";
var ItemListOrderType = "http://schema.org/ItemListOrderType";
var ItemPage = "http://schema.org/ItemPage";
var JewelryStore = "http://schema.org/JewelryStore";
var JobPosting = "http://schema.org/JobPosting";
var JoinAction = "http://schema.org/JoinAction";
var Joint = "http://schema.org/Joint";
var LakeBodyOfWater = "http://schema.org/LakeBodyOfWater";
var Landform = "http://schema.org/Landform";
var LandmarksOrHistoricalBuildings = "http://schema.org/LandmarksOrHistoricalBuildings";
var Language = "http://schema.org/Language";
var LearningResource = "http://schema.org/LearningResource";
var LeaveAction = "http://schema.org/LeaveAction";
var LegalForceStatus = "http://schema.org/LegalForceStatus";
var LegalService = "http://schema.org/LegalService";
var LegalValueLevel = "http://schema.org/LegalValueLevel";
var Legislation = "http://schema.org/Legislation";
var LegislationObject = "http://schema.org/LegislationObject";
var LegislativeBuilding = "http://schema.org/LegislativeBuilding";
var LendAction = "http://schema.org/LendAction";
var Library2 = "http://schema.org/Library";
var LibrarySystem = "http://schema.org/LibrarySystem";
var LifestyleModification = "http://schema.org/LifestyleModification";
var Ligament = "http://schema.org/Ligament";
var LikeAction = "http://schema.org/LikeAction";
var LinkRole = "http://schema.org/LinkRole";
var LiquorStore = "http://schema.org/LiquorStore";
var ListItem = "http://schema.org/ListItem";
var ListenAction = "http://schema.org/ListenAction";
var LiteraryEvent = "http://schema.org/LiteraryEvent";
var LiveBlogPosting = "http://schema.org/LiveBlogPosting";
var LoanOrCredit = "http://schema.org/LoanOrCredit";
var LocalBusiness = "http://schema.org/LocalBusiness";
var LocationFeatureSpecification = "http://schema.org/LocationFeatureSpecification";
var Locksmith = "http://schema.org/Locksmith";
var LodgingBusiness = "http://schema.org/LodgingBusiness";
var LodgingReservation = "http://schema.org/LodgingReservation";
var LoseAction = "http://schema.org/LoseAction";
var LymphaticVessel = "http://schema.org/LymphaticVessel";
var Manuscript = "http://schema.org/Manuscript";
var Map__workaround = "http://schema.org/Map";
var MapCategoryType = "http://schema.org/MapCategoryType";
var MarryAction = "http://schema.org/MarryAction";
var Mass = "http://schema.org/Mass";
var MathSolver = "http://schema.org/MathSolver";
var MaximumDoseSchedule = "http://schema.org/MaximumDoseSchedule";
var MeasurementMethodEnum = "http://schema.org/MeasurementMethodEnum";
var MeasurementTypeEnumeration = "http://schema.org/MeasurementTypeEnumeration";
var MediaGallery = "http://schema.org/MediaGallery";
var MediaManipulationRatingEnumeration = "http://schema.org/MediaManipulationRatingEnumeration";
var MediaObject = "http://schema.org/MediaObject";
var MediaReview = "http://schema.org/MediaReview";
var MediaReviewItem = "http://schema.org/MediaReviewItem";
var MediaSubscription = "http://schema.org/MediaSubscription";
var MedicalAudience = "http://schema.org/MedicalAudience";
var MedicalAudienceType = "http://schema.org/MedicalAudienceType";
var MedicalBusiness = "http://schema.org/MedicalBusiness";
var MedicalCause = "http://schema.org/MedicalCause";
var MedicalClinic = "http://schema.org/MedicalClinic";
var MedicalCode = "http://schema.org/MedicalCode";
var MedicalCondition = "http://schema.org/MedicalCondition";
var MedicalConditionStage = "http://schema.org/MedicalConditionStage";
var MedicalContraindication = "http://schema.org/MedicalContraindication";
var MedicalDevice = "http://schema.org/MedicalDevice";
var MedicalDevicePurpose = "http://schema.org/MedicalDevicePurpose";
var MedicalEntity = "http://schema.org/MedicalEntity";
var MedicalEnumeration = "http://schema.org/MedicalEnumeration";
var MedicalEvidenceLevel = "http://schema.org/MedicalEvidenceLevel";
var MedicalGuideline = "http://schema.org/MedicalGuideline";
var MedicalGuidelineContraindication = "http://schema.org/MedicalGuidelineContraindication";
var MedicalGuidelineRecommendation = "http://schema.org/MedicalGuidelineRecommendation";
var MedicalImagingTechnique = "http://schema.org/MedicalImagingTechnique";
var MedicalIndication = "http://schema.org/MedicalIndication";
var MedicalIntangible = "http://schema.org/MedicalIntangible";
var MedicalObservationalStudy = "http://schema.org/MedicalObservationalStudy";
var MedicalObservationalStudyDesign = "http://schema.org/MedicalObservationalStudyDesign";
var MedicalOrganization = "http://schema.org/MedicalOrganization";
var MedicalProcedure = "http://schema.org/MedicalProcedure";
var MedicalProcedureType = "http://schema.org/MedicalProcedureType";
var MedicalRiskCalculator = "http://schema.org/MedicalRiskCalculator";
var MedicalRiskEstimator = "http://schema.org/MedicalRiskEstimator";
var MedicalRiskFactor = "http://schema.org/MedicalRiskFactor";
var MedicalRiskScore = "http://schema.org/MedicalRiskScore";
var MedicalScholarlyArticle = "http://schema.org/MedicalScholarlyArticle";
var MedicalSign = "http://schema.org/MedicalSign";
var MedicalSignOrSymptom = "http://schema.org/MedicalSignOrSymptom";
var MedicalSpecialty = "http://schema.org/MedicalSpecialty";
var MedicalStudy = "http://schema.org/MedicalStudy";
var MedicalStudyStatus = "http://schema.org/MedicalStudyStatus";
var MedicalSymptom = "http://schema.org/MedicalSymptom";
var MedicalTest = "http://schema.org/MedicalTest";
var MedicalTestPanel = "http://schema.org/MedicalTestPanel";
var MedicalTherapy = "http://schema.org/MedicalTherapy";
var MedicalTrial = "http://schema.org/MedicalTrial";
var MedicalTrialDesign = "http://schema.org/MedicalTrialDesign";
var MedicalWebPage = "http://schema.org/MedicalWebPage";
var MedicineSystem = "http://schema.org/MedicineSystem";
var MeetingRoom = "http://schema.org/MeetingRoom";
var MensClothingStore = "http://schema.org/MensClothingStore";
var Menu = "http://schema.org/Menu";
var MenuItem = "http://schema.org/MenuItem";
var MenuSection = "http://schema.org/MenuSection";
var MerchantReturnEnumeration = "http://schema.org/MerchantReturnEnumeration";
var MerchantReturnPolicy = "http://schema.org/MerchantReturnPolicy";
var MerchantReturnPolicySeasonalOverride = "http://schema.org/MerchantReturnPolicySeasonalOverride";
var Message2 = "http://schema.org/Message";
var MiddleSchool = "http://schema.org/MiddleSchool";
var MobileApplication = "http://schema.org/MobileApplication";
var MobilePhoneStore = "http://schema.org/MobilePhoneStore";
var MolecularEntity = "http://schema.org/MolecularEntity";
var MonetaryAmount = "http://schema.org/MonetaryAmount";
var MonetaryAmountDistribution = "http://schema.org/MonetaryAmountDistribution";
var MonetaryGrant = "http://schema.org/MonetaryGrant";
var MoneyTransfer = "http://schema.org/MoneyTransfer";
var MortgageLoan = "http://schema.org/MortgageLoan";
var Mosque = "http://schema.org/Mosque";
var Motel = "http://schema.org/Motel";
var Motorcycle = "http://schema.org/Motorcycle";
var MotorcycleDealer = "http://schema.org/MotorcycleDealer";
var MotorcycleRepair = "http://schema.org/MotorcycleRepair";
var MotorizedBicycle = "http://schema.org/MotorizedBicycle";
var Mountain = "http://schema.org/Mountain";
var MoveAction = "http://schema.org/MoveAction";
var Movie = "http://schema.org/Movie";
var MovieClip = "http://schema.org/MovieClip";
var MovieRentalStore = "http://schema.org/MovieRentalStore";
var MovieSeries = "http://schema.org/MovieSeries";
var MovieTheater = "http://schema.org/MovieTheater";
var MovingCompany = "http://schema.org/MovingCompany";
var Muscle = "http://schema.org/Muscle";
var Museum = "http://schema.org/Museum";
var MusicAlbum = "http://schema.org/MusicAlbum";
var MusicAlbumProductionType = "http://schema.org/MusicAlbumProductionType";
var MusicAlbumReleaseType = "http://schema.org/MusicAlbumReleaseType";
var MusicComposition = "http://schema.org/MusicComposition";
var MusicEvent = "http://schema.org/MusicEvent";
var MusicGroup = "http://schema.org/MusicGroup";
var MusicPlaylist = "http://schema.org/MusicPlaylist";
var MusicRecording = "http://schema.org/MusicRecording";
var MusicRelease = "http://schema.org/MusicRelease";
var MusicReleaseFormatType = "http://schema.org/MusicReleaseFormatType";
var MusicStore = "http://schema.org/MusicStore";
var MusicVenue = "http://schema.org/MusicVenue";
var MusicVideoObject = "http://schema.org/MusicVideoObject";
var NGO = "http://schema.org/NGO";
var NLNonprofitType = "http://schema.org/NLNonprofitType";
var NailSalon = "http://schema.org/NailSalon";
var Nerve = "http://schema.org/Nerve";
var NewsArticle = "http://schema.org/NewsArticle";
var NewsMediaOrganization = "http://schema.org/NewsMediaOrganization";
var Newspaper = "http://schema.org/Newspaper";
var NightClub = "http://schema.org/NightClub";
var NonprofitType = "http://schema.org/NonprofitType";
var Notary = "http://schema.org/Notary";
var NoteDigitalDocument = "http://schema.org/NoteDigitalDocument";
var Number__workaround = "http://schema.org/Number";
var NutritionInformation = "http://schema.org/NutritionInformation";
var Observation2 = "http://schema.org/Observation";
var Occupation = "http://schema.org/Occupation";
var OccupationalExperienceRequirements = "http://schema.org/OccupationalExperienceRequirements";
var OccupationalTherapy = "http://schema.org/OccupationalTherapy";
var OceanBodyOfWater = "http://schema.org/OceanBodyOfWater";
var Offer2 = "http://schema.org/Offer";
var OfferCatalog = "http://schema.org/OfferCatalog";
var OfferForLease = "http://schema.org/OfferForLease";
var OfferForPurchase = "http://schema.org/OfferForPurchase";
var OfferItemCondition = "http://schema.org/OfferItemCondition";
var OfferShippingDetails = "http://schema.org/OfferShippingDetails";
var OfficeEquipmentStore = "http://schema.org/OfficeEquipmentStore";
var OnDemandEvent = "http://schema.org/OnDemandEvent";
var OnlineBusiness = "http://schema.org/OnlineBusiness";
var OnlineStore = "http://schema.org/OnlineStore";
var OpeningHoursSpecification = "http://schema.org/OpeningHoursSpecification";
var OpinionNewsArticle = "http://schema.org/OpinionNewsArticle";
var Optician = "http://schema.org/Optician";
var Order = "http://schema.org/Order";
var OrderAction = "http://schema.org/OrderAction";
var OrderItem = "http://schema.org/OrderItem";
var OrderStatus = "http://schema.org/OrderStatus";
var Organization4 = "http://schema.org/Organization";
var OrganizationRole = "http://schema.org/OrganizationRole";
var OrganizeAction = "http://schema.org/OrganizeAction";
var OutletStore = "http://schema.org/OutletStore";
var OwnershipInfo = "http://schema.org/OwnershipInfo";
var PaintAction = "http://schema.org/PaintAction";
var Painting = "http://schema.org/Painting";
var PalliativeProcedure = "http://schema.org/PalliativeProcedure";
var ParcelDelivery = "http://schema.org/ParcelDelivery";
var ParentAudience = "http://schema.org/ParentAudience";
var Park = "http://schema.org/Park";
var ParkingFacility = "http://schema.org/ParkingFacility";
var PathologyTest = "http://schema.org/PathologyTest";
var Patient2 = "http://schema.org/Patient";
var PawnShop = "http://schema.org/PawnShop";
var PayAction = "http://schema.org/PayAction";
var PaymentCard = "http://schema.org/PaymentCard";
var PaymentChargeSpecification = "http://schema.org/PaymentChargeSpecification";
var PaymentMethod = "http://schema.org/PaymentMethod";
var PaymentService = "http://schema.org/PaymentService";
var PaymentStatusType = "http://schema.org/PaymentStatusType";
var PeopleAudience = "http://schema.org/PeopleAudience";
var PerformAction = "http://schema.org/PerformAction";
var PerformanceRole = "http://schema.org/PerformanceRole";
var PerformingArtsTheater = "http://schema.org/PerformingArtsTheater";
var PerformingGroup = "http://schema.org/PerformingGroup";
var Periodical = "http://schema.org/Periodical";
var Permit = "http://schema.org/Permit";
var Person4 = "http://schema.org/Person";
var PetStore = "http://schema.org/PetStore";
var Pharmacy = "http://schema.org/Pharmacy";
var Photograph = "http://schema.org/Photograph";
var PhotographAction = "http://schema.org/PhotographAction";
var PhysicalActivity = "http://schema.org/PhysicalActivity";
var PhysicalActivityCategory = "http://schema.org/PhysicalActivityCategory";
var PhysicalExam = "http://schema.org/PhysicalExam";
var PhysicalTherapy = "http://schema.org/PhysicalTherapy";
var Physician = "http://schema.org/Physician";
var Place2 = "http://schema.org/Place";
var PlaceOfWorship = "http://schema.org/PlaceOfWorship";
var PlanAction = "http://schema.org/PlanAction";
var Play = "http://schema.org/Play";
var PlayAction = "http://schema.org/PlayAction";
var PlayGameAction = "http://schema.org/PlayGameAction";
var Playground = "http://schema.org/Playground";
var Plumber = "http://schema.org/Plumber";
var PodcastEpisode = "http://schema.org/PodcastEpisode";
var PodcastSeason = "http://schema.org/PodcastSeason";
var PodcastSeries = "http://schema.org/PodcastSeries";
var PoliceStation = "http://schema.org/PoliceStation";
var PoliticalParty = "http://schema.org/PoliticalParty";
var Pond = "http://schema.org/Pond";
var PostOffice = "http://schema.org/PostOffice";
var PostalAddress = "http://schema.org/PostalAddress";
var PostalCodeRangeSpecification = "http://schema.org/PostalCodeRangeSpecification";
var Poster = "http://schema.org/Poster";
var PreOrderAction = "http://schema.org/PreOrderAction";
var PrependAction = "http://schema.org/PrependAction";
var Preschool = "http://schema.org/Preschool";
var PresentationDigitalDocument = "http://schema.org/PresentationDigitalDocument";
var PreventionIndication = "http://schema.org/PreventionIndication";
var PriceComponentTypeEnumeration = "http://schema.org/PriceComponentTypeEnumeration";
var PriceSpecification = "http://schema.org/PriceSpecification";
var PriceTypeEnumeration = "http://schema.org/PriceTypeEnumeration";
var Product = "http://schema.org/Product";
var ProductCollection = "http://schema.org/ProductCollection";
var ProductGroup = "http://schema.org/ProductGroup";
var ProductModel = "http://schema.org/ProductModel";
var ProductReturnEnumeration = "http://schema.org/ProductReturnEnumeration";
var ProductReturnPolicy = "http://schema.org/ProductReturnPolicy";
var ProfessionalService = "http://schema.org/ProfessionalService";
var ProfilePage = "http://schema.org/ProfilePage";
var ProgramMembership = "http://schema.org/ProgramMembership";
var Project2 = "http://schema.org/Project";
var PronounceableText = "http://schema.org/PronounceableText";
var Property3 = "http://schema.org/Property";
var PropertyValue = "http://schema.org/PropertyValue";
var PropertyValueSpecification = "http://schema.org/PropertyValueSpecification";
var Protein = "http://schema.org/Protein";
var PsychologicalTreatment = "http://schema.org/PsychologicalTreatment";
var PublicSwimmingPool = "http://schema.org/PublicSwimmingPool";
var PublicToilet = "http://schema.org/PublicToilet";
var PublicationEvent = "http://schema.org/PublicationEvent";
var PublicationIssue = "http://schema.org/PublicationIssue";
var PublicationVolume = "http://schema.org/PublicationVolume";
var QAPage = "http://schema.org/QAPage";
var QualitativeValue = "http://schema.org/QualitativeValue";
var QuantitativeValue = "http://schema.org/QuantitativeValue";
var QuantitativeValueDistribution = "http://schema.org/QuantitativeValueDistribution";
var Quantity2 = "http://schema.org/Quantity";
var Question2 = "http://schema.org/Question";
var Quiz = "http://schema.org/Quiz";
var Quotation = "http://schema.org/Quotation";
var QuoteAction = "http://schema.org/QuoteAction";
var RVPark = "http://schema.org/RVPark";
var RadiationTherapy = "http://schema.org/RadiationTherapy";
var RadioBroadcastService = "http://schema.org/RadioBroadcastService";
var RadioChannel = "http://schema.org/RadioChannel";
var RadioClip = "http://schema.org/RadioClip";
var RadioEpisode = "http://schema.org/RadioEpisode";
var RadioSeason = "http://schema.org/RadioSeason";
var RadioSeries = "http://schema.org/RadioSeries";
var RadioStation = "http://schema.org/RadioStation";
var Rating = "http://schema.org/Rating";
var ReactAction = "http://schema.org/ReactAction";
var ReadAction = "http://schema.org/ReadAction";
var RealEstateAgent = "http://schema.org/RealEstateAgent";
var RealEstateListing = "http://schema.org/RealEstateListing";
var ReceiveAction = "http://schema.org/ReceiveAction";
var Recipe = "http://schema.org/Recipe";
var Recommendation = "http://schema.org/Recommendation";
var RecommendedDoseSchedule = "http://schema.org/RecommendedDoseSchedule";
var RecyclingCenter = "http://schema.org/RecyclingCenter";
var RefundTypeEnumeration = "http://schema.org/RefundTypeEnumeration";
var RegisterAction = "http://schema.org/RegisterAction";
var RejectAction = "http://schema.org/RejectAction";
var RentAction = "http://schema.org/RentAction";
var RentalCarReservation = "http://schema.org/RentalCarReservation";
var RepaymentSpecification = "http://schema.org/RepaymentSpecification";
var ReplaceAction = "http://schema.org/ReplaceAction";
var ReplyAction = "http://schema.org/ReplyAction";
var Report = "http://schema.org/Report";
var ReportageNewsArticle = "http://schema.org/ReportageNewsArticle";
var ReportedDoseSchedule = "http://schema.org/ReportedDoseSchedule";
var ResearchOrganization = "http://schema.org/ResearchOrganization";
var ResearchProject = "http://schema.org/ResearchProject";
var Researcher = "http://schema.org/Researcher";
var Reservation = "http://schema.org/Reservation";
var ReservationPackage = "http://schema.org/ReservationPackage";
var ReservationStatusType = "http://schema.org/ReservationStatusType";
var ReserveAction = "http://schema.org/ReserveAction";
var Reservoir = "http://schema.org/Reservoir";
var Residence = "http://schema.org/Residence";
var Resort = "http://schema.org/Resort";
var Restaurant = "http://schema.org/Restaurant";
var RestrictedDiet = "http://schema.org/RestrictedDiet";
var ResumeAction = "http://schema.org/ResumeAction";
var ReturnAction = "http://schema.org/ReturnAction";
var ReturnFeesEnumeration = "http://schema.org/ReturnFeesEnumeration";
var ReturnLabelSourceEnumeration = "http://schema.org/ReturnLabelSourceEnumeration";
var ReturnMethodEnumeration = "http://schema.org/ReturnMethodEnumeration";
var Review = "http://schema.org/Review";
var ReviewAction = "http://schema.org/ReviewAction";
var ReviewNewsArticle = "http://schema.org/ReviewNewsArticle";
var RiverBodyOfWater = "http://schema.org/RiverBodyOfWater";
var Role = "http://schema.org/Role";
var RoofingContractor = "http://schema.org/RoofingContractor";
var Room = "http://schema.org/Room";
var RsvpAction = "http://schema.org/RsvpAction";
var RsvpResponseType = "http://schema.org/RsvpResponseType";
var SaleEvent = "http://schema.org/SaleEvent";
var SatiricalArticle = "http://schema.org/SatiricalArticle";
var Schedule2 = "http://schema.org/Schedule";
var ScheduleAction = "http://schema.org/ScheduleAction";
var ScholarlyArticle = "http://schema.org/ScholarlyArticle";
var School = "http://schema.org/School";
var SchoolDistrict = "http://schema.org/SchoolDistrict";
var ScreeningEvent = "http://schema.org/ScreeningEvent";
var Sculpture = "http://schema.org/Sculpture";
var SeaBodyOfWater = "http://schema.org/SeaBodyOfWater";
var SearchAction = "http://schema.org/SearchAction";
var SearchRescueOrganization = "http://schema.org/SearchRescueOrganization";
var SearchResultsPage = "http://schema.org/SearchResultsPage";
var Season = "http://schema.org/Season";
var Seat = "http://schema.org/Seat";
var SeekToAction = "http://schema.org/SeekToAction";
var SelfStorage = "http://schema.org/SelfStorage";
var SellAction = "http://schema.org/SellAction";
var SendAction = "http://schema.org/SendAction";
var Series = "http://schema.org/Series";
var Service2 = "http://schema.org/Service";
var ServiceChannel = "http://schema.org/ServiceChannel";
var ShareAction = "http://schema.org/ShareAction";
var SheetMusic = "http://schema.org/SheetMusic";
var ShippingDeliveryTime = "http://schema.org/ShippingDeliveryTime";
var ShippingRateSettings = "http://schema.org/ShippingRateSettings";
var ShoeStore = "http://schema.org/ShoeStore";
var ShoppingCenter = "http://schema.org/ShoppingCenter";
var ShortStory = "http://schema.org/ShortStory";
var SingleFamilyResidence = "http://schema.org/SingleFamilyResidence";
var SiteNavigationElement = "http://schema.org/SiteNavigationElement";
var SizeGroupEnumeration = "http://schema.org/SizeGroupEnumeration";
var SizeSpecification = "http://schema.org/SizeSpecification";
var SizeSystemEnumeration = "http://schema.org/SizeSystemEnumeration";
var SkiResort = "http://schema.org/SkiResort";
var SocialEvent = "http://schema.org/SocialEvent";
var SocialMediaPosting = "http://schema.org/SocialMediaPosting";
var SoftwareApplication = "http://schema.org/SoftwareApplication";
var SoftwareSourceCode = "http://schema.org/SoftwareSourceCode";
var SolveMathAction = "http://schema.org/SolveMathAction";
var SomeProducts = "http://schema.org/SomeProducts";
var SpeakableSpecification = "http://schema.org/SpeakableSpecification";
var SpecialAnnouncement = "http://schema.org/SpecialAnnouncement";
var Specialty = "http://schema.org/Specialty";
var SportingGoodsStore = "http://schema.org/SportingGoodsStore";
var SportsActivityLocation = "http://schema.org/SportsActivityLocation";
var SportsClub = "http://schema.org/SportsClub";
var SportsEvent = "http://schema.org/SportsEvent";
var SportsOrganization = "http://schema.org/SportsOrganization";
var SportsTeam = "http://schema.org/SportsTeam";
var SpreadsheetDigitalDocument = "http://schema.org/SpreadsheetDigitalDocument";
var StadiumOrArena = "http://schema.org/StadiumOrArena";
var State = "http://schema.org/State";
var Statement2 = "http://schema.org/Statement";
var StatisticalPopulation = "http://schema.org/StatisticalPopulation";
var StatisticalVariable = "http://schema.org/StatisticalVariable";
var StatusEnumeration = "http://schema.org/StatusEnumeration";
var SteeringPositionValue = "http://schema.org/SteeringPositionValue";
var Store2 = "http://schema.org/Store";
var StructuredValue = "http://schema.org/StructuredValue";
var StupidType = "http://schema.org/StupidType";
var SubscribeAction = "http://schema.org/SubscribeAction";
var Substance2 = "http://schema.org/Substance";
var SubwayStation = "http://schema.org/SubwayStation";
var Suite = "http://schema.org/Suite";
var SuperficialAnatomy = "http://schema.org/SuperficialAnatomy";
var SurgicalProcedure = "http://schema.org/SurgicalProcedure";
var SuspendAction = "http://schema.org/SuspendAction";
var Syllabus = "http://schema.org/Syllabus";
var Synagogue = "http://schema.org/Synagogue";
var TVClip = "http://schema.org/TVClip";
var TVEpisode = "http://schema.org/TVEpisode";
var TVSeason = "http://schema.org/TVSeason";
var TVSeries = "http://schema.org/TVSeries";
var Table = "http://schema.org/Table";
var TakeAction = "http://schema.org/TakeAction";
var TattooParlor = "http://schema.org/TattooParlor";
var Taxi = "http://schema.org/Taxi";
var TaxiReservation = "http://schema.org/TaxiReservation";
var TaxiService = "http://schema.org/TaxiService";
var TaxiStand = "http://schema.org/TaxiStand";
var Taxon = "http://schema.org/Taxon";
var TechArticle = "http://schema.org/TechArticle";
var TelevisionChannel = "http://schema.org/TelevisionChannel";
var TelevisionStation = "http://schema.org/TelevisionStation";
var TennisComplex = "http://schema.org/TennisComplex";
var Text = "http://schema.org/Text";
var TextDigitalDocument = "http://schema.org/TextDigitalDocument";
var TextObject = "http://schema.org/TextObject";
var TheaterEvent = "http://schema.org/TheaterEvent";
var TheaterGroup = "http://schema.org/TheaterGroup";
var TherapeuticProcedure = "http://schema.org/TherapeuticProcedure";
var Thesis = "http://schema.org/Thesis";
var Thing3 = "http://schema.org/Thing";
var Ticket = "http://schema.org/Ticket";
var TieAction = "http://schema.org/TieAction";
var Time = "http://schema.org/Time";
var TipAction = "http://schema.org/TipAction";
var TireShop = "http://schema.org/TireShop";
var TouristAttraction = "http://schema.org/TouristAttraction";
var TouristDestination = "http://schema.org/TouristDestination";
var TouristInformationCenter = "http://schema.org/TouristInformationCenter";
var TouristTrip = "http://schema.org/TouristTrip";
var ToyStore = "http://schema.org/ToyStore";
var TrackAction = "http://schema.org/TrackAction";
var TradeAction = "http://schema.org/TradeAction";
var TrainReservation = "http://schema.org/TrainReservation";
var TrainStation = "http://schema.org/TrainStation";
var TrainTrip = "http://schema.org/TrainTrip";
var TransferAction = "http://schema.org/TransferAction";
var TravelAction = "http://schema.org/TravelAction";
var TravelAgency = "http://schema.org/TravelAgency";
var TreatmentIndication = "http://schema.org/TreatmentIndication";
var Trip2 = "http://schema.org/Trip";
var TypeAndQuantityNode = "http://schema.org/TypeAndQuantityNode";
var UKNonprofitType = "http://schema.org/UKNonprofitType";
var URL2 = "http://schema.org/URL";
var USNonprofitType = "http://schema.org/USNonprofitType";
var UnRegisterAction = "http://schema.org/UnRegisterAction";
var UnitPriceSpecification = "http://schema.org/UnitPriceSpecification";
var UpdateAction = "http://schema.org/UpdateAction";
var UseAction = "http://schema.org/UseAction";
var UserBlocks = "http://schema.org/UserBlocks";
var UserCheckins = "http://schema.org/UserCheckins";
var UserComments = "http://schema.org/UserComments";
var UserDownloads = "http://schema.org/UserDownloads";
var UserInteraction = "http://schema.org/UserInteraction";
var UserLikes = "http://schema.org/UserLikes";
var UserPageVisits = "http://schema.org/UserPageVisits";
var UserPlays = "http://schema.org/UserPlays";
var UserPlusOnes = "http://schema.org/UserPlusOnes";
var UserReview = "http://schema.org/UserReview";
var UserTweets = "http://schema.org/UserTweets";
var VacationRental = "http://schema.org/VacationRental";
var Vehicle = "http://schema.org/Vehicle";
var Vein = "http://schema.org/Vein";
var Vessel = "http://schema.org/Vessel";
var VeterinaryCare = "http://schema.org/VeterinaryCare";
var VideoGallery = "http://schema.org/VideoGallery";
var VideoGame = "http://schema.org/VideoGame";
var VideoGameClip = "http://schema.org/VideoGameClip";
var VideoGameSeries = "http://schema.org/VideoGameSeries";
var VideoObject = "http://schema.org/VideoObject";
var VideoObjectSnapshot = "http://schema.org/VideoObjectSnapshot";
var ViewAction = "http://schema.org/ViewAction";
var VirtualLocation = "http://schema.org/VirtualLocation";
var VisualArtsEvent = "http://schema.org/VisualArtsEvent";
var VisualArtwork = "http://schema.org/VisualArtwork";
var VitalSign = "http://schema.org/VitalSign";
var Volcano = "http://schema.org/Volcano";
var VoteAction = "http://schema.org/VoteAction";
var WPAdBlock = "http://schema.org/WPAdBlock";
var WPFooter = "http://schema.org/WPFooter";
var WPHeader = "http://schema.org/WPHeader";
var WPSideBar = "http://schema.org/WPSideBar";
var WantAction = "http://schema.org/WantAction";
var WarrantyPromise = "http://schema.org/WarrantyPromise";
var WarrantyScope = "http://schema.org/WarrantyScope";
var WatchAction = "http://schema.org/WatchAction";
var Waterfall = "http://schema.org/Waterfall";
var WearAction = "http://schema.org/WearAction";
var WearableMeasurementTypeEnumeration = "http://schema.org/WearableMeasurementTypeEnumeration";
var WearableSizeGroupEnumeration = "http://schema.org/WearableSizeGroupEnumeration";
var WearableSizeSystemEnumeration = "http://schema.org/WearableSizeSystemEnumeration";
var WebAPI = "http://schema.org/WebAPI";
var WebApplication = "http://schema.org/WebApplication";
var WebContent = "http://schema.org/WebContent";
var WebPage = "http://schema.org/WebPage";
var WebPageElement = "http://schema.org/WebPageElement";
var WebSite = "http://schema.org/WebSite";
var WholesaleStore = "http://schema.org/WholesaleStore";
var WinAction = "http://schema.org/WinAction";
var Winery = "http://schema.org/Winery";
var WorkBasedProgram = "http://schema.org/WorkBasedProgram";
var WorkersUnion = "http://schema.org/WorkersUnion";
var WriteAction = "http://schema.org/WriteAction";
var XPathType = "http://schema.org/XPathType";
var Zoo = "http://schema.org/Zoo";
var abridged = "http://schema.org/abridged";
var abstract3 = "http://schema.org/abstract";
var accelerationTime = "http://schema.org/accelerationTime";
var acceptedAnswer = "http://schema.org/acceptedAnswer";
var acceptedOffer = "http://schema.org/acceptedOffer";
var acceptedPaymentMethod = "http://schema.org/acceptedPaymentMethod";
var acceptsReservations = "http://schema.org/acceptsReservations";
var accessCode = "http://schema.org/accessCode";
var accessMode = "http://schema.org/accessMode";
var accessModeSufficient = "http://schema.org/accessModeSufficient";
var accessibilityAPI = "http://schema.org/accessibilityAPI";
var accessibilityControl = "http://schema.org/accessibilityControl";
var accessibilityFeature = "http://schema.org/accessibilityFeature";
var accessibilityHazard = "http://schema.org/accessibilityHazard";
var accessibilitySummary = "http://schema.org/accessibilitySummary";
var accommodationCategory = "http://schema.org/accommodationCategory";
var accommodationFloorPlan = "http://schema.org/accommodationFloorPlan";
var accountId = "http://schema.org/accountId";
var accountMinimumInflow = "http://schema.org/accountMinimumInflow";
var accountOverdraftLimit = "http://schema.org/accountOverdraftLimit";
var accountablePerson = "http://schema.org/accountablePerson";
var acquireLicensePage = "http://schema.org/acquireLicensePage";
var acquiredFrom = "http://schema.org/acquiredFrom";
var acrissCode = "http://schema.org/acrissCode";
var actionAccessibilityRequirement = "http://schema.org/actionAccessibilityRequirement";
var actionPlatform = "http://schema.org/actionPlatform";
var actionStatus = "http://schema.org/actionStatus";
var actionableFeedbackPolicy = "http://schema.org/actionableFeedbackPolicy";
var activeIngredient = "http://schema.org/activeIngredient";
var activityDuration = "http://schema.org/activityDuration";
var activityFrequency = "http://schema.org/activityFrequency";
var actors = "http://schema.org/actors";
var addOn = "http://schema.org/addOn";
var additionalName = "http://schema.org/additionalName";
var additionalNumberOfGuests = "http://schema.org/additionalNumberOfGuests";
var additionalProperty = "http://schema.org/additionalProperty";
var additionalType = "http://schema.org/additionalType";
var additionalVariable = "http://schema.org/additionalVariable";
var address3 = "http://schema.org/address";
var addressCountry = "http://schema.org/addressCountry";
var addressLocality = "http://schema.org/addressLocality";
var addressRegion = "http://schema.org/addressRegion";
var administrationRoute = "http://schema.org/administrationRoute";
var advanceBookingRequirement = "http://schema.org/advanceBookingRequirement";
var adverseOutcome = "http://schema.org/adverseOutcome";
var affectedBy = "http://schema.org/affectedBy";
var affiliation2 = "http://schema.org/affiliation";
var afterMedia = "http://schema.org/afterMedia";
var agent3 = "http://schema.org/agent";
var aggregateRating = "http://schema.org/aggregateRating";
var aircraft = "http://schema.org/aircraft";
var albumProductionType = "http://schema.org/albumProductionType";
var albumReleaseType = "http://schema.org/albumReleaseType";
var albums = "http://schema.org/albums";
var alcoholWarning = "http://schema.org/alcoholWarning";
var algorithm = "http://schema.org/algorithm";
var alignmentType = "http://schema.org/alignmentType";
var alternativeHeadline = "http://schema.org/alternativeHeadline";
var alternativeOf = "http://schema.org/alternativeOf";
var amenityFeature = "http://schema.org/amenityFeature";
var amount3 = "http://schema.org/amount";
var amountOfThisGood = "http://schema.org/amountOfThisGood";
var announcementLocation = "http://schema.org/announcementLocation";
var annualPercentageRate = "http://schema.org/annualPercentageRate";
var answerCount = "http://schema.org/answerCount";
var answerExplanation = "http://schema.org/answerExplanation";
var antagonist = "http://schema.org/antagonist";
var appearance = "http://schema.org/appearance";
var applicableCountry = "http://schema.org/applicableCountry";
var applicableLocation = "http://schema.org/applicableLocation";
var applicantLocationRequirements = "http://schema.org/applicantLocationRequirements";
var application2 = "http://schema.org/application";
var applicationCategory = "http://schema.org/applicationCategory";
var applicationContact = "http://schema.org/applicationContact";
var applicationDeadline = "http://schema.org/applicationDeadline";
var applicationStartDate = "http://schema.org/applicationStartDate";
var applicationSubCategory = "http://schema.org/applicationSubCategory";
var applicationSuite = "http://schema.org/applicationSuite";
var appliesToDeliveryMethod = "http://schema.org/appliesToDeliveryMethod";
var appliesToPaymentMethod = "http://schema.org/appliesToPaymentMethod";
var archivedAt = "http://schema.org/archivedAt";
var area = "http://schema.org/area";
var arrivalAirport = "http://schema.org/arrivalAirport";
var arrivalBoatTerminal = "http://schema.org/arrivalBoatTerminal";
var arrivalBusStop = "http://schema.org/arrivalBusStop";
var arrivalGate = "http://schema.org/arrivalGate";
var arrivalPlatform = "http://schema.org/arrivalPlatform";
var arrivalStation = "http://schema.org/arrivalStation";
var arrivalTerminal = "http://schema.org/arrivalTerminal";
var arrivalTime = "http://schema.org/arrivalTime";
var artEdition = "http://schema.org/artEdition";
var artMedium = "http://schema.org/artMedium";
var artform = "http://schema.org/artform";
var articleBody = "http://schema.org/articleBody";
var articleSection = "http://schema.org/articleSection";
var artist = "http://schema.org/artist";
var asin = "http://schema.org/asin";
var aspect = "http://schema.org/aspect";
var assembly = "http://schema.org/assembly";
var assemblyVersion = "http://schema.org/assemblyVersion";
var assesses = "http://schema.org/assesses";
var associatedAnatomy = "http://schema.org/associatedAnatomy";
var associatedArticle = "http://schema.org/associatedArticle";
var associatedClaimReview = "http://schema.org/associatedClaimReview";
var associatedDisease = "http://schema.org/associatedDisease";
var associatedMedia = "http://schema.org/associatedMedia";
var associatedMediaReview = "http://schema.org/associatedMediaReview";
var associatedPathophysiology = "http://schema.org/associatedPathophysiology";
var athlete = "http://schema.org/athlete";
var attendees = "http://schema.org/attendees";
var audienceType = "http://schema.org/audienceType";
var audio = "http://schema.org/audio";
var authenticator = "http://schema.org/authenticator";
var author3 = "http://schema.org/author";
var availability2 = "http://schema.org/availability";
var availabilityEnds = "http://schema.org/availabilityEnds";
var availabilityStarts = "http://schema.org/availabilityStarts";
var availableAtOrFrom = "http://schema.org/availableAtOrFrom";
var availableChannel = "http://schema.org/availableChannel";
var availableDeliveryMethod = "http://schema.org/availableDeliveryMethod";
var availableFrom = "http://schema.org/availableFrom";
var availableIn = "http://schema.org/availableIn";
var availableLanguage = "http://schema.org/availableLanguage";
var availableService = "http://schema.org/availableService";
var availableStrength = "http://schema.org/availableStrength";
var availableTest = "http://schema.org/availableTest";
var availableThrough = "http://schema.org/availableThrough";
var awards = "http://schema.org/awards";
var awayTeam = "http://schema.org/awayTeam";
var backstory = "http://schema.org/backstory";
var bankAccountType = "http://schema.org/bankAccountType";
var baseSalary = "http://schema.org/baseSalary";
var bccRecipient = "http://schema.org/bccRecipient";
var bed = "http://schema.org/bed";
var beforeMedia = "http://schema.org/beforeMedia";
var beneficiaryBank = "http://schema.org/beneficiaryBank";
var benefits = "http://schema.org/benefits";
var benefitsSummaryUrl = "http://schema.org/benefitsSummaryUrl";
var bestRating = "http://schema.org/bestRating";
var billingAddress = "http://schema.org/billingAddress";
var billingDuration = "http://schema.org/billingDuration";
var billingIncrement = "http://schema.org/billingIncrement";
var billingPeriod = "http://schema.org/billingPeriod";
var billingStart = "http://schema.org/billingStart";
var bioChemInteraction = "http://schema.org/bioChemInteraction";
var bioChemSimilarity = "http://schema.org/bioChemSimilarity";
var biologicalRole = "http://schema.org/biologicalRole";
var biomechnicalClass = "http://schema.org/biomechnicalClass";
var birthDate2 = "http://schema.org/birthDate";
var birthPlace = "http://schema.org/birthPlace";
var bitrate = "http://schema.org/bitrate";
var blogPosts = "http://schema.org/blogPosts";
var bloodSupply = "http://schema.org/bloodSupply";
var boardingGroup = "http://schema.org/boardingGroup";
var boardingPolicy = "http://schema.org/boardingPolicy";
var bodyLocation = "http://schema.org/bodyLocation";
var bodyType = "http://schema.org/bodyType";
var bookEdition = "http://schema.org/bookEdition";
var bookFormat = "http://schema.org/bookFormat";
var bookingAgent = "http://schema.org/bookingAgent";
var bookingTime = "http://schema.org/bookingTime";
var borrower = "http://schema.org/borrower";
var box = "http://schema.org/box";
var branch = "http://schema.org/branch";
var branchCode = "http://schema.org/branchCode";
var branchOf = "http://schema.org/branchOf";
var brand2 = "http://schema.org/brand";
var breadcrumb = "http://schema.org/breadcrumb";
var breastfeedingWarning = "http://schema.org/breastfeedingWarning";
var broadcastAffiliateOf = "http://schema.org/broadcastAffiliateOf";
var broadcastChannelId = "http://schema.org/broadcastChannelId";
var broadcastDisplayName = "http://schema.org/broadcastDisplayName";
var broadcastFrequency = "http://schema.org/broadcastFrequency";
var broadcastFrequencyValue = "http://schema.org/broadcastFrequencyValue";
var broadcastOfEvent = "http://schema.org/broadcastOfEvent";
var broadcastServiceTier = "http://schema.org/broadcastServiceTier";
var broadcastSignalModulation = "http://schema.org/broadcastSignalModulation";
var broadcastSubChannel = "http://schema.org/broadcastSubChannel";
var broadcastTimezone = "http://schema.org/broadcastTimezone";
var broadcaster = "http://schema.org/broadcaster";
var browserRequirements = "http://schema.org/browserRequirements";
var busName = "http://schema.org/busName";
var busNumber = "http://schema.org/busNumber";
var businessDays = "http://schema.org/businessDays";
var businessFunction = "http://schema.org/businessFunction";
var buyer = "http://schema.org/buyer";
var byArtist = "http://schema.org/byArtist";
var byDay = "http://schema.org/byDay";
var byMonth = "http://schema.org/byMonth";
var byMonthDay = "http://schema.org/byMonthDay";
var byMonthWeek = "http://schema.org/byMonthWeek";
var callSign = "http://schema.org/callSign";
var calories = "http://schema.org/calories";
var candidate2 = "http://schema.org/candidate";
var carbohydrateContent = "http://schema.org/carbohydrateContent";
var cargoVolume = "http://schema.org/cargoVolume";
var carrier = "http://schema.org/carrier";
var carrierRequirements = "http://schema.org/carrierRequirements";
var cashBack = "http://schema.org/cashBack";
var catalog = "http://schema.org/catalog";
var catalogNumber = "http://schema.org/catalogNumber";
var causeOf = "http://schema.org/causeOf";
var ccRecipient = "http://schema.org/ccRecipient";
var character = "http://schema.org/character";
var characterAttribute = "http://schema.org/characterAttribute";
var characterName = "http://schema.org/characterName";
var cheatCode = "http://schema.org/cheatCode";
var checkinTime = "http://schema.org/checkinTime";
var checkoutPageURLTemplate = "http://schema.org/checkoutPageURLTemplate";
var checkoutTime = "http://schema.org/checkoutTime";
var chemicalComposition = "http://schema.org/chemicalComposition";
var chemicalRole = "http://schema.org/chemicalRole";
var childMaxAge = "http://schema.org/childMaxAge";
var childMinAge = "http://schema.org/childMinAge";
var children = "http://schema.org/children";
var cholesterolContent = "http://schema.org/cholesterolContent";
var circle = "http://schema.org/circle";
var citation2 = "http://schema.org/citation";
var claimInterpreter = "http://schema.org/claimInterpreter";
var claimReviewed = "http://schema.org/claimReviewed";
var clincalPharmacology = "http://schema.org/clincalPharmacology";
var clipNumber = "http://schema.org/clipNumber";
var closes = "http://schema.org/closes";
var coach = "http://schema.org/coach";
var code2 = "http://schema.org/code";
var codeRepository = "http://schema.org/codeRepository";
var codeValue = "http://schema.org/codeValue";
var codingSystem = "http://schema.org/codingSystem";
var colleagues = "http://schema.org/colleagues";
var collection3 = "http://schema.org/collection";
var collectionSize = "http://schema.org/collectionSize";
var color2 = "http://schema.org/color";
var colorist = "http://schema.org/colorist";
var comment4 = "http://schema.org/comment";
var commentCount = "http://schema.org/commentCount";
var commentText = "http://schema.org/commentText";
var commentTime = "http://schema.org/commentTime";
var competencyRequired = "http://schema.org/competencyRequired";
var composer = "http://schema.org/composer";
var comprisedOf2 = "http://schema.org/comprisedOf";
var conditionsOfAccess = "http://schema.org/conditionsOfAccess";
var confirmationNumber = "http://schema.org/confirmationNumber";
var connectedTo = "http://schema.org/connectedTo";
var constraintProperty = "http://schema.org/constraintProperty";
var contactOption = "http://schema.org/contactOption";
var contactPoints = "http://schema.org/contactPoints";
var contactType = "http://schema.org/contactType";
var contactlessPayment = "http://schema.org/contactlessPayment";
var containedIn = "http://schema.org/containedIn";
var contentRating = "http://schema.org/contentRating";
var contentReferenceTime = "http://schema.org/contentReferenceTime";
var contentSize = "http://schema.org/contentSize";
var contentType2 = "http://schema.org/contentType";
var contentUrl = "http://schema.org/contentUrl";
var contraindication2 = "http://schema.org/contraindication";
var contributor4 = "http://schema.org/contributor";
var cookTime = "http://schema.org/cookTime";
var cookingMethod = "http://schema.org/cookingMethod";
var copyrightHolder = "http://schema.org/copyrightHolder";
var copyrightNotice = "http://schema.org/copyrightNotice";
var copyrightYear = "http://schema.org/copyrightYear";
var correction = "http://schema.org/correction";
var correctionsPolicy = "http://schema.org/correctionsPolicy";
var costCategory = "http://schema.org/costCategory";
var costCurrency = "http://schema.org/costCurrency";
var costOrigin = "http://schema.org/costOrigin";
var costPerUnit = "http://schema.org/costPerUnit";
var countriesNotSupported = "http://schema.org/countriesNotSupported";
var countriesSupported = "http://schema.org/countriesSupported";
var countryOfAssembly = "http://schema.org/countryOfAssembly";
var countryOfLastProcessing = "http://schema.org/countryOfLastProcessing";
var countryOfOrigin2 = "http://schema.org/countryOfOrigin";
var course = "http://schema.org/course";
var courseCode = "http://schema.org/courseCode";
var courseMode = "http://schema.org/courseMode";
var coursePrerequisites = "http://schema.org/coursePrerequisites";
var courseSchedule = "http://schema.org/courseSchedule";
var courseWorkload = "http://schema.org/courseWorkload";
var coverageEndTime = "http://schema.org/coverageEndTime";
var coverageStartTime = "http://schema.org/coverageStartTime";
var creativeWorkStatus = "http://schema.org/creativeWorkStatus";
var credentialCategory = "http://schema.org/credentialCategory";
var creditText = "http://schema.org/creditText";
var creditedTo = "http://schema.org/creditedTo";
var cssSelector = "http://schema.org/cssSelector";
var currenciesAccepted = "http://schema.org/currenciesAccepted";
var currency2 = "http://schema.org/currency";
var currentExchangeRate = "http://schema.org/currentExchangeRate";
var customer = "http://schema.org/customer";
var customerRemorseReturnFees = "http://schema.org/customerRemorseReturnFees";
var customerRemorseReturnLabelSource = "http://schema.org/customerRemorseReturnLabelSource";
var customerRemorseReturnShippingFeesAmount = "http://schema.org/customerRemorseReturnShippingFeesAmount";
var cutoffTime = "http://schema.org/cutoffTime";
var cvdCollectionDate = "http://schema.org/cvdCollectionDate";
var cvdFacilityCounty = "http://schema.org/cvdFacilityCounty";
var cvdFacilityId = "http://schema.org/cvdFacilityId";
var cvdNumBeds = "http://schema.org/cvdNumBeds";
var cvdNumBedsOcc = "http://schema.org/cvdNumBedsOcc";
var cvdNumC19Died = "http://schema.org/cvdNumC19Died";
var cvdNumC19HOPats = "http://schema.org/cvdNumC19HOPats";
var cvdNumC19HospPats = "http://schema.org/cvdNumC19HospPats";
var cvdNumC19MechVentPats = "http://schema.org/cvdNumC19MechVentPats";
var cvdNumC19OFMechVentPats = "http://schema.org/cvdNumC19OFMechVentPats";
var cvdNumC19OverflowPats = "http://schema.org/cvdNumC19OverflowPats";
var cvdNumICUBeds = "http://schema.org/cvdNumICUBeds";
var cvdNumICUBedsOcc = "http://schema.org/cvdNumICUBedsOcc";
var cvdNumTotBeds = "http://schema.org/cvdNumTotBeds";
var cvdNumVent = "http://schema.org/cvdNumVent";
var cvdNumVentUse = "http://schema.org/cvdNumVentUse";
var dataFeedElement = "http://schema.org/dataFeedElement";
var datasetTimeInterval = "http://schema.org/datasetTimeInterval";
var dateDeleted = "http://schema.org/dateDeleted";
var dateIssued = "http://schema.org/dateIssued";
var dateModified = "http://schema.org/dateModified";
var datePosted = "http://schema.org/datePosted";
var datePublished = "http://schema.org/datePublished";
var dateRead = "http://schema.org/dateRead";
var dateReceived = "http://schema.org/dateReceived";
var dateSent = "http://schema.org/dateSent";
var dateVehicleFirstRegistered = "http://schema.org/dateVehicleFirstRegistered";
var dateline = "http://schema.org/dateline";
var dayOfWeek2 = "http://schema.org/dayOfWeek";
var deathDate = "http://schema.org/deathDate";
var deathPlace = "http://schema.org/deathPlace";
var defaultValue2 = "http://schema.org/defaultValue";
var deliveryAddress = "http://schema.org/deliveryAddress";
var deliveryLeadTime = "http://schema.org/deliveryLeadTime";
var deliveryMethod = "http://schema.org/deliveryMethod";
var deliveryStatus = "http://schema.org/deliveryStatus";
var deliveryTime = "http://schema.org/deliveryTime";
var department = "http://schema.org/department";
var departureAirport = "http://schema.org/departureAirport";
var departureBoatTerminal = "http://schema.org/departureBoatTerminal";
var departureBusStop = "http://schema.org/departureBusStop";
var departureGate = "http://schema.org/departureGate";
var departurePlatform = "http://schema.org/departurePlatform";
var departureStation = "http://schema.org/departureStation";
var departureTerminal = "http://schema.org/departureTerminal";
var departureTime = "http://schema.org/departureTime";
var dependencies = "http://schema.org/dependencies";
var depth = "http://schema.org/depth";
var device2 = "http://schema.org/device";
var diagnosis2 = "http://schema.org/diagnosis";
var diagram = "http://schema.org/diagram";
var diet = "http://schema.org/diet";
var dietFeatures = "http://schema.org/dietFeatures";
var differentialDiagnosis = "http://schema.org/differentialDiagnosis";
var directApply = "http://schema.org/directApply";
var directors = "http://schema.org/directors";
var disambiguatingDescription = "http://schema.org/disambiguatingDescription";
var discount = "http://schema.org/discount";
var discountCode = "http://schema.org/discountCode";
var discountCurrency = "http://schema.org/discountCurrency";
var discusses = "http://schema.org/discusses";
var discussionUrl = "http://schema.org/discussionUrl";
var diseasePreventionInfo = "http://schema.org/diseasePreventionInfo";
var diseaseSpreadStatistics = "http://schema.org/diseaseSpreadStatistics";
var dissolutionDate = "http://schema.org/dissolutionDate";
var distance = "http://schema.org/distance";
var distinguishingSign = "http://schema.org/distinguishingSign";
var distribution = "http://schema.org/distribution";
var diversityPolicy = "http://schema.org/diversityPolicy";
var diversityStaffingReport = "http://schema.org/diversityStaffingReport";
var documentation2 = "http://schema.org/documentation";
var doesNotShip = "http://schema.org/doesNotShip";
var domainIncludes = "http://schema.org/domainIncludes";
var domiciledMortgage = "http://schema.org/domiciledMortgage";
var doorTime = "http://schema.org/doorTime";
var dosageForm = "http://schema.org/dosageForm";
var doseSchedule = "http://schema.org/doseSchedule";
var doseUnit = "http://schema.org/doseUnit";
var doseValue = "http://schema.org/doseValue";
var downPayment = "http://schema.org/downPayment";
var downloadUrl = "http://schema.org/downloadUrl";
var downvoteCount = "http://schema.org/downvoteCount";
var drainsTo = "http://schema.org/drainsTo";
var driveWheelConfiguration = "http://schema.org/driveWheelConfiguration";
var dropoffLocation = "http://schema.org/dropoffLocation";
var dropoffTime = "http://schema.org/dropoffTime";
var drug = "http://schema.org/drug";
var drugClass = "http://schema.org/drugClass";
var drugUnit = "http://schema.org/drugUnit";
var duns = "http://schema.org/duns";
var duplicateTherapy = "http://schema.org/duplicateTherapy";
var durationOfWarranty = "http://schema.org/durationOfWarranty";
var duringMedia = "http://schema.org/duringMedia";
var earlyPrepaymentPenalty = "http://schema.org/earlyPrepaymentPenalty";
var editEIDR = "http://schema.org/editEIDR";
var editor2 = "http://schema.org/editor";
var eduQuestionType = "http://schema.org/eduQuestionType";
var educationRequirements = "http://schema.org/educationRequirements";
var educationalAlignment = "http://schema.org/educationalAlignment";
var educationalCredentialAwarded = "http://schema.org/educationalCredentialAwarded";
var educationalFramework = "http://schema.org/educationalFramework";
var educationalLevel = "http://schema.org/educationalLevel";
var educationalProgramMode = "http://schema.org/educationalProgramMode";
var educationalRole = "http://schema.org/educationalRole";
var educationalUse = "http://schema.org/educationalUse";
var elevation = "http://schema.org/elevation";
var eligibilityToWorkRequirement = "http://schema.org/eligibilityToWorkRequirement";
var eligibleCustomerType = "http://schema.org/eligibleCustomerType";
var eligibleDuration = "http://schema.org/eligibleDuration";
var eligibleQuantity = "http://schema.org/eligibleQuantity";
var eligibleRegion = "http://schema.org/eligibleRegion";
var eligibleTransactionVolume = "http://schema.org/eligibleTransactionVolume";
var email = "http://schema.org/email";
var embedUrl = "http://schema.org/embedUrl";
var embeddedTextCaption = "http://schema.org/embeddedTextCaption";
var emissionsCO2 = "http://schema.org/emissionsCO2";
var employees = "http://schema.org/employees";
var employerOverview = "http://schema.org/employerOverview";
var employmentType = "http://schema.org/employmentType";
var employmentUnit = "http://schema.org/employmentUnit";
var encodingType = "http://schema.org/encodingType";
var encodings = "http://schema.org/encodings";
var endDate2 = "http://schema.org/endDate";
var endOffset = "http://schema.org/endOffset";
var endTime2 = "http://schema.org/endTime";
var endorsee = "http://schema.org/endorsee";
var endorsers = "http://schema.org/endorsers";
var energyEfficiencyScaleMax = "http://schema.org/energyEfficiencyScaleMax";
var energyEfficiencyScaleMin = "http://schema.org/energyEfficiencyScaleMin";
var engineDisplacement = "http://schema.org/engineDisplacement";
var enginePower = "http://schema.org/enginePower";
var engineType = "http://schema.org/engineType";
var entertainmentBusiness = "http://schema.org/entertainmentBusiness";
var epidemiology = "http://schema.org/epidemiology";
var episodeNumber = "http://schema.org/episodeNumber";
var episodes = "http://schema.org/episodes";
var equal = "http://schema.org/equal";
var error2 = "http://schema.org/error";
var estimatedCost = "http://schema.org/estimatedCost";
var estimatedFlightDuration = "http://schema.org/estimatedFlightDuration";
var estimatedSalary = "http://schema.org/estimatedSalary";
var estimatesRiskOf = "http://schema.org/estimatesRiskOf";
var ethicsPolicy = "http://schema.org/ethicsPolicy";
var eventAttendanceMode = "http://schema.org/eventAttendanceMode";
var eventSchedule = "http://schema.org/eventSchedule";
var eventStatus = "http://schema.org/eventStatus";
var events = "http://schema.org/events";
var evidenceLevel = "http://schema.org/evidenceLevel";
var evidenceOrigin = "http://schema.org/evidenceOrigin";
var exceptDate = "http://schema.org/exceptDate";
var exchangeRateSpread = "http://schema.org/exchangeRateSpread";
var exercisePlan = "http://schema.org/exercisePlan";
var exerciseRelatedDiet = "http://schema.org/exerciseRelatedDiet";
var exerciseType = "http://schema.org/exerciseType";
var exifData = "http://schema.org/exifData";
var expectedArrivalFrom = "http://schema.org/expectedArrivalFrom";
var expectedArrivalUntil = "http://schema.org/expectedArrivalUntil";
var expectedPrognosis = "http://schema.org/expectedPrognosis";
var expectsAcceptanceOf = "http://schema.org/expectsAcceptanceOf";
var experienceInPlaceOfEducation = "http://schema.org/experienceInPlaceOfEducation";
var experienceRequirements = "http://schema.org/experienceRequirements";
var expertConsiderations = "http://schema.org/expertConsiderations";
var expires = "http://schema.org/expires";
var expressedIn = "http://schema.org/expressedIn";
var familyName = "http://schema.org/familyName";
var fatContent = "http://schema.org/fatContent";
var faxNumber = "http://schema.org/faxNumber";
var featureList = "http://schema.org/featureList";
var feesAndCommissionsSpecification = "http://schema.org/feesAndCommissionsSpecification";
var fiberContent = "http://schema.org/fiberContent";
var fileFormat = "http://schema.org/fileFormat";
var fileSize = "http://schema.org/fileSize";
var financialAidEligible = "http://schema.org/financialAidEligible";
var firstAppearance = "http://schema.org/firstAppearance";
var firstPerformance = "http://schema.org/firstPerformance";
var flightDistance = "http://schema.org/flightDistance";
var flightNumber = "http://schema.org/flightNumber";
var floorLevel = "http://schema.org/floorLevel";
var floorLimit = "http://schema.org/floorLimit";
var floorSize = "http://schema.org/floorSize";
var followee = "http://schema.org/followee";
var follows = "http://schema.org/follows";
var followup = "http://schema.org/followup";
var foodEstablishment = "http://schema.org/foodEstablishment";
var foodEvent = "http://schema.org/foodEvent";
var foodWarning = "http://schema.org/foodWarning";
var founders = "http://schema.org/founders";
var foundingDate = "http://schema.org/foundingDate";
var foundingLocation = "http://schema.org/foundingLocation";
var free = "http://schema.org/free";
var freeShippingThreshold = "http://schema.org/freeShippingThreshold";
var fromLocation = "http://schema.org/fromLocation";
var fuelCapacity = "http://schema.org/fuelCapacity";
var fuelConsumption = "http://schema.org/fuelConsumption";
var fuelEfficiency = "http://schema.org/fuelEfficiency";
var fuelType = "http://schema.org/fuelType";
var functionalClass = "http://schema.org/functionalClass";
var funder2 = "http://schema.org/funder";
var gameAvailabilityType = "http://schema.org/gameAvailabilityType";
var gameEdition = "http://schema.org/gameEdition";
var gameItem = "http://schema.org/gameItem";
var gameLocation = "http://schema.org/gameLocation";
var gamePlatform = "http://schema.org/gamePlatform";
var gameTip = "http://schema.org/gameTip";
var gender3 = "http://schema.org/gender";
var geo2 = "http://schema.org/geo";
var geoContains = "http://schema.org/geoContains";
var geoCoveredBy = "http://schema.org/geoCoveredBy";
var geoCovers = "http://schema.org/geoCovers";
var geoCrosses = "http://schema.org/geoCrosses";
var geoDisjoint = "http://schema.org/geoDisjoint";
var geoEquals = "http://schema.org/geoEquals";
var geoIntersects = "http://schema.org/geoIntersects";
var geoMidpoint = "http://schema.org/geoMidpoint";
var geoOverlaps = "http://schema.org/geoOverlaps";
var geoRadius = "http://schema.org/geoRadius";
var geoTouches = "http://schema.org/geoTouches";
var geoWithin = "http://schema.org/geoWithin";
var geographicArea = "http://schema.org/geographicArea";
var gettingTestedInfo = "http://schema.org/gettingTestedInfo";
var givenName = "http://schema.org/givenName";
var globalLocationNumber = "http://schema.org/globalLocationNumber";
var governmentBenefitsInfo = "http://schema.org/governmentBenefitsInfo";
var gracePeriod = "http://schema.org/gracePeriod";
var grantee2 = "http://schema.org/grantee";
var greater = "http://schema.org/greater";
var greaterOrEqual = "http://schema.org/greaterOrEqual";
var gtin12 = "http://schema.org/gtin12";
var gtin13 = "http://schema.org/gtin13";
var gtin14 = "http://schema.org/gtin14";
var gtin8 = "http://schema.org/gtin8";
var guideline2 = "http://schema.org/guideline";
var guidelineDate = "http://schema.org/guidelineDate";
var guidelineSubject = "http://schema.org/guidelineSubject";
var handlingTime = "http://schema.org/handlingTime";
var hasAdultConsideration = "http://schema.org/hasAdultConsideration";
var hasBioPolymerSequence = "http://schema.org/hasBioPolymerSequence";
var hasCategoryCode = "http://schema.org/hasCategoryCode";
var hasCourse = "http://schema.org/hasCourse";
var hasCourseInstance = "http://schema.org/hasCourseInstance";
var hasCredential = "http://schema.org/hasCredential";
var hasDeliveryMethod = "http://schema.org/hasDeliveryMethod";
var hasDigitalDocumentPermission = "http://schema.org/hasDigitalDocumentPermission";
var hasDriveThroughService = "http://schema.org/hasDriveThroughService";
var hasEnergyConsumptionDetails = "http://schema.org/hasEnergyConsumptionDetails";
var hasEnergyEfficiencyCategory = "http://schema.org/hasEnergyEfficiencyCategory";
var hasHealthAspect = "http://schema.org/hasHealthAspect";
var hasMeasurement = "http://schema.org/hasMeasurement";
var hasMenuItem = "http://schema.org/hasMenuItem";
var hasMenuSection = "http://schema.org/hasMenuSection";
var hasMolecularFunction = "http://schema.org/hasMolecularFunction";
var hasOccupation = "http://schema.org/hasOccupation";
var hasOfferCatalog = "http://schema.org/hasOfferCatalog";
var hasPOS = "http://schema.org/hasPOS";
var hasProductReturnPolicy = "http://schema.org/hasProductReturnPolicy";
var headline = "http://schema.org/headline";
var healthCondition = "http://schema.org/healthCondition";
var healthPlanCoinsuranceOption = "http://schema.org/healthPlanCoinsuranceOption";
var healthPlanCoinsuranceRate = "http://schema.org/healthPlanCoinsuranceRate";
var healthPlanCopay = "http://schema.org/healthPlanCopay";
var healthPlanCopayOption = "http://schema.org/healthPlanCopayOption";
var healthPlanCostSharing = "http://schema.org/healthPlanCostSharing";
var healthPlanDrugOption = "http://schema.org/healthPlanDrugOption";
var healthPlanDrugTier = "http://schema.org/healthPlanDrugTier";
var healthPlanId = "http://schema.org/healthPlanId";
var healthPlanMarketingUrl = "http://schema.org/healthPlanMarketingUrl";
var healthPlanNetworkId = "http://schema.org/healthPlanNetworkId";
var healthPlanNetworkTier = "http://schema.org/healthPlanNetworkTier";
var healthPlanPharmacyCategory = "http://schema.org/healthPlanPharmacyCategory";
var healthcareReportingData = "http://schema.org/healthcareReportingData";
var height3 = "http://schema.org/height";
var highPrice = "http://schema.org/highPrice";
var hiringOrganization = "http://schema.org/hiringOrganization";
var homeLocation = "http://schema.org/homeLocation";
var homeTeam = "http://schema.org/homeTeam";
var honorificPrefix = "http://schema.org/honorificPrefix";
var honorificSuffix = "http://schema.org/honorificSuffix";
var hospitalAffiliation = "http://schema.org/hospitalAffiliation";
var hostingOrganization = "http://schema.org/hostingOrganization";
var hoursAvailable = "http://schema.org/hoursAvailable";
var howPerformed = "http://schema.org/howPerformed";
var httpMethod = "http://schema.org/httpMethod";
var iataCode = "http://schema.org/iataCode";
var icaoCode = "http://schema.org/icaoCode";
var identifyingExam = "http://schema.org/identifyingExam";
var identifyingTest = "http://schema.org/identifyingTest";
var illustrator = "http://schema.org/illustrator";
var imagingTechnique = "http://schema.org/imagingTechnique";
var inAlbum = "http://schema.org/inAlbum";
var inBroadcastLineup = "http://schema.org/inBroadcastLineup";
var inChI = "http://schema.org/inChI";
var inChIKey = "http://schema.org/inChIKey";
var inCodeSet = "http://schema.org/inCodeSet";
var inPlaylist = "http://schema.org/inPlaylist";
var inProductGroupWithID = "http://schema.org/inProductGroupWithID";
var inStoreReturnsOffered = "http://schema.org/inStoreReturnsOffered";
var inSupportOf = "http://schema.org/inSupportOf";
var incentives = "http://schema.org/incentives";
var includedComposition = "http://schema.org/includedComposition";
var includedDataCatalog = "http://schema.org/includedDataCatalog";
var includedInHealthInsurancePlan = "http://schema.org/includedInHealthInsurancePlan";
var includedRiskFactor = "http://schema.org/includedRiskFactor";
var includesAttraction = "http://schema.org/includesAttraction";
var includesHealthPlanFormulary = "http://schema.org/includesHealthPlanFormulary";
var includesHealthPlanNetwork = "http://schema.org/includesHealthPlanNetwork";
var includesObject = "http://schema.org/includesObject";
var increasesRiskOf = "http://schema.org/increasesRiskOf";
var industry = "http://schema.org/industry";
var ineligibleRegion = "http://schema.org/ineligibleRegion";
var infectiousAgent = "http://schema.org/infectiousAgent";
var infectiousAgentClass = "http://schema.org/infectiousAgentClass";
var ingredients = "http://schema.org/ingredients";
var inker = "http://schema.org/inker";
var insertion = "http://schema.org/insertion";
var installUrl = "http://schema.org/installUrl";
var instructor = "http://schema.org/instructor";
var intensity = "http://schema.org/intensity";
var interactingDrug = "http://schema.org/interactingDrug";
var interactionCount = "http://schema.org/interactionCount";
var interactionService = "http://schema.org/interactionService";
var interactionType = "http://schema.org/interactionType";
var interactivityType = "http://schema.org/interactivityType";
var interestRate = "http://schema.org/interestRate";
var interpretedAsClaim = "http://schema.org/interpretedAsClaim";
var inventoryLevel = "http://schema.org/inventoryLevel";
var inverseOf2 = "http://schema.org/inverseOf";
var isAcceptingNewPatients = "http://schema.org/isAcceptingNewPatients";
var isAccessoryOrSparePartFor = "http://schema.org/isAccessoryOrSparePartFor";
var isAvailableGenerically = "http://schema.org/isAvailableGenerically";
var isBasedOnUrl = "http://schema.org/isBasedOnUrl";
var isConsumableFor = "http://schema.org/isConsumableFor";
var isFamilyFriendly = "http://schema.org/isFamilyFriendly";
var isGift = "http://schema.org/isGift";
var isInvolvedInBiologicalProcess = "http://schema.org/isInvolvedInBiologicalProcess";
var isLiveBroadcast = "http://schema.org/isLiveBroadcast";
var isLocatedInSubcellularLocation = "http://schema.org/isLocatedInSubcellularLocation";
var isPlanForApartment = "http://schema.org/isPlanForApartment";
var isProprietary = "http://schema.org/isProprietary";
var isRelatedTo = "http://schema.org/isRelatedTo";
var isResizable = "http://schema.org/isResizable";
var isSimilarTo = "http://schema.org/isSimilarTo";
var isUnlabelledFallback = "http://schema.org/isUnlabelledFallback";
var isbn = "http://schema.org/isbn";
var isicV4 = "http://schema.org/isicV4";
var iso6523Code = "http://schema.org/iso6523Code";
var isrcCode = "http://schema.org/isrcCode";
var issn = "http://schema.org/issn";
var issueNumber = "http://schema.org/issueNumber";
var issuedBy = "http://schema.org/issuedBy";
var issuedThrough = "http://schema.org/issuedThrough";
var iswcCode = "http://schema.org/iswcCode";
var item2 = "http://schema.org/item";
var itemCondition = "http://schema.org/itemCondition";
var itemDefectReturnFees = "http://schema.org/itemDefectReturnFees";
var itemDefectReturnLabelSource = "http://schema.org/itemDefectReturnLabelSource";
var itemDefectReturnShippingFeesAmount = "http://schema.org/itemDefectReturnShippingFeesAmount";
var itemListElement = "http://schema.org/itemListElement";
var itemListOrder = "http://schema.org/itemListOrder";
var itemLocation = "http://schema.org/itemLocation";
var itemReviewed = "http://schema.org/itemReviewed";
var itemShipped = "http://schema.org/itemShipped";
var itinerary = "http://schema.org/itinerary";
var iupacName = "http://schema.org/iupacName";
var jobImmediateStart = "http://schema.org/jobImmediateStart";
var jobLocation = "http://schema.org/jobLocation";
var jobLocationType = "http://schema.org/jobLocationType";
var jobStartDate = "http://schema.org/jobStartDate";
var jobTitle = "http://schema.org/jobTitle";
var keywords = "http://schema.org/keywords";
var knownVehicleDamages = "http://schema.org/knownVehicleDamages";
var knows2 = "http://schema.org/knows";
var knowsAbout = "http://schema.org/knowsAbout";
var knowsLanguage = "http://schema.org/knowsLanguage";
var labelDetails = "http://schema.org/labelDetails";
var landlord = "http://schema.org/landlord";
var language5 = "http://schema.org/language";
var lastReviewed = "http://schema.org/lastReviewed";
var latitude3 = "http://schema.org/latitude";
var layoutImage = "http://schema.org/layoutImage";
var learningResourceType = "http://schema.org/learningResourceType";
var leaseLength = "http://schema.org/leaseLength";
var legalName = "http://schema.org/legalName";
var legalStatus = "http://schema.org/legalStatus";
var legislationChanges = "http://schema.org/legislationChanges";
var legislationConsolidates = "http://schema.org/legislationConsolidates";
var legislationDate = "http://schema.org/legislationDate";
var legislationDateVersion = "http://schema.org/legislationDateVersion";
var legislationIdentifier = "http://schema.org/legislationIdentifier";
var legislationJurisdiction = "http://schema.org/legislationJurisdiction";
var legislationLegalForce = "http://schema.org/legislationLegalForce";
var legislationLegalValue = "http://schema.org/legislationLegalValue";
var legislationPassedBy = "http://schema.org/legislationPassedBy";
var legislationResponsible = "http://schema.org/legislationResponsible";
var legislationTransposes = "http://schema.org/legislationTransposes";
var legislationType = "http://schema.org/legislationType";
var leiCode = "http://schema.org/leiCode";
var lender = "http://schema.org/lender";
var lesser = "http://schema.org/lesser";
var lesserOrEqual = "http://schema.org/lesserOrEqual";
var letterer = "http://schema.org/letterer";
var license3 = "http://schema.org/license";
var line2 = "http://schema.org/line";
var linkRelationship = "http://schema.org/linkRelationship";
var liveBlogUpdate = "http://schema.org/liveBlogUpdate";
var loanMortgageMandateAmount = "http://schema.org/loanMortgageMandateAmount";
var loanPaymentAmount = "http://schema.org/loanPaymentAmount";
var loanPaymentFrequency = "http://schema.org/loanPaymentFrequency";
var loanRepaymentForm = "http://schema.org/loanRepaymentForm";
var loanTerm = "http://schema.org/loanTerm";
var loanType = "http://schema.org/loanType";
var locationCreated = "http://schema.org/locationCreated";
var lodgingUnitDescription = "http://schema.org/lodgingUnitDescription";
var lodgingUnitType = "http://schema.org/lodgingUnitType";
var logo2 = "http://schema.org/logo";
var longitude3 = "http://schema.org/longitude";
var loser = "http://schema.org/loser";
var lowPrice = "http://schema.org/lowPrice";
var lyricist = "http://schema.org/lyricist";
var lyrics = "http://schema.org/lyrics";
var maintainer = "http://schema.org/maintainer";
var manufacturer2 = "http://schema.org/manufacturer";
var map3 = "http://schema.org/map";
var mapType = "http://schema.org/mapType";
var maps = "http://schema.org/maps";
var marginOfError = "http://schema.org/marginOfError";
var masthead = "http://schema.org/masthead";
var materialExtent = "http://schema.org/materialExtent";
var mathExpression = "http://schema.org/mathExpression";
var maxPrice = "http://schema.org/maxPrice";
var maxValue2 = "http://schema.org/maxValue";
var maximumAttendeeCapacity = "http://schema.org/maximumAttendeeCapacity";
var maximumEnrollment = "http://schema.org/maximumEnrollment";
var maximumIntake = "http://schema.org/maximumIntake";
var maximumPhysicalAttendeeCapacity = "http://schema.org/maximumPhysicalAttendeeCapacity";
var maximumVirtualAttendeeCapacity = "http://schema.org/maximumVirtualAttendeeCapacity";
var mealService = "http://schema.org/mealService";
var measuredProperty = "http://schema.org/measuredProperty";
var measurementDenominator = "http://schema.org/measurementDenominator";
var measurementMethod = "http://schema.org/measurementMethod";
var measurementQualifier = "http://schema.org/measurementQualifier";
var mechanismOfAction = "http://schema.org/mechanismOfAction";
var mediaAuthenticityCategory = "http://schema.org/mediaAuthenticityCategory";
var mediaItemAppearance = "http://schema.org/mediaItemAppearance";
var median = "http://schema.org/median";
var medicalAudience = "http://schema.org/medicalAudience";
var medicalSpecialty = "http://schema.org/medicalSpecialty";
var medicineSystem = "http://schema.org/medicineSystem";
var meetsEmissionStandard = "http://schema.org/meetsEmissionStandard";
var members2 = "http://schema.org/members";
var membershipNumber = "http://schema.org/membershipNumber";
var membershipPointsEarned = "http://schema.org/membershipPointsEarned";
var memoryRequirements = "http://schema.org/memoryRequirements";
var mentions = "http://schema.org/mentions";
var menu = "http://schema.org/menu";
var menuAddOn = "http://schema.org/menuAddOn";
var merchant = "http://schema.org/merchant";
var messageAttachment = "http://schema.org/messageAttachment";
var mileageFromOdometer = "http://schema.org/mileageFromOdometer";
var minPrice = "http://schema.org/minPrice";
var minValue2 = "http://schema.org/minValue";
var minimumPaymentDue = "http://schema.org/minimumPaymentDue";
var missionCoveragePrioritiesPolicy = "http://schema.org/missionCoveragePrioritiesPolicy";
var mobileUrl = "http://schema.org/mobileUrl";
var model = "http://schema.org/model";
var modelDate = "http://schema.org/modelDate";
var modifiedTime = "http://schema.org/modifiedTime";
var molecularFormula2 = "http://schema.org/molecularFormula";
var molecularWeight2 = "http://schema.org/molecularWeight";
var monoisotopicMolecularWeight = "http://schema.org/monoisotopicMolecularWeight";
var monthlyMinimumRepaymentAmount = "http://schema.org/monthlyMinimumRepaymentAmount";
var monthsOfExperience = "http://schema.org/monthsOfExperience";
var mpn = "http://schema.org/mpn";
var multipleValues = "http://schema.org/multipleValues";
var muscleAction = "http://schema.org/muscleAction";
var musicArrangement = "http://schema.org/musicArrangement";
var musicBy = "http://schema.org/musicBy";
var musicCompositionForm = "http://schema.org/musicCompositionForm";
var musicGroupMember = "http://schema.org/musicGroupMember";
var musicReleaseFormat = "http://schema.org/musicReleaseFormat";
var musicalKey = "http://schema.org/musicalKey";
var naics = "http://schema.org/naics";
var name4 = "http://schema.org/name";
var namedPosition = "http://schema.org/namedPosition";
var nationality = "http://schema.org/nationality";
var naturalProgression = "http://schema.org/naturalProgression";
var negativeNotes = "http://schema.org/negativeNotes";
var nerve = "http://schema.org/nerve";
var nerveMotor = "http://schema.org/nerveMotor";
var netWorth = "http://schema.org/netWorth";
var newsUpdatesAndGuidelines = "http://schema.org/newsUpdatesAndGuidelines";
var nextItem = "http://schema.org/nextItem";
var noBylinesPolicy = "http://schema.org/noBylinesPolicy";
var nonEqual = "http://schema.org/nonEqual";
var nonProprietaryName = "http://schema.org/nonProprietaryName";
var nonprofitStatus = "http://schema.org/nonprofitStatus";
var normalRange = "http://schema.org/normalRange";
var nsn = "http://schema.org/nsn";
var numAdults = "http://schema.org/numAdults";
var numChildren = "http://schema.org/numChildren";
var numConstraints = "http://schema.org/numConstraints";
var numTracks = "http://schema.org/numTracks";
var numberOfAccommodationUnits = "http://schema.org/numberOfAccommodationUnits";
var numberOfAirbags = "http://schema.org/numberOfAirbags";
var numberOfAvailableAccommodationUnits = "http://schema.org/numberOfAvailableAccommodationUnits";
var numberOfAxles = "http://schema.org/numberOfAxles";
var numberOfBathroomsTotal = "http://schema.org/numberOfBathroomsTotal";
var numberOfBedrooms = "http://schema.org/numberOfBedrooms";
var numberOfBeds = "http://schema.org/numberOfBeds";
var numberOfCredits = "http://schema.org/numberOfCredits";
var numberOfDoors = "http://schema.org/numberOfDoors";
var numberOfEmployees = "http://schema.org/numberOfEmployees";
var numberOfEpisodes = "http://schema.org/numberOfEpisodes";
var numberOfForwardGears = "http://schema.org/numberOfForwardGears";
var numberOfFullBathrooms = "http://schema.org/numberOfFullBathrooms";
var numberOfItems = "http://schema.org/numberOfItems";
var numberOfLoanPayments = "http://schema.org/numberOfLoanPayments";
var numberOfPages = "http://schema.org/numberOfPages";
var numberOfPartialBathrooms = "http://schema.org/numberOfPartialBathrooms";
var numberOfPlayers = "http://schema.org/numberOfPlayers";
var numberOfPreviousOwners = "http://schema.org/numberOfPreviousOwners";
var numberOfRooms = "http://schema.org/numberOfRooms";
var numberOfSeasons = "http://schema.org/numberOfSeasons";
var numberedPosition = "http://schema.org/numberedPosition";
var nutrition = "http://schema.org/nutrition";
var observationAbout = "http://schema.org/observationAbout";
var observationDate = "http://schema.org/observationDate";
var observationPeriod = "http://schema.org/observationPeriod";
var occupancy = "http://schema.org/occupancy";
var occupationLocation = "http://schema.org/occupationLocation";
var occupationalCategory = "http://schema.org/occupationalCategory";
var occupationalCredentialAwarded = "http://schema.org/occupationalCredentialAwarded";
var offerCount = "http://schema.org/offerCount";
var offersPrescriptionByMail = "http://schema.org/offersPrescriptionByMail";
var openingHours = "http://schema.org/openingHours";
var openingHoursSpecification = "http://schema.org/openingHoursSpecification";
var opens = "http://schema.org/opens";
var operatingSystem = "http://schema.org/operatingSystem";
var opponent = "http://schema.org/opponent";
var option3 = "http://schema.org/option";
var orderDate = "http://schema.org/orderDate";
var orderDelivery = "http://schema.org/orderDelivery";
var orderItemNumber = "http://schema.org/orderItemNumber";
var orderItemStatus = "http://schema.org/orderItemStatus";
var orderNumber = "http://schema.org/orderNumber";
var orderQuantity = "http://schema.org/orderQuantity";
var orderStatus = "http://schema.org/orderStatus";
var orderedItem = "http://schema.org/orderedItem";
var organizer2 = "http://schema.org/organizer";
var originAddress = "http://schema.org/originAddress";
var originalMediaContextDescription = "http://schema.org/originalMediaContextDescription";
var originalMediaLink = "http://schema.org/originalMediaLink";
var originatesFrom = "http://schema.org/originatesFrom";
var overdosage = "http://schema.org/overdosage";
var ownedFrom = "http://schema.org/ownedFrom";
var ownedThrough = "http://schema.org/ownedThrough";
var ownershipFundingInfo = "http://schema.org/ownershipFundingInfo";
var owns = "http://schema.org/owns";
var pageEnd = "http://schema.org/pageEnd";
var pageStart = "http://schema.org/pageStart";
var pagination = "http://schema.org/pagination";
var parentItem = "http://schema.org/parentItem";
var parentService = "http://schema.org/parentService";
var parents = "http://schema.org/parents";
var partOfEpisode = "http://schema.org/partOfEpisode";
var partOfInvoice = "http://schema.org/partOfInvoice";
var partOfOrder = "http://schema.org/partOfOrder";
var partOfSeason = "http://schema.org/partOfSeason";
var partOfSystem = "http://schema.org/partOfSystem";
var partOfTVSeries = "http://schema.org/partOfTVSeries";
var partySize = "http://schema.org/partySize";
var passengerPriorityStatus = "http://schema.org/passengerPriorityStatus";
var passengerSequenceNumber = "http://schema.org/passengerSequenceNumber";
var pathophysiology = "http://schema.org/pathophysiology";
var pattern2 = "http://schema.org/pattern";
var payload2 = "http://schema.org/payload";
var paymentAccepted = "http://schema.org/paymentAccepted";
var paymentDue = "http://schema.org/paymentDue";
var paymentMethod = "http://schema.org/paymentMethod";
var paymentMethodId = "http://schema.org/paymentMethodId";
var paymentStatus2 = "http://schema.org/paymentStatus";
var paymentUrl = "http://schema.org/paymentUrl";
var penciler = "http://schema.org/penciler";
var percentile10 = "http://schema.org/percentile10";
var percentile25 = "http://schema.org/percentile25";
var percentile75 = "http://schema.org/percentile75";
var percentile90 = "http://schema.org/percentile90";
var performerIn = "http://schema.org/performerIn";
var performers = "http://schema.org/performers";
var permissionType = "http://schema.org/permissionType";
var permissions = "http://schema.org/permissions";
var permitAudience = "http://schema.org/permitAudience";
var permittedUsage = "http://schema.org/permittedUsage";
var petsAllowed = "http://schema.org/petsAllowed";
var phoneticText = "http://schema.org/phoneticText";
var photos = "http://schema.org/photos";
var physicalRequirement = "http://schema.org/physicalRequirement";
var physiologicalBenefits = "http://schema.org/physiologicalBenefits";
var pickupLocation = "http://schema.org/pickupLocation";
var pickupTime = "http://schema.org/pickupTime";
var playMode = "http://schema.org/playMode";
var playerType = "http://schema.org/playerType";
var playersOnline = "http://schema.org/playersOnline";
var polygon = "http://schema.org/polygon";
var populationType = "http://schema.org/populationType";
var positiveNotes = "http://schema.org/positiveNotes";
var possibleComplication = "http://schema.org/possibleComplication";
var possibleTreatment = "http://schema.org/possibleTreatment";
var postOfficeBoxNumber = "http://schema.org/postOfficeBoxNumber";
var postOp = "http://schema.org/postOp";
var postalCode2 = "http://schema.org/postalCode";
var postalCodeBegin = "http://schema.org/postalCodeBegin";
var postalCodeEnd = "http://schema.org/postalCodeEnd";
var postalCodePrefix = "http://schema.org/postalCodePrefix";
var postalCodeRange = "http://schema.org/postalCodeRange";
var potentialAction = "http://schema.org/potentialAction";
var potentialUse = "http://schema.org/potentialUse";
var preOp = "http://schema.org/preOp";
var predecessorOf = "http://schema.org/predecessorOf";
var pregnancyCategory = "http://schema.org/pregnancyCategory";
var pregnancyWarning = "http://schema.org/pregnancyWarning";
var prepTime = "http://schema.org/prepTime";
var preparation2 = "http://schema.org/preparation";
var prescribingInfo = "http://schema.org/prescribingInfo";
var prescriptionStatus = "http://schema.org/prescriptionStatus";
var previousItem = "http://schema.org/previousItem";
var previousStartDate = "http://schema.org/previousStartDate";
var price = "http://schema.org/price";
var priceComponent2 = "http://schema.org/priceComponent";
var priceComponentType = "http://schema.org/priceComponentType";
var priceCurrency = "http://schema.org/priceCurrency";
var priceRange = "http://schema.org/priceRange";
var priceSpecification = "http://schema.org/priceSpecification";
var priceType = "http://schema.org/priceType";
var priceValidUntil = "http://schema.org/priceValidUntil";
var primaryImageOfPage = "http://schema.org/primaryImageOfPage";
var primaryPrevention = "http://schema.org/primaryPrevention";
var printColumn = "http://schema.org/printColumn";
var printEdition = "http://schema.org/printEdition";
var printPage = "http://schema.org/printPage";
var printSection = "http://schema.org/printSection";
var procedure2 = "http://schema.org/procedure";
var procedureType = "http://schema.org/procedureType";
var processingTime = "http://schema.org/processingTime";
var processorRequirements = "http://schema.org/processorRequirements";
var producer = "http://schema.org/producer";
var produces = "http://schema.org/produces";
var productGroupID = "http://schema.org/productGroupID";
var productID = "http://schema.org/productID";
var productReturnDays = "http://schema.org/productReturnDays";
var productReturnLink = "http://schema.org/productReturnLink";
var productSupported = "http://schema.org/productSupported";
var productionCompany = "http://schema.org/productionCompany";
var productionDate = "http://schema.org/productionDate";
var proficiencyLevel = "http://schema.org/proficiencyLevel";
var programMembershipUsed = "http://schema.org/programMembershipUsed";
var programName = "http://schema.org/programName";
var programPrerequisites = "http://schema.org/programPrerequisites";
var programType = "http://schema.org/programType";
var programmingLanguage = "http://schema.org/programmingLanguage";
var programmingModel = "http://schema.org/programmingModel";
var propertyID = "http://schema.org/propertyID";
var proprietaryName = "http://schema.org/proprietaryName";
var proteinContent = "http://schema.org/proteinContent";
var providerMobility = "http://schema.org/providerMobility";
var providesService = "http://schema.org/providesService";
var publicAccess = "http://schema.org/publicAccess";
var publicTransportClosuresInfo = "http://schema.org/publicTransportClosuresInfo";
var publication = "http://schema.org/publication";
var publicationType = "http://schema.org/publicationType";
var publishedBy = "http://schema.org/publishedBy";
var publishedOn = "http://schema.org/publishedOn";
var publisher4 = "http://schema.org/publisher";
var publisherImprint = "http://schema.org/publisherImprint";
var purchaseDate = "http://schema.org/purchaseDate";
var qualifications = "http://schema.org/qualifications";
var quarantineGuidelines = "http://schema.org/quarantineGuidelines";
var query2 = "http://schema.org/query";
var quest = "http://schema.org/quest";
var question2 = "http://schema.org/question";
var rangeIncludes = "http://schema.org/rangeIncludes";
var ratingCount = "http://schema.org/ratingCount";
var ratingExplanation = "http://schema.org/ratingExplanation";
var ratingValue = "http://schema.org/ratingValue";
var readBy = "http://schema.org/readBy";
var readonlyValue = "http://schema.org/readonlyValue";
var realEstateAgent = "http://schema.org/realEstateAgent";
var recipe = "http://schema.org/recipe";
var recipeCategory = "http://schema.org/recipeCategory";
var recipeCuisine = "http://schema.org/recipeCuisine";
var recipeInstructions = "http://schema.org/recipeInstructions";
var recipeYield = "http://schema.org/recipeYield";
var recognizedBy = "http://schema.org/recognizedBy";
var recognizingAuthority = "http://schema.org/recognizingAuthority";
var recommendationStrength = "http://schema.org/recommendationStrength";
var recommendedIntake = "http://schema.org/recommendedIntake";
var recordLabel = "http://schema.org/recordLabel";
var recourseLoan = "http://schema.org/recourseLoan";
var referenceQuantity = "http://schema.org/referenceQuantity";
var referencesOrder = "http://schema.org/referencesOrder";
var refundType = "http://schema.org/refundType";
var regionDrained = "http://schema.org/regionDrained";
var regionsAllowed = "http://schema.org/regionsAllowed";
var relatedAnatomy = "http://schema.org/relatedAnatomy";
var relatedCondition = "http://schema.org/relatedCondition";
var relatedDrug = "http://schema.org/relatedDrug";
var relatedLink = "http://schema.org/relatedLink";
var relatedStructure = "http://schema.org/relatedStructure";
var relatedTherapy = "http://schema.org/relatedTherapy";
var relatedTo2 = "http://schema.org/relatedTo";
var releaseDate2 = "http://schema.org/releaseDate";
var releaseNotes = "http://schema.org/releaseNotes";
var releasedEvent = "http://schema.org/releasedEvent";
var relevantOccupation = "http://schema.org/relevantOccupation";
var relevantSpecialty = "http://schema.org/relevantSpecialty";
var remainingAttendeeCapacity = "http://schema.org/remainingAttendeeCapacity";
var renegotiableLoan = "http://schema.org/renegotiableLoan";
var repeatCount = "http://schema.org/repeatCount";
var repeatFrequency = "http://schema.org/repeatFrequency";
var repetitions2 = "http://schema.org/repetitions";
var replacee = "http://schema.org/replacee";
var replacer = "http://schema.org/replacer";
var replyToUrl = "http://schema.org/replyToUrl";
var reportNumber = "http://schema.org/reportNumber";
var representativeOfPage = "http://schema.org/representativeOfPage";
var requiredCollateral = "http://schema.org/requiredCollateral";
var requiredGender = "http://schema.org/requiredGender";
var requiredMaxAge = "http://schema.org/requiredMaxAge";
var requiredMinAge = "http://schema.org/requiredMinAge";
var requiredQuantity = "http://schema.org/requiredQuantity";
var requirements2 = "http://schema.org/requirements";
var requiresSubscription = "http://schema.org/requiresSubscription";
var reservationFor = "http://schema.org/reservationFor";
var reservationId = "http://schema.org/reservationId";
var reservationStatus = "http://schema.org/reservationStatus";
var reservedTicket = "http://schema.org/reservedTicket";
var responsibilities = "http://schema.org/responsibilities";
var restPeriods = "http://schema.org/restPeriods";
var restockingFee = "http://schema.org/restockingFee";
var resultComment = "http://schema.org/resultComment";
var resultReview = "http://schema.org/resultReview";
var returnFees = "http://schema.org/returnFees";
var returnLabelSource = "http://schema.org/returnLabelSource";
var returnMethod = "http://schema.org/returnMethod";
var returnPolicyCategory = "http://schema.org/returnPolicyCategory";
var returnPolicyCountry = "http://schema.org/returnPolicyCountry";
var returnPolicySeasonalOverride = "http://schema.org/returnPolicySeasonalOverride";
var returnShippingFeesAmount = "http://schema.org/returnShippingFeesAmount";
var reviewAspect = "http://schema.org/reviewAspect";
var reviewBody = "http://schema.org/reviewBody";
var reviewCount = "http://schema.org/reviewCount";
var reviewRating = "http://schema.org/reviewRating";
var reviewedBy = "http://schema.org/reviewedBy";
var reviews = "http://schema.org/reviews";
var riskFactor = "http://schema.org/riskFactor";
var risks = "http://schema.org/risks";
var roofLoad = "http://schema.org/roofLoad";
var rsvpResponse = "http://schema.org/rsvpResponse";
var runsTo = "http://schema.org/runsTo";
var runtime = "http://schema.org/runtime";
var rxcui = "http://schema.org/rxcui";
var safetyConsideration = "http://schema.org/safetyConsideration";
var salaryCurrency = "http://schema.org/salaryCurrency";
var salaryUponCompletion = "http://schema.org/salaryUponCompletion";
var sameAs2 = "http://schema.org/sameAs";
var sampleType = "http://schema.org/sampleType";
var saturatedFatContent = "http://schema.org/saturatedFatContent";
var scheduleTimezone = "http://schema.org/scheduleTimezone";
var scheduledPaymentDate = "http://schema.org/scheduledPaymentDate";
var scheduledTime = "http://schema.org/scheduledTime";
var schemaVersion = "http://schema.org/schemaVersion";
var schoolClosuresInfo = "http://schema.org/schoolClosuresInfo";
var screenCount = "http://schema.org/screenCount";
var screenshot = "http://schema.org/screenshot";
var sdDatePublished = "http://schema.org/sdDatePublished";
var sdLicense = "http://schema.org/sdLicense";
var sdPublisher = "http://schema.org/sdPublisher";
var seasonNumber = "http://schema.org/seasonNumber";
var seasons = "http://schema.org/seasons";
var seatNumber = "http://schema.org/seatNumber";
var seatRow = "http://schema.org/seatRow";
var seatSection = "http://schema.org/seatSection";
var seatingCapacity = "http://schema.org/seatingCapacity";
var seatingType = "http://schema.org/seatingType";
var secondaryPrevention = "http://schema.org/secondaryPrevention";
var securityClearanceRequirement = "http://schema.org/securityClearanceRequirement";
var securityScreening = "http://schema.org/securityScreening";
var seeks = "http://schema.org/seeks";
var sender2 = "http://schema.org/sender";
var sensoryRequirement = "http://schema.org/sensoryRequirement";
var sensoryUnit = "http://schema.org/sensoryUnit";
var seriousAdverseOutcome = "http://schema.org/seriousAdverseOutcome";
var serverStatus = "http://schema.org/serverStatus";
var servesCuisine = "http://schema.org/servesCuisine";
var serviceAudience = "http://schema.org/serviceAudience";
var serviceLocation = "http://schema.org/serviceLocation";
var serviceOperator = "http://schema.org/serviceOperator";
var servicePhone = "http://schema.org/servicePhone";
var servicePostalAddress = "http://schema.org/servicePostalAddress";
var serviceSmsNumber = "http://schema.org/serviceSmsNumber";
var serviceType2 = "http://schema.org/serviceType";
var serviceUrl = "http://schema.org/serviceUrl";
var servingSize = "http://schema.org/servingSize";
var sha256 = "http://schema.org/sha256";
var sharedContent = "http://schema.org/sharedContent";
var shippingDestination = "http://schema.org/shippingDestination";
var shippingDetails = "http://schema.org/shippingDetails";
var shippingLabel = "http://schema.org/shippingLabel";
var shippingOrigin = "http://schema.org/shippingOrigin";
var shippingRate = "http://schema.org/shippingRate";
var shippingSettingsLink = "http://schema.org/shippingSettingsLink";
var siblings = "http://schema.org/siblings";
var signDetected = "http://schema.org/signDetected";
var signOrSymptom = "http://schema.org/signOrSymptom";
var significance = "http://schema.org/significance";
var significantLinks = "http://schema.org/significantLinks";
var size2 = "http://schema.org/size";
var sizeGroup = "http://schema.org/sizeGroup";
var sizeSystem = "http://schema.org/sizeSystem";
var skills = "http://schema.org/skills";
var sku = "http://schema.org/sku";
var slogan = "http://schema.org/slogan";
var smiles = "http://schema.org/smiles";
var smokingAllowed = "http://schema.org/smokingAllowed";
var sodiumContent = "http://schema.org/sodiumContent";
var softwareAddOn = "http://schema.org/softwareAddOn";
var softwareHelp = "http://schema.org/softwareHelp";
var softwareVersion = "http://schema.org/softwareVersion";
var sourceOrganization = "http://schema.org/sourceOrganization";
var sourcedFrom = "http://schema.org/sourcedFrom";
var spatial2 = "http://schema.org/spatial";
var speakable = "http://schema.org/speakable";
var specialCommitments = "http://schema.org/specialCommitments";
var specialOpeningHoursSpecification = "http://schema.org/specialOpeningHoursSpecification";
var specialty2 = "http://schema.org/specialty";
var speechToTextMarkup = "http://schema.org/speechToTextMarkup";
var speed = "http://schema.org/speed";
var spokenByCharacter = "http://schema.org/spokenByCharacter";
var sport = "http://schema.org/sport";
var sportsActivityLocation = "http://schema.org/sportsActivityLocation";
var sportsEvent = "http://schema.org/sportsEvent";
var sportsTeam = "http://schema.org/sportsTeam";
var spouse = "http://schema.org/spouse";
var stage2 = "http://schema.org/stage";
var stageAsNumber = "http://schema.org/stageAsNumber";
var starRating = "http://schema.org/starRating";
var startDate2 = "http://schema.org/startDate";
var startOffset = "http://schema.org/startOffset";
var startTime2 = "http://schema.org/startTime";
var statType = "http://schema.org/statType";
var status5 = "http://schema.org/status";
var steeringPosition = "http://schema.org/steeringPosition";
var stepValue = "http://schema.org/stepValue";
var steps = "http://schema.org/steps";
var storageRequirements = "http://schema.org/storageRequirements";
var streetAddress = "http://schema.org/streetAddress";
var strengthUnit = "http://schema.org/strengthUnit";
var strengthValue = "http://schema.org/strengthValue";
var structuralClass = "http://schema.org/structuralClass";
var study2 = "http://schema.org/study";
var studyDesign2 = "http://schema.org/studyDesign";
var studyLocation = "http://schema.org/studyLocation";
var studySubject = "http://schema.org/studySubject";
var stupidProperty = "http://schema.org/stupidProperty";
var subEvents = "http://schema.org/subEvents";
var subReservation = "http://schema.org/subReservation";
var subStageSuffix = "http://schema.org/subStageSuffix";
var subStructure = "http://schema.org/subStructure";
var subTest = "http://schema.org/subTest";
var subtitleLanguage = "http://schema.org/subtitleLanguage";
var successorOf = "http://schema.org/successorOf";
var sugarContent = "http://schema.org/sugarContent";
var suggestedAge = "http://schema.org/suggestedAge";
var suggestedGender = "http://schema.org/suggestedGender";
var suggestedMaxAge = "http://schema.org/suggestedMaxAge";
var suggestedMeasurement = "http://schema.org/suggestedMeasurement";
var suggestedMinAge = "http://schema.org/suggestedMinAge";
var suitableForDiet = "http://schema.org/suitableForDiet";
var supersededBy = "http://schema.org/supersededBy";
var supplyTo = "http://schema.org/supplyTo";
var supportingData = "http://schema.org/supportingData";
var surface = "http://schema.org/surface";
var syllabusSections = "http://schema.org/syllabusSections";
var target3 = "http://schema.org/target";
var targetDescription = "http://schema.org/targetDescription";
var targetName = "http://schema.org/targetName";
var targetPlatform = "http://schema.org/targetPlatform";
var targetPopulation = "http://schema.org/targetPopulation";
var targetProduct = "http://schema.org/targetProduct";
var targetUrl = "http://schema.org/targetUrl";
var taxID = "http://schema.org/taxID";
var taxonRank = "http://schema.org/taxonRank";
var taxonomicRange = "http://schema.org/taxonomicRange";
var teaches = "http://schema.org/teaches";
var telephone = "http://schema.org/telephone";
var temporal2 = "http://schema.org/temporal";
var termDuration = "http://schema.org/termDuration";
var termsOfService = "http://schema.org/termsOfService";
var termsPerYear = "http://schema.org/termsPerYear";
var text2 = "http://schema.org/text";
var textValue = "http://schema.org/textValue";
var thumbnail2 = "http://schema.org/thumbnail";
var thumbnailUrl = "http://schema.org/thumbnailUrl";
var tickerSymbol = "http://schema.org/tickerSymbol";
var ticketNumber = "http://schema.org/ticketNumber";
var ticketToken = "http://schema.org/ticketToken";
var ticketedSeat = "http://schema.org/ticketedSeat";
var timeOfDay2 = "http://schema.org/timeOfDay";
var timeRequired = "http://schema.org/timeRequired";
var timeToComplete = "http://schema.org/timeToComplete";
var tissueSample = "http://schema.org/tissueSample";
var title6 = "http://schema.org/title";
var titleEIDR = "http://schema.org/titleEIDR";
var toLocation = "http://schema.org/toLocation";
var toRecipient = "http://schema.org/toRecipient";
var tocContinuation = "http://schema.org/tocContinuation";
var tocEntry = "http://schema.org/tocEntry";
var tongueWeight = "http://schema.org/tongueWeight";
var tool = "http://schema.org/tool";
var torque = "http://schema.org/torque";
var totalHistoricalEnrollment = "http://schema.org/totalHistoricalEnrollment";
var totalJobOpenings = "http://schema.org/totalJobOpenings";
var totalPaymentDue = "http://schema.org/totalPaymentDue";
var totalPrice = "http://schema.org/totalPrice";
var totalTime = "http://schema.org/totalTime";
var tourBookingPage = "http://schema.org/tourBookingPage";
var touristType = "http://schema.org/touristType";
var trackingNumber = "http://schema.org/trackingNumber";
var trackingUrl = "http://schema.org/trackingUrl";
var tracks = "http://schema.org/tracks";
var trailer = "http://schema.org/trailer";
var trailerWeight = "http://schema.org/trailerWeight";
var trainName = "http://schema.org/trainName";
var trainNumber = "http://schema.org/trainNumber";
var trainingSalary = "http://schema.org/trainingSalary";
var transFatContent = "http://schema.org/transFatContent";
var transcript = "http://schema.org/transcript";
var transitTime = "http://schema.org/transitTime";
var transitTimeLabel = "http://schema.org/transitTimeLabel";
var translator = "http://schema.org/translator";
var transmissionMethod = "http://schema.org/transmissionMethod";
var travelBans = "http://schema.org/travelBans";
var trialDesign = "http://schema.org/trialDesign";
var tributary = "http://schema.org/tributary";
var tripOrigin = "http://schema.org/tripOrigin";
var typeOfBed = "http://schema.org/typeOfBed";
var typeOfGood = "http://schema.org/typeOfGood";
var typicalAgeRange = "http://schema.org/typicalAgeRange";
var typicalCreditsPerTerm = "http://schema.org/typicalCreditsPerTerm";
var typicalTest = "http://schema.org/typicalTest";
var underName = "http://schema.org/underName";
var unitCode = "http://schema.org/unitCode";
var unitText = "http://schema.org/unitText";
var unnamedSourcesPolicy = "http://schema.org/unnamedSourcesPolicy";
var unsaturatedFatContent = "http://schema.org/unsaturatedFatContent";
var uploadDate = "http://schema.org/uploadDate";
var upvoteCount = "http://schema.org/upvoteCount";
var url4 = "http://schema.org/url";
var urlTemplate = "http://schema.org/urlTemplate";
var usedToDiagnose = "http://schema.org/usedToDiagnose";
var userInteractionCount = "http://schema.org/userInteractionCount";
var usesDevice = "http://schema.org/usesDevice";
var usesHealthPlanIdStandard = "http://schema.org/usesHealthPlanIdStandard";
var utterances = "http://schema.org/utterances";
var validFor = "http://schema.org/validFor";
var validFrom = "http://schema.org/validFrom";
var validIn = "http://schema.org/validIn";
var validThrough = "http://schema.org/validThrough";
var validUntil = "http://schema.org/validUntil";
var value3 = "http://schema.org/value";
var valueAddedTaxIncluded = "http://schema.org/valueAddedTaxIncluded";
var valueMaxLength = "http://schema.org/valueMaxLength";
var valueMinLength = "http://schema.org/valueMinLength";
var valueName = "http://schema.org/valueName";
var valuePattern = "http://schema.org/valuePattern";
var valueReference = "http://schema.org/valueReference";
var valueRequired = "http://schema.org/valueRequired";
var variableMeasured = "http://schema.org/variableMeasured";
var variablesMeasured = "http://schema.org/variablesMeasured";
var variantCover = "http://schema.org/variantCover";
var variesBy = "http://schema.org/variesBy";
var vatID = "http://schema.org/vatID";
var vehicleConfiguration = "http://schema.org/vehicleConfiguration";
var vehicleEngine = "http://schema.org/vehicleEngine";
var vehicleIdentificationNumber = "http://schema.org/vehicleIdentificationNumber";
var vehicleInteriorColor = "http://schema.org/vehicleInteriorColor";
var vehicleInteriorType = "http://schema.org/vehicleInteriorType";
var vehicleModelDate = "http://schema.org/vehicleModelDate";
var vehicleSeatingCapacity = "http://schema.org/vehicleSeatingCapacity";
var vehicleSpecialUsage = "http://schema.org/vehicleSpecialUsage";
var vehicleTransmission = "http://schema.org/vehicleTransmission";
var vendor = "http://schema.org/vendor";
var verificationFactCheckingPolicy = "http://schema.org/verificationFactCheckingPolicy";
var version4 = "http://schema.org/version";
var video = "http://schema.org/video";
var videoFormat = "http://schema.org/videoFormat";
var videoFrameSize = "http://schema.org/videoFrameSize";
var videoQuality = "http://schema.org/videoQuality";
var volumeNumber = "http://schema.org/volumeNumber";
var warning2 = "http://schema.org/warning";
var warrantyPromise = "http://schema.org/warrantyPromise";
var warrantyScope = "http://schema.org/warrantyScope";
var webCheckinTime = "http://schema.org/webCheckinTime";
var webFeed = "http://schema.org/webFeed";
var weight = "http://schema.org/weight";
var weightTotal = "http://schema.org/weightTotal";
var wheelbase = "http://schema.org/wheelbase";
var width3 = "http://schema.org/width";
var winner = "http://schema.org/winner";
var wordCount = "http://schema.org/wordCount";
var workHours = "http://schema.org/workHours";
var workLocation = "http://schema.org/workLocation";
var workPerformed = "http://schema.org/workPerformed";
var workPresented = "http://schema.org/workPresented";
var workload = "http://schema.org/workload";
var worksFor = "http://schema.org/worksFor";
var worstRating = "http://schema.org/worstRating";
var xpath = "http://schema.org/xpath";
var yearBuilt = "http://schema.org/yearBuilt";
var yearlyRevenue = "http://schema.org/yearlyRevenue";
var yearsInOperation = "http://schema.org/yearsInOperation";
var actionApplication = "http://schema.org/actionApplication";
var actionOption = "http://schema.org/actionOption";
var album = "http://schema.org/album";
var albumRelease = "http://schema.org/albumRelease";
var alternateName = "http://schema.org/alternateName";
var alumni = "http://schema.org/alumni";
var alumniOf = "http://schema.org/alumniOf";
var archiveHeld = "http://schema.org/archiveHeld";
var arterialBranch = "http://schema.org/arterialBranch";
var artworkSurface = "http://schema.org/artworkSurface";
var attendee2 = "http://schema.org/attendee";
var audience3 = "http://schema.org/audience";
var availableOnDevice = "http://schema.org/availableOnDevice";
var award = "http://schema.org/award";
var blogPost = "http://schema.org/blogPost";
var broker = "http://schema.org/broker";
var caption = "http://schema.org/caption";
var category3 = "http://schema.org/category";
var childTaxon = "http://schema.org/childTaxon";
var clinicalPharmacology = "http://schema.org/clinicalPharmacology";
var codeSampleType = "http://schema.org/codeSampleType";
var colleague = "http://schema.org/colleague";
var contactPoint = "http://schema.org/contactPoint";
var containsPlace = "http://schema.org/containsPlace";
var containsSeason = "http://schema.org/containsSeason";
var contentLocation = "http://schema.org/contentLocation";
var creator3 = "http://schema.org/creator";
var dataset = "http://schema.org/dataset";
var dateCreated = "http://schema.org/dateCreated";
var director = "http://schema.org/director";
var duration4 = "http://schema.org/duration";
var employee = "http://schema.org/employee";
var encodesBioChemEntity = "http://schema.org/encodesBioChemEntity";
var encodesCreativeWork = "http://schema.org/encodesCreativeWork";
var encodingFormat = "http://schema.org/encodingFormat";
var episode = "http://schema.org/episode";
var event2 = "http://schema.org/event";
var exampleOfWork = "http://schema.org/exampleOfWork";
var executableLibraryName = "http://schema.org/executableLibraryName";
var exerciseCourse = "http://schema.org/exerciseCourse";
var founder = "http://schema.org/founder";
var frequency2 = "http://schema.org/frequency";
var fundedItem = "http://schema.org/fundedItem";
var funding = "http://schema.org/funding";
var game = "http://schema.org/game";
var gameServer = "http://schema.org/gameServer";
var genre = "http://schema.org/genre";
var hasBioChemEntityPart = "http://schema.org/hasBioChemEntityPart";
var hasBroadcastChannel = "http://schema.org/hasBroadcastChannel";
var hasDefinedTerm = "http://schema.org/hasDefinedTerm";
var hasMenu = "http://schema.org/hasMenu";
var hasMerchantReturnPolicy = "http://schema.org/hasMerchantReturnPolicy";
var hasVariant = "http://schema.org/hasVariant";
var holdingArchive = "http://schema.org/holdingArchive";
var inDefinedTermSet = "http://schema.org/inDefinedTermSet";
var inLanguage = "http://schema.org/inLanguage";
var incentiveCompensation = "http://schema.org/incentiveCompensation";
var interactionStatistic = "http://schema.org/interactionStatistic";
var isAccessibleForFree = "http://schema.org/isAccessibleForFree";
var isBasedOn = "http://schema.org/isBasedOn";
var isEncodedByBioChemEntity = "http://schema.org/isEncodedByBioChemEntity";
var isPartOfBioChemEntity = "http://schema.org/isPartOfBioChemEntity";
var isVariantOf = "http://schema.org/isVariantOf";
var itemOffered = "http://schema.org/itemOffered";
var jobBenefits = "http://schema.org/jobBenefits";
var jurisdiction2 = "http://schema.org/jurisdiction";
var legislationApplies = "http://schema.org/legislationApplies";
var mainContentOfPage = "http://schema.org/mainContentOfPage";
var mainEntity = "http://schema.org/mainEntity";
var mainEntityOfPage = "http://schema.org/mainEntityOfPage";
var makesOffer = "http://schema.org/makesOffer";
var measurementTechnique = "http://schema.org/measurementTechnique";
var merchantReturnDays = "http://schema.org/merchantReturnDays";
var merchantReturnLink = "http://schema.org/merchantReturnLink";
var offeredBy = "http://schema.org/offeredBy";
var offers = "http://schema.org/offers";
var parent2 = "http://schema.org/parent";
var parentTaxon = "http://schema.org/parentTaxon";
var partOfSeries = "http://schema.org/partOfSeries";
var partOfTrip = "http://schema.org/partOfTrip";
var paymentDueDate = "http://schema.org/paymentDueDate";
var performTime = "http://schema.org/performTime";
var performer2 = "http://schema.org/performer";
var photo2 = "http://schema.org/photo";
var provider3 = "http://schema.org/provider";
var providesBroadcastService = "http://schema.org/providesBroadcastService";
var recipeIngredient = "http://schema.org/recipeIngredient";
var recordedAs = "http://schema.org/recordedAs";
var recordedAt = "http://schema.org/recordedAt";
var recordedIn = "http://schema.org/recordedIn";
var recordingOf = "http://schema.org/recordingOf";
var releaseOf = "http://schema.org/releaseOf";
var review = "http://schema.org/review";
var roleName = "http://schema.org/roleName";
var runtimePlatform = "http://schema.org/runtimePlatform";
var season = "http://schema.org/season";
var serialNumber2 = "http://schema.org/serialNumber";
var serviceArea = "http://schema.org/serviceArea";
var serviceOutput = "http://schema.org/serviceOutput";
var sibling = "http://schema.org/sibling";
var significantLink = "http://schema.org/significantLink";
var softwareRequirements = "http://schema.org/softwareRequirements";
var sponsor = "http://schema.org/sponsor";
var subOrganization = "http://schema.org/subOrganization";
var subTrip = "http://schema.org/subTrip";
var subjectOf = "http://schema.org/subjectOf";
var suggestedAnswer = "http://schema.org/suggestedAnswer";
var superEvent = "http://schema.org/superEvent";
var targetCollection = "http://schema.org/targetCollection";
var temporalCoverage = "http://schema.org/temporalCoverage";
var termCode = "http://schema.org/termCode";
var track = "http://schema.org/track";
var translationOfWork = "http://schema.org/translationOfWork";
var usageInfo = "http://schema.org/usageInfo";
var warranty = "http://schema.org/warranty";
var workTranslation = "http://schema.org/workTranslation";
var yield__workaround = "http://schema.org/yield";
var about2 = "http://schema.org/about";
var actor3 = "http://schema.org/actor";
var associatedReview = "http://schema.org/associatedReview";
var competitor = "http://schema.org/competitor";
var containedInPlace = "http://schema.org/containedInPlace";
var encoding = "http://schema.org/encoding";
var hasMap = "http://schema.org/hasMap";
var material2 = "http://schema.org/material";
var memberOf = "http://schema.org/memberOf";
var parentOrganization = "http://schema.org/parentOrganization";
var result3 = "http://schema.org/result";
var seller = "http://schema.org/seller";
var spatialCoverage = "http://schema.org/spatialCoverage";
var step2 = "http://schema.org/step";
var subEvent = "http://schema.org/subEvent";
var supply = "http://schema.org/supply";
var workFeatured = "http://schema.org/workFeatured";
var areaServed = "http://schema.org/areaServed";
var image3 = "http://schema.org/image";
var includedInDataCatalog = "http://schema.org/includedInDataCatalog";
var member6 = "http://schema.org/member";
var recipient2 = "http://schema.org/recipient";
var workExample = "http://schema.org/workExample";
var description7 = "http://schema.org/description";
var gtin = "http://schema.org/gtin";
var hasRepresentation = "http://schema.org/hasRepresentation";
var hasPart3 = "http://schema.org/hasPart";
var position2 = "http://schema.org/position";
var isPartOf2 = "http://schema.org/isPartOf";
var instrument2 = "http://schema.org/instrument";
var object4 = "http://schema.org/object";
var publishingPrinciples = "http://schema.org/publishingPrinciples";
var location6 = "http://schema.org/location";
var participant3 = "http://schema.org/participant";
var identifier4 = "http://schema.org/identifier";
var schemaImport = /* @__PURE__ */ Object.freeze({
  AMRadioChannel,
  APIReference,
  AboutPage,
  AcceptAction,
  Accommodation,
  AccountingService,
  AchieveAction,
  Action: Action2,
  ActionAccessSpecification,
  ActionStatusType,
  ActivateAction,
  AddAction,
  AdministrativeArea,
  AdultEntertainment,
  AdultOrientedEnumeration,
  AdvertiserContentArticle,
  AggregateOffer,
  AggregateRating,
  AgreeAction,
  Airline,
  Airport,
  AlignmentObject,
  AllocateAction,
  AmpStory,
  AmusementPark,
  AnalysisNewsArticle,
  AnatomicalStructure,
  AnatomicalSystem,
  AnimalShelter,
  Answer: Answer2,
  Apartment,
  ApartmentComplex,
  AppendAction,
  ApplyAction,
  ApprovedIndication,
  Aquarium,
  ArchiveComponent,
  ArchiveOrganization,
  ArriveAction,
  ArtGallery,
  Artery,
  Article: Article2,
  AskAction,
  AskPublicNewsArticle,
  AssessAction,
  AssignAction,
  Atlas,
  Attorney,
  Audience,
  AudioObject,
  AudioObjectSnapshot,
  Audiobook,
  AuthorizeAction,
  AutoBodyShop,
  AutoDealer,
  AutoPartsStore,
  AutoRental,
  AutoRepair,
  AutoWash,
  AutomatedTeller,
  AutomotiveBusiness,
  BackgroundNewsArticle,
  Bakery,
  BankAccount,
  BankOrCreditUnion,
  BarOrPub,
  Barcode,
  Beach,
  BeautySalon,
  BedAndBreakfast,
  BedDetails,
  BedType,
  BefriendAction,
  BikeStore,
  BioChemEntity,
  Blog,
  BlogPosting,
  BloodTest,
  BoardingPolicyType,
  BoatReservation,
  BoatTerminal,
  BoatTrip,
  BodyMeasurementTypeEnumeration,
  BodyOfWater,
  Bone,
  Book,
  BookFormatType,
  BookSeries,
  BookStore,
  BookmarkAction,
  Boolean__workaround,
  BorrowAction,
  BowlingAlley,
  BrainStructure,
  Brand,
  BreadcrumbList,
  Brewery,
  Bridge,
  BroadcastChannel,
  BroadcastEvent,
  BroadcastFrequencySpecification,
  BroadcastService,
  BrokerageAccount,
  BuddhistTemple,
  BusOrCoach,
  BusReservation,
  BusStation,
  BusStop,
  BusTrip,
  BusinessAudience,
  BusinessEntityType,
  BusinessEvent,
  BusinessFunction,
  BuyAction,
  CDCPMDRecord,
  CableOrSatelliteService,
  CafeOrCoffeeShop,
  Campground,
  CampingPitch,
  Canal,
  CancelAction,
  Car,
  CarUsageType,
  Casino,
  CategoryCode,
  CategoryCodeSet,
  CatholicChurch,
  Cemetery,
  Chapter,
  CheckAction,
  CheckInAction,
  CheckOutAction,
  CheckoutPage,
  ChemicalSubstance,
  ChildCare,
  ChildrensEvent,
  ChooseAction,
  Church,
  City,
  CityHall,
  CivicStructure,
  Claim: Claim2,
  ClaimReview,
  Class: Class5,
  Clip,
  ClothingStore,
  Code,
  Collection: Collection3,
  CollectionPage: CollectionPage2,
  CollegeOrUniversity,
  ComedyClub,
  ComedyEvent,
  ComicCoverArt,
  ComicIssue,
  ComicSeries,
  ComicStory,
  Comment,
  CommentAction,
  CommunicateAction,
  CompleteDataFeed,
  CompoundPriceSpecification,
  ComputerLanguage,
  ComputerStore,
  ConfirmAction,
  Consortium,
  ConstraintNode,
  ConsumeAction,
  ContactPage,
  ContactPoint: ContactPoint2,
  ContactPointOption,
  Continent,
  ControlAction,
  ConvenienceStore,
  Conversation,
  CookAction,
  Corporation,
  CorrectionComment,
  Country,
  Course,
  CourseInstance,
  Courthouse,
  CoverArt,
  CovidTestingFacility,
  CreateAction,
  CreativeWork,
  CreativeWorkSeason,
  CreativeWorkSeries,
  CreditCard,
  Crematorium,
  CriticReview,
  CssSelectorType,
  CurrencyConversionService,
  DDxElement,
  DanceEvent,
  DanceGroup,
  DataCatalog,
  DataDownload,
  DataFeed,
  DataFeedItem,
  DataType: DataType2,
  Dataset,
  Date__workaround,
  DateTime,
  DatedMoneySpecification,
  DayOfWeek,
  DaySpa,
  DeactivateAction,
  DefenceEstablishment,
  DefinedRegion,
  DefinedTerm,
  DefinedTermSet,
  DeleteAction,
  DeliveryChargeSpecification,
  DeliveryEvent,
  DeliveryMethod,
  DeliveryTimeSettings,
  Demand,
  Dentist,
  DepartAction,
  DepartmentStore,
  DepositAccount,
  DiagnosticLab,
  DiagnosticProcedure,
  Diet,
  DietarySupplement,
  DigitalDocument,
  DigitalDocumentPermission,
  DigitalDocumentPermissionType,
  DigitalPlatformEnumeration,
  DisagreeAction,
  DiscoverAction,
  DiscussionForumPosting,
  DislikeAction,
  Distance: Distance2,
  Distillery,
  DonateAction,
  DoseSchedule,
  DownloadAction,
  DrawAction,
  Drawing,
  DrinkAction,
  DriveWheelConfigurationValue,
  Drug,
  DrugClass,
  DrugCost,
  DrugCostCategory,
  DrugLegalStatus,
  DrugPregnancyCategory,
  DrugPrescriptionStatus,
  DrugStrength,
  DryCleaningOrLaundry,
  Duration: Duration2,
  EUEnergyEfficiencyEnumeration,
  EatAction,
  EducationEvent,
  EducationalAudience,
  EducationalOccupationalCredential,
  EducationalOccupationalProgram,
  EducationalOrganization,
  Electrician,
  ElectronicsStore,
  ElementarySchool,
  EmailMessage,
  Embassy,
  EmergencyService,
  EmployeeRole,
  EmployerAggregateRating,
  EmployerReview,
  EmploymentAgency,
  EndorseAction,
  EndorsementRating,
  Energy,
  EnergyConsumptionDetails,
  EnergyEfficiencyEnumeration,
  EnergyStarEnergyEfficiencyEnumeration,
  EngineSpecification,
  EntertainmentBusiness,
  EntryPoint,
  Enumeration,
  Episode,
  Event: Event2,
  EventAttendanceModeEnumeration,
  EventReservation,
  EventSeries,
  EventStatusType,
  EventVenue,
  ExchangeRateSpecification,
  ExerciseAction,
  ExerciseGym,
  ExercisePlan,
  ExhibitionEvent,
  FAQPage,
  FMRadioChannel,
  FastFoodRestaurant,
  Festival,
  FilmAction,
  FinancialProduct,
  FinancialService,
  FindAction,
  FireStation,
  Flight,
  FlightReservation,
  Float,
  FloorPlan,
  Florist,
  FollowAction,
  FoodEstablishment,
  FoodEstablishmentReservation,
  FoodEvent,
  FoodService,
  FundingAgency,
  FundingScheme,
  FurnitureStore,
  Game,
  GameAvailabilityEnumeration,
  GamePlayMode,
  GameServer,
  GameServerStatus,
  GardenStore,
  GasStation,
  GatedResidenceCommunity,
  GenderType,
  Gene,
  GeneralContractor,
  GeoCircle,
  GeoCoordinates,
  GeoShape,
  GeospatialGeometry,
  GiveAction,
  GolfCourse,
  GovernmentBenefitsType,
  GovernmentBuilding,
  GovernmentOffice,
  GovernmentOrganization,
  GovernmentPermit,
  GovernmentService,
  Grant,
  GroceryStore,
  Guide,
  HVACBusiness,
  Hackathon,
  HairSalon,
  HardwareStore,
  HealthAndBeautyBusiness,
  HealthAspectEnumeration,
  HealthClub,
  HealthInsurancePlan,
  HealthPlanCostSharingSpecification,
  HealthPlanFormulary,
  HealthPlanNetwork,
  HealthTopicContent,
  HighSchool,
  HinduTemple,
  HobbyShop,
  HomeAndConstructionBusiness,
  HomeGoodsStore,
  Hospital,
  Hostel,
  Hotel,
  HotelRoom,
  House,
  HousePainter,
  HowTo,
  HowToDirection,
  HowToItem,
  HowToSection,
  HowToStep,
  HowToSupply,
  HowToTip,
  HowToTool,
  HyperToc,
  HyperTocEntry,
  IceCreamShop,
  IgnoreAction,
  ImageGallery,
  ImageObject,
  ImageObjectSnapshot,
  ImagingTest,
  IndividualProduct,
  InfectiousAgentClass,
  InfectiousDisease,
  InformAction,
  InsertAction,
  InstallAction,
  InsuranceAgency,
  Intangible,
  Integer,
  InteractAction,
  InteractionCounter,
  InternetCafe,
  InvestmentFund,
  InvestmentOrDeposit,
  InviteAction,
  Invoice: Invoice2,
  ItemAvailability,
  ItemList,
  ItemListOrderType,
  ItemPage,
  JewelryStore,
  JobPosting,
  JoinAction,
  Joint,
  LakeBodyOfWater,
  Landform,
  LandmarksOrHistoricalBuildings,
  Language,
  LearningResource,
  LeaveAction,
  LegalForceStatus,
  LegalService,
  LegalValueLevel,
  Legislation,
  LegislationObject,
  LegislativeBuilding,
  LendAction,
  Library: Library2,
  LibrarySystem,
  LifestyleModification,
  Ligament,
  LikeAction,
  LinkRole,
  LiquorStore,
  ListItem,
  ListenAction,
  LiteraryEvent,
  LiveBlogPosting,
  LoanOrCredit,
  LocalBusiness,
  LocationFeatureSpecification,
  Locksmith,
  LodgingBusiness,
  LodgingReservation,
  LoseAction,
  LymphaticVessel,
  Manuscript,
  Map__workaround,
  MapCategoryType,
  MarryAction,
  Mass,
  MathSolver,
  MaximumDoseSchedule,
  MeasurementMethodEnum,
  MeasurementTypeEnumeration,
  MediaGallery,
  MediaManipulationRatingEnumeration,
  MediaObject,
  MediaReview,
  MediaReviewItem,
  MediaSubscription,
  MedicalAudience,
  MedicalAudienceType,
  MedicalBusiness,
  MedicalCause,
  MedicalClinic,
  MedicalCode,
  MedicalCondition,
  MedicalConditionStage,
  MedicalContraindication,
  MedicalDevice,
  MedicalDevicePurpose,
  MedicalEntity,
  MedicalEnumeration,
  MedicalEvidenceLevel,
  MedicalGuideline,
  MedicalGuidelineContraindication,
  MedicalGuidelineRecommendation,
  MedicalImagingTechnique,
  MedicalIndication,
  MedicalIntangible,
  MedicalObservationalStudy,
  MedicalObservationalStudyDesign,
  MedicalOrganization,
  MedicalProcedure,
  MedicalProcedureType,
  MedicalRiskCalculator,
  MedicalRiskEstimator,
  MedicalRiskFactor,
  MedicalRiskScore,
  MedicalScholarlyArticle,
  MedicalSign,
  MedicalSignOrSymptom,
  MedicalSpecialty,
  MedicalStudy,
  MedicalStudyStatus,
  MedicalSymptom,
  MedicalTest,
  MedicalTestPanel,
  MedicalTherapy,
  MedicalTrial,
  MedicalTrialDesign,
  MedicalWebPage,
  MedicineSystem,
  MeetingRoom,
  MensClothingStore,
  Menu,
  MenuItem,
  MenuSection,
  MerchantReturnEnumeration,
  MerchantReturnPolicy,
  MerchantReturnPolicySeasonalOverride,
  Message: Message2,
  MiddleSchool,
  MobileApplication,
  MobilePhoneStore,
  MolecularEntity,
  MonetaryAmount,
  MonetaryAmountDistribution,
  MonetaryGrant,
  MoneyTransfer,
  MortgageLoan,
  Mosque,
  Motel,
  Motorcycle,
  MotorcycleDealer,
  MotorcycleRepair,
  MotorizedBicycle,
  Mountain,
  MoveAction,
  Movie,
  MovieClip,
  MovieRentalStore,
  MovieSeries,
  MovieTheater,
  MovingCompany,
  Muscle,
  Museum,
  MusicAlbum,
  MusicAlbumProductionType,
  MusicAlbumReleaseType,
  MusicComposition,
  MusicEvent,
  MusicGroup,
  MusicPlaylist,
  MusicRecording,
  MusicRelease,
  MusicReleaseFormatType,
  MusicStore,
  MusicVenue,
  MusicVideoObject,
  NGO,
  NLNonprofitType,
  NailSalon,
  Nerve,
  NewsArticle,
  NewsMediaOrganization,
  Newspaper,
  NightClub,
  NonprofitType,
  Notary,
  NoteDigitalDocument,
  Number__workaround,
  NutritionInformation,
  Observation: Observation2,
  Occupation,
  OccupationalExperienceRequirements,
  OccupationalTherapy,
  OceanBodyOfWater,
  Offer: Offer2,
  OfferCatalog,
  OfferForLease,
  OfferForPurchase,
  OfferItemCondition,
  OfferShippingDetails,
  OfficeEquipmentStore,
  OnDemandEvent,
  OnlineBusiness,
  OnlineStore,
  OpeningHoursSpecification,
  OpinionNewsArticle,
  Optician,
  Order,
  OrderAction,
  OrderItem,
  OrderStatus,
  Organization: Organization4,
  OrganizationRole,
  OrganizeAction,
  OutletStore,
  OwnershipInfo,
  PaintAction,
  Painting,
  PalliativeProcedure,
  ParcelDelivery,
  ParentAudience,
  Park,
  ParkingFacility,
  PathologyTest,
  Patient: Patient2,
  PawnShop,
  PayAction,
  PaymentCard,
  PaymentChargeSpecification,
  PaymentMethod,
  PaymentService,
  PaymentStatusType,
  PeopleAudience,
  PerformAction,
  PerformanceRole,
  PerformingArtsTheater,
  PerformingGroup,
  Periodical,
  Permit,
  Person: Person4,
  PetStore,
  Pharmacy,
  Photograph,
  PhotographAction,
  PhysicalActivity,
  PhysicalActivityCategory,
  PhysicalExam,
  PhysicalTherapy,
  Physician,
  Place: Place2,
  PlaceOfWorship,
  PlanAction,
  Play,
  PlayAction,
  PlayGameAction,
  Playground,
  Plumber,
  PodcastEpisode,
  PodcastSeason,
  PodcastSeries,
  PoliceStation,
  PoliticalParty,
  Pond,
  PostOffice,
  PostalAddress,
  PostalCodeRangeSpecification,
  Poster,
  PreOrderAction,
  PrependAction,
  Preschool,
  PresentationDigitalDocument,
  PreventionIndication,
  PriceComponentTypeEnumeration,
  PriceSpecification,
  PriceTypeEnumeration,
  Product,
  ProductCollection,
  ProductGroup,
  ProductModel,
  ProductReturnEnumeration,
  ProductReturnPolicy,
  ProfessionalService,
  ProfilePage,
  ProgramMembership,
  Project: Project2,
  PronounceableText,
  Property: Property3,
  PropertyValue,
  PropertyValueSpecification,
  Protein,
  PsychologicalTreatment,
  PublicSwimmingPool,
  PublicToilet,
  PublicationEvent,
  PublicationIssue,
  PublicationVolume,
  QAPage,
  QualitativeValue,
  QuantitativeValue,
  QuantitativeValueDistribution,
  Quantity: Quantity2,
  Question: Question2,
  Quiz,
  Quotation,
  QuoteAction,
  RVPark,
  RadiationTherapy,
  RadioBroadcastService,
  RadioChannel,
  RadioClip,
  RadioEpisode,
  RadioSeason,
  RadioSeries,
  RadioStation,
  Rating,
  ReactAction,
  ReadAction,
  RealEstateAgent,
  RealEstateListing,
  ReceiveAction,
  Recipe,
  Recommendation,
  RecommendedDoseSchedule,
  RecyclingCenter,
  RefundTypeEnumeration,
  RegisterAction,
  RejectAction,
  RentAction,
  RentalCarReservation,
  RepaymentSpecification,
  ReplaceAction,
  ReplyAction,
  Report,
  ReportageNewsArticle,
  ReportedDoseSchedule,
  ResearchOrganization,
  ResearchProject,
  Researcher,
  Reservation,
  ReservationPackage,
  ReservationStatusType,
  ReserveAction,
  Reservoir,
  Residence,
  Resort,
  Restaurant,
  RestrictedDiet,
  ResumeAction,
  ReturnAction,
  ReturnFeesEnumeration,
  ReturnLabelSourceEnumeration,
  ReturnMethodEnumeration,
  Review,
  ReviewAction,
  ReviewNewsArticle,
  RiverBodyOfWater,
  Role,
  RoofingContractor,
  Room,
  RsvpAction,
  RsvpResponseType,
  SaleEvent,
  SatiricalArticle,
  Schedule: Schedule2,
  ScheduleAction,
  ScholarlyArticle,
  School,
  SchoolDistrict,
  ScreeningEvent,
  Sculpture,
  SeaBodyOfWater,
  SearchAction,
  SearchRescueOrganization,
  SearchResultsPage,
  Season,
  Seat,
  SeekToAction,
  SelfStorage,
  SellAction,
  SendAction,
  Series,
  Service: Service2,
  ServiceChannel,
  ShareAction,
  SheetMusic,
  ShippingDeliveryTime,
  ShippingRateSettings,
  ShoeStore,
  ShoppingCenter,
  ShortStory,
  SingleFamilyResidence,
  SiteNavigationElement,
  SizeGroupEnumeration,
  SizeSpecification,
  SizeSystemEnumeration,
  SkiResort,
  SocialEvent,
  SocialMediaPosting,
  SoftwareApplication,
  SoftwareSourceCode,
  SolveMathAction,
  SomeProducts,
  SpeakableSpecification,
  SpecialAnnouncement,
  Specialty,
  SportingGoodsStore,
  SportsActivityLocation,
  SportsClub,
  SportsEvent,
  SportsOrganization,
  SportsTeam,
  SpreadsheetDigitalDocument,
  StadiumOrArena,
  State,
  Statement: Statement2,
  StatisticalPopulation,
  StatisticalVariable,
  StatusEnumeration,
  SteeringPositionValue,
  Store: Store2,
  StructuredValue,
  StupidType,
  SubscribeAction,
  Substance: Substance2,
  SubwayStation,
  Suite,
  SuperficialAnatomy,
  SurgicalProcedure,
  SuspendAction,
  Syllabus,
  Synagogue,
  TVClip,
  TVEpisode,
  TVSeason,
  TVSeries,
  Table,
  TakeAction,
  TattooParlor,
  Taxi,
  TaxiReservation,
  TaxiService,
  TaxiStand,
  Taxon,
  TechArticle,
  TelevisionChannel,
  TelevisionStation,
  TennisComplex,
  Text,
  TextDigitalDocument,
  TextObject,
  TheaterEvent,
  TheaterGroup,
  TherapeuticProcedure,
  Thesis,
  Thing: Thing3,
  Ticket,
  TieAction,
  Time,
  TipAction,
  TireShop,
  TouristAttraction,
  TouristDestination,
  TouristInformationCenter,
  TouristTrip,
  ToyStore,
  TrackAction,
  TradeAction,
  TrainReservation,
  TrainStation,
  TrainTrip,
  TransferAction,
  TravelAction,
  TravelAgency,
  TreatmentIndication,
  Trip: Trip2,
  TypeAndQuantityNode,
  UKNonprofitType,
  URL: URL2,
  USNonprofitType,
  UnRegisterAction,
  UnitPriceSpecification,
  UpdateAction,
  UseAction,
  UserBlocks,
  UserCheckins,
  UserComments,
  UserDownloads,
  UserInteraction,
  UserLikes,
  UserPageVisits,
  UserPlays,
  UserPlusOnes,
  UserReview,
  UserTweets,
  VacationRental,
  Vehicle,
  Vein,
  Vessel,
  VeterinaryCare,
  VideoGallery,
  VideoGame,
  VideoGameClip,
  VideoGameSeries,
  VideoObject,
  VideoObjectSnapshot,
  ViewAction,
  VirtualLocation,
  VisualArtsEvent,
  VisualArtwork,
  VitalSign,
  Volcano,
  VoteAction,
  WPAdBlock,
  WPFooter,
  WPHeader,
  WPSideBar,
  WantAction,
  WarrantyPromise,
  WarrantyScope,
  WatchAction,
  Waterfall,
  WearAction,
  WearableMeasurementTypeEnumeration,
  WearableSizeGroupEnumeration,
  WearableSizeSystemEnumeration,
  WebAPI,
  WebApplication,
  WebContent,
  WebPage,
  WebPageElement,
  WebSite,
  WholesaleStore,
  WinAction,
  Winery,
  WorkBasedProgram,
  WorkersUnion,
  WriteAction,
  XPathType,
  Zoo,
  abridged,
  abstract: abstract3,
  accelerationTime,
  acceptedAnswer,
  acceptedOffer,
  acceptedPaymentMethod,
  acceptsReservations,
  accessCode,
  accessMode,
  accessModeSufficient,
  accessibilityAPI,
  accessibilityControl,
  accessibilityFeature,
  accessibilityHazard,
  accessibilitySummary,
  accommodationCategory,
  accommodationFloorPlan,
  accountId,
  accountMinimumInflow,
  accountOverdraftLimit,
  accountablePerson,
  acquireLicensePage,
  acquiredFrom,
  acrissCode,
  actionAccessibilityRequirement,
  actionPlatform,
  actionStatus,
  actionableFeedbackPolicy,
  activeIngredient,
  activityDuration,
  activityFrequency,
  actors,
  addOn,
  additionalName,
  additionalNumberOfGuests,
  additionalProperty,
  additionalType,
  additionalVariable,
  address: address3,
  addressCountry,
  addressLocality,
  addressRegion,
  administrationRoute,
  advanceBookingRequirement,
  adverseOutcome,
  affectedBy,
  affiliation: affiliation2,
  afterMedia,
  agent: agent3,
  aggregateRating,
  aircraft,
  albumProductionType,
  albumReleaseType,
  albums,
  alcoholWarning,
  algorithm,
  alignmentType,
  alternativeHeadline,
  alternativeOf,
  amenityFeature,
  amount: amount3,
  amountOfThisGood,
  announcementLocation,
  annualPercentageRate,
  answerCount,
  answerExplanation,
  antagonist,
  appearance,
  applicableCountry,
  applicableLocation,
  applicantLocationRequirements,
  application: application2,
  applicationCategory,
  applicationContact,
  applicationDeadline,
  applicationStartDate,
  applicationSubCategory,
  applicationSuite,
  appliesToDeliveryMethod,
  appliesToPaymentMethod,
  archivedAt,
  area,
  arrivalAirport,
  arrivalBoatTerminal,
  arrivalBusStop,
  arrivalGate,
  arrivalPlatform,
  arrivalStation,
  arrivalTerminal,
  arrivalTime,
  artEdition,
  artMedium,
  artform,
  articleBody,
  articleSection,
  artist,
  asin,
  aspect,
  assembly,
  assemblyVersion,
  assesses,
  associatedAnatomy,
  associatedArticle,
  associatedClaimReview,
  associatedDisease,
  associatedMedia,
  associatedMediaReview,
  associatedPathophysiology,
  athlete,
  attendees,
  audienceType,
  audio,
  authenticator,
  author: author3,
  availability: availability2,
  availabilityEnds,
  availabilityStarts,
  availableAtOrFrom,
  availableChannel,
  availableDeliveryMethod,
  availableFrom,
  availableIn,
  availableLanguage,
  availableService,
  availableStrength,
  availableTest,
  availableThrough,
  awards,
  awayTeam,
  backstory,
  bankAccountType,
  baseSalary,
  bccRecipient,
  bed,
  beforeMedia,
  beneficiaryBank,
  benefits,
  benefitsSummaryUrl,
  bestRating,
  billingAddress,
  billingDuration,
  billingIncrement,
  billingPeriod,
  billingStart,
  bioChemInteraction,
  bioChemSimilarity,
  biologicalRole,
  biomechnicalClass,
  birthDate: birthDate2,
  birthPlace,
  bitrate,
  blogPosts,
  bloodSupply,
  boardingGroup,
  boardingPolicy,
  bodyLocation,
  bodyType,
  bookEdition,
  bookFormat,
  bookingAgent,
  bookingTime,
  borrower,
  box,
  branch,
  branchCode,
  branchOf,
  brand: brand2,
  breadcrumb,
  breastfeedingWarning,
  broadcastAffiliateOf,
  broadcastChannelId,
  broadcastDisplayName,
  broadcastFrequency,
  broadcastFrequencyValue,
  broadcastOfEvent,
  broadcastServiceTier,
  broadcastSignalModulation,
  broadcastSubChannel,
  broadcastTimezone,
  broadcaster,
  browserRequirements,
  busName,
  busNumber,
  businessDays,
  businessFunction,
  buyer,
  byArtist,
  byDay,
  byMonth,
  byMonthDay,
  byMonthWeek,
  callSign,
  calories,
  candidate: candidate2,
  carbohydrateContent,
  cargoVolume,
  carrier,
  carrierRequirements,
  cashBack,
  catalog,
  catalogNumber,
  causeOf,
  ccRecipient,
  character,
  characterAttribute,
  characterName,
  cheatCode,
  checkinTime,
  checkoutPageURLTemplate,
  checkoutTime,
  chemicalComposition,
  chemicalRole,
  childMaxAge,
  childMinAge,
  children,
  cholesterolContent,
  circle,
  citation: citation2,
  claimInterpreter,
  claimReviewed,
  clincalPharmacology,
  clipNumber,
  closes,
  coach,
  code: code2,
  codeRepository,
  codeValue,
  codingSystem,
  colleagues,
  collection: collection3,
  collectionSize,
  color: color2,
  colorist,
  comment: comment4,
  commentCount,
  commentText,
  commentTime,
  competencyRequired,
  composer,
  comprisedOf: comprisedOf2,
  conditionsOfAccess,
  confirmationNumber,
  connectedTo,
  constraintProperty,
  contactOption,
  contactPoints,
  contactType,
  contactlessPayment,
  containedIn,
  contentRating,
  contentReferenceTime,
  contentSize,
  contentType: contentType2,
  contentUrl,
  contraindication: contraindication2,
  contributor: contributor4,
  cookTime,
  cookingMethod,
  copyrightHolder,
  copyrightNotice,
  copyrightYear,
  correction,
  correctionsPolicy,
  costCategory,
  costCurrency,
  costOrigin,
  costPerUnit,
  countriesNotSupported,
  countriesSupported,
  countryOfAssembly,
  countryOfLastProcessing,
  countryOfOrigin: countryOfOrigin2,
  course,
  courseCode,
  courseMode,
  coursePrerequisites,
  courseSchedule,
  courseWorkload,
  coverageEndTime,
  coverageStartTime,
  creativeWorkStatus,
  credentialCategory,
  creditText,
  creditedTo,
  cssSelector,
  currenciesAccepted,
  currency: currency2,
  currentExchangeRate,
  customer,
  customerRemorseReturnFees,
  customerRemorseReturnLabelSource,
  customerRemorseReturnShippingFeesAmount,
  cutoffTime,
  cvdCollectionDate,
  cvdFacilityCounty,
  cvdFacilityId,
  cvdNumBeds,
  cvdNumBedsOcc,
  cvdNumC19Died,
  cvdNumC19HOPats,
  cvdNumC19HospPats,
  cvdNumC19MechVentPats,
  cvdNumC19OFMechVentPats,
  cvdNumC19OverflowPats,
  cvdNumICUBeds,
  cvdNumICUBedsOcc,
  cvdNumTotBeds,
  cvdNumVent,
  cvdNumVentUse,
  dataFeedElement,
  datasetTimeInterval,
  dateDeleted,
  dateIssued,
  dateModified,
  datePosted,
  datePublished,
  dateRead,
  dateReceived,
  dateSent,
  dateVehicleFirstRegistered,
  dateline,
  dayOfWeek: dayOfWeek2,
  deathDate,
  deathPlace,
  defaultValue: defaultValue2,
  deliveryAddress,
  deliveryLeadTime,
  deliveryMethod,
  deliveryStatus,
  deliveryTime,
  department,
  departureAirport,
  departureBoatTerminal,
  departureBusStop,
  departureGate,
  departurePlatform,
  departureStation,
  departureTerminal,
  departureTime,
  dependencies,
  depth,
  device: device2,
  diagnosis: diagnosis2,
  diagram,
  diet,
  dietFeatures,
  differentialDiagnosis,
  directApply,
  directors,
  disambiguatingDescription,
  discount,
  discountCode,
  discountCurrency,
  discusses,
  discussionUrl,
  diseasePreventionInfo,
  diseaseSpreadStatistics,
  dissolutionDate,
  distance,
  distinguishingSign,
  distribution,
  diversityPolicy,
  diversityStaffingReport,
  documentation: documentation2,
  doesNotShip,
  domainIncludes,
  domiciledMortgage,
  doorTime,
  dosageForm,
  doseSchedule,
  doseUnit,
  doseValue,
  downPayment,
  downloadUrl,
  downvoteCount,
  drainsTo,
  driveWheelConfiguration,
  dropoffLocation,
  dropoffTime,
  drug,
  drugClass,
  drugUnit,
  duns,
  duplicateTherapy,
  durationOfWarranty,
  duringMedia,
  earlyPrepaymentPenalty,
  editEIDR,
  editor: editor2,
  eduQuestionType,
  educationRequirements,
  educationalAlignment,
  educationalCredentialAwarded,
  educationalFramework,
  educationalLevel,
  educationalProgramMode,
  educationalRole,
  educationalUse,
  elevation,
  eligibilityToWorkRequirement,
  eligibleCustomerType,
  eligibleDuration,
  eligibleQuantity,
  eligibleRegion,
  eligibleTransactionVolume,
  email,
  embedUrl,
  embeddedTextCaption,
  emissionsCO2,
  employees,
  employerOverview,
  employmentType,
  employmentUnit,
  encodingType,
  encodings,
  endDate: endDate2,
  endOffset,
  endTime: endTime2,
  endorsee,
  endorsers,
  energyEfficiencyScaleMax,
  energyEfficiencyScaleMin,
  engineDisplacement,
  enginePower,
  engineType,
  entertainmentBusiness,
  epidemiology,
  episodeNumber,
  episodes,
  equal,
  error: error2,
  estimatedCost,
  estimatedFlightDuration,
  estimatedSalary,
  estimatesRiskOf,
  ethicsPolicy,
  eventAttendanceMode,
  eventSchedule,
  eventStatus,
  events,
  evidenceLevel,
  evidenceOrigin,
  exceptDate,
  exchangeRateSpread,
  exercisePlan,
  exerciseRelatedDiet,
  exerciseType,
  exifData,
  expectedArrivalFrom,
  expectedArrivalUntil,
  expectedPrognosis,
  expectsAcceptanceOf,
  experienceInPlaceOfEducation,
  experienceRequirements,
  expertConsiderations,
  expires,
  expressedIn,
  familyName,
  fatContent,
  faxNumber,
  featureList,
  feesAndCommissionsSpecification,
  fiberContent,
  fileFormat,
  fileSize,
  financialAidEligible,
  firstAppearance,
  firstPerformance,
  flightDistance,
  flightNumber,
  floorLevel,
  floorLimit,
  floorSize,
  followee,
  follows,
  followup,
  foodEstablishment,
  foodEvent,
  foodWarning,
  founders,
  foundingDate,
  foundingLocation,
  free,
  freeShippingThreshold,
  fromLocation,
  fuelCapacity,
  fuelConsumption,
  fuelEfficiency,
  fuelType,
  functionalClass,
  funder: funder2,
  gameAvailabilityType,
  gameEdition,
  gameItem,
  gameLocation,
  gamePlatform,
  gameTip,
  gender: gender3,
  geo: geo2,
  geoContains,
  geoCoveredBy,
  geoCovers,
  geoCrosses,
  geoDisjoint,
  geoEquals,
  geoIntersects,
  geoMidpoint,
  geoOverlaps,
  geoRadius,
  geoTouches,
  geoWithin,
  geographicArea,
  gettingTestedInfo,
  givenName,
  globalLocationNumber,
  governmentBenefitsInfo,
  gracePeriod,
  grantee: grantee2,
  greater,
  greaterOrEqual,
  gtin12,
  gtin13,
  gtin14,
  gtin8,
  guideline: guideline2,
  guidelineDate,
  guidelineSubject,
  handlingTime,
  hasAdultConsideration,
  hasBioPolymerSequence,
  hasCategoryCode,
  hasCourse,
  hasCourseInstance,
  hasCredential,
  hasDeliveryMethod,
  hasDigitalDocumentPermission,
  hasDriveThroughService,
  hasEnergyConsumptionDetails,
  hasEnergyEfficiencyCategory,
  hasHealthAspect,
  hasMeasurement,
  hasMenuItem,
  hasMenuSection,
  hasMolecularFunction,
  hasOccupation,
  hasOfferCatalog,
  hasPOS,
  hasProductReturnPolicy,
  headline,
  healthCondition,
  healthPlanCoinsuranceOption,
  healthPlanCoinsuranceRate,
  healthPlanCopay,
  healthPlanCopayOption,
  healthPlanCostSharing,
  healthPlanDrugOption,
  healthPlanDrugTier,
  healthPlanId,
  healthPlanMarketingUrl,
  healthPlanNetworkId,
  healthPlanNetworkTier,
  healthPlanPharmacyCategory,
  healthcareReportingData,
  height: height3,
  highPrice,
  hiringOrganization,
  homeLocation,
  homeTeam,
  honorificPrefix,
  honorificSuffix,
  hospitalAffiliation,
  hostingOrganization,
  hoursAvailable,
  howPerformed,
  httpMethod,
  iataCode,
  icaoCode,
  identifyingExam,
  identifyingTest,
  illustrator,
  imagingTechnique,
  inAlbum,
  inBroadcastLineup,
  inChI,
  inChIKey,
  inCodeSet,
  inPlaylist,
  inProductGroupWithID,
  inStoreReturnsOffered,
  inSupportOf,
  incentives,
  includedComposition,
  includedDataCatalog,
  includedInHealthInsurancePlan,
  includedRiskFactor,
  includesAttraction,
  includesHealthPlanFormulary,
  includesHealthPlanNetwork,
  includesObject,
  increasesRiskOf,
  industry,
  ineligibleRegion,
  infectiousAgent,
  infectiousAgentClass,
  ingredients,
  inker,
  insertion,
  installUrl,
  instructor,
  intensity,
  interactingDrug,
  interactionCount,
  interactionService,
  interactionType,
  interactivityType,
  interestRate,
  interpretedAsClaim,
  inventoryLevel,
  inverseOf: inverseOf2,
  isAcceptingNewPatients,
  isAccessoryOrSparePartFor,
  isAvailableGenerically,
  isBasedOnUrl,
  isConsumableFor,
  isFamilyFriendly,
  isGift,
  isInvolvedInBiologicalProcess,
  isLiveBroadcast,
  isLocatedInSubcellularLocation,
  isPlanForApartment,
  isProprietary,
  isRelatedTo,
  isResizable,
  isSimilarTo,
  isUnlabelledFallback,
  isbn,
  isicV4,
  iso6523Code,
  isrcCode,
  issn,
  issueNumber,
  issuedBy,
  issuedThrough,
  iswcCode,
  item: item2,
  itemCondition,
  itemDefectReturnFees,
  itemDefectReturnLabelSource,
  itemDefectReturnShippingFeesAmount,
  itemListElement,
  itemListOrder,
  itemLocation,
  itemReviewed,
  itemShipped,
  itinerary,
  iupacName,
  jobImmediateStart,
  jobLocation,
  jobLocationType,
  jobStartDate,
  jobTitle,
  keywords,
  knownVehicleDamages,
  knows: knows2,
  knowsAbout,
  knowsLanguage,
  labelDetails,
  landlord,
  language: language5,
  lastReviewed,
  latitude: latitude3,
  layoutImage,
  learningResourceType,
  leaseLength,
  legalName,
  legalStatus,
  legislationChanges,
  legislationConsolidates,
  legislationDate,
  legislationDateVersion,
  legislationIdentifier,
  legislationJurisdiction,
  legislationLegalForce,
  legislationLegalValue,
  legislationPassedBy,
  legislationResponsible,
  legislationTransposes,
  legislationType,
  leiCode,
  lender,
  lesser,
  lesserOrEqual,
  letterer,
  license: license3,
  line: line2,
  linkRelationship,
  liveBlogUpdate,
  loanMortgageMandateAmount,
  loanPaymentAmount,
  loanPaymentFrequency,
  loanRepaymentForm,
  loanTerm,
  loanType,
  locationCreated,
  lodgingUnitDescription,
  lodgingUnitType,
  logo: logo2,
  longitude: longitude3,
  loser,
  lowPrice,
  lyricist,
  lyrics,
  maintainer,
  manufacturer: manufacturer2,
  map: map3,
  mapType,
  maps,
  marginOfError,
  masthead,
  materialExtent,
  mathExpression,
  maxPrice,
  maxValue: maxValue2,
  maximumAttendeeCapacity,
  maximumEnrollment,
  maximumIntake,
  maximumPhysicalAttendeeCapacity,
  maximumVirtualAttendeeCapacity,
  mealService,
  measuredProperty,
  measurementDenominator,
  measurementMethod,
  measurementQualifier,
  mechanismOfAction,
  mediaAuthenticityCategory,
  mediaItemAppearance,
  median,
  medicalAudience,
  medicalSpecialty,
  medicineSystem,
  meetsEmissionStandard,
  members: members2,
  membershipNumber,
  membershipPointsEarned,
  memoryRequirements,
  mentions,
  menu,
  menuAddOn,
  merchant,
  messageAttachment,
  mileageFromOdometer,
  minPrice,
  minValue: minValue2,
  minimumPaymentDue,
  missionCoveragePrioritiesPolicy,
  mobileUrl,
  model,
  modelDate,
  modifiedTime,
  molecularFormula: molecularFormula2,
  molecularWeight: molecularWeight2,
  monoisotopicMolecularWeight,
  monthlyMinimumRepaymentAmount,
  monthsOfExperience,
  mpn,
  multipleValues,
  muscleAction,
  musicArrangement,
  musicBy,
  musicCompositionForm,
  musicGroupMember,
  musicReleaseFormat,
  musicalKey,
  naics,
  name: name4,
  namedPosition,
  nationality,
  naturalProgression,
  negativeNotes,
  nerve,
  nerveMotor,
  netWorth,
  newsUpdatesAndGuidelines,
  nextItem,
  noBylinesPolicy,
  nonEqual,
  nonProprietaryName,
  nonprofitStatus,
  normalRange,
  nsn,
  numAdults,
  numChildren,
  numConstraints,
  numTracks,
  numberOfAccommodationUnits,
  numberOfAirbags,
  numberOfAvailableAccommodationUnits,
  numberOfAxles,
  numberOfBathroomsTotal,
  numberOfBedrooms,
  numberOfBeds,
  numberOfCredits,
  numberOfDoors,
  numberOfEmployees,
  numberOfEpisodes,
  numberOfForwardGears,
  numberOfFullBathrooms,
  numberOfItems,
  numberOfLoanPayments,
  numberOfPages,
  numberOfPartialBathrooms,
  numberOfPlayers,
  numberOfPreviousOwners,
  numberOfRooms,
  numberOfSeasons,
  numberedPosition,
  nutrition,
  observationAbout,
  observationDate,
  observationPeriod,
  occupancy,
  occupationLocation,
  occupationalCategory,
  occupationalCredentialAwarded,
  offerCount,
  offersPrescriptionByMail,
  openingHours,
  openingHoursSpecification,
  opens,
  operatingSystem,
  opponent,
  option: option3,
  orderDate,
  orderDelivery,
  orderItemNumber,
  orderItemStatus,
  orderNumber,
  orderQuantity,
  orderStatus,
  orderedItem,
  organizer: organizer2,
  originAddress,
  originalMediaContextDescription,
  originalMediaLink,
  originatesFrom,
  overdosage,
  ownedFrom,
  ownedThrough,
  ownershipFundingInfo,
  owns,
  pageEnd,
  pageStart,
  pagination,
  parentItem,
  parentService,
  parents,
  partOfEpisode,
  partOfInvoice,
  partOfOrder,
  partOfSeason,
  partOfSystem,
  partOfTVSeries,
  partySize,
  passengerPriorityStatus,
  passengerSequenceNumber,
  pathophysiology,
  pattern: pattern2,
  payload: payload2,
  paymentAccepted,
  paymentDue,
  paymentMethod,
  paymentMethodId,
  paymentStatus: paymentStatus2,
  paymentUrl,
  penciler,
  percentile10,
  percentile25,
  percentile75,
  percentile90,
  performerIn,
  performers,
  permissionType,
  permissions,
  permitAudience,
  permittedUsage,
  petsAllowed,
  phoneticText,
  photos,
  physicalRequirement,
  physiologicalBenefits,
  pickupLocation,
  pickupTime,
  playMode,
  playerType,
  playersOnline,
  polygon,
  populationType,
  positiveNotes,
  possibleComplication,
  possibleTreatment,
  postOfficeBoxNumber,
  postOp,
  postalCode: postalCode2,
  postalCodeBegin,
  postalCodeEnd,
  postalCodePrefix,
  postalCodeRange,
  potentialAction,
  potentialUse,
  preOp,
  predecessorOf,
  pregnancyCategory,
  pregnancyWarning,
  prepTime,
  preparation: preparation2,
  prescribingInfo,
  prescriptionStatus,
  previousItem,
  previousStartDate,
  price,
  priceComponent: priceComponent2,
  priceComponentType,
  priceCurrency,
  priceRange,
  priceSpecification,
  priceType,
  priceValidUntil,
  primaryImageOfPage,
  primaryPrevention,
  printColumn,
  printEdition,
  printPage,
  printSection,
  procedure: procedure2,
  procedureType,
  processingTime,
  processorRequirements,
  producer,
  produces,
  productGroupID,
  productID,
  productReturnDays,
  productReturnLink,
  productSupported,
  productionCompany,
  productionDate,
  proficiencyLevel,
  programMembershipUsed,
  programName,
  programPrerequisites,
  programType,
  programmingLanguage,
  programmingModel,
  propertyID,
  proprietaryName,
  proteinContent,
  providerMobility,
  providesService,
  publicAccess,
  publicTransportClosuresInfo,
  publication,
  publicationType,
  publishedBy,
  publishedOn,
  publisher: publisher4,
  publisherImprint,
  purchaseDate,
  qualifications,
  quarantineGuidelines,
  query: query2,
  quest,
  question: question2,
  rangeIncludes,
  ratingCount,
  ratingExplanation,
  ratingValue,
  readBy,
  readonlyValue,
  realEstateAgent,
  recipe,
  recipeCategory,
  recipeCuisine,
  recipeInstructions,
  recipeYield,
  recognizedBy,
  recognizingAuthority,
  recommendationStrength,
  recommendedIntake,
  recordLabel,
  recourseLoan,
  referenceQuantity,
  referencesOrder,
  refundType,
  regionDrained,
  regionsAllowed,
  relatedAnatomy,
  relatedCondition,
  relatedDrug,
  relatedLink,
  relatedStructure,
  relatedTherapy,
  relatedTo: relatedTo2,
  releaseDate: releaseDate2,
  releaseNotes,
  releasedEvent,
  relevantOccupation,
  relevantSpecialty,
  remainingAttendeeCapacity,
  renegotiableLoan,
  repeatCount,
  repeatFrequency,
  repetitions: repetitions2,
  replacee,
  replacer,
  replyToUrl,
  reportNumber,
  representativeOfPage,
  requiredCollateral,
  requiredGender,
  requiredMaxAge,
  requiredMinAge,
  requiredQuantity,
  requirements: requirements2,
  requiresSubscription,
  reservationFor,
  reservationId,
  reservationStatus,
  reservedTicket,
  responsibilities,
  restPeriods,
  restockingFee,
  resultComment,
  resultReview,
  returnFees,
  returnLabelSource,
  returnMethod,
  returnPolicyCategory,
  returnPolicyCountry,
  returnPolicySeasonalOverride,
  returnShippingFeesAmount,
  reviewAspect,
  reviewBody,
  reviewCount,
  reviewRating,
  reviewedBy,
  reviews,
  riskFactor,
  risks,
  roofLoad,
  rsvpResponse,
  runsTo,
  runtime,
  rxcui,
  safetyConsideration,
  salaryCurrency,
  salaryUponCompletion,
  sameAs: sameAs2,
  sampleType,
  saturatedFatContent,
  scheduleTimezone,
  scheduledPaymentDate,
  scheduledTime,
  schemaVersion,
  schoolClosuresInfo,
  screenCount,
  screenshot,
  sdDatePublished,
  sdLicense,
  sdPublisher,
  seasonNumber,
  seasons,
  seatNumber,
  seatRow,
  seatSection,
  seatingCapacity,
  seatingType,
  secondaryPrevention,
  securityClearanceRequirement,
  securityScreening,
  seeks,
  sender: sender2,
  sensoryRequirement,
  sensoryUnit,
  seriousAdverseOutcome,
  serverStatus,
  servesCuisine,
  serviceAudience,
  serviceLocation,
  serviceOperator,
  servicePhone,
  servicePostalAddress,
  serviceSmsNumber,
  serviceType: serviceType2,
  serviceUrl,
  servingSize,
  sha256,
  sharedContent,
  shippingDestination,
  shippingDetails,
  shippingLabel,
  shippingOrigin,
  shippingRate,
  shippingSettingsLink,
  siblings,
  signDetected,
  signOrSymptom,
  significance,
  significantLinks,
  size: size2,
  sizeGroup,
  sizeSystem,
  skills,
  sku,
  slogan,
  smiles,
  smokingAllowed,
  sodiumContent,
  softwareAddOn,
  softwareHelp,
  softwareVersion,
  sourceOrganization,
  sourcedFrom,
  spatial: spatial2,
  speakable,
  specialCommitments,
  specialOpeningHoursSpecification,
  specialty: specialty2,
  speechToTextMarkup,
  speed,
  spokenByCharacter,
  sport,
  sportsActivityLocation,
  sportsEvent,
  sportsTeam,
  spouse,
  stage: stage2,
  stageAsNumber,
  starRating,
  startDate: startDate2,
  startOffset,
  startTime: startTime2,
  statType,
  status: status5,
  steeringPosition,
  stepValue,
  steps,
  storageRequirements,
  streetAddress,
  strengthUnit,
  strengthValue,
  structuralClass,
  study: study2,
  studyDesign: studyDesign2,
  studyLocation,
  studySubject,
  stupidProperty,
  subEvents,
  subReservation,
  subStageSuffix,
  subStructure,
  subTest,
  subtitleLanguage,
  successorOf,
  sugarContent,
  suggestedAge,
  suggestedGender,
  suggestedMaxAge,
  suggestedMeasurement,
  suggestedMinAge,
  suitableForDiet,
  supersededBy,
  supplyTo,
  supportingData,
  surface,
  syllabusSections,
  target: target3,
  targetDescription,
  targetName,
  targetPlatform,
  targetPopulation,
  targetProduct,
  targetUrl,
  taxID,
  taxonRank,
  taxonomicRange,
  teaches,
  telephone,
  temporal: temporal2,
  termDuration,
  termsOfService,
  termsPerYear,
  text: text2,
  textValue,
  thumbnail: thumbnail2,
  thumbnailUrl,
  tickerSymbol,
  ticketNumber,
  ticketToken,
  ticketedSeat,
  timeOfDay: timeOfDay2,
  timeRequired,
  timeToComplete,
  tissueSample,
  title: title6,
  titleEIDR,
  toLocation,
  toRecipient,
  tocContinuation,
  tocEntry,
  tongueWeight,
  tool,
  torque,
  totalHistoricalEnrollment,
  totalJobOpenings,
  totalPaymentDue,
  totalPrice,
  totalTime,
  tourBookingPage,
  touristType,
  trackingNumber,
  trackingUrl,
  tracks,
  trailer,
  trailerWeight,
  trainName,
  trainNumber,
  trainingSalary,
  transFatContent,
  transcript,
  transitTime,
  transitTimeLabel,
  translator,
  transmissionMethod,
  travelBans,
  trialDesign,
  tributary,
  tripOrigin,
  typeOfBed,
  typeOfGood,
  typicalAgeRange,
  typicalCreditsPerTerm,
  typicalTest,
  underName,
  unitCode,
  unitText,
  unnamedSourcesPolicy,
  unsaturatedFatContent,
  uploadDate,
  upvoteCount,
  url: url4,
  urlTemplate,
  usedToDiagnose,
  userInteractionCount,
  usesDevice,
  usesHealthPlanIdStandard,
  utterances,
  validFor,
  validFrom,
  validIn,
  validThrough,
  validUntil,
  value: value3,
  valueAddedTaxIncluded,
  valueMaxLength,
  valueMinLength,
  valueName,
  valuePattern,
  valueReference,
  valueRequired,
  variableMeasured,
  variablesMeasured,
  variantCover,
  variesBy,
  vatID,
  vehicleConfiguration,
  vehicleEngine,
  vehicleIdentificationNumber,
  vehicleInteriorColor,
  vehicleInteriorType,
  vehicleModelDate,
  vehicleSeatingCapacity,
  vehicleSpecialUsage,
  vehicleTransmission,
  vendor,
  verificationFactCheckingPolicy,
  version: version4,
  video,
  videoFormat,
  videoFrameSize,
  videoQuality,
  volumeNumber,
  warning: warning2,
  warrantyPromise,
  warrantyScope,
  webCheckinTime,
  webFeed,
  weight,
  weightTotal,
  wheelbase,
  width: width3,
  winner,
  wordCount,
  workHours,
  workLocation,
  workPerformed,
  workPresented,
  workload,
  worksFor,
  worstRating,
  xpath,
  yearBuilt,
  yearlyRevenue,
  yearsInOperation,
  actionApplication,
  actionOption,
  album,
  albumRelease,
  alternateName,
  alumni,
  alumniOf,
  archiveHeld,
  arterialBranch,
  artworkSurface,
  attendee: attendee2,
  audience: audience3,
  availableOnDevice,
  award,
  blogPost,
  broker,
  caption,
  category: category3,
  childTaxon,
  clinicalPharmacology,
  codeSampleType,
  colleague,
  contactPoint,
  containsPlace,
  containsSeason,
  contentLocation,
  creator: creator3,
  dataset,
  dateCreated,
  director,
  duration: duration4,
  employee,
  encodesBioChemEntity,
  encodesCreativeWork,
  encodingFormat,
  episode,
  event: event2,
  exampleOfWork,
  executableLibraryName,
  exerciseCourse,
  founder,
  frequency: frequency2,
  fundedItem,
  funding,
  game,
  gameServer,
  genre,
  hasBioChemEntityPart,
  hasBroadcastChannel,
  hasDefinedTerm,
  hasMenu,
  hasMerchantReturnPolicy,
  hasVariant,
  holdingArchive,
  inDefinedTermSet,
  inLanguage,
  incentiveCompensation,
  interactionStatistic,
  isAccessibleForFree,
  isBasedOn,
  isEncodedByBioChemEntity,
  isPartOfBioChemEntity,
  isVariantOf,
  itemOffered,
  jobBenefits,
  jurisdiction: jurisdiction2,
  legislationApplies,
  mainContentOfPage,
  mainEntity,
  mainEntityOfPage,
  makesOffer,
  measurementTechnique,
  merchantReturnDays,
  merchantReturnLink,
  offeredBy,
  offers,
  parent: parent2,
  parentTaxon,
  partOfSeries,
  partOfTrip,
  paymentDueDate,
  performTime,
  performer: performer2,
  photo: photo2,
  provider: provider3,
  providesBroadcastService,
  recipeIngredient,
  recordedAs,
  recordedAt,
  recordedIn,
  recordingOf,
  releaseOf,
  review,
  roleName,
  runtimePlatform,
  season,
  serialNumber: serialNumber2,
  serviceArea,
  serviceOutput,
  sibling,
  significantLink,
  softwareRequirements,
  sponsor,
  subOrganization,
  subTrip,
  subjectOf,
  suggestedAnswer,
  superEvent,
  targetCollection,
  temporalCoverage,
  termCode,
  track,
  translationOfWork,
  usageInfo,
  warranty,
  workTranslation,
  yield__workaround,
  about: about2,
  actor: actor3,
  associatedReview,
  competitor,
  containedInPlace,
  encoding,
  hasMap,
  material: material2,
  memberOf,
  parentOrganization,
  result: result3,
  seller,
  spatialCoverage,
  step: step2,
  subEvent,
  supply,
  workFeatured,
  areaServed,
  image: image3,
  includedInDataCatalog,
  member: member6,
  recipient: recipient2,
  workExample,
  description: description7,
  gtin,
  hasRepresentation,
  hasPart: hasPart3,
  position: position2,
  isPartOf: isPartOf2,
  instrument: instrument2,
  object: object4,
  publishingPrinciples,
  location: location6,
  participant: participant3,
  identifier: identifier4
});

// ../node_modules/rdf-namespaces/dist/schema_https-33c5f793.js
var AMRadioChannel2 = "https://schema.org/AMRadioChannel";
var APIReference2 = "https://schema.org/APIReference";
var AboutPage2 = "https://schema.org/AboutPage";
var AcceptAction2 = "https://schema.org/AcceptAction";
var Accommodation2 = "https://schema.org/Accommodation";
var AccountingService2 = "https://schema.org/AccountingService";
var AchieveAction2 = "https://schema.org/AchieveAction";
var Action3 = "https://schema.org/Action";
var ActionAccessSpecification2 = "https://schema.org/ActionAccessSpecification";
var ActionStatusType2 = "https://schema.org/ActionStatusType";
var ActivateAction2 = "https://schema.org/ActivateAction";
var AddAction2 = "https://schema.org/AddAction";
var AdministrativeArea2 = "https://schema.org/AdministrativeArea";
var AdultEntertainment2 = "https://schema.org/AdultEntertainment";
var AdultOrientedEnumeration2 = "https://schema.org/AdultOrientedEnumeration";
var AdvertiserContentArticle2 = "https://schema.org/AdvertiserContentArticle";
var AggregateOffer2 = "https://schema.org/AggregateOffer";
var AggregateRating2 = "https://schema.org/AggregateRating";
var AgreeAction2 = "https://schema.org/AgreeAction";
var Airline2 = "https://schema.org/Airline";
var Airport2 = "https://schema.org/Airport";
var AlignmentObject2 = "https://schema.org/AlignmentObject";
var AllocateAction2 = "https://schema.org/AllocateAction";
var AmpStory2 = "https://schema.org/AmpStory";
var AmusementPark2 = "https://schema.org/AmusementPark";
var AnalysisNewsArticle2 = "https://schema.org/AnalysisNewsArticle";
var AnatomicalStructure2 = "https://schema.org/AnatomicalStructure";
var AnatomicalSystem2 = "https://schema.org/AnatomicalSystem";
var AnimalShelter2 = "https://schema.org/AnimalShelter";
var Answer3 = "https://schema.org/Answer";
var Apartment2 = "https://schema.org/Apartment";
var ApartmentComplex2 = "https://schema.org/ApartmentComplex";
var AppendAction2 = "https://schema.org/AppendAction";
var ApplyAction2 = "https://schema.org/ApplyAction";
var ApprovedIndication2 = "https://schema.org/ApprovedIndication";
var Aquarium2 = "https://schema.org/Aquarium";
var ArchiveComponent2 = "https://schema.org/ArchiveComponent";
var ArchiveOrganization2 = "https://schema.org/ArchiveOrganization";
var ArriveAction2 = "https://schema.org/ArriveAction";
var ArtGallery2 = "https://schema.org/ArtGallery";
var Artery2 = "https://schema.org/Artery";
var Article3 = "https://schema.org/Article";
var AskAction2 = "https://schema.org/AskAction";
var AskPublicNewsArticle2 = "https://schema.org/AskPublicNewsArticle";
var AssessAction2 = "https://schema.org/AssessAction";
var AssignAction2 = "https://schema.org/AssignAction";
var Atlas2 = "https://schema.org/Atlas";
var Attorney2 = "https://schema.org/Attorney";
var Audience2 = "https://schema.org/Audience";
var AudioObject2 = "https://schema.org/AudioObject";
var AudioObjectSnapshot2 = "https://schema.org/AudioObjectSnapshot";
var Audiobook2 = "https://schema.org/Audiobook";
var AuthorizeAction2 = "https://schema.org/AuthorizeAction";
var AutoBodyShop2 = "https://schema.org/AutoBodyShop";
var AutoDealer2 = "https://schema.org/AutoDealer";
var AutoPartsStore2 = "https://schema.org/AutoPartsStore";
var AutoRental2 = "https://schema.org/AutoRental";
var AutoRepair2 = "https://schema.org/AutoRepair";
var AutoWash2 = "https://schema.org/AutoWash";
var AutomatedTeller2 = "https://schema.org/AutomatedTeller";
var AutomotiveBusiness2 = "https://schema.org/AutomotiveBusiness";
var BackgroundNewsArticle2 = "https://schema.org/BackgroundNewsArticle";
var Bakery2 = "https://schema.org/Bakery";
var BankAccount2 = "https://schema.org/BankAccount";
var BankOrCreditUnion2 = "https://schema.org/BankOrCreditUnion";
var BarOrPub2 = "https://schema.org/BarOrPub";
var Barcode2 = "https://schema.org/Barcode";
var Beach2 = "https://schema.org/Beach";
var BeautySalon2 = "https://schema.org/BeautySalon";
var BedAndBreakfast2 = "https://schema.org/BedAndBreakfast";
var BedDetails2 = "https://schema.org/BedDetails";
var BedType2 = "https://schema.org/BedType";
var BefriendAction2 = "https://schema.org/BefriendAction";
var BikeStore2 = "https://schema.org/BikeStore";
var BioChemEntity2 = "https://schema.org/BioChemEntity";
var Blog2 = "https://schema.org/Blog";
var BlogPosting2 = "https://schema.org/BlogPosting";
var BloodTest2 = "https://schema.org/BloodTest";
var BoardingPolicyType2 = "https://schema.org/BoardingPolicyType";
var BoatReservation2 = "https://schema.org/BoatReservation";
var BoatTerminal2 = "https://schema.org/BoatTerminal";
var BoatTrip2 = "https://schema.org/BoatTrip";
var BodyMeasurementTypeEnumeration2 = "https://schema.org/BodyMeasurementTypeEnumeration";
var BodyOfWater2 = "https://schema.org/BodyOfWater";
var Bone2 = "https://schema.org/Bone";
var Book2 = "https://schema.org/Book";
var BookFormatType2 = "https://schema.org/BookFormatType";
var BookSeries2 = "https://schema.org/BookSeries";
var BookStore2 = "https://schema.org/BookStore";
var BookmarkAction2 = "https://schema.org/BookmarkAction";
var Boolean__workaround2 = "https://schema.org/Boolean";
var BorrowAction2 = "https://schema.org/BorrowAction";
var BowlingAlley2 = "https://schema.org/BowlingAlley";
var BrainStructure2 = "https://schema.org/BrainStructure";
var Brand2 = "https://schema.org/Brand";
var BreadcrumbList2 = "https://schema.org/BreadcrumbList";
var Brewery2 = "https://schema.org/Brewery";
var Bridge2 = "https://schema.org/Bridge";
var BroadcastChannel2 = "https://schema.org/BroadcastChannel";
var BroadcastEvent2 = "https://schema.org/BroadcastEvent";
var BroadcastFrequencySpecification2 = "https://schema.org/BroadcastFrequencySpecification";
var BroadcastService2 = "https://schema.org/BroadcastService";
var BrokerageAccount2 = "https://schema.org/BrokerageAccount";
var BuddhistTemple2 = "https://schema.org/BuddhistTemple";
var BusOrCoach2 = "https://schema.org/BusOrCoach";
var BusReservation2 = "https://schema.org/BusReservation";
var BusStation2 = "https://schema.org/BusStation";
var BusStop2 = "https://schema.org/BusStop";
var BusTrip2 = "https://schema.org/BusTrip";
var BusinessAudience2 = "https://schema.org/BusinessAudience";
var BusinessEntityType2 = "https://schema.org/BusinessEntityType";
var BusinessEvent2 = "https://schema.org/BusinessEvent";
var BusinessFunction2 = "https://schema.org/BusinessFunction";
var BuyAction2 = "https://schema.org/BuyAction";
var CDCPMDRecord2 = "https://schema.org/CDCPMDRecord";
var CableOrSatelliteService2 = "https://schema.org/CableOrSatelliteService";
var CafeOrCoffeeShop2 = "https://schema.org/CafeOrCoffeeShop";
var Campground2 = "https://schema.org/Campground";
var CampingPitch2 = "https://schema.org/CampingPitch";
var Canal2 = "https://schema.org/Canal";
var CancelAction2 = "https://schema.org/CancelAction";
var Car2 = "https://schema.org/Car";
var CarUsageType2 = "https://schema.org/CarUsageType";
var Casino2 = "https://schema.org/Casino";
var CategoryCode2 = "https://schema.org/CategoryCode";
var CategoryCodeSet2 = "https://schema.org/CategoryCodeSet";
var CatholicChurch2 = "https://schema.org/CatholicChurch";
var Cemetery2 = "https://schema.org/Cemetery";
var Chapter2 = "https://schema.org/Chapter";
var CheckAction2 = "https://schema.org/CheckAction";
var CheckInAction2 = "https://schema.org/CheckInAction";
var CheckOutAction2 = "https://schema.org/CheckOutAction";
var CheckoutPage2 = "https://schema.org/CheckoutPage";
var ChemicalSubstance2 = "https://schema.org/ChemicalSubstance";
var ChildCare2 = "https://schema.org/ChildCare";
var ChildrensEvent2 = "https://schema.org/ChildrensEvent";
var ChooseAction2 = "https://schema.org/ChooseAction";
var Church2 = "https://schema.org/Church";
var City2 = "https://schema.org/City";
var CityHall2 = "https://schema.org/CityHall";
var CivicStructure2 = "https://schema.org/CivicStructure";
var Claim3 = "https://schema.org/Claim";
var ClaimReview2 = "https://schema.org/ClaimReview";
var Class6 = "https://schema.org/Class";
var Clip2 = "https://schema.org/Clip";
var ClothingStore2 = "https://schema.org/ClothingStore";
var Code2 = "https://schema.org/Code";
var Collection4 = "https://schema.org/Collection";
var CollectionPage3 = "https://schema.org/CollectionPage";
var CollegeOrUniversity2 = "https://schema.org/CollegeOrUniversity";
var ComedyClub2 = "https://schema.org/ComedyClub";
var ComedyEvent2 = "https://schema.org/ComedyEvent";
var ComicCoverArt2 = "https://schema.org/ComicCoverArt";
var ComicIssue2 = "https://schema.org/ComicIssue";
var ComicSeries2 = "https://schema.org/ComicSeries";
var ComicStory2 = "https://schema.org/ComicStory";
var Comment2 = "https://schema.org/Comment";
var CommentAction2 = "https://schema.org/CommentAction";
var CommunicateAction2 = "https://schema.org/CommunicateAction";
var CompleteDataFeed2 = "https://schema.org/CompleteDataFeed";
var CompoundPriceSpecification2 = "https://schema.org/CompoundPriceSpecification";
var ComputerLanguage2 = "https://schema.org/ComputerLanguage";
var ComputerStore2 = "https://schema.org/ComputerStore";
var ConfirmAction2 = "https://schema.org/ConfirmAction";
var Consortium2 = "https://schema.org/Consortium";
var ConstraintNode2 = "https://schema.org/ConstraintNode";
var ConsumeAction2 = "https://schema.org/ConsumeAction";
var ContactPage2 = "https://schema.org/ContactPage";
var ContactPoint3 = "https://schema.org/ContactPoint";
var ContactPointOption2 = "https://schema.org/ContactPointOption";
var Continent2 = "https://schema.org/Continent";
var ControlAction2 = "https://schema.org/ControlAction";
var ConvenienceStore2 = "https://schema.org/ConvenienceStore";
var Conversation2 = "https://schema.org/Conversation";
var CookAction2 = "https://schema.org/CookAction";
var Corporation2 = "https://schema.org/Corporation";
var CorrectionComment2 = "https://schema.org/CorrectionComment";
var Country2 = "https://schema.org/Country";
var Course2 = "https://schema.org/Course";
var CourseInstance2 = "https://schema.org/CourseInstance";
var Courthouse2 = "https://schema.org/Courthouse";
var CoverArt2 = "https://schema.org/CoverArt";
var CovidTestingFacility2 = "https://schema.org/CovidTestingFacility";
var CreateAction2 = "https://schema.org/CreateAction";
var CreativeWork2 = "https://schema.org/CreativeWork";
var CreativeWorkSeason2 = "https://schema.org/CreativeWorkSeason";
var CreativeWorkSeries2 = "https://schema.org/CreativeWorkSeries";
var CreditCard2 = "https://schema.org/CreditCard";
var Crematorium2 = "https://schema.org/Crematorium";
var CriticReview2 = "https://schema.org/CriticReview";
var CssSelectorType2 = "https://schema.org/CssSelectorType";
var CurrencyConversionService2 = "https://schema.org/CurrencyConversionService";
var DDxElement2 = "https://schema.org/DDxElement";
var DanceEvent2 = "https://schema.org/DanceEvent";
var DanceGroup2 = "https://schema.org/DanceGroup";
var DataCatalog2 = "https://schema.org/DataCatalog";
var DataDownload2 = "https://schema.org/DataDownload";
var DataFeed2 = "https://schema.org/DataFeed";
var DataFeedItem2 = "https://schema.org/DataFeedItem";
var DataType3 = "https://schema.org/DataType";
var Dataset2 = "https://schema.org/Dataset";
var Date__workaround2 = "https://schema.org/Date";
var DateTime2 = "https://schema.org/DateTime";
var DatedMoneySpecification2 = "https://schema.org/DatedMoneySpecification";
var DayOfWeek2 = "https://schema.org/DayOfWeek";
var DaySpa2 = "https://schema.org/DaySpa";
var DeactivateAction2 = "https://schema.org/DeactivateAction";
var DefenceEstablishment2 = "https://schema.org/DefenceEstablishment";
var DefinedRegion2 = "https://schema.org/DefinedRegion";
var DefinedTerm2 = "https://schema.org/DefinedTerm";
var DefinedTermSet2 = "https://schema.org/DefinedTermSet";
var DeleteAction2 = "https://schema.org/DeleteAction";
var DeliveryChargeSpecification2 = "https://schema.org/DeliveryChargeSpecification";
var DeliveryEvent2 = "https://schema.org/DeliveryEvent";
var DeliveryMethod2 = "https://schema.org/DeliveryMethod";
var DeliveryTimeSettings2 = "https://schema.org/DeliveryTimeSettings";
var Demand2 = "https://schema.org/Demand";
var Dentist2 = "https://schema.org/Dentist";
var DepartAction2 = "https://schema.org/DepartAction";
var DepartmentStore2 = "https://schema.org/DepartmentStore";
var DepositAccount2 = "https://schema.org/DepositAccount";
var DiagnosticLab2 = "https://schema.org/DiagnosticLab";
var DiagnosticProcedure2 = "https://schema.org/DiagnosticProcedure";
var Diet2 = "https://schema.org/Diet";
var DietarySupplement2 = "https://schema.org/DietarySupplement";
var DigitalDocument2 = "https://schema.org/DigitalDocument";
var DigitalDocumentPermission2 = "https://schema.org/DigitalDocumentPermission";
var DigitalDocumentPermissionType2 = "https://schema.org/DigitalDocumentPermissionType";
var DigitalPlatformEnumeration2 = "https://schema.org/DigitalPlatformEnumeration";
var DisagreeAction2 = "https://schema.org/DisagreeAction";
var DiscoverAction2 = "https://schema.org/DiscoverAction";
var DiscussionForumPosting2 = "https://schema.org/DiscussionForumPosting";
var DislikeAction2 = "https://schema.org/DislikeAction";
var Distance3 = "https://schema.org/Distance";
var Distillery2 = "https://schema.org/Distillery";
var DonateAction2 = "https://schema.org/DonateAction";
var DoseSchedule2 = "https://schema.org/DoseSchedule";
var DownloadAction2 = "https://schema.org/DownloadAction";
var DrawAction2 = "https://schema.org/DrawAction";
var Drawing2 = "https://schema.org/Drawing";
var DrinkAction2 = "https://schema.org/DrinkAction";
var DriveWheelConfigurationValue2 = "https://schema.org/DriveWheelConfigurationValue";
var Drug2 = "https://schema.org/Drug";
var DrugClass2 = "https://schema.org/DrugClass";
var DrugCost2 = "https://schema.org/DrugCost";
var DrugCostCategory2 = "https://schema.org/DrugCostCategory";
var DrugLegalStatus2 = "https://schema.org/DrugLegalStatus";
var DrugPregnancyCategory2 = "https://schema.org/DrugPregnancyCategory";
var DrugPrescriptionStatus2 = "https://schema.org/DrugPrescriptionStatus";
var DrugStrength2 = "https://schema.org/DrugStrength";
var DryCleaningOrLaundry2 = "https://schema.org/DryCleaningOrLaundry";
var Duration3 = "https://schema.org/Duration";
var EUEnergyEfficiencyEnumeration2 = "https://schema.org/EUEnergyEfficiencyEnumeration";
var EatAction2 = "https://schema.org/EatAction";
var EducationEvent2 = "https://schema.org/EducationEvent";
var EducationalAudience2 = "https://schema.org/EducationalAudience";
var EducationalOccupationalCredential2 = "https://schema.org/EducationalOccupationalCredential";
var EducationalOccupationalProgram2 = "https://schema.org/EducationalOccupationalProgram";
var EducationalOrganization2 = "https://schema.org/EducationalOrganization";
var Electrician2 = "https://schema.org/Electrician";
var ElectronicsStore2 = "https://schema.org/ElectronicsStore";
var ElementarySchool2 = "https://schema.org/ElementarySchool";
var EmailMessage2 = "https://schema.org/EmailMessage";
var Embassy2 = "https://schema.org/Embassy";
var EmergencyService2 = "https://schema.org/EmergencyService";
var EmployeeRole2 = "https://schema.org/EmployeeRole";
var EmployerAggregateRating2 = "https://schema.org/EmployerAggregateRating";
var EmployerReview2 = "https://schema.org/EmployerReview";
var EmploymentAgency2 = "https://schema.org/EmploymentAgency";
var EndorseAction2 = "https://schema.org/EndorseAction";
var EndorsementRating2 = "https://schema.org/EndorsementRating";
var Energy2 = "https://schema.org/Energy";
var EnergyConsumptionDetails2 = "https://schema.org/EnergyConsumptionDetails";
var EnergyEfficiencyEnumeration2 = "https://schema.org/EnergyEfficiencyEnumeration";
var EnergyStarEnergyEfficiencyEnumeration2 = "https://schema.org/EnergyStarEnergyEfficiencyEnumeration";
var EngineSpecification2 = "https://schema.org/EngineSpecification";
var EntertainmentBusiness2 = "https://schema.org/EntertainmentBusiness";
var EntryPoint2 = "https://schema.org/EntryPoint";
var Enumeration2 = "https://schema.org/Enumeration";
var Episode2 = "https://schema.org/Episode";
var Event3 = "https://schema.org/Event";
var EventAttendanceModeEnumeration2 = "https://schema.org/EventAttendanceModeEnumeration";
var EventReservation2 = "https://schema.org/EventReservation";
var EventSeries2 = "https://schema.org/EventSeries";
var EventStatusType2 = "https://schema.org/EventStatusType";
var EventVenue2 = "https://schema.org/EventVenue";
var ExchangeRateSpecification2 = "https://schema.org/ExchangeRateSpecification";
var ExerciseAction2 = "https://schema.org/ExerciseAction";
var ExerciseGym2 = "https://schema.org/ExerciseGym";
var ExercisePlan2 = "https://schema.org/ExercisePlan";
var ExhibitionEvent2 = "https://schema.org/ExhibitionEvent";
var FAQPage2 = "https://schema.org/FAQPage";
var FMRadioChannel2 = "https://schema.org/FMRadioChannel";
var FastFoodRestaurant2 = "https://schema.org/FastFoodRestaurant";
var Festival2 = "https://schema.org/Festival";
var FilmAction2 = "https://schema.org/FilmAction";
var FinancialProduct2 = "https://schema.org/FinancialProduct";
var FinancialService2 = "https://schema.org/FinancialService";
var FindAction2 = "https://schema.org/FindAction";
var FireStation2 = "https://schema.org/FireStation";
var Flight2 = "https://schema.org/Flight";
var FlightReservation2 = "https://schema.org/FlightReservation";
var Float2 = "https://schema.org/Float";
var FloorPlan2 = "https://schema.org/FloorPlan";
var Florist2 = "https://schema.org/Florist";
var FollowAction2 = "https://schema.org/FollowAction";
var FoodEstablishment2 = "https://schema.org/FoodEstablishment";
var FoodEstablishmentReservation2 = "https://schema.org/FoodEstablishmentReservation";
var FoodEvent2 = "https://schema.org/FoodEvent";
var FoodService2 = "https://schema.org/FoodService";
var FundingAgency2 = "https://schema.org/FundingAgency";
var FundingScheme2 = "https://schema.org/FundingScheme";
var FurnitureStore2 = "https://schema.org/FurnitureStore";
var Game2 = "https://schema.org/Game";
var GameAvailabilityEnumeration2 = "https://schema.org/GameAvailabilityEnumeration";
var GamePlayMode2 = "https://schema.org/GamePlayMode";
var GameServer2 = "https://schema.org/GameServer";
var GameServerStatus2 = "https://schema.org/GameServerStatus";
var GardenStore2 = "https://schema.org/GardenStore";
var GasStation2 = "https://schema.org/GasStation";
var GatedResidenceCommunity2 = "https://schema.org/GatedResidenceCommunity";
var GenderType2 = "https://schema.org/GenderType";
var Gene2 = "https://schema.org/Gene";
var GeneralContractor2 = "https://schema.org/GeneralContractor";
var GeoCircle2 = "https://schema.org/GeoCircle";
var GeoCoordinates2 = "https://schema.org/GeoCoordinates";
var GeoShape2 = "https://schema.org/GeoShape";
var GeospatialGeometry2 = "https://schema.org/GeospatialGeometry";
var GiveAction2 = "https://schema.org/GiveAction";
var GolfCourse2 = "https://schema.org/GolfCourse";
var GovernmentBenefitsType2 = "https://schema.org/GovernmentBenefitsType";
var GovernmentBuilding2 = "https://schema.org/GovernmentBuilding";
var GovernmentOffice2 = "https://schema.org/GovernmentOffice";
var GovernmentOrganization2 = "https://schema.org/GovernmentOrganization";
var GovernmentPermit2 = "https://schema.org/GovernmentPermit";
var GovernmentService2 = "https://schema.org/GovernmentService";
var Grant2 = "https://schema.org/Grant";
var GroceryStore2 = "https://schema.org/GroceryStore";
var Guide2 = "https://schema.org/Guide";
var HVACBusiness2 = "https://schema.org/HVACBusiness";
var Hackathon2 = "https://schema.org/Hackathon";
var HairSalon2 = "https://schema.org/HairSalon";
var HardwareStore2 = "https://schema.org/HardwareStore";
var HealthAndBeautyBusiness2 = "https://schema.org/HealthAndBeautyBusiness";
var HealthAspectEnumeration2 = "https://schema.org/HealthAspectEnumeration";
var HealthClub2 = "https://schema.org/HealthClub";
var HealthInsurancePlan2 = "https://schema.org/HealthInsurancePlan";
var HealthPlanCostSharingSpecification2 = "https://schema.org/HealthPlanCostSharingSpecification";
var HealthPlanFormulary2 = "https://schema.org/HealthPlanFormulary";
var HealthPlanNetwork2 = "https://schema.org/HealthPlanNetwork";
var HealthTopicContent2 = "https://schema.org/HealthTopicContent";
var HighSchool2 = "https://schema.org/HighSchool";
var HinduTemple2 = "https://schema.org/HinduTemple";
var HobbyShop2 = "https://schema.org/HobbyShop";
var HomeAndConstructionBusiness2 = "https://schema.org/HomeAndConstructionBusiness";
var HomeGoodsStore2 = "https://schema.org/HomeGoodsStore";
var Hospital2 = "https://schema.org/Hospital";
var Hostel2 = "https://schema.org/Hostel";
var Hotel2 = "https://schema.org/Hotel";
var HotelRoom2 = "https://schema.org/HotelRoom";
var House2 = "https://schema.org/House";
var HousePainter2 = "https://schema.org/HousePainter";
var HowTo2 = "https://schema.org/HowTo";
var HowToDirection2 = "https://schema.org/HowToDirection";
var HowToItem2 = "https://schema.org/HowToItem";
var HowToSection2 = "https://schema.org/HowToSection";
var HowToStep2 = "https://schema.org/HowToStep";
var HowToSupply2 = "https://schema.org/HowToSupply";
var HowToTip2 = "https://schema.org/HowToTip";
var HowToTool2 = "https://schema.org/HowToTool";
var HyperToc2 = "https://schema.org/HyperToc";
var HyperTocEntry2 = "https://schema.org/HyperTocEntry";
var IceCreamShop2 = "https://schema.org/IceCreamShop";
var IgnoreAction2 = "https://schema.org/IgnoreAction";
var ImageGallery2 = "https://schema.org/ImageGallery";
var ImageObject2 = "https://schema.org/ImageObject";
var ImageObjectSnapshot2 = "https://schema.org/ImageObjectSnapshot";
var ImagingTest2 = "https://schema.org/ImagingTest";
var IndividualProduct2 = "https://schema.org/IndividualProduct";
var InfectiousAgentClass2 = "https://schema.org/InfectiousAgentClass";
var InfectiousDisease2 = "https://schema.org/InfectiousDisease";
var InformAction2 = "https://schema.org/InformAction";
var InsertAction2 = "https://schema.org/InsertAction";
var InstallAction2 = "https://schema.org/InstallAction";
var InsuranceAgency2 = "https://schema.org/InsuranceAgency";
var Intangible2 = "https://schema.org/Intangible";
var Integer2 = "https://schema.org/Integer";
var InteractAction2 = "https://schema.org/InteractAction";
var InteractionCounter2 = "https://schema.org/InteractionCounter";
var InternetCafe2 = "https://schema.org/InternetCafe";
var InvestmentFund2 = "https://schema.org/InvestmentFund";
var InvestmentOrDeposit2 = "https://schema.org/InvestmentOrDeposit";
var InviteAction2 = "https://schema.org/InviteAction";
var Invoice3 = "https://schema.org/Invoice";
var ItemAvailability2 = "https://schema.org/ItemAvailability";
var ItemList2 = "https://schema.org/ItemList";
var ItemListOrderType2 = "https://schema.org/ItemListOrderType";
var ItemPage2 = "https://schema.org/ItemPage";
var JewelryStore2 = "https://schema.org/JewelryStore";
var JobPosting2 = "https://schema.org/JobPosting";
var JoinAction2 = "https://schema.org/JoinAction";
var Joint2 = "https://schema.org/Joint";
var LakeBodyOfWater2 = "https://schema.org/LakeBodyOfWater";
var Landform2 = "https://schema.org/Landform";
var LandmarksOrHistoricalBuildings2 = "https://schema.org/LandmarksOrHistoricalBuildings";
var Language2 = "https://schema.org/Language";
var LearningResource2 = "https://schema.org/LearningResource";
var LeaveAction2 = "https://schema.org/LeaveAction";
var LegalForceStatus2 = "https://schema.org/LegalForceStatus";
var LegalService2 = "https://schema.org/LegalService";
var LegalValueLevel2 = "https://schema.org/LegalValueLevel";
var Legislation2 = "https://schema.org/Legislation";
var LegislationObject2 = "https://schema.org/LegislationObject";
var LegislativeBuilding2 = "https://schema.org/LegislativeBuilding";
var LendAction2 = "https://schema.org/LendAction";
var Library3 = "https://schema.org/Library";
var LibrarySystem2 = "https://schema.org/LibrarySystem";
var LifestyleModification2 = "https://schema.org/LifestyleModification";
var Ligament2 = "https://schema.org/Ligament";
var LikeAction2 = "https://schema.org/LikeAction";
var LinkRole2 = "https://schema.org/LinkRole";
var LiquorStore2 = "https://schema.org/LiquorStore";
var ListItem2 = "https://schema.org/ListItem";
var ListenAction2 = "https://schema.org/ListenAction";
var LiteraryEvent2 = "https://schema.org/LiteraryEvent";
var LiveBlogPosting2 = "https://schema.org/LiveBlogPosting";
var LoanOrCredit2 = "https://schema.org/LoanOrCredit";
var LocalBusiness2 = "https://schema.org/LocalBusiness";
var LocationFeatureSpecification2 = "https://schema.org/LocationFeatureSpecification";
var Locksmith2 = "https://schema.org/Locksmith";
var LodgingBusiness2 = "https://schema.org/LodgingBusiness";
var LodgingReservation2 = "https://schema.org/LodgingReservation";
var LoseAction2 = "https://schema.org/LoseAction";
var LymphaticVessel2 = "https://schema.org/LymphaticVessel";
var Manuscript2 = "https://schema.org/Manuscript";
var Map__workaround2 = "https://schema.org/Map";
var MapCategoryType2 = "https://schema.org/MapCategoryType";
var MarryAction2 = "https://schema.org/MarryAction";
var Mass2 = "https://schema.org/Mass";
var MathSolver2 = "https://schema.org/MathSolver";
var MaximumDoseSchedule2 = "https://schema.org/MaximumDoseSchedule";
var MeasurementMethodEnum2 = "https://schema.org/MeasurementMethodEnum";
var MeasurementTypeEnumeration2 = "https://schema.org/MeasurementTypeEnumeration";
var MediaGallery2 = "https://schema.org/MediaGallery";
var MediaManipulationRatingEnumeration2 = "https://schema.org/MediaManipulationRatingEnumeration";
var MediaObject2 = "https://schema.org/MediaObject";
var MediaReview2 = "https://schema.org/MediaReview";
var MediaReviewItem2 = "https://schema.org/MediaReviewItem";
var MediaSubscription2 = "https://schema.org/MediaSubscription";
var MedicalAudience2 = "https://schema.org/MedicalAudience";
var MedicalAudienceType2 = "https://schema.org/MedicalAudienceType";
var MedicalBusiness2 = "https://schema.org/MedicalBusiness";
var MedicalCause2 = "https://schema.org/MedicalCause";
var MedicalClinic2 = "https://schema.org/MedicalClinic";
var MedicalCode2 = "https://schema.org/MedicalCode";
var MedicalCondition2 = "https://schema.org/MedicalCondition";
var MedicalConditionStage2 = "https://schema.org/MedicalConditionStage";
var MedicalContraindication2 = "https://schema.org/MedicalContraindication";
var MedicalDevice2 = "https://schema.org/MedicalDevice";
var MedicalDevicePurpose2 = "https://schema.org/MedicalDevicePurpose";
var MedicalEntity2 = "https://schema.org/MedicalEntity";
var MedicalEnumeration2 = "https://schema.org/MedicalEnumeration";
var MedicalEvidenceLevel2 = "https://schema.org/MedicalEvidenceLevel";
var MedicalGuideline2 = "https://schema.org/MedicalGuideline";
var MedicalGuidelineContraindication2 = "https://schema.org/MedicalGuidelineContraindication";
var MedicalGuidelineRecommendation2 = "https://schema.org/MedicalGuidelineRecommendation";
var MedicalImagingTechnique2 = "https://schema.org/MedicalImagingTechnique";
var MedicalIndication2 = "https://schema.org/MedicalIndication";
var MedicalIntangible2 = "https://schema.org/MedicalIntangible";
var MedicalObservationalStudy2 = "https://schema.org/MedicalObservationalStudy";
var MedicalObservationalStudyDesign2 = "https://schema.org/MedicalObservationalStudyDesign";
var MedicalOrganization2 = "https://schema.org/MedicalOrganization";
var MedicalProcedure2 = "https://schema.org/MedicalProcedure";
var MedicalProcedureType2 = "https://schema.org/MedicalProcedureType";
var MedicalRiskCalculator2 = "https://schema.org/MedicalRiskCalculator";
var MedicalRiskEstimator2 = "https://schema.org/MedicalRiskEstimator";
var MedicalRiskFactor2 = "https://schema.org/MedicalRiskFactor";
var MedicalRiskScore2 = "https://schema.org/MedicalRiskScore";
var MedicalScholarlyArticle2 = "https://schema.org/MedicalScholarlyArticle";
var MedicalSign2 = "https://schema.org/MedicalSign";
var MedicalSignOrSymptom2 = "https://schema.org/MedicalSignOrSymptom";
var MedicalSpecialty2 = "https://schema.org/MedicalSpecialty";
var MedicalStudy2 = "https://schema.org/MedicalStudy";
var MedicalStudyStatus2 = "https://schema.org/MedicalStudyStatus";
var MedicalSymptom2 = "https://schema.org/MedicalSymptom";
var MedicalTest2 = "https://schema.org/MedicalTest";
var MedicalTestPanel2 = "https://schema.org/MedicalTestPanel";
var MedicalTherapy2 = "https://schema.org/MedicalTherapy";
var MedicalTrial2 = "https://schema.org/MedicalTrial";
var MedicalTrialDesign2 = "https://schema.org/MedicalTrialDesign";
var MedicalWebPage2 = "https://schema.org/MedicalWebPage";
var MedicineSystem2 = "https://schema.org/MedicineSystem";
var MeetingRoom2 = "https://schema.org/MeetingRoom";
var MensClothingStore2 = "https://schema.org/MensClothingStore";
var Menu2 = "https://schema.org/Menu";
var MenuItem2 = "https://schema.org/MenuItem";
var MenuSection2 = "https://schema.org/MenuSection";
var MerchantReturnEnumeration2 = "https://schema.org/MerchantReturnEnumeration";
var MerchantReturnPolicy2 = "https://schema.org/MerchantReturnPolicy";
var MerchantReturnPolicySeasonalOverride2 = "https://schema.org/MerchantReturnPolicySeasonalOverride";
var Message3 = "https://schema.org/Message";
var MiddleSchool2 = "https://schema.org/MiddleSchool";
var MobileApplication2 = "https://schema.org/MobileApplication";
var MobilePhoneStore2 = "https://schema.org/MobilePhoneStore";
var MolecularEntity2 = "https://schema.org/MolecularEntity";
var MonetaryAmount2 = "https://schema.org/MonetaryAmount";
var MonetaryAmountDistribution2 = "https://schema.org/MonetaryAmountDistribution";
var MonetaryGrant2 = "https://schema.org/MonetaryGrant";
var MoneyTransfer2 = "https://schema.org/MoneyTransfer";
var MortgageLoan2 = "https://schema.org/MortgageLoan";
var Mosque2 = "https://schema.org/Mosque";
var Motel2 = "https://schema.org/Motel";
var Motorcycle2 = "https://schema.org/Motorcycle";
var MotorcycleDealer2 = "https://schema.org/MotorcycleDealer";
var MotorcycleRepair2 = "https://schema.org/MotorcycleRepair";
var MotorizedBicycle2 = "https://schema.org/MotorizedBicycle";
var Mountain2 = "https://schema.org/Mountain";
var MoveAction2 = "https://schema.org/MoveAction";
var Movie2 = "https://schema.org/Movie";
var MovieClip2 = "https://schema.org/MovieClip";
var MovieRentalStore2 = "https://schema.org/MovieRentalStore";
var MovieSeries2 = "https://schema.org/MovieSeries";
var MovieTheater2 = "https://schema.org/MovieTheater";
var MovingCompany2 = "https://schema.org/MovingCompany";
var Muscle2 = "https://schema.org/Muscle";
var Museum2 = "https://schema.org/Museum";
var MusicAlbum2 = "https://schema.org/MusicAlbum";
var MusicAlbumProductionType2 = "https://schema.org/MusicAlbumProductionType";
var MusicAlbumReleaseType2 = "https://schema.org/MusicAlbumReleaseType";
var MusicComposition2 = "https://schema.org/MusicComposition";
var MusicEvent2 = "https://schema.org/MusicEvent";
var MusicGroup2 = "https://schema.org/MusicGroup";
var MusicPlaylist2 = "https://schema.org/MusicPlaylist";
var MusicRecording2 = "https://schema.org/MusicRecording";
var MusicRelease2 = "https://schema.org/MusicRelease";
var MusicReleaseFormatType2 = "https://schema.org/MusicReleaseFormatType";
var MusicStore2 = "https://schema.org/MusicStore";
var MusicVenue2 = "https://schema.org/MusicVenue";
var MusicVideoObject2 = "https://schema.org/MusicVideoObject";
var NGO2 = "https://schema.org/NGO";
var NLNonprofitType2 = "https://schema.org/NLNonprofitType";
var NailSalon2 = "https://schema.org/NailSalon";
var Nerve2 = "https://schema.org/Nerve";
var NewsArticle2 = "https://schema.org/NewsArticle";
var NewsMediaOrganization2 = "https://schema.org/NewsMediaOrganization";
var Newspaper2 = "https://schema.org/Newspaper";
var NightClub2 = "https://schema.org/NightClub";
var NonprofitType2 = "https://schema.org/NonprofitType";
var Notary2 = "https://schema.org/Notary";
var NoteDigitalDocument2 = "https://schema.org/NoteDigitalDocument";
var Number__workaround2 = "https://schema.org/Number";
var NutritionInformation2 = "https://schema.org/NutritionInformation";
var Observation3 = "https://schema.org/Observation";
var Occupation2 = "https://schema.org/Occupation";
var OccupationalExperienceRequirements2 = "https://schema.org/OccupationalExperienceRequirements";
var OccupationalTherapy2 = "https://schema.org/OccupationalTherapy";
var OceanBodyOfWater2 = "https://schema.org/OceanBodyOfWater";
var Offer3 = "https://schema.org/Offer";
var OfferCatalog2 = "https://schema.org/OfferCatalog";
var OfferForLease2 = "https://schema.org/OfferForLease";
var OfferForPurchase2 = "https://schema.org/OfferForPurchase";
var OfferItemCondition2 = "https://schema.org/OfferItemCondition";
var OfferShippingDetails2 = "https://schema.org/OfferShippingDetails";
var OfficeEquipmentStore2 = "https://schema.org/OfficeEquipmentStore";
var OnDemandEvent2 = "https://schema.org/OnDemandEvent";
var OnlineBusiness2 = "https://schema.org/OnlineBusiness";
var OnlineStore2 = "https://schema.org/OnlineStore";
var OpeningHoursSpecification2 = "https://schema.org/OpeningHoursSpecification";
var OpinionNewsArticle2 = "https://schema.org/OpinionNewsArticle";
var Optician2 = "https://schema.org/Optician";
var Order2 = "https://schema.org/Order";
var OrderAction2 = "https://schema.org/OrderAction";
var OrderItem2 = "https://schema.org/OrderItem";
var OrderStatus2 = "https://schema.org/OrderStatus";
var Organization5 = "https://schema.org/Organization";
var OrganizationRole2 = "https://schema.org/OrganizationRole";
var OrganizeAction2 = "https://schema.org/OrganizeAction";
var OutletStore2 = "https://schema.org/OutletStore";
var OwnershipInfo2 = "https://schema.org/OwnershipInfo";
var PaintAction2 = "https://schema.org/PaintAction";
var Painting2 = "https://schema.org/Painting";
var PalliativeProcedure2 = "https://schema.org/PalliativeProcedure";
var ParcelDelivery2 = "https://schema.org/ParcelDelivery";
var ParentAudience2 = "https://schema.org/ParentAudience";
var Park2 = "https://schema.org/Park";
var ParkingFacility2 = "https://schema.org/ParkingFacility";
var PathologyTest2 = "https://schema.org/PathologyTest";
var Patient3 = "https://schema.org/Patient";
var PawnShop2 = "https://schema.org/PawnShop";
var PayAction2 = "https://schema.org/PayAction";
var PaymentCard2 = "https://schema.org/PaymentCard";
var PaymentChargeSpecification2 = "https://schema.org/PaymentChargeSpecification";
var PaymentMethod2 = "https://schema.org/PaymentMethod";
var PaymentService2 = "https://schema.org/PaymentService";
var PaymentStatusType2 = "https://schema.org/PaymentStatusType";
var PeopleAudience2 = "https://schema.org/PeopleAudience";
var PerformAction2 = "https://schema.org/PerformAction";
var PerformanceRole2 = "https://schema.org/PerformanceRole";
var PerformingArtsTheater2 = "https://schema.org/PerformingArtsTheater";
var PerformingGroup2 = "https://schema.org/PerformingGroup";
var Periodical2 = "https://schema.org/Periodical";
var Permit2 = "https://schema.org/Permit";
var Person5 = "https://schema.org/Person";
var PetStore2 = "https://schema.org/PetStore";
var Pharmacy2 = "https://schema.org/Pharmacy";
var Photograph2 = "https://schema.org/Photograph";
var PhotographAction2 = "https://schema.org/PhotographAction";
var PhysicalActivity2 = "https://schema.org/PhysicalActivity";
var PhysicalActivityCategory2 = "https://schema.org/PhysicalActivityCategory";
var PhysicalExam2 = "https://schema.org/PhysicalExam";
var PhysicalTherapy2 = "https://schema.org/PhysicalTherapy";
var Physician2 = "https://schema.org/Physician";
var Place3 = "https://schema.org/Place";
var PlaceOfWorship2 = "https://schema.org/PlaceOfWorship";
var PlanAction2 = "https://schema.org/PlanAction";
var Play2 = "https://schema.org/Play";
var PlayAction2 = "https://schema.org/PlayAction";
var PlayGameAction2 = "https://schema.org/PlayGameAction";
var Playground2 = "https://schema.org/Playground";
var Plumber2 = "https://schema.org/Plumber";
var PodcastEpisode2 = "https://schema.org/PodcastEpisode";
var PodcastSeason2 = "https://schema.org/PodcastSeason";
var PodcastSeries2 = "https://schema.org/PodcastSeries";
var PoliceStation2 = "https://schema.org/PoliceStation";
var PoliticalParty2 = "https://schema.org/PoliticalParty";
var Pond2 = "https://schema.org/Pond";
var PostOffice2 = "https://schema.org/PostOffice";
var PostalAddress2 = "https://schema.org/PostalAddress";
var PostalCodeRangeSpecification2 = "https://schema.org/PostalCodeRangeSpecification";
var Poster2 = "https://schema.org/Poster";
var PreOrderAction2 = "https://schema.org/PreOrderAction";
var PrependAction2 = "https://schema.org/PrependAction";
var Preschool2 = "https://schema.org/Preschool";
var PresentationDigitalDocument2 = "https://schema.org/PresentationDigitalDocument";
var PreventionIndication2 = "https://schema.org/PreventionIndication";
var PriceComponentTypeEnumeration2 = "https://schema.org/PriceComponentTypeEnumeration";
var PriceSpecification2 = "https://schema.org/PriceSpecification";
var PriceTypeEnumeration2 = "https://schema.org/PriceTypeEnumeration";
var Product2 = "https://schema.org/Product";
var ProductCollection2 = "https://schema.org/ProductCollection";
var ProductGroup2 = "https://schema.org/ProductGroup";
var ProductModel2 = "https://schema.org/ProductModel";
var ProductReturnEnumeration2 = "https://schema.org/ProductReturnEnumeration";
var ProductReturnPolicy2 = "https://schema.org/ProductReturnPolicy";
var ProfessionalService2 = "https://schema.org/ProfessionalService";
var ProfilePage2 = "https://schema.org/ProfilePage";
var ProgramMembership2 = "https://schema.org/ProgramMembership";
var Project3 = "https://schema.org/Project";
var PronounceableText2 = "https://schema.org/PronounceableText";
var Property4 = "https://schema.org/Property";
var PropertyValue2 = "https://schema.org/PropertyValue";
var PropertyValueSpecification2 = "https://schema.org/PropertyValueSpecification";
var Protein2 = "https://schema.org/Protein";
var PsychologicalTreatment2 = "https://schema.org/PsychologicalTreatment";
var PublicSwimmingPool2 = "https://schema.org/PublicSwimmingPool";
var PublicToilet2 = "https://schema.org/PublicToilet";
var PublicationEvent2 = "https://schema.org/PublicationEvent";
var PublicationIssue2 = "https://schema.org/PublicationIssue";
var PublicationVolume2 = "https://schema.org/PublicationVolume";
var QAPage2 = "https://schema.org/QAPage";
var QualitativeValue2 = "https://schema.org/QualitativeValue";
var QuantitativeValue2 = "https://schema.org/QuantitativeValue";
var QuantitativeValueDistribution2 = "https://schema.org/QuantitativeValueDistribution";
var Quantity3 = "https://schema.org/Quantity";
var Question3 = "https://schema.org/Question";
var Quiz2 = "https://schema.org/Quiz";
var Quotation2 = "https://schema.org/Quotation";
var QuoteAction2 = "https://schema.org/QuoteAction";
var RVPark2 = "https://schema.org/RVPark";
var RadiationTherapy2 = "https://schema.org/RadiationTherapy";
var RadioBroadcastService2 = "https://schema.org/RadioBroadcastService";
var RadioChannel2 = "https://schema.org/RadioChannel";
var RadioClip2 = "https://schema.org/RadioClip";
var RadioEpisode2 = "https://schema.org/RadioEpisode";
var RadioSeason2 = "https://schema.org/RadioSeason";
var RadioSeries2 = "https://schema.org/RadioSeries";
var RadioStation2 = "https://schema.org/RadioStation";
var Rating2 = "https://schema.org/Rating";
var ReactAction2 = "https://schema.org/ReactAction";
var ReadAction2 = "https://schema.org/ReadAction";
var RealEstateAgent2 = "https://schema.org/RealEstateAgent";
var RealEstateListing2 = "https://schema.org/RealEstateListing";
var ReceiveAction2 = "https://schema.org/ReceiveAction";
var Recipe2 = "https://schema.org/Recipe";
var Recommendation2 = "https://schema.org/Recommendation";
var RecommendedDoseSchedule2 = "https://schema.org/RecommendedDoseSchedule";
var RecyclingCenter2 = "https://schema.org/RecyclingCenter";
var RefundTypeEnumeration2 = "https://schema.org/RefundTypeEnumeration";
var RegisterAction2 = "https://schema.org/RegisterAction";
var RejectAction2 = "https://schema.org/RejectAction";
var RentAction2 = "https://schema.org/RentAction";
var RentalCarReservation2 = "https://schema.org/RentalCarReservation";
var RepaymentSpecification2 = "https://schema.org/RepaymentSpecification";
var ReplaceAction2 = "https://schema.org/ReplaceAction";
var ReplyAction2 = "https://schema.org/ReplyAction";
var Report2 = "https://schema.org/Report";
var ReportageNewsArticle2 = "https://schema.org/ReportageNewsArticle";
var ReportedDoseSchedule2 = "https://schema.org/ReportedDoseSchedule";
var ResearchOrganization2 = "https://schema.org/ResearchOrganization";
var ResearchProject2 = "https://schema.org/ResearchProject";
var Researcher2 = "https://schema.org/Researcher";
var Reservation2 = "https://schema.org/Reservation";
var ReservationPackage2 = "https://schema.org/ReservationPackage";
var ReservationStatusType2 = "https://schema.org/ReservationStatusType";
var ReserveAction2 = "https://schema.org/ReserveAction";
var Reservoir2 = "https://schema.org/Reservoir";
var Residence2 = "https://schema.org/Residence";
var Resort2 = "https://schema.org/Resort";
var Restaurant2 = "https://schema.org/Restaurant";
var RestrictedDiet2 = "https://schema.org/RestrictedDiet";
var ResumeAction2 = "https://schema.org/ResumeAction";
var ReturnAction2 = "https://schema.org/ReturnAction";
var ReturnFeesEnumeration2 = "https://schema.org/ReturnFeesEnumeration";
var ReturnLabelSourceEnumeration2 = "https://schema.org/ReturnLabelSourceEnumeration";
var ReturnMethodEnumeration2 = "https://schema.org/ReturnMethodEnumeration";
var Review2 = "https://schema.org/Review";
var ReviewAction2 = "https://schema.org/ReviewAction";
var ReviewNewsArticle2 = "https://schema.org/ReviewNewsArticle";
var RiverBodyOfWater2 = "https://schema.org/RiverBodyOfWater";
var Role2 = "https://schema.org/Role";
var RoofingContractor2 = "https://schema.org/RoofingContractor";
var Room2 = "https://schema.org/Room";
var RsvpAction2 = "https://schema.org/RsvpAction";
var RsvpResponseType2 = "https://schema.org/RsvpResponseType";
var SaleEvent2 = "https://schema.org/SaleEvent";
var SatiricalArticle2 = "https://schema.org/SatiricalArticle";
var Schedule3 = "https://schema.org/Schedule";
var ScheduleAction2 = "https://schema.org/ScheduleAction";
var ScholarlyArticle2 = "https://schema.org/ScholarlyArticle";
var School2 = "https://schema.org/School";
var SchoolDistrict2 = "https://schema.org/SchoolDistrict";
var ScreeningEvent2 = "https://schema.org/ScreeningEvent";
var Sculpture2 = "https://schema.org/Sculpture";
var SeaBodyOfWater2 = "https://schema.org/SeaBodyOfWater";
var SearchAction2 = "https://schema.org/SearchAction";
var SearchRescueOrganization2 = "https://schema.org/SearchRescueOrganization";
var SearchResultsPage2 = "https://schema.org/SearchResultsPage";
var Season2 = "https://schema.org/Season";
var Seat2 = "https://schema.org/Seat";
var SeekToAction2 = "https://schema.org/SeekToAction";
var SelfStorage2 = "https://schema.org/SelfStorage";
var SellAction2 = "https://schema.org/SellAction";
var SendAction2 = "https://schema.org/SendAction";
var Series2 = "https://schema.org/Series";
var Service3 = "https://schema.org/Service";
var ServiceChannel2 = "https://schema.org/ServiceChannel";
var ShareAction2 = "https://schema.org/ShareAction";
var SheetMusic2 = "https://schema.org/SheetMusic";
var ShippingDeliveryTime2 = "https://schema.org/ShippingDeliveryTime";
var ShippingRateSettings2 = "https://schema.org/ShippingRateSettings";
var ShoeStore2 = "https://schema.org/ShoeStore";
var ShoppingCenter2 = "https://schema.org/ShoppingCenter";
var ShortStory2 = "https://schema.org/ShortStory";
var SingleFamilyResidence2 = "https://schema.org/SingleFamilyResidence";
var SiteNavigationElement2 = "https://schema.org/SiteNavigationElement";
var SizeGroupEnumeration2 = "https://schema.org/SizeGroupEnumeration";
var SizeSpecification2 = "https://schema.org/SizeSpecification";
var SizeSystemEnumeration2 = "https://schema.org/SizeSystemEnumeration";
var SkiResort2 = "https://schema.org/SkiResort";
var SocialEvent2 = "https://schema.org/SocialEvent";
var SocialMediaPosting2 = "https://schema.org/SocialMediaPosting";
var SoftwareApplication2 = "https://schema.org/SoftwareApplication";
var SoftwareSourceCode2 = "https://schema.org/SoftwareSourceCode";
var SolveMathAction2 = "https://schema.org/SolveMathAction";
var SomeProducts2 = "https://schema.org/SomeProducts";
var SpeakableSpecification2 = "https://schema.org/SpeakableSpecification";
var SpecialAnnouncement2 = "https://schema.org/SpecialAnnouncement";
var Specialty2 = "https://schema.org/Specialty";
var SportingGoodsStore2 = "https://schema.org/SportingGoodsStore";
var SportsActivityLocation2 = "https://schema.org/SportsActivityLocation";
var SportsClub2 = "https://schema.org/SportsClub";
var SportsEvent2 = "https://schema.org/SportsEvent";
var SportsOrganization2 = "https://schema.org/SportsOrganization";
var SportsTeam2 = "https://schema.org/SportsTeam";
var SpreadsheetDigitalDocument2 = "https://schema.org/SpreadsheetDigitalDocument";
var StadiumOrArena2 = "https://schema.org/StadiumOrArena";
var State2 = "https://schema.org/State";
var Statement3 = "https://schema.org/Statement";
var StatisticalPopulation2 = "https://schema.org/StatisticalPopulation";
var StatisticalVariable2 = "https://schema.org/StatisticalVariable";
var StatusEnumeration2 = "https://schema.org/StatusEnumeration";
var SteeringPositionValue2 = "https://schema.org/SteeringPositionValue";
var Store3 = "https://schema.org/Store";
var StructuredValue2 = "https://schema.org/StructuredValue";
var StupidType2 = "https://schema.org/StupidType";
var SubscribeAction2 = "https://schema.org/SubscribeAction";
var Substance3 = "https://schema.org/Substance";
var SubwayStation2 = "https://schema.org/SubwayStation";
var Suite2 = "https://schema.org/Suite";
var SuperficialAnatomy2 = "https://schema.org/SuperficialAnatomy";
var SurgicalProcedure2 = "https://schema.org/SurgicalProcedure";
var SuspendAction2 = "https://schema.org/SuspendAction";
var Syllabus2 = "https://schema.org/Syllabus";
var Synagogue2 = "https://schema.org/Synagogue";
var TVClip2 = "https://schema.org/TVClip";
var TVEpisode2 = "https://schema.org/TVEpisode";
var TVSeason2 = "https://schema.org/TVSeason";
var TVSeries2 = "https://schema.org/TVSeries";
var Table2 = "https://schema.org/Table";
var TakeAction2 = "https://schema.org/TakeAction";
var TattooParlor2 = "https://schema.org/TattooParlor";
var Taxi2 = "https://schema.org/Taxi";
var TaxiReservation2 = "https://schema.org/TaxiReservation";
var TaxiService2 = "https://schema.org/TaxiService";
var TaxiStand2 = "https://schema.org/TaxiStand";
var Taxon2 = "https://schema.org/Taxon";
var TechArticle2 = "https://schema.org/TechArticle";
var TelevisionChannel2 = "https://schema.org/TelevisionChannel";
var TelevisionStation2 = "https://schema.org/TelevisionStation";
var TennisComplex2 = "https://schema.org/TennisComplex";
var Text2 = "https://schema.org/Text";
var TextDigitalDocument2 = "https://schema.org/TextDigitalDocument";
var TextObject2 = "https://schema.org/TextObject";
var TheaterEvent2 = "https://schema.org/TheaterEvent";
var TheaterGroup2 = "https://schema.org/TheaterGroup";
var TherapeuticProcedure2 = "https://schema.org/TherapeuticProcedure";
var Thesis2 = "https://schema.org/Thesis";
var Thing4 = "https://schema.org/Thing";
var Ticket2 = "https://schema.org/Ticket";
var TieAction2 = "https://schema.org/TieAction";
var Time2 = "https://schema.org/Time";
var TipAction2 = "https://schema.org/TipAction";
var TireShop2 = "https://schema.org/TireShop";
var TouristAttraction2 = "https://schema.org/TouristAttraction";
var TouristDestination2 = "https://schema.org/TouristDestination";
var TouristInformationCenter2 = "https://schema.org/TouristInformationCenter";
var TouristTrip2 = "https://schema.org/TouristTrip";
var ToyStore2 = "https://schema.org/ToyStore";
var TrackAction2 = "https://schema.org/TrackAction";
var TradeAction2 = "https://schema.org/TradeAction";
var TrainReservation2 = "https://schema.org/TrainReservation";
var TrainStation2 = "https://schema.org/TrainStation";
var TrainTrip2 = "https://schema.org/TrainTrip";
var TransferAction2 = "https://schema.org/TransferAction";
var TravelAction2 = "https://schema.org/TravelAction";
var TravelAgency2 = "https://schema.org/TravelAgency";
var TreatmentIndication2 = "https://schema.org/TreatmentIndication";
var Trip3 = "https://schema.org/Trip";
var TypeAndQuantityNode2 = "https://schema.org/TypeAndQuantityNode";
var UKNonprofitType2 = "https://schema.org/UKNonprofitType";
var URL3 = "https://schema.org/URL";
var USNonprofitType2 = "https://schema.org/USNonprofitType";
var UnRegisterAction2 = "https://schema.org/UnRegisterAction";
var UnitPriceSpecification2 = "https://schema.org/UnitPriceSpecification";
var UpdateAction2 = "https://schema.org/UpdateAction";
var UseAction2 = "https://schema.org/UseAction";
var UserBlocks2 = "https://schema.org/UserBlocks";
var UserCheckins2 = "https://schema.org/UserCheckins";
var UserComments2 = "https://schema.org/UserComments";
var UserDownloads2 = "https://schema.org/UserDownloads";
var UserInteraction2 = "https://schema.org/UserInteraction";
var UserLikes2 = "https://schema.org/UserLikes";
var UserPageVisits2 = "https://schema.org/UserPageVisits";
var UserPlays2 = "https://schema.org/UserPlays";
var UserPlusOnes2 = "https://schema.org/UserPlusOnes";
var UserReview2 = "https://schema.org/UserReview";
var UserTweets2 = "https://schema.org/UserTweets";
var VacationRental2 = "https://schema.org/VacationRental";
var Vehicle2 = "https://schema.org/Vehicle";
var Vein2 = "https://schema.org/Vein";
var Vessel2 = "https://schema.org/Vessel";
var VeterinaryCare2 = "https://schema.org/VeterinaryCare";
var VideoGallery2 = "https://schema.org/VideoGallery";
var VideoGame2 = "https://schema.org/VideoGame";
var VideoGameClip2 = "https://schema.org/VideoGameClip";
var VideoGameSeries2 = "https://schema.org/VideoGameSeries";
var VideoObject2 = "https://schema.org/VideoObject";
var VideoObjectSnapshot2 = "https://schema.org/VideoObjectSnapshot";
var ViewAction2 = "https://schema.org/ViewAction";
var VirtualLocation2 = "https://schema.org/VirtualLocation";
var VisualArtsEvent2 = "https://schema.org/VisualArtsEvent";
var VisualArtwork2 = "https://schema.org/VisualArtwork";
var VitalSign2 = "https://schema.org/VitalSign";
var Volcano2 = "https://schema.org/Volcano";
var VoteAction2 = "https://schema.org/VoteAction";
var WPAdBlock2 = "https://schema.org/WPAdBlock";
var WPFooter2 = "https://schema.org/WPFooter";
var WPHeader2 = "https://schema.org/WPHeader";
var WPSideBar2 = "https://schema.org/WPSideBar";
var WantAction2 = "https://schema.org/WantAction";
var WarrantyPromise2 = "https://schema.org/WarrantyPromise";
var WarrantyScope2 = "https://schema.org/WarrantyScope";
var WatchAction2 = "https://schema.org/WatchAction";
var Waterfall2 = "https://schema.org/Waterfall";
var WearAction2 = "https://schema.org/WearAction";
var WearableMeasurementTypeEnumeration2 = "https://schema.org/WearableMeasurementTypeEnumeration";
var WearableSizeGroupEnumeration2 = "https://schema.org/WearableSizeGroupEnumeration";
var WearableSizeSystemEnumeration2 = "https://schema.org/WearableSizeSystemEnumeration";
var WebAPI2 = "https://schema.org/WebAPI";
var WebApplication2 = "https://schema.org/WebApplication";
var WebContent2 = "https://schema.org/WebContent";
var WebPage2 = "https://schema.org/WebPage";
var WebPageElement2 = "https://schema.org/WebPageElement";
var WebSite2 = "https://schema.org/WebSite";
var WholesaleStore2 = "https://schema.org/WholesaleStore";
var WinAction2 = "https://schema.org/WinAction";
var Winery2 = "https://schema.org/Winery";
var WorkBasedProgram2 = "https://schema.org/WorkBasedProgram";
var WorkersUnion2 = "https://schema.org/WorkersUnion";
var WriteAction2 = "https://schema.org/WriteAction";
var XPathType2 = "https://schema.org/XPathType";
var Zoo2 = "https://schema.org/Zoo";
var abridged2 = "https://schema.org/abridged";
var abstract4 = "https://schema.org/abstract";
var accelerationTime2 = "https://schema.org/accelerationTime";
var acceptedAnswer2 = "https://schema.org/acceptedAnswer";
var acceptedOffer2 = "https://schema.org/acceptedOffer";
var acceptedPaymentMethod2 = "https://schema.org/acceptedPaymentMethod";
var acceptsReservations2 = "https://schema.org/acceptsReservations";
var accessCode2 = "https://schema.org/accessCode";
var accessMode2 = "https://schema.org/accessMode";
var accessModeSufficient2 = "https://schema.org/accessModeSufficient";
var accessibilityAPI2 = "https://schema.org/accessibilityAPI";
var accessibilityControl2 = "https://schema.org/accessibilityControl";
var accessibilityFeature2 = "https://schema.org/accessibilityFeature";
var accessibilityHazard2 = "https://schema.org/accessibilityHazard";
var accessibilitySummary2 = "https://schema.org/accessibilitySummary";
var accommodationCategory2 = "https://schema.org/accommodationCategory";
var accommodationFloorPlan2 = "https://schema.org/accommodationFloorPlan";
var accountId2 = "https://schema.org/accountId";
var accountMinimumInflow2 = "https://schema.org/accountMinimumInflow";
var accountOverdraftLimit2 = "https://schema.org/accountOverdraftLimit";
var accountablePerson2 = "https://schema.org/accountablePerson";
var acquireLicensePage2 = "https://schema.org/acquireLicensePage";
var acquiredFrom2 = "https://schema.org/acquiredFrom";
var acrissCode2 = "https://schema.org/acrissCode";
var actionAccessibilityRequirement2 = "https://schema.org/actionAccessibilityRequirement";
var actionPlatform2 = "https://schema.org/actionPlatform";
var actionStatus2 = "https://schema.org/actionStatus";
var actionableFeedbackPolicy2 = "https://schema.org/actionableFeedbackPolicy";
var activeIngredient2 = "https://schema.org/activeIngredient";
var activityDuration2 = "https://schema.org/activityDuration";
var activityFrequency2 = "https://schema.org/activityFrequency";
var actors2 = "https://schema.org/actors";
var addOn2 = "https://schema.org/addOn";
var additionalName2 = "https://schema.org/additionalName";
var additionalNumberOfGuests2 = "https://schema.org/additionalNumberOfGuests";
var additionalProperty2 = "https://schema.org/additionalProperty";
var additionalType2 = "https://schema.org/additionalType";
var additionalVariable2 = "https://schema.org/additionalVariable";
var address4 = "https://schema.org/address";
var addressCountry2 = "https://schema.org/addressCountry";
var addressLocality2 = "https://schema.org/addressLocality";
var addressRegion2 = "https://schema.org/addressRegion";
var administrationRoute2 = "https://schema.org/administrationRoute";
var advanceBookingRequirement2 = "https://schema.org/advanceBookingRequirement";
var adverseOutcome2 = "https://schema.org/adverseOutcome";
var affectedBy2 = "https://schema.org/affectedBy";
var affiliation3 = "https://schema.org/affiliation";
var afterMedia2 = "https://schema.org/afterMedia";
var agent4 = "https://schema.org/agent";
var aggregateRating2 = "https://schema.org/aggregateRating";
var aircraft2 = "https://schema.org/aircraft";
var albumProductionType2 = "https://schema.org/albumProductionType";
var albumReleaseType2 = "https://schema.org/albumReleaseType";
var albums2 = "https://schema.org/albums";
var alcoholWarning2 = "https://schema.org/alcoholWarning";
var algorithm2 = "https://schema.org/algorithm";
var alignmentType2 = "https://schema.org/alignmentType";
var alternativeHeadline2 = "https://schema.org/alternativeHeadline";
var alternativeOf2 = "https://schema.org/alternativeOf";
var amenityFeature2 = "https://schema.org/amenityFeature";
var amount4 = "https://schema.org/amount";
var amountOfThisGood2 = "https://schema.org/amountOfThisGood";
var announcementLocation2 = "https://schema.org/announcementLocation";
var annualPercentageRate2 = "https://schema.org/annualPercentageRate";
var answerCount2 = "https://schema.org/answerCount";
var answerExplanation2 = "https://schema.org/answerExplanation";
var antagonist2 = "https://schema.org/antagonist";
var appearance2 = "https://schema.org/appearance";
var applicableCountry2 = "https://schema.org/applicableCountry";
var applicableLocation2 = "https://schema.org/applicableLocation";
var applicantLocationRequirements2 = "https://schema.org/applicantLocationRequirements";
var application3 = "https://schema.org/application";
var applicationCategory2 = "https://schema.org/applicationCategory";
var applicationContact2 = "https://schema.org/applicationContact";
var applicationDeadline2 = "https://schema.org/applicationDeadline";
var applicationStartDate2 = "https://schema.org/applicationStartDate";
var applicationSubCategory2 = "https://schema.org/applicationSubCategory";
var applicationSuite2 = "https://schema.org/applicationSuite";
var appliesToDeliveryMethod2 = "https://schema.org/appliesToDeliveryMethod";
var appliesToPaymentMethod2 = "https://schema.org/appliesToPaymentMethod";
var archivedAt2 = "https://schema.org/archivedAt";
var area2 = "https://schema.org/area";
var arrivalAirport2 = "https://schema.org/arrivalAirport";
var arrivalBoatTerminal2 = "https://schema.org/arrivalBoatTerminal";
var arrivalBusStop2 = "https://schema.org/arrivalBusStop";
var arrivalGate2 = "https://schema.org/arrivalGate";
var arrivalPlatform2 = "https://schema.org/arrivalPlatform";
var arrivalStation2 = "https://schema.org/arrivalStation";
var arrivalTerminal2 = "https://schema.org/arrivalTerminal";
var arrivalTime2 = "https://schema.org/arrivalTime";
var artEdition2 = "https://schema.org/artEdition";
var artMedium2 = "https://schema.org/artMedium";
var artform2 = "https://schema.org/artform";
var articleBody2 = "https://schema.org/articleBody";
var articleSection2 = "https://schema.org/articleSection";
var artist2 = "https://schema.org/artist";
var asin2 = "https://schema.org/asin";
var aspect2 = "https://schema.org/aspect";
var assembly2 = "https://schema.org/assembly";
var assemblyVersion2 = "https://schema.org/assemblyVersion";
var assesses2 = "https://schema.org/assesses";
var associatedAnatomy2 = "https://schema.org/associatedAnatomy";
var associatedArticle2 = "https://schema.org/associatedArticle";
var associatedClaimReview2 = "https://schema.org/associatedClaimReview";
var associatedDisease2 = "https://schema.org/associatedDisease";
var associatedMedia2 = "https://schema.org/associatedMedia";
var associatedMediaReview2 = "https://schema.org/associatedMediaReview";
var associatedPathophysiology2 = "https://schema.org/associatedPathophysiology";
var athlete2 = "https://schema.org/athlete";
var attendees2 = "https://schema.org/attendees";
var audienceType2 = "https://schema.org/audienceType";
var audio2 = "https://schema.org/audio";
var authenticator2 = "https://schema.org/authenticator";
var author4 = "https://schema.org/author";
var availability3 = "https://schema.org/availability";
var availabilityEnds2 = "https://schema.org/availabilityEnds";
var availabilityStarts2 = "https://schema.org/availabilityStarts";
var availableAtOrFrom2 = "https://schema.org/availableAtOrFrom";
var availableChannel2 = "https://schema.org/availableChannel";
var availableDeliveryMethod2 = "https://schema.org/availableDeliveryMethod";
var availableFrom2 = "https://schema.org/availableFrom";
var availableIn2 = "https://schema.org/availableIn";
var availableLanguage2 = "https://schema.org/availableLanguage";
var availableService2 = "https://schema.org/availableService";
var availableStrength2 = "https://schema.org/availableStrength";
var availableTest2 = "https://schema.org/availableTest";
var availableThrough2 = "https://schema.org/availableThrough";
var awards2 = "https://schema.org/awards";
var awayTeam2 = "https://schema.org/awayTeam";
var backstory2 = "https://schema.org/backstory";
var bankAccountType2 = "https://schema.org/bankAccountType";
var baseSalary2 = "https://schema.org/baseSalary";
var bccRecipient2 = "https://schema.org/bccRecipient";
var bed2 = "https://schema.org/bed";
var beforeMedia2 = "https://schema.org/beforeMedia";
var beneficiaryBank2 = "https://schema.org/beneficiaryBank";
var benefits2 = "https://schema.org/benefits";
var benefitsSummaryUrl2 = "https://schema.org/benefitsSummaryUrl";
var bestRating2 = "https://schema.org/bestRating";
var billingAddress2 = "https://schema.org/billingAddress";
var billingDuration2 = "https://schema.org/billingDuration";
var billingIncrement2 = "https://schema.org/billingIncrement";
var billingPeriod2 = "https://schema.org/billingPeriod";
var billingStart2 = "https://schema.org/billingStart";
var bioChemInteraction2 = "https://schema.org/bioChemInteraction";
var bioChemSimilarity2 = "https://schema.org/bioChemSimilarity";
var biologicalRole2 = "https://schema.org/biologicalRole";
var biomechnicalClass2 = "https://schema.org/biomechnicalClass";
var birthDate3 = "https://schema.org/birthDate";
var birthPlace2 = "https://schema.org/birthPlace";
var bitrate2 = "https://schema.org/bitrate";
var blogPosts2 = "https://schema.org/blogPosts";
var bloodSupply2 = "https://schema.org/bloodSupply";
var boardingGroup2 = "https://schema.org/boardingGroup";
var boardingPolicy2 = "https://schema.org/boardingPolicy";
var bodyLocation2 = "https://schema.org/bodyLocation";
var bodyType2 = "https://schema.org/bodyType";
var bookEdition2 = "https://schema.org/bookEdition";
var bookFormat2 = "https://schema.org/bookFormat";
var bookingAgent2 = "https://schema.org/bookingAgent";
var bookingTime2 = "https://schema.org/bookingTime";
var borrower2 = "https://schema.org/borrower";
var box2 = "https://schema.org/box";
var branch2 = "https://schema.org/branch";
var branchCode2 = "https://schema.org/branchCode";
var branchOf2 = "https://schema.org/branchOf";
var brand3 = "https://schema.org/brand";
var breadcrumb2 = "https://schema.org/breadcrumb";
var breastfeedingWarning2 = "https://schema.org/breastfeedingWarning";
var broadcastAffiliateOf2 = "https://schema.org/broadcastAffiliateOf";
var broadcastChannelId2 = "https://schema.org/broadcastChannelId";
var broadcastDisplayName2 = "https://schema.org/broadcastDisplayName";
var broadcastFrequency2 = "https://schema.org/broadcastFrequency";
var broadcastFrequencyValue2 = "https://schema.org/broadcastFrequencyValue";
var broadcastOfEvent2 = "https://schema.org/broadcastOfEvent";
var broadcastServiceTier2 = "https://schema.org/broadcastServiceTier";
var broadcastSignalModulation2 = "https://schema.org/broadcastSignalModulation";
var broadcastSubChannel2 = "https://schema.org/broadcastSubChannel";
var broadcastTimezone2 = "https://schema.org/broadcastTimezone";
var broadcaster2 = "https://schema.org/broadcaster";
var browserRequirements2 = "https://schema.org/browserRequirements";
var busName2 = "https://schema.org/busName";
var busNumber2 = "https://schema.org/busNumber";
var businessDays2 = "https://schema.org/businessDays";
var businessFunction2 = "https://schema.org/businessFunction";
var buyer2 = "https://schema.org/buyer";
var byArtist2 = "https://schema.org/byArtist";
var byDay2 = "https://schema.org/byDay";
var byMonth2 = "https://schema.org/byMonth";
var byMonthDay2 = "https://schema.org/byMonthDay";
var byMonthWeek2 = "https://schema.org/byMonthWeek";
var callSign2 = "https://schema.org/callSign";
var calories2 = "https://schema.org/calories";
var candidate3 = "https://schema.org/candidate";
var carbohydrateContent2 = "https://schema.org/carbohydrateContent";
var cargoVolume2 = "https://schema.org/cargoVolume";
var carrier2 = "https://schema.org/carrier";
var carrierRequirements2 = "https://schema.org/carrierRequirements";
var cashBack2 = "https://schema.org/cashBack";
var catalog2 = "https://schema.org/catalog";
var catalogNumber2 = "https://schema.org/catalogNumber";
var causeOf2 = "https://schema.org/causeOf";
var ccRecipient2 = "https://schema.org/ccRecipient";
var character2 = "https://schema.org/character";
var characterAttribute2 = "https://schema.org/characterAttribute";
var characterName2 = "https://schema.org/characterName";
var cheatCode2 = "https://schema.org/cheatCode";
var checkinTime2 = "https://schema.org/checkinTime";
var checkoutPageURLTemplate2 = "https://schema.org/checkoutPageURLTemplate";
var checkoutTime2 = "https://schema.org/checkoutTime";
var chemicalComposition2 = "https://schema.org/chemicalComposition";
var chemicalRole2 = "https://schema.org/chemicalRole";
var childMaxAge2 = "https://schema.org/childMaxAge";
var childMinAge2 = "https://schema.org/childMinAge";
var children2 = "https://schema.org/children";
var cholesterolContent2 = "https://schema.org/cholesterolContent";
var circle2 = "https://schema.org/circle";
var citation3 = "https://schema.org/citation";
var claimInterpreter2 = "https://schema.org/claimInterpreter";
var claimReviewed2 = "https://schema.org/claimReviewed";
var clincalPharmacology2 = "https://schema.org/clincalPharmacology";
var clipNumber2 = "https://schema.org/clipNumber";
var closes2 = "https://schema.org/closes";
var coach2 = "https://schema.org/coach";
var code3 = "https://schema.org/code";
var codeRepository2 = "https://schema.org/codeRepository";
var codeValue2 = "https://schema.org/codeValue";
var codingSystem2 = "https://schema.org/codingSystem";
var colleagues2 = "https://schema.org/colleagues";
var collection4 = "https://schema.org/collection";
var collectionSize2 = "https://schema.org/collectionSize";
var color3 = "https://schema.org/color";
var colorist2 = "https://schema.org/colorist";
var comment5 = "https://schema.org/comment";
var commentCount2 = "https://schema.org/commentCount";
var commentText2 = "https://schema.org/commentText";
var commentTime2 = "https://schema.org/commentTime";
var competencyRequired2 = "https://schema.org/competencyRequired";
var composer2 = "https://schema.org/composer";
var comprisedOf3 = "https://schema.org/comprisedOf";
var conditionsOfAccess2 = "https://schema.org/conditionsOfAccess";
var confirmationNumber2 = "https://schema.org/confirmationNumber";
var connectedTo2 = "https://schema.org/connectedTo";
var constraintProperty2 = "https://schema.org/constraintProperty";
var contactOption2 = "https://schema.org/contactOption";
var contactPoints2 = "https://schema.org/contactPoints";
var contactType2 = "https://schema.org/contactType";
var contactlessPayment2 = "https://schema.org/contactlessPayment";
var containedIn2 = "https://schema.org/containedIn";
var contentRating2 = "https://schema.org/contentRating";
var contentReferenceTime2 = "https://schema.org/contentReferenceTime";
var contentSize2 = "https://schema.org/contentSize";
var contentType3 = "https://schema.org/contentType";
var contentUrl2 = "https://schema.org/contentUrl";
var contraindication3 = "https://schema.org/contraindication";
var contributor5 = "https://schema.org/contributor";
var cookTime2 = "https://schema.org/cookTime";
var cookingMethod2 = "https://schema.org/cookingMethod";
var copyrightHolder2 = "https://schema.org/copyrightHolder";
var copyrightNotice2 = "https://schema.org/copyrightNotice";
var copyrightYear2 = "https://schema.org/copyrightYear";
var correction2 = "https://schema.org/correction";
var correctionsPolicy2 = "https://schema.org/correctionsPolicy";
var costCategory2 = "https://schema.org/costCategory";
var costCurrency2 = "https://schema.org/costCurrency";
var costOrigin2 = "https://schema.org/costOrigin";
var costPerUnit2 = "https://schema.org/costPerUnit";
var countriesNotSupported2 = "https://schema.org/countriesNotSupported";
var countriesSupported2 = "https://schema.org/countriesSupported";
var countryOfAssembly2 = "https://schema.org/countryOfAssembly";
var countryOfLastProcessing2 = "https://schema.org/countryOfLastProcessing";
var countryOfOrigin3 = "https://schema.org/countryOfOrigin";
var course2 = "https://schema.org/course";
var courseCode2 = "https://schema.org/courseCode";
var courseMode2 = "https://schema.org/courseMode";
var coursePrerequisites2 = "https://schema.org/coursePrerequisites";
var courseSchedule2 = "https://schema.org/courseSchedule";
var courseWorkload2 = "https://schema.org/courseWorkload";
var coverageEndTime2 = "https://schema.org/coverageEndTime";
var coverageStartTime2 = "https://schema.org/coverageStartTime";
var creativeWorkStatus2 = "https://schema.org/creativeWorkStatus";
var credentialCategory2 = "https://schema.org/credentialCategory";
var creditText2 = "https://schema.org/creditText";
var creditedTo2 = "https://schema.org/creditedTo";
var cssSelector2 = "https://schema.org/cssSelector";
var currenciesAccepted2 = "https://schema.org/currenciesAccepted";
var currency3 = "https://schema.org/currency";
var currentExchangeRate2 = "https://schema.org/currentExchangeRate";
var customer2 = "https://schema.org/customer";
var customerRemorseReturnFees2 = "https://schema.org/customerRemorseReturnFees";
var customerRemorseReturnLabelSource2 = "https://schema.org/customerRemorseReturnLabelSource";
var customerRemorseReturnShippingFeesAmount2 = "https://schema.org/customerRemorseReturnShippingFeesAmount";
var cutoffTime2 = "https://schema.org/cutoffTime";
var cvdCollectionDate2 = "https://schema.org/cvdCollectionDate";
var cvdFacilityCounty2 = "https://schema.org/cvdFacilityCounty";
var cvdFacilityId2 = "https://schema.org/cvdFacilityId";
var cvdNumBeds2 = "https://schema.org/cvdNumBeds";
var cvdNumBedsOcc2 = "https://schema.org/cvdNumBedsOcc";
var cvdNumC19Died2 = "https://schema.org/cvdNumC19Died";
var cvdNumC19HOPats2 = "https://schema.org/cvdNumC19HOPats";
var cvdNumC19HospPats2 = "https://schema.org/cvdNumC19HospPats";
var cvdNumC19MechVentPats2 = "https://schema.org/cvdNumC19MechVentPats";
var cvdNumC19OFMechVentPats2 = "https://schema.org/cvdNumC19OFMechVentPats";
var cvdNumC19OverflowPats2 = "https://schema.org/cvdNumC19OverflowPats";
var cvdNumICUBeds2 = "https://schema.org/cvdNumICUBeds";
var cvdNumICUBedsOcc2 = "https://schema.org/cvdNumICUBedsOcc";
var cvdNumTotBeds2 = "https://schema.org/cvdNumTotBeds";
var cvdNumVent2 = "https://schema.org/cvdNumVent";
var cvdNumVentUse2 = "https://schema.org/cvdNumVentUse";
var dataFeedElement2 = "https://schema.org/dataFeedElement";
var datasetTimeInterval2 = "https://schema.org/datasetTimeInterval";
var dateDeleted2 = "https://schema.org/dateDeleted";
var dateIssued2 = "https://schema.org/dateIssued";
var dateModified2 = "https://schema.org/dateModified";
var datePosted2 = "https://schema.org/datePosted";
var datePublished2 = "https://schema.org/datePublished";
var dateRead2 = "https://schema.org/dateRead";
var dateReceived2 = "https://schema.org/dateReceived";
var dateSent2 = "https://schema.org/dateSent";
var dateVehicleFirstRegistered2 = "https://schema.org/dateVehicleFirstRegistered";
var dateline2 = "https://schema.org/dateline";
var dayOfWeek3 = "https://schema.org/dayOfWeek";
var deathDate2 = "https://schema.org/deathDate";
var deathPlace2 = "https://schema.org/deathPlace";
var defaultValue3 = "https://schema.org/defaultValue";
var deliveryAddress2 = "https://schema.org/deliveryAddress";
var deliveryLeadTime2 = "https://schema.org/deliveryLeadTime";
var deliveryMethod2 = "https://schema.org/deliveryMethod";
var deliveryStatus2 = "https://schema.org/deliveryStatus";
var deliveryTime2 = "https://schema.org/deliveryTime";
var department2 = "https://schema.org/department";
var departureAirport2 = "https://schema.org/departureAirport";
var departureBoatTerminal2 = "https://schema.org/departureBoatTerminal";
var departureBusStop2 = "https://schema.org/departureBusStop";
var departureGate2 = "https://schema.org/departureGate";
var departurePlatform2 = "https://schema.org/departurePlatform";
var departureStation2 = "https://schema.org/departureStation";
var departureTerminal2 = "https://schema.org/departureTerminal";
var departureTime2 = "https://schema.org/departureTime";
var dependencies2 = "https://schema.org/dependencies";
var depth2 = "https://schema.org/depth";
var device3 = "https://schema.org/device";
var diagnosis3 = "https://schema.org/diagnosis";
var diagram2 = "https://schema.org/diagram";
var diet2 = "https://schema.org/diet";
var dietFeatures2 = "https://schema.org/dietFeatures";
var differentialDiagnosis2 = "https://schema.org/differentialDiagnosis";
var directApply2 = "https://schema.org/directApply";
var directors2 = "https://schema.org/directors";
var disambiguatingDescription2 = "https://schema.org/disambiguatingDescription";
var discount2 = "https://schema.org/discount";
var discountCode2 = "https://schema.org/discountCode";
var discountCurrency2 = "https://schema.org/discountCurrency";
var discusses2 = "https://schema.org/discusses";
var discussionUrl2 = "https://schema.org/discussionUrl";
var diseasePreventionInfo2 = "https://schema.org/diseasePreventionInfo";
var diseaseSpreadStatistics2 = "https://schema.org/diseaseSpreadStatistics";
var dissolutionDate2 = "https://schema.org/dissolutionDate";
var distance2 = "https://schema.org/distance";
var distinguishingSign2 = "https://schema.org/distinguishingSign";
var distribution2 = "https://schema.org/distribution";
var diversityPolicy2 = "https://schema.org/diversityPolicy";
var diversityStaffingReport2 = "https://schema.org/diversityStaffingReport";
var documentation3 = "https://schema.org/documentation";
var doesNotShip2 = "https://schema.org/doesNotShip";
var domainIncludes2 = "https://schema.org/domainIncludes";
var domiciledMortgage2 = "https://schema.org/domiciledMortgage";
var doorTime2 = "https://schema.org/doorTime";
var dosageForm2 = "https://schema.org/dosageForm";
var doseSchedule2 = "https://schema.org/doseSchedule";
var doseUnit2 = "https://schema.org/doseUnit";
var doseValue2 = "https://schema.org/doseValue";
var downPayment2 = "https://schema.org/downPayment";
var downloadUrl2 = "https://schema.org/downloadUrl";
var downvoteCount2 = "https://schema.org/downvoteCount";
var drainsTo2 = "https://schema.org/drainsTo";
var driveWheelConfiguration2 = "https://schema.org/driveWheelConfiguration";
var dropoffLocation2 = "https://schema.org/dropoffLocation";
var dropoffTime2 = "https://schema.org/dropoffTime";
var drug2 = "https://schema.org/drug";
var drugClass2 = "https://schema.org/drugClass";
var drugUnit2 = "https://schema.org/drugUnit";
var duns2 = "https://schema.org/duns";
var duplicateTherapy2 = "https://schema.org/duplicateTherapy";
var durationOfWarranty2 = "https://schema.org/durationOfWarranty";
var duringMedia2 = "https://schema.org/duringMedia";
var earlyPrepaymentPenalty2 = "https://schema.org/earlyPrepaymentPenalty";
var editEIDR2 = "https://schema.org/editEIDR";
var editor3 = "https://schema.org/editor";
var eduQuestionType2 = "https://schema.org/eduQuestionType";
var educationRequirements2 = "https://schema.org/educationRequirements";
var educationalAlignment2 = "https://schema.org/educationalAlignment";
var educationalCredentialAwarded2 = "https://schema.org/educationalCredentialAwarded";
var educationalFramework2 = "https://schema.org/educationalFramework";
var educationalLevel2 = "https://schema.org/educationalLevel";
var educationalProgramMode2 = "https://schema.org/educationalProgramMode";
var educationalRole2 = "https://schema.org/educationalRole";
var educationalUse2 = "https://schema.org/educationalUse";
var elevation2 = "https://schema.org/elevation";
var eligibilityToWorkRequirement2 = "https://schema.org/eligibilityToWorkRequirement";
var eligibleCustomerType2 = "https://schema.org/eligibleCustomerType";
var eligibleDuration2 = "https://schema.org/eligibleDuration";
var eligibleQuantity2 = "https://schema.org/eligibleQuantity";
var eligibleRegion2 = "https://schema.org/eligibleRegion";
var eligibleTransactionVolume2 = "https://schema.org/eligibleTransactionVolume";
var email2 = "https://schema.org/email";
var embedUrl2 = "https://schema.org/embedUrl";
var embeddedTextCaption2 = "https://schema.org/embeddedTextCaption";
var emissionsCO22 = "https://schema.org/emissionsCO2";
var employees2 = "https://schema.org/employees";
var employerOverview2 = "https://schema.org/employerOverview";
var employmentType2 = "https://schema.org/employmentType";
var employmentUnit2 = "https://schema.org/employmentUnit";
var encodingType2 = "https://schema.org/encodingType";
var encodings2 = "https://schema.org/encodings";
var endDate3 = "https://schema.org/endDate";
var endOffset2 = "https://schema.org/endOffset";
var endTime3 = "https://schema.org/endTime";
var endorsee2 = "https://schema.org/endorsee";
var endorsers2 = "https://schema.org/endorsers";
var energyEfficiencyScaleMax2 = "https://schema.org/energyEfficiencyScaleMax";
var energyEfficiencyScaleMin2 = "https://schema.org/energyEfficiencyScaleMin";
var engineDisplacement2 = "https://schema.org/engineDisplacement";
var enginePower2 = "https://schema.org/enginePower";
var engineType2 = "https://schema.org/engineType";
var entertainmentBusiness2 = "https://schema.org/entertainmentBusiness";
var epidemiology2 = "https://schema.org/epidemiology";
var episodeNumber2 = "https://schema.org/episodeNumber";
var episodes2 = "https://schema.org/episodes";
var equal2 = "https://schema.org/equal";
var error3 = "https://schema.org/error";
var estimatedCost2 = "https://schema.org/estimatedCost";
var estimatedFlightDuration2 = "https://schema.org/estimatedFlightDuration";
var estimatedSalary2 = "https://schema.org/estimatedSalary";
var estimatesRiskOf2 = "https://schema.org/estimatesRiskOf";
var ethicsPolicy2 = "https://schema.org/ethicsPolicy";
var eventAttendanceMode2 = "https://schema.org/eventAttendanceMode";
var eventSchedule2 = "https://schema.org/eventSchedule";
var eventStatus2 = "https://schema.org/eventStatus";
var events2 = "https://schema.org/events";
var evidenceLevel2 = "https://schema.org/evidenceLevel";
var evidenceOrigin2 = "https://schema.org/evidenceOrigin";
var exceptDate2 = "https://schema.org/exceptDate";
var exchangeRateSpread2 = "https://schema.org/exchangeRateSpread";
var exercisePlan2 = "https://schema.org/exercisePlan";
var exerciseRelatedDiet2 = "https://schema.org/exerciseRelatedDiet";
var exerciseType2 = "https://schema.org/exerciseType";
var exifData2 = "https://schema.org/exifData";
var expectedArrivalFrom2 = "https://schema.org/expectedArrivalFrom";
var expectedArrivalUntil2 = "https://schema.org/expectedArrivalUntil";
var expectedPrognosis2 = "https://schema.org/expectedPrognosis";
var expectsAcceptanceOf2 = "https://schema.org/expectsAcceptanceOf";
var experienceInPlaceOfEducation2 = "https://schema.org/experienceInPlaceOfEducation";
var experienceRequirements2 = "https://schema.org/experienceRequirements";
var expertConsiderations2 = "https://schema.org/expertConsiderations";
var expires2 = "https://schema.org/expires";
var expressedIn2 = "https://schema.org/expressedIn";
var familyName2 = "https://schema.org/familyName";
var fatContent2 = "https://schema.org/fatContent";
var faxNumber2 = "https://schema.org/faxNumber";
var featureList2 = "https://schema.org/featureList";
var feesAndCommissionsSpecification2 = "https://schema.org/feesAndCommissionsSpecification";
var fiberContent2 = "https://schema.org/fiberContent";
var fileFormat2 = "https://schema.org/fileFormat";
var fileSize2 = "https://schema.org/fileSize";
var financialAidEligible2 = "https://schema.org/financialAidEligible";
var firstAppearance2 = "https://schema.org/firstAppearance";
var firstPerformance2 = "https://schema.org/firstPerformance";
var flightDistance2 = "https://schema.org/flightDistance";
var flightNumber2 = "https://schema.org/flightNumber";
var floorLevel2 = "https://schema.org/floorLevel";
var floorLimit2 = "https://schema.org/floorLimit";
var floorSize2 = "https://schema.org/floorSize";
var followee2 = "https://schema.org/followee";
var follows2 = "https://schema.org/follows";
var followup2 = "https://schema.org/followup";
var foodEstablishment2 = "https://schema.org/foodEstablishment";
var foodEvent2 = "https://schema.org/foodEvent";
var foodWarning2 = "https://schema.org/foodWarning";
var founders2 = "https://schema.org/founders";
var foundingDate2 = "https://schema.org/foundingDate";
var foundingLocation2 = "https://schema.org/foundingLocation";
var free2 = "https://schema.org/free";
var freeShippingThreshold2 = "https://schema.org/freeShippingThreshold";
var fromLocation2 = "https://schema.org/fromLocation";
var fuelCapacity2 = "https://schema.org/fuelCapacity";
var fuelConsumption2 = "https://schema.org/fuelConsumption";
var fuelEfficiency2 = "https://schema.org/fuelEfficiency";
var fuelType2 = "https://schema.org/fuelType";
var functionalClass2 = "https://schema.org/functionalClass";
var funder3 = "https://schema.org/funder";
var gameAvailabilityType2 = "https://schema.org/gameAvailabilityType";
var gameEdition2 = "https://schema.org/gameEdition";
var gameItem2 = "https://schema.org/gameItem";
var gameLocation2 = "https://schema.org/gameLocation";
var gamePlatform2 = "https://schema.org/gamePlatform";
var gameTip2 = "https://schema.org/gameTip";
var gender4 = "https://schema.org/gender";
var geo3 = "https://schema.org/geo";
var geoContains2 = "https://schema.org/geoContains";
var geoCoveredBy2 = "https://schema.org/geoCoveredBy";
var geoCovers2 = "https://schema.org/geoCovers";
var geoCrosses2 = "https://schema.org/geoCrosses";
var geoDisjoint2 = "https://schema.org/geoDisjoint";
var geoEquals2 = "https://schema.org/geoEquals";
var geoIntersects2 = "https://schema.org/geoIntersects";
var geoMidpoint2 = "https://schema.org/geoMidpoint";
var geoOverlaps2 = "https://schema.org/geoOverlaps";
var geoRadius2 = "https://schema.org/geoRadius";
var geoTouches2 = "https://schema.org/geoTouches";
var geoWithin2 = "https://schema.org/geoWithin";
var geographicArea2 = "https://schema.org/geographicArea";
var gettingTestedInfo2 = "https://schema.org/gettingTestedInfo";
var givenName2 = "https://schema.org/givenName";
var globalLocationNumber2 = "https://schema.org/globalLocationNumber";
var governmentBenefitsInfo2 = "https://schema.org/governmentBenefitsInfo";
var gracePeriod2 = "https://schema.org/gracePeriod";
var grantee3 = "https://schema.org/grantee";
var greater2 = "https://schema.org/greater";
var greaterOrEqual2 = "https://schema.org/greaterOrEqual";
var gtin122 = "https://schema.org/gtin12";
var gtin132 = "https://schema.org/gtin13";
var gtin142 = "https://schema.org/gtin14";
var gtin82 = "https://schema.org/gtin8";
var guideline3 = "https://schema.org/guideline";
var guidelineDate2 = "https://schema.org/guidelineDate";
var guidelineSubject2 = "https://schema.org/guidelineSubject";
var handlingTime2 = "https://schema.org/handlingTime";
var hasAdultConsideration2 = "https://schema.org/hasAdultConsideration";
var hasBioPolymerSequence2 = "https://schema.org/hasBioPolymerSequence";
var hasCategoryCode2 = "https://schema.org/hasCategoryCode";
var hasCourse2 = "https://schema.org/hasCourse";
var hasCourseInstance2 = "https://schema.org/hasCourseInstance";
var hasCredential2 = "https://schema.org/hasCredential";
var hasDeliveryMethod2 = "https://schema.org/hasDeliveryMethod";
var hasDigitalDocumentPermission2 = "https://schema.org/hasDigitalDocumentPermission";
var hasDriveThroughService2 = "https://schema.org/hasDriveThroughService";
var hasEnergyConsumptionDetails2 = "https://schema.org/hasEnergyConsumptionDetails";
var hasEnergyEfficiencyCategory2 = "https://schema.org/hasEnergyEfficiencyCategory";
var hasHealthAspect2 = "https://schema.org/hasHealthAspect";
var hasMeasurement2 = "https://schema.org/hasMeasurement";
var hasMenuItem2 = "https://schema.org/hasMenuItem";
var hasMenuSection2 = "https://schema.org/hasMenuSection";
var hasMolecularFunction2 = "https://schema.org/hasMolecularFunction";
var hasOccupation2 = "https://schema.org/hasOccupation";
var hasOfferCatalog2 = "https://schema.org/hasOfferCatalog";
var hasPOS2 = "https://schema.org/hasPOS";
var hasProductReturnPolicy2 = "https://schema.org/hasProductReturnPolicy";
var headline2 = "https://schema.org/headline";
var healthCondition2 = "https://schema.org/healthCondition";
var healthPlanCoinsuranceOption2 = "https://schema.org/healthPlanCoinsuranceOption";
var healthPlanCoinsuranceRate2 = "https://schema.org/healthPlanCoinsuranceRate";
var healthPlanCopay2 = "https://schema.org/healthPlanCopay";
var healthPlanCopayOption2 = "https://schema.org/healthPlanCopayOption";
var healthPlanCostSharing2 = "https://schema.org/healthPlanCostSharing";
var healthPlanDrugOption2 = "https://schema.org/healthPlanDrugOption";
var healthPlanDrugTier2 = "https://schema.org/healthPlanDrugTier";
var healthPlanId2 = "https://schema.org/healthPlanId";
var healthPlanMarketingUrl2 = "https://schema.org/healthPlanMarketingUrl";
var healthPlanNetworkId2 = "https://schema.org/healthPlanNetworkId";
var healthPlanNetworkTier2 = "https://schema.org/healthPlanNetworkTier";
var healthPlanPharmacyCategory2 = "https://schema.org/healthPlanPharmacyCategory";
var healthcareReportingData2 = "https://schema.org/healthcareReportingData";
var height4 = "https://schema.org/height";
var highPrice2 = "https://schema.org/highPrice";
var hiringOrganization2 = "https://schema.org/hiringOrganization";
var homeLocation2 = "https://schema.org/homeLocation";
var homeTeam2 = "https://schema.org/homeTeam";
var honorificPrefix2 = "https://schema.org/honorificPrefix";
var honorificSuffix2 = "https://schema.org/honorificSuffix";
var hospitalAffiliation2 = "https://schema.org/hospitalAffiliation";
var hostingOrganization2 = "https://schema.org/hostingOrganization";
var hoursAvailable2 = "https://schema.org/hoursAvailable";
var howPerformed2 = "https://schema.org/howPerformed";
var httpMethod2 = "https://schema.org/httpMethod";
var iataCode2 = "https://schema.org/iataCode";
var icaoCode2 = "https://schema.org/icaoCode";
var identifyingExam2 = "https://schema.org/identifyingExam";
var identifyingTest2 = "https://schema.org/identifyingTest";
var illustrator2 = "https://schema.org/illustrator";
var imagingTechnique2 = "https://schema.org/imagingTechnique";
var inAlbum2 = "https://schema.org/inAlbum";
var inBroadcastLineup2 = "https://schema.org/inBroadcastLineup";
var inChI2 = "https://schema.org/inChI";
var inChIKey2 = "https://schema.org/inChIKey";
var inCodeSet2 = "https://schema.org/inCodeSet";
var inPlaylist2 = "https://schema.org/inPlaylist";
var inProductGroupWithID2 = "https://schema.org/inProductGroupWithID";
var inStoreReturnsOffered2 = "https://schema.org/inStoreReturnsOffered";
var inSupportOf2 = "https://schema.org/inSupportOf";
var incentives2 = "https://schema.org/incentives";
var includedComposition2 = "https://schema.org/includedComposition";
var includedDataCatalog2 = "https://schema.org/includedDataCatalog";
var includedInHealthInsurancePlan2 = "https://schema.org/includedInHealthInsurancePlan";
var includedRiskFactor2 = "https://schema.org/includedRiskFactor";
var includesAttraction2 = "https://schema.org/includesAttraction";
var includesHealthPlanFormulary2 = "https://schema.org/includesHealthPlanFormulary";
var includesHealthPlanNetwork2 = "https://schema.org/includesHealthPlanNetwork";
var includesObject2 = "https://schema.org/includesObject";
var increasesRiskOf2 = "https://schema.org/increasesRiskOf";
var industry2 = "https://schema.org/industry";
var ineligibleRegion2 = "https://schema.org/ineligibleRegion";
var infectiousAgent2 = "https://schema.org/infectiousAgent";
var infectiousAgentClass2 = "https://schema.org/infectiousAgentClass";
var ingredients2 = "https://schema.org/ingredients";
var inker2 = "https://schema.org/inker";
var insertion2 = "https://schema.org/insertion";
var installUrl2 = "https://schema.org/installUrl";
var instructor2 = "https://schema.org/instructor";
var intensity2 = "https://schema.org/intensity";
var interactingDrug2 = "https://schema.org/interactingDrug";
var interactionCount2 = "https://schema.org/interactionCount";
var interactionService2 = "https://schema.org/interactionService";
var interactionType2 = "https://schema.org/interactionType";
var interactivityType2 = "https://schema.org/interactivityType";
var interestRate2 = "https://schema.org/interestRate";
var interpretedAsClaim2 = "https://schema.org/interpretedAsClaim";
var inventoryLevel2 = "https://schema.org/inventoryLevel";
var inverseOf3 = "https://schema.org/inverseOf";
var isAcceptingNewPatients2 = "https://schema.org/isAcceptingNewPatients";
var isAccessoryOrSparePartFor2 = "https://schema.org/isAccessoryOrSparePartFor";
var isAvailableGenerically2 = "https://schema.org/isAvailableGenerically";
var isBasedOnUrl2 = "https://schema.org/isBasedOnUrl";
var isConsumableFor2 = "https://schema.org/isConsumableFor";
var isFamilyFriendly2 = "https://schema.org/isFamilyFriendly";
var isGift2 = "https://schema.org/isGift";
var isInvolvedInBiologicalProcess2 = "https://schema.org/isInvolvedInBiologicalProcess";
var isLiveBroadcast2 = "https://schema.org/isLiveBroadcast";
var isLocatedInSubcellularLocation2 = "https://schema.org/isLocatedInSubcellularLocation";
var isPlanForApartment2 = "https://schema.org/isPlanForApartment";
var isProprietary2 = "https://schema.org/isProprietary";
var isRelatedTo2 = "https://schema.org/isRelatedTo";
var isResizable2 = "https://schema.org/isResizable";
var isSimilarTo2 = "https://schema.org/isSimilarTo";
var isUnlabelledFallback2 = "https://schema.org/isUnlabelledFallback";
var isbn2 = "https://schema.org/isbn";
var isicV42 = "https://schema.org/isicV4";
var iso6523Code2 = "https://schema.org/iso6523Code";
var isrcCode2 = "https://schema.org/isrcCode";
var issn2 = "https://schema.org/issn";
var issueNumber2 = "https://schema.org/issueNumber";
var issuedBy2 = "https://schema.org/issuedBy";
var issuedThrough2 = "https://schema.org/issuedThrough";
var iswcCode2 = "https://schema.org/iswcCode";
var item3 = "https://schema.org/item";
var itemCondition2 = "https://schema.org/itemCondition";
var itemDefectReturnFees2 = "https://schema.org/itemDefectReturnFees";
var itemDefectReturnLabelSource2 = "https://schema.org/itemDefectReturnLabelSource";
var itemDefectReturnShippingFeesAmount2 = "https://schema.org/itemDefectReturnShippingFeesAmount";
var itemListElement2 = "https://schema.org/itemListElement";
var itemListOrder2 = "https://schema.org/itemListOrder";
var itemLocation2 = "https://schema.org/itemLocation";
var itemReviewed2 = "https://schema.org/itemReviewed";
var itemShipped2 = "https://schema.org/itemShipped";
var itinerary2 = "https://schema.org/itinerary";
var iupacName2 = "https://schema.org/iupacName";
var jobImmediateStart2 = "https://schema.org/jobImmediateStart";
var jobLocation2 = "https://schema.org/jobLocation";
var jobLocationType2 = "https://schema.org/jobLocationType";
var jobStartDate2 = "https://schema.org/jobStartDate";
var jobTitle2 = "https://schema.org/jobTitle";
var keywords2 = "https://schema.org/keywords";
var knownVehicleDamages2 = "https://schema.org/knownVehicleDamages";
var knows3 = "https://schema.org/knows";
var knowsAbout2 = "https://schema.org/knowsAbout";
var knowsLanguage2 = "https://schema.org/knowsLanguage";
var labelDetails2 = "https://schema.org/labelDetails";
var landlord2 = "https://schema.org/landlord";
var language6 = "https://schema.org/language";
var lastReviewed2 = "https://schema.org/lastReviewed";
var latitude4 = "https://schema.org/latitude";
var layoutImage2 = "https://schema.org/layoutImage";
var learningResourceType2 = "https://schema.org/learningResourceType";
var leaseLength2 = "https://schema.org/leaseLength";
var legalName2 = "https://schema.org/legalName";
var legalStatus2 = "https://schema.org/legalStatus";
var legislationChanges2 = "https://schema.org/legislationChanges";
var legislationConsolidates2 = "https://schema.org/legislationConsolidates";
var legislationDate2 = "https://schema.org/legislationDate";
var legislationDateVersion2 = "https://schema.org/legislationDateVersion";
var legislationIdentifier2 = "https://schema.org/legislationIdentifier";
var legislationJurisdiction2 = "https://schema.org/legislationJurisdiction";
var legislationLegalForce2 = "https://schema.org/legislationLegalForce";
var legislationLegalValue2 = "https://schema.org/legislationLegalValue";
var legislationPassedBy2 = "https://schema.org/legislationPassedBy";
var legislationResponsible2 = "https://schema.org/legislationResponsible";
var legislationTransposes2 = "https://schema.org/legislationTransposes";
var legislationType2 = "https://schema.org/legislationType";
var leiCode2 = "https://schema.org/leiCode";
var lender2 = "https://schema.org/lender";
var lesser2 = "https://schema.org/lesser";
var lesserOrEqual2 = "https://schema.org/lesserOrEqual";
var letterer2 = "https://schema.org/letterer";
var license4 = "https://schema.org/license";
var line3 = "https://schema.org/line";
var linkRelationship2 = "https://schema.org/linkRelationship";
var liveBlogUpdate2 = "https://schema.org/liveBlogUpdate";
var loanMortgageMandateAmount2 = "https://schema.org/loanMortgageMandateAmount";
var loanPaymentAmount2 = "https://schema.org/loanPaymentAmount";
var loanPaymentFrequency2 = "https://schema.org/loanPaymentFrequency";
var loanRepaymentForm2 = "https://schema.org/loanRepaymentForm";
var loanTerm2 = "https://schema.org/loanTerm";
var loanType2 = "https://schema.org/loanType";
var locationCreated2 = "https://schema.org/locationCreated";
var lodgingUnitDescription2 = "https://schema.org/lodgingUnitDescription";
var lodgingUnitType2 = "https://schema.org/lodgingUnitType";
var logo3 = "https://schema.org/logo";
var longitude4 = "https://schema.org/longitude";
var loser2 = "https://schema.org/loser";
var lowPrice2 = "https://schema.org/lowPrice";
var lyricist2 = "https://schema.org/lyricist";
var lyrics2 = "https://schema.org/lyrics";
var maintainer2 = "https://schema.org/maintainer";
var manufacturer3 = "https://schema.org/manufacturer";
var map4 = "https://schema.org/map";
var mapType2 = "https://schema.org/mapType";
var maps2 = "https://schema.org/maps";
var marginOfError2 = "https://schema.org/marginOfError";
var masthead2 = "https://schema.org/masthead";
var materialExtent2 = "https://schema.org/materialExtent";
var mathExpression2 = "https://schema.org/mathExpression";
var maxPrice2 = "https://schema.org/maxPrice";
var maxValue3 = "https://schema.org/maxValue";
var maximumAttendeeCapacity2 = "https://schema.org/maximumAttendeeCapacity";
var maximumEnrollment2 = "https://schema.org/maximumEnrollment";
var maximumIntake2 = "https://schema.org/maximumIntake";
var maximumPhysicalAttendeeCapacity2 = "https://schema.org/maximumPhysicalAttendeeCapacity";
var maximumVirtualAttendeeCapacity2 = "https://schema.org/maximumVirtualAttendeeCapacity";
var mealService2 = "https://schema.org/mealService";
var measuredProperty2 = "https://schema.org/measuredProperty";
var measurementDenominator2 = "https://schema.org/measurementDenominator";
var measurementMethod2 = "https://schema.org/measurementMethod";
var measurementQualifier2 = "https://schema.org/measurementQualifier";
var mechanismOfAction2 = "https://schema.org/mechanismOfAction";
var mediaAuthenticityCategory2 = "https://schema.org/mediaAuthenticityCategory";
var mediaItemAppearance2 = "https://schema.org/mediaItemAppearance";
var median2 = "https://schema.org/median";
var medicalAudience2 = "https://schema.org/medicalAudience";
var medicalSpecialty2 = "https://schema.org/medicalSpecialty";
var medicineSystem2 = "https://schema.org/medicineSystem";
var meetsEmissionStandard2 = "https://schema.org/meetsEmissionStandard";
var members3 = "https://schema.org/members";
var membershipNumber2 = "https://schema.org/membershipNumber";
var membershipPointsEarned2 = "https://schema.org/membershipPointsEarned";
var memoryRequirements2 = "https://schema.org/memoryRequirements";
var mentions2 = "https://schema.org/mentions";
var menu2 = "https://schema.org/menu";
var menuAddOn2 = "https://schema.org/menuAddOn";
var merchant2 = "https://schema.org/merchant";
var messageAttachment2 = "https://schema.org/messageAttachment";
var mileageFromOdometer2 = "https://schema.org/mileageFromOdometer";
var minPrice2 = "https://schema.org/minPrice";
var minValue3 = "https://schema.org/minValue";
var minimumPaymentDue2 = "https://schema.org/minimumPaymentDue";
var missionCoveragePrioritiesPolicy2 = "https://schema.org/missionCoveragePrioritiesPolicy";
var mobileUrl2 = "https://schema.org/mobileUrl";
var model2 = "https://schema.org/model";
var modelDate2 = "https://schema.org/modelDate";
var modifiedTime2 = "https://schema.org/modifiedTime";
var molecularFormula3 = "https://schema.org/molecularFormula";
var molecularWeight3 = "https://schema.org/molecularWeight";
var monoisotopicMolecularWeight2 = "https://schema.org/monoisotopicMolecularWeight";
var monthlyMinimumRepaymentAmount2 = "https://schema.org/monthlyMinimumRepaymentAmount";
var monthsOfExperience2 = "https://schema.org/monthsOfExperience";
var mpn2 = "https://schema.org/mpn";
var multipleValues2 = "https://schema.org/multipleValues";
var muscleAction2 = "https://schema.org/muscleAction";
var musicArrangement2 = "https://schema.org/musicArrangement";
var musicBy2 = "https://schema.org/musicBy";
var musicCompositionForm2 = "https://schema.org/musicCompositionForm";
var musicGroupMember2 = "https://schema.org/musicGroupMember";
var musicReleaseFormat2 = "https://schema.org/musicReleaseFormat";
var musicalKey2 = "https://schema.org/musicalKey";
var naics2 = "https://schema.org/naics";
var name5 = "https://schema.org/name";
var namedPosition2 = "https://schema.org/namedPosition";
var nationality2 = "https://schema.org/nationality";
var naturalProgression2 = "https://schema.org/naturalProgression";
var negativeNotes2 = "https://schema.org/negativeNotes";
var nerve2 = "https://schema.org/nerve";
var nerveMotor2 = "https://schema.org/nerveMotor";
var netWorth2 = "https://schema.org/netWorth";
var newsUpdatesAndGuidelines2 = "https://schema.org/newsUpdatesAndGuidelines";
var nextItem2 = "https://schema.org/nextItem";
var noBylinesPolicy2 = "https://schema.org/noBylinesPolicy";
var nonEqual2 = "https://schema.org/nonEqual";
var nonProprietaryName2 = "https://schema.org/nonProprietaryName";
var nonprofitStatus2 = "https://schema.org/nonprofitStatus";
var normalRange2 = "https://schema.org/normalRange";
var nsn2 = "https://schema.org/nsn";
var numAdults2 = "https://schema.org/numAdults";
var numChildren2 = "https://schema.org/numChildren";
var numConstraints2 = "https://schema.org/numConstraints";
var numTracks2 = "https://schema.org/numTracks";
var numberOfAccommodationUnits2 = "https://schema.org/numberOfAccommodationUnits";
var numberOfAirbags2 = "https://schema.org/numberOfAirbags";
var numberOfAvailableAccommodationUnits2 = "https://schema.org/numberOfAvailableAccommodationUnits";
var numberOfAxles2 = "https://schema.org/numberOfAxles";
var numberOfBathroomsTotal2 = "https://schema.org/numberOfBathroomsTotal";
var numberOfBedrooms2 = "https://schema.org/numberOfBedrooms";
var numberOfBeds2 = "https://schema.org/numberOfBeds";
var numberOfCredits2 = "https://schema.org/numberOfCredits";
var numberOfDoors2 = "https://schema.org/numberOfDoors";
var numberOfEmployees2 = "https://schema.org/numberOfEmployees";
var numberOfEpisodes2 = "https://schema.org/numberOfEpisodes";
var numberOfForwardGears2 = "https://schema.org/numberOfForwardGears";
var numberOfFullBathrooms2 = "https://schema.org/numberOfFullBathrooms";
var numberOfItems2 = "https://schema.org/numberOfItems";
var numberOfLoanPayments2 = "https://schema.org/numberOfLoanPayments";
var numberOfPages2 = "https://schema.org/numberOfPages";
var numberOfPartialBathrooms2 = "https://schema.org/numberOfPartialBathrooms";
var numberOfPlayers2 = "https://schema.org/numberOfPlayers";
var numberOfPreviousOwners2 = "https://schema.org/numberOfPreviousOwners";
var numberOfRooms2 = "https://schema.org/numberOfRooms";
var numberOfSeasons2 = "https://schema.org/numberOfSeasons";
var numberedPosition2 = "https://schema.org/numberedPosition";
var nutrition2 = "https://schema.org/nutrition";
var observationAbout2 = "https://schema.org/observationAbout";
var observationDate2 = "https://schema.org/observationDate";
var observationPeriod2 = "https://schema.org/observationPeriod";
var occupancy2 = "https://schema.org/occupancy";
var occupationLocation2 = "https://schema.org/occupationLocation";
var occupationalCategory2 = "https://schema.org/occupationalCategory";
var occupationalCredentialAwarded2 = "https://schema.org/occupationalCredentialAwarded";
var offerCount2 = "https://schema.org/offerCount";
var offersPrescriptionByMail2 = "https://schema.org/offersPrescriptionByMail";
var openingHours2 = "https://schema.org/openingHours";
var openingHoursSpecification2 = "https://schema.org/openingHoursSpecification";
var opens2 = "https://schema.org/opens";
var operatingSystem2 = "https://schema.org/operatingSystem";
var opponent2 = "https://schema.org/opponent";
var option4 = "https://schema.org/option";
var orderDate2 = "https://schema.org/orderDate";
var orderDelivery2 = "https://schema.org/orderDelivery";
var orderItemNumber2 = "https://schema.org/orderItemNumber";
var orderItemStatus2 = "https://schema.org/orderItemStatus";
var orderNumber2 = "https://schema.org/orderNumber";
var orderQuantity2 = "https://schema.org/orderQuantity";
var orderStatus2 = "https://schema.org/orderStatus";
var orderedItem2 = "https://schema.org/orderedItem";
var organizer3 = "https://schema.org/organizer";
var originAddress2 = "https://schema.org/originAddress";
var originalMediaContextDescription2 = "https://schema.org/originalMediaContextDescription";
var originalMediaLink2 = "https://schema.org/originalMediaLink";
var originatesFrom2 = "https://schema.org/originatesFrom";
var overdosage2 = "https://schema.org/overdosage";
var ownedFrom2 = "https://schema.org/ownedFrom";
var ownedThrough2 = "https://schema.org/ownedThrough";
var ownershipFundingInfo2 = "https://schema.org/ownershipFundingInfo";
var owns2 = "https://schema.org/owns";
var pageEnd2 = "https://schema.org/pageEnd";
var pageStart2 = "https://schema.org/pageStart";
var pagination2 = "https://schema.org/pagination";
var parentItem2 = "https://schema.org/parentItem";
var parentService2 = "https://schema.org/parentService";
var parents2 = "https://schema.org/parents";
var partOfEpisode2 = "https://schema.org/partOfEpisode";
var partOfInvoice2 = "https://schema.org/partOfInvoice";
var partOfOrder2 = "https://schema.org/partOfOrder";
var partOfSeason2 = "https://schema.org/partOfSeason";
var partOfSystem2 = "https://schema.org/partOfSystem";
var partOfTVSeries2 = "https://schema.org/partOfTVSeries";
var partySize2 = "https://schema.org/partySize";
var passengerPriorityStatus2 = "https://schema.org/passengerPriorityStatus";
var passengerSequenceNumber2 = "https://schema.org/passengerSequenceNumber";
var pathophysiology2 = "https://schema.org/pathophysiology";
var pattern3 = "https://schema.org/pattern";
var payload3 = "https://schema.org/payload";
var paymentAccepted2 = "https://schema.org/paymentAccepted";
var paymentDue2 = "https://schema.org/paymentDue";
var paymentMethod2 = "https://schema.org/paymentMethod";
var paymentMethodId2 = "https://schema.org/paymentMethodId";
var paymentStatus3 = "https://schema.org/paymentStatus";
var paymentUrl2 = "https://schema.org/paymentUrl";
var penciler2 = "https://schema.org/penciler";
var percentile102 = "https://schema.org/percentile10";
var percentile252 = "https://schema.org/percentile25";
var percentile752 = "https://schema.org/percentile75";
var percentile902 = "https://schema.org/percentile90";
var performerIn2 = "https://schema.org/performerIn";
var performers2 = "https://schema.org/performers";
var permissionType2 = "https://schema.org/permissionType";
var permissions2 = "https://schema.org/permissions";
var permitAudience2 = "https://schema.org/permitAudience";
var permittedUsage2 = "https://schema.org/permittedUsage";
var petsAllowed2 = "https://schema.org/petsAllowed";
var phoneticText2 = "https://schema.org/phoneticText";
var photos2 = "https://schema.org/photos";
var physicalRequirement2 = "https://schema.org/physicalRequirement";
var physiologicalBenefits2 = "https://schema.org/physiologicalBenefits";
var pickupLocation2 = "https://schema.org/pickupLocation";
var pickupTime2 = "https://schema.org/pickupTime";
var playMode2 = "https://schema.org/playMode";
var playerType2 = "https://schema.org/playerType";
var playersOnline2 = "https://schema.org/playersOnline";
var polygon2 = "https://schema.org/polygon";
var populationType2 = "https://schema.org/populationType";
var positiveNotes2 = "https://schema.org/positiveNotes";
var possibleComplication2 = "https://schema.org/possibleComplication";
var possibleTreatment2 = "https://schema.org/possibleTreatment";
var postOfficeBoxNumber2 = "https://schema.org/postOfficeBoxNumber";
var postOp2 = "https://schema.org/postOp";
var postalCode3 = "https://schema.org/postalCode";
var postalCodeBegin2 = "https://schema.org/postalCodeBegin";
var postalCodeEnd2 = "https://schema.org/postalCodeEnd";
var postalCodePrefix2 = "https://schema.org/postalCodePrefix";
var postalCodeRange2 = "https://schema.org/postalCodeRange";
var potentialAction2 = "https://schema.org/potentialAction";
var potentialUse2 = "https://schema.org/potentialUse";
var preOp2 = "https://schema.org/preOp";
var predecessorOf2 = "https://schema.org/predecessorOf";
var pregnancyCategory2 = "https://schema.org/pregnancyCategory";
var pregnancyWarning2 = "https://schema.org/pregnancyWarning";
var prepTime2 = "https://schema.org/prepTime";
var preparation3 = "https://schema.org/preparation";
var prescribingInfo2 = "https://schema.org/prescribingInfo";
var prescriptionStatus2 = "https://schema.org/prescriptionStatus";
var previousItem2 = "https://schema.org/previousItem";
var previousStartDate2 = "https://schema.org/previousStartDate";
var price2 = "https://schema.org/price";
var priceComponent3 = "https://schema.org/priceComponent";
var priceComponentType2 = "https://schema.org/priceComponentType";
var priceCurrency2 = "https://schema.org/priceCurrency";
var priceRange2 = "https://schema.org/priceRange";
var priceSpecification2 = "https://schema.org/priceSpecification";
var priceType2 = "https://schema.org/priceType";
var priceValidUntil2 = "https://schema.org/priceValidUntil";
var primaryImageOfPage2 = "https://schema.org/primaryImageOfPage";
var primaryPrevention2 = "https://schema.org/primaryPrevention";
var printColumn2 = "https://schema.org/printColumn";
var printEdition2 = "https://schema.org/printEdition";
var printPage2 = "https://schema.org/printPage";
var printSection2 = "https://schema.org/printSection";
var procedure3 = "https://schema.org/procedure";
var procedureType2 = "https://schema.org/procedureType";
var processingTime2 = "https://schema.org/processingTime";
var processorRequirements2 = "https://schema.org/processorRequirements";
var producer2 = "https://schema.org/producer";
var produces2 = "https://schema.org/produces";
var productGroupID2 = "https://schema.org/productGroupID";
var productID2 = "https://schema.org/productID";
var productReturnDays2 = "https://schema.org/productReturnDays";
var productReturnLink2 = "https://schema.org/productReturnLink";
var productSupported2 = "https://schema.org/productSupported";
var productionCompany2 = "https://schema.org/productionCompany";
var productionDate2 = "https://schema.org/productionDate";
var proficiencyLevel2 = "https://schema.org/proficiencyLevel";
var programMembershipUsed2 = "https://schema.org/programMembershipUsed";
var programName2 = "https://schema.org/programName";
var programPrerequisites2 = "https://schema.org/programPrerequisites";
var programType2 = "https://schema.org/programType";
var programmingLanguage2 = "https://schema.org/programmingLanguage";
var programmingModel2 = "https://schema.org/programmingModel";
var propertyID2 = "https://schema.org/propertyID";
var proprietaryName2 = "https://schema.org/proprietaryName";
var proteinContent2 = "https://schema.org/proteinContent";
var providerMobility2 = "https://schema.org/providerMobility";
var providesService2 = "https://schema.org/providesService";
var publicAccess2 = "https://schema.org/publicAccess";
var publicTransportClosuresInfo2 = "https://schema.org/publicTransportClosuresInfo";
var publication2 = "https://schema.org/publication";
var publicationType2 = "https://schema.org/publicationType";
var publishedBy2 = "https://schema.org/publishedBy";
var publishedOn2 = "https://schema.org/publishedOn";
var publisher5 = "https://schema.org/publisher";
var publisherImprint2 = "https://schema.org/publisherImprint";
var purchaseDate2 = "https://schema.org/purchaseDate";
var qualifications2 = "https://schema.org/qualifications";
var quarantineGuidelines2 = "https://schema.org/quarantineGuidelines";
var query3 = "https://schema.org/query";
var quest2 = "https://schema.org/quest";
var question3 = "https://schema.org/question";
var rangeIncludes2 = "https://schema.org/rangeIncludes";
var ratingCount2 = "https://schema.org/ratingCount";
var ratingExplanation2 = "https://schema.org/ratingExplanation";
var ratingValue2 = "https://schema.org/ratingValue";
var readBy2 = "https://schema.org/readBy";
var readonlyValue2 = "https://schema.org/readonlyValue";
var realEstateAgent2 = "https://schema.org/realEstateAgent";
var recipe2 = "https://schema.org/recipe";
var recipeCategory2 = "https://schema.org/recipeCategory";
var recipeCuisine2 = "https://schema.org/recipeCuisine";
var recipeInstructions2 = "https://schema.org/recipeInstructions";
var recipeYield2 = "https://schema.org/recipeYield";
var recognizedBy2 = "https://schema.org/recognizedBy";
var recognizingAuthority2 = "https://schema.org/recognizingAuthority";
var recommendationStrength2 = "https://schema.org/recommendationStrength";
var recommendedIntake2 = "https://schema.org/recommendedIntake";
var recordLabel2 = "https://schema.org/recordLabel";
var recourseLoan2 = "https://schema.org/recourseLoan";
var referenceQuantity2 = "https://schema.org/referenceQuantity";
var referencesOrder2 = "https://schema.org/referencesOrder";
var refundType2 = "https://schema.org/refundType";
var regionDrained2 = "https://schema.org/regionDrained";
var regionsAllowed2 = "https://schema.org/regionsAllowed";
var relatedAnatomy2 = "https://schema.org/relatedAnatomy";
var relatedCondition2 = "https://schema.org/relatedCondition";
var relatedDrug2 = "https://schema.org/relatedDrug";
var relatedLink2 = "https://schema.org/relatedLink";
var relatedStructure2 = "https://schema.org/relatedStructure";
var relatedTherapy2 = "https://schema.org/relatedTherapy";
var relatedTo3 = "https://schema.org/relatedTo";
var releaseDate3 = "https://schema.org/releaseDate";
var releaseNotes2 = "https://schema.org/releaseNotes";
var releasedEvent2 = "https://schema.org/releasedEvent";
var relevantOccupation2 = "https://schema.org/relevantOccupation";
var relevantSpecialty2 = "https://schema.org/relevantSpecialty";
var remainingAttendeeCapacity2 = "https://schema.org/remainingAttendeeCapacity";
var renegotiableLoan2 = "https://schema.org/renegotiableLoan";
var repeatCount2 = "https://schema.org/repeatCount";
var repeatFrequency2 = "https://schema.org/repeatFrequency";
var repetitions3 = "https://schema.org/repetitions";
var replacee2 = "https://schema.org/replacee";
var replacer2 = "https://schema.org/replacer";
var replyToUrl2 = "https://schema.org/replyToUrl";
var reportNumber2 = "https://schema.org/reportNumber";
var representativeOfPage2 = "https://schema.org/representativeOfPage";
var requiredCollateral2 = "https://schema.org/requiredCollateral";
var requiredGender2 = "https://schema.org/requiredGender";
var requiredMaxAge2 = "https://schema.org/requiredMaxAge";
var requiredMinAge2 = "https://schema.org/requiredMinAge";
var requiredQuantity2 = "https://schema.org/requiredQuantity";
var requirements3 = "https://schema.org/requirements";
var requiresSubscription2 = "https://schema.org/requiresSubscription";
var reservationFor2 = "https://schema.org/reservationFor";
var reservationId2 = "https://schema.org/reservationId";
var reservationStatus2 = "https://schema.org/reservationStatus";
var reservedTicket2 = "https://schema.org/reservedTicket";
var responsibilities2 = "https://schema.org/responsibilities";
var restPeriods2 = "https://schema.org/restPeriods";
var restockingFee2 = "https://schema.org/restockingFee";
var resultComment2 = "https://schema.org/resultComment";
var resultReview2 = "https://schema.org/resultReview";
var returnFees2 = "https://schema.org/returnFees";
var returnLabelSource2 = "https://schema.org/returnLabelSource";
var returnMethod2 = "https://schema.org/returnMethod";
var returnPolicyCategory2 = "https://schema.org/returnPolicyCategory";
var returnPolicyCountry2 = "https://schema.org/returnPolicyCountry";
var returnPolicySeasonalOverride2 = "https://schema.org/returnPolicySeasonalOverride";
var returnShippingFeesAmount2 = "https://schema.org/returnShippingFeesAmount";
var reviewAspect2 = "https://schema.org/reviewAspect";
var reviewBody2 = "https://schema.org/reviewBody";
var reviewCount2 = "https://schema.org/reviewCount";
var reviewRating2 = "https://schema.org/reviewRating";
var reviewedBy2 = "https://schema.org/reviewedBy";
var reviews2 = "https://schema.org/reviews";
var riskFactor2 = "https://schema.org/riskFactor";
var risks2 = "https://schema.org/risks";
var roofLoad2 = "https://schema.org/roofLoad";
var rsvpResponse2 = "https://schema.org/rsvpResponse";
var runsTo2 = "https://schema.org/runsTo";
var runtime2 = "https://schema.org/runtime";
var rxcui2 = "https://schema.org/rxcui";
var safetyConsideration2 = "https://schema.org/safetyConsideration";
var salaryCurrency2 = "https://schema.org/salaryCurrency";
var salaryUponCompletion2 = "https://schema.org/salaryUponCompletion";
var sameAs3 = "https://schema.org/sameAs";
var sampleType2 = "https://schema.org/sampleType";
var saturatedFatContent2 = "https://schema.org/saturatedFatContent";
var scheduleTimezone2 = "https://schema.org/scheduleTimezone";
var scheduledPaymentDate2 = "https://schema.org/scheduledPaymentDate";
var scheduledTime2 = "https://schema.org/scheduledTime";
var schemaVersion2 = "https://schema.org/schemaVersion";
var schoolClosuresInfo2 = "https://schema.org/schoolClosuresInfo";
var screenCount2 = "https://schema.org/screenCount";
var screenshot2 = "https://schema.org/screenshot";
var sdDatePublished2 = "https://schema.org/sdDatePublished";
var sdLicense2 = "https://schema.org/sdLicense";
var sdPublisher2 = "https://schema.org/sdPublisher";
var seasonNumber2 = "https://schema.org/seasonNumber";
var seasons2 = "https://schema.org/seasons";
var seatNumber2 = "https://schema.org/seatNumber";
var seatRow2 = "https://schema.org/seatRow";
var seatSection2 = "https://schema.org/seatSection";
var seatingCapacity2 = "https://schema.org/seatingCapacity";
var seatingType2 = "https://schema.org/seatingType";
var secondaryPrevention2 = "https://schema.org/secondaryPrevention";
var securityClearanceRequirement2 = "https://schema.org/securityClearanceRequirement";
var securityScreening2 = "https://schema.org/securityScreening";
var seeks2 = "https://schema.org/seeks";
var sender3 = "https://schema.org/sender";
var sensoryRequirement2 = "https://schema.org/sensoryRequirement";
var sensoryUnit2 = "https://schema.org/sensoryUnit";
var seriousAdverseOutcome2 = "https://schema.org/seriousAdverseOutcome";
var serverStatus2 = "https://schema.org/serverStatus";
var servesCuisine2 = "https://schema.org/servesCuisine";
var serviceAudience2 = "https://schema.org/serviceAudience";
var serviceLocation2 = "https://schema.org/serviceLocation";
var serviceOperator2 = "https://schema.org/serviceOperator";
var servicePhone2 = "https://schema.org/servicePhone";
var servicePostalAddress2 = "https://schema.org/servicePostalAddress";
var serviceSmsNumber2 = "https://schema.org/serviceSmsNumber";
var serviceType3 = "https://schema.org/serviceType";
var serviceUrl2 = "https://schema.org/serviceUrl";
var servingSize2 = "https://schema.org/servingSize";
var sha2562 = "https://schema.org/sha256";
var sharedContent2 = "https://schema.org/sharedContent";
var shippingDestination2 = "https://schema.org/shippingDestination";
var shippingDetails2 = "https://schema.org/shippingDetails";
var shippingLabel2 = "https://schema.org/shippingLabel";
var shippingOrigin2 = "https://schema.org/shippingOrigin";
var shippingRate2 = "https://schema.org/shippingRate";
var shippingSettingsLink2 = "https://schema.org/shippingSettingsLink";
var siblings2 = "https://schema.org/siblings";
var signDetected2 = "https://schema.org/signDetected";
var signOrSymptom2 = "https://schema.org/signOrSymptom";
var significance2 = "https://schema.org/significance";
var significantLinks2 = "https://schema.org/significantLinks";
var size3 = "https://schema.org/size";
var sizeGroup2 = "https://schema.org/sizeGroup";
var sizeSystem2 = "https://schema.org/sizeSystem";
var skills2 = "https://schema.org/skills";
var sku2 = "https://schema.org/sku";
var slogan2 = "https://schema.org/slogan";
var smiles2 = "https://schema.org/smiles";
var smokingAllowed2 = "https://schema.org/smokingAllowed";
var sodiumContent2 = "https://schema.org/sodiumContent";
var softwareAddOn2 = "https://schema.org/softwareAddOn";
var softwareHelp2 = "https://schema.org/softwareHelp";
var softwareVersion2 = "https://schema.org/softwareVersion";
var sourceOrganization2 = "https://schema.org/sourceOrganization";
var sourcedFrom2 = "https://schema.org/sourcedFrom";
var spatial3 = "https://schema.org/spatial";
var speakable2 = "https://schema.org/speakable";
var specialCommitments2 = "https://schema.org/specialCommitments";
var specialOpeningHoursSpecification2 = "https://schema.org/specialOpeningHoursSpecification";
var specialty3 = "https://schema.org/specialty";
var speechToTextMarkup2 = "https://schema.org/speechToTextMarkup";
var speed2 = "https://schema.org/speed";
var spokenByCharacter2 = "https://schema.org/spokenByCharacter";
var sport2 = "https://schema.org/sport";
var sportsActivityLocation2 = "https://schema.org/sportsActivityLocation";
var sportsEvent2 = "https://schema.org/sportsEvent";
var sportsTeam2 = "https://schema.org/sportsTeam";
var spouse2 = "https://schema.org/spouse";
var stage3 = "https://schema.org/stage";
var stageAsNumber2 = "https://schema.org/stageAsNumber";
var starRating2 = "https://schema.org/starRating";
var startDate3 = "https://schema.org/startDate";
var startOffset2 = "https://schema.org/startOffset";
var startTime3 = "https://schema.org/startTime";
var statType2 = "https://schema.org/statType";
var status6 = "https://schema.org/status";
var steeringPosition2 = "https://schema.org/steeringPosition";
var stepValue2 = "https://schema.org/stepValue";
var steps2 = "https://schema.org/steps";
var storageRequirements2 = "https://schema.org/storageRequirements";
var streetAddress2 = "https://schema.org/streetAddress";
var strengthUnit2 = "https://schema.org/strengthUnit";
var strengthValue2 = "https://schema.org/strengthValue";
var structuralClass2 = "https://schema.org/structuralClass";
var study3 = "https://schema.org/study";
var studyDesign3 = "https://schema.org/studyDesign";
var studyLocation2 = "https://schema.org/studyLocation";
var studySubject2 = "https://schema.org/studySubject";
var stupidProperty2 = "https://schema.org/stupidProperty";
var subEvents2 = "https://schema.org/subEvents";
var subReservation2 = "https://schema.org/subReservation";
var subStageSuffix2 = "https://schema.org/subStageSuffix";
var subStructure2 = "https://schema.org/subStructure";
var subTest2 = "https://schema.org/subTest";
var subtitleLanguage2 = "https://schema.org/subtitleLanguage";
var successorOf2 = "https://schema.org/successorOf";
var sugarContent2 = "https://schema.org/sugarContent";
var suggestedAge2 = "https://schema.org/suggestedAge";
var suggestedGender2 = "https://schema.org/suggestedGender";
var suggestedMaxAge2 = "https://schema.org/suggestedMaxAge";
var suggestedMeasurement2 = "https://schema.org/suggestedMeasurement";
var suggestedMinAge2 = "https://schema.org/suggestedMinAge";
var suitableForDiet2 = "https://schema.org/suitableForDiet";
var supersededBy2 = "https://schema.org/supersededBy";
var supplyTo2 = "https://schema.org/supplyTo";
var supportingData2 = "https://schema.org/supportingData";
var surface2 = "https://schema.org/surface";
var syllabusSections2 = "https://schema.org/syllabusSections";
var target4 = "https://schema.org/target";
var targetDescription2 = "https://schema.org/targetDescription";
var targetName2 = "https://schema.org/targetName";
var targetPlatform2 = "https://schema.org/targetPlatform";
var targetPopulation2 = "https://schema.org/targetPopulation";
var targetProduct2 = "https://schema.org/targetProduct";
var targetUrl2 = "https://schema.org/targetUrl";
var taxID2 = "https://schema.org/taxID";
var taxonRank2 = "https://schema.org/taxonRank";
var taxonomicRange2 = "https://schema.org/taxonomicRange";
var teaches2 = "https://schema.org/teaches";
var telephone2 = "https://schema.org/telephone";
var temporal3 = "https://schema.org/temporal";
var termDuration2 = "https://schema.org/termDuration";
var termsOfService2 = "https://schema.org/termsOfService";
var termsPerYear2 = "https://schema.org/termsPerYear";
var text3 = "https://schema.org/text";
var textValue2 = "https://schema.org/textValue";
var thumbnail3 = "https://schema.org/thumbnail";
var thumbnailUrl2 = "https://schema.org/thumbnailUrl";
var tickerSymbol2 = "https://schema.org/tickerSymbol";
var ticketNumber2 = "https://schema.org/ticketNumber";
var ticketToken2 = "https://schema.org/ticketToken";
var ticketedSeat2 = "https://schema.org/ticketedSeat";
var timeOfDay3 = "https://schema.org/timeOfDay";
var timeRequired2 = "https://schema.org/timeRequired";
var timeToComplete2 = "https://schema.org/timeToComplete";
var tissueSample2 = "https://schema.org/tissueSample";
var title7 = "https://schema.org/title";
var titleEIDR2 = "https://schema.org/titleEIDR";
var toLocation2 = "https://schema.org/toLocation";
var toRecipient2 = "https://schema.org/toRecipient";
var tocContinuation2 = "https://schema.org/tocContinuation";
var tocEntry2 = "https://schema.org/tocEntry";
var tongueWeight2 = "https://schema.org/tongueWeight";
var tool2 = "https://schema.org/tool";
var torque2 = "https://schema.org/torque";
var totalHistoricalEnrollment2 = "https://schema.org/totalHistoricalEnrollment";
var totalJobOpenings2 = "https://schema.org/totalJobOpenings";
var totalPaymentDue2 = "https://schema.org/totalPaymentDue";
var totalPrice2 = "https://schema.org/totalPrice";
var totalTime2 = "https://schema.org/totalTime";
var tourBookingPage2 = "https://schema.org/tourBookingPage";
var touristType2 = "https://schema.org/touristType";
var trackingNumber2 = "https://schema.org/trackingNumber";
var trackingUrl2 = "https://schema.org/trackingUrl";
var tracks2 = "https://schema.org/tracks";
var trailer2 = "https://schema.org/trailer";
var trailerWeight2 = "https://schema.org/trailerWeight";
var trainName2 = "https://schema.org/trainName";
var trainNumber2 = "https://schema.org/trainNumber";
var trainingSalary2 = "https://schema.org/trainingSalary";
var transFatContent2 = "https://schema.org/transFatContent";
var transcript2 = "https://schema.org/transcript";
var transitTime2 = "https://schema.org/transitTime";
var transitTimeLabel2 = "https://schema.org/transitTimeLabel";
var translator2 = "https://schema.org/translator";
var transmissionMethod2 = "https://schema.org/transmissionMethod";
var travelBans2 = "https://schema.org/travelBans";
var trialDesign2 = "https://schema.org/trialDesign";
var tributary2 = "https://schema.org/tributary";
var tripOrigin2 = "https://schema.org/tripOrigin";
var typeOfBed2 = "https://schema.org/typeOfBed";
var typeOfGood2 = "https://schema.org/typeOfGood";
var typicalAgeRange2 = "https://schema.org/typicalAgeRange";
var typicalCreditsPerTerm2 = "https://schema.org/typicalCreditsPerTerm";
var typicalTest2 = "https://schema.org/typicalTest";
var underName2 = "https://schema.org/underName";
var unitCode2 = "https://schema.org/unitCode";
var unitText2 = "https://schema.org/unitText";
var unnamedSourcesPolicy2 = "https://schema.org/unnamedSourcesPolicy";
var unsaturatedFatContent2 = "https://schema.org/unsaturatedFatContent";
var uploadDate2 = "https://schema.org/uploadDate";
var upvoteCount2 = "https://schema.org/upvoteCount";
var url5 = "https://schema.org/url";
var urlTemplate2 = "https://schema.org/urlTemplate";
var usedToDiagnose2 = "https://schema.org/usedToDiagnose";
var userInteractionCount2 = "https://schema.org/userInteractionCount";
var usesDevice2 = "https://schema.org/usesDevice";
var usesHealthPlanIdStandard2 = "https://schema.org/usesHealthPlanIdStandard";
var utterances2 = "https://schema.org/utterances";
var validFor2 = "https://schema.org/validFor";
var validFrom2 = "https://schema.org/validFrom";
var validIn2 = "https://schema.org/validIn";
var validThrough2 = "https://schema.org/validThrough";
var validUntil2 = "https://schema.org/validUntil";
var value4 = "https://schema.org/value";
var valueAddedTaxIncluded2 = "https://schema.org/valueAddedTaxIncluded";
var valueMaxLength2 = "https://schema.org/valueMaxLength";
var valueMinLength2 = "https://schema.org/valueMinLength";
var valueName2 = "https://schema.org/valueName";
var valuePattern2 = "https://schema.org/valuePattern";
var valueReference2 = "https://schema.org/valueReference";
var valueRequired2 = "https://schema.org/valueRequired";
var variableMeasured2 = "https://schema.org/variableMeasured";
var variablesMeasured2 = "https://schema.org/variablesMeasured";
var variantCover2 = "https://schema.org/variantCover";
var variesBy2 = "https://schema.org/variesBy";
var vatID2 = "https://schema.org/vatID";
var vehicleConfiguration2 = "https://schema.org/vehicleConfiguration";
var vehicleEngine2 = "https://schema.org/vehicleEngine";
var vehicleIdentificationNumber2 = "https://schema.org/vehicleIdentificationNumber";
var vehicleInteriorColor2 = "https://schema.org/vehicleInteriorColor";
var vehicleInteriorType2 = "https://schema.org/vehicleInteriorType";
var vehicleModelDate2 = "https://schema.org/vehicleModelDate";
var vehicleSeatingCapacity2 = "https://schema.org/vehicleSeatingCapacity";
var vehicleSpecialUsage2 = "https://schema.org/vehicleSpecialUsage";
var vehicleTransmission2 = "https://schema.org/vehicleTransmission";
var vendor2 = "https://schema.org/vendor";
var verificationFactCheckingPolicy2 = "https://schema.org/verificationFactCheckingPolicy";
var version5 = "https://schema.org/version";
var video2 = "https://schema.org/video";
var videoFormat2 = "https://schema.org/videoFormat";
var videoFrameSize2 = "https://schema.org/videoFrameSize";
var videoQuality2 = "https://schema.org/videoQuality";
var volumeNumber2 = "https://schema.org/volumeNumber";
var warning3 = "https://schema.org/warning";
var warrantyPromise2 = "https://schema.org/warrantyPromise";
var warrantyScope2 = "https://schema.org/warrantyScope";
var webCheckinTime2 = "https://schema.org/webCheckinTime";
var webFeed2 = "https://schema.org/webFeed";
var weight2 = "https://schema.org/weight";
var weightTotal2 = "https://schema.org/weightTotal";
var wheelbase2 = "https://schema.org/wheelbase";
var width4 = "https://schema.org/width";
var winner2 = "https://schema.org/winner";
var wordCount2 = "https://schema.org/wordCount";
var workHours2 = "https://schema.org/workHours";
var workLocation2 = "https://schema.org/workLocation";
var workPerformed2 = "https://schema.org/workPerformed";
var workPresented2 = "https://schema.org/workPresented";
var workload2 = "https://schema.org/workload";
var worksFor2 = "https://schema.org/worksFor";
var worstRating2 = "https://schema.org/worstRating";
var xpath2 = "https://schema.org/xpath";
var yearBuilt2 = "https://schema.org/yearBuilt";
var yearlyRevenue2 = "https://schema.org/yearlyRevenue";
var yearsInOperation2 = "https://schema.org/yearsInOperation";
var actionApplication2 = "https://schema.org/actionApplication";
var actionOption2 = "https://schema.org/actionOption";
var album2 = "https://schema.org/album";
var albumRelease2 = "https://schema.org/albumRelease";
var alternateName2 = "https://schema.org/alternateName";
var alumni2 = "https://schema.org/alumni";
var alumniOf2 = "https://schema.org/alumniOf";
var archiveHeld2 = "https://schema.org/archiveHeld";
var arterialBranch2 = "https://schema.org/arterialBranch";
var artworkSurface2 = "https://schema.org/artworkSurface";
var attendee3 = "https://schema.org/attendee";
var audience4 = "https://schema.org/audience";
var availableOnDevice2 = "https://schema.org/availableOnDevice";
var award2 = "https://schema.org/award";
var blogPost2 = "https://schema.org/blogPost";
var broker2 = "https://schema.org/broker";
var caption2 = "https://schema.org/caption";
var category4 = "https://schema.org/category";
var childTaxon2 = "https://schema.org/childTaxon";
var clinicalPharmacology2 = "https://schema.org/clinicalPharmacology";
var codeSampleType2 = "https://schema.org/codeSampleType";
var colleague2 = "https://schema.org/colleague";
var contactPoint2 = "https://schema.org/contactPoint";
var containsPlace2 = "https://schema.org/containsPlace";
var containsSeason2 = "https://schema.org/containsSeason";
var contentLocation2 = "https://schema.org/contentLocation";
var creator4 = "https://schema.org/creator";
var dataset2 = "https://schema.org/dataset";
var dateCreated2 = "https://schema.org/dateCreated";
var director2 = "https://schema.org/director";
var duration5 = "https://schema.org/duration";
var employee2 = "https://schema.org/employee";
var encodesBioChemEntity2 = "https://schema.org/encodesBioChemEntity";
var encodesCreativeWork2 = "https://schema.org/encodesCreativeWork";
var encodingFormat2 = "https://schema.org/encodingFormat";
var episode2 = "https://schema.org/episode";
var event3 = "https://schema.org/event";
var exampleOfWork2 = "https://schema.org/exampleOfWork";
var executableLibraryName2 = "https://schema.org/executableLibraryName";
var exerciseCourse2 = "https://schema.org/exerciseCourse";
var founder2 = "https://schema.org/founder";
var frequency3 = "https://schema.org/frequency";
var fundedItem2 = "https://schema.org/fundedItem";
var funding2 = "https://schema.org/funding";
var game2 = "https://schema.org/game";
var gameServer2 = "https://schema.org/gameServer";
var genre2 = "https://schema.org/genre";
var hasBioChemEntityPart2 = "https://schema.org/hasBioChemEntityPart";
var hasBroadcastChannel2 = "https://schema.org/hasBroadcastChannel";
var hasDefinedTerm2 = "https://schema.org/hasDefinedTerm";
var hasMenu2 = "https://schema.org/hasMenu";
var hasMerchantReturnPolicy2 = "https://schema.org/hasMerchantReturnPolicy";
var hasVariant2 = "https://schema.org/hasVariant";
var holdingArchive2 = "https://schema.org/holdingArchive";
var inDefinedTermSet2 = "https://schema.org/inDefinedTermSet";
var inLanguage2 = "https://schema.org/inLanguage";
var incentiveCompensation2 = "https://schema.org/incentiveCompensation";
var interactionStatistic2 = "https://schema.org/interactionStatistic";
var isAccessibleForFree2 = "https://schema.org/isAccessibleForFree";
var isBasedOn2 = "https://schema.org/isBasedOn";
var isEncodedByBioChemEntity2 = "https://schema.org/isEncodedByBioChemEntity";
var isPartOfBioChemEntity2 = "https://schema.org/isPartOfBioChemEntity";
var isVariantOf2 = "https://schema.org/isVariantOf";
var itemOffered2 = "https://schema.org/itemOffered";
var jobBenefits2 = "https://schema.org/jobBenefits";
var jurisdiction3 = "https://schema.org/jurisdiction";
var legislationApplies2 = "https://schema.org/legislationApplies";
var mainContentOfPage2 = "https://schema.org/mainContentOfPage";
var mainEntity2 = "https://schema.org/mainEntity";
var mainEntityOfPage2 = "https://schema.org/mainEntityOfPage";
var makesOffer2 = "https://schema.org/makesOffer";
var measurementTechnique2 = "https://schema.org/measurementTechnique";
var merchantReturnDays2 = "https://schema.org/merchantReturnDays";
var merchantReturnLink2 = "https://schema.org/merchantReturnLink";
var offeredBy2 = "https://schema.org/offeredBy";
var offers2 = "https://schema.org/offers";
var parent3 = "https://schema.org/parent";
var parentTaxon2 = "https://schema.org/parentTaxon";
var partOfSeries2 = "https://schema.org/partOfSeries";
var partOfTrip2 = "https://schema.org/partOfTrip";
var paymentDueDate2 = "https://schema.org/paymentDueDate";
var performTime2 = "https://schema.org/performTime";
var performer3 = "https://schema.org/performer";
var photo3 = "https://schema.org/photo";
var provider4 = "https://schema.org/provider";
var providesBroadcastService2 = "https://schema.org/providesBroadcastService";
var recipeIngredient2 = "https://schema.org/recipeIngredient";
var recordedAs2 = "https://schema.org/recordedAs";
var recordedAt2 = "https://schema.org/recordedAt";
var recordedIn2 = "https://schema.org/recordedIn";
var recordingOf2 = "https://schema.org/recordingOf";
var releaseOf2 = "https://schema.org/releaseOf";
var review2 = "https://schema.org/review";
var roleName2 = "https://schema.org/roleName";
var runtimePlatform2 = "https://schema.org/runtimePlatform";
var season2 = "https://schema.org/season";
var serialNumber3 = "https://schema.org/serialNumber";
var serviceArea2 = "https://schema.org/serviceArea";
var serviceOutput2 = "https://schema.org/serviceOutput";
var sibling2 = "https://schema.org/sibling";
var significantLink2 = "https://schema.org/significantLink";
var softwareRequirements2 = "https://schema.org/softwareRequirements";
var sponsor2 = "https://schema.org/sponsor";
var subOrganization2 = "https://schema.org/subOrganization";
var subTrip2 = "https://schema.org/subTrip";
var subjectOf2 = "https://schema.org/subjectOf";
var suggestedAnswer2 = "https://schema.org/suggestedAnswer";
var superEvent2 = "https://schema.org/superEvent";
var targetCollection2 = "https://schema.org/targetCollection";
var temporalCoverage2 = "https://schema.org/temporalCoverage";
var termCode2 = "https://schema.org/termCode";
var track2 = "https://schema.org/track";
var translationOfWork2 = "https://schema.org/translationOfWork";
var usageInfo2 = "https://schema.org/usageInfo";
var warranty2 = "https://schema.org/warranty";
var workTranslation2 = "https://schema.org/workTranslation";
var yield__workaround2 = "https://schema.org/yield";
var about3 = "https://schema.org/about";
var actor4 = "https://schema.org/actor";
var associatedReview2 = "https://schema.org/associatedReview";
var competitor2 = "https://schema.org/competitor";
var containedInPlace2 = "https://schema.org/containedInPlace";
var encoding2 = "https://schema.org/encoding";
var hasMap2 = "https://schema.org/hasMap";
var material3 = "https://schema.org/material";
var memberOf2 = "https://schema.org/memberOf";
var parentOrganization2 = "https://schema.org/parentOrganization";
var result4 = "https://schema.org/result";
var seller2 = "https://schema.org/seller";
var spatialCoverage2 = "https://schema.org/spatialCoverage";
var step3 = "https://schema.org/step";
var subEvent2 = "https://schema.org/subEvent";
var supply2 = "https://schema.org/supply";
var workFeatured2 = "https://schema.org/workFeatured";
var areaServed2 = "https://schema.org/areaServed";
var image4 = "https://schema.org/image";
var includedInDataCatalog2 = "https://schema.org/includedInDataCatalog";
var member7 = "https://schema.org/member";
var recipient3 = "https://schema.org/recipient";
var workExample2 = "https://schema.org/workExample";
var description8 = "https://schema.org/description";
var gtin2 = "https://schema.org/gtin";
var hasRepresentation2 = "https://schema.org/hasRepresentation";
var hasPart4 = "https://schema.org/hasPart";
var position3 = "https://schema.org/position";
var isPartOf3 = "https://schema.org/isPartOf";
var instrument3 = "https://schema.org/instrument";
var object5 = "https://schema.org/object";
var publishingPrinciples2 = "https://schema.org/publishingPrinciples";
var location7 = "https://schema.org/location";
var participant4 = "https://schema.org/participant";
var identifier5 = "https://schema.org/identifier";
var schema_httpsImport = /* @__PURE__ */ Object.freeze({
  AMRadioChannel: AMRadioChannel2,
  APIReference: APIReference2,
  AboutPage: AboutPage2,
  AcceptAction: AcceptAction2,
  Accommodation: Accommodation2,
  AccountingService: AccountingService2,
  AchieveAction: AchieveAction2,
  Action: Action3,
  ActionAccessSpecification: ActionAccessSpecification2,
  ActionStatusType: ActionStatusType2,
  ActivateAction: ActivateAction2,
  AddAction: AddAction2,
  AdministrativeArea: AdministrativeArea2,
  AdultEntertainment: AdultEntertainment2,
  AdultOrientedEnumeration: AdultOrientedEnumeration2,
  AdvertiserContentArticle: AdvertiserContentArticle2,
  AggregateOffer: AggregateOffer2,
  AggregateRating: AggregateRating2,
  AgreeAction: AgreeAction2,
  Airline: Airline2,
  Airport: Airport2,
  AlignmentObject: AlignmentObject2,
  AllocateAction: AllocateAction2,
  AmpStory: AmpStory2,
  AmusementPark: AmusementPark2,
  AnalysisNewsArticle: AnalysisNewsArticle2,
  AnatomicalStructure: AnatomicalStructure2,
  AnatomicalSystem: AnatomicalSystem2,
  AnimalShelter: AnimalShelter2,
  Answer: Answer3,
  Apartment: Apartment2,
  ApartmentComplex: ApartmentComplex2,
  AppendAction: AppendAction2,
  ApplyAction: ApplyAction2,
  ApprovedIndication: ApprovedIndication2,
  Aquarium: Aquarium2,
  ArchiveComponent: ArchiveComponent2,
  ArchiveOrganization: ArchiveOrganization2,
  ArriveAction: ArriveAction2,
  ArtGallery: ArtGallery2,
  Artery: Artery2,
  Article: Article3,
  AskAction: AskAction2,
  AskPublicNewsArticle: AskPublicNewsArticle2,
  AssessAction: AssessAction2,
  AssignAction: AssignAction2,
  Atlas: Atlas2,
  Attorney: Attorney2,
  Audience: Audience2,
  AudioObject: AudioObject2,
  AudioObjectSnapshot: AudioObjectSnapshot2,
  Audiobook: Audiobook2,
  AuthorizeAction: AuthorizeAction2,
  AutoBodyShop: AutoBodyShop2,
  AutoDealer: AutoDealer2,
  AutoPartsStore: AutoPartsStore2,
  AutoRental: AutoRental2,
  AutoRepair: AutoRepair2,
  AutoWash: AutoWash2,
  AutomatedTeller: AutomatedTeller2,
  AutomotiveBusiness: AutomotiveBusiness2,
  BackgroundNewsArticle: BackgroundNewsArticle2,
  Bakery: Bakery2,
  BankAccount: BankAccount2,
  BankOrCreditUnion: BankOrCreditUnion2,
  BarOrPub: BarOrPub2,
  Barcode: Barcode2,
  Beach: Beach2,
  BeautySalon: BeautySalon2,
  BedAndBreakfast: BedAndBreakfast2,
  BedDetails: BedDetails2,
  BedType: BedType2,
  BefriendAction: BefriendAction2,
  BikeStore: BikeStore2,
  BioChemEntity: BioChemEntity2,
  Blog: Blog2,
  BlogPosting: BlogPosting2,
  BloodTest: BloodTest2,
  BoardingPolicyType: BoardingPolicyType2,
  BoatReservation: BoatReservation2,
  BoatTerminal: BoatTerminal2,
  BoatTrip: BoatTrip2,
  BodyMeasurementTypeEnumeration: BodyMeasurementTypeEnumeration2,
  BodyOfWater: BodyOfWater2,
  Bone: Bone2,
  Book: Book2,
  BookFormatType: BookFormatType2,
  BookSeries: BookSeries2,
  BookStore: BookStore2,
  BookmarkAction: BookmarkAction2,
  Boolean__workaround: Boolean__workaround2,
  BorrowAction: BorrowAction2,
  BowlingAlley: BowlingAlley2,
  BrainStructure: BrainStructure2,
  Brand: Brand2,
  BreadcrumbList: BreadcrumbList2,
  Brewery: Brewery2,
  Bridge: Bridge2,
  BroadcastChannel: BroadcastChannel2,
  BroadcastEvent: BroadcastEvent2,
  BroadcastFrequencySpecification: BroadcastFrequencySpecification2,
  BroadcastService: BroadcastService2,
  BrokerageAccount: BrokerageAccount2,
  BuddhistTemple: BuddhistTemple2,
  BusOrCoach: BusOrCoach2,
  BusReservation: BusReservation2,
  BusStation: BusStation2,
  BusStop: BusStop2,
  BusTrip: BusTrip2,
  BusinessAudience: BusinessAudience2,
  BusinessEntityType: BusinessEntityType2,
  BusinessEvent: BusinessEvent2,
  BusinessFunction: BusinessFunction2,
  BuyAction: BuyAction2,
  CDCPMDRecord: CDCPMDRecord2,
  CableOrSatelliteService: CableOrSatelliteService2,
  CafeOrCoffeeShop: CafeOrCoffeeShop2,
  Campground: Campground2,
  CampingPitch: CampingPitch2,
  Canal: Canal2,
  CancelAction: CancelAction2,
  Car: Car2,
  CarUsageType: CarUsageType2,
  Casino: Casino2,
  CategoryCode: CategoryCode2,
  CategoryCodeSet: CategoryCodeSet2,
  CatholicChurch: CatholicChurch2,
  Cemetery: Cemetery2,
  Chapter: Chapter2,
  CheckAction: CheckAction2,
  CheckInAction: CheckInAction2,
  CheckOutAction: CheckOutAction2,
  CheckoutPage: CheckoutPage2,
  ChemicalSubstance: ChemicalSubstance2,
  ChildCare: ChildCare2,
  ChildrensEvent: ChildrensEvent2,
  ChooseAction: ChooseAction2,
  Church: Church2,
  City: City2,
  CityHall: CityHall2,
  CivicStructure: CivicStructure2,
  Claim: Claim3,
  ClaimReview: ClaimReview2,
  Class: Class6,
  Clip: Clip2,
  ClothingStore: ClothingStore2,
  Code: Code2,
  Collection: Collection4,
  CollectionPage: CollectionPage3,
  CollegeOrUniversity: CollegeOrUniversity2,
  ComedyClub: ComedyClub2,
  ComedyEvent: ComedyEvent2,
  ComicCoverArt: ComicCoverArt2,
  ComicIssue: ComicIssue2,
  ComicSeries: ComicSeries2,
  ComicStory: ComicStory2,
  Comment: Comment2,
  CommentAction: CommentAction2,
  CommunicateAction: CommunicateAction2,
  CompleteDataFeed: CompleteDataFeed2,
  CompoundPriceSpecification: CompoundPriceSpecification2,
  ComputerLanguage: ComputerLanguage2,
  ComputerStore: ComputerStore2,
  ConfirmAction: ConfirmAction2,
  Consortium: Consortium2,
  ConstraintNode: ConstraintNode2,
  ConsumeAction: ConsumeAction2,
  ContactPage: ContactPage2,
  ContactPoint: ContactPoint3,
  ContactPointOption: ContactPointOption2,
  Continent: Continent2,
  ControlAction: ControlAction2,
  ConvenienceStore: ConvenienceStore2,
  Conversation: Conversation2,
  CookAction: CookAction2,
  Corporation: Corporation2,
  CorrectionComment: CorrectionComment2,
  Country: Country2,
  Course: Course2,
  CourseInstance: CourseInstance2,
  Courthouse: Courthouse2,
  CoverArt: CoverArt2,
  CovidTestingFacility: CovidTestingFacility2,
  CreateAction: CreateAction2,
  CreativeWork: CreativeWork2,
  CreativeWorkSeason: CreativeWorkSeason2,
  CreativeWorkSeries: CreativeWorkSeries2,
  CreditCard: CreditCard2,
  Crematorium: Crematorium2,
  CriticReview: CriticReview2,
  CssSelectorType: CssSelectorType2,
  CurrencyConversionService: CurrencyConversionService2,
  DDxElement: DDxElement2,
  DanceEvent: DanceEvent2,
  DanceGroup: DanceGroup2,
  DataCatalog: DataCatalog2,
  DataDownload: DataDownload2,
  DataFeed: DataFeed2,
  DataFeedItem: DataFeedItem2,
  DataType: DataType3,
  Dataset: Dataset2,
  Date__workaround: Date__workaround2,
  DateTime: DateTime2,
  DatedMoneySpecification: DatedMoneySpecification2,
  DayOfWeek: DayOfWeek2,
  DaySpa: DaySpa2,
  DeactivateAction: DeactivateAction2,
  DefenceEstablishment: DefenceEstablishment2,
  DefinedRegion: DefinedRegion2,
  DefinedTerm: DefinedTerm2,
  DefinedTermSet: DefinedTermSet2,
  DeleteAction: DeleteAction2,
  DeliveryChargeSpecification: DeliveryChargeSpecification2,
  DeliveryEvent: DeliveryEvent2,
  DeliveryMethod: DeliveryMethod2,
  DeliveryTimeSettings: DeliveryTimeSettings2,
  Demand: Demand2,
  Dentist: Dentist2,
  DepartAction: DepartAction2,
  DepartmentStore: DepartmentStore2,
  DepositAccount: DepositAccount2,
  DiagnosticLab: DiagnosticLab2,
  DiagnosticProcedure: DiagnosticProcedure2,
  Diet: Diet2,
  DietarySupplement: DietarySupplement2,
  DigitalDocument: DigitalDocument2,
  DigitalDocumentPermission: DigitalDocumentPermission2,
  DigitalDocumentPermissionType: DigitalDocumentPermissionType2,
  DigitalPlatformEnumeration: DigitalPlatformEnumeration2,
  DisagreeAction: DisagreeAction2,
  DiscoverAction: DiscoverAction2,
  DiscussionForumPosting: DiscussionForumPosting2,
  DislikeAction: DislikeAction2,
  Distance: Distance3,
  Distillery: Distillery2,
  DonateAction: DonateAction2,
  DoseSchedule: DoseSchedule2,
  DownloadAction: DownloadAction2,
  DrawAction: DrawAction2,
  Drawing: Drawing2,
  DrinkAction: DrinkAction2,
  DriveWheelConfigurationValue: DriveWheelConfigurationValue2,
  Drug: Drug2,
  DrugClass: DrugClass2,
  DrugCost: DrugCost2,
  DrugCostCategory: DrugCostCategory2,
  DrugLegalStatus: DrugLegalStatus2,
  DrugPregnancyCategory: DrugPregnancyCategory2,
  DrugPrescriptionStatus: DrugPrescriptionStatus2,
  DrugStrength: DrugStrength2,
  DryCleaningOrLaundry: DryCleaningOrLaundry2,
  Duration: Duration3,
  EUEnergyEfficiencyEnumeration: EUEnergyEfficiencyEnumeration2,
  EatAction: EatAction2,
  EducationEvent: EducationEvent2,
  EducationalAudience: EducationalAudience2,
  EducationalOccupationalCredential: EducationalOccupationalCredential2,
  EducationalOccupationalProgram: EducationalOccupationalProgram2,
  EducationalOrganization: EducationalOrganization2,
  Electrician: Electrician2,
  ElectronicsStore: ElectronicsStore2,
  ElementarySchool: ElementarySchool2,
  EmailMessage: EmailMessage2,
  Embassy: Embassy2,
  EmergencyService: EmergencyService2,
  EmployeeRole: EmployeeRole2,
  EmployerAggregateRating: EmployerAggregateRating2,
  EmployerReview: EmployerReview2,
  EmploymentAgency: EmploymentAgency2,
  EndorseAction: EndorseAction2,
  EndorsementRating: EndorsementRating2,
  Energy: Energy2,
  EnergyConsumptionDetails: EnergyConsumptionDetails2,
  EnergyEfficiencyEnumeration: EnergyEfficiencyEnumeration2,
  EnergyStarEnergyEfficiencyEnumeration: EnergyStarEnergyEfficiencyEnumeration2,
  EngineSpecification: EngineSpecification2,
  EntertainmentBusiness: EntertainmentBusiness2,
  EntryPoint: EntryPoint2,
  Enumeration: Enumeration2,
  Episode: Episode2,
  Event: Event3,
  EventAttendanceModeEnumeration: EventAttendanceModeEnumeration2,
  EventReservation: EventReservation2,
  EventSeries: EventSeries2,
  EventStatusType: EventStatusType2,
  EventVenue: EventVenue2,
  ExchangeRateSpecification: ExchangeRateSpecification2,
  ExerciseAction: ExerciseAction2,
  ExerciseGym: ExerciseGym2,
  ExercisePlan: ExercisePlan2,
  ExhibitionEvent: ExhibitionEvent2,
  FAQPage: FAQPage2,
  FMRadioChannel: FMRadioChannel2,
  FastFoodRestaurant: FastFoodRestaurant2,
  Festival: Festival2,
  FilmAction: FilmAction2,
  FinancialProduct: FinancialProduct2,
  FinancialService: FinancialService2,
  FindAction: FindAction2,
  FireStation: FireStation2,
  Flight: Flight2,
  FlightReservation: FlightReservation2,
  Float: Float2,
  FloorPlan: FloorPlan2,
  Florist: Florist2,
  FollowAction: FollowAction2,
  FoodEstablishment: FoodEstablishment2,
  FoodEstablishmentReservation: FoodEstablishmentReservation2,
  FoodEvent: FoodEvent2,
  FoodService: FoodService2,
  FundingAgency: FundingAgency2,
  FundingScheme: FundingScheme2,
  FurnitureStore: FurnitureStore2,
  Game: Game2,
  GameAvailabilityEnumeration: GameAvailabilityEnumeration2,
  GamePlayMode: GamePlayMode2,
  GameServer: GameServer2,
  GameServerStatus: GameServerStatus2,
  GardenStore: GardenStore2,
  GasStation: GasStation2,
  GatedResidenceCommunity: GatedResidenceCommunity2,
  GenderType: GenderType2,
  Gene: Gene2,
  GeneralContractor: GeneralContractor2,
  GeoCircle: GeoCircle2,
  GeoCoordinates: GeoCoordinates2,
  GeoShape: GeoShape2,
  GeospatialGeometry: GeospatialGeometry2,
  GiveAction: GiveAction2,
  GolfCourse: GolfCourse2,
  GovernmentBenefitsType: GovernmentBenefitsType2,
  GovernmentBuilding: GovernmentBuilding2,
  GovernmentOffice: GovernmentOffice2,
  GovernmentOrganization: GovernmentOrganization2,
  GovernmentPermit: GovernmentPermit2,
  GovernmentService: GovernmentService2,
  Grant: Grant2,
  GroceryStore: GroceryStore2,
  Guide: Guide2,
  HVACBusiness: HVACBusiness2,
  Hackathon: Hackathon2,
  HairSalon: HairSalon2,
  HardwareStore: HardwareStore2,
  HealthAndBeautyBusiness: HealthAndBeautyBusiness2,
  HealthAspectEnumeration: HealthAspectEnumeration2,
  HealthClub: HealthClub2,
  HealthInsurancePlan: HealthInsurancePlan2,
  HealthPlanCostSharingSpecification: HealthPlanCostSharingSpecification2,
  HealthPlanFormulary: HealthPlanFormulary2,
  HealthPlanNetwork: HealthPlanNetwork2,
  HealthTopicContent: HealthTopicContent2,
  HighSchool: HighSchool2,
  HinduTemple: HinduTemple2,
  HobbyShop: HobbyShop2,
  HomeAndConstructionBusiness: HomeAndConstructionBusiness2,
  HomeGoodsStore: HomeGoodsStore2,
  Hospital: Hospital2,
  Hostel: Hostel2,
  Hotel: Hotel2,
  HotelRoom: HotelRoom2,
  House: House2,
  HousePainter: HousePainter2,
  HowTo: HowTo2,
  HowToDirection: HowToDirection2,
  HowToItem: HowToItem2,
  HowToSection: HowToSection2,
  HowToStep: HowToStep2,
  HowToSupply: HowToSupply2,
  HowToTip: HowToTip2,
  HowToTool: HowToTool2,
  HyperToc: HyperToc2,
  HyperTocEntry: HyperTocEntry2,
  IceCreamShop: IceCreamShop2,
  IgnoreAction: IgnoreAction2,
  ImageGallery: ImageGallery2,
  ImageObject: ImageObject2,
  ImageObjectSnapshot: ImageObjectSnapshot2,
  ImagingTest: ImagingTest2,
  IndividualProduct: IndividualProduct2,
  InfectiousAgentClass: InfectiousAgentClass2,
  InfectiousDisease: InfectiousDisease2,
  InformAction: InformAction2,
  InsertAction: InsertAction2,
  InstallAction: InstallAction2,
  InsuranceAgency: InsuranceAgency2,
  Intangible: Intangible2,
  Integer: Integer2,
  InteractAction: InteractAction2,
  InteractionCounter: InteractionCounter2,
  InternetCafe: InternetCafe2,
  InvestmentFund: InvestmentFund2,
  InvestmentOrDeposit: InvestmentOrDeposit2,
  InviteAction: InviteAction2,
  Invoice: Invoice3,
  ItemAvailability: ItemAvailability2,
  ItemList: ItemList2,
  ItemListOrderType: ItemListOrderType2,
  ItemPage: ItemPage2,
  JewelryStore: JewelryStore2,
  JobPosting: JobPosting2,
  JoinAction: JoinAction2,
  Joint: Joint2,
  LakeBodyOfWater: LakeBodyOfWater2,
  Landform: Landform2,
  LandmarksOrHistoricalBuildings: LandmarksOrHistoricalBuildings2,
  Language: Language2,
  LearningResource: LearningResource2,
  LeaveAction: LeaveAction2,
  LegalForceStatus: LegalForceStatus2,
  LegalService: LegalService2,
  LegalValueLevel: LegalValueLevel2,
  Legislation: Legislation2,
  LegislationObject: LegislationObject2,
  LegislativeBuilding: LegislativeBuilding2,
  LendAction: LendAction2,
  Library: Library3,
  LibrarySystem: LibrarySystem2,
  LifestyleModification: LifestyleModification2,
  Ligament: Ligament2,
  LikeAction: LikeAction2,
  LinkRole: LinkRole2,
  LiquorStore: LiquorStore2,
  ListItem: ListItem2,
  ListenAction: ListenAction2,
  LiteraryEvent: LiteraryEvent2,
  LiveBlogPosting: LiveBlogPosting2,
  LoanOrCredit: LoanOrCredit2,
  LocalBusiness: LocalBusiness2,
  LocationFeatureSpecification: LocationFeatureSpecification2,
  Locksmith: Locksmith2,
  LodgingBusiness: LodgingBusiness2,
  LodgingReservation: LodgingReservation2,
  LoseAction: LoseAction2,
  LymphaticVessel: LymphaticVessel2,
  Manuscript: Manuscript2,
  Map__workaround: Map__workaround2,
  MapCategoryType: MapCategoryType2,
  MarryAction: MarryAction2,
  Mass: Mass2,
  MathSolver: MathSolver2,
  MaximumDoseSchedule: MaximumDoseSchedule2,
  MeasurementMethodEnum: MeasurementMethodEnum2,
  MeasurementTypeEnumeration: MeasurementTypeEnumeration2,
  MediaGallery: MediaGallery2,
  MediaManipulationRatingEnumeration: MediaManipulationRatingEnumeration2,
  MediaObject: MediaObject2,
  MediaReview: MediaReview2,
  MediaReviewItem: MediaReviewItem2,
  MediaSubscription: MediaSubscription2,
  MedicalAudience: MedicalAudience2,
  MedicalAudienceType: MedicalAudienceType2,
  MedicalBusiness: MedicalBusiness2,
  MedicalCause: MedicalCause2,
  MedicalClinic: MedicalClinic2,
  MedicalCode: MedicalCode2,
  MedicalCondition: MedicalCondition2,
  MedicalConditionStage: MedicalConditionStage2,
  MedicalContraindication: MedicalContraindication2,
  MedicalDevice: MedicalDevice2,
  MedicalDevicePurpose: MedicalDevicePurpose2,
  MedicalEntity: MedicalEntity2,
  MedicalEnumeration: MedicalEnumeration2,
  MedicalEvidenceLevel: MedicalEvidenceLevel2,
  MedicalGuideline: MedicalGuideline2,
  MedicalGuidelineContraindication: MedicalGuidelineContraindication2,
  MedicalGuidelineRecommendation: MedicalGuidelineRecommendation2,
  MedicalImagingTechnique: MedicalImagingTechnique2,
  MedicalIndication: MedicalIndication2,
  MedicalIntangible: MedicalIntangible2,
  MedicalObservationalStudy: MedicalObservationalStudy2,
  MedicalObservationalStudyDesign: MedicalObservationalStudyDesign2,
  MedicalOrganization: MedicalOrganization2,
  MedicalProcedure: MedicalProcedure2,
  MedicalProcedureType: MedicalProcedureType2,
  MedicalRiskCalculator: MedicalRiskCalculator2,
  MedicalRiskEstimator: MedicalRiskEstimator2,
  MedicalRiskFactor: MedicalRiskFactor2,
  MedicalRiskScore: MedicalRiskScore2,
  MedicalScholarlyArticle: MedicalScholarlyArticle2,
  MedicalSign: MedicalSign2,
  MedicalSignOrSymptom: MedicalSignOrSymptom2,
  MedicalSpecialty: MedicalSpecialty2,
  MedicalStudy: MedicalStudy2,
  MedicalStudyStatus: MedicalStudyStatus2,
  MedicalSymptom: MedicalSymptom2,
  MedicalTest: MedicalTest2,
  MedicalTestPanel: MedicalTestPanel2,
  MedicalTherapy: MedicalTherapy2,
  MedicalTrial: MedicalTrial2,
  MedicalTrialDesign: MedicalTrialDesign2,
  MedicalWebPage: MedicalWebPage2,
  MedicineSystem: MedicineSystem2,
  MeetingRoom: MeetingRoom2,
  MensClothingStore: MensClothingStore2,
  Menu: Menu2,
  MenuItem: MenuItem2,
  MenuSection: MenuSection2,
  MerchantReturnEnumeration: MerchantReturnEnumeration2,
  MerchantReturnPolicy: MerchantReturnPolicy2,
  MerchantReturnPolicySeasonalOverride: MerchantReturnPolicySeasonalOverride2,
  Message: Message3,
  MiddleSchool: MiddleSchool2,
  MobileApplication: MobileApplication2,
  MobilePhoneStore: MobilePhoneStore2,
  MolecularEntity: MolecularEntity2,
  MonetaryAmount: MonetaryAmount2,
  MonetaryAmountDistribution: MonetaryAmountDistribution2,
  MonetaryGrant: MonetaryGrant2,
  MoneyTransfer: MoneyTransfer2,
  MortgageLoan: MortgageLoan2,
  Mosque: Mosque2,
  Motel: Motel2,
  Motorcycle: Motorcycle2,
  MotorcycleDealer: MotorcycleDealer2,
  MotorcycleRepair: MotorcycleRepair2,
  MotorizedBicycle: MotorizedBicycle2,
  Mountain: Mountain2,
  MoveAction: MoveAction2,
  Movie: Movie2,
  MovieClip: MovieClip2,
  MovieRentalStore: MovieRentalStore2,
  MovieSeries: MovieSeries2,
  MovieTheater: MovieTheater2,
  MovingCompany: MovingCompany2,
  Muscle: Muscle2,
  Museum: Museum2,
  MusicAlbum: MusicAlbum2,
  MusicAlbumProductionType: MusicAlbumProductionType2,
  MusicAlbumReleaseType: MusicAlbumReleaseType2,
  MusicComposition: MusicComposition2,
  MusicEvent: MusicEvent2,
  MusicGroup: MusicGroup2,
  MusicPlaylist: MusicPlaylist2,
  MusicRecording: MusicRecording2,
  MusicRelease: MusicRelease2,
  MusicReleaseFormatType: MusicReleaseFormatType2,
  MusicStore: MusicStore2,
  MusicVenue: MusicVenue2,
  MusicVideoObject: MusicVideoObject2,
  NGO: NGO2,
  NLNonprofitType: NLNonprofitType2,
  NailSalon: NailSalon2,
  Nerve: Nerve2,
  NewsArticle: NewsArticle2,
  NewsMediaOrganization: NewsMediaOrganization2,
  Newspaper: Newspaper2,
  NightClub: NightClub2,
  NonprofitType: NonprofitType2,
  Notary: Notary2,
  NoteDigitalDocument: NoteDigitalDocument2,
  Number__workaround: Number__workaround2,
  NutritionInformation: NutritionInformation2,
  Observation: Observation3,
  Occupation: Occupation2,
  OccupationalExperienceRequirements: OccupationalExperienceRequirements2,
  OccupationalTherapy: OccupationalTherapy2,
  OceanBodyOfWater: OceanBodyOfWater2,
  Offer: Offer3,
  OfferCatalog: OfferCatalog2,
  OfferForLease: OfferForLease2,
  OfferForPurchase: OfferForPurchase2,
  OfferItemCondition: OfferItemCondition2,
  OfferShippingDetails: OfferShippingDetails2,
  OfficeEquipmentStore: OfficeEquipmentStore2,
  OnDemandEvent: OnDemandEvent2,
  OnlineBusiness: OnlineBusiness2,
  OnlineStore: OnlineStore2,
  OpeningHoursSpecification: OpeningHoursSpecification2,
  OpinionNewsArticle: OpinionNewsArticle2,
  Optician: Optician2,
  Order: Order2,
  OrderAction: OrderAction2,
  OrderItem: OrderItem2,
  OrderStatus: OrderStatus2,
  Organization: Organization5,
  OrganizationRole: OrganizationRole2,
  OrganizeAction: OrganizeAction2,
  OutletStore: OutletStore2,
  OwnershipInfo: OwnershipInfo2,
  PaintAction: PaintAction2,
  Painting: Painting2,
  PalliativeProcedure: PalliativeProcedure2,
  ParcelDelivery: ParcelDelivery2,
  ParentAudience: ParentAudience2,
  Park: Park2,
  ParkingFacility: ParkingFacility2,
  PathologyTest: PathologyTest2,
  Patient: Patient3,
  PawnShop: PawnShop2,
  PayAction: PayAction2,
  PaymentCard: PaymentCard2,
  PaymentChargeSpecification: PaymentChargeSpecification2,
  PaymentMethod: PaymentMethod2,
  PaymentService: PaymentService2,
  PaymentStatusType: PaymentStatusType2,
  PeopleAudience: PeopleAudience2,
  PerformAction: PerformAction2,
  PerformanceRole: PerformanceRole2,
  PerformingArtsTheater: PerformingArtsTheater2,
  PerformingGroup: PerformingGroup2,
  Periodical: Periodical2,
  Permit: Permit2,
  Person: Person5,
  PetStore: PetStore2,
  Pharmacy: Pharmacy2,
  Photograph: Photograph2,
  PhotographAction: PhotographAction2,
  PhysicalActivity: PhysicalActivity2,
  PhysicalActivityCategory: PhysicalActivityCategory2,
  PhysicalExam: PhysicalExam2,
  PhysicalTherapy: PhysicalTherapy2,
  Physician: Physician2,
  Place: Place3,
  PlaceOfWorship: PlaceOfWorship2,
  PlanAction: PlanAction2,
  Play: Play2,
  PlayAction: PlayAction2,
  PlayGameAction: PlayGameAction2,
  Playground: Playground2,
  Plumber: Plumber2,
  PodcastEpisode: PodcastEpisode2,
  PodcastSeason: PodcastSeason2,
  PodcastSeries: PodcastSeries2,
  PoliceStation: PoliceStation2,
  PoliticalParty: PoliticalParty2,
  Pond: Pond2,
  PostOffice: PostOffice2,
  PostalAddress: PostalAddress2,
  PostalCodeRangeSpecification: PostalCodeRangeSpecification2,
  Poster: Poster2,
  PreOrderAction: PreOrderAction2,
  PrependAction: PrependAction2,
  Preschool: Preschool2,
  PresentationDigitalDocument: PresentationDigitalDocument2,
  PreventionIndication: PreventionIndication2,
  PriceComponentTypeEnumeration: PriceComponentTypeEnumeration2,
  PriceSpecification: PriceSpecification2,
  PriceTypeEnumeration: PriceTypeEnumeration2,
  Product: Product2,
  ProductCollection: ProductCollection2,
  ProductGroup: ProductGroup2,
  ProductModel: ProductModel2,
  ProductReturnEnumeration: ProductReturnEnumeration2,
  ProductReturnPolicy: ProductReturnPolicy2,
  ProfessionalService: ProfessionalService2,
  ProfilePage: ProfilePage2,
  ProgramMembership: ProgramMembership2,
  Project: Project3,
  PronounceableText: PronounceableText2,
  Property: Property4,
  PropertyValue: PropertyValue2,
  PropertyValueSpecification: PropertyValueSpecification2,
  Protein: Protein2,
  PsychologicalTreatment: PsychologicalTreatment2,
  PublicSwimmingPool: PublicSwimmingPool2,
  PublicToilet: PublicToilet2,
  PublicationEvent: PublicationEvent2,
  PublicationIssue: PublicationIssue2,
  PublicationVolume: PublicationVolume2,
  QAPage: QAPage2,
  QualitativeValue: QualitativeValue2,
  QuantitativeValue: QuantitativeValue2,
  QuantitativeValueDistribution: QuantitativeValueDistribution2,
  Quantity: Quantity3,
  Question: Question3,
  Quiz: Quiz2,
  Quotation: Quotation2,
  QuoteAction: QuoteAction2,
  RVPark: RVPark2,
  RadiationTherapy: RadiationTherapy2,
  RadioBroadcastService: RadioBroadcastService2,
  RadioChannel: RadioChannel2,
  RadioClip: RadioClip2,
  RadioEpisode: RadioEpisode2,
  RadioSeason: RadioSeason2,
  RadioSeries: RadioSeries2,
  RadioStation: RadioStation2,
  Rating: Rating2,
  ReactAction: ReactAction2,
  ReadAction: ReadAction2,
  RealEstateAgent: RealEstateAgent2,
  RealEstateListing: RealEstateListing2,
  ReceiveAction: ReceiveAction2,
  Recipe: Recipe2,
  Recommendation: Recommendation2,
  RecommendedDoseSchedule: RecommendedDoseSchedule2,
  RecyclingCenter: RecyclingCenter2,
  RefundTypeEnumeration: RefundTypeEnumeration2,
  RegisterAction: RegisterAction2,
  RejectAction: RejectAction2,
  RentAction: RentAction2,
  RentalCarReservation: RentalCarReservation2,
  RepaymentSpecification: RepaymentSpecification2,
  ReplaceAction: ReplaceAction2,
  ReplyAction: ReplyAction2,
  Report: Report2,
  ReportageNewsArticle: ReportageNewsArticle2,
  ReportedDoseSchedule: ReportedDoseSchedule2,
  ResearchOrganization: ResearchOrganization2,
  ResearchProject: ResearchProject2,
  Researcher: Researcher2,
  Reservation: Reservation2,
  ReservationPackage: ReservationPackage2,
  ReservationStatusType: ReservationStatusType2,
  ReserveAction: ReserveAction2,
  Reservoir: Reservoir2,
  Residence: Residence2,
  Resort: Resort2,
  Restaurant: Restaurant2,
  RestrictedDiet: RestrictedDiet2,
  ResumeAction: ResumeAction2,
  ReturnAction: ReturnAction2,
  ReturnFeesEnumeration: ReturnFeesEnumeration2,
  ReturnLabelSourceEnumeration: ReturnLabelSourceEnumeration2,
  ReturnMethodEnumeration: ReturnMethodEnumeration2,
  Review: Review2,
  ReviewAction: ReviewAction2,
  ReviewNewsArticle: ReviewNewsArticle2,
  RiverBodyOfWater: RiverBodyOfWater2,
  Role: Role2,
  RoofingContractor: RoofingContractor2,
  Room: Room2,
  RsvpAction: RsvpAction2,
  RsvpResponseType: RsvpResponseType2,
  SaleEvent: SaleEvent2,
  SatiricalArticle: SatiricalArticle2,
  Schedule: Schedule3,
  ScheduleAction: ScheduleAction2,
  ScholarlyArticle: ScholarlyArticle2,
  School: School2,
  SchoolDistrict: SchoolDistrict2,
  ScreeningEvent: ScreeningEvent2,
  Sculpture: Sculpture2,
  SeaBodyOfWater: SeaBodyOfWater2,
  SearchAction: SearchAction2,
  SearchRescueOrganization: SearchRescueOrganization2,
  SearchResultsPage: SearchResultsPage2,
  Season: Season2,
  Seat: Seat2,
  SeekToAction: SeekToAction2,
  SelfStorage: SelfStorage2,
  SellAction: SellAction2,
  SendAction: SendAction2,
  Series: Series2,
  Service: Service3,
  ServiceChannel: ServiceChannel2,
  ShareAction: ShareAction2,
  SheetMusic: SheetMusic2,
  ShippingDeliveryTime: ShippingDeliveryTime2,
  ShippingRateSettings: ShippingRateSettings2,
  ShoeStore: ShoeStore2,
  ShoppingCenter: ShoppingCenter2,
  ShortStory: ShortStory2,
  SingleFamilyResidence: SingleFamilyResidence2,
  SiteNavigationElement: SiteNavigationElement2,
  SizeGroupEnumeration: SizeGroupEnumeration2,
  SizeSpecification: SizeSpecification2,
  SizeSystemEnumeration: SizeSystemEnumeration2,
  SkiResort: SkiResort2,
  SocialEvent: SocialEvent2,
  SocialMediaPosting: SocialMediaPosting2,
  SoftwareApplication: SoftwareApplication2,
  SoftwareSourceCode: SoftwareSourceCode2,
  SolveMathAction: SolveMathAction2,
  SomeProducts: SomeProducts2,
  SpeakableSpecification: SpeakableSpecification2,
  SpecialAnnouncement: SpecialAnnouncement2,
  Specialty: Specialty2,
  SportingGoodsStore: SportingGoodsStore2,
  SportsActivityLocation: SportsActivityLocation2,
  SportsClub: SportsClub2,
  SportsEvent: SportsEvent2,
  SportsOrganization: SportsOrganization2,
  SportsTeam: SportsTeam2,
  SpreadsheetDigitalDocument: SpreadsheetDigitalDocument2,
  StadiumOrArena: StadiumOrArena2,
  State: State2,
  Statement: Statement3,
  StatisticalPopulation: StatisticalPopulation2,
  StatisticalVariable: StatisticalVariable2,
  StatusEnumeration: StatusEnumeration2,
  SteeringPositionValue: SteeringPositionValue2,
  Store: Store3,
  StructuredValue: StructuredValue2,
  StupidType: StupidType2,
  SubscribeAction: SubscribeAction2,
  Substance: Substance3,
  SubwayStation: SubwayStation2,
  Suite: Suite2,
  SuperficialAnatomy: SuperficialAnatomy2,
  SurgicalProcedure: SurgicalProcedure2,
  SuspendAction: SuspendAction2,
  Syllabus: Syllabus2,
  Synagogue: Synagogue2,
  TVClip: TVClip2,
  TVEpisode: TVEpisode2,
  TVSeason: TVSeason2,
  TVSeries: TVSeries2,
  Table: Table2,
  TakeAction: TakeAction2,
  TattooParlor: TattooParlor2,
  Taxi: Taxi2,
  TaxiReservation: TaxiReservation2,
  TaxiService: TaxiService2,
  TaxiStand: TaxiStand2,
  Taxon: Taxon2,
  TechArticle: TechArticle2,
  TelevisionChannel: TelevisionChannel2,
  TelevisionStation: TelevisionStation2,
  TennisComplex: TennisComplex2,
  Text: Text2,
  TextDigitalDocument: TextDigitalDocument2,
  TextObject: TextObject2,
  TheaterEvent: TheaterEvent2,
  TheaterGroup: TheaterGroup2,
  TherapeuticProcedure: TherapeuticProcedure2,
  Thesis: Thesis2,
  Thing: Thing4,
  Ticket: Ticket2,
  TieAction: TieAction2,
  Time: Time2,
  TipAction: TipAction2,
  TireShop: TireShop2,
  TouristAttraction: TouristAttraction2,
  TouristDestination: TouristDestination2,
  TouristInformationCenter: TouristInformationCenter2,
  TouristTrip: TouristTrip2,
  ToyStore: ToyStore2,
  TrackAction: TrackAction2,
  TradeAction: TradeAction2,
  TrainReservation: TrainReservation2,
  TrainStation: TrainStation2,
  TrainTrip: TrainTrip2,
  TransferAction: TransferAction2,
  TravelAction: TravelAction2,
  TravelAgency: TravelAgency2,
  TreatmentIndication: TreatmentIndication2,
  Trip: Trip3,
  TypeAndQuantityNode: TypeAndQuantityNode2,
  UKNonprofitType: UKNonprofitType2,
  URL: URL3,
  USNonprofitType: USNonprofitType2,
  UnRegisterAction: UnRegisterAction2,
  UnitPriceSpecification: UnitPriceSpecification2,
  UpdateAction: UpdateAction2,
  UseAction: UseAction2,
  UserBlocks: UserBlocks2,
  UserCheckins: UserCheckins2,
  UserComments: UserComments2,
  UserDownloads: UserDownloads2,
  UserInteraction: UserInteraction2,
  UserLikes: UserLikes2,
  UserPageVisits: UserPageVisits2,
  UserPlays: UserPlays2,
  UserPlusOnes: UserPlusOnes2,
  UserReview: UserReview2,
  UserTweets: UserTweets2,
  VacationRental: VacationRental2,
  Vehicle: Vehicle2,
  Vein: Vein2,
  Vessel: Vessel2,
  VeterinaryCare: VeterinaryCare2,
  VideoGallery: VideoGallery2,
  VideoGame: VideoGame2,
  VideoGameClip: VideoGameClip2,
  VideoGameSeries: VideoGameSeries2,
  VideoObject: VideoObject2,
  VideoObjectSnapshot: VideoObjectSnapshot2,
  ViewAction: ViewAction2,
  VirtualLocation: VirtualLocation2,
  VisualArtsEvent: VisualArtsEvent2,
  VisualArtwork: VisualArtwork2,
  VitalSign: VitalSign2,
  Volcano: Volcano2,
  VoteAction: VoteAction2,
  WPAdBlock: WPAdBlock2,
  WPFooter: WPFooter2,
  WPHeader: WPHeader2,
  WPSideBar: WPSideBar2,
  WantAction: WantAction2,
  WarrantyPromise: WarrantyPromise2,
  WarrantyScope: WarrantyScope2,
  WatchAction: WatchAction2,
  Waterfall: Waterfall2,
  WearAction: WearAction2,
  WearableMeasurementTypeEnumeration: WearableMeasurementTypeEnumeration2,
  WearableSizeGroupEnumeration: WearableSizeGroupEnumeration2,
  WearableSizeSystemEnumeration: WearableSizeSystemEnumeration2,
  WebAPI: WebAPI2,
  WebApplication: WebApplication2,
  WebContent: WebContent2,
  WebPage: WebPage2,
  WebPageElement: WebPageElement2,
  WebSite: WebSite2,
  WholesaleStore: WholesaleStore2,
  WinAction: WinAction2,
  Winery: Winery2,
  WorkBasedProgram: WorkBasedProgram2,
  WorkersUnion: WorkersUnion2,
  WriteAction: WriteAction2,
  XPathType: XPathType2,
  Zoo: Zoo2,
  abridged: abridged2,
  abstract: abstract4,
  accelerationTime: accelerationTime2,
  acceptedAnswer: acceptedAnswer2,
  acceptedOffer: acceptedOffer2,
  acceptedPaymentMethod: acceptedPaymentMethod2,
  acceptsReservations: acceptsReservations2,
  accessCode: accessCode2,
  accessMode: accessMode2,
  accessModeSufficient: accessModeSufficient2,
  accessibilityAPI: accessibilityAPI2,
  accessibilityControl: accessibilityControl2,
  accessibilityFeature: accessibilityFeature2,
  accessibilityHazard: accessibilityHazard2,
  accessibilitySummary: accessibilitySummary2,
  accommodationCategory: accommodationCategory2,
  accommodationFloorPlan: accommodationFloorPlan2,
  accountId: accountId2,
  accountMinimumInflow: accountMinimumInflow2,
  accountOverdraftLimit: accountOverdraftLimit2,
  accountablePerson: accountablePerson2,
  acquireLicensePage: acquireLicensePage2,
  acquiredFrom: acquiredFrom2,
  acrissCode: acrissCode2,
  actionAccessibilityRequirement: actionAccessibilityRequirement2,
  actionPlatform: actionPlatform2,
  actionStatus: actionStatus2,
  actionableFeedbackPolicy: actionableFeedbackPolicy2,
  activeIngredient: activeIngredient2,
  activityDuration: activityDuration2,
  activityFrequency: activityFrequency2,
  actors: actors2,
  addOn: addOn2,
  additionalName: additionalName2,
  additionalNumberOfGuests: additionalNumberOfGuests2,
  additionalProperty: additionalProperty2,
  additionalType: additionalType2,
  additionalVariable: additionalVariable2,
  address: address4,
  addressCountry: addressCountry2,
  addressLocality: addressLocality2,
  addressRegion: addressRegion2,
  administrationRoute: administrationRoute2,
  advanceBookingRequirement: advanceBookingRequirement2,
  adverseOutcome: adverseOutcome2,
  affectedBy: affectedBy2,
  affiliation: affiliation3,
  afterMedia: afterMedia2,
  agent: agent4,
  aggregateRating: aggregateRating2,
  aircraft: aircraft2,
  albumProductionType: albumProductionType2,
  albumReleaseType: albumReleaseType2,
  albums: albums2,
  alcoholWarning: alcoholWarning2,
  algorithm: algorithm2,
  alignmentType: alignmentType2,
  alternativeHeadline: alternativeHeadline2,
  alternativeOf: alternativeOf2,
  amenityFeature: amenityFeature2,
  amount: amount4,
  amountOfThisGood: amountOfThisGood2,
  announcementLocation: announcementLocation2,
  annualPercentageRate: annualPercentageRate2,
  answerCount: answerCount2,
  answerExplanation: answerExplanation2,
  antagonist: antagonist2,
  appearance: appearance2,
  applicableCountry: applicableCountry2,
  applicableLocation: applicableLocation2,
  applicantLocationRequirements: applicantLocationRequirements2,
  application: application3,
  applicationCategory: applicationCategory2,
  applicationContact: applicationContact2,
  applicationDeadline: applicationDeadline2,
  applicationStartDate: applicationStartDate2,
  applicationSubCategory: applicationSubCategory2,
  applicationSuite: applicationSuite2,
  appliesToDeliveryMethod: appliesToDeliveryMethod2,
  appliesToPaymentMethod: appliesToPaymentMethod2,
  archivedAt: archivedAt2,
  area: area2,
  arrivalAirport: arrivalAirport2,
  arrivalBoatTerminal: arrivalBoatTerminal2,
  arrivalBusStop: arrivalBusStop2,
  arrivalGate: arrivalGate2,
  arrivalPlatform: arrivalPlatform2,
  arrivalStation: arrivalStation2,
  arrivalTerminal: arrivalTerminal2,
  arrivalTime: arrivalTime2,
  artEdition: artEdition2,
  artMedium: artMedium2,
  artform: artform2,
  articleBody: articleBody2,
  articleSection: articleSection2,
  artist: artist2,
  asin: asin2,
  aspect: aspect2,
  assembly: assembly2,
  assemblyVersion: assemblyVersion2,
  assesses: assesses2,
  associatedAnatomy: associatedAnatomy2,
  associatedArticle: associatedArticle2,
  associatedClaimReview: associatedClaimReview2,
  associatedDisease: associatedDisease2,
  associatedMedia: associatedMedia2,
  associatedMediaReview: associatedMediaReview2,
  associatedPathophysiology: associatedPathophysiology2,
  athlete: athlete2,
  attendees: attendees2,
  audienceType: audienceType2,
  audio: audio2,
  authenticator: authenticator2,
  author: author4,
  availability: availability3,
  availabilityEnds: availabilityEnds2,
  availabilityStarts: availabilityStarts2,
  availableAtOrFrom: availableAtOrFrom2,
  availableChannel: availableChannel2,
  availableDeliveryMethod: availableDeliveryMethod2,
  availableFrom: availableFrom2,
  availableIn: availableIn2,
  availableLanguage: availableLanguage2,
  availableService: availableService2,
  availableStrength: availableStrength2,
  availableTest: availableTest2,
  availableThrough: availableThrough2,
  awards: awards2,
  awayTeam: awayTeam2,
  backstory: backstory2,
  bankAccountType: bankAccountType2,
  baseSalary: baseSalary2,
  bccRecipient: bccRecipient2,
  bed: bed2,
  beforeMedia: beforeMedia2,
  beneficiaryBank: beneficiaryBank2,
  benefits: benefits2,
  benefitsSummaryUrl: benefitsSummaryUrl2,
  bestRating: bestRating2,
  billingAddress: billingAddress2,
  billingDuration: billingDuration2,
  billingIncrement: billingIncrement2,
  billingPeriod: billingPeriod2,
  billingStart: billingStart2,
  bioChemInteraction: bioChemInteraction2,
  bioChemSimilarity: bioChemSimilarity2,
  biologicalRole: biologicalRole2,
  biomechnicalClass: biomechnicalClass2,
  birthDate: birthDate3,
  birthPlace: birthPlace2,
  bitrate: bitrate2,
  blogPosts: blogPosts2,
  bloodSupply: bloodSupply2,
  boardingGroup: boardingGroup2,
  boardingPolicy: boardingPolicy2,
  bodyLocation: bodyLocation2,
  bodyType: bodyType2,
  bookEdition: bookEdition2,
  bookFormat: bookFormat2,
  bookingAgent: bookingAgent2,
  bookingTime: bookingTime2,
  borrower: borrower2,
  box: box2,
  branch: branch2,
  branchCode: branchCode2,
  branchOf: branchOf2,
  brand: brand3,
  breadcrumb: breadcrumb2,
  breastfeedingWarning: breastfeedingWarning2,
  broadcastAffiliateOf: broadcastAffiliateOf2,
  broadcastChannelId: broadcastChannelId2,
  broadcastDisplayName: broadcastDisplayName2,
  broadcastFrequency: broadcastFrequency2,
  broadcastFrequencyValue: broadcastFrequencyValue2,
  broadcastOfEvent: broadcastOfEvent2,
  broadcastServiceTier: broadcastServiceTier2,
  broadcastSignalModulation: broadcastSignalModulation2,
  broadcastSubChannel: broadcastSubChannel2,
  broadcastTimezone: broadcastTimezone2,
  broadcaster: broadcaster2,
  browserRequirements: browserRequirements2,
  busName: busName2,
  busNumber: busNumber2,
  businessDays: businessDays2,
  businessFunction: businessFunction2,
  buyer: buyer2,
  byArtist: byArtist2,
  byDay: byDay2,
  byMonth: byMonth2,
  byMonthDay: byMonthDay2,
  byMonthWeek: byMonthWeek2,
  callSign: callSign2,
  calories: calories2,
  candidate: candidate3,
  carbohydrateContent: carbohydrateContent2,
  cargoVolume: cargoVolume2,
  carrier: carrier2,
  carrierRequirements: carrierRequirements2,
  cashBack: cashBack2,
  catalog: catalog2,
  catalogNumber: catalogNumber2,
  causeOf: causeOf2,
  ccRecipient: ccRecipient2,
  character: character2,
  characterAttribute: characterAttribute2,
  characterName: characterName2,
  cheatCode: cheatCode2,
  checkinTime: checkinTime2,
  checkoutPageURLTemplate: checkoutPageURLTemplate2,
  checkoutTime: checkoutTime2,
  chemicalComposition: chemicalComposition2,
  chemicalRole: chemicalRole2,
  childMaxAge: childMaxAge2,
  childMinAge: childMinAge2,
  children: children2,
  cholesterolContent: cholesterolContent2,
  circle: circle2,
  citation: citation3,
  claimInterpreter: claimInterpreter2,
  claimReviewed: claimReviewed2,
  clincalPharmacology: clincalPharmacology2,
  clipNumber: clipNumber2,
  closes: closes2,
  coach: coach2,
  code: code3,
  codeRepository: codeRepository2,
  codeValue: codeValue2,
  codingSystem: codingSystem2,
  colleagues: colleagues2,
  collection: collection4,
  collectionSize: collectionSize2,
  color: color3,
  colorist: colorist2,
  comment: comment5,
  commentCount: commentCount2,
  commentText: commentText2,
  commentTime: commentTime2,
  competencyRequired: competencyRequired2,
  composer: composer2,
  comprisedOf: comprisedOf3,
  conditionsOfAccess: conditionsOfAccess2,
  confirmationNumber: confirmationNumber2,
  connectedTo: connectedTo2,
  constraintProperty: constraintProperty2,
  contactOption: contactOption2,
  contactPoints: contactPoints2,
  contactType: contactType2,
  contactlessPayment: contactlessPayment2,
  containedIn: containedIn2,
  contentRating: contentRating2,
  contentReferenceTime: contentReferenceTime2,
  contentSize: contentSize2,
  contentType: contentType3,
  contentUrl: contentUrl2,
  contraindication: contraindication3,
  contributor: contributor5,
  cookTime: cookTime2,
  cookingMethod: cookingMethod2,
  copyrightHolder: copyrightHolder2,
  copyrightNotice: copyrightNotice2,
  copyrightYear: copyrightYear2,
  correction: correction2,
  correctionsPolicy: correctionsPolicy2,
  costCategory: costCategory2,
  costCurrency: costCurrency2,
  costOrigin: costOrigin2,
  costPerUnit: costPerUnit2,
  countriesNotSupported: countriesNotSupported2,
  countriesSupported: countriesSupported2,
  countryOfAssembly: countryOfAssembly2,
  countryOfLastProcessing: countryOfLastProcessing2,
  countryOfOrigin: countryOfOrigin3,
  course: course2,
  courseCode: courseCode2,
  courseMode: courseMode2,
  coursePrerequisites: coursePrerequisites2,
  courseSchedule: courseSchedule2,
  courseWorkload: courseWorkload2,
  coverageEndTime: coverageEndTime2,
  coverageStartTime: coverageStartTime2,
  creativeWorkStatus: creativeWorkStatus2,
  credentialCategory: credentialCategory2,
  creditText: creditText2,
  creditedTo: creditedTo2,
  cssSelector: cssSelector2,
  currenciesAccepted: currenciesAccepted2,
  currency: currency3,
  currentExchangeRate: currentExchangeRate2,
  customer: customer2,
  customerRemorseReturnFees: customerRemorseReturnFees2,
  customerRemorseReturnLabelSource: customerRemorseReturnLabelSource2,
  customerRemorseReturnShippingFeesAmount: customerRemorseReturnShippingFeesAmount2,
  cutoffTime: cutoffTime2,
  cvdCollectionDate: cvdCollectionDate2,
  cvdFacilityCounty: cvdFacilityCounty2,
  cvdFacilityId: cvdFacilityId2,
  cvdNumBeds: cvdNumBeds2,
  cvdNumBedsOcc: cvdNumBedsOcc2,
  cvdNumC19Died: cvdNumC19Died2,
  cvdNumC19HOPats: cvdNumC19HOPats2,
  cvdNumC19HospPats: cvdNumC19HospPats2,
  cvdNumC19MechVentPats: cvdNumC19MechVentPats2,
  cvdNumC19OFMechVentPats: cvdNumC19OFMechVentPats2,
  cvdNumC19OverflowPats: cvdNumC19OverflowPats2,
  cvdNumICUBeds: cvdNumICUBeds2,
  cvdNumICUBedsOcc: cvdNumICUBedsOcc2,
  cvdNumTotBeds: cvdNumTotBeds2,
  cvdNumVent: cvdNumVent2,
  cvdNumVentUse: cvdNumVentUse2,
  dataFeedElement: dataFeedElement2,
  datasetTimeInterval: datasetTimeInterval2,
  dateDeleted: dateDeleted2,
  dateIssued: dateIssued2,
  dateModified: dateModified2,
  datePosted: datePosted2,
  datePublished: datePublished2,
  dateRead: dateRead2,
  dateReceived: dateReceived2,
  dateSent: dateSent2,
  dateVehicleFirstRegistered: dateVehicleFirstRegistered2,
  dateline: dateline2,
  dayOfWeek: dayOfWeek3,
  deathDate: deathDate2,
  deathPlace: deathPlace2,
  defaultValue: defaultValue3,
  deliveryAddress: deliveryAddress2,
  deliveryLeadTime: deliveryLeadTime2,
  deliveryMethod: deliveryMethod2,
  deliveryStatus: deliveryStatus2,
  deliveryTime: deliveryTime2,
  department: department2,
  departureAirport: departureAirport2,
  departureBoatTerminal: departureBoatTerminal2,
  departureBusStop: departureBusStop2,
  departureGate: departureGate2,
  departurePlatform: departurePlatform2,
  departureStation: departureStation2,
  departureTerminal: departureTerminal2,
  departureTime: departureTime2,
  dependencies: dependencies2,
  depth: depth2,
  device: device3,
  diagnosis: diagnosis3,
  diagram: diagram2,
  diet: diet2,
  dietFeatures: dietFeatures2,
  differentialDiagnosis: differentialDiagnosis2,
  directApply: directApply2,
  directors: directors2,
  disambiguatingDescription: disambiguatingDescription2,
  discount: discount2,
  discountCode: discountCode2,
  discountCurrency: discountCurrency2,
  discusses: discusses2,
  discussionUrl: discussionUrl2,
  diseasePreventionInfo: diseasePreventionInfo2,
  diseaseSpreadStatistics: diseaseSpreadStatistics2,
  dissolutionDate: dissolutionDate2,
  distance: distance2,
  distinguishingSign: distinguishingSign2,
  distribution: distribution2,
  diversityPolicy: diversityPolicy2,
  diversityStaffingReport: diversityStaffingReport2,
  documentation: documentation3,
  doesNotShip: doesNotShip2,
  domainIncludes: domainIncludes2,
  domiciledMortgage: domiciledMortgage2,
  doorTime: doorTime2,
  dosageForm: dosageForm2,
  doseSchedule: doseSchedule2,
  doseUnit: doseUnit2,
  doseValue: doseValue2,
  downPayment: downPayment2,
  downloadUrl: downloadUrl2,
  downvoteCount: downvoteCount2,
  drainsTo: drainsTo2,
  driveWheelConfiguration: driveWheelConfiguration2,
  dropoffLocation: dropoffLocation2,
  dropoffTime: dropoffTime2,
  drug: drug2,
  drugClass: drugClass2,
  drugUnit: drugUnit2,
  duns: duns2,
  duplicateTherapy: duplicateTherapy2,
  durationOfWarranty: durationOfWarranty2,
  duringMedia: duringMedia2,
  earlyPrepaymentPenalty: earlyPrepaymentPenalty2,
  editEIDR: editEIDR2,
  editor: editor3,
  eduQuestionType: eduQuestionType2,
  educationRequirements: educationRequirements2,
  educationalAlignment: educationalAlignment2,
  educationalCredentialAwarded: educationalCredentialAwarded2,
  educationalFramework: educationalFramework2,
  educationalLevel: educationalLevel2,
  educationalProgramMode: educationalProgramMode2,
  educationalRole: educationalRole2,
  educationalUse: educationalUse2,
  elevation: elevation2,
  eligibilityToWorkRequirement: eligibilityToWorkRequirement2,
  eligibleCustomerType: eligibleCustomerType2,
  eligibleDuration: eligibleDuration2,
  eligibleQuantity: eligibleQuantity2,
  eligibleRegion: eligibleRegion2,
  eligibleTransactionVolume: eligibleTransactionVolume2,
  email: email2,
  embedUrl: embedUrl2,
  embeddedTextCaption: embeddedTextCaption2,
  emissionsCO2: emissionsCO22,
  employees: employees2,
  employerOverview: employerOverview2,
  employmentType: employmentType2,
  employmentUnit: employmentUnit2,
  encodingType: encodingType2,
  encodings: encodings2,
  endDate: endDate3,
  endOffset: endOffset2,
  endTime: endTime3,
  endorsee: endorsee2,
  endorsers: endorsers2,
  energyEfficiencyScaleMax: energyEfficiencyScaleMax2,
  energyEfficiencyScaleMin: energyEfficiencyScaleMin2,
  engineDisplacement: engineDisplacement2,
  enginePower: enginePower2,
  engineType: engineType2,
  entertainmentBusiness: entertainmentBusiness2,
  epidemiology: epidemiology2,
  episodeNumber: episodeNumber2,
  episodes: episodes2,
  equal: equal2,
  error: error3,
  estimatedCost: estimatedCost2,
  estimatedFlightDuration: estimatedFlightDuration2,
  estimatedSalary: estimatedSalary2,
  estimatesRiskOf: estimatesRiskOf2,
  ethicsPolicy: ethicsPolicy2,
  eventAttendanceMode: eventAttendanceMode2,
  eventSchedule: eventSchedule2,
  eventStatus: eventStatus2,
  events: events2,
  evidenceLevel: evidenceLevel2,
  evidenceOrigin: evidenceOrigin2,
  exceptDate: exceptDate2,
  exchangeRateSpread: exchangeRateSpread2,
  exercisePlan: exercisePlan2,
  exerciseRelatedDiet: exerciseRelatedDiet2,
  exerciseType: exerciseType2,
  exifData: exifData2,
  expectedArrivalFrom: expectedArrivalFrom2,
  expectedArrivalUntil: expectedArrivalUntil2,
  expectedPrognosis: expectedPrognosis2,
  expectsAcceptanceOf: expectsAcceptanceOf2,
  experienceInPlaceOfEducation: experienceInPlaceOfEducation2,
  experienceRequirements: experienceRequirements2,
  expertConsiderations: expertConsiderations2,
  expires: expires2,
  expressedIn: expressedIn2,
  familyName: familyName2,
  fatContent: fatContent2,
  faxNumber: faxNumber2,
  featureList: featureList2,
  feesAndCommissionsSpecification: feesAndCommissionsSpecification2,
  fiberContent: fiberContent2,
  fileFormat: fileFormat2,
  fileSize: fileSize2,
  financialAidEligible: financialAidEligible2,
  firstAppearance: firstAppearance2,
  firstPerformance: firstPerformance2,
  flightDistance: flightDistance2,
  flightNumber: flightNumber2,
  floorLevel: floorLevel2,
  floorLimit: floorLimit2,
  floorSize: floorSize2,
  followee: followee2,
  follows: follows2,
  followup: followup2,
  foodEstablishment: foodEstablishment2,
  foodEvent: foodEvent2,
  foodWarning: foodWarning2,
  founders: founders2,
  foundingDate: foundingDate2,
  foundingLocation: foundingLocation2,
  free: free2,
  freeShippingThreshold: freeShippingThreshold2,
  fromLocation: fromLocation2,
  fuelCapacity: fuelCapacity2,
  fuelConsumption: fuelConsumption2,
  fuelEfficiency: fuelEfficiency2,
  fuelType: fuelType2,
  functionalClass: functionalClass2,
  funder: funder3,
  gameAvailabilityType: gameAvailabilityType2,
  gameEdition: gameEdition2,
  gameItem: gameItem2,
  gameLocation: gameLocation2,
  gamePlatform: gamePlatform2,
  gameTip: gameTip2,
  gender: gender4,
  geo: geo3,
  geoContains: geoContains2,
  geoCoveredBy: geoCoveredBy2,
  geoCovers: geoCovers2,
  geoCrosses: geoCrosses2,
  geoDisjoint: geoDisjoint2,
  geoEquals: geoEquals2,
  geoIntersects: geoIntersects2,
  geoMidpoint: geoMidpoint2,
  geoOverlaps: geoOverlaps2,
  geoRadius: geoRadius2,
  geoTouches: geoTouches2,
  geoWithin: geoWithin2,
  geographicArea: geographicArea2,
  gettingTestedInfo: gettingTestedInfo2,
  givenName: givenName2,
  globalLocationNumber: globalLocationNumber2,
  governmentBenefitsInfo: governmentBenefitsInfo2,
  gracePeriod: gracePeriod2,
  grantee: grantee3,
  greater: greater2,
  greaterOrEqual: greaterOrEqual2,
  gtin12: gtin122,
  gtin13: gtin132,
  gtin14: gtin142,
  gtin8: gtin82,
  guideline: guideline3,
  guidelineDate: guidelineDate2,
  guidelineSubject: guidelineSubject2,
  handlingTime: handlingTime2,
  hasAdultConsideration: hasAdultConsideration2,
  hasBioPolymerSequence: hasBioPolymerSequence2,
  hasCategoryCode: hasCategoryCode2,
  hasCourse: hasCourse2,
  hasCourseInstance: hasCourseInstance2,
  hasCredential: hasCredential2,
  hasDeliveryMethod: hasDeliveryMethod2,
  hasDigitalDocumentPermission: hasDigitalDocumentPermission2,
  hasDriveThroughService: hasDriveThroughService2,
  hasEnergyConsumptionDetails: hasEnergyConsumptionDetails2,
  hasEnergyEfficiencyCategory: hasEnergyEfficiencyCategory2,
  hasHealthAspect: hasHealthAspect2,
  hasMeasurement: hasMeasurement2,
  hasMenuItem: hasMenuItem2,
  hasMenuSection: hasMenuSection2,
  hasMolecularFunction: hasMolecularFunction2,
  hasOccupation: hasOccupation2,
  hasOfferCatalog: hasOfferCatalog2,
  hasPOS: hasPOS2,
  hasProductReturnPolicy: hasProductReturnPolicy2,
  headline: headline2,
  healthCondition: healthCondition2,
  healthPlanCoinsuranceOption: healthPlanCoinsuranceOption2,
  healthPlanCoinsuranceRate: healthPlanCoinsuranceRate2,
  healthPlanCopay: healthPlanCopay2,
  healthPlanCopayOption: healthPlanCopayOption2,
  healthPlanCostSharing: healthPlanCostSharing2,
  healthPlanDrugOption: healthPlanDrugOption2,
  healthPlanDrugTier: healthPlanDrugTier2,
  healthPlanId: healthPlanId2,
  healthPlanMarketingUrl: healthPlanMarketingUrl2,
  healthPlanNetworkId: healthPlanNetworkId2,
  healthPlanNetworkTier: healthPlanNetworkTier2,
  healthPlanPharmacyCategory: healthPlanPharmacyCategory2,
  healthcareReportingData: healthcareReportingData2,
  height: height4,
  highPrice: highPrice2,
  hiringOrganization: hiringOrganization2,
  homeLocation: homeLocation2,
  homeTeam: homeTeam2,
  honorificPrefix: honorificPrefix2,
  honorificSuffix: honorificSuffix2,
  hospitalAffiliation: hospitalAffiliation2,
  hostingOrganization: hostingOrganization2,
  hoursAvailable: hoursAvailable2,
  howPerformed: howPerformed2,
  httpMethod: httpMethod2,
  iataCode: iataCode2,
  icaoCode: icaoCode2,
  identifyingExam: identifyingExam2,
  identifyingTest: identifyingTest2,
  illustrator: illustrator2,
  imagingTechnique: imagingTechnique2,
  inAlbum: inAlbum2,
  inBroadcastLineup: inBroadcastLineup2,
  inChI: inChI2,
  inChIKey: inChIKey2,
  inCodeSet: inCodeSet2,
  inPlaylist: inPlaylist2,
  inProductGroupWithID: inProductGroupWithID2,
  inStoreReturnsOffered: inStoreReturnsOffered2,
  inSupportOf: inSupportOf2,
  incentives: incentives2,
  includedComposition: includedComposition2,
  includedDataCatalog: includedDataCatalog2,
  includedInHealthInsurancePlan: includedInHealthInsurancePlan2,
  includedRiskFactor: includedRiskFactor2,
  includesAttraction: includesAttraction2,
  includesHealthPlanFormulary: includesHealthPlanFormulary2,
  includesHealthPlanNetwork: includesHealthPlanNetwork2,
  includesObject: includesObject2,
  increasesRiskOf: increasesRiskOf2,
  industry: industry2,
  ineligibleRegion: ineligibleRegion2,
  infectiousAgent: infectiousAgent2,
  infectiousAgentClass: infectiousAgentClass2,
  ingredients: ingredients2,
  inker: inker2,
  insertion: insertion2,
  installUrl: installUrl2,
  instructor: instructor2,
  intensity: intensity2,
  interactingDrug: interactingDrug2,
  interactionCount: interactionCount2,
  interactionService: interactionService2,
  interactionType: interactionType2,
  interactivityType: interactivityType2,
  interestRate: interestRate2,
  interpretedAsClaim: interpretedAsClaim2,
  inventoryLevel: inventoryLevel2,
  inverseOf: inverseOf3,
  isAcceptingNewPatients: isAcceptingNewPatients2,
  isAccessoryOrSparePartFor: isAccessoryOrSparePartFor2,
  isAvailableGenerically: isAvailableGenerically2,
  isBasedOnUrl: isBasedOnUrl2,
  isConsumableFor: isConsumableFor2,
  isFamilyFriendly: isFamilyFriendly2,
  isGift: isGift2,
  isInvolvedInBiologicalProcess: isInvolvedInBiologicalProcess2,
  isLiveBroadcast: isLiveBroadcast2,
  isLocatedInSubcellularLocation: isLocatedInSubcellularLocation2,
  isPlanForApartment: isPlanForApartment2,
  isProprietary: isProprietary2,
  isRelatedTo: isRelatedTo2,
  isResizable: isResizable2,
  isSimilarTo: isSimilarTo2,
  isUnlabelledFallback: isUnlabelledFallback2,
  isbn: isbn2,
  isicV4: isicV42,
  iso6523Code: iso6523Code2,
  isrcCode: isrcCode2,
  issn: issn2,
  issueNumber: issueNumber2,
  issuedBy: issuedBy2,
  issuedThrough: issuedThrough2,
  iswcCode: iswcCode2,
  item: item3,
  itemCondition: itemCondition2,
  itemDefectReturnFees: itemDefectReturnFees2,
  itemDefectReturnLabelSource: itemDefectReturnLabelSource2,
  itemDefectReturnShippingFeesAmount: itemDefectReturnShippingFeesAmount2,
  itemListElement: itemListElement2,
  itemListOrder: itemListOrder2,
  itemLocation: itemLocation2,
  itemReviewed: itemReviewed2,
  itemShipped: itemShipped2,
  itinerary: itinerary2,
  iupacName: iupacName2,
  jobImmediateStart: jobImmediateStart2,
  jobLocation: jobLocation2,
  jobLocationType: jobLocationType2,
  jobStartDate: jobStartDate2,
  jobTitle: jobTitle2,
  keywords: keywords2,
  knownVehicleDamages: knownVehicleDamages2,
  knows: knows3,
  knowsAbout: knowsAbout2,
  knowsLanguage: knowsLanguage2,
  labelDetails: labelDetails2,
  landlord: landlord2,
  language: language6,
  lastReviewed: lastReviewed2,
  latitude: latitude4,
  layoutImage: layoutImage2,
  learningResourceType: learningResourceType2,
  leaseLength: leaseLength2,
  legalName: legalName2,
  legalStatus: legalStatus2,
  legislationChanges: legislationChanges2,
  legislationConsolidates: legislationConsolidates2,
  legislationDate: legislationDate2,
  legislationDateVersion: legislationDateVersion2,
  legislationIdentifier: legislationIdentifier2,
  legislationJurisdiction: legislationJurisdiction2,
  legislationLegalForce: legislationLegalForce2,
  legislationLegalValue: legislationLegalValue2,
  legislationPassedBy: legislationPassedBy2,
  legislationResponsible: legislationResponsible2,
  legislationTransposes: legislationTransposes2,
  legislationType: legislationType2,
  leiCode: leiCode2,
  lender: lender2,
  lesser: lesser2,
  lesserOrEqual: lesserOrEqual2,
  letterer: letterer2,
  license: license4,
  line: line3,
  linkRelationship: linkRelationship2,
  liveBlogUpdate: liveBlogUpdate2,
  loanMortgageMandateAmount: loanMortgageMandateAmount2,
  loanPaymentAmount: loanPaymentAmount2,
  loanPaymentFrequency: loanPaymentFrequency2,
  loanRepaymentForm: loanRepaymentForm2,
  loanTerm: loanTerm2,
  loanType: loanType2,
  locationCreated: locationCreated2,
  lodgingUnitDescription: lodgingUnitDescription2,
  lodgingUnitType: lodgingUnitType2,
  logo: logo3,
  longitude: longitude4,
  loser: loser2,
  lowPrice: lowPrice2,
  lyricist: lyricist2,
  lyrics: lyrics2,
  maintainer: maintainer2,
  manufacturer: manufacturer3,
  map: map4,
  mapType: mapType2,
  maps: maps2,
  marginOfError: marginOfError2,
  masthead: masthead2,
  materialExtent: materialExtent2,
  mathExpression: mathExpression2,
  maxPrice: maxPrice2,
  maxValue: maxValue3,
  maximumAttendeeCapacity: maximumAttendeeCapacity2,
  maximumEnrollment: maximumEnrollment2,
  maximumIntake: maximumIntake2,
  maximumPhysicalAttendeeCapacity: maximumPhysicalAttendeeCapacity2,
  maximumVirtualAttendeeCapacity: maximumVirtualAttendeeCapacity2,
  mealService: mealService2,
  measuredProperty: measuredProperty2,
  measurementDenominator: measurementDenominator2,
  measurementMethod: measurementMethod2,
  measurementQualifier: measurementQualifier2,
  mechanismOfAction: mechanismOfAction2,
  mediaAuthenticityCategory: mediaAuthenticityCategory2,
  mediaItemAppearance: mediaItemAppearance2,
  median: median2,
  medicalAudience: medicalAudience2,
  medicalSpecialty: medicalSpecialty2,
  medicineSystem: medicineSystem2,
  meetsEmissionStandard: meetsEmissionStandard2,
  members: members3,
  membershipNumber: membershipNumber2,
  membershipPointsEarned: membershipPointsEarned2,
  memoryRequirements: memoryRequirements2,
  mentions: mentions2,
  menu: menu2,
  menuAddOn: menuAddOn2,
  merchant: merchant2,
  messageAttachment: messageAttachment2,
  mileageFromOdometer: mileageFromOdometer2,
  minPrice: minPrice2,
  minValue: minValue3,
  minimumPaymentDue: minimumPaymentDue2,
  missionCoveragePrioritiesPolicy: missionCoveragePrioritiesPolicy2,
  mobileUrl: mobileUrl2,
  model: model2,
  modelDate: modelDate2,
  modifiedTime: modifiedTime2,
  molecularFormula: molecularFormula3,
  molecularWeight: molecularWeight3,
  monoisotopicMolecularWeight: monoisotopicMolecularWeight2,
  monthlyMinimumRepaymentAmount: monthlyMinimumRepaymentAmount2,
  monthsOfExperience: monthsOfExperience2,
  mpn: mpn2,
  multipleValues: multipleValues2,
  muscleAction: muscleAction2,
  musicArrangement: musicArrangement2,
  musicBy: musicBy2,
  musicCompositionForm: musicCompositionForm2,
  musicGroupMember: musicGroupMember2,
  musicReleaseFormat: musicReleaseFormat2,
  musicalKey: musicalKey2,
  naics: naics2,
  name: name5,
  namedPosition: namedPosition2,
  nationality: nationality2,
  naturalProgression: naturalProgression2,
  negativeNotes: negativeNotes2,
  nerve: nerve2,
  nerveMotor: nerveMotor2,
  netWorth: netWorth2,
  newsUpdatesAndGuidelines: newsUpdatesAndGuidelines2,
  nextItem: nextItem2,
  noBylinesPolicy: noBylinesPolicy2,
  nonEqual: nonEqual2,
  nonProprietaryName: nonProprietaryName2,
  nonprofitStatus: nonprofitStatus2,
  normalRange: normalRange2,
  nsn: nsn2,
  numAdults: numAdults2,
  numChildren: numChildren2,
  numConstraints: numConstraints2,
  numTracks: numTracks2,
  numberOfAccommodationUnits: numberOfAccommodationUnits2,
  numberOfAirbags: numberOfAirbags2,
  numberOfAvailableAccommodationUnits: numberOfAvailableAccommodationUnits2,
  numberOfAxles: numberOfAxles2,
  numberOfBathroomsTotal: numberOfBathroomsTotal2,
  numberOfBedrooms: numberOfBedrooms2,
  numberOfBeds: numberOfBeds2,
  numberOfCredits: numberOfCredits2,
  numberOfDoors: numberOfDoors2,
  numberOfEmployees: numberOfEmployees2,
  numberOfEpisodes: numberOfEpisodes2,
  numberOfForwardGears: numberOfForwardGears2,
  numberOfFullBathrooms: numberOfFullBathrooms2,
  numberOfItems: numberOfItems2,
  numberOfLoanPayments: numberOfLoanPayments2,
  numberOfPages: numberOfPages2,
  numberOfPartialBathrooms: numberOfPartialBathrooms2,
  numberOfPlayers: numberOfPlayers2,
  numberOfPreviousOwners: numberOfPreviousOwners2,
  numberOfRooms: numberOfRooms2,
  numberOfSeasons: numberOfSeasons2,
  numberedPosition: numberedPosition2,
  nutrition: nutrition2,
  observationAbout: observationAbout2,
  observationDate: observationDate2,
  observationPeriod: observationPeriod2,
  occupancy: occupancy2,
  occupationLocation: occupationLocation2,
  occupationalCategory: occupationalCategory2,
  occupationalCredentialAwarded: occupationalCredentialAwarded2,
  offerCount: offerCount2,
  offersPrescriptionByMail: offersPrescriptionByMail2,
  openingHours: openingHours2,
  openingHoursSpecification: openingHoursSpecification2,
  opens: opens2,
  operatingSystem: operatingSystem2,
  opponent: opponent2,
  option: option4,
  orderDate: orderDate2,
  orderDelivery: orderDelivery2,
  orderItemNumber: orderItemNumber2,
  orderItemStatus: orderItemStatus2,
  orderNumber: orderNumber2,
  orderQuantity: orderQuantity2,
  orderStatus: orderStatus2,
  orderedItem: orderedItem2,
  organizer: organizer3,
  originAddress: originAddress2,
  originalMediaContextDescription: originalMediaContextDescription2,
  originalMediaLink: originalMediaLink2,
  originatesFrom: originatesFrom2,
  overdosage: overdosage2,
  ownedFrom: ownedFrom2,
  ownedThrough: ownedThrough2,
  ownershipFundingInfo: ownershipFundingInfo2,
  owns: owns2,
  pageEnd: pageEnd2,
  pageStart: pageStart2,
  pagination: pagination2,
  parentItem: parentItem2,
  parentService: parentService2,
  parents: parents2,
  partOfEpisode: partOfEpisode2,
  partOfInvoice: partOfInvoice2,
  partOfOrder: partOfOrder2,
  partOfSeason: partOfSeason2,
  partOfSystem: partOfSystem2,
  partOfTVSeries: partOfTVSeries2,
  partySize: partySize2,
  passengerPriorityStatus: passengerPriorityStatus2,
  passengerSequenceNumber: passengerSequenceNumber2,
  pathophysiology: pathophysiology2,
  pattern: pattern3,
  payload: payload3,
  paymentAccepted: paymentAccepted2,
  paymentDue: paymentDue2,
  paymentMethod: paymentMethod2,
  paymentMethodId: paymentMethodId2,
  paymentStatus: paymentStatus3,
  paymentUrl: paymentUrl2,
  penciler: penciler2,
  percentile10: percentile102,
  percentile25: percentile252,
  percentile75: percentile752,
  percentile90: percentile902,
  performerIn: performerIn2,
  performers: performers2,
  permissionType: permissionType2,
  permissions: permissions2,
  permitAudience: permitAudience2,
  permittedUsage: permittedUsage2,
  petsAllowed: petsAllowed2,
  phoneticText: phoneticText2,
  photos: photos2,
  physicalRequirement: physicalRequirement2,
  physiologicalBenefits: physiologicalBenefits2,
  pickupLocation: pickupLocation2,
  pickupTime: pickupTime2,
  playMode: playMode2,
  playerType: playerType2,
  playersOnline: playersOnline2,
  polygon: polygon2,
  populationType: populationType2,
  positiveNotes: positiveNotes2,
  possibleComplication: possibleComplication2,
  possibleTreatment: possibleTreatment2,
  postOfficeBoxNumber: postOfficeBoxNumber2,
  postOp: postOp2,
  postalCode: postalCode3,
  postalCodeBegin: postalCodeBegin2,
  postalCodeEnd: postalCodeEnd2,
  postalCodePrefix: postalCodePrefix2,
  postalCodeRange: postalCodeRange2,
  potentialAction: potentialAction2,
  potentialUse: potentialUse2,
  preOp: preOp2,
  predecessorOf: predecessorOf2,
  pregnancyCategory: pregnancyCategory2,
  pregnancyWarning: pregnancyWarning2,
  prepTime: prepTime2,
  preparation: preparation3,
  prescribingInfo: prescribingInfo2,
  prescriptionStatus: prescriptionStatus2,
  previousItem: previousItem2,
  previousStartDate: previousStartDate2,
  price: price2,
  priceComponent: priceComponent3,
  priceComponentType: priceComponentType2,
  priceCurrency: priceCurrency2,
  priceRange: priceRange2,
  priceSpecification: priceSpecification2,
  priceType: priceType2,
  priceValidUntil: priceValidUntil2,
  primaryImageOfPage: primaryImageOfPage2,
  primaryPrevention: primaryPrevention2,
  printColumn: printColumn2,
  printEdition: printEdition2,
  printPage: printPage2,
  printSection: printSection2,
  procedure: procedure3,
  procedureType: procedureType2,
  processingTime: processingTime2,
  processorRequirements: processorRequirements2,
  producer: producer2,
  produces: produces2,
  productGroupID: productGroupID2,
  productID: productID2,
  productReturnDays: productReturnDays2,
  productReturnLink: productReturnLink2,
  productSupported: productSupported2,
  productionCompany: productionCompany2,
  productionDate: productionDate2,
  proficiencyLevel: proficiencyLevel2,
  programMembershipUsed: programMembershipUsed2,
  programName: programName2,
  programPrerequisites: programPrerequisites2,
  programType: programType2,
  programmingLanguage: programmingLanguage2,
  programmingModel: programmingModel2,
  propertyID: propertyID2,
  proprietaryName: proprietaryName2,
  proteinContent: proteinContent2,
  providerMobility: providerMobility2,
  providesService: providesService2,
  publicAccess: publicAccess2,
  publicTransportClosuresInfo: publicTransportClosuresInfo2,
  publication: publication2,
  publicationType: publicationType2,
  publishedBy: publishedBy2,
  publishedOn: publishedOn2,
  publisher: publisher5,
  publisherImprint: publisherImprint2,
  purchaseDate: purchaseDate2,
  qualifications: qualifications2,
  quarantineGuidelines: quarantineGuidelines2,
  query: query3,
  quest: quest2,
  question: question3,
  rangeIncludes: rangeIncludes2,
  ratingCount: ratingCount2,
  ratingExplanation: ratingExplanation2,
  ratingValue: ratingValue2,
  readBy: readBy2,
  readonlyValue: readonlyValue2,
  realEstateAgent: realEstateAgent2,
  recipe: recipe2,
  recipeCategory: recipeCategory2,
  recipeCuisine: recipeCuisine2,
  recipeInstructions: recipeInstructions2,
  recipeYield: recipeYield2,
  recognizedBy: recognizedBy2,
  recognizingAuthority: recognizingAuthority2,
  recommendationStrength: recommendationStrength2,
  recommendedIntake: recommendedIntake2,
  recordLabel: recordLabel2,
  recourseLoan: recourseLoan2,
  referenceQuantity: referenceQuantity2,
  referencesOrder: referencesOrder2,
  refundType: refundType2,
  regionDrained: regionDrained2,
  regionsAllowed: regionsAllowed2,
  relatedAnatomy: relatedAnatomy2,
  relatedCondition: relatedCondition2,
  relatedDrug: relatedDrug2,
  relatedLink: relatedLink2,
  relatedStructure: relatedStructure2,
  relatedTherapy: relatedTherapy2,
  relatedTo: relatedTo3,
  releaseDate: releaseDate3,
  releaseNotes: releaseNotes2,
  releasedEvent: releasedEvent2,
  relevantOccupation: relevantOccupation2,
  relevantSpecialty: relevantSpecialty2,
  remainingAttendeeCapacity: remainingAttendeeCapacity2,
  renegotiableLoan: renegotiableLoan2,
  repeatCount: repeatCount2,
  repeatFrequency: repeatFrequency2,
  repetitions: repetitions3,
  replacee: replacee2,
  replacer: replacer2,
  replyToUrl: replyToUrl2,
  reportNumber: reportNumber2,
  representativeOfPage: representativeOfPage2,
  requiredCollateral: requiredCollateral2,
  requiredGender: requiredGender2,
  requiredMaxAge: requiredMaxAge2,
  requiredMinAge: requiredMinAge2,
  requiredQuantity: requiredQuantity2,
  requirements: requirements3,
  requiresSubscription: requiresSubscription2,
  reservationFor: reservationFor2,
  reservationId: reservationId2,
  reservationStatus: reservationStatus2,
  reservedTicket: reservedTicket2,
  responsibilities: responsibilities2,
  restPeriods: restPeriods2,
  restockingFee: restockingFee2,
  resultComment: resultComment2,
  resultReview: resultReview2,
  returnFees: returnFees2,
  returnLabelSource: returnLabelSource2,
  returnMethod: returnMethod2,
  returnPolicyCategory: returnPolicyCategory2,
  returnPolicyCountry: returnPolicyCountry2,
  returnPolicySeasonalOverride: returnPolicySeasonalOverride2,
  returnShippingFeesAmount: returnShippingFeesAmount2,
  reviewAspect: reviewAspect2,
  reviewBody: reviewBody2,
  reviewCount: reviewCount2,
  reviewRating: reviewRating2,
  reviewedBy: reviewedBy2,
  reviews: reviews2,
  riskFactor: riskFactor2,
  risks: risks2,
  roofLoad: roofLoad2,
  rsvpResponse: rsvpResponse2,
  runsTo: runsTo2,
  runtime: runtime2,
  rxcui: rxcui2,
  safetyConsideration: safetyConsideration2,
  salaryCurrency: salaryCurrency2,
  salaryUponCompletion: salaryUponCompletion2,
  sameAs: sameAs3,
  sampleType: sampleType2,
  saturatedFatContent: saturatedFatContent2,
  scheduleTimezone: scheduleTimezone2,
  scheduledPaymentDate: scheduledPaymentDate2,
  scheduledTime: scheduledTime2,
  schemaVersion: schemaVersion2,
  schoolClosuresInfo: schoolClosuresInfo2,
  screenCount: screenCount2,
  screenshot: screenshot2,
  sdDatePublished: sdDatePublished2,
  sdLicense: sdLicense2,
  sdPublisher: sdPublisher2,
  seasonNumber: seasonNumber2,
  seasons: seasons2,
  seatNumber: seatNumber2,
  seatRow: seatRow2,
  seatSection: seatSection2,
  seatingCapacity: seatingCapacity2,
  seatingType: seatingType2,
  secondaryPrevention: secondaryPrevention2,
  securityClearanceRequirement: securityClearanceRequirement2,
  securityScreening: securityScreening2,
  seeks: seeks2,
  sender: sender3,
  sensoryRequirement: sensoryRequirement2,
  sensoryUnit: sensoryUnit2,
  seriousAdverseOutcome: seriousAdverseOutcome2,
  serverStatus: serverStatus2,
  servesCuisine: servesCuisine2,
  serviceAudience: serviceAudience2,
  serviceLocation: serviceLocation2,
  serviceOperator: serviceOperator2,
  servicePhone: servicePhone2,
  servicePostalAddress: servicePostalAddress2,
  serviceSmsNumber: serviceSmsNumber2,
  serviceType: serviceType3,
  serviceUrl: serviceUrl2,
  servingSize: servingSize2,
  sha256: sha2562,
  sharedContent: sharedContent2,
  shippingDestination: shippingDestination2,
  shippingDetails: shippingDetails2,
  shippingLabel: shippingLabel2,
  shippingOrigin: shippingOrigin2,
  shippingRate: shippingRate2,
  shippingSettingsLink: shippingSettingsLink2,
  siblings: siblings2,
  signDetected: signDetected2,
  signOrSymptom: signOrSymptom2,
  significance: significance2,
  significantLinks: significantLinks2,
  size: size3,
  sizeGroup: sizeGroup2,
  sizeSystem: sizeSystem2,
  skills: skills2,
  sku: sku2,
  slogan: slogan2,
  smiles: smiles2,
  smokingAllowed: smokingAllowed2,
  sodiumContent: sodiumContent2,
  softwareAddOn: softwareAddOn2,
  softwareHelp: softwareHelp2,
  softwareVersion: softwareVersion2,
  sourceOrganization: sourceOrganization2,
  sourcedFrom: sourcedFrom2,
  spatial: spatial3,
  speakable: speakable2,
  specialCommitments: specialCommitments2,
  specialOpeningHoursSpecification: specialOpeningHoursSpecification2,
  specialty: specialty3,
  speechToTextMarkup: speechToTextMarkup2,
  speed: speed2,
  spokenByCharacter: spokenByCharacter2,
  sport: sport2,
  sportsActivityLocation: sportsActivityLocation2,
  sportsEvent: sportsEvent2,
  sportsTeam: sportsTeam2,
  spouse: spouse2,
  stage: stage3,
  stageAsNumber: stageAsNumber2,
  starRating: starRating2,
  startDate: startDate3,
  startOffset: startOffset2,
  startTime: startTime3,
  statType: statType2,
  status: status6,
  steeringPosition: steeringPosition2,
  stepValue: stepValue2,
  steps: steps2,
  storageRequirements: storageRequirements2,
  streetAddress: streetAddress2,
  strengthUnit: strengthUnit2,
  strengthValue: strengthValue2,
  structuralClass: structuralClass2,
  study: study3,
  studyDesign: studyDesign3,
  studyLocation: studyLocation2,
  studySubject: studySubject2,
  stupidProperty: stupidProperty2,
  subEvents: subEvents2,
  subReservation: subReservation2,
  subStageSuffix: subStageSuffix2,
  subStructure: subStructure2,
  subTest: subTest2,
  subtitleLanguage: subtitleLanguage2,
  successorOf: successorOf2,
  sugarContent: sugarContent2,
  suggestedAge: suggestedAge2,
  suggestedGender: suggestedGender2,
  suggestedMaxAge: suggestedMaxAge2,
  suggestedMeasurement: suggestedMeasurement2,
  suggestedMinAge: suggestedMinAge2,
  suitableForDiet: suitableForDiet2,
  supersededBy: supersededBy2,
  supplyTo: supplyTo2,
  supportingData: supportingData2,
  surface: surface2,
  syllabusSections: syllabusSections2,
  target: target4,
  targetDescription: targetDescription2,
  targetName: targetName2,
  targetPlatform: targetPlatform2,
  targetPopulation: targetPopulation2,
  targetProduct: targetProduct2,
  targetUrl: targetUrl2,
  taxID: taxID2,
  taxonRank: taxonRank2,
  taxonomicRange: taxonomicRange2,
  teaches: teaches2,
  telephone: telephone2,
  temporal: temporal3,
  termDuration: termDuration2,
  termsOfService: termsOfService2,
  termsPerYear: termsPerYear2,
  text: text3,
  textValue: textValue2,
  thumbnail: thumbnail3,
  thumbnailUrl: thumbnailUrl2,
  tickerSymbol: tickerSymbol2,
  ticketNumber: ticketNumber2,
  ticketToken: ticketToken2,
  ticketedSeat: ticketedSeat2,
  timeOfDay: timeOfDay3,
  timeRequired: timeRequired2,
  timeToComplete: timeToComplete2,
  tissueSample: tissueSample2,
  title: title7,
  titleEIDR: titleEIDR2,
  toLocation: toLocation2,
  toRecipient: toRecipient2,
  tocContinuation: tocContinuation2,
  tocEntry: tocEntry2,
  tongueWeight: tongueWeight2,
  tool: tool2,
  torque: torque2,
  totalHistoricalEnrollment: totalHistoricalEnrollment2,
  totalJobOpenings: totalJobOpenings2,
  totalPaymentDue: totalPaymentDue2,
  totalPrice: totalPrice2,
  totalTime: totalTime2,
  tourBookingPage: tourBookingPage2,
  touristType: touristType2,
  trackingNumber: trackingNumber2,
  trackingUrl: trackingUrl2,
  tracks: tracks2,
  trailer: trailer2,
  trailerWeight: trailerWeight2,
  trainName: trainName2,
  trainNumber: trainNumber2,
  trainingSalary: trainingSalary2,
  transFatContent: transFatContent2,
  transcript: transcript2,
  transitTime: transitTime2,
  transitTimeLabel: transitTimeLabel2,
  translator: translator2,
  transmissionMethod: transmissionMethod2,
  travelBans: travelBans2,
  trialDesign: trialDesign2,
  tributary: tributary2,
  tripOrigin: tripOrigin2,
  typeOfBed: typeOfBed2,
  typeOfGood: typeOfGood2,
  typicalAgeRange: typicalAgeRange2,
  typicalCreditsPerTerm: typicalCreditsPerTerm2,
  typicalTest: typicalTest2,
  underName: underName2,
  unitCode: unitCode2,
  unitText: unitText2,
  unnamedSourcesPolicy: unnamedSourcesPolicy2,
  unsaturatedFatContent: unsaturatedFatContent2,
  uploadDate: uploadDate2,
  upvoteCount: upvoteCount2,
  url: url5,
  urlTemplate: urlTemplate2,
  usedToDiagnose: usedToDiagnose2,
  userInteractionCount: userInteractionCount2,
  usesDevice: usesDevice2,
  usesHealthPlanIdStandard: usesHealthPlanIdStandard2,
  utterances: utterances2,
  validFor: validFor2,
  validFrom: validFrom2,
  validIn: validIn2,
  validThrough: validThrough2,
  validUntil: validUntil2,
  value: value4,
  valueAddedTaxIncluded: valueAddedTaxIncluded2,
  valueMaxLength: valueMaxLength2,
  valueMinLength: valueMinLength2,
  valueName: valueName2,
  valuePattern: valuePattern2,
  valueReference: valueReference2,
  valueRequired: valueRequired2,
  variableMeasured: variableMeasured2,
  variablesMeasured: variablesMeasured2,
  variantCover: variantCover2,
  variesBy: variesBy2,
  vatID: vatID2,
  vehicleConfiguration: vehicleConfiguration2,
  vehicleEngine: vehicleEngine2,
  vehicleIdentificationNumber: vehicleIdentificationNumber2,
  vehicleInteriorColor: vehicleInteriorColor2,
  vehicleInteriorType: vehicleInteriorType2,
  vehicleModelDate: vehicleModelDate2,
  vehicleSeatingCapacity: vehicleSeatingCapacity2,
  vehicleSpecialUsage: vehicleSpecialUsage2,
  vehicleTransmission: vehicleTransmission2,
  vendor: vendor2,
  verificationFactCheckingPolicy: verificationFactCheckingPolicy2,
  version: version5,
  video: video2,
  videoFormat: videoFormat2,
  videoFrameSize: videoFrameSize2,
  videoQuality: videoQuality2,
  volumeNumber: volumeNumber2,
  warning: warning3,
  warrantyPromise: warrantyPromise2,
  warrantyScope: warrantyScope2,
  webCheckinTime: webCheckinTime2,
  webFeed: webFeed2,
  weight: weight2,
  weightTotal: weightTotal2,
  wheelbase: wheelbase2,
  width: width4,
  winner: winner2,
  wordCount: wordCount2,
  workHours: workHours2,
  workLocation: workLocation2,
  workPerformed: workPerformed2,
  workPresented: workPresented2,
  workload: workload2,
  worksFor: worksFor2,
  worstRating: worstRating2,
  xpath: xpath2,
  yearBuilt: yearBuilt2,
  yearlyRevenue: yearlyRevenue2,
  yearsInOperation: yearsInOperation2,
  actionApplication: actionApplication2,
  actionOption: actionOption2,
  album: album2,
  albumRelease: albumRelease2,
  alternateName: alternateName2,
  alumni: alumni2,
  alumniOf: alumniOf2,
  archiveHeld: archiveHeld2,
  arterialBranch: arterialBranch2,
  artworkSurface: artworkSurface2,
  attendee: attendee3,
  audience: audience4,
  availableOnDevice: availableOnDevice2,
  award: award2,
  blogPost: blogPost2,
  broker: broker2,
  caption: caption2,
  category: category4,
  childTaxon: childTaxon2,
  clinicalPharmacology: clinicalPharmacology2,
  codeSampleType: codeSampleType2,
  colleague: colleague2,
  contactPoint: contactPoint2,
  containsPlace: containsPlace2,
  containsSeason: containsSeason2,
  contentLocation: contentLocation2,
  creator: creator4,
  dataset: dataset2,
  dateCreated: dateCreated2,
  director: director2,
  duration: duration5,
  employee: employee2,
  encodesBioChemEntity: encodesBioChemEntity2,
  encodesCreativeWork: encodesCreativeWork2,
  encodingFormat: encodingFormat2,
  episode: episode2,
  event: event3,
  exampleOfWork: exampleOfWork2,
  executableLibraryName: executableLibraryName2,
  exerciseCourse: exerciseCourse2,
  founder: founder2,
  frequency: frequency3,
  fundedItem: fundedItem2,
  funding: funding2,
  game: game2,
  gameServer: gameServer2,
  genre: genre2,
  hasBioChemEntityPart: hasBioChemEntityPart2,
  hasBroadcastChannel: hasBroadcastChannel2,
  hasDefinedTerm: hasDefinedTerm2,
  hasMenu: hasMenu2,
  hasMerchantReturnPolicy: hasMerchantReturnPolicy2,
  hasVariant: hasVariant2,
  holdingArchive: holdingArchive2,
  inDefinedTermSet: inDefinedTermSet2,
  inLanguage: inLanguage2,
  incentiveCompensation: incentiveCompensation2,
  interactionStatistic: interactionStatistic2,
  isAccessibleForFree: isAccessibleForFree2,
  isBasedOn: isBasedOn2,
  isEncodedByBioChemEntity: isEncodedByBioChemEntity2,
  isPartOfBioChemEntity: isPartOfBioChemEntity2,
  isVariantOf: isVariantOf2,
  itemOffered: itemOffered2,
  jobBenefits: jobBenefits2,
  jurisdiction: jurisdiction3,
  legislationApplies: legislationApplies2,
  mainContentOfPage: mainContentOfPage2,
  mainEntity: mainEntity2,
  mainEntityOfPage: mainEntityOfPage2,
  makesOffer: makesOffer2,
  measurementTechnique: measurementTechnique2,
  merchantReturnDays: merchantReturnDays2,
  merchantReturnLink: merchantReturnLink2,
  offeredBy: offeredBy2,
  offers: offers2,
  parent: parent3,
  parentTaxon: parentTaxon2,
  partOfSeries: partOfSeries2,
  partOfTrip: partOfTrip2,
  paymentDueDate: paymentDueDate2,
  performTime: performTime2,
  performer: performer3,
  photo: photo3,
  provider: provider4,
  providesBroadcastService: providesBroadcastService2,
  recipeIngredient: recipeIngredient2,
  recordedAs: recordedAs2,
  recordedAt: recordedAt2,
  recordedIn: recordedIn2,
  recordingOf: recordingOf2,
  releaseOf: releaseOf2,
  review: review2,
  roleName: roleName2,
  runtimePlatform: runtimePlatform2,
  season: season2,
  serialNumber: serialNumber3,
  serviceArea: serviceArea2,
  serviceOutput: serviceOutput2,
  sibling: sibling2,
  significantLink: significantLink2,
  softwareRequirements: softwareRequirements2,
  sponsor: sponsor2,
  subOrganization: subOrganization2,
  subTrip: subTrip2,
  subjectOf: subjectOf2,
  suggestedAnswer: suggestedAnswer2,
  superEvent: superEvent2,
  targetCollection: targetCollection2,
  temporalCoverage: temporalCoverage2,
  termCode: termCode2,
  track: track2,
  translationOfWork: translationOfWork2,
  usageInfo: usageInfo2,
  warranty: warranty2,
  workTranslation: workTranslation2,
  yield__workaround: yield__workaround2,
  about: about3,
  actor: actor4,
  associatedReview: associatedReview2,
  competitor: competitor2,
  containedInPlace: containedInPlace2,
  encoding: encoding2,
  hasMap: hasMap2,
  material: material3,
  memberOf: memberOf2,
  parentOrganization: parentOrganization2,
  result: result4,
  seller: seller2,
  spatialCoverage: spatialCoverage2,
  step: step3,
  subEvent: subEvent2,
  supply: supply2,
  workFeatured: workFeatured2,
  areaServed: areaServed2,
  image: image4,
  includedInDataCatalog: includedInDataCatalog2,
  member: member7,
  recipient: recipient3,
  workExample: workExample2,
  description: description8,
  gtin: gtin2,
  hasRepresentation: hasRepresentation2,
  hasPart: hasPart4,
  position: position3,
  isPartOf: isPartOf3,
  instrument: instrument3,
  object: object5,
  publishingPrinciples: publishingPrinciples2,
  location: location7,
  participant: participant4,
  identifier: identifier5
});

// ../node_modules/rdf-namespaces/dist/sec-5a58a07a.js
var Proof = "https://w3id.org/security#Proof";
var ProofGraph = "https://w3id.org/security#ProofGraph";
var VerificationMethod = "https://w3id.org/security#VerificationMethod";
var DataIntegrityProof = "https://w3id.org/security#DataIntegrityProof";
var Multikey = "https://w3id.org/security#Multikey";
var JsonWebKey = "https://w3id.org/security#JsonWebKey";
var Ed25519VerificationKey2020 = "https://w3id.org/security#Ed25519VerificationKey2020";
var Ed25519Signature2020 = "https://w3id.org/security#Ed25519Signature2020";
var ProcessingError = "https://w3id.org/security#ProcessingError";
var Key = "https://w3id.org/security#Key";
var EcdsaSecp256k1Signature2019 = "https://w3id.org/security#EcdsaSecp256k1Signature2019";
var EcdsaSecp256k1Signature2020 = "https://w3id.org/security#EcdsaSecp256k1Signature2020";
var EcdsaSecp256k1VerificationKey2019 = "https://w3id.org/security#EcdsaSecp256k1VerificationKey2019";
var EcdsaSecp256k1RecoverySignature2020 = "https://w3id.org/security#EcdsaSecp256k1RecoverySignature2020";
var EcdsaSecp256k1RecoveryMethod2020 = "https://w3id.org/security#EcdsaSecp256k1RecoveryMethod2020";
var MerkleProof2019 = "https://w3id.org/security#MerkleProof2019";
var X25519KeyAgreementKey2019 = "https://w3id.org/security#X25519KeyAgreementKey2019";
var Ed25519VerificationKey2018 = "https://w3id.org/security#Ed25519VerificationKey2018";
var JsonWebKey2020 = "https://w3id.org/security#JsonWebKey2020";
var JsonWebSignature2020 = "https://w3id.org/security#JsonWebSignature2020";
var BbsBlsSignature2020 = "https://w3id.org/security#BbsBlsSignature2020";
var BbsBlsSignatureProof2020 = "https://w3id.org/security#BbsBlsSignatureProof2020";
var Bls12381G1Key2020 = "https://w3id.org/security#Bls12381G1Key2020";
var Bls12381G2Key2020 = "https://w3id.org/security#Bls12381G2Key2020";
var blockchainAccountId = "https://w3id.org/security#blockchainAccountId";
var ethereumAddress = "https://w3id.org/security#ethereumAddress";
var publicKeyBase58 = "https://w3id.org/security#publicKeyBase58";
var publicKeyPem = "https://w3id.org/security#publicKeyPem";
var publicKeyHex = "https://w3id.org/security#publicKeyHex";
var jws = "https://w3id.org/security#jws";
var secImport = /* @__PURE__ */ Object.freeze({
  Proof,
  ProofGraph,
  VerificationMethod,
  DataIntegrityProof,
  Multikey,
  JsonWebKey,
  Ed25519VerificationKey2020,
  Ed25519Signature2020,
  ProcessingError,
  Key,
  EcdsaSecp256k1Signature2019,
  EcdsaSecp256k1Signature2020,
  EcdsaSecp256k1VerificationKey2019,
  EcdsaSecp256k1RecoverySignature2020,
  EcdsaSecp256k1RecoveryMethod2020,
  MerkleProof2019,
  X25519KeyAgreementKey2019,
  Ed25519VerificationKey2018,
  JsonWebKey2020,
  JsonWebSignature2020,
  BbsBlsSignature2020,
  BbsBlsSignatureProof2020,
  Bls12381G1Key2020,
  Bls12381G2Key2020,
  blockchainAccountId,
  ethereumAddress,
  publicKeyBase58,
  publicKeyPem,
  publicKeyHex,
  jws
});

// ../node_modules/rdf-namespaces/dist/sioc-49ca0ecf.js
var Community = "http://rdfs.org/sioc/ns#Community";
var Container3 = "http://rdfs.org/sioc/ns#Container";
var Forum = "http://rdfs.org/sioc/ns#Forum";
var Item2 = "http://rdfs.org/sioc/ns#Item";
var Post = "http://rdfs.org/sioc/ns#Post";
var Role3 = "http://rdfs.org/sioc/ns#Role";
var Space = "http://rdfs.org/sioc/ns#Space";
var Site = "http://rdfs.org/sioc/ns#Site";
var Thread = "http://rdfs.org/sioc/ns#Thread";
var UserAccount = "http://rdfs.org/sioc/ns#UserAccount";
var Usergroup = "http://rdfs.org/sioc/ns#Usergroup";
var about4 = "http://rdfs.org/sioc/ns#about";
var account_of = "http://rdfs.org/sioc/ns#account_of";
var addressed_to = "http://rdfs.org/sioc/ns#addressed_to";
var administrator_of = "http://rdfs.org/sioc/ns#administrator_of";
var attachment3 = "http://rdfs.org/sioc/ns#attachment";
var avatar = "http://rdfs.org/sioc/ns#avatar";
var container_of = "http://rdfs.org/sioc/ns#container_of";
var content4 = "http://rdfs.org/sioc/ns#content";
var creator_of = "http://rdfs.org/sioc/ns#creator_of";
var delivered_at = "http://rdfs.org/sioc/ns#delivered_at";
var discussion_of = "http://rdfs.org/sioc/ns#discussion_of";
var email3 = "http://rdfs.org/sioc/ns#email";
var email_sha1 = "http://rdfs.org/sioc/ns#email_sha1";
var embeds_knowledge = "http://rdfs.org/sioc/ns#embeds_knowledge";
var feed = "http://rdfs.org/sioc/ns#feed";
var follows3 = "http://rdfs.org/sioc/ns#follows";
var function_of = "http://rdfs.org/sioc/ns#function_of";
var generator2 = "http://rdfs.org/sioc/ns#generator";
var has_administrator = "http://rdfs.org/sioc/ns#has_administrator";
var has_container = "http://rdfs.org/sioc/ns#has_container";
var has_creator = "http://rdfs.org/sioc/ns#has_creator";
var has_discussion = "http://rdfs.org/sioc/ns#has_discussion";
var has_function = "http://rdfs.org/sioc/ns#has_function";
var has_host = "http://rdfs.org/sioc/ns#has_host";
var has_member = "http://rdfs.org/sioc/ns#has_member";
var has_moderator = "http://rdfs.org/sioc/ns#has_moderator";
var has_modifier = "http://rdfs.org/sioc/ns#has_modifier";
var has_owner = "http://rdfs.org/sioc/ns#has_owner";
var has_parent = "http://rdfs.org/sioc/ns#has_parent";
var has_reply = "http://rdfs.org/sioc/ns#has_reply";
var has_scope = "http://rdfs.org/sioc/ns#has_scope";
var has_space = "http://rdfs.org/sioc/ns#has_space";
var has_subscriber = "http://rdfs.org/sioc/ns#has_subscriber";
var has_usergroup = "http://rdfs.org/sioc/ns#has_usergroup";
var host_of = "http://rdfs.org/sioc/ns#host_of";
var id3 = "http://rdfs.org/sioc/ns#id";
var ip_address = "http://rdfs.org/sioc/ns#ip_address";
var last_activity_date = "http://rdfs.org/sioc/ns#last_activity_date";
var last_item_date = "http://rdfs.org/sioc/ns#last_item_date";
var last_reply_date = "http://rdfs.org/sioc/ns#last_reply_date";
var latest_version = "http://rdfs.org/sioc/ns#latest_version";
var likes = "http://rdfs.org/sioc/ns#likes";
var link2 = "http://rdfs.org/sioc/ns#link";
var links_to = "http://rdfs.org/sioc/ns#links_to";
var member_of = "http://rdfs.org/sioc/ns#member_of";
var mentions3 = "http://rdfs.org/sioc/ns#mentions";
var moderator_of = "http://rdfs.org/sioc/ns#moderator_of";
var modifier_of = "http://rdfs.org/sioc/ns#modifier_of";
var name6 = "http://rdfs.org/sioc/ns#name";
var next_by_date = "http://rdfs.org/sioc/ns#next_by_date";
var next_version = "http://rdfs.org/sioc/ns#next_version";
var note2 = "http://rdfs.org/sioc/ns#note";
var num_authors = "http://rdfs.org/sioc/ns#num_authors";
var num_items = "http://rdfs.org/sioc/ns#num_items";
var num_replies = "http://rdfs.org/sioc/ns#num_replies";
var num_threads = "http://rdfs.org/sioc/ns#num_threads";
var num_views = "http://rdfs.org/sioc/ns#num_views";
var owner_of = "http://rdfs.org/sioc/ns#owner_of";
var parent_of = "http://rdfs.org/sioc/ns#parent_of";
var previous_by_date = "http://rdfs.org/sioc/ns#previous_by_date";
var previous_version = "http://rdfs.org/sioc/ns#previous_version";
var read_at = "http://rdfs.org/sioc/ns#read_at";
var related_to = "http://rdfs.org/sioc/ns#related_to";
var reply_of = "http://rdfs.org/sioc/ns#reply_of";
var respond_to = "http://rdfs.org/sioc/ns#respond_to";
var scope_of = "http://rdfs.org/sioc/ns#scope_of";
var shared_by = "http://rdfs.org/sioc/ns#shared_by";
var space_of = "http://rdfs.org/sioc/ns#space_of";
var subscriber_of = "http://rdfs.org/sioc/ns#subscriber_of";
var topic3 = "http://rdfs.org/sioc/ns#topic";
var usergroup_of = "http://rdfs.org/sioc/ns#usergroup_of";
var siocImport = /* @__PURE__ */ Object.freeze({
  Community,
  Container: Container3,
  Forum,
  Item: Item2,
  Post,
  Role: Role3,
  Space,
  Site,
  Thread,
  UserAccount,
  Usergroup,
  about: about4,
  account_of,
  addressed_to,
  administrator_of,
  attachment: attachment3,
  avatar,
  container_of,
  content: content4,
  creator_of,
  delivered_at,
  discussion_of,
  email: email3,
  email_sha1,
  embeds_knowledge,
  feed,
  follows: follows3,
  function_of,
  generator: generator2,
  has_administrator,
  has_container,
  has_creator,
  has_discussion,
  has_function,
  has_host,
  has_member,
  has_moderator,
  has_modifier,
  has_owner,
  has_parent,
  has_reply,
  has_scope,
  has_space,
  has_subscriber,
  has_usergroup,
  host_of,
  id: id3,
  ip_address,
  last_activity_date,
  last_item_date,
  last_reply_date,
  latest_version,
  likes,
  link: link2,
  links_to,
  member_of,
  mentions: mentions3,
  moderator_of,
  modifier_of,
  name: name6,
  next_by_date,
  next_version,
  note: note2,
  num_authors,
  num_items,
  num_replies,
  num_threads,
  num_views,
  owner_of,
  parent_of,
  previous_by_date,
  previous_version,
  read_at,
  related_to,
  reply_of,
  respond_to,
  scope_of,
  shared_by,
  space_of,
  subscriber_of,
  topic: topic3,
  usergroup_of
});

// ../node_modules/rdf-namespaces/dist/skos-de6d709a.js
var Concept = "http://www.w3.org/2004/02/skos/core#Concept";
var ConceptScheme = "http://www.w3.org/2004/02/skos/core#ConceptScheme";
var Collection5 = "http://www.w3.org/2004/02/skos/core#Collection";
var OrderedCollection2 = "http://www.w3.org/2004/02/skos/core#OrderedCollection";
var inScheme = "http://www.w3.org/2004/02/skos/core#inScheme";
var hasTopConcept = "http://www.w3.org/2004/02/skos/core#hasTopConcept";
var topConceptOf = "http://www.w3.org/2004/02/skos/core#topConceptOf";
var notation = "http://www.w3.org/2004/02/skos/core#notation";
var semanticRelation = "http://www.w3.org/2004/02/skos/core#semanticRelation";
var broader = "http://www.w3.org/2004/02/skos/core#broader";
var narrower = "http://www.w3.org/2004/02/skos/core#narrower";
var related2 = "http://www.w3.org/2004/02/skos/core#related";
var broaderTransitive = "http://www.w3.org/2004/02/skos/core#broaderTransitive";
var narrowerTransitive = "http://www.w3.org/2004/02/skos/core#narrowerTransitive";
var member8 = "http://www.w3.org/2004/02/skos/core#member";
var memberList = "http://www.w3.org/2004/02/skos/core#memberList";
var mappingRelation = "http://www.w3.org/2004/02/skos/core#mappingRelation";
var broadMatch = "http://www.w3.org/2004/02/skos/core#broadMatch";
var narrowMatch = "http://www.w3.org/2004/02/skos/core#narrowMatch";
var relatedMatch = "http://www.w3.org/2004/02/skos/core#relatedMatch";
var exactMatch = "http://www.w3.org/2004/02/skos/core#exactMatch";
var closeMatch = "http://www.w3.org/2004/02/skos/core#closeMatch";
var skosImport = /* @__PURE__ */ Object.freeze({
  Concept,
  ConceptScheme,
  Collection: Collection5,
  OrderedCollection: OrderedCollection2,
  inScheme,
  hasTopConcept,
  topConceptOf,
  notation,
  semanticRelation,
  broader,
  narrower,
  related: related2,
  broaderTransitive,
  narrowerTransitive,
  member: member8,
  memberList,
  mappingRelation,
  broadMatch,
  narrowMatch,
  relatedMatch,
  exactMatch,
  closeMatch
});

// ../node_modules/rdf-namespaces/dist/solid-5db7be47.js
var Account3 = "http://www.w3.org/ns/solid/terms#Account";
var Inbox = "http://www.w3.org/ns/solid/terms#Inbox";
var InsertDeletePatch = "http://www.w3.org/ns/solid/terms#InsertDeletePatch";
var ListedDocument = "http://www.w3.org/ns/solid/terms#ListedDocument";
var Notification = "http://www.w3.org/ns/solid/terms#Notification";
var Patch = "http://www.w3.org/ns/solid/terms#Patch";
var Timeline = "http://www.w3.org/ns/solid/terms#Timeline";
var TypeIndex = "http://www.w3.org/ns/solid/terms#TypeIndex";
var TypeRegistration = "http://www.w3.org/ns/solid/terms#TypeRegistration";
var UnlistedDocument = "http://www.w3.org/ns/solid/terms#UnlistedDocument";
var account2 = "http://www.w3.org/ns/solid/terms#account";
var deletes = "http://www.w3.org/ns/solid/terms#deletes";
var forClass = "http://www.w3.org/ns/solid/terms#forClass";
var inbox2 = "http://www.w3.org/ns/solid/terms#inbox";
var inserts = "http://www.w3.org/ns/solid/terms#inserts";
var instance2 = "http://www.w3.org/ns/solid/terms#instance";
var instanceContainer = "http://www.w3.org/ns/solid/terms#instanceContainer";
var loginEndpoint = "http://www.w3.org/ns/solid/terms#loginEndpoint";
var logoutEndpoint = "http://www.w3.org/ns/solid/terms#logoutEndpoint";
var notification = "http://www.w3.org/ns/solid/terms#notification";
var oidcIssuer = "http://www.w3.org/ns/solid/terms#oidcIssuer";
var owner3 = "http://www.w3.org/ns/solid/terms#owner";
var patches = "http://www.w3.org/ns/solid/terms#patches";
var privateTypeIndex = "http://www.w3.org/ns/solid/terms#privateTypeIndex";
var publicTypeIndex = "http://www.w3.org/ns/solid/terms#publicTypeIndex";
var read = "http://www.w3.org/ns/solid/terms#read";
var storageQuota = "http://www.w3.org/ns/solid/terms#storageQuota";
var storageUsage = "http://www.w3.org/ns/solid/terms#storageUsage";
var typeIndex = "http://www.w3.org/ns/solid/terms#typeIndex";
var timeline = "http://www.w3.org/ns/solid/terms#timeline";
var where = "http://www.w3.org/ns/solid/terms#where";
var solidImport = /* @__PURE__ */ Object.freeze({
  Account: Account3,
  Inbox,
  InsertDeletePatch,
  ListedDocument,
  Notification,
  Patch,
  Timeline,
  TypeIndex,
  TypeRegistration,
  UnlistedDocument,
  account: account2,
  deletes,
  forClass,
  inbox: inbox2,
  inserts,
  instance: instance2,
  instanceContainer,
  loginEndpoint,
  logoutEndpoint,
  notification,
  oidcIssuer,
  owner: owner3,
  patches,
  privateTypeIndex,
  publicTypeIndex,
  read,
  storageQuota,
  storageUsage,
  typeIndex,
  timeline,
  where
});

// ../node_modules/rdf-namespaces/dist/space-86738b33.js
var ControlledStorage = "http://www.w3.org/ns/pim/space#ControlledStorage";
var PersonalStorage = "http://www.w3.org/ns/pim/space#PersonalStorage";
var PublicStorage = "http://www.w3.org/ns/pim/space#PublicStorage";
var Storage = "http://www.w3.org/ns/pim/space#Storage";
var Workspace = "http://www.w3.org/ns/pim/space#Workspace";
var masterWorkspace = "http://www.w3.org/ns/pim/space#masterWorkspace";
var preferencesFile = "http://www.w3.org/ns/pim/space#preferencesFile";
var storage = "http://www.w3.org/ns/pim/space#storage";
var uriPrefix = "http://www.w3.org/ns/pim/space#uriPrefix";
var workspace = "http://www.w3.org/ns/pim/space#workspace";
var spaceImport = /* @__PURE__ */ Object.freeze({
  ControlledStorage,
  PersonalStorage,
  PublicStorage,
  Storage,
  Workspace,
  masterWorkspace,
  preferencesFile,
  storage,
  uriPrefix,
  workspace
});

// ../node_modules/rdf-namespaces/dist/tab-e36cfd85.js
var Access3 = "http://www.w3.org/2007/ont/link#Access";
var Document4 = "http://www.w3.org/2007/ont/link#Document";
var Mailbox2 = "http://www.w3.org/2007/ont/link#Mailbox";
var ProtocolEvent2 = "http://www.w3.org/2007/ont/link#ProtocolEvent";
var RDFDocument2 = "http://www.w3.org/2007/ont/link#RDFDocument";
var Response2 = "http://www.w3.org/2007/ont/link#Response";
var Session4 = "http://www.w3.org/2007/ont/link#Session";
var isMentionedIn2 = "http://www.w3.org/2007/ont/link#isMentionedIn";
var mentionsClass2 = "http://www.w3.org/2007/ont/link#mentionsClass";
var protocol3 = "http://www.w3.org/2007/ont/link#protocol";
var redirectedRequest2 = "http://www.w3.org/2007/ont/link#redirectedRequest";
var requestedBy2 = "http://www.w3.org/2007/ont/link#requestedBy";
var requestedURI2 = "http://www.w3.org/2007/ont/link#requestedURI";
var response4 = "http://www.w3.org/2007/ont/link#response";
var session2 = "http://www.w3.org/2007/ont/link#session";
var source5 = "http://www.w3.org/2007/ont/link#source";
var status7 = "http://www.w3.org/2007/ont/link#status";
var testDataset2 = "http://www.w3.org/2007/ont/link#testDataset";
var uri4 = "http://www.w3.org/2007/ont/link#uri";
var tabImport = /* @__PURE__ */ Object.freeze({
  Access: Access3,
  Document: Document4,
  Mailbox: Mailbox2,
  ProtocolEvent: ProtocolEvent2,
  RDFDocument: RDFDocument2,
  Response: Response2,
  Session: Session4,
  isMentionedIn: isMentionedIn2,
  mentionsClass: mentionsClass2,
  protocol: protocol3,
  redirectedRequest: redirectedRequest2,
  requestedBy: requestedBy2,
  requestedURI: requestedURI2,
  response: response4,
  session: session2,
  source: source5,
  status: status7,
  testDataset: testDataset2,
  uri: uri4
});

// ../node_modules/rdf-namespaces/dist/tabont-9bc9523e.js
var Access4 = "http://www.w3.org/2007/ont/link#Access";
var Document5 = "http://www.w3.org/2007/ont/link#Document";
var Mailbox3 = "http://www.w3.org/2007/ont/link#Mailbox";
var ProtocolEvent3 = "http://www.w3.org/2007/ont/link#ProtocolEvent";
var RDFDocument3 = "http://www.w3.org/2007/ont/link#RDFDocument";
var Response3 = "http://www.w3.org/2007/ont/link#Response";
var Session5 = "http://www.w3.org/2007/ont/link#Session";
var isMentionedIn3 = "http://www.w3.org/2007/ont/link#isMentionedIn";
var mentionsClass3 = "http://www.w3.org/2007/ont/link#mentionsClass";
var protocol4 = "http://www.w3.org/2007/ont/link#protocol";
var redirectedRequest3 = "http://www.w3.org/2007/ont/link#redirectedRequest";
var requestedBy3 = "http://www.w3.org/2007/ont/link#requestedBy";
var requestedURI3 = "http://www.w3.org/2007/ont/link#requestedURI";
var response5 = "http://www.w3.org/2007/ont/link#response";
var session3 = "http://www.w3.org/2007/ont/link#session";
var source6 = "http://www.w3.org/2007/ont/link#source";
var status8 = "http://www.w3.org/2007/ont/link#status";
var testDataset3 = "http://www.w3.org/2007/ont/link#testDataset";
var uri5 = "http://www.w3.org/2007/ont/link#uri";
var tabontImport = /* @__PURE__ */ Object.freeze({
  Access: Access4,
  Document: Document5,
  Mailbox: Mailbox3,
  ProtocolEvent: ProtocolEvent3,
  RDFDocument: RDFDocument3,
  Response: Response3,
  Session: Session5,
  isMentionedIn: isMentionedIn3,
  mentionsClass: mentionsClass3,
  protocol: protocol4,
  redirectedRequest: redirectedRequest3,
  requestedBy: requestedBy3,
  requestedURI: requestedURI3,
  response: response5,
  session: session3,
  source: source6,
  status: status8,
  testDataset: testDataset3,
  uri: uri5
});

// ../node_modules/rdf-namespaces/dist/vcard-9a881061.js
var Acquaintance = "http://www.w3.org/2006/vcard/ns#Acquaintance";
var Agent2 = "http://www.w3.org/2006/vcard/ns#Agent";
var BBS = "http://www.w3.org/2006/vcard/ns#BBS";
var Car3 = "http://www.w3.org/2006/vcard/ns#Car";
var Cell = "http://www.w3.org/2006/vcard/ns#Cell";
var Child = "http://www.w3.org/2006/vcard/ns#Child";
var Colleague = "http://www.w3.org/2006/vcard/ns#Colleague";
var Contact2 = "http://www.w3.org/2006/vcard/ns#Contact";
var Coresident = "http://www.w3.org/2006/vcard/ns#Coresident";
var Coworker = "http://www.w3.org/2006/vcard/ns#Coworker";
var Crush = "http://www.w3.org/2006/vcard/ns#Crush";
var Date__workaround3 = "http://www.w3.org/2006/vcard/ns#Date";
var Dom = "http://www.w3.org/2006/vcard/ns#Dom";
var Emergency = "http://www.w3.org/2006/vcard/ns#Emergency";
var Fax = "http://www.w3.org/2006/vcard/ns#Fax";
var Female2 = "http://www.w3.org/2006/vcard/ns#Female";
var Friend = "http://www.w3.org/2006/vcard/ns#Friend";
var Home = "http://www.w3.org/2006/vcard/ns#Home";
var ISDN = "http://www.w3.org/2006/vcard/ns#ISDN";
var Internet = "http://www.w3.org/2006/vcard/ns#Internet";
var Intl__workaround = "http://www.w3.org/2006/vcard/ns#Intl";
var Kin = "http://www.w3.org/2006/vcard/ns#Kin";
var Label = "http://www.w3.org/2006/vcard/ns#Label";
var Male2 = "http://www.w3.org/2006/vcard/ns#Male";
var Me = "http://www.w3.org/2006/vcard/ns#Me";
var Met = "http://www.w3.org/2006/vcard/ns#Met";
var Modem = "http://www.w3.org/2006/vcard/ns#Modem";
var Msg = "http://www.w3.org/2006/vcard/ns#Msg";
var Muse = "http://www.w3.org/2006/vcard/ns#Muse";
var Neighbor = "http://www.w3.org/2006/vcard/ns#Neighbor";
var None = "http://www.w3.org/2006/vcard/ns#None";
var Other2 = "http://www.w3.org/2006/vcard/ns#Other";
var PCS = "http://www.w3.org/2006/vcard/ns#PCS";
var Pager = "http://www.w3.org/2006/vcard/ns#Pager";
var Parcel = "http://www.w3.org/2006/vcard/ns#Parcel";
var Parent = "http://www.w3.org/2006/vcard/ns#Parent";
var Postal = "http://www.w3.org/2006/vcard/ns#Postal";
var Pref = "http://www.w3.org/2006/vcard/ns#Pref";
var Sibling = "http://www.w3.org/2006/vcard/ns#Sibling";
var Spouse = "http://www.w3.org/2006/vcard/ns#Spouse";
var Sweetheart = "http://www.w3.org/2006/vcard/ns#Sweetheart";
var Tel = "http://www.w3.org/2006/vcard/ns#Tel";
var Text3 = "http://www.w3.org/2006/vcard/ns#Text";
var TextPhone = "http://www.w3.org/2006/vcard/ns#TextPhone";
var Unknown = "http://www.w3.org/2006/vcard/ns#Unknown";
var Video2 = "http://www.w3.org/2006/vcard/ns#Video";
var Voice = "http://www.w3.org/2006/vcard/ns#Voice";
var Work = "http://www.w3.org/2006/vcard/ns#Work";
var X400 = "http://www.w3.org/2006/vcard/ns#X400";
var adr = "http://www.w3.org/2006/vcard/ns#adr";
var agent5 = "http://www.w3.org/2006/vcard/ns#agent";
var anniversary = "http://www.w3.org/2006/vcard/ns#anniversary";
var bday = "http://www.w3.org/2006/vcard/ns#bday";
var category5 = "http://www.w3.org/2006/vcard/ns#category";
var class__workaround3 = "http://www.w3.org/2006/vcard/ns#class";
var email4 = "http://www.w3.org/2006/vcard/ns#email";
var geo4 = "http://www.w3.org/2006/vcard/ns#geo";
var hasAdditionalName = "http://www.w3.org/2006/vcard/ns#hasAdditionalName";
var hasCalendarBusy = "http://www.w3.org/2006/vcard/ns#hasCalendarBusy";
var hasCalendarLink = "http://www.w3.org/2006/vcard/ns#hasCalendarLink";
var hasCalendarRequest = "http://www.w3.org/2006/vcard/ns#hasCalendarRequest";
var hasCategory = "http://www.w3.org/2006/vcard/ns#hasCategory";
var hasCountryName = "http://www.w3.org/2006/vcard/ns#hasCountryName";
var hasFN = "http://www.w3.org/2006/vcard/ns#hasFN";
var hasFamilyName = "http://www.w3.org/2006/vcard/ns#hasFamilyName";
var hasGender = "http://www.w3.org/2006/vcard/ns#hasGender";
var hasGivenName = "http://www.w3.org/2006/vcard/ns#hasGivenName";
var hasHonorificPrefix = "http://www.w3.org/2006/vcard/ns#hasHonorificPrefix";
var hasHonorificSuffix = "http://www.w3.org/2006/vcard/ns#hasHonorificSuffix";
var hasInstantMessage = "http://www.w3.org/2006/vcard/ns#hasInstantMessage";
var hasLanguage = "http://www.w3.org/2006/vcard/ns#hasLanguage";
var hasLocality = "http://www.w3.org/2006/vcard/ns#hasLocality";
var hasNickname = "http://www.w3.org/2006/vcard/ns#hasNickname";
var hasNote = "http://www.w3.org/2006/vcard/ns#hasNote";
var hasOrganizationName = "http://www.w3.org/2006/vcard/ns#hasOrganizationName";
var hasOrganizationUnit = "http://www.w3.org/2006/vcard/ns#hasOrganizationUnit";
var hasPostalCode = "http://www.w3.org/2006/vcard/ns#hasPostalCode";
var hasRegion = "http://www.w3.org/2006/vcard/ns#hasRegion";
var hasRelated = "http://www.w3.org/2006/vcard/ns#hasRelated";
var hasRole = "http://www.w3.org/2006/vcard/ns#hasRole";
var hasSource = "http://www.w3.org/2006/vcard/ns#hasSource";
var hasStreetAddress = "http://www.w3.org/2006/vcard/ns#hasStreetAddress";
var hasTitle = "http://www.w3.org/2006/vcard/ns#hasTitle";
var hasUID = "http://www.w3.org/2006/vcard/ns#hasUID";
var hasValue2 = "http://www.w3.org/2006/vcard/ns#hasValue";
var label3 = "http://www.w3.org/2006/vcard/ns#label";
var language7 = "http://www.w3.org/2006/vcard/ns#language";
var latitude5 = "http://www.w3.org/2006/vcard/ns#latitude";
var longitude5 = "http://www.w3.org/2006/vcard/ns#longitude";
var mailer = "http://www.w3.org/2006/vcard/ns#mailer";
var note3 = "http://www.w3.org/2006/vcard/ns#note";
var org = "http://www.w3.org/2006/vcard/ns#org";
var prodid2 = "http://www.w3.org/2006/vcard/ns#prodid";
var rev = "http://www.w3.org/2006/vcard/ns#rev";
var role2 = "http://www.w3.org/2006/vcard/ns#role";
var title8 = "http://www.w3.org/2006/vcard/ns#title";
var tz = "http://www.w3.org/2006/vcard/ns#tz";
var value5 = "http://www.w3.org/2006/vcard/ns#value";
var Address3 = "http://www.w3.org/2006/vcard/ns#Address";
var Email = "http://www.w3.org/2006/vcard/ns#Email";
var Group4 = "http://www.w3.org/2006/vcard/ns#Group";
var Individual = "http://www.w3.org/2006/vcard/ns#Individual";
var Name = "http://www.w3.org/2006/vcard/ns#Name";
var VCard = "http://www.w3.org/2006/vcard/ns#VCard";
var fn = "http://www.w3.org/2006/vcard/ns#fn";
var hasAddress = "http://www.w3.org/2006/vcard/ns#hasAddress";
var hasEmail = "http://www.w3.org/2006/vcard/ns#hasEmail";
var hasGeo = "http://www.w3.org/2006/vcard/ns#hasGeo";
var hasKey2 = "http://www.w3.org/2006/vcard/ns#hasKey";
var hasLogo = "http://www.w3.org/2006/vcard/ns#hasLogo";
var hasName = "http://www.w3.org/2006/vcard/ns#hasName";
var hasPhoto = "http://www.w3.org/2006/vcard/ns#hasPhoto";
var hasSound = "http://www.w3.org/2006/vcard/ns#hasSound";
var hasTelephone = "http://www.w3.org/2006/vcard/ns#hasTelephone";
var hasURL = "http://www.w3.org/2006/vcard/ns#hasURL";
var key2 = "http://www.w3.org/2006/vcard/ns#key";
var logo4 = "http://www.w3.org/2006/vcard/ns#logo";
var n = "http://www.w3.org/2006/vcard/ns#n";
var nickname = "http://www.w3.org/2006/vcard/ns#nickname";
var photo4 = "http://www.w3.org/2006/vcard/ns#photo";
var sound = "http://www.w3.org/2006/vcard/ns#sound";
var tel = "http://www.w3.org/2006/vcard/ns#tel";
var url6 = "http://www.w3.org/2006/vcard/ns#url";
var Location3 = "http://www.w3.org/2006/vcard/ns#Location";
var hasMember2 = "http://www.w3.org/2006/vcard/ns#hasMember";
var locality = "http://www.w3.org/2006/vcard/ns#locality";
var region3 = "http://www.w3.org/2006/vcard/ns#region";
var Organization6 = "http://www.w3.org/2006/vcard/ns#Organization";
var Gender = "http://www.w3.org/2006/vcard/ns#Gender";
var Kind = "http://www.w3.org/2006/vcard/ns#Kind";
var Type = "http://www.w3.org/2006/vcard/ns#Type";
var TelephoneType = "http://www.w3.org/2006/vcard/ns#TelephoneType";
var RelatedType = "http://www.w3.org/2006/vcard/ns#RelatedType";
var vcardImport = /* @__PURE__ */ Object.freeze({
  Acquaintance,
  Agent: Agent2,
  BBS,
  Car: Car3,
  Cell,
  Child,
  Colleague,
  Contact: Contact2,
  Coresident,
  Coworker,
  Crush,
  Date__workaround: Date__workaround3,
  Dom,
  Emergency,
  Fax,
  Female: Female2,
  Friend,
  Home,
  ISDN,
  Internet,
  Intl__workaround,
  Kin,
  Label,
  Male: Male2,
  Me,
  Met,
  Modem,
  Msg,
  Muse,
  Neighbor,
  None,
  Other: Other2,
  PCS,
  Pager,
  Parcel,
  Parent,
  Postal,
  Pref,
  Sibling,
  Spouse,
  Sweetheart,
  Tel,
  Text: Text3,
  TextPhone,
  Unknown,
  Video: Video2,
  Voice,
  Work,
  X400,
  adr,
  agent: agent5,
  anniversary,
  bday,
  category: category5,
  class__workaround: class__workaround3,
  email: email4,
  geo: geo4,
  hasAdditionalName,
  hasCalendarBusy,
  hasCalendarLink,
  hasCalendarRequest,
  hasCategory,
  hasCountryName,
  hasFN,
  hasFamilyName,
  hasGender,
  hasGivenName,
  hasHonorificPrefix,
  hasHonorificSuffix,
  hasInstantMessage,
  hasLanguage,
  hasLocality,
  hasNickname,
  hasNote,
  hasOrganizationName,
  hasOrganizationUnit,
  hasPostalCode,
  hasRegion,
  hasRelated,
  hasRole,
  hasSource,
  hasStreetAddress,
  hasTitle,
  hasUID,
  hasValue: hasValue2,
  label: label3,
  language: language7,
  latitude: latitude5,
  longitude: longitude5,
  mailer,
  note: note3,
  org,
  prodid: prodid2,
  rev,
  role: role2,
  title: title8,
  tz,
  value: value5,
  Address: Address3,
  Email,
  Group: Group4,
  Individual,
  Name,
  VCard,
  fn,
  hasAddress,
  hasEmail,
  hasGeo,
  hasKey: hasKey2,
  hasLogo,
  hasName,
  hasPhoto,
  hasSound,
  hasTelephone,
  hasURL,
  key: key2,
  logo: logo4,
  n,
  nickname,
  photo: photo4,
  sound,
  tel,
  url: url6,
  Location: Location3,
  hasMember: hasMember2,
  locality,
  region: region3,
  Organization: Organization6,
  Gender,
  Kind,
  Type,
  TelephoneType,
  RelatedType
});

// ../node_modules/rdf-namespaces/dist/wf-d698b4a6.js
var ActionItem = "http://www.w3.org/2005/01/wf/flow#ActionItem";
var Change = "http://www.w3.org/2005/01/wf/flow#Change";
var Closed = "http://www.w3.org/2005/01/wf/flow#Closed";
var Creation = "http://www.w3.org/2005/01/wf/flow#Creation";
var Message4 = "http://www.w3.org/2005/01/wf/flow#Message";
var NonTerminalState = "http://www.w3.org/2005/01/wf/flow#NonTerminalState";
var Open = "http://www.w3.org/2005/01/wf/flow#Open";
var Product3 = "http://www.w3.org/2005/01/wf/flow#Product";
var Task2 = "http://www.w3.org/2005/01/wf/flow#Task";
var TerminalState = "http://www.w3.org/2005/01/wf/flow#TerminalState";
var Tracker = "http://www.w3.org/2005/01/wf/flow#Tracker";
var Transition = "http://www.w3.org/2005/01/wf/flow#Transition";
var affects = "http://www.w3.org/2005/01/wf/flow#affects";
var allowedTransitions = "http://www.w3.org/2005/01/wf/flow#allowedTransitions";
var asigneeClass = "http://www.w3.org/2005/01/wf/flow#asigneeClass";
var assignee = "http://www.w3.org/2005/01/wf/flow#assignee";
var attachment4 = "http://www.w3.org/2005/01/wf/flow#attachment";
var creates = "http://www.w3.org/2005/01/wf/flow#creates";
var dateDue = "http://www.w3.org/2005/01/wf/flow#dateDue";
var deliverable = "http://www.w3.org/2005/01/wf/flow#deliverable";
var dependent2 = "http://www.w3.org/2005/01/wf/flow#dependent";
var description9 = "http://www.w3.org/2005/01/wf/flow#description";
var final = "http://www.w3.org/2005/01/wf/flow#final";
var goalDescription = "http://www.w3.org/2005/01/wf/flow#goalDescription";
var initialState = "http://www.w3.org/2005/01/wf/flow#initialState";
var issue2 = "http://www.w3.org/2005/01/wf/flow#issue";
var issueCategory = "http://www.w3.org/2005/01/wf/flow#issueCategory";
var issueClass = "http://www.w3.org/2005/01/wf/flow#issueClass";
var message3 = "http://www.w3.org/2005/01/wf/flow#message";
var modifiedBy = "http://www.w3.org/2005/01/wf/flow#modifiedBy";
var recipent = "http://www.w3.org/2005/01/wf/flow#recipent";
var requires3 = "http://www.w3.org/2005/01/wf/flow#requires";
var screenShot = "http://www.w3.org/2005/01/wf/flow#screenShot";
var sender4 = "http://www.w3.org/2005/01/wf/flow#sender";
var source7 = "http://www.w3.org/2005/01/wf/flow#source";
var stateStore = "http://www.w3.org/2005/01/wf/flow#stateStore";
var subscriber2 = "http://www.w3.org/2005/01/wf/flow#subscriber";
var successCriteria = "http://www.w3.org/2005/01/wf/flow#successCriteria";
var task = "http://www.w3.org/2005/01/wf/flow#task";
var terminalOutput = "http://www.w3.org/2005/01/wf/flow#terminalOutput";
var testData2 = "http://www.w3.org/2005/01/wf/flow#testData";
var tracker = "http://www.w3.org/2005/01/wf/flow#tracker";
var transactionStore = "http://www.w3.org/2005/01/wf/flow#transactionStore";
var wfImport = /* @__PURE__ */ Object.freeze({
  ActionItem,
  Change,
  Closed,
  Creation,
  Message: Message4,
  NonTerminalState,
  Open,
  Product: Product3,
  Task: Task2,
  TerminalState,
  Tracker,
  Transition,
  affects,
  allowedTransitions,
  asigneeClass,
  assignee,
  attachment: attachment4,
  creates,
  dateDue,
  deliverable,
  dependent: dependent2,
  description: description9,
  final,
  goalDescription,
  initialState,
  issue: issue2,
  issueCategory,
  issueClass,
  message: message3,
  modifiedBy,
  recipent,
  requires: requires3,
  screenShot,
  sender: sender4,
  source: source7,
  stateStore,
  subscriber: subscriber2,
  successCriteria,
  task,
  terminalOutput,
  testData: testData2,
  tracker,
  transactionStore
});

// ../node_modules/rdf-namespaces/dist/index.es.js
var acl = aclImport;
var arg = argImport;
var as = asImport;
var cal = calImport;
var contact3 = contactImport;
var dc = dcImport;
var dct = dctImport;
var fhir = fhirImport;
var foaf = foafImport;
var http = httpImport;
var hydra = hydraImport;
var ldp = ldpImport;
var link3 = linkImport;
var log = logImport;
var meeting = meetingImport;
var owl = owlImport;
var qu = quImport;
var trip3 = tripImport;
var rdf = rdfImport;
var rdfs = rdfsImport;
var sched = schedImport;
var schema = schemaImport;
var schema_https = schema_httpsImport;
var sec = secImport;
var sioc = siocImport;
var skos = skosImport;
var solid = solidImport;
var space = spaceImport;
var tab = tabImport;
var tabont = tabontImport;
var vcard = vcardImport;
var wf = wfImport;

// src/terms/createListOfTerms.ts
var createListOfTerms = (terms) => Object.keys(terms).flatMap((prefix2) => {
  return Object.keys(terms[prefix2]).map((name7) => ({
    uri: terms[prefix2][name7],
    shorthand: `${prefix2}:${name7}`
  }));
});

// src/terms/listKnownTerms.ts
function listKnownTerms() {
  return createListOfTerms(index_es_exports);
}

// src/uri/UriService.ts
var import_slugify = __toESM(require_slugify());
var UriService = class {
  // We expect to use the store for calculating the uris for things
  // e.g. looking up locations in type index
  constructor(store) {
    this.store = store;
  }
  /**
   * Proposes a URI for a new thing based on what the referenceUri identifies:
   * - if a container, the new URI is in this container
   * - if a file, the new URI is in the same container as said file
   * - if a non-information-resource, the new URI is in the same container as that resource
   * @param referenceUri
   * @param name (will be slugified)
   */
  proposeUriForNewThing(referenceUri, name7) {
    const filename = (0, import_slugify.default)(name7, { lower: true });
    return `${new URL(filename, referenceUri)}#it`;
  }
};

// src/ldp-container/LdpContainer.ts
var LdpContainer = class extends Thing {
  constructor(uri6, store, editable = false) {
    super(uri6, store, editable);
    this.uri = uri6;
    this.store = store;
    this.editable = editable;
  }
  contains() {
    const contains3 = this.store.statementsMatching(
      namedNode(this.uri),
      namedNode("http://www.w3.org/ns/ldp#contains"),
      null,
      namedNode(this.uri)
    );
    return contains3.map((content5) => ({
      uri: content5.object.value,
      name: content5.object.value.replace(
        new RegExp(`${this.uri}([^/]*)/?`),
        "$1"
      )
    }));
  }
};

// src/index.ts
var PodOS = class {
  constructor() {
    this.session = new BrowserSession();
    this.store = new Store(this.session);
    this.flagAuthorizationMetaDataOnSessionChange();
    this.uriService = new UriService(this.store);
    this.fileFetcher = new FileFetcher(this.session);
  }
  /*
       Flagging authorization metadata is necessary every time the user
       logs in or out, so that metadata from previous requests is outdated
       and not considered to determine whether a resource is editable anymore.
  
       See: https://github.com/linkeddata/rdflib.js/pull/512
    */
  flagAuthorizationMetaDataOnSessionChange() {
    this.session.observeSession().pipe(
      tap(() => {
        this.store.updater.flagAuthorizationMetadata();
      })
    ).subscribe();
  }
  handleIncomingRedirect(restorePreviousSession = false) {
    this.session.handleIncomingRedirect(restorePreviousSession);
  }
  fetch(uri6) {
    return this.store.fetch(uri6);
  }
  fetchAll(uris) {
    return this.store.fetchAll(uris);
  }
  fetchFile(url7) {
    return this.fileFetcher.fetchFile(url7);
  }
  addPropertyValue(thing, property3, value6) {
    return this.store.addPropertyValue(thing, property3, value6);
  }
  listKnownTerms() {
    return listKnownTerms();
  }
  addNewThing(uri6, name7, type5) {
    return this.store.addNewThing(uri6, name7, type5);
  }
  proposeUriForNewThing(referenceUri, name7) {
    return this.uriService.proposeUriForNewThing(referenceUri, name7);
  }
  /**
   * @deprecated use observeSession instead
   * @param callback
   */
  trackSession(callback) {
    return this.session.trackSession((session4) => {
      callback(session4);
    });
  }
  /**
   * returns a behavior subject that can be used to observe changes in the session state
   */
  observeSession() {
    return this.session.observeSession();
  }
  /**
   * Calls the provided callback with the original URL that was open before the silent auth redirect
   * @param callback
   */
  onSessionRestore(callback) {
    this.session.onSessionRestore(callback);
  }
  /**
   * Fetch the WebId profile and preferences file for the given WebID
   * @param webId
   */
  async fetchProfile(webId) {
    await this.fetch(webId);
    const profile2 = this.store.get(webId).assume(WebIdProfile);
    const preferences = profile2.getPreferencesFile();
    if (preferences) {
      await this.fetch(preferences);
    }
    return profile2;
  }
  /**
   * Fetch the private label index for the given profile and build a search index from it
   * @param webId
   */
  async buildSearchIndex(profile2) {
    const labelIndexUris = profile2.getPrivateLabelIndexes();
    if (labelIndexUris.length > 0) {
      await this.fetchAll(labelIndexUris);
      const labelIndex = labelIndexUris.map(
        (uri6) => this.store.get(uri6).assume(LabelIndex)
      );
      return new SearchIndex(labelIndex);
    }
    return new SearchIndex([]);
  }
  logout() {
    return this.session.logout();
  }
  login(oidcIssuer2 = "http://localhost:3000") {
    return this.session.login(oidcIssuer2);
  }
  loadContactsModule() {
    return loadContactsModule(this.store);
  }
};
export {
  BinaryFile,
  BrokenFile,
  BrowserSession,
  HttpStatus,
  LabelIndex,
  LdpContainer,
  PodOS,
  RdfDocument,
  SearchIndex,
  Thing,
  WebIdProfile,
  labelFromUri
};
/*! Bundled license information:

@inrupt/oidc-client/lib/oidc-client.min.js:
  (*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
   *)
  (*! Mike Samuel (c) 2009 | code.google.com/p/json-sans-eval
   *)
  (*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <http://feross.org>
   * @license  MIT
   *)
  (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)

lunr/lunr.js:
  (**
   * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.9
   * Copyright (C) 2020 Oliver Nightingale
   * @license MIT
   *)
  (*!
   * lunr.utils
   * Copyright (C) 2020 Oliver Nightingale
   *)
  (*!
   * lunr.Set
   * Copyright (C) 2020 Oliver Nightingale
   *)
  (*!
   * lunr.tokenizer
   * Copyright (C) 2020 Oliver Nightingale
   *)
  (*!
   * lunr.Pipeline
   * Copyright (C) 2020 Oliver Nightingale
   *)
  (*!
   * lunr.Vector
   * Copyright (C) 2020 Oliver Nightingale
   *)
  (*!
   * lunr.stemmer
   * Copyright (C) 2020 Oliver Nightingale
   * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
   *)
  (*!
   * lunr.stopWordFilter
   * Copyright (C) 2020 Oliver Nightingale
   *)
  (*!
   * lunr.trimmer
   * Copyright (C) 2020 Oliver Nightingale
   *)
  (*!
   * lunr.TokenSet
   * Copyright (C) 2020 Oliver Nightingale
   *)
  (*!
   * lunr.Index
   * Copyright (C) 2020 Oliver Nightingale
   *)
  (*!
   * lunr.Builder
   * Copyright (C) 2020 Oliver Nightingale
   *)
*/
